/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 399);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(405);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(424)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(254);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sheetsManager = undefined;

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _map = __webpack_require__(538);

var _map2 = _interopRequireDefault(_map);

var _minSafeInteger = __webpack_require__(554);

var _minSafeInteger2 = _interopRequireDefault(_minSafeInteger);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _getDisplayName = __webpack_require__(287);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _wrapDisplayName = __webpack_require__(98);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _contextTypes = __webpack_require__(557);

var _contextTypes2 = _interopRequireDefault(_contextTypes);

var _jss = __webpack_require__(266);

var _ns = __webpack_require__(288);

var ns = _interopRequireWildcard(_ns);

var _jssPreset = __webpack_require__(265);

var _jssPreset2 = _interopRequireDefault(_jssPreset);

var _createMuiTheme = __webpack_require__(166);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(187);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _createGenerateClassName = __webpack_require__(253);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _getStylesCreator = __webpack_require__(559);

var _getStylesCreator2 = _interopRequireDefault(_getStylesCreator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// New JSS instance.
var jss = (0, _jss.create)((0, _jssPreset2.default)());

// Use a singleton or the provided one by the context.
var generateClassName = (0, _createGenerateClassName2.default)();

// Global index counter to preserve source order.
// As we create the style sheet during componentWillMount lifecycle,
// children are handled after the parents, so the order of style elements would
// be parent->child. It is a problem though when a parent passes a className
// which needs to override any childs styles. StyleSheet of the child has a higher
// specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = _minSafeInteger2.default;

var sheetsManager = exports.sheetsManager = new _map2.default();

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

// In order to have self-supporting components, we rely on default theme when not provided.
var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === undefined ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === undefined ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties3.default)(options, ['withTheme', 'flip', 'name']);

    var stylesCreator = (0, _getStylesCreator2.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || withTheme || typeof name === 'string';

    indexCounter += 1;
    stylesCreator.options.index = indexCounter;

     false ? (0, _warning2.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join(' ')) : void 0;

    var WithStyles = function (_React$Component) {
      (0, _inherits3.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        (0, _classCallCheck3.default)(this, WithStyles);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithStyles.__proto__ || (0, _getPrototypeOf2.default)(WithStyles)).call(this, props, context));

        _this.state = {};
        _this.disableStylesGeneration = false;
        _this.jss = null;
        _this.sheetOptions = null;
        _this.sheetsManager = sheetsManager;
        _this.stylesCreatorSaved = null;
        _this.theme = null;
        _this.unsubscribeId = null;


        _this.jss = _this.context[ns.jss] || jss;

        var muiThemeProviderOptions = _this.context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        }

        // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107
        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, _this.context[ns.sheetOptions]);
        // We use || as the function call is lazy evaluated.
        _this.theme = listenToTheme ? _themeListener2.default.initial(context) || getDefaultTheme() : noopTheme;
        return _this;
      }

      (0, _createClass3.default)(WithStyles, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this.attach(this.theme);
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;
            _this2.attach(_this2.theme);

            // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.
            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'attach',
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);

          if (!sheetManager) {
            sheetManager = new _map2.default();
            this.sheetsManager.set(stylesCreatorSaved, sheetManager);
          }

          var sheetManagerTheme = sheetManager.get(theme);

          if (!sheetManagerTheme) {
            sheetManagerTheme = {
              refs: 0,
              sheet: null
            };
            sheetManager.set(theme, sheetManagerTheme);
          }

          if (sheetManagerTheme.refs === 0) {
            var styles = stylesCreatorSaved.create(theme, name);
            var meta = name;

            if (false) {
              meta = (0, _getDisplayName2.default)(Component);
            }

            var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
              meta: meta,
              classNamePrefix: meta,
              flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
              link: false
            }, this.sheetOptions, stylesCreatorSaved.options, {
              name: name
            }, styleSheetOptions));

            sheetManagerTheme.sheet = sheet;
            sheet.attach();

            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManagerTheme.refs += 1;
        }
      }, {
        key: 'detach',
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;
          var sheetManager = this.sheetsManager.get(stylesCreatorSaved);
          var sheetManagerTheme = sheetManager.get(theme);

          sheetManagerTheme.refs -= 1;

          if (sheetManagerTheme.refs === 0) {
            sheetManager.delete(theme);
            this.jss.removeStyleSheet(sheetManagerTheme.sheet);
            var sheetsRegistry = this.context[ns.sheetsRegistry];
            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManagerTheme.sheet);
            }
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;

          var _props = this.props,
              classesProp = _props.classes,
              innerRef = _props.innerRef,
              other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'innerRef']);


          var classes = void 0;
          var renderedClasses = {};

          if (!this.disableStylesGeneration) {
            var sheetManager = this.sheetsManager.get(this.stylesCreatorSaved);
            var sheetsManagerTheme = sheetManager.get(this.theme);
            renderedClasses = sheetsManagerTheme.sheet.classes;
          }

          if (classesProp) {
            classes = (0, _extends3.default)({}, renderedClasses, (0, _keys2.default)(classesProp).reduce(function (accumulator, key) {
               false ? (0, _warning2.default)(renderedClasses[key] || _this3.disableStylesGeneration, ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not implemented in ' + (0, _getDisplayName2.default)(Component) + '.'), 'You can only override one of the following: ' + (0, _keys2.default)(renderedClasses).join(',')].join('\n')) : void 0;

               false ? (0, _warning2.default)(!classesProp[key] || typeof classesProp[key] === 'string', ['Material-UI: the key `' + key + '` ' + ('provided to the classes property is not valid for ' + (0, _getDisplayName2.default)(Component) + '.'), 'You need to provide a non empty string instead of: ' + classesProp[key] + '.'].join('\n')) : void 0;

              if (classesProp[key]) {
                accumulator[key] = renderedClasses[key] + ' ' + classesProp[key];
              }

              return accumulator;
            }, {}));
          } else {
            classes = renderedClasses;
          }

          var more = {};

          // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.
          if (withTheme) {
            more.theme = this.theme;
          }

          return _react2.default.createElement(Component, (0, _extends3.default)({ classes: classes }, more, other, { ref: innerRef }));
        }
      }]);
      return WithStyles;
    }(_react2.default.Component);

    WithStyles.propTypes =  false ? {
      /**
       * Useful to extend the style applied to components.
       */
      classes: _propTypes2.default.object,
      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes2.default.func
    } : {};

    WithStyles.contextTypes = (0, _extends3.default)({
      muiThemeProviderOptions: _propTypes2.default.object
    }, _contextTypes2.default, listenToTheme ? _themeListener2.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = (0, _wrapDisplayName2.default)(Component, 'WithStyles');
    }

    (0, _hoistNonReactStatics2.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};

exports.default = withStyles;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(177);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(513), __esModule: true };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(177);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(530);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(534);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
} //  weak

function contains(obj, pred) {
  return (0, _keys2.default)(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }
    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }
    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }
  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (func) {
    return func != null;
  }).reduce(function (acc, func) {
     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SvgIcon = __webpack_require__(741);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SvgIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 17 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = objectToGetParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable prefer-template */
function objectToGetParams(object) {
  return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(object).filter(function (key) {
    return !!object[key];
  }).map(function (key) {
    return key + '=' + encodeURIComponent(object[key]);
  }).join('&');
}
/* eslint-enable prefer-template */

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shouldUpdate = __webpack_require__(743);

var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);

var _shallowEqual = __webpack_require__(745);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _setDisplayName = __webpack_require__(354);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(98);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
    return !(0, _shallowEqual2.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

exports.default = pure;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__(765);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Paper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(292);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Typography = __webpack_require__(154);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Typography).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(406);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var core = __webpack_require__(21);
var ctx = __webpack_require__(59);
var hide = __webpack_require__(52);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _wrapDisplayName = __webpack_require__(98);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createMuiTheme = __webpack_require__(166);

var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);

var _themeListener = __webpack_require__(187);

var _themeListener2 = _interopRequireDefault(_themeListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTheme = void 0;

function getDefaultTheme() {
  if (defaultTheme) {
    return defaultTheme;
  }

  defaultTheme = (0, _createMuiTheme2.default)();
  return defaultTheme;
}

// Provide the theme object as a property to the input component.
var withTheme = function withTheme() {
  return function (Component) {
    var WithTheme = function (_React$Component) {
      (0, _inherits3.default)(WithTheme, _React$Component);

      function WithTheme(props, context) {
        (0, _classCallCheck3.default)(this, WithTheme);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));

        _this.state = {};
        _this.unsubscribeId = null;

        _this.state = {
          // We use || as the function call is lazy evaluated.
          theme: _themeListener2.default.initial(context) || getDefaultTheme()
        };
        return _this;
      }

      (0, _createClass3.default)(WithTheme, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
            _this2.setState({ theme: theme });
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.unsubscribeId !== null) {
            _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(Component, (0, _extends3.default)({ theme: this.state.theme }, this.props));
        }
      }]);
      return WithTheme;
    }(_react2.default.Component);

    WithTheme.contextTypes = _themeListener2.default.contextTypes;

    if (false) {
      WithTheme.displayName = (0, _wrapDisplayName2.default)(Component, 'WithTheme');
    }

    (0, _hoistNonReactStatics2.default)(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };
};

exports.default = withTheme;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createFirebaseInstance = __webpack_require__(291);

var _firebaseConnect = __webpack_require__(729);

var _firebaseConnect2 = _interopRequireDefault(_firebaseConnect);

var _firestoreConnect = __webpack_require__(730);

var _firestoreConnect2 = _interopRequireDefault(_firestoreConnect);

var _withFirebase = __webpack_require__(731);

var _withFirebase2 = _interopRequireDefault(_withFirebase);

var _withFirestore = __webpack_require__(732);

var _withFirestore2 = _interopRequireDefault(_withFirestore);

var _enhancer = __webpack_require__(733);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _reducer = __webpack_require__(734);

var _reducer2 = _interopRequireDefault(_reducer);

var _constants = __webpack_require__(49);

var _constants2 = _interopRequireDefault(_constants);

var _auth = __webpack_require__(217);

var _helpers = __webpack_require__(332);

var helpers = _interopRequireWildcard(_helpers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  firebase: _firebaseConnect2.default,
  createFirebaseInstance: _createFirebaseInstance.createFirebaseInstance,
  firebaseConnect: _firebaseConnect2.default,
  createFirebaseConnect: _firebaseConnect.createFirebaseConnect,
  firestoreConnect: _firestoreConnect2.default,
  createFirestoreConnect: _firestoreConnect.createFirestoreConnect,
  withFirebase: _withFirebase2.default,
  createWithFirebase: _withFirebase.createWithFirebase,
  withFirestore: _withFirestore2.default,
  createWithFirestore: _withFirestore.createWithFirestore,
  reducer: _reducer2.default,
  firebaseReducer: _reducer2.default,
  firebaseStateReducer: _reducer2.default,
  reduxReactFirebase: _enhancer2.default,
  reactReduxFirebase: _enhancer2.default,
  reduxFirebase: _enhancer2.default,
  constants: _constants2.default,
  actionTypes: _constants.actionTypes,
  getFirebase: _enhancer.getFirebase,
  authIsReady: _auth.authIsReady,
  helpers: helpers
}, helpers);
module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ieDetection__ = __webpack_require__(366);














var isPromise = function isPromise(obj) {
  return !!obj && ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(obj)) === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
};

function windowOpen(url, _ref, onShareWindowClose) {
  var name = _ref.name,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 400 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 550 : _ref$width;

  /* eslint-disable no-mixed-operators */
  var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  /* eslint-enable no-mixed-operators */

  var config = {
    height: height,
    width: width,
    left: left,
    top: top,
    location: 'no',
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar: 'no',
    scrollbars: 'yes',
    resizable: 'no',
    centerscreen: 'yes',
    chrome: 'yes'
  };

  var shareDialog = window.open(url, Object(__WEBPACK_IMPORTED_MODULE_11__ieDetection__["a" /* default */])(10) ? '' : name, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(config).map(function (key) {
    return key + '=' + config[key];
  }).join(', '));

  if (onShareWindowClose) {
    var interval = window.setInterval(function () {
      try {
        if (shareDialog === null || shareDialog.closed) {
          window.clearInterval(interval);
          onShareWindowClose(shareDialog);
        }
      } catch (e) {
        /* eslint-disable no-console */
        console.error(e);
        /* eslint-enable no-console */
      }
    }, 1000);
  }

  return shareDialog;
}

var ShareButton = function (_PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShareButton, _PureComponent);

  function ShareButton() {
    var _ref2;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref2 = ShareButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ShareButton)).call.apply(_ref2, [this].concat(args))), _this), _this.onClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          openWindow = _this$props.openWindow;


      if (disabled) {
        return;
      }

      e.preventDefault();

      var link = _this.link();

      if (openWindow) {
        _this.openWindow(link);
      }

      if (onClick) {
        onClick(link);
      }
    }, _this.onKeyPress = function (e) {
      if (e.key === 'Enter' || e.key === 13) {
        _this.onClick(e);
      }
    }, _this.openWindow = function (link) {
      var _this$props2 = _this.props,
          beforeOnClick = _this$props2.beforeOnClick,
          onShareWindowClose = _this$props2.onShareWindowClose,
          windowWidth = _this$props2.windowWidth,
          windowHeight = _this$props2.windowHeight;


      var windowOptions = {
        height: windowHeight,
        width: windowWidth
      };

      var windowOpenBound = function windowOpenBound() {
        return windowOpen(link, windowOptions, onShareWindowClose);
      };

      if (beforeOnClick) {
        var returnVal = beforeOnClick();

        if (isPromise(returnVal)) {
          returnVal.then(windowOpenBound);
        } else {
          windowOpenBound();
        }
      } else {
        windowOpenBound();
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ShareButton, [{
    key: 'link',
    value: function link() {
      var _props = this.props,
          url = _props.url,
          opts = _props.opts,
          networkLink = _props.networkLink;

      return networkLink(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          additionalProps = _props2.additionalProps,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          disabledStyle = _props2.disabledStyle,
          network = _props2.network,
          role = _props2.role,
          style = _props2.style,
          tabIndex = _props2.tabIndex;


      var classes = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('SocialMediaShareButton', 'SocialMediaShareButton--' + network, {
        'SocialMediaShareButton--disabled': !!disabled,
        disabled: !!disabled
      }, className);

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, additionalProps, {
          role: role,
          tabIndex: tabIndex,
          onClick: this.onClick,
          onKeyPress: this.onKeyPress,
          className: classes,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, disabled ? disabledStyle : {}) }),
        children
      );
    }
  }]);

  return ShareButton;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

ShareButton.propTypes = {
  additionalProps: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  disabledStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  network: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  networkLink: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  opts: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  openWindow: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  url: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
  windowWidth: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  windowHeight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
  beforeOnClick: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onShareWindowClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  tabIndex: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string
};
ShareButton.defaultProps = {
  disabledStyle: {
    opacity: 0.6
  },
  openWindow: true,
  role: 'button',
  tabIndex: '0'
};


function createShareButton(network, link) {
  var optsMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  var propTypes = arguments[3];
  var defaultProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var CreatedButton = function CreatedButton(props) {
    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ShareButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      network: network,
      networkLink: link,
      opts: optsMap(props) }));
  };

  CreatedButton.propTypes = propTypes;
  CreatedButton.defaultProps = defaultProps;

  return CreatedButton;
}

/* harmony default export */ __webpack_exports__["a"] = (createShareButton);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iconFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function iconFactory(network, iconConfig) {
  var Icon = function Icon(props) {
    var className = props.className,
        iconBgStyle = props.iconBgStyle,
        logoFillColor = props.logoFillColor,
        round = props.round,
        size = props.size;


    var baseStyle = {
      width: size,
      height: size
    };

    var classes = 'social-icon social-icon--' + network + ' ' + className;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { style: baseStyle },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'svg',
        {
          viewBox: '0 0 64 64',
          width: size,
          height: size,
          className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          !round ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', {
            width: '64',
            height: '64',
            fill: iconConfig.color,
            style: iconBgStyle }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle', {
            cx: '32',
            cy: '32',
            r: '31',
            fill: iconConfig.color,
            style: iconBgStyle })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'g',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: iconConfig.icon, fill: logoFillColor })
        )
      )
    );
  };

  Icon.propTypes = {
    className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    iconBgStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    logoFillColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    round: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  };

  Icon.defaultProps = {
    className: '',
    iconBgStyle: {},
    logoFillColor: 'white',
    size: 64
  };

  return Icon;
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(785);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getLocation", function() { return __WEBPACK_IMPORTED_MODULE_1__selectors__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMatchSelector", function() { return __WEBPACK_IMPORTED_MODULE_1__selectors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "push", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "go", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return __WEBPACK_IMPORTED_MODULE_3__actions__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(173)('wks');
var uid = __webpack_require__(121);
var Symbol = __webpack_require__(41).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(60);
var IE8_DOM_DEFINE = __webpack_require__(256);
var toPrimitive = __webpack_require__(167);
var dP = Object.defineProperty;

exports.f = __webpack_require__(42) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(477), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObject = __webpack_require__(17);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(61)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ButtonBase = __webpack_require__(563);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonBase).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    getRawTag = __webpack_require__(576),
    objectToString = __webpack_require__(577);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _assign = __webpack_require__(254);

var _assign2 = _interopRequireDefault(_assign);

exports.withOptions = withOptions;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowEqual = __webpack_require__(159);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _supports = __webpack_require__(750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultEventOptions = {
  capture: false,
  passive: false
};

function mergeDefaultEventOptions(options) {
  return (0, _assign2.default)({}, defaultEventOptions, options);
}

function getEventListenerArgs(eventName, callback, options) {
  var args = [eventName, callback];
  args.push(_supports.passiveOption ? options : options.capture);
  return args;
}

function on(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function off(target, eventName, callback, options) {
  // eslint-disable-next-line prefer-spread
  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
}

function forEachListener(props, iteratee) {
  var children = props.children,
      target = props.target,
      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);


  (0, _keys2.default)(eventProps).forEach(function (name) {
    if (name.substring(0, 2) !== 'on') {
      return;
    }

    var prop = eventProps[name];
    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
    var isObject = type === 'object';
    var isFunction = type === 'function';

    if (!isObject && !isFunction) {
      return;
    }

    var capture = name.substr(-7).toLowerCase() === 'capture';
    var eventName = name.substring(2).toLowerCase();
    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;

    if (isObject) {
      iteratee(eventName, prop.handler, prop.options);
    } else {
      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
    }
  });
}

function withOptions(handler, options) {
   false ? (0, _warning2.default)(options, 'react-event-listener: should be specified options in withOptions.') : void 0;

  return {
    handler: handler,
    options: mergeDefaultEventOptions(options)
  };
}

var EventListener = function (_React$Component) {
  (0, _inherits3.default)(EventListener, _React$Component);

  function EventListener() {
    (0, _classCallCheck3.default)(this, EventListener);
    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addListeners();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _shallowEqual2.default)(this.props, nextProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: 'addListeners',
    value: function addListeners() {
      this.applyListeners(on);
    }
  }, {
    key: 'removeListeners',
    value: function removeListeners() {
      this.applyListeners(off);
    }
  }, {
    key: 'applyListeners',
    value: function applyListeners(onOrOff) {
      var target = this.props.target;


      if (target) {
        var element = target;

        if (typeof target === 'string') {
          element = window[target];
        }

        forEachListener(this.props, onOrOff.bind(null, element));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children || null;
    }
  }]);
  return EventListener;
}(_react2.default.Component);

EventListener.propTypes =  false ? {
  /**
   * You can provide a single child too.
   */
  children: _propTypes2.default.node,
  /**
   * The DOM target to listen to.
   */
  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
} : {};

exports.default = EventListener;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var actionsPrefix = exports.actionsPrefix = '@@reactReduxFirebase';

var actionTypes = exports.actionTypes = {
  START: actionsPrefix + '/START',
  SET: actionsPrefix + '/SET',
  REMOVE: actionsPrefix + '/REMOVE',
  MERGE: actionsPrefix + '/MERGE',
  SET_PROFILE: actionsPrefix + '/SET_PROFILE',
  LOGIN: actionsPrefix + '/LOGIN',
  LOGOUT: actionsPrefix + '/LOGOUT',
  LOGIN_ERROR: actionsPrefix + '/LOGIN_ERROR',
  NO_VALUE: actionsPrefix + '/NO_VALUE',
  UNAUTHORIZED_ERROR: actionsPrefix + '/UNAUTHORIZED_ERROR',
  ERROR: actionsPrefix + '/ERROR',
  CLEAR_ERRORS: actionsPrefix + '/CLEAR_ERRORS',
  SET_LISTENER: actionsPrefix + '/SET_LISTENER',
  UNSET_LISTENER: actionsPrefix + '/UNSET_LISTENER',
  AUTHENTICATION_INIT_STARTED: actionsPrefix + '/AUTHENTICATION_INIT_STARTED',
  AUTHENTICATION_INIT_FINISHED: actionsPrefix + '/AUTHENTICATION_INIT_FINISHED',
  SESSION_START: actionsPrefix + '/SESSION_START',
  SESSION_END: actionsPrefix + '/SESSION_END',
  FILE_UPLOAD_START: actionsPrefix + '/FILE_UPLOAD_START',
  FILE_UPLOAD_ERROR: actionsPrefix + '/FILE_UPLOAD_ERROR',
  FILE_UPLOAD_PROGRESS: actionsPrefix + '/FILE_UPLOAD_PROGRESS',
  FILE_UPLOAD_COMPLETE: actionsPrefix + '/FILE_UPLOAD_COMPLETE',
  FILE_DELETE_START: actionsPrefix + '/FILE_DELETE_START',
  FILE_DELETE_ERROR: actionsPrefix + '/FILE_DELETE_ERROR',
  FILE_DELETE_COMPLETE: actionsPrefix + '/FILE_DELETE_COMPLETE',
  AUTH_UPDATE_START: actionsPrefix + '/AUTH_UPDATE_START',
  AUTH_UPDATE_SUCCESS: actionsPrefix + '/AUTH_UPDATE_SUCCESS',
  AUTH_UPDATE_ERROR: actionsPrefix + '/AUTH_UPDATE_ERROR',
  PROFILE_UPDATE_START: actionsPrefix + '/PROFILE_UPDATE_START',
  PROFILE_UPDATE_SUCCESS: actionsPrefix + '/PROFILE_UPDATE_SUCCESS',
  PROFILE_UPDATE_ERROR: actionsPrefix + '/PROFILE_UPDATE_ERROR',
  EMAIL_UPDATE_START: actionsPrefix + '/EMAIL_UPDATE_START',
  EMAIL_UPDATE_SUCCESS: actionsPrefix + '/EMAIL_UPDATE_SUCCESS',
  EMAIL_UPDATE_ERROR: actionsPrefix + '/EMAIL_UPDATE_ERROR',
  AUTH_RELOAD_START: actionsPrefix + '/AUTH_RELOAD_START',
  AUTH_RELOAD_ERROR: actionsPrefix + '/AUTH_RELOAD_ERROR',
  AUTH_RELOAD_SUCCESS: actionsPrefix + '/AUTH_RELOAD_SUCCESS',
  AUTH_LINK_START: actionsPrefix + '/AUTH_LINK_START',
  AUTH_LINK_ERROR: actionsPrefix + '/AUTH_LINK_ERROR',
  AUTH_LINK_SUCCESS: actionsPrefix + '/AUTH_LINK_SUCCESS',
  AUTH_EMPTY_CHANGE: actionsPrefix + '/AUTH_EMPTY_CHANGE'
};

var defaultConfig = exports.defaultConfig = {
  userProfile: null,
  presence: null,
  sessions: 'sessions',
  enableLogging: false,
  preserveOnLogout: null,
  preserveOnEmptyAuthChange: null,
  resetBeforeLogin: true,
  updateProfileOnLogin: true,
  enableRedirectHandling: true,
  autoPopulateProfile: false,
  setProfilePopulateResults: false,
  dispatchOnUnsetListener: true,
  dispatchRemoveAction: false,
  enableEmptyAuthChanges: true,
  firebaseStateName: 'firebase',
  attachAuthIsReady: false,
  keysToRemoveFromAuth: ['appName', 'apiKey', 'authDomain', 'redirectEventId', 'stsTokenManager', 'uid']
};

var supportedAuthProviders = exports.supportedAuthProviders = ['google', 'github', 'twitter', 'facebook'];

var topLevelPaths = exports.topLevelPaths = ['auth', 'profile', 'ordered', 'data'];

exports.default = {
  actionTypes: actionTypes,
  defaultConfig: defaultConfig
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
var styles=function styles(theme){return{root:{flexGrow:1,marginTop:30},paper:{//padding: 16,
},appbar:{position:'relative',zIndex:'1000'},slide:{position:'relative',zIndex:'0',minHeight:'100px'},card:{maxWidth:'100%'},media:{height:200,backgroundSize:'cover'},centerGrid:{flexDirection:'column',flexGrow:1,display:'flex',flexWrap:'wrap',alignItems:'center',marginTop:'8px'},itemGrid:{marginTop:'16px',textAlign:'center',width:'100%'},formControl:{marginTop:'16px'},textInput:{marginTop:'24px'},fullTextInput:{margin:'24px 0px 8px 0px'},fullButton:{margin:'5px'},popperClose:{pointerEvents:'none'}};};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(988);
var util = __webpack_require__(87);
var logger$1 = __webpack_require__(158);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {},
    _a["no-app" /* NO_APP */] = "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$name}",
    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$name}' already exists",
    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$name}' already deleted",
    _a["duplicate-service" /* DUPLICATE_SERVICE */] = "Firebase service named '{$name}' already registered",
    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.',
    _a);
var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function (val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            for (var _i = 0, _a = Object.keys(_this.services_); _i < _a.length; _i++) {
                var serviceKey = _a[_i];
                for (var _b = 0, _c = Object.keys(_this.services_[serviceKey]); _b < _c.length; _b++) {
                    var instanceKey = _c[_b];
                    services.push(_this.services_[serviceKey][instanceKey]);
                }
            }
            return Promise.all(services
                .filter(function (service) { return 'INTERNAL' in service; })
                .map(function (service) { return service.INTERNAL.delete(); }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');

var version = "6.2.4";

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        // @ts-ignore
        app: app,
        // @ts-ignore
        apps: null,
        SDK_VERSION: version,
        INTERNAL: {
            registerService: registerService,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    namespace['default'] = namespace;
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps[name];
        callAppHooks(app, 'delete');
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!util.contains(apps, name)) {
            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { name: name });
        }
        return apps[name];
    }
    // @ts-ignore
    app['App'] = firebaseAppImpl;
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, { name: String(name) });
        }
        if (util.contains(apps, name)) {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { name: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) { return apps[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        if (allowMultipleInstances === void 0) { allowMultipleInstances = false; }
        // Cannot re-register a service that already exists
        if (factories[name]) {
            throw ERROR_FACTORY.create("duplicate-service" /* DUPLICATE_SERVICE */, { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        function serviceNamespace(appArg) {
            if (appArg === void 0) { appArg = app(); }
            // @ts-ignore
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
                    name: name
                });
            }
            // Forward service instance lookup to the FirebaseApp.
            // @ts-ignore
            return appArg[name]();
        }
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        // @ts-ignore
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        // @ts-ignore
        firebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    function callAppHooks(app, eventName) {
        for (var _i = 0, _a = Object.keys(factories); _i < _a.length; _i++) {
            var serviceName = _a[_i];
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        }
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib_1.__assign({}, namespace.INTERNAL, { createFirebaseNamespace: createFirebaseNamespace,
        extendNamespace: extendNamespace,
        createSubscribe: util.createSubscribe,
        ErrorFactory: util.ErrorFactory,
        deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');
// Firebase Lite detection
// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (util.isBrowser() && self.firebase !== undefined) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    // eslint-disable-next-line
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var firebaseNamespace = createFirebaseNamespace();
var initializeApp = firebaseNamespace.initializeApp;
firebaseNamespace.initializeApp = function () {
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and set \"module\"\n      to false and \"main\" to true:\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, arguments);
};
var firebase = firebaseNamespace;

exports.default = firebase;
exports.firebase = firebase;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(38);
var createDesc = __webpack_require__(91);
module.exports = __webpack_require__(42) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = undefined;

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNan = __webpack_require__(264);

var _isNan2 = _interopRequireDefault(_isNan);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = exports.easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

/* eslint-disable no-param-reassign */

var duration = exports.duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

var formatMs = exports.formatMs = function formatMs(milliseconds) {
  return Math.round(milliseconds) + 'ms';
};
var isString = exports.isString = function isString(value) {
  return typeof value === 'string';
};
var isNumber = exports.isNumber = function isNumber(value) {
  return !(0, _isNan2.default)(parseFloat(value));
};

/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */
exports.default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === undefined ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === undefined ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === undefined ? 0 : _options$delay,
        other = (0, _objectWithoutProperties3.default)(options, ['duration', 'easing', 'delay']);


     false ? (0, _warning2.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning2.default)(isNumber(durationOption) || isString(durationOption), 'Material-UI: argument "duration" must be a number or a string but found ' + durationOption + '.') : void 0;
     false ? (0, _warning2.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning2.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unrecognized argument(s) [' + (0, _keys2.default)(other).join(',') + ']') : void 0;

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return animatedProp + ' ' + (typeof durationOption === 'string' ? durationOption : formatMs(durationOption)) + ' ' + easingOption + ' ' + (typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36;

    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneChildrenWithClassName = cloneChildrenWithClassName;
exports.isMuiElement = isMuiElement;
exports.isMuiComponent = isMuiComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */

function cloneChildrenWithClassName(children, className) {
  return _react2.default.Children.map(children, function (child) {
    return _react2.default.isValidElement(child) && _react2.default.cloneElement(child, {
      className: (0, _classnames2.default)(child.props.className, className)
    });
  });
}

function isMuiElement(element, muiNames) {
  return _react2.default.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function isMuiComponent(element, muiNames) {
  return muiNames.indexOf(element.muiName) !== -1;
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(580),
    baseMatchesProperty = __webpack_require__(626),
    identity = __webpack_require__(105),
    isArray = __webpack_require__(13),
    property = __webpack_require__(631);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isLength = __webpack_require__(194);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shareCountFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);










var SocialMediaShareCount = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialMediaShareCount, _Component);

  function SocialMediaShareCount(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialMediaShareCount);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialMediaShareCount.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialMediaShareCount)).call(this, props));

    _this._isMounted = false;
    _this.state = { count: 0 };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialMediaShareCount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.updateCount(this.props.url);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.url !== this.props.url) {
        this.updateCount(nextProps.url);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'updateCount',
    value: function updateCount(url) {
      var _this2 = this;

      if (this.props.getCount) {
        this.setState({
          isLoading: true
        });

        this.props.getCount(url, function (count) {
          if (_this2._isMounted) {
            _this2.setState({
              count: count,
              isLoading: false
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          isLoading = _state.isLoading;
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('SocialMediaShareCount', className) },
        !isLoading && children(count || 0)
      );
    }
  }]);

  return SocialMediaShareCount;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

SocialMediaShareCount.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  getCount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  url: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

SocialMediaShareCount.defaultProps = {
  children: function children(shareCount) {
    return shareCount;
  }
};

function shareCountFactory(getCount) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(SocialMediaShareCount, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ getCount: getCount }, props));
  };
}

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["h"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* unused harmony export select */
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (immutable) */ __webpack_exports__["i"] = takeEvery;
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(239);



var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(255);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

   false ? (0, _warning2.default)(value >= min && value <= max, 'Material-UI: the value provided ' + value + ' is out of range [' + min + ', ' + max + '].') : void 0;

  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 *  @returns {string} A CSS rgb color string
 */
//  weak
/* eslint-disable no-use-before-define */

function convertHexToRGB(color) {
  color = color.substr(1);

  var re = new RegExp('.{1,' + color.length / 3 + '}', 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? 'rgb(' + colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', ') + ')' : '';
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  return { type: type, values: values };
}

/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;


  if (type.indexOf('rgb') > -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') > -1) {
    values[1] = values[1] + '%';
    values[2] = values[2] + '%';
  }

  return color.type + '(' + values.join(', ') + ')';
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') > -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized
      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } else if (decomposedColor.type.indexOf('hsl') > -1) {
    return decomposedColor.values[2] / 100;
  }

  throw new Error('Material-UI: unsupported `' + color + '` color.');
}

/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;

  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}

/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function fade(color, value) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in fade(' + color + ', ' + value + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  color.values[3] = value;

  return recomposeColor(color);
}

/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in darken(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}

/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
   false ? (0, _warning2.default)(color, 'Material-UI: missing color argument in lighten(' + color + ', ' + coefficient + ').') : void 0;

  if (!color) return color;

  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') > -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') > -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__(562);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(592),
    getValue = __webpack_require__(595);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(103);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(144),
    baseAssignValue = __webpack_require__(145);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Grid = __webpack_require__(746);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17),
    now = __webpack_require__(751),
    toNumber = __webpack_require__(350);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(772)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(449);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(451);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(459);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(165);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(461);
/* unused harmony reexport withRouter */



















/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(168);
var defined = __webpack_require__(170);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(170);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(178);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(124);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

exports = module.exports = function(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}


/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(574);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(301),
    baseKeys = __webpack_require__(197),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(622),
    Map = __webpack_require__(188),
    Promise = __webpack_require__(623),
    Set = __webpack_require__(624),
    WeakMap = __webpack_require__(303),
    baseGetTag = __webpack_require__(44),
    toSource = __webpack_require__(293);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isKey = __webpack_require__(198),
    stringToPath = __webpack_require__(306),
    toString = __webpack_require__(104);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(313),
    createBaseEach = __webpack_require__(639);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CircularProgress = __webpack_require__(815);

Object.defineProperty(exports, 'CircularProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CircularProgress).default;
  }
});

var _LinearProgress = __webpack_require__(816);

Object.defineProperty(exports, 'LinearProgress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LinearProgress).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(989);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function (input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, webSafe) {
        this.init_();
        var charToByteMap = webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return (typeof window !== 'undefined' &&
        // @ts-ignore Setting up an broadly applicable index signature for Window
        // just to deal with this case would probably be a bad idea.
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return (Object.prototype.toString.call(global.process) === '[object process]');
    }
    catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof self === 'object' && self.self === self;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */ (function (_super) {
    tslib_1.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error));
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        var customData = data[0] || {};
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
            var key = _b[_a];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = customData[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}());
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (!!now &&
        !!validSince &&
        !!validUntil &&
        now >= validSince &&
        now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, fn, context) {
    var res = {};
    for (var key in obj) {
        res[key] = fn.call(context, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, context) {
    for (var key in obj) {
        if (fn.call(context, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, context) {
    var key = findKey(obj, fn, context);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, offset) {
        if (!offset) {
            offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(offset) << 24) |
                        (buf.charCodeAt(offset + 1) << 16) |
                        (buf.charCodeAt(offset + 2) << 8) |
                        buf.charCodeAt(offset + 3);
                offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[offset] << 24) |
                        (buf[offset + 1] << 16) |
                        (buf[offset + 2] << 8) |
                        buf[offset + 3];
                offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (length === undefined) {
            length = bytes.length;
        }
        var lengthMinusBlock = length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf === this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}());

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            // tslint:disable-next-line:no-floating-promises
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        // tslint:disable-next-line:no-floating-promises
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        // tslint:disable-next-line:no-floating-promises
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argumentNumber The index of the argument
 * @param optional Whether or not the argument is optional
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) {
        return;
    }
    if (typeof context !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.Sha1 = Sha1;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.clone = clone;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getUA = getUA;
exports.getValues = getValues;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isEmpty = isEmpty;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isNonNullObject = isNonNullObject;
exports.isReactNative = isReactNative;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(58);
/* unused harmony reexport take */
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport race */
/* unused harmony reexport call */
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* unused harmony reexport cancel */
/* unused harmony reexport select */
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createGenerateClassName = __webpack_require__(253);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName).default;
  }
});

var _createMuiTheme = __webpack_require__(166);

Object.defineProperty(exports, 'createMuiTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createMuiTheme).default;
  }
});

var _jssPreset = __webpack_require__(265);

Object.defineProperty(exports, 'jssPreset', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_jssPreset).default;
  }
});

var _MuiThemeProvider = __webpack_require__(512);

Object.defineProperty(exports, 'MuiThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MuiThemeProvider).default;
  }
});

var _withStyles = __webpack_require__(4);

Object.defineProperty(exports, 'withStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withStyles).default;
  }
});

var _withTheme = __webpack_require__(27);

Object.defineProperty(exports, 'withTheme', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withTheme).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(258);
var enumBugKeys = __webpack_require__(174);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createBreakpoints;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = exports.keys = ['xs', 'sm', 'md', 'lg', 'xl'];

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === undefined ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === undefined ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === undefined ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties3.default)(breakpoints, ['values', 'unit', 'step']);


  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return '@media (min-width:' + value + unit + ')';
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return '@media (max-width:' + (value - step / 100) + unit + ')';
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return '@media (min-width:' + values[start] + unit + ') and ' + ('(max-width:' + (values[keys[endIndex]] - step / 100) + unit + ')');
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends3.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(125);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(269);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(487);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options = this.options,
          parent = _options.parent,
          sheet = _options.sheet,
          jss = _options.jss,
          Renderer = _options.Renderer,
          generateClassName = _options.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      var _options2 = this.options,
          plugins = _options2.jss.plugins,
          sheet = _options2.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, this.get(name), sheet);
        return;
      }

      for (var index = 0; index < this.index.length; index++) {
        plugins.onUpdate(name, this.index[index], sheet);
      }
    }

    /**
     * Link renderable rules with CSSRuleList.
     */

  }, {
    key: 'link',
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(515);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(523);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specialProperty = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _extends3 = __webpack_require__(2);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = exactProp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

var specialProperty = exports.specialProperty = 'exact-prop: \u200B';

function exactProp(propTypes, componentNameInError) {
  return (0, _extends4.default)({}, propTypes, (0, _defineProperty3.default)({}, specialProperty, function (props) {
    var unknownProps = (0, _keys2.default)(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });
    if (unknownProps.length > 0) {
      return new TypeError(componentNameInError + ': unknown props found: ' + unknownProps.join(', ') + '. Please remove the unknown properties.');
    }
    return null;
  }));
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__(287);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(566);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToDate = exports.wrapDisplayName = exports.getDisplayName = exports.createCallable = exports.getEventsFromInput = undefined;

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _events = __webpack_require__(578);

Object.defineProperty(exports, 'getEventsFromInput', {
  enumerable: true,
  get: function get() {
    return _events.getEventsFromInput;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createCallable = exports.createCallable = function createCallable(f) {
  return (0, _isFunction3.default)(f) ? f : function () {
    return f;
  };
};

var getDisplayName = exports.getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var wrapDisplayName = exports.wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var stringToDate = exports.stringToDate = function stringToDate(strInput) {
  try {
    return new Date(JSON.parse(strInput));
  } catch (err) {
    console.error('Error parsing string to date:', err.message || err);
    return strInput;
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(140);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(629);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = __webpack_require__(740);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormGroup = __webpack_require__(359);

Object.defineProperty(exports, 'FormGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormGroup).default;
  }
});

var _FormLabel = __webpack_require__(761);

Object.defineProperty(exports, 'FormLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLabel).default;
  }
});

var _FormControl = __webpack_require__(360);

Object.defineProperty(exports, 'FormControl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControl).default;
  }
});

var _FormHelperText = __webpack_require__(361);

Object.defineProperty(exports, 'FormHelperText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormHelperText).default;
  }
});

var _FormControlLabel = __webpack_require__(763);

Object.defineProperty(exports, 'FormControlLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormControlLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadingStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadingStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return testStart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(110);
var loadingStart=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["e" /* LOADING_START */],'message');var loadingStop=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["f" /* LOADING_STOP */]);var testStart=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["k" /* TEST_START */]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SIGNIN_REQUEST */
/* unused harmony export SIGNIN_SUCCESS */
/* unused harmony export SIGNIN_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROFILE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PROFILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROFILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JOBSEARCH_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return JOBSEARCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JOBSEARCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return JOBSEARCH_DELETE; });
/* unused harmony export TEST_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TEST_ANSWER; });
/* unused harmony export TEST_SUCCESS */
/* unused harmony export TEST_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TEST_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOADING_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOADING_STOP; });
/* harmony export (immutable) */ __webpack_exports__["l"] = makeActionCreator;
//App
//SIGNIN
var SIGNIN_REQUEST='@@signin/REQUEST';var SIGNIN_SUCCESS='@@signin/SUCCESS';var SIGNIN_FAILURE='@@signin/FAILURE';//PROFILE
var PROFILE_ADD='@@profile/ADD';var PROFILE_SUCCESS='@@profile/SUCCESS';var PROFILE_FAILURE='@@profile/FAILURE';//JOBSEARCH
var JOBSEARCH_ADD='@@jobSearch/ADD';var JOBSEARCH_SUCCESS='@@jobSearch/SUCCESS';var JOBSEARCH_FAILURE='@@jobSearch/FAILURE';var JOBSEARCH_DELETE='@@jobSearch/DELETE';//TEST
var TEST_REQUEST='@@test/REQUEST';var TEST_ANSWER='@@test/ANSWER';var TEST_SUCCESS='@@test/SUCCESS';var TEST_FAILURE='@@test/FAILURE';var TEST_START='@@test/START';//LOADING
var LOADING_START='@@loading/START';var LOADING_STOP='@@loading/STOP';//TEST
function makeActionCreator(type){for(var _len=arguments.length,argNames=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){argNames[_key-1]=arguments[_key];}return function(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}var action={type:type};argNames.forEach(function(arg,index){action[argNames[index]]=args[index];});return action;};}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Card = __webpack_require__(764);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Card).default;
  }
});

var _CardContent = __webpack_require__(766);

Object.defineProperty(exports, 'CardContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardContent).default;
  }
});

var _CardActions = __webpack_require__(767);

Object.defineProperty(exports, 'CardActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardActions).default;
  }
});

var _CardMedia = __webpack_require__(768);

Object.defineProperty(exports, 'CardMedia', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardMedia).default;
  }
});

var _CardHeader = __webpack_require__(769);

Object.defineProperty(exports, 'CardHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CardHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTransitionProps = getTransitionProps;
var reflow = exports.reflow = function reflow(node) {
  return node.scrollTop;
};

function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === undefined ? {} : _props$style;


  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode],
    delay: style.transitionDelay
  };
}

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Menu = __webpack_require__(372);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Menu).default;
  }
});

var _MenuList = __webpack_require__(381);

Object.defineProperty(exports, 'MenuList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuList).default;
  }
});

var _MenuItem = __webpack_require__(856);

Object.defineProperty(exports, 'MenuItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(219);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _InputAdornment = __webpack_require__(861);

Object.defineProperty(exports, 'InputAdornment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputAdornment).default;
  }
});

var _InputLabel = __webpack_require__(862);

Object.defineProperty(exports, 'InputLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InputLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(171);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
	var clone = !optionsArgument || optionsArgument.clone !== false;

	return (clone && isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, optionsArgument)
		: value
}

function defaultArrayMerge(target, source, optionsArgument) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, optionsArgument)
	})
}

function mergeObject(target, source, optionsArgument) {
	var destination = {};
	if (isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
		} else {
			destination[key] = deepmerge(target[key], source[key], optionsArgument);
		}
	});
	return destination
}

function deepmerge(target, source, optionsArgument) {
	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, optionsArgument)
	} else if (sourceIsArray) {
		var arrayMerge = options.arrayMerge || defaultArrayMerge;
		return arrayMerge(target, source, optionsArgument)
	} else {
		return mergeObject(target, source, optionsArgument)
	}
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, optionsArgument)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(486);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(60);
var dPs = __webpack_require__(519);
var enumBugKeys = __webpack_require__(174);
var IE_PROTO = __webpack_require__(172)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(257)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(520).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(38).f;
var has = __webpack_require__(62);
var TAG = __webpack_require__(34)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(59);
var call = __webpack_require__(282);
var isArrayIter = __webpack_require__(283);
var anObject = __webpack_require__(60);
var toLength = __webpack_require__(120);
var getIterFn = __webpack_require__(284);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(132),
    stackClear = __webpack_require__(587),
    stackDelete = __webpack_require__(588),
    stackGet = __webpack_require__(589),
    stackHas = __webpack_require__(590),
    stackSet = __webpack_require__(591);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(582),
    listCacheDelete = __webpack_require__(583),
    listCacheGet = __webpack_require__(584),
    listCacheHas = __webpack_require__(585),
    listCacheSet = __webpack_require__(586);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(101);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(604);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(618),
    isObjectLike = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(22),
    stubFalse = __webpack_require__(619);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    toKey = __webpack_require__(66);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 141 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(141),
    baseIteratee = __webpack_require__(55),
    baseMap = __webpack_require__(637),
    isArray = __webpack_require__(13);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promisesForPopulate = exports.populateList = exports.getPopulateChild = exports.getPopulates = exports.getPopulateObjs = exports.getChildType = exports.getPopulateObj = undefined;

var _some2 = __webpack_require__(315);

var _some3 = _interopRequireDefault(_some2);

var _has2 = __webpack_require__(316);

var _has3 = _interopRequireDefault(_has2);

var _set2 = __webpack_require__(317);

var _set3 = _interopRequireDefault(_set2);

var _forEach2 = __webpack_require__(202);

var _forEach3 = _interopRequireDefault(_forEach2);

var _get2 = __webpack_require__(102);

var _get3 = _interopRequireDefault(_get2);

var _map2 = __webpack_require__(142);

var _map3 = _interopRequireDefault(_map2);

var _isObject2 = __webpack_require__(17);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _filter2 = __webpack_require__(643);

var _filter3 = _interopRequireDefault(_filter2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPopulateObj = exports.getPopulateObj = function getPopulateObj(str) {
  if (!(0, _isString3.default)(str)) {
    return str;
  }
  var strArray = str.split(':');

  return { child: strArray[0], root: strArray[1] };
};
var getChildType = exports.getChildType = function getChildType(child) {
  if ((0, _isString3.default)(child)) {
    return 'string';
  }
  if ((0, _isArray3.default)(child)) {
    return 'array';
  }
  if ((0, _isObject3.default)(child)) {
    return 'object';
  }
  return 'other';
};

var getPopulateObjs = exports.getPopulateObjs = function getPopulateObjs(arr) {
  if (!(0, _isArray3.default)(arr)) {
    return arr;
  }
  return arr.map(function (o) {
    return (0, _isObject3.default)(o) ? o : getPopulateObj(o);
  });
};

var getPopulates = exports.getPopulates = function getPopulates(params) {
  var populates = (0, _filter3.default)(params, function (param) {
    return param.indexOf('populate') !== -1 || (0, _isObject3.default)(param) && param.populates;
  }).map(function (p) {
    return p.split('=')[1];
  });

  if (!populates.length) {
    return null;
  }
  return populates.map(getPopulateObj);
};

var getPopulateChild = exports.getPopulateChild = function getPopulateChild(firebase, populate, id) {
  return firebase.database().ref().child(populate.root + '/' + id).once('value').then(function (snap) {
    return snap.val();
  });
};

var populateList = exports.populateList = function populateList(firebase, list, p, results) {
  if (!results[p.root]) {
    (0, _set3.default)(results, p.root, {});
  }
  return Promise.all((0, _map3.default)(list, function (id, childKey) {
    var populateKey = id === true ? childKey : id;
    return getPopulateChild(firebase, p, populateKey).then(function (pc) {
      if (pc) {
        return (0, _set3.default)(results, p.root + '.' + populateKey, pc);
      }
      return results;
    });
  }));
};

var promisesForPopulate = exports.promisesForPopulate = function promisesForPopulate(firebase, dataKey, originalData, populatesIn) {
  var promisesArray = [];
  var results = {};

  var populatesForData = getPopulateObjs((0, _isFunction3.default)(populatesIn) ? populatesIn(dataKey, originalData) : populatesIn);

  var dataHasPopulateChilds = (0, _some3.default)(populatesForData, function (populate) {
    return (0, _has3.default)(originalData, populate.child);
  });

  if (dataHasPopulateChilds) {
    (0, _forEach3.default)(populatesForData, function (p) {
      if ((0, _isString3.default)((0, _get3.default)(originalData, p.child))) {
        return promisesArray.push(getPopulateChild(firebase, p, (0, _get3.default)(originalData, p.child)).then(function (v) {
          if (v) {
            (0, _set3.default)(results, p.root + '.' + (0, _get3.default)(originalData, p.child), v);
          }
        }));
      }

      return promisesArray.push(populateList(firebase, (0, _get3.default)(originalData, p.child), p, results));
    });
  } else {
    (0, _forEach3.default)(originalData, function (d, key) {
      var populatesForDataItem = getPopulateObj((0, _isFunction3.default)(populatesIn) ? populatesIn(key, d) : populatesIn);

      (0, _forEach3.default)(populatesForDataItem, function (p) {
        var idOrList = (0, _get3.default)(d, p.child);

        if (!idOrList) {
          return;
        }

        if ((0, _isString3.default)(idOrList)) {
          return promisesArray.push(getPopulateChild(firebase, p, idOrList).then(function (v) {
            if (v) {
              (0, _set3.default)(results, p.root + '.' + idOrList, v);
            }
            return results;
          }));
        }

        if ((0, _isArray3.default)(idOrList) || (0, _isObject3.default)(idOrList)) {
          return promisesArray.push(populateList(firebase, idOrList, p, results));
        }
      });
    });
  }

  return Promise.all(promisesArray).then(function () {
    return results;
  });
};

exports.default = { promisesForPopulate: promisesForPopulate };

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(145),
    eq = __webpack_require__(101);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(318);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(301),
    baseKeysIn = __webpack_require__(652),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 149 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(148),
    isObject = __webpack_require__(17);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWidthDown = exports.isWidthUp = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _wrapDisplayName = __webpack_require__(98);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _withTheme = __webpack_require__(27);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _createBreakpoints = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// By default, returns true if screen width is the same or greater than the given breakpoint.
var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
  }
  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
};

// By default, returns true if screen width is the same or less than the given breakpoint.
var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
  }
  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
};

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$resizeInterv = options.resizeInterval,
        resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv,
        _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === undefined ? false : _options$withTheme;

    var WithWidth = function (_React$Component) {
      (0, _inherits3.default)(WithWidth, _React$Component);

      function WithWidth() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithWidth);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          width: undefined
        }, _this.handleResize = (0, _debounce2.default)(function () {
          _this.updateWidth(window.innerWidth);
        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithWidth, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.updateWidth(window.innerWidth);
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this.handleResize.cancel();
        }
      }, {
        key: 'updateWidth',
        value: function updateWidth(innerWidth) {
          var breakpoints = this.props.theme.breakpoints;
          var width = null;

          /**
           * Start with the slowest value as low end devices often have a small screen.
           *
           * innerWidth |xs      sm      md      lg      xl
           *            |-------|-------|-------|-------|------>
           * width      |  xs   |  sm   |  md   |  lg   |  xl
           */
          var index = 1;
          while (width === null && index < _createBreakpoints.keys.length) {
            var currentWidth = _createBreakpoints.keys[index];

            // @media are inclusive, so reproduce the behavior here.
            if (innerWidth < breakpoints.values[currentWidth]) {
              width = _createBreakpoints.keys[index - 1];
              break;
            }

            index += 1;
          }

          width = width || 'xl';

          if (width !== this.state.width) {
            this.setState({
              width: width
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              initialWidth = _props.initialWidth,
              theme = _props.theme,
              width = _props.width,
              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);

          var props = (0, _extends3.default)({
            width: width || this.state.width || initialWidth
          }, other);
          var more = {};

          if (withThemeOption) {
            more.theme = theme;
          }

          // When rendering the component on the server,
          // we have no idea about the client browser screen width.
          // In order to prevent blinks and help the reconciliation of the React tree
          // we are not rendering the child component.
          //
          // An alternative is to use the `initialWidth` property.
          if (props.width === undefined) {
            return null;
          }

          return _react2.default.createElement(
            _reactEventListener2.default,
            { target: 'window', onResize: this.handleResize },
            _react2.default.createElement(Component, (0, _extends3.default)({}, more, props))
          );
        }
      }]);
      return WithWidth;
    }(_react2.default.Component);

    WithWidth.propTypes =  false ? {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty componenent during the first mount.
       * In some situation you might want to use an heristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * http://caniuse.com/#search=client%20hint
       */
      initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
      /**
       * @ignore
       */
      theme: _propTypes2.default.object.isRequired,
      /**
       * Bypass the width calculation logic.
       */
      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : {};

    if (false) {
      WithWidth.displayName = (0, _wrapDisplayName2.default)(Component, 'WithWidth');
    }

    (0, _hoistNonReactStatics2.default)(WithWidth, Component);

    return (0, _withTheme2.default)()(WithWidth);
  };
};

exports.default = withWidth;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _List = __webpack_require__(753);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _ListItem = __webpack_require__(356);

Object.defineProperty(exports, 'ListItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItem).default;
  }
});

var _ListItemAvatar = __webpack_require__(754);

Object.defineProperty(exports, 'ListItemAvatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemAvatar).default;
  }
});

var _ListItemText = __webpack_require__(755);

Object.defineProperty(exports, 'ListItemText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemText).default;
  }
});

var _ListItemIcon = __webpack_require__(756);

Object.defineProperty(exports, 'ListItemIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemIcon).default;
  }
});

var _ListItemSecondaryAction = __webpack_require__(757);

Object.defineProperty(exports, 'ListItemSecondaryAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListItemSecondaryAction).default;
  }
});

var _ListSubheader = __webpack_require__(758);

Object.defineProperty(exports, 'ListSubheader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListSubheader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      margin: 0
    },
    display4: theme.typography.display4,
    display3: theme.typography.display3,
    display2: theme.typography.display2,
    display1: theme.typography.display1,
    headline: theme.typography.headline,
    title: theme.typography.title,
    subheading: theme.typography.subheading,
    body2: theme.typography.body2,
    body1: theme.typography.body1,
    caption: theme.typography.caption,
    button: theme.typography.button,
    alignLeft: {
      textAlign: 'left'
    },
    alignCenter: {
      textAlign: 'center'
    },
    alignRight: {
      textAlign: 'right'
    },
    alignJustify: {
      textAlign: 'justify'
    },
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    gutterBottom: {
      marginBottom: '0.35em'
    },
    paragraph: {
      marginBottom: theme.spacing.unit * 2
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    colorError: {
      color: theme.palette.error.main
    }
  };
};

function Typography(props) {
  var _classNames;

  var align = props.align,
      classes = props.classes,
      classNameProp = props.className,
      componentProp = props.component,
      color = props.color,
      gutterBottom = props.gutterBottom,
      headlineMapping = props.headlineMapping,
      noWrap = props.noWrap,
      paragraph = props.paragraph,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['align', 'classes', 'className', 'component', 'color', 'gutterBottom', 'headlineMapping', 'noWrap', 'paragraph', 'variant']);


  var className = (0, _classnames2.default)(classes.root, classes[variant], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.noWrap, noWrap), (0, _defineProperty3.default)(_classNames, classes.gutterBottom, gutterBottom), (0, _defineProperty3.default)(_classNames, classes.paragraph, paragraph), (0, _defineProperty3.default)(_classNames, classes['align' + (0, _helpers.capitalize)(align)], align !== 'inherit'), _classNames), classNameProp);

  var Component = componentProp || (paragraph ? 'p' : headlineMapping[variant]) || 'span';

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Typography.propTypes =  false ? {
  /**
   * Set the text-align on the component.
   */
  align: _propTypes2.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'textSecondary', 'secondary', 'error', 'default']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes2.default.bool,
  /**
   * We are empirically mapping the variant property to a range of different DOM element types.
   * For instance, h1 to h6. If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` property.
   */
  headlineMapping: _propTypes2.default.object,
  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes2.default.bool,
  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes2.default.bool,
  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes2.default.oneOf(['display4', 'display3', 'display2', 'display1', 'headline', 'title', 'subheading', 'body2', 'body1', 'caption', 'button'])
} : {};

Typography.defaultProps = {
  align: 'inherit',
  color: 'default',
  gutterBottom: false,
  headlineMapping: {
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: 'h1',
    title: 'h2',
    subheading: 'h3',
    body2: 'aside',
    body1: 'p'
  },
  noWrap: false,
  paragraph: false,
  variant: 'body1'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTypography' })(Typography);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(842);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Modal).default;
  }
});

var _Backdrop = __webpack_require__(380);

Object.defineProperty(exports, 'Backdrop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Backdrop).default;
  }
});

var _ModalManager = __webpack_require__(378);

Object.defineProperty(exports, 'ModalManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(53);

var _withTheme = __webpack_require__(27);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Transition

var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/demos/modals) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = function (_React$Component) {
  (0, _inherits3.default)(Fade, _React$Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Fade.__proto__ || (0, _getPrototypeOf2.default)(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
      var theme = _this.props.theme;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('opacity', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Fade, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              opacity: 0
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Fade;
}(_react2.default.Component);

Fade.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Fade.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Fade);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(981);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function (instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */ (function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function () {
            return this._logLevel;
        },
        set: function (val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function () {
            return this._logHandler;
        },
        set: function (val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(438);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _deepmerge = __webpack_require__(123);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _createTypography = __webpack_require__(471);

var _createTypography2 = _interopRequireDefault(_createTypography);

var _createBreakpoints = __webpack_require__(93);

var _createBreakpoints2 = _interopRequireDefault(_createBreakpoints);

var _createPalette = __webpack_require__(472);

var _createPalette2 = _interopRequireDefault(_createPalette);

var _createMixins = __webpack_require__(473);

var _createMixins2 = _interopRequireDefault(_createMixins);

var _shadows = __webpack_require__(476);

var _shadows2 = _interopRequireDefault(_shadows);

var _transitions = __webpack_require__(53);

var _transitions2 = _interopRequireDefault(_transitions);

var _zIndex = __webpack_require__(481);

var _zIndex2 = _interopRequireDefault(_zIndex);

var _spacing = __webpack_require__(482);

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$palette = options.palette,
      paletteInput = _options$palette === undefined ? {} : _options$palette,
      _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === undefined ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === undefined ? {} : _options$mixins,
      _options$typography = options.typography,
      typographyInput = _options$typography === undefined ? {} : _options$typography,
      shadowsInput = options.shadows,
      other = (0, _objectWithoutProperties3.default)(options, ['palette', 'breakpoints', 'mixins', 'typography', 'shadows']);


  var palette = (0, _createPalette2.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints2.default)(breakpointsInput);

  var muiTheme = (0, _extends3.default)({
    direction: 'ltr',
    palette: palette,
    typography: (0, _createTypography2.default)(palette, typographyInput),
    mixins: (0, _createMixins2.default)(breakpoints, _spacing2.default, mixinsInput),
    breakpoints: breakpoints,
    shadows: shadowsInput || _shadows2.default
  }, (0, _deepmerge2.default)({
    transitions: _transitions2.default,
    spacing: _spacing2.default,
    zIndex: _zIndex2.default
  }, other));

   false ? (0, _warning2.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;

  return muiTheme;
} // < 1kb payload overhead when lodash/merge is > 3kb.
exports.default = createMuiTheme;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(47);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(169);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(173)('keys');
var uid = __webpack_require__(121);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 175 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var common = {
  black: '#000',
  white: '#fff'
};

exports.default = common;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(474), __esModule: true };

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(124);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(267);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(126);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(517)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(182)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(183);
var $export = __webpack_require__(26);
var redefine = __webpack_require__(273);
var hide = __webpack_require__(52);
var has = __webpack_require__(62);
var Iterators = __webpack_require__(96);
var $iterCreate = __webpack_require__(518);
var setToStringTag = __webpack_require__(128);
var getPrototypeOf = __webpack_require__(272);
var ITERATOR = __webpack_require__(34)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(34);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(121)('meta');
var isObject = __webpack_require__(47);
var has = __webpack_require__(62);
var setDesc = __webpack_require__(38).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(61)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(41);
var core = __webpack_require__(21);
var LIBRARY = __webpack_require__(183);
var wksExt = __webpack_require__(184);
var defineProperty = __webpack_require__(38).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHANNEL = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Same value used by react-jss
var CHANNEL = exports.CHANNEL = '__THEMING__';

var themeListener = {
  contextTypes: (0, _defineProperty3.default)({}, CHANNEL, _propTypes2.default.object),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};

exports.default = themeListener;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(596),
    mapCacheDelete = __webpack_require__(603),
    mapCacheGet = __webpack_require__(605),
    mapCacheHas = __webpack_require__(606),
    mapCacheSet = __webpack_require__(607);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(608),
    isObjectLike = __webpack_require__(23);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(299),
    stubArray = __webpack_require__(300);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(620),
    baseUnary = __webpack_require__(195),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(292);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(139),
    nativeKeys = __webpack_require__(621);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(103);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    last = __webpack_require__(310),
    parent = __webpack_require__(634),
    toKey = __webpack_require__(66);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(101),
    isArrayLike = __webpack_require__(56),
    isIndex = __webpack_require__(82),
    isObject = __webpack_require__(17);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(144),
    castPath = __webpack_require__(84),
    isIndex = __webpack_require__(82),
    isObject = __webpack_require__(17),
    toKey = __webpack_require__(66);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(146),
    baseEach = __webpack_require__(85),
    castFunction = __webpack_require__(642),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(197),
    getTag = __webpack_require__(83),
    isArrayLike = __webpack_require__(56),
    isString = __webpack_require__(67),
    stringSize = __webpack_require__(645);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(131),
    arrayEach = __webpack_require__(146),
    assignValue = __webpack_require__(144),
    baseAssign = __webpack_require__(324),
    baseAssignIn = __webpack_require__(651),
    cloneBuffer = __webpack_require__(325),
    copyArray = __webpack_require__(106),
    copySymbols = __webpack_require__(654),
    copySymbolsIn = __webpack_require__(655),
    getAllKeys = __webpack_require__(297),
    getAllKeysIn = __webpack_require__(327),
    getTag = __webpack_require__(83),
    initCloneArray = __webpack_require__(656),
    initCloneByTag = __webpack_require__(657),
    initCloneObject = __webpack_require__(329),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(137),
    isMap = __webpack_require__(661),
    isObject = __webpack_require__(17),
    isSet = __webpack_require__(663),
    keys = __webpack_require__(81);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(302);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(296);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    getPrototype = __webpack_require__(206),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(666),
    overRest = __webpack_require__(330),
    setToString = __webpack_require__(210);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(667),
    shortOut = __webpack_require__(331);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recursiveUnset = exports.preserveValuesFromState = exports.combineReducers = undefined;

var _unset2 = __webpack_require__(682);

var _unset3 = _interopRequireDefault(_unset2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _pick2 = __webpack_require__(351);

var _pick3 = _interopRequireDefault(_pick2);

var _isBoolean2 = __webpack_require__(718);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _size2 = __webpack_require__(203);

var _size3 = _interopRequireDefault(_size2);

var _replace2 = __webpack_require__(719);

var _replace3 = _interopRequireDefault(_replace2);

var _get2 = __webpack_require__(102);

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pathToArr = pathToArr;
exports.getSlashStrPath = getSlashStrPath;
exports.getDotStrPath = getDotStrPath;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pathToArr(path) {
  return path ? path.split(/\//).filter(function (p) {
    return !!p;
  }) : [];
}

function getSlashStrPath(path) {
  return pathToArr(path).join('/');
}

function getDotStrPath(path) {
  return pathToArr(path).join('.');
}

var combineReducers = exports.combineReducers = function combineReducers(reducers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return Object.keys(reducers).reduce(function (nextState, key) {
      nextState[key] = reducers[key](state[key], action);
      return nextState;
    }, {});
  };
};

var preserveValuesFromState = exports.preserveValuesFromState = function preserveValuesFromState(state, preserveSetting, nextState) {
  if ((0, _isFunction3.default)(preserveSetting)) {
    return preserveSetting(state, nextState);
  }

  if ((0, _isBoolean3.default)(preserveSetting) && preserveSetting) {
    return nextState ? _extends({}, state, nextState) : state;
  }

  if ((0, _isArray3.default)(preserveSetting)) {
    return (0, _pick3.default)(state, preserveSetting);
  }

  throw new Error('Invalid preserve parameter. It must be an Object or an Array');
};

var recursiveUnset = exports.recursiveUnset = function recursiveUnset(path, obj) {
  var isRecursiveCall = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!path) {
    return obj;
  }

  if ((0, _size3.default)((0, _get3.default)(obj, path)) > 0 && isRecursiveCall) {
    return obj;
  }

  var objectWithRemovedKey = (0, _unset3.default)(path, obj);
  var newPath = path.match(/\./) ? (0, _replace3.default)(path, /\.[^.]*$/, '') : '';
  return recursiveUnset(newPath, objectWithRemovedKey, true);
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(683),
    util = __webpack_require__(685);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(338),
    createBind = __webpack_require__(687),
    createCurry = __webpack_require__(688),
    createHybrid = __webpack_require__(340),
    createPartial = __webpack_require__(705),
    getData = __webpack_require__(344),
    mergeData = __webpack_require__(706),
    setData = __webpack_require__(346),
    setWrapToString = __webpack_require__(347),
    toInteger = __webpack_require__(349);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(148),
    baseLodash = __webpack_require__(215);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfileOnFirestore = exports.updateProfileOnRTDB = exports.createAuthIsReady = exports.authIsReady = exports.getLoginMethodAndParams = undefined;

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _capitalize2 = __webpack_require__(720);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _constants = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createAuthProvider = function createAuthProvider(firebase, providerName, scopes) {
  var capitalProviderName = (0, _capitalize3.default)(providerName) + 'AuthProvider';
  var provider = new firebase.auth[capitalProviderName]();

  var customAuthParameters = firebase._.config.customAuthParameters;

  if (customAuthParameters && customAuthParameters[providerName]) {
    provider.setCustomParameters(customAuthParameters[providerName]);
  }

  if (providerName.toLowerCase() === 'twitter' || !(0, _isFunction3.default)(provider.addScope)) {
    return provider;
  }

  provider.addScope('email');

  if (scopes) {
    if ((0, _isArray3.default)(scopes)) {
      scopes.forEach(function (scope) {
        provider.addScope(scope);
      });
    }
    if ((0, _isString3.default)(scopes)) {
      provider.addScope(scopes);
    }
  }

  return provider;
};

var getLoginMethodAndParams = exports.getLoginMethodAndParams = function getLoginMethodAndParams(firebase, creds) {
  var email = creds.email,
      password = creds.password,
      provider = creds.provider,
      type = creds.type,
      token = creds.token,
      scopes = creds.scopes,
      phoneNumber = creds.phoneNumber,
      applicationVerifier = creds.applicationVerifier,
      credential = creds.credential;

  if (credential) {
    return { method: 'signInWithCredential', params: [credential] };
  }
  if (provider) {
    if (_constants.supportedAuthProviders.indexOf(provider.toLowerCase()) === -1) {
      throw new Error(provider + ' is not a valid Auth Provider');
    }
    if (token) {
      throw new Error('provider with token no longer supported, use credential parameter instead');
    }
    var authProvider = createAuthProvider(firebase, provider, scopes);
    if (type === 'popup') {
      return { method: 'signInWithPopup', params: [authProvider] };
    }
    return { method: 'signInWithRedirect', params: [authProvider] };
  }
  if (token) {
    return { method: 'signInWithCustomToken', params: [token] };
  }
  if (phoneNumber) {
    if (!applicationVerifier) {
      throw new Error('Application verifier is required for phone authentication');
    }
    return {
      method: 'signInWithPhoneNumber',
      params: [phoneNumber, applicationVerifier]
    };
  }
  return { method: 'signInWithEmailAndPassword', params: [email, password] };
};

var isAuthReady = function isAuthReady(store, stateName) {
  var state = store.getState();
  var firebaseState = stateName ? state[stateName] : state;
  var firebaseAuthState = firebaseState && firebaseState.auth;
  if (!firebaseAuthState) {
    throw new Error('The Firebase auth state could not be found in the store under the attribute \'' + (stateName ? stateName + '.' : '') + 'auth\'. Make sure your react-redux-firebase reducer is correctly set in the store');
  }
  return firebaseState.auth.isLoaded;
};

var authIsReady = exports.authIsReady = function authIsReady(store) {
  var stateName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'firebase';
  return new Promise(function (resolve) {
    if (isAuthReady(store, stateName)) {
      resolve();
    } else {
      var unsubscribe = store.subscribe(function () {
        if (isAuthReady(store, stateName)) {
          unsubscribe();
          resolve();
        }
      });
    }
  });
};

var createAuthIsReady = exports.createAuthIsReady = function createAuthIsReady(store, config) {
  return (0, _isFunction3.default)(config.authIsReady) ? config.authIsReady(store, config) : authIsReady(store, config.firebaseStateName);
};

var updateProfileOnRTDB = exports.updateProfileOnRTDB = function updateProfileOnRTDB(firebase, profileUpdate) {
  var database = firebase.database,
      _firebase$_ = firebase._,
      config = _firebase$_.config,
      authUid = _firebase$_.authUid;

  var profileRef = database().ref(config.userProfile + '/' + authUid);
  return profileRef.update(profileUpdate).then(function () {
    return profileRef.once('value');
  });
};

var updateProfileOnFirestore = exports.updateProfileOnFirestore = function updateProfileOnFirestore(firebase, profileUpdate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$useSet = options.useSet,
      useSet = _options$useSet === undefined ? true : _options$useSet,
      _options$merge = options.merge,
      merge = _options$merge === undefined ? true : _options$merge;
  var firestore = firebase.firestore,
      _firebase$_2 = firebase._,
      config = _firebase$_2.config,
      authUid = _firebase$_2.authUid;

  var profileRef = firestore().doc(config.userProfile + '/' + authUid);

  var profileUpdatePromise = useSet ? profileRef.set(profileUpdate, { merge: merge }) : profileRef.update(profileUpdate);
  return profileUpdatePromise.then(function () {
    return profileRef.get();
  });
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Avatar = __webpack_require__(358);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.hasValue = hasValue;
exports.isDirty = isDirty;
exports.isAdornedStart = isAdornedStart;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Textarea = __webpack_require__(762);

var _Textarea2 = _interopRequireDefault(_Textarea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is dirty (a.k.a. filled).
//
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isDirty(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

var styles = exports.styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: 0
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';

  return {
    root: {
      // Mimics the default input display property used by browsers for an input.
      display: 'inline-flex',
      position: 'relative',
      fontFamily: theme.typography.fontFamily,
      color: light ? 'rgba(0, 0, 0, 0.87)' : theme.palette.common.white,
      fontSize: theme.typography.pxToRem(16)
    },
    formControl: {
      'label + &': {
        marginTop: theme.spacing.unit * 2
      }
    },
    inkbar: {
      '&:after': {
        backgroundColor: theme.palette.primary[light ? 'dark' : 'light'],
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      }
    },
    error: {
      '&:after': {
        backgroundColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red
      }
    },
    focused: {},
    disabled: {
      color: theme.palette.text.disabled
    },
    underline: {
      '&:before': {
        backgroundColor: bottomLineColor,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 1,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.
      },
      '&:hover:not($disabled):before': {
        backgroundColor: theme.palette.text.primary,
        height: 2
      },
      '&$disabled:before': {
        background: 'transparent',
        backgroundImage: 'linear-gradient(to right, ' + bottomLineColor + ' 33%, transparent 0%)',
        backgroundPosition: 'left top',
        backgroundRepeat: 'repeat-x',
        backgroundSize: '5px 1px'
      }
    },
    multiline: {
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px'
    },
    fullWidth: {
      width: '100%'
    },
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: theme.spacing.unit - 2 + 'px 0 ' + (theme.spacing.unit - 1) + 'px',
      border: 0,
      boxSizing: 'content-box',
      verticalAlign: 'middle',
      background: 'none',
      margin: 0, // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder, // Firefox 19+
      '&:-ms-input-placeholder': placeholder, // IE 11
      '&::-ms-input-placeholder': placeholder, // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden, // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden, // IE 11
        '&::-ms-input-placeholder': placeholderHidden, // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible, // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible, // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
      }
    },
    inputDense: {
      paddingTop: theme.spacing.unit / 2 - 1
    },
    inputDisabled: {
      opacity: 1 // Reset iOS opacity
    },
    inputType: {
      // type="date" or type="time", etc. have specific styles we need to reset.
      height: '1.1875em' // Reset (19px), match the native input line-height
    },
    inputMultiline: {
      resize: 'none',
      padding: 0
    },
    inputSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    }
  };
};

function formControlState(props, context) {
  var disabled = props.disabled;
  var error = props.error;
  var margin = props.margin;

  if (context && context.muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = context.muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = context.muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = context.muiFormControl.margin;
    }
  }

  return {
    disabled: disabled,
    error: error,
    margin: margin
  };
}

var Input = function (_React$Component) {
  (0, _inherits3.default)(Input, _React$Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.input = null, _this.handleFocus = function (event) {
      // Fix an bug with IE11 where the focus/blur events are triggered
      // while the input is disabled.
      if (formControlState(_this.props, _this.context).disabled) {
        event.stopPropagation();
        return;
      }

      _this.setState({ focused: true });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _this.handleBlur = function (event) {
      _this.setState({ focused: false });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleChange = function (event) {
      if (!_this.isControlled) {
        _this.checkDirty(_this.input);
      }

      // Perform in the willUpdate
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _this.handleRefInput = function (node) {
      _this.input = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      } else if (_this.props.inputProps && _this.props.inputProps.ref) {
        _this.props.inputProps.ref(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Input, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // We are consuming the parent muiFormControl context.
      // We don't want a child to consume it a second time.
      return {
        muiFormControl: null
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isControlled = this.props.value != null;

      if (this.isControlled) {
        this.checkDirty(this.props);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.isControlled) {
        this.checkDirty(this.input);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState, nextContext) {
      if (this.isControlled) {
        this.checkDirty(nextProps);
      } // else performed in the onChange

      // Book keep the focused state.
      if (!formControlState(this.props, this.context).disabled && formControlState(nextProps, nextContext).disabled) {
        var muiFormControl = this.context.muiFormControl;

        if (muiFormControl && muiFormControl.onBlur) {
          muiFormControl.onBlur();
        }
      }
    }

    // Holds the input reference

  }, {
    key: 'checkDirty',
    value: function checkDirty(obj) {
      var muiFormControl = this.context.muiFormControl;


      if (isDirty(obj)) {
        if (muiFormControl && muiFormControl.onDirty) {
          muiFormControl.onDirty();
        }
        if (this.props.onDirty) {
          this.props.onDirty();
        }
        return;
      }

      if (muiFormControl && muiFormControl.onClean) {
        muiFormControl.onClean();
      }
      if (this.props.onClean) {
        this.props.onClean();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          autoComplete = _props.autoComplete,
          autoFocus = _props.autoFocus,
          classes = _props.classes,
          classNameProp = _props.className,
          defaultValue = _props.defaultValue,
          disabledProp = _props.disabled,
          disableUnderline = _props.disableUnderline,
          endAdornment = _props.endAdornment,
          errorProp = _props.error,
          fullWidth = _props.fullWidth,
          id = _props.id,
          inputComponent = _props.inputComponent,
          _props$inputProps = _props.inputProps;
      _props$inputProps = _props$inputProps === undefined ? {} : _props$inputProps;
      var inputPropsClassName = _props$inputProps.className,
          inputPropsProp = (0, _objectWithoutProperties3.default)(_props$inputProps, ['className']),
          inputRef = _props.inputRef,
          marginProp = _props.margin,
          multiline = _props.multiline,
          name = _props.name,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClean = _props.onClean,
          onDirty = _props.onDirty,
          onFocus = _props.onFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          placeholder = _props.placeholder,
          readOnly = _props.readOnly,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          startAdornment = _props.startAdornment,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoComplete', 'autoFocus', 'classes', 'className', 'defaultValue', 'disabled', 'disableUnderline', 'endAdornment', 'error', 'fullWidth', 'id', 'inputComponent', 'inputProps', 'inputRef', 'margin', 'multiline', 'name', 'onBlur', 'onChange', 'onClean', 'onDirty', 'onFocus', 'onKeyDown', 'onKeyUp', 'placeholder', 'readOnly', 'rows', 'rowsMax', 'startAdornment', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var _formControlState = formControlState(this.props, this.context),
          disabled = _formControlState.disabled,
          error = _formControlState.error,
          margin = _formControlState.margin;

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), (0, _defineProperty3.default)(_classNames, classes.focused, this.state.focused), (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.inkbar, !disableUnderline), (0, _defineProperty3.default)(_classNames, classes.multiline, multiline), (0, _defineProperty3.default)(_classNames, classes.underline, !disableUnderline), _classNames), classNameProp);

      var inputClassName = (0, _classnames2.default)(classes.input, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.inputDisabled, disabled), (0, _defineProperty3.default)(_classNames2, classes.inputType, type !== 'text'), (0, _defineProperty3.default)(_classNames2, classes.inputMultiline, multiline), (0, _defineProperty3.default)(_classNames2, classes.inputSearch, type === 'search'), (0, _defineProperty3.default)(_classNames2, classes.inputDense, margin === 'dense'), _classNames2), inputPropsClassName);

      var required = muiFormControl && muiFormControl.required === true;

      var InputComponent = 'input';
      var inputProps = (0, _extends3.default)({}, inputPropsProp, {
        ref: this.handleRefInput
      });

      if (inputComponent) {
        InputComponent = inputComponent;
        inputProps = (0, _extends3.default)({
          // Rename ref to inputRef as we don't know the
          // provided `inputComponent` structure.
          inputRef: this.handleRefInput
        }, inputProps, {
          ref: null
        });
      } else if (multiline) {
        if (rows && !rowsMax) {
          InputComponent = 'textarea';
        } else {
          inputProps = (0, _extends3.default)({
            rowsMax: rowsMax,
            textareaRef: this.handleRefInput
          }, inputProps, {
            ref: null
          });
          InputComponent = _Textarea2.default;
        }
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ onBlur: this.handleBlur, onFocus: this.handleFocus, className: className }, other),
        startAdornment,
        _react2.default.createElement(InputComponent, (0, _extends3.default)({
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          className: inputClassName,
          onChange: this.handleChange,
          onKeyUp: onKeyUp,
          onKeyDown: onKeyDown,
          disabled: disabled,
          required: required ? true : undefined,
          value: value,
          id: id,
          name: name,
          defaultValue: defaultValue,
          placeholder: placeholder,
          type: type,
          readOnly: readOnly,
          rows: rows,
          'aria-required': required,
          'aria-invalid': error
        }, inputProps)),
        endAdornment
      );
    }
  }]);
  return Input;
}(_react2.default.Component);

Input.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes2.default.string,
  /**
   * The default input value, useful when not controlling the component.
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes2.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes2.default.node,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense', 'none']),
  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * TODO
   */
  onClean: _propTypes2.default.func,
  /**
   * TODO
   */
  onDirty: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes2.default.node,
  /**
   * Type of the input element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Input.muiName = 'Input';

Input.defaultProps = {
  disableUnderline: false,
  fullWidth: false,
  multiline: false,
  type: 'text'
};

Input.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

Input.childContextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInput' })(Input);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toolbar = __webpack_require__(835);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDescendant = function isDescendant(el, target) {
  if (target !== null && target.parentNode) {
    return el === target || isDescendant(el, target.parentNode);
  }
  return false;
};

/**
 * Listen for click events that are triggered outside of the component children.
 */

var ClickAwayListener = function (_React$Component) {
  (0, _inherits3.default)(ClickAwayListener, _React$Component);

  function ClickAwayListener() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ClickAwayListener);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.mounted = false, _this.handleClickAway = function (event) {
      // Ignore events that have been `event.preventDefault()` marked.
      if (event.defaultPrevented) {
        return;
      }

      // IE11 support, which trigger the handleClickAway even after the unbind
      if (_this.mounted) {
        var el = (0, _reactDom.findDOMNode)(_this);

        if (document.documentElement && document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
          _this.props.onClickAway(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ClickAwayListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactEventListener2.default,
        {
          target: 'document',
          onMouseup: this.handleClickAway,
          onTouchend: this.handleClickAway
        },
        this.props.children
      );
    }
  }]);
  return ClickAwayListener;
}(_react2.default.Component);

ClickAwayListener.propTypes =  false ? {
  children: _propTypes2.default.node.isRequired,
  onClickAway: _propTypes2.default.func.isRequired
} : {};

exports.default = ClickAwayListener;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

var _withTheme = __webpack_require__(27);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getScale(value) {
  return 'scale(' + value + ', ' + Math.pow(value, 2) + ')';
} // @inheritedComponent Transition

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: getScale(1)
  }
};

/**
 * The Grow transition is used by the [Popover](/demos/popovers) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = function (_React$Component) {
  (0, _inherits3.default)(Grow, _React$Component);

  function Grow() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Grow);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Grow.__proto__ || (0, _getPrototypeOf2.default)(Grow)).call.apply(_ref, [this].concat(args))), _this), _this.autoTimeout = undefined, _this.timer = null, _this.handleEnter = function (node) {
      var _this$props = _this.props,
          theme = _this$props.theme,
          timeout = _this$props.timeout;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      var duration = 0;
      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay
      })].join(',');

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          timeout = _this$props2.timeout;

      var duration = 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      if (timeout === 'auto') {
        duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
        _this.autoTimeout = duration;
      } else {
        duration = transitionDuration;
      }

      node.style.transition = [theme.transitions.create('opacity', {
        duration: duration,
        delay: delay
      }), theme.transitions.create('transform', {
        duration: duration * 0.666,
        delay: delay || duration * 0.333
      })].join(',');

      node.style.opacity = '0';
      node.style.transform = getScale(0.75);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTimeout || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Grow, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme', 'timeout']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          appear: true,
          onEnter: this.handleEnter,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              opacity: 0,
              transform: getScale(0.75)
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Grow;
}(_react2.default.Component);

Grow.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Grow.defaultProps = {
  timeout: 'auto'
};

exports.default = (0, _withTheme2.default)()(Grow);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.setTranslateValue = setTranslateValue;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

var _withTheme = __webpack_require__(27);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _transitions = __webpack_require__(53);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUTTER = 24;

// Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `translate3d(0, 0, 0)`.`
// @inheritedComponent Transition

function getTranslateValue(props, node) {
  var direction = props.direction;

  var rect = node.getBoundingClientRect();

  var transform = void 0;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return 'translateX(100vw) translateX(-' + (rect.left - offsetX) + 'px)';
  } else if (direction === 'right') {
    return 'translateX(-' + (rect.left + rect.width + GUTTER - offsetX) + 'px)';
  } else if (direction === 'up') {
    return 'translateY(100vh) translateY(-' + (rect.top - offsetY) + 'px)';
  }

  // direction === 'down'
  return 'translate3d(0, ' + (0 - (rect.top + rect.height)) + 'px, 0)';
}

function setTranslateValue(props, node) {
  var transform = getTranslateValue(props, node);

  if (transform) {
    node.style.transform = transform;
    node.style.webkitTransform = transform;
  }
}

/**
 * The Slide transition is used by the [Snackbar](/demos/snackbars) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = function (_React$Component) {
  (0, _inherits3.default)(Slide, _React$Component);

  function Slide() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Slide);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slide.__proto__ || (0, _getPrototypeOf2.default)(Slide)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _this.transition = null, _this.handleResize = (0, _debounce2.default)(function () {
      // Skip configuration where the position is screen size invariant.
      if (_this.props.in || _this.props.direction === 'down' || _this.props.direction === 'right') {
        return;
      }

      var node = (0, _reactDom.findDOMNode)(_this.transition);
      if (node) {
        setTranslateValue(_this.props, node);
      }
    }, 166), _this.handleEnter = function (node) {
      setTranslateValue(_this.props, node);
      (0, _utils.reflow)(node);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.easeOut,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.easeOut,
        delay: delay
      });
      node.style.transform = 'translate3d(0, 0, 0)';
      node.style.webkitTransform = 'translate3d(0, 0, 0)';
      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.sharp,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
        duration: transitionDuration,
        easing: theme.transitions.easing.sharp,
        delay: delay
      });
      setTranslateValue(_this.props, node);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExited = function (node) {
      // No need for transitions when the component is hidden
      node.style.transition = '';
      node.style.webkitTransition = '';

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Slide, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // state.mounted handle SSR, once the component is mounted, we need
      // to properly hide it.
      if (!this.props.in) {
        // We need to set initial translate values of transition element
        // otherwise component will be shown when in=false.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        mounted: true
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.direction !== this.props.direction && !this.props.in) {
        // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        this.updatePosition();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var node = (0, _reactDom.findDOMNode)(this.transition);
      if (node) {
        node.style.visibility = 'inherit';
        setTranslateValue(this.props, node);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onEntering', 'onExit', 'onExited', 'style', 'theme']);


      var style = {};

      // We use this state to handle the server-side rendering.
      // We don't know the width of the children ahead of time.
      // We need to render it.
      if (!this.props.in && !this.state.mounted) {
        style.visibility = 'hidden';
      }

      style = (0, _extends3.default)({}, style, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onResize: this.handleResize },
        _react2.default.createElement(
          _Transition2.default,
          (0, _extends3.default)({
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onExit: this.handleExit,
            onExited: this.handleExited,
            appear: true,
            style: style,
            ref: function ref(node) {
              _this2.transition = node;
            }
          }, other),
          children
        )
      );
    }
  }]);
  return Slide;
}(_react2.default.Component);

Slide.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * Direction the child node will enter from.
   */
  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Slide.defaultProps = {
  direction: 'down',
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Slide);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextField = __webpack_require__(860);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cognitive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return personality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return softskills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return wp; });
function ascArray(n){return Array.from(new Array(n),function(x,i){return i+1;});}function descArray(n){return Array.from(new Array(n),function(x,i){return i+1;}).reverse();}var cognitive=[{'02':4},{'04':8},{'08':8},{'12':2},{'15':5},{'18':2},{'20':5},{'24':7},{'30':3},{'32':4},{'34':6},{'37':4},{'38':3},{'40':3},{'47':3}];var personality=[{'ฉันหาเพื่อนใหม่ได้ง่าย':{'trait':'extraversion','score':ascArray(5)}},{'ฉันรู้สึกเห็นใจคนที่มีชีวิตลำบากกว่าฉัน':{'trait':'agreeableness','score':ascArray(5)}},{'ฉันชอบอยู่ท่ามกลางผู้คน':{'trait':'extraversion','score':ascArray(5)}},{'ฉันไม่ผัดวันประกันพรุ่ง':{'trait':'conscientiousness','score':ascArray(5)}},{'ฉันกล้าแสดงความคิดเห็นในห้องเรียน':{'trait':'extraversion','score':ascArray(5)}},{'ฉันเชื่อว่าทุกคนล้วนมีเจตนาดีต่อกัน':{'trait':'agreeableness','score':ascArray(5)}},{'ฉันชอบพักผ่อนอยู่เฉยๆ ในเวลาว่าง':{'trait':'extraversion','score':descArray(5)}},{'ฉันเรียนหนักจนกว่าจะประสบความสำเร็จ':{'trait':'mastery','score':ascArray(5)}},{'ฉันสนุกกับการหาช่องโหว่ในกฎกติกา':{'trait':'agreeableness','score':descArray(5)}},{'ฉันไม่ล้อเลียนเพื่อนฝูง':{'trait':'agreeableness','score':ascArray(5)}},{'ฉันตั้งใจทำการบ้านเพื่อให้ไม่มีข้อผิดพลาด':{'trait':'conscientiousness','score':ascArray(5)}},{'ฉันเป็นคนชอบลงมือก่อน คิดทีหลัง':{'trait':'conscientiousness','score':descArray(5)}},{'ฉันอ่านหนังสือหลากหลายประเภท':{'trait':'desireToLearn','score':ascArray(5)}},{'ฉันต้องการเรียนรู้สิ่งใหม่ๆ อยู่เสมอ':{'trait':'desireToLearn','score':ascArray(5)}},{'ฉันไม่ชอบออกจากสภาวะที่ตนเองคุ้นเคย':{'trait':'desireToLearn','score':descArray(5)}},{'ฉันพัฒนาตนเองอยู่เสมอแม้ฉันจะทำมันได้ดีแล้ว':{'trait':'mastery','score':ascArray(5)}},{'ห้องนอนของฉันสะอาดและเป็นระเบียบ':{'trait':'conscientiousness','score':ascArray(5)}},{'ฉันตั้งเป้าหมายที่พอดีๆ เพื่อไม่กดดันตนเอง':{'trait':'mastery','score':descArray(5)}},{'ฉันพยายามมากขึ้นหากต้องแข่งขันกับผู้อื่น':{'trait':'otherReferencedGoals','score':ascArray(5)}},{'ฉันศึกษาบทเรียนลึกกว่าที่ครูสอนในห้อง':{'trait':'mastery','score':ascArray(5)}},{'ฉันชอบหาความรู้เพิ่มเติมในสิ่งที่ครูไม่ได้สอน':{'trait':'desireToLearn','score':ascArray(5)}},{'ฉันยินดีกับความสำเร็จของผู้อื่น':{'trait':'otherReferencedGoals','score':descArray(5)}},{'ฉันต้องการประสบความสำเร็จเหนือผู้อื่น':{'trait':'otherReferencedGoals','score':ascArray(5)}},{'ฉันทำให้คนรอบข้างผิดหวังอยู่บ่อยครั้ง':{'trait':'selfEfficacy','score':descArray(5)}},{'ฉันหาอะไรมาแข่งขันกับเพื่อนๆ อยู่เสมอ':{'trait':'competitiveness','score':ascArray(5)}},{'ฉันเป็นคนไม่ชอบการแข่งขัน':{'trait':'competitiveness','score':descArray(5)}},{'ฉันไม่กังวลเกี่ยวกับความล้มเหลวที่อาจจะเกิดขึ้น':{'trait':'worry','score':ascArray(5)}},{'การแข่งขันทำให้ฉันตั้งใจมากขึ้น':{'trait':'competitiveness','score':ascArray(5)}},{'ฉันมักทำผลงานได้ดีในสถานการณ์การแข่งขัน':{'trait':'competitiveness','score':ascArray(5)}},{'ฉันไม่คิดกังวลเกี่ยวกับสิ่งที่เกิดขึ้นแล้ว':{'trait':'worry','score':ascArray(5)}},{'ฉันไม่อ่อนไหวไปกับอารมณ์ชั่ววูบ':{'trait':'emotionality','score':ascArray(5)}},{'ความรับผิดชอบมากมายทำให้ฉันกดดัน':{'trait':'emotionality','score':descArray(5)}},{'ฉันปกป้องตนเองอย่างเต็มที่หากถูกรังแก':{'trait':'selfEfficacy','score':ascArray(5)}},{'ฉันกังวลว่าผู้อื่นจะเห็นข้อบกพร่องของฉัน':{'trait':'worry','score':descArray(5)}},{'ฉันนอนหลับได้ปกติ แม้มีงานสำคัญรออยู่ในวันรุ่งขึ้น':{'trait':'worry','score':ascArray(5)}},{'ฉันผิดหวังหากเห็นผู้อื่นทำอะไรได้ดีกว่าตนเอง':{'trait':'otherReferencedGoals','score':ascArray(5)}},{'ฉันไม่รู้สึกประหม่าก่อนการสอบครั้งสำคัญ':{'trait':'emotionality','score':ascArray(5)}},{'ฉันรู้สึกผ่อนคลาย แม้รู้ว่ากำลังมีคนมองฉันอยู่':{'trait':'emotionality','score':ascArray(5)}},{'ฉันตัดสินใจสิ่งต่างๆ ในชีวิตด้วยตนเอง':{'trait':'selfEfficacy','score':ascArray(5)}},{'ฉันจัดการกับอุปสรรคต่างๆ ในชีวิตได้เสมอ':{'trait':'selfEfficacy','score':ascArray(5)}}];var softskills=[{'ฉันไม่ถนัดการนำเสนองานหน้าชั้น':{'trait':'CPN','score':descArray(5)}},{'ฉันช่วยเหลือเพื่อนๆ ให้มีความก้าวหน้าในการเรียน':{'trait':'PPM','score':ascArray(5)}},{'ฉันตัดสินใจได้อย่างเด็ดขาด แม้ในสถานการณ์กดดัน':{'trait':'LOM','score':ascArray(5)}},{'เมื่อมีปัญหา ฉันหาทางออกที่ทุกฝ่ายพอใจได้เสมอ':{'trait':'CPN','score':ascArray(5)}},{'ในการทำงานกลุ่ม ฉันสนใจเฉพาะงานส่วนของฉันเอง':{'trait':'PPM','score':descArray(5)}},{'ฉันเปิดใจกับมุมมองที่แตกต่าง':{'trait':'PIS','score':ascArray(5)}},{'ฉันประเมินตนเองเพื่อหาทางพัฒนาให้ดีขึ้น':{'trait':'PPM','score':ascArray(5)}},{'ฉันสามารถโน้มน้าวให้ผู้อื่นทำในสิ่งที่ฉันต้องการ':{'trait':'CPN','score':ascArray(5)}},{'ฉันเป็นคนตัดสินใจแน่วแน่ ไม่ละล้าละลัง':{'trait':'SMC','score':ascArray(5)}},{'ฉันรับผิดชอบในงาน ไม่ต้องให้ใครมาจ้ำจี้จ้ำไช':{'trait':'SMC','score':ascArray(5)}},{'ฉันเป็นคนมีโลกส่วนตัวสูง เข้าถึงยาก':{'trait':'PIS','score':descArray(5)}},{'ปัญหาส่วนตัวของฉันไม่ส่งผลเสียต่อการเรียน':{'trait':'SMC','score':ascArray(5)}},{'ฉันทำงานร่วมกับผู้อื่นได้ดี':{'trait':'PIS','score':ascArray(5)}},{'ในการทำงานกลุ่ม ฉันเป็นผู้ตามมากกว่าผู้นำ':{'trait':'LOM','score':descArray(5)}},{'ในการทำงานกลุ่ม ฉันมักเป็นคนคอยประสานงาน':{'trait':'PIS','score':ascArray(5)}},{'ฉันรู้จุดแข็งและจุดอ่อนของเพื่อนแต่ละคน':{'trait':'PPM','score':ascArray(5)}},{'ฉันวางแผนและบริหารเวลาของตนเองเป็นอย่างดี':{'trait':'LOM','score':ascArray(5)}},{'ฉันคิดอย่างรอบคอบก่อนการตัดสินใจแต่ละครั้ง':{'trait':'LOM','score':ascArray(5)}},{'ฉันเป็นคนอารมณ์ร้อน':{'trait':'SMC','score':descArray(5)}},{'ฉันสามารถอธิบายเรื่องยากๆ ให้เข้าใจได้ง่าย':{'trait':'CPN','score':ascArray(5)}},{'ฉันปรับวิธีการสื่อสารให้เข้ากับสถานการณ์และผู้ฟัง':{'trait':'PCS','score':ascArray(5)}},{'ฉันไม่เปิดเผยความลับของเพื่อนให้ผู้อื่นรับรู้':{'trait':'PEW','score':ascArray(5)}},{'ฉันสนุกกับการซุบซิบนินทาในกลุ่มเพื่อน':{'trait':'PEW','score':descArray(5)}},{'ฉันเปิดใจรับฟังคำวิจารณ์ แม้จะไม่เห็นด้วยนักก็ตาม':{'trait':'PCS','score':ascArray(5)}},{'ฉันเป็นคนตรงไปตรงมาและซื่อสัตย์ต่อทุกคน':{'trait':'PEW','score':ascArray(5)}},{'ฉันปรับตัวเข้ากับสถานการณ์ที่เปลี่ยนแปลงได้ดี':{'trait':'PCS','score':ascArray(5)}},{'ภาพลักษณ์ที่ดีของโรงเรียนไม่ใช่เรื่องของฉัน':{'trait':'PCS','score':descArray(5)}},{'ในการทำงานกลุ่ม ฉันทำงานเต็มที่ ไม่เอาเปรียบใคร':{'trait':'PEW','score':ascArray(5)}}];var wp=[{'ประกอบเฟอร์นิเจอร์กึ่งสำเร็จรูป':{'trait':'WPPM','score':ascArray(5)}},{'หาคำอธิบายของปรากฏการณ์ต่างๆ':{'trait':'WIAM','score':ascArray(5)}},{'ตกแต่งบ้านสำหรับโอกาสพิเศษ':{'trait':'WPPM','score':ascArray(5)}},{'แนะแนวหรือให้คำปรึกษาแก่ผู้อื่น':{'trait':'WICH','score':ascArray(5)}},{'เรียนรู้การดูดาวและดาราศาสตร์':{'trait':'WIAM','score':ascArray(5)}},{'เรียนรู้โปรแกรมคอมพิวเตอร์ใหม่ๆ':{'trait':'WIAM','score':ascArray(5)}},{'ดูแลเด็กหรือบุคคลพิการ':{'trait':'WICH','score':ascArray(5)}},{'วางกลยุทธ์การทำงานหรือแผนธุรกิจ':{'trait':'WPAM','score':ascArray(5)}},{'วิเคราะห์ข้อมูลเชิงสถิติ':{'trait':'WIAM','score':ascArray(5)}},{'ซ่อมแซมอุปกรณ์อิเล็กทรอนิกส์':{'trait':'WPPM','score':ascArray(5)}},{'ออกแบบบ้านในฝันของตนเอง':{'trait':'WCII','score':ascArray(5)}},{'ทำอาหารหรือขนมรับประทานเอง':{'trait':'WPPM','score':ascArray(5)}},{'ร้องเพลงหรือเล่นดนตรี':{'trait':'WCII','score':ascArray(5)}},{'อาสาสมัครทำประโยชน์เพื่อสังคม':{'trait':'WICH','score':ascArray(5)}},{'โพสรูปที่ไม่เหมือนใครลงโซเชียลมีเดีย':{'trait':'WCII','score':ascArray(5)}},{'สอนหรือถ่ายทอดความรู้แก่ผู้อื่น':{'trait':'WICH','score':ascArray(5)}},{'ซ่อมแซมเฟอร์นิเจอร์ในบ้าน':{'trait':'WPPM','score':ascArray(5)}},{'อ่านรีวิวสินค้าและบริการก่อนตัดสินใจซื้อ':{'trait':'WCEO','score':ascArray(5)}},{'สร้างความสนิทสนมกับเพื่อนต่างแดน':{'trait':'WICH','score':ascArray(5)}},{'เสนอขายสินค้าหรือบริการแก่ผู้อื่น':{'trait':'WPAM','score':ascArray(5)}},{'เป็นผู้นำการประชุมหรือสัมมนา':{'trait':'WPAM','score':ascArray(5)}},{'เจรจาต่อรองราคาสินค้าหรือบริการ':{'trait':'WPAM','score':ascArray(5)}},{'จัดระเบียบข้อมูลและเอกสารสำคัญ':{'trait':'WCEO','score':ascArray(5)}},{'สร้างแรงบันดาลใจให้ผู้อื่นตั้งใจทำงาน':{'trait':'WPAM','score':ascArray(5)}},{'ถ่ายภาพบุคคลหรือวิวทิวทัศน์':{'trait':'WCII','score':ascArray(5)}},{'ทำบัญชีรายรับรายจ่าย':{'trait':'WCEO','score':ascArray(5)}},{'ตรวจตราความถูกต้องของเอกสารสำคัญ':{'trait':'WCEO','score':ascArray(5)}},{'แก้ไขและเรียบเรียงรายงานกลุ่ม':{'trait':'WCEO','score':ascArray(5)}},{'เขียนบทความหรือแต่งเพลงถึงผู้อื่น':{'trait':'WCII','score':ascArray(5)}},{'เล่นเกมส์ฝึกทักษะการคิด':{'trait':'WIAM','score':ascArray(5)}}];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _CheckBoxOutlineBlank = __webpack_require__(891);

var _CheckBoxOutlineBlank2 = _interopRequireDefault(_CheckBoxOutlineBlank);

var _CheckBox = __webpack_require__(892);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(107);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'none'
  },
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0
  },
  default: {},
  checked: {},
  disabled: {}
};

/**
 * @ignore - internal component.
 */

var SwitchBase = function (_React$Component) {
  (0, _inherits3.default)(SwitchBase, _React$Component);

  function SwitchBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwitchBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwitchBase.__proto__ || (0, _getPrototypeOf2.default)(SwitchBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.input = null, _this.isControlled = null, _this.handleInputChange = function (event) {
      var checked = event.target.checked;

      if (!_this.isControlled) {
        _this.setState({ checked: checked });
      }

      if (_this.props.onChange) {
        _this.props.onChange(event, checked);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SwitchBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;


      this.isControlled = props.checked != null;

      if (!this.isControlled) {
        // not controlled, use internal state
        this.setState({
          checked: props.defaultChecked !== undefined ? props.defaultChecked : false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          checkedProp = _props.checked,
          checkedIcon = _props.checkedIcon,
          classes = _props.classes,
          classNameProp = _props.className,
          disabledProp = _props.disabled,
          iconProp = _props.icon,
          id = _props.id,
          inputProps = _props.inputProps,
          inputRef = _props.inputRef,
          name = _props.name,
          onChange = _props.onChange,
          tabIndex = _props.tabIndex,
          type = _props.type,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'checkedIcon', 'classes', 'className', 'disabled', 'icon', 'id', 'inputProps', 'inputRef', 'name', 'onChange', 'tabIndex', 'type', 'value']);
      var muiFormControl = this.context.muiFormControl;

      var disabled = disabledProp;

      if (muiFormControl) {
        if (typeof disabled === 'undefined') {
          disabled = muiFormControl.disabled;
        }
      }

      var checked = this.isControlled ? checkedProp : this.state.checked;
      var className = (0, _classnames2.default)(classes.root, classes.default, classNameProp, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checked, checked), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames));

      var icon = checked ? checkedIcon : iconProp;

      var hasLabelFor = type === 'checkbox' || type === 'radio';

      return _react2.default.createElement(
        _IconButton2.default,
        (0, _extends3.default)({
          component: 'span',
          className: className,
          disabled: disabled,
          tabIndex: null,
          role: undefined
        }, other),
        icon,
        _react2.default.createElement('input', (0, _extends3.default)({
          id: hasLabelFor && id,
          type: type,
          name: name,
          checked: checkedProp,
          onChange: this.handleInputChange,
          className: classes.input,
          disabled: disabled,
          tabIndex: tabIndex,
          value: value,
          ref: inputRef
        }, inputProps))
      );
    }
  }]);
  return SwitchBase;
}(_react2.default.Component);

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.


SwitchBase.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

SwitchBase.defaultProps = {
  checkedIcon: _react2.default.createElement(_CheckBox2.default, null),
  disableRipple: false,
  icon: _react2.default.createElement(_CheckBoxOutlineBlank2.default, null),
  type: 'checkbox'
};

SwitchBase.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitchBase' })(SwitchBase);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _transitions = __webpack_require__(53);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },
    entered: {
      height: 'auto'
    },
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },
    wrapperInner: {
      width: '100%'
    }
  };
};

/**
 * The Collapes transition is used by the
 * [Vetical Stepper](/demos/steppers#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
// @inheritedComponent Transition

var Collapse = function (_React$Component) {
  (0, _inherits3.default)(Collapse, _React$Component);

  function Collapse() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Collapse.__proto__ || (0, _getPrototypeOf2.default)(Collapse)).call.apply(_ref, [this].concat(args))), _this), _this.wrapper = null, _this.autoTransitionDuration = undefined, _this.timer = null, _this.handleEnter = function (node) {
      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleEntering = function (node) {
      var _this$props = _this.props,
          timeout = _this$props.timeout,
          theme = _this$props.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = wrapperHeight + 'px';

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.handleEntered = function (node) {
      node.style.height = 'auto';

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.handleExit = function (node) {
      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;
      node.style.height = wrapperHeight + 'px';

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.handleExiting = function (node) {
      var _this$props2 = _this.props,
          timeout = _this$props2.timeout,
          theme = _this$props2.theme;

      var wrapperHeight = _this.wrapper ? _this.wrapper.clientHeight : 0;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration;

      if (timeout === 'auto') {
        var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
        node.style.transitionDuration = duration2 + 'ms';
        _this.autoTransitionDuration = duration2;
      } else {
        node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : transitionDuration + 'ms';
      }

      node.style.height = _this.props.collapsedHeight;

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.addEndListener = function (_, next) {
      if (_this.props.timeout === 'auto') {
        _this.timer = setTimeout(next, _this.autoTransitionDuration || 0);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Collapse, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          collapsedHeight = _props.collapsedHeight,
          Component = _props.component,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExiting = _props.onExiting,
          style = _props.style,
          theme = _props.theme,
          timeout = _props.timeout,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'collapsedHeight', 'component', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExiting', 'style', 'theme', 'timeout']);


      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({
          onEntering: this.handleEntering,
          onEnter: this.handleEnter,
          onEntered: this.handleEntered,
          onExiting: this.handleExiting,
          onExit: this.handleExit,
          addEndListener: this.addEndListener,
          timeout: timeout === 'auto' ? null : timeout
        }, other),
        function (state, childProps) {
          return _react2.default.createElement(
            Component,
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.container, (0, _defineProperty3.default)({}, classes.entered, state === 'entered'), className),
              style: (0, _extends3.default)({}, style, {
                minHeight: collapsedHeight
              })
            }, childProps),
            _react2.default.createElement(
              'div',
              {
                className: classes.wrapper,
                ref: function ref(node) {
                  _this2.wrapper = node;
                }
              },
              _react2.default.createElement(
                'div',
                { className: classes.wrapperInner },
                children
              )
            )
          );
        }
      );
    }
  }]);
  return Collapse;
}(_react2.default.Component);

Collapse.propTypes =  false ? {
  /**
   * The content node to be collapsed.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes2.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Collapse.defaultProps = {
  collapsedHeight: '0px',
  component: 'div',
  timeout: _transitions.duration.standard
};

exports.default = (0, _withStyles2.default)(styles, {
  withTheme: true,
  name: 'MuiCollapse'
})(Collapse);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(402);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "store", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__saga__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducer__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(1005);
//import logger from 'redux-logger'
__WEBPACK_IMPORTED_MODULE_11_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_13__config__["a" /* firebase */]);//create middleWares
var history=__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()();var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["a" /* default */])();var middlewares=Object(__WEBPACK_IMPORTED_MODULE_7_redux__["a" /* applyMiddleware */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["routerMiddleware"])(history),sagaMiddleware//    logger
);var store=Object(__WEBPACK_IMPORTED_MODULE_7_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_10__reducer__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_7_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux_firebase__["reactReduxFirebase"])(__WEBPACK_IMPORTED_MODULE_11_firebase___default.a,__WEBPACK_IMPORTED_MODULE_13__config__["b" /* reduxFirebase */]),middlewares));sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_9__saga__["a" /* default */],__WEBPACK_IMPORTED_MODULE_12_react_redux_firebase__["getFirebase"]);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */],{history:history})),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(233);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(234);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(238);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(118);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(240);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(244);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(432);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(440);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15), __webpack_require__(439)(module)))

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(248);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(161);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(165);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return go; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return goForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return routerActions; });

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generatorCounter = 0;

// Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === undefined ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === undefined ? 'jss' : _options$productionPr;

  var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
  var ruleCounter = 0;

  // - HMR can lead to many class name generators being instantiated,
  // so the warning is only triggered in production.
  // - We expect a class name generator to be instantiated per new request on the server,
  // so the warning is only triggered client side.
  // - You can get away with having multiple class name generators
  // by modifying the `productionPrefix`.
  if ("production" === 'production' && typeof window !== 'undefined' && productionPrefix === 'jss') {
    generatorCounter += 1;

    if (generatorCounter > 2) {
      // eslint-disable-next-line no-console
      console.error(['Material-UI: we have detected more than needed creation of the class name generator.', 'You should only use one class name generator on the client side.', 'If you do otherwise, you take the risk to have conflicting class names in production.'].join('\n'));
    }
  }

  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning2.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    // Code branch the whole block at the expense of more code.
    if (dangerouslyUseGlobalCSS) {
      if (styleSheet && styleSheet.options.classNamePrefix) {
        var prefix = styleSheet.options.classNamePrefix;
        // Sanitize the string as will be used to prefix the generated class name.
        prefix = prefix.replace(escapeRegex, '-');

        if (prefix.match(/^Mui/)) {
          return prefix + '-' + rule.key;
        }

        if (false) {
          return prefix + '-' + rule.key + '-' + ruleCounter;
        }
      }

      if (true) {
        return '' + productionPrefix + ruleCounter;
      }

      return rule.key + '-' + ruleCounter;
    }

    if (true) {
      return '' + productionPrefix + ruleCounter;
    }

    if (styleSheet && styleSheet.options.classNamePrefix) {
      var _prefix = styleSheet.options.classNamePrefix;
      // Sanitize the string as will be used to prefix the generated class name.
      _prefix = _prefix.replace(escapeRegex, '-');

      return _prefix + '-' + rule.key + '-' + ruleCounter;
    }

    return rule.key + '-' + ruleCounter;
  };
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(466), __esModule: true };

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(42) && !__webpack_require__(61)(function () {
  return Object.defineProperty(__webpack_require__(257)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);
var document = __webpack_require__(41).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(62);
var toIObject = __webpack_require__(74);
var arrayIndexOf = __webpack_require__(469)(false);
var IE_PROTO = __webpack_require__(172)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

exports.default = indigo;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

exports.default = pink;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

exports.default = grey;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

exports.default = red;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(26);
var core = __webpack_require__(21);
var fails = __webpack_require__(61);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(479), __esModule: true };

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jssGlobal = __webpack_require__(483);

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

var _jssNested = __webpack_require__(501);

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssCamelCase = __webpack_require__(502);

var _jssCamelCase2 = _interopRequireDefault(_jssCamelCase);

var _jssDefaultUnit = __webpack_require__(504);

var _jssDefaultUnit2 = _interopRequireDefault(_jssDefaultUnit);

var _jssVendorPrefixer = __webpack_require__(506);

var _jssVendorPrefixer2 = _interopRequireDefault(_jssVendorPrefixer);

var _jssPropsSort = __webpack_require__(511);

var _jssPropsSort2 = _interopRequireDefault(_jssPropsSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Subset of jss-preset-default with only the plugins the Material-UI
// components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal2.default)(), (0, _jssNested2.default)(), (0, _jssCamelCase2.default)(), (0, _jssDefaultUnit2.default)(), (0, _jssVendorPrefixer2.default)(), (0, _jssPropsSort2.default)()]
  };
}

exports.default = jssPreset;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(484);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(124);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(267);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(485);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(94);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(179);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(270);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(489);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(244);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(271);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(488);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(269);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(94);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleSheet = function () {
  function StyleSheet(styles, options) {
    _classCallCheck(this, StyleSheet);

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var name in styles) {
        added.push(this.addRule(name, styles[name], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'update',
    value: function update(name, data) {
      this.rules.update(name, data);
      return this;
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(62);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(172)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(521);
var global = __webpack_require__(41);
var hide = __webpack_require__(52);
var Iterators = __webpack_require__(96);
var TO_STRING_TAG = __webpack_require__(34)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(169);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(258);
var hiddenKeys = __webpack_require__(174).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(122);
var createDesc = __webpack_require__(91);
var toIObject = __webpack_require__(74);
var toPrimitive = __webpack_require__(167);
var has = __webpack_require__(62);
var IE8_DOM_DEFINE = __webpack_require__(256);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(42) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 279 */
/***/ (function(module, exports) {



/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(52);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(60);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(96);
var ITERATOR = __webpack_require__(34)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(285);
var ITERATOR = __webpack_require__(34)('iterator');
var Iterators = __webpack_require__(96);
module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(169);
var TAG = __webpack_require__(34)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Namespaces to avoid conflicts on the context.
 */
var jss = exports.jss = '64a55d578f856d258dc345b094a2a2b3';
var sheetsRegistry = exports.sheetsRegistry = 'd4bd0baacbc52bbd48bbb9eb24344ecd';
var managers = exports.managers = 'b768b78919504fba9de2c03545c5cd3a';
var sheetOptions = exports.sheetOptions = '6fc570d6bd61383819d0f9e7407c452d';

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Reboot = __webpack_require__(560);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Reboot).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerWindow;

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownerWindow(node) {
  var doc = (0, _ownerDocument2.default)(node);
  return doc && doc.defaultView || doc.parentWindow;
}
module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirebaseInstance = undefined;

var _isObject2 = __webpack_require__(17);

var _isObject3 = _interopRequireDefault(_isObject2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(100);

var _actions = __webpack_require__(320);

var _actions2 = __webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createFirebaseInstance = exports.createFirebaseInstance = function createFirebaseInstance(firebase, configs, dispatch) {
  if (configs.enableLogging && firebase.database && typeof firebase.database.enableLogging === 'function') {
    firebase.database.enableLogging(configs.enableLogging);
  }

  var defaultInternals = {
    watchers: {},
    listeners: {},
    callbacks: {},
    queries: {},
    config: configs,
    authUid: null
  };

  Object.defineProperty(firebase, '_', {
    value: defaultInternals,
    writable: true,
    enumerable: true,
    configurable: true
  });

  var withMeta = function withMeta(method, path, value, onComplete) {
    if ((0, _isObject3.default)(value)) {
      var prefix = method === 'update' ? 'updated' : 'created';
      var dataWithMeta = _extends({}, value, _defineProperty({}, prefix + 'At', firebase.database.ServerValue.TIMESTAMP));
      if (firebase.auth().currentUser) {
        dataWithMeta[prefix + 'By'] = firebase.auth().currentUser.uid;
      }
      return firebase.database().ref(path)[method](dataWithMeta, onComplete);
    }
    return firebase.database().ref(path)[method](value, onComplete);
  };

  var set = function set(path, value, onComplete) {
    return firebase.database().ref(path).set(value, onComplete);
  };

  var setWithMeta = function setWithMeta(path, value, onComplete) {
    return withMeta('set', path, value, onComplete);
  };

  var push = function push(path, value, onComplete) {
    return firebase.database().ref(path).push(value, onComplete);
  };

  var pushWithMeta = function pushWithMeta(path, value, onComplete) {
    return withMeta('push', path, value, onComplete);
  };

  var update = function update(path, value, onComplete) {
    return firebase.database().ref(path).update(value, onComplete);
  };

  var updateWithMeta = function updateWithMeta(path, value, onComplete) {
    return withMeta('update', path, value, onComplete);
  };

  var remove = function remove(path, onComplete, options) {
    return _actions2.queryActions.remove(firebase, dispatch, path, options).then(function () {
      if (typeof onComplete === 'function') {
        onComplete();
      }
      return path;
    });
  };

  var uniqueSet = function uniqueSet(path, value, onComplete) {
    return firebase.database().ref(path).transaction(function (d) {
      return d === null ? value : undefined;
    }).then(function (_ref) {
      var committed = _ref.committed,
          snapshot = _ref.snapshot;

      if (!committed) {
        var newError = new Error('Path already exists.');
        if (onComplete) onComplete(newError);
        return Promise.reject(newError);
      }
      if (onComplete) onComplete(snapshot);
      return snapshot;
    });
  };

  var uploadFile = function uploadFile(path, file, dbPath, options) {
    return _actions2.storageActions.uploadFile(dispatch, firebase, {
      path: path,
      file: file,
      dbPath: dbPath,
      options: options
    });
  };

  var uploadFiles = function uploadFiles(path, files, dbPath, options) {
    return _actions2.storageActions.uploadFiles(dispatch, firebase, {
      path: path,
      files: files,
      dbPath: dbPath,
      options: options
    });
  };

  var deleteFile = function deleteFile(path, dbPath) {
    return _actions2.storageActions.deleteFile(dispatch, firebase, { path: path, dbPath: dbPath });
  };

  var watchEvent = function watchEvent(type, path, storeAs) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return _actions2.queryActions.watchEvent(firebase, dispatch, _extends({
      type: type,
      path: path,
      storeAs: storeAs
    }, options));
  };

  var unWatchEvent = function unWatchEvent(type, path, queryId) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return _actions2.queryActions.unWatchEvent(firebase, dispatch, _extends({
      type: type,
      path: path,
      queryId: queryId
    }, options));
  };

  var promiseEvents = function promiseEvents(watchArray, options) {
    var inputAsFunc = (0, _utils.createCallable)(watchArray);
    var prevData = inputAsFunc(options, firebase);
    var queryConfigs = (0, _utils.getEventsFromInput)(prevData);

    return Promise.all(queryConfigs.map(function (queryConfig) {
      return _actions2.queryActions.watchEvent(firebase, dispatch, queryConfig);
    }));
  };

  var login = function login(credentials) {
    return _actions2.authActions.login(dispatch, firebase, credentials);
  };

  var logout = function logout() {
    return _actions2.authActions.logout(dispatch, firebase);
  };

  var createUser = function createUser(credentials, profile) {
    return _actions2.authActions.createUser(dispatch, firebase, credentials, profile);
  };

  var resetPassword = function resetPassword(credentials) {
    return _actions2.authActions.resetPassword(dispatch, firebase, credentials);
  };

  var confirmPasswordReset = function confirmPasswordReset(code, password) {
    return _actions2.authActions.confirmPasswordReset(dispatch, firebase, code, password);
  };

  var verifyPasswordResetCode = function verifyPasswordResetCode(code) {
    return _actions2.authActions.verifyPasswordResetCode(dispatch, firebase, code);
  };

  var updateProfile = function updateProfile(profileUpdate, options) {
    return _actions2.authActions.updateProfile(dispatch, firebase, profileUpdate, options);
  };

  var updateAuth = function updateAuth(authUpdate, updateInProfile) {
    return _actions2.authActions.updateAuth(dispatch, firebase, authUpdate, updateInProfile);
  };

  var updateEmail = function updateEmail(newEmail, updateInProfile) {
    return _actions2.authActions.updateEmail(dispatch, firebase, newEmail, updateInProfile);
  };

  var reloadAuth = function reloadAuth() {
    return _actions2.authActions.reloadAuth(dispatch, firebase);
  };

  var linkWithCredential = function linkWithCredential(credential) {
    return _actions2.authActions.linkWithCredential(dispatch, firebase, credential);
  };

  var actionCreators = (0, _actions.mapWithFirebaseAndDispatch)(firebase, dispatch, {
    signInWithPhoneNumber: _actions2.authActions.signInWithPhoneNumber
  });

  var helpers = _extends({
    ref: function ref(path) {
      return firebase.database().ref(path);
    },
    set: set,
    setWithMeta: setWithMeta,
    uniqueSet: uniqueSet,
    push: push,
    pushWithMeta: pushWithMeta,
    remove: remove,
    update: update,
    updateWithMeta: updateWithMeta,
    login: login,
    logout: logout,
    updateAuth: updateAuth,
    updateEmail: updateEmail,
    updateProfile: updateProfile,
    uploadFile: uploadFile,
    uploadFiles: uploadFiles,
    deleteFile: deleteFile,
    createUser: createUser,
    resetPassword: resetPassword,
    confirmPasswordReset: confirmPasswordReset,
    verifyPasswordResetCode: verifyPasswordResetCode,
    watchEvent: watchEvent,
    unWatchEvent: unWatchEvent,
    reloadAuth: reloadAuth,
    linkWithCredential: linkWithCredential,
    promiseEvents: promiseEvents
  }, actionCreators);

  return _extends(firebase, helpers, { helpers: helpers });
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 293 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(609),
    arraySome = __webpack_require__(295),
    cacheHas = __webpack_require__(612);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(298),
    getSymbols = __webpack_require__(192),
    keys = __webpack_require__(81);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(191),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 299 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(617),
    isArguments = __webpack_require__(136),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(137),
    isIndex = __webpack_require__(82),
    isTypedArray = __webpack_require__(193);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(627);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(630),
    hasPath = __webpack_require__(308);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(84),
    isArguments = __webpack_require__(136),
    isArray = __webpack_require__(13),
    isIndex = __webpack_require__(82),
    isLength = __webpack_require__(194),
    toKey = __webpack_require__(66);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(191),
    isFlattenable = __webpack_require__(636);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(314),
    keys = __webpack_require__(81);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(638);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(295),
    baseIteratee = __webpack_require__(55),
    baseSome = __webpack_require__(640),
    isArray = __webpack_require__(13),
    isIterateeCall = __webpack_require__(200);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(641),
    hasPath = __webpack_require__(308);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(201);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populateAndDispatch = exports.orderedFromSnapshot = exports.applyParamsToQuery = exports.unsetWatcher = exports.getWatcherCount = exports.setWatcher = exports.getQueryIdFromPath = exports.getWatchPath = undefined;

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _size2 = __webpack_require__(203);

var _size3 = _interopRequireDefault(_size2);

var _forEach2 = __webpack_require__(202);

var _forEach3 = _interopRequireDefault(_forEach2);

var _isNaN2 = __webpack_require__(648);

var _isNaN3 = _interopRequireDefault(_isNaN2);

var _constants = __webpack_require__(49);

var _populate = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tryParseToNumber = function tryParseToNumber(value) {
  var result = Number(value);
  if ((0, _isNaN3.default)(result)) {
    return value;
  }
  return result;
};

var getWatchPath = exports.getWatchPath = function getWatchPath(event, path) {
  if (!event || event === '' || !path) {
    throw new Error('Event and path are required');
  }
  return event + ':' + (path.substring(0, 1) === '/' ? '' : '/') + path;
};

var getQueryIdFromPath = exports.getQueryIdFromPath = function getQueryIdFromPath(path, event) {
  if (!(0, _isString3.default)(path)) {
    throw new Error('Query path must be a string');
  }
  var origPath = path;
  var pathSplitted = path.split('#');
  path = pathSplitted[0];

  var isQuery = pathSplitted.length > 1;
  var queryParams = isQuery ? pathSplitted[1].split('&') : [];
  var queryId = isQuery ? queryParams.map(function (param) {
    var splittedParam = param.split('=');

    if (splittedParam[0] === 'queryId') {
      return splittedParam[1];
    }
  }).filter(function (q) {
    return q;
  }) : undefined;
  return queryId && queryId.length > 0 ? event ? event + ':/' + queryId : queryId[0] : isQuery ? origPath : undefined;
};

var setWatcher = exports.setWatcher = function setWatcher(firebase, dispatch, event, path, queryId) {
  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);

  if (firebase._.watchers[id]) {
    firebase._.watchers[id]++;
  } else {
    firebase._.watchers[id] = 1;
  }

  dispatch({ type: _constants.actionTypes.SET_LISTENER, path: path, payload: { id: id } });

  return firebase._.watchers[id];
};

var getWatcherCount = exports.getWatcherCount = function getWatcherCount(firebase, event, path, queryId) {
  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);
  return firebase._.watchers[id];
};

var unsetWatcher = exports.unsetWatcher = function unsetWatcher(firebase, dispatch, event, path, queryId) {
  var id = queryId || getQueryIdFromPath(path, event) || getWatchPath(event, path);
  path = path.split('#')[0];
  var watchers = firebase._.watchers;

  if (watchers[id] <= 1) {
    delete watchers[id];
    if (event !== 'first_child' && event !== 'once') {
      firebase.database().ref().child(path).off(event);
    }
  } else if (watchers[id]) {
    watchers[id]--;
  }

  dispatch({ type: _constants.actionTypes.UNSET_LISTENER, path: path, payload: { id: id } });
};

var applyParamsToQuery = exports.applyParamsToQuery = function applyParamsToQuery(queryParams, query) {
  var doNotParse = false;
  if (queryParams) {
    queryParams.forEach(function (param) {
      param = param.split('=');
      switch (param[0]) {
        case 'orderByValue':
          query = query.orderByValue();
          doNotParse = true;
          break;
        case 'orderByPriority':
          query = query.orderByPriority();
          doNotParse = true;
          break;
        case 'orderByKey':
          query = query.orderByKey();
          doNotParse = true;
          break;
        case 'orderByChild':
          query = query.orderByChild(param[1]);
          break;
        case 'limitToFirst':
          query = query.limitToFirst(parseInt(param[1], 10));
          break;
        case 'limitToLast':
          query = query.limitToLast(parseInt(param[1], 10));
          break;
        case 'notParsed':
          doNotParse = true;
          break;
        case 'parsed':
          doNotParse = false;
          break;
        case 'equalTo':
          var equalToParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          equalToParam = equalToParam === 'null' ? null : equalToParam;
          equalToParam = equalToParam === 'false' ? false : equalToParam;
          equalToParam = equalToParam === 'true' ? true : equalToParam;
          query = param.length === 3 ? query.equalTo(equalToParam, param[2]) : query.equalTo(equalToParam);
          break;
        case 'startAt':
          var startAtParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          startAtParam = startAtParam === 'null' ? null : startAtParam;
          query = param.length === 3 ? query.startAt(startAtParam, param[2]) : query.startAt(startAtParam);
          break;
        case 'endAt':
          var endAtParam = !doNotParse ? tryParseToNumber(param[1]) : param[1];
          endAtParam = endAtParam === 'null' ? null : endAtParam;
          query = param.length === 3 ? query.endAt(endAtParam, param[2]) : query.endAt(endAtParam);
          break;
      }
    });
  }

  return query;
};

var orderedFromSnapshot = exports.orderedFromSnapshot = function orderedFromSnapshot(snap) {
  if (snap.hasChildren && !snap.hasChildren()) {
    return null;
  }
  var ordered = [];
  if (snap.forEach) {
    snap.forEach(function (child) {
      ordered.push({ key: child.key, value: child.val() });
    });
  }
  return (0, _size3.default)(ordered) ? ordered : null;
};

var populateAndDispatch = exports.populateAndDispatch = function populateAndDispatch(firebase, dispatch, config) {
  var data = config.data,
      populates = config.populates,
      snapshot = config.snapshot,
      path = config.path,
      storeAs = config.storeAs;

  return (0, _populate.promisesForPopulate)(firebase, snapshot.key, data, populates).then(function (results) {
    (0, _forEach3.default)(results, function (result, path) {
      dispatch({
        type: _constants.actionTypes.MERGE,
        path: path,
        data: result
      });
    });
    dispatch({
      type: _constants.actionTypes.SET,
      path: storeAs || path,
      data: data,
      ordered: orderedFromSnapshot(snapshot)
    });
    return results;
  }).catch(function (err) {
    dispatch({
      type: _constants.actionTypes.ERROR,
      payload: err
    });
    return Promise.reject(err);
  });
};

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapWithFirebaseAndDispatch = exports.wrapInDispatch = undefined;

var _mapValues2 = __webpack_require__(321);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _isObject2 = __webpack_require__(17);

var _isObject3 = _interopRequireDefault(_isObject2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var wrapInDispatch = exports.wrapInDispatch = function wrapInDispatch(dispatch, _ref) {
  var ref = _ref.ref,
      meta = _ref.meta,
      method = _ref.method,
      _ref$args = _ref.args,
      args = _ref$args === undefined ? [] : _ref$args,
      types = _ref.types;

  var _types = _slicedToArray(types, 3),
      requestingType = _types[0],
      successType = _types[1],
      errorType = _types[2];

  dispatch({
    type: (0, _isObject3.default)(requestingType) ? requestingType.type : requestingType,
    meta: meta,
    payload: (0, _isObject3.default)(requestingType) ? requestingType.payload : { args: args }
  });
  return method.apply(undefined, _toConsumableArray(args)).then(function (payload) {
    dispatch({
      type: (0, _isObject3.default)(successType) ? successType.type : successType,
      meta: meta,
      payload: (0, _isObject3.default)(successType) ? successType.payload : payload
    });
    return payload;
  }).catch(function (err) {
    dispatch({
      type: errorType,
      meta: meta,
      payload: err
    });
    return Promise.reject(err);
  });
};

var createWithFirebaseAndDispatch = function createWithFirebaseAndDispatch(firebase, dispatch, dispatchFirst) {
  return function (func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return func.apply(firebase, dispatchFirst ? [dispatch, firebase].concat(args) : [firebase, dispatch].concat(args));
    };
  };
};

var mapWithFirebaseAndDispatch = exports.mapWithFirebaseAndDispatch = function mapWithFirebaseAndDispatch(firebase, dispatch, actions) {
  var aliases = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  var withFirebaseAndDispatch = createWithFirebaseAndDispatch(firebase, dispatch);
  return _extends({}, (0, _mapValues3.default)(actions, withFirebaseAndDispatch), aliases.reduce(function (acc, _ref2) {
    var action = _ref2.action,
        name = _ref2.name;
    return _extends({}, acc, _defineProperty({}, name, withFirebaseAndDispatch(action)));
  }, {}));
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(145),
    baseForOwn = __webpack_require__(313),
    baseIteratee = __webpack_require__(55);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storageActions = exports.queryActions = exports.authActions = undefined;

var _auth = __webpack_require__(650);

var authActions = _interopRequireWildcard(_auth);

var _query = __webpack_require__(352);

var queryActions = _interopRequireWildcard(_query);

var _storage = __webpack_require__(727);

var storageActions = _interopRequireWildcard(_storage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.authActions = authActions;
exports.queryActions = queryActions;
exports.storageActions = storageActions;
exports.default = { authActions: authActions, queryActions: queryActions, storageActions: storageActions };

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(141),
    baseClone = __webpack_require__(205),
    baseUnset = __webpack_require__(199),
    castPath = __webpack_require__(84),
    copyObject = __webpack_require__(68),
    customOmitClone = __webpack_require__(665),
    flatRest = __webpack_require__(209),
    getAllKeysIn = __webpack_require__(327);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(68),
    keys = __webpack_require__(81);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(22);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module)))

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(191),
    getPrototype = __webpack_require__(206),
    getSymbols = __webpack_require__(192),
    stubArray = __webpack_require__(300);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(298),
    getSymbolsIn = __webpack_require__(326),
    keysIn = __webpack_require__(147);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(207);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(148),
    getPrototype = __webpack_require__(206),
    isPrototype = __webpack_require__(139);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(149);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 331 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populate = exports.fixPath = exports.isEmpty = exports.isLoaded = exports.getVal = undefined;

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _some2 = __webpack_require__(315);

var _some3 = _interopRequireDefault(_some2);

var _compact2 = __webpack_require__(669);

var _compact3 = _interopRequireDefault(_compact2);

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _defaultsDeep2 = __webpack_require__(670);

var _defaultsDeep3 = _interopRequireDefault(_defaultsDeep2);

var _reduce2 = __webpack_require__(676);

var _reduce3 = _interopRequireDefault(_reduce2);

var _every2 = __webpack_require__(679);

var _every3 = _interopRequireDefault(_every2);

var _mapValues2 = __webpack_require__(321);

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _map2 = __webpack_require__(142);

var _map3 = _interopRequireDefault(_map2);

var _last2 = __webpack_require__(310);

var _last3 = _interopRequireDefault(_last2);

var _has2 = __webpack_require__(316);

var _has3 = _interopRequireDefault(_has2);

var _get2 = __webpack_require__(102);

var _get3 = _interopRequireDefault(_get2);

var _set2 = __webpack_require__(317);

var _set3 = _interopRequireDefault(_set2);

var _size2 = __webpack_require__(203);

var _size3 = _interopRequireDefault(_size2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(49);

var _populate = __webpack_require__(143);

var _reducers = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getVal = exports.getVal = function getVal(firebase, path, notSetValue) {
  if (!firebase) {
    return notSetValue;
  }

  var dotPath = (0, _reducers.getDotStrPath)(path);
  var valueAtPath = (0, _get3.default)(firebase, dotPath, notSetValue);

  return valueAtPath;
};

var isLoaded = exports.isLoaded = function isLoaded() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args || !args.length ? true : (0, _every3.default)(args, function (arg) {
    return arg !== undefined && (0, _get3.default)(arg, 'isLoaded') !== false;
  });
};

var isEmpty = exports.isEmpty = function isEmpty() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return (0, _some3.default)(args, function (arg) {
    return !(arg && (0, _size3.default)(arg)) || arg.isEmpty === true;
  });
};

var fixPath = exports.fixPath = function fixPath(path) {
  return (path.substring(0, 1) === '/' ? '' : '/') + path;
};

var buildChildList = function buildChildList(state, list, p) {
  return (0, _mapValues3.default)(list, function (val, key) {
    var getKey = val;

    if (val === true) {
      getKey = key;
    }

    var dotRoot = (0, _compact3.default)(p.root.split('/')).join('.');
    var pathArr = [dotRoot, getKey];

    if (p.childParam) {
      pathArr.push(p.childParam);
    }

    var pathString = pathArr.join('.');

    if ((0, _get3.default)(state.data, pathString)) {
      return p.keyProp ? _extends(_defineProperty({}, p.keyProp, getKey), (0, _get3.default)(state.data, pathString)) : (0, _get3.default)(state.data, pathString);
    }

    return val === true ? val : getKey;
  });
};

var populateChild = function populateChild(state, child, p) {
  var childVal = (0, _get3.default)(child, p.child);
  if (!child || !childVal) {
    return null;
  }

  if ((0, _isString3.default)(childVal)) {
    var dotRoot = (0, _compact3.default)(p.root.split('/')).join('.');
    var pathArr = [dotRoot, childVal];

    if (p.childParam) {
      pathArr.push(p.childParam);
    }

    var pathString = pathArr.join('.');

    var populateVal = (0, _get3.default)(state.data, pathString);
    if (populateVal) {
      return (0, _set3.default)({}, p.childAlias || p.child, p.keyProp ? _extends(_defineProperty({}, p.keyProp, childVal), populateVal) : populateVal);
    }

    return child;
  }

  return (0, _set3.default)({}, p.childAlias || p.child, buildChildList(state, childVal, p));
};

var populate = exports.populate = function populate(state, path, populates, notSetValue) {
  var splitPath = (0, _compact3.default)(path.split('/'));

  var pathArr = _constants.topLevelPaths.indexOf(splitPath[0]) === -1 ? ['data'].concat(_toConsumableArray(splitPath)) : splitPath;
  var dotPath = pathArr.join('.');

  var data = (0, _get3.default)(state, dotPath, notSetValue);

  if (!state || data === notSetValue) {
    return notSetValue;
  }

  if (data === null) {
    return null;
  }

  var populatesForData = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates((0, _last3.default)(pathArr), data) : populates);

  if ((0, _isArray3.default)(data)) {
    var someArrayItemHasKey = function someArrayItemHasKey(array) {
      return function (key) {
        return (0, _some3.default)(array, function (item) {
          return (0, _has3.default)(item, key);
        });
      };
    };

    var _dataHasPopulateChilds = (0, _some3.default)(populatesForData, function (populate) {
      return someArrayItemHasKey(data)(['value', populate.child]);
    });

    if (_dataHasPopulateChilds) {
      return data.map(function (_ref) {
        var key = _ref.key,
            dataValue = _ref.value;

        var populatedValue = populatesForData.map(function (p) {
          return populateChild(state, dataValue, p);
        }).reduce(function (acc, v) {
          return (0, _defaultsDeep3.default)(v, acc);
        }, dataValue);

        return {
          key: key,
          value: populatedValue
        };
      });
    }

    return data;
  }

  var dataHasPopulateChilds = (0, _some3.default)(populatesForData, function (p) {
    return (0, _has3.default)(data, p.child);
  });

  if (dataHasPopulateChilds) {
    return populatesForData.map(function (p) {
      return populateChild(state, data, p);
    }).reduce(function (acc, v) {
      return (0, _defaultsDeep3.default)(v, acc);
    }, data);
  }

  if (pathArr.indexOf('profile') !== -1) {
    return data;
  }

  return (0, _mapValues3.default)(data, function (child, childKey) {
    var key = pathArr[0] === 'ordered' ? child.key : childKey;

    var populatesForDataItem = (0, _populate.getPopulateObjs)((0, _isFunction3.default)(populates) ? populates(key, child) : populates);

    var dataHasPopulateChilds = (0, _some3.default)(populatesForDataItem, function (p) {
      return (0, _has3.default)(child, p.child);
    });

    if (!dataHasPopulateChilds) {
      return child;
    }

    return (0, _reduce3.default)((0, _map3.default)(populatesForDataItem, function (p) {
      return populateChild(state, child, p);
    }), function (obj, v) {
      return (0, _defaultsDeep3.default)(v, obj);
    }, child);
  });
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(105),
    overRest = __webpack_require__(330),
    setToString = __webpack_require__(210);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(131),
    assignMergeValue = __webpack_require__(335),
    baseFor = __webpack_require__(314),
    baseMergeDeep = __webpack_require__(672),
    isObject = __webpack_require__(17),
    keysIn = __webpack_require__(147),
    safeGet = __webpack_require__(336);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(145),
    eq = __webpack_require__(101);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(333),
    isIterateeCall = __webpack_require__(200);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(105),
    metaMap = __webpack_require__(339);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(303);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(341),
    composeArgsRight = __webpack_require__(342),
    countHolders = __webpack_require__(689),
    createCtor = __webpack_require__(151),
    createRecurry = __webpack_require__(343),
    getHolder = __webpack_require__(348),
    reorder = __webpack_require__(704),
    replaceHolders = __webpack_require__(216),
    root = __webpack_require__(22);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(690),
    setData = __webpack_require__(346),
    setWrapToString = __webpack_require__(347);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(339),
    noop = __webpack_require__(691);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(148),
    baseLodash = __webpack_require__(215);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(338),
    shortOut = __webpack_require__(331);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(696),
    insertWrapDetails = __webpack_require__(697),
    setToString = __webpack_require__(210),
    updateWrapDetails = __webpack_require__(698);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(707);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17),
    isSymbol = __webpack_require__(103);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(716),
    flatRest = __webpack_require__(209);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.unWatchEvents = exports.watchEvents = exports.unWatchEvent = exports.watchEvent = undefined;

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _constants = __webpack_require__(49);

var _query = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var watchEvent = exports.watchEvent = function watchEvent(firebase, dispatch, options) {
  if (!firebase.database || typeof firebase.database !== 'function') {
    throw new Error('Firebase database is required to create watchers');
  }
  var type = options.type,
      path = options.path,
      populates = options.populates,
      queryParams = options.queryParams,
      queryId = options.queryId,
      isQuery = options.isQuery,
      storeAs = options.storeAs;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  var id = queryId || (0, _query.getQueryIdFromPath)(path);
  var counter = (0, _query.getWatcherCount)(firebase, type, watchPath, id);

  if (counter > 0) {
    if (id) {
      (0, _query.unsetWatcher)(firebase, dispatch, type, path, id);
    } else {
      return;
    }
  }

  (0, _query.setWatcher)(firebase, dispatch, type, watchPath, id);

  if (type === 'first_child') {
    return firebase.database().ref().child(path).orderByKey().limitToFirst(1).once('value').then(function (snapshot) {
      if (snapshot.val() === null) {
        dispatch({
          type: _constants.actionTypes.NO_VALUE,
          path: storeAs || path
        });
      }
      return snapshot;
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.ERROR,
        path: storeAs || path,
        payload: err
      });
      return Promise.reject(err);
    });
  }

  var query = firebase.database().ref().child(path);

  if (isQuery) {
    query = (0, _query.applyParamsToQuery)(queryParams, query);
  }

  dispatch({ type: _constants.actionTypes.START, path: storeAs || path });

  if (type === 'once') {
    return query.once('value').then(function (snapshot) {
      if (snapshot.val() === null) {
        return dispatch({
          type: _constants.actionTypes.NO_VALUE,
          path: storeAs || path
        });
      }

      if (!populates) {
        return dispatch({
          type: _constants.actionTypes.SET,
          path: storeAs || path,
          data: snapshot.val(),
          ordered: (0, _query.orderedFromSnapshot)(snapshot)
        });
      }

      return (0, _query.populateAndDispatch)(firebase, dispatch, {
        path: path,
        storeAs: storeAs,
        snapshot: snapshot,
        data: snapshot.val(),
        populates: populates
      });
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.UNAUTHORIZED_ERROR,
        payload: err
      });
      return Promise.reject(err);
    });
  }

  query.on(type, function (snapshot) {
    var data = type === 'child_removed' ? undefined : snapshot.val();
    var resultPath = storeAs || type === 'value' ? path : path + '/' + snapshot.key;

    if (!populates) {
      var ordered = type === 'child_added' ? [{ key: snapshot.key, value: snapshot.val() }] : (0, _query.orderedFromSnapshot)(snapshot);
      return dispatch({
        type: _constants.actionTypes.SET,
        path: storeAs || resultPath,
        data: data,
        ordered: ordered
      });
    }

    return (0, _query.populateAndDispatch)(firebase, dispatch, {
      path: path,
      storeAs: storeAs,
      snapshot: snapshot,
      data: snapshot.val(),
      populates: populates
    });
  }, function (err) {
    dispatch({ type: _constants.actionTypes.ERROR, payload: err });
  });
};

var unWatchEvent = exports.unWatchEvent = function unWatchEvent(firebase, dispatch, _ref) {
  var type = _ref.type,
      path = _ref.path,
      storeAs = _ref.storeAs,
      queryId = _ref.queryId;

  var watchPath = !storeAs ? path : path + '@' + storeAs;
  (0, _query.unsetWatcher)(firebase, dispatch, type, watchPath, queryId);
};

var watchEvents = exports.watchEvents = function watchEvents(firebase, dispatch, events) {
  if (!(0, _isArray3.default)(events)) {
    throw new Error('Events config must be an Array');
  }
  return events.map(function (event) {
    return watchEvent(firebase, dispatch, event);
  });
};

var unWatchEvents = exports.unWatchEvents = function unWatchEvents(firebase, dispatch, events) {
  return events.forEach(function (event) {
    return unWatchEvent(firebase, dispatch, event);
  });
};

var remove = exports.remove = function remove(firebase, dispatch, path) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$dispatchActi = options.dispatchAction,
      dispatchAction = _options$dispatchActi === undefined ? true : _options$dispatchActi;
  var dispatchRemoveAction = firebase._.config.dispatchRemoveAction;

  return firebase.database().ref(path).remove().then(function () {
    if (dispatchRemoveAction && dispatchAction) {
      dispatch({ type: _constants.actionTypes.REMOVE, path: path });
    }
    return path;
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.ERROR, payload: err });
    return Promise.reject(err);
  });
};

exports.default = { watchEvents: watchEvents, unWatchEvents: unWatchEvents, remove: remove };

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(190);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__(744);

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Hidden = __webpack_require__(748);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hidden).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left'
    },
    container: {
      position: 'relative'
    },
    keyboardFocused: {
      backgroundColor: theme.palette.action.hover
    },
    default: {
      paddingTop: 12,
      paddingBottom: 12
    },
    dense: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    disabled: {
      opacity: 0.5
    },
    divider: {
      borderBottom: '1px solid ' + theme.palette.divider,
      backgroundClip: 'padding-box'
    },
    gutters: {
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2
    },
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positionned.
      paddingRight: theme.spacing.unit * 4
    }
  };
};

var ListItem = function (_React$Component) {
  (0, _inherits3.default)(ListItem, _React$Component);

  function ListItem() {
    (0, _classCallCheck3.default)(this, ListItem);
    return (0, _possibleConstructorReturn3.default)(this, (ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(ListItem, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense || this.context.dense || false
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          button = _props.button,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          componentProp = _props.component,
          ContainerComponent = _props.ContainerComponent,
          ContainerProps = _props.ContainerProps,
          dense = _props.dense,
          disabled = _props.disabled,
          disableGutters = _props.disableGutters,
          divider = _props.divider,
          other = (0, _objectWithoutProperties3.default)(_props, ['button', 'children', 'classes', 'className', 'component', 'ContainerComponent', 'ContainerProps', 'dense', 'disabled', 'disableGutters', 'divider']);


      var isDense = dense || this.context.dense || false;
      var children = _react2.default.Children.toArray(childrenProp);
      var hasAvatar = children.some(function (value) {
        return (0, _reactHelpers.isMuiElement)(value, ['ListItemAvatar']);
      });
      var hasSecondaryAction = children.length && (0, _reactHelpers.isMuiElement)(children[children.length - 1], ['ListItemSecondaryAction']);

      var className = (0, _classnames2.default)(classes.root, isDense || hasAvatar ? classes.dense : classes.default, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.gutters, !disableGutters), (0, _defineProperty3.default)(_classNames, classes.divider, divider), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.button, button), (0, _defineProperty3.default)(_classNames, classes.secondaryAction, hasSecondaryAction), _classNames), classNameProp);

      var componentProps = (0, _extends3.default)({ className: className, disabled: disabled }, other);
      var Component = componentProp || 'li';

      if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.keyboardFocusedClassName = classes.keyboardFocused;
        Component = _ButtonBase2.default;
      }

      if (hasSecondaryAction) {
        Component = Component !== _ButtonBase2.default && !componentProp ? 'div' : Component;

        return _react2.default.createElement(
          ContainerComponent,
          (0, _extends3.default)({ className: classes.container }, ContainerProps),
          _react2.default.createElement(
            Component,
            componentProps,
            children
          ),
          children.pop()
        );
      }

      return _react2.default.createElement(
        Component,
        componentProps,
        children
      );
    }
  }]);
  return ListItem;
}(_react2.default.Component);

ListItem.propTypes =  false ? {
  /**
   * If `true`, the list item will be a button (using `ButtonBase`).
   */
  button: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The container component. Useful when a `ListItemSecondaryAction` is rendered.
   */
  ContainerComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the container element when the component
   * is used to display a `ListItemSecondaryAction`.
   */
  ContainerProps: _propTypes2.default.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: _propTypes2.default.bool,
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: _propTypes2.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: _propTypes2.default.bool
} : {};

ListItem.defaultProps = {
  button: false,
  ContainerComponent: 'li',
  dense: false,
  disabled: false,
  disableGutters: false,
  divider: false
};

ListItem.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItem.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItem' })(ListItem);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Divider = __webpack_require__(759);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Divider).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: theme.spacing.unit * 5,
      height: theme.spacing.unit * 5,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE11.
      objectFit: 'cover'
    }
  };
};

function Avatar(props) {
  var alt = props.alt,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = (0, _objectWithoutProperties3.default)(props, ['alt', 'children', 'childrenClassName', 'classes', 'className', 'component', 'imgProps', 'sizes', 'src', 'srcSet']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react2.default.isValidElement(childrenProp)) {
      var childrenClassName = (0, _classnames2.default)(childrenClassNameProp, childrenProp.props.className);
      children = _react2.default.cloneElement(childrenProp, { className: childrenClassName });
    } else {
      children = childrenProp;
    }
  } else if (src || srcSet) {
    children = _react2.default.createElement('img', (0, _extends3.default)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  }

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Avatar.propTypes =  false ? {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes2.default.string,
  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   * The className of the child element.
   * Used by Chip and ListItemIcon to style the Avatar icon.
   */
  childrenClassName: _propTypes2.default.string,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `img` element when the component
   * is used to display an image.
   */
  imgProps: _propTypes2.default.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes2.default.string,
  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes2.default.string,
  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: _propTypes2.default.string
} : {};

Avatar.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAvatar' })(Avatar);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  row: {
    flexDirection: 'row'
  }
};

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
function FormGroup(props) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      row = props.row,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'children', 'row']);

  var rootClassName = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.row, row), className);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: rootClassName }, other),
    children
  );
}

FormGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Display group of elements in a compact row.
   */
  row: _propTypes2.default.bool
} : {};

FormGroup.defaultProps = {
  row: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormGroup' })(FormGroup);

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(219);

var _helpers = __webpack_require__(14);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      position: 'relative',
      // Reset fieldset default style
      minWidth: 0,
      padding: 0,
      margin: 0,
      border: 0
    },
    marginNormal: {
      marginTop: theme.spacing.unit * 2,
      marginBottom: theme.spacing.unit
    },
    marginDense: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit / 2
    },
    fullWidth: {
      width: '100%'
    }
  };
};

/**
 * Provides context such as dirty/focused/error/required for form inputs.
 * Relying on the context provides high flexibilty and ensures that the state always stay
 * consitent across the children of the `FormControl`.
 * This context is used by the following components:
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 */

var FormControl = function (_React$Component) {
  (0, _inherits3.default)(FormControl, _React$Component);

  function FormControl(props, context) {
    (0, _classCallCheck3.default)(this, FormControl);

    // We need to iterate through the children and find the Input in order
    // to fully support server side rendering.
    var _this = (0, _possibleConstructorReturn3.default)(this, (FormControl.__proto__ || (0, _getPrototypeOf2.default)(FormControl)).call(this, props, context));

    _this.state = {
      adornedStart: false,
      dirty: false,
      focused: false
    };

    _this.handleFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState(function (state) {
        return !state.focused ? { focused: true } : null;
      });
    };

    _this.handleBlur = function (event) {
      // The event might be undefined.
      // For instance, a child component might call this hook
      // when an input is disabled but still having the focus.
      if (_this.props.onBlur && event) {
        _this.props.onBlur(event);
      }
      _this.setState(function (state) {
        return state.focused ? { focused: false } : null;
      });
    };

    _this.handleDirty = function () {
      if (!_this.state.dirty) {
        _this.setState({ dirty: true });
      }
    };

    _this.handleClean = function () {
      if (_this.state.dirty) {
        _this.setState({ dirty: false });
      }
    };

    var children = _this.props.children;

    if (children) {
      _react2.default.Children.forEach(children, function (child) {
        if ((0, _reactHelpers.isMuiElement)(child, ['Input', 'Select']) && (0, _Input.isDirty)(child.props, true)) {
          _this.state.dirty = true;
        }
        if ((0, _reactHelpers.isMuiElement)(child, ['Input']) && (0, _Input.isAdornedStart)(child.props)) {
          _this.state.adornedStart = true;
        }
      });
    }
    return _this;
  }

  (0, _createClass3.default)(FormControl, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          disabled = _props.disabled,
          error = _props.error,
          required = _props.required,
          margin = _props.margin;
      var _state = this.state,
          adornedStart = _state.adornedStart,
          dirty = _state.dirty,
          focused = _state.focused;


      return {
        muiFormControl: {
          adornedStart: adornedStart,
          dirty: dirty,
          disabled: disabled,
          error: error,
          focused: focused,
          margin: margin,
          required: required,
          onDirty: this.handleDirty,
          onClean: this.handleClean,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props2 = this.props,
          classes = _props2.classes,
          className = _props2.className,
          Component = _props2.component,
          disabled = _props2.disabled,
          error = _props2.error,
          fullWidth = _props2.fullWidth,
          margin = _props2.margin,
          required = _props2.required,
          other = (0, _objectWithoutProperties3.default)(_props2, ['classes', 'className', 'component', 'disabled', 'error', 'fullWidth', 'margin', 'required']);


      return _react2.default.createElement(Component, (0, _extends3.default)({
        className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['margin' + (0, _helpers.capitalize)(margin)], margin !== 'none'), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), className)
      }, other, {
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }));
    }
  }]);
  return FormControl;
}(_react2.default.Component);

FormControl.propTypes =  false ? {
  /**
   * The contents of the form control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormControl.defaultProps = {
  component: 'div',
  disabled: false,
  error: false,
  fullWidth: false,
  margin: 'none',
  required: false
};

FormControl.childContextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControl' })(FormControl);

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      textAlign: 'left',
      marginTop: theme.spacing.unit,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0
    },
    dense: {
      marginTop: theme.spacing.unit / 2
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
};

function FormHelperText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disabledProp = props.disabled,
      errorProp = props.error,
      marginProp = props.margin,
      Component = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disabled', 'error', 'margin', 'component']);
  var muiFormControl = context.muiFormControl;


  var disabled = disabledProp;
  var error = errorProp;
  var margin = marginProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }

    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }

    if (typeof margin === 'undefined') {
      margin = muiFormControl.margin;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), (0, _defineProperty3.default)(_classNames, classes.dense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

FormHelperText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense'])
} : {};

FormHelperText.defaultProps = {
  component: 'p'
};

FormHelperText.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormHelperText' })(FormHelperText);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return jobSearchAdd; });
/* unused harmony export jobSearchSuccess */
/* unused harmony export jobSearchFailure */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return jobSearchDelete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(110);
var jobSearchAdd=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["a" /* JOBSEARCH_ADD */],'university','faculty','department','jobs','image','oldJobs','name');var jobSearchSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["d" /* JOBSEARCH_SUCCESS */]);var jobSearchFailure=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["c" /* JOBSEARCH_FAILURE */]);var jobSearchDelete=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["b" /* JOBSEARCH_DELETE */],'jobId','jobs');

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' });

var Extension = function Extension(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Extension = (0, _pure2.default)(Extension);
Extension.muiName = 'SvgIcon';

exports.default = Extension;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' });

var InsertEmoticon = function InsertEmoticon(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

InsertEmoticon = (0, _pure2.default)(InsertEmoticon);
InsertEmoticon.muiName = 'SvgIcon';

exports.default = InsertEmoticon;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' });

var Work = function Work(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Work = (0, _pure2.default)(Work);
Work.muiName = 'SvgIcon';

exports.default = Work;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInternetExplorerBefore;
/*
 * This detection method identifies Internet Explorers up until version 11.
 *
 * Reference: https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
 */
function isInternetExplorerBefore(version) {
  var iematch = /MSIE ([0-9]+)/g.exec(window.navigator.userAgent);

  return iematch ? +iematch[1] < version : false;
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  RESISTANCE_COEF: 0.6,

  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SocialLoginButton = __webpack_require__(828);

var _SocialLoginButton2 = _interopRequireDefault(_SocialLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLoginButtonProvider = function SocialLoginButtonProvider(_ref) {
    var defaults = _ref.defaults,
        props = _ref.props;

    var finalProps = _extends({}, defaults, props, {
        style: _extends({}, defaults.style, props.style),
        activeStyle: _extends({}, defaults.activeStyle, props.activeStyle)
    });
    // console.log('provider:', {defaults, props}, {finalProps});
    return _react2.default.createElement(_SocialLoginButton2.default, finalProps);
};

exports.default = SocialLoginButtonProvider;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AppBar = __webpack_require__(834);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AppBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Manager = __webpack_require__(836);

Object.defineProperty(exports, 'Manager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Manager).default;
  }
});

var _Target = __webpack_require__(837);

Object.defineProperty(exports, 'Target', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Target).default;
  }
});

var _Popper = __webpack_require__(838);

Object.defineProperty(exports, 'Popper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popper).default;
  }
});

var _Arrow = __webpack_require__(840);

Object.defineProperty(exports, 'Arrow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Arrow).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _scrollbarSize = __webpack_require__(373);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Popover = __webpack_require__(374);

var _Popover2 = _interopRequireDefault(_Popover);

var _MenuList = __webpack_require__(381);

var _MenuList2 = _interopRequireDefault(_MenuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
}; // @inheritedComponent Popover

var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

var styles = exports.styles = {
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100vh - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  }
};

var Menu = function (_React$Component) {
  (0, _inherits3.default)(Menu, _React$Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.getContentAnchorEl = function () {
      if (!_this.menuList || !_this.menuList.selectedItem) {
        return (0, _reactDom.findDOMNode)(_this.menuList).firstChild;
      }

      return (0, _reactDom.findDOMNode)(_this.menuList.selectedItem);
    }, _this.menuList = undefined, _this.focus = function () {
      if (_this.menuList && _this.menuList.selectedItem) {
        (0, _reactDom.findDOMNode)(_this.menuList.selectedItem).focus();
        return;
      }

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);
      if (menuList && menuList.firstChild) {
        menuList.firstChild.focus();
      }
    }, _this.handleEnter = function (element) {
      var theme = _this.props.theme;

      var menuList = (0, _reactDom.findDOMNode)(_this.menuList);

      // Focus so the scroll computation of the Popover works as expected.
      _this.focus();

      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      if (menuList && element.clientHeight < menuList.clientHeight && !menuList.style.width) {
        var size = (0, _scrollbarSize2.default)() + 'px';
        menuList.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = size;
        menuList.style.width = 'calc(100% + ' + size + ')';
      }

      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }
    }, _this.handleListKeyDown = function (event, key) {
      if (key === 'tab') {
        event.preventDefault();

        if (_this.props.onClose) {
          _this.props.onClose(event);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          MenuListProps = _props.MenuListProps,
          onEnter = _props.onEnter,
          _props$PaperProps = _props.PaperProps,
          PaperProps = _props$PaperProps === undefined ? {} : _props$PaperProps,
          PopoverClasses = _props.PopoverClasses,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'MenuListProps', 'onEnter', 'PaperProps', 'PopoverClasses', 'theme']);


      return _react2.default.createElement(
        _Popover2.default,
        (0, _extends3.default)({
          getContentAnchorEl: this.getContentAnchorEl,
          classes: PopoverClasses,
          onEnter: this.handleEnter,
          anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
          PaperProps: (0, _extends3.default)({}, PaperProps, {
            classes: (0, _extends3.default)({}, PaperProps.classes, {
              root: classes.paper
            })
          })
        }, other),
        _react2.default.createElement(
          _MenuList2.default,
          (0, _extends3.default)({
            role: 'menu',
            onKeyDown: this.handleListKeyDown
          }, MenuListProps, {
            ref: function ref(node) {
              _this2.menuList = node;
            }
          }),
          children
        )
      );
    }
  }]);
  return Menu;
}(_react2.default.Component);

Menu.propTypes =  false ? {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * Properties applied to the `MenuList` element.
   */
  MenuListProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the Menu enters.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the Menu exits.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the Menu has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the menu is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: _propTypes2.default.object,
  /**
   * `classes` property applied to the `Popover` element.
   */
  PopoverClasses: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Menu.defaultProps = {
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenu', withTheme: true })(Menu);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Popover = __webpack_require__(841);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Popover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = activeElement;

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function activeElement() {
  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();

  try {
    return doc.activeElement;
  } catch (e) {/* ie throws if no active element */}
}
module.exports = exports['default'];

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 *
 * Internal helper component to allow attaching a ref to a
 * child element that may not accept refs (functional component).
 */
var RefHolder = function (_React$Component) {
  (0, _inherits3.default)(RefHolder, _React$Component);

  function RefHolder() {
    (0, _classCallCheck3.default)(this, RefHolder);
    return (0, _possibleConstructorReturn3.default)(this, (RefHolder.__proto__ || (0, _getPrototypeOf2.default)(RefHolder)).apply(this, arguments));
  }

  (0, _createClass3.default)(RefHolder, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes =  false ? {
  children: _propTypes2.default.node
} : {};

exports.default = RefHolder;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Portal = __webpack_require__(843);

var _Portal2 = _interopRequireDefault(_Portal);

var _LegacyPortal = __webpack_require__(844);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reactDom2.default.createPortal ? _Portal2.default : _LegacyPortal2.default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _style = __webpack_require__(846);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(373);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(853);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(855);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findIndexOf(data, callback) {
  var idx = -1;
  data.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (item) {
    return item.modals.indexOf(modal) !== -1;
  });
}

function getPaddingRight(node) {
  return parseInt((0, _style2.default)(node, 'paddingRight') || 0, 10);
}

function setContainerStyle(data, container) {
  var style = { overflow: 'hidden' };

  // We are only interested in the actual `style` here because we will override it.
  data.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (data.overflowing) {
    var scrollbarSize = (0, _scrollbarSize2.default)();

    // Use computed style, here to get the real padding to add our scrollbar width.
    style.paddingRight = getPaddingRight(container) + scrollbarSize + 'px';

    // .mui-fixed is a global helper.
    var fixedNodes = document.querySelectorAll('.mui-fixed');
    for (var i = 0; i < fixedNodes.length; i += 1) {
      var paddingRight = getPaddingRight(fixedNodes[i]);
      data.prevPaddings.push(paddingRight);
      fixedNodes[i].style.paddingRight = paddingRight + scrollbarSize + 'px';
    }
  }

  (0, _keys2.default)(style).forEach(function (key) {
    container.style[key] = style[key];
  });
}

function removeContainerStyle(data, container) {
  (0, _keys2.default)(data.style).forEach(function (key) {
    container.style[key] = data.style[key];
  });

  var fixedNodes = document.querySelectorAll('.mui-fixed');
  for (var i = 0; i < fixedNodes.length; i += 1) {
    fixedNodes[i].style.paddingRight = data.prevPaddings[i] + 'px';
  }
}
/**
 * @ignore - do not document.
 *
 * Proper state managment for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class
 * Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$hideSiblingNodes = _ref.hideSiblingNodes,
      hideSiblingNodes = _ref$hideSiblingNodes === undefined ? true : _ref$hideSiblingNodes,
      _ref$handleContainerO = _ref.handleContainerOverflow,
      handleContainerOverflow = _ref$handleContainerO === undefined ? true : _ref$handleContainerO;

  (0, _classCallCheck3.default)(this, ModalManager);

  this.add = function (modal, container) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      overflowing: (0, _isOverflowing2.default)(container),
      prevPaddings: []
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return modalIdx;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);
    _this.modals.splice(modalIdx, 1);

    // If that was the last modal in a container, clean up the container.
    if (data.modals.length === 0) {
      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      // Otherwise make sure the next top modal is visible to a SR.
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }

    return modalIdx;
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  // this.modals[modalIdx] = modal
  this.modals = [];
  // this.containers[containerIdx] = container
  this.containers = [];
  // this.data[containerIdx] = {
  //   modals: [],
  // }
  this.data = [];
};

exports.default = ModalManager;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(847);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Fade = __webpack_require__(156);

var _Fade2 = _interopRequireDefault(_Fade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    zIndex: -1,
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    willChange: 'opacity',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  invisible: {
    backgroundColor: 'transparent'
  }
};

function Backdrop(props) {
  var classes = props.classes,
      invisible = props.invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'invisible', 'open', 'transitionDuration']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.invisible, invisible));

  return _react2.default.createElement(
    _Fade2.default,
    (0, _extends3.default)({ appear: true, 'in': open, timeout: transitionDuration }, other),
    _react2.default.createElement('div', { className: className, 'aria-hidden': 'true' })
  );
}

Backdrop.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is open.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Backdrop.defaultProps = {
  invisible: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBackdrop' })(Backdrop);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _contains = __webpack_require__(130);

var _contains2 = _interopRequireDefault(_contains);

var _activeElement = __webpack_require__(375);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _List = __webpack_require__(153);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent List

var MenuList = function (_React$Component) {
  (0, _inherits3.default)(MenuList, _React$Component);

  function MenuList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MenuList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuList.__proto__ || (0, _getPrototypeOf2.default)(MenuList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentTabIndex: undefined
    }, _this.list = undefined, _this.selectedItem = undefined, _this.blurTimer = undefined, _this.handleBlur = function (event) {
      _this.blurTimer = setTimeout(function () {
        if (_this.list) {
          var list = (0, _reactDom.findDOMNode)(_this.list);
          var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
          if (!(0, _contains2.default)(list, currentFocus)) {
            _this.resetTabIndex();
          }
        }
      }, 30);

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      var key = (0, _keycode2.default)(event);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));

      if ((key === 'up' || key === 'down') && (!currentFocus || currentFocus && !(0, _contains2.default)(list, currentFocus))) {
        if (_this.selectedItem) {
          (0, _reactDom.findDOMNode)(_this.selectedItem).focus();
        } else {
          list.firstChild.focus();
        }
      } else if (key === 'down') {
        event.preventDefault();
        if (currentFocus.nextElementSibling) {
          currentFocus.nextElementSibling.focus();
        }
      } else if (key === 'up') {
        event.preventDefault();
        if (currentFocus.previousElementSibling) {
          currentFocus.previousElementSibling.focus();
        }
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(event, key);
      }
    }, _this.handleItemFocus = function (event) {
      var list = (0, _reactDom.findDOMNode)(_this.list);
      if (list) {
        for (var i = 0; i < list.children.length; i += 1) {
          if (list.children[i] === event.currentTarget) {
            _this.setTabIndex(i);
            break;
          }
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MenuList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.resetTabIndex();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: 'setTabIndex',
    value: function setTabIndex(index) {
      this.setState({ currentTabIndex: index });
    }
  }, {
    key: 'focus',
    value: function focus() {
      var currentTabIndex = this.state.currentTabIndex;

      var list = (0, _reactDom.findDOMNode)(this.list);
      if (!list || !list.children || !list.firstChild) {
        return;
      }

      if (currentTabIndex && currentTabIndex >= 0) {
        list.children[currentTabIndex].focus();
      } else {
        list.firstChild.focus();
      }
    }
  }, {
    key: 'resetTabIndex',
    value: function resetTabIndex() {
      var list = (0, _reactDom.findDOMNode)(this.list);
      var currentFocus = (0, _activeElement2.default)((0, _ownerDocument2.default)(list));
      var items = [].concat((0, _toConsumableArray3.default)(list.children));
      var currentFocusIndex = items.indexOf(currentFocus);

      if (currentFocusIndex !== -1) {
        return this.setTabIndex(currentFocusIndex);
      }

      if (this.selectedItem) {
        return this.setTabIndex(items.indexOf((0, _reactDom.findDOMNode)(this.selectedItem)));
      }

      return this.setTabIndex(0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onBlur = _props.onBlur,
          onKeyDown = _props.onKeyDown,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onBlur', 'onKeyDown']);


      return _react2.default.createElement(
        _List2.default,
        (0, _extends3.default)({
          role: 'menu',
          ref: function ref(node) {
            _this2.list = node;
          },
          className: className,
          onKeyDown: this.handleKeyDown,
          onBlur: this.handleBlur
        }, other),
        _react2.default.Children.map(children, function (child, index) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            tabIndex: index === _this2.state.currentTabIndex ? 0 : -1,
            ref: child.props.selected ? function (node) {
              _this2.selectedItem = node;
            } : undefined,
            onFocus: _this2.handleItemFocus
          });
        })
      );
    }
  }]);
  return MenuList;
}(_react2.default.Component);

MenuList.propTypes =  false ? {
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func
} : {};

exports.default = MenuList;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Snackbar = __webpack_require__(858);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Snackbar).default;
  }
});

var _SnackbarContent = __webpack_require__(383);

Object.defineProperty(exports, 'SnackbarContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SnackbarContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

var _colorManipulator = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var _root;

  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);

  return {
    root: (_root = {
      pointerEvents: 'initial',
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px ' + theme.spacing.unit * 3 + 'px'
    }, (0, _defineProperty3.default)(_root, theme.breakpoints.up('md'), {
      minWidth: 288,
      maxWidth: 568,
      borderRadius: 2
    }), (0, _defineProperty3.default)(_root, theme.breakpoints.down('sm'), {
      flexGrow: 1
    }), _root),
    message: {
      padding: theme.spacing.unit + 'px 0'
    },
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: theme.spacing.unit * 3,
      marginRight: -theme.spacing.unit
    }
  };
}; // @inheritedComponent Paper

function SnackbarContent(props) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'classes', 'className', 'message']);


  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({
      component: _Typography2.default,
      headlineMapping: {
        body1: 'div'
      },
      role: 'alertdialog',
      square: true,
      elevation: 6,
      className: (0, _classnames2.default)(classes.root, className)
    }, other),
    _react2.default.createElement(
      'div',
      { className: classes.message },
      message
    ),
    action ? _react2.default.createElement(
      'div',
      { className: classes.action },
      action
    ) : null
  );
}

SnackbarContent.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The message to display.
   */
  message: _propTypes2.default.node
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSnackbarContent' })(SnackbarContent);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return schools; });
var schools=["เทศบาล 3 (ชาญวิทยา)","บ้านกุดชุมแสง","ราชประชานุเคราะห์ 50","ภูดินแดงวิทยา","ชะแล้นิมิตวิทยา","กมล-เรียม สุโกศล (บ้านผาใต้)","กมลศิลป์สามัคคี"," กรป.กลางอุปถัมภ์","กระจายสุทธิธรรมโมอนุสรณ์ฯ","กระดิ่งทอง","กระทุ่มราย (วิบูลย์วิทยาคม)","กระเทียมวิทยา","กระบุรี","กระแสพัฒนา","กระแสสินธุ์วิทยา","กรับใหญ่ว่องกุศลกิจพิทยาคม","กรุงไทย","กฤษณา","กฤษณาวิทยา","กลับเพชรศึกษา","กลางคลอง 27","กลางคลองสิบ","กลางดงราษฎร์อุปถัมภ์","กลางหมื่นสงเคราะห์","กลาโหมราชเสนา","กลาโหมราชเสนา 2","กลาโหมอุทิศ","กวางโจนศึกษา","กองทัพบกอุทิศบ้านดอนยาง","กองทัพบกอุทิศบ้านหนองไผ่","กองทัพบกอุทิศบ้านใหม่ไทยถาวร","กองทัพบกอุปถัมภ์","กองบินอุบลสงเคราะห์","ก้องอุดมวิทยาคาร","ก้อนแก้วราษฎร์บำรุง","กอบกาญจน์ศึกษามูลนิธิ","กอรวกพิทยาสรรค์","กะทู้วิทยา","กะปง","กะปงพิทยาคม","กะพี้ดอนขวางวิทยา","กันกงบ้านลี่สามัคคี","กันเกราพิทยาคม","กันตังรัษฎาศึกษา","กันทรลักษ์วิทยา","กันทราราม (นุ่นศึกษาคาร)","กัลยาณวัตร","กัลยาณิวัฒนา 1","กัลยาณิวัฒนา 2","เตรียมอุดมศึกษาพัฒนาการ สุราษฎร์ธานี","กาญจนวัฒน์วิทยา","กาญจนาภิเษกวิทยาลัย อุทัยธานี","กาญจนาภิเษกวิทยาลัย ฉะเชิงเทรา","กานดา","กาบเชิงมิตรภาพที่ 190","การเคหะท่าทราย","การไฟฟ้าส่วนภูมิภาคสงเคราะห์ 3 (บ้านใหม่เกษม)","การุญวิทยา","ก้าวหน้าสามัคคีคำงูเหลือม","กาวิละวิทยาลัย","กาฬสินธุ์พิทยาสัย","กำแพงดินพิทยาคม","อนุบาลกำแพงแสน","บ้านกำแมดคำเจริญ","กิ่งเพชร","กิตติคุณ","กิตติญาณอุปถัมภ์","กิตติพิทยา","กิตติวิทย์บ้านพรุ","กิริวัฒนศักดิ์","กิ่วประชาวิทยา","กิ่วแลน้อยประสิทธิ์วิทยา","กุฉินารายณ์","กุญแจคริสเตียนวิทยา","บ้านกุดกระหนวน","กุดกว้างสวาสดิ์วิทยา","กุดเก่าน้อยบำรุงวิทย์","กุดขอนแก่นท่าเกษม","กุดเข้ห้วยบงวิทยานุกูล","กุดครองวิทยาคาร","กุดค้าวเทพพิทยา","กุดฆ้องชัยวิทยา","กุดจิกวิทยา","กุดจิกวิทยาคาร","กุดฉิมวิทยาคม","เทศบาล 1 กุดชุมคุรุราษฎร์บำรุง","อนุบาลกุดชุมพัฒนา (ศรีวิสารรังสรรค์)","กุดดู่พิทยาคม","กุดตอแก่นราษฎร์วิทยา","กุดตาดำ (คงฤทธิ์คุรุราษฎร์สามัคคี)","กุดตุ้มสามัคคีวิทยา","กุดบากราษฎร์บำรุง","กุดปลาค้าวราษฎร์บำรุง","กุดไผทประชาสรรค์","กุดยม (คุรุราษฎร์ไตรมิตร)","บ้านกุดลิงง้อหนองแก","กุดลิงวิทยาคม","กุดเวียนวิทย์ผดุง","กุดสิมวิทยาสาร","กุดหว้าวิทยา","กุดแห่วิทยา","กุดอ้อประชานุสรณ์","กุดอ้อสุขสวัสดิ์วิทยา","กุตาไก้วิทยาคม","กุลโน","กุลวรรณศึกษา","กุลศิริศาสน์","กุสุมาลย์วิทยาคม","กู่สว่างสามัคคี","เกล็ดแก้ว","เกษตรนาสมหวังสามัคคี","เกษตรประชาตาทวด","เกษตรศิลปวิทยา","เกษตรสุขราษฎร์บำรุง","เกษตรอิสานสามัคคี","เกษมบ้านนาคำ","เกษมพิทยา","เก่าน้อยโนนรังวิทยาเสริม","เกาะแก้วพิศดาร","เกาะแก้วสามัคคี","เกาะคาวิทยาคม","เกาะเคี่ยม","บ้านเกาะนาคา","เกาะปันหยี","เกาะมะพร้าว","เกาะไม้ไผ่","เกาะยาว","เกาะสิเหร่","เกาะหมากน้อย","เกาะโหลน","เกียรติคุณวิทยา","เกียรติประชา","เกียรติวัธนเวคิน 1 (วัดปากบาง)","เกียรติวัธนเวคิน 2 (วัดปลักเขว้า)","แก้งคำประชาสามัคคี","แก่งนาขามสามัคคี","แก้งนางราษฎร์บำรุง","แก่งบ้านยางป่าคาย","บ้านหนองสนมพะลาน","แก่งพฤๅชัยวิทยา","แกดำวิทยาคาร","แก่นเท่าพัฒนศึกษา","แก่นนครวิทยาลัย","แกน้อยศึกษา","แกเปะราษฎร์นิยม","แก้วอินทร์สุธาอุทิศ","โกมลวิทยาคาร","โกรกพระ","ไกรราษฎร์วิทยา","ขจรทรัพย์อํารุง","ขจรเนติยุทธ","ขนงพระใต้","ขนอมพิทยา","ขนาดมอญพิทยาคม","ขมิ้นราษฎร์สงเคราะห์","บ้านน้ำครกใหม่","ขลุงรัชดาภิเษก","ขวาววิทยาคาร","ขอนแก่นวิทยายน","ขอนแก่นวิทยาลัย","ขอนแก่นวิทยาเสริม","ขามแก่นนคร","ขามเตี้ยพิทยาคม","ขามเปี้ยบ้านศรีสุข","ขามสงเคราะห์","ข้าวหลามชัยศรีดอนยางวิทยา","ขุขันธ์วิทยา","ขุนตาลวิทยาคม","ขุนทะเลวิทยาคม","ขุนยวม","ขุนห้วยตากพัฒนาศึกษา","ขุนห้วยบ้านรุ่ง","ขุหลุ (ประชาวิทยาคาร)","เขตการทางสงเคราะห์ 5 (ไตรคามสิทธิศิลป์)","เขมพิทยา","เขมราฐ","เขวาชีรัฐประชาสรรค์","เขว้าศึกษา","ห้วยขาแข้งวิทยาคม","เขาดินพิทยารักษ์","เขาดินวิทยาคาร","เขาทอง","เขาพระทอง","เขาพังไกร","เขาเพิ่มนารีผลวิทยา","เขาไร่ศรีราชา","เขาวงพระจันทร์","เขาสระนางสรง","เขาสามยอด","เขาสิงโต","เขาหินกราวประชาสรรค์","เขื่องใน (เจริญราษฎร์)","เขื่อนกระพี้ศึกษา","เขื่อนเจ้าพระยา","เขื่อนน้ำพุง","เขื่อนบางลาง","เขื่อนเพชร (ชลประทานสงเคราะห์)","เขื่อนภูมิพล","คงชัยสิทธิ์วิทยา","คงรักษ์ประชานุเคราะห์","คชเวกวิทยา","คณะเทศบาลนครกรุงเทพ 3","ลำพะยาประชานุเคราะห์","คมเพชรวิทยาคาร","ครบุรีวิทยา","ครุราษฎร์รังสรรค์","คลอง11 ศาลาครุ (เที้ยมอุปถัมภ์)","คลองกระแชงเตย","คลองกระทุ่มราษฎร์อุทิศ (ทดสอบแก้ไข)","คลองกลันตัน (มีสุวรรณอนุสรณ์)","คลองกันยา","คลองเกลือ","คลองขวาง","คลองจิก (สุขสินนุเคราะห์)","คลองเจริญราษฎร์","คลองแจ้งวิทยา","คลองตาจ่า (คงจีบอุทิศ)","คลองตาเอี่ยม","คลองทวีวัฒนา (ทองน่วมอนุสรณ์)","คลองท่อมมิตรภาพที่ 160","คลองทางหลวง","คลองไทรวิทยาสิทธิ์","คลองนาเกลือน้อย (กลิ่นอยู่อุปถัมภ์)","คลองบางกระทึก","คลองบางกระบือ","คลองบางกะสี","คลองบางกะอี่","คลองบางแก้ว","คลองบางน้ำจืด","คลองบางปู","คลองบางโพธิ์","คลองบ้านพร้าว","คลองบ้านระกาศ","คลองปลัดเปรียง","คลองแปดประชาสรรค์","คลองพน","คลองพระยานาคราช","คลองพระอุดม","คลองพานทอง","คลองมหาวงก์","คลองมะขามเทศ","คลองยางนุสรณ์","คลองโยงเวทีอุปถัมภ์","คลองลากค้อน","คลองลาดกระบัง","คลองลาดช้าง","คลองวัดไร่","คลองสระ (สภาวิทยาอุทิศ)","คลองสอง (เสวตสมบูรณ์อุปถัมภ์)","คลองสองพี่น้อง (ใจดีอุปถัมภ์)","คลองสะบัดจาก","คลองสำโรง","คลองสิบสาม ","คลองเสาธง (ถนอม วารีดีนุเคราะห์)","คลองหนึ่ง (แก้วนิมิตร)","คล่องหมื่นเพชรอนุสรณ์ ค่ายวชิราลงกรณ์อุปถัมภ์","คลองหลุมลึก","คลองห้า (พฤกษชัฏราษฏร์บำรุง)","คลองใหญ่วิทยา","คลองใหม่","คล้ายสอนศึกษา","ควนเกยสุทธิวิทยา","ควนสุบรรณ","ค้อจารย์วิทยา","คอตัน","คอตันคลอง 27","คอนเรียบอนุกูล","ค้อวิทยาคม","คันนายาว (ธารินเจริญสงเคราะห์)","ค่ายธนะรัชต์","ค่ายบกหวานโพนตาลวิทยา","ค่ายบางระจัน","ค่ายประจักษ์ศิลปาคม","ค่ายลูกเสือนิคมลำปาว","ค่ายลูกเสือบ้านโป่ง","ค่ายลูกเสืออำเภอสวี","คำกุงประชานุกูล","คำขามวิทยา","คำเขื่อนแก้ว","คำค้อพิทยศึกษา","คำคาราษฎร์บำรุง","คำแคนราษฎร์วิทยาและบ้านโนนสะอาด","คำแคนวิทยา","คำเจริญวิทยา","คำชมภูท่าเรือสมบูรณ์วิทย์","คำเตยอุปถัมภ์","คำเที่ยงอนุสสรณ์","คำนางตุ้มโนนสวรรค์","บ้านคำบกราษฎร์นุกูล","คำบงพิทยาคม","คำบอนวิทยา","คำบอนวิทยาสรรพ์","คำประถมนิคมสงเคราะห์","คำปลาฝาโนนชัย","คำไผ่สงเคราะห์","คำพระโคกก่งวิทยา","คำเพิ่มพิทยา","คำโพนคำม่วงวิทยา","คำโพนทองบริบูรณ์ราษฎร์บำรุง","คำโพนทองราษฎร์นิยม","คำม่วงจรัสวิทย์","คำมะโค้งหนองแฝก","คำมะเบื่อแสงเพชร","คำมันปลาผดุงวิทย์","คำเม็กวิทยา","คำเมยราษฎร์พัฒนา","คำเมยวิทยาคม","บ้านคำแมดพิทยาสรรพ์","คำยิ่งหมีมณีเวทย์","คำลือชาศรีสวัสดิ์วิทยา","คำสร้อยพิทยาสรรค์","คำสายทองวิทยา","คำหมุนผดุงเวทย์","คำหุ่งราษฎร์บำรุง","คำเหมือดแก้วบำเพ็ญวิทยา","คำใหญ่ปันน้ำใจ","คำใหญ่วิทยา","คำโองวิทยา","คำไฮพิทยาคม","คำไฮวิทยา","คีรีบูรวัฒนา (ตีบุ)","คีรีรัฐนิคม","คีรีราษฎร์รังสฤษดิ์","คีรีวงศ์วัฒนา","คีรีวัฒนา","คีรีศรีสาครวิทยา","คุระบุรี","คุรุชนประสิทธิ์ศิลป์","คุรุชนพัฒนา","คุรุประชาชนูทิศ (วันครู 2504)","คุรุประชานุกูล","คุรุประชาสรรค์","คุรุประชาสรรค์ศึกษา","คุรุราษฎร์วิทยา","คุรุราษฎร์สามัคคี","คุรุศิษย์วิทยา","คุรุสภา","คูเตยราษฎร์สามัคคี","คู้สลอด 2 (ชมแช่มวิทย์อุปถัมภ์)","เค็งใหญ่หนองงูเหลือม","เคหะทุ่งสองห้องวิทยา 1","เคหะบางพลี (10 ปี สปช.)","เคหะประชาสามัคคี","เคียงศิริ","เคียงศิริบ้านโพธิ์ทอง","โคกกลางราษฎร์พัฒนา","โคกกลางราษฎร์พิทักษ์","โคกกลางวิทยา","โคกกลางสมเด็จ","บ้านโคกกลางหนองไหลพิทยาสรรพ์","โคกกลางเหนือพิทยาสรรพ์","โคกก่องราษฎร์นุกูล","โคกก่องวิทยา","โคกคอนวิทยานุกูล","โคกค่ายโคกใหญ่วิทยา","โคกคำวิทยา","โคกเครือวิทยา","โคกงามวิทยาคาร","โคกเจริญวิทยา","โคกชาดกลางท่าโพธิ์","โคกตาพรหม","โคกนางามสามัคคี","โคกนาดี","โคกน้ำเกลี้ยงวิทยาคม","โคกประสิทธิ์วิทยา","โคกเพชรวิทยาคาร","โคกโพธิ์ไชยศึกษา","โคกโพธิ์วิทยา","โคกม่วงประชาสรรค์","โคกม่วงศึกษา","โคกมะขามจั่นเสือสามัคคี","โคกมะลิวิทยา","โคกเมยประชาพัฒนา","โคกยอ","โคกเริงรมย์ศิลปาคาร","โคกล่ามผดุงวิทย์","โคกล่ามวิทยา","โคกล่ามวิทยาคาร","โคกลำพานวิทยา","โคกเลาะวิทยาคาร","โคกวังวนวิทยา","โคกศรีวิทยายน","โคกศรีหนองคลอง","โคกสว่างหาญไพรวัลย์","โคกสะอาดศึกษา","โคกสำราญราษฎร์อำนวย","โคกสำราญวิทยา","โคกสำโรง","โคกสีพิทยาสรรพ์","โคกสูงกุดน้ำใส","โคกสูงราษฎร์สามัคคี","โคกสูงสว่าง (ราษฎร์บูรณะ)","โคกสูงสำราญ","โคกสูงใหญ่วิทยา","โคกหวายราษฎร์สามัคคี","โคกใหญ่ประชารัฐวิทยา","โค้งน้ำตับวิทยาคาร","โค้งบ้านใหม่","โครงการหลวงแกน้อย","ไค้นุ่นวิทยาพูน","โฆวินทะ","โฆสิตสโมสร","งิ้วด่อนราษฎร์สามัคคีบำรุง","จงกลกิตติขจรวิทยา","จตุคามประชาสรรค์","จตุคามพิทยาคม","จตุคามราษฎร์วิทยา","จตุคามวิทยา","จตุคามวิทยาคม","จตุคามสามัคคีวิทยา","จตุรคามพัฒนา","จตุรคามรังสรรค์","จตุรคามสามัคคี","จตุรพักตรพิมาน","จตุรมิตรบ้านไผ่","จตุรมิตรวิทยา","จตุราษฎร์ศึกษา","จตุวัฎมหาราชานุสรณ์","จระเข้วิทยายน","จรัสพิชากร","จรัสวิทยาคาร (มิตรภาพที่ 57)","จริมอนุสรณ์ 2","จริมอนุสรณ์ 1","จรูญกิมลี้กิจจาทรอนุสรณ์","จรูญศรีวิทยาประชานุกูล","จอมแก้ววิทยา","จอมจันทร์วิทยาคาร","จอมทองวิทยา","จอมมณี","จักรพงษ์บ้านห้วยเทียน","จักราชราษฎร์สามัคคี","จัดสรรที่ดินสงเคราะห์","จัตุรัสวิทยานุกูล","จันจว้าวิทยาคม","จันทคามวิทยา","จันทร์เจริญ","จันทร์ทองเอี่ยม","จันทราพระกิตติคุณ","จันทราราม","จันทราราษฎร์","จันทราวาส (คุรุราษฎร์วิทยา)","จ่าการบุญ","จารย์ตำรา","จารุศรบํารุง","จํารูญเนติศาสตร์","จำรูญชัยพฤกษ์ราษฎร์วิทยา","จำไฮบ้านเหล่า","จิตประชาราษฎร์","จินดาพงศ์","จินดาวิทยาคาร 2 (บ้านหนองศาลา)","จินดาวิทยาคาร 3","จินดาสินธวานนท์","จินดาอารมณ์","ปัญญาวิทย์","จิระศาสตร์วิทยา","จุกเสม็ด","จุมจังนาคำชลประทานวิทยา","จุมจังพลังราษฎร์","จุมจังอุปกรณ์เจริญเวทย์","จุฬางกูรวิทยา","จุฬาภรณ์พิชญาคาร","จุฬาภรณราชวิทยาลัย มุกดาหาร","จุฬาราษฎร์วิทยา","เจ.ซี.บ้านอินทร์แปลง","เจ.ซี.โคราชอนุสรณ์ 1","เจดีย์หลวงพิทยา","เจริญใจ","เจริญดีวิทยา","ทุ่งเจริญพัฒนา","เจริญรัชต์ภาคย์","เจริญรัฐอุปถัมภ์","เจริญราษฎร์อุปถัมภ์","เจริญราษฎร์วิทยา","เจริญวิทยา","เจริญเวชวิทยา","เจริญศรีศึกษา","เจริญศึกษา","เจริญสุขอุดมวิทยา","เจ้าพ่อหลวงอุปถัมภ์ 10","เจ้าพ่อหลวงอุปถัมภ์ 5","เจ้าพ่อหลวงอุปถัมภ์ 9","เจ้าฟ้าสร้าง","เจ้าแม่หลวงอุปถัมภ์ 2","เจียงทองพิทยาคม","เจียรวนนท์อุทิศ 1","เจียรวนนท์อุทิศ 2","เจียรวนนท์อุทิศ 3","เจียรวนนท์อุทิศ 4","แจ้คอนวิทยา","แจ้ซ้อนวิทยา","แจนแลนวิทยา","แจ้ห่มวิทยา","บ้านโจ้โก้ และบ้านโจ้โก้ สาขาห้วยสา","ใจประสงค์ศึกษา","ฉวาง","ฉัตรทิพย์เทพวิทยา","ฉันทนาวัณรถ","ฉิมพลีมา","ฉิมพลีวิทยา","เฉลิมช่วงวิทยาทาน","เฉลิมพระเกียรติ 60 พรรษา สมเด็จพระนางเจ้าสิริกิติ์พระบรมราชินีนาถ","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ศรีสะเกษ","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ กาญจนบุรี","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ หนองบัวลำภู ในพระราชูปถัมภ์สมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี","เฉลิมมณีฉายวิทยาคาร","ตาดหมอกวิทยา"," ชด.ศึกษาสงเคราะห์ 1","ชนแดนวิทยาคม","ชนบทศึกษา","ชนะใช้กิจการ","ชนม์พัฒนา","ชลนายกสงเคราะห์","ชลบุรี “สุขบท”","ชลประทานแก่งกระจาน","ชลประทานเขื่อนแม่กวงจิราธิวัฒน์อุปถัมภ์","ชลประทานนาตลิ่งชัน","ชลประทานบ้านกอโจด","ชลประทานปราณบุรี และชลประทานปราณบุรี สาขาบ้านวังปลา","ชลประทานผาแตก (ปัญญาพลอุปถัมภ์)","ชลประทานสงเคราะห์","ชลประทานอนุเคราะห์","ช่องกุ่มวิทยา","ช่องแมวพิทยา","ช่องลมจันทิมาประชาพิทักษ์","ช่องสาริกา","ชัยเกษมวิทยา","ชัยชุมพลวิทยา","ชัยชุมภู","ช่างกลอนุสรณ์ 3 (บ้านหนองหวาย)","ชาตรีวิทยา","ชาติเฉลิม","ชาติตระการโกศล","ชาติวิทยา","ชานุมานวิทยาคม","ชายเขาวิทยา","ชายแดนประชาสรรค์","ชายแดนอนุสรณ์","ชายนาพัฒนา (สำเนียง สนิทอุปถัมภ์)","ชายพะเนาหนองโพธิ์","ชาวไทยใหม่ (โดม-ทักษิณอนุสรณ์)","ชาวไร่","ชินวงศ์อุปถัมภ์","ชีโนวาทธำรง","ชีพอนุสรณ์","ชุณหะวัณ","ชุนชนอาจสามารถ","ชุบศร (ร.31 พัน.1 รอ.อุปภัมภ์)","ชุมชน 1 วัดสะกัดน้ำมัน","ชุมชน 12 ท่าตาลประชาสฤษฏ์","ชุมชน 15 บ้านเนินสว่าง","ชุมชน 17 บ้านนาตาดี","ชุมชน 2 บ้านกกไม้แดง","ชุมชน 3 บ้านเนินกุ่ม (ประชานุกูล)","ชุมชน 8 ราษฎร์อุทิศพิทยา","ชุมชนกระนวน","ชุมชนกลางแก้งส้มป่อย","ชุมชนกิ่วแลหลวงประสิทธิ์วิทยา","ชุมชนกุงเก่าราษฎร์ประสิทธิ์","ชุมชนกุดค้า","ชุมชนกุดโดนวิทยาคม","ชุมชนกุดบอดวิทยาเสริม","ชุมชนกุดหมากไฟ","ชุมชนแก้งคำวิทยา","ชุมชนไกรลาศวิทยาคม","ชุมชนบ้านข่วงเปาเหนือ","ชุมชนขัวสูงสวรรค์","อนุบาลเขาสวนกวาง","ชุมชนคงวิทยา","ชุมชนคลองจันทน์","ชุมชนควนดินแดง ม.173","ชุมชนคำตานาหนองกุง","ชุมชนโคกม่วงเผอิญศรีภูธรอุปภัมภ์","ชุมชนโคกสารวิทยา","ชุมชนจระเข้หิน (สังฆ์คุรุประชาฯ)","จรูญลองรัตนาคาร","ชุมชนจำปี","ชุมชนแจนแลนราษฎร์บำรุง","ชุมชนชลประทานรังสรรค์","ชุมชนชวนวิทยา","ชุมชนชุมแพ","ชุมชนเชียงเครือราษฎร์รังสรรค์","ชุมชนเชียงใหม่พัฒนา","ชุมชนดงแคนใหญ่","ชุมชนดงม่วงไข่","ชุมชนดงมะไฟเจริญศิลป์","ชุมชนดงเย็น","ชุมชนดอนตาล","ชุมชนดอนไพล","ชุมชนดอนยูงวิทยายน","ชุมชนด่านวิทยา","ชุมชนดิฏฐอำรุง","ชุมชนต่อแพวิทยา","ชุมชนตำบลหินปัก","ชุมชนไตรคามราษฎร์บำรุง","ชุมชนทมป่าข่า","ชุมชนทะนงบ้านไร่","ชุมชนที่ 11 วัดสุวรรณประดิษฐ์","ชุมชนที่ 14 วัดดอนทอง","ชุมชนเทศบาล ๓ (พินิจพิทยานุสรณ์)","ชุมชนเทศบาลวัดศรีดอนไชย","ชุมชนแท่นประจัน","ชุมชนนาคำไฮวิทยา","ชุมชนนางัว","ชุมชนนาจารย์วิทยา","ชุมชนนาเต่าสุขสวรรค์ (ประชาราษฎร์ 347)","ชุมชนนาทมโคกก่อง","ชุมชนนามนวิทยาคาร","ชุมชนนามะเขือวิทยา","ชุมชนนาเรียงวิทยาคม","ชุมชนนาสีนวล","ชุมชนน้ำเกลี้ยงกล่อมวิทยา","ชุมชนน้ำอ้อม","ชุมชนนิคมทับกวางสงเคราะห์ 1","ชุมชนนิคมสร้างตนเองเชียงพิณ 2","ชุมชนนิคมสร้างตนเองเทพา","ชุมชนนิรมัย","ชุมชนโนนแดง","ชุมชนโนนสมบูรณ์","ชุมชนโนนสูง","ชุมชนโนนแสนสุข","ชุมชนโนนหอมไผ่ล้อม","ชุมชนโนนหันวันครู","ชุมชนบงเหนือ","ชุมชนบดมาดพอกน้อย","ชุมชนบริษัทน้ำตาลตะวันออก","ชุมชนบ่อแสนพันมิตรภาพที่211","ชุมชนบัวคำ","ชุมชนบัวบานสามัคคี","ชุมชนบางทรายใหญ่","ชุมชนบ้านกระดานหน้าแกล","ชุมชนบ้านกระเดื่อง (โศภณประชานุกูล)","ชุมชนบ้านกรือเซะ","ชุมชนบ้านกลับ (สราญราษฎร์)","ชุมชนบ้านกลาง (สนิทวิทยาการ)","ชุมชนบ้านกลางนาโน","ชุมชนบ้านกะมิยอ","ชุมชนบ้านกำเนิดเพชร","ชุมชนบ้านกำแพงดิน","ชุมชนบ้านกำแมด","ชุมชนบ้านกุดดู่","ชุมชนบ้านกุดปลาดุก","ชุมชนบ้านกุดเป่ง","ชุมชนบ้านกุดม่วง","ชุมชนบ้านกุดไห","ชุมชนบ้านกู่ (ป่าเป้าประชานุเคราะห์)","ชุมชนบ้านกู่จาน","กู่สันตรัตน์","ชุมชนบ้านเกาะสมอ (สามัคคีวิทยา)","ชุมชนบ้านแก่ง (ไกรสรพงษ์สงเคราะห์)","ชุมชนบ้านแก้งคร้อหนองไผ่","ชุมชนบ้านแก่งเสือเต้น","ชุมชนบ้านขวาว","ชุมชนบ้านขอนขว้าง","ชุมชนบ้านขามธาตุวิทยา","ชุมชนบ้านขามป้อม","ชุมชนบ้านข้าวปุ้น (ศาสนานุเคราะห์)","ชุมชนบ้านเขากลม","ชุมชนบ้านเขาแก้ว","ชุมชนบ้านเขาใบไม้","ชุมชนบ้านเขาลูกช้าง","ชุมชนบ้านเขาสมิงและสาขาวัดลำภูราย","ชุมชนบ้านเขาหลาง","ชุมชนบ้านคณฑี (ประสิทธิ์อุปถัมภ์)","ชุมชนบ้านคลองเคียน (ประชาสามัคคี)","ชุมชนบ้านคลองพลู","ชุมชนบ้านคลองยาง","ชุมชนบ้านคลองลาน","ชุมชนบ้านคลองเหมือง","ชุมชนบ้านควนปริง","ชุมชนบ้านคาย","ชุมชนบ้านคำชะอี","ชุมชนบ้านคำพระ","ชุมชนบ้านคำพอกท่าดอกแก้ว","ชุมชนบ้านคุริง (มิตรภาพที่ 25)","ชุมชนบ้านโคก","ชุมชนบ้านโคกกลางมิตรภาพที่ 84","ชุมชนบ้านโคกค่าย","ชุมชนบ้านโคกทม (พิศิษฐ์พิทยาคาร)","ชุมชนบ้านโคกปรง","ชุมชนบ้านโคกยาว","ชุมชนบ้านโคกล่าม","ชุมชนบ้านโคกว่าน","ชุมชนบ้านโคกสวาย","ชุมชนบ้านโคกสะอาด","ชุมชนบ้านโคกสี","ชุมชนบ้านโคกหม้อ","ชุมชนบ้านโคกอุดม","ชุมชนบ้านโค้งไผ่","ชุมชนบ้านโคน","ชุมชนบ้านงัวบา","ชุมชนบ้านจอก (คอนสวรรค์วิทยากร)","ชุมชนบ้านจะโหนงมิตรภาพที่ 222","ชุมชนบ้านจัววิทยา","ชุมชนบ้านจิกดู่","ชุมชนบ้านเจดีย์","ชุมชนบ้านเจียด","ชุมชนบ้านชนบท","ชุมชนบ้านชมสะอาด","ชุมชนบ้านช่องแสมสาร","ชุมชนบ้านช่อระกา","ชุมชนบ้านชัยบาดาล","ชุมชนบ้านช่างเคิ่ง","ชุมชนบ้านชาด","ชุมชนบ้านชุมช้าง","ชุมชนบ้านชุมพล","ชุมชนบ้านเชียงกลม","ชุมชนบ้านเชียงแก้ว","ชุมชนบ้านเชียงบาน","ชุมชนบ้านเชียงเพ็ง","ชุมชนบ้านไชยบุรี","ชุมชนบ้านซากอ","ชุมชนบ้านซาง","ชุมชนบ้านซาด","ชุมชนบ้านเซเป็ด","ชุมชนบ้านแซร์ออ","ชุมชนบ้านดง","ชุมชนบ้านดงเค็ง","ชุมชนบ้านดงบัง","ชุมชนบ้านดอนจิก (จรรยาราษฎร์)","ชุมชนบ้านดอนตัน","ชุมชนบ้านดอนนางงาม","บ้านดอนผึ้ง","ชุมชนบ้านดอนมนต์","ชุมชนบ้านดอนมูล","ชุมชนบ้านดอนโม่","ชุมชนบ้านดอนหัน","ชุมชนบ้านดอนใหญ่-บูรพา","ชุมชนบ้านดอนอะราง","ชุมชนบ้านด่าน","ชุมชนบ้านด่านจาก","อนุบาลด่านซ้าย","ชุมชนบ้านดุง","ชุมชนบ้านดู่ใต้","ชุมชนบ้านต้นสน","ชุมชนบ้านตลาดทุ่งเหียง","ชุมชนบ้านตลาดน้อย (ประชานุกูล)","ชุมชนบ้านตะขบ","ชุมชนบ้านตะลุโบะ","ชุมชนบ้านตากแว้ง","ชุมชนบ้านตาแกะ","ชุมชนบ้านต้าตลาด","ชุมชนบ้านตาหลังใน","ชุมชนบ้านติ้ว","ชุมชนบ้านตุ้มท่า","ชุมชนบ้านตูม","ชุมชนบ้านตูมวิทยาคาร","ชุมชนบ้านโต้นศรีพิมลวิทยา","ชุมชนบ้านใต้","ชุมชนบ้านถ่อน","ชุมชนบ้านถ้ำสิงห์","ชุมชนบ้านทราย","ชุมชนบ้านทรายขาว","ชุมชนบ้านทะเลทรัพย์","ชุมชนบ้านทับสวาย","ชุมชนบ้านท่ากระดาน","ชุมชนบ้านท่าข้าม","ชุมชนบ้านทางควาย","ชุมชนบ้านท่างาม","ชุมชนบ้านท่าบ่อแบง","ชุมชนบ้านท่าพระ","ชุมชนบ้านท่าศิลา","ชุมชนบ้านท่าสองยาง","ชุมชนบ้านท่าเสา","ชุมชนบ้านท่าแหน","ชุมชนบ้านทุ่ง","ชุมชนบ้านทุ่งคล้า","ชุมชนบ้านทุ่งช้าง","ชุมชนบ้านทุ่งตาลเลียน","ชุมชนบ้านทุ่งน้อย ","ชุมชนบ้านทุ่งนา","ชุมชนบ้านทุ่งนางาม","ชุมชนบ้านทุ่งป่าแดด","ชุมชนบ้านทุ่งแฝก","ชุมชนบ้านทุ่งโพธิ์","ชุมชนบ้านทุ่งศรี (ราษฎร์รังสฤษฎ์)","ชุมชนบ้านทุ่งสงบ","ชุมชนบ้านไทรย้อย","ชุมชนบ้านไทรห้อง","ชุมชนบ้านธาตุ","ชุมชนบ้านนากล่ำ","ชุมชนบ้านนากอก","ชุมชนบ้านนากอกหนองบก","ชุมชนบ้านนากัน","ชุมชนบ้านนาคา","ชุมชนบ้านนางกำ","ชุมชนบ้านนาด้วง","ชุมชนบ้านนาดีหนองไผ่","ชุมชนบ้านนาทะนุง","ชุมชนบ้านนาทับ","ชุมชนบ้านนาบอน","ชุมชนบ้านนาพึง","ชุมชนบ้านนาแพง","ชุมชนบ้านนาโพธิ์","ชุมชนบ้านนาโพธิ์ (ต.ม.ธ.ก. รุ่น 7 อนุสรณ์)","ชุมชนบ้านนาเยีย","ชุมชนบ้านนารากอรพิมพ์","ชุมชนบ้านนาไร่ใหญ่","ชุมชนบ้านนาวา","ชุมชนบ้านนาสีทอง","ชุมชนบ้านนาหลวง","ชุมชนบ้านนาอ้อ","ชุมชนบ้านน้ำคำแดง (มนต์ชัยเวทย์วิวรณ์)","ชุมชนบ้านน้ำดิบ","ชุมชนบ้านน้ำน้อย","ชุมชนบ้านน้ำปลีก","ชุมชนบ้านน้ำปั้ว","ชุมชนบ้านน้ำร้อน","ชุมชนบ้านน้ำวิ่ง","เนินหัวโล้หนองยางพิทยาคม","ชุมชนบ้านโนนจิก","ชุมชนบ้านโนนเจริญ","ชุมชนบ้านโนนแดง","ชุมชนบ้านโนนเปือย (มหาพิมพ์สงเคราะห์)","ชุมชนบ้านโนนสมบูรณ์","ชุมชนบ้านโนนสวาง","ชุมชนบ้านโนนสาวเอ้","ชุมชนบ้านบวกครกน้อย","ชุมชนบ้านบวกโป่ง","ชุมชนบ้านบ่อ","ชุมชนบ้านบ่อแก้ว","ชุมชนบ้านบอน","ชุมชนบ้านบอนวิทยา","ชุมชนบ้านบ่อประดู่","ชุมชนบ้านบัวพักเกวียน","ชุมชนบ้านบัวใหญ่","ชุมชนบ้านบางเก่า","ชุมชนบ้านบางคลาน (เงินอนุสรณ์)","ชุมชนบ้านบางจาก","ชุมชนบ้านบางทรายน้อย","ชุมชนบ้านบางเสร่","ชุมชนบ้านบางโหนด","ชุมชนบ้านบึงแกชัยชนะบูรพา","ชุมชนบ้านบือแนปีแน","ชุมชนบ้านบุ่งแก้ว","ชุมชนบ้านบุ่งคล้าวิทยา","ชุมชนบ้านบุ่งเลิศ","ชุมชนบ้านบุเปือย","ชุมชนบ้านบุสามัคคีพัฒนา","ชุมชนบ้านปงป่าหวาย","ชุมชนบ้านประดู่ยืน","ชุมชนบ้านประโดก-โคกไผ่(สถิตวิริยคุณ)","ชุมชนบ้านประตูชัย","ชุมชนบ้านปลาขาว","ชุมชนบ้านปะโค","ชุมชนบ้านปากชม","ชุมชนบ้านปากพวก","ชุมชนบ้านปากสวย","ชุมชนบ้านปากเสียว","ชุมชนบ้านปากห้วย","ชุมชนบ้านป่าก่อดำ","ชุมชนบ้านป่าคาแม่เงินสามัคคี","ชุมชนบ้านปางหมู","ชุมชนบ้านปาดัง","ชุมชนบ้านป่าแดง","ชุมชนบ้านปาแดปาลัส","ชุมชนบ้านปาตา","ชุมชนบ้านป่าไผ่","ชุมชนบ้านป่าแฝกสามัคคี","ชุมชนบ้านป่ามะม่วง","ชุมชนบ้านป่าสักน้อย","บ้านปิน (ปินประชาราษฎร์)","ชุมชนบ้านปูยุด","ชุมชนบ้านแป้น (แก้วมะแป้น)","ชุมชนบ้านโป่ง","ชุมชนบ้านผานกเค้า","ชุมชนบ้านผาบ่อง","ชุมชนบ้านผาผ่า","ชุมชนบ้านผำ","ชุมชนบ้านไผ่ยิ่งยงอุทิศ","ชุมชนบ้านฝั่งแดง","ชุมชนบ้านฝาง","ชุมชนบ้านพงสตา","ชุมชนบ้านพบพระ","ชุมชนบ้านพรหมนิมิต","ชุมชนบ้านพระยืน","ชุมชนบ้านพร้าวหนุ่ม","ชุมชนบ้านพวก","ชุมชนบ้านพิมาน","ชุมชนบ้านพุดหง","ชุมชนบ้านพุเตย","ชุมชนบ้านพุ่มแก","ชุมชนบ้านเพชร","ชุมชนบ้านเพชร (วันครู 2500)","ชุมชนบ้านโพธิ์ตาก","ชุมชนบ้านโพธิ์โนนแดงวิทยา","ชุมชนบ้านโพธิ์สองห้องวิทยา","ชุมชนบ้านโพนงาม","ชุมชนบ้านโพนเมือง","ชุมชนบ้านโพนสว่างดอนโมง","ชุมชนบ้านโพนสา","ชุมชนบ้านฟ่อนวิทยา","ชุมชนบ้านเฟือยลุง","ชุมชนบ้านโภชน์","ชุมชนบ้านม่วงไข่","ชุมชนบ้านมะค่า","ชุมชนบ้านมะนังดาลำ","ชุมชนบ้านมั่ว","ชุมชนบ้านมาย","ชุมชนบ้านเมืองการุ้ง มิตรภาพที่ 52","ชุมชนบ้านเมืองเก่า","ชุมชนบ้านเมืองงาย","ชุมชนบ้านเมืองปอน","ชุมชนบ้านเมืองยอน","ชุมชนบ้านเมืองหงส์","ชุมชนบ้านแม่กุน้อย","ชุมชนบ้านแม่ข้าวต้มหลวง","ชุมชนบ้านแม่จะเราบ้านทุ่ง","ชุมชนบ้านแม่ต้าน (ราษฎรบำรุง)","ชุมชนบ้านแม่ตาวกลางมิตรภาพที่ 26","ชุมชนบ้านแม่ตืน","ชุมชนบ้านแม่ทัง","ชุมชนบ้านแม่ป้าก","ชุมชนบ้านแม่ปุ","ชุมชนบ้านแม่ยะ","ชุมชนบ้านแม่ระวานสองแคว","ชุมชนบ้านแม่สาบ","ชุมชนบ้านแม่สุก","ชุมชนบ้านแม่สูนหลวง","ชุมชนบ้านแม่หละป่าป๋วย","ชุมชนบ้านแม่ฮ่าง","ชุมชนบ้านแม่ฮาว","ชุมชนบ้านแม่ฮี้","ชุมชนบ้านไม้งาม","ชุมชนบ้านไม้ดัด","ชุมชนบ้านไม้ลุงขน มิตรภาพที่ 169","ชุมชนบ้านยางกู่","ชุมชนบ้านยางสีสุราช","ชุมชนบ้านยูโย","ชุมชนบ้านร้อง","ชุมชนบ้านร้องเข็ม (ร้องเข็มวิทยาคาร)","ชุมชนบ้านระเว","ชุมชนบ้านไร่สีสุก","ชุมชนบ้านละหารมิตรภาพที่ 113","ชุมชนบ้านลาด","ชุมชนบ้านวังกระดาษเงิน","ชุมชนบ้านวังกลม","ชุมชนบ้านวังจ๊อม","ชุมชนบ้านวังจันทน์","ชุมชนบ้านวังดิน","ชุมชนบ้านวังไทร (วังไทรวิทยาคม)","ชุมชนบ้านวังพิกุล","ชุมชนบ้านวังเพิ่ม","ชุมชนบ้านวังสะแบง","ชุมชนบ้านวังหิน","ชุมชนบ้านวัด","ชุมชนบ้านแวง","ชุมชนบ้านแวงใหญ่","ชุมชนบ้านศรีไค (ศรีวัฒนาวิทยาคาร)","ชุมชนบ้านศรีฐาน","ชุมชนบ้านศรีดอนชัย","ชุมชนบ้านศีรษะละเลิง","ชุมชนบ้านสบเปา","ชุมชนบ้านสร้างค้อ","ชุมชนบ้านสร้างดู่ดอนเขือง","ชุมชนบ้านสร้างถ่อสามัคคี","ชุมชนบ้านสร้างแป้น","ชุมชนบ้านสลกบาตร (วันครู2504)","บ้านสวนอุดมวิทยา","ชุมชนบ้านสว่าง","ชุมชนบ้านสองชั้น","ชุมชนบ้านสะแก","ชุมชนบ้านสะท้อน (วันครู 2503)","ชุมชนบ้านสะนอ","ชุมชนบ้านสะนิง","ชุมชนบ้านสะพือ","ชุมชนบ้านสันกำแพง","ชุมชนบ้านสันจำปา","ชุมชนบ้านสันมะค่า","ชุมชนบ้านสา","ชุมชนบ้านสาบัน","ชุมชนบ้านสามผง","ชุมชนบ้านสำพันตา","ชุมชนบ้านสำโรง","ชุมชนบ้านสีแก้ว","ชุมชนบ้านสี่แยก","ชุมชนบ้านสี่แยกโนนหัวนา","ชุมชนบ้านเสารีก","ชุมชนบ้านเสิงสาง","ชุมชนบ้านโสก","ชุมชนบ้านโสกวิทยาคาร","ชุมชนบ้านหนองขมาร","ชุมชนบ้านหนองขุ่น","ชุมชนบ้านหนองคัน","ชุมชนบ้านหนองคู (อินทร์ประชาคาร)","ชุมชนบ้านหนองคู","ชุมชนบ้านหนองแคน (นนทาภิบาล)","ชุมชนบ้านหนองงาแซง","ชุมชนบ้านหนองจิก","ชุมชนบ้านหนองจิกท่าแร่","ชุมชนบ้านหนองเซียงซา","ชุมชนบ้านหนองทุ่ม","ชุมชนบ้านหนองบ่อ (วิจิตรราษฎร์สามัคคี)","ชุมชนบ้านหนองบัว","ชุมชนบ้านหนองบัวโคก","ชุมชนบ้านหนองบัวแดง","ชุมชนบ้านหนองบัวระเหว","บัวลาย","ชุมชนบ้านหนองปรือ","ชุมชนบ้านหนองปลิง","ชุมชนบ้านหนองปลิง (นาคอุปถัมภ์)","ชุมชนบ้านหนองผึ้ง (ประพันธ์คุรุราษฎร์อุทิศ)","ชุมชนบ้านหนองฝ้าย","ชุมชนบ้านหนองเม็ก","ชุมชนบ้านหนองยองวิทยา","ชุมชนบ้านหนองย่างซี้น","ชุมชนบ้านหนองยาว","ชุมชนบ้านหนองเรือ","ชุมชนบ้านหนองเลา","ชุมชนบ้านหนองแวง","ชุมชนบ้านหนองแวงน้อย","ชุมชนบ้านหนองสะโน","ชุมชนบ้านหนองหญ้าปล้อง","เทศบาลหนองหญ้าม้า(กีฬาท้องถิ่นจังหวัดร้อยเอ็ด) เทศบาลเมืองร้อยเอ็ด","ชุมชนบ้านหนองหิ้ง","ชุมชนหนองหิน","ชุมชนบ้านหนองฮี (ถาวรวิทยาคม)","ชุมชนบ้านหน้าเขา","ชุมชนบ้านหนุนเหนือ (แสงศรีวิทยา)","ชุมชนบ้านหม้อ","ชุมชนบ้านหมอกจำแป่","ชุมชนบ้านหมากค่า","ชุมชนบ้านหมากยาง","ชุมชนบ้านหลวง","ชุมชนบ้านหลุมรัง","ชุมชนบ้านห้วยกระบอก (สามัคคีวิทยา)","ชุมชนบ้านห้วยค้อมิตรภาพที่206","ชุมชนบ้านห้วยงิ้ว","ชุมชนบ้านห้วยโจดโคกสะอาด","ชุมชนบ้านห้วยมะเขือ","ชุมชนบ้านห้วยยายจิ๋ว","ชุมชนบ้านห้วยแย้","ชุมชนบ้านห้วยลาน","ชุมชนบ้านห้วยหลัว","บ้านหว้า","ชุมชนบ้านหัน","ชุมชนบ้านหันมัญจาคีรี","ชุมชนบ้านหัวกุญแจ","ชุมชนบ้านหัวขัว","ชุมชนบ้านหัวพลวง (รัฐพรมมณีอุทิศ)","ชุมชนบ้านหัวเรือ","ชุมชนบ้านหัววัว (ราษฎร์อุทิศ)","ชุมชนบ้านหัวหวาย","ชุมชนบ้านหัวหวาย สาขาม่วงน้อย","ชุมชนบ้านหางน้ำสาคร","ชุมชนบ้านหายโศก","ชุมชนบ้านเหมืองจี้","ชุมชนบ้านเหมืองหม้อ (เหมืองหม้อสามัคคี)","ชุมชนบ้านเหล่าล้อ (พิมพ์คุรุราษฎร์บำรุง)","ชุมชนบ้านเหลื่อม","ชุมชนบ้านใหม่","ชุมชนบ้านใหม่ สาขาบ้านแม่เทย","ชุมชนบ้านใหม่หนองไทร","ชุมชนบ้านอมก๋อย","ชุมชนบ้านอ้อย","ชุมชนบ้านอ่างเวียน","ชุมชนบ้านอ่าวลึกเหนือ","ชุมชนบ้านอาฮี","ชุมชนบ้านอุ้มผาง","ชุมชนบ้านอุ่มเม่าสิงห์ไคล","ชุมชนบ้านแฮด","ชุมชนบึงบา","ชุมชนประชาธิปัตย์วิทยาคาร","ชุมชนประชานิกรอํานวยเวทย์","ชุมชนประชานิคม","ชุมชนประชาสงเคราะห์ 4","ชุมชนประชาสรรค์","ชุมชนประชาสามัคคี","ชุมชนประทาย","ชุมชนประสานมิตร","ชุมชนเปือยหัวดง","ชุมชนโปร่งวังม่วง","ชุมชนผาเลือดวิทยาคาร","ชุมชนไผ่ล้อม","ชุมชนไผ่ล้อมวิทยา","ชุมชนพลับพลา","ชุมชนพอกใหญ่ไทยสมบูรณ์","ชุมชนพิบูลสงคราม","ชุมชนโพธิ์ไทร","ชุมชนโพนงามประสาทศิลป์","ชุมชนโพนงามโพนสวาง","ชุมชนโพนทราย","ชุมชนโพนพิทยาคม","ชุมชนภูมิวิทยา","ชุมชนภูเรือ","ชุมชนภูแล่นช้างคเชนทร์พิทยาคาร","ภูเวียงวิทยายน","ชุมชนมาบอำมฤต","ชุมชนมิตรภาพ","ชุมชนเมืองปากฝาง","ชุมชนเมืองหนองสูง","ชุมชนแม่ลาศึกษา","ชุมชนไมตรีอุทิศ","ชุมชนยอดแก่งสงเคราะห์","ชุมชนรัชดาภิเษกมิตรภาพที่ 115","ชุมชนลานสกา","ชุมชนลำทะเมนชัยศึกษา","ชุมชนเลิศพินิจพิทยาคม","อนุบาลวังไทร","ชุมชนวังสะพุง","ชุมชนวังหลุมวิทยาคาร","ชุมชนวัดกลางกร่ำ","ชุมชนวัดกลางท่าข้าม","ชุมชนวัดกลางวังเย็น (เริ่มประชานุกูล)","ชุมชนวัดกะทูนเหนือ มิตรภาพที่ 218","ชุมชนวัดกำแพง","ชุมชนวัดกำแพงใต้ (กำแพงสังฆรักษ์วิทยา)","ชุมชนวัดเกยไชยเหนือ","ชุมชนวัดเกาะเพชร","ชุมชนวัดเกาะหงษ์ (นิโรธธรรมรังสรรค์)","ชุมชนวัดไก่เตี้ย","ชุมชนวัดขันเงิน","ชุมชนวัดเขาแก้ววิเชียร","ชุมชนวัดเขาดินเหนือ","ชุมชนวัดเขาไม้แก้ว","ชุมชนวัดเขาลำปะ","ชุมชนวัดคลองคะเชนทร์","ชุมชนวัดคลองไทร (ฉัตรราษฎร์บำรุง)","ชุมชนวัดคลองปลากด","ชุมชนวัดคลองรีมิตรภาพที่ 220","ชุมชนวัดควนมีด","ชุมชนวัดคีรีนาครัตนาราม","ชุมชนวัดโคกกลาง ","ชุมชนวัดโคกเข็ม(พุทธสรานุสรณ์)","ชุมชนวัดโคกดอกไม้","ชุมชนวัดจงโก มิตรภาพที่ 157","ชุมชนวัดจันทน์กะพ้อ","ชุมชนวัดจันทาราม","ชุมชนวัดเจ็ดเสมียน","ชุมชนวัดเฉลิมอาสน์","ชุมชนวัดช่อแล","ชุมชนวัดชุมพร","ชุมชนวัดเชิงแส","ชุมชนวัดเชี่ยวโอสถ","ชุมชนวัดดงขวาง","ชุมชนวัดดงยาง","ชุมชนวัดดอนคลังมิตรภาพที่ 178","ชุมชนวัดดักคะนน","ชุมชนวัดต้นเชือก (ถาวรวิทย์อุปกฤต)","ชุมชนวัดตราชู","ชุมชนวัดตะเคียนงาม","ชุมชนวัดถัมภาวาส (เสาร์อุทิศ)","ชุมชนวัดทอนหงส์","ชุมชนวัดทับมา","ชุมชนวัดท่าซุง (เลิศ-สินอุปถัมภ์)","ชุมชนวัดท่าเดื่อ","ชุมชนวัดท่าผา","ชุมชนวัดท่าพริก (จริยาอุปถัมภ์)","ชุมชนวัดท่าลิพง","ชุมชนวัดทําเลทอง","ชุมชนวัดท่าสุธาราม","ชุมชนวัดทุ่งหลวง","ชุมชนวัดเทพมงคล","ชุมชนวัดเทพราช","ชุมชนวัดไทยงาม","ชุมชนวัดไทรน้อย","ชุมชนวัดไทรม้า","ชุมชนวัดธรรมถาวร","อนุบาลวัดนางใน (ละเอียดอุปถัมภ์)","ชุมชนวัดนาเหนือ","ชุมชนวัดน้ำขาว","ชุมชนวัดน้ำพุ (น้ำพุพิทยาคาร)","ชุมชนวัดเนินม่วง","ชุมชนวัดบรมธาตุ","ชุมชนวัดบ่อไร่","ชุมชนวัดบัวแก้วเกษร (วรพงศ์อนุกูล)","ชุมชนวัดบางกระดาน (สวนราษฎร์บำรุง)","ชุมชนวัดบางกะดี","ชุมชนวัดบางไกรใน (ศีลพิบูลย์วิทยา)","ชุมชนวัดบางขัน","ชุมชนวัดบางคู","ชุมชนวัดบางโค (แม่นางวิทย์อุปการี)","ชุมชนวัดบางแตน","ชุมชนวัดบางบูชา","ชุมชนวัดบางไผ่","ชุมชนวัดบ้านแก่ง","ชุมชนวัดบ้านขาว","ชุมชนวัดบ้านโง้ง","ชุมชนวัดบ้านดง","ชุมชนวัดบ้านร่อม","ชุมชนวัดบ้านระกาศ","ชุมชนวัดบ้านเลือก (โพธาภิรมย์)","ชุมชนวัดบ้านหนองกง (ประจวบไตรมิตรวิทยา)","ชุมชนวัดบ้านหว้า ","ชุมชนวัดบำรุงธรรม","ชุมชนวัดโบสถ์","ชุมชนวัดประสาทสิทธิ์ (ศรีพรหมินทร์)","ชุมชนวัดปลักชะเมา","ชุมชนวัดปัณณาราม","ชุมชนวัดปากกอง","ชุมชนวัดป่าขะ","ชุมชนวัดป่าทรงธรรม","ชุมชนวัดป่าศรี","ชุมชนวัดปิยาราม","ชุมชนวัดพระธาตุลำปางหลวง","ชุมชนวัดพระนอน","ชุมชนวัดพระนอนจักรสีห์ (มิตรภาพที่ 133)","ชุมชนวัดพระปรางค์วิริยวิทยา","ชุมชนวัดพิชัยนาวาส (รัฐราษฎร์ประดิษฐ์วิทยา)","ชุมชนวัดพิชิตปิตยาราม","ชุมชนวัดโพธิ์ทอง ","ชุมชนวัดม่วง","ชุมชนวัดมหาธาตุ","ชุมชนวัดมหาโพธิเหนือ","ชุมชนวัดมัชฌิมเขตชลาราม","ชุมชนวัดมาติการาม","ชุมชนวัดย่านขาด (ประชาสงเคราะห์)","ชุมชนวัดรวง","ชุมชนวัดระโสม","ชุมชนวัดรางบัว (แหลมราษฎร์บำรุง)","ชุมชนวัดราษฎร์เจริญธรรม","ชุมชนวัดราษฎร์นิยม","ชุมชนวัดราษฎร์บำรุง","ชุมชนวัดริ้วหว้า","ชุมชนวัดวังเคียน","ชุมชนวัดวังจิก","ชุมชนวัดวิเศษชัยชาญ","ชุมชนวัดวิสุทธิชลาราม","ชุมชนวัดวิหารแดง (วรมิตรภัทรายุวราษฎร์ประดิษฐ์)","ชุมชนวัดศรีคำชมภู","ชุมชนวัดศรีดงเย็น","ชุมชนวัดศรีนาวา","ชุมชนวัดศรีประจันตคาม","ชุมชนวัดศรีมณีวรรณ (ธรรมศิริอุปถัมภ์)","เทศบาลปลายบางวัดส้มเกลี้ยง","ชุมชนวัดสมรโกฏิ","ชุมชนวัดสระแก้ว","ชุมชนวัดสวนลำไย (เสนาณรงค์อุปถัมภ์2)","ชุมชนวัดสันป่าลาน","ชุมชนวัดสาขลา","ชุมชนวัดสามบ่อ","ชุมชนวัดสายดงยาง","ชุมชนวัดสำพะเนียง (แร่ผดุงวิทยา)","ชุมชนวัดสำโรง","ชุมชนวัดสุเมธ","ชุมชนวัดสุวรรณบรรพต","ชุมชนวัดสุวรรณรังษี","ชุมชนวัดสุวรรณาราม","ชุมชนวัดเสด็จ","ชุมชนวัดเสด็จ (คุณ ศรีประเสริฐอุปถัมภ์)","ชุมชนวัดเสาธงหิน","ชุมชนวัดแสนตุ้ง","ชุมชนวัดหนองคล้ายางพะเนียด","ชุมชนวัดหนองค้อ","ชุมชนวัดหนองคอกหมู","ชุมชนวัดหนองจวง","ชุมชนวัดหนองตำลึง","ชุมชนวัดหนองโนใต้","ชุมชนวัดหนองปลาหมอ","ชุมชนวัดหนองโพ","ชุมชนวัดหนองรี","ชุมชนวัดหนองลากฆ้อน","ชุมชนวัดหน้าไม้","ชุมชนวัดหมน","ชุมชนวัดห้วยร่วม","ชุมชนวัดหัตถสารเกษตร","ชุมชนวัดหัวถนนใต้ (นิยุตประชาสรรค์)","ชุมชนวัดหัวสำโรง (ศรีราษฎร์บำรุง)","ชุมชนวัดหาดถั่ว","ชุมชนวัดหาดพันไกร","ชุมชนวัดหาดสำราญ","ชุมชนวัดใหญ่โพหัก (โพธิ์เบญจมอุทิศ)","ชุมชนวัดอัมพวนาราม","ชุมชนวัดอัมพวัน","ชุมชนวัดอ่าวช่อ","ชุมชนวัดอำภาศิริวงศ์","ชุมชนวัดอินทคีรี","ศรีจอมทอง","ชุมชนศิลาเพชร","ชุมชนศิลาแลง","ชุมชนศูนย์อพยพแปลง 4","ชุมชนสงเคราะห์","ชุมชนสมสนุก","ชุมชนสว่างวิทยา","ชุมชนสวี","ชุมชนสหกรณ์นิคมวิทยา","สหกรณ์พัฒนา","ชุมชนสหพัฒนา","ชุมชนส่องดาว","อุดมสังวรวิทยา","ชุมชนสะงวย","ชุมชนบ้านสะพานไม้แก่น","ชุมชนสะอาดผดุงศิลป์","เทศบาลสันป่ายางหลวง","ชุมชนสัมพันธ์บ้านลาโละ","ชุมชนสามัคคีราษฎร์บำรุง","ชุมชนสีถานดำรงวิทย์","ชุมชนหนองกุงวิทยา","ชุมชนบ้านหนองไข่น้ำ","ชุมชนหนองโดน (ประมาณราษฎร์บริบาล)","ชุมชนหนองบัวโคก (ทองวิทยานุกูล)","ชุมชนหนองบัวน้อยโนนชาติหนองเห็นวิทยา","ชุมชนหนองเม็ก","ชุมชนหนองยางวิทยาคม","ชุมชนหนองแวงสุวิทย์","ชุมชนหนองสองห้องคุรุราษฎร์รังสรรค์","ชุมชนหนองสอวิทยาคาร","ชุมชนหนองแสงโนนสว่าง","ชุมชนหนองหัวฟาน","ชุมชนหนองหินวิทยาคาร","ชุมชนหนองฮีสามัคคี","ชุมชนหมู่บ้านพัฒนา","ชุมชนหมูม่นวิทยาสรรพ์","ชุมชนหลักเหลี่ยมวิทยาคม","ชุมชนห้วยไผ่","ชุมชนห้วยยาง","ชุมชนห้องแซงวิทยา","อนุบาลชุมชนหัวดง","ชุมชนแหลมงอบ (นิเทศก์อุปถัมภ์)","ชุมชนเอื้องก่อนาดี","ชุมชนบ้านดอยเต่า","ชุมพรนาเจริญ","อนุบาลชุมพลบุรี","ชุมพลวิทยาสรรค์","ชุมพลศึกษา","ชุมพลสวรรค์วิทยา","ชูธรรมานุสรณ์","ชูวิชาราษฎร์","เชตวันหนองหมู","เชาวน์วัศ","เชิงคีรี(สุวิชานวรวุฒิ)","เชิงชุมราษฎร์นุกูล","เชิงผา","เชียงของวิทยาคม","เชียงเครือวิทยาคม","เชียงงามวิทยาคาร","เชียงรากน้อย (ทรัพย์-สังเวียน เหราบัตย์อนุสรณ์)","เชียงสาศิลปสถาน","เชียงใหม่คริสเตียน","เชียรใหญ่สามัคคีวิทยา","โชคชัยพรหมบุตรบริหาร","โชคอำนวย","โชติคุณเกษมบ้านเมืองงาม","โชติพันธุ์วิทยาสามัคคี","ไชยณรงค์วิทยา","ไชยวานนาเลิงคุ้งสะอาด","ไชยวารวิทยาคม","ไชยศรีเรืองวิทย์วิทย์","ไชยะวิทยา","ซอย 12 สาย 4 ซ้าย","ซอย 16 สาย 3 ซ้าย","ซอย 17 สาย 2 ซ้าย","ซอย 19 สาย 2 ขวา","ซอย 26 สาย 4 ซ้าย","ซอย 3 สาย 4 ซ้าย","ซอย 5 สาย 2 ซ้าย","ซอย 7 สาย 4 ซ้าย","ซอยพิเศษสาย 4 ซ้าย","ซอและฮ์ศึกษา","ซับถาวรพัฒนา","ซับมงคลวิทยา","ซางตาครู้สคอนแวนท์","ซางตาครู้สศึกษา","ซำสูงพิทยาคม","ซู่เอ็ง","เซนต์ยอแซฟมุกดาหาร","เซนต์โยเซฟคอนเวนต์","เซนต์โยเซฟนครสวรรค์","เซนต์โยเซฟศรีเพชรบูรณ์","แซงบาดาลบ้านบากวิทยา","แซงแหลมดินแดงโนนสวรรค์ (ธรรมศาสตร์ร้อยเอ็ด)","โซงเหล่าโป่วิทยา","ญาณวิศิษฎ์","ดงเกลือวิทยา","ดงชนเหล่าแมดบำรุงวิทย์","ดงตะขบราษฎร์สงเคราะห์","ดงน้อยวิทยา","ดงน้อยสงเคราะห์","ดงบังราษฎร์นุเคราะห์","ดงบังวิทยา","ดงบังวิทยายน","ดงบังอำนวยวิทย์","ดงพยุงสงเคราะห์","โนนกกจิกประชาสรรพ์","ดงพะยอมหนองคูสามัคคีวิทยา","แม่ลาววิทยาคม","ดงมะไฟวิทยา","ดงเมืองวิทยาคาร","ดงยางสะแบง","ดงเย็นวิทยาคม","ดงไร่ราษฎร์พัฒนา","ดงเว้นดงเจริญวิทยา","ดงสมบูรณ์ประชารัฐ","ดงสวรรค์อุดมมิตร","ดงสวางวรวิทย์","ดงสวางวิทยายน","ดงหัวเรือป่าม่วงวิทยา","ดงเหนือประชาสรรค์","ดงใหญ่พัฒนา (ดงใหญ่ 4)","ดมวิทยาคาร","ดรุณบัณฑิตพิทยา","ดรุณราษฎร์วิทยา","ดรุณวิทยากร","ดรุณศึกษา","ดวงวิภา","ดอนกลอยวิทยาคาร","ดอนกอกเกตสมบูรณ์สามัคคี","ดอนก่อโนนสวรรค์","ดอนแก้ว (รัฐประชาสรรค์)","ดอนขีวิทยา","ดอนแคนดอนหวายสามัคคี","ดอนแคนโนนเปลือยวิทยา","ดอนชัยวิทยา","บ้านดอนชัยวิทยา","ดอนเชียงบาลราษฎร์บำรุงศิลป์","ดอนตาลดงบังวิทยา","ดอนถ่อนโคกกลางวิทยา","ดอนท้าววิทยา","ดอนนางหงส์บูรพาสงเคราะห์","บ้านดอนน้ำคำ","ดอนน้ำใสวิทยา","ดอนปอวิทยา","ดอนเปล้าศึกษา","ดอนมัน","ดอนมูลวิทยาคาร","ดอนยานางศึกษา","ดอนยูงราษฎร์ประดิษฐ์วิทยาคาร","ดอนสามง่ามผิว หงสวีณะอุปถัมภ์","ดอนเสาโฮง (นิคมวิทยาคาร)","ดอนหวายตาใกล้เหล่าเจริญ","ดอนหวายราษฎร์บำรุง","ดอนหันประชารัฐศึกษา","ดอนหันราษฎร์อุปถัมภ์","ดอนเหลืองทองวิทยา","ดอนใหญ่พัฒนา","ดอนอีลุ่ม (ประชารัฐพัฒนา)","ดอนแฮดวิทยา","ดอยงามวิทยาคม","ดอยลานพิทยา","ดอยเวียงผาพิทยา","เวียงผาวิทยา","ดอยเวียงวิทยา","ดอยสามหมื่น","ดอยแสนใจ (ตชด.อนุสรณ์)","ดอยหลวง รัชมังคลาภิเษก","ด่านเกวียนวิทยา","ด่านขุนทด","ด่านซ้าย","ด่านแต้ราษฎร์สงเคราะห์","ด่านใต้วิทยา","ด่านมะขามเตี้ยวิทยาคม","ด่านแม่คํามัน","ด่านสิงขร","ด่านเหนือหนองไผ่สงเคราะห์","ดานใหญ่พิทยาคาร","ด่านอุดมวิทยา","ด่านอุดมศึกษา","ดาราคาม","ดาราสมุทร ภูเก็ต","ดาวรุ่งวิทยา","ดาวเรืองสมสะอาด","อนุบาลดำรงราชานุสรณ์","ดำรงสินสงเคราะห์","ดำรงสินอุทิศ","ดินดำบัวรองวิทยา","ดินดำวังชัยวิทยา","ดิศกุล","ดีมากอุปถัมภ์","ชุมชนบ้านหนองแสง","ชุมชนดูนสาด","เด่นไชยประชานุกูล","เด่นทัพชัย","เด่นวิทยา","เดื่อวิทยาคาร","ตำรวจตระเวนชายแดนไลออนส์มหาจักร 8","ตำรวจตระเวนชายแดนบ้านทุ่งไม้ด้วน 1","ตำรวจตระเวนชายแดนราษฎร์พิทักษ์","ตำรวจตระเวนชายแดนศึกษานารีอนุสรณ์ 3 (ห้วยส้าน)","สมาคมไทยผลิตยา 2","ตงศิริราษฎร์อนุสรณ์","ตำรวจตระเวนชายแดนบ้านเกษตรสมบูรณ์","ตำรวจตระเวนชายแดนค่ายพระเจ้าตากสงเคราะห์ 2","ตำรวจตระเวนชายแดนทองพูนพิทยา","ตำรวจตระเวนชายแดนบ้านค้อ","ตำรวจตระเวนชายแดนบ้านท่าข้าม","ตำรวจตระเวนชายแดนบำรุงที่ 60","ตำรวจตระเวนชายแดนบ้านป่งคอม","ต้นธงวิทยา","ต้นบากราษฎร์บำรุง","ต้นพิกุล","ต้นแหนหลวงประสิทธิ์วิทยา","ตระการพืชผล","ตรังวิทยา","ตรีมิตรวิทยา","ตลาดเกาะแรต","ตลาดขุนขยัน","ตลาดคลอง 16 (เอื้อสุนทรวัฒนาอุทิศ)","ตลาดคลองสวน (อัศวาณิชย์บำรุง)","ตลาดเจริญสุข","ตลาดนัดต้นมะขาม","ตลาดนัดบาซาเอ","ตลาดบางคูลัด","ตลาดบางบ่อ","ตลาดบางพลีน้อย","ตลาดปรีกี","ตลาดปากคลองเจ้า","ตลาดเปร็ง (น้อยใจบุญอุทิศ)","ตลาดรางกระทุ่ม","ตลาดสำรอง","ตลาดหนองหวาย","ตลุกดู่วิทยาคม","ตะโกดอนหญ้านาง","ตะแบกวิทยา","ตั้งพิรุฬห์ธรรม","ตากแดดสุธรรมประชาสรรค์","ตากสินราชานุสรณ์","ตาขุน","ตานีวิทยา","ตาเนินราษฎร์วิทยาคาร","ตาลชุมมิตรภาพที่ 186","ตาลชุมศึกษาลัย","ตำบลโคกกรวด (ผดุงรัฐประชานุกูล)","ตำบลบ้านแป้น","ตำบลบ้านโพธิ์","ตำบลริมปิง","ตำรวจตระเวนชายแดนช่างกลปทุมวันอนุสรณ์ 10","ตำรวจตระเวนชายแดนบ้านแม่ออกฮู","ตำรวจตระเวนชายแดนบ้านหนองมะแซว","ตำหนักเพนียด","ติ้ววิทยาคม","เตชะไพบูลย์ 2","เตชะไพบูลย์ 1","เต็มรักศึกษา","เตยสนุ่นสามัคคี","เตรียมทหารรุ่นที่ 13 อนุสรณ์ (บ้านด่านยาว)","เตรียมปริญญานุสรณ์","เตรียมอุดมศึกษาน้อมเกล้า กบินทร์บุรี","เตาไหราษฎร์ผดุง","เติมแสงไขปากช่องวิทยา","แตลศิริวิทยา","ไตรกิตทัตตานนท์","ไตรคาม","ไตรคามประชาพัฒนา","ไตรคามประชาสรรค์","ไตรคามราษฎร์บำรุง","ไตรคามวิทยา","ไตรคามวิทยาสรรค์","ไตรคามศรีอนุสรณ์","ไตรคามสามัคคี","ไตรคามสามัคคี (บ้านขี้เหล็ก)","ไตรคามสามัคคีวิทยา","ไตรธารวิทยา","ไตรประชาวิทยา","ไตรประชาสามัคคี","ไตรภูมิวิทยา","ไตรมิตร","ไตรมิตรประชาบำรุง","ไตรมิตรพัฒนศึกษา","ไตรมิตรพิทยา","ไตรมิตรวิทยา","ไตรมิตรวิทยาคาร","ไตรมิตรวิทยาสรรค์","ไตรมิตรศึกษา","ไตรมิตรสามัคคี","ไตรรัตน์วิทยาคาร","ไตรราษฎร์คุรุสามัคคี","ไตรราษฎร์วิทยา","ไตรราษฎร์วิทยาคาร","ไตรราษฎร์สามัคคี","ไตรราษฎร์สามัคคีวิทยา","ไตรราษฎร์อุปถัมภ์","ถนนชัยสามัคคี","ถนนมิตรภาพ","ถนนสุรนารายณ์ (คุรุรัฐประชาสรรค์)","ถลางพระนางสร้าง","ถ้ำปลาวิทยายน","เถิน-ท่าผา","ทรัพย์ทวี","ทรัพย์ราษฎร์บำรุง","ทรายขาววิทยา","ทรายทองเฉลิมวิทย์","ทรายทองราษฎร์อุทิศ","ทรายทองวิทยา","ทวีคามวิทยา","ทวีรัตน์","ทวีวัฒนา","ทหารอากาศบำรุง","ทองทิพย์วิทยา","ทองพูลอุทิศ","ทองสวัสดิ์วิทยาคาร","ทองอยู่นุตกูล","ท่อนสังข์วิทยา","ทอนเสียดวิทยาคาร","ทับ6วิทยาคาร","ทับกุงประชานุกูล","ทับช้างวิทยาคม","ทับไชยาพัฒนา","ทับทิมสยาม 06","ทับทิมสยาม 03","ทับทิมสยาม 05","ทับเที่ยงฮั่วเฉียว","ทับปุด","ทับยายเชียงวิทยา","ทับหลีสุริยวงศ์","ทัศนาวลัย","ท่ากลางแจ้งจมวิทยา","ท่ากุญชร","ท่าแก้งบำรุงศิลป์","ท่าแกวิทยากร","ท่าคันโทวิทยายน","ท่าไคร้สามัคคี","ท่างิ้ว (ต.ช.ด.อุปถัมภ์)","ท่าจีนอุดมวิทยา","ท่าฉัตรไชย","ท่าช้างรัฐประชาพัฒนา","ท่าตูม(สนิทราษฎร์วิทยาคม)","ท่าทรายประชาอุปถัมภ์","ทํานบแพ้ว","ทานสัมฤทธิ์วิทยา","ท่านาจานวิทยา","ท่าบอนมิตรภาพที่ 90","ท่าบ้านหลวง (รัฐรังสรรค์วิทยา)","ท่าปลาอนุสรณ์ 1","ท่าปลาอนุสรณ์ 2","ท่าแฝกอนุสรณ์ 1","ท่าแฝกอนุสรณ์ 2","ท่าแฝกอนุสรณ์ 4","ท่าพะเนียดกุญชร","ท่าเพลิงเหมือดแอ่ท่าใหม่หนองมะเกลือวิทยา","ท่าโพธิ์ผักก้ามวิทยา","ท่าเมืองสำราญวิทย์","ท้ายทุ่งราษฎร์วิทยาคาร","ท้ายพิกุล (สำนักงานสลากกินแบ่งสงเคราะห์ 68)","ท่าเยี่ยมหนองคล้าประชาส่งเสริม","ท่าระหัดราษฎร์สฤษฎิ์","ท่าเรือวิทยา","ท่าแร่วิทยา","ท่าละมัย","ท่าลาด","ท่าลานทอง","ท่าลำดวนประชาบำรุง","ท้าวสุรนารี (2521)","ท้าวสุรนารี(ระดมอนุสรณ์)","ท่าศาลา","ท่าศาลาราษฎร์วิทยา","ท่าสีดาวิทยา","ท่าแสงวิทยายน","ท่าแห่วิทยาคม","ทิพย์พิทยา","ทิวไผ่งาม","ทุ่งกว๋าววิทยาคม","ทุ่งกุลาประชารัฐ","บ้านทุ่งไก่ดัก","ทุ่งคลองวิทยา","วัดทุ่งควายพัฒนศึกษา","วัดทุ่งคอก (สุวรรณสาธุกิจ)","ทุ่งคาพิทยาคาร","ทุ่งคาวิทยา","บ้านทุ่งต้นงิ้ว","ทุ่งต้นปีก","ทุ่งตะโกวิทยา","ทุ่งตาพลวิทยา","ทุ่งไทรทอง","ทุ่งน้อยพัฒนา","ทุ่งบ่อวิทยา","ทุ่งโปร่งประชาสรรค์","ทุ่งฝางวิทยา","เทศบาล 1 (ทุ่งฟ้าบดราษฎร์บำรุง)","ทุ่งมนพิทยาคาร","ทุ่งมนราษฎร์บำรุง","ทุ่งมหาเมฆ","บ้านทุ่งมอก ","ทุ่งมะพร้าววิทยา","ทุ่งยางแดงพิทยาคม","ทุ่งยางเปล","ทุ่งรวงทอง","ทุ่งศรีทอง","ทุ่งศรีเมืองประชาวิทย์","ทุ่งศรีเมืองวิทยา","ทุ่งสะเดาประชาสรรค์","ทุ่งหนองขามวิทยา","ทุ่งหนองแห้งประชาสรรค์","ทุ่งหมื่นทุ่งแสนพิทยาคม","ทุ่งฮั้ววิทยา","เทนมีย์มิตรประชา","เทพคงคา","เทพคีรีพิทยาคม","เทพนรรัตน์","เทพประทาน (บ้านเจ๊ะเด็ง)","เทพประทานไทยยืนยง","เทพประสิทธิ์วิทยา","เทพรัตน์","เทพศาลาประชาสรรค์","เทพศิรินทร์","เทพสถิตวิทยา","เทพสัมฤทธิ์วิทยา","เทพเสนานุสรณ์","เทพา","เพรักษมาตาวิทยา","เทวะคลองตรง","เทวัญอำนวยวิทย์","เทศบาล ๑ กิตติขจร","เทศบาล 1 (บ้านในเมือง)","เทศบาล 1 (บ้านสะเตง)","เทศบาล 1 (วัดเจียงอี)","เทศบาล 1 (สถาวร)","เทศบาล ๑ บางมูลนาก","เทศบาล 1 บ้านโคกสำโรง","เทศบาล 1 บ้านชะอำ (ชะอำวิทยาคาร)","เทศบาล 1 โพศรี","เทศบาล 1 วัดแก่นเหล็ก (รัตนกะลัสอนุสรณ์)","เทศบาล ๑ วัดต้นสน","เทศบาล 1 วัดท้ายเมือง","เทศบาล 1 วัดพระงาม (สามัคคีพิทยา)","เทศบาล 1 ศรีเกิด","เทศบาล 1 (หนองแสง)","เทศบาล 1 (บ้านบัวใหญ่)","เทศบาล 1 (บูรพาวิทยากร)","เทศบาล 1 (เยี่ยมเกษสุวรรณ)","เทศบาล 1 ระบบสาธิตเทศบาลเมืองลพบุรี","เทศบาล ๒ วัดดอนมูลชัย","เทศบาล 2 (เชิงชุมอนุชนวิทยา)","เทศบาล 2 (ถนนบำรุงเมือง)","เทศบาล 2 (บ้านบาเละฮิเล)","เทศบาล 2 (บ้านมาลายูบางกอก)","เทศบาล 2 (วัดคูหาสวรรค์)","เทศบาล 2 (วัดใน)","เทศบาล 2 (วัดภูเขาดิน)","เทศบาล 2 (วัดสมอราย)","เทศบาล 2 (วัดใหม่ท่าพาณิชย์)","เทศบาล 2 ","เทศบาล 2 (สหกรณ์สมทบ)","เทศบาล 2 บ้านปากน้ำ (พิธานอุทิศ)","เทศบาล 2 พระยาศรีสุนทรโวหาร (น้อย อาจารยางกูร)","เทศบาล 2 มุขมนตรี","เทศบาล 2 วัดกวิศราราม","เทศบาล 2 วัดแก้วจันทราราม","เทศบาล 2 วัดชัยมงคล","เทศบาล 2 วัดไทรย้อย (ญาณธรรมสัมฤทธิ์)","เทศบาล 2 วัดพระทรง","เทศบาล 2 วัดโล่ห์สุทธาวาส","เทศบาล 2 วัดสว่างคงคา","เทศบาล 2 วัดเสนหา (สมัครพลผดุง)","เทศบาล 2 ศรีบุญเรือง","เทศบาล 2 สามัคคีวัฒนา","เทศบาล 2 หนองบัว","เทศบาล 3 ","เทศบาล 3 (คลองตาเค็ด)","เทศบาล ๓ วัดชัยชนะสงคราม","เทศบาล 3 ชุมชนหมู่บ้านตัวอย่าง","เทศบาล 3 (ตลาดล่าง)(เทศบาล)","เทศบาล 3 (บ้านหนองม่วง)","เทศบาล 3 (ยมราชสามัคคี)","เทศบาล 3 (วัดพุทธภูมิ)","เทศบาล 3 (วิมุกตายนวิทยา)","เทศบาล 3 (สระกระเทียม)","เทศบาล 3 ชุมชนวัดจันทราวาส","เทศบาล 3 บ้านเหล่า","เทศบาล 3 ระบบสาธิตเทศบาลเมืองลพบุรี","เทศบาล 3 วัดชัยมงคล","เทศบาล 3 วัดเนรัญชรา","เทศบาล 3 วัดเหนือ","เทศบาล 4 (ชุมชนวัดธรรมจักร)","เทศบาล ๔ (เชาวนปรีชาอุทิศ)","เทศบาล 4 (ธนวิถี)","เทศบาล 4 (บ้านชุกกุ่ม)","เทศบาล ๔ (เพาะชำ)","เทศบาล 4 (รัตนโกสินทร์ 200 ป๊)","เทศบาล 4 (วัดโพธาวาส)(เทศบาล)","เทศบาล 4 (สิทธิไชยอุปถัมภ์)","เทศบาล 4 (อมร สะเพียรชัยอุทิศ)","เทศบาล 4 (อุดมวิทย์สมใจ)","เทศบาล 4 บ้านบ่อแขม (เรือนพริ้งอาสาสงเคราะห์)","เทศบาล ๔ รัตนวิทยานุสรณ์","เทศบาล 4 วัดไชยสุรินทร์","เทศบาล 4 วัดโพธิวราราม","เทศบาล 4 ระบบสาธิตเทศบาลเมืองลพบุรี","เทศบาล 4 (กาแป๊ะฮูลู)","เทศบาล 5 (กระดาษไทยอนุเคราะห์)","เทศบาล 5 (ตลาดเก่า)","เทศบาล 5 (วัดป่าจิตตสามัคคี)","เทศบาล 5 (วัดกลางวรวิหาร)","เทศบาล 5 (วัดพันปี)","เทศบาล 5 (วัดหาดใหญ่)","เทศบาล 5 (สมพรอภัยโส)","เทศบาล 5 บ้านห้วยทรายใต้","เทศบาล 5 วัดพระปฐมเจดีย์","เทศบาล 5 สีหรักษ์วิทยา","เทศบาล 6 (วัดเมืองยะลา)","เทศบาล 6 บ้านห้วยทรายเหนือ (ราชวิทยุตาคาร)","มัธยมเทศบาล 6 นครอุดรธานี","เทศบาล 6 นครเชียงราย","เทศบาล 7 บ้านหนองตาพด","เทศบาล 7 รถไฟสงเคราะห์","เทศบาล 8 สวนสนชะอำ (วันครู 2501)","เทศบาล 9 บ้านสามพระยา","เทศบาล 9 มณเฑียรทองอนุรณ์","เทศบาลคุ้มหนองคู","เทศบาลจามเทวี","เทศบาลชนะชัยศรี","เทศบาลชลราษฎร์นุเคราะห์","เทศบาลตาคลี (ขุนตาคลีคณะกิจ)","เทศบาลท่าเรือประชานุกูล","เทศบาลท่าอิฐ","เทศบาลบ้านกล้วย","เทศบาลบ้านกิโลสอง","เทศบาลบ้านค้อ","เทศบาลบ้านคูหาสวรรค์","เทศบาลบ้านตูม","เทศบาลบ้านท้ายช้าง","เทศบาลบ้านท่าหลวง","เทศบาลบ้านบางเหนียว","เทศบาลบ้านปากคลอง","เทศบาลบ้านปากทาง","เทศบาลบ้านไผ่","เทศบาลบ้านแมด","เทศบาลบ้านศรีมหาราชา","เทศบาลบ้านส่องนางใย","เทศบาลบ้านสามกอง (วิเศษนุกูลกิจอุทิศ)","เทศบาลบ้านหมี่","เทศบาลบูรพาพิทยาคาร","เทศบาลบูรพาอุบล","เทศบาลปลูกปัญญา","เทศบาลแป้นจันทร์กระจ่าง","เทศบาลพลประชานุกูล","เทศบาลโพธิ์ศรี","เทศบาลเมืองสวรรคโลก","เทศบาลเมืองจันทบุรี 1","เทศบาลเมืองจันทบุรี 2","เทศบาลเมืองภูเก็ต","เทศบาลวัดกลาง","เทศบาลวัดกำแพง (อุดมพิทยากร)","เทศบาลวัดกู่คำ","เทศบาลวัดขจรรังสรรค์","เทศบาลวัดเขียน","เทศบาลวัดโขดทิมทาราม","เทศบาลวัดชัยชุมพล","เทศบาลวัดชัยมงคล","เทศบาลวัดดอนไก่ดี (สังวรจันทสรราษฏรวิทยา)","เทศบาลวัดด่านประชากร","เทศบาลวัดตองปุโบราณคณิสสร","เทศบาล ๓ (วัดท่ามะปราง)","เทศบาลวัดท่าสะต๋อย","เทศบาลวัดไทรอารีรักษ์ (มณีวิทยา)","อนุบาลเทศบาลนครพิษณุโลก","เทศบาลวัดนิโครธาราม","เทศบาลวัดเนินสุทธาวาส (สุทธิพงษ์ประชานุล)","เทศบาลวัดบูรพาภิราม","เทศบาลประตูลี้","เทศบาลวัดปากน้ำ","เทศบาลวัดปากน้ำโพใต้ (ท.2)","เทศบาลวัดป่าโค","เทศบาลวัดป่าเรไร","เทศบาลวัดพวกช้าง","เทศบาลวัดโพธิ์","เทศบาลวัดภูผาภิมุข","เทศบาลวัดเหมืองแดง","เทศบาลวัดแม่นางปลื้ม","เทศบาลวัดรัตนชัย","เทศบาลวัดราษฎร์นิยมธรรม","เทศบาลวัดราษฎรอุทิศ","เทศบาลวัดลุ่มมหาชัยชุมพล","เทศบาลวัดเวฬุวัน","เทศบาลวัดศาลาปูน","เทศบาลวัดสระทอง","เทศบาลวัดสวรรคนิเวศ","เทศบาลวัดสวรรคาราม","เทศบาลวัดสวัสติการาม","เทศบาลวัดสิงห์สถิตย์","เทศบาลวัดหนองบัว","เทศบาลวัดเหนือ","เทศบาลวารินวิชาชาติ","เทศบาลศรีบุญยานุสสรณ์","เทศบาลศรีเมืองพลประชานุเคราะห์","เทศบาลศรีสวัสดิ์","เทศบาลสวรรคโลกประชาสรรค์","เทศบาลสันป่ายางหน่อม","เทศบาลสามัคคีวิทยา","เทศบาลหนองแวงประชาอุปถัมภ์","เทศบาลห้วยยอดวิทยา","เทศบาลอินทปัญญา วัดใหญ่อินทาราม","เที่ยงธรรมวิทยา","บ้านเที่ยงนาเรียง","เทียมนครวิทยา","ไทยทนุบ้านสันต้นดู่","ไทยนิยมสงเคราะห์","ไทยประสิทธิ์ศาสตร์","ไทยรัฐวิทยา ๑ (บ้านหัวช้าง)","ไทยรัฐวิทยา 100 (บ้านคันนาหิน)","ไทยรัฐวิทยา 12 (บ้านเอก)","ไทยรัฐวิทยา 13 (บ้านพุม่วง)","ไทยรัฐวิทยา 14 (ท่าใหม่บ้านสิ้ว)","ไทยรัฐวิทยา 15 บ้านโกส้ม","ไทยรัฐวิทยา 16 (บ้านโนนพลวง)","ไทยรัฐวิทยา 17 (บ้านมะโม)","ไทยรัฐวิทยา 19 (บ้านคำน้อย)","ไทยรัฐวิทยา 101 เฉลิมพระเกียรติ","ไทยรัฐวิทยา 2 (วัดช้างใหญ่)","ไทยรัฐวิทยา 20 (บ้านหนองมะค่าโมง)","ไทยรัฐวิทยา 21 (บ้านลําเหย)","ไทยรัฐวิทยา 22 (ใต้ร่มเย็น)","ไทยรัฐวิทยา 23 (วัดโคกโหนด)","ไทยรัฐวิทยา 24 (บาโงยบาแด)","ไทยรัฐวิทยา 25 (บ้านบุ่งน้ำเต้า)","ไทยรัฐวิทยา 26 (บ้านหนองหิน)","ไทยรัฐวิทยา 27 (บ้านชำเม็ง)","ไทยรัฐวิทยา 28 (บ้านจานเขื่องนามั่ง)","ไทยรัฐวิทยา 29 (กะทู้)","ไทยรัฐวิทยา 3 (วัดบางไทร)","ไทยรัฐวิทยา 30 (ศรีสังวร)","ไทยรัฐวิทยา 31 (ทุ่งน้าวพุทธิมาศึกษากร)","ไทยรัฐวิทยา 32 (บ้านสาขันหอม)","ไทยรัฐวิทยา 33 (บ้านทุ่งพร้าว)","ไทยรัฐวิทยา 35 (คำกั้ง)","ไทยรัฐวิทยา 36 (บ้านบะตากา)","ไทยรัฐวิทยา 37 (วัดหัวถิน)","ไทยรัฐวิทยา 38 (บ้านน้ำร้อน)","ไทยรัฐวิทยา 39 (บ้านนาโต๊ะหมิง)","ไทยรัฐวิทยา 4 (ป.ปัญญาฐาปนกิจอุปถัมภ์)","ไทยรัฐวิทยา 40","ไทยรัฐวิทยา 41 (บ้านหัวนาศรีวิเชียรประชาอุทิศ)","ไทยรัฐวิทยา 43 (บ้านคลองเขต)","ไทยรัฐวิทยา ๔๕ (บ้านดอนแท่น)","ไทยรัฐวิทยา 46 (ดอกคำใต้)","ไทยรัฐวิทยา 47 (วัดนาเดา)","ไทยรัฐวิทยา 48 (บ้านทุ่งโป่ง)","ไทยรัฐวิทยา 49 (บ้านวงเวียน)","ไทยรัฐวิทยา 50 (บ้านคำพี้)","ไทยรัฐวิทยา 51 (บ้านโคกกว้าง)","ไทยรัฐวิทยา 52 (ชุมชนบ้านต้นไพ)","ไทยรัฐวิทยา 54 (วัดไสเสียด)","ไทยรัฐวิทยา 55 (วัดโบสถ์ดอนพรหม)","ไทยรัฐวิทยา 56 (บ้านหนองกระทุ่ม)","ไทยรัฐวิทยา 58 (ห้วยคตสามัคคี)","ไทยรัฐวิทยา 59 (วัดสังขวิจิตร)","ไทยรัฐวิทยา 6","ไทยรัฐวิทยา 60 (บ้านเขาตะพานนาก)","ไทยรัฐวิทยา 61 (บ้านห้วยยะอุ)","ไทยรัฐวิทยา 62 (บ้านนาหัวบ่อบัวหนองเม็ก)","ไทยรัฐวิทยา 63 (ชุมชนบ้านคำแดง)","ไทยรัฐวิทยา 64 (บ้านหนองเกตุ)","ไทยรัฐวิทยา 65 (วังไทรติ่ง)","ไทยรัฐวิทยา 66 (บ้านนาเนียน)","ไทยรัฐวิทยา 67 (บ้านนาพรุ)","ไทยรัฐวิทยา 68 (วัดเหวลาด)","ไทยรัฐวิทยา 69 (คลองหลวง)","ไทยรัฐวิทยา 70 (บ้านบางแก้ว)","ไทยรัฐวิทยา 71 (ก่อสร้างคลองด่าน)","ไทยรัฐวิทยา 72 (เทศบาล8)","ไทยรัฐวิทยา 73 (วัดบ้านพร้าว)","ไทยรัฐวิทยา 74 (ชุมชนบ้านคีรีวง)","ไทยรัฐวิทยา 75 เฉลิมพระเกียรติ","ไทยรัฐวิทยา 76 (บ้านพละ)","ไทยรัฐวิทยา 77 (บ้านเนินสันติ)","ไทยรัฐวิทยา ๗๘ (วัดสามัคคีชัย)","ไทยรัฐวิทยา 79 (บ้านหนองอาบช้าง)","ไทยรัฐวิทยา 8 (บ้านมะขามสูง)","ไทยรัฐวิทยา 80 (วังปริงเพ็ชรไพศาล)","ไทยรัฐวิทยา 81 (บ้านหนองภัยศูนย์)","ไทยรัฐวิทยา 82 (โคกตองเจริญ)","ไทยรัฐวิทยา 83 (บ้านห้วยโจด)","ไทยรัฐวิทยา 84 (บ้านสำราญเพี้ยฟาน)","ไทยรัฐวิทยา 85 (บ้านห้วยทาก)","ไทยรัฐวิทยา 86 (บ้านป่าสักหลวง)","ไทยรัฐวิทยา 87 (นิคมสร้างตนเอง 1)","ไทยรัฐวิทยา 88 (บ้านคลองควน)","ไทยรัฐวิทยา 89 (บ้านโคกสยา)","ไทยรัฐวิทยา 9 (วัดใหม่ราษฎร์นุกูล)","ไทยรัฐวิทยา 90 (บ้านโคกตะแบก)","ไทยรัฐวิทยา 91 (บ้านโคกจักจั่น)","ไทยรัฐวิทยา 93 (บ้านลาดตะเคียน)","ไทยรัฐวิทยา 94 (บ้านบ่อน้ำร้อน)","ไทยรัฐวิทยา 96 (ชุมชนบ้านธาตุ)","ไทยรัฐวิทยา 97 (บ้านบางบอน)","ไทยรัฐวิทยา 99 (บ้านแม่สุยะ)","ไทยรัฐวิทยา 53 (บ้านคลองขนาน)","ไทยรัฐวิทยา 57 (บ้านท่าฉนวน)","ไทยรัฐวิทยา 10 (บ้านใหม่)","ไทยรัฐวิทยา 11 (บ้านแข้)","ไทยรัฐวิทยา 18","ไทยรัฐวิทยา 34 (บ้านกุดโง้ง)","ไทยรัฐวิทยา 42","ไทยรัฐวิทยา 44 (บ้านนนทรี)","ไทยรัฐวิทยา 95 (วัดโพธิ์ทองบน)","ไทยรัฐวิทยา 98 (บ้านงอบ)","ไทยราษฎร์คีรี","ไทยวัฒนาประชารัฐ","ไทยสมุทรมิตรภาพที่ 187","ไทรงาม","ไทรงามเฉลิมพระเกียรติ","ไทรงามผดุงวิทย์","ไทรทอง","ไทรทองวิทยาคาร","ไทรทองอุปถัมภ์","ไทรโยคใหญ่","ธงชัยวิทยา","ธงชัยเหนือวิทยา","ธงธานี","ธนบุรีโคกสีหนองเต่าวิทยายน","ธนสิทธิ์อนุสรณ์","ธนากรสงเคราะห์","ธนาคารออมสิน","ธเนตรวิทยา","ธรรมจาริกอุปถัมภ์ 1","ธรรมจารีนิวาส","ธรรมนูญกองช่างวิทยา","ธรรมภิรักษ์","ธรรมยานประยุต","ธรรมราชศึกษา","ธรรมศรีสุวรรณดิษฐ์","ธรรมศาสตร์ - จุฬา 1","ธรรมศาสตร์ - จุฬา 2","ธรรมาธิปไตย","ธัญญสิทธิศิลป์","ธัมมสิริศึกษาสัตหีบ","ธาตุน้อยก่อสำราญ","ธาตุนาเวงวิทยา","ธาตุพระลอ (รามราษฎร์บูรณะ)","ธารเกษม","ธารโตวัฑฒนวิทย์","ธารทหาร (แสงสว่างอุปถัมภ์)","ธารทองวิทยา (ป่ารวก)","ธารน้ำใจ","ธารแร่","ธาราคีรี","ธาราบรรพต","ธีระวัธน์บำเพ็ญ","อนุบาลนครจัมปาศรี","นครชัยประชาสรรค์","นครไทยวิทยาคม","นครวิทยาคม","นครศรีลำดวนวิทยา","นครหลวง (พิบูลประเสริฐวิทย์)","ราชวินิต นนทบุรี","นนทรีวิทยา","นราทร","นวมินทราชูทิศ ทักษิณ","นักธุรกิจ (บ้านโคกสนาม)","นันทบุรีวิทยา","นากุงวิทยาเสริม","อนุบาลนาแกผดุงราชกิจเจริญ","นาแกพิทยาคม","นาแกราษฎร์อำนวย","นาแก้วพิทยาคม","นาโกทรายทองวิทยาคม","นาโกพิศาลราษฎร์อุปถัมภ์","นาโกวิทยา","นาโกวิทยาสูง","นาขามร่วมราษฎร์บำรุง","นาขามวิทยา","นาข่าวิทยา","นาคดีอนุสรณ์","นาคนาวาอุปถัมภ์","นาครัวประชาสามัคคี","อนุบาลนาคสมุทรเดชอุดม","นาค้อวิทยาคม","นาคำพิทยาสรรพ์","นาคำราษฎร์รังสรรค์","นาคูณวิทยา","นาไคร้ประชาสรรค์","นาไคร้พิทยาสรรพ์","นางอยโพนปลาโหล","นางามวิทยา","นางามแก่นลำดวนวิทยา","นางามวิทยาคาร","นางิ้ววิทยาสรรค์","นาจะหลวย (กรป.กลางอุปถัมภ์)","นาจานเจริญวิทย์","นาจานศึกษา","นาจำปา","นาจิกพิทยาคม","นาเจริญหนองแดง","นาเชือกวิทยาสรรพ์","นาดีหลุมข้าววิทยา","นาตาลวิทยาคม","นาถ่อนท่าวิทยาคาร","นาถ่อนวิทยานุกูล","นาทันวิทยา","นานกกก","นานกชุมวิทยาคม","นาน้อยวิทยา","นาบงวิทยา","นาบ้านไร่วิทยา","นาบึงราษฎร์สงเคราะห์","นาผือโคกกอก","นาผือบอนราษฎร์นุกูล","เสริมซ้ายวิทยา","นาฝายวิทยา","นาเพียงสว่างวิทยานุกูล","นาแพงวิทยาคาร","นาโพธิ์ชีวิทยา","นาโพธิ์พิทยาสรรพ์","นามนราษฎร์นุเคราะห์","นามนราษฎร์สงเคราะห์","นามลวิทยาคาร","นามูลสมบูรณ์วิทย์","นายางกลักพิทยาคม","นาโยงวิทยาคม","นารายณ์คำผงวิทยา","นารายณ์วิทยา","นารีราษฎร์สามัคคี","บ้านนาวังกุดตากล้า","นาวาราชกิจพิทยานุสรณ์","นาเวียงจุลดิศวิทยา","บ้านนาแวงหนองหัวลิง","นาสาร","นาสีนวลวิทยา","นาสีนวลโสกทรายวิทยา","นาสีนวลอุดมเวศม์","นาเสียวศึกษาคาร","นาหนองทุ่มตาลเดี่ยวสระแก้ววิทยา","นาหนองทุ่มวิทยาคม","นาหม่อโนนลานประชาสรรค์","นาห้วยยางสองคอน","นาหว้าไตรประชาคม","นาหว้าพิทยาคม (ธาตุประสิทธิ์ประชานุเคราะห์)","นาอวนวิทยาสิทธิ์","นาอ้อยคำสะอาด","นาฮีนุเคราะห์","นาฮุมอุดมสวรรค์สามัคคี","น้ำเกลี้ยงวิทยา","น้ำคำพิทยา","น้ำคำสมศรี","น้ำคำใหญ่วิทยา","น้ำจั้นราษฎร์บำรุง","น้ำตกปาโจ (วันครู 2501)","น้ำตกห้วยสวนพลู","น้ำพร้าสามัคคี","น้ำพอง","น้ำพองประชานุกูล","เทศบาลน้ำพองภูริพัฒน์","น้ำพุงจัดระเบียบวิทยา","น้ำยืน","น้ำริดราษฎร์บำรุง","น้ำสาดกลาง","น้ำสาดเหนือ","น้ำสิงห์ (สนง.สลากกินแบ่งสงเคราะห์ที่ 78)","น้ำใสวรวิทย์","นิกรราษฎร์บํารุงวิทย์","นิกรราษฎร์บูรณะ (เหราบัตย์อุทิศ)","นิคม 2 (ตชด.สงเคราะห์)","นิคม 3 (กรมประชาสงเคราะห์)","นิคม 4 (กรมประชาสงเคราะห์)","นิคมกุฉินารายณ์ หมู่ 2","นิคมกุฉินารายณ์ หมู่ 3","นิคมกุฉินารายณ์ หมู่ 6","นิคมควนขนุนวิทยา","นิคมโคกม่วงศรีสมพร","นิคมเจริญชัย","นิคมชลประทานสงเคราะห์","นิคมชานุมานสงเคราะห์ 1","เพียงหลวง 9 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","นิคมชานุมานสงเคราะห์ 3","นิคมซอย 10","นิคมทับกวางสงเคราะห์ 2","นิคมบางระกำ 1 (รุ้งวิไล)","นิคมบางระกำ 2 (ราษฎร์บำรุง)","นิคมบางระกำ 4 (บางระกำชนูปถัมภ์)","นิคมบางระกำ 6 (ท่ามะเกลือ)","นิคมบางระกำ 8 (หนองปลวก)","นิคมบ้านกร่าง (สามัคคีสงเคราะห์)","นิคมบ้านหัน","นิคมพัฒนา","นิคมพัฒนา 4","นิคมพัฒนา 10","นิคมพัฒนา 2","นิคมพัฒนา 5","นิคมพัฒนา 6","นิคมพัฒนา 7","นิคมพัฒนา 9","นิคมพัฒนาผัง 120","นิคมพัฒนาผัง 20","นิคมพัฒนาผัง 42","นิคมพัฒนาผัง 6","นิคมพัฒนาภาคใต้ 1","นิคมพัฒนาภาคใต้ 2","นิคมพัฒนาภาคใต้ 3","นิคมพัฒนาสายตรี 2","นิคมพัฒนาสายโท 11","นิคมลำนารายณ์","นิคมลำปาววิทยา","นิคมวัฒนา 6","นิคมวิทยา","นิคมสงเคราะห์","นิคมสงเคราะห์ 1","นิคมสงเคราะห์ 2","นิคมสงเคราะห์ 3","นิคมสงเคราะห์ 4","นิคมสงเคราะห์วิทยา","นิคมสร้างตนเอง","นิคมสร้างตนเอง 1","นิคมสร้างตนเอง 1 (ทุ่งโพธิ์ทะเล)","นิคมสร้างตนเอง 2","นิคมสร้างตนเอง 2 (บ่อทอง)","นิคมสร้างตนเอง 3","นิคมสร้างตนเอง 3 (แปดอ้อม)","นิคมสร้างตนเอง 4","นิคมสร้างตนเอง 4 (บ้านใหม่ศรีอุบล)","นิคมสร้างตนเอง 5","นิคมสร้างตนเอง 5 (สระเตย)","นิคมสร้างตนเอง 6","นิคมสร้างตนเอง 7","นิคมสร้างตนเอง 8","นิคมสร้างตนเอง 9","นิคมสร้างตนเองจังหวัดระยอง 1","นิคมสร้างตนเอง จ.ระยอง 10","นิคมสร้างตนเอง จ.ระยอง 13","นิคมสร้างตนเอง จ.ระยอง 2","นิคมสร้างตนเอง จ.ระยอง 3","นิคมสร้างตนเอง จ.ระยอง 4","นิคมสร้างตนเอง จ.ระยอง 5","นิคมสร้างตนเอง จ.ระยอง 6","ชุมชนนิคมสร้างตนเองจังหวัดระยอง 7","นิคมสร้างตนเอง จ.ระยอง 8","นิคมสร้างตนเอง จ.ระยอง 9","นิคมสร้างตนเองกระเสียว 1","นิคมสร้างตนเองกระเสียว 2","นิคมสร้างตนเองกิ่วลม 1","นิคมสร้างตนเองกิ่วลม 3","นิคมสร้างตนเองเขื่อนเพชร (พิบูลย์สงเคราะห์)","นิคมสร้างตนเองโคกโพธิ์","นิคมสร้างตนเองจังหวัดสระบุรี (พิบูลสงเคราะห์ 2)","นิคมสร้างตนเองเชียงพิณ 1","นิคมสร้างตนเองเชียงพิณ 3","นิคมสร้างตนเองเชียงพิณ 5","นิคมสร้างตนเองเทพา 2","นิคมสร้างตนเองเทพา 3","นิคมสร้างตนเองเทพา 4","นิคมสร้างตนเองธารโต 5","นิคมสร้างตนเองธารโต 6","นิคมสร้างตนเองบางระกำ 5","นิคมสร้างตนเองปราสาท","นิคมสร้างตนเองปราสาท 1","นิคมสร้างตนเองปราสาท 4","นิคมสร้างตนเองปราสาท 2","นิคมสร้างตนเองปราสาท 3","นิคม 1","นิคมสร้างตนเองพระราชประสงค์ 1","นิคมสร้างตนเองพัฒนาภาคใต้ 1","นิคมสร้างตนเองพัฒนาภาคใต้ 10","นิคมสร้างตนเองพัฒนาภาคใต้ 13","นิคมสร้างตนเองพัฒนาภาคใต้ 2","นิคมสร้างตนเองพัฒนาภาคใต้ 3","นิคมสร้างตนเองพัฒนาภาคใต้ 5","นิคมสร้างตนเองพัฒนาภาคใต้ 6","นิคมสร้างตนเองพัฒนาภาคใต้ 9","นิคมสร้างตนเองพิมาย 1","นิคมสร้างตนเองพิมาย 2","นิคมสร้างตนเองพิมาย 3","นิคมสร้างตนเองพิมาย 4","นิคมสร้างตนเองพิมาย 5","นิคมสร้างตนเองพิมาย 6","นิคมสร้างตนเองรัตภูมิ","นิคมสร้างตนเองลําน้ำน่านสงเคราะห์ 2","นิคมสร้างตนเองลำน้ำน่านสงเคราะห์ 3","นิคมสร้างตนเองลําน้ำน่านสงเคราะห์ 6","นิคมสร้างตนเองลำโดมใหญ่","นิคมสร้างตนเองลำตะคอง 1","นิคมสร้างตนเองลำตะคอง 2","นิคมสร้างตนเองลำตะคอง 4","นิคมสร้างตนเองลำตะคอง 5","นิคมสร้างตนเองลำน้ำน่านสงเคราะห์ 1","นิคมสร้างตนเองลำน้ำน่านสงเคราะห์ 4","นิคมสร้างตนเองเลี้ยงโคนม","นิคมสร้างตนเองแว้ง","นิคมสร้างตนเองแว้ง สายโท 2","นิคมสร้างตนเองสงเคราะห์ชาวเขา","นิคมสร้างตนเองห้วยคล้า 2","นิคมสร้างตนเองห้วยคล้า 3","นิคมสร้างตนเองห้วยคล้า 1","นิคมสร้างตนเองห้วยหลวง 1","นิคมสร้างตนเองห้วยหลวง 2","นิบงชนูปถัมภ์","นิมิตศึกษา","นิยมไพรผาหมอน อินทนนท์","นิยมมิตรวิทยาคาร","นิยมราษฎร์วิทยา","นิลรัตน์อนุสรณ์","นุ่มประสงค์วิทยา","เนรมิตศึกษา","เนินแก้ววิทยาคาร","บ้านเนินดินราษฎร์อุทิศ","เนินพระเนาว์วิทยา","เนินมะกอก","เนินลาดวิทยา","เนินสง่าวิทยา","แนะนำราษฎร์บำรุง","โนนกราดสามัคคี","โนนกอกวิทยา","โนนข่าประชาสรรค์","โนนข่าวิทยา","โนนขุยสามัคคี","โนนเขวาประชารักษ์","โนนเขวาประสิทธิ์ศิลป์","โนนเขวาเหล่าใหญ่ราษฎร์ส่งเสริม","โนนคร้อวิทยา","โนนค้อวิทยาคม","โนนค่าวิทยา","โนนคำวิทยา","โนนคูณวิทยา","โนนคูณอัมพวัน","โนนฆ้องวิทยาคาร","โนนงามศึกษา","โนนชัยประชาสรรค์","โนนชาดหนองช้างน้ำ","โนนเชียงบังหาดหนองแค","โนนดู่โพนหวายประชาสรรค์","โนนแดงราษฎร์ประสิทธิ์","โนนตาวิทย์","โนนตูม ","โนนเตาไหหนองแก","โนนทองวิทยา","โนนไทยวิทยาคาร","โนนธาตุนาอ้ายใหญ่วิทยา","โนนน้อยแผ่นดินทอง","โนนนารายณ์วิทยา","โนนปลาขาวราษฎร์บูรณะ","โนนปอแดงวิทยา","โนนป่างิ้ววิจิตวิทยา","โนนพะยอมพิทยไพศาล","โนนเพชรพัฒนา","โนนเพ็ดวิทยา","โนนโพธิ์บะก่ามวิทยา","โนนสมบูรณ์วิทยา","โนนมะค่าพรมนุสรณ์ราษฎร์บำรุง","โนนเมืองประชานุเคราะห์","โนนเมืองวิทยาคาร","โนนศิลาไกรฤกษ์ราษฎร์อำนวย","โนนศิลาสว่างวิทย์","โนนศิลาเหล่าเกษตร","โนนสง่าราษฎร์บำรุง","โนนสมบูรณ์ประชาสรรค์","โนนสวรรค์วิทยา","โนนสวางวิทยาสรรค์","โนนสะอาดพิทยา","โนนสะอาดพิทยาสรรค์","โนนสะอาดราษฎร์สามัคคี","โนนสะอาดราษฎร์อำนวย","โนนสะอาดวิทยา","โนนสังวิทยาสรรค์","โนนสาสวรรค์","โนนสำราญวิทยา","โนนสำราญหนองหญ้าขาว","โนนสีดาวิทยา","โนนสุวรรณพิทยาคม","โนนสูงโคกกลาง","โนนสูงพิทยาคาร","โนนสูงวิทยา","โนนเสลาประสาทวิทย์","โนนเสลาประสาทวิทย์ และสาขาประชาสามัคคี","โนนหญ้าคาหนองสระพิทยาคม","โนนหว้านไพล","โนนหันวิทยายน","โนนอุดมศึกษา","โนนอุดมสะอาดวิทยา","โนนไฮหนองอีกุ้มวิทยา","ในเมือง","บ.แม่จ๊างส.บ้านดงหลวง-ดงน้อย","บดินทรเดชา (สิงห์ สิงหเสนี)","บดินทร์เดชา (สิงห์ สิงหเสนี) 4","บดินทรเดชา (สิงห์สิงหเสนี) 2","บ้านสวนกล้วย","บรรณโศภิษฐ์","บรรพตพิสัยพิทยาคม","บรรพตวิทยา","บรรหารแจ่มใสวิทยา 2 (วัดลาดหอย)","บรรหารแจ่มใสวิทยา 4","บรรหารวิทยา","บริบาลภูมิเขตต์","บริษัทไทยกสิกรสงเคราะห์","บ่อเกดวิจิตรวิทยา","บ่อแก้วดงมะไฟมิตรภาพที่ 81","บ่อชะเนงวิทยา","บ่อทองลพบุรี","บ่อทองวิทยา","บอนเขียวราษฎร์บำรุง","บ่อน้อยประชาสรรค์","บ่อบุโปโล","บ่อพันขันวิทยา","บ่อแร่","บ่อแร่-ธารเลา","บ่อไร่วิทยาคม","บ่อวิทยบางระกำ","บ่อสี่เหลี่ยมวิทยา","บะยาวพัฒนาศึกษา","บะฮีวิทยาคม","บันนังสตาวิทยา","บันนังสตาอินทรฉัตรมิตรภาพที่ 200_ที่ระลึก ส.ร.อ.","บัวเชดวิทยา","บัวปุ่นสันเทียะอนุสรณ์","บัวสะอาดส่งเสริม","บัวสูงบัวเงินวิทยา","บัวเหลือง","บัวเหลือง สาขาบ้านหนองบัว","บัวใหญ่พิทยาคม","บ้านกันจด","อนุบาลบางแก้ว","บางแก้วประชาสรรค์","บางไก่เถื่อน (ตันติวิสิษฐ์ประชานุกูล)","บางขุนเทียนศึกษา","เทศบาล 1 (บางครุ อุปการราษฎร์)","บางคูลัด","วัดบางคูวัด","บางแค (เนื่องสังวาลย์อนุสรณ์)","บางชวดอนุสรณ์","บางชัน (ปลื้มวิทยานุสรณ์)","บางไทร","วัดบางนางบุญ","บางปลาม้า","บางปะกง ","บางไผ่ราษฎร์สงเคราะห์","บางพะเนียง","บางโพธิ์เหนือ","บางโพธิ์ใหม่","บางมูลนาก (ราษฎร์อุทิศ)","บางแม่หม้าย","บางยางพัฒนา","บางระกำ","บางสะพาน","บ้าน ก.ม.7","บ้าน กม.2","บ้าน กม.28","บ้าน กม.30","บ้าน กม.35","บ้านแม่หม้อ","บ้านกกกว้าว","บ้านกกกะบก","บ้านกกกุงคุรุราษฎร์พัฒนา","บ้านกกเกลี้ยง","บ้านกกค้อกกโพธิ์","บ้านกกจั่น","บ้านกกจาน","บ้านกกชุมแสง","บ้านกกเชียง","บ้านกกซ้อ","บ้านกกดู่","บ้านกกตาล","บ้านกกตาลดงบังวิทยา","บ้านกกตูม","บ้านกกทอง","บ้านกกไทร","บ้านกกบก","บ้านกกปลาซิวนาโด่","บ้านกกโพธิ์วังกำ","บ้านกกโพธิ์แสนเอี้ยม","บ้านกกม่วง","บ้านกกส้มโฮง","บ้านกกสะตี","กกสะทอนเครือหวายดิน","บ้านกกเหี่ยน","บ้านกกโอ","บ้านกกไฮ","บ้านกกไฮโนนน้ำคำ","บ้านก๋ง","บ้านกง (ประชานุกูล)","บ้านกง (ราษฎร์อุทิศ)","บ้านกงกะยาง","บ้านกงพาน","บ้านกงหนิง","บ้าน กม.80","บ้านกม.ศูนย์","บ้านกม.ห้า","บ้านกมลราษฎร์","ราชประชานุเคราะห์ 36 (บ้านกมลา)","บ้านกรงปินัง","บ้านกรงอิตํา","บ้านกรวดนาฮัง","บ้านกรอกสะแก","บ้านกรอบ","บ้านกระจังงาม","บ้านกระจาย","บ้านกระจายเหล่าสูง","บ้านกระจูด","บ้านกระเจา","บ้านกระชงค์ (ประชาอุทิศ)","บ้านกระแชงใหญ่","บ้านกระดาน","บ้านกระดาน (รัฐประชาสรรค์)","บ้านกระเดาอุ่มแสง","บ้านกระเดียง","บ้านกระเดียน","บ้านกระเดื่อง","บ้านกระโด","บ้านกระโดน","บ้านกระโดนกะลันทา","บ้านกระโดนค้อ (กระโดนค้อผดุงวิทยา)","บ้านกระโดนเตี้ย","กระต่ายด่อนวิทยา","บ้านกระต่ายโนนสวัสดิ์","บ้านกระเต็ล","บ้านกระถิน","บ้านกระถินหนองเครือชุด","บ้านกระถุน","บ้านกระทิง","บ้านกระทิงทอง","บ้านกระทุ่ม","อนุบาลจอมพระ","บ้านกระทุ่มเครือ","บ้านกระทุ่มจานสามัคคี","บ้านกระทุ่มทอง","บ้านกระทุ่มทองประชาสรรค์","บ้านกระทุ่มแท่น","บ้านกระทุ่มราย","บ้านกระทุ่มล้ม","บ้านกระเทียม (ราษฎร์วิทยาคม)","บ้านกระนวนซำสูง","บ้านกระบกเตี้ย","บ้านกระบวยทอง","บ้านกระบาก (กระบากวิทยาคม)","บ้านกระบี่","บ้านกระบี่น้อย","บ้านกระบูน","บ้านกระเบา","บ้านกระเบากลัก","บ้านกระเบื้อง","บ้านกระเบื้องโนนทิง","บ้านกระเบื้องวิทยาคาร","บ้านกระเบื้องใหญ่","บ้านกระพี้","บ้านกระเพรา","บ้านกระโพ (กระโพราษฎร์วิทยาคาร)","บ้านกระโพธิ์ช่างหม้อ","บ้านกระมัลพัฒนา","บ้านกระแมด","บ้านกระยอมหนองเดิ่น","บ้านกระแล","บ้านกระวัน","บ้านกระสัง","บ้านกระสัง (หรุ่นราษฎร์รังสรรค์)","บ้านกระสังข์","บ้านกระสังสามัคคี","บ้านกระเสาะ","บ้านกระแสร์อุดม-ท่าโคราช","บ้านกระโสบ (เพียรประสิทธิ์วิทยา)","บ้านกระโสม (ผดุงนิคมวิทยา)","บ้านกระหนวนดอนดั่ง","บ้านกระหวะ","บ้านกระหวัน","บ้านกระหวันโนนเจริญ","บ้านกระออม","บ้านกระอาน","บ้านกร่าง (พระขาวชัยสิทธิ์)","บ้านกราม","บ้านกรือซอ","บ้านกรือเซะ","บ้านกรุงกรัก","บ้านกรุงเจริญ","บ้านกรุงหยันใต้","บ้านกรูด","บ้านกรูดหนองซำ","บ้านกรูดหนองออก","บ้านกฤษณา","บ้านกล้วย","บ้านกล้วย ","บ้านกล้วยกว้าง","บ้านกล้วยจอหอ","บ้านกล้วยวิทยา","บ้านกลอง","บ้านกลอเซโล","บ้านกล้อทอ","บ้านกลอนโด","บ้านกลอยโนนสมบูรณ์","บ้านกลอยสามัคคี","บ้านกลันทาวิทยา","บ้านกลาง","บ้านกลางบ้านหนาด","บ้านกลางสระเกษ","บ้านกลาง ","บ้านกลาง (ประชาคมวิทยา)","บ้านกลาง (วิโรจน์สามัคคีประชาสรรค์)","บ้านกลางคลอง 30","บ้านกลางดง","บ้านกลางน้อย","บ้านกลางนา","บ้านกลางนาเดื่อ","บ้านกลางประชาสรรค์","บ้านกลางเพชร (สุโขวิทยา)","บ้านกลางมิตรภาพที่ 63","บ้านกลางมิตรภาพที่ 44","บ้านกลางมูลอ้น","บ้านกลางเสลภูมิ","บ้านกลางหนองดินดำ","บ้านกลางใหญ่","บ้านกลิ้งกลอง","บ้านกลุ่ม 5 ประชารัฐ","บ้านกลุ่มพัฒนา","บ้านกลูบี","บ้านกวดโคกสว่าง","บ้านกวน","บ้านกวนบุ่น","บ้านก็วล","บ้านกวาง (ลือราษฎร์วัฒนา)","บ้านกวางงอย ","บ้านกวางโจนโนนทอง","บ้านกวางดีด","บ้านกว้างท่าเยี่ยม","บ้านกว้านเหนือ (สุทัศน์อุปถัมภ์)","บ้านกวาลอซีรา","บ้านกว๋าวโท้ง","บ้านก่อ","บ้านก่อบึง","บ้านก้อ","บ้านก๊อ","อนุบาลวารินชำราบ(ก่อวิทยาคาร)","บ้านก่อ (รามคำแหงอนุสรณ์ 2)","บ้านก่อ (ราษฎร์นุกูล)","บ้านกอก","บ้านกอกแก้ว","บ้านกอกโคกวิทยา","บ้านกอกดอนพยอม","บ้านกอกนายูง (คุรุราษฎร์บำรุง)","บ้านกอกโนนแต้","บ้านกอกป่าผุวิทยา","บ้านกอกวิทยา","บ้านกอกวิทยาคม","บ้านกอกวิทยาคาร","บ้านกอกหนองผือ","บ้านกอกหลวง","บ้านกอกหวาน","บ้านกอกหัวนา","บ้านกองก๋อย","บ้านก่องขันธ์","บ้านกองแขก","บ้านกองแขก สาขาบ้านแม่หลุ","บ้านกองโค","บ้านกองงาม","บ้านกองทูล (พิทักษ์ราษฎร์วิทยาคาร)","บ้านกองแปใต้","บ้านกองแป่มหนองสวรรค์","บ้านกองพระทราย","บ้านกองโพน","บ้านกองม่องทะ","บ้านกองลม","บ้านกองลอย","บ้านกองวะ","บ้านกองหิน","บ้านกองแหะ","บ้านกองอิฐ","บ้านก่องาม","บ้านก้อจัดสรร และรร.บ้านก้อทุ่ง","บ้านกอตง","บ้านกอตอตือร๊ะ","บ้านก้อนเส้า","บ้านก๊อน้อย","บ้านก่อนาดี","บ้านกอแนะเหนือ","บ้านก่อโนนหล่อง","บ้านกอบแกบ","บ้านกอมูเดอ","บ้านกอย","บ้านกอไร่ใหญ่","บ้านกอแลบีเละ","บ้านกอสะเลียม","บ้านก่อแสนสำราญสามัคคี","บ้านก๊อหลวง","บ้านกะกำ","บ้านกะดาด","บ้านกะดึ","บ้านกะโดนหนองยาง","บ้านกะตะ","บ้านกะตูปะ","บ้านกะเตียด","บ้านกะทม (คุณรสนิมิต)","บ้านกะทม (ร่วนวิทยา)","บ้านกะทะ","บ้านกะทิง","บ้านกะทุ่มลาย","เทศบาล 2 บ้านกะทู้","บ้านกะนัง (ฤทธิ์ประชาสรรค์)","บ้านกะบกเตี้ย","บ้านกะปง","บ้านกะปู","บ้านกะพี้","บ้านกะมอล (กรป.กลางประชาอุทิศ)","บ้านกะริคี","บ้านกะรุบี","บ้านกะลัน","บ้านกะลาพอ","บ้านกะลึง","บ้านกะลูแป","บ้านกะเลงเวกทับทิมสยาม","บ้านกะเลา - ศรีพัฒนา","บ้านกะวัน","บ้านกะสัง","บ้านกะไหล","บ้านกะเอิน","บ้านกะแอก","บ้านกระแอกน้อย","บ้านกั้งโนนสะอาด","บ้านกันจาน","บ้านกันจารย์","บ้านกันจุ","บ้านกันโจรง","บ้านกันตม (คุรุราษฎร์สามัคคี)","บ้านกันตรง","บ้านกันตรวจ","บ้านกันตรวจห้วย","บ้านกันตรุม","บ้านกันตังใต้","บ้านกันเตรีย็ง","บ้านกันแตสระรุน","บ้านกันทรอม","บ้านกันทรอมน้อย","บ้านกันทรารมย์","บ้านกันโทรกประชาสรรค์","บ้านกันผม","บ้านกันละ","บ้านกันแสง","บ้านกาเกาะ","บ้านกาเกาะ (แหลมราษฎร์นุเคราะห์)","บ้านกาเกาะระโยง","บ้านกางของ","บ้านก้างปลา","บ้านกาจับ","บ้านกาเจาะหนองไผ่","บ้านกาซ้อง","บ้านกาด (เขมวังส์ฯ)","บ้านกาด","บ้านกาดถี","บ้านกาดฮาว","บ้านกาดือแป","บ้านกาเด็ง","บ้านกาโดะ","บ้านกาตอง","บ้านก่าน","บ้านกานต์สามัคคี","บ้านก้านเหลือง","เทศบาล 5 ชุมชนก้านเหลือง","บ้านก้านเหลือง (คุรุราษฎร์วัฒนา)","บ้านก้านเหลืองดง","บ้านกาเนะ","บ้านกาแนะ","บ้านกาบกระบือ","บ้านกาบิน","บ้านกาบุ๊","บ้านกาแบง","บ้านกําปงปีแซ","บ้านกาพระ","บ้านกือเม็ง","บ้านก๋ายน้อย","บ้านกาเยาะมาตี","บ้านกาแย","บ้านกาแร","บ้านกาลอ","บ้านกาลันยีตัน","บ้านกาลิซา","บ้านกาลึม","บ้านกาลูบี","บ้านกาลูปัง","บ้านกาแลกุมิ","บ้านกาแลสะนอ","บ้านกาวะ","บ้านกาศ (วัฒนาประชานุกูล)","บ้านกาศเมฆ","บ้านกาโสด","บ้านกาใส","บ้านกาหงษ์","บ้านกาหนั๊วะ","บ้านกาหยี","บ้านกาฮง","บ้านกำปงบือแน","บ้านกำปัง","บ้านกำพวน","บ้านกำพี้","บ้านกำพี้เหล่ากาเจริญศิลป์","บ้านกำแพงเพชร","บ้านกำแพงเศียร","บ้านกำแมด","บ้านกำสนประชาสรรค์","บ้านกำสนราษฎร์อุทิศ","บ้านกำไสจาน","บ้านกิโลแปด","บ้านกิโลสาม","บ้านกิ่วแก้ว","บ้านกิ่วเคียน","บ้านกิ่วจันทร์ (เสรินทวัฒน์อุปถัมภ์)","บ้านกิ่วดงมะไฟ","บ้านน้ำตวง","บ้านกิ่วมื่น","บ้านกิ่วลม","บ้านกิ่วเสือ","บ้านกิ่วห้วยเบิก","บ้านกึ่งพุทธกาล","บ้านกึ้ดสามสิบ","บ้านกือยา","บ้านกือลอง","บ้านกือแล","บ้านกุง","บ้านกุงโกน","บ้านกุงขาม","บ้านกุงชัย","บ้านกุงประชาสรรค์","บ้านกุงไม้สักมิตรภาพที่ 98","บ้านกุงศรี","บ้านกุฏิพระ","บ้านกุดกง","บ้านกุดกลอย","บ้านกุดก่วงท่าแสงจันทร์","บ้านกุดก่วยโนนเจริญ","บ้านกุดกว้าง","บ้านกุดกว้างประชาสรรค์","บ้านกุดกวางสร้อย","บ้านกุดกอก","บ้านกุดกะเสียน","บ้านกุดกั่ว","บ้านกุดกุง","บ้านกุดแก","บ้านกุดแกลบ","บ้านกุดไกรสร","บ้านกุดขนวน","บ้านกุดขมิ้น","บ้านกุดขอนแก่น","บ้านกุดขุ่น","บ้านกุดขุ่นสวาสดิ์","บ้านกุดเขียว","บ้านกุดแข้","บ้านกุดแข้ด่อนหนองบัว","บ้านกุดแข้ใต้","บ้านกุดแข้โนนโพธิ์วิทยา","กุดคอก่านโคกสำราญโนนสวรรค์","บ้านกุดคอเมย","บ้านกุดแคนประชาสรรค์","บ้านกุดแคน","บ้านกุดแคนสามัคคี","บ้านกุดโคลน","กีฬาหมื่นศรีวิทยานุสรณ์","บ้านกุดโง้ง","บ้านกุดโง้ง (สิริราษฎร์บำรุง)","บ้านกุดโง้งดงสวรรค์","บ้านกุดโง้งวังเดื่อ","บ้านกุดจอก","บ้านกุดจอกน้อย","บ้านกุดจอกห้องพอกขี้เหล็ก","บ้านกุดจอกใหญ่","บ้านกุดจับ","บ้านกุดจาน","บ้านกุดจิก","บ้านกุดจิก (รัชชุศิริอนุกูล)","บ้านกุดจิกนาสมบูรณ์","บ้านกุดจิกหนองแห้ว","บ้านกุดโจด","บ้านกุดฉนวน","บ้านกุดฉิม","บ้านกุดฉิมพิทยาคาร","บ้านกุดชมภู","บ้านกุดชะนวน ","บ้านกุดชุม","บ้านกุดเชียงมี","บ้านกุดเชียงมุน","บ้านกุดเชียงหมี","บ้านกุดเชือก","บ้านกุดซุย","บ้านกุดดินจี่","บ้านกุดดุกวิทยา","บ้านกุดดุกสุขเกษม","บ้านกุดดู่อุดมวิทย์","บ้านกุดแดง","บ้านกุดโดก","บ้านกุดตะกาบ","บ้านกุดตะเคียน","บ้านกุดตากล้า","บ้านกุดตาใกล้","บ้านกุดตาเพชร","บ้านกุดตาลาด","บ้านกุดเต่า","บ้านกุดเต่าวิทยา","บ้านกุดแต้","บ้านกุดท่าลือ","บ้านกุดแท่น","บ้านกุดธาตุ","บ้านกุดน้อย","บ้านกุดนาแก้ว","บ้านกุดนาขาม (เชิดชูวิทยาสาร)","บ้านกุดนาค้อ","บ้านกุดนางทอหูก","บ้านกุดนางทุย","บ้านกุดนาดีโนนลาน","บ้านกุดน้ำกิน","บ้านกุดน้ำขุ่น","บ้านกุดน้ำใส","บ้านกุดน้ำใสจานบกน้อย","บ้านกุดน้ำใส (3 พระครูอนุสรณ์)","บ้านกุดน้ำใส (ผดุงวิทยาคาร)","บ้านกุดบง","บ้านกุดโบสถ์","บ้านกุดประทาย","บ้านกุดปราสาท","บ้านกุดปลาขาว","บ้านกุดปลาเข็งเหมืองลี่","บ้านกุดปลาฉลาดหนองปรือ","บ้านกุดปลาดุก","บ้านกุดเป่ง","บ้านกุดผักหนามคำน้อย","บ้านกุดผึ้ง","บ้านกุดไผ่","บ้านกุดฝั่งแดง","บ้านกุดพังเครือ","บ้านกุดพังทุย","บ้านกุดพันเขียว","บ้านกุดเพียขอมนาผายโนนสังข์","บ้านกุดเพียขอมเหนือ","บ้านกุดม่วง","บ้านกุดมะโน","บ้านกุดมะฮงดงสวาง","บ้านกุดเม็ก","บ้านกุดเมืองฮาม (ศิริราษฎร์สงเคราะห์)","บ้านกุดยาง","บ้านกุดยาลวน","บ้านกุดระงุม","บ้านกุดระหวี่","บ้านกุดรัง","บ้านกุดรู","บ้านกุดเรือ","บ้านกุดเรือคำ","บ้านกุดละลม","บ้านกุดลันน้อยคีรี","บ้านกุดเลา","บ้านกุดเลาะ (คุรุประชานุสรณ์)","บ้านกุดเวียน","กุดสระวิทยานุกูล","บ้านกุดสระแก้ว","บ้านกุดสะกอย","บ้านกุดสะเทียนใหม่ศรีทอง","บ้านกุดสำโรง","บ้านกุดสิม","บ้านกุดเสถียร","บ้านกุดเสลาหนองขวาง","บ้านกุดแสง (ธาราประชาบำรุง)","บ้านกุดหมากเห็บ","บ้านกุดหว้า","บ้านกุดหวาย","บ้านกุดหอยกาบ","บ้านกุดหัวช้าง","กุดหานสามัคคี","บ้านกุดหิน","บ้านกุดหูลิง","บ้านกุดแห่","บ้านกุดใหญ่","บ้านกุดฮู","บ้านกุดแฮดวัฒนราษฎร์ผดุง","บ้านกุตาไก้","บ้านกุบังจามัง","บ้านกุบังปะโหลด","บ้านกุ่ม","บ้านกุ่ม (คุรุประชาสามัคคี)","บ้านกุ่มเนิ้งใต้","บ้านกุมแป","บ้านกุ่มพะยาหนองกระทุ่มวิทยา","บ้านกุยเหนือ","บ้านกุยแหย่","บ้านกุรุคุ","บ้านกุศกร","บ้านกู่","บ้านกู่ (ราษฎร์สามัคคี)","บ้านกู่กาสิงห์","บ้านกู้กู","บ้านกู่โกสีย์วิทยา","บ้านกูจิงลือปะ","บ้านกู่ทอง","บ้านกูน","บ้านกูบังบาเดาะ","บ้านกูบู","บ้านกูแบสาลอ","บ้านกูแบอีแก","บ้านกูยิ","บ้านกูเล็ง","บ้านกูวา","บ้านกูวิง","บ้านกูแว (ประชาอุทิศ)","บ้านเกต ","บ้านเกตรี","บ้านเก็ตโฮ่","บ้านเก็บงา (ประชารัฐพัฒนา)","บ้านเก็ม","บ้านเกยเชน","บ้านเกริงกระเวีย","บ้านเกริ่นกฐิน","บ้านเกรียมโนนสำโรง","บ้านเกล็ดแก้ว (ซีเซะ)","บ้านเกวต","บ้านเกศกาสร","บ้านเกษตรถาวร","บ้านเกษตรพัฒนา","บ้านเกษตรสมบูรณ์","บ้านเกษม","บ้านเกษมสุข","บ้านเกะรอ","บ้านเก่า","เทศบาล 1 (บ้านเก่า)","บ้านเก่ากลอยกุดกระสู้","บ้านเก่ากลาง","บ้านเก่าขาม","บ้านเก่าค้อ","บ้านเก่างิ้วหนองบั่ว (คุรุราษฎร์ประสิทธิ์)","บ้านเก่าเดื่อ","บ้านเก่าต้นมะค่า","บ้านเก่าน้อย","บ้านเก่าน้อยหนองเส็งหินลาด","บ้านเก่า-บ้านน้อย","บ้านเก่าปอแดง","บ้านเก่าร้าง","องค์การบริหารส่วนจังหวัดกาญจนบุรี ๑ (บ้านเก่าวิทยา)","บ้านเก่าวิทยานุกูล","บ้านเก่าใหญ่โนนสะอาด","บ้านเก่าใหม่","บ้านเกาะ","บ้านเกาะกระโพธิ์","บ้านเกาะกลาง","บ้านเกาะแก้ว","บ้านเกาะแก้ว (การไฟฟ้าอุปถัมภ์)","บ้านเกาะแก้วอนุสรณ์","บ้านเกาะขวัญ","บ้านเกาะค่าง","บ้านเกาะเคี่ยม","บ้านเกาะโคบ","บ้านเกาะจัน","บ้านเกาะจำ","บ้านเกาะแจนแวน","บ้านเกาะช้าง","บ้านเกาะดอน (เลิศสินธุ์ประชาสรรค์)","บ้านเกาะตรวจ","บ้านเกาะตา","บ้านเกาะตาล","บ้านเกาะตาเลี้ยง (ทองดีประชานุกูล)","บ้านเกาะเต่า","บ้านเกาะทวด","บ้านเกาะทองสม","บ้านเกาะทัง","บ้านเกาะทาก","บ้านเกาะเทโพ","บ้านเกาะไทร","บ้านเกาะนก","บ้านเกาะนกเภา","บ้านเกาะนอก (ประชานุเคราะห์)","บ้านเกาะน้อย","บ้านเกาะนางคำ","บ้านเกาะนางคำเหนือ","บ้านเกาะนางโดย","บ้านเกาะนาน้อย","บ้านเกาะนํ้ารอบ","บ้านเกาะน้ำโจน","บ้านเกาะบูโหลน","บ้านเกาะปราง","บ้านเกาะปอ","บ้านเกาะปุด","บ้านเกาะปู","บ้านเกาะเปริด (เจริญรัตน์ราษฎร์นุกูล)","บ้านเกาะเปาะ","บ้านเกาะไผ่","บ้านเกาะฝ้าย (ราษฎร์อุทิศวิทยาคาร)","บ้านเกาะพยาม","บ้านเกาะพลวย","บ้านเกาะพิมูล","บ้านเกาะพีพี","บ้านเกาะโพธิ์ (วันครู2500)","บ้านเกาะโพธิ์งาม","บ้านเกาะโพธิ์แจ้ง","บ้านเกาะมะนาว","บ้านเกาะมุกด์","บ้านเกาะไม้แหลม","บ้านเกาะยวน","บ้านเกาะยะระโตดนุ้ย","บ้านเกาะยาว","บ้านเกาะรัง","บ้านเกาะรากเสียด","บ้านเกาะแรต","บ้านเกาะลอย","บ้านเกาะลาน","บ้านเกาะลิบง","บ้านเกาะแลหนัง","บ้านเกาะวงษ์เกียรติ์ (ชัชวาลอนุสรณ์)","บ้านเกาะวิทยา","บ้านเกาะศรีบอยา","บ้านเกาะสะท้อน","บ้านเกาะสะบ้า","บ้านเกาะสาหร่ายชัยพัฒนา","บ้านเกาะสินไห","บ้านเกาะสุด","บ้านเกาะเสือ","บ้านเกาะหม้อแกง","บ้านเกาะหมาก","บ้านเกาะหมาก (สถิตย์สุทธิวงษ์)","บ้านเกาะหมี","บ้านเกาะหลวง","บ้านเกาะเหลา","บ้านเกาะใหญ่","บ้านเกาะอาดัง","บ้านเกาะอ้ายด้วน","บ้านเกาะฮั่ง","บ้านเกิ้ง","บ้านเกิ้ง (สลากกินแบ่งสงเคราะห์-170)","บ้านเกิ้ง (อส.พป.37)","บ้านเกิ้งน้อย","บ้านเกี๋ยง","บ้านเกี๋ยง ","บ้านเกี๋ยงใต้","บ้านเกียรติ","บ้านเกียรติเจริญ","บ้านแก","บ้านแกประชาสามัคคี","บ้านแก ","บ้านแก่ง","บ้านแก้งสีลารมณ์สามัคคี","บ้านแก้งศรีสว่าง","บ้านแก้ง","บ้านแก้ง (คุรุวิทยานุสรณ์)","แก้งโนนคำประชาสรรค์","บ้านแก้ง2","แก้งกฐินภูจำปา","บ้านแก่งกบ","บ้านแก่งกระทั่ง","บ้านแก่งกอก","บ้านแก้งกอก","บ้านแก้งกะอาม","บ้านแก่งกุลาสามัคคี","บ้านแก่งเกลี้ยง","บ้านแก่งโกสุมท่างาม","บ้านแก้งขอ","บ้านแก้งขิงแคง","บ้านแก้งขี้เหล็ก","บ้านแก่งครก","บ้านแก้งค้อ","บ้านแก่งคันนา","บ้านแก่งเค็ง","บ้านแก่งจอ","บ้านแก่งจูงนาง","บ้านแก่งเจ็ดแคว","บ้านแก่งเจริญ","บ้านแก้งช้างเนียม","บ้านแก้งซาว","บ้านแก่งดินสอ","บ้านแก่งดูกใส","บ้านแก้งเดื่อ","บ้านแก่งโดม","บ้านแก้งตาดไซ","บ้านแก่งโตน","บ้านแก้งโตน","บ้านแก้งใต้","บ้านแก่งทุ่ง","บ้านแก่งน้อย","บ้านแก้งนาคำ","บ้านแก้งนาง","แก้งนาบอนพิทยาสรรค์","บ้านแก้ง-โนนส้มกบ","บ้านแก่งบัวคำ","บ้านแก่งประลอม","บ้านแก่งปลาปก","บ้านแก่งเพกา","บ้านแก่งโพธิ์","บ้านแก่งม่วง","บ้านแก่งมี้","บ้านแก่งยาง","บ้านแก้งยาง","บ้านแก่งยาว","บ้านแก้งยาว","บ้านแก่งระเบิด","บ้านแก้งลิงโคกสว่าง","บ้านแก่งแล่น","บ้านแก่งศรีภูมิ","บ้านแก้งสนามนาง","บ้านแก้งสมบูรณ์","บ้านแก่งสฤษดิ์เสนาอุปถัมภ์","บ้านแก้งสว่าง","บ้านแก่งสะเดา","บ้านแก่งสีเสียด","บ้านแก่งหลวง","บ้านแก่งหลวง (รถไฟราษฎร์บพิธ)","บ้านแก้งหลักด่าน","บ้านแก่งหว้าแก่งไฮ","บ้านแก่งหวาย","บ้านแกงหอม","บ้านแก่งหินกกสะทอน","บ้านแก่งหินปูน","บ้านแก้งเหนือ","บ้านแก้งใหม่","บ้านแก้งอะฮวน","บ้านแก่งไฮ","อนุบาลแกดำ","บ้านแกดำ","บ้านแกท่าวารี","บ้านแก่น","บ้านแก่นเต่า","บ้านแก่นทราย (คุรุราษฎร์ผดุงวิทย์)","บ้านแก่นท้าว","บ้านแก่นท้าว (อโศกวุฒิกรสงเคราะห์)","บ้านแก่นเท่า","บ้านแก่นประดู่","บ้านแก่นฟ้า","บ้านกุดหวาย สาขาแก่นเมธี","บ้านแก่นวิทยา","บ้านแกนาคำ","บ้านแกแม","บ้านแก้ว","บ้านแก่วตาว (นาดี)","บ้านแก่วตาว (อิปุ่ม)","บ้านแก้วปัดโป่ง","บ้านแก้วเพชรพลอย","บ้านแก้วเมธี","บ้านแก้วสุวรรณ","บ้านแกวิทยาคม","บ้านแกวิทยายน","บ้านแกสระใหญ่","บ้านแกหัวแฮดส้มโฮงวิทยา","บ้านแกใหญ่","บ้านแกใหม่นิคม","บ้านโก","บ้านโก้งโค้ง","บ้านโกตา","บ้านโกตาบารู","บ้านโกทา","บ้านโกน้อย","บ้านโก่ย","บ้านโกรก","บ้านโกรกกระหาด","บ้านโกรกกุลา","บ้านโกรกแก้ว","บ้านโกรกขี้หนู","บ้านโกรกช้างน้อย","บ้านโกรกเดือนห้า","บ้านโกรกตารอด","บ้านโกรกไม้แดง","บ้านโกรกรกฟ้า","บ้านโกรกลึก","บ้านโกรกสำโรง","บ้านโกรกสิงขร","บ้านโกรกหว้า","บ้านโกสัมพี (วิเศษน้อมมิตรอนุกูล)","บ้านไก่คำ","บ้านไก่นา","บ้านไก่ป่า","บ้านไกลเสนียด","บ้านขึ่งงามมงคล","บ้านขจัดภัย","บ้านขนวน","บ้านขนวนจานสามัคคี","บ้านขนวน (คุรุประชาสรรค์)","บ้านขนวนนคร","บ้านขนวนสีแก้ว","บ้านขนา","บ้านขนาด","บ้านขนาดมอญ","บ้านขนายดี (ประชารัฐบำรุง)","บ้านขนุน","บ้านขนุน (วันธรรมศาสตร์ศรีสะเกษ 2515)","บ้านขมวด","บ้านขมิ้น","บ้านขมิ้น สาขาภูเงิน","บ้านขมิ้น (เรืองราษฎร์รังสรรค์)","บ้านขมิ้นจานทุ่ง","บ้านขมิ้นโนนหัวนา","บ้านขมิ้นบ่อโคลน","ขมิ้นพัฒนวิทย์","บ้านขยอง","สตรีวิทยาสมาคม","บ้านขยูงทองยางภิรมย์","บ้านขลอด","บ้านขลุงไผ่","บ้านข่วงเปาใต้","บ้านขวดน้ำมัน","บ้านขวัญพัฒน์","บ้านขวาง (น้อมประชานุกูล)","บ้านขว้างคลีชูชาติ","บ้านขว้างท่าสะแบง","บ้านขว้างวิทยากร","บ้านขว้างใหญ่","บ้านขวาน้อย","ขวาวคุรุราษฎร์ประชาสรรค์","บ้านขวาว","บ้านขวาวใหญ่","บ้านข้องโป้","บ้านขอน","บ้านขอนกองโพนทอง","บ้านขอนแก่นโนนสวรรค์","บ้านขอนแก่น","บ้านขอนแก่น (นิกรราษฎร์ศรัทธาคาร)","บ้านขอนแก่นตะคุ","บ้านขอนแก่นหนองบอน","บ้านขอนขว้าง","บ้านขอนคลาน","บ้านขอนซุง","บ้านขอนแดง","บ้านขอนตาล","บ้านขอนแต้","บ้านขอนแตก","บ้านขอนแป้น","บ้านขอนยาง","บ้านขอนยูง","บ้านขอนสองสลึง","ขอนสักตอประดู่ระหอกโพธิ์","บ้านขอนสักรัฐราษฎร์บำรุง","บ้านขอนหาด","บ้านขอบด้ง","บ้านขอบเหล็ก","บ้านขอม","บ้านข่อย","บ้านข่อยโทน","บ้านข่อยมิตรภาพที่ 110","บ้านข่อยสองนาง","บ้านข่อยสูง","บ้านขอวิทยา","บ้านขะเนก","บ้านขะเนจื้อ","บ้านขะยูง","บ้านขะยูง (ขะยูงศิลป์ศึกษา)","บ้านขะยูง (โนนเจริญศึกษา)","บ้านขัดเค้า","บ้านขัน","บ้านขั้นไดใหญ่โนนค้อ","บ้านขันหมู่","บ้านขัวก่าย","บ้านขัวขอนแคน","บ้านขัวแคน","บ้านขัวแคร่","บ้านขัวไม้แก่น (มหิดลอนุสรณ์ 3)","บ้านขัวล้อ","บ้านขัวสูง","บ้านข่า","บ้านข่าโคม","บ้านข่าเชียงพิน","บ้านข่าดอนเข็ม","บ้านขาทรายมะเขือสามัคคี","บ้านข่าทุ่งม่วงโนนศรีสมบูรณ์","บ้านข่าน้อย","บ้านขาม","บ้านขามโพนทัน","บ้านขาม (ขามเขตวิทยาคาร)","บ้านขาม (สำนักงานสลากกินแบ่งสมทบ)","บ้านขามขุนร่ม ","บ้านขามคุรุราษฎร์อุปถัมภ์","บ้านขามฆ้อง","บ้านขามชั่งโค","บ้านขามเฒ่ากุดข้าวปุ้น (ราษฎร์อุทิศ)","บ้านขามเฒ่า","บ้านขามเดื่อราษฎร์สงเคราะห์","บ้านขามตาเบ้า","บ้านขามเตี้ยน้อย","บ้านขามเตี้ยใหญ่","บ้านขามใต้","บ้านขามทะเลสอ","บ้านขามทับขอน","บ้านขามน้อย","ขามนาเพียงโคกยาว","บ้านขามป้อม","บ้านขามป้อม (สังวาลย์อนุสรณ์)","บ้านขามป้อมชานบึงโพธิ์ทอง (สำนักงานสลากกินแบ่งสงเคราะห์ 86)","บ้านขามป้อมดงเย็น","บ้านขามป้อมราษฎร์นุกูล","บ้านขามเปี้ย","บ้านขามพิมาย","บ้านขามระกา","บ้านขามราษฎร์นุกูล","บ้านขามราษฎร์วิทยาคม","บ้านขามเรียงเขียบโนนแสบงดอนมัน","บ้านขามเรียน","บ้านขามวิทยาคม","บ้านขามเวียน","บ้านขามศึกษาคาร","บ้านขามสามัคคี","บ้านขามเสม็ดบำรุง","บ้านขามหนองครอง","บ้านขามหนองแวง","บ้านขามใหญ่","บ้านขาว","บ้านข้าวแป้ง","บ้านข้าวสาร","บ้านขาวัว","บ้านขาแหย่งพัฒนา","บ้านขี้ตุ่น (แหล่งจะหลุง)","บ้านขี้นาก (ศรีธรรมวัฒน์ราษฎร์อนุกูล)","บ้านขี้นาค","บ้านขีศรีสง่าโนนเสียว","บ้านขีหนองจิก","บ้านขี้เหล็ก","บ้านขี้เหล็กดอยดินแดง","บ้านขี้เหล็กขี้ตุ่นหลุบเปลือย","บ้านขี้เหล็ก 'คุรุราษฎร์บำรุง'","บ้านขี้เหล็กคำเจริญ","บ้านขี้เหล็ก (อสพป.40)","บ้านขี้เหล็กเขียวไพรวัลย์วิทยา","บ้านขี้เหล็กซ้ายดอนแตง","บ้านขี้เหล็กดงเค็งวิทยา","บ้านขี้เหล็กโนนจาน","บ้านขี้เหล็กบุ่งเบาสามัคคี","บ้านขี้เหล็กเหล่าสมบูรณ์","บ้านขี้เหล็กใหญ่","บ้านขุน","บ้านขุนกลาง","บ้านขุนกำลัง","บ้านขุนแจ๋","บ้านขุนชำนาญ","บ้านขุนไชยทอง","บ้านขุนด่าน","บ้านขุนตื่น","บ้านขุนแตะ","บ้านขุนทะเล","บ้านขุนนาวัง","บ้านขุนน้ำคับ","บ้านขุนน้ำน่าน","บ้านขุนแปะ","บ้านขุนฝาง","บ้านขุนภูมิ","บ้านขุนแม่ต้อบ","บ้านขุนแม่ตื่นน้อย","บ้านขุนแม่นาย","บ้านขุนแม่บง (ตชด.)","บ้านขุนแม่รวม","บ้านขุนแม่ลา","บ้านขุนแม่หยอด","บ้านขุนยะ","บ้านขุนราษฎร์","บ้านขุนลาว","บ้านขุนวง","บ้านขุนวงเหนือ","บ้านขุนศรี","บ้านขุนสมุทร","บ้านขุนสมุทรไทย (จ้อย อบเชยอุทิศ)","บ้านขุนสรวย","บ้านขุนสาใน","บ้านขุนห้วย","บ้านขุนห้วยไคร้","บ้านขุนห้วยช่องแคบ","บ้านขุนห้วยนกแล","บ้านขุนห้วยแม่ต้าน","บ้านขุนห้วยแม่ท้อ","บ้านขุนหาญ","บ้านขุนแหง","บ้านขุมขี้ยาง","บ้านขุมคำ","ขุมคำวิทยา (สำนักงานสลากกินแบ่งสงเคราะห์ 673)","บ้านขุมเงิน","บ้านขุมเงิน (ราษฎร์สามัคคีวิทยา)","บ้านขุมดิน","บ้านขุมดินสว่างประชานุกูล","บ้านขุมปูน","บ้านขุมเหล็ก","บ้านขุยวิทยา","บ้านเข็ก","บ้านเข็กน้อย","บ้านเข็กใหญ่","บ้านเข็งมิตรภาพที่ 139","บ้านเขตเมือง","บ้านเข็มทอง","บ้านเขวา","บ้านเขวาสะดืออีสาน","บ้านเขว้า","บ้านเขวา (รัฐประชาวิทยากร)","บ้านเขวา (ราษฎรพัฒนา)","บ้านเขวา (เทพอนุสรณ์)","บ้านเขวาค้อโคกกลาง","บ้านเขวาโคกสวายโดด","บ้านเขวาโดนแหย่งสามัคคี","บ้านเขวาตะคลอง","บ้านเขวาทุ่ง","บ้านเขวาธะนัง","บ้านเขวาไร่ (ดรุณวิทยา)","บ้านเขว้าวิทยา","บ้านเขว้าศึกษา","อนุบาลเขวาสินรินทร์","บ้านเขวาหรดี","บ้านเขวาใหญ่","บ้านเขวิก","บ้านเขากรวด","บ้านเขากระโดง (ศิลาทองอุปถัมภ์)","บ้านเขากระแต","บ้านเขากระปุก","บ้านเขากลิ้ง","บ้านเขากวางทอง","บ้านเขากอบ","บ้านเขากะลา","บ้านเขากำแพง","บ้านเขาเกล็ด","บ้านเขาแก้ว","บ้านเขาแก้ววิทยา","บ้านเขาขวาง","บ้านเขาข่า","บ้านเขาขาด","บ้านเขาเขียว","บ้านเขาคณฑา","บ้านเขาคราม (ศรีจันทร์อุทิศ)","บ้านเขาคลองซอง","บ้านเขาคลัง","บ้านเขาคอก","บ้านเขาคันทรง","บ้านเขาค้างคาว","บ้านเขาค่าย","บ้านเขาคีริส","บ้านเขาแค","บ้านเขาไคร","บ้านเขางาม","บ้านเขาแงน","บ้านเขาจั๊กจั่น","บ้านเขาจันทน์หอม","บ้านเขาจันทร์","บ้านเขาจาน","บ้านเขาจีน","บ้านเขาช่อง","บ้านเขาช่องลม","บ้านเขาชะโงก","บ้านเขาชะอางคร่อมคลอง","บ้านเขาชันโต๊ะ","บ้านเขาช้าง","บ้านเขาช้างฟุบ ","บ้านเขาชานหมาก","บ้านเขาชีจรรย์","บ้านเขาซก","บ้านเข้าซ้อน","บ้านเขาเฒ่า","บ้านเขาด้วน","บ้านเขาดิน","บ้านเขาดิน (ประชานุกูล)","บ้านเขาดิน (ประชาอุทิศ)","บ้านเขาดิน (แสงสว่างวิทยา)","บ้านเขาดินใต้","บ้านเขาดินทอง","บ้านเขาดินประชาพัฒน์","บ้านเขาดินไพรวัน","บ้านเขาดินวังตาสี","บ้านเขาดินเหนือ","บ้านเขาแดง","บ้านเขาตก ","บ้านเขาตลาด","บ้านเขาตอก","บ้านเขาตะกรุบพัฒนา","บ้านเขาตะแคง","บ้านเขาตะแบก","บ้านเขาตะเภาทอง","บ้านเขาตั้ง","บ้านเขาตันหยง (มิตรภาพที่ 153)","บ้านเขาตากุน","บ้านเขาตาง้อก","บ้านเขาตาว","บ้านเขาตาสัก","บ้านเขาตาอิ๋น","บ้านเขาตำบล","บ้านเขาตูม","บ้านเขาเตียน มิตรภาพที่ 134","บ้านเขาถ่าน","บ้านเขาถ้ำ","บ้านเขาถ้ำพระ","บ้านเขาทราย","บ้านเขาทอง","บ้านเขาทองผางับ","บ้านเขาทองหลาง","บ้านเขาทะลุ","บ้านเขาทับควาย","บ้านเขาเทพพิทักษ์","บ้านเขาเทียมป่า","บ้านเขาธรรมบท","บ้านเขานกยูง","บ้านเขานมนาง","บ้านเขาน้อย","เทศบาลบ้านเขาน้อย","บ้านเขาน้อยสามัคคี","บ้านเขานันทา","บ้านเขานางต่วม","บ้านเขานางสางหัว","บ้านเขานางหงส์","บ้านเขานาใน","ชุมชนบ้านเขาน้ำโจน","บ้านเขาน้ำเพชร","บ้านเขาน้ำอุ่น","บ้านเขานิพันธ์","บ้านเขาบ่อ","บ้านเขาบ่อทอง","บ้านเขาบายศรี","บ้านเขาปิหลาย","บ้านเขาปู่","บ้านเขาปูน","บ้านเขาเปาะ","บ้านเขาโป่ง","บ้านเขาผาลาด","บ้านเขาฝาก","บ้านเขาฝาชี","บ้านเขาฝ้าย","บ้านเขาพญาปราบ","บ้านเขาพนม","บ้านเขาพรมสุวรรณ","บ้านเขาพระ","บ้านเขาพระอินทร์","บ้านเขาพระเอก","บ้านเขาพริกไทย","บ้านเขาพริกอนุสรณ์","บ้านเขาพรุเสม็ด","บ้านเขาพลวง","บ้านเขาพลัด","บ้านเขาพัง","บ้านเขาพาง","บ้านเขาเพิ่ม","บ้านเขาฟ้า","บ้านเขาภูมิ่ง","บ้านเขามะกา","บ้านเขามะเกลือ","บ้านเขามะปริง","บ้านเขามัน","บ้านเขามุสิ","บ้านเขาแม่กระทู้","บ้านตะแบกงาม สาขาบ้านธารมะยม","บ้านเขาไม้เกวียน","บ้านเขาไม้แก้ว","บ้านเขาไม้เดน","บ้านเขาไม้ไผ่","บ้านเขายวนเฒ่า","บ้านเขาย้อย","บ้านเขายางโปร่ง","บ้านเขายายกะตา","บ้านเขายายชุม","บ้านเขายาวราษฎร์พัฒนา","บ้านเขารวก","บ้านเขารวก (ร่วมมิตรพัฒนา)","บ้านเขารักเกียรติ","บ้านเขารักษ์","บ้านเขาราบ","บ้านเขาราวเทียนทอง (ประดิษฐ์ราษฎร์อุปถัมภ์)","บ้านเขาแรต","บ้านเขาล้อ (เขาล้อประชาชนูทิศ)","บ้านเขาล่อม","บ้านเขาลอย","บ้านเขาล้าน","บ้านเขาลูกโล่","บ้านเขาเลี้ยว","บ้านเขาเลื่อม","บ้านเขาโล้น","บ้านเขาวง","บ้านเขาวงกรด","บ้านเขาวัง","บ้านเขาวังแก้ว","บ้านเขาวังทอง","บ้านเขาวังม่าน","บ้านเขาวังเยี่ยม","บ้านเขาศาลา","บ้านเขาสมโภชน์","บ้านเขาสมอแคลง (ริ้วศิริวัฒน์อุปถัมภ์)","บ้านเขาสว่างอารมณ์","บ้านเขาส่องกล้อง","บ้านเขาสะท้อน","บ้านเขาสะพานนาค","บ้านเขาสัก","บ้านเขาสัตตพรหม","บ้านเขาสามชั้น","บ้านเขาสามสิบ","บ้านเขาสามหน่วย","บ้านเขาสาลิกา","บ้านเขาสูงราษฎร์บำรุง","บ้านเขาหมูมัน","บ้านเขาหลัก","บ้านเขาห้วยมะหาด","บ้านเขาหวาย","บ้านเขาหอม","บ้านเขาหัวช้าง","บ้านเขาหัวนา","บ้านเขาหิน","บ้านเขาหินกลิ้ง","บ้านเขาหินซ้อน (พัฒนาการภาคตะวันออก)","บ้านเขาหินตั้ง","บ้านเขาหินแท่น","บ้านเขาแหลม","บ้านเขาใหญ่ (อุดมธรรมรสอุปถัมภ์)","บ้านเขาใหญ่","บ้านเขาอ่างแก้ว","บ้านเขาอำนวยสุข","บ้านเขาอีส้าน","บ้านเขาโอน","บ้านเขียะ","บ้านเขือง","บ้านเขื่องคำ","บ้านเขื่อน (ท่าพระประชาสรรค์)","บ้านเขื่อน (เขื่อนศึกษาคาร)","บ้านเขื่อนผาก","บ้านเขื่อนลั่น","บ้านเขื่อนสุนทร (รัฐประชาวิทยา)","บ้านเขือน้ำ","บ้านแข้","บ้านแข้ (เจริญราษฎร์วิทยา)","บ้านแข็งขยัน","บ้านแข้ด่อน-หนองบัว","บ้านแข้ด่อน","บ้านแขนท้าว","บ้านแขนนาง","บ้านแข่โพนเมือง","บ้านแขม","บ้านแขม (ธรรมเสนานุสรณ์)","บ้านแขมเจริญ","บ้านแขมใต้","บ้านแขมโพนทอง","บ้านแขมเหนือ","บ้านแขยง","บ้านแขว","บ้านแขวงกลั่น (จี๊ด น้อยใจบุญ บำรุง 2)","บ้านแขวงเภา","บ้านโขงกุดหวาย","บ้านโขงใหญ่","บ้านโขดทราย","บ้านโขมงหัก","บ้านคกงิ้ว","บ้านคกไผ่","บ้านคกมาด","บ้านคกเลา","บ้านคกเว้า","บ้านคงคาล้อม","บ้านคชศิลา","บ้านคชาธาร","บ้านคดศอก","บ้านคนชุม","บ้านครกคำ","บ้านครบุรีนครธรรมโฆสิตวิทยาคาร","บ้านครบุรีศึกษา","บ้านคร้อห้วยชัน (แย้มมงคลสินธุ์)","บ้านครั่ง","บ้านครัว (ซิเมนต์ไทยสงเคราะห์)","บ้านครึ่งใต้","บ้านครึ่ง","บ้านครึมม่วง","บ้านคล้อโคกกว้าง","บ้านคลอง","บ้านคลอง 1","บ้านคลอง 14","บ้านคลอง 21","บ้านคลอง 22 (อาจเอิบจิตรอุปถัมภ์)","บ้านคลอง 23","บ้านคลอง 24","บ้านคลอง 3 (ดรุณศึกษา)","บ้านคลอง 3 วิทยา (ประชาสามัคคี)","บ้านคลอง 30","บ้านคลอง 31","บ้านคลอง 33","บ้านคลองกรวด","บ้านคลองกระจังวังไทร","บ้านคลองกระทุ่มแบน","บ้านคลองกรำ","บ้านคลองกรูด","บ้านคลองกล้วย","บ้านคลองกลอยมิตรภาพที่ 82","บ้านคลองกลาง","บ้านคลองกลุ่ม","บ้านคลองกวางเขาวัง","บ้านคลองกะชี","บ้านคลองกะโบน","บ้านคลองกะพง","บ้านคลองกะพั้ว","บ้านคลองกั่ว","บ้านคลองกา","บ้านคลองกำ","บ้านคลองกำลัง","บ้านคลองกุ่ม","บ้านคลองกุย","บ้านคลองเกตุ","บ้านคลองแก้มช้ำ","บ้านคลองไก่เถื่อน","บ้านคลองขนุน","บ้านคลองขวางบน","บ้านคลองของ","บ้านคลองข่อย","บ้านคลองขัน","บ้านคลองขามป้อม","บ้านคลองขุด","บ้านคลองเขม้า","บ้านคลองเขาล้อน","บ้านคลองแขยง","บ้านคลองแขยงวิทยา","บ้านคลองคต","บ้านคลองครก","บ้านคลองคราม","บ้านคลองคล้า","บ้านคลองคันฉอ","บ้านคลองคุ้ย","บ้านคลองเค็ม","บ้านคลองเคียน","บ้านคลองแค","บ้านคลองแคว","บ้านคลองโค","บ้านคลองไคร","บ้านคลองงา","บ้านคลองเงิน","บ้านคลองแงะ","บ้านคลองแงะ (ชาติบุณยวิทยาคาร) มิตรภาพที่ 230","บ้านคลองจัง (วรรณ-สิงห์ อุทิศ)","บ้านคลองจัน","บ้านคลองจันลา","บ้านคลองจาก","บ้านคลองจินดา","บ้านคลองเจริญ","บ้านคลองเจ้า (เสนะวัตราษฎร์วิทยา)","บ้านคลองเจ้า","บ้านคลองเจ้าเมือง","บ้านคลองเจ้าแรง","บ้านคลองชะโด","บ้านคลองชะนี","บ้านคลองชะมวง","บ้านคลองชะอม","บ้านคลองชะอุ่น","บ้านคลองช้าง","บ้านคลองชายธง","บ้านคลองชีล้อม","บ้านคลองซับน้อยสามัคคี","บ้านคลองซื่อ","บ้านคลองดิน","บ้านคลองดินดำ","บ้านคลองดินเหนียว","บ้านคลองดู่","บ้านคลองเดื่อ","บ้านคลองตกวิทยา","บ้านคลองต่อ (ทวีรัตน์อุปถัมภ์)","บ้านคลองตะขาบ","บ้านคลองตะเข้","บ้านคลองตะคร้อ","บ้านคลองตะเคียน","บ้านคลองตะเคียน หมู่ 2 (วันครู 2504)","บ้านคลองตะแบก","บ้านคลองตะพานหิน","บ้านคลองตักน้ำ","บ้านคลองตัน","บ้านคลองตาคง","บ้านคลองตางาว","บ้านคลองตาเพชร","บ้านคลองตามั่น","บ้านคลองตาล(กระจ่างจินดา)","บ้านคลองตาหมื่น","บ้านคลองต่ำ","บ้านคลองตีนเป็ด","บ้านคลองตูก","บ้านคลองเต็ง","บ้านคลองเตย","บ้านคลองเตยโนนพยอมประชาสรรค์","บ้านคลองเตาะ","บ้านคลองโตน","บ้านคลองโตนด","บ้านคลองโต๊ะนุ้ย","บ้านคลองทราย","บ้านคลองทราย ","บ้านคลองทรายขาว","บ้านคลองทรายราษฎร์อุทิศ","บ้านคลองทรายใหญ่","บ้านคลองท่อมเหนือ","บ้านคลองท่าแตง","บ้านคลองทำเนียบ","บ้านคลองทิพย์","บ้านคลองทุเรียน","บ้านคลองไทร","บ้านคลองไทรพัฒนา","บ้านคลองธรรมชาติ","บ้านคลองนกกระทุง (ศรีเล็กดีวิทยาคาร)","บ้านคลองนกกระทุง (เรียงราษฎร์อุทิศ 2)","บ้านคลองน้อย","บ้านคลองนางาม","บ้านคลองนามิตรภาพที่ 201","บ้านคลองน้ำเขียว","บ้านคลองน้ำคัน","บ้านคลองน้ำเค็ม","บ้านคลองน้ำโจน","บ้านคลองน้ำโจน สาขาบ้านสระหลวง","บ้านคลองน้ำแดง","บ้านคลองน้ำเป็น","บ้านคลองน้ำเย็น","บ้านคลองน้ำใส (บุญประชานุกูล)","บ้านคลองน้ำใส","บ้านคลองน้ำไหลใต้","บ้านคลองนิน","บ้านคลองบง","บ้านคลองบอน","บ้านคลองบัว (เอี่ยมแสงโรจน์)","บ้านคลองบางกก","บ้านคลองบางกระจัน","บ้านคลองบางไซ","บ้านคลองบางบ่อ","บ้านคลองบางไผ่","บ้านคลองบุหรี่","บ้านคลองใบพัด","บ้านคลองประดู่","บ้านคลองประทุน","บ้านคลองประสงค์","บ้านคลองปราบ","บ้านคลองปริง","บ้านคลองปลาโด","บ้านคลองปลายนา และสาขาบ้านไผ่ขวาง","บ้านคลองปลาสร้อย","บ้านคลองปลาหมอ","บ้านคลองปอม","บ้านคลองปะเหลียน","บ้านคลองปัญญา","บ้านคลองป่าไม้","บ้านคลองปิ้ง","บ้านใหม่เจริญสุข สาขาบ้านคลองปิ่นโตประชาสามัคคี","บ้านคลองปีก","บ้านคลองเป็ด","บ้านคลองเปล (สุนทรอุปถัมภ์)","บ้านคลองโป่ง","บ้านคลองผักขม","บ้านคลองไผ่","บ้านคลองไผ่งาม","บ้านคลองฝรั่ง (บัวเอี่ยมพิทยากร)","บ้านคลองพระพิมล","บ้านคลองพระมอพิสัย","บ้านคลองพระยา","บ้านคลองพร้าว","บ้านคลองพลูประชาสรรค์","บ้านคลองพวนประทีปบำรุง","บ้านคลองพังกลาง","บ้านคลองพา","บ้านคลองเพชรสวาย","บ้านคลองโพธิ์พัฒนา","บ้านคลองไพร","บ้านคลองมดแดง","บ้านคลองมดแดง สาขาบ้านใหม่ชุมนุมไทร","บ้านคลองม่วง","บ้านคลองม่วงเหนือ","บ้านคลองมวน","บ้านคลองมหาสวัสดิ์ (ตั้งตรงจิตร 17)","บ้านคลองมอญ","บ้านคลองมะขาม","บ้านคลองมะค่าหิน","บ้านคลองมะนาว","บ้านคลองมะไฟ","บ้านคลองมะละกอ","บ้านคลองมานิง","บ้านคลองมือไทร (สว่างไสวราษฏร์บำรุง)","บ้านคลองเมือง","บ้านคลองไม้แดง","บ้านคลองยวน","บ้านคลองยา","บ้านคลองยา (เจริญราษฎร์สามัคคี)","บ้านคลองยาง","บ้านคลองยาง (มูลบนอุปถัมภ์)","บ้านคลองยางประชาสรรค์","บ้านคลองยายเมือง","บ้านคลองยายสร้อย","บ้านคลองยายอินทร์","บ้านคลองย่าหนัด","บ้านคลองโยง","บ้านคลองร่วม","บ้านคลองรอก","บ้านคลองระ","บ้านคลองระกำ","บ้านคลองรั้ว","บ้านคลองราง","บ้านคลองเรียงงาม","บ้านคลองเรือ","บ้านคลองแร่","บ้านคลองแรด","บ้านคลองโร","บ้านคลองลอย","บ้านคลองละมุง","บ้านคลองละวาน","บ้านคลองลัดอ้อมใหญ่","บ้านคลองลาน","บ้านคลองลาว","บ้านคลองลำปริง","บ้านคลองลึกพัฒนา","บ้านคลองลุ","บ้านคลองวัง","บ้านคลองวังทอง","บ้านคลองวัว","บ้านคลองวาฬ","บ้านคลองศรีเมือง","บ้านคลองศอก (เพิ่มประชาราษฎร์อุปถัมภ์)","บ้านคลองสง","บ้านคลองสงค์","บ้านคลองสมบูรณ์","บ้านคลองสมบูรณ์ สาขาบ้านคลองสมุย","บ้านคลองสระ","บ้านคลองสว่างอารมณ์","บ้านคลองสอง","บ้านคลองสอง (ราษฎร์บำรุง)","บ้านคลองสองปาก","บ้านคลองสะแกป่าหวาย","บ้านคลองสะท้อน","บ้านคลองสะพานช้าง","บ้านคลองสัก","บ้านคลองสาย","บ้านคลองสาร","บ้านคลองสารเพชร","บ้านคลองสาริกา","บ้านคลองสำราญ","บ้านคลองสำโรง","บ้านคลองสำอางค์","บ้านคลองสิบแปด","บ้านคลองสิบสอง","บ้านคลองสิบสาม","บ้านคลองสีนวล","บ้านคลองสีฟัน","บ้านคลองสุข","บ้านคลองสุขใจ","บ้านคลองสุด (ประชาอุทิศ)","บ้านคลองสูบ","บ้านคลองเสาเหนือ","บ้านคลองเสือ","บ้านคลองไส","บ้านคลองหกวา","บ้านคลองหนึ่ง","บ้านคลองหมาก","บ้านคลองหมากนัด","บ้านคลองหมี","บ้านคลองหลวง","บ้านคลองห้วยทราย","บ้านคลองห้วยนา","คลองห้วยนาพัฒนาการ","บ้านคลองห้วยยั้ง","บ้านคลองห้วยหลัว","บ้านคลองหวะ (ทวีรัตน์ราษฎร์บํารุง)","บ้านคลองหว้า","บ้านคลองหวาย","บ้านยางเอน","บ้านคลองหวายเล็ก","บ้านคลองหอยโข่ง","บ้านคลองหันแดง","บ้านคลองห้า (ราษฎร์บำรุง)","บ้านคลองห้าง","บ้านคลองหาด","บ้านคลองหาเหนือ","บ้านคลองหิน","บ้านคลองหินปูน","บ้านคลองหินร่อง","บ้านคลองเหนก","บ้านคลองเหลง","บ้านคลองเหีย","บ้านคลองแห้ง","บ้านคลองแห้งวิทยา","บ้านคลองโหยน","บ้านคลองใหญ่","บ้านคลองใหญ่ใต้","บ้านคลองใหม่ (พรเอิบดิลกราษฎร์บำรุง)","บ้านคลองอุดม","บ้านคลองอุดมสุข","บ้านคลองแอ่ง","บ้านคลองโอ่ง","บ้านคลองโอม","บ้านคล้อมิตรภาพที่ 226","บ้านคลอแระ","บ้านคล้าโนนคราม","บ้านคลีกลิ้ง","บ้านควน","บ้านควนกบ","บ้านควนกลาง","บ้านควนกองเมือง","บ้านควนกุฎ","บ้านควนเก","บ้านควนเกาะจันทร์","บ้านควนขนุน","บ้านควนขัน","บ้านควนขี้แรด","บ้านควนคง","บ้านควนคีรีวงศ์","บ้านควนคูหา","บ้านควนเคี่ยม","บ้านควนโคกยา","บ้านควนเงิน","บ้านควนจง","บ้านควนจำปา","บ้านควนเจดีย์","บ้านควนเจริญ","บ้านควนชิง","บ้านควนดิน","บ้านควนดินแดง","บ้านควนดินสอ (กรป.กลางอุปถัมภ์)","บ้านควนแดง","บ้านควนตม","บ้านควนต่อ","บ้านควนตะวันออก","บ้านควนตัง","บ้านควนตานี","บ้านควนตีหมุน","บ้านควนตุ้งกู","บ้านควนแตน","บ้านควนโตน","บ้านควนใต้","บ้านควนทอง (ประชาอุทิศ)","บ้านควนไทรงาม","บ้านควนนกหว้า","บ้านควนนา","บ้านควนนิมิต","บ้านควนนิยม","บ้านควนเนียง","บ้านควนเนียงใน","บ้านควนโนรี","บ้านควนประ","บ้านควนประกอบ","บ้านควนประชาสรรค์","บ้านควนปริง","บ้านควนแปลงงู","บ้านควนพญา","บ้านควนพนางตุง (สินประชา)","บ้านควนพระสาครินทร์","บ้านควนพรุพี","บ้านควนพลี","บ้านควนพัฒนาประชาสรรค์","บ้านควนโพธิ์","บ้านควนฟ้าแลบ","บ้านควนม่วง","บ้านควนมหาชัย","บ้านควนมิตร","บ้านควนมุด","วัดควนเมา","บ้านควนไม้ดำ","บ้านควนไม้ไผ่","บ้านควนยวน","บ้านควนยอ","บ้านควนยาง","บ้านควนยูง","บ้านควนรา","บ้านควนราชา","บ้านควนรุย","บ้านควนแรด","บ้านควนล่อน","บ้านควนลังงา","บ้านควนลาแม","บ้านควนลำภู","บ้านควนเลียบ (วัดควนเลียบ)","บ้านควนสตอ","บ้านควนสระ","บ้านควนสระแก้ว","บ้านควนสวรรค์","บ้านควนสว่างวัฒนา","บ้านควนสะตอ","บ้านควนสามัคคี","บ้านควนสินชัย","บ้านควนสุวรรณ","บ้านควนสูง","บ้านควนเสม็ด","บ้านควนโส","บ้านควนหนองกก","บ้านควนหนองยาง","บ้านควนหนองหงส์","บ้านควนหมอทอง","บ้านควนหมาก","บ้านควนหยี","บ้านควนหรัน","บ้านควนหัวช้าง","บ้านควนหินแท่น","บ้านควนแหวง","บ้านควนใหม่","บ้านควนอวดพัน","บ้านควนอารี","บ้านควนอินทนินงาม","บ้านควนอินนอโม","บ้านควนโอ","บ้านควร","บ้านค้อ","บ้านค้อ (เคนราษฎร์บำรุง)","บ้านค้อปัญญานุสรณ์","บ้านค้อ (ธัญญวิทยาคาร)","ค้อใหญ่ชัยยุทธวิทยา","บ้านคอกควาย (สันติภาพคุรุราษฎร์พัฒนา)","บ้านคอกควายหนองแห้ววิทยา","บ้านคอกคีแสนตอ","บ้านคอกช้าง","บ้านคอกช้างพัฒนา","บ้านคอกม้า","บ้านคอกวัว","บ้านคอกหนองไพร","บ้านค้อกำแพง","บ้านค้อกุดจอก","บ้านค้อกุดลาด","บ้านค้อเขียวพิทยาภูมิ","บ้านคอโค","บ้านคอดยาง","บ้านค้อดอนแคน","บ้านคอเตี้ย","บ้านค้อใต้","บ้านค้อทอง (อำไพพิทยาคาร)","บ้านค้อท่อนน้อย","บ้านคอนกาม","บ้านคอนฉิม","บ้านคอนน้อย","บ้านคอนเมือง","บ้านคอนเลียบ","บ้านคอนสวรรค์","บ้านคอนสวรรค์สินเจริญ","บ้านคอนสา","บ้านคอนสาย","บ้านคอนสาร","บ้านค้อน้อย","บ้านค้อโนนเพ็ก","บ้านค้อโนนสว่าง","บ้านค้อบอน","บ้านคอปล้อง","บ้านคอพรุ","บ้านค้อโพนสวางยางชุม","บ้านค้อเมืองแสน","บ้านค้อยางปอ (อสพป.35)","บ้านค้อราษฎร์บำรุงวิทยา","บ้านคอลอกาเว","บ้านคอลอตันหยง","บ้านคอลอมุดอ","บ้านคอแลน","บ้านคอสน","บ้านค้อแสนสี","บ้านคอหงษ์","บ้านค้อเหนือค้อใต้ดอนกลาง","บ้านค้อใหญ่","บ้านคอเอน","บ้านคะนา","บ้านคะนาสามัคคี","บ้านคะแนง","บ้านคะปวง","บ้านคั่นกระได","บ้านคันชา","บ้านคันท่าเกวียน","บ้านคันแท","บ้านคันธง","บ้านคันธทรัพย์","บ้านคันธาร์","บ้านคันธุลี","บ้านคันเปือย","บ้านคันพะลาน","บ้านคันไร่ (อาภากโรคุรุราษฎร์)","บ้านคันสูง","บ้านคับพวง","บ้านคัวะ","บ้านค่า","บ้านค้างใจ","บ้านค้างตะนะวิทยา","บ้านค้างปินใจ","บ้านค้างพลู","บ้านค้างภิบาล","บ้านค้างอ้อย","บ้านคางฮุง","บ้านคางฮุงไข่นุ่นโนนศึกษา","บ้านคางฮุงเจริญศิลป์","บ้านค่างาม (อัตตราษฎร์บำรุง)","บ้านคาโต","บ้านคานหักโนนใหญ่ (ศิริเกตุประชาวิทย์)","บ้านคาบ","บ้านค่าบน","บ้านค่าย","บ้านค่ายเจริญ","บ้านค่ายทะยิง","บ้านค่ายนุ่นโนนแคน","บ้านค่ายรวมมิตร","บ้านค่ายหางเรียง","บ้านคาละแมะ","บ้านคาหาน","บ้านคำน้ำทิพย์","บ้านโคกกลาง","บ้านคำกลาง","บ้านคำกลางคำสมบูรณ์","บ้านคำกลางวังม่วง","บ้านคำกลิ้ง","บ้านคำก้าว","บ้านคำกุงหนองอิดุม","บ้านคำเกิ่ง","บ้านคำเกิ่งหนองจิก","บ้านคำเกิด","บ้านคำเกิ้ม","บ้านคำแก่นคูณ","บ้านคำแก้วโนนสามัคคี","บ้านคำแก้ว","บ้านคำขวาง","บ้านคำข่า","บ้านคำเขือง","บ้านคำเขื่อนแก้ว","บ้านคำแขนศอก","บ้านคำครตา","บ้านคำครั่ง","บ้านคำครึ่ง","บ้านคำแคน","บ้านคำแคนแก่นคูณ","บ้านคำแคนคำเจริญ","บ้านคำโคกสูง","บ้านคำโคนสว่าง","บ้านคำจวง","บ้านคำจั่น (ปาสานะเตนุสรณ์)","บ้านคำจำปา","บ้านคำเจริญ","บ้านคำเจริญราษฎร์บำรุง","บ้านคำเจริญสามแยกราษฎร์บำรุง","บ้านคำชนดงต้อง","บ้านคำชะอี","บ้านคำเชียงวัน","บ้านคำไชยวาน","บ้านคำไชยวาล","บ้านคำโซ่","บ้านคำด้วง","บ้านคำดอกไม้","บ้านคำดู่","บ้านคำเดือย","บ้านคำแดง","บ้านคำตอยูง","อนุบาลคำตากล้า","บ้านคำตานา (อรัญวาสวิทยา)","บ้านคำเตย (คำเตยราษฎร์ร่วมจิต)","บ้านคำเตย","บ้านคำเต้าแก้วหินลาด","บ้านคำเตาะเลาะโนนเค็ง","บ้านคำนกกก","บ้านคำน้อย","บ้านคำนางปุ่ม","บ้านคำนางรวย","บ้านคำนางโอก","บ้านคำนาแซง","บ้านคำนาดี","บ้านคำน้ำเกี้ยง","บ้านคำน้ำสร้าง","บ้านคำเนียม (คำเนียมวิทยาคาร)","บ้านคำบง","คำบงเจริญสุข","บ้านคำบง1","บ้านคำบง2","บ้านคำบ่อ","บ้านคำบอน","คำบอนประชาสรรค์","บ้านคำบอนคุรุราษฎร์บำรุง","บ้านคำบอนโนนสมโภชน์","บ้านคำบาก","บ้านคำบิดโคกโพนยาง","บ้านคำปลากั้ง","บ้านคำปลาฝานาทวี","บ้านคำปอแก้วคำไหล","บ้านคำปะกั้ง","บ้านคำปะกั้ง สาขาบ้านดงอ่าง","บ้านคำปากดาว","บ้านคำป่าก่อ","บ้านคำป่าหลาย","บ้านคำป่าหว้าน","บ้านคำโป้งเป้งโคตรธิสารวิทยา","บ้านคำผง","บ้านคำผักหนอกสงเปือย","บ้านคำผักหนาม","บ้านคำผ่าน","บ้านคำผาสุก","บ้านคำผึ้ง","บ้านคำเผือ","คำไผ่ประชาสามัคคี","บ้านคำไผ่โนนบ้านใหม่","บ้านคำไผ่","บ้านคำพระ","บ้านคำพอก","บ้านคำพอก 1","บ้านคำพอก 2","บ้านคำพอุง (ประชาราษฎร์บำรุง)","บ้านคำพิมูล","บ้านคำพี้","บ้านคำโพธิ์โคกก่อง","บ้านคำโพน","บ้านคำโพนสูง","บ้านคำภู","คำภูเงินโนนผักหวานวิทยา","บ้านคำภูทอง","บ้านคำมณี","บ้านคำม่วง","บ้านคำม่วมดงเย็น","บ้านคำมืด","บ้านคำมืดวิทยา","บ้านคำเม็ก","บ้านคำเม็กหนองนางฟ้า","บ้านคำเม็ก (พัฒนะบำรุง)","บ้านคำเม็กห้วยไผ่","บ้านคำแมด","บ้านคำแม่นาง","บ้านคำแม่มุ่ย","คำยางพิทยาคม","บ้านคำยาง","บ้านคำย่านาง","บ้านคำเรือง","บ้านคำลอดพื้น","บ้านคำเลา","บ้านคำเลาะ","บ้านคำแวง","บ้านคำสง่าประชาสรรค์","บ้านคำสมบูรณ์","บ้านคำสมอ (ศรีศึกษา)","บ้านคำสมิง","บ้านคำสร้อย","บ้านคำสร้างช้าง","บ้านคำสร้างบ่อ","บ้านคำสว่าง","บ้านคำสะแนน","บ้านคำสะอาด","บ้านคำสำราญ","บ้านคำสุข","บ้านคำหญ้าแดง","บ้านคำหนามแท่ง","บ้านคำหม่วย","บ้านคำหมากอ่อน","บ้านคำหมาไนร่องเข","บ้านคำหมีหนองข่า","บ้านคำหมื่น ","บ้านคำหว้า (วิบูลราษฎร์สามัคคี)","บ้านคำหัวช้างโนนตุ่นป่ามะนาว","บ้านคำหาด","บ้านคำแหลม","บ้านคำแหว","บ้านคำใหญ่","บ้านคำไหล","บ้านคำอ้อ","คำอาฮวนศรีสุราษฎร์วิทยา","บ้านคำอีหงษ์","บ้านคำอุดม","บ้านคำอุปราช","บ้านคำฮี","คำแฮดประชาสรรค์","คำไฮสำโรงวิทยาคาร","บ้านคำไฮน้อย","บ้านคำไฮผักแว่น","บ้านคำไฮหัวทุ่งประชาบำรุง","บ้านคำไฮใหญ่","บ้านคีรีเทพนิมิต","บ้านคีรีรอบ","บ้านคีรีลาดพัฒนา","บ้านคีรีวง","บ้านคีรีวงศ์","วัดคีรีวิหาร","บ้านคึม","บ้านคึมข่า","บ้านคึมชาด","บ้านคึมชาดตาดบกศรีสมพร","บ้านคึมชาดห้วยบง","บ้านคึมชาตหนองผงนาดี","บ้านคึมชาติประชาสรรค์","บ้านคึมบง","บ้านคึมมะอุ","บ้านคึมยาว","บ้านคึมหญ้านาง","บ้านคึมใหญ่","บ้านคุ้งเขาเขียว (สำเภาราษฎร์บำรุง)","บ้านคุ้งตะเภา","บ้านคุ้งวังวัว","บ้านคุ้งวารี","บ้านคุ้ม","บ้านคุ้ม (ประสารราษฎร์วิทยา)","บ้านคุ้มแสนชะนี","บ้านคุย","บ้านคุยขนวนไผ่ล้อม","บ้านคุยแขวน","บ้านคุยค้อ (บัญฑิตประชาสรรค์)","บ้านคุยเชือก","บ้านคุยตับเต่า","บ้านคุยนางขาว","บ้านคุยบ้านโอง","บ้านคุยประดู่","บ้านคุยป่ายาง","บ้านคุยป่ารัง","บ้านคุยผงดงน้อย","บ้านคุยแพง","บ้านคุยโพธิ์","บ้านคุยมะตูม","บ้านคุยมะม่วง","บ้านคุยยาง","บ้านคุรอด","บ้านคุระ","คูคำพิทยาสรรพ์","บ้านคู","บ้านคู (คุรุศิษย์วิทยาคาร)","บ้านคู (ประชาอุปถัมภ์)","บ้านคูขาด","บ้านคูขาด (ศรีวิทยาคาร)","บ้านคูขาด (สถิตอุปถัมภ์)","บ้านคูขาดน้อย","บ้านคู้คด","บ้านคูซอด","บ้านคูณสระแก้ว (วิชานนท์ประชานุกูล)","บ้านคูดงประชาสรรค์","บ้านคูดินทราย","บ้านคูเดื่อ","บ้านคูตัน","บ้านคูนายสังข์","บ้านคูบ","บ้านคูบอน","บ้านคูบัว","บ้านคูฟ้า","บ้านคูเมือง","บ้านคูเมือง (อ่อนอนุเคราะห์)","บ้านคูเมืองสามัคคีวิทยา","บ้านคูระ","บ้านคูวอ","บ้านคูศักดิ์สิทธิ์","บ้านคูสระ","บ้านคูสว่าง","บ้านคูสองชั้น","บ้านคูสะคาม","บ้านคูสี่แจ","บ้านคูหา","บ้านเค็ง","บ้านเค็งนาดี","บ้านเครอะบอ","บ้านเครือคู้","บ้านเครือซูด","บ้านเคลียง","บ้านเคียน","บ้านแค","บ้านแคกลางหงษ์","บ้านแคทราย (ซ่อนกลิ่นอุปถัมภ์)","บ้านแคทอง","บ้านแคน","บ้านแคน (คุรุราษฎร์ส่งเสริม)","บ้านแคน (ประชาสามัคคี)","บ้านแคน (วันครู 2503)","บ้านแคน (สมเด็จอุปถัมภ์)","บ้านแคนดำ","บ้านแคนน้อย","บ้านแคนน้อยหนองเลิง","บ้านแคนสามัคคี","บ้านแคนเหนือ","บ้านแคนา","บ้านแครายเกษตรพันธุ์พิทยาคาร","บ้านแคว้ง","บ้านแควป่าสัก","บ้านแควมะกอก","บ้านโคก","บ้านโคก 7 ลูก","บ้านโคก (ทองคุรุราษฎร์พัฒนา)","บ้านโคก (อสพป.32)","บ้านโคก1","บ้านโคก2","บ้านโคกกกม่วง","บ้านโคกก่ง","บ้านโคกกรม","บ้านโคกกรวด","บ้านโคกกรวดหนองพวง","บ้านโคกกระจง","บ้านโคกกระเจียว","บ้านโคกกระชาย","บ้านโคกกระชายโนนกุ่ม","บ้านโคกกระแชขี้เหล็กน้อย","บ้านโคกกระดี่","บ้านโคกยามู","บ้านโคกกระท้อน","บ้านโคกกะทือ","บ้านโคกกะเทียม (ราษฎร์ดำริบำรุง)","บ้านโคกกระบือ","บ้านโคกกระเบื้องสามัคคี","บ้านโคกกระเบื้องไห","บ้านโคกกระพี้หนองนกเขาสามัคคี","บ้านโคกกร่าง","บ้านโคกกลอย","บ้านโคกกลางน้ำจั้นจอมศรี","บ้านโคกกลางใหม่โพธิ์ทอง","บ้านโคกกลาง สาขาคำอินแปลง","บ้านโคกกลาง (ประชารัฐพัฒนา)","บ้านโคกกลาง (วรนาถประชาสรรค์)","บ้านโคกกลางแก้งน้อย","บ้านโคกกลางคุรุราษฏร์ศึกษา","บ้านโคกกลางนาล้อม","บ้านโคกกลางโนนคูณโนนศิลา","บ้านโคกกลางโนนงาม","บ้านโคกกลางบ่อหลุบ","บ้านโคกกลางประชาสรรค์","บ้านโคกกลางวิทยา","เพียงหลวง 8 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านโคกกลางหนองแปน","บ้านโคกกลางหนองแวงใหญ่","บ้านโคกกลางเหนือ","บ้านโคกกลางอนุสรณ์","บ้านโคกกว้าง","บ้านโคกกอ","บ้านโคกก่อ","บ้านโคกกอกหินเหล็กไฟ","บ้านโคกก่อง","บ้านโคกก่องคูสะคาม","บ้านโคกก่องโคกสูงหนองแต้","บ้านโคกก่องดอนทองวิทยา","บ้านโคกก่องดอนนกชุม","บ้านโคกก่องนคร","บ้านโคกก่องมิตรภาพที่ 86","บ้านโคกก่องวังนอง","บ้านโคกก่องสหมิตรวิทยาคาร","บ้านโคกก่องหนองแวง","บ้านโคกก่องหนองแวงยาว","บ้านโคกกะชาย","บ้านโคกกะทอ","บ้านโคกกะเพอ (ซ้ำกับลำดับที่ 51)","บ้านโคกกี่","บ้านโคกกุงหินลาดโคกเจริญ","บ้านโคกกุง","โคกกุงหนองหงษ์หนองไฮ","บ้านโคกกุงดอนกอก","บ้านโคกเกษม (สหรัฐ-ราษฎร์สามัคคี)","บ้านโคกเก่า","บ้านโคกเกาะ","บ้านโคกแก้ว","โคกโกโคกกลาง","บ้านโคกโก","บ้านโคกโก่ง","บ้านโคกขมิ้น","บ้านโคกขมิ้นพัฒนา","บ้านโคกข่า","บ้านโคกขาม","บ้านโคกขาม (นาคพัฒนา)","บ้านโคกขามโนนสมบูรณ์","บ้านโคกขามเลียน","บ้านโคกข่าหนองโก","บ้านโคกขี้เหล็ก","บ้านโคกเขาพัฒนา","บ้านโคกแขวน","บ้านโคกคงสมโภชน์","บ้านโคกคอน","บ้านโคกคอนดอนม่วย","โคกคันจ้องหนองแต้สามัคคี","บ้านโคกคา","บ้านโคกค่าย","โคกคำทุ่งสว่าง","บ้านโคกคำไหล","บ้านโคกคึม (สง่าประชาสรรค์)","บ้านโคกเคียน","บ้านโคกไค","บ้านโคกงาม","บ้านโคกงิ้ว","บ้านโคกงู","บ้านโคกงูเห่า","บ้านโคกจักจั่น","บ้านโคกจาน","บ้านโคกจำเริญ","บ้านโคกเจริญคำน้ำแซบวิทยา","บ้านโคกเจริญ","บ้านโคกแจง","บ้านโคกโจด","บ้านโคกชะแง้","บ้านโคกช้างฮ้าย","บ้านโคกชำแระ","บ้านโคกชุม","วัดบ้านโคกซาด","บ้านโคกดินแดง","บ้านโคกโดน","บ้านโคกตก","บ้านโคกต้นสะตอ","บ้านโคกตะโก","บ้านโคกตะขบ","บ้านโคกตะเคียน","บ้านโคกตะเคียนงาม","บ้านโคกตะเคียนสามัคคี","นราธิป-พร้อยสุพิณ บ้านโคกตะแบง","บ้านโคกตะพาบ","บ้านโคกตา","บ้านโคกตาดทอง","บ้านโคกตาพรม","บ้านโคกตาล","บ้านโคกตีเต","บ้านโคกตูม","บ้านโคกเต่า","บ้านโคกโต่งโต้น","บ้านโคกโตนด","บ้านโคกถ่อนสองแพวิทยา","บ้านโคกถาวร","บ้านโคกถาวรทรายงาม","บ้านโคกทม","บ้านโคกทราย","บ้านโคกทหาร","บ้านโคกท่า","บ้านโคกทุ่งน้อย","บ้านโคกทุ่งยั้ง","บ้านโคกเที่ยง","บ้านโคกเทียม","บ้านโคกไทร","บ้านโคกนกทา","บ้านโคกนกสาริกา","บ้านโคกน้อย","เทศบาลตำบลน้ำโสม","บ้านโคกนาโก","บ้านโคกนาคำ","บ้านโคกนางามปลาเซียม","บ้านโคกนาฝาย","บ้านโคกนาเหล่า","บ้านโคกน้ำเกี้ยง","บ้านโคกนิบง","บ้านโคกนิยม","บ้านโคกบริการสันกำแพง","บ้านโคกบัวค้อ","บ้านโคกบุ (บอนประชารัฐบำรุง)","บ้านโคกเบง","บ้านโคกโบสถ์","บ้านโคกใบบัว","บ้านโคกประดู่","บ้านโคกปราสาท","บ้านโคกปรือ","บ้านโคกป่ากุง","บ้านโคกป่าจิก","บ้านโคกป่าฝาง","บ้านโคกเปราะ","บ้านโคกแปะ","บ้านโคกผักหวาน","บ้านโคกผักหวานโนนรังษี","บ้านโคกผักหอม","บ้านโคกไผ่-ขนาย","บ้านโคกแฝก","บ้านโคกแฝกดอนทะยิง","บ้านโคกพนมดี","บ้านโคกพะยอม","บ้านโคกพยอม","บ้านโคกพระ","บ้านโคกพระเจ้าโนนรัง","บ้านโคกพระวินัยดี","บ้านโคกพระหนองยายเกลี้ยง","บ้านโคกพลวง","บ้านโคกพะธาย","บ้านโคกพัฒนา","บ้านโคกเพ็ก","บ้านโคกเพชร","บ้านโคกเพชร (บุญเหลือคุรุราษฎร์บำรุง)","บ้านโคกเพชร (เภดประชารัฐบำรุง)","บ้านโคกเพชรไสยา","บ้านโคกเพ็ด","บ้านโคกเพร็ก","บ้านโคกเพร็ดโนนจำปา","บ้านโคกเพิ่มโคกกลาง","บ้านโคกเพิ่มพูนพิทยา","บ้านโคกแพงพวย (บัวประชาสรรค์)","บ้านโคกโพธิ์","บ้านโคกไพรวัน","บ้านโคกไพล","บ้านโคกฟันโปง","บ้านโคกเฟือง","บ้านโคกภู","บ้านโคกมน","บ้านโคกม่วง","บ้านโคกม่วงทองวิทยา","บ้านโคกม่วง (ดำประชาอุทิศ)","บ้านโคกม่วงชุม","บ้านโคกม่วย","บ้านโคกมอน","บ้านโคกมะกอก (ก.ร.ป.กลางอุปถัมภ์)","บ้านโคกมะขวิด","บ้านโคกมะขาม","บ้านโคกมะค่า","บ้านโคกมะตูม","บ้านโคกมะนาวทันสมัย","บ้านโคกมะพร้าว","บ้านโคกมะม่วง","บ้านโคกมะเมียน (ธรรมสุชาติอุทิศ)","บ้านโคกมั่งงอย (คุรุประชาบำเพ็ญ)","บ้านโคกม้า","บ้านโคกมือบามิตรภาพที่ 223","บ้านโคกมุ่นเหล่าสวรรค์","บ้านโคกเมา","บ้านโคกเมือง","บ้านโคกแมงเงา","บ้านโคกแมแน","บ้านโคกไม้งาม","บ้านโคกไม้งาม (ส่งเสริมวิทยา)","บ้านโคกไม้แดง","บ้านโคกไม้แดงหัวกระสัง","บ้านโคกไม้ล้ม","บ้านโคกยาง","บ้านโคกยาง (บุญรอด-บอนอุทิศ)","บ้านโคกย่าง","บ้านโคกยางหนองตาสี","บ้านโคกยางหนองถนน","บ้านโคกยาว","บ้านโคกยูง","บ้านโคกระกา","บ้านโคกระกาน้อย","บ้านโคกระเวียง","บ้านโคกระเหย","บ้านโคกรัก","บ้านโคกรัง","บ้านโคกรังน้อย","บ้านโคกรัมย์","บ้านโคกไร่","บ้านโคกลอย","บ้านโคกลาด","บ้านโคกลาน","บ้านโคกล่าม","บ้านโคกล่ามหมากหญ้าท่าสำราญ","บ้านโคกล่ามกลางตำแย (ไพจิตรอุปถัมภ์)","บ้านโคกล่ามขี้เหล็ก","บ้านโคกล่ามโนนกอกสามัคคี","บ้านโคกล่ามวิทยา","บ้านโคกลาวหนองเหล็ก","บ้านโคกลำดวน","บ้านโคกลิ่น","บ้านโคกเล้า","บ้านโคกเลาะ","บ้านโคกเลาะ (มิตรภาพที่ 159)","บ้านโคกวังสาร","บ้านโคกวัด","บ้านโคกวัดใหม่","บ้านโคกวา","บ้านโคกวิชัยโนนไชยพร","บ้านโคกวิทยา","บ้านโคกศรี","บ้านโคกศรีแก้ว","บ้านโคกศรีสำราญวังหน้าผา","บ้านโคกศรีห้วยยาง","บ้านโคกศาลา","บ้านโคกศิลา","บ้านโคกสงเปือยดอนดู่วิทยา","บ้านโคกสง่า","โคกสง่า","บ้านโคกสง่า (มิตรภาพคุรุราษฎร์นุสรณ์)","บ้านโคกสง่านางาม","บ้านโคกสนวน","บ้านโคกสนั่น","บ้านโคกสมบูรณ์","อนุบาลสว่างวีระวงศ์","บ้านโคกสมอง","บ้านโคกสยา","บ้านโคกสวัสดี","บ้านโคกสวาง","บ้านโคกสว่าง","บ้านโคกสว่างป่าไม้งาม","โคกสว่างดงง่ามน้อย","บ้านโคกสว่าง (คุรุประชานุกูล)","บ้านโคกสว่าง (บุญคุรุราษฎร์วิทยา)","บ้านโคกสว่าง (เรืองศิษย์วิทยานุกูล)","บ้านโคกสว่าง 1","บ้านโคกสว่าง 2","บ้านโคกสว่างนาดี","โคกสวาสดิ์หนองสองห้องดอนแดง","บ้านโคกสหกรณ์เทพรักษา","บ้านโคกสะแกลาด","บ้านโคกสะแบง","บ้านโคกสะอาด","บ้านโคกสะอาดเกษตรพัฒนา","บ้านโคกสะอาดศรีบูรพา","บ้านโคกสะอาดหนองหัวช้าง","บ้านโคกสะอาด (ประชาราษฎร์รังสรรค์)","โคกสะอาดแก้งวิทยา","บ้านโคกสะอาดวิทยาคาร","บ้านโคกสะอาดสามัคคี","บ้านโคกสะอาดใหม่สามัคคี","บ้านโคกสัก","บ้านโคกสั้น","บ้านโคกสันติสุข","บ้านโคกสามัคคี","บ้านโคกสายทอง","บ้านโคกสำราญ","บ้านโคกสำราญพรสวรรค์","บ้านโคกสำราญหินลาดพัฒนา","บ้านโคกสำโรง","บ้านโคกสิงห์","บ้านโคกสิเหรง","บ้านโคกสี","บ้านโคกสี (จตุรภูมิพิทยา)","บ้านโคกสีแก้ว","บ้านโคกสีโคกเปี้ย","บ้านโคกสีไค","บ้านโคกสีทองหลาง","บ้านโคกสีมิตรภาพที่ 87","บ้านโคกสีวังแสง","บ้านโคกสีวิทยาเสริม","บ้านโคกสุข","บ้านโคกสุพรรณ","บ้านโคกสุมุ","บ้านโคกสุวรรณ","บ้านโคกสูง","บ้านโคกสูงโคกสวรรค์","บ้านโคกสูง (สมานสามัคคี)","บ้านโคกสูง (สหราษฎร์บำรุง)","บ้านโคกสูงคูขาด","บ้านโคกสูงประชาสรรค์","บ้านโคกสูงพิทยาคาร","บ้านโคกสูง-วังศิลา","บ้านโคกสูงวิทยา","บ้านโคกสูงวิทยาคม","บ้านโคกสูงวิทยานุกูล","บ้านโคกสูงสะอาด","บ้านโคกสูงหนองเสียวหนองขี","บ้านโคกสูงอ่างสมบูรณ์","บ้านโคกเสี่ยว","บ้านโคกแสง","บ้านโคกแสมสาร","บ้านโคกแสว","บ้านโคกโสนทองวิทยา","บ้านโคกใส","บ้านโคกหนองกุง","บ้านโคกหนองจอก","บ้านโคกหนองแซง","บ้านโคกหนองบัว","บ้านโคกหนองไผ่","บ้านโคกหนองลาด","บ้านโคกหนองแวง","บ้านโคกหนองหล่ม","บ้านโคกหนองแห้ว","บ้านโคกหมัก","บ้านโคกหลวง","บ้านโคกหลวงพ่อ (พินิจศิลป์ประชานุกูล)","บ้านโคกหล่าม(รัฐราษฎร์สามัคคี)","บ้านโคกหอม","บ้านโคกหัวช้าง","บ้านโคกหัวภู","บ้านโคกหาร","บ้านโคกหิน","บ้านโคกหินกอง","บ้านโคกหินช้าง","บ้านโคกหินตั้งศึกษาศิลป์","บ้านโคกหินเหล็กไฟ","บ้านโคกหินแฮ่","บ้านโคกเห็ด","บ้านโคกเหรียง","บ้านโคกแห้ว","บ้านโคกใหญ่","บ้านโคกใหญ่วิทยา","บ้านโคกใหญ่หนองสองห้อง","บ้านโคกใหม่นายม","บ้านโคกใหม่นายม สาขาบ้านดงซำ","บ้านโคกใหม่หนองสรวง","บ้านโคกอาโพน","บ้านโคกอารักษ์","บ้านโคคลาน","บ้านโค้งกระโดน","บ้านโค้งงาม","บ้านโค้งดารา","บ้านโค้งตะคร้อ","บ้านโค้งประดู่","โค้งยางวิทยา","บ้านโค้งรถไฟ","บ้านโค้งสวอง","บ้านโค้งสำราญ","บ้านโค้งอร่าม","บ้านโคนผง","บ้านโคราช","บ้านโคลด","บ้านใคร่นุ่น","บ้านใคร่นุ่นราษฏร์บำรุง","บ้านไค่นุ่นหนองบัวบานวิทยา","บ้านไคร่นุ่น","บ้านไคสี","บ้านฆอเลาะทูวอ","บ้านแฆแบ๊ะ","บ้านง่อนหนองพะเนาว์ (มิตรภาพที่ 126)","บ้านงอมถ้ำ","บ้านงอมมด","บ้านงอยเลิงทอง","บ้านง้อหนองแสง","บ้านง้าง","บ้านงาช้าง","บ้านงิ้ว","บ้านงิ้ว (คุรูปถัมภ์)","บ้านงิ้วงาม","บ้านงิ้วแบ้","บ้านงิ้วป่าไผ่ (ราษฎร์นุกูล)","บ้านงิ้วพังฮอ","บ้านงิ้วมีชัย","บ้านงิ้วศิริราษฎร์บำรุง","บ้านงิ้วสร้างแก้ว","บ้านงิ้วสูง","บ้านงิ้วหว่านศึกษาคาร","บ้านงิ้วใหม่","บ้านงูเหลือม","บ้านจกปก","บ้านจ๋ง","บ้านจบก","บ้านจมื่น","บ้านจรเข้มาก","บ้านจรเข้สามพัน","บ้านจรวย","บ้านจรอกใหญ่","บ้านจรัส","บ้านจรุกเตย","บ้านจรูกแขวะ","บ้านจอก","บ้านจอก (ประชาสามัคคี)","บ้านจอกขวาง","จ้อก้อแมดมันเหลืองวิทยา","บ้านจอง","บ้านจ้อง","บ้านจองกอ","องค์การบริหารส่วนจังหวัดบ้านจองคำ","บ้านจอเจริญ","บ้านจอซิเดอเหนือ","บ้านจอเบาะ","บ้านจอมแจ้ง","บ้านจอมแจ้งมิตรภาพที่ 193","จอมตาลโนนดู่โนนสำราญ","บ้านจอมทอง","บ้านจอมทองพัฒนา","บ้านจอมบึง (วาปีพร้อมประชาศึกษา)","บ้านจอมปลวกสูงสร้างกุง","บ้านจอมปิง","บ้านจอมพระ","บ้านจอมพะลาน","บ้านจอมมณี","บ้านจอมมณีใต้","บ้านจอมวิทยา","บ้านจอมศรี","จอมศรีโคกก่องวิทยา","บ้านจอมสังข์","บ้านจอหอ","จะกงวิทยา","บ้านจะกว๊ะ","บ้านจะเข้ภูหอม","บ้านจะคือ","บ้านจะเฆ่","บ้านจะตี","บ้านจะทิ้งพระ (วิจารณ์ศีลคุณ)","บ้านจะเนียงสามัคคี","บ้านจะเนียว","บ้านจะแนะ","บ้านจะบู (สมบูรณ์วิทยา)","บ้านจะโปรง","บ้านจะมาแกะ","บ้านจะรัง","บ้านจะรังตาดงมิตรภาพที่ 175","บ้านจะรังบองอ","บ้านจะแลเกาะ","บ้านจะหลวย","บ้านจักจรูก","บ้านจังเกา (ลุสิมาวิทยาคาร)","บ้านจังเอิดหนองแมว","บ้านจังเอิน","บ้านจังเอิล","บ้านจัดสรร","บ้านจัดสรรสามัคคี","บ้านจัน","บ้านจั่น","บ้านจั่นโคกรักษ์ (รัฐประชาสรรค์)","บ้านจันดี","บ้านจันเดย์","บ้านจันทเขลม","บ้านจันทน์","บ้านจันทร์","บ้านจันทร์งาม","บ้านจันทร์เพ็ญ","บ้านจันทร์ลาดวิทยา","บ้านจันทร์สว่าง","บ้านจันทร์หอมตาเสก","บ้านจันทโรภาส","บ้านจันทัย","บ้านจันทิมา","บ้านจันทึง","บ้านจันรม","บ้านจันลม","บ้านจันลา","บ้านจั่นศรีวิไล","บ้านจันอัด","บ้านจันอุย","บ้านจับไม้","บ้านจัมปา","บ้านจ่ากอง","บ้านจางวาง","บ้านจาน","บ้านจาน (นิเทศอุปถัมภ์)","บ้านจานตะโนน","บ้านจานเตย","บ้านจานใต้","บ้านจานทองกวาววิทยา","บ้านจานทุ่ง","บ้านจานทุ่งโนนสังข์","บ้านจานโนนสูง","บ้านจานบัว","บ้านจานลาน","บ้านจานเลียว","บ้านจานวิทยา","บ้านจานแสนไชย","บ้านจานหนองคู","บ้านจานเหนือ","บ้านจาบ","บ้านจาแบปะมิตรภาพที่ 197","บ้านจาร","บ้านจารพัต","บ้านจารย์","บ้านจาเราะซูซู","บ้านจาเราะปะไต","บ้านจาหนัน","บ้านจำ","บ้านจำไก่","บ้านจำค่า","บ้านจำคาวตอง","บ้านจำตาเหิน","บ้านจำนรรจ์","บ้านจำนัก","บ้านจำนันสายเจริญ","บ้านจำบอน","บ้านจำปา","บ้านจำปาดง","บ้านจำปาทอง","บ้านจำปานวง","บ้านจำปานาถ่อน","บ้านจำปาประชานุเคราะห์","บ้านจำปาโมง","บ้านจำปาวิทยา","บ้านจำปาศิริราษฎร์","บ้านจำป่าหวาย","บ้านจำปาหัวบึง","บ้านจำปุย","บ้านจำปูน","บ้านจำผักกูดทรายทอง","บ้านจำหวาย","บ้านจิก","บ้านจิก (หจก.วิบูลย์พาณิชย์อนุเคราะห์)","บ้านจิกกะลา","บ้านจิกคันช้อน","บ้านจิกเทิง (วินัยสารประชานุกูล)","บ้านจิกลาด","บ้านจิกลุ่ม","บ้านจิกใหญ่","บ้านจิจิก","บ้านจิตตมาสพัฒนา","บ้านจีกแดก","บ้านจืองา","บ้านจือนือแร","บ้านจือแร","บ้านจือโระ","บ้านจุการ","บ้านจุน","บ้านจุปะ","บ้านจุโป","บ้านจุฬาภรณ์ 12","บ้านจู้ด (วิชัยสามัคคีราษฎร์)","บ้านจูดแดง","บ้านจูโวะ","บ้านเจ็ดเนิน","บ้านเจดีย์โคะ","บ้านเจดีย์แม่ครัว","บ้านเจน (เจนจันทรานุกูล)","บ้านเจริญผล","เจริญเมืองวิทยา","บ้านเจริญสามัคคี","บ้านเจริญสุข(กรป.กลางอุปถัมภ์)","บ้านเจริญสุข","บ้านเจ๊ะเก","บ้านเจ๊ะบิลัง","บ้านเจ๊ะยอ","บ้านเจ๊ะหลี","บ้านเจ๊ะเหม","บ้านเจ้าขรัว","บ้านเจ้าคุณ","บ้านเจ้าเณร","บ้านเจาทอง","บ้านเจ้าทุ่ง","บ้านเจ้าวัด","บ้านเจ้าหลาว","บ้านเจาเหนือ","บ้านเจาะกือแย","บ้านเจาะเกาะ","บ้านเจาะตาแม","บ้านเจาะบาแน","บ้านเจาะบือแม","บ้านเจาะปันตัง","บ้านเจาะไอร้อง","บ้านเจี่ย","บ้านเจียรพัฒนา","บ้านแจ้ง","บ้านแจ้งโคกกล่ามแจ้งข่า (คุรุประชาสรรค์)","บ้านแจ่งกู่เรือง","บ้านแจงงาม","แจ้งตราดคลองไทร","บ้านแจ้งทัพม้า","บ้านแจ้งน้อย","บ้านแจ้งใหญ่","บ้านแจนแลน","บ้านแจ่มหลวง","บ้านแจรน (ปอเกีย-พลินอุทิศ 1)","บ้านโจด","บ้านโจด (ท้าวสุรนารีอนุสรณ์4)","บ้านโจดกลาง","บ้านโจดนาตาล","บ้านโจดนาห่อมเดื่อ","บ้านโจดโนนข่า","บ้านโจดบัวบาน","บ้านโจดพิทยาคาร","บ้านโจดม่วง","บ้านโจดศรีวิชัย","บ้านโจดศิริราษฎร์บำรุง","บ้านโจดหนองแกหนองสิม","บ้านโจดใหญ่","บ้านโจรก","บ้านโจะโหวะ","บ้านใจดี","บ้านฉกาจช่องโค","บ้านฉนวน","บ้านฉลอง","บ้านฉลองชัย","บ้านฉลอม","บ้านฉลีกหนองมะแซว","บ้านฉลุง","บ้านฉันเพล","บ้านฉาง","บ้านฉางเกลือ (รักเมืองไทย 3)","บ้านฉางข้าวน้อย (วันครู 2503)","บ้านฉางหลาง","บ้านฉิมพลี","บ้านฉู่ฉี่","บ้านเฉนียง","บ้านเฉลียง (คุรุราษฎร์บำรุง)","บ้านเฉลียงทอง","บ้านเฉลียงลับ","บ้านโฉลกหลำ","บ้านโฉลง","บ้านชงโคสันติสุขวิทยาคาร","บ้านชมน้อย","บ้านชมพู","บ้านชมภู","บ้านชมภูพาน","บ้านชลประทาน","บ้านชวดบัว","บ้านช่อกระถินพัฒนา","บ้านช่อง","บ้านช่องยางชุม","บ้านช่องกระทิง","บ้านช่องกลิ้งช่องกรด","บ้านช่องกะพัด","บ้านช่องเขาหมาก","บ้านช่องคีรี","บ้านช่องแคบ","บ้านช่องโค","บ้านช่องช้าง","บ้านช่องด่าน","บ้านช่องตะเคียน","บ้านช่องไทร","บ้านช่องไทรราษฎร์พัฒนา","บ้านช่องฝาง","บ้านช่องพลี","บ้านช่องฟืน","บ้านช่องมะเฟือง","ชุมชนบ้านช่องม้าเหลียว","บ้านช่องเม็ก","บ้านช่องแมว","บ้านช่องไม้งาม","บ้านช่องไม้ดำ","บ้านช่องลม","บ้านช่องสะเดา (การไฟฟ้าฝ่ายผลิตอุปถัมภ์)","บ้านช่องสำราญ","บ้านช่องเสียด","บ้านช่องหลาด","บ้านช่องหาร","บ้านชอนเดื่อ (สำนักงานสลากกินแบ่งสงเคราะห์ 111)","บ้านชอนไพร","บ้านชอนสมบูรณ์","บ้านช่อผกา","บ้านช่อฟ้า","บ้านช่อระกา","บ้านชะแงะ","บ้านชะโงมนาโดน","บ้านชะโดเหล่าบึงแก้ว","บ้านชะโนด 1","บ้านชะโนด 2","บ้านชะโนต","บ้านชะม่วง","บ้านชะเมา","บ้านชะเมาสามต้น","บ้านชะแม","บ้านชะลอมแหน","บ้านชะลาด","บ้านชะลาดระฆัง","บ้านชะวากยาว","บ้านชะวึก","บ้านชะไว","บ้านชะอวด","บ้านชะเอาะ","บ้านชะเอียน","บ้านชั่งสี่","บ้านชัฎเจริญ","บ้านชัฏหนองหมี","บ้านชัฏฝาง","บ้านชัย","บ้านชัยชนะ","บ้านชัยพรมิตรภาพที่ 67","บ้านชัยพฤกษ์","บ้านชัยภูมิ","บ้านชัยมงคล","บ้านชัยศรี","บ้านชัยศรีสุข","บ้านชากไทย (จงจินต์ประชานุเคราะห์)","บ้านชากนอก","บ้านชากนา (ประเสริฐราษฎร์พัฒนา)","บ้านชากพุดซา","บ้านชากมะหาด","บ้านชากยายจีน","วัดชากลูกหญ้า","บ้านชาคลี","บ้านช้าง","บ้านช้างข้าม","บ้านช้างคลอด","บ้านช้างคับ","บ้านช้างเชื่อ","บ้านช้างตะลูด","บ้านช้างตาย","บ้านช้างใน","บ้านช่างปี่","บ้านช้างเผือก","บ้านช้างมิ่ง","บ้านช่างหม้อ","บ้านชาด","บ้านชาดฝางหัวเรือ","บ้านชาดมะเหลื่อม","บ้านชาดวิทยาคาร","บ้านชาดศรีสมบูรณ์","บ้านชาดศาลา","บ้านชาดหนองเหล็ก","บ้านชาดฮี (ธรรมทินโนปถัมภ์)","บ้านชาติ","บ้านชาติตระการ","บ้านชาติสามัคคี","บ้านชาน","บ้านชานุวรรณ (ประชาวิทยาคาร)","บ้านชําผักหนาม","บ้านชายคลอง","บ้านชายควน","บ้านชายเคือง","บ้านชายทะเล","บ้านชายทะเลกาหลง","บ้านชายทะเลโคกขามมิตรภาพที่ 95","บ้านชายทะเลบางกระเจ้า","บ้านชายท่า","บ้านชายทุ่ง","บ้านชายธูป","บ้านชำขวาง","บ้านชำฆ้อ","บ้านชำแจงแมง","บ้านชำเบง","บ้านชำโพธิ์-ตาเกษ (ประจวบสงเคราะห์)","บ้านชำม่วง","บ้านชำแระ","บ้านชำแระกลาง","บ้านชำสมอ","บ้านชำสมิง","บ้านชำโสม","บ้านชี","บ้านชีกกค้อ","บ้านชีทวน","บ้านชีลองกลาง","บ้านชีลองใต้","บ้านชีลองเหนือ","บ้านชีวาน","บ้านชีวึก (สังฆประชาสรรค์)","ชีโหล่นวิทยา","บ้านชุมขลิง","บ้านชุมโค","ชุมชัยหนองย่างชิ้น","บ้านชุมทอง","บ้านชุมนาก","บ้านชุมนุมใน","บ้านชุมนุมปรกฟ้า","บ้านชุมนุมพระ","บ้านชุมนุมสูง","บ้านชุมพล (อ้นอารีศึกษาคาร)","บ้านชุมพลบุรี (ชุมพลราษฎร์บำรุง)","บ้านชุมแพ","บ้านชุมภูทอง","บ้านชุมภูพรโสกก่าม","บ้านชุมม่วง","บ้านชุมโลง","บ้านชุมแสง","บ้านชุมแสง (บุญคุรุราษฎร์บำรุง)","ชุมแสงลาดค้อหนองเขื่อน","บ้านชุมแสงโนนเหลี่ยม","บ้านชูชาติ","บ้านเชตวัน","บ้านเชิงชาย","บ้านเชิงชุม","บ้านเชิงดอย (ดอยสะเก็ดศึกษา)","บ้านเชิงดอย","บ้านเชิงดอยสุเทพ","เทศบาลเชิงทะเล (ตันติวิท)","บ้านเชียง (ประชาเชียงเชิด)","บ้านเชียงกรม","บ้านเชียงของ","บ้านเชียงคาน ","บ้านเชียงคาน ","บ้านเชียงคาน (ราษฎร์ประสานมิตร)","บ้านเชียงเครือคำสร้างบ่อ","บ้านเชียงเคี่ยน (คณาราษฎร์บำรุง)","บ้านเชียงงาม","บ้านเชียงดา","บ้านเชียงดาว","บ้านเชียงดีกุดเชือม","บ้านเชียงพัง","บ้านเชียงพิณ","บ้านเชียงเพ็ง","บ้านเชียงยืน","บ้านเชียงยืน (เชียงยืนวิทยา)","บ้านเชียงรากน้อย","บ้านเชียงแล นาทราย (คุรุราษฎร์รังสฤษฎ์)","บ้านเชียงวิทยา","บ้านเชียงสือราษฎร์อำนวย","บ้านเชียงหวางสร้างลาน","บ้านเชียงแหว","บ้านเชียงอาด","บ้านเชี่ยวขวาน","บ้านเชี่ยวเฟือง","บ้านเชี่ยวมะปราง","บ้านเชี่ยวหมวง","บ้านเชี่ยวเหลียง","บ้านเชือก","บ้านเชือก (ทวีปัญญา)","บ้านเชือกคุยเพ็ก","บ้านเชือกน้อย","เชือกหม้วยวิทยา","บ้านเชื้อเพลิง","บ้านแชงเปิง","บ้านแช่ช้าง (เทพนานุกูล)","บ้านแช่ฟ้า","บ้านแชะ","บ้านโชกใต้","บ้านโชกเหนือ","บ้านโชค","บ้านโชคกราด","บ้านโชคเจริญ","บ้านโชคชัย","บ้านโชคชัยพรตาดไฮ","บ้านโชคชัยพัฒนา","บ้านโชคนาสาม","บ้านโชคอำนวย","บ้านไชยชนะ","บ้านไชยพรม","บ้านไชยฟอง","บ้านไชยภักดี","บ้านไชยมงคล","บ้านไชยมงคล (สืบสินวิทยา)","บ้านไชยราช","บ้านไชยวานโนนลือชัย","บ้านไชยวาล","บ้านไชยศรี","บ้านไชยสถาน","บ้านไชยสอ","บ้านไชยามาตย์ (เตรียมปริญญาอนุสรณ์)","บ้านซ่ง","บ้านซ่งเต่า","บ้านซ้งวิทยาคม","บ้านซรายอ","บ้านซ่อง","บ้านซ่อง (ประชากรบำรุง)","บ้านซองกาเรีย","บ้านซองแมว","บ้านซ่อมกอก","บ้านซ่อมดู่","บ้านซอย 10","บ้านซอย 2","บ้านซอยสอง (อภิชาตราษฎร์อุปถัมภ์)","บ้านซะซอม","บ้านซะวาซอ","บ้านซับกระโซ่","บ้านซับกระดาน","บ้านซับกระถินทอง","บ้านซับก้านเหลือง","บ้านซับเกษม","บ้านซับขลุง","บ้านซับข่อย","บ้านซับครก","บ้านซับคะนิง","บ้านซับเค้าแมว","บ้านซับงูเหลือม","บ้านซับจำปา","บ้านซับเจริญ","บ้านซับเจริญสุข","บ้านซับชมภู","บ้านซับชะอม","บ้านซับชุมพล","บ้านซับดินดำ","บ้านซับเดื่อ","ซับแดงซำไผ่","บ้านซับตะคร้อ","บ้านซับตะเคียน","บ้านซับตะเคียนทอง","บ้านซับตะแบก","บ้านซับตารี","บ้านซับเต่า","บ้านซับใต้","บ้านซับถาวร","บ้านซับไทร","บ้านซับไทรทอง","บ้านซับนกแก้ว","บ้านซับน้อย","บ้านซับน้อยใต้สามัคคี","บ้านซับน้อยพัฒนา","บ้านซับน้อยเหนือ","บ้านซับน้ำเย็น","บ้านซับบอนซับเจริญ","บ้านซับบอน","บ้านซับปลากั้ง","บ้านซับเปิบ","บ้านซับผักกาด","บ้านซับผาสุก","บ้านซับพระไวย์","บ้านซับพริก","บ้านซับพลู","บ้านซับม่วง","บ้านซับมะนาว","บ้านซับไม้แดง","บ้านซับยาง","บ้านซับรวงไทร","บ้านซับวารินทร์","บ้านซับศรีจันทร์","บ้านซับเศรษฐี","บ้านซับโศก","บ้านซับสนุ่น","บ้านซับสมบูรณ์","บ้านซับสมพงษ์","บ้านซับสวัสดิ์","บ้านซับสะเดา","บ้านซับสามัคคี","บ้านซับสำราญใต้","บ้านซับสำราญเหนือ","บ้านซับสิงโต","บ้านซับสีทอง","บ้านซับสุราษฎร์","บ้านซับหมี","บ้านซับหวาย","บ้านซับหินขวาง","บ้านซับหินเพลิง","บ้านซับใหญ่วิทยาคม","บ้านซับใหญ่","บ้านซับใหญ่ศึกษานารีอนุสรณ์ 5","บ้านซับใหม่","บ้านซับอีลุม","บ้านซาด","บ้านซาดหัวหนองแคน","บ้านซาดศึกษา","บ้านซาต (มงคลวิทยา)","บ้านซ่าน","บ้านซ่านสามัคคี","บ้านซ่าเลือด","บ้านซาวหลวง","บ้านซำ","บ้านซำกกค้อ","บ้านซำขี้เหล็ก","บ้านชำเขียน","บ้านซำไคร้","บ้านซำงู","บ้านซำจานเนินทอง","บ้านซำจำปา","บ้านซำเจียง-ดงป่าเปลือย","บ้านซำตะเคียน (ลูกเสือชาวบ้านสมุทรปราการอุปถัมภ์)","บ้านซำตาโตง","บ้านซำเตย (ประกอบนงนุชอุปถัมภ์)","บ้านซำทอง","บ้านซำนกจิบ","บ้านซำบอน","บ้านซำบ่าง","บ้านซำบุ่น","บ้านซำป่ารัง","บ้านซำป่าหัน","บ้านซำผักแว่น-นาซำ","บ้านซำพร้าว","บ้านซำโพธิ์","บ้านซำภู","บ้านซำภูทอง","บ้านซำม่วง","บ้านซำมูลนาก","บ้านซำยาง","บ้านซำรัง","บ้านซำสะกวยน้อย","บ้านซำเสี้ยว","บ้านซำหวาย","บ้านซำแฮด (นักศึกษา-ประชานุสรณ์5)","บ้านซำไฮ","บ้านซินหนองเขวา (คุรุราษฎร์บำรุง)","บ้านซิแบร","บ้านซิวาเดอ","บ้านซีเยาะ","บ้านซึม (ศีลราษฎร์นุเคราะห์)","บ้านซือเลาะ","บ้านเซซ่งพัฒนา","บ้านเซโนนม่วง","บ้านเซประชาอุทิศ","บ้านเซอทะ","บ้านเซินใต้","บ้านเซินราษฎร์เกษมศรี","บ้านเซิม","บ้านเซียงซิน - โนนดู่","บ้านเซียงเซา","บ้านเซียบ","บ้านเซียมป่าหม้อ","บ้านเซือม","บ้านแซรไปร","บ้านแซรสะโบว","บ้านแซว","บ้านแซวประดู่","บ้านแซววิทยาคม","บ้านแซะ","บ้านแซะโมะ","บ้านโซกม่วง","บ้านโซง","บ้านโซงเลง","บ้านโซ่งเหล่านาดี","บ้านเฑียรยา","บ้านณรงค์","บ้านดง","บ้านดง และบ้านห้วยดอกเข็ม","บ้านดงเจริญ","บ้านดง (ธรรมาราษฎร์นุสรณ์)","บ้านดง (บึงไทรวิทยาคาร)","บ้านดงกระชู","บ้านดงกระทงยาม","บ้านดงกลาง","บ้านดงก้อม","บ้านดงกะเชา","บ้านดงกระทิง (มิตรภาพอนุสรณ์)","บ้านดงกะพุงหนองนาแซง","บ้านดงกำพี้","บ้านดงกู่","บ้านดงเกตุ","บ้านดงเก่า","บ้านดงขวาง","บ้านดงขวางคำโทน","บ้านดงขันทอง","บ้านดงขีสะเดาหวาน","บ้านดงขุมข้าว ","บ้านดงขุย","บ้านดงขุยใต้","บ้านดงแขวน","บ้านดงครั่งน้อย","บ้านดงครั่งใหญ่","บ้านดงคล้อ","บ้านดงค้าพัฒนา","บ้านดงคำ","บ้านดงคำโพธิ์","บ้านดงคุย","บ้านดงคู่","บ้านดงคู้","บ้านดงเค็ง","บ้านดงเค็ง (นําวัฒนาอุปถัมภ์)","บ้านดงเค็ง (คุรุราษฎร์ประชาสามัคคี)","บ้านดงเค็งดอนหัน","บ้านดงเค็งตู้","บ้านดงเครือวัลย์","บ้านดงแคน","บ้านดงโคร่ง","บ้านดงจงอาง","บ้านดงจันทำ","บ้านดงจันทูหนองไผ่ (ราษฎร์บำรุง)","บ้านดงจิก","บ้านดงเจริญ (วงค์ประชานุกูล)","บ้านดงแจ้งโนนสูง","บ้านดงชมภู","บ้านดงช้าง","บ้านดงช้างดี","บ้านดงเชือก","บ้านดงโชค","บ้านดงซ่อม","ดงซ่อมพิทยาคม","บ้านดงดารา","บ้านดงดาล","บ้านดงดำ","บ้านดงดำมิตรภาพที่ 88","บ้านดงดินแดง","บ้านดงดิบ","บ้านดงดู่งาม","บ้านดงเดือย","บ้านดงแดง","บ้านดงแดงหนองเพียขันธ์","บ้านดงต้อง (ดงขวางราษฎร์บำรุง)","บ้านดงต้อง","บ้านดงตาจันทร์","บ้านดงตาหวัง","บ้านดงติ้ว","บ้านดงใต้","บ้านดงถาวร","บ้านดงแถบ","บ้านดงทิพย์","บ้านดงโทน","บ้านดงไทยวิทยา","บ้านดงธาตุ","บ้านดงน้อย","บ้านดงน้อยโคกหนองแก","บ้านดงน้อยพัฒนา","บ้านดงนา","บ้านดงนาคำ","บ้านดงน้ำเดื่อ","บ้านดงบัง","บ้านดงบังป่าโจด","บ้านดงบัง (คุรุราษฎร์พัฒนา)","บ้านดงบัง (พิกุลศึกษาคาร)","บ้านดงบัง (สว่างวิทยา)","บ้านดงบัง (อาทรราษฎร์บำรุง)","บ้านดงบังคุรุราษฎร์บำรุง","บ้านดงบังคุรุราษฎร์อุปถัมภ์","บ้านดงบังซับสมบูรณ์","บ้านดงบังโนนจานเสาเล้า","บ้านดงบังพัฒนา","บ้านดงบังมวลชนรังสรรค์","บ้านดงบังหนองเขื่อน","บ้านดงบาก","บ้านดงบากโนนสวรรค์","บ้านดงบากหนองตาเต็น","บ้านดงบ้านนาประชาสรรค์","บ้านดงบุญนาค และสาขาสันกำแพง","บ้านดงประชานุกูล","บ้านดงประดาพระ","บ้านดงประเสริฐ","บ้านดงปอ","บ้านดงป่ายูง","บ้านดงป่าลัน","บ้านดงป่าส้านใหม่เจริญ","บ้านดงป่าหวาย","บ้านดงป่าเหมี้ยง","บ้านดงเปือย (มูลศึกษาวิทยา)","บ้านดงผักเทียม","บ้านดงพลวง","บ้านดงพลอง","บ้านดงพลอง (สำนักงานสลากกินแบ่งฯ)","บ้านยาง สามต้นสาขาบ้านดงพลับ","บ้านดงพอง","บ้านดงพัฒนาดงต้องประชารัฐ","บ้านดงพัฒนา","บ้านดงโพนยอ","บ้านดงไพรวัลย์","บ้านดงม่วงหัวดงหนองบาก","บ้านดงมอน","บ้านดงมะกรูด","บ้านดงมะกุ","บ้านดงมะกุ้ม","บ้านดงมะเกลือ","บ้านดงมะดะ","ดงมะตื๋นเนินสยามวิทยา","บ้านดงมะไฟ","บ้านดงมะไฟสามัคคีราษฎร์อุทิศ","บ้านดงมะยางหนองนกหอ","บ้านดงมะรุม","บ้านดงมะหรี่","บ้านดงมะเอก","บ้านดงมัน","บ้านดงมูลเหล็ก","บ้านดงเมย","บ้านดงเมือง (ดงเมืองวิทยา)","บ้านดงเมืองจอก","บ้านดงไม้งาม","บ้านดงยอ","บ้านดงย่อ","บ้านดงยอสามัคคีพิทยาศิลป์","บ้านดงยาง","บ้านดงยางพรพิบูลย์","บ้านดงยาง (คุรุราษฏร์บำรุง)","บ้านดงยาง 1","บ้านดงยาง 2","บ้านดงยางโคกพิลา (ประชาอุปถมภ์)","บ้านดงยางใต้","บ้านดงยางน้อยโนนตาล","บ้านดงยางนารายณ์","บ้านดงย่าปา","บ้านดงยายเภา","บ้านดงเย็น","บ้านดงเย็นพัฒนา","บ้านดงเย็นมิตรภาพที่ 167","บ้านดงเรือง","บ้านดงเรืองประชาสรรค์","บ้านดงฤาษี","บ้านดงลาน","บ้านดงลาน (คุรุรัฐประชาสรรค์)","บ้านดงลึก","บ้านดงวังพัง","บ้านดงวัฒนา","บ้านดงวิทยา","บ้านดงวิทยาคาร","บ้านดงเวียง","บ้านดงศรีสําราญ","บ้านดงสง่า","บ้านดงสระพัง","บ้านดงสวนพัฒนา","บ้านดงสวรรค์","บ้านดงสวรรค์ (คุรุราษฎร์รังสรรค์)","ดงสวรรค์วิทยา","บ้านดงสวรรค์หนองนกกด","บ้านดงสวอง","บ้านดงสวาง","ดงสว่างเจริญวิทย์","วัดหนองไผ่ สาขาบ้านดงสว่าง","บ้านดงสว่าง","บ้านดงสักงาม","บ้านดงสาร","บ้านดงสารภี","บ้านดงสำราญ","บ้านดงสิงห์ (ดำรงราษฎร์สามัคคี)","บ้านดงสีโท","บ้านดงสีเสียด","บ้านดงสุระ (แก้วอินตาราษฎร์บำรุง)","บ้านดงเสลา","บ้านดงเสียด","บ้านดงเสียว","บ้านดงเสือเหลือง","ดงแสนแก้วดงสำราญ","บ้านดงแสนตอ (ผดุงราษฎร์วิทยาคาร)","บ้านดงแสนสุข","บ้านดงหนองเกี่ยว","บ้านดงหนองบัว","บ้านดงหนองโพธิ์","บ้านดงหนองเหียน","บ้านดงหม้อทอง","บ้านดงหมากไฟ","บ้านดงหมู","บ้านดงหลง","บ้านดงหลบ","บ้านดงหลวง","บ้านดงห้วยเปลือย","บ้านดงห้วยหลวง","บ้านดงหวาย","บ้านดงหวายดงขวาง","บ้านดงหัวช้าง","บ้านดงเหนือ","บ้านดงแหลม","บ้านดงใหญ่","บ้านดงใหม่","บ้านดงอัคคะประชาสามัคคี","บ้านดงอินตา","บ้านดงอินำ","บ้านดงอีด่อย","บ้านดงอุดม","บ้านด้วงหนองหญ้ารังกา","บ้านดวด","บ้านดวน","บ้านดวนบากน้อย","บ้านดวนใหญ่ (ลีราษฎร์วัฒนา)","บ้านดอกคำใต้","บ้านดอกแดง","บ้านดอกบัว (บุญมานุเคราะห์)","บ้านดอกบัว (ราษฏร์บำรุง)","บ้านดอกไม้","บ้านดองกำเม็ด","บ้านดองดึง","บ้านดอน","บ้านดอน (นุ้ยนิธยาคาร)","บ้านดอน (ศรีเสริมกสิกร)","บ้านดอน (สหรัฐ-ราษฎร์อุทิศ)","บ้านดอนกกโพธิ์ค่ายเสรีวิทยา","บ้านดอนกระชาย","บ้านดอนกระดูกเนื้อ","บ้านดอนกระทิง-ศีรษะช้าง","บ้านดอนกร่าง (ฉากราษฎร์บำรุง)","บ้านดอนกรูด","บ้านดอนกลองหนองไฮ","บ้านดอนกลอย","บ้านดอนกลอยดอนอุดม","ดอนกลอยโนนชาด (พิลาศอุปถัมภ์)","บ้านดอนกลอยหนองยาง","บ้านดอนกลาง","บ้านดอนกลางทุ่งคำแต้","บ้านดอนกลาง (ราษฎร์สงเคราะห์)","บ้านดอนกลาง (กิดารีศึกษาคาร)","บ้านดอนกลางตาลเดี่ยว","บ้านดอนกลางนุกูลวิทย์","บ้านดอนก่อ","บ้านดอนกอก","บ้านดอนก่อกกเหลี่ยม","บ้านดอนกอย","บ้านดอนกะโดน","บ้านดอนกะทอด","บ้านดอนเกตุ","บ้านดอนเกล็ด","องค์การบริหารส่วนจังหวัดสุราษฏร์ธานี 2 (บ้านดอนเกลี้ยง)","บ้านดอนเกาะกา","บ้านดอนแก้ว","ดอนแก้วปากเป่งคุยสำโรง","บ้านดอนแก้วโนนอินทร์แปลง","บ้านดอนแก้ว (อาสาพัฒนาอินทร์ราษฎร์วิทยา)","บ้านดอนไก่ดี","บ้านดอนไก่เถื่อน","บ้านดอนขนุนพัฒนา","บ้านดอนขวาง","บ้านดอนข่อย ","บ้านดอนขะยอม","บ้านดอนข่า","บ้านดอนขาม","บ้านดอนขาว","บ้านดอนข้าวหลาม","บ้านดอนขิงแคงเหล่าน้อย","บ้านดอนขี้เหล็ก","บ้านดอนขุนห้วย","บ้านดอนเขว้า","บ้านดอนเขียว","บ้านดอนแขม","บ้านดอนแขวนประชานุกูล","บ้านดอนคนทา","บ้านดอนคราม","บ้านดอนควาย","บ้านดอนคำ","บ้านดอนเค็ง","บ้านดอนเค็ด","บ้านดอนเคี่ยม","บ้านดอนแค","บ้านดอนแคน","บ้านดอนแคน (คุรุราษฎร์ผดุงวิทย์)","บ้านดงดำมิตรภาพที่ 88 สาขาบ้านดอนโค้ง","บ้านดอนฆ่าเสือ","บ้านดอนงัว","บ้านดอนงาม","บ้านดอนงูเหลือม","บ้านดอนเงิน","บ้านดอนจังหัน","บ้านดอนจั่น (วาศน์เจริญเรือนอุทิศ)","บ้านดอนจันทร์","บ้านดอนจันทร์โพนสวรรค์","บ้านดอนจำปา","บ้านดอนจำปาดอนสวรรค์","บ้านดอนจิก","บ้านดอนเจริญ","บ้านดอนโจด","บ้านดอนใจดี","บ้านดอนชมพู (สังฆประชานุเคราะห์)","บ้านดอนชัย","บ้านดอนชัย (ประชาอุทิศ)","บ้านดอนชัย (กันทราษฎร์วิทยาคาร)","บ้านดอนชัยชนะ","บ้านดอนช้าง (ศรีสุขวิทยาคาร)","บ้านดอนชาด","บ้านดอนชี","บ้านดอนชีหนองมะยอด","บ้านดอนชุม (พิริยเทพวงศ์อนุสรณ์)","บ้านดอนเชียงคูณ","ชุมชนดอนเชียงโทรังแร้ง","บ้านดอนเชียงยืน","บ้านดอนไชย","บ้านดอนไชยป่าแขม","บ้านดอนซาก","บ้านดอนแซะ","บ้านดอนด่านใน","บ้านดอนดินแดง","บ้านดอนดี (ประชานุกูล)","บ้านดอนดึง","บ้านดอนดู่","บ้านดอนดู่คุรุราษฎร์บำรุง","บ้านดอนดู่คุรุราษฎร์วิทยา","บ้านดอนดู่วังบอน","บ้านดอนดู่เหล่าเสือ","บ้านดอนเดื่อ","บ้านดอนแดง","บ้านดอนแดงดอนดู่","บ้านดอนแดงคำอ้อ","บ้านดอนแดงดอนน้อยวิทยา","บ้านดอนแดงนาโนน","บ้านดอนแดงน้ำเกลี้ยง","บ้านดอนแดงเม่นใหญ่","บ้านดอนโด่โคกเลียบ","บ้านดอนตอง","บ้านดอนตะเคียน","บ้านดอนตะมุน","บ้านดอนตะลี","บ้านดอนตะลุมพุก (เจริญจิตต์วิทยา)","บ้านดอนตะหนิน","บ้านดอนตัดเรือ","องค์การบริหารส่วนตำบลเมืองพาน (บ้านดอนตัน)","บ้านดอนตาลโนนสูง","บ้านดอนตาลเสี้ยน","บ้านดอนตาวง","บ้านดอนตาสังข์","บ้านดอนตำลึง","บ้านดอนติ้ว","บ้านดอนติ้ว (ยาสูบสงเคราะห์)","บ้านดอนตูม","บ้านดอนเตย","บ้านดอนเตาเหล็ก","บ้านดอนเตาอิฐ","บ้านดอนแตง","บ้านดอนโตนด","บ้านดอนถั่วแปบพัฒนา","บ้านดอนทราย","บ้านดอนทอง","บ้านดอนทอง (อ่องพิทยาคาร)","บ้านดอนทอย","บ้านดอนทะแยง","บ้านดอนทับช้าง","บ้านดอนทัพควายครั่งน้อยโนนชาด","บ้านดอนแท่น","บ้านดอนแท่น (ประชานุสรณ์)","บ้านดอนโทน","บ้านดอนไทรงาม","บ้านดอนธรรม","บ้านดอนธาตุท่าฉางท่าพระทราย","บ้านดอนธูป","บ้านดอน-นกเอี้ยงเก่า","บ้านดอนนน","บ้านดอนน้อยท่าแห่ตาลม","บ้านดอนนา","บ้านดอนนางคำ","บ้านดอนนางหงส์ (หงส์ทองวิทยา)","บ้านดอนนาดี","บ้านดอนนาลุ่ม","บ้านดอนบม","บ้านดอนบ่อกุ่ม","บ้านดอนบ่อดอนแฮด","บ้านดอนบาก","บ้านดอนแบก (สุขประชา)","บ้านดอนประดู่","บ้านดอนประทาย","บ้านดอนปอ","บ้านดอนปอแดง","บ้านดอนปอหนองโอง","บ้านดอนป่าแคน","บ้านดอนปิน","บ้านดอนเปล้า","บ้านดอนผวา","บ้านดอนผอุง","บ้านดอนไผ่","บ้านดอนไผ่ (ราษฎร์รังสรรค์)","บ้านดอนไผ่ (อุดม-สอางค์อุ่นสุวรรณ)","บ้านดอนพยอม","บ้านดอนพยอมน้อย","บ้านดอนพราหมณ์","บ้านดอนพลอง","บ้านดอนพะงาด (รัฐราษฎร์วิทยา)","บ้านดอนพะธาย","บ้านดอนพันชาด","บ้านดอนพุทรา","บ้านดอนแพง","บ้านดอนโพ","บ้านดอนโพธิ์","บ้านดอนไพรวัลย์","บ้านดอนฟักทอง (พิณจันทนวงศ์ประชาสรรค์)","บ้านดอนเฟือง","บ้านดอนมดแดง (บ้านดงบัง)","บ้านดอนม่วง","บ้านดอนม่วง (แก้วประชาสรรค์)","บ้านดอนม่วงไข่","บ้านดอนม่วงป่าโมง","บ้านดอนม่วย","บ้านดอนมหาวัน","บ้านดอนมะกอก","บ้านดอนมะขาม","บ้านดอนมะขามช้าง (ใจราษฎร์อุปถัมภ์)","บ้านดอนมะจ่าง","บ้านดอนมะซ่อม","บ้านดอนมะตูม","บ้านดอนมะยาง กม.3","บ้านดอนมุกมัน","บ้านดอนมุยหนองแฝก","บ้านดอนมูล","บ้านดอนมูล (ศิลาเพชร)","บ้านต๊ำดอนมูล","บ้านดอนมูล (แงง)","บ้านดอนมูล (สุวรรณสาราษฎร์บำรุง)","บ้านดอนเมย","บ้านดอนเมือง","บ้านดอนโมกข์","บ้านดอนโมงสัมพันธ์ปลาคูณม่วงน้อย","บ้านดอนไม้งาม","บ้านดอนไม้ไฟ","บ้านดอนไม้ลาย","บ้านดอนยาง","บ้านดอนยาง (สหราษฎร์บำรุงวิทย์)","บ้านดอนยางเดี่ยว","บ้านดอนยางทุ่งน้อย","บ้านดอนยานาง","บ้านดอนยาว","บ้านดอนยาวประชากรอุปการ","บ้านดอนยี่กรอก","บ้านดอนยู","บ้านดอนเย็นใต้","บ้านดอนแยง","บ้านดอนระเบียง","บ้านดอนรัก","บ้านดอนเรือ","บ้านดอนแร้ง","บ้านดอนโรง มิตรภาพที่ 196","บ้านดอนไร่","บ้านดอนละนาม","บ้านดอนลาว","บ้านดอนลำดวน","บ้านดอนวัว","บ้านดอนว่าน","บ้านดอนวิเวก (วิเวกวิทยาคาร)","บ้านดอนเวียงจันทน์","บ้านดอนศาลา","บ้านดอนสง่า","บ้านดอนสน","บ้านดอนสนวน","บ้านดอนสบเปือ","บ้านดอนสมบูรณ์","บ้านดอนสมอ","บ้านดอนส้มโฮงวิทยาคม","บ้านดอนสระ","บ้านดอนสระจันทร์","บ้านดอนสลี","บ้านดอนสวรรค์","ดอนสวรรค์หนองกุงใต้วิทยา","บ้านดอนสว่าง","บ้านดอนสะฝาง","บ้านดอนสันติ","บ้านดอนสัมพันธ์","บ้านดอนสามัคคี","บ้านดอนสำนัก","บ้านดอนสำราญ","บ้านดอนสำโรง","บ้านดอนสุวรรณ","บ้านดอนสูง","บ้านดอนเสาธง","บ้านดอนเสียด","บ้านดอนแสนสุข","บ้านดอนหญ้านาง","บ้านดอนหน่อง","บ้านดอนหม่วย","บ้านดอนหมากพริกลิ้นฟ้า","บ้านดอนหมากมาย (ราษฎร์สามัคคีวิทยา)","บ้านดอนหมี","บ้านดอนหมู","บ้านดอนหมูโพธิ์ศรี ","บ้านดอนหมูวิทยา","บ้านดอนหลวง","บ้านดอนหล่ายทุ่ง","บ้านดอนหลี่","บ้านดอนหว่านหัวหนอง","บ้านดอนหวาย","บ้านดอนหวาย (สิงห์คุรุประชาสรรค์)","บ้านดอนหัน","บ้านดอนหันนาจาน","บ้านดอนหันโนนเพ็ด","บ้านดอนหันโนนหินแห่","บ้านดอนหันวิทยา","บ้านดอนหันวิทยาสาร","บ้านดอนหันสระบัว","บ้านดอนหันนาสวรรค์","บ้านดอนหัววัง","บ้านดอนหาด","บ้านดอนเหมือด","บ้านดอนใหญ่","บ้านดอนใหญ่หนองโสน","บ้านดอนอุดม","บ้านดอนอุดม (เนยอุปถัมภ์)","บ้านดอนอุมรัว","บ้านดอนโองท่าวารีวิทยาสรรค์","บ้านดอนฮี","บ้านดอย","บ้านดอยแก้ว","บ้านดอยไก่เขี่ย","บ้านดอยคำ","บ้านดอยงาม","บ้านดอยจัน","บ้านดอยช้าง","บ้านดอยแดน","บ้านดอยติ้ว","บ้านดอยน้ำเพียงดิน","บ้านดอยผีลู และสาขาบ้านในของ","บ้านดอยเลี่ยม","บ้านดอยสะโง๊ะ","บ้านดอยหล่อ","บ้านดอยฮาง","บ้านดาดทองเจริญ","บ้านดาดอุดม","บ้านดาโต๊ะ","บ้านดาน","บ้านด่าน","อนุบาลบ้านด่าน","บ้านด่าน (รัฐราษฎร์พัฒนา)","บ้านด่าน (ราษฎรบำรุง)","บ้านด่านกรงกราง","บ้านด่านเกวียน","บ้านดานคำ","บ้านด่านโง","บ้านด่านจันทร์","บ้านด่านเจริญชัย","บ้านด่านเจริญท่ากอกวิทยาสรรค์","บ้านด่านชัยพัฒนา","บ้านด่านช้าง","บ้านด่านชุมพล","บ้านด่านดู่","บ้านด่านติง","บ้านด่านทองหลาง","บ้านด่านไทยล้อม","บ้านด่านไทรสามัคคี","บ้านด่านนอกดง","บ้านด่านบุญธรรม","บ้านด่านพัฒนา","บ้านด่านมน","บ้านด่านม่วงคำ","อนุบาลด่านมะขามเตี้ย","บ้านด่านแม่แฉลบ","บ้านด่านโลด","บ้านด่านสมบูรณ์","บ้านด่านสันติราษฎร์","บ้านด่านหม่วน","บ้านด่านฮัง","บ้านดําเนินสะดวก (กิมลี้มณีฉาย)","บ้านด้ามพร้า","บ้านด้าย (ปาราษฎร์ดำรง)","บ้านด้ายเทพกาญจนาอุปถัมภ์","บ้านดารา","บ้านดาลบังบด","บ้านดาลอ","บ้านดาวเรือง (ธนาคารกรุงเทพ17)","บ้านดาหลำ","บ้านดาฮง","บ้านดำรงรักษ์ (ประชาอุทิศ)","บ้านดินก้อง","บ้านดินจี่","บ้านดินดำ","บ้านดินดำคำไฮ (หาญคุรุราษฎร์สามัคคี)","บ้านดินดำหมากเฟือง","บ้านดินดำเหล่าเสนใต้","บ้านดินแดง","บ้านดินแดง (สีลาประชารัฐ)","บ้านดินแดงน้อย","บ้านดินแดงสามัคคี","บ้านดินทรายอ่อน","บ้านดินทอง","บ้านดินนา","บ้านดินลาน","บ้านดินโส","บ้านดีลัง","บ้านดือแย","บ้านดือแยหะยี","บ้านดุซงปาแย","บ้านดุซงยอ","บ้านดุมใหญ่ดงยาง","บ้านดู่","บ้านดู่ฝายใหญ่","บ้านดู่ (สหราษฎร์พัฒนาคาร)","บ้านดู่ (สหราษฎร์วิทยา)","บ้านดูกอึ่ง","บ้านดูกอึ่งศรีเจริญ (ศรีปัญญาวิทยาคม)","บ้านดูกู","บ้านดู่ค้อ","บ้านดู่ทุ่งคำบอน","บ้านดูน","บ้านดูนประชารัฐ","บ้านดูนเลา","บ้านดูนสิม (อสพป.8)","บ้านดู่น้อย","บ้านดู่นาหนองไผ่","บ้านดู่พงษ์","บ้านดู่พัฒนา","บ้านดู่ลาด","บ้านดูลาเปอร์","บ้านดูวา","บ้านดู่โศก","บ้านดูสน","บ้านดู่หนองโกโนนสมบูรณ์","บ้านดู่ใหญ่","บ้านดู่อาราง","บ้านเด่น","บ้านเด่นชาติ","บ้านเด่นชุมพล","บ้านเด่นด่าน","บ้านเด่นพระ","เด่นไม้ซุงวิทยาคม","บ้านเด่นราษฎร์","เด่นวัวราษฎร์รังสรรค์","บ้านเด่นวิทยา","บ้านเด่นสําโรง","บ้านเด่นเหล็ก","บ้านเดิด","บ้านเดิ่น","บ้านเดิ่นหัวบึงวิทยา","บ้านเดียง (พลีศึกษา)","บ้านเดียงตะวันตก","บ้านเดียม","บ้านเดื่อ","บ้านเดื่อทุ่งสวรรค์","บ้านเดื่อดอนกลาง (ประชาสงเคราะห์)","บ้านเดื่อใต้","บ้านเดื่อศรีคันไชย","บ้านเดื่อสะพานโดม","บ้านแดง","บ้านแดงหนองแซง","บ้านแดง (สหราษฏร์วิทยา)","บ้านแดง (บุญเสริมอุทิศ)","บ้านแดง (รัฐราษฎร์พัฒนา)","บ้านแดงเจริญศิลป์","บ้านแดงน้อย","บ้านแดงโนนสว่าง","บ้านแดงประชาสรรค์","บ้านแดงโพงคำแก้ว","บ้านแดงราษฎร์สามัคคี","บ้านแดงสว่าง","บ้านแดงหม้อ","บ้านแดงเหล่ายอด","บ้านแดงใหญ่ (ราษฎร์คุรุวิทยาคาร)","บ้านแดนชุมพล (ประชานุกูล)","บ้านแดนพนา","บ้านโดง","บ้านโดด","บ้านโดท่างาม","บ้านโดน","บ้านโดนออง","บ้านโดนอาว","บ้านโดนโอก","บ้านโดมประดิษฐ์","บ้านใดโพธิ์ (เงิน-ทองย้อยอุทิศ)","บ้านไดกระพังปลา","บ้านไดชุมแสง","บ้านไดปลาดุกราษฎร์ศรัทธาทรงธรรม","บ้านไดรัง (ราษฎร์อุทิศ)","บ้านไดลึก ","บ้านต้นกระบก","บ้านต้นเกด","ต้นแก้วผดุงพิทยาลัย","บ้านต้นเขืองโจ้โก้สามัคคี","บ้านต้นง้าว","บ้านต้นงิ้ว","บ้านต้นงุ้น","บ้านต้นจันทน์","บ้านต้นโชค","บ้านต้นแซะ","บ้านต้นตาล","บ้านต้นโตนด","บ้านต้นทุเรียน","บ้านต้นไทร","บ้านต้นปรง","บ้านต้นประดู่","บ้านต้นปริง","บ้านต้นปล้องแดนเมือง","บ้านต้นผึ้ง","บ้านต้นโพธิ์ (ประชานุกูล)","ชุมชนศึกษาบ้านแม่สะแลป","บ้านต้นม่วง","บ้านต้นม่วง (ธรรมบาลวิทยา)","บ้านต้นมะพร้าว","บ้านต้นมะพร้าวมิตรภาพที่ 91","บ้านต้นยวน","บ้านต้นยาง","บ้านต้นรุง","บ้านต้นลำแพน","บ้านต้นสน","บ้านต้นส้าน","บ้านต้นสำโรง","บ้านต้นหนุน (หนุนราษฎร์สามัคคี)","บ้านต้นหยี","บ้านต้นแหน ","บ้านตบหู","บ้านตรมไพร","บ้านตรวจ","บ้านตรอกแค","บ้านตรอกนอง (ประทีปวารีราษฎร์วิทยา)","บ้านตรอกปลาไหล","บ้านตรอกสะเดา","บ้านตรอย","บ้านตระกวน","บ้านตระกาจ","บ้านตระการ","บ้านตระแบก","บ้านตระแบกน้อย","บ้านตระเปียงเตีย","บ้านตระมูง","บ้านตระแสง","บ้านตรัง","บ้านตรัง (จันทสิงห์อุทิศ)","บ้านตรางสวาย","บ้านตราด","บ้านตราดหนองพลวง","บ้านตราแด๊ะ","บ้านตรำดม","บ้านตรีคาม","บ้านตรึม ","บ้านตรุง","บ้านตลาด","บ้านตลาด (คำนายครุราษฎร์รังสรรค์)","บ้านตลาดขี้เหล็ก","บ้านตลาดควาย","บ้านตลาดควาย (ประชานุกูล)","บ้านตลาดชัย","บ้านตลาดไชย","บ้านตลาดตาโหมก","ตลาดไทรโนนดู่หนองจิกวิทยา","บ้านตลาดไทร","บ้านตลาดนัดคลองขุด","บ้านตลาดเนินหิน (สุรกิจบวรราษฎร์อุปถัมภ์)","บ้านตลาดโนนโพธิ์","บ้านตลาดประดู่","บ้านตลาดพัฒนา","บ้านตลาดโพธิ์ ","บ้านตลาดม่วง","บ้านตลาดแย้","บ้านตลาดลำใหม่","บ้านตลาดวังหว้า","บ้านตลาดหนองแก","บ้านตลาดหนองเรือ","บ้านตลาดเหนือ (วันครู 2502)","บ้านตลาดอุดมวิทย์","บ้านตลิ่งชัน","บ้านตลิ่งชัน-สร้างแก้ว","บ้านตลิ่งสูง","บ้านตลิ่งสูงสามัคคี","บ้านตลุกกลางทุ่ง","บ้านตลุกข่อยน้ำ","บ้านตลุกคูณพัฒนา","บ้านตลุกงาม","บ้านตลุกชั่งโค","บ้านตลุกป่าตาล","บ้านตลุกพลวง","บ้านตลุกสาหร่าย","บ้านตลุกหิน","บ้านตลุกหินปูน","บ้านตลุงใต้","บ้านตลุงโนนกอก","บ้านตลุงเหนือ","บ้านตอกตรา","บ้านตอกแป้น","บ้านตอแก","บ้านตอง","บ้านต้อง","บ้านต้อง (ศรีบัวบานวิทยาคาร)","บ้านตองกาย","บ้านตองโขบ","บ้านต้องโคกกะแซ","บ้านตองม่วงชุม","บ้านต้องหนองสระปลา","บ้านต่อตั้ง","บ้านต้อน","บ้านต้อนราษฎร์ดำรงวิทย์","บ้านต้อนวิทยาคาร","บ้านต้อนเหนือ","บ้านต๋อม","บ้านต๋อมดง","บ้านตอรัง","บ้านตอเรือ","บ้านต่อเรือ","บ้านตอแล","บ้านตอหลัง","บ้านตอออ","บ้านตะกรบ","บ้านตะกรุด","บ้านตะกรุดหิน","บ้านตะกรุมทอง","บ้านตะกั่วป่า","บ้านตะกุดเครือปลอก","บ้านตะกุดงาม","บ้านตะกุดจั่น","บ้านตะกุดตาสา (ลองตองประชานุกูล)","บ้านตะกุดโนนระเวียง","บ้านตะกุดเป้า","บ้านตะกุดไผ่","บ้านตะกุดภิบาล","บ้านตะกุดหว้า","บ้านตะกุย (ค้ำคูณบำรุง)","บ้านตะเกราทอง","บ้านตะแกรง","บ้านตะโก","บ้านตะโก ","บ้านตะโกโคก","บ้านตะโกทุ่ง (คุรุราษฎร์รังสรรค์)","บ้านตะโกบำรุง","บ้านตะโกรี","บ้านตะโกล่าง","บ้านตะเข้ขานสามัคคีวิทยา","บ้านตะคร้อ","บ้านตะคร้อ (มิตรภาพ4)","บ้านตะคร้อ (รัฐประชาชนูทิศ)","บ้านตะครอง","บ้านตะครองใต้","บ้านตะคร้อโนนทอง","บ้านตะคร้อลาด","บ้านตะคร้อหนองหญ้าขาว","บ้านตะเคียน","บ้านตะเคียนงาม","บ้านตะเคียนช่างเหล็ก","บ้านตะเคียนด้วน","บ้านตะเคียนเตี้ย","บ้านตะเคียนทอง","บ้านตะเคียนบังอีง","บ้านตะเคียนเภา","บ้านตะเคียนราม","บ้านตะเคียนหลบฟ้า","บ้านตะโคงสามัคคี","บ้านตะเฆ่ค่าย","ตะดอบวิทยา","บ้านตะตึงไถง","บ้านตะโกตาเนตร","บ้านตะโนน","บ้านตะบอง ","บ้านตะบิ้ง","บ้านตะบิงติงงี","บ้านตะบิงติงงีสามัคคี","บ้านตะบิงตีงี","บ้านตะเบาะ","บ้านตะแบก","บ้านตะแบกงาม","บ้านตะแบงสามัคคี","บ้านตะพานหิน","บ้านตะพุนทอง","บ้านตะเภา","บ้านตะมะยูง","บ้านตะมะหนองกระจาน","บ้านตะโม่ประชาสรรค์","บ้านตะลอมไผ่","บ้านตะลุมพุก","บ้านดะแลง","บ้านตะโละ","บ้านตะโละไกรทอง","บ้านตะโละซูแม","บ้านตะโละดารามัน","บ้านตะโละแน็ง","บ้านตะโละบาลอ","บ้านตะโละบูเก๊ะ","บ้านตะโละมีญอ","บ้านตะโละแมะนา","บ้านตะโละสดาร์","บ้านตะโละสะมีแล","บ้านตะโละใส","บ้านตะโละหะลอ","บ้านตะวันจาก","บ้านตะเสะ","บ้านตะหนอด","บ้านตะเหลี่ยง","บ้านตัง","บ้านตังกาเด็ง","บ้านตั้งใจ","บ้านตังหมอง","บ้านตันหยง","บ้านตันหยงกลิง","บ้านตันหยงกาโบยชัยพัฒนา","บ้านตันหยงดาลอ","บ้านตันหยงเปาว์","บ้านตันหยงโป","บ้านตันหยงละไน้","บ้านตันหยงลิมอ","บ้านตันหยงลุโละ","บ้านตันหยงอุมา","บ้านตับเต่า","บ้านตับเต่าโนนจันทร์","บ้านตับเต่าหนองเทาสามัคคี","บ้านตัวอย่าง","บ้านตากแดด","บ้านตากประถมวิทยา","บ้านตากฟ้าพัฒนา","บ้านตากลาง","บ้านตากวน","บ้านตากอง","บ้านตากิ่ม","บ้านตากูก","บ้านตาเกาตาโกย","บ้านตาแก","บ้านตาโกน","บ้านตาขุน","บ้านตาคง","บ้านตาเครือ","บ้านต่างแคน","บ้านต่างตา","บ้านตางมาง","บ้านตางาม","บ้านตาโงะ","บ้านตาจวน","บ้านตาจ่อยหนองสระ","บ้านตาจั่น","บ้านตาเจา","บ้านตาชี","บ้านตาชู","บ้านตาเซะ","บ้านตาเซะใต้","บ้านตาเซะเหนือ","บ้านตาด","บ้านตาดกลอย","บ้านตาดข่า","บ้านตาดข่าพัฒนา","บ้านตาดซ้อ","บ้านตาดแต้","บ้านตาดโตน","บ้านตาดโตนไร่เดชา","บ้านตาดโตน (คุรุประชาสามัคคี)","บ้านตาดทอง","บ้านตาดน้ำพุ","บ้านตาดโนนทองหลาง","บ้านตาดภูวง","บ้านตาดม","บ้านตาดราษฎร์สมบูรณ์","บ้านตาดรินทอง","บ้านตาดเสริม","บ้านตาดเสี้ยว","บ้านตาดไฮ","บ้านตาเตน","บ้านตาเตียว","บ้านตาแตรวทัพดัด","บ้านตาทอง","บ้านตาทิตย์","บ้านตาแท่น","บ้านตานบ","บ้านตานวน","บ้านต้านาล้อม","บ้านตานี","บ้านตาเนาะปูเต๊ะ","บ้านตาเนาะปูเต๊ะใน","บ้านตาเนาะแมเราะ","บ้านตาบา","บ้านตาเบา","บ้านตาแบน","บ้านตาปรก","บ้านตาเป้า","บ้านตาเปาว์","บ้านตาเปียง","บ้านตาแปด","บ้านตาพราม","บ้านตาพวนสร้างแซ่ง","บ้านตาเพชร","บ้านต้าม","บ้านบันนังบูโย (บ้านตามตะวัน)","บ้านตามา","บ้านตามาง (อมฤทธิ์อุปถัมภ์)","บ้านตามุง","บ้านตามุย","บ้านตามูล (รัฐประชาสงเคราะห์)","บ้านตาเม็ง (อสพป.9)","บ้านตาเมาะ","บ้านตาเมียง","บ้านตาโม","บ้านตาโมม","บ้านต้าย","บ้านต้ายนาคูณวิทยา","บ้านต้ายสวรรค์ดงหว้าน","บ้านตายอย","บ้านตายัวะ","บ้านตายา","บ้านตายู (อสพป.32)","บ้านตาราม","บ้านตาเรือง (ตำรวจชายแดนสงเคราะห์)","บ้านตาล","บ้านตาลราษฏร์อุทิศ","บ้านตาลกุดยางเดี่ยวโนนสมบูรณ์","บ้านตาลโกน","บ้านตาลเจ็ดยอด","บ้านตาลชุม","บ้านตาลดำ","บ้านตาลเดี่ยว","บ้านตาลใต้","บ้านตาลเนิ้ง (โพธิราชอำนวย)","บ้านตาลปากน้ำ","บ้านตาลพร้า","บ้านตาลเลียน","บ้านตาลวก","บ้านตาลเหนือ","บ้านตาลอก","บ้านตาลอย-หนองคัน","บ้านตาลีอายร์","บ้านตาเลียว","บ้านตาโละ","บ้านตาวร","บ้านตาวัง","บ้านตาสะดำ (สุรวุฒิอนุเคราะห์)","บ้านตาสา","บ้านตาสุด","บ้านตาเส็ด","บ้านตําเสาพัฒนา","บ้านตาเสาะ","บ้านตาโสม","บ้านตาหนึก","บ้านตาหมน","บ้านตาหมื่น","บ้านตาหยวก (ประชาสงเคราะห์)","บ้านต้าหลวง (ต้าประชานุกูล)","บ้านตาหล่ำ","บ้านตาเหล็ง","บ้านตาแหลวโนนหมากแงว","บ้านตาโหงก","บ้านตาอ็อง","บ้านตาอี","บ้านตาอุด","บ้านตาเอก","บ้านตาโอง","บ้านตาฮะ","ต๊ำ (อินโต-ประชานุเคราะห์)","บ้านต๊ำใน","บ้านตำปูง","บ้านต๊ำพระแล และสาขาบ้านต๊ำกลาง","บ้านต๊ำม่อน","บ้านตำมะลังใต้","บ้านตำมะลังเหนือ","บ้านตำแยหนองคู","บ้านตำแย","บ้านตำแย (ประชานุเคราะห์)","บ้านตำแย (ประชาสงเคราะห์)","บ้านตำแยโนนยาง","บ้านตำแยหนองเม็ก","บ้านตำหนัง","บ้านตำหรุ (วิงประชาสงเคราะห์)","บ้านต๊ำเหล่า","บ้านติงไหร","เทศบาลนาอาน 1 บ้านติดต่อ","บ้านติเตะ","บ้านติม (พันธ์พิทยาคม)","บ้านติ้ว (คุรุราษฎร์สงเคราะห์)","บ้านติ้ว","บ้านติ้วราษฏร์อุทิศ","บ้านติ้วน้อย","บ้านติ้วสันติสุข","บ้านตีกา","บ้านตีนตก","วัดเชิงเนิน","บ้านตีนเป็ด","บ้านตีบใต้","บ้านตึก","บ้านตึกชุม","บ้านตึ๊ด","บ้านตือกอ","บ้านตือเบาะ","บ้านตือมายู","บ้านตือระ","บ้านตือระ มิตรภาพที่ 172","บ้านตุ","บ้านตุ๊กแก","บ้านตุงติง","บ้านตุงลอย","บ้านตุงลุง","บ้านตุงลุงเหนือ","บ้านตุ่น","บ้านตุปะ","บ้านตุ้มเหนือ","บ้านตูแตหรำ","บ้านตูบโกบ","บ้านตูบค้อ","บ้านตูบช้าง","บ้านตูม","บ้านตูม (สังวาลย์ราษฎร์สามัคคี)","บ้านตูม (นพค.15 กรป.กลางอุปถัมภ์)","บ้านตูม (ราษฎร์บูรณะ)","บ้านตูม (อนุกูลราษฎร์พัฒนา)","บ้านตูมราษฎร์บูรณะ","บ้านตูมหวาน","บ้านตูล","บ้านตูเวาะ","บ้านตูหยง","บ้านเตง (เรือนจุลประชาสรรค์)","บ้านเตย","ภูคาวิทยาคม","บ้านเตย (คุรุราษฎร์วิทยา)","บ้านเตยกระโตน","บ้านเตยประชาบำรุง","บ้านเตยใหญ่","บ้านเตราะหัก","บ้านเตรียม","บ้านเตรียมปัญญา","บ้านเตว็ดกลาง","บ้านเตว็ดนอก (สร้อยสนประชาสรรค์)","บ้านเตาแดก","บ้านเต่านอ","บ้านเตาบ่า","บ้านเตาปูน","บ้านเตาปูน (ธนาคารกรุงเทพ 16)","บ้านเตาปูน (พิไชยาประชานุกูล)","บ้านเต้าปูนหาย","บ้านเตาหม้อ (กิจกาญจน์ราษร์อุทิศ)","บ้านเตาเหล็กประดู่หัวคู","บ้านเตาเหล็ก-ลุมปุ๊ก","บ้านเตาไห","บ้านเตาไหสร้างแก้ว","บ้านเต่าไหเหนือ","บ้านเตียนอาง","บ้านแต้ - หนองบก","บ้านแต้ ","บ้านแต (กวีรัตน์ราษฎร์บำรุง)","บ้านแต้เก่า","บ้านแต้ชะบา (อสพป.38)","บ้านแต้มะหลี่","บ้านแตล","บ้านแต้ใหม่","บ้านแตะหรำ","บ้านโต","บ้านโตก","บ้านโตกใต้","บ้านโต่งโต้น","บ้านโตงน้อย","บ้านโตน","บ้านโตนดพูนผลวิทยา","บ้านโตนด","บ้านโตนด (คีรีมาศวิทยา)","บ้านโตนดน้อย","บ้านโต้นนท์","บ้านโตนปาหนัน","บ้านโตนยาง","บ้านโต้นสามัคคีวิทยา","บ้านโต๊ะชูด","บ้านโต๊ะเด็ง","บ้านโต๊ะตีเต","บ้านโต๊ะนอ","บ้านโตะบาลา","บ้านโต๊ะปาแก๊ะ","บ้านโต๊ะพราน","บ้านโต๊ะเวาะ","บ้านใต้","บ้านใต้ฆ้องโนนจิก","บ้านไตรคีรี","บ้านไตรตรึงษ์","บ้านถนน","บ้านถนน (ประสมทรัพย์ประชานุกูล 1)","บ้านถนนกลาง","วัดถนนกะเพรา","บ้านถนนคด (ศรีวิทยาคาร)","บ้านถนนโคกใหญ่","บ้านถนนงาม (มิตรภาพที่ 27)","บ้านถนนชัย","บ้านถนนถั่ว (กองทัพบกประชาสามัคคี)","บ้านถนนน้อย","บ้านถนนพระร่วง","บ้านถนนโพธิ์","บ้านถนนหัก","บ้านถนนหัก (เพียรประจงวิทยา)","บ้านถนนหัก (สุวรรณราษฎร์บำรุง)","บ้านถนนหักใหญ่","บ้านถลุงเหล็ก","บ้านถ่อน","บ้านถ่อน (คุรุราษฎร์สามัคคี)","บ้านถ่อน ต.พันนา","บ้านถ่อนคำหวด","บ้านถ่อนดอนม่วง","บ้านถ่อนน้อยหนองไผ่คำ","บ้านถ่อนนาเพลิน","บ้านถ่อนนาลับ","บ้านถ่อนใหญ่ถ่อนน้อย","บ้านถ่อนใหญ่","บ้านถาวรนาอุดม","บ้านถาวร","บ้านถาวรวัฒนา","บ้านถ้ำ","บ้านถ้ำ ตชด.","บ้านถ้ำแก้ว (เตรียมอุดมศึกษา 1)","บ้านถ้ำโกบ","บ้านถ้ำเขาน้อย","บ้านถ้ำแข้","บ้านถ้ำคะนอง","บ้านธรรมรัตน์","บ้านถ้ำเจริญ","บ้านถ้ำช้างอินทร์แปลง","บ้านถ้ำดาวดึงส์","บ้านถ้ำตลอด","บ้านถ้ำตับเตา","บ้านถ้ำเต่า","บ้านถ้ำทองหลาง","บ้านถ้ำทะลุ","บ้านถ้ำธง","บ้านถ้ำน้ำบัง","บ้านถ้ำประชาบำรุง","บ้านถ้ำปลา","บ้านถ้ำผาตอง","บ้านถ้ำผาลาด","บ้านถ้ำผึ้ง","บ้านถ้ำพระ","บ้านถ้ำพริก","บ้านถ้ำเพชร","บ้านถ้ำมงคลชัย","บ้านถ้ำมูล","บ้านถ้ำลอด","บ้านถ้ำลา","บ้านถ้ำศิลป์","บ้านถ้ำเสือ","บ้านถิ่น","บ้านถิ่นสุขาวิทยา","บ้านถิ่น (ถิ่นวิทยาคาร)","บ้านถิ่นทอนเหนือ","บ้านถิ่นสำราญ","บ้านถืมตอง","บ้านเถกิง","บ้านแถววังน้ำใสสามัคคี (คุรุราษฎร์บำรุง)","บ้านแถววิทยาคาร","บ้านไถงตรง","บ้านทด","บ้านทดเจริญ","บ้านทดน้อย","บ้านทดวงศ์สมบูรณ์","บ้านทนง (รัฐราษฎร์วิทยา)","บ้านทม","บ้านทมนางาม","บ้านทมอ (เดื่อราษฎร์บำรุง)","บ้านทรงธรรม","บ้านทรัพย์เกษตร","บ้านทรัพย์เจริญ","บ้านทรัพย์ประเมิน","บ้านทรัพย์พุทรา","บ้านทรัพย์ภูพานคำปลายหลายหนองผักแว่น","บ้านทรัพย์มงคล","บ้านทรัพย์มะนาว","บ้านทรัพย์วังทอง","บ้านทรัพย์สมบูรณ์","ทรัพย์สมบูรณ์พิทยาคม","บ้านทรัพย์สมบูรณ์โนนอินทร์แปลง","บ้านทรัพย์สว่าง","บ้านทรัพย์สินพูน","บ้านทรายแก้ว","บ้านทรายขาว","บ้านทรายขาวหนองแป้นประชาสรรค์","บ้านทรายงาม","บ้านทรายงามวิทยา","บ้านทรายแดง","บ้านทรายทอง","เทศบาลทับช้าง 1","บ้านทรายทองวิทยาคม","บ้านทรายพูล","บ้านทรายมูล","ทรายมูลหนองกุงทรายศรีพิทยา","บ้านทรายมูล (จันทน์รัตนานุเคราะห์)","บ้านทรายมูล (ทรายมูลประชาราษฏร์)","บ้านทรายมูลคำผักแพว","บ้านทวดทอง","บ้านทวดเหนือ","บ้านทวารไพร","บ้านทวีผล","บ้านท้องโกงกาง","บ้านท้องครก","บ้านทองคำพิงวิทยา","บ้านท้องคุ้ง","บ้านท้องนายปาน","บ้านท้องฟ้า","บ้านทองมงคล","บ้านท้องเรือ","บ้านทองสวัสดิ์","บ้านทองสาย","บ้านทองหลาง","บ้านทองหลางน้อย","บ้านทองอินทร์","บ้านทองอินทร์สวนมอญ","บ้านทอน","บ้านท่อน","บ้านทอนดอนยาว","บ้านทอนตรน","บ้านทอนพลา","บ้านทอนวังปราง","บ้านทอนหญ้าปล้อง","บ้านทอนหาน","บ้านทอนเหรียน","บ้านท่อเมืองลัง","บ้านทะนงชัย","บ้านทะเมนชัย","บ้านทะลอก","บ้านทะเล (เสมาประชาสรรค์)","บ้านทะเลทอง","บ้านทะเลนอก","บ้านทะเลบก","บ้านทะเลพัฒนา","บ้านทะเลวังวัด","บ้านทะเลสองห้อง","บ้านทะเลหอยราษฎร์อุทิศ","บ้านทะเลหอยราษฎร์อุทิศ สาขาบ้านควนเขียว","บ้านทะเลเหมียง","บ้านทะโลงเหนือ","บ้านทัน","บ้านทันดู่เหนือ","บ้านทันสมัย","บ้านทับกระดาษ","บ้านทับกี่","บ้านทับกุมารทอง","บ้านทับโกบ","บ้านทับควาย","บ้านทับจาก","บ้านทับช้าง","บ้านทับเดื่อ","บ้านทับใต้","บ้านทับท้อน","บ้านทับไทร","บ้านทับน้อย","บ้านทับบา","บ้านทับเบิกร่วมใจ","บ้านทับปริก","บ้านทับผึ้ง","บ้านทับพล","บ้านทับโพธิ์วิทยา","บ้านทับเมย","บ้านทับยาง","บ้านทับร้าง","บ้านทับละคร","พระราชทานทับละมุ","บ้านทับลาน","บ้านทับลุ่มประชาพัฒนา","บ้านทับวัง","บ้านทับศิลา","บ้านทับสงฆ์","บ้านทับสูง","บ้านทับใหม่","บ้านทับใหม่ (ราษฎร์บำรุง)","บ้านทับไฮ","บ้านทัพ","บ้านทัพกระบือ","บ้านทัพเซียม","บ้านทัพตาแทน","บ้านทัพทัน","บ้านทัพไทย","บ้านทัพนคร","บ้านทัพป่าจิก","บ้านทัพป่าเส้า","บ้านทัพพระยา","บ้านทัพมะขาม","บ้านทัพม้าดอนหันแวงวิทยา","บ้านทัพม่าน","บ้านทัพยายปอน","บ้านทัพส่วยหนองพอก","บ้านทัพหลวง","บ้านท่า","บ้านท่ากกแก","บ้านท่ากกแดง","บ้านท่ากกต้อง","บ้านท่ากกตาล","บ้านท่ากฐิน","บ้านท่ากรวด","บ้านท่ากระดาน","บ้านท่ากระดุน","บ้านท่ากระเทียม","บ้านท่ากระเสริม","บ้านท่ากร่าง","บ้านท่ากลอย (ทรัพย์กมลประชาสรรค์)","บ้านท่าก่อ","บ้านท่าก้อน","บ้านท่าก๊อพลับพลา","บ้านท่ากอม่วง (รัฐประชาอุทิศ)","บ้านท่ากะบาก","บ้านท่ากำชำ","บ้านท่ากุน","บ้านทากู่","บ้านท่ากูบ","บ้านท่าเกวียน","บ้านท่าเกษม","บ้านท่าโก","บ้านท่าขนอน","บ้านท่าขนาน","บ้านท่าขวัญ (ราษฎร์บำรุง)","บ้านท่าข้องเหล็ก","บ้านท่าขอนยาง","บ้านท่าข่อย","บ้านท่าขาม","บ้านท่าข้าม","บ้านท่าข้ามโพนสว่าง","บ้านท่าข้ามควาย","บ้านท่าข้ามตั้งตรงจิตร 10 (นายประยงค์ นางเล็ก ตั้งตรงจิตร)","บ้านท่าขามไร่เดื่อสามัคคี","บ้านท่าข้ามวังน้ำ","บ้านท่าข้ามสามัคคี","บ้านท่าข้าวเปลือก","บ้านท่าขาหย่าง","บ้านท่าขี้เหล็ก","บ้านท่าขึ้น","บ้านท่าขุนคง","บ้านทาขุมเงิน","บ้านท่าเขา","บ้านท่าคร้อ","บ้านท่าคล้อ","บ้านท่าคลอง","บ้านท่าควาย","บ้านท่าค้อ","บ้านท่าค้อ (ชุณห์ประสาทศิลป์)","บ้านท่าคอยนาง","บ้านท่าคาน","บ้านท่าค้ำ (ไตรราษฎร์บำรุง)","บ้านท่าคำบง","บ้านท่าคำรวม","บ้านท่าคุระ (บรรหารราษฎร์นุกูล)","บ้านท่าแค วันครู 2500","บ้านท่าแคง (เสริมอุทิศ)","บ้านท่าไค้","บ้านท่าไคร","บ้านท่าไคร้","บ้านทางขวาง","บ้านทางข้าม","บ้านทางงอ","บ้านทางตรง","บ้านทางพาดเขาสวนกวาง","บ้านทางพาดหนองแวงโอง (ศรเสนานุสรณ์)","บ้านทางยาง","บ้านทางสาย","บ้านทางหวาย","บ้านท่างอย","บ้านท่างาม และรร.บ้านท่างาม สาขาบ้านดานเม็ก","บ้านท่างาม","บ้านท่าจันทน์","บ้านท่าจันทน์ (ศักดี)","บ้านท่าจันทน์ (สำลีประชานุเคราะห์)","บ้านท่าจาม","บ้านท่าจำปา","บ้านท่าจีน","บ้านท่าจูด","บ้านท่าเจริญ","บ้านท่าฉาง","บ้านท่าแฉลบ","บ้านทาชมภู","บ้านท่าช่วง","บ้านท่าชวน","บ้านท่าชะมวง","บ้านท่าชะเมา","บ้านท่าชะอม","บ้านท่าชัย","บ้านท่าช้าง","บ้านท่าช้าง และวัดสันเหมือง","บ้านท่าช้างเจริญไพศาล","บ้านท่าช้าง (เขตการทางนครราชสีมาสงเคราะห์ 2)","บ้านท่าช้างคล้องหนองอีเปี้ย","บ้านท่าช้างน้อยโนนสวัสดิ์","บ้านท่าชุม (ประชาอุทิศวิทยาคาร)","บ้านท่าเชียงเครือ","บ้านท่าเชียด","บ้านท่าซุง","บ้านท่าแซะ","บ้านท่าด้วง","บ้านท่าดอกแก้ว","บ้านท่าดอกคำ","บ้านท่าดาน","บ้านท่าด่าน","บ้านท่าดินดำ","บ้านท่าดินแดง","บ้านท่าดีหมี","บ้านท่าเดื่อ","บ้านท่าแดง","บ้านท่าตลาด","เพียงหลวง ๑ (บ้านท่าตอน) ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านท่าตะโก","บ้านท่าตะคร้อ","บ้านท่าตะคร้อมิตรภาพที่ 192","บ้านท่าตะเคียน","บ้านท่าตะแบก","บ้านท่าตะเภา","บ้านท่าตาฝั่ง","บ้านท่าตาสี","บ้านท่าตาเสือ","บ้านท่าตูม","บ้านท่าตูมดงสระพัง","บ้านท่าตูมดอนเรือ","บ้านท่าเต้น","บ้านท่าเตียน","บ้านท่าแตง","บ้านท่าแต้ปุ่งแก","บ้านท่าโต๊ะเมฆ","บ้านท่าทราย","บ้านท่าทอง (สามัคคีประชาสฤษฎิ์)","บ้านท่าทอง (อุดมวิทยาคาร)","บ้านท่าทองดำ","บ้านท่าทางเกวียน","บ้านท่าทิศเฮืองกกเกลือ","บ้านท่าทุ่งนา","บ้านทาทุ่งไผ่","บ้านท่าทุ่ม","บ้านท่าเทศ","บ้านท่าโทก","บ้านท่าไท","บ้านท่าไทร","บ้านทาน","บ้านท่านหญิงวิภา","บ้านท่าน้อย","วัดบ้านท่านั่ง","บ้านท่านา","บ้านท่านางงาม","บ้านท่านางแนว","บ้านท่านางพรหม (ธนาคารกรุงเทพ 8)","บ้านท่านางเลื่อนท่าข่อย","บ้านท่าน้ำ","บ้านท่าน้ำเค็มใต้","บ้านท่าน้ำตะวันตก","บ้านท่าน้ำตะวันออก","บ้านท่านุ่น","บ้านท่าเนียน","บ้านทำเนียบ","บ้านท่าบ้งมั่ง (ทหารอากาศอเมริกันสงเคราะห์)","บ้านท่าบม","บ้านท่าบ่อ","บ้านท่าบ่อ (บ่อศรีรัตนอำนวย)","บ้านท่าบ่อยาง","บ้านท่าบันได","บ้านท่าบัว ","บ้านท่าบุ่ง","บ้านท่าปก","บ้านท่าประดู่","บ้านทาปลาดุก","บ้านท่าปะทายโนนตูม","บ้านท่าปากแหว่ง","บ้านท่าปาบ","บ้านทาป่าเปา","บ้านทาป่าสัก","อนุบาลบ้านท่าปุย","บ้านท่าปุยตก","บ้านท่าเปลือย","บ้านท่าเปิบ","บ้านท่าโป่ง","บ้านท่าโป่งแดง","บ้านท่าโปงทอง","บ้านท่าผักชี","บ้านท่าผา","บ้านท่าผาปุ้ม","บ้านท่าผู","บ้านท่าไผ่","บ้านท่าฝาง","บ้านท่าพง","บ้านท่าพระตระกาศ","บ้านท่าพระเนาว์","บ้านท่าพล (ท่าพลวิทยาคาร)","บ้านท่าพลู","บ้านท่าพะเนียง","บ้านท่าพันโฮง","บ้านท่าพิกุล","บ้านท่าพุ","บ้านท่าพุทรา","บ้านท่าเพชร","บ้านท่าแพ","บ้านท่าแพราษฎร์พัฒนา","บ้านท่าโพธิ์ (พินิจค้าประชาสรรค์)","ท่าโพธิ์ท่าไฮหนองแวงประชาสรรค์","บ้านท่าโพธิ์","บ้านท่าโพธิ์ท่ามะเดื่อน้อย","บ้านท่าโพธิ์ศรี","บ้านท่าฟ้าใต้","บ้านท่าฟ้าเหนือ","บ้านทาม","บ้านทามจาน","บ้านท่าม่วง","บ้านท่าม่วงเวียงคํา","บ้านท่ามะกรูด","บ้านท่ามะกอก","บ้านท่ามะกา","บ้านท่ามะเกว๋น","บ้านท่ามะเกี๋ยง","บ้านท่ามะแกง","บ้านท่ามะขาม","บ้านท่ามะเดื่อ","บ้านท่ามะนาว","บ้านท่ามะปราง","บ้านท่ามะพร้าว","บ้านท่ามะเฟือง","บ้านท่ามะไฟ","บ้านท่ามะไฟหวาน","บ้านท่ามะริด","บ้านท่ามะโอ","บ้านท่ามักกะสัง","บ้านท่าม่าน","บ้านท่ามิหรำ","บ้านท่าเมือง","บ้านท่าไม้","บ้านท่าไม้งาม","บ้านท่าไม้แดง","บ้านท่าไม้ทอง","บ้านท่าไม้รวก","บ้านท่าไม้ลาย","บ้านท้ายน้ำ","บ้านท่ายม","บ้านท่ายาง","บ้านท่ายาง (ประชาสรรค์)","บ้านท่ายางชุม","บ้านท่ายามู","บ้านท่าเยี่ยม","บ้านท่าเยี่ยมโนนคอม","บ้านท่าเยี่ยมน้ำพุง","บ้านท่าเยี่ยมวิทยา","บ้านท่าเยี่ยมวิทยายล","บ้านท่าแย้","บ้านท่าแยก","บ้านท่าระพา","บ้านท่าเริงรมย์","บ้านท่าเรือ","บ้านท่าเรือ (ประสาทอนุสรณ์)","บ้านท่าเรือจ้าง (ประชาชนูปถัมภ์)","บ้านท่าเรือมิตรภาพ 30","บ้านท่าแร่","บ้านท่าแร้ง","บ้านท่าโรง","บ้านท่าไร่ไทยเจริญ","บ้านท่าฤทธิ์","เพียงหลวง 12 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านท่าล้อ (ราษฎร์ประดิษฐ์)","บ้านท่าล้อ","บ้านท่าลาด","บ้านท่าลาดเหล่าอาภรณ์","บ้านท่าลาด สาขาแหลมทอง","บ้านท่าลาดขาว","บ้านท่าลาดคำตานา","บ้านท่าลาดโนนตูม","บ้านท่าลาดราษฎร์สามัคคี","บ้านท่าลาดวารีวิทยา","บ้านท่าลาดหนองผักตบ","บ้านท่าลาว (พัชรศาสน์ราษฎร์นุเคราะห์)","บ้านท่าลำบิด","บ้านท่าลี่","บ้านท่าลี่ศรีสุขวิทยา","บ้านท่าเล่","บ้านท่าเลอ","บ้านท่าเลียบ","บ้านท่าเลื่อนสามัคคี (คส.5 อุปถัมภ์)","บ้านท่าแลหลา","บ้านท่าโล้","บ้านท้าวบุญเรือง","บ้านท่าวะ (ราษฎร์บำรุง)","บ้านท่าวังไทรสามัคคี","บ้านท่าวังผาประชารัฐวิทยาคาร","บ้านท่าวังย่างควาย","บ้านท่าวัด ","บ้านท่าวา","บ้านท่าว้า","บ้านท่าวารี","บ้านท่าวิเศษ","บ้านท่าเวียง","บ้านท่าศรีไคล","บ้านท่าศรีชมชื่น","บ้านท่าศาลา","ท่าศาลาวิทยา","บ้านท่าศาลาประชารังสรรค์","บ้านท่าศิลา","บ้านท่าสนามชัย","บ้านท่าสนุก","บ้านท่าสนุ่น","บ้านท่าส้ม","บ้านท่าสมอโคกสมบูรณ์","บ้านท่าส้มโฮง","บ้านท่าสวรรค์","บ้านท่าสว่าง","บ้านท่าสวาทท่าลี่","บ้านท่าสวาย","บ้านท่าสองคอน","บ้านท่าสองแคว","บ้านทาสองท่า","บ้านท่าสะแก","บ้านท่าสะตือ","บ้านท่าสะอาด","บ้านท่าสะอาด (สวรรค์คงคา)","บ้านท่าสัก","บ้านท่าสัง","บ้านท่าสาป","บ้านท่าสาย","บ้านท่าสำราญ","บ้านท่าสี","บ้านท่าสีไค","บ้านท่าสู","บ้านท่าสูง","บ้านท่าเสด็จ","บ้านท่าเสลา","บ้านท่าเสลี่ยง","บ้านท่าเสา","บ้านท่าเสากระโดง","บ้านท่าเสาเภา","บ้านท่าเสียว","บ้านท่าเสียว (กาญจนาอุปถัมภ์)","บ้านท่าเสียวคันลึม","บ้านท่าโสม","บ้านท่าหนองเทา","บ้านท่าหนองปากพาน","บ้านท่าหนองพันทา","บ้านท่าหนองหว้า","บ้านท่าหนาด","บ้านท่าหนามแก้วสวนกล้วย","บ้านท่าหมอไชย","บ้านท่าหมาก","บ้านท่าหลวง","บ้านท่าหลวงนาคำ","บ้านท่าหลุก","บ้านท่าหลุกสันทราย","บ้านท่าห้วยคำ","บ้านท่าหวี","บ้านท่าหัน","บ้านท่าหัวลบ","บ้านท่าหิน","บ้านท่าหินโงม","บ้านท่าหินลาด","บ้านท่าหินส้ม","ชุมชนบ้านกำแพงดิน สาขาบ้านท่าแห","บ้านท่าไห (ไหทอง)","บ้านท่าฬ่อ (ครุฑวิทยากรณ์)","บ้านท่าอวน","บ้านท่าอ่าง","บ้านท่าอาจ","บ้านท่าอินทร์แปลง","บ้านท่าอิบุญ","บ้านท่าอุดม","บ้านท่าอุทัย","บ้านท่าอุเทน","บ้านท่าฮ่อ","บ้านทำนบ","บ้านแหลมดิน","บ้านทำนบ (เลิศสินอนุสรณ์)","บ้านทำนบเทวดา","บ้านทำนบพัฒนา","บ้านทิกแล้ง และสาขาห้วยหินลับ","บ้านทิดไทย","บ้านทิพย์นวด","บ้านทิพย์เนตร","บ้านทิพโสต","บ้านทิยาเพอ","บ้านทีกะเป่อ","บ้านทีฮือลือ","บ้านทือ","บ้านทุ่ง","บ้านทุ่งวิทยพัฒน์","บ้านทุ่งสภากาชาดอุปถัมภ์ 2550","บ้านทุ่งกง","บ้านทุ่งกรวด","บ้านทุ่งกระเชาะ","บ้านทุ่งกระโดน","บ้านทุ่งกะโตน","บ้านทุ่งกระถิน","บ้านทุ่งกระบ่ำ","บ้านทุ่งกร่าง","บ้านทุ่งกราด","บ้านทุ่งกลม","บ้านทุ่งกล้วย","บ้านทุ่งกลับ","บ้านทุ่งกวาง","บ้านทุ่งกว้าง","บ้านทุ่งกอ","บ้านทุ่งก่อ (ใจประชานุเคราะห์)","บ้านทุ่งกอกหนองเกาะ","บ้านทุ่งกองมู","บ้านทุ่งก้างย่าง","บ้านทุ่งกินนร","บ้านทุ่งกู่ด้าย","บ้านทุ่งเกราะ","บ้านทุ่งเกลี้ยง","บ้านทุ่งเกวียน","บ้านทุ่งเกาะญวน","บ้านทุ่งแก","บ้านทุ่งโก","บ้านทุ่งขนวน","บ้านทุ่งข่วง","บ้านทุ่งขวัญแก้ว","บ้านทุ่งขันหมาก","บ้านทุ่งขาม","บ้านทุ่งข้าวพวง","บ้านทุ่งข้าวหาง","บ้านทุ่งขี้เหล็ก","บ้านทุ่งขี้อ้าย","บ้านทุ่งขุนน้อยหนองจานวิทยา","บ้านทุ่งขุนใหญ่","บ้านทุ่งเขาสะบ้า","บ้านทุ่งแขวน","บ้านทุ่งคมบาง","บ้านทุ่งครก","บ้านทุ่งครั้ง","บ้านทุ่งคลองควาย","บ้านทุ่งคัวะ","บ้านทุ่งคา","บ้านทุ่งคา ","บ้านทุ่งคาโตนด","บ้านทุ่งค่าย","บ้านทุ่งคำ","บ้านทุ่งคำหลวง","บ้านทุ่งเค็จ","บ้านทุ่งเค็ด","บ้านทุ่งเคล็ด","บ้านทุ่งแค","บ้านทุ่งแค้ว (คันธวงศ์วิทยาคาร)","บ้านทุ่งใคร","บ้านทุ่งงาย","บ้านทุ่งงิ้ว (ประชาสงเคราะห์2)","บ้านทุ่งเงินโนนเจริญ","บ้านทุ่งจัง","บ้านทุ่งจังหัน","บ้านทุ่งจำเริง","บ้านทุ่งจี้","บ้านทุ่งจูด","บ้านทุ่งเจดีย์","บ้านทุ่งเจริญ (เครือราษฎร์สงเคราะห์)","บ้านทุ่งแจง","บ้านทุ่งชน","บ้านทุ่งชมพู และบ้านพระบาทโนนคูณ","บ้านทุ่งช้าง","บ้านทุ่งชุมพล","บ้านทุ่งเชือก","บ้านทุ่งโชน","บ้านทุ่งไชย (พัฒนานุสรณ์)","บ้านทุ่งซางดงหลวง","บ้านทุ่งซ่าน","บ้านทุ่งดอน","บ้านทุ่งดินดำ","บ้านทุ่งดินแดง","บ้านทุ่งดินลุ่ม","บ้านทุ่งต้นศรี","บ้านทุ่งต่อ","บ้านทุ่งตอน","บ้านทุ่งต่อเรือ","บ้านทุ่งตัน","บ้านทุ่งตากล้า (คุรุราษฎร์บำรุงวิทย์)","บ้านทุ่งตาแก้ว","บ้านทุ่งตาทั่ง (ศิริราษฎร์บำรุง)","บ้านทุ่งตาพุก","บ้านทุ่งต๋ำ","บ้านทุ่งตำเสา","บ้านทุ่งตำเสา ","บ้านทุ่งติ้ว","บ้านทุ่งแต","บ้านทุ่งแต้","บ้านทุ่งโต๊ะดัง","บ้านทุ่งใต้","บ้านทุ่งถ้ำ","บ้านทุ่งทรายจก","บ้านทุ่งทอง","บ้านทุ่งท่าช้าง","บ้านทุ่งท่าเสา","บ้านทุ่งเทิง","บ้านทุ่งไทร","บ้านทุ่งไทรงาม","บ้านทุ่งธาตุท่าลี่ดอนกลางสามัคคี","บ้านทุ่งน้อย","บ้านทุ่งน้อย (นิวนามทองอุปถัมภ์ 1)","บ้านทุ่งน้อย (มิตรภาพที่ 12)","บ้านทุ่งน้อยหนองโจดหนองหอย","บ้านทุ่งนา","บ้านทุ่งนํ้า","บ้านทุ่งนาค","บ้านทุ่งนาคราช","บ้านทุ่งนาเคียน","บ้านทุ่งนางเภา","บ้านทุ่งนางโอก (อ่อนอำนวยศิลป์)","บ้านทุ่งนาตาปิ่น","บ้านทุ่งนาน้อย","บ้านทุ่งนานางหรอก ","บ้านทุ่งนาเมือง","บ้านทุ่งนารี","บ้านทุ่งนาวิทยา","บ้านทุ่งนาสวน","บ้านทุ่งน้ำตก","บ้านทุ่งน้ำแพร่ป่าบง","บ้านทุ่งน้ำใส","บ้านทุ่งนุ้ย","บ้านทุ่งนุ้ย ","บ้านทุ่งในไร่","บ้านทุ่งบก","บ้านทุ่งบอน","บ้านทุ่งบิ่น","บ้านทุ่งบุหลัง","บ้านทุ่งปง","บ้านทุ่งประทุน","บ้านทุ่งประพาส","บ้านทุ่งประสาน","บ้านทุ่งปรือ","ทุ่งปรือพิทยาคม (รัตนปัญโญ)","บ้านทุ่งปลากัด","บ้านทุ่งป่ากระถิน","บ้านทุ่งป่าข่า","บ้านทุ่งปาหนัน","บ้านทุ่งปี้","บ้านทุ่งเป็ด","บ้านทุ่งโป่ง","บ้านทุ่งโป่งมิตรภาพที่ 78","บ้านทุ่งโป๊ะ","บ้านทุ่งผา","บ้านทุ่งผึ้ง","บ้านทุ่งไผ่","บ้านทุ่งฝาย","บ้านทุ่งฝูง","บ้านทุ่งแฝก","บ้านทุ่งพรหมทอง ","บ้านทุ่งพระ","บ้านทุ่งพร้าว (เพ็กกี้ฮิทค็อค)","บ้านทุ่งพลวง","บ้านทุ่งพล้อ","บ้านทุ่งพลับ","บ้านทุ่งพะยอม","บ้านทุ่งพัฒนา","บ้านทุ่งพาย","บ้านทุ่งเพียง","บ้านทุ่งแพม","บ้านทุ่งโพธิ์","บ้านทุ่งโพธิ์ชัย","บ้านทุ่งโพธิ์นาอุดม","บ้านทุ่งไพล","บ้านทุ่งฟ้าผ่า","บ้านทุ่งฟ้าฮ่าม","บ้านทุ่งเฟื้อ (เอมสะอาดอำนวย)","บ้านทุ่งมณี (คุรุราษฎร์นุกูล)","บ้านทุ่งมน","บ้านทุ่งมน (ริมราษฎร์นุสรณ์)","บ้านทุ่งมนธาตุวิทยา","บ้านทุ่งมนวิทยาคาร","บ้านทุ่งม่วง","บ้านทุ่งมหาชัย","บ้านทุ่งมหาศาล","บ้านทุ่งมอก","บ้านทุ่งมะกอก","บ้านทุ่งมะขาม","บ้านทุ่งมะขามเฒ่า","บ้านทุ่งมะขามป้อม","บ้านทุ่งมะปรัง","บ้านทุ่งมะพร้าว","บ้านทุ่งมั่ง","บ้านทุ่งมังกะหร่า","บ้านทุ่งม่าน","บ้านทุ่งแม่น้ำน้อย","บ้านทุ่งโม่ง","บ้านทุ่งไม้ไผ่","บ้านทุ่งยาง","บ้านทุ่งยางงาม","บ้านทุ่งยาว","บ้านทุ่งยาวคำโปรย","บ้านทุ่งเย็น","บ้านทุ่งรวงทอง","บ้านทุ่งรักชัยพัฒน์","บ้านทุ่งราม (รามรุ่งอรชัย)","บ้านทุ่งริ้น","บ้านทุ่งรูง","บ้านทุ่งเรี้ย","บ้านทุ่งเรือโกลน","บ้านทุ่งละคร","บ้านทุ่งละหาน","บ้านทุ่งละออง","บ้านทุ่งลาน","บ้านทุ่งลุยลาย (กฟผ.อุปถัมภ์)","บ้านทุ่งเลน","บ้านทุ่งเลียบ","บ้านทุ่งวัง","บ้านทุ่งวัวแล่น","บ้านทุ่งว้า","บ้านทุ่งวิมาน","บ้านทุ่งศักดิ์","บ้านทุ่งศาลา","บ้านทุ่งเศรษฐี","บ้านทุ่งส้มป่อย","บ้านทุ่งสมอ","บ้านทุ่งสร้าน","บ้านทุ่งสวน","บ้านทุ่งสว่าง","บ้านทุ่งสว่าง (ราษฎร์พัฒนา)","บ้านทุ่งสว่างวัฒนา","บ้านทุ่งส่อหงษา","บ้านทุ่งสะแกง","บ้านทุ่งสะแบง","บ้านทุ่งสะโบ๊ะ","บ้านทุ่งสาคร","บ้านทุ่งส้าน","บ้านทุ่งสามแท่ง","บ้านทุ่งส่าย","บ้านทุ่งสำราญ","บ้านทุ่งสีเสียด","บ้านทุ่งสูง","บ้านทุ่งเสม็ด","บ้านทุ่งเสม็ด ","บ้านทุ่งเสียน","บ้านทุ่งเสี้ยว (นวรัฐ)","บ้านทุ่งเสือโทน","บ้านทุ่งหก","บ้านทุ่งหงษ์","บ้านทุ่งหงาว","บ้านทุ่งหญ้าแดง","บ้านทุ่งหนอง","บ้านทุ่งหนองแก้ว","บ้านทุ่งหนองบัว","บ้านทุ่งหนองสิบบาท","บ้านทุ่งหนองแห้ง","บ้านทุ่งหมัน","บ้านทุ่งหมากหนุ่ม","บ้านทุ่งหยีเพ็ง","บ้านทุ่งหล่ม","บ้านทุ่งหลวง","บ้านทุ่งหลวงวัฒนาคาร","บ้านทุ่งหลุก","บ้านปางแดง","บ้านทุ่งหันตรา","บ้านทุ่งหัวขวาน","บ้านทุ่งหัวช้าง","บ้านทุ่งหัวนา","บ้านทุ่งหัวพรหม","ทุ่งห้าราษฎร์สามัคคีวิทยา","บ้านทุ่งหินโคน","บ้านทุ่งหินปูน","บ้านทุ่งเหนือ (ราษฎร์สามัคคี)","บ้านทุ่งเหรียง","บ้านทุ่งโห้ง","บ้านทุ่งใหญ่","บ้านทุ่งใหญ่ม่วง (คุรุราษฎร์บำรุง)","บ้านทุ่งใหญ่โพธิ์ชัย","บ้านทุ่งไหม้","บ้านทุ่งอ่าง","บ้านทุ่งอิฐ","บ้านทุ่งเอี้ยงสามัคคี","บ้านทุ่งฮ้าง","บ้านทุ่งฮี","บ้านทุ่งเฮ้า","บ้านทุ่งโฮ้ง (อภิวังวิทยาลัย)","บ้านทุ่ม","บ้านทุ่มฝาง","บ้านทุ่ม (ทุ่มประชานุเคราะห์)","บ้านทุ่ม (อสพป.3)","บ้านทุ่มห้วย","บ้านทู้ (สามัคคีวิทยา)","บ้านเทนมีย์","อนุบาลเทพสุนทรินทร์","บ้านเทพนคร","บ้านเทพนิมิต","เพียงหลวง 10","บ้านเทพประทับ","บ้านเทพประทาน","บ้านเทพพนม","บ้านเทพพนาธรรมนิติอุปถัมภ์","บ้านเทพพยัคฆ์","บ้านเทพพัฒนา","บ้านเทพมงคลทอง","บ้านเทพราช","บ้านเทพสถาพร","บ้านเทพา","บ้านเทวฤทธิ์พันลึก","บ้านเทวัญ (คุรุราษฎร์นุกูล)","บ้านเทวีดอนขม","บ้านเทศมงคล","บ้านเทอดไทย","บ้านเท่อเล่อ","บ้านเทา-นาบอน","บ้านเทิน","บ้านเทียมเจริญ","บ้านเทื่อม","บ้านแทงวิทยา","บ้านแท่น","บ้านแท่นแก้ว","บ้านแท่นทัพไทย","บ้านแท่นโนนหนองคู","บ้านแท่นบัลลังก์","บ้านแท่นพระ","บ้านแทรง","บ้านโทกค่า (สหราษฎร์บำรุง)","บ้านโทกน้ำกัด","บ้านโทกหัวช้าง","บ้านโท้งวิทยา","บ้านโทน (ราษฎร์อุทิศ)","บ้านโทะ","บ้านไทย","บ้านไทยเจริญ","บ้านไทยชนะศึก","บ้านไทยเดิม","เพียงหลวง 14 (ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี)","บ้านไทยทวี","บ้านไทยนิยมพัฒนา","บ้านไทยบวกแต้บวกเตย","บ้านไทยพัฒนา","บ้านไทยโพนทราย","บ้านไทยสมบูรณ์","บ้านไทยสมบูรณ์ (กรป.กลางอุทิศ)","บ้านไทยสมพร","บ้านไทยสันติสุข","บ้านไทยสามัคคี","บ้านไทยสามารถ","บ้านไทร","บ้านไทรงาม","บ้านไทรงามโนนภูดิน","บ้านไทรดงยั้ง","บ้านไทรทอง","บ้านไทรทองสามัคคี","บ้านไทรบ่วง","บ้านไทรย้อย","บ้านไทรโยง","บ้านไทรล่า","บ้านไทรห้อง","บ้านไทรออ","บ้านธงชัย","บ้านธงชัยสามัคคี","บ้านธงน้อย","บ้านธงหลวง","บ้านธรรมเจริญ","บ้านธรรมชาติล่าง","บ้านธรรมเถียร (สุขประชารัฐ)","บ้านธรรมรัตน์ใน","บ้านธรรมละ","บ้านธรรมษา","บ้านธวัชบุรี","บ้านธาตุ","บ้านธาตุ ","บ้านธาตุประชานุกูล","บ้านธาตุ (สหพัฒนานุสรณ์)","บ้านธาตุกุดพร้าว","บ้านธาตุขิงแกง","บ้านธาตุจอมศรี","บ้านธาตุตาลเดี่ยว","บ้านธาตุน้อย(สิงห์ประชาวิทยาคาร)","บ้านธาตุประทับ","บ้านธาตุพนม (พิทักษ์วิทยา)","บ้านธาตุพิทยาคม","บ้านธาตุวิทยา","บ้านธาตุสามัคคี","บ้านธารชะอม","บ้านธารทองแดง","บ้านธารทิพย์","บ้านธารนพเก้า","บ้านธารน้ำทิพย์","บ้านธารน้ำผึ้ง","บ้านธารน้ำใส","บ้านธารปราสาท","บ้านธารมะลิ","บ้านธารหวาย","บ้านธารอารี","บ้านธำมรงค์ (รองประชาสงค์เคราะห์)","บ้านนกขะบา","บ้านนกเขาทอง","บ้านนกเขาเปล้า","บ้านนกคลาน","บ้านนกงาง","บ้านนกเต็น","บ้านนกยูง (อสพป.30)","บ้านนกเหาะ","บ้านนครเดิด","บ้านนนท์","บ้านนบ","บ้านนราภิรมย์","บ้านนเรศ","บ้านนวราษฎร์","บ้านนอก","บ้านนอกนา","บ้านป่าแดงบุญนาค และบ้านเจดีย์งาม","บ้านน้อมเกล้า","บ้านน้อย","บ้านน้อย ","บ้านน้อยกลางคำแคนเหนือ","บ้านน้อยกุดคล้า","บ้านน้อยจอมศรี","บ้านน้อยซุ้มขี้เหล็ก","น้อยดอนข่าประชาสามัคคี","บ้านน้อยใต้","บ้านน้อยทวย","บ้านน้อยพัฒนา","บ้านน้อยสะแกกวน","บ้านน้อยหนองหนาด","บ้านน้อยหนองหว้า","บ้านน้อยนาเหนือ","บ้านนันทาราม (นันทราษฎร์วิทยา)","บ้านนา","องค์การบริหารส่วนจังหวัดสุราษฎร์ธานี 3 (บ้านนา)","บ้านนา (ประสิทธิ์วิทยาคาร)","บ้านนา (สามัคคีวิทยา)","บ้านนากบ","บ้านนากระเซ็ง","บ้านนากระแซง","บ้านนากระเดา","บ้านนากระตึบ","บ้านนากระแต้","บ้านนากลาง","บ้านนากลาง สาขาบ้านห้วยผักกูด","บ้านนากวาง","บ้านชุมชนนากว้างพัฒนศึกษา","บ้านนากว้าว (กิ่ว)","บ้านนากอ","บ้านนาก้อ","บ้านนากอ (มะดากะอุทิศ)","บ้านนากอก","บ้านนาก๊อก","บ้านนากะทาด","บ้านนากะทืมโนนสะอาด","บ้านนากั้ง","บ้านนากับแก้","บ้านนาก้า","บ้านนากาญจน์","บ้านนาก้านเหลือง","บ้านนากาหลง","บ้านนากุงยางคำ","บ้านนากุดสิม","บ้านนากู่","บ้านนาเกตุ","บ้านนาเก็น","บ้านนาเกลือ","นาเกษมเจริญวิทยา","บ้านนาเกา","บ้านนาเกาะ","บ้านนาเกิดผล","บ้านนาเกียน","บ้านนาแก","บ้านนาแกม่วงหนองตุกหลุก","บ้านนาแกน้อย (นทพ.อุปถัมภ์)","บ้านนาแกบึงเหล็ก","บ้านนาแก้ว","บ้านนาแก้วประชารัฐ","บ้านนาแก้วประชาสรรค์","บ้านนาโก","บ้านนาไก่นาคำน้อยวิทยา","บ้านนาไก่เขี่ย","บ้านนาขนวน","บ้านนาขนัน","บ้านนาขมิ้น","บ้านนาขวาง","บ้านนาขอม","บ้านนาข่อย","บ้านนาข่า","บ้านนาข่าคำพอก","บ้านนาข่าท่า","บ้านนาขาม","บ้านนาขามดอนติ้ว","บ้านนาขามป้อม","บ้านนาขามป้อมวิทยาคม","บ้านนาขามผดุงวิทยา","บ้านนาขามส้มป่อย","บ้านนาขุนไกร","บ้านนาขุมคัน","บ้านนาเข","บ้านนาแขม","บ้านนาคต","บ้านนาครอง","บ้านนาคลอง","บ้านนาคลองกลาง","บ้านนาคล้าย","บ้านนาควน","บ้านนาคอ","บ้านนาค้อ","บ้านนาคอก","บ้านนาคอกมิตรภาพที่ 104","นาคอกควาย","บ้านนาคอกควาย","บ้านนาค้อกลาง","บ้านนาค้อใต้","บ้านนาคอมนาดอกไม้","บ้านนาคอย","บ้านนาคอเรือ","บ้านนาค้อเหนือ","บ้านนาคะนึง","บ้านนาคา","บ้านนาคำ","บ้านนาคานหักประชานุสรณ์","บ้านนาคาย","บ้านนาค่าย","บ้านนาคำปักแฮด","บ้านนาคำพรสันติ","บ้านนาคำ (ถิรธัมโมอุปถัมภ์)","บ้านนาคำแคน","บ้านนาคำน้อย","บ้านนาคำน้อย1","บ้านนาคำน้อย 2","นาคำน้อยวิทยา","บ้านนาคำนาใน","บ้านนาคำโนนขาม","บ้านนาคำมูลชมภูพร","บ้านนาคำวัง","บ้านนาคำวิทยา","บ้านนาคำวิทยาคาร","บ้านนาคำสามัคคี","บ้านนาคำหลวง","บ้านนาคำใหญ่ (ราษฎร์บริบาล)","บ้านนาคิแลน","บ้านนาคุรุราษฎร์วัฒนา","บ้านนาคู","บ้านนาคู่","บ้านนาคู (คุรุราษฎร์อุปถัมภ์)","บ้านนาคูณ","บ้านนาคูหา","บ้านน้ำเค็ม","บ้านนาเคียน","บ้านนาแค","บ้านนาแคทุ่งขวาง","บ้านนาแคน","บ้านนาโคก","บ้านนาโคก (นาเกลือสัมพันธ์)","บ้านนาไค้","บ้านนาไคร้","บ้านนางแก้ว","บ้านนางเข็ม","บ้านนางแดด","บ้านนางแดดเหนือ","บ้านนางเตี้ยไศลทอง","บ้านนางแตน","บ้านนางโทพัฒนา","บ้านนางเม้ง","บ้านนางรอง","บ้านนางรอง (ยุทธกาจราษฎร์วิทยาคาร)","ปราสาทหินนางรำ","บ้านนางเลง","บ้านนางเลิ้งโคกล่าม","บ้านนางเลิศ","บ้านนางแล","บ้านนางแลใน","บ้านนางวงสุ่มห้วยเนียม","บ้านนางหลง","บ้านนางเหริญ","บ้านนาง้อง","บ้านนางัว","บ้านนางั่ว (เจริญวิทยาคาร)","บ้านนางัวสายปัญญา","บ้านนางั่วเหนือ","บ้านนางาม","แก่นเท่าโสกน้ำขุ่น","นางาม (ผลแก้วอุปถัมภ์)","บ้านนางามมิตรภาพที่131","บ้านนาง่ามเล้า","บ้านนางิ้ว","บ้านนางิ้ว (ประชาสามัคคี)","บ้านนางิ้วนาโพธิ์","บ้านนาจลอง","บ้านนาจวก","บ้านนาจะลา","บ้านนาจะแหน","บ้านนาจักร (จักรราษฎร์บำรุง)","นาจานซับสมบูรณ์","บ้านนาจาน","เพียงหลวง 18 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านนาจานกล้วยน้อย","บ้านนาจานโนนนาโพธิ์","นาจานนาเจริญโนนทัน","บ้านนาจานบ่อแก้ววิทยาคาร","บ้านนาจ่าย","บ้านนาจาร","นาจิกหนองทุ่งมนต์หนองชาด","บ้านนาเจริญ","บ้านนาเจริญวิทยา","บ้านนาเจียง","บ้านนาโจด","บ้านนาเฉลียง","บ้านนาเฉลียงใต้","บ้านนาชมดอนกลางวิทยา","ชุมชนบ้านนาชะอัง","บ้านนาชักหวาย","บ้านนาช้างน้ำ","บ้านนาชุมใหม่นิรมิต","บ้านนาชุม","บ้านนาชุมช้าง","บ้านนาชุมใต้","บ้านนาชุมแสง","บ้านนาชุมเห็ด","บ้านนาเชิงคีรี","บ้านนาเชือก","บ้านนาแช่","บ้านนาซอ","บ้านนาซาว","บ้านนาซ่าว","บ้านนาซำ","บ้านนาซำจวงดอนมะค่าวิทย์","บ้านนาซำแซง","บ้านนาซึม","บ้านนาเซแสงวิไล","บ้านนาแซง","บ้านนาแซะ","บ้านนาดง","บ้านนาดอกคำ","บ้านนาดอกไม้","ประชานาดอกไม้","บ้านนาดอกไม้ มิตรภาพที่ 120ฯ","บ้านนาดอกไม้ขามเบี้ยดอนข่า","บ้านนาดอกไม้ผดุงวิทยา","บ้านนาดอนบก","บ้านนาดอย","บ้านนาดา","บ้านนาด่าน","บ้านนาดินจี่แสงตะวัน (รวมธรรมราษฎร์บำรุง)","บ้านนาดินดำ","บ้านนาดี","บ้านนาดีนาอุดม","บ้านนาดี ","บ้านนาดี (คุรุประชารัฐ)","บ้านนาดี 2","บ้านนาดีค่ายสว่างวิทยา","บ้านนาดีโคกกลาง","บ้านนาดีดอนจาน","บ้านนาดีทุ่งเจริญ","บ้านนาดีวิทยา","บ้านนาดีศรีสะอาด","บ้านนาดีศรีสุข","บ้านนาดีสร้างบง","บ้านนาดีหัวภู","บ้านนาดู่","บ้านนาดูน","บ้านนาดูนนาดี","บ้านนาเดื่อ","บ้านนาโด่","บ้านนาโดนเก่า","บ้านนาโดนใหม่","บ้านนาโดโพธิ์ศรี","บ้านนาโดม","บ้านนาตงสหราษฎร์อุทิศ","บ้านนาต้นจั่น","บ้านนาต้นโพธิ์","บ้านนาต๋ม","บ้านนาตราว","บ้านนาต้อง","บ้านนาตอง (นาตองสามัคคี)","บ้านนาต้องนาสมนึก","บ้านนาตอน","บ้านนาตะกุด","บ้านนาตะคุ","บ้านนาตะโครก","บ้านนาตะแบง 2","บ้านนาตะแบง1","บ้านนาตังกระแบก (กาญจนูปถัมภ์)","บ้านนาตังตระแบก (กาญจนูปถัมภ์)","บ้านนาตับเต่า","บ้านนาตากาง","บ้านนาตาดนาโปร่ง","บ้านนาตาดสมสะอาด","บ้านนาตาโพ","บ้านนาตาแย้ม","บ้านนาตาล","บ้านนาตาลคำข่า","บ้านนาตาลใต้","บ้านนาตาลเหนือโนนสวาท","บ้านนาตาลเหนือ","บ้านนาตาวงษ์","บ้านนาตาหมุด","บ้านนาตาแหลวดงยางวิทยา","บ้านนาตำเสา","บ้านนาตุ่น (สหราษฎร์วิทยา)","บ้านนาตุ้ม (คุรุราษฎร์วิทยานุสรณ์)","บ้านนาตูม","บ้านนาเตย","บ้านนาเต่า","บ้านนาเตียง","บ้านนาแต้","นาแต้โคกสำราญ","บ้านนาโตง","บ้านนาใต้","บ้านนาถ่ม","บ้านนาถ่อน","บ้านนาทม","บ้านนาท่มหนองผักบุ้ง","บ้านนาทราย","บ้านนาทรายน้ำรอด","บ้านนาทวี","บ้านนาทอง","บ้านนาทองสุก","บ้านนาทอน","บ้านนาท่อม","บ้านนาทอย","บ้านนาทะเล","บ้านนาทัน","บ้านนาทับควาย","บ้านนาทับไฮ","บ้านนาทาม","บ้านนาทุ่ง","บ้านนาทุ่งกลาง","บ้านนาทุ่งเชือก","บ้านนาทุ่งโพธิ์","บ้านนาทุ่งมั่ง","บ้านนาทุ่งใหญ่","บ้านนาทุ่ม","บ้านนาเทา","บ้านนานกเขียน","บ้านนานกชุมนาชุมพร","บ้านนานกหงส์เสรี","บ้านนานวน","บ้านนานวนหนองแคน","บ้านนานวล","นานวลราษฎร์นิยม","บ้านนานอ","บ้านนานอก","บ้านนาน้อย","บ้านนาน้อยแสนสุข","บ้านนานางวาน","บ้านนาน้ำโครม","บ้านนาน้ำชุ่ม","บ้านนาน้ำซำ","บ้านนาน้ำพาย","บ้านนาน้ำมัน","บ้านนานิน","บ้านนาโนน","บ้านนาใน","บ้านนาบง","บ้านนาบ่อ","บ้านนาบ่อคำ","บ้านนาบอน","บ้านนาบัว","บ้านนาบัวไผ่วิทยา","บ้านนาบั่ว","บ้านนาบุญโหล่งขอด","บ้านนาเบน","บ้านนาเบี้ย","บ้านนาแบก","บ้านนาโบสถ์ (น้อมมิตรอนุกูล)","บ้านนาปง","บ้านนาป่ง","บ้านนาป่งคอง","บ้านนาประชาสัมพันธ์","บ้านนาประชาสัมพันธ์ สาขาโคกอนุ","บ้านนาประชุม","บ้านนาประดู่","บ้านนาปรัง","บ้านนาปราน","บ้านนาปลากั้ง","บ้านนาปลาจาด","บ้านนาป้อ","บ้านนาป่า","บ้านนาป่าคาย","นาป่ามโนรถ","บ้านนาป่าแดง","บ้านนาป่าน","บ้านนาป่าแปก","บ้านนาป่าหนาด","บ้านนาปุ่ง","บ้านนาปู-นากลาง","บ้านนาปู่ป้อม และสาขาทุ่งสาแล","บ้านนาเปอะ","บ้านนาเปือย","บ้านนาแปน","บ้านนาโป่ง","บ้านนาโป่งโพน","บ้านนาโปน้อย","ชุมชนนาโปใหญ่-โคกสุวรรณ","บ้านนาผักก้าม","บ้านนาผักปอด","บ้านนาผักหมนาหมากแงว","บ้านนาผักฮาด","บ้านนาผา","บ้านนาผาง (วิบูลย์ราษฎร์สามัคคี)","บ้านนาผาย","บ้านนาไผ่","บ้านนาไผ่ล้อม","บ้านนาฝ่า","บ้านนาฝาง","บ้านนาฝาย","บ้านนาฝาย (ประชาสงเคราะห์)","บ้านนาฝายนาโพธิ์","บ้านนาฝายเหนือ","บ้านนาฝายเหล่าหุ่ง","บ้านนาแฝก","บ้านนาพง","บ้านนาพญา","บ้านนาพระโนนห้วยแคน","ชุมชนนาพระชัย","บ้านนาพราน","บ้านนาพรุ","บ้านนาพะเนียงออ","บ้านนาพัง","บ้านนาพา","บ้านนาพิน","บ้านนาพู่","บ้านนาพูน","บ้านนาพูนทรัพย์","บ้านนาเพ็ญ","บ้านนาเพียง","บ้านนาเพียงเก่าสนธิราษฎร์สามัคคี","บ้านนาเพียงน้อยนาสมบูรณ์","บ้านนาเพียงใหญ่","บ้านนาแพง","บ้านนาแพงโคกน้ำสร้าง","บ้านนาแพงคุรุรัฐสามัคคี","บ้านนาแพงสงแดง","บ้านนาโพธิ์","บ้านนาโพธิ์ (ครุราษฎร์สามัคคี)","บ้านนาโพธิ์ (สหพันธ์พิทยาภรณ์)","บ้านนาโพธิ์กลาง","บ้านนาโพธิ์คุรุราษฎร์พัฒนา","บ้านนาโพธิ์ใต้","บ้านนาโพธิ์นาจาน","บ้านนาโพธิ์อ่างสร้างหิน","บ้านนาไพร","บ้านนาไพรงาม","บ้านนาฟองแดง","บ้านนาฟ่อน","บ้านนาภู","บ้านนามกุย","บ้านนามน","บ้านนามนดงติ้ววิทยา","บ้านนามน (สามัคคีวิทยาคาร)","บ้านนามนประชาสามัคคี","บ้านนาม่วง","บ้านนาม่องดงนิมิตวิทยา","บ้านนาม่องนาเมือง","บ้านนามะเขือ","บ้านนามะเฟือง","บ้านนามั่ง","บ้านนามาลา","บ้านนามึน","บ้านนามูล","บ้านนามูลตุ่น","บ้านนามูลฮิ้น","บ้านนาเมย","บ้านนาเมือง","บ้านนาเมืองไทย","บ้านนาเมืองเพชร","บ้านนาแมด","บ้านนาโม้","บ้านนาโมง","บ้านนายม","บ้านนายม ","บ้านนายอ","นายอวัฒนา","บ้านนายอน้อย","บ้านนายาง","นายางวิทยา","บ้านนายาง (วิเทศปริยัติราษฎร์รังสรรค์)","บ้านนายายหม่อม","บ้านนายาว","บ้านนายาวสามัคคี","บ้านนายูง","บ้านนาเยีย","บ้านนาแยง","บ้านนาระยะพัฒนา","บ้านนารังกา","บ้านนารา ","บ้านนาราชควาย","บ้านนาราชควายน้อย","บ้านนาราบ (จุลเกษตรศึกษาคาร)","บ้านนารายณ์","บ้านนาราใหญ่","บ้านนารี","บ้านนารุ่ง","บ้านนาเรียง","บ้านนาเรียงทุ่งเจริญ","บ้านนาเรือง","บ้านนาไร่","บ้านนาไร่เดียว","บ้านนาไร่เดียว (ประชาบำรุง)","บ้านนาไร่ใหญ่","บ้านนาล้อม","บ้านนาล้อมกุดตะกล้า","บ้านนาล้อมโคกสว่าง","บ้านนาลับแลง","บ้านนาลาน","บ้านนาลานข้าว","บ้านนาลาว","บ้านนาลึก","บ้านนาลึ่ง","บ้านนาเลา","บ้านนาเลา และสาขาบ้านอวยศรี","บ้านนาเลาะ","บ้านนาเลิง","บ้านนาเลิน","บ้านนาเลียง","บ้านนาเลี่ยง","บ้านนาไลย","บ้านนาวง","บ้านนาวงเดือน","บ้านนาวงศ์","บ้านนาวอง","บ้านนาวัง","บ้านนาวังเวิน","บ้านนาวังแหน","บ้านนาวัลเปรียง","บ้านนาวัว","บ้านนาวา","บ้านนาวิทยาคม","บ้านนาวี","บ้านนาเวียงคำศิริ","บ้านนาเวียง","บ้านนาเวียง (วรพจนานุสรณ์)","บ้านนาแวง","บ้านนาศรีดงเค็ง","บ้านนาศรีนวล","บ้านนาศรีสุข ","บ้านนาสนาดก์","บ้านนาสนามนาหว้าเกษม","บ้านนาสนุ่น","บ้านนาสม (วิไลราษฎร์ศึกษา)","บ้านนาสมใจ","บ้านนาสมนึก","บ้านนาสมบูรณ์","บ้านนาส้มมอ","บ้านนาส้มโฮง","บ้านนาสระลอย","บ้านนาสร้าง (นิวนามทองอุปถัมภ์ 2)","บ้านนาส่วง","บ้านนาสวน","บ้านนาสวรรค์","บ้านนาสองห้อง","บ้านนาสองเหมือง","บ้านนาส่อนโพนทัน","บ้านนาสะเดา","บ้านนาสะโน","บ้านนาสะแบง","นาสะเม็งวิทยา","บ้านนาสะไมย์","บ้านนาสะอาด","บ้านนาสัก","บ้านนาสา","บ้านนาสาม (เกียรติประชา)","บ้านนาสามัคคี","บ้านนาสาวนาน","บ้านนาสำราญรุ่งเรือง","บ้านนาสิงห์","บ้านนาสี","บ้านนาสีดา","บ้านนาสีนวน","บ้านนาสีนวล","บ้านนาสีนวลโนนสะอาด","บ้านนาสีสลากกินแบ่งสงเคราะห์ 59","บ้านนาสีใส","บ้านนาสุรินทร์","บ้านนาเส","บ้านนาเสียวหนองชาติ","บ้านนาเสียวโคกสว่าง","บ้านนาเสือก","บ้านนาเสือหลายหนองยอ","บ้านนาแสง","บ้านนาแส่ง-แม่ไฮ-นากิ๋ม","บ้านนาแสน","บ้านนาโส่","บ้านนาโสก","บ้านนาโสกน้อย","บ้านนาหัวภู","บ้านนาโสม","บ้านนาหนอง","บ้านนาหนองแคน","บ้านนาหนองทุ่ม","บ้านนาหนองบก","บ้านนาหนองหวาย","บ้านนาหนองใหญ่","บ้านนาหนัง","บ้านนาหนาด","บ้านนาหน่ำ","บ้านนาหนุน 1-ปิตุราษฎร์","บ้านนาหมอม้า","บ้านนาหมูม่น","บ้านนาหยา","บ้านนาหยาด","บ้านนาหล่ม","บ้านนาหลวง","บ้านนาหลวง (ประชาพัฒนา)","บ้านนาหลวง (สำนักงานสลากกินแบ่งสงเคราะห์ที่ 387)","บ้านนาหลวง 1","บ้านนาหลวง 2","บ้านนาหลวงยางเดี่ยว","บ้านนาหลัก","บ้านนาหล่าย","บ้านนาหลู่เหล่าตอง","บ้านนาห้วยแคน","บ้านนาห้วยแดง","บ้านนาห้วยแดงดงสำโรง","นาหว้านาเจริญ","บ้านนาหว้า","นาหว้าประชาสรรค์","บ้านนาหว้า (สันติราษฎร์พิทยาคม)","บ้านนาหว้าใต้","บ้านนาหว้าน้อย","บ้านนาหวาย","บ้านนาหว้าเหนือ","บ้านนาห่อม","บ้านนาหัวบ่อ","บ้านนาหัวแรด","บ้านนาหัวแหลม","บ้านนาหินกอง","บ้านนาหินโหง่นนาดง","บ้านนาหืก","บ้านนาเหนือ","บ้านนาเหนือทุ่งทองวิทยา","บ้านนาเหมือง","บ้านนาเหมือดแอ่","บ้านนาเหรี่ยง","บ้านนาเหล่า","บ้านนาเหลืองไชยราม","บ้านนาเหลืองใน","บ้านนาเหว่อโนนอุดม","บ้านนาแหลม (กองแก้วราษฎร์อุปถัมภ์)","บ้านนาแห้ว","บ้านนาโหนด","บ้านนาโหนนน้อย","บ้านนาใหญ่","บ้านนาใหญ่ (เสถียรราษฎร์รัฐผดุง)","บ้านนาใหม่","บ้านนาไหม","บ้านนาไหม้","บ้านนาอวนน้อย","บ้านนาออก","บ้านนาอ้อม","บ้านนาอ่างสร้างอ่าง","บ้านนาอ่าง","บ้านนาอ่างคำ","บ้านนาอ่างทอง","บ้านนาอ่างม่วงคำ","บ้านนาอิซาง","นาอินวิทยาคม","บ้านนาอินทร์นาโอนาคอยพัฒนา","บ้านนาอินทร์แต่ง","บ้านนาอีเลิศ","บ้านนาอุดม","บ้านนาอุ่นน่อง (ประชารัฐวิทยาคาร)","บ้านนาอุ่ม","บ้านนาเอือด","บ้านนาแอง","บ้านนาโอน","บ้านนาฮ่อง","บ้านนาฮัง","บ้านนาฮ่าง","บ้านนาฮำ","บ้านนาฮี","บ้านนาเฮืองนางช้างเฒ่า","บ้านนาโฮง","บ้านนาไฮ","บ้านนาไฮ (ประชาอุปถัมภ์)","บ้านนาไฮ (มิตรภาพที่ 145)","บ้านน้ำกร่อย","บ้านน้ำกระจาย","บ้านน้ำกระโทม","บ้านน้ำกลาย","บ้านน้ำก้อ","บ้านน้ำก่ำ (สิทธิผลนุกูล)","บ้านน้ำก่ำ (ล้ำประชาอุปถัมภ์)","บ้านน้ำกุ่ม","บ้านน้ำเกลี้ยง","บ้านน้ำเกี้ยงโนนสว่าง","บ้านน้ำเกี๋ยน","บ้านน้ำแก่นกลาง","บ้านน้ำแก่นเหนือ","บ้านน้ำขวบ-โนนดู่ (กองทัพบกอุปถัมภ์)","บ้านน้ำขอบ","บ้านน้ำขาว","บ้านน้ำขุ่น","บ้านน้ำขุ่นคำนกเปล้า","บ้านน้ำขุ่นโนนผางาม","บ้านน้ำขุม","บ้านน้ำเขียว","บ้านน้ำเขียว (น้ำเขียววิทยาคม)","บ้านน้ำครั่ง","บ้านน้ำคลาด","บ้านน้ำคลุ้ง","บ้านน้ำค้อ","บ้านน้ำคา","บ้านน้ำคำ (บางระจัน 15)","บ้านน้ำคำ","บ้านน้ำคำน้อย","บ้านน้ำคำน้อยวิทยา","บ้านน้ำคำใหญ่(ประกาศราษฎร์รังสรรค์)","บ้านน้ำคิว","บ้านน้ำเคิม","บ้านน้ำแคม","บ้านน้ำโค้ง","บ้านน้ำโค้ง (นนทราษฎร์รัฐบำรุง)","บ้านน้ำโค้ง (ประชานิมิต)","บ้านน้ำไคร้","บ้านน้ำงาว","บ้านน้ำเงิน","บ้านน้ำจวง","บ้านน้ำจ้อย","บ้านน้ำจั้น","บ้านน้ำจันทร์","บ้านน้ำจั้นน้อย","บ้านน้ำจาน","บ้านน้ำจำ","บ้านน้ำจืด","บ้านน้ำจืดน้อย","บ้านน้ำจุน","บ้านน้ำโจ้","บ้านน้ำโจน","บ้านน้ำฉา","บ้านน้ำโฉ","บ้านน้ำช้างพัฒนา","บ้านน้ำชำ (ประชาราษฎร์สามัคคี)","บ้านน้ำชำ (วิชัยชนานุเคราะห์)","บ้านน้ำชุน","บ้านน้ำซับ","บ้านน้ำซับเจริญ","บ้านน้ำซึม","บ้านน้ำด้วน","บ้านน้ำดำ","น้ำดิบพิทยาคม","บ้านน้ำดิบ","บ้านน้ำดิบ (ศรีกำแพงอุปถัมภ์)","บ้านน้ำดิบมะพร้าว","บ้านน้ำดุกเหนือ","บ้านน้ำเดื่อ","บ้านน้ำเดือด","บ้านน้ำเดื่อใต้","บ้านน้ำตก","บ้านน้ำตกพลิ้ว (เฉลิมพงษ์ราษฎร์พิทยาคาร)","บ้านน้ำตกพัฒนา (นพค.อุปถัมภ์)","บ้านน้ำตกแม่กลาง","บ้านน้ำต๊ะ","บ้านน้ำตาก","บ้านน้ำทบ","บ้านน้ำทรง","บ้านนำทรัพย์","บ้านน้ำทรัพย์","บ้านน้ำท่วม","บ้านน้ำทองน้อย","บ้านน้ำทอน","บ้านน้ำทิพย์","บ้านน้ำทุเรียน","บ้านน้ำเที่ยงดอนอิจันทร์","บ้านน้ำเที่ยง","บ้านน้ำเที่ยง 2","บ้านน้ำเที่ยงนาเรียง","บ้านน้ำเที่ยงลานเตหนองเม็ก","บ้านน้ำเที่ยงวันครู 2501","บ้านน้ำโทก-หัวดง","บ้านน้ำโท้ง","บ้านน้ำบ่อ","บ้านน้ำบ่อดง","บ้านน้ำบ่า","บ้านน้ำบุ้น","บ้านน้ำปลามุง","บ้านน้ำป้าก-ห้วยธนู","บ้านน้ำปาด","บ้านน้ำปาย","บ้านน้ำปุก","บ้านน้ำปุ้น","บ้านน้ำปู่","บ้านน้ำปูน","บ้านน้ำเป","บ้านน้ำเป็น","บ้านน้ำเปื๋อย","บ้านน้ำแป่ง","บ้านน้ำผึ้ง","บ้านน้ำผึ้ง ","บ้านน้ำผึ้งประชาสรรค์","บ้านน้ำโผ่","บ้านน้ำไผ่","บ้านน้ำพ่น","บ้านน้ำพร","บ้านน้ำพรม","บ้านน้ำพราย","บ้านน้ำพริก","บ้านน้ำพาง","บ้านน้ำพาน","บ้านน้ำพิ","บ้านน้ำพี้มิตรภาพที่ 214","บ้านน้ำพุ","บ้านน้ำพุพรหมานุสรณ์","บ้านน้ำพุคุรุราษฎร์สงเคราะห์","บ้านน้ำพุง","บ้านน้ำพุปางวัว","บ้านน้ำพุร้อน","บ้านน้ำพุหินลาด","บ้านน้ำเพียงดิน","บ้านน้ำแพ","บ้านน้ำแพร่","บ้านน้ำแพะ","บ้านน้ำภาคน้อย","บ้านน้ำภู","บ้านน้ำมวบ","บ้านน้ำม้า","บ้านน้ำมิน","บ้านน้ำมี","บ้านน้ำมุด","บ้านน้ำโมง","บ้านน้ำโมง ปางสา","บ้านน้ำย้อย","บ้านน้ำยาง","บ้านน้ำยาว","บ้านน้ำเย็น","บ้านน้ำเย็น (กองทัพบกอุปถัมภ์)","บ้านน้ำร้อน","บ้านน้ำรอบ","บ้านน้ำราด","บ้านน้ำราบ","บ้านน้ำริน","บ้านลุกป่าก๊อ","บ้านน้ำริน (คุรุราษฎร์รังสรรค์)","บ้านน้ำรีพัฒนา","บ้านน้ำเรื่อง","บ้านน้ำแรม (รัฐราษฎร์อนุเคราะห์)","บ้านน้ำลอก (รัฐราษฎร์รังสรรค์)","บ้านน้ำลอด","บ้านน้ำลอดน้อย","บ้านน้ำลอม","บ้านน้ำลักใต้","บ้านน้ำลัด","บ้านน้ำลัดสบแก่น","บ้านน้ำลัดสามัคคี","บ้านน้ำลาด","บ้านน้ำลี","บ้านน้ำเลา","บ้านน้ำเลา (น้ำเลาวิทยาคาร)","บ้านน้ำเลาเหนือ (เหรียญราษฎร์อนุสรณ์)","บ้านน้ำเลียง","บ้านน้ำวน","บ้านน้ำวิ่ง","บ้านน้ำสร้าง และสาขาบ้านแก่งเสี้ยว","บ้านน้ำสร้าง-นางเภา ","บ้านน้ำสร้างหนองบะ","บ้านน้ำสวยภักดี","บ้านน้ำสวยมิตรภาพที่ 19","บ้านน้ำสวยห้วยปลาดุก","บ้านน้ำสอด","บ้านน้ำส่อม","บ้านน้ำสามวัง","น้ำสุดวิไลประชาสรรค์","บ้านน้ำใส","บ้านน้ำใสเที่ยมแข้","บ้านน้ำใสม่วงวิทยา","บ้านน้ำหก","บ้านน้ำหมัน","บ้านน้ำหมีใหญ่","บ้านน้ำหรา","บ้านน้ำหลง","บ้านน้ำหอม","บ้านน้ำหักศึกษา","บ้านน้ำหิน","บ้านน้ำอ้อ","บ้านน้ำอ้อม","บ้านน้ำอ้อมน้อย","บ้านน้ำอ้อมผักระย่า","บ้านน้ำอ้อมเล้า","บ้านน้ำอ้อย","บ้านน้ำอ่าง (สำนักงานสลากกินแบ่งสงเคราะห์ที่ 163)","บ้านน้ำอุ่น","บ้านน้ำอูน","บ้านน้ำฮอก (รัฐราษฎร์วิทยา)","บ้านน้ำฮาว","บ้านน้ำฮู","บ้านน้ำฮูผาเสื่อ และสาขาปางตอง","บ้านน้ำเฮี้ย","บ้านนิคม","บ้านนิคมเขต","บ้านนิคมดงบัง","บ้านนิคมพัฒนา","บ้านนิคมร่มเกล้า","บ้านนิคมวังหิน","บ้านนิคมสร้างตนเองธารโต","เพียงหลวง 2 (นิคมสายโท 12 ใต้)","บ้านนิคมสายโท 12 เหนือ","บ้านนิคมสายโท 8","บ้านนิคมหนองตาล","บ้านนิบง","บ้านนิบงพัฒนา","เมืองธวัชบุรี","บ้านนุเซะโปล้","บ้านนูโร๊ะ","บ้านเนิน","บ้านเนินกรวด","บ้านเนินกรอย","บ้านเนินก้าว","บ้านเนินขวาง","บ้านเนินคนธา","บ้านเนินเคว่า (พูลประชาสรรค์)","บ้านเนินแค","บ้านเนินจันทร์","บ้านเนินจำปา","บ้านเนินซาก","บ้านเนินซ่าน","บ้านเนินดินแดง (จงจินต์ รุจิรวงศ์ อุปถัมภ์ 1)","บ้านเนินดินแดง","บ้านเนินตอง","บ้านเนินตะบก","บ้านเนินตาแมว","บ้านเนินตาล","บ้านเนินตูม","บ้านเนินถาวร","บ้านเนินทราย","บ้านเนินทอง","บ้านเนินทองราษฎร์พัฒนา","บ้านเนินทุ่ง (ชื่นประชาราษฏร์บำรุง)","บ้านเนินธัมมัง","บ้านเนินนิมิต","บ้านเนินบ่อทอง","บ้านเนินประดู่","บ้านเนินประดู่ (คุรุราษฎร์วิทยา)","บ้านเนินผาสุก","บ้านเนินไผ่ (ไพศาลชลประชาสรรค์)","บ้านเนินพยอม","บ้านเนินพยอม สาขาบึงนคร","บ้านเนินพลวง","บ้านเนินพลวงวิทยา","บ้านเนินพลับหวาน","บ้านเนินพะยอม","บ้านเนินพัฒนา","บ้านเนินโพธิ์","บ้านเนินไพร","บ้านเนินม่วง","บ้านเนินม่วง (ประชาบำรุง)","บ้านเนินมะค่า","บ้านเนินมะคึด","บ้านเนินมะปราง","บ้านเนินมะลื่น","บ้านเนินมะหาด","บ้านเนินมิตรภาพที่ 47","บ้านเนินโมก","บ้านเนินไม้แดง","บ้านเนินไม้หอม","บ้านเนินยาง","บ้านเนินยาว","บ้านเนินยุ้ง","บ้านเนินรัก","บ้านเนินไร่","บ้านเนินวิทยา","บ้านเนินเวียง","บ้านเนินศาลา","บ้านเนินสง่า","บ้านเนินสมบูรณ์","บ้านเนินสวนอ้อย","บ้านเนินสวรรค์","บ้านเนินสว่าง","บ้านเนินสะอาด","บ้านเนินสาธารณ์","บ้านเนินสำราญราษฎร์พัฒนา","บ้านเนินสุขสำรอง","บ้านเนินสุวรรณ","บ้านเนินสูง","บ้านเนินเสาธง","บ้านเนินหย่อง","บ้านเนินหลังเต่า","บ้านเนินหอม","บ้านเนินใหม่","บ้านแนงมุด","บ้านโนน","บ้านโนน ","บ้านโนน (รัฐประชาสงเคราะห์)","บ้านโนนกกข่า","บ้านโนนกกจาน","บ้านโนนกระเดา","บ้านโนนกระโดน","บ้านโนนกระเบื้องหนองหัวช้างสามัคคี","บ้านโนนกระพี้วิทยา","บ้านโนนกระยอมกุดลอบ","บ้านโนนกราด","บ้านโนนกลาง","บ้านโนนก่อ","บ้านโนนกอก","บ้านโนนกอยจูมสุรพรรควิทยา","บ้านโนนกอย","บ้านโนนกาเร็น","บ้านโนนกาหลง","บ้านโนนกาหลงน้อย","บ้านโนนกุง","บ้านโนนกุ่มมิตรภาพที่210","บ้านโนนกู่","บ้านโนนเกษตร","บ้านโนนเกษม","บ้านโนนแก","บ้านโนนแก้ง","บ้านโนนแกด","บ้านโนนแก้ว","บ้านโนนแก้วโพนทอง","บ้านโนนโก","บ้านโนนขมิ้น","บ้านโนนขวาวนายูง","บ้านโนนข่า","บ้านโนนข่า (พอง)","บ้านโนนข่าประชานุเคราะห์","บ้านโนนขาม","บ้านโนนขามป้อม","บ้านโนนข่าวิทยา","บ้านโนนขี้ตุ่น","บ้านโนนขี้เหล็ก","บ้านโนนขุมคำ","บ้านโนนเขวา","บ้านโนนเขวาประชาศึกษา","บ้านโนนเขวาหนองแสง","บ้านโนนเขื่องจงเจริญ","บ้านโนนคร้อ","บ้านโนนค้อ","บ้านโนนค้อหนองบ่อ","บ้านโนนค้อทุ่ง","บ้านโนนคอม","บ้านโนนค้อลุคุ","บ้านโนนคัดเค้าคุยกอก","บ้านโนนคำแก้ว","บ้านโนนคำตื้อจตุราษฎร์วิทยา (โรตารี่1)","บ้านโนนคำน้ำจั้นใหญ่","บ้านโนนคุด","บ้านโนนคูณ","บ้านโนนคูณรัฐประชาสรรค์","บ้านโนนคูณแสนสุข","บ้านโนนเค็ง","บ้านโนนแคน","บ้านโนนงาม","บ้านโนนงามวิทยา","บ้านโนนงามอุดมวิทย์","บ้านโนนงิ้ว","บ้านโนนงิ้วตลาดใหม่สามัคคี","บ้านโนนจักจั่น","บ้านโนนจั่น","บ้านโนนจันทร์","โนนจันทึกห้วยแกวิทยา","บ้านโนนจั่นห้วยแสงพรสวรรค์","โนนจานวิทยา","บ้านโนนจาน","บ้านโนนจาน (เนตรขันธ์ราษฎร์บำรุง)","บ้านโนนจานหนองสีขา","บ้านโนนจานหนองแสง","บ้านโนนจำปา","บ้านโนนจำปาประชาสรรค์","บ้านโนนจิก","บ้านโนนจิกหนองคู","บ้านโนนเจริญ","บ้านโนนเจริญศิลป์","บ้านโนนโจด","บ้านโนนชนะสังคม","บ้านโนนชัยศรี","บ้านโนนชัยศรีหนองแคน","บ้านโนนชัยศิลป์","บ้านโนนชาด","บ้านโนนชาดผดุงวิทย์","บ้านโนนชาดวรุบลวิทยา","บ้านโนนชาดวิทยา","บ้านโนนชาติ","บ้านโนนชาติยูง","บ้านโนนเชียงค้ำ","บ้านโนนเชือก","บ้านโนนโชงโลง","บ้านโนนไชยศรี","บ้านโนนเซียง","บ้านโนนฐานะ","บ้านโนนดั่ง","บ้านโนนดั่ง (คุรุราษฎร์รังสรรค์)","บ้านโนนดินจี่","บ้านโนนดินแดง","บ้านโนนดู่","บ้านโนนดู่ (รัฐราษฎร์อุปถัมภ์)","บ้านโนนเดื่อ","บ้านโนนแดง","บ้านโนนแดงมะขามหวาน","บ้านโนนแดงโคกเล้า","บ้านโนนแดงน้อย","บ้านโนนแดงโนนม่วง","บ้านโนนแดงประชานุเคราะห์","บ้านโนนตะโก","บ้านโนนตะแบก","บ้านโนนตาด","บ้านโนนตาเถร","บ้านโนนตาพรม","บ้านโนนตารอด","บ้านโนนตาล","บ้านโนนตาลกุดเวียนหนองหญ้าม้า","บ้านโนนตาล (ศีลาคุรุราษฎร์พัฒนา)","บ้านโนนตาลหนามแท่ง","บ้านโนนตาสุดวิทยาสรรค์","บ้านโนนตำหนัก","บ้านโนนติ้ว","บ้านโนนตุ่น","บ้านโนนตุ่น (คุรุประชาวิทยาคาร)","บ้านโนนตุ่นประชาบำรุง","บ้านโนนตุ่นศึกษา","บ้านโนนตุ่นสามัคคีศึกษา","บ้านโนนตูม","บ้านโนนตูม สาขาบ้านทุ่งสว่าง","บ้านโนนเต็ง","บ้านโนนแต้","บ้านโนนแต้ (คุรุราษฎร์วิทยา)","บ้านโนนถ่อน","บ้านโนนถั่วดิน","บ้านโนนถาวร","บ้านโนนทราย","บ้านโนนทรายคำ","บ้านโนนทรายงาม","บ้านโนนทรายน้อย","บ้านโนนทรายฟอง","บ้านโนนทรายสระทอง","บ้านโนนทอง","บ้านโคกมนโนนทอง","บ้านโนนทองโนนหวาย","บ้านโนนทองคำเจริญ","บ้านโนนทองโนนสะอาด","บ้านโนนทองวิทยาคม","บ้านโนนทองหลาง","บ้านโนนทองหลาง (ตุ๊ประสิทธิ์ประชาสรรค์)","บ้านโนนทองหลางโคกสูง","บ้านโนนทองหลางโนนไผ่งาม","บ้านโนนทองห้วยบาก","บ้านโนนทองอินทร์","บ้านโนนท่อน","บ้านโนนท่อนวิทยา","บ้านโนนทะยุง","บ้านโนนทัน","บ้านโนนทันวิทยา","บ้านโนนทับช้าง","บ้านโนนทุ่งดอนชาด","บ้านโนนเที่ยง","บ้านโนนแท่น","บ้านโนนไทย","บ้านโนนธาตุ","บ้านโนนธาตุ (พิศาลราษฏร์พัฒนา)","บ้านโนนนกหอ","บ้านโนนนกหอ (เพ็งแสนวิทยา)","บ้านโนนน้อย","บ้านโนนนาสร้าง","บ้านโนนน้ำผึ้ง","บ้านโนนน้ำอ้อม","บ้านโนนเนาว์","บ้านโนนบก","บ้านโนนบ่อ","บ้านโนนบอน (คำหล้าประชานุเคราะห์)","บ้านโนนบ่อหวายดินดำ","บ้านโนนบากมิตรภาพที่ 83","บ้านโนนบุญมี","บ้านโนนบุรุษ","บ้านโนนประดู่","บ้านโนนประทาย","บ้านโนนประเสริฐ","บ้านโนนปลาเข็ง","บ้านโนนปอแดง","บ้านโนนปอแดง ","บ้านโนนป่าซาง","บ้านโนนป่าหว้านเชียงฮาย","บ้านโนนปีบ","บ้านโนนเปลือย","บ้านโนนเปือย","บ้านโนนผักชี","บ้านโนนผักหวาน","บ้านโนนผาสุก","บ้านโนนผึ้ง","บ้านโนนไผ่ขุย","บ้านโนนฝาย","บ้านโนนแฝก","บ้านโนนพยอม","บ้านโนนพระคำ","บ้านโนนพฤกษ์","บ้านโนนพลวง","บ้านโนนพอก","บ้านโนนพะไล","บ้านโนนพันชาติ","บ้านโนนพันชาติกุดโดน","บ้านโนนพุทรา","บ้านโนนเพ็ก","บ้านโนนเพกา","บ้านโนนเพชร","บ้านโนนเพชรพิทยาคม","บ้านโนนเพ็ด","บ้านโนนเพิ่ม","บ้านโนนแพง","บ้านโนนโพ","บ้านโนนโพธิ์","บ้านโนนโพธิ์ศรี","บ้านโนนฟันเรือบะยาววิทยา","บ้านโนนภิบาลโคกกลาง","บ้านโนนภูทอง","บ้านโนนม่วง","บ้านโนนม่วงท่าพลับพลา","บ้านโนนม่วงโนนจิก","อนุบาลคลองขลุง สาขาบ้านโนนมะกอก","บ้านโนนมะกอก","บ้านโนนมะกอกงาม","บ้านโนนมะเกลือ","บ้านโนนมะข่า","บ้านโนนมะเฟือง","บ้านโนนมันเทศ","บ้านโนนเมือง","บ้านโนนเมือง (เทิดเกียรติวีระชน)","บ้านโนนเมือง (เยี่ยมประชาสรรค์)","บ้านโนนเมืองโคกกุง","บ้านโนนเมืองประชาสรรค์","บ้านโนนเมืองสองคอน","บ้านโนนไม้งาม","บ้านโนนยอ","บ้านโนนยาง","บ้านโนนยางคำ","บ้านโนนยาง-ดอนเม็ก","บ้านโนนยางรัฐพัฒนา","บ้านโนนยานาง","บ้านโนนเยาะ-โนนศิริ","บ้านโนนแย้","บ้านโนนระเวียง","บ้านโนนรัง","บ้านโนนรังหนองผือวิทยา","บ้านโนนรังน้อย","บ้านโนนรังวิทยาคาร","บ้านโนนรังหนองบอน","บ้านโนนรังหนองบัวดง","บ้านโนนรังใหญ่","บ้านโนนราษี","บ้านโนนราษีโคกล่าม","บ้านโนนราษีฝางวิทยา","บ้านโนนเรือคำบอน","บ้านโนนเรือง","บ้านโนนเรือตอเรือ","บ้านโนนแร่","บ้านโนนฤาษี","บ้านโนนลาด","บ้านโนนลาน","บ้านโนนลี","บ้านโนนเลียง","บ้านโนนวังเยี่ยม","บ้านโนนว่าน","บ้านโนนศรี","บ้านโนนศรีทอง","บ้านโนนศรีภิบาล","บ้านโนนศรีสง่า","บ้านโนนศรีสง่า สาขาบ้านวังตอตั้ง","บ้านโนนศรีสวัสดิ์","บ้านโนนศาลา","บ้านโนนศิลา","บ้านโนนศิลาโนนม่วงวิทยา","บ้านโนนศิลาราศรี","บ้านโนนสงเปลือย","บ้านโนนสงวนสิบเก้าโปร่งวิทยา","บ้านโนนสง่า","โนนสง่าหนองแวงวิทยา","บ้านโนนสนาม","บ้านโนนสบาย","บ้านโนนสมบูรณ์","โนนสมบูรณ์โคกใหญ่","บ้านโนนสมบูรณ์โปร่งสุวรรณ","บ้านโนนสมบูรณ์ (อสพป.25)","บ้านโนนสมบูรณ์พัฒนา","บ้านโนนสมอ","บ้านโนนสลวย","บ้านโนนสวรรค์","บ้านโนนสวรรค์เก่าข่า","บ้านโนนสวรรค์ชัยมงคล","บ้านโนนสวรรค์ประชารัฐรังสรรค์","โนนสวรรค์ประชาสรรพ์ภูปอ","บ้านสวรรค์ราษฎร์","บ้านโนนสวรรค์สมบูรณ์วิทย์","บ้านโนนสวรรค์หนองแก","บ้านโนนสวาง","บ้านโนนสว่าง","บ้านโนนสว่างวังเสือ","บ้านโนนสว่าง 2","บ้านโนนสว่าง (อสพป.17)","บ้านโนนสว่างท่ากระบือ","บ้านโนนสว่างบวรวิทยา","บ้านโนนสว่างโสกนกไก่นา","บ้านโนนสวาท","บ้านโนนสวาทหนองไพบูลย์","บ้านโนนสะเดา","บ้านโนนสะแบงหนองสวรรค์","บ้านโนนสะอาด","โนนสะอาดห้วยตะกั่ววิทยา","บ้านโนนสะอาดหนองแต้","บ้านโนนสะอาดอีตู้","บ้านโนนสะอาดผาสุก","บ้านโนนสะอาด (ศิริคุณราษฎร์วิทยา)","บ้านโนนสะอาดราษฎร์บำรุง","บ้านโนนสะอาด 2","บ้านโนนสะอาดนาเหมือด","บ้านโนนสะอาดประชาสรรค์","บ้านโนนสะอาดศึกษา","บ้านโนนสะอาดหนองหญ้าม้าโคกสี","บ้านโนนสะอาดห้วยบั้งทิง","บ้านโนนสัง","บ้านโนนสัง (โนนสังวิทยาคาร)","บ้านโนนสังข์","บ้านโนนสังข์ศรี","บ้านโนนสังป่ารัง","บ้านโนนสั้นหนองแคสามัคคี","บ้านโนนสา","บ้านโนนสาทร","บ้านโนนสายขมิ้นหนองแมว","บ้านโนนสายหนองหว้า","บ้านโนนสาวเอ้","บ้านโนนสำนัก","เทศบาล 4 (บ้านโนนสำนักมิตรภาพที่ 121)","บ้านโนนสำราญ","บ้านโนนสำราญ-ยางเรียน","บ้านโนนสำราญสมสนุก","บ้านโนนสำโรง","บ้านโนนสำโรงหนองหมากแซว","บ้านโนนสิมมา","บ้านโนนสุข","บ้านโนนสุวรรณแสงวิทยา","บ้านโนนสูง","บ้านโนนสูงใหม่วังทอง","บ้านโนนสูง (ต.โดมประดิษฐ์)","โนนสูงโนนโฮมวิทยา","บ้านโนนสูงดอนพิกุล","บ้านโนนสูงดอนหลี่","บ้านโนนสูงน้อย","บ้านโนนสูงวังขอนจิก","บ้านโนนสูงสุขสมบูรณ์","บ้านโนนสูงหนองสวรรค์","บ้านโนนเสถียร","บ้านโนนเสน่ห์","บ้านโนนเสลา","บ้านโนนเสาขวัญ","บ้านโนนแสนคำหนองศาลา (กรป.กลางราษฎร์พัฒ)","บ้านโนนแสนสุข","บ้านโนนแสบง","บ้านโนนแสวง","บ้านโนนหนองบัว","บ้านโนนหนองแฝก","บ้านโนนหนองม่วง","บ้านโนนหนองแวง","บ้านโนนหนองสิม","บ้านโนนหนองไฮ","บ้านโนนหนามแท่ง","บ้านโนนหมากเดือย","บ้านโนนหมากมุ่น","บ้านโนนหยาดน้ำเกลี้ยง","บ้านโนนหลี่","บ้านโนนหวางโนนกุง","บ้านโนนหว้าทอง","บ้านโนนหว้านไพล (คุรุราษฎร์สงเคราะห์)","บ้านโนนหว้านไฟประชาสรรค์","บ้านโนนหวาย","บ้านโนนหอมโนนศาลา","บ้านโนนหอม","บ้านโนนหัวช้าง","บ้านโนนหัวนา","บ้านโนนหัวบึง","บ้านโนนหาด","บ้านโนนหินแร่","บ้านโนนหินลาด-กุดกว้าง","บ้านโนนหุ่ง","บ้านโนนหุ่งหนองหว้าน้ำท่วม","บ้านโนนเห็ดไค","บ้านโนนเห็ดไคล","บ้านโนนเห็นวังชัย","บ้านโนนเหม่า","บ้านโนนเหมือดแอ่","บ้านโนนเหมือดแอ่บัวหล่น","บ้านโนนเหลื่อม","บ้านโนนเหลื่อมหัวขัว","บ้านโนนแหลมทอง","บ้านโนนแหลมทอง สาขาคอนผึ้ง","บ้านโนนโหนน (อ่อนอุปการ)","บ้านโนนใหญ่","บ้านโนนใหญ่ (โอภาสพิทยาคาร)","บ้านโนนใหญ่ (คุรุราษฎร์พัฒนา)","บ้านโนนใหม่ (ประชาอุปถัมภ์)","บ้านโนนไหมโนนศิลา","บ้านโนนไหล่หนองเลิง","บ้านโนนอ้อ","บ้านโนนอำนวย","บ้านโนนอีปังโพนวัว","บ้านโนนอุดม","บ้านห้วยแสง","บ้านโนนอุดมนภดลอุปถัมภ์","บ้านโนนแฮด","บ้านโนนไฮ","บ้านใน (อินทราษฎร์บำรุง)","บ้านในกริม","บ้านในเขียว 1","บ้านในเขียว 2","บ้านในควน","บ้านในช่องมิตรภาพที่ 123","บ้านในดง","บ้านในตูล","บ้านในถุ้ง","บ้านในทอน","บ้านในทับ","บ้านในปง","บ้านในปราบราษฎร์ประสงค์","บ้านในเพลา","บ้านในเมือง","บ้านในยวน","บ้านในไร่","บ้านในล็อค","บ้านในวัง","บ้านในเวียง","บ้านในสอย","บ้านในหยง","เพียงหลวง 5 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านในห้วย","บ้านในหุบ","บ้านในเหมือง","บ้านบก","บ้านบก (ประชาสามัคคี)","บ้านบก (มั่นสามัคคีพิทยาคาร)","บ้านบกกราย","บ้านบกเก้าห้อง","บ้านบกขี้ยาง","บ้านบกแดงผักขะย่า","บ้านบกน้อยหนองแคนหนองแปน","บ้านบกโนนเรียง","บ้านบกบ่างถ่อนหนองขุน","บ้านบกปุย","บ้านบกพร้าว","บ้านบกหนองทันน้ำ","บ้านบกห้วยโนน","บ้านบกห้อง","บ้านบกหัก","บ้านบง","บ้านบงคำ","บ้านบงตัน","บ้านบงใต้โนนรัง","บ้านบงวิทยา","บ้านบน","บ้านบนเขาแก่งเรียง","บ้านบนควน","บ้านบนนา","บ้านบนไร่","บ้านบรบือ (บรบือราษฎร์ผดุง)","บ้านบรมสุข","บ้านบระเอ็ง","บ้านบราโอ","บ้านบริจ๊ะ","บ้านบริบูรณ์","บ้านบริหารชนบท","บ้านบละแต","บ้านบลูกา","บ้านบลูกาสนอ","บ้านบลูกาฮีเล","บ้านบวก (อภิชัยราษฎร์นฤมิต)","บ้านบวกค้าง","บ้านบวกจั่น","บ้านบวกเปา","บ้านบวกแรด","บ้านบวกหมื้อ","บ้านบวกอ่าง","บ้านบ่อ","บ้านบ่อกระบาก","บ้านบ่อกรัง","บ้านบ่อกรูด","บ้านบ่อกวางทอง","บ้านบ่อกะปุง","บ้านบอเกาะ","บ้านบ่อแก","บ้านบ่อแกบ่อทอง","บ้านบ่อแกนางเลา","บ้านบ่อแก้ว","บ้านบ่อแกใหญ่ (มิตรภาพ 36)","บ้านบ่อขม","บ้านบ่อคู่","บ้านบ้องตี้","บ้านบองอ","บ้านบ่อเจ็ดลูก","บ้านบ่อโฉลก","บ้านบ่อชะเนง","บ้านบ่อโชน","บ่อดอกซ้อนท่าวัด","บ้านบ่อดาน","บ้านบ่อดิน","บ้านบ่อดินสอพอง","บ้านบ่อเดือนห้า","บ้านบ่อแดง","บ้านบ่อตรุ","บ้านบ่อตะคร้อ","บ้านบ่อตะครองโนนฝ้ายสามัคคี","บ้านบ่อตะเคียนทอง","บ้านบ่อตาโพธิ์","บ้านบ่อตาโล่","บ้านบ่อเตย","บ้านบ่อทราย","บ้านบ่อทอง","บ้านบ่อทับใต้","บ้านบ่อไทย","บ้านบ่อไทยสามัคคี","บ้านบอนวิทยา","บ้านบอน","บ้านบอน (ท่าวารีวิทยา)","บ้านบอนสหราษฎร์บำรุง","บ้านบอนสหราษฎร์อุทิศ","บ้านบอนใหญ่","บ้านบ่อน้อยหนองงัวสว่างวิทย์","บ้านบือนังกือเปาะ","บ้านบ่อนางชิง","บ้านบ่อน้ำ","บ้านบ่อน้ำผุด","บ้านบ่อน้ำพุ","บ้านบ่อน้ำร้อน","บ้านบ่อน้ำส้ม","บ้านบ่อน้ำใส","บ้านบ่อโนนมะค้ำวิทยาคาร","บ้านหนองพง สาขาบ้านบ่อปิ้งเกลือ","บ้านบ่อบึงโพนจาน","บ้านบ่อเบี้ย","บ้านบ่อปลา","บ้านบ่อปัทม์","บ้านบ่อแปดร้อย","บ้านบ่อแปบหนองหญ้าม้าวิทยา","บ้านบ่อผุด","บ้านบ่อพนา","บ้านบ่อพระ","บ้านบ่อพลับ","บ้านบ่อโพง","บ้านบ่อโพธิ์","บ้านบ่อไฟไหม้","บ้านบอม","บ้านบ่อมอง","บ้านบ่อมะม่วง","อนุบาลบ้านบ่อไม้หว้า","บ้านบ่อยาง","บ้านบ่อยายส้ม (แก้วประชาสรรค์)","บ้านบ่อระแหง","บ้านบ่อรัง","บ้านบ่อร้าง (ผลานิวรรต)","บ้านบ่อแรต (สะอาดลออราษฎร์บำรุง)","บ้านบ่อไร่ (ร่วมจิตอนุกูล)","บ้านบ่อลิงประชาสรรค์","บ้านบ่อวิน (ลิขิตราษฎร์บำรุง)","บ้านบ่อเวฬุ","บ้านบ่อสร้างนรากรประสาท","บ้านบ่อสลี","บ้านบ่อสวก","บ้านบ่อสะอาด","บ้านบ่อสามแสน","บ้านบ่อสำราญ","บ้านบ่อสำโรง","บ้านบ่อแสง","บ้านบ่อแสน","บ้านบ่อหยวก","บ้านบ่อหลวง","บ้านบ่อหว้า","บ้านบ่อหวาย","กลุ่มนักข่าวหญิง 2 (บ้านบ่อหวี)","บ้านบ่อห้อ","บ้านบ่อหอย","บ้านบ่อหิน","บ้านบ่อเหมืองน้อย","บ้านบ่อใหญ่","บ้านบ่อใหญ่ (บ่อใหญ่เรืองศิลป์)","บ้านบ่ออิฐ","บ้านบ่อแฮ้วสันช้างหิน","บ้านบะ","บ้านบะขมิ้น (วัชระอนุสรณ์)","บ้านบะคอม","บ้านบะเค (ราษฎร์ผดุงวิทยาคาร)","บ้านบะแค","บ้านบะแต้","บ้านบะทองนาหัวช้าง","บ้านบะนกทา","บ้านบะป่าคา","บ้านบะยาว","บ้านบะยาวบุ่งโง้งสามัคคี","บ้านบะยาวราษฎร์นุเคราะห์","บ้านบะลังกา","บ้านคอนศรีบะสะแบง","บ้านบะเสียว","บ้านบะหลวงหนองแวง","บ้านบะหว้า","บ้านบะหัวเมย","บ้านบะแหบหญ้าคา","บ้านบะใหญ่","บ้านบะไห","บ้านบะฮี","บ้านบักจรัง","บ้านบักดอก","มัธยมบักดองวิทยา","บ้านบันนังกูแว","บ้านบันนังดามา","บ้านบันนังปุเลา","บ้านบัลลังก์","บ้านบัลลังก์พงสวาย","บ้านบัลลังก์สะอาด","บ้านบัว","บ้านบัว (สระพังวิทยา)","บ้านบัว (รัฐราษฎร์วิทยา)","บ้านบัวขาว","บ้านบัวขาว (พร้อมพันธ์อุปถัมภ์)","บ้านบัวขาว (วันครู 2500)","บ้านบัวขุนจง (กรป.กลางอุปถัมภ์)","บ้านบัวคุรุราษฎร์สามัคคี","บ้านบัวโคก","บ้านบัวงาม","บ้านบัวจันทร์","บ้านบัวเจริญ","บ้านบัวชุม","บ้านบัวเชด","บ้านบัวแดง","บ้านบัวแดง (ปทุมรัตต์วิทยาคาร)","บ้านบัวตะเคียน","บ้านบัวถนน","บ้านบัวทอง","บ้านบัวท่า","บ้านบัวเทิง","บ้านบัวเทียม","บ้านบัวน้อยโนนปอ","บ้านบัวบก","บ้านบัวมาศ","บ้านบัวยาง","บ้านบัวระรมย์","บ้านบัวราษฎร์บำรุง","บ้านบัววัฒนา","บ้านบัววัด","บัวดงมันวิทยาและสาขาบ้านดงมัน","บ้านบัวสามัคคี","บ้านบัวหลวง (สหราษฎร์บำรุง)","บ้านบาก","บ้านบาก 1","บ้านบาก 2","บ้านบากง","บ้านบากชุม","บ้านบากเรือดอนเรือ","บ้านบากเรือ","บ้านบากหนองแดง","บ้านบากหนองเทา","บ้านบากใหญ่หนองปอหนองซำ","บ้านบากัน","บ้านบางกัน","บ้านบากันโต๊ะทิด","บ้านบาโคหนองแคน","บ้านบางกง","บ้านบางกระบือ","บ้านบางกระสั้น (โรงงานกระดาษอุปถัมภ์)","บ้านบางกรัก","บ้านบางกล้วยนอก","บ้านบางกล่ำ","บ้านบางกลาง","บ้านบางกะปิ (ฝ่ายประถมศึกษา)","บ้านบางกุ้ง","บ้านบางกุฬา","บ้านบางเกตุ","บ้านบางเก่า","บ้านบางแก้ว","บ้านบางแก้ว (สำนักงานสลากกินแบ่งสงเคราะห์ 44)","บ้านบางขนุน","บ้านบางขาม","บ้านบางข้าว","บ้านบางขุด","บ้านบางขุนทอง","บ้านบางขุนแพ่ง","บ้านบางครั่ง","บ้านบางคราม","บ้านบางคลอง (ราษฎร์อุทิศ)","บ้านบางคลอง (สามัคคีประชาคาร)","บ้านบางคลี","บ้านบางคอย","บ้านบางค้างคาว","บ้านบางคู","บ้านบางงา (รัฐประชาสรรค์)","บ้านบางจัน","บ้านบางจาก","บ้านบางจิก","บ้านบางเจริญ","บ้านบางฉาง","บ้านบางชุมโถ","บ้านบางด้ง","บ้านบางด้วน","บ้านบางดาน","บ้านบางดี","บ้านบางตะเภา","บ้านบางตะลุมพอ","บ้านบางติบ","บ้านบางเตย","บ้านบางเตา","บ้านบางเตียว","บ้านบางทอง","บ้านบางทัน","บ้านบางเทา","บ้านบางไทร","บ้านบางนกวัก","บ้านบางนอน","บ้านบางน้อย","บ้านบางนา","บ้านบางนางลี่ (กมลราษฎร์สามัคคี)","บ้านบางน้ำจืด","บ้านบางนายสี","บ้านบางน้ำเย็น","บ้านบางนุ","บ้านบางเนียง","บ้านบางเนียน","บ้านบางบ่อ","บ้านบางเบน","บ้านบางเบ้า","บ้านบางเบิด","บ้านบางปรง","บ้านบางปรน","บ้านบางประชาภิบาล","บ้านบางประแดง","บ้านบางประสามัคคี","บ้านบางปรุ","บ้านบางปลาร้า","บ้านบางปลาหมอ","บ้านบางปาน","บ้านบางปู","บ้านบางเป้า","บ้านบางพระ","บ้านบางพล้อยางหลวง","บ้านบางพลี (บุศย์บูรณะ)","บ้านบางแฟบ","บ้านบางมรวน","บ้านบางมวง","บ้านบางม่วง (ประชารังสิต)","บ้านบางม่วง","บ้านบางมะนาว","บ้านบางมะฝ่อ ","บ้านบางมะรวด","บ้านบางมัน","บ้านบางม่า","บ้านบางมูลนาก","บ้านบางยาง","บ้านบางรักษ์","บ้านบางราพา","บ้านบางริ้น","บ้านบางรุ่งโรจน์","บ้านบางรูป","บ้านบางแรด","บ้านบางโรง","บ้านบางละมุง","บ้านบางลาง","บ้านบางลาด","บ้านบางลี่(สุขรัฐราษฎร์บำรุง)","บ้านบางลึก","บ้านบางเลน","บ้านบางวัง","บ้านบางวัน","บ้านบางสนิม","บ้านบางสองรา","บ้านบางสะพานน้อย","บ้านบางสัก","ราชประชานุเคราะห์ 35 จังหวัดพังงา","บ้านบางสาน","บ้านบางสำราญ","บ้านบางสำโรง","บ้านบางสีกิ้ม","บ้านบางแสม","บ้านบางโสก","บ้านบางหมาก","บ้านบางหมากน้อย","บ้านบางหมู","บ้านบางหยด","บ้านบางหยี","บ้านบางหลง","บ้านบางหลวง","บ้านบางหลาม","บ้านบางหว้า","บ้านบางหอ (โสภณเชาวน์ราษฎร์รังสรรค์)","บ้านบางหอย","บ้านบางหัก","บ้านบางหิน","บ้านบางเหรียง","บ้านบางเหียน","บ้านบางโหนด","บ้านบางใหญ่","บ้านบางใหญ่สามัคคี","บ้านบางใหญ่สินปุน","บ้านบางไหน","บ้านบาเงง","บ้านบาโง","บ้านบาโงกาเซาะ","บ้านบาโงกือเต","บ้านบาโงกูโบ","บ้านบาโงฆาดิง","บ้านบาโงดุดุง","บ้านบาโงปะแต","บ้านบาโงปูโละ","บ้านบาโงมาแย","บ้านบาโงมูลง","บ้านบาโงย","บ้านบาโงยซิแน","บ้านบาโงยือแบ็ง","บ้านบาโงยือริง","บ้านบาโงระนะ","บ้านบาโงสะโต","บ้านบาโงฮูมอ","บ้านบาจุ","บ้านบาเจาะ","บ้านบาโด","บ้านบาตง","บ้านบาตร (ชัยทัตราษฏร์บำรุง)","บ้านบาตะกูโบ","บ้านบาตัน (ฟรอยด์รอสอนุสรณ์)","บ้านบาตาปาเซ","บ้านบาตูปูเต๊ะ","บ้านบาตูฯ มิตรภาพที่ 66","บ้านบาแตตูแง","บ้านดอนสั้น","บ้านบ้านยาง","บ้านบานา","บ้านบายอ","บ้านบาระแนะ","บ้านบารายี","บ้านบาราเฮาะ","บ้านบาละ","บ้านบาละแต","บ้านบาลูกายาอิง","บ้านบาเลาะ","บ้านบาโลย","บ้านบ้าหวี","บ้านบาโหย","บ้านบำรุงวิทย์","บ้านบิง","บ้านบิง (สุประชาจูงกลางนุสสรณ์)","บ้านบินยา","บ้านบีติง","บ้านบึง","บ้านบึง (ศรีราชา)","บ้านบึง-ยางประชาสรรค์","บ้านบึง ","บ้านบึง (สนง.สลากกินแบ่งสมทบสร้าง 253)","บ้านบึง (สันติมโนประชาสรรค์)","บ้านบึงกระจับ","บ้านบึงกระดาน","บ้านบึงกระดาน (เมธาประชานุกูล)","บ้านบึงกระโดน (ศิริสิงห์อุปถัมภ์)","บ้านบึงกระโพธิ์","บ้านบึงกลาง","บ้านบึงกาฬ","บ้านบึงแก","บ้านบึงขวาง","บ้านบึงโคกสะอาด","บ้านบึงงาม","บ้านบึงเจริญ","บ้านบึงฉิม","บึงเฒ่าวิทยา","บ้านบึงโดนรัฐราษฎร์อนุสรณ์","บ้านบึงต้นชัน","บ้านบึงตะกาด","บ้านบึงตะกู","บ้านบึงตะโก","บ้านบึงตะโกน (ธนาคารกรุงเทพ)","บ้านบึงตะแบก","บ้านบึงตาต้า","บ้านบึงทอง","บ้านบึงทับจั่น ","บ้านบึงทับช้าง","บ้านบึงทับปรางค์","บ้านบึงทับแรต","บ้านบึงท่ายวน","บ้านบึงไทย","บ้านบึงธรรมโรง","บ้านบึงนาจาน","บ้านบึงน้ำใส","บ้านบึงเนียมบึงใคร่นุ่นท่าหิน","บ้านบึงโน","บ้านบึงบอน","บึงบัวพิทยาคม","บ้านบึงบาดาลราษฎร์บำรุง","บ้านบึง-เบาะอุ่น","บ้านบึงประดู่","บ้านบึงปรือ","บ้านบึงพระ","บ้านบึงพระราม","บ้านบึงพระอาจารย์","บ้านบึงพร้าว","บ้านบึงพาด (นิคมราษฎร์สงเคราะห์)","บ้านบึงพิไกร","บ้านบึงพิชัย","บ้านบึงโพธิ์","บ้านบึงมะลู","บ้านบึงมาลย์","บ้านบึงราษฎร์","บ้านบึงลัด","บ้านบึงลาด","บ้านบึงลี","บ้านบึงลูกนก","บ้านบึงวิทยา","บ้านบึงสวย","บ้านบึงสวรรค์","บ้านบึงสวางค์คุยโพธิ์","บ้านบึงสามพัน","บ้านบึงสามัคคีกำแพงเขต","บ้านบึงสาร","บ้านบึงสำราญ","บ้านบึงเสือเต้น","บ้านบึงหญ้า","บ้านบึงหมอก","บ้านบึงหมัน (นิรภัยประชานุเคราะห์)","บ้านบึงหล่ม","บ้านบึงหล่มสามัคคี","บ้านบึงหอม","บ้านบึงหัวแหวน","บ้านบึงอ้อ (ปุ่นอุปถัมภ์)","บึงอุดมบึงคำ","บ้านบือจะ","บ้านบือเจาะ","บ้านบือเจ๊าะ","บือดองพัฒนา","บ้านบือแนนากอ","บ้านบือแนปีแย","บ้านบือมัง","บ้านบือยอง","บ้านบือราแง","บ้านบือราเป๊ะ","บ้านบือเระ","บ้านบือแรง","บ้านบือเล็ง","บ้านบือเล็งใต้","บ้านบุ","บ้านบุ (รัฐราษฎร์รังสฤษฎ์)","บ้านบุ (ประชารัฐพัฒนา)","บ้านบุกระโทก","บ้านบุกระสัง","บ้านบุกะสัง","บ้านบูเกะคละ (บุญชอบ สาครินทร์)","บ้านบุแกรงตะเคียน (ปานอุทิศวิทยา)","บ้านบุเขว้า","บ้านบุ่ง","บ้านบุ้ง","บ้านบุ่งกกเรียง","บ้านบุ่งกะเซอร์","บ้านบุ่งแก้วน้ำลัด","บ้านบุ่งวิทยา","บ้านบุ่งเข้","บ้านบุ่งเขียว","บ้านบุ่งคล้า","บ้านบุ่งคล้าท่างาม","บ้านบุ่งค้อ","บ้านบุ่งค้า","บ้านบุ่งค้าแก่งข่า","บ้านบุ่งคำ","บ้านบุ่งคำ สาขาดอนใหญ่","บ้านบุ่งง้าว","บ้านบุ่งซวยห้วยยาง","บ้านบุ่งตาข่าย","บ้านบุ่งตารอด","บ้านบุ่งเตย","บ้านบุ่งบก","บ้านบุ่งเบา","บ้านบุ่งเบ้าห้วยเจริญ","บ้านบุ่งปลาฝา","บ้านบุ่งผลำ","บ้านบุ่งฝาง","บ้านบุ่งมะกรูด-วังพลับ","บ้านบุ่งมะแลง","บ้านบุ่งเม่นหนองดู่","บ้านบุ่งยาง","บ้านบุ่งเวียนวิทยา","บ้านบุ่งสัก","บ้านบุ่งสิบสี่ราษฎร์บำรุง","บ้านบุ่งไสล่","บ้านบุ่งหมากลาน","บ้านบุ่งหวาย","บ้านบุ่งอ้ายเจี้ยม","บ้านบุ่งอุทัย","บ้านบุเจ้าคุณ","บ้านบุฉนวน","บ้านบุญแจ่ม (ประชาสามัคคี)","บ้านบุญช่วย","บ้านบุญทัน","บ้านบุญนาค","บุญมีศรีสว่าง","บ้านบุญยืน","บ้านบุญเริง (ประชานุสรณ์)","บ้านบุญเรือง","บ้านบุญเรือง (อินทะวงศานุเคราะห์)","บ้านบุญเลอ","บ้านบุญโลก","บ้านบุดี","บ้านบุตร","บ้านบุตะโก","บ้านบุตาวงษ์","บ้านบุตาเวสน์","บ้านบุตาสง","บ้านบุตาสุ่มหนองโจด","บ้านบุตาโสม","บ้านบุตาโฮ-โนนกลาง","บ้านบุทม","บ้านบุโบย","บ้านบุปผาราม","บ้านบุผาง","บ้านบุไผ่","บ้านบุพราหมณ์","บ้านบุมะกรูด","บ้านบุมะขามป้อม","บ้านบุมะค่า (ชาวไร่สามัคคี)","บ้านบุยายแลบ","บ้านบุยาว","บ้านบุระไหว","บ้านบุรินทร์ (บุญชอบ สาครินทร์)","บ้านบุรีรัมย์","บ้านบุฤาษี","บ้านบุวังหว้า","บ้านบุสายออ (บุญเขตบริหาร)","บ้านบุสูง","บ้านบุเสมาทอง","บ้านบุเสี้ยว","บ้านบุ-หนองเทา","บ้านบุหว้าสามัคคี","บ้านบุหัวช้าง","บ้านบุใหญ่","บ้านบุอันโนง","บ้านบุอาไร","บ้านบุฮม","บ้านบูกิต","บ้านบูกิ๊ตยือแร","บ้านบูเกตยามู","บ้านบูเกะกอตอ","บ้านบูเกะกุง","บ้านบูเก๊ะฆลูโฆ","บ้านบูเกะจือฆา","บ้านบูเกะตา","บ้านบูเก๊ะตาโมงมิตรภาพที่ 128","บ้านบูเกะบากง","บ้านบูเก๊ะบือแต","บ้านบูเกะบือราแง","บ้านบูเกะสูดอ","บ้านบูโกะ","บ้านบูดน","บ้านบูดี","บ้านบูรพา","บ้านเบงท่าลาด","บ้านเบญจา","บ้านเบญญา","บ้านเบตง ","บ้านเบอเส้ง","บ้านเบิกไพร","บ้านเบิด","บ้านเบิดวิทยา","บ้านแบก (แบกสมบูรณ์วิทย์)","บ้านแบง","บ้านแบ่ง","บ้านแบรอ","บ้านแบหอ","บ้านโบกม่วง","บ้านโบสถ์โพธิ์","บ้านใบหนา","บ้านปง","บ้านปง (อินทขิลวิทยาคาร)","บ้านปง (ป้อมประชานุกูล)","บ้านปง (วัฒนาวิทยาคาร)","บ้านปงกา","บ้านปงของ (ธรรมราษฎร์นุกุล)","บ้านป่งขาม","บ้านปงคอบ","บ้านปงเคียน","บ้านปงดอน","ป่งแดงวิทยาคม","บ้านปงตา","บ้านปงตำ","บ้านปงเตา","บ้านปงใต้","บ้านปงถ้ำ","บ้านปงท่าข้าม (ปงประชานุกูล)","บ้านปงแท่น","บ้านปงป่าเอื้อง","บ้านป่งเปือย","บ้านปงพร้าว (ประชารัฐวิทยา)","บ้านปงแพ่ง","บ้านป่งโพน","บ้านปงแม่ลอบ","ปงยางคก ","บ้านปงวัง","บ้านปงสนุก","บ้านปงหลวง","บ้านปงหัวหาด (หัวหาดราษฎร์บำรุง)","บ้านปงใหม่","บ้านป่งไฮราษฎร์สามัคคี","บ้านปฏิรูป","บ้านปทุม (ถาวรราษฎร์ศึกษา)","บ้านปทุมวาปี","บ้านปรอผาโด้","บ้านประกอบ","บ้านประแกต","บ้านประคอง","บ้านประคำ","บ้านประจัน","บ้านประจําไม้","บ้านประชาสันต์","บ้านประชาสามัคคี","บ้านประชาสุขสันต์","บ้านประชาสุขสันติ์","บ้านประชาอารี","บ้านประดาง (บุญธรรมจำปาอุปถัมภ์)","บ้านประดาเจ็ดรัง","บ้านประดาประชาราษฎร์","บ้านประดาหัก","บ้านประดู่","บ้านประดู่งาม","บ้านประดู่เฒ่า","บ้านประตง (ศูนย์อนุบาล อ.สอยดาว)","บ้านประตูโขง","บ้านประตูน้ำพระพิมล","บ้านประตูป่า","บ้านประตูพลิก","เขตพื้นที่การศึกษาอำเภอขุนยวม","บ้านประเถท (โพธิพิทยาราม)","บ้านประทัดบุอาลอ","บ้านประทาย","บ้านประทุนทอง","บ้านประทุนอายอง","บ้านประปืด","บ้านประพาส","บ้านประสิทธิ์ธนู (ปอเกีย-พลินอุทิศ 2).","บ้านประสุข","บ้านประหูต","บ้านประแหย่ง","บ้านปรัง","บ้านปรางค์","บ้านปรางค์น้อย","บ้านปรางค์มะค่า","บ้านปรางคล้า","บ้านปรางหมู่ (ศรีวิทย์ศึกษา)","บ้านปราบราษฏร์อุทิศ","บ้านปรารถนาดี","บ้านปราสาท","บ้านปราสาท (สุวรรณราษฎร์ประสิทธิ์)","บ้านปราสาทกวางขาว","บ้านปราสาทตราดมิตรภาพที่58","บ้านปราสาททอง","บ้านปราสาทเบง","บ้านปราสาทเยอ","บ้านปราสาทสามัคคี","บ้านปริก (กุก่องวิทยาคาร)","บ้านปริกใต้","บ้านปริง (วันครู 2500)","บ้านปรีง","บ้านปรือเกียน","บ้านปรือคัน","บ้านปรือน้อย","บ้านปรือพวงสำราญ","บ้านปรือพันไถ","บ้านปรือวาย","บ้านปรือวายใหญ่","บ้านปรือใหญ่","บ้านปรุบุมะค่า","บ้านปลวกแดง","บ้านปลวกสูง","บ้านปล้องใต้","บ้านปล้องส้าน","บ้านปล่องหอย","บ้านปล่องเหลี่ยม","บ้านปลักคล้า","บ้านปลักแตน","บ้านปลักบ่อ","บ้านปลักปรือ","บ้านปลักปลา","บ้านปลักไม้ดำ","บ้านปลักแรด","บ้านปลักหว้า","บ้านปลัด","บ้านปลัดมุม","บ้านปลาข่อ","บ้านปลาขาว","บ้านหนองปลาเข็ง-กอไหล่","บ้านปลาค้าว","ปลาค้าวหนองน้ำเที่ยง","บ้านปลาดุก","บ้านปลาเดิดปลาปัดสำโรง","บ้านปลาโด","บ้านปลาบ่า","บ้านปลาปากน้อย","บ้านปลาฝา","บ้านปลายคลอง (ผดุงกุลราษฎร์อุทิศ)","บ้านปลายคลอง","บ้านปลายคลอง 20","บ้านปลายคลอง 22","บ้านปลายคลองน้อย","บ้านปลายคลองเพรง","บ้านปลายคลองวัน","บ้านปลายดาบ","บ้านปลายทอน","เทศบาลปราณบุรี (บ้านปลายน้ำ)","บ้านปลายน้ำ","บ้านปลายรา","บ้านปลายราง","บ้านปลายละหาน","บ้านปลายศอก","บ้านปลายสาย","บ้านปลายเส","บ้านปลายห้วย","บ้านปลายแหลม","บ้านปลาหลาย","บ้านปลาอีด","บ้านปลื้มพัฒนา","บ้านปวง","บ้านปวงคำ (ประชาอุทิศ)","บ้านปวงตึก","บ้านปวนพุ","บ้านปอ","บ้านป็อง","บ้านป่อง","บ้านป้องกันตนเองด่านชุมพล","บ้านป้องสร้างบุ","บ้านปอแดง","บ้านปอแดงโคกสะอาด","บ้านปอน","บ้านปอเนาะ","บ้านปอบิด","บ้านปอพราน","บ้านปอพาน","บ้านปอพานหนองโน","บ้านปอภาร (ปอภารราษฎร์บำรุง)","บ้านป้อมประชานุกูล","บ้านปอยเดิน (อินทรศึกษา)","บ้านปอเยาะ","บ้านปอเรียง","บ้านปอหมัน","บ้านปะกาจินอ","บ้านปะกาลิมาปุโระ","บ้านปะกาลือสง","บ้านปะกาฮะรัง","บ้านปะคำดง","บ้านปะคำสำโรง","บ้านปะโค","บ้านปะโคตะกอ (ประชาสามัคคี)","บ้านปะดะดอ","บ้านปะเด็ง","บ้านปะเดา","บ้านปะแดลางา","บ้านปะโด๊ะ","บ้านปะตาเมาะ","บ้านปะแต","บ้านปะทัดบุวิทยา","บ้านปะทาย","บ้านปะนอยไถง","บ้านปะนาเระ (รัฐอุทิศ)","บ้านปะลุกา","บ้านปะลุกานากอ","บ้านปะลุกาแปเราะ","บ้านปะลุกาสาเมาะ","บ้านปะลุรู","บ้านปะหละ","บ้านปะหละทะ","บ้านปะเหลียน","บ้านปะอา","บ้านปะอาว","บ้านปะอุง","บ้านปัก","บ้านปักหมู","บ้านปังกู (คุรุประชานุสรณ์)","บ้านปังหวาน","บ้านปัญจคาม (เรียนติสสวงศ์วิทยา)","บ้านปันง้าว","บ้านปันจอร์","บ้านปันเต้า","บ้านปั้นหม้อ","บ้านปัว","ปัวพิทยา","บ้านป่า (บิลอาสาประชาสรรค์)","บ้านปากกะแดะ","บ้านปากกา","บ้านปากกาง (ประชาราษฎร์รังสฤษฎ์)","บ้านปากกุดหวาย","บ้านปากข้าวสาร (บริษัทข้าวไทยจำกัดสงเคราะห์ 2)","บ้านปากคลอง","บ้านปากคลอง 17","บ้านปากคลอง 31","บ้านปากคลอง (ราษฏร์อุปกรณ์)","บ้านปากคลองแดน","บ้านปากคลองน้ำเชี่ยว","บ้านปากคลองบางกระดาน","บ้านปากคลองร่วม","บ้านปากคลองเรือ (โพธิ์โตนด)","บ้านปากคลองโรงนาค","บ้านปากคลองลาน","บ้านปากคะยาง","บ้านปากค่ายช่องแมว","บ้านปากแคว","บ้านปากง่าม","บ้านปากจก","ปากจอกวิทยา","บ้านปากเจา","บ้านปากเจียงโนนทอง","บ้านปากช่อง","บ้านปากช่อง (คุรุสามัคคี 1)","บ้านปากช่องผาเบียด","บ้านปากช่องสนามชัย","บ้านปากเชียร","บ้านปากแซง","บ้านปากดง","บ้านปากดง (เทียนศรีประสิทธิ์)","บ้านปากดงส่งเสริมธรรม","บ้านปากดวด","บ้านปากดอนสัก","บ้านปากด่าน","บ้านปากดุก","บ้านปากแดง","บ้านปากโดม","บ้านปากตก","บ้านปากโตน","บ้านปากถัก","บ้านปากทรง","บ้านปากทวย","บ้านปากทางเขื่อนภูมิพล","บ้านปากทางท่าลี่","บ้านปากทำเรียง","บ้านปากนาสวน","บ้านปากน้ำ (เผดิมจีนนาวาสงเคราะห์)","บ้านปากน้ำ","บ้านปากน้ำเก่า","บ้านปากน้ำท่ากระจาย","บ้านปากน้ำปราณ","บ้านปากน้ำปากพญา","บ้านปากน้ำปากพูน","บ้านปากน้ำหลังสวน ","บ้านปากเนียม","บ้านปากบัง","บ้านปากบาง","บ้านปากบางกลม","บ้านปากบางตาวา","บ้านปากบางนาคราช","บ้านปากบางนาทับ","บ้านปากบางสะกอม","บ้านปากบารา","บ้านปากบุ่งคุยจั่นมหาศาลจิตตรังสรรค์","บ้านปากบุ่ง","บ้านปากปรน","บ้านปากปวน","บ้านปากปัด","บ้านปากปาด","บ้านปากปาน (สีมารัตน์วิทยานุสรณ์)","บ้านปากปิง","บ้านปากโป่ง","บ้านปากพญา","บ้านปากพรุ","บ้านปากพล","บ้านปากพู่ (รองหงส์ทองรัฐรังสรรค์)","บ้านปากแพรก","บ้านปากไพ","บ้านปากภู","บ้านปากมั่งห้วยทับช้าง","บ้านปากมาง","บ้านปากยาง","บ้านปากยาม (สุนทรกัลยาคาร)","บ้านปากรอง","บ้านปากระแนะ","บ้านปากรัตน์","บ้านปากลง","บ้านป่ากล้วย","บ้านปากละงู","บ้านปากลัด","ป่ากลาง (มิตรภาพที่ 166)","บ้านปากลําปิล็อก","บ้านปากเลข","บ้านปากวัง","บ้านปากวีปมิตรภาพที่ 124","บ้านปากสระ","บ้านปากสาน","บ้านปากสาย","บ้านปากสิน (ตันประชานุเคราะห์)","บ้านปากโสม","บ้านปากหมัน","บ้านปากหมาก","บ้านปากหยา","บ้านปากหรา","บ้านปากห้วย","บ้านปากห้วยขอนแก่น","บ้านปากห้วยด่าน","บ้านปากห้วยเดื่อ","บ้านปากห้วยฝาง","บ้านปากห้วยม่วง","บ้านปากห้วยวังนอง","บ้านปากหว้า","บ้านปากหาน","บ้านปากหาร","บ้านปากเหมือง","บ้านป่ากอ","บ้านป่าก่อ","บ้านป่าก๊อ","บ้านป่าก๋อย","บ้านปากออก","บ้านปากอิง","บ้านปากอูน (ปากอูนผดุงวิทย์)","บ้านป่ากะพี้","บ้านป่าก้าง","บ้านป่าก้าว","บ้านป่าก้าวดอนแดง","บ้านป่ากุงน้อย","บ้านป่ากุงหนานาเจริญ","บ้านป่ากุงใหญ่","บ้านป่ากุมเกาะ","บ้านปากู (มีนาประชาคาร)","บ้านป่าแก","บ้านป่าแก่","บ้านป่าแกเครือ","บ้านป่าแก่บ่อหิน","บ้านป่าขนุน","บ้านป่าข่า","บ้านป่าข่างโนนลาน","บ้านป่าขาม","บ้านป่าข้าวหลาม","บ้านป่าขีหนองขุ่น","บ้านป่าขี้ยาง","บ้านป่าแข (อุดมศรัทธานุกูล)","บ้านป่าแขม","บ้านป่าแขมหนองเรือ","บ้านป่าครองชีพ","บ้านป่าคลอก","บ้านป่าคลัก (สำนักงานสลากกินแบ่งสงเคราะห์ 540)","บ้านป่าคา","บ้านป่าคาป่าม่วง","บ้านป่าคาย","บ้านป่าคาใหม่","บ้านปาง","บ้านปางกว้าง","บ้านปางกอม","บ้านปางกิ่ว (ศุภสิทธิ์มหาคุณ)","บ้านปางเกลือ","บ้านปางเกาะทราย","บ้านปางเกี๊ยะ","บ้านปางแก","บ้านปางแก (สภาประชานุกูล)","บ้านปางโก","บ้านปางขนุน","บ้านปางขอน","บ้านปางขุม","บ้านปางคอม","บ้านปางค่า","บ้านปางคาม","บ้านปางคึก","บ้านปางเคาะ","บ้านปางงุ้น และสาขาบ้านร่วมจิต","บ้านปางงู","บ้านปางชัย","บ้านปางช้าง","บ้านปางดะ","บ้านปางต้นเดื่อ","บ้านปางตอง","บ้านปางตาไว","บ้านปางถ้ำ","บ้านปางน้ำถุ","บ้านปางบอนวัฒนาคาร","บ้านปางปึงราษฎร์บำรุง","บ้านปางป๋อ","บ้านปางป้อม","บ้านปางปอย","บ้านปางปุก","บ้านปางเป๋ย","บ้านปางแปก","บ้านปางผักหม","บ้านปางเฟือง","บ้านปางมดแดง","ปางมะกาดวิทยา","บ้านปางมะขามป้อม","อนุบาลปางมะค่า","บ้านปางมะนาว","บ้านปางมะเยา","บ้านปางมะหัน","บ้านปางมะโอ","บ้านปางไม้","บ้านปางไม้แดง","บ้านปางไม้ไผ่","บ้านปางยาง","บ้านปางยาว (รัฐราษฎร์ผดุงวิทย์)","บ้านปางริมกรณ์","บ้านปางเรือ (จุฬาสงเคราะห์)","บ้านปางละกอ","บ้านปางลับแล","บ้านปางลาว","บ้านปางวุ้น","บ้านปางสวรรค์","บ้านปางสัก","บ้านปางสา","บ้านปางส้าน","บ้านปางสุด","บ้านปางหก","บ้านปางหมิ่น","บ้านปางหลวง","บ้านปางหละ","บ้านปางห้วยตาด","ปางหัดสหศาสตร์","บ้านปางห้า","บ้านปางหินฝน","บ้านปางอ้อย","บ้านปางอ้า","บ้านปางอ่าย","บ้านปางอ่ายห้วยชมภู","บ้านปางอุ๋ง","บ้านปางฮ่าง","บ้านปางไฮ","บ้านป่างาม","บ้านป่างิ้ว","บ้านป่างิ้ว (ราษฎร์บำรุง)","บ้านป่างิ้วหนองฮี","บ้านป่าแงะ","บ้านป่าจั่น","บ้านป่าจ้ำ","บ้านป่าจี้","บ้านปาโจ","บ้านป่าชัน","บ้านป่าชาด","บ้านป่าชาดคุรุประชาบำรุง","บ้านป่าชิง","บ้านป่าซาง","อนุบาลเมืองลี","บ้านป่าซางงาม","บ้านป่าซางน้อย","บ้านป่าซางเหนือ","บ้านป่าซ่าน","บ้านปาเซ","บ้านป่าเซ่า (ประชานุสรณ์)","บ้านป่าแซง","บ้านป่าดวน","บ้านป่าดวนพังหาด","บ้านปาดังยอ","บ้านป่าดู่","บ้านป่าเด็ง","บ้านป่าแดงแจ้งกระหนวน","บ้านป่าแดง","ป่าแดงหนองฮูโนนไทย","บ้านป่าแดง (เขาค้อ)","บ้านป่าแดง (ไชยอุปถัมภ์)","บ้านป่าแดง (รัฐราษฎร์รังสรรค์)","บ้านป่าแดง (วันรัตตวิทยา)","บ้านป่าแดงงาม","บ้านป่าแดง สาขาบ้านหนองตอน้อย","บ้านป่าแดงห้วยหลวง","บ้านป่าแดด บ้านนาเรือน และบ้านยางหลวง","บ้านป่าแดด","บ้านป่าแดด (เวทยาสมิทธิ์)","บ้านปาแดรู","บ้านป่าตง","บ้านป่าตอง","บ้านป่าตองท่าเนินสามัคคี","บ้านป่าตองหนองงู","บ้านป่าตะแบง","บ้านป่าตันกุมเมือง","บ้านป่าต้าก","บ้านป่าตาล","เทศบาลตำบลป่าตาล","บ้านป่าตาว","บ้านป่าติ้ว","บ้านป่าตึง","บ้านป่าตึง (วิทยประสาท)","บ้านป่าตึงงาม","บ้านป่าตึงดอยซิว","บ้านป่าตุ้ม","บ้านปาเต","บ้านป่าเตย","บ้านปาเต๊ะ","บ้านป่าเตี้ย","บ้านป่าเตียว","บ้านปาแตรายอ","บ้านป่าแต้ว","บ้านป่าใต้","บ้านป่าถล่ม","บ้านป่าถ่อน (วิทยาสมิทธิ์)","บ้านป่าถั่ว","บ้านป่าทุ่ง","บ้านป่าน","บ้านป่านหนองอ้อ","บ้านปานัน","บ้านป่าบง","บ้านป่าบง (หล้าราษฎร์วิทยา)","บ้านป่าบงท้าวแก่นจันทร์","บ้านป่าบงห้วยฮ่าง","บ้านป่าบอน","บ้านป่าบากเหล่าเรือ (คุรุราษฎร์สามัคคี)","บ้านป่าป๋วย","บ้านป่าปอ","บ้านป่าป้อง","บ้านป่าปอสหพัฒนศึกษา","บ้านป่าปอ สาขาบ้านหนองข่าลิ้น","อนุบาลเมือง (ป่าปุ๊มิตรภาพที่ 29) และสาขาห้วยแก้วล่าง","บ้านป่าเป้งน้ำซับ","บ้านป่าเป้า","บ้านป่าเปา-ป่าซางน้อย","ป่าเปือยเทพอำนวย","บ้านป่าแป๋","บ้านป่าโปง และบ้านป่าโปง สาขากองแปเหนือ","บ้านต้นงิ้ว สาขาบ้านห้วยเหี้ยะ","บ้านป่าผาง","บ้านป่าไผ่","บ้านไอปาเซ","บ้านปาฝา (คุรุประชานุสรณ์)","บ้านป่าฝาง","บ้านป่าแฝ-หนองอ้อ","บ้านป่าแฝกเหนือ","บ้านป่าพน","บ้านป่าพยอม","บ้านป่าพร้าว-บูรณะ","บ้านป่าพลู","บ้านป่าพาด","บ้านป่าเพกา","บ้านป่าม่วง","บ้านป่ามะกรูด","บ้านป่ามะม่วง","บ้านป่ามื่น","บ้านป่าเมี่ยงแม่พริก","บ้านป่าโมง","บ้านป่าไม้งาม","บ้านป่าไม้แดง","บ้านป่าไม้พระฉาย","บ้านป่าไม้สหกรณ์","บ้านป่าไม้สะพานลาว","บ้านปายอ","บ้านป่ายาง","บ้านป่ายางวนาทิพย์","บ้านป่ายางตะวันตก","บ้านป่ายางใต้","บ้านป่ายางมน","บ้านป่ายางหลวง","บ้านป่ายุบ (บุ้นกีประชานุเคราะห์)","บ้านป่ารกฟ้า","บ้านป่ารวก","บ้านป่ารวก (คุรุราษฎร์สงเคราะห์)","บ้านป่าระกำ","บ้านป่ารังงาม","บ้านปารี","บ้านป่าเร็ด","บ้านปาเระ","บ้านป่าไร่","บ้านป่าไร่โนนม่วง","บ้านป่าไร่หลวงวิทยา (ตชด.ช่างกลปทุมวันอนุสรณ์ 9)","บ้านป่าไร่เหนือ","บ้านปาลอบาต๊ะ","บ้านป่าลัน","บ้านปาลัส","บ้านป่าลาน","บ้านป่าลานหินดาด","บ้านป่าเลา","บ้านป่าเลา (ประชานุสรณ์)","ป่าแลวหลวงวิทยา","บ้านป่าวังกวาง","บ้านป่าว่าน และสาขามอตาเจ๊ก","บ้านป่าวิไล (สโมสรออนส์จันทบุรีอุปถัมภ์)","บ้านป่าสน","บ้านป่าสะแข","บ้านป่าสัก","ป่าสักวิทยา","บ้านป่าสัก (ทศพลอนุสรณ์)","บ้านป่าสักไก่","บ้านป่าสักงาม","บ้านป่าสักสามัคคี","ป่าสังข์ป่าม่วงวิทยา","บ้านป่าสังข์หนองฮี","บ้านป่าส่าน","บ้านป่าส้าน","บ้านป่าสุ่ม","บ้านป่าสุ่มหนองปิงวิทยาคาร","บ้านป่าเสร้า","บ้านป่าเส้า","บ้านป่าเสี้ยว","บ้านปาหนัน","บ้านป่าหนาม","บ้านป่าหม้อหนองคู","บ้านป่าหมาก","บ้านป่าหมากวิทยา","บ้านป่าหวัง","บ้านป่าหว้าน","บ้านป่าหวาย","บ้านป่าหวายนั่งราษฎร์บำรุง","บ้านป่าหัด","บ้านป่าหัดป่าแขม","บ้านป่าหุ่ง","บ้านป่าเหมี้ยง","บ้านป่าเหมือด","บ้านป่าเหลื่อม","บ้านป่าเหว","อนุบาลเมืองลำพูน (บ้านป่าเห็วอภิวงศ์ประชานุกูล)","บ้านป่าเหียง","บ้านป่าแหนหนองไร่","บ้านป่าแหย่ง","บ้านป่าไหน่","บ้านป่าอ้อดอนชัย","บ้านป่าอ้อ","บ้านป่าอ้อย","บ้านป่าโอน","บ้านป่าฮิ้น","บ้านปิงใน","บ้านปิงหลวง","บ้านปิน","บ้านปินเหนือ","บ้านปิใหญ่","บ้านปี้","บ้านปี๊","บ้านปึกสำโรง","บ้านปุ่งสหราษฎร์บำรุง","บ้านปุดเนียม","บ้านปุนวิทยา","บ้านปุน","บ้านปุยคำ","บ้านปุโรง","บ้านปุลากง","บ้านปุลามาวอ","บ้านปู","บ้านปู่แก้ว","บ้านปูคา","บ้านปู่จ้าว","บ้านปูซูตีฆอ","บ้านปูตะ","บ้านปูเต้อ","บ้านปูแป้","บ้านปูโป๊ะ","บ้านปูยู","บ้านปูลัย","บ้านปูลากาป๊ะ","บ้านปูลาเจ๊ะมูดอ","บ้านปูลู","บ้านเป็ด","บ้านเป็ด (ท่าบึงประชาสงเคราะห์)","บ้านเป็ดฟากทุ่ง","บ้านเปร็ดใน","บ้านเปร็ต","บ้านเปราะ","บ้านเปราะหอมพัฒนา","บ้านเปรียง","บ้านเปล","บ้านเปล่งโนนกระยอม","บ้านเปลาะปลอเมืองที (ประชารัฐสามัคคี)","บ้านเปลือยดอนมันน้ำ","บ้านเปลือย (คุรุสรรค์วิทยา)","บ้านเปลือย (สามัคคีราษฎร์ประสิทธิ์)","บ้านเปลือยตาลคุรุวิทยาประชานุกูล","บ้านเปลือยน้อยสุขสวัสดิ์","บ้านเปลือยน้อย (คุรุรัฐประชาสามัคคี)","บ้านเปลือยน้ำสามัคคี","บ้านเปลือยสีแก้ว","บ้านเปลือยหนองตูบ","บ้านเปา","บ้านเป้าประชาบำรุง","บ้านเป้า","บ้านเป้าป่าแสด","บ้านเป้า (สุทธิสารอุทิศ)","บ้านเป้า (รัฐราษฎร์บำรุง)","บ้านเป้า (สำราญไชยวิทยา)","บ้านเปาปมดงยาง (มิตรภาพที่ 155)","บ้านเป้าวิทยาคาร","บ้านเปาะ","บ้านเปาะเจ๊ะเต็ง","บ้านเปาะสวอง","ท่านผู้หญิงวิไล อมาตยกุล (บ้านเปิงเคลิ่ง)","บ้านเปียง (รัฐบำรุง)","บ้านเปียงใจ","บ้านเปียงซ้อ","บ้านเปียงหลวง","บ้านเปียด","บ้านเปียะ","บ้านเปือย","บ้านเปือยประชาสามัคคี","บ้านเปือยทานตะวันพิทยาสรรพ์","บ้านเปือยขาม","บ้านเปือยนาสูง","บ้านเปือยใหญ่ชาติหนองบ่อ","บ้านแปดอุ้ม","บ้านแป้น","บ้านแป้น (สามัคคีประชานุกูล)","บ้านแป้น (รัฐราษฎร์วิทยา)","บ้านแป้นสามัคคีราษฎร์บำรุง","บ้านแปรง","บ้านแป-ระใต้","บ้านแป-ระเหนือ","บ้านแปลง","บ้านแปลง (รามคำแหงอนุสรณ์ 7)","บ้านแปลงกระถิน","บ้านแปลงไผ่-ขุนคลัง","บ้านแปลงสี่","บ้านแปะ","บ้านแปะสามัคคี","บ้านแป๊ะบุญ","บ้านโปง","บ้านโป่ง (อนิวัตต์ราษฎร์สามัคคี)","บ้านโป่ง","บ้านโป่ง (คำประชานุกูล)","บ้านโปง (ประชาสามัคคี)","บ้านโป่งกระทิงบน","บ้านโป่งกระทิงล่าง","บ้านโป่งกระสัง","บ้านโป่งกลางน้ำ","บ้านโป่งกวาง","บ้านโป่งกะเฌอ","บ้านโป่งกะพ้อ","บ้านโป่งกะสัง","บ้านโป่งกุ่ม","บ้านโป่งกูป","บ้านโป่งเก้ง","บ้านโป่งเกต","บ้านโป่งเกตุ","บ้านโป่งเกลือ","บ้านโป่งโก","บ้านโป่งขวาก","บ้านโป่งข่อย","บ้านโป่งขุนเพชรพัฒนา","บ้านโป่งคองใต้","บ้านโป่งคองเหนือ","บ้านโป่งคอม","บ้านโป่งคำ","บ้านโป่งแค","บ้านโป่งแคศรีถาวร","บ้านโป่งเจ็ด","บ้านโป่งเจริญ","บ้านโป่งเจริญชัย","บ้านโป่งช้าง","บ้านโป่งชี","บ้านโป่งดาวเรือง","บ้านโป่งดินดำ","บ้านโป่งดู่ประชาอุทิศ","บ้านโป่งแดง","บ้านโป่งแดงน้ำฉ่าสามัคคี","บ้านโป่งตะขบ","บ้านโป่งตะเคียน","บ้านโป่งตาเบ้า","บ้านโป่งตาลอง","บ้านโป่งตีนตั่ง","บ้านโป่งแต้","บ้านโป่งถืบ","บ้านโปงทุ่ง","บ้านโป่งเทวี","บ้านโป่งไทร","บ้านโป่งนก","บ้านโป่งนกแก้ว","บ้านโป่งนกพิทยา","บ้านโป่งนกพิทยา สาขาบ้านคลองผักหวาน","บ้านโป่งน้อย","บ้านโป่งนาคำ","บ้านโป่งน้ำตก","บ้านโป่งน้ำร้อน","บ้านโป่งบุญเจริญ","บ้านโป่งประชาพัฒน์","บ้านโป่งปะ","บ้านโป่งป่าติ้ว","บ้านโป่งปูเฟือง","บ้านโป่งเป้า","บ้านโป่งเปือย","บ้านโป่งไผ่","บ้านโป่งฝาง","บ้านโป่งพระบาท","บ้านโป่งพรานอินทร์","บ้านโป่งพาน","บ้านโป่งโพธิ์","บ้านโป่งมอญ","บ้านโป่งแมลงวัน (จิราธิวัฒน์อุปถัมภ์)","บ้านโป่งยอ","บ้านโป่งยอ (จำเริญ โฆสิตสกุล)","บ้านโป่งแย้","วัดโป่งแยงเฉลิมพระเกียรติ","บ้านโป่งแยงใน","บ้านโป่งรู","บ้านโป่งวัว","บ้านโป่งวัวแดง","บ้านโป่งศรี","บ้านโป่งศรีโทน","บ้านโป่งสลอด","บ้านโป่งสวองคีรีวรรณ์","บ้านโป่งสะเก็ต","บ้านโป่งสา","บ้านโป่งสามขา","บ้านโป่งสามสิบ","บ้านโป่งสามัคคี","บ้านโป่งหนองสิม","บ้านโป่งหว้า","บ้านโป่งหวาย","บ้านโป่งหิน","บ้านโป่งเหนือ","บ้านโป่งแห้ง","บ้านโป่งไหม","บ้านโป่งเอียด","บ้านโป่งฮึ้ง","บ้านโป่งไฮ","บ้านโปร่ง","บ้านโปร่งเจริญ","บ้านโปร่งเกตุ","บ้านโปร่งโก","บ้านโปร่งคลอง (ประชาวิทยาคาร)","บ้านโปร่งแจ้ง","บ้านโป่งตาสา","บ้านโปร่งมีชัย","บ้านโปร่งสนวน","บ้านโปร่งสะเดา","บ้านโปร่งสังข์","บ้านโปร่งสามัคคี","บ้านโปร่งสำราญ","บ้านโปร่งหนองเปงใหม่จำปา","บ้านโปร่งใหญ่","บ้านโปะหมอ","บ้านผไทรวมพล","บ้านผไทรินทร์","บ้านผมเด็น","บ้านผักกะย่า","บ้านผักกาดหญ้าโรตารี่อุทิศ","บ้านผักขย่าใหญ่","บ้านผักขวง","บ้านผักขะ","บ้านผักขะย่านาคอยโนนแดง","บ้านผักคำภู","บ้านผักตบ","บ้านผักตบประชานุกูล","บ้านผักบุ้ง","บ้านผักเผ็ดจ้อก้อ","บ้านผักแพว (คุรุราษฎร์รังสฤษฎ์)","บ้านผักแว่น","บ้านผักแว่นอนามัย (คุรุศิษยานุกูล)","บ้านผักแว่น (ผักแว่นวิทยาคาร)","บ้านผักหนอก","บ้านผักหนาม","บ้านผักหย่า","บ้านผักหวาน","บ้านผักหวานโนนสวาง","บ้านผักไหม","บ้านผักเฮือก","บ้านผังสามัคคี","บ้านผับแล้ง","บ้านผากลางดง","บ้านผากลางนา","บ้านผาแก้ว","บ้านผาขวาง","ผาขวางวิทยา","บ้านผาขาม","บ้านผาขาว","บ้านผ้าขาวโพนแพง","บ้านผาคันวิทยา","บ้านผาฆ้อง","บ้านผางอุดมสมบูรณ์วิทยา","บ้านผาจั๊บ (คุรุราษฎร์อนุกูล)","บ้านผาจุก","บ้านผาช้างมูบ และสาขาบ้านแม่ต๋อมใน","บ้านผาซ่อนโชคชัย","บ้านผาซำบอน","บ้านผาเดื่อ","บ้านผาแดง","บ้านผาแดงหลวง","บ้านผาตั้ง","บ้านผาต้าย","บ้านผาตูบ","บ้านผาแตน","บ้านผาทอง","บ้านผาท่าพล","บ้านผาน้อย","บ้านผานัง","บ้านผาน้ำเที่ยง","บ้านผาน้ำย้อย","บ้านผาบ่อง (คุรุราษฎร์สามัคคี)","บ้านผาแบ่น","บ้านผาปูน","ผาผึ้งวิทยาคม","บ้านผาพอด","บ้านผามอก (ประชานุเคราะห์)","บ้านผามอน","บ้านผาแมว","บ้านผาเยอ","บ้านผารังหมี","บ้านผารางวังหม้อ (มิตรประชา)","บ้านผาละปิ","บ้านผาลั้ง","บ้านผาลาด","บ้านผาแล","บ้านผาวัง","บ้านผาเวียง","บ้านผาสะนา","บ้านผาสามยอด","บ้านผาสำราญ","บ้านผาสิงห์","บ้านผาสุก (ราษฎร์บำรุง)","บ้านผาสุก และสาขาผาสวรรค์","บ้านผาเสด็จ","บ้านผาหมอน","บ้านผาหลัก","บ้านผาหวาย","บ้านผาฮี้","บ้านผำ","บ้านผำโนนสว่าง","บ้านผิผ่วน","บ้านผีปานเหนือ","บ้านผึ้ง","บ้านผึ้ง (มธุลีย์ประชาสรรค์)","บ้านผึ้ง (รัฐราษฎร์บำรุง)","บ้านผึ้ง (สามัคคี)","บ้านผึ่งแดด","บ้านผึ้งโดม","บ้านผือ","บ้านผือ (ประชาพัฒนา)","บ้านผือ (สวัสดิ์ราษฎร์วิทยา)","บ้านผือน้อย","บ้านผือวิทยายน","บ้านผือเหมือดม่วงพัฒนา","บ้านผือฮี","บ้านผือฮีนาลานาจาน","บ้านเผียน","บ้านแผ่นดินทอง","บ้านโผงโผง","บ้านโผลง","บ้านไผ่","บ้านไผ่ (วันครู 2503)","ชุมชนไผ่กุดหิน-ท่าเดื่อ","บ้านไผ่คอกวัว","บ้านไผ่งาม","บ้านไผ่ตะล่อม","บ้านไผ่ตาโม้","บ้านไผ่ตาสุ่ม","บ้านไผ่โทน","บ้านไผ่โทน (นวลราษฎร์วิทยา)","บ้านไผ่น้ำเที่ยง","บ้านไผ่โน้ม","บ้านไผ่แปลกแม่","บ้านไผ่พิทยาคม","บ้านไผ่มัน","บ้านไผ่ย้อย","บ้านไผ่ยาวสามัคคี","บ้านไผ่ลวก","บ้านไผ่ล้อม (วงษ์บุญตรีฉวีรัตน์)","บ้านไผ่ล้อม","บ้านไผ่ล้อม (สำนักงานสลากกินแบ่งสงเคราะห์ 46)","บ้านไผ่ล้อมโนนสมบัติ","บ้านไผ่ล้อมสามัคคี","บ้านไผ่ศึกษา","บ้านไผ่สี","บ้านไผ่สีทอง","บ้านไผ่แสงทองประชาสรรค์","บ้านไผ่หนองแคน","บ้านไผ่หมูขวิด (พงษ์ผลประสาทวิทยา)","บ้านไผ่หลวง","บ้านไผ่ใหญ่","บ้านไผ่ใหญ่ (ดำรงค์อุทิศ)","บ้านฝังงา","บ้านฝั่งแดง (พระเทพวรมุนีอุปถัมภ์)","บ้านฝั่งแดง","บ้านฝั่งตื้น","บ้านฝั่งเพ","บ้านฝั่งหมิ่น (รัฐราษฎร์บำรุง)","บ้านฝั่งหมิ่น","บ้านฝางวิทยา ศูนย์เครือข่ายทุ่งใหญ่","บ้านฝาง","บ้านฝางคำสามัคคี","บ้านฝางน้อย","บ้านฝางวิทยา","บ้านฝาผนัง","บ้านฝาผนังวังจาน","บ้านฝาย","บ้านฝ้าย","บ้านฝายกวาง","บ้านฝายแก้ว","เทศบาลบ้านฝายดินสอ","บ้านฝ่ายท่า","บ้านฝายนาแซง","บ้านฝ้ายนาตมส้มป่อย","บ้านฝายโบสถ์","บ้านฝายป่าบัว","บ้านฝายพญานาค","บ้านฝายวังบอน","บ้านฝายหินประชารักษ์","บ้านฝายหิน","บ้านแฝก","บ้านแฝกโนนสำราญ","บ้านพงกูแว","บ้านพงแขม","บ้านพงพรต","บ้านพงโพด","บ้านพงยือไร","บ้านพงษ์โนนประวัติ","บ้านพงษ์เพชรอนุสรณ์","บ้านพงสิม","บ้านพญาพิภักดิ์","บ้านพญาไพร","บ้านผาจี","บ้านพญาวัง","บ้านพน","บ้านพนม","บ้านพนมกาว","บ้านพนมดิน","บ้านพนมดี","บ้านพนมนาง","บ้านพนมเพชร","บ้านพนมไพร","บ้านพนมรอก","บ้านพนอม","บ้านพนัสดงสว่างวิทย์","บ้านพนาทักษิณ","บ้านพนานต์ (สามัคคีวิทยา)","บ้านพนานิคม","บ้านพนาสวรรค์","บ้านพนาหนองหิน","บ้านพม่า","บ้านพยอม","บ้านพยอมงาม","บ้านพยูน","บ้านพรทิพย์","บ้านพรมใต้พิทยาคาร","บ้านพรมทิน","บ้านพรมเทพ (พรมเทพราษฎร์บำรุง)","บ้านพรมสวรรค์","บ้านพรมห้วยข่าวิทยา","บ้านพรสวรรค์","บ้านพรสำราญ","บ้านพรหม","บ้านพรหมเขต","บ้านพรหมจรรย์","บ้านพรหมเจริญ","บ้านพรหมณี","บ้านพรหมนิมิต","บ้านพรหมนิยม","บ้านพรหมประชาสรรค์","บ้านพรหมมาสามัคคี","บ้านพรหมยาม","บ้านพรหมรังสิต","บ้านพรหมสว่าง","บ้านพรหมสะอาด","บ้านพร่อน","บ้านพระ","บ้านพระแก้ว","บ้านพระครูน้อย","บ้านพระเจ้า (ศรีมหาธาตุ)","บ้านพระซองเหนือ","บ้านพระที่นั่ง","บ้านพระนอน","บ้านพระนั่งดิน","บ้านพระนารายณ์","บ้านพระบาท","บ้านพระบาทท่าเรือ","บ้านพระบาทนาหงส์","บ้านพระบาทห้วยผึ้ง","บ้านพระปรง","บ้านพระปรางค์","บ้านพระปืด","บ้านพระพุทธ","บ้านพระพุทธบาทประสาธน์วิทย์","บ้านพระเพลิง","บ้านพระม่วง","บ้านพระมะขามสามัคคี","บ้านพระรักษ์ราษฎร์บำรุง","บ้านพระโรจน์ (ชนูปถัมภ์)","บ้านพระเสาร์ (สามัคคีวิทยาคม)","บ้านพระแอะ","บ้านพราน","บ้านพราน (ประชานุเคราะห์)","บ้านพรานกระต่าย","บ้านพรานเหมือน","บ้านพรานอ้น","บ้านพร้าว","บ้านพร้าวกลาง","พร้าวใต้เจริญสุข","บ้านพร้าวเหนือ","บ้านพรุ","บ้านพรุจำปา","บ้านพรุจูด","บ้านพรุชิง","บ้านพรุแชง","บ้านพรุดินนา","บ้านพรุตะเคียน","บ้านพรุตู","บ้านพรุเตย","บ้านพรุเตียว","บ้านพรุนายขาว","บ้านพรุใน","บ้านพรุบัว","บ้านพรุพ้อ","บ้านพรุพี","บ้านพรุยายชี","บ้านพรุวง","บ้านพรุหลุมพี","บ้านพรุหวา","บ้านพรุใหญ่","บ้านพลกรัง (เดชาติวงค์คงฤทธิ์อนุสรณ์)","บ้านพลงตาเอี่ยม","บ้านพลจลก","บ้านพลวง","บ้านพลวง (พรหมบำรุงราษฎร์)","บ้านพลไว","บ้านพลสงคราม (แพงรัฐราษฎร์วิทยา)","บ้านพลับ","บ้านพลับ (วิสุทธิวังราช)","บ้านพลับ (มีราษฎร์บำรุง)","บ้านพลับพลา","บ้านพลับพลาชัย","บ้านพลับหนองคำ (มหาชัยชิโนบล)","บ้านพลาญชัย","บ้านพลายชุมพล","บ้านพลำ","บ้านพวงพยอม","บ้านพวยเด้งสันติสุข","บ้านพอก","บ้านพอก (บำรุงวิทยา)","บ้านพอกโนนหนองผือคำไผ่ใต้","บ้านพอกหนองแข้","บ้านพอกใหญ่ดอนต้นม่วง","บ้านพอโกบ","บ้านพองหนีบ","บ้านพอแดง","บ้านพอบิด","บ้านพ่อมิ่ง","บ้านพอแม็ง","บ้านพอเหมาะ","บ้านพะงาดวิทยา","บ้านพะเด๊ะ","บ้านพะทาย","บ้านพะเนา","บ้านพะเนาว์","บ้านพะเนาว์ราษฎร์บำรุง","บ้านพะแนงวิทยา","บ้านพะปูเงาะ","บ้านพะมอลอ","บ้านพะเยา","บ้านพะเยียวตาสุ (อสพป.37)","บ้านพะลอง","บ้านพะละ","บ้านพะลาน","บ้านพะไล","บ้านพะวร","บ้านพะแวะ","บ้านพังกาญจน์","บ้านพังขว้างวัฒนศิลป์","บ้านพังขว้างเหนือ 909 กรป.กลางอุปถัมภ์","บ้านพังคอง","บ้านพังเคน","บ้านพังโคน (จำปาสามัคคีวิทยา)","บ้านพังงู","บ้านพังซ่อน","บ้านพังปริง","บ้านพังเภา","บ้านพังลา(ตรีวณีชวิทยาคาร)","บ้านพังหรัน","บ้านพังเหา","บ้านพัฒนา","บ้านพัฒนา 2","บ้านพัฒนาดงน้อย","บ้านพัฒนาสามัคคี","บ้านพัดทะเล","บ้านพัดโบก","บ้านพันขาง","บ้านพันชนะ","บ้านพันเชิง (วงศ์หล้าราษฎร์บำรุง)","บ้านพันดอน","บ้านพันดุง","บ้านพันตน","บ้านพันธ์สงวน","บ้านพันธุลี","บ้านพันนา","บ้านพันลำ","บ้านพันลำ ","บ้านพันษี","บ้านพันเสด็จนอก","บ้านพันเสด็จใน","บ้านพันเสา","บ้านพันห่าวดอนดู่","บ้านพับ","บ้านพาชี","บ้านพาดหมอน (ศิริวรรณจินดา)","บ้านพาน","บ้านพานทอง","บ้านพานพร้าว","บ้านพานสหราษฎร์บำรุง","บ้านพารา","บ้านพิงพวย","บ้านพิงพวย (เสียงราษฎร์พัฒนา)","บ้านพิชิตคเชนทร์","บ้านพิตำ","บ้านพิเทน (วันครู 2502)","บ้านพิมานท่า","บ้านพิลา","บ้านพี้","บ้านพี้ใต้","บ้านพีพวย","บ้านพี่เลี้ยง (อิ่มอุทิศ)","บ้านพี้เหนือ","บ้านพืชคาม","บ้านพืชเจริญ","บ้านพืชผล","บ้านพุกระโดน","บ้านพุกร่าง (พลอุปถัมภ์)","บ้านพุกะชัด","บ้านพุเกตุ","บ้านพุขาม","บ้านพุเข็ม","บ้านพุคาย","บ้านพุแค","บ้านพุซาง","บ้านพุดซา","บ้านพุต่อ","บ้านพุตะเคียน","บ้านพุตะแบก","บ้านพุตุม","บ้านพุเตย","บ้านพุทธรักษา","บ้านพุทรา","บ้านพุนกยูง","บ้านพุน้อย","บ้านพุน้ำเปรี้ยว","บ้านพุน้ำร้อน","บ้านพุบ่องป่าขี","บ้านพุบอน","บ้านพุบอนบน","บ้านพุปลาไหล","บ้านพุปลู","บ้านพุพรหม","บ้านพุพลู","บ้านพุม่วง","บ้านพุม่วง-พุพง","บ้านพุม่วงราษฎรบำรุง","บ้านพุมะค่า","บ้านพุย","บ้านพุย สาขาพุยใต้","บ้านพุรวก","บ้านพุลุ้ง (กรป.กลางอุปถัมภ์)","บ้านพุเลียบ","บ้านพุหวาย","บ้านพุใหญ่","บ้านพุองกะ","บ้านพูด กรป.กลาง","บ้านพูน","บ้านพูนสุข (ประชานุกูล)","บ้านเพ็กท่าบ่อวิทยา","บ้านเพ็ก","บ้านเพ็กคำบากหายโศก","บ้านเพ็กน้อย","บ้านเพ็กเฟื้อย","บ้านเพ็กใหญ่และสระบัว (คุรุราษฏร์สามัคคี)","บ้านเพชรเจริญพัฒนา","บ้านเพชรน้ำผึ้ง","บ้านเพชรนิยม","บ้านเพชรประชาสามัคคี","บ้านเพชรไฝ","บ้านเพชรมงคล","บ้านเพชรละคร","บ้านเพ็ดน้อย","บ้านเพลินวัฒนา","บ้านเพิก (รัฐประชาสามัคคี)","บ้านเพิ่ม","บ้านเพิ่ม (อรุโณอุปถัมภ์)","บ้านเพีย","บ้านเพียแก้ว","บ้านเพียซำพุวิทยา","บ้านเพียนาม","บ้านเพี้ยฟานโนนตุ่น","บ้านเพี้ยฟานโนนสวรรค์","บ้านเพียมาต (รัฐราษฎร์พิทยาคาร)","บ้านเพี้ยราม","บ้านแพ","บ้านแพงหนองเหนือ","บ้านแพง","วัดบ้านแพง (จตุคามวิทยา)","บ้านแพงโคก","บ้านแพงน้อย","บ้านแพงพวย","บ้านแพงพวย (สังฆคุรุราษฎร์บำรุง)","บ้านแพงพิทยาคม","อนุบาลบ้านแพง","บ้านแพงศรี","บ้านแพงสะพัง","บ้านแพงใหญ่","บ้านแพมบก","บ้านแพรกกลาง","บ้านแพรกหนามแดง","บ้านแพรกแห้ง","บ้านแพร้ว","บ้านแพะพิทยา","บ้านแพะ","บ้านแพะกลาง","บ้านแพะทุ่งเจริญ","บ้านแพะยันต์ดอยแช่","บ้านโพง","บ้านโพงกอก","บ้านโพซอ","อนุบาลโพทะเล ","บ้านโพทะเลประชาสรรค์","บ้านโพธิ์","บ้านโพธิ์ (ชุมคณานุสรณ์)","บ้านโพธิ์ (คุรุราษฎร์ประสิทธิ์)","บ้านโพธิ์ (โพธิ์ทองวิทยา)","บ้านโพธิ์ (โพธิ์ศรีวิทยา)","บ้านโพธิ์กระมัล","บ้านโพธิ์กระสังข์","บ้านโพธิ์กอง","บ้านโพธิ์งามหนองหญ้าขาววิทยา","บ้านโพธิ์งาม","บ้านโพธิ์งาม (สุขะวรรณะอุปถัมภ์)","บ้านโพธิ์งาม (สนานทองคำประชาสรรค์)","บ้านโพธิ์เงิน","บ้านโพธิ์ชัน","บ้านโพธิ์ชัย","บ้านโพธิ์ชัยดอกคำ","บ้านโพธิ์ชัยแหลมทอง","บ้านโพธิ์ไชย","บ้านโพธิญาณ","บ้านโพธิ์ดอนหวาย","โพธิ์ตากวิทยา","บ้านโพธิ์ตาก","บ้านโพธิ์ตาสี","บ้านโพธิ์ทอง","บ้านโพธิ์ทอง (ยุทธศิลป์สงเคราะห์)","บ้านโพธิ์ทองชัยประสิทธิ์ (จำลองราษฎร์อุปถัมภ์)","บ้านโพธิ์ท่าเมือง","บ้านโพธิ์ไทร","บ้านโพธิ์ไทรทองวิทยา","บ้านโพธิ์ไทรโพธิ์ศรี","บ้านโพธิ์น้อย","บ้านโพธิ์น้อยหนองสิม","การไฟฟ้าส่วนภูมิภาคสงเคราะห์ 1 (บ้านโพธิ์น้อยกุดสวง)","บ้านโพธิ์โนนจานอีลอก","บ้านโพธิ์ประทับช้าง","บ้านโพธิ์ประสาท","บ้านโพธิ์พนา","บ้านโพธิ์พัฒนา","บ้านโพธิ์มีหนองเม็กโนนสะอาด","บ้านโพธิ์มูลเพียเภ้า","บ้านโพธิ์ลังกา","บ้านโพธิ์ศรี","บ้านโพธิ์ศรี ","บ้านโพธิ์ศรี (คุรุราษฎร์อินทรสุภผล)","บ้านโพธิ์ศรีสามัคคี","บ้านโพธิ์ศรีสําราญ","บ้านโพธิ์ศรีหัวงัว","บ้านโพธิ์สง่า","บ้านโพธิ์สง่า (มังกรสามเสนอนุสรณ์)","บ้านโพธิ์สวัสดิ์","บ้านโพธิ์สามัคคี","บ้านโพธิ์ห้วย","บ้านโพธิ์หอม","บ้านโพธิ์เหล่าวิชาคำสีดา","บ้านโพธิ์ใหญ่","บ้านโพธิ์เอน","บ้านโพน","บ้านโพนก่อ","บ้านโพนก่อ (ราษฏร์อนุสรณ์)","บ้านโพนก้างปลาโนนสมบูรณ์","บ้านโพนโก","โพนขวาวพิทยาคม","บ้านโพนขวาว","บ้านโพนข่า (วินิตวิทยาคาร)","บ้านโพนขาว","บ้านโพนครก","บ้านโพนครกน้อย","บ้านโพนค้อ","บ้านโพนค้อโพนสวรรค์","บ้านโพนงอย","บ้านโพนงาม","บ้านโพนงามเกี้ยงเก่า","บ้านโพนงาม (พูลเพิ่มวิทยาคาร)","บ้านโพนงามคุรุราษฎร์วิทยา","บ้านโพนงามหนองตุ","บ้านโพนเงินโพนทอง","บ้านโพนจาน","บ้านโพนชาย","บ้านโพนเฒ่า","บ้านโพนดวน","บ้านโพนดวน ","บ้านโพนดวนสาวเอ้","บ้านโพนดินแดง","บ้านโพนดู่โคกสวัสดิ์","บ้านโพนเดื่อโนนสวรรค์","บ้านโพนแดง","บ้านโพนตูมหนองแสง","บ้านโพนทราย","บ้านโพนทรายโนนเรือ","บ้านโพนทอง","บ้านโพนทอง (สญชัยประชาเวทย์)","บ้านโพนทอง (แสงราษฎร์สามัคคี)","บ้านโพนทองประชาอุทิศ","บ้านโพนทัน","บ้านโพนทา","บ้านโพนแท่น","บ้านโพนนาดี","บ้านโพนบก","บ้านโพนบกสหราษฎร์วิทยา","บ้านโพนบกหนองผือ","บ้านโพนบกหัวขัววิทยาคาร","บ้านโพนแบง","บ้านโพนปลัด","บ้านโพนป่าแดง","บ้านโพนป่าหว้าน","บ้านโพนไผ่","บ้านโพนพระ","บ้านโพนพอุง","บ้านโพนเพ็ก","บ้านโพนเพ็กพิทยา","บ้านโพนแพง","บ้านโพนโพธิ์หว้างาม","บ้านโพนไพล","บ้านโพนม่วง","บ้านโพนเมือง","บ้านโพนเมือง (สุกวิทยา)","บ้านโพนเมืองน้อย","บ้านโพนเมืองมะทัน","บ้านโพนยาง","บ้านโพนยางคำ กรป.กลางพัฒนา","บ้านโพนยานาง","บ้านโพนละออม","บ้านโพนเลา","บ้านโพนวัฒนาวิทยา","บ้านโพนสวรรค์","บ้านโพนสวาง","บ้านโพนสวางหนองแหน","บ้านโพนสวางกลางเจริญ","บ้านโพนสว่าง","บ้านโพนสว่างวังเย็น","บ้านโพนสะอาด","บ้านโพนสาวเอ้","บ้านโพนสิม (เสมาพิทยา)","บ้านโพนสูง","บ้านโพนสูงโนนสวรรค์","บ้านโพนหนอง","บ้านโพนหิน","บ้านโพนแอวขัน","บ้านโพนไฮ และสาขาบ้านโคกยาว","บ้านโพรงเข้","บ้านโพรงจระเข้","บ้านโพรงตะเข้","บ้านโพรงตะเฆ่ (จันทร์ประสิทธิ์นุเคราะห์)","บ้านโพหวาย","บ้านไพ","บ้านไพจาน","บ้านไพบูลย์","บ้านไพรขลา (ไพรขลาราษฎร์พิทยากูล)","บ้านไพรงาม","บ้านไพรจิตรวิทยา","บ้านไพรนกยูง (วันชัยประชาสรรค์)","บ้านไพรพะยอม","บ้านไพรพัฒนา","บ้านไพรวัน","บ้านไพรวัลย์น้อย","บ้านไพรวัลย์ปอแดง","บ้านไพรษรสำโรง","บ้านไพรสวรรค์","บ้านไพรสะเดา","บ้านไพรอุดม","บ้านไพล","บ้านไพล (ไตรมิตรสามัคคี)","บ้านไพศาล (ลี้ลอยอุทิศ)","บ้านไพศาลสามัคคี","บ้านฟองใต้","บ้านฟ่อน","บ้านฟักทอง","บ้านฟ้า","บ้านฟากนา","บ้านฟากบึง","บ้านฟากพอง","บ้านฟากเลย (สหราษฎร์อนุสรณ์)","บ้านฟากห้วย","บ้านฟ้าประทาน","บ้านฟ้าผ่า","บ้านฟาร์มสัมพันธ์กิจ","บ้านฟ่าวงาม","บ้านฟ้าห่วน","บ้านฟ้าเหลื่อม","บ้านฟุบสะแก","บ้านภักดีแผ่นดิน","บ้านภู","บ้านภูกระแต","บ้านภูเขาขาม","บ้านภูเขาทอง","บ้านภูเขาลาด","บ้านภูเขาวง","บ้านภูคำเบ้า","บ้านภูงา","บ้านภูเงิน","บ้านภูเงิน (อินทรสุขศรีราษฎร์สามัคคี)","บ้านภูดิน","บ้านภูดิน (มิตรผลอุปถัมภ์)","บ้านภูดินพัฒนา","บ้านภูดินหนองตะครอง","บ้านภูดินหินกอง","บ้านภูตะคาม","บ้านภูถ้ำพระพรเจริญ","บ้านภูทอง","บ้านภูทองลานมันหลัก 160","บ้านภูไทร","บ้านภูนกเขียน","บ้านภูน้ำหยด","เทศบาล4 บ้านภูบ่อบิด","บ้านภูป่าไผ่","บ้านภูปูน","บ้านภูผักไซ่","บ้านภูผาหอมพัฒนา","บ้านภูแผงม้า","บ้านภูพระโนนผักหวาน","บ้านภูพานคำ","บ้านภูพานทอง","บ้านภูเพ็ก","บ้านภูมะหรี่","บ้านภูมิซรอล","บ้านภูมิธรรม","บ้านภูมินิยมพัฒนา","บ้านภูมิศาลา","บ้านภูมิสตึง","บ้านภูมูลเบ้า","บ้านภูล้อม","บ้านภูวง","บ้านภูสวรรค์","บ้านภูหล่น","บ้านภูเหล็ก","บ้านมณฑล","บ้านมณีโชติสามัคคี","บ้านมณีลอย","บ้านมดตะนอย","บ้านมนต์คีรี","บ้านมนตรีวิทยา","บ้านมะโนรา","บ้านมรสวบ","บ้านม่วง","บ้านม่วงวิทยา","บ้านม่วงหนองตาด","บ้านม่วงอาจโพธิ์ศรี (คุรุราษฏร์วิชาคม)","บ้านม่วง (ม่วงเกษมวิทยาคาร)","บ้านม่วง (รามคำแหงอนุสรณ์)","บ้านม่วงกาชัง","บ้านม่วงกุล","บ้านม่วงขามประชารักษ์","บ้านม่วงขี้เหล็กยานาง","บ้านม่วงไข่","บ้านม่วงไข่บ้านเม็ก (โพธิ์ชัยวิทยา)","บ้านม่วงไข่ประชาราษฎร์สงเคราะห์","บ้านม่วงคอนสาย","บ้านม่วงค่อม","บ้านม่วงคำ","บ้านม่วงโคน","บ้านม่วงงาม","บ้านม่วงเงาะ","บ้านม่วงเจริญราษฎร์","บ้านม่วงชี","บ้านม่วงชุม","บ้านม่วงชุม สาขาบ้านสวนชา","บ้านม่วงเฒ่า","บ้านม่วงดง","บ้านม่วงเดียด","บ้านม่วงเตี้ย","บ้านม่วงโตน","บ้านม่วงถ้ำ","บ้านม่วงทรัพย์โกฎิ","บ้านม่วงทวน","บ้านม่วงท่าลาด","บ้านม่วงน้อย","บ้านม่วงนาดี","บ้านม่วงนาสีดา","บ้านม่วงน้ำ (ประชาศิษย์วิทยา)","เพียงหลวง 13 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านม่วงเนิ้ง","บ้านม่วงโนนกระแต","บ้านม่วงโนนสูง","บ้านม่วงบุญมี","บ้านม่วงประชาบํารุง","บ้านม่วงเปเหมือดแอ่","บ้านม่วงโป้","ม่วงโป้หนองน้ำขุ่น","บ้านม่วงฝ้าย","บ้านม่วงพี่น้อง","บ้านม่วงพุ่ม","บ้านม่วงโพธิ์ศรี","บ้านม่วงโพรง (รัฐอุทิศ)","บ้านม่วงมูล","บ้านม่วงยาย","บ้านม่วงแยก","บ้านม่วงลายราษฎร์ผดุงศิลป์","บ้านม่วงลีบ","บ้านม่วงวิทยาคม","บ้านม่วงวิทยาคาร","บ้านม่วงวิทยายน","บ้านม่วงสร้อย","บ้านม่วงสว่างสามัคคี","บ้านม่วงสวาสดิ์","บ้านม่วงสามปี","บ้านม่วงหนองบอนสามัคคี","บ้านม่วงหมาก","บ้านม่วงหวาน","บ้านม่วงหอม (สนง.สลากกินแบ่งสงเคราะห์ 43)","บ้านม่วงหัก","บ้านม่วงใหญ่","บ้านม่วงใหญ่ดอนน้อยวิทยา","บ้านม่วงใหม่","บ้านม่วงอยู่ประยงค์ ณ บ้านเบิก","บ้านม่วงฮี","บ้านมหาการเฉียงพง","บ้านมหาเจริญ","บ้านมหาชัย","บ้านมหาโพธิ","บ้านมหิงษาราม","บ้านมอเกอ","บ้านมอเจริญ","บ้านมอเจริญ สาขาบ้านใหม่เชียงราย","บ้านมอญ","บ้านมอแดง (สิงห์ทองประชาสรรค์)","บ้านมอใต้","บ้านม่อน (ปัญญาฉลาดราษฎร์นุกูล)","บ้านม่อนป่ายาง","บ้านม่อนปิ่น","บ้านม่อนแสนศรี","บ้านม่อนหินเหล็กไฟ","บ้านมอสมบัติ","บ้านมอสมบูรณ์มิตรภาพที่ 189","บ้านมอเหนือ","บ้านมะกรูด","บ้านมะกอ","บ้านมะกอก","บ้านมะกอกใต้ (มุขประชาอุปถัมภ์)","บ้านมะกอกหมู่(ปุญสิริวิทยา)","บ้านมะกอกหวาน","วัดมะกับตองหลวง","บ้านมะเกลือเก่า (ศาสนการบริรักษ์บำรุง)","บ้านมะเกลือโกรกกระสัง","บ้านมะเกลือโนนทอง","บ้านมะเกลือใหม่","บ้านมะขาม","บ้านมะขามภูมิ","บ้านมะขาม (สาครมะขามราษฎร์)","บ้านมะขามเฒ่า (เปรมประชารัฐวิทยา)","บ้านมะขามทานตะวัน","ขามป้อมประชานุกูล","บ้านมะขามโพรง","บ้านมะขามเอน","บ้านมะเขือ","บ้านมะเขือแจ้","บ้านมะค่า","บ้านมะค่า (คงฤทธิบัวสุวรรณอนุสรณ์)","บ้านมะค่างาม","บ้านมะค่าดอนทะยิง","บ้านมะชมโนนสง่า","บ้านมะแซวหนองโง้ง","บ้านมะเดื่อ","บ้านมะเดื่อชุมพร","บ้านมะเดื่อทอง","บ้านมะเดื่อหวาน","บ้านมะต้อง","บ้านมะนัง","บ้านมะนังกาหยี","บ้านมะนังปันยัง","บ้านมะนังยง","บ้านมะนาว","บ้านมะนาวหวาน","บ้านมะแนดาแล","บ้านมะโบ่","บ้านมะปริง","บ้านมะพร้าวต้นเดียว","บ้านมะพริกดู่โพนสิม","บ้านมะฟัก","เพียงหลวง 6 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านมะม่วงงาม","บ้านมะม่วงเจ็ดต้น","บ้านมะม่วงทอง","บ้านมะม่วงหวาน","บ้านมะม่วงเอน","บ้านมะมัง","บ้านมะเมียง","บ้านมะยาง","บ้านมะยูง","บ้านมะรวด","บ้านมะรือโบตก","บ้านมะรือโบออกมิตรภาพที่ 199","บ้านมะรุม","บ้านมะเริง","บ้านมะลูจรุงหนองปรีง","บ้านมะเลาะ","บ้านมะหงัง","บ้านมะหรี่ (ศิริวิทยาคาร)","บ้านมะหุด","บ้านมะอึ","บ้านมังกาล่า","บ้านมัดกานกทาขุมปูน","บ้านมันปลา","บ้านม้า","บ้านม้างอน","บ้านมาบกระเปา","บ้านมาบกราด","บ้านมาบกราดวิทยา","บ้านมาบกรูด","บ้านมาบแก","บ้านมาบคล้า","บ้านมาบแค","บ้านมาบช้างนอน","บ้านมาบตอง","บ้านมาบตะโกเอน","มาบตากล้าร่มเย็น","บ้านมาบตาพุด","บ้านมาบเตย","บ้านมาบนาดี","บ้านมาบบัว","บ้านมาบประชัน","บ้านมาบป่าแดง","บ้านมาบป่าหวาย","บ้านมาบไผ่","บ้านมาบฝาง","บ้านมาบพะยอม","บ้านมาบฟักทอง","บ้านมาบแฟบ","บ้านมาบมะไฟ","บ้านมาบยางพร","บ้านมาบลำบิด","บ้านมาบสมอ","บ้านมาบสมอสามัคคี","บ้านมาบหัวทีง","บ้านมาบเหลาชะโอน","บ้านมาบเหียง","บ้านมาบโอน","บ้านมาลา","บ้านม่าหนิก","บ้านมาแฮ","บ้านมิ่งมงคล","บ้านมือบา","บ้านมือลอ (มะอาแดอุทิศ)","บ้านมือและห์","บ้านมุนี","บ้านมูกมันโนนอุดมสามัคคี","บ้านมูเซอ","บ้านมูโนะ","บ้านมูลกระบือ","บ้านมูลตุ่น","บ้านมูลนาค","บ้านมูหลง","บ้านเม็ก","บ้านเม็กดงเรือง","บ้านเม็กดำ","บ้านเม็กน้อยหนองไผ่","บ้านเม็กหางเหย","บ้านเม็กใหญ่","บ้านเม็ง","บ้านเม่น","บ้านเม่นน้อย","บ้านเม่นใหญ่","บ้านเมย","บ้านเมรัย","บ้านเมาะลาแต","บ้านเมี่ยง","บ้านเมี่ยงแคนดวน","บ้านเมืองกลาง","บ้านเมืองกลางวิทยา","บ้านเมืองก๊ะ","บ้านเมืองกาญจน์","บ้านเมืองกื้ด","บ้านเมืองเก่า","บ้านเมืองเก่าซ่ง (รัฐราษฎร์รังสรรค์)","บ้านเมืองเก่า (ศรีอินทราทิตย์)","บ้านเมืองแก","บ้านเมืองขอน","บ้านเมืองคง","บ้านเมืองคลอง","บ้านเมืองคอง","บ้านเมืองจัง","บ้านเมืองจันทร์","บ้านเมืองตะโก","บ้านเมืองตึง","บ้านเมืองเตา","บ้านเมืองทอง (วีระประชานุสรณ์)","บ้านเมืองที","บ้านเมืองน้อย","บ้านเมืองน้อย (นิมมานเหมินทานุสรณ์)","บ้านเมืองน้อยหนองมุข","บ้านเมืองนะ","บ้านเมืองนาซำ","บ้านเมืองนาท","เมืองบัววิทยาคาร","บ้านเมืองบาง","บ้านเมืองปักสามัคคี","บ้านเมืองปัง","บ้านเมืองแปง","บ้านเมืองไผ่","บ้านเมืองไผ่กระท่ม","บ้านเมืองแฝก","บ้านเมืองพรึก","บ้านเมืองพลับพลา","บ้านเมืองพาน","เมืองพานบ้านโก่มวิทยา","บ้านเมืองเพ็ง","บ้านเมืองเพีย","บ้านเมืองแพม","บ้านเมืองไพร","บ้านเมืองไพร (เมืองไพรวิทยาคาร)","บ้านเมืองยาง (เอี่ยมโอภาสประชานุกูล)","บ้านเมืองรัง","บ้านเมืองลีง","บ้านเมืองสรวง","บ้านเมืองเสือ","บ้านเมืองหมีพรหมวิทยา","บ้านเมืองหลวง","บ้านเมืองอาง","บ้านแม่กรณ์","บ้านแม่กระต๋อม","บ้านแม่กะทิง","บ้านแม่กลองเก่า","บ้านแม่กลองน้อย","บ้านแม่กลองใหม่","บ้านแม่กวัก","บ้านแม่กวางใต้","บ้านแม่กวางเหนือ","บ้านแม่กองคา","บ้านแม่กองปิน","บ้านแม่กองแป","บ้านแม่ก๋อน","บ้านแม่กอนใน","บ้านแม่ก๊ะ","บ้านแม่กะไน","บ้านแม่กัวะ","บ้านแม่กา","บ้านแม่กาษา","บ้านแม่กิ๊","บ้านแม่กึ๊ด","บ้านแม่กื้ดสามท่า","บ้านแม่กื้ดหลวงกัญไชยมิตรภาพที่ 182","บ้านแม่กุ้งหลวง","บ้านแม่กุหลวง","บ้านแม่กุเหนือ","บ้านแม่เกาะวิทยา","บ้านแม่แก้วเด่นชัย","บ้านแม่แก้วใต้","บ้านแม่แก้ว","บ้านแม่โกนเกน","บ้านแม่โกปี่","บ้านแม่ขมวก","บ้านแม่ขมิง","บ้านแม่ขรี (สวิงประชาสรรค์)","บ้านแม่ขะนิง","บ้านแม่ขะปู","บ้านแม่ข่า","บ้านแม่ขาน","บ้านแม่ข้าวต้มท่าสุด","บ้านแม่ขิ","บ้านแม่ขีด","บ้านแม่แขก","บ้านแม่โขง","บ้านแม่โข่จู","บ้านแม่คะ","บ้านแม่คะตวน","บ้านแม่คะเมย","บ้านแม่คาวหลวง","บ้านแม่คำ","บ้านแม่คำ (ธรรมาประชาสรรค์)","บ้านแม่คำฝั่งหมิ่น","บ้านแม่คำมี (รัตนปัญญา)","เทศบาลตำบลแม่คำ (แม่คำสบเปินราษฎร์นุกูล)","บ้านแม่คี-หนองอ้อ","แม่คือวิทยา","บ้านแม่คุ","บ้านแม่แคม","บ้านแม่แคะ","บ้านแม่ไคร้","บ้านแม่งอนกลาง","บ้านแม่งอนขี้เหล็ก","บ้านแม่งะ","บ้านแม่งาวใต้","บ้านแม่งูด","บ้านแม่เงา","บ้านแม่จว้า","บ้านแม่จว้าใต้","บ้านแม่จอ","บ้านแม่จอก","บ้านแม่จ้อง","บ้านแม่จ๋อง","บ้านแม่จองไฟ (รัฐราษฎร์พัฒนา)","บ้านแม่จะเราสองแคว","บ้านแม่จั๊วะ","บ้านแม่จ๋า","บ้านแม่จาง","บ้านแม่จ๊าง","บ้านแม่เจดีย์","บ้านแม่แจ๊ะ","บ้านแม่โจ้","บ้านแม่ใจ","บ้านแม่ใจ (แม่ใจเพาะวิทยาการ)","บ้านแม่เชียงรายลุ่ม","บ้านแม่ซา","บ้านแมด","บ้านแมดคำลือชา (ราษฎร์สามัคคี)","บ้านแม่ดง","บ้านแมดนาท่ม","บ้านแม่ดอกแดง","บ้านแม่แดดน้อย","บ้านแม่แดดน้อย สาขาบ้านดงสามหมื่น","เทพเสด็จวิทยา","บ้านแม่ต้อบใต้","บ้านแม่ต้อบเหนือ","บ้านแม่ต๋อม","บ้านแม่ตอละ","แม่ตะไคร้","บ้านแม่ตะมาน","บ้านแม่ตะละ","บ้านแม่ตะละเหนือ","บ้านแม่ตั๋ง","บ้านแม่ตา","บ้านแม่ตาช้าง","บ้านแม่ตาใน","บ้านแม่ตาแมว","บ้านแม่ตาลน้อย-ปางปง ปางทราย","บ้านแม่ตาว","บ้านแม่ตาวใต้","บ้านแม่ตาวแพะ","บ้านแม่ตาวใหม่","บ้านแม่ต๋ำ","บ้านแม่ต๋ำน้อย","บ้านแม่ต๋ำบุญโยง","บ้านแม่ตีบ","บ้านแม่ตื้ด","บ้านแม่ตื่น","บ้านแม่ตูบ","บ้านแม่ตูม","บ้านแม่เติน","บ้านแม่เตี๋ย","บ้านแม่เตี๊ยะ","บ้านแม่แต","บ้านแม่โต๋","แม่โถวิทยาคม","บ้านแม่โถ","บ้านแม่โถใต้","บ้านแม่ทราย (คุรุราษฎร์เจริญวิทย์)","บ้านแม่ทอม","บ้านแม่ทะ","บ้านแม่ทะลบ","บ้านแม่ทะลาย","บ้านแม่ทะลุ","บ้านแม่ทาน","บ้านแม่ท่าแพ","บ้านแม่ทาย","บ้านแม่ที","บ้านแม่ทุเลา","บ้านแม่ทุเลาใน","บ้านแม่เทย","บ้านแม่เทิน","บ้านแม่เทียบ","บ้านแม่ไทย","บ้านแม่นนท์","บ้านแม่นะ","บ้านแม่นาจร","บ้านแม่นาจาง","บ้านแม่นาจางเหนือ","บ้านแม่นาเติง","บ้านแม่นาเรือ","บ้านแม่นาเรือใต้","ห้วยน้ำขุ่นวิทยา","บ้านแม่น้ำคู้","บ้านแม่แนต","บ้านแม่บงใต้","บ้านแม่บงเหนือ","บ้านแม่บวน","บ้านแม่บ่อทอง","บ้านแม่บอน","บ้านแม่บัว","บ้านแม่ประจัน","บ้านแม่ประจันต์","บ้านแม่ป้อก","บ้านแม่ป้อกใน","บ้านแม่ปอถ่า","บ้านแม่ปะ","บ้านแม่ปะใต้","บ้านแม่ปะเหนือ","บ้านแม่ปั๋ง","บ้านแม่ปันเดง","บ้านแม่ปาคี","บ้านแม่ปาง","บ้านแม่ปาน","บ้านแม่ปาน (แม่ปานประชาสงเคราะห์)","บ้านแม่ป๋าม","บ้านแม่ปิง และสาขาบ้านหวาย","บ้านแม่ปืม","บ้านแม่ปุง","บ้านแม่ปุ๋น","บ้านแม่ปูคา","บ้านแม่ปูนหลวง","บ้านแม่เปา","บ้านแม่แปง","แม่โป่งประชาสามัคคี","บ้านแม่ผง","บ้านแม่ผักแหละ","บ้านแม่ผึ้ง","บ้านแม่แฝก","บ้านแม่พร้าว","บ้านแม่พริก","บ้านแม่พริก (เมืองยศพิทยานุกุล)","บ้านแม่พริกบน","บ้านแม่พลู","บ้านแม่พวก","บ้านแม่พะยวบ","บ้านแม่พุง","บ้านแม่แพ","บ้านแม่แพง","บ้านแม่แพน้อย","บ้านแม่แพหลวง","บ้านแม่โพ","บ้านแม่เฟือง","แม่มอญวิทยา","บ้านแม่มะ","บ้านแม่มะลอ","บ้านแม่ม่า","บ้านแม่มุ","บ้านแม่เมย","บ้านแม่แมม","บ้านแม่แมะ","บ้านแม่โมกข์","บ้านแม่โมงเย้า","บ้านแม่ย่อย (เจียร-สมศรี วังทองคำ)","บ้านแม่ยางกาด (มิตรภาพที่ 13)","แม่ยางตาล (กิตติประชานุกูล)","บ้านแม่ยางโพธิ์ (โพธิ์ราษฎร์รังสรรค์)","บ้านแม่ยางมิ้น","บ้านแม่ยางยวง (ลูนราษฎร์สงเคราะห์)","บ้านแม่ยางร้อง (แม่ยางประชานุเคราะห์)","บ้านแม่ยางห้า","บ้านแม่ยามเหนือ","บ้านแม่เย็น","บ้านแม่ระกา","บ้านแม่ระมาดน้อย","บ้านแม่ระมาดราษฎร์บำรุง","บ้านแม่ระเมิง","บ้านแม่ระหัน","บ้านแม่รัง (จัดสรรราษฎร์สงเคราะห์)","บ้านแม่ราก","บ้านแม่แรม","บ้านแม่ลอง","บ้านแม่ลอยไร่","บ้านแม่ละ","บ้านแม่ละนา","บ้านแม่ละเมา","บ้านแม่ลัว","บ้านแม่ลัว (วิริยะราษฎร์สงเคราะห์)","บ้านแม่ลากเนินทอง","บ้านแม่ลาก๊ะ","บ้านแม่ลาด","บ้านแม่ลาน","บ้านแม่ลาน (ราษฎร์อุทิศ)","บ้านแม่ลานคำ","บ้านแม่ลานหลวง","บ้านแม่ลานหลวง สาขาดอยซาง","บ้านแม่ลาผาไหว","บ้านแม่ลามา","บ้านแม่ลาย","บ้านแม่ลายเหนือ","บ้านแม่ลิด","บ้านแม่เลา","บ้านแม่เลียง","บ้านแม่เลียงพัฒนา","บ้านแม่แลบ","บ้านแม่และ","บ้านแม่วะ","บ้านแม่วะเด่นชัย","บ้านแม่วะหลวง","บ้านแม่วังช้าง","บ้านแม่แว","บ้านแม่ศึก","บ้านแม่สง","บ้านแม่สลองใน","บ้านแม่สละ","บ้านแม่สละเหนือ","บ้านแม่สลิด","บ้านแม่สลิดหลวงวิทยา","บ้านแม่สวด","บ้านแม่สวรรค์น้อย","บ้านแม่สอย","บ้านแม่สะกั๊วะ","บ้านแม่สะกึ๊ด","บ้านแม่สะงา","บ้านแม่สะเต","บ้านแม่สะนาม","บ้านแม่สะปึ๋ง","บ้านแม่สะปึ๋งใต้","บ้านแม่สะเป่","บ้านแม่สะเป่ใต้","บ้านแม่สะแมง","บ้านแม่สะเรียง","บ้านแม่สะลาบ","บ้านแม่สา","บ้านแม่สาน","บ้านวังใหม่","บ้านแม่ส้าน","บ้านแม่สามแลบ","บ้านแม่สายดอนทัน (คำแวงประชาอุทิศ)","บ้านแม่สาว","บ้านแม่สำ","บ้านแม่สิน","บ้านแม่สุ","บ้านแม่สุก","บ้านแม่สุขใน","บ้านแม่สุขวังเหนือ","บ้านแม่สุริน","บ้านแม่สูนน้อย","บ้านแม่แสม","บ้านแม่แสะ","บ้านแม่หงานหลวง","บ้านแม่หลงสบจาง","บ้านแม่หล่วง","บ้านแม่หลองน้อย","บ้านแม่หล่าย (ประชานุสรณ์)","บ้านแม่หล่ายกาซ้อง (ลือราษฎร์อุปถัมภ์)","บ้านแม่หลุย","บ้านแม่หลู้ (รัฐราษฎร์รังสรรค์)","บ้านแม่หว่าง (ราษฎร์อุปถัมภ์)","บ้านแม่หวาน","บ้านแม่หอย","บ้านแม่หาด","บ้านแม่หาร","บ้านแม่หีด","บ้านแม่เหมืองหลวง","บ้านแม่เหียะ","บ้านแม่เหียะสามัคคี","บ้านแม่ใหญ่","บ้านแม่อมกิ","บ้านแม่อมลอง","บ้านแม่อมลาน","บ้านแม่ออ","บ้านแม่อ้อ","บ้านแม่ออก","บ้านแม่ออกผารู","บ้านแม่ออกเหนือ","บ้านแม่อ้อนอก","บ้านแม่อ้อใน","บ้านแม่อาง","บ้านแม่อ่างขาง","บ้านแม่อาว","บ้านแม่อิง","บ้านแม่อีแลบ","บ้านแม่อีไฮ","บ้านแม่อุมป๊อก","บ้านแม่อุมพาย","บ้านแม่อุมลอง","บ้านแม่อุมลองหลวง","บ้านแม่อุสุ","บ้านแม่อูคอ","บ้านแม่อูคอหลวง","บ้านแม่เอาะ","แม่แอบวิทยาคม","บ้านแม่ฮวก","บ้านแม่ฮ้อยเงิน","แม่ฮ่างวิทยา","บ้านแม่ฮุ","บ้านแม่ฮู้","บ้านแม่แฮใต้","บ้านแม่แฮเหนือ","บ้านแมะแซ","บ้านโม่งหลวง","บ้านโม่งหลวง สาขาบ้านแม่อมลานใน","บ้านโมน (เกาะแก้ววิทยา)","บ้านโมย","บ้านไม้กะพง","บ้านไม้แก่น","บ้านไม้ขาว","บ้านไม้งาม","บ้านไม้ซางหนาม","บ้านไม้แดง","บ้านไม้ตะเคียน และ รร.บ้านไม้ตะเคียน สาขาป่าตึงงาม","บ้านไม้ฝาด","บ้านไม้ยามิตรภาพที่168","บ้านไม้รูด (วิสิทธิ์ประชาสรรค์)"," อบจ.บ้านไม้เรียบ (ตันติโกวิทบำรุง)","บ้านไม้ล่าว (คุรุราษฎร์พัฒนา)","บ้านไม้สลี","บ้านไม้สะเป่","บ้านยกกระบัตร","บ้านยมเบือ","บ้านยวด","บ้านยวนปลา","บ้านยวนโปะ","บ้านยวนยาง","ชุมชนย่อวิทยา","บ้านยอกขาม","บ้านยองแยง","บ้านยอด","บ้านยอดชาดวิทยา","บ้านยอดดอนชี","บ้านยอดดอยวัฒนา","บ้านยอดดอยวิทยา","บ้านยอดห้วย","บ้านยอดห้วยแก้ว","บ้านย้อมพัฒนา","บ้านยะต๊ะ","บ้านยะบะ (อุปการวิทยา)","บ้านยะพอ","บ้านยะรม","บ้านยะรัง","บ้านยะลา","บ้านยะลูตง (ประชุมวิทยาสาร)","บ้านยะวึก (ผจงราษฎร์วิทยาคาร)","บ้านยะหอ","บ้านยะหา","บ้านยะออ","บ้านยา","บ้านยาง","บ้านยาง (ยางทวงวิทยา)","บ้านยาง ","บ้านยาง (คุรุราษฎร์วิทยา)","บ้านยาง (อาสาพัฒนา 3)","บ้านยาง (สารกิจราษฎร์วิทยา)","บ้านยางกระจับ","บ้านยางกระทุง","บ้านยางกลาง","บ้านยางกะเดา และบ้านยางกะเดา สาขานาคำภูฮี","บ้านยางกาญจน์","บ้านยางกุด","บ้านยางกุดนาคำ","บ้านยางเกาะ","บ้านยางเกี่ยวแฝก","บ้านยางแก้ว","ยางโกนวิทย์","บ้านยางโกลน","บ้านยางขาคีม","บ้านยางขาม","บ้านยางขามเฒ่า","บ้านยางขาว","บ้านยางขี้นก","บ้านยางเขา","บ้านยางครก","บ้านยางคำ","บ้านยางคำวิทยา","บ้านยางคู่","บ้านยางเครือ","บ้านยางเครือด่านน้อย","บ้านยางงอย","บ้านยางงาม","บ้านยางงาม (ศุภรธรรมนิวิฏฐ์)","บ้านยางงาม (สาครเขตอุดม)","บ้านยางจ้องหนองแวงน้อย","บ้านยางช้า","บ้านยางชุม","บ้านยางชุมภูมิตำรวจ","บ้านยางชุมใหญ่ และบ้านยางชุมใหญ่สาขาบ้านดอนโก","บ้านยางซอง","บ้านยางซ้าย (พรหมมาประชาสรรค์)","บ้านยางเฌอ (วีรชนอุทิศ)","บ้านยางเดี่ยวหนองถ่ม (ค้ำอำนวยศึกษา)","บ้านยางแดง","บ้านยางแดน","พินิจราษฎร์บำรุง","ผดุงราษฎร์วิทยา","บ้านยางตะพาย","บ้านยางเตี้ย","บ้านยางเตี้ยโคกรัง","บ้านยางใต้","บ้านยางทะเล","บ้านยางเทิง","บ้านยางโทน","บ้านยางนกกระทุง","บ้านยางนกคู่","บ้านยางน้อย","บ้านยางน้อย (พรหมพิทยา)","บ้านยางน้อยตองปิด","บ้านยางน้อยสามัคคี","บ้านยางน้อยหัวสิบ","บ้านยางน้ำกลัดใต้","บ้านยางน้ำกลัดเหนือ","บ้านยางน้ำใส","บ้านยางบอน (อำพานุสรณ์)","บ้านยางบ่อภิรมย์","บ้านยางบ่ออี","บ้านยางบึง","บ้านยางเปา","บ้านยางเปียง","บ้านยางเมือง","บ้านยางโยภาพ","บ้านยางระหง","บ้านยางราก","บ้านยางลาด","บ้านยางลุ่ม","บ้านยางเลิง","บ้านยางโล้นเจริญราษฎร์ไพบูลย์","บ้านยางวังกางฮุง","บ้านยางวิทยา","บ้านยางสักกระโพหลุ่ม","บ้านยางสามัคคี","บ้านยางสาว","บ้านยางสินไชย หนองหาด","บ้านยางสุขวัฒน์","บ้านยางสูง","บ้านยางหล่อโนนน้ำย้อย","บ้านยางหล่อโนนสวนกล้วย","บ้านยางหวาย","บ้านยางหัวลม","บ้านยางห่างโนนทัน","บ้านยางห้าหลุม","บ้านยางเหล่าสวนกล้วย","บ้านยางแหลม","บ้านยางใหญ่","บ้านยางอ้อย","บ้านยางอิไลดอนก่อ","บ้านยางอุง","บ้านยางเอือด","บ้านยางโองนอก","บ้านย่านซื่อ","บ้านย่านซื่อ มิตรภาพ 147","บ้านย่านดินแดง","บ้านย่านดู่","บ้านย่านตาขาว","บ้านย่านนางวิ่ง","บ้านย่านมะปราง","บ้านย่านมัทรี","บ้านย่านยาว","บ้านย่านยาว (ย่านยาวประชาสรรค์)","บ้านย่านสะบ้า","บ้านย่านใหญ่","บ้านย่านอุดม","บ้านยานาง","บ้านยานิง","บ้านยาบี","บ้านยาป่าแหน","บ้านยามกาโนนคำ","บ้านยามกาใหญ่","บ้านยามูเฉลิม","บ้านยายคำ","บ้านยายจั่น","บ้านยายไท","บ้านยายแพง (พิศผ่องประชานุสรณ์)","บ้านยารอ","บ้านยาแลเบาะ","บ้านยาวี-ห้วยโป่ง","บ้านย่าหมี","บ้านยี่งอ","บ้านยี่มุ่ย","บ้านยือนัง","บ้านยือริง","บ้านยือลอ","บ้านยือลาแป","บ้านชงโค","บ้านยุบตาเหน่ง","บ้านยุบพริก","บ้านยุบใหญ่","บ้านยุโป (รุ่งวิทยา)","บ้านยู้","บ้านยูงงาม","บ้านยูงทอง","บ้านเยาะ","บ้านแยง","บ้านแยงมิตรภาพที่ 146","บ้านแยประชาสรรค์","บ้านแยหนองแคน","บ้านแยะ","บ้านโยธา","บ้านโยนช้า (บุญอาจวิทยา)","บ้านร่มเกล้า","บ้านร่มเกล้า 2","บ้านร่มเกล้า 3","บ้านร่มเกล้า 4","บ้านรมณีย์","บ้านร่มไทร","บ้านร่มโพธิ์ทอง","เพียงหลวง 16 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านร่มโพธิ์ไทร","บ้านร่มเย็น","บ้านร่มเย็นวิทยา","บ้านร่มหลวง","บ้านรวงโนนไทโนนโจด","บ้านรวมใจ","บ้านร่วมใจ","บ้านร่วมใจ 1","บ้านร่วมใจ 2","บ้านรวมทรัพย์","บ้านรวมไทย","บ้านรวมมิตร","บ้านร่วมมิตร","บ้านร้อง","บ้านร้องกวาง (จันทิมาคม)","บ้านร่องกอก","บ้านร่องกะถิน","ชุมชนบ้านร่องกาศ (ศรีวิทยาคาร)","บ้านร่องกาศใต้ (รัฐราษฎร์บูรณะ)","บ้านร่องก๊อ-ม่วงคำ","บ้านร่องเก้า","บ้านร่องข่า","บ้านร้องขี้เหล็ก","บ้านร่องขุ่นป่าข่า (สุทธานุสรณ์)","บ้านร่องคตสันปูเลย","บ้านร่องค้อม","บ้านร่องคำ","ร่องคำหงส์ทองวิทยา","บ้านร่องแค (ป่าผึ้งสามัคคี)","บ้านร่องจว้าและสาขาบ้านศรีชุม","บ้านร่องจิก","บ้านร่องเจริญ","บ้านร่องช้าง","บ้านร้องเชียงแรง","บ้านร่องแช่","บ้านร่องแซง","บ้านร่องดู่","บ้านร่องแดง (ชัยมาประชารัฐอุปถัมภ์)","บ้านร้องตลาด(ประชานุเคราะห์)","บ้านร่องตาซุน","บ้านร่องตาที","บ้านร่องน้ำ","บ้านร่องโนร่องแกมคำบอน","บ้านโยนกวิทยา","บ้านร่องบง","บ้านร้องบง","บ้านร่องบัวลอย","บ้านร่องปลาขาว","บ้านร่องปอ","บ้านร่องป่าไผ่","บ้านร่องเผียว","บ้านร่องไผ่","บ้านร่องฟอง","บ้านร่องมะดูก","บ้านร่องแมด","บ้านร่องย้าง","บ้านร้องยุ้งข้าว","บ้านร่องระกำ","บ้านร้องเรือ","บ้านร้องลึก","บ้านร่องสมอ","บ้านร่องสะอาด","บ้านร่องเสี้ยว (รัฐราษฎร์ผดุงวิทย์)","บ้านร่องหวาย","บ้านร่องหอย","บ้านร่องหอยพัฒนา","บ้านร่องห้า","บ้านร่องไฮ","บ้านร่อน","บ้านร่อนทอง","บ้านรอบเมือง (คุรุรัฐประชานุสรณ์)","บ้านร้อยไร่","บ้านระกา","บ้านระกา (สนง.สลากกินแบ่งสงเคราะห์ 74)","บ้านระกาย","บ้านระกาสังแก","บ้านระกาเสม็ด","อนุบาลศีขรภูมิ","บ้านระไซร์ (เด่นพัฒนา)","บ้านระไซร์สองชั้น","บ้านระตะ","บ้านระนามพลวง (สมานราษฎร์วิทยาคาร)","บ้านระโนต (ธัญเจริญ)","บ้านระเภาว์","บ้านระมาดค้อ","บ้านระโยง","บ้านระโยงใหญ่","บ้านระเริง","บ้านระวิง","บ้านระวี","บ้านระเวิง","บ้านระเวียง","บ้านระเวียง ","บ้านระแว้ง","บ้านระหว่างควน","บ้านระหัด","บ้านระหานประชาศึกษา","บ้านระหาร","บ้านรักถิ่นไทย","บ้านรักไทย","บ้านรักแผ่นดิน","บ้านรังงาม","เพียงหลวง 15 (บ้านรังแตน) ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านรังแถว","บ้านรังนก (ประชาพิทักษ์)","บ้านรังมดแดง","บ้านรังย้อย","บ้านรังแร้ง","บ้านรัดปูน","อนุบาลรัตนบุรี (อุทิศวิทยา)","บ้านรัตนะและบ้านรัตนะ สาขาชีวังเงิน","บ้านรัตนะ","บ้านรัตนา","บ้านรันเดง","บ้านรับแพรก (คุรุราษฎร์สงเคราะห์)","บ้านรับร่อ","บ้านรั้วตะวัน","บ้านรางกระต่าย ","บ้านรางกระทุ่ม","บ้านรางกะทุ่ม","บ้านรางขาม","บ้านรางเฆ่","บ้านรางจิก","บ้านรางทอง","บ้านรางปลาหมอ","บ้านรางพยอม","บ้านรางโพธิ์","บ้านรางม่วง","บ้านรางมะเดื่อ","บ้านรางมูก","บ้านรางยอม","บ้านรางสะเดา","บ้านรางสายบัว","บ้านรางสาลี่","บ้านรางสีหมอก (โพธิ์รัฐจี่ประชาสรรค์)","บ้านรางหางม้า","บ้านรางห้าตำลึง (สายบุญเรืองราษฎร์รังสรรค์)","บ้านรางอีเม้ย (ฮงบำรุงราษฎร์)","บ้านราชกรูด","บ้านราชธานี","บ้านราชมุนี","บ้านร้านตัดผม","บ้านร้านหญ้า","บ้านรานอ","บ้านร่าปู","บ้านราม","บ้านรามง","บ้านรามราช","บ้านรามัน","บ้านรามา","บ้านราโมง","บ้านราวต้นจันทร์","บ้านราวนคร","บ้านราวรังงาม","บ้านราวอ","บ้านราไว","บ้านราษฎร์เจริญ","บ้านราษฎร์ดำเนิน","บ้านราษฎร์นิยม (จอประยูรอุปถัมภ์)","บ้านราษฎร์บำรุง","บ้านราษฎร์ประดิษฐ์","บ้านราษฎร์ประสานจิต","บ้านราษฎร์พัฒนา","บ้านราษฎร์รักแดน","บ้านราษฎร์สามัคคี","บ้านราษฎร์อุปถัมภ์","บ้านราษฎร์ภักดี","บ้านราษฏร์สงวน","บ้านร่าหมาด","บ้านราหุล","บ้านริแง","บ้านรินหลวง","บ้านริมกก","บ้านริมใต้","บ้านริมทะเล","บ้านริมลาว","ริมวัง 1","ริมวัง 2","บ้านรือเปาะ","บ้านรือเสาะ","บ้านรุง","บ้านรุ่ง","บ้านรุ่งอรุณ (กองทัพบกอุปถัมภ์)","บ้านรุน","บ้านรูสะมิแล","บ้านเราะ (อุทัยประชาสรรค์)","บ้านเริงรมย์","บ้านเรียงกระดก","บ้านเรียม","บ้านเรือ","บ้านเรือง","บ้านเรืองชัย","บ้านเรือทองคลองคำ","บ้านแร่","บ้านโรงเข้","บ้านโรงช้างวิทยา","บ้านโรงวัว","บ้านโรงหม้อมิตรภาพที่ 75","บ้านโรงหีบ","บ้านโรงเหล็ก","บ้านไร่","บ้านไร่/สันป่าสัก","บ้านไร่ (ประชาสามัคคี)","บ้านไร่ (ตระเวนชายแดนอนุสรณ์)","บ้านไร่โนนสำราญ","บ้านไร่ (ทองคูณคุรุราษฎร์สามัคคี)","บ้านไร่ (สำนักงานสลากกินแบ่งสงเคราะห์ 155)","บ้านไร่เก่า","บ้านไร่เก่าสามร้อยยอด","บ้านไร่ขอนยางขวาง","บ้านไร่ขี","บ้านไร่โคก (อินทร์ประชาสรรค์)","บ้านไร่โคกหนองปรือ (ประสมทรัพย์อนุสรณ์)","บ้านไร่จันดี","บ้านไร่เจริญ","บ้านไร่ดง","บ้านไร่ดอน","บ้านไร่ดอน (อินทโชติวิริยานุสรณ์)","บ้านไร่ดอนแตง","บ้านไร่ต้นสำโรง","บ้านไร่ตาพุฒ","บ้านไร่ตีนตก","บ้านไร่ใต้","บ้านไร่ถิ่นน้อย (อาจอำรุง)","บ้านไร่ทรัพย์เจริญ","บ้านไร่ทาม","บ้านไร่ไทรทองพระยาลับแล","บ้านไร่นางาม","บ้านไร่นาดี","บ้านไร่น้ำหิน","บ้านไร่ใน","บ้านไร่บน","บ้านไร่บนสามัคคี","บ้านไร่บ้านไฮ่","บ้านไร่ประชาสรรค์","บ้านไร่ป่า","บ้านไร่ป้า","บ้านไร่ป่าไม้แดงวิทยา","บ้านไร่ฝาย","บ้านไร่พญา","บ้านไร่พรุ","บ้านไร่พวย มิตรภาพที่ 18","บ้านไร่พัฒนา","บ้านไร่พัฒนา (ราษฎร์บูรณะวิทยา)","บ้านไร่พิทยาคม","บ้านไร่มุสลิม","บ้านไร่ยาว","บ้านไร่ร่วมวิทยาคาร","บ้านไร่ลำปาง","บ้านไร่วิทยา","บ้านไร่ศรัทธาราษฎร์","บ้านไร่ศรีอุบล","บ้านไร่สมบูรณ์","บ้านไร่สามศรี","บ้านไร่สุขสันต์","บ้านไร่สุขสันต์และสาขาบ้านห้วยส้มป่อย","บ้านไร่เสธ์","บ้านไร่หลวง","บ้านไร่ห้วยพี้","บ้านไร่เหนือ","บ้านไร่แหลมทอง","บ้านไร่ใหญ่","บ้านไร่ใหม่","บ้านไร่ใหม่พัฒนา","บ้านไร่ใหหลำ","บ้านไร่ออก","บ้านไร่อ้อย","บ้านฤกษ์อุดมอู่สะเภา","บ้านลดา","บ้านลวงเหนือ","บ้านล้อง","บ้านลอง (ฟองจันทร์ราษฎร์อุปถัมภ์)","บ้านล่องควน","บ้านล้องเครือกวาว","บ้านลองตอง","บ้านล้องหนองหอย","บ้านล้องอ้อ","บ้านล้อแตก","บ้านลอมคอม","บ้านล่อมเสือโฮก","บ้านละกอ","บ้านละทาย","บ้านละเบิกตาฮีง","บ้านละมงค์","บ้านละมุ","บ้านละลม","บ้านละลมติม (จิตรพลานุสนธิ์)","บ้านละลมพนู","บ้านละลมโพธิ์","บ้านละลมระไซ","บ้านละลายมีชัย","บ้านละลูน","บ้านละเลิงพิมาน","บ้านละเลิงหิน","บ้านละว้า","บ้านละว้าวังควาย","บ้านละเวง","บ้านละเวี้ย (แปลงคุรุราษฎร์บำรุง)","บ้านละโว้","บ้านละหอกกระสัง","บ้านละหอกตะแบง","บ้านละหาน","บ้านละหาน (อภิรักษ์วิทยา)","บ้านละหานค่าย","บ้านละหานทราย (คุรุราษฎร์บำรุงวิทยา)","บ้านละหานทรายเก่า","บ้านละหานทรายใหม่","บ้านละหานนา","บ้านละหานสามัคคี","บ้านละหาร","บ้านละหารยามู","บ้านละหุ่งหนองกก","บ้านละออง","บ้านละอุ่นใต้","บ้านละอูบ","บ้านละเอาะ","บ้านละแอ","บ้านลังกา","บ้านลังกาประชาสรรค์","บ้านลังโกม","เทศบาล 1","บ้านลันแต้","บ้านลากชาย","บ้านลากอ","บ้านลางสาด","บ้านลางา","บ้านลาด","บ้านลาด (ประชาราษฎร์บำรุง)","บ้านลาด (ราษฎร์บำรุง)","บ้านลาดกระทิง","บ้านลาดกะเฌอ ","บ้านลาดเก่า","บ้านลาดควาย","บ้านลาดค้อ","บ้านลาดค่าง","บ้านลาดคื้อ","บ้านลาดแค","บ้านลาดช้าง (ระคนกิจศึกษา)","บ้านลาดชุมพล","บ้านลาดตะกุด (สูงทองกาญจนาประชานุสรณ์)","บ้านลาดใต้","บ้านลาดไทรงาม","บ้านลาดน้อย","บ้านลาดนาเพียง","บ้านลาดบัวขาว","บ้านลาดผักหนาม","บ้านลาดโพธิ์ (สุทธิราษฎร์รังสรรค์)","บ้านลาดวารี","บ้านลาดวิถี","บ้านลาดวิทยาเสริม","บ้านลาดสมดี","บ้านลาดสระบัวหนองลุมพุกวิทยา","บ้านลาดหญ้าคา","บ้านลาดหอคำ","บ้านลาดเหนือ","บ้านลาดใหญ่","บ้านลาดใหญ่สามัคคี","บ้านลาน","บ้านลานกระทิง","บ้านลานกระบือ","บ้านลานข่อย","บ้านลานเข้","บ้านลานควาย","บ้านลานคา","บ้านลานช้าง","บ้านลานช้างมิตรภาพ 45","บ้านลานช้างท่าว","บ้านลานดอกไม้","บ้านลานตะแบก","บ้านลานตาบัว","บ้านลานตาเมือง","บ้านลานเต็ง","บ้านลานทอง","บ้านลานนา","บ้านลานบ่า","บ้านลานไผ่","บ้านลานมะคร้อ","บ้านลานสะเดา","บ้านลานสาง","บ้านลานห้วยเดื่อ","บ้านลานหิน","บ้านลานแหลม (สรนุวัตรราษฎร์อุทิศ)","บ้านลานเอื้อง","บ้านลาเมาะ","บ้านลาเมาะฮีเล","บ้านลาไม","บ้านลาแล","บ้านลาเวง","บ้านลาหงา","บ้านละอาร์","บ้านลําอีซู","บ้านลำแก่น","บ้านลำโกฏิทอง","บ้านลำโกน (คุรุรัฐราษฎร์พัฒนา)","บ้านลำคลอง","บ้านลำคลองยาง","บ้านลำแคลง","บ้านล้ำเจริญ","บ้านลำช้าง","บ้านลำชี","บ้านลำชี (วุฒิวงษ์ราษฎร์สงเคราะห์)","บ้านลำเชิงไกร","บ้านลำโชค","บ้านลำไซกง","บ้านลำดวน","อนุบาลลำดวน (สุรพินท์ราษฎร์นุสรณ์)","บ้านลำดวน (เมยราษฎร์อุปถัมภ์)","บ้านลำดวนพัฒนา","บ้านลำแดง","บ้านลำตะคร้อ","บ้านลำตาเณร","บ้านลำทองหลาง","บ้านลำทะเมนชัย","บ้านลำทับ","บ้านลำท่าโพ","บ้านลำนางแก้ว","บ้านลำนางรอง","บ้านลำนารวย","บ้านลำปลอกเหนือ","บ้านลำปางกลาง","บ้านลำป่าสักมูล","บ้านลำปี (พิบูลสงครามอุปถัมภ์)","บ้านลำเปา","บ้านลำโป่งเพชร","บ้านลำพญากลาง","บ้านลำพยนต์","บ้านลำพยา","บ้านลำพระ","บ้านลำพาด","บ้านลำพิกุล","บ้านลำพุก","บ้านลำเพิญ (อรุณราษฎร์สงเคราะห์)","บ้านลำเพียก","บ้านลำแพะ","บ้านลำไพล","บ้านลำภาศ","บ้านลำภู","บ้านลำภูรา","บ้านลำมะโกรก","บ้านลำเลียง","บ้านลำวะ","บ้านลำสนธิ","บ้านลำสมพุง","บ้านลำหัก","บ้านลำหาด","บ้านลิกี","บ้านลิงไอ","บ้านลิ้นช้าง","บ้านลิ่นถิ่น","บ้านลิ้นฟ้า","บ้านลิพอน","บ้านลิพัง","บ้านเขาติง","บ้านลิมุด (บุญชอบ สาครินทร์)","บ้านลีตอ","บ้านลึมบอง","บ้านลือชัยโนนศรีไคลร่องน้ำคำ","บ้านลือนาคำ","บ้านลือเน็ง","บ้านลือมุ","บ้านลุงขี้หนู","บ้านลุงเขว้า","บ้านลุงตามัน","บ้านลุงท่าเจริญ","บ้านลุงประดู่","บ้านลุงปุง","บ้านลุงพลู","บ้านลุงม่วง","บ้านลุโบะปาเระ","บ้านลุ่มชุมแสง","บ้านลุ่มผึ้ง","บ้านลุมพุก (จันทรศึกษา)","บ้านลุมพุก","บ้านลุมพุกคลองแก้ว","บ้านลุมพุกคูวงศ์","บ้านลุมพุกหนองกุง","บ้านลุมภู","บ้านลู (คัมภีร์ราษฎร์บำรุง)","บ้านลูกเดือน","บ้านลูโบ๊ะกาเยาะ","บ้านลูโบ๊ะซามา","บ้านลุโบะดาโต๊ะ","บ้านลูโบะดีแย","บ้านลูโบ๊ะบาตู","บ้านลุโบะบายะ","บ้านลูโบะบูโละ","บ้านลูโบ๊ะปันยัง","บ้านลูโบ๊ะเยาะ","บ้านลูโบะลือซง","บ้านเลโคะ","บ้านเล็บกะรอก","บ้านเล็บเงือก","บ้านเลยวังไสย์","บ้านเลา","บ้านเล้า","บ้านเล่า (ประชานุเคราะห์)","บ้านเล้าข้าว","บ้านเลาลี","บ้านเล่าวิทยาคาร","บ้านเล้าวิทยาคาร","บ้านเลาสู","บ้านเลาะ","บ้านเลิง","บ้านเลิงคา","บ้านเลิงใต้","บ้านเลิงทุ่ม","บ้านเลิงบ่อ","บ้านเลิงบัว","บ้านเลิงบาก","บ้านเลิงแฝกโพนทองพัฒนา","บ้านเลิงแฝกบัวแก้ว","บ้านเลิงแสง","บ้านเลิศสวัสดิ์(ราษฎร์รังสรรค์วิทยา)","บ้านเลิศอรุณ","บ้านเลียบ","บ้านเลี่ยมพิลึก","บ้านเลี้ยว","บ้านเลื่อม","บ้านแลแวะ","บ้านโลทู","บ้านโละ","บ้านโล๊ะป่าตุ้ม","บ้านวงฆ้อง","วัดวงฆ้อง (ราษฎร์สุริยศึกษา)","บ้านวงศ์ษาพัฒนา","บ้านวนท่าแครง","บ้านวนาหลวง","บ้านวัง","บ้านวัง (สายอนุกูล)","บ้านวังกกเดื่อ","บ้านวังก้นหวด","บ้านวังก์พง (รัฐราษฏร์บำรุง)","บ้านวังกระแจะ","บ้านวังกระดี่ทอง","บ้านวังกระโดน","บ้านวังกระโดนน้อย","บ้านวังกระโดนใหญ่","บ้านวังกระสวย","บ้านวังกระแส","บ้านวังกร่าง","บ้านวังกวาง","บ้านวังกว้าง","บ้านวังกอง","บ้านวังกะทะ","บ้านวังกะเบา","บ้านวังกะพ้อ ","บ้านวังก้านเหลือง","บ้านวังกำแพง","บ้านวังกุง","บ้านวังกุ่ม","บ้านวังเกษตร","บ้านวังเกิ้ง","บ้านวังขวัญ","บ้านวังขวาก","บ้านวังขอน","บ้านวังขอนขว้าง","บ้านวังขอนดู่","บ้านวังขอนแดง","บ้านวังขอนแดงหนองหญ้าปล้อง","บ้านวังขอนป่าไผ่","บ้านวังขอนพาดหนองแวง","บ้านวังขอนมิตรภาพที่ 137","บ้านวังขอนสัก","บ้านวังข่อย","บ้านวังขาม","บ้านวังขุม","บ้านวังเข","บ้านวังแข้","บ้านวังแขม","บ้านวังแขม (สว่างชัยวงษ์)","บ้านวังโขน","บ้านวังคกอูบมุง","บ้านวังคมคาย","บ้านวังค้อ","บ้านวังคอไห (สงฆ์ประชาชนูทิศ)","บ้านวังคาง","บ้านวังคางฮูง","บ้านวังคู","บ้านวังคูณ","บ้านวังเค็มใหม่","บ้านวังแคน","บ้านวังแคนวังคูณวิทยา","บ้านวังโค้ง","บ้านวังโคนเปือย","บ้านวังโคนไผ่","บ้านวังไคร้มิตรภาพที่ 102","บ้านวังจรเข้","บ้านวังจั่น","บ้านวังจาน","บ้านวังจานโนนสำราญ","บ้านวังเจริญ","บ้านวังเจ้า","อนุบาลวังเจ้า","บ้านวังชมภู","บ้านวังชะนาง","บ้านวังชะโอน","บ้านวังชัย","บ้านวังช้าง","บ้านวังช้าง (ธีรราษฎร์รังสฤษฏ์)","บ้านวังชิ้น","บ้านวังชุมพร","บ้านวังแช่กลอย","บ้านวังไชย","บ้านวังซอง","บ้านวังซ่าน","บ้านวังด้ง","บ้านวังดารา","บ้านวังดิน","บ้านวังดิน (วังดินราษฎร์บำรุง)","บ้านวังดินสอ","บ้านวังดินเหนียว","บ้านวังเดือนห้า","บ้านวังแดง","บ้านวังแดง (สหจิตวิทยาคาร)","บ้านวังแดง (หมู่สองสามัคคี)","บ้านวังแดด","บ้านวังตง","บ้านวังตม","บ้านวังตลับ","บ้านวังตอสามัคคี","บ้านวังตะกู","บ้านวังตะโก","บ้านวังตะคร้อ","บ้านวังตะคร้อ (ธนาคารกรุงเทพ 5)","บ้านวังตะเคียน","บ้านวังตะเคียน (ขยันการนาวีราษฎร์อุทิศ)","บ้านวังตะเฆ่","บ้านวังตะแบก","บ้านวังตะล่อม","บ้านวังตัก","บ้านวังตาช่วย","บ้านวังตาดราษฎร์อุทิศ","บ้านวังตาท้าว","บ้านวังตาเทพ","บ้านวังตามน (น้อยประชาสรรค์)","บ้านวังตามัว","บ้านวังตายศ ","บ้านวังตาลาดสมบูรณ์","บ้านวังตาว","บ้านวังตาอินทร์","บ้านวังตำลึง","บ้านวังเตย","บ้านวังเต่า","บ้านวังถ้ำ","อนุบาลวังทรายพูน","บ้านวังทอง","ชุมชนวังทอง","บ้านวังทองแดง","บ้านวังทองประชานุกูล","บ้านวังทองราษฎร์สามัคคี","บ้านวังทองสามัคคี","บ้านวังทะลุ","บ้านวังทับเกวียน","บ้านวังทับไทร","บ้านวังทับยา","บ้านวังท่าดี","บ้านวังเทโพ","บ้านวังแท่น","บ้านวังไทร","บ้านวังไทรทอง","บ้านวังธน","บ้านวังธาร","บ้านวังนกแอ่น","บ้านวังนอง","บ้านวังน้อย","บ้านวังนางนวล","บ้านวังน้ำ","บ้านวังน้ำขาว","บ้านวังน้ำขาวชนูปถัมภ์","บ้านวังน้ำเขียว","บ้านวังน้ำซึม","บ้านวังน้ำแดง","บ้านวังน้ำพัฒนา","บ้านวังน้ำพัฒนา สาขาบ้านบ่อหิน","บ้านวังน้ำมอก","บ้านวังน้ำลัด","บ้านวังน้ำหยาด","บ้านวังบง","บ้านวังบงค์","บ้านวังบวบ","บ้านวังบ่อ (ราษฎร์เจริญ)","บ้านวังบอน","บ้านวังบัว","บ้านวังบัวทอง","บ้านวังบัวสามัคคีวิทยา","บ้านวังบาล","บ้านวังบูรพา","บ้านวังเบน (ภูธรอุปถัมภ์)","บ้านวังเบอะ","บ้านวังโบสถ์","บ้านวังประจบ","บ้านวังประจัน","บ้านวังประดา","บ้านวังประดู่","บ้านวังปรากฏ (ประชานุกูล)","บ้านวังปริง","บ้านวังปลัด","บ้านวังปลา","บ้านวังปลาช่อน","บ้านวังปลาเซือม","บ้านวังปลาโด","ชุมชนวังปลาป้อมวิทยศึกษา","บ้านวังปลาฝา","บ้านวังปลาหมู","บ้านวังปากบุ่ง","บ้านวังปึ้ง","บ้านวังปืน","บ้านวังเป่ง","บ้านวังโป่ง","บ้านวังโป่ง (ประชาบำรุง)","บ้านวังโป่งท่าวังแคน","บ้านวังโป่งพัฒนา","บ้านวังโปร่ง","บ้านวังผักแว่น","บ้านวังวิทยา","บ้านวังผา","บ้านวังผาง","บ้านวังผาตาด","บ้านวังผาลาด","บ้านวังผือขามป้อม","บ้านวังไผ่","บ้านวังไผ่ป่าจั่น","บ้านวังพง","บ้านวังพญา","บ้านวังพรม","บ้านวังพระเคียน","บ้านวังพระวังไฮ","บ้านวังพร้าว","บ้านวังพร้าว-สบเรียง","บ้านวังพลับ","บ้านวังพลาย","บ้านวังพอก","บ้านวังพะเนียด","บ้านวังพา","บ้านวังพิกุล","บ้านวังเพลิง","บ้านวังโพ","บ้านวังโพธิ์","บ้านวังโพน","บ้านวังโพนคึมน้ำเกลี้ยง","บ้านวังโพรง","บ้านวังฟ่อน (สิทธิราษฎร์บำรุง)","บ้านวังแฟน","บ้านวังไฟไหม้","บ้านวังมน","บ้านวังมนเดือยไก่","บ้านวังมล","บ้านวังม่วง","บ้านวังม่วย","บ้านวังมะกรูด","บ้านวังมะค่า","บ้านวังมะเดื่อ","บ้านวังมะริว","บ้านวังไม้แดง","บ้านวังไม้ตอก","บ้านวังไม้ส้าน","บ้านวังยวน","บ้านวังยาง","บ้านวังยาง (ราษฎร์สามัคคี)","บ้านวังยาง (วังยางวิทยานุกูล)","บ้านวังยายทอง","บ้านวังยายมาก","บ้านวังยาว","บ้านวังยาววิทยายน","บ้านวังยาวสามัคคี","บ้านวังยิ้มแย้ม","บ้านวังเย็น","บ้านวังเยี่ยม","บ้านวังรวก","บ้านวังร่อง","บ้านวังรัก","บ้านวังราง","บ้านวังรางน้อย","บ้านวังรี","บ้านวังรู (เฉลิมรัฐวิทยาคาร)","บ้านวังแร่","บ้านวังแรง","บ้านวังโรงน้อย","บ้านวังโรงใหญ่สามัคคี","บ้านวังล้อมรำลึก","บ้านวังลาน","บ้านวังลานวังทอง","บ้านวังลาว","บ้านวังลำ","บ้านวังลึก","บ้านวังลึก (ยุวนาฏชนูทิศ)","บ้านวังลุง (เพชรประชานุเคราะห์)","บ้านวังลุง","วัดรายชะโดบ้านวังลูกช้าง","บ้านวังเลาโสมสวรรค์","บ้านวังเลาหัวฝาย","บ้านวังเลียง","บ้านวังไลย์","บ้านวังวน","บ้านวังวน (ชูชีพ-สนิทพลอยน้อยอุปถัมภ์)","บ้านวังวน (ราษฎร์พิทยา)","บ้านวังวัว","บ้านวังว้า","บ้านวังเวิน","บ้านวังเวินกุดหล่ม","บ้านวังเวินพัฒนา","บ้านวังเวียง","บ้านวังศรี","บ้านวังศาล","บ้านวังศิลา","บ้านวังสนวน","บ้านวังสมบูรณ์","บ้านวังสวย","บ้านวังสวาบ","บ้านวังสะพุง","บ้านวังสะโม","บ้านวังสายทอง","บ้านวังสาร","บ้านวังสารภี","บ้านวังสำราญ","บ้านวังสำลี","บ้านวังสิงห์","บ้านวังสิม","บ้านวังสีสด","บ้านวังเสมา (พินิจอนุสรณ์)","บ้านวังแสง","บ้านวังใส","บ้านวังหงส์ (วังหงส์วิทยาคาร)","บ้านวังหมอ","บ้านวังหม้อ","บ้านวังหมี","บ้านวังหมื่น","บ้านวังหรัง (ประสิทธิ์อุปถัมภ์)","บ้านวังหลวง","บ้านวังหลวง (วังมาประชาสามัคคี)","บ้านวังหว้า","วังหวายวิทยาคม","บ้านวังหวาย","บ้านวังหอน","บ้านวังหันน้ำดึง","บ้านวังหัวดอย","บ้านวังหัวเรือ","บ้านวังหัวแหวนพัฒนา","บ้านวังหาด","บ้านวังหามแห","บ้านวังหินเก่าค้อ","ชุมชนวังหิน","บ้านวังหิน (มั่นภักดีอุปถัมภ์)","บ้านวังหิน","บ้านวังหินซอง","บ้านวังหินซา","บ้านวังหินโนนสว่าง","วังหินลาดวังเจริญ","วังหูกวางราษฎร์ผดุงวิทย์","บ้านวังเหว","บ้านวังใหญ่","บ้านวังใหญ่ (ราษฎร์บำรุง)","บ้านวังใหญ่ปลายรํา","บ้านวังใหม่ (ประชาอุทิศ 2519)","บ้านวังไหโนนสมบูรณ์","บ้านวังอ้อ","บ้านวังอ้อ (ยอดสังข์วิทยา)","บ้านวังอ่าง","บ้านวังอาบช้างมิตรภาพที่ 141","บ้านวังอ้ายคง","บ้านวังอ้ายจีด","บ้านวังอีแอ่น","บ้านวังฮาง","บ้านวังไฮวังทอง","บ้านวังไฮ","บ้านวังไฮหนองกุง","บ้านวัฒนา","บ้านวัดใน","บ้านวัดโบสถ์","บ้านวัดโบสถ์(บำรุงวุฒิวิทยา)","วัดร่อน","บ้านวัดหลวง","บ้านวัดใหม่","บ้านวัวแดง","บ้านว่าน","บ้านว่านเขื่อนค้อวิทยา","บ้านว่านบ้านด่าน","อนุบาลวานรนิวาส (ราษฎร์บำรุง)","บ้านวาน้อย","บ้านวาปี","บ้านวารไพรศรี","วารีสวัสดิ์วิทยา","บ้านวารีสีสุก","บ้านวารีอุดม","บ้านวาเล่ย์","บ้านวาวี","บ้านวาใหญ่","บ้านวิจิตรพัฒนา","บ้านเวฬุวัน","บ้านเว่อวิทยานุกูล","บ้านเวาะ","บ้านเวาะวิทยาคม","บ้านเวินชัยคุรุราษฏร์บำรุง","บ้านเวินบึก","บ้านเวินพระบาท","บ้านเวินร่องถ่อนสามัคคี","บ้านเวียง","บ้านเวียง (ตุอุปถัมภ์)","บ้านเวียง (เวียงราษฎร์บำรุง)","บ้านเวียงกลาง","บ้านเวียงกือนา","บ้านเวียงแก้ว","เวียงแก้ววิทยา","บ้านเวียงคุก","บ้านเวียงชัย","บ้านเวียงเดิม","บ้านเวียงตั้ง (คำวรรธประชานุกูล)","บ้านเวียงทอง (เวียงทองวิทยาคาร)","บ้านเวียงฝาง","บ้านเวียงพาน","บ้านเวียงยอง","บ้านเวียงสอง","บ้านเวียงสา","บ้านเวียงหมอก","บ้านเวียงหลวง","บ้านเวียงหวาย","บ้านเวียงเหนือ","บ้านเวียงแหง","บ้านเวียย","บ้านแวง","บ้านแวงวังเซียม","บ้านแว้ง","บ้านแวงชัยโคกหนองโจด","บ้านแวงดงหนองยาง","บ้านแวงนคร (สังฆวิทยา)","บ้านแวงน้อย","บ้านแวงโนนเปือยหนองแสง","บ้านแวงประชารัฐบำรุง","บ้านแวงยางกุดตะเข้","บ้านแวงวิทยา","บ้านแวงเหล่าเก่าน้อย","บ้านแวด","บ้านแวนโค้ง","บ้านโว้งบ่อ","บ้านศรัทธาตะพง","บ้านศรีกองงาม","บ้านศรีเกษตรพัฒนา","บ้านศรีเกิด","บ้านศรีแก้ว","บ้านศรีไกรลาศ","บ้านศรีขวัญเมือง","บ้านศรีคุณ (คุรุประชาวิทยา)","บ้านศรีงาม","บ้านศรีเจริญทอง","บ้านศรีชมภู","บ้านศรีชัยคราม","บ้านศรีชมชื่นบุญชิตวิทยา","บ้านศรีเชียงใหม่","บ้านศรีณรงค์","บ้านศรีดอนชัย","บ้านศรีดอนไชย(ประชานุกูล)","วัดศรีดอนตัน","บ้านศรีดอนมูล","บ้านศรีตะวัน (ราษฎร์สามัคคี)","บ้านศรีเตี้ย","บ้านศรีถาวร","บ้านศรีทรายมูล","บ้านศรีทอง","บ้านศรีทองสามัคคี","บ้านศรีท่าน้ำ","บ้านศรีเทพน้อย","บ้านศรีธน","บ้านศรีธนู","บ้านศรีนคร","บ้านศรีนวล","บ้านศรีนาป่าน","บ้านศรีนาม่าน","บ้านศรีนาวา","บ้านศรีนิมิต","บ้านศรีบัว","บ้านศรีบุญยืน-วังทอง","บ้านศรีบุญเรือง","ชุมชนศรีบุญเรือง","บ้านศรีปทุมวัลย์","บ้านศรีประชา","บ้านศรีป่าแดง","บ้านศรีป้าน","บ้านศรีพงัน","บ้านศรีพนม","บ้านศรีพระยาราษฎร์บำรุง","บ้านศรีไพศาล","บ้านศรีภูมิ","บ้านศรีภูมิสามัคคี","บ้านศรีมงคล","บ้านศรีม่วงแดง","บ้านศรีมูลเมือง","บ้านศรีมูลเรือง (วัลลภราษฎร์รังสรรค์)","บ้านศรีเมือง","บ้านศรีเมืองชุม","บ้านศรีเมืองใหม่","บ้านศรีย้อย","บ้านศรีรักษา","บ้านศรีราชา","บ้านศรีวิชัย","บ้านศรีวิชา ","บ้านศรีวิไลท่าสวนยา","บ้านศรีเวินชัย","บ้านศรีเวียง","บ้านศรีศรัทธามิตรภาพที่ 176","ศรีศึกษา","วัดศีรษะกระบือ","บ้านศรีสมเด็จ","บ้านศรีสมบูรณ์","บ้านศรีสมบูรณ์พัฒนา","บ้านศรีสมบูรณ์แหลมทอง","บ้านศรีสวรรค์","ศรีสว่าง","บ้านศรีสว่าง","บ้านศรีสว่างพัฒนา","บ้านศรีสวาย","บ้านศรีสะอาด","บ้านศรีสิทธิ์ (ใจมาอนุเคราะห์)","บ้านศรีสุข","บ้านศรีสุข (คุรุราษฎร์สามัคคี)","บ้านศรีสุขนาล้อม","บ้านศรีสุขสำราญ","บ้านศรีสุพรรณ","บ้านศรีสุวรรณโพนสว่าง","บ้านศรีหมวดเกล้า","บ้านศรีอรุณ","บ้านศรีอุดมซำตารมย์","บ้านศรีอุดมธัญญะ","บ้านศรีอุบลพัฒนา","บ้านศาลเจ้าไก่ต่อ","บ้านศาลเจ้าพ่อ","บ้านศาลา","บ้านศาลาแก้ว","บ้านศาลาไก่ฟุบ","บ้านศาลาคลอง","บ้านศาลาด่าน","บ้านศาลาดิน","บ้านศาลาดินห้วยเตย","บ้านศาลาตะเคียน","บ้านศาลาทวดทอง","บ้านศาลาน้อย","บ้านศาลาน้ำ","บ้านศาลาประปุน","บ้านศาลาพระม่วง","บ้านศาลาแม่ทา","บ้านศาลาลอย","บ้านศาลาลัย","บ้านศาลาลาย","บ้านศาลาลำดวน","บ้านศาลาลูกไก่","บ้านศาลาสอง","บ้านศาลาสามัคคี","บ้านศาลาหนองขอน","บ้านศาลาใหม่","บ้านศาลาอูมา","บ้านศิริพัฒน์","บ้านศิริพัฒนา","บ้านศิลา","บ้านศิลางาม","บ้านศิลาทอง","บ้านศิลานาโพธิ์","บ้านศิลาร่วมสามัคคี","บ้านศิวาลัย","บ้านศีรษะกระบือ (อิสระคุรุราษฎร์)","บ้านศุภชัย","บ้านศูนย์กลาง","บ้านศูนย์ไหม","บ้านเศรษฐี","บ้านเศลาใต้","บ้านโศกกะฐิน","บ้านโศกขามป้อม","บ้านโศกน้อย","บ้านโศกนาคท่าม่วง","บ้านสกร็อม (ประสาทศีลสามัคคี)","บ้านสกล","บ้านสกาดใต้","บ้านสกุล","บ้านสงแคน","บ้านสงป่าเปลือย","บ้านสงเปลือย","บ้านสงเปลือยโพธิ์สระแก้ว","บ้านสงเปลือย (ประชาราษฎร์บำรุง)","บ้านสงเปลือยดงสามสิบ","บ้านสงเปือย","บ้านส้งเปือย","บ้านสงเปือยเหนือ","บ้านสงเปือยฮ่องเดื่อ","บ้านสงยาง","บ้านสงยางดอนไม้คูณ","บ้านสงยางนาตากล้า","บ้านสงาว","บ้านสดอ","บ้านสดำ","บ้านสตึก","บ้านสถาน","บ้านสน","บ้านสนกลาง","บ้านสนบ","บ้านสนวน","บ้านสนวน ","บ้านสนวนนางแก้ว","บ้านสนาม","บ้านสนามชัย","บ้านสนามชัย (พิมพ์ประชานุกูล)","บ้านสนามบิน","บ้านสนามบิน (ประชาศึกษา)","บ้านสนามสามัคคีสโมสรโรตารี่ 2","บ้านสนาย","บ้านสบกอน","บ้านสบขาม","บ้านสบขุ่น","บ้านสบค่อม","บ้านสบคาบ และสาขาแก่งปันเต๊า","บ้านสบคำ","บ้านสบแจ่มฝั่งซ้าย","บ้านสบเติ๋น","บ้านสบเตี๊ยะ และบ้านทุ่งปูน","บ้านสบทุ ","บ้านสบบง","บ้านสบป่อง","บ้านสบป้าก","สบป้าดวิทยา","บ้านสบปืน","บ้านสบเป็ด","บ้านสบแปะ","บ้านสบพลึง","บ้านสบแพม","บ้านสบฟ้า","บ้านสบมาง","บ้านสบเมย","บ้านสบแม่รวม","บ้านสบยม (น้อมมิตรอนุกูล)","บ้านสบยาง","บ้านสบรวก","บ้านสบลาน","บ้านสบลี","บ้านสบวาก","บ้านสบสอย","บ้านสบสา","บ้านสบสาย","บ้านสบสาย (จันทร์พัฒน์ประชาสรรค์)","บ้านสบหนอง","บ้านสบหาร","บ้านสบาย","บ้านส้มกบ (รัฐราษฎร์บำรุง)","บ้านส้มกบงาม","บ้านสมจิต","บ้านสมดี","บ้านสมเด็จเจ้าพระยาอุปถัมภ์","บ้านสมบัติเจริญ","บ้านสมบูรณ์","บ้านสมบูรณ์ (เบญจานุเคราะห์)","บ้านสมบูรณ์ (ปัญจวิทยา)","บ้านส้มป่อย","บ้านส้มป่อย ","บ้านส้มป่อยค่ายเมืองแสน","บ้านส้มป่อยศรีวิศรมิตรภาพที่ 161","บ้านส้มป่อย (ส้มป่อยวิทยาเสริม)","บ้านส้มผ่อ","บ้านสมพรรัตน์","บ้านส้มมิตรภาพที่ 93","บ้านส้มเลา","บ้านสมวิไล","บ้านสมศรี","บ้านสมศรีมะแปบประชาบำรุง","บ้านสมสนุก","บ้านสมสนุกดงหนองบอน","บ้านสมสะอาด","บ้านสมสะอาดเนินกุง","บ้านสมสะอาดหนองแวง","บ้านสมอ","บ้านสมอโคน","บ้านสม็อง","บ้านสมอทอง","บ้านส้มโฮง","บ้านสมัย","บ้านสมานมิตร","บ้านสมาหอ","บ้านสมุด","บ้านสรรเสริญ","บ้านสรศรี","บ้านสร้อย (ประชารัฐรังสรรค์)","บ้านสร้อยพร้าว","บ้านสร้อยศรี","บ้านสระ","วัดบ้านสระ","บ้านสระกรวด","บ้านสระกระโจม","บ้านสระกอไทร","บ้านสระกุด","บ้านสระเกตุโมรี","บ้านสระเกษ","บ้านสระแก้ว","บ้านสระแก้วเจริญศิลป์","บ้านสระแก้วประชาสรรค์","บ้านสระแก้วหนองคู","บ้านสระขาม","บ้านสระขี้ตุ่น","บ้านสระขุด","บ้านสระครก","บ้านสระคลองพัฒนา","บ้านสระคำ","บ้านสระคูณ ","บ้านสระแคน","บ้านสระงาม","วัดสระจรเข้","บ้านสระจันทอง","บ้านสระแจง","บ้านสระซาง","บ้านสระดอกเกษ","บ้านสระตอง","บ้านสระตะเคียน","บ้านสระตะเฆ่","บ้านสระตาพรม","บ้านสระเตย","บ้านสระเตยพัฒนา","บ้านสระแต้","บ้านสระทอง","บ้านสระนอก","บ้านสระนา","บ้านสระนางมโนราห์","บ้านสระนารายณ์","บ้านสระน้ำส้ม","บ้านสระบรเพ็ด","บ้านสระบัว","บ้านสระบัวก่ำ","บ้านสระบัวทอง","บ้านสระบาก","บ้านสระบานสามัคคี","บ้านสระประดู่","บ้านสระประดู่หนองมะค่า","บ้านสระประทีป","บ้านสระปะคำถาวร","บ้านสระผักโพด","บ้านสระพระ","บ้านสระพัง","บ้านสระพังข่า","บ้านสระเพลง","บ้านสระโพนทอง","บ้านสระภู","บ้านสระมะค่า","บ้านสระมาลา","บ้านสระไม้แดง","วัดสระลงเรือ","บ้านสระละมาน","บ้านสระลำใย","บ้านสระลุมพุก","บ้านสระว่านพระยา","บ้านสระเศรษฐี","บ้านสระสมิง","บ้านสระสะแก","บ้านสระสาลี","บ้านสระสิงห์โต","บ้านสระสี่เหลี่ยม","บ้านสระหมื่นเชียง","บ้านสระหลวง","บ้านสระห้วยยางอุปถัมภ์","บ้านสระใหญ่","บ้านสร้าง (สำริต ภู่เงินอนุสรณ์)","บ้านสร้างก่อ","บ้านสร้างแก้ว","สร้างแก้วอ่างคำค้อ อำนวยวิทย์","บ้านสร้างแก้วราษฎร์พัฒนา","บ้านสร้างขุ่ย","บ้านสร้างคำ","บ้านสร้างช้างไผ่หนองไร่มิตรภาพที่ 143","บ้านสร้างแซ่งวังถั่ว","บ้านสร้างแต้นาประเสริฐ","บ้านสร้างถ่อ","สร้างนกทาดอนหวาย","บ้านสร้างนางขาว","บ้านสร้างบก","บ้านสร้างบาก","บ้านสร้างปี่","บ้านสร้างแป้น","บ้านสร้างแป้นดอนนาแพง","บ้านสร้างพอก","บ้านสร้างโพน","บ้านสร้างฟาก","บ้านสร้างม่วงส้มเสี้ยว","บ้านสร้างมิ่ง","บ้านสร้างมิ่งมิตรภาพที่ 191","บ้านสร้างเม็ก","บ้านสร้างเรือ","บ้านสร้างสะแบง","บ้านสร้างเสี่ยน","บ้านสร้างแสน","บ้านสร้างหลวงสร้างคำ","บ้านสร้างหว้า","บ้านสร้างหอม","บ้านสร้างหิน","บ้านสร้างหินวิทยานุเคราะห์","บ้านสร้างเหล่าโนนแดง","บ้านสร้างแห่","บ้านสร้างโหง่น","บ้านสร้างใหญ่","บ้านสร้างเอี่ยน","บ้านสลก","บ้านสลักใด","บ้านสลักได","บ้านสลับ","เพียงหลวง 11 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านตาหงษ์","สวงษ์พัฒนาศึกษา","บ้านสวน","บ้านสวนขวัญ","บ้านสวนเขื่อน (ราษฎร์บูรณวิทยา)","บ้านสวนงัว (ราษฎร์ใจดี)","บ้านสวนจันทน์","บ้านสวนจิก","บ้านสวนดอกคำ","บ้านสวนดอกท่าขันทองสามัคคี","บ้านสวนแตง","บ้านสวนใต้ (ครองประชานุกูล)","บ้านสวนทรัพย์","บ้านสวนเทศ","บ้านสวนใน","บ้านสวนปอ","บ้านสวนผึ้ง","บ้านสวนพลู","บ้านสวนมอญ","บ้านสวนมอนคำ","บ้านสวนมอนไคร่นุ่นวังหิน","บ้านสวนมะเดื่อ","บ้านสวนเมี่ยง","บ้านสวนส้ม","บ้านสวนสมบูรณ์","บ้านสวนสวรรค์","บ้านสวนหม่อน (ราษฎร์สงเคราะห์)","บ้านสวนหม่อน","บ้านสวนหลวง","บ้านสวนหลวง (สวนหลวงวิทยายน)","บ้านสวนหอม","บ้านสวนห้อมผางาม","บ้านสวนเหนือ (ประชาบำรุง )","บ้านสวนโหนด","บ้านสวนใหม่","บ้านสวนอ้อย","บ้านสวนอาย","บ้านสวยศรี","บ้านสวยหลง","บ้านสวรรค์","บ้านสวองหนองไผ่ล้อม","สวัสดีวิทยา","บ้านสวัสดี","บ้านสว้า","บ้านสว่าง","บ้านสว่างดอนดู่","บ้านสว่างหนองเสือ","บ้านสว่างโนนสวาง","บ้านสว่าง (สว่างวิทยาคาร)","บ้านสว่างเชียงหวาง","บ้านสว่างดอนช้าง","บ้านสว่างใต้","บ้านสว่างนาดี","บ้านสว่างโนนแดง","บ้านสว่างโนนทอง","บ้านสว่างโนนสูง","บ้านสว่างปากราง","บ้านสว่างพัฒนา","บ้านสว่างมรรคา","บ้านสว่างยางท่าแจ้ง","บ้านสว่างวิทยา","บ้านสว่างสำราญ","เทศบาลเลิงนกทา","บ้านสวาท","บ้านสวาย","บ้านสวาย-สนวน","บ้านสวายจีก","บ้านสวายซอ","บ้านสวายสนิท","บ้านสวายสอ","บ้านสวายสอ ","บ้านสวาสดิ์","บ้านสหกรณ์","บ้านสหพันธ์อ่างทอง","บ้านส้อง","บ้านสองคร","บ้านสองคอน","บ้านสองคอนศิริคุรุราษฎร์","บ้านสองแคว","บ้านสองแควใต้","บ้านสองชั้น","บ้านส่องตาแล","บ้านสองธาร","บ้านสองพี่น้อง","บ้านสองพี่น้องวิทยาคาร","บ้านสองแพรก","บ้านสองแพรก มิตรภาพที่ 92","บ้านสองสลึง ตั้งตรงจิตร 9","บ้านสองสะโกม","บ้านสองห้อง (คุรุราษฎร์สามัคคี)","บ้านสองห้องหนองดงหนองหิน","บ้านสองห้องฮ่องน้อย","บ้านส้องเหนือ","บ้านส่องอนามัย","บ้านส้อเด่นพัฒนา","บ้านซอแบะ","บ้านสอยดาว","บ้านสะกอม","บ้านสะกาด","บ้านสะกำ ","บ้านสะเกิน","บ้านสะแกเครือ","บ้านสะแกงาม","บ้านสะคาม","บ้านสะคุวิทยา","บ้านสะง้อ","บ้านสะเดา","บ้านสะเดา (คุรุประชาวิทยาคาร)","บ้านสะเดา (สามัคคีวิทยา)","บ้านสะเดาซ้าย","บ้านสะเดาน้อย","บ้านสะเดาหนองไผ่ และสาขาเสาเล้า","บ้านสะเดาหวาน","บ้านสะเดาใหญ่","บ้านสะเดาะพงมิตรภาพที่ 229","บ้านสะเดียง","บ้านสะเต็ง","บ้านสะโต","บ้านสะท้อ","บ้านสะทอนโนนแพงประชาสรรค์","บ้านสะทืด","บ้านสะเนียน","บ้านสะแนน (สามัคคีวิทยา)","บ้านสะแนะ","บ้านสะโน","บ้านสะบารัง","บ้านสะแบง","บ้านสะแบงตาก","บ้านสะปอม","บ้านสะปัน","บ้านสะปำ","บ้านสะปุ๋ง","บ้านสะพลี(บางกอกโพสต์ศึกษา)","บ้านสะพังกร่าง","บ้านสะพาน","บ้านสะพานกฐิน","บ้านสะพานเคียน","บ้านสะพานโดม","บ้านสะพานพน","บ้านสะพานยาว","บ้านสะพานยูง","บ้านสะพานเลือก","บ้านสะพานสาม","บ้านสะพานสี่","บ้านสะพานเสือ","บ้านสะพานหัก","บ้านสะพานหัน","บ้านสะพานหิน","บ้านสะพานหิน (ประชาสามัคคี)","บ้านสะพือใต้","บ้านสะพือท่าค้อ","บ้านสะพุง","บ้านสะพุงเหนือ","บ้านสะมัด","ดอนสะไมย์วิทยา","บ้านสะแร","บ้านสะลวงนอก","บ้านสะละภูเวียง","บ้านสะเลียม","บ้านสะเลียม (ปัญญาราษฎร์รังสรรค์)","บ้านสะเลียมหวาน","บ้านสะแล่ง","บ้านสะโล","บ้านสะหริ่ง","บ้านสะอัก (ประชาอุปถัมภ์)","ศรีสะอาดวิทยาคม","บ้านสะอาง (ประชาสามัคคี)","บ้านสะอาด","สะอาดประชาสรรค์","บ้านสะอาด (สะอาดวิทยาคาร)","สะอาดเจริญใหม่สามัคคี","บ้านสะอาดดอนเงิน","บ้านสะอาดนาดี","บ้านสะอาดนาพังศรีเจริญ","บ้านสะอาดนามูล","บ้านสะอาดลายเหนือ","บ้านสะอาดหนองเรือ","บ้านสะเอะ","บ้านสะเอะใน","บ้านสะเอิง","บ้านสักทุ่ง","บ้านสักพัฒนา","บ้านสักลอ","บ้านสักหลง","บ้านสักแห้ง","บ้านสังกะลีนาขาม","บ้านสังกาอู้","บ้านสังแกหนองคู","บ้านสังแก","บ้านสังข์","บ้านสังข์ (ศรีเมืองราษฎร์สามัคคี)","บ้านสังข์ทอง","บ้านสังข์สงยาง (คุรุราษฎร์วิทยา)","บ้านสังขะ","บ้านสังเคิล","บ้านสังซาวังน้ำขาว","บ้านสังเม็ก","บ้านสัตหีบ","บ้านสัน","บ้านสันกลาง","บ้านสันกลาง (ราษฎร์พัฒนา)","บ้านสันกลางนาดอ","บ้านสันกว๊านทุ่งกิ่ว","บ้านสันกอง","บ้านสันกอเหียง","บ้านสันก้างปลา","บ้านสันกำแพง","บ้านสันขวาง","วัดสันคะยอม","บ้านสันคะยอม","บ้านสันโค้ง","บ้านสันโค้ง (เชียงรายจรูญราษฎร์)","บ้านสันจกปก","บ้านสันเจดีย์","บ้านสันเจริญ","องค์การบริหารส่วนตำบลดอยงาม (สันช้างตาย)","บ้านสันชุม (สหราษฎร์บำรุง)","บ้านสันดอน","บ้านสันดาบ","บ้านสันต้นขาม","บ้านสันต้นดู่","บ้านสันต้นธง","บ้านสันต้นเปา","บ้านสันต้นผึ้ง","บ้านสันต้นม่วง และสาขาบ้านสันสลี","บ้านสันต้นม่วงเหนือ","บ้านสันต้นหมื้อ","บ้านสันต้นแหน","บ้านสันตะลุง","บ้านสันติ","บ้านสันติคาม","บ้านสันติคีรี","บ้านแม่เต๋อ","บ้านสันติธรรม","บ้านสันติพิทยาคาร","บ้านสันติภาพ","บ้านสันติสุข","บ้านสันติสุขการไฟฟ้าอุปถัมภ์","บ้านสันถนน","บ้านสันทราย","บ้านสันทราย (ราษฎร์สามัคคี)","บ้านสันทรายคองน้อย","บ้านสันทรายมูล","บ้านสันทะ","บ้านสันธาตุ","บ้านสันนา","บ้านสันบุญเรือง","บ้านสันปง","บ้านสันป่ง","บ้านสันประดู่(คำประชานุสรณ์)","บ้านสันปอธง","บ้านสันป่าเกี๊ยะ","บ้านสันป่าข่า","บ้านสันป่างิ้ว","บ้านสันป่าแดง","บ้านสันป่าถ่อน","บ้านสันป่าบง","บ้านสันป่าป๋วย","บ้านสันป่าเปา","บ้านสันป่าพลวง","บ้านสันป่าไร่","บ้านสันป่าสัก","บ้านสันป่าเหียง","บ้านสันป่าเหียว","บ้านสันปูเลย","บ้านสันปูเลย และ รร.บ้านดงขี้เหล็ก","บ้านสันปู่สี (ราษฎร์วิทยากุล)","บ้านสันผักแค","บ้านสันผักหวาน","บ้านสันพระเนตร","บ้านสันม่วง","บ้านสันมะเกลือ","บ้านสันมะเค็ด","บ้านสันมะเค็ดสันขี้เหล็กหัวฝายพัฒนา","บ้านสันมะนะ","บ้านสันมะแฟน","บ้านสันยาวสันลิดไม้","บ้านสันยูง","บ้านสันวิไล","บ้านสันเวียงใหม่","บ้านสันศรี","บ้านสันสลี","บ้านสันหลวง","บ้านสันหลวงสามัคคี","บ้านสันหีบ","บ้านสัมพันธ์","บ้านสัมฤทธิ์","บ้านสา","บ้านสากอ","บ้านสาคร","บ้านสาครพัฒนา","บ้านสาครเหนือ","บ้านสาคอ","บ้านสาคู","บ้านสาคูมิตรภาพที่ 195","บ้านสาด-ผึ้งนาเกลือ","บ้านส้าน","บ้านส้าน (คุรุราษฎร์รังสรรค์)","บ้านสานตม มิตรภาพที่ 101","บ้านส้านนาหนองใหม่","บ้านสานแว้","บ้านสำนักหว้า","บ้านสาแพะ","บ้านสาม","บ้านสามกระทาย","บ้านสามแก้ว","บ้านสามขัว","บ้านสามขา","บ้านสามขาหนองสำโรง(นิพัทธ์ธรรมาภรณ์อุปถัมภ์)","บ้านสามขามิตรภาพที่ 3","บ้านสามโค","บ้านสามง่าม","บ้านสามเงา","บ้านสามช่อง","บ้านสามบึงบาตร","บ้านสามพราน (นครสาระผดุงวิทย์)","บ้านสามพวง (สามัคคีพิทยา)","บ้านสามเพียแสนจำปา","บ้านสามแพรก","บ้านสามยอด","บ้านสามแยก","สามแยกผดุงวิทย์","บ้านสามแยกจำปา","สามแยกชมภูโคกเจริญยางเครือพัฒนา","บ้านสามแยกดงสวรรค์","บ้านสามแยกน้ำเป็น","บ้านสามแยกพิทักษ์","บ้านสามแยกโพธิ์ชัย","บ้านสามแยกภูกอย","บ้านสามแยกวังชมภู","บ้านสามแยกหัวภูธร","บ้านสามแยกหินกอง","บ้านสามร้อยยอด (บุณยรักษ์อุทิศ)","บ้านสามเรือน","บ้านสามเรือน (วันครู 2500)","บ้านสามสบ","บ้านสามสัก","บ้านสามสิบพัฒนา","บ้านสามเส้า","บ้านสามเสียม","บ้านสามหนอง","บ้านสามหมอโนนทัน","บ้านสามหมื่น","บ้านสามหลักพัฒนา","บ้านสามหลัง","บ้านสามหลัง (ประชารังสรรค์)","บ้านสามเหลี่ยม","บ้านสามัคคี","บ้านสามัคคีชัย","บ้านสามัคคีธรรม","บ้านสามัคคีธรรมวิทยา","บ้านสามัคคีพัฒนา","บ้านสาเมาะ","บ้านสายควน","บ้านสายคำโห้","บ้านสายชนวน","บ้านสายชล","บ้านสายดินแดง","บ้านสายตรี 16","บ้านสายตรี 9","บ้านสายโท 1","บ้านสายโท 4 ใต้ ","บ้านสายนาดงอุปถัมภ์","บ้านสายน้ำทิพย์","บ้านสายปลาหลาย (คุรุราษฎร์ผดุง)","บ้านสายสนอง","บ้านสายหมอ","บ้านสายะ","บ้านสารจอด","บ้านสารจอดเก่า","บ้านสารจอดร่องกลอง","บ้านสารจิตร","บ้านสารภี","บ้านสารวัตร","บ้านสารเห็ด","บ้านสาระแพ","บ้านสาโรช","บ้านสาลี่","บ้านสาลีก","บ้านสาวแล","บ้านสาวอ","บ้านสาวเอ้","บ้านสาวะถี (สาวัตถีราษฎร์รังสฤษฏิ์)","บ้านสาวิทยาสรรพ์","บ้านสาหร่าย","บ้านสาหร่ายวิทยา","บ้านสำนัก","บ้านสำนักตะคร้อ","บ้านสำนักตูมกา","บ้านสำนักทอง","บ้านสำนักพิมาน","บ้านสำนักม่วง","บ้านสำนักไม้เรียบ","บ้านสำนักหมัน","บ้านสำนักใหม่","บ้านสำพะเนียง","บ้านสำเภา","บ้านสำเภาลูน","บ้านสำราญ","บ้านสำราญหนองบาก","บ้านสำราญนิวาสสามัคคี","บ้านสำราญสุข","บ้านสำราญหินลาด","บ้านสำโรง","บ้านสำโรงหัวนาโนนจันทร์หอม","บ้านสำโรงโคเฒ่า","บ้านสำโรง (ภิญโญอนุสรณ์)","บ้านสำโรง (คุรุประชาสามัคคี)","บ้านสำโรง (คุรุรัฐประชาสรรค์)","บ้านสำโรง (บางมด 2514)","บ้านสำโรง (วิทยาราษฎร์)","บ้านสำโรงเกียรติ","บ้านสำโรงคุรุราษฎร์วิทยาและสาขาบ้านหนองแวง","บ้านสำโรงโคก","บ้านสำโรงโคกจันทร์หอมวิทยา","บ้านสำโรงโคกเพชร","บ้านสำโรง-โคกเพชร","บ้านสำโรงตาเจ็น","บ้านสำโรงทาบ(บริคุตต์วิทยาคุณ)","บ้านสำโรงทุ่ง","บ้านสำโรงน้อย","บ้านสำโรงน้อยหนองบัว","บ้านสำโรงนาดี","บ้านสำโรงโนนเค็ง","บ้านสำโรงพรหมอนุสรณ์","บ้านสำโรงพลัน","บ้านสำโรงพิมาน","บ้านสำโรงสันติภาพ","บ้านสำโรงหนองจอก","บ้านสำโหรง","บ้านสิงห์","บ้านสิงห์ (ราษฎร์อนุสรณ์)","บ้านสิงห์ไคล","บ้านสิเดะ","บ้านสินชัย","บ้านสิบสอง","บ้านสิบสองหุ้น","บ้านสิโป","บ้านสิม","บ้านสิริขุนหาญ","บ้านสีโค","บ้านสี่แจ","บ้านสีชมพูมิตรภาพที่ 164","บ้านสีดางาม","บ้านสีดาสระแก้ว","บ้านสีถาน","บ้านสีปลาด","บ้านสีพรม","บ้านสีมุม","บ้านสี่แยก","บ้านสี่แยกคลองศิลา","บ้านสี่แยกสมเด็จ","บ้านสี่แยกสามัคคี","บ้านสีระมัน","บ้านสีล้ง","บ้านสีสุก","บ้านสีสุกห้วยโมง","บ้านสีเสียด","บ้านสีเสียดบํารุง","บ้านสี่เหลี่ยม","บ้านสี่เหลี่ยมน้อย","บ้านสี่เหลี่ยมวิทยา","บ้านสี่เหลี่ยมใหญ่","บ้านสีออสว่างราษฎร์สามัคคี","บ้านสือดัง","บ้านสุขเกษม","บ้านสุขขุม (อนุสรณ์พลยงค์)","บ้านสุขเจริญ","บ้านสุขเดือนห้า","บ้านสุขไพบูลย์","บ้านสุขฤทัย","บ้านสุขสมบูรณ์","บ้านสุขสำราญ","บ้านสุขัง (ราษฎร์สามัคคี)","บ้านสุ่งเจริญ","บ้านสุชน","บ้านสุดห้วยนา","บ้านสุเป๊ะ","บ้านสุพรรณ (คุรุราษฎร์วิทยา)","บ้านสุมข้าม","บ้านสุเม่น","บ้านสุรเดชสามัคคี","บ้านสุรศักดิ์","บ้านสุวรรณเขต","บ้านสุวรรณคาม","บ้านสุวรรณคีรี","บ้านสุวรรณประชาพัฒนา","บ้านสุวรรณภูมิ","บ้านสุวรรณวารี","บ้านสุโสะ","บ้านสุเหร่า","บ้านสุไหงโก-ลก","บ้านสุไหงบาตู","บ้านสุไหงบาลา","เพียงหลวง 4 (ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี)","บ้านสูงเนิน","บ้านสูงเนินสามัคคี","บ้านสูงยาง","บ้านสูบ","บ้านเสกกอง","บ้านเสม็ด","บ้านเสม็ด (สถาปัตย์อนุสรณ์ 1)","บ้านเสม็ด ","บ้านเสม็ด (ประชารัฐนุเคราะห์)","บ้านเสม็ดโคกตาล","บ้านเสม็ดจวน","บ้านเสม็ดประชาอุปถัมภ์","บ้านเสมอใจ","บ้านเสมา","บ้านเสรียง","บ้านเสลา","บ้านเสลาสุขเกษม","บ้านเสลาถั่วแปบ","บ้านเสลาประชารัฐ","บ้านเสลาโสรง","บ้านเสลี่ยงทอง","บ้านเสว(ราษฎร์สามัคคี)","บ้านเสวยซุง","บ้านเสอเพลอโนนสวรรค์","บ้านเสาขวัญกุดก้อม","บ้านเสาเดียวอนุสรณ์","บ้านเสาธงชัย","บ้านเสาธงใหญ่","บ้านเสาเล้า","บ้านเสาเล้าโคกแก่นช้าง","บ้านเสาเล้าผักชีศรีสวัสดิ์","บ้านเสาเล้าหินแตก","บ้านเสาวัด","บ้านเสาหงษ์","บ้านเสาหงส์","บ้านเสาหิน","บ้านเสียม (เสียมทองวิทยาคาร)","บ้านเสียว","บ้านเสี้ยว","บ้านเสียวโคกกลาง","บ้านเสี้ยวน้อย","บ้านเสียววิทยาสรรพ์","บ้านเสียวสงคราม","บ้านเสี้ยวใหญ่","บ้านเสือกินวัวโคกน้อย","บ้านเสือโก้ก","บ้านเสื่องข้าว","บ้านเสือเฒ่า","บ้านเสือเฒ่าหนองเรือวิทยา","บ้านเสือบอง","บ้านแสง","บ้านแส์ง","บ้านแสงจันทร์","บ้านแสงดาวโนนธาตุ","บ้านแสงน้อย","บ้านแสงไผ่","บ้านแสงภา","บ้านแสงมณีวิทยา","บ้านแสงเมืองแคน","บ้านแสงวิมาน","บ้านแสงสว่าง","บ้านแสงใหญ่ (คุรุราษฎร์บำรุง)","บ้านแสงอรุณ","บ้านแสนกาง","บ้านแสนแก้วหนองคูไซ","บ้านแสนขัน","บ้านแสนคำ (นาชุมสามัคคี)","บ้านแสนเจริญ","บ้านแสนตอ","บ้านแสนถาวร","บ้านแสนพันหมันหย่อน","บ้านแสนสำราญ","บ้านแสนสี","บ้านแสนสุข","บ้านแสนอุดม","บ้านแสรออ","บ้านแสลงโทน","บ้านแสลงพัน","บ้านแสลงพันกระเจา","บ้านแสลงพันธ์","บ้านแสลงพันบุณเยิง","บ้านแสวงสุข","บ้านโสก","บ้านโสกวังอ้อยหนู (ประชาสามัคคี)","บ้านโสกกระแต้","บ้านโสกกล้า","บ้านโสกก้านเหลือง","บ้านโสกก่ามนาตาไก้","บ้านโสกกาว","บ้านโสกแกคำเจริญ","บ้านโสกคร้อ","บ้านโสกคลอง","บ้านโสกคูณ","บ้านโสกแคนหนองหญ้าปล้อง","บ้านโสกงูเหลือม","บ้านโสกจาน","บ้านโสกจานนาดี","บ้านโสกแจ้ง","บ้านโสกชัน","บ้านโสกช้าง","บ้านโสกเชือก (คุรุราษฎร์อำนวย)","บ้านโสกเชือกนกเจ่าพัฒนา","บ้านโสกดู่","บ้านโสกเดื่อ","บ้านโสกแดง","โสกโดนคำไหลคำเตย","บ้านโสกตลิ่งโสกจาน","บ้านโสกเตย","บ้านโสกแต้","บ้านโสกท่าลาดพัฒนา","บ้านโสกท่าวังหิน","บ้านโสกนกเต็น","บ้านโสกนาค","บ้านโสกนาดี","บ้านโสกน้ำขาว","บ้านโสกน้ำขุ่น","บ้านโสกน้ำใส","บ้านโสกบง","บ้านโสกปลาดุก","บ้านโสกผักหวาน","บ้านโสกไผ่","บ้านโสกโพธิ์โสกพอก","บ้านโสกภารา","บ้านโสกม่วง","บ้านโสกม่วงดอนดู่","บ้านโสกมะตูม","บ้านโสกมูลนาค","บ้านโสกแมว","บ้านโสกยาง","บ้านโสกรวกหนองซึก","บ้านโสกรัง กุดบัว วังทรายขาว","บ้านโสกรัง","บ้านโสกรังโนนสว่าง","บ้านโสกสนวน","บ้านโสกสาน","บ้านโสกเสี้ยวแสนสุข","บ้านโสกแสง","บ้านโสกหมู","บ้านโสกหว้า","บ้านโสกหว้าโนนหอม","บ้านโสกหาด","บ้านโสกใหญ่","บ้านโสง (คุรุประชาสรรค์)","บ้านโสน","บ้านโสน (พิทยศึกษา)","บ้านโสม (วงศ์ทวีอุปถัมภ์)","บ้านโสมง","บ้านโสมน","บ้านโสมเยี่ยมโนนพัฒนา","บ้านใสถิน","อนุบาลควนขนุน","บ้านใสอ้อย","บ้านไส้ไก่","บ้านไสขรบ","บ้านไสขาม","บ้านไสโคกเกาะ","บ้านไส้จ่อ","บ้านไสดง","บ้านไสตอ","บ้านไสเตาอ้อย","บ้านไสถั่ว","บ้านไสกุน","บ้านไสท้อน","บ้านไสไทย","บ้านไสนายขัน","เทศบาลบ้านไสน้ำเย็น","บ้านไสใน","บ้านไสบ่อ","บ้านไสโป๊ะ","บ้านไสพลู","บ้านไสมะม่วง","บ้านไสยาศน์ (ราษฎร์บูรณะ)","บ้านไสยาสน์","บ้านไสยูงปัก","บ้านไสเลียบ","บ้านไสส้าน","บ้านไสหินตั้ง","บ้านไสเหรียง","บ้านไสใหญ่","บ้านหก","บ้านหงษ์ทอง","บ้านหงษ์ทอง (แสนสุขวิทยา)","บ้านหงษาวดี","บ้านหงส์ทองสามขา","บ้านหงอนไก่ (โคกสง่า)","บ้านหญ้าขาว","บ้านหญ้าคา","บ้านหญ้าคา ว.ท.อ.","บ้านหญ้าคาใต้","บ้านหญ้าคาท่าหลวง","บ้านหญ้าคาโนนแจง","บ้านหญ้าคาประชาเนรมิต","บ้านหญ้าคาดอนเค็ง","บ้านหญ้าคาเหนือ","บ้านหญ้าเครือเสาเล้าร่องดูก","บ้านหญ้านาง (ประชาวิทยาคาร)","บ้านหญ้าปล้อง","บ้านหญ้าหน่อง","บ้านหนอง","บ้านหนองกก","วัดบ้านหนองกก","บ้านหนองกก (ทรงรวมมิตร)","บ้านหนองกกคูณ","บ้านหนองกกตลุกผักไร","บ้านหนองกกตะแบงสามัคคี","บ้านหนองกกหนองยาว","บ้านหนองกง","บ้านหนองกบนาแมน","บ้านหนองกบ","บ้านหนองกรด","บ้านหนองกรดสามัคคี","บ้านหนองกระดาน","บ้านหนองกระดาษ","บ้านหนองกระดิ่ง","บ้านหนองกระดี่","บ้านหนองกระดี่ (บางประชาสรรค์)","บ้านหนองกระโดน","บ้านหนองกระโดนดอนมะเกลือสามัคคี","บ้านหนองกระต่าย","บ้านหนองกระถิน","บ้านหนองกระทิง","บ้านหนองกระทุงตากแดด","บ้านหนองกระทุ่ม","บ้านหนองกระทุ่ม (จันทร์ประชานุเคราะห์)","บ้านหนองกระทุ่มสระอโนดาด","บ้านหนองกระทู้","บ้านหนองกระเทียมใต้","บ้านหนองกระเทียมเหนือ","บ้านหนองกระบอกราษฎร์อุทิศวิทยา","บ้านหนองกระบาก","บ้านหนองกระบือ","บ้านหนองกระยัง","บ้านหนองกระหนวนหนองเม็ก","บ้านหนองกระโห้","บ้านหนองกรับ","บ้านหนองกร่าง","บ้านหนองกราด","บ้านหนองกราดน้อย","บ้านหนองกลด","บ้านหนองกลอย","บ้านหนองกลับ","บ้านหนองกล้า","บ้านหนองกลางโคก","บ้านหนองกลางดง","บ้านหนองกลางดอน","บ้านหนองกลางพง","บ้านหนองกวั่งหนองกรุงศรี","บ้านหนองกวาง","บ้านหนองกวางทอง","บ้านหนองกวางลี้(ประสิทธิ์ประชานุสรณ์)","บ้านหนองกอก","บ้านหนองกองแก้ว","บ้านหนองกอบง","บ้านหนองกอมป่าขาว","บ้านหนองกอยสิทธิราษฎร์บำรุง","เทศบาล 2 บ้านหนองกะจะ (ธง-นิรมลอุปถัมภ์)","บ้านหนองกะทะ","บ้านหนองกะท้าว","บ้านหนองกะเบา","บ้านหนองกะปาด","บ้านหนองกะเปา","เทศบาล 2","บ้านหนองกะหนาก","บ้านหนองกันเกรา","บ้านหนองกันจอ","บ้านหนองกับ","บ้านหนองกัว","บ้านหนองกา","บ้านหนองกา ","บ้านหนองกาด","บ้านหนองก่านคำไผ่","บ้านหนองกาโนนสิมมา","บ้านหนองการะโก","บ้านหนองกาว","บ้านหนองกำไร","บ้านหนองกินเพล","บ้านหนองกี่","บ้านหนองกี่ประชาสามัคคี","บ้านหนองกี่สุขสำราญ","บ้านหนองกุง","บ้านหนองกุ้ง","บ้านหนองกุง (ฮินดูสมาช)","บ้านหนองกุงกลาง","บ้านหนองกุงแก้ว","บ้านหนองกุงขี้ควง","บ้านหนองกุงคชสาร","บ้านหนองกุงคำไฮ","บ้านหนองกุงคุรุประชาสรรค์","บ้านหนองกุงดอนตาเขสามัคคี","บ้านหนองกุงดอนบาก","บ้านหนองกุงดิ่ง","บ้านหนองกุงเต่า","บ้านหนองกุงทับม้า","บ้านหนองกุงธนสารโศภณ และโคกไม้งาม","บ้านหนองกุงน้อย","บ้านหนองกุงโนนทัน","บ้านหนองกุงบำรุง","บ้านหนองกุงมนศึกษา","บ้านหนองกุงวันดีประชาสรรค์","หนองกุงวิทยา","หนองกุงศาลาน้ำเที่ยงวิทยากร","บ้านหนองกุงวิทยาคาร","บ้านหนองกุงศรีโพธิ์ศรีสมพร","บ้านหนองกุงสนามชัย","บ้านหนองกุงสว่าง","บ้านหนองกุงหนองเจริญ","บ้านหนองกุงใหญ่","บ้านหนองกุงใหม่","บ้านหนองกุฏิ","บ้านหนองกุดแคน","บ้านหนองกุ่ม","บ้านหนองกุลา","บ้านหนองเกด","บ้านหนองเกตุ","บ้านหนองเก็ม","บ้านหนองเก่า","บ้านหนองเก้าห้อง","บ้านหนองเกาะ (คุรุราษฏร์บำรุง)","บ้านหนองเกิด","บ้านหนองแก","บ้านหนองแกหนองโล","บ้านหนองแก (สามัคคีวิทยา)","บ้านหนองแก่ง","บ้านหนองแก่งทราย","บ้านหนองแกเชียงราย","บ้านหนองแกใน","บ้านหนองแกประชาสรรค์","บ้านหนองแก้ว","บ้านหนองแก้ว (ราษฎร์ผดุงวิทยา)","บ้านหนองแก้วสำโรง","บ้านหนองแกวิทยา","บ้านหนองแกหนองโน","บ้านหนองโก","บ้านหนองโกโพธิ์เงินคำผักกูด","บ้านหนองโกโนนประดู่วิทยา","บ้านหนองโกโสกกระหนวน","บ้านหนองโกวิทยา","บ้านหนองไก่แก้ว (เพิ่มเจริญประชานุกูล)","บ้านหนองไก่ขัน","บ้านหนองไก่ขาว (ฉวีบรรณสารพิจิตรอุปถัมภ์)","บ้านหนองไก่ต่อ","บ้านหนองไก่เถื่อน","บ้านหนองไก่ปิ้ง","บ้านหนองไก่ห้าว","บ้านหนองไก่เหลือง","บ้านหนองขนาก","บ้านหนองขนาด","บ้านหนองขนาน","บ้านหนองขมิ้น","บ้านหนองขยาด","บ้านหนองขวาง","บ้านหนองขวางวิทยา","บ้านหนองขวาว","บ้านหนองขวาว (ศรีสุรินทร์บำรุง)","บ้านหนองขอน","บ้านหนองขอน (ประชารัฐนุเคราะห์)","บ้านหนองขอนแก่น","บ้านหนองขอนแก่น และสาขาสี่แยก","บ้านหนองขอนเทพพนม","บ้านหนองขอนประชาสรรค์","บ้านหนองขอนโพนสิม","บ้านหนองข่า","หนองข่าประชาอุทิศ","หนองข่าป่าหวาย","บ้านหนองข่า (คุรุประชาวิทยา)","บ้านหนองขานาง","บ้านหนองข่าหนองคูโปโล","บ้านหนองขาม","บ้านหนองขาม (สันติกาญจน์ราษฎร์บำรุง)","บ้านหนองขามวิทยาคม","บ้านหนองขาม (ค่ายเสนีย์อุปถัมภ์)","บ้านหนองขาม (ทองงามวิทยา)","บ้านหนองขามท่างาม","บ้านหนองขามน้อย","บ้านหนองขามนาดี","บ้านหนองขามบ่อแก้ววิทยา","บ้านหนองขามบ่อหิน","บ้านหนองขามประชาบำรุง","บ้านหนองขามป้อม","บ้านหนองขามวิทยา","บ้านหนองขามสมบูรณ์","บ้านหนองขามแสบง","หนองขามพิทยาคม","บ้านหนองขามหัวหนองสามัคคี","บ้านหนองขาว","บ้านหนองขาวกลาง","บ้านหนองข้าวเหนียว","บ้านหนองข่าวิทยานุสรณ์","บ้านหนองขาหยั่ง","บ้านหนองขาหย่าง","บ้านหนองกระบือวิทยาคม","บ้านหนองขี้นกยาง","บ้านหนองขี้ม้า","บ้านหนองขี้เห็น","บ้านหนองขี้เหล็ก","บ้านหนองขุ่น","บ้านหนองขุ่นนาคำ","บ้านหนองขุ่นเหล่าหลักวิทยา","บ้านหนองขุนพรม","บ้านหนองขุ่นมิตรภาพที่ 136","บ้านหนองขุ่นวิทยาคาร","บ้านหนองขุนศรี","บ้านหนองขุย","บ้านหนองขุย (นาคสวัสดิ์ประชานุเคราะห์)","บ้านหนองขุยคูเมือง","บ้านหนองเข้","บ้านหนองเข็ง","บ้านหนองเข็งเหล่าแค","บ้านหนองเขมร","บ้านหนองเขาอ่อน","บ้านหนองเขิน","บ้านหนองเขียด","บ้านหนองเขียดมิตรภาพที่ 205","บ้านหนองเขียว","บ้านหนองเขื่อง","บ้านหนองเขื่อน","บ้านหนองเขื่อนช้าง","บ้านหนองแข้","บ้านหนองแข้หนองหว้าป่าสะแบง","บ้านหนองแข้ดง","บ้านหนองแข้โนนมาลา","บ้านหนองแขม","บ้านหนองแขม (หนองแขมประชาสรรค์)","บ้านหนองแขมอีโล","บ้านหนองแขวนกูบ","บ้านหนองโข่ย (ประชารัฐบำรุง)","บ้านหนองไข่นก","บ้านหนองไข่น้ำ","บ้านหนองไขว่","บ้านหนองครก","บ้านหนองครก ","บ้านหนองครองราษฎร์ประสงค์","บ้านหนองคร้า","บ้านหนองครึม","บ้านหนองคลอง","บ้านหนองคลองใหม่หัวนาคำ","บ้านหนองคลองหัวขัว","บ้านหนองคลองดอนแดง","บ้านหนองคลองหนองทุ่ม","บ้านหนองคล้า","บ้านหนองค้อ","บ้านหนองคอก","บ้านหนองคอกควาย (คุรุประชานุสรณ์)","บ้านหนองคอไก่","บ้านหนองคอง","บ้านหนองคอน","บ้านหนองคอนไทย","บ้านหนองคอนไทย (คุรุประชาสรรค์)","บ้านหนองคอนแสน","บ้านหนองคอม","บ้านหนองค้อสวนอ้อย","ชุมชนหนองคะเน","บ้านหนองคังคา","บ้านหนองคัน","บ้านหนองคันนา","บ้านหนองคับคา","บ้านหนองคา","บ้านหนองค้า","บ้านหนองค้าดารกานนท์วิทยา","บ้านหนองค้ากลางฮุง","บ้านหนองค้าโคกกุง","บ้านหนองคาง","บ้านหนองค่าย","บ้านหนองคำ","บ้านหนองคุ้มวิทยา","บ้านหนองคุย","บ้านหนองคู","บ้านหนองคู (หนองคูวิทยาคาร)","บ้านหนองคูสะแบะ","บ้านหนองคู (โสภณประชานุกูล)","บ้านหนองคู (อ.ส.พ.ป.23)","บ้านหนองคูขาด","บ้านหนองคูขาม","บ้านหนองคูโคกเพ็ก","บ้านหนองคูไชยหนองขาม","บ้านหนองคูณ","บ้านหนองคูณน้ำจั้น","บ้านหนองคูณพิณทอง","บ้านหนองคูทรายมูล","บ้านหนองคูน้อย","บ้านหนองคูโนนแก้วหนองอีย่า","บ้านหนองคูบอน","บ้านหนองคูม่วง","บ้านหนองคูวิทยาคม","บ้านหนองคูใหญ่","บ้านหนองคูอาวอย","บ้านหนองเค็ด","บ้านหนองเค็ม","บ้านหนองแค","บ้านหนองแคสวนสวรรค์","บ้านหนองแคทราย","บ้านหนองแคน","บ้านหนองแคน (คุรุราษฎร์สามัคคี)","บ้านหนองแคนโคกสะอาด","บ้านหนองแคนดอนสนุก","บ้านหนองแคนน้อย","บ้านหนองแคนนาจาน","บ้านหนองแคนสหราษฎร์วิทยา","บ้านหนองแคนหนองเทา","บ้านหนองแคนหัวฝาย","บ้านหนองแคหนองโข่ย (อำนวยศิลป์)","บ้านหนองโคก (อดุลถวิลราษฎร์บำรุง)","บ้านหนองโค้ง","บ้านหนองโคบาล","บ้านหนองโคลน","บ้านหนองไคร้","บ้านหนองฆ้อ","บ้านหนองฆ้อง","บ้านหนองฆ้องนาสีนวล","บ้านหนองงา","บ้านหนองงิ้วเหล่าแปน","บ้านหนองงิ้ว","บ้านหนองงิ้ว หนองไทร","บ้านหนองงูเหลือม","บ้านหนองงูเหลือม (ประชารัฐบำรุง)","บ้านหนองงูเหลือม (คุรุราษฎร์รัฐกิจโกศล)","บ้านหนองงูเห่า","บ้านหนองเงินฮ้อย","บ้านหนองเงือก","บ้านหนองโง้ง","บ้านหนองจระเข้หิน","บ้านหนองจอก","บ้านหนองจอก (จิตติ-บุญศรี)","บ้านหนองจอกโนนสมบูรณ์","บ้านหนองจอกวังกำแพง","บ้านหนองจะบก","บ้านหนองจะปราบ","บ้านหนองจัง","บ้านหนองจั่น","บ้านหนองจันทน์","บ้านหนองจันทน์หอม","บ้านหนองจันทร์","บ้านหนองจั่ว","บ้านหนองจาน","บ้านหนองยาง-หนองจาน","บ้านหนองจานใต้","บ้านหนองจานบุลาน","บ้านหนองจำนัก","บ้านหนองจำปา","บ้านหนองจิก","บ้านหนองจิก (บริษัทข้าวไทยจำกัดสงเคราะห์ 1)","บ้านหนองจิกโคกสูง","บ้านหนองจิกตีนเนิน","บ้านหนองจิกนาเรือง","บ้านหนองจิกยาว","บ้านหนองจิกรากข่า","บ้านหนองจิกรี","บ้านหนองจูด","บ้านหนองจูบ","บ้านหนองเจ","บ้านหนองเจ๊กกวย","บ้านหนองเจ๊กสร้อย","บ้านหนองเจ็ดบาท","บ้านหนองเจ็ดหาบ","บ้านหนองเจริญ","บ้านหนองเจริญ (ประชาพัฒนา)","บ้านหนองเจริญสุข","บ้านหนองเจ้าเมือง","บ้านหนองแจง","บ้านหนองแจ้ง","บ้านหนองแจ้งน้อย","บ้านหนองแจ้งใหญ่","บ้านหนองโจงโลง","บ้านหนองโจด","บ้านหนองโจดสวนมอน","บ้านหนองฉิม","บ้านหนองฉิม (สิงห์จันทร์บำรุง)","บ้านหนองชวด","บ้านหนองชะลาบ","บ้านหนองชะอม","บ้านหนองชะแอน","บ้านหนองชัยวาน","บ้านหนองชาก (ประโยชน์บุพการีอุทิศ)","บ้านหนองชากแง้ว","บ้านหนองช้าง","บ้านหนองช้าง (ประชาสามัคคี)","บ้านหนองช้างคาวหนองบง","บ้านหนองช้างคืน","บ้านหนองช้างงาม","บ้านหนองช้างลง","บ้านหนองช้างเอก","บ้านหนองชาด","บ้านหนองชำนาญ","บ้านหนองชุม","บ้านหนองชุมพล","บ้านหนองชุมแสง","บ้านหนองชุมแสง (พัชรศาสน์ราษฎร์นุเคราะห์)","บ้านหนองชุมเห็ด","บ้านหนองชุมเห็ด (ประจวบอุปถัมถ์)","บ้านหนองเชียงคา","บ้านหนองเชียงทูน","บ้านหนองเชียงรอด","บ้านหนองเชือก","บ้านหนองแช่ไม้","บ้านหนองซ่งแย้","บ้านหนองซน","บ้านหนองซอ","บ้านหนองซอแซ","บ้านหนองซอน","บ้านหนองซ่อนผึ้งผดุงวิทย์","บ้านหนองซ่อมตะเคียนงาม","บ้านหนองซา","บ้านหนองซ้ำซาก","บ้านหนองเซียงซุยโนนสะอาด","บ้านหนองเซือม","บ้านหนองแซง","บ้านหนองแซงสร้อย","บ้านหนองแซงแสงอรุณ","บ้านหนองญาติ","บ้านหนองเฒ่า","บ้านหนองเฒ่ากา","บ้านหนองดง","บ้านหนองดอกบัว","บ้านหนองด่าน","บ้านหนองดินดำ","บ้านหนองดินดำ (คุรุราษฎร์ผดุงวิทย์)","บ้านหนองดินแดง","บ้านหนองดุด","บ้านหนองดุม","บ้านหนองดุมหัวช้าง (ราษฎร์พัฒนา)","บ้านหนองดุมหนองแคนน้อย","บ้านหนองดุมหนองม่วง","บ้านหนองดู่ประชาสรรค์","บ้านหนองดู่","บ้านหนองดู่ดอนเปือย","บ้านหนองดู่ดอนเปือย สาขาบ้านดอนเปือย","บ้านหนองดูนโนนค้อหนองหัวลิง","บ้านหนองเดิ่น","บ้านหนองเดิ่นดอนขาว","บ้านหนองเดิ่นท่า","บ้านหนองเดิ่นทุ่ง","บ้านหนองเดียงน้อยโนนใหญ่","บ้านหนองแดง","บ้านหนองแดง (คุรุราษฎร์บำเพ็ญ)","บ้านหนองแดงกุดจิก","บ้านหนองแดงสหมิตร","บ้านหนองแดน","บ้านหนองโด","บ้านหนองโดกนาคำโนนธาตุ","บ้านหนองโดดอนเสียด","บ้านหนองโดน","บ้านหนองโดนประสาทวิทย์","บ้านหนองโดนรกฟ้า","บ้านหนองโดนหอกลอง","บ้านหนองโดนอ้อยช้าง","บ้านหนองต้นพลวง","บ้านหนองตม","บ้านหนองตระเสก","บ้านหนองตราด","บ้านหนองตราดน้อย","บ้านหนองตลับ","บ้านหนองตลาด","บ้านหนองตลาด-โนนเปือย","บ้านหนองตอ","บ้านหนองตอสูงแคน","บ้านหนองต่อ","บ้านหนองต้อ","บ้านหนองตอนาดีเทพประทานวิทยา","หนองตอกเกี้ยหัวนาประชาสรรค์","บ้านหนองตอกแป้นวิทยา","หนองตอกแป้นหนองมั่งวิทยา","บ้านหนองตอแก้ว","บ้านหนองต่อโคกหนองโจด","บ้านหนองตอง","บ้านหนองตอตะเคียน","บ้านหนองตอ-บัวเสียว","บ้านหนองตอ-โพนสูงนาคำ","บ้านหนองตะกู","วัดหนองกันเกรา","บ้านหนองตะโก","บ้านหนองตะไก้","บ้านหนองตะไก้ (ประชาพัฒนา)","บ้านหนองตะไก้โนนมันปลา","บ้านหนองตะขบ","บ้านหนองตะเข้-หนองตูม","บ้านหนองตะคร้อ","บ้านหนองตะครองบ้านโกรก","บ้านหนองตะครอง","บ้านหนองตะคลอง","บ้านหนองตะเคียน","บ้านหนองตะเคียนบอน","บ้านหนองตะแบก","บ้านหนองตะเภา","บ้านหนองตะมะพันทาโนนกอง (ธนาคารกรุงเทพ 2)","บ้านหนองตะลุมปุ๊ก","บ้านหนองตับเต่า","บ้านหนองตากร้า","บ้านหนองตากล้า","บ้านหนองตากวย","บ้านหนองตาก้าย","บ้านหนองตาแก้ว","บ้านหนองตาใกล้","บ้านหนองตาไก้","บ้านหนองตาไก้ตลาดหนองแก","บ้านหนองตาไก้เผือกใต้วิทยา","บ้านหนองตาไก้พิทยา","บ้านหนองตาไก้หนองตุ","บ้านหนองตาไก้หนองเม็ก","บ้านหนองตาคง","บ้านหนองตาฉาว (จตฺตราษฎร์บำรุง)","บ้านหนองตาเชียง","บ้านหนองตาด","บ้านหนองตาดน้อย","บ้านหนองตาดำ","บ้านหนองตาเดช","บ้านหนองตาแต้ม (ราชประชานุกูล)","บ้านหนองตานา","บ้านหนองตาเนิด","บ้านหนองตาบ่ง","บ้านหนองตาปู่","บ้านหนองตาพุด","บ้านหนองตาแพ่ง","บ้านหนองตาเมือง","บ้านหนองต่าย","บ้านหนองตายอด","บ้านหนองตาเย็น","บ้านหนองตาเยา","บ้านหนองตาราม","บ้านหนองตาล","บ้านหนองตาเสือ","บ้านหนองติ้ว","บ้านหนองตึก-ห้วยน้ำใส","บ้านหนองตื่น","บ้านหนองตุ","บ้านหนองตุ้ม","บ้านหนองตูมท่ายาง","บ้านหนองตูม","บ้านหนองเต็ง","บ้านหนองเต็ง ","บ้านหนองเต็งรัง","บ้านหนองเตย","บ้านหนองเตา","บ้านหนองเต่า","บ้านหนองเต่าราษฎร์บำรุง","บ้านหนองเต่าเพชรเจริญ","บ้านหนองเต่าดอนหายโศก","บ้านหนองเต่าบึงเรือใหญ่","บ้านหนองเตาปูน","บ้านหนองเต่าสามัคคี","บ้านหนองเตียน","บ้านหนองแต้","บ้านหนองแต้หนองโก","บ้านหนองแตง","บ้านหนองแต้น้อย","บ้านหนองแต้พัฒนา","บ้านหนองแต้ราษฎร์สามัคคีวิทยา","บ้านหนองโต๊ะ","บ้านหนองถนน","บ้านหนองถ่ม","บ้านหนองถ่ม (คุรุราษฎร์อนุสรณ์)","บ้านหนองถ้อย","บ้านหนองถั่วแปบ","บ้านหนองถาวร","บ้านหนองถ้ำ","บ้านหนองท่ม","บ้านหนองท่มคำเจริญ","บ้านหนองท่มท่ากระดัน","บ้านหนองทราย","บ้านหนองทอง","บ้านหนองทองลิ่ม","บ้านหนองทองหล่อ","บ้านหนองทองหลางโนนกุง","หนองทอนโนนขุนทิพย์วิทยา","บ้านหนองท่อม","บ้านหนองทะลอก","บ้านหนองทะเล","บ้านหนองทัพ","บ้านหนองทัพไทย","บ้านหนองทา","บ้านหนองท่าควาย","บ้านหนองทามใหญ่","บ้านหนองทุ่งมน","บ้านหนองทุ่ม","บ้านหนองทุ่มหนองสะแบง","บ้านหนองทุ่ม(พุทธานุเคราะห์)","บ้านหนองทุ่มโนนสวรรค์","บ้านหนองทุ่มโนนสูงวิทยา","บ้านหนองทุ่มโนนหาดวิทยา","บ้านหนองทุ่มประชาสรรค์","บ้านหนองทุ่มวิทยา","บ้านหนองทุ่มศรีโพธิ์ทอง","บ้านหนองทุ่มหนองโจด","บ้านหนองทุ่มหนองหว้า","บ้านหนองเทพ","บ้านหนองเทา","บ้านหนองโทนหนองเขวา","บ้านหนองไทร","บ้านหนองไทร (ปัญจคามคุรุสรรค์)","บ้านหนองธง","เทศบาล(บ้านหนองนก)","บ้านหนองนกกระเรียน","บ้านหนองนกกวัก","บ้านหนองนกกะเรียน","บ้านหนองนกเกรียน","บ้านหนองนกแก้ว","บ้านหนองนกเขา","บ้านหนองนกเขียน","บ้านหนองนกเขียนนาเสถียร","บ้านหนองนกเขียนประชาอุปถัมภ์","บ้านหนองนกเขียนโพนทัน","วัดหนองนกคุ่ม","บ้านหนองนกคู่","อนุบาลทุ่งทราย (บ้านหนองนกชุม)","บ้านหนองนกทา","บ้านหนองนกทา สาขาบ้านหนองขุมเงิน","บ้านหนองนกปีกกา","บ้านหนองนกเป็ด","บ้านหนองนกออกประชาสรรค์","บ้านหนองนนทรี","บ้านหนองนมนาง","บ้านหนองนมวัว","บ้านหนองนอ","บ้านหนองน้อย","บ้านหนองนา","บ้านหนองนากวางอั้น","บ้านหนองนาคำ","บ้านหนองนาคำประชานุเคราะห์","บ้านหนองนาโคกไผ่ล้อมสามัคคี","บ้านหนองนาง","บ้านหนองนางขวัญ","บ้านหนองนางด่อน","บ้านหนองนางดำ","บ้านหนองนางตุ้มบากหัวคำ","บ้านหนองนางแพรว (บุญเหลือราษฎร์วิทยาคาร)","บ้านหนองนางเลิง","บ้านหนองนางเลิ้ง","บ้านหนองนางาม","บ้านหนองนาเจริญ","บ้านหนองนาแซง ดอนเจริญ","บ้านหนองนาแซงโนนงิ้ว","บ้านหนองนาทราย","บ้านหนองนาเทิงโนนผึ้ง","บ้านหนองนาใน","บ้านหนองนาโพธิ์","บ้านหนองนายขุ้ย","บ้านหนองนาไร่เดียว","บ้านหนองนาเลิศ","บ้านหนองนาว","บ้านหนองนาเวียง","บ้านหนองนาสร้าง (ศิริราษฎร์บูรณะ)","บ้านหนองนาหล้า","บ้านหนองนาหารสมสนุกวิทยา","บ้านหนองนาไฮโนนสะอาด","บ้านหนองน้ำกลัด","บ้านหนองน้ำขาวเจริญราษฎร์","บ้านหนองน้ำขุ่น","บ้านหนองน้ำเขียว","บ้านหนองน้ำเค็ม","บ้านหนองน้ำแดง","บ้านหนองน้ำเต้า","บ้านหนองน้ำเต้าโนนสวน","บ้านหนองน้ำถ่าย","บ้านหนองน้ำรัด (พรหมาประชาสงเคาระห์)","บ้านหนองน้ำสร้าง","บ้านหนองน้ำใส","บ้านหนองเนิน","บ้านหนองเนียน","หนองโนราษฎร์บำรุง","บ้านหนองโน","บ้านหนองโน (คุรุราษฎร์พัฒนา)","บ้านหนองโนไชยวาน","บ้านหนองโนใต้","บ้านหนองโนทับม้า","บ้านหนองโนน้อย","บ้านหนองโนประชานุเคราะห์","บ้านหนองโนประชาสรรค์","บ้านหนองโนวิทยา","บ้านหนองโนสวนโคก","บ้านหนองโนหนองดูน","บ้านหนองโนอีดำ","บ้านหนองบก","บ้านหนองบกโนนสวาท","บ้านหนองบง","บ้านหนองบ่มกล้วย","บ้านหนองบ้วย","บ้านหนองบ่อ","บ้านหนองบ่อ (พอลพิทยาประชานุสรณ์)","บ้านหนองบอน","บ้านหนองบอนฐานเจ้าป่า","บ้านหนองบอนหัวหนองเหล่ายาว","บ้านหนองบอนใต้","บ้านหนองบอนวิทยา","บ้านหนองบอนเวียงชัย","บ้านหนองบะโคกสว่าง","บ้านหนองบักโทน","บ้านหนองบัว","บ้านหนองบัวขาว","บ้านหนองบัวและ บ้านหนองบัว (สาขานาเชือก)","บ้านหนองบั่ว ","บ้านหนองบั่ว","บ้านหนองบั่วประชาสรรค์","บ้านหนองบัว (จิตพินิจประชาสรรค์)","บ้านหนองบัว (ชาลีราษฎร์สามัคคี)","บ้านหนองบัว (ประชาสงเคราะห์)","บ้านหนองบัว (สหรัฐพิบูลประชาสรรค์)","บ้านหนองบัวกระจาย","บ้านหนองบัวกลาง","บ้านหนองบัวกาเหรียญ","บ้านหนองบัวกุดอ้อ","บ้านหนองบัวด่านเก่า","บ้านหนองบัวแก้ว","บ้านหนองบัวเขาดิน","บ้านหนองบัวคำ","บ้านหนองบัวคำมูล","บ้านหนองบัวคำแสน","บ้านหนองบัวคู","บ้านหนองบัวคูสองห้อง","บ้านหนองบัวโคก","บ้านหนองบัวงาม","บ้านหนองบัวเงิน","บ้านหนองบัวเงินหนองบัวทอง","บ้านหนองบัวเจ้าป่า","บ้านหนองบัวไชยวาน","บ้านหนองบัวโซม","บ้านหนองบัวดง (รัฐราษฎร์วิทยาคม)","บ้านหนองบัวดอนไผ่","บ้านหนองบัวดอนส้มป่อย","บ้านหนองบัวดีหมี (คุรุสามัคคี 3)","บ้านหนองบัวแดง","บ้านหนองบัวแดงวิทยา","บ้านหนองบัวแดนเกษม","บ้านหนองบัวตะเกียด","บ้านหนองบัวตากลาน","บ้านหนองบัวตาคง","บ้านหนองบัวใต้","บ้านหนองบัวทวิคามบำรุง","บ้านหนองบัวทอง","บ้านหนองบัวท่าช้าง","บ้านหนองบัวทุ่ง","บ้านหนองบัวน้อย","บ้านหนองบัวน้อยห้วยโจดโนนขามแป","บ้านหนองบัวนาค","บ้านหนองบัวหนองแวง","บ้านหนองบัวโนนมี้","บ้านหนองบัวโนนเมือง","บ้านหนองบัวโนนสว่าง","บ้านหนองบัวบาน","บ้านหนองบัวบาน (บัวบานวิทยาคม)","บ้านหนองบัวผาบ่ม","บ้านหนองบัวพรม","บ้านหนองบัวเพวัง (คุรุราษฎร์รังสรรค์)","บ้านหนองบัวแพ","บ้านหนองบัวมิตรภาพที่ 85","บ้านหนองบัวเย็น","บ้านหนองบัวรอง (อินทรผลบำรุง)","บ้านหนองบัวรองสามัคคี","บ้านหนองบัวราษฎร์รัฐบำรุง","บ้านหนองบัวเรณ","บ้านหนองบัวเรียน","บ้านหนองบัวลอง","บ้านหนองบัวละคร","บ้านหนองบัวลี","บ้านหนองบัวเลิง","หนองบัวเลิงเหล่าสวนมอญ","บ้านหนองบัววิทยา","บ้านหนองบั่ววิทยา","บ้านหนองบัวสงยาง","บ้านหนองบัวสร้างวิทยาคาร","บ้านหนองบัวสะอาดโพธิ์คำ","บ้านหนองบัวสันติสุข","บ้านหนองบัวสันตุ","บ้านหนองบัวสามัคคี","บ้านหนองบัวสิม","บ้านหนองบัวหน้าฐานบิน","บ้านหนองบัวหลวง","บ้านหนองบัวหิ่ง (สนิทราษฎร์บำรุง)","บ้านหนองบัวเหนือ","บ้านหนองบัวใหญ่","บ้านหนองบัวอารี","บ้านหนองบัวฮี","บ้านหนองบาก","บ้านหนองบาง","บ้านหนองบาท้าว","บ้านหนองบึง","บ้านหนองบึงทวาย","บ้านหนองบุญชู","บ้านหนองบุนนาก","บ้านหนองบุนาหล่ำ","บ้านหนองเบ็ญ","บ้านหนองเบญจ","บ้านหนองเบน","บ้านหนองเบิด","บ้านหนองโบสถ์","บ้านหนองปกติ","บ้านหนองปรง","บ้านหนองปรงกาญจนา","บ้านหนองประดู่","บ้านหนองประโยชน์","บ้านหนองประเสริฐ","บ้านหนองปรึก","บ้านหนองปรือ","หนองปรือประชาสรรค์","บ้านหนองปรือ (รัฐราษฎร์พัฒนา)","บ้านหนองปรือกันยาง","บ้านหนองปรือคึมม่วง","บ้านหนองปรือน้อย","บ้านหนองปรือโป่ง","บ้านหนองปรู","บ้านหนองปล้อง","บ้านหนองปล้องโพช","บ้านหนองปลา","บ้านหนองปลาขาว","บ้านหนองปลาเข็ง","บ้านหนองปลาคูณ","บ้านหนองปลาซิว","บ้านหนองปลาดุก","บ้านหนองปลาดุกศรีวิทยา","บ้านหนองปลาแดก","บ้านหนองปลาตอง (ประชาวิทยาคาร)","บ้านหนองปลาน้อย (สุทธะเรืองศิลป์)","บ้านหนองปลาปาก","บ้านหนองปลาปึ่งหนองเบ็น","บ้านหนองปลามัน","บ้านหนองปลามันหนองไร่","บ้านหนองปลาสะเด็ด","บ้านหนองปลาสะวาย (ศรีวิชัยประชานุสรณ์)","บ้านหนองปลาหมอศรีสง่า","บ้านหนองปลาหมัดบัวงาม","บ้านหนองปลาไหล","บ้านหนองปลาไหล (ปรีชาราษฎร์รังสรรค์)","บ้านหนองปลาไหลราษฎร์บำรุง","บ้านหนองปลิง","บ้านหนองปอ","บ้านหนองปอแดง","บ้านหนองปักหลัก","บ้านหนองปากชัฎ","บ้านหนองปากดง","บ้านหนองปากโลง (รัฐประชานุเคราะห์)","บ้านหนองป่าก่อ","บ้านหนองปาดฟาน","บ้านหนองป่าตอ","บ้านหนองป้าน","บ้านหนองป่าไร่","บ้านหนองป่าอ้อย","บ้านหนองปิง","บ้านหนองปิงโปง","บ้านหนองปิด","บ้านหนองปีกนก","บ้านหนองปืนแตก","บ้านหนองปุน","บ้านหนองปุหลก","บ้านหนองเป็ด","บ้านหนองเป็ด (เกษตรศาสตร์อนุสรณ์)","บ้านหนองเป็ดน้ำ (สวัสดิ์ราษฎร์วิทยา)","บ้านหนองเปล","บ้านหนองเปล่ง","บ้านหนองเปลือยตาแสง","บ้านหนองเป้า","บ้านหนองเป่าปี่","บ้านหนองแปก","บ้านหนองแปน","บ้านหนองโป่ง","บ้านหนองโป่งราษฎร์บำรุง","บ้านหนองผง","บ้านหนองผักกาด","เทศบาล 5 บ้านหนองผักก้าม","บ้านหนองผักจิก","บ้านหนองผักชี","บ้านหนองผักตบ","บ้านหนองผักตบโพนเพ็ก","บ้านหนองผักเทียม","บ้านหนองผักบุ้ง","บ้านหนองผักแพว","บ้านหนองผักโพด","บ้านหนองผักไร","บ้านหนองผักแว่น","หนองผักแว่นโป่งสังข์วิทยา","บ้านหนองผักแว่นดอนเขือง","บ้านหนองผักหนอก","บ้านหนองผักหนาม","บ้านหนองผักหลอด","บ้านหนองผ้าขาว","บ้านหนองผ้าอ้อม","บ้านหนองผำ","บ้านหนองผำโคกสวรรค์","บ้านหนองผือ","หนองผือวิทยาคม","บ้านหนองผือโปร่งคำ","บ้านหนองผือกอบง","บ้านหนองผือจำเริญพัฒนา","บ้านหนองผือท่าปากเป่ง","บ้านหนองผือน้อย (สันติราษฎร์บำรุง)","บ้านหนองผือ-โนนค้อ","บ้านหนองผือโนนแคน","บ้านหนองผือโพนศรีสามัคคี","บ้านหนองผือราษฎร์บำรุง","บ้านหนองผือราษฎร์ประสิทธิ์ และบ้านดอนกอก","บ้านหนองผุก","บ้านหนองผูกเต่า","บ้านหนองผู้เฒ่า","บ้านหนองเผาถ่าน (ประชาประสิทธิ์)","บ้านหนองไผ่","บ้านหนองไผ่ (ยอดราษฎร์บำรุง)","บ้านหนองไผ่หนองหิน","บ้านหนองไผ่ (วัดเวฬุวันอุปถัมภ์)","บ้านหนองไผ่แก้ว (พูลสุขสหการอุปถัมภ์)","บ้านหนองไผ่แก้ว","บ้านหนองไผ่ด้ามขวาน","บ้านหนองไผ่ดุสิตประชาสรรค์","บ้านหนองไผ่นาดี","บ้านหนองไผ่พัฒนา","บ้านหนองไผ่พิทยาคม","บ้านหนองไผ่-มาบชุมแสง","บ้านหนองไผ่ล้อม","บ้านหนองไผ่ล้อม ","บ้านหนองไผ่ลุ่ม","บ้านหนองไผ่วิทยา","บ้านหนองไผ่หนองหว้า","บ้านหนองไผ่ใหญ่","บ้านหนองฝั่งแดง","บ้านหนองฝาง","บ้านหนองฝาง (บัวค้ำวิทยา)","บ้านหนองฝ้าย","บ้านหนองเฝ้า","บ้านหนองแฝก","บ้านหนองแฝกยางเครือ","บ้านหนองพง","บ้านหนองพงนก","บ้านหนองพงเล็ก","บ้านหนองพญา","บ้านหนองพยอม","บ้านหนองพรหม","บ้านหนองพระ","หนองพระบางตลาดม่วง","บ้านหนองพรานปาน","บ้านหนองพรานพุก","บ้านหนองพลวง","บ้านหนองพลวงน้อย","บ้านหนองพลวงใหญ่","บ้านหนองพลอง","บ้านหนองพลับ","บ้านหนองพลับ (อินทจิตบำรุง)","บ้านหนองพอก","บ้านหนองพอกน้อย","บ้านหนองพะแนง","บ้านหนองพะอง","บ้านหนองพัง","บ้านหนองพังพวย","บ้านหนองพันทา","บ้านหนองพานแยบัวห้าว","บ้านหนองพิกุล (วิชิตนาคอุปถัมภ์)","บ้านหนองพิกุล","บ้านหนองพิมาน","บ้านหนองพีพ่วน","บ้านหนองพู่วังหินซา","บ้านหนองเพชร","บ้านหนองเพดาน","บ้านหนองเพรางาย (สลากกินแบ่งสงเคราะห์ที่ 364 หอม-บุญนาคอนุเคราะห์)","บ้านหนองเพิก","บ้านหนองเพียน","บ้านหนองแพงพวย","บ้านหนองโพด (สพท.อบ.5)","บ้านหนองโพงโพด","บ้านหนองโพด","บ้านหนองโพดเพชรพิทยา","บ้านหนองโพธิ์","บ้านหนองโพธิ์ มิตรภาพที่ 129","บ้านหนองโพธิ์นามาบ","บ้านหนองโพธิ์วังโน","บ้านหนองโพนงาม","บ้านหนองโพลง","บ้านหนองฟ้า","บ้านหนองฟานยืน","บ้านหนองแฟบ","บ้านหนองแฟบ (วุฒิรัฐประชาสรรค์)","บ้านหนองมงคล","บ้านหนองมดแดง (ราษฎร์ประสิทธิ์วิทยาคม)","บ้านหนองมน","บ้านหนองมวง","บ้านหนองม่วง","หนองม่วงประชานุกูล","บ้านหนองม่วงราษฎร์อุทิศ","บ้านหนองม่วง และสาขาบะยาวมลชัยศรี","หนองม่วงชมพูทอง","บ้านหนองม่วงไข่ (ม่วงไข่วิทยาคาร)","บ้านหนองม่วงช่างพิม","บ้านหนองม่วงโนนงิ้ว","บ้านหนองม่วงบำรุง","บ้านหนองม่วงพัฒนา","บ้านหนองม่วงวิทยาคาร","บ้านหนองม่วงหนองแต้","บ้านหนองม่วงหลุบคา","บ้านหนองม่วงหวาน","บ้านหนองม่วงใหญ่","บ้านหนองม่วงใหญ่หนองตานา","บ้านหนองม่วน","บ้านหนองมะกอก","บ้านหนองมะเกลือ","บ้านหนองมะเกาะ","วัดหนองมะขาม","บ้านหนองมะขาม","บ้านหนองมะเขือ","บ้านหนองมะเขือหนองตานา","บ้านหนองมะคัง (จ่างอนุสรณ์)","บ้านหนองมะค่า","วัดหนองมะค่า","บ้านหนองมะค่า (ทองศรีสงเคราะห์)","บ้านหนองมะค่าแต้","บ้านหนองมะงง","บ้านหนองมะจับ","บ้านหนองมะแซว","บ้านหนองมะทอ","บ้านหนองมะปริง","บ้านหนองมะม่วง","บ้านหนองมะเม้า","บ้านหนองมะล้อห้วยทรายขาว","บ้านหนองมะสัง","บ้านหนองมะเสี่ยงโนนม่วง","หนองมังโนนกลางห่องแดง","บ้านหนองมั่ง","บ้านหนองมัน","บ้านหนองมันปลา","บ้านหนองมันปลา ","บ้านหนองม้า","บ้านหนองมาก","บ้านหนองมุก","บ้านหนองเม็ก","บ้านหนองเม็ก (สถาพรประชานุเคราะห์)","บ้านหนองเม็กพิทยา","บ้านหนองเม็กหนองทุ่มโนนศิลาประชาสรรค์","บ้านหนองเม็กห้วยทราย","บ้านหนองเมน","อนุบาลวังไทร สาขาบ้านหนองเม่น","อนุบาลเมืองเมยวดี","บ้านหนองเมา","บ้านหนองเมืองกลาง","บ้านหนองเมืองต่ำ","บ้านหนองเมืองน้อย","บ้านหนองแมงดา","บ้านหนองแม่แตง (ธรรมศาสตร์อาสา)","บ้านหนองแม่นา","บ้านหนองแมว","บ้านหนองโมก","บ้านหนองไม้","บ้านหนองไม้กอง","บ้านหนองไม้แก่น","บ้านหนองไม้งาม","บ้านหนองไม้งาม 1","บ้านหนองไม้งาม 2","บ้านหนองไม้แดง","บ้านหนองไม้ตาย","บ้านหนองไม้ตายหนองซองแมว","บ้านหนองไม้ถี่","บ้านหนองไม้ไผ่","บ้านหนองไม้ยางดำ","บ้านหนองไม้สอ","บ้านหนองไม้สัก","บ้านหนองยวน","บ้านหนองยอโพนแพง","บ้านหนองยาง","หนองยางวิทยาคม","ชุมชนหนองยางหนองม่วง","บ้านหนองยาง (ธนาคารกรุงเทพ10)","บ้านหนองยาง (อนุศาสนานุสรณ์)","บ้านหนองยางไคล","บ้านหนองย่างงัว","บ้านหนองย่างช้าง","บ้านหนองย่างทอย","บ้านหนองย่างแลนหนองทุ่ม","บ้านหนองยางหนองไผ่","บ้านหนองย่างหมู","บ้านหนองยางห้วยสะแบก","บ้านหนองยายดา","บ้านหนองยายพิมพ์ (ไตรคามประชาสรรค์)","วัดสำเภาทอง (บ้านหนองยายเภา)","บ้านหนองยายแม็ม","บ้านหนองยายหมาด","บ้านหนองยายเอม","บ้านหนองยารักษ์-ลำโพง (รัฐประชาสรรค์)","บ้านหนองยาว","บ้านหนองยาว (ราษฎร์สามัคคีรังสรรค์)","บ้านหนองยิงหมี","บ้านหนองยูง","บ้านหนองโยโคกปืด","บ้านหนองใยบัว","บ้านหนองร่ม","บ้านหนองรวก","บ้านหนองระกำ","บ้านหนองระฆัง","บ้านหนองระนาม","บ้านหนองระมาน","บ้านหนองระเยียว","บ้านหนองระเวียง","บ้านหนองระแวง","บ้านหนองระหาน (สามัคคีพลาคาร)","บ้านหนองระแหง","บ้านหนองรัก","บ้านหนองรักษ์","บ้านหนองรัง","บ้านหนองรังกา","บ้านหนองรังมิตรภาพที่ 107","บ้านหนองรังสิต","บ้านหนองราชวัตร","บ้านหนองร้าน","บ้านหนองร้านหญ้าโนนข่า","บ้านหนองราโพ","บ้านหนองริ้น","บ้านหนองรี","บ้านหนองรี ","บ้านหนองรุง","บ้านหนองรุงพระทะเล","บ้านหนองรูแข้","บ้านหนองเรี้ย","บ้านหนองเรียน","บ้านหนองเรือ","บ้านหนองแร้ง (แหลมสุขประชานุกูล)","บ้านหนองแรต","บ้านหนองโรง","บ้านหนองไร่จันทร์เกษม","บ้านหนองไร่","บ้านหนองไรไก่","บ้านหนองละมั่ง","บ้านหนองละมั่งทอง","บ้านหนองละมาน","บ้านหนองละลอก","บ้านหนองละหานทราย","บ้านหนองลังกา","บ้านหนองลันราษฎร์บำรุง","บ้านหนองล้างช้าง","บ้านหนองลาด","บ้านหนองลาดหนองแปนคำผักกูด","บ้านหนองลาด (ราษฎร์ประสิทธิ์สุทธิสุวรรณ)","บ้านหนองลาด (ราษฎร์อุทิศวิทยาคม)","บ้านหนองลาดควาย ","บ้านหนองลาดควาย","บ้านหนองลาดวิทยาคาร","บ้านหนองลาน","บ้านหนองล่าม","บ้านหนองลาว","บ้านหนองลีวิทยาคม","บ้านหนองลุง","บ้านหนองลุมพุก","อนุบาลหนองบัวแดง","หนองลุมพุกหนองยางสามัคคี","บ้านหนองลุมพุกโนนสว่าง","บ้านหนองลุมพุกบุ่งแสง","บ้านหนองลุมพุกหญ้าม้า","บ้านหนองลูกควาย","บ้านหนองลูกช้าง","บ้านหนองเล","บ้านหนองเลา","บ้านหนองเล้าข้าว","บ้านหนองเลิงคำ","บ้านหนองแล้ง","บ้านหนองแลงระไง","บ้านหนองวัดป่า","บ้านหนองวัลย์เปรียง","บ้านหนองวัวชุม","บ้านหนองวัวดำ","บ้านหนองวัวแดง","บ้านหนองแวง","บ้านหนองแวงสหคามวิทย์","บ้านหนองแวงประชาราษฎร์อำนวย","ชุมชนบ้านหนองแวง (คุรุราษฎร์อุปถัมภ์)","บ้านหนองแวง (โสวรรณีวิทยาคม)","บ้านหนองแวงคำ","บ้านหนองแวงคูป่าชาติ","บ้านหนองแวงงิ้วตาก","บ้านหนองแวงจุมพล","บ้านหนองแวงเดิดเกษตรสมบูรณ์","บ้านหนองแวงตอตั้ง","บ้านหนองแวงตาด","บ้านหนองแวงท่าวัด","บ้านหนองแวงนอก","บ้านหนองแวงน้อย","บ้านหนองแวงนางเบ้า","บ้านหนองแวงโนนขี้เหล็ก","บ้านหนองแวงบกไผ่ล้อมวิทยา","บ้านหนองแวงบวรวิทย์","บ้านหนองแวงบ่อแก้ว","บ้านหนองแวงประชาสรรค์","บ้านหนองแวงเป่ง","บ้านหนองแวงโพนเขวา","บ้านหนองแวงภูเขา","บ้านหนองแวงมน","บ้านหนองแวงยาว","บ้านหนองแวงไร่","บ้านหนองแวงสวนกล้วย","บ้านหนองแวง สาขาบ้านโนนรัง","บ้านหนองแวงสามัคคี","บ้านหนองแวงโสกพระ","บ้านหนองแวงหนองจิกโนนตุ่น","บ้านหนองแวงหนองตุ","บ้านหนองแวงหนองหัวคน","บ้านหนองแวงแห่","บ้านหนองแวงใหญ่","บ้านหนองแวงฮี","บ้านหนองแว่น","บ้านหนองศรีจันทร์","บ้านหนองศรีเจริญ-หนองผึ้ง","บ้านหนองศรีทองสว่างวิทย์","บ้านหนองศรีวิชัย","บ้านหนองศาลเจ้า","บ้านหนองศาลา","บ้านหนองศาลาโนนสว่าง","บ้านหนองศาลาป่าชาด","บ้านหนองศาลาราษฎร์บำรุง","ศิริราษฏร์หมากหญ้า","บ้านหนองศิลา (พรชุมชนวิทยา)","บ้านหนองไศล","บ้านหนองสทิต","บ้านหนองสนม","บ้านหนองสนมดอนติ้ว","บ้านหนองสนวน","บ้านหนองสนิท","บ้านหนองสนุ่น","บ้านหนองสมบูรณ์","บ้านหนองสรวง","บ้านหนองสรวงหนองซำ","บ้านหนองสระ","บ้านหนองสระพัง","บ้านหนองสระพังโนนสะอาด","บ้านหนองสระพังทอง","บ้านหนองสระหงส์","บ้านหนองสร้างไพร","บ้านสร้างหมากแข้ง","บ้านหนองสลักได","บ้านหนองสลัดได","บ้านหนองสลิด","บ้านหนองสลุด","บ้านหนองสวง","บ้านหนองสวง (อสพป.2)","บ้านหนองสวรรค์ (ไชยเชียงพิณ)","บ้านหนองสว่าง","บ้านหนองสองตอน","บ้านหนองสองพี่น้อง","บ้านหนองสองห้อง","บ้านหนองสองห้อง (เทพผาประชานุกูล)","บ้านหนองสองห้อง (คุรุราษฎร์บำรุง)","บ้านหนองสองห้องทรัพย์เจริญ","บ้านหนองสองห้องหนองแห้วโนนศรี","บ้านหนองสะแก","บ้านหนองสะแก (ราษฎร์บำรุง)","บ้านหนองสะแกยาว","บ้านหนองสะแกสน","บ้านหนองสะแกสี่","บ้านหนองสะโน","บ้านหนองสะโนนาสมบูรณ์","บ้านหนองสะไนราษฎร์รังสฤษฏ์","บ้านหนองสะบ้า","บ้านหนองสะแบง","บ้านหนองสะแบงศรีชุมพร","บ้านหนองสะแบงสามัคคี","บ้านหนองสะแบงหนองโน","บ้านหนองสะพาน","บ้านหนองสะมอน","บ้านหนองสะหนาย","บ้านหนองสะเอ้ง","บ้านหนองสัง (ไลอุทิศ)","บ้านหนองสังข์","ชุมชนหนองสังข์","บ้านหนองสาดโนนเจริญ","บ้านหนองสานแตร","อนุบาลภูพาน","บ้านหนองสามขา","บ้านหนองสามขา ดอนแก้ว","บ้านหนองสามพญา","บ้านหนองสามพราน","บ้านหนองสามสีหนองดินดำ","บ้านหนองสาย","บ้านหนองสาร","บ้านหนองส้าวโพนงอยประชาชื่น","บ้านหนองสาหร่าย","บ้านหนองสำราญ","บ้านหนองสำราญหนองเรือ","บ้านหนองสำโรง","บ้านหนองสำโรงน้อย","บ้านหนองสิม","เทศบาล ๑ (หนองสิมใหญ่)","บ้านหนองสีซอ","บ้านหนองสีดา","บ้านหนองสีนวล","บ้านหนองสุขสันต์","บ้านหนองสุวรรณ (ราษฎร์สงเคราะห์)","บ้านหนองสูน","บ้านหนองเสม็ด","บ้านหนองเสมา","บ้านหนองเสา","บ้านหนองเสาเดียว","บ้านหนองเสาเถียร","บ้านหนองเสาเล้า","บ้านหนองเสียวชัยมงคล","บ้านหนองเสี้ยว","บ้านหนองเสี้ยว (ประชาสรรค์)","บ้านหนองเสือ","หนองเสือพิทยาคม","บ้านหนองเสือช้าง","บ้านหนองเสือบอง","บ้านหนองแสง","บ้านหนองแสงทุ่มยาว","บ้านหนองแสงโคกสะอาด","บ้านหนองแสงดงอีบ่าง","ชุมชนหนองแสง","บ้านหนองแสงแสงแก้ว","บ้านหนองแสงจริญพัฒนา","หนองแสงวิทยาสรรค์","บ้านหนองแสง (หนองแสงราษฎร์วิทยา)","บ้านหนองแสงคำ","บ้านหนองแสงโคกน้อย","บ้านหนองแสงท่าดอนม่วย","บ้านหนองแสงทุ่ง","บ้านหนองแสงน้อย","บ้านหนองแสงนาล้อม","บ้านหนองแสง-วังอ่าง","ชุมชนบ้านห้วยโจดโคกสะอาด สาขาบ้านหนองแสงวิทยา","บ้านหนองแสงวิทยา","บ้านหนองแสงสว่างวิทย์","บ้านหนองแสงสามัคคี","บ้านหนองแสงหนองเม็ก","บ้านหนองแสงใหญ่","บ้านหนองแสลบ","บ้านหนองโสกดาว","บ้านหนองโสน","บ้านหนองโสน (รัฐราษฎร์บำรุง)","บ้านหนองโสมง","ชุมชนหนองใสใหม่สามัคคี","เทศบาล1 หนองใส","บ้านหนองหงษ์","บ้านหนองหงษ์หนองงู","บ้านหนองหงส์","บ้านหนองหงอก","บ้านหนองหญ้า","บ้านหนองหญ้าโก้ง","บ้านหนองหญ้าขาว","บ้านหนองหญ้าข้าวนก","บ้านหนองหญ้าคา","บ้านหนองหญ้าไซ","บ้านหนองหญ้าไซย์","บ้านหนองหญ้าปล้อง","บ้านหนองหญ้าปล้องวิทยา","บ้านหนองหญ้าปล้อง (สำนักงานสลากกินแบ่งสงเคราะห์ 60)","บ้านหนองหญ้าปล้อง (อุดมวนา)","บ้านหนองหญ้าปล้องขัวสูง","บ้านหนองหญ้าปล้องพัฒนา","บ้านหนองหญ้าปล้องหนองหว้า","บ้านหนองหญ้าแพรกท่าแร่","บ้านหนองหญ้าม้า","บ้านหนองหญ้ามุ้ง","บ้านหนองหญ้ารังกา","หนองหญ้ารังกาหนองส่วยดอนดู่","บ้านหนองหญ้ารังกาห้วยขุมปูน","บ้านหนองหญ้าลาด","บ้านหนองหญ้าวัว","บ้านหนองหน่อง","บ้านหนองหนอน","บ้านหนองหนาม","บ้านหนองหนามแท่ง","บ้านหนองหนาว","บ้านหนองหมอ","บ้านหนองหม้อ","บ้านหนองหม้อข้าว (ศิริทวีอุปถัมภ์)","บ้านหนองหมาก","บ้านหนองหมากแก้ว","บ้านหนองหมากแซว","บ้านหนองหมี","บ้านหนองหมีหัวดง (ประชาวิทยาคาร)","บ้านหนองหมื่น","บ้านหนองหมื่นชัย","บ้านหนองหมื่นถ่าน","บ้านหนองหมู","บ้านหนองหมูน้อย","บ้านหนองหรี่","บ้านหนองหล่ม","บ้านหนองหล่มคลองเตย","บ้านหนองหล่มหนองเซือมใต้","บ้านหนองหล่มหนองเหล่า","บ้านหนองหลวง","ท่านผู้หญิงพรสม กุณฑลจินดา","บ้านหนองหลอด","บ้านหนองหลัก","บ้านหนองหลักช้าง","บ้านหนองหลักศิลา","บ้านหนองหลักสามัคคี","บ้านหนองหลุบ","บ้านหนองหลุมพอ","บ้านหนองห้วยฝาด","บ้านหนองหว้า","บ้านหนองหว้า (ถนอมราษฎร์บำรุง)","บ้านหนองหว้าหนองหญ้าขาว","บ้านหนองหว้า ","บ้านหนองหว้าวิทยาสรรค์","บ้านหนองหว้า (ชมายนุกูล)","บ้านหนองหว้า (ประชาสรรค์)","บ้านหนองหว้ากุดไก่แก้ว","บ้านหนองหว้าขุนอัดวิทยา","บ้านหนองหว้าเข้ากรรม","บ้านหนองหว้าเฒ่า","บ้านหนองหว้าดอนตะเกียด","บ้านหนองหว้าตาดำ","บ้านหนองหว้าทับทัย","บ้านหนองหว้านาคำพัฒนา","บ้านหนองหว้าโนนทอง","บ้านหนองหว้าประชารัฐ","บ้านหนองหว้าประชาสามัคคี","บ้านหนองหว้าประชาอาสา","บ้านหนองหว้าโพนศิลา","บ้านหนองหวาย","บ้านหนองหว้าสามัคคี","บ้านหนองหว้าสุขใจ","บ้านหนองหว้าหนองแคนดอนบาก","บ้านหนองหว้าหนองไผ่","บ้านหนองหว้าเอน","บ้านหนองหอย","หนองหอยเทพเทวัญ","บ้านหนองหอยโข่ง","บ้านหนองหอยคัน","บ้านหนองหอยคำอ้อม","หนองหอยปังบำเหน็จวิทยา","บ้านหนองหอยป่าหวาย","บ้านหนองหอยใหญ่","บ้านหนองหัน","บ้านหนองหัวคน","บ้านหนองหัวควาย","บ้านหนองหัวคู","บ้านหนองหัวงัว","บ้านหนองหัวช้าง","บ้านหนองหัวช้างดอนพันชาด","บ้านหนองหัวปลวก","บ้านหนองหัวยาง","บ้านหนองหัวเรือ","บ้านหนองหัวแรด","บ้านหนองหัวลิงหนองขอน","บ้านหนองหัววัว","บ้านหนองหัวหมู","บ้านหนองหัวหมู (บำรุงราษฎร์อุปถัมภ์)","บ้านหนองห่าง","บ้านหนองห้าง","บ้านหนองห้างหนองกวาง","บ้านหนองหาดใหญ่","บ้านหนองหาน (วันครู 2502)","บ้านหนองห่าน (ประชาสามัคคี)","บ้านหนองห้ามิตรภาพที่ 125","บ้านหนองหาร (ทิพวันอุทิศ)","บ้านหนองหารจาง","บ้านหนองหิ้งโคกเจริญ","บ้านหนองหิ่งหาย","บ้านหนองหิน","บ้านหนองหิน (อสพป.15)","บ้านหนองหินโคน","บ้านหนองหินน้อย","บ้านหนองหูช้าง","บ้านหนองเหมือดเมี่ยง","บ้านหนองเหมือดแอ่","บ้านหนองเหรียง","บ้านหนองเหล็ก","บ้านหนองเหล็กประชาพัฒน์","บ้านหนองเหล็ก (กองทัพบกอุปถัมภ์)","บ้านหนองเหล็กธาตุน้อย","บ้านหนองเหล็กโนนหนองหว้า","บ้านหนองเหล็กราษฎร์วิทยา","บ้านหนองเหล่า","บ้านหนองเหล่า (ราษฎร์บำรุงวิทยาคาร)","หนองเหลืองขามนคร","บ้านหนองเหี่ย","บ้านหนองเหียง","บ้านหนองแห้ง","บ้านหนองแหน","บ้านหนองแหนดอนกู่","บ้านหนองแหย่ง","บ้านหนองแห้ว","บ้านหนองแหวน","บ้านหนองแห้วพัฒนา","บ้านหนองแห้วปรางค์กู่","บ้านหนองแห้วหนองบัวทอง","บ้านหนองใหญ่","บ้านหนองใหญ่พัฒนา","บ้านหนองใหญ่ (คุรุราษฏร์อุปถัมภ์)","บ้านหนองใหญ่-ตาไทย","บ้านหนองใหญ่ทับครัว","บ้านหนองไห","บ้านหนองไหล (พุธเพิ่มวัฒนราษฎร์)","บ้านหนองไหลหนองบัวทอง","บ้านหนองอนามัย","บ้านหนองอ้ม","บ้านหนองอรุณ","บ้านหนองออ","บ้านหนองอ้อ","บ้านหนองอ้อ (ราษฏร์สามัคคี)","บ้านหนองอ้อโคกสว่าง","บ้านหนองอ้อน้อย","บ้านหนองอั้ว","บ้านหนองอาคูณ","บ้านหนองอ่างดอกรัก","บ้านหนองอําเภอจีน","บ้านหนองอาแมะ","บ้านหนองอ้ายสาม","บ้านหนองอาสา","บ้านหนองอิงพิง","บ้านหนองอิไทย","บ้านหนองอิโล","บ้านหนองอิอู","บ้านหนองอีกว่าง","บ้านหนองอีเก้ง","บ้านหนองอีเข็ม","บ้านหนองอีดำ","บ้านหนองอีโถน","บ้านหนองอียอ","บ้านหนองอีเลิง","บ้านหนองอีหล่อ","บ้านหนองอีเห็น","บ้านหนองอีเหลอ","บ้านหนองอึ่งโปโล","บ้านหนองอุ","บ้านหนองอุ่ม","บ้านหนองอุมลัว","บ้านหนองอุโลก","บ้านหนองเอาะหนองสิม","บ้านหนองเอียน","บ้านหนองเอี่ยน","บ้านหนองเอี่ยนดง ","บ้านหนองเอี่ยว","บ้านหนองแอก","บ้านหนองแอกดอนสวรรค์","บ้านหนองโอใหญ่","บ้านหนองโอง","วัดบ้านหนองโอ่ง","บ้านหนองโอนหนองฮาง","บ้านหนองฮะ","บ้านหนองฮังแหลว","บ้านหนองฮาง","บ้านหนองฮ่าง-สันหลวง","บ้านหนองฮี","บ้านหนองฮีหนองแคน","บ้านหนองฮูฝอยลม","บ้านหนองแฮหนองเหล็ก","บ้านหนองไฮ","บ้านหนองไฮ (เมฆวิทยาคาร)","บ้านหนองไฮขามเปี้ย","บ้านหนองไฮโคกสง่า","บ้านหนองไฮใต้","บ้านหนองไฮโนนสำราญ","บ้านหนองไฮประชาสรรค์","บ้านหนองไฮโพธิ์ชัย","บ้านหนองไฮ-วังขอนยม","บ้านหนองไฮวิทยา","บ้านหนองไฮหนองแวง","บ้านหนองไฮเหนือ","บ้านหน่อมฟ้าเลื่อมวิทยา","บ้านหนับเภา","บ้านหน้ากลองวิทยา","บ้านหน้าเขา","บ้านหน้าเขาใต้ร่มเย็น 1","บ้านหน้าเขาวัด","บ้านหน้าควน","บ้านหน้าควนลัง","บ้านหน้าค่าย","บ้านหน้าซึง","บ้านหนาด","บ้านหนาด ","บ้านหนาดสงเคราะห์","บ้านหน้าทอง","บ้านหน้าฝายบึงตาโพ","บ้านหน้าพระธาตุ","บ้านหนามแท่งไชยประสิทธิ์","บ้านหนามแท่ง","บ้านหน้าวัง","บ้านหน้าวัดโพธิ์","บ้านหน้าศาล","บ้านหน้าสถานี","บ้านหน้าเหมน","บ้านหน่ำฮั้ว","บ้านหนุก","บ้านหนุน","บ้านหนุนใต้ (หนุนราษฎร์บำรุง)","บ้านหม้อ","บ้านหม่องกระแทะ","บ้านหมอตา","บ้านหม้อทอง","บ้านหมอนสูง","บ้านหมอแปง","บ้านหมอมุ่ย","บ้านหมอสม","บ้านหม้อเหนือ (หลวงปู่เหรียญอุปถัมภ์)","บ้านหมัด (คุรุรัฐสงเคราะห์)","บ้านหมัน","บ้านหมาก","บ้านหมากก่องฝายแตก","บ้านหมากเขียบ","บ้านหมากแข้ง","บ้านหมากแข้งกกกอก","บ้านหมากตูมดอนยานาง","บ้านหมากบ้าเลาโคกกลาง","บ้านหมากปรก","บ้านหมากพริก","บ้านหมากมายโพธิ์ทอง","บ้านหมากมาย","บ้านหมากมี่","บ้านหมากยาง","บ้านหมากหญ้า","บ้านหมากหม้อโนนเกษตร","บ้านหมากหัววัง","บ้านหมากหุ่งขี้เหล็ก","บ้านหมากแหน่ง","บ้านหม่านศรีทองวิทยา","บ้านหมี่เหล่าน้อย","บ้านหมื่นข้าว","บ้านหมื่นจิต","บ้านหมื่นเทพ","อนุบาลบ้านค่ายหมื่นแผ้ว","บ้านหมื่นฤาชัย","บ้านหมื่นไวย","บ้านหมื่นศรีน้อย","หมื่นศรีประชาสรรค์","บ้านหมุ้น","ชุมชนหมูม่นวิทยาสรรค์","บ้านหมูม้น","บ้านหมูม่นโพนสว่าง","บ้านหมูสี","บ้านหยงสตาร์","บ้านหยวก","บ้านหย่วน (เชียงคำนาคโรวาท)","บ้านหยอด","บ้านหยีในสามัคคี","บ้านหรรษา (เจริญประชานุเคราะห์)","บ้านหร่ายการ้อง","บ้านหลวง","บ้านหลวงแจ้ซ้อน","บ้านหลวงใต้","บ้านหลวงหัวสวย","บ้านหลวงเหนือ (วิทิตตานุกูล)","บ้านหลัก","บ้านหลักเขต","บ้านหลักด่าน","บ้านหลักด่านหนองจอก","บ้านหลักแดนห้วยโป่งพัฒนา","บ้านหลักปัน","บ้านหลักป้ายประชานุเคราะห์","บ้านหลักเมตร (พริ้งมากราษฎร์อนุสรณ์)","บ้านหลักเมตร","บ้านหลักร้อย","บ้านหลักศิลา","บ้านหลักสิบเก้าสามัคคี","บ้านหลังเขา","บ้านหลังท่อ","บ้านหลังสวนประชาสามัคคี","บ้านหลังสอด","บ้านหลังโสด","บ้านหลับมืนพรวน","บ้านหล่าย","บ้านหล่ายแก้ว","บ้านหล่ายขานาง","บ้านหล่ายทา","บ้านหล่ายท่า","บ้านหล่ายทุ่ง","บ้านหล่ายฝาง","บ้านหล่ายฝายแก้ว","บ้านหล่ายฮ่องปุ๊","บ้านหลุก","บ้านหลุง (ใหม่บุรพาคม)","บ้านหลุง","บ้านหลุ่งตะเคียน","บ้านหลุ่งประดู่","บ้านหลุบกุง","บ้านหลุบควันเมืองหงส์","บ้านหลุบคา","บ้านหลุบค่าย","บ้านหลุบงิ้ว","บ้านหลุบแซง","บ้านหลุบปึ้ง","บ้านหลุบเพ็ก","บ้านหลุบโพธิ์","บ้านหลุบเลา","บ้านหลุบหวายป่าขาม","บ้านหลุบอินทรราษฎร์บำรุง","บ้านหลุมข้าว","บ้านหลุมเข้า มิตรภาพที่ 117","บ้านหลุมเงิน","บ้านหลุมหิน","บ้านหลู้","บ้านห้วงกระแจะ (สวัสดิชัยอุปถัมภ์)","บ้านห้วงปลาไหล ","บ้านห้วงพัฒนา","บ้านห้วงสลิด","บ้านห้วงหิน","บ้านหวด","บ้านห้วย","บ้านห้วย (คุรุประชาคาร)","บ้านห้วยกนทา","บ้านห้วยกบ","บ้านห้วยกรด","บ้านห้วยกรวด","บ้านห้วยกระต่าย","บ้านห้วยกระทิง","บ้านห้วยกรุ","บ้านห้วยกล้า","บ้านห้วยกลาง","บ้านห้วยกวางจริง","บ้านห้วยกวางทอง","บ้านห้วยกว๊าน","บ้านห้วยกอก","บ้านห้วยกอก 1","บ้านห้วยกอก2","บ้านห้วยกอกพัฒนา","บ้านห้วยกอกหนองเค็ม","บ้านห้วยกองก้าด","บ้านห้วยกองเป๊าะ","บ้านห้วยกองมูลและสาขา","บ้านห้วยกองสี","บ้านห้วยก้อด","บ้านห้วยก้อม","บ้านห้วยกะทะทอง","บ้านห้วยกะปิ","บ้านห้วยกะโปะ","บ้านห้วยกะโหลก","บ้านห้วยกั้ง","บ้านห้วยก้างรัฐประชาสงเคราะห์","บ้านห้วยกาน และรร.บ้านทุ่งม่าน","บ้านห้วยกาน (รัฐราษฎร์อุปถัมภ์)","บ้านห้วยก้านเหลือง","บ้านห้วยกาบเปลือย","บ้านห้วยกุ้ง","บ้านห้วยกุ่ม","บ้านห้วยกูด","บ้านห้วยกู่ป๊ะ","บ้านห้วยเกตุ","บ้านห้วยเกษียร","บ้านห้วยเกิ้ง ","บ้านห้วยเกี๋ยง","บ้านห้วยแกดอนหันหนองหญ้าม้า","บ้านห้วยแก้งหนองศาลา","บ้านห้วยแกลบ","บ้านห้วยแก้ว","บ้านห้วยแก้วมิตรภาพที่ 51","บ้านห้วยแก้วสามัคคีธรรม","บ้านห้วยแก้วห้วยสำราญ","บ้านห้วยโก๋น","บ้านห้วยไก่ป่าวิทยา","บ้านห้วยไก่ป่า","บ้านห้วยขม","บ้านห้วยขวาง","บ้านห้วยขอน (ญาณศรัทธาสามัคคี)","บ้านห้วยขอนหาด","บ้านห้วยขอบห้วยเหียม","บ้านห้วยข่อย","บ้านห้วยข่อย สาขาบ้านซำบุ่น","บ้านห้วยขะยุง (คุรุพานิชวิทยาคาร)","บ้านห้วยข่า","บ้านห้วยข่าเฒ่า","บ้านห้วยขาน","บ้านห้วยข่าโนนสมบูรณ์","บ้านห้วยข้าวลีบ","บ้านห้วยขี้หนูดอนเพิ่มวิทยา","บ้านห้วยขี้เหล็ก","บ้านห้วยเขย่ง","บ้านห้วยเขว้า","บ้านห้วยไข่เน่า","บ้านห้วยคนทา","บ้านห้วยครั่ง","บ้านห้วยคล้า","บ้านห้วยค้อ","บ้านห้วยคอกหมู","บ้านห้วยคอม","บ้านห้วยคะมะ","บ้านห้วยคัง","บ้านห้วยคำ","บ้านห้วยคำตาล","บ้านห้วยคุ","บ้านห้วยเคียนเหนือ","บ้านห้วยแคน","บ้านห้วยแคนโนนสูง","บ้านห้วยโค้ง","บ้านห้วยไค้","บ้านห้วยไคร้","บ้านห้วยงาช้าง","บ้านห้วยงูกลาง","บ้านห้วยงูสิงห์","บ้านห้วยงูเหลือม","บ้านห้วยจรเข้","บ้านห้วยจอย","บ้านห้วยจะค่าน ตชด.อนุสรณ์","ห้วยเจริญวิทยา","บ้านห้วยเจริญ","บ้านห้วยเจริญราษฎร์","บ้านห้วยเจียง","บ้านห้วยโจด","บ้านห้วยฉลอง","บ้านห้วยชมภู","บ้านห้วยชัน","ห้วยชันวิทยา","บ้านห้วยซัน","บ้านห้วยช่างคำ และสาขาห้วยช่างเหล็ก","บ้านห้วยช้างแทง","บ้านห้วยเชียงหนองอีเบ้า","บ้านห้วยเชือก","บ้านห้วยเซือมใต้","บ้านทิยาเพอ สาขาบ้านห้วยไชยยงค์","บ้านห้วยซ้อ","อนุบาลแม่จริม","บ้านห้วยเซือมเหนือ","บ้านห้วยไซ","บ้านห้วยไซงัว","บ้านห้วยด้วน","บ้านห้วยดอกเข็ม","บ้านห้วยดอกไม้","บ้านห้วยด่าน","บ้านห้วยด้าย","บ้านห้วยดีเลิศ","บ้านห้วยดู่","บ้านห้วยเดื่อ","บ้านห้วยเดื่อโคกสว่าง","บ้านห้วยเดื่อน้อย","บ้านห้วยเดื่อเหนือ","บ้านห้วยแดง","บ้านห้วยต้นตอง","บ้านห้วยตม","บ้านห้วยต้มชัยยะวงศาอุปถัมภ์","บ้านห้วยตลาด","บ้านห้วยตลุง","บ้านห้วยตอ","บ้านห้วยต่อ","บ้านห้วยตอง","บ้านห้วยตะแกะ","บ้านห้วยตะโก","บ้านห้วยตะคร้อ","บ้านห้วยตะแคง","บ้านห้วยตะแคงใต้","บ้านห้วยตะปอก","บ้านห้วยตัดไม้วังเดื่อ","บ้านห้วยตากด้าย","บ้านห้วยตาด","บ้านห้วยตาดำ","บ้านห้วยตามอญ","บ้านห้วยต้าวิทยา","บ้านห้วยตาหมิง","บ้านห้วยติ่ง","บ้านห้วยติ้ว","บ้านห้วยตีนตั่ง","บ้านห้วยตุ้ม (ตุ้มใต้ตระการคุณ)","บ้านห้วยตูม","บ้านห้วยเตย","บ้านห้วยเตยพัฒนา","บ้านห้วยเต่า","บ้านห้วยโตก","บ้านห้วยใต้","บ้านห้วยถั่วใต้","บ้านห้วยทม","บ้านห้วยทรัพย์มิตรภาพที่ 61","บ้านห้วยทราย","บ้านห้วยทรายมิตรภาพที่ 150","บ้านห้วยทราย 1","บ้านห้วยทราย 2","บ้านห้วยทรายขาว","บ้านห้วยทรายคำ","บ้านห้วยทรายทอง","บ้านห้วยทรายทุ่งมน","บ้านห้วยทรายเลื่อน","บ้านห้วยทรายศึกษา","บ้านห้วยทรายเหนือ","บ้านห้วยทอง","บ้านห้วยท้องฟาน","บ้านห้วยทับทอง","บ้านห้วยทับมอญ","บ้านห้วยท่าง","บ้านห้วยท่าช้าง","บ้านห้วยที","บ้านห้วยแทง","บ้านห้วยโทงดอนสวรรค์","บ้านห้วยไทร","บ้านห้วยไทรงาม","บ้านห้วยนกกก และบ้านห้วยนกกก สาขาจ่อคี","บ้านห้วยนกเปล้า (คุ้ย คุรุราษฎร์วิทยา)","บ้านห้วยนกแล","บ้านห้วยน้อย","บ้านห้วยนา","บ้านห้วยนาค","บ้านห้วยนาคราช","บ้านห้วยนาย","บ้านห้วยน้ำแก้ว","บ้านห้วยน้ำขาว","บ้านห้วยน้ำคำ","บ้านห้วยน้ำเค็ม","บ้านห้วยน้ำจาง","บ้านห้วยน้ำโจน","บ้านห้วยน้ำไซ","บ้านห้วยน้ำดำ","บ้านห้วยน้ำดิบ","บ้านห้วยน้ำทรัพย์","บ้านห้วยน้ำเที่ยง","บ้านห้วยน้ำนัก","บ้านห้วยน้ำปลา","บ้านห้วยน้ำผัก","บ้านห้วยน้ำพุ","บ้านห้วยน้ำพุประชาพัฒนา","บ้านห้วยน้ำเมย","บ้านห้วยน้ำเย็น","บ้านห้วยน้ำเย็น มิตรภาพที่ 112","บ้านห้วยน้ำราก (ไตรราษฎร์บำรุง)","บ้านห้วยน้ำลาด","บ้านห้วยน้ำใส","บ้านห้วยน้ำอุ่น","บ้านห้วยนึ่ง","บ้านห้วยเนียม","บ้านห้วยโนนเจริญ","บ้านห้วยโนนพฤกษ์","บ้านห้วยบง","ทาเหนือวิทยา","บ้านห้วยบงดงมะไฟ","บ้านห้วยบง (ธนาคารกรุงเทพฯ 19)","บ้านห้วยบงใต้","บ้านห้วยบงเหนือ","บ้านห้วยบ่อซืน","บ้านห้วยบ่อทอง","บ้านห้วยบอน","บ้านห้วยบาง","บ้านห้วยบุ่นนาทัน","บ้านห้วยปมฝาด","บ้านห้วยประสิทธิ์","บ้านห้วยปราบ","บ้านห้วยปริก","บ้านห้วยปริศนา","วัดไร่แตงทอง","บ้านห้วยปลากั้ง","บ้านห้วยปลาดุก","บ้านห้วยปลาโดศรีสามารถ","บ้านห้วยปลาฝา","บ้านห้วยปลาหลด","บ้านห้วยปอ","บ้านห้วยปันจ๊อย","บ้านห้วยปางผาง","บ้านห้วยป่าซาง","บ้านห้วยป่าน","บ้านห้วยป่าปก","บ้านห้วยปิง","บ้านห้วยปุก","บ้านห้วยปู","บ้านห้วยปูน","บ้านห้วยปูลิง","บ้านห้วยปูเลย","บ้านห้วยเป้ง","บ้านห้วยเปลวเงือก","บ้านห้วยเปล้า","บ้านห้วยเป้า","บ้านห้วยเป้าเหนือ","บ้านห้วยโป้","บ้านห้วยโป่ง","บ้านห้วยโป่ง (ประชานุเคราะห์)","บ้านห้วยโป่งกาน","บ้านห้วยโป่ง-ไผ่ขวาง","บ้านห้วยโป่งอ่อน","บ้านห้วยผักกูด","บ้านห้วยผักขะ","บ้านห้วยผักขะ สาขาไทยเสรี","บ้านห้วยผักเน่า","บ้านห้วยผักไล","บ้านห้วยผา","บ้านห้วยผาก","บ้านห้วยผาลาด","บ้านห้วยผึ้ง","บ้านห้วยผึ้งใหม่","บ้านห้วยผุก","บ้านห้วยโผ","บ้านห้วยไผ่","บ้านห้วยไผ่ขุย","บ้านห้วยไผ่ใต้","บ้านห้วยไผ่โนนคำมี","บ้านห้วยไผ่หนองโน","บ้านห้วยไผ่เหนือ","บ้านห้วยฝรั่ง","บ้านห้วยฝา","บ้านห้วยฝาง","บ้านห้วยฝ้าย","บ้านห้วยพระ","บ้านห้วยพลวง","บ้านห้วยพลับ","บ้านห้วยพลู","บ้านห้วยพลู (ราษฎร์ทิพยานนท์)","บ้านห้วยพลูหนัง","บ้านห้วยพอด","บ้านห้วยพิชัย","บ้านห้วยพุน","บ้านห้วยแพ่ง","บ้านห้วยฟอง","บ้านห้วยฟาน","บ้านห้วยไฟ","บ้านห้วยมงคล","บ้านห้วยม่วง","บ้านห้วยม่วงคุรุราษฎร์รังสรรค์","บ้านห้วยม่วงฝั่งซ้าย","บ้านห้วยมอญ","บ้านห้วยมะกอก","ห้วยมะเกลือวิทยา","บ้านห้วยมะแกง","บ้านห้วยมะเขือส้ม","บ้านห้วยมะซาง","บ้านห้วยมะนาว","บ้านห้วยมะพร้าว","บ้านห้วยมะไฟ","บ้านห้วยมะระ (เทวานุกูลวิทยา)","บ้านห้วยมะหินฝน","บ้านห้วยมัด","บ้านห้วยม้า (สุนทรนิวาส)","บ้านห้วยม้าลอย","บ้านห้วยมาลัย","บ้านห้วยมุด","บ้านห้วยมุ่น","บ้านห้วยเม็ง (ประสาทวิทย์)","บ้านห้วยแมง","บ้านห้วยแม่ซ้าย","บ้านห้วยแม่แดง","บ้านห้วยแม่บอน","บ้านห้วยแม่เลี่ยม","บ้านห้วยไม้แก่น","บ้านห้วยไม้ซอด","บ้านห้วยไม้ซาง","บ้านห้วยไม้แป้น","บ้านห้วยไม้หก","บ้านห้วยยศ","บ้านห้วยยา","บ้านห้วยยาง","บ้านห้วยยางชัยพร","ห้วยยางจอมมณี","บ้านห้วยยาง (สุภาพสามัคคีราษฎร์)","บ้านห้วยยาง (คุรุประชาสรรค์)","บ้านห้วยยางดำ","บ้านห้วยยางดี","บ้านห้วยยางโทน","บ้านห้วยยางประชาสรรค์","ห้วยยางมัญจาคีรี","บ้านห้วยยางมิตรภาพที่ 35","บ้านห้วยยางสะอาด","บ้านห้วยยูง","บ้านห้วยร่วม","บ้านห้วยระย้า","บ้านห้วยระหงส์","บ้านห้วยรั้ว (เสนาณรงค์อุปถัมภ์)","บ้านห้วยรากไม้","บ้านห้วยรางเกตุ","บ้านห้วยรื่น","บ้านห้วยเร็จ","บ้านห้วยเรือ","บ้านห้วยแร่","บ้านห้วยโรงนอก","บ้านห้วยไร่","บ้านห้วยไร่ (รัฐราษฎร์อนุกูล)","บ้านห้วยไร่สามัคคี","บ้านห้วยล่วง","บ้านห้วยลวงไซ","บ้านห้วยละเบ้ายา","บ้านห้วยลากปืน","บ้านห้วยลาด","บ้านห้วยลาน","บ้านห้วยลำโมง","บ้านห้วยลึก","บ้านห้วยลึกผาลาดสามัคคี","บ้านห้วยลุง","บ้านห้วยเล็บมือ","บ้านห้วยเลา","บ้านห้วยแล้ง","บ้านห้วยวอก","บ้านห้วยวังโตน","บ้านห้วยวังปลา","บ้านห้วยศรีเกษร","บ้านห้วยศาลา","บ้านห้วยโศก","บ้านห้วยสนามทราย","บ้านห้วยสนุกสะพานทอง","บ้านห้วยส้ม","บ้านห้วยส้มใต้","บ้านห้วยสมบูรณ์","บ้านห้วยส้มป่อย","บ้านห้วยสระภูมิ","บ้านห้วยสวิง","บ้านห้วยสวิงน้อย","บ้านห้วยสะแก","บ้านห้วยสะคาม","เพียงหลวง 7 ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านห้วยสะแพด","บ้านห้วยสะลักวิทยา","บ้านห้วยสะอาด","บ้านห้วยสัก","บ้านห้วยสัก (ประชานุกูล)","บ้านห้วยสักตะเพียนทอง","บ้านห้วยส้าน","บ้านห้วยส้านพลับพลา","ห้วยส้านยาววิทยา","บ้านห้วยสามขา","บ้านห้วยสามพาดหนองแกสหราษฎร์พัฒนา","บ้านห้วยสามยอดเทวกุล","บ้านห้วยสายหนัง","บ้านห้วยสาร","บ้านห้วยสาร สาขาบ้านช่องฉันทนา","บ้านห้วยสาราม","บ้านห้วยสำราญ","บ้านห้วยสิงห์","บ้านห้วยสีเสียด","บ้านห้วยสูน","บ้านห้วยเสลา","บ้านห้วยเสียด","บ้านห้วยเสือ","บ้านห้วยเสือเฒ่า (เจ้ากอแก้วอุปถัมภ์)","บ้านห้วยเสือเต้น","บ้านห้วยแสงอรุณวิทยา","บ้านห้วยโส","บ้านห้วยหก","บ้านห้วยหญ้าเครือ","บ้านห้วยหญ้าไซ","บ้านห้วยหนองจันทิ","บ้านห้วยหมอเฒ่า","บ้านห้วยหมาก","บ้านห้วยหมากแดง","บ้านห้วยหมากใต้","บ้านห้วยหมากหนุน","บ้านห้วยหมากหล่ำ","บ้านห้วยหมากเอียก","บ้านห้วยหมีศรีสวัสดิ์","บ้านห้วยหมูพิทยา","บ้านห้วยหยวก","บ้านห้วยหลอด","บ้านห้วยหล่อดูก","บ้านห้วยหละ","บ้านห้วยหลาว","บ้านห้วยหวด","บ้านห้วยหว้า","บ้านห้วยหว้าวังทอง","บ้านห้วยหวาย","บ้านห้วยหอม","บ้านห้วยห้อม","บ้านห้วยห้อม ","บ้านห้วยหัน","บ้านห้วยห้า","บ้านห้วยห้าง","บ้านห้วยห้างป่าสา","บ้านห้วยหาน","ห้วยหานประชาสรรค์","บ้านห้วยหามต่าง","บ้านห้วยหาร","บ้านห้วยห้าใหม่","บ้านห้วยหิน","บ้านห้วยหินขาว","บ้านห้วยหินขาวมิตรภาพที่ 213","บ้านห้วยหินซาน้ำอ้อมพรหมมานุสรณ์","บ้านห้วยหินดำ","บ้านห้วยหินฝน","บ้านห้วยหินลับ","บ้านห้วยหินลาด","บ้านห้วยหินลาดใน","บ้านห้วยหีบวิทยาธาร","บ้านห้วยหุงเกลือ","บ้านห้วยหูด","บ้านห้วยเหล็ก","บ้านห้วยเหล็กไฟ","บ้านห้วยเหลือง","บ้านห้วยเหิน","บ้านห้วยแห้ง","บ้านห้วยแหน","บ้านห้วยใหญ่","ห้วยใหญ่ยางงาม","บ้านห้วยไห","บ้านห้วยไหล่","บ้านห้วยไหสมบูรณ์","บ้านห้วยอรุณหินลาด","บ้านห้วยอ้อ","บ้านห้วยอ้อ (ห้วยอ้อวิทยาคม)","บ้านห้วยอ้อย","บ้านห้วยอาลัย","บ้านห้วยอีจีน","บ้านห้วยอึ่ง","บ้านห้วยอูน","บ้านห้วยเอียน","บ้านห้วยโอน","บ้านห้วยฮวก","บ้านห้วยฮวกจอมทองนาฝาย","บ้านห้วยฮ่อม","บ้านห้วยฮากไม้เหนือ","บ้านห้วยฮากไม้ใต้","บ้านห้วยฮี้","บ้านห้วยเฮี้ย","บ้านห้วยเฮี่ยน","บ้านห้วยเฮี๊ยะ","บ้านห้วยเฮือและสาขาห้วยระพี","บ้านห้วยเฮือสาขาห้วยระพี","บ้านห้วยแฮ้ว","บ้านห้วยไฮ","บ้านหว้ากอ (มิตรภาพที่72)","บ้านหวาง","บ้านหว่างคลอง","บ้านหว้าเฒ่า","บ้านหว้าทอง","บ้านหว้าน","บ้านหว้านสหวิทยา","บ้านหว้าน (รัฐราษฎร์นุกูล)","บ้านหว้านน้อย","บ้านหว่านไฟ","บ้านหว้านใหญ่","บ้านหว้านใหญ่ประชาคม","บ้านหว่าโน","บ้านหวาย","บ้านหวาย (หวายวิทยานุกูล)","บ้านหวายกุดสว่าง","บ้านหวายน้อย","บ้านหวายหลึม","บ้านหวายหลึม (โพธิ์ศรีราษฎร์วิทยา)","บ้านหว้าหลัง","บ้านหว้าเหล่าโพนทองประชานุกูล","บ้านหว้าเอน","บ้านหอกลองกระสัง","บ้านห่อง","บ้านห่องขอน","บ้านห้องข่าหนองเสือตาย","บ้านห้องคลองร่องคำ","บ้านห่องคำ","บ้านห่องชัน","บ้านห้องแซง","บ้านห่องเตย","บ้านห่องปอ","บ้านห่องยูง","บ้านหอมเกร็ด (เฉลิมราษฎร์นครยอดบำรุง)","บ้านหอย","บ้านหอย ","บ้านหอย (เติมเอนจิเนียริ่งอุปถัมภ์)","บ้านหอยโนนดู่","บ้านหอยสะเดาพัฒนา","บ้านหัน","บ้านหัน (คุรุราษฎร์อุทิศ)","บ้านหัน (วุฒิวิทยาคาร)","บ้านหัน (สลากกินแบ่ง 5)","บ้านหันโจดหนองกุง","บ้านหันเชียงเหียน","บ้านหันดอนดู่ (วิจิตรอุปถัมภ์)","บ้านหันตะเภา","บ้านหันเตย","บ้านหันทราย","บ้านหันเทาผักกาดย่า","บ้านหันน้อย","บ้านหันศิลางาม","บ้านหันโสกเชือก","บ้านหันหน่องสามัคคี","บ้านหันห้วยทราย","บ้านหันใหญ่","บ้านหันแฮด","บ้านหัวกาหมิง","บ้านหัวแก่ง","บ้านหัวโกรก","บ้านหัวข่วง","บ้านหัวขัว","บ้านหัวขัว (เบญจคุรุราษฏร์อุทิศ)","บ้านหัวขัวใต้","บ้านหัวขัวนาแปะหนองอึ่ง","บ้านหัวขัวโพธิ์ศรี","บ้านหัวขัวเหมือดแอ่","บ้านหัวเขา","บ้านหัวเขาจีน","บ้านหัวเขาตาคลี","บ้านหัวเข่าแตก","บ้านหัวเขาพุประดู่","บ้านหัวแข้","บ้านหัวคลอง","บ้านหัวควน","บ้านหัวค่าย","บ้านหัวคำ","บ้านหัวคู","บ้านหัวงัว","บ้านหัวงัว ","บ้านหัวงัว (อุสุภราชวิทยาคาร)","บ้านหัวช้าง","บ้านหัวช้าง (ราษฎร์บำรุง)","บ้านหัวช้างโคกม่วง","บ้านหัวช้างหนองแสง","บ้านหัวดง","หัวดงหนองคลอง","บ้านหัวดงกำแพง","บ้านหัวดงยาง","บ้านหัวดอน","บ้านหัวดอน (สำนักงานสลากกินแบ่งรัฐบาลสมทบสร้าง 28)","บ้านหัวดอนขามสามัคคี","บ้านหัวดอนชาด","บ้านหัวดอนเปลือยพัฒนา","บ้านหัวดอย","บ้านหัวดาน","บ้านหัวด่านนาปูน","บ้านหัวดุม","บ้านหัวตะแบก","บ้านหัวตะพาน","บ้านหัวตาลแถว","บ้านหัวโตก","บ้านหัวถนน","บ้านหัวถนนเหนือ (รัฐประชาชนูทิศ)","บ้านหัวทราย","บ้านหัวทะเล","บ้านหัวทะเล ","บ้านหัวทำนบ","บ้านหัวทุ่ง","บ้านหัวทุ่งประชาสรรค์","หัวโทนมิตรภาพที่ 165ฯ","บ้านหัวไทร","บ้านหัวนา","บ้านหัวนา และสาขาห้วยหมากเลี่ยม","บ้านหัวนา สาขาบ้านห้วยหมากเลี่ยม","บ้านหัวนากลาง","บ้านหัวนาคำ","บ้านหัวนาคำโนนสมบัติ","บ้านหัวนาจระเข้หนองแปน","บ้านหัวนาดำ","บ้านหัวนาเลา","บ้านหัวนาหนองแวง","บ้านหัวนาแหลม","บ้านหัวน้ำ","บ้านหัวน้ำแม่ฮ่องสอน","บ้านหัวโนน","บ้านหัวโนนตาล (สหราษฎร์วิทยาสรรค์)","บ้านหัวบึง","บ้านหัวบึงสว่าง","บ้านหัวบึงทุ่ง (เขตการทางนครราชสีมาสงเคราะห์ 3)","บ้านหัวบึงหัวสระ และบ้านดอนหญ้านาง","บ้านหัวปอ","บ้านหัวปอน","บ้านหัวป่าเขียว","บ้านหัวป้าง","บ้านหัวปาบ","บ้านหัวฝาย","อนุบาลหัวฝาย","บ้านหัวฝาย และสาขาบ้านศรีค้ำ","บ้านหัวฝาย (ประชาสารสงเคราะห์)","บ้านหัวฝายโนนสะอาดวิทยา","บ้านหัวฝายประชานุกูล","บ้านหัวพี","บ้านหัวภู","บ้านหัวเมือง","ชุมชนบ้านหัวเมือง","บ้านหัวเมือง (แหวนวังประชาบำรุง)","บ้านหัวแม่โถ","บ้านหัวแม่สุริน","บ้านห้วยปู สาขา","บ้านหัวยาง","บ้านหัวรัง","บ้านหัวริน","บ้านหัวแรต","บ้านหัวแรตนาโพธิ์","บ้านหัวลา","บ้านหัวลำ","บ้านหัวลำพู","บ้านหัววัง","บ้านหัววังกร่าง","บ้านหัววัวหนองนารี","บ้านหัวว่าว","บ้านหัวเวียง (โกศัลย์วิทย์)","บ้านหัวเวียงเหนือ","บ้านหัวสระ","บ้านหัวสะพาน","บ้านหัวสะพานมิตรภาพที่ 217","บ้านหัวเสลา","บ้านหัวเสือ","ชุมชนบ้านหัวเสือ","บ้านหัวโสก","บ้านหัวหนอง","บ้านหัวหนอง (สังฆวิทยา)","บ้านหัวหนองกุดหลด","บ้านหัวหนองคู","บ้านหัวหนองตาด","บ้านหัวหนองนาวัวโนนงิ้ว","บ้านหัวหนองยาง","บ้านหัวหนองแวง (สามัคคีราษฎร์บำรุง)","บ้านหัวหนอง (แหลมทองคุรุรัฐประชาสรรค์)","บ้านหัวหมอน","บ้านหัวหมากบน","บ้านหัวหมากล่าง","บ้านหัวหมู","บ้านหัวหาด","บ้านหัวหิน","บ้านหัวเหล่า","บ้านหัวเห่ว","บ้านหัวอ้อทะมวงสามัคคี","บ้านหัวอ่าว (ก๊วยสมบุญราษฏร์บำรุง)","บ้านหัวแฮต","บ้านหัสคุณ","บ้านหางดง","บ้านห่างทางหลวง","บ้านหางน้ำหนองแขม (โออุปถัมภ์)","บ้านหางว่าวโนนบัว","บ้านห้างสูง","บ้านห้างสูง (เกตุวัตถาประชานุเคราะห์)","บ้านห่างหลวง","บ้านห้างหว้า (คุรุรัฐประชาสรรค์)","บ้านเวียงหงส์ล้านนา","บ้านหาญ","บ้านหาญฮี","บ้านหาด","บ้านหาด (อสพป.13)","บ้านหาดกวน","บ้านหาดขาม","บ้านหาดไข่เต่า","บ้านหาดคัมภีร์","บ้านหาดเค็ด","บ้านหาดงาม","บ้านหาดงิ้ว","บ้านหาดจิก","บ้านหาดชะอม","บ้านหาดทรายแก้ว","บ้านหาดทรายขาวผามุม","บ้านหาดทรายคูณ","บ้านหาดทรายดำ","บ้านหาดทรายมูล","บ้านหาดทรายยาว","บ้านหาดทรายรี","บ้านหาดทับยา","บ้านหาดนาค","บ้านหาดใน","บ้านบางไม้แก้วประชาสามัคคี","ริมโขงวิทยา","บ้านหาดเบี้ย","บ้านหาดพระ","บ้านหาดแพง (หาดแพงวิทยา)","บ้านหาดภราดรภาพ","บ้านหาดยาว","บ้านหาดรั่ว","บ้านหาดริ้น","บ้านหาดเล็ก","บ้านหาดเลา","บ้านหาดสถาพร","บ้านหาดส้มแป้น","บ้านหาดสวนยา","บ้านหาดสองแคว","บ้านหาดสั่ง","บ้านหาดสำราญมิตรภาพที่ 207","บ้านหาดสูง","บ้านหาดเสือเต้น","บ้านหาดหงส์","บ้านหาดใหญ่","บ้านหานเพชร","บ้านหามแหโนนสังข์สามัคคี","บ้านหายโศก","บ้านหาร","บ้านหารแก้ว","บ้านหารเทา (จรุงราษฎร์ดำเนิน)","บ้านหารฮี","บ้านหิงห้อย","บ้านหินวิทยา","บ้านหินกบ","บ้านหินกลิ้ง","บ้านหินกอง","บ้านหินกองสามัคคี","บ้านหินเกิ้ง","บ้านหินแก้ว","บ้านหินขัน","บ้านหินขาว","บ้านหินคอกควาย","บ้านหินคูณ","บ้านหินโค่งประชานุเคราะห์","บ้านหินโคน","บ้านหินงามสามัคคี","บ้านหินโง่น","บ้านหินโง่น สาขาบ้านสักง่า","บ้านหินโงม","บ้านหินโงมโนนสร้างไพ","บ้านหินช้าง","บ้านหินซ้อน","บ้านหินดาด","บ้านหินดาดน้อย","บ้านหินดาดใหญ่","บ้านหินดาตราษฎร์บำรุง","บ้านหินดาน","บ้านหินแด้น","บ้านหินตลาดศรีสง่าวิทยา","บ้านหินตลาด สาขาศรีภูทอง","บ้านหินตั้ง","บ้านหินตั้งโคกก่อง","บ้านหินตั้งบังพระจันทร์","บ้านหินตุ้ม","บ้านหินแตก","บ้านหินเทิน","บ้านหินประกาย","บ้านหินผุด","บ้านหินเพิง","บ้านหินร่ม","บ้านหินร่องโนนสวรรค์","บ้านหินรอยเมย","บ้านหินราว","บ้านหินแร่","บ้านหินแร่หนองนกเป็ดวิทยา","บ้านหินลับศิลามงคล","บ้านหินลาด","บ้านหินลาดนาดี","บ้านหินลาดนาโนหนองกุง","หินลาดนาไฮวิทยาคม","บ้านหินลาดพัฒนา","บ้านหินลาดวังตอ","บ้านหินลาดแสนตอ","บ้านหินลาดหนองโดน","บ้านหินลูกช้าง","บ้านหินแลบ","บ้านหินวง","บ้านหินวัว","บ้านหินสอ","บ้านหินสามก้อน","บ้านหินสิ่ว","บ้านหินสี และสาขาบ้านลานคา","บ้านหินสูง","บ้านหินหล่อง","บ้านหินห่อม","บ้านหินเหล็กไฟ","บ้านหินเหลิ่ง","บ้านหินเหิบ","หินเหิบซับภูทอง","บ้านหินเหิบศิลาทิพย์","บ้านหินแห่","บ้านหินแห่โนนเมืองน้อย","บ้านหินแหลม","หินแห่เสริมศิลป์","บ้านหินโหง่น","บ้านหินฮาว","บ้านหินฮาวน้ำกงวิทยา","บ้านหินฮาวโนนงาม","บ้านหินฮาวลำวังชู","บ้านหุ่งหลวงพะเนียด","บ้านดุหุน","บ้านหุบกะพง","บ้านหุบบอน","บ้านหุบพริก","บ้านหูช้าง","บ้านหูทำนบ","บ้านหูแร่","บ้านหูลิงโนนศิลา","บ้านเหงี่ยงกระจ๊ะ","บ้านเห็ดผึ้งหนองก่าม","บ้านเห็นอ้ม","บ้านเหนือ","บ้านเหนือ (วัดลำพะยา 2)","บ้านเหนือเขมราฐ","บ้านเหนือคลอง","บ้านเหนือทัพรั้ง","บ้านเหนือน้ำ","บ้านเหม้าหนองข่าวิทยา","บ้านเหม้าหนองเรือ","บ้านเหมืองง่า","บ้านเหมืองแดง","บ้านเหมืองแดงน้อย","บ้านเหมืองตะกั่ว","บ้านเหมืองตามุก","บ้านเหมืองทวด","บ้านเหมืองทอง","บ้านเหมืองไทร","บ้านเหมืองบ่า","บ้านเหมืองแบ่ง","บ้านเหมืองแพร่","บ้านเหมืองแร่","เพียงหลวง 3 (บ้านเหมืองแร่อีต่อง) ในทูลกระหม่อมหญิงอุบลรัตนราชกัญญา สิริวัฒนาพรรณวดี","บ้านเหมืองลึก","บ้านเหมืองสองท่อ","บ้านเหมือดขาว","บ้านเหมือดป่าตอง","บ้านเหมือดแอ่","บ้านเหมือดแอ่แก้งไฮ","บ้านเหมือดแอ่คุรุราษฎร์อุทิศ","บ้านเหมือดแอ่ภูเม็ง","บ้านเหมือดแอ่หนองโดน","บ้านเหรียงงาม","บ้านเหล็ก","บ้านเหล็กกกกอกสามัคคี","บ้านเหล่า","บ้านเหล่า และสาขาบ้านหนองบัว","บ้านเหล่า (คุรุประชานุเคราะห์)","บ้านเหล่า (พงษ์เกีรยติประชาสรรค์)","บ้านเหล่า (พิชัยศิริราษฎร์รังสรรค์)","บ้านเหล่า (รัฐราษฎร์บำรุง)","บ้านเหล่ากกโก","บ้านเหล่ากกโพธิ์กกเค็ง","บ้านเหล่ากกหุ่งสว่าง","บ้านเหล่ากล้วย","บ้านเหล่ากล้วยโนนสมพร","บ้านเหล่ากว้าง","บ้านเหล่ากอหก","บ้านเหล่ากาดย่า","บ้านเหล่ากุด","บ้านเหล่าเกวียนหัก","บ้านเหล่าขวาว","บ้านเหล่าขาม (มูลสารศึกษาสงเคราะห์)","บ้านเหล่าข้าว","บ้านเหล่าข้าวดอนก่อ","บ้านเหล่าแขมดงกลาง","บ้านเหล่าแขมทอง","บ้านเหล่าคราม","บ้านเหล่าค้อ","บ้านเหล่าคาม","บ้านเหล่าคำ","บ้านเหล่าแค","บ้านเหล่าง้าวโนนค้อประชาสรรค์","บ้านเหล่างิ้ว (เหล่างิ้ววิทยานุกูล)","บ้านเหล่าโง้ง","บ้านเหล่าจั่น","บ้านเหล่าจั่นนาภู","บ้านเหล่าจั่นหนองทุ่ม","บ้านเหล่าแชแลหนองแวง","บ้านเหล่าดง","บ้านเหล่าดอนเงิน","บ้านเหล่าดอนแตง","บ้านเหล่าดู่","บ้านเหล่าแดง","บ้านเหล่าต่างคำ","บ้านเหล่าตามาอุดมชัย","บ้านเหล่าตำแย","บ้านเหล่าติ้ว","บ้านเหล่าถาวร","บ้านเหล่าทองหลาง","บ้านเหล่าทุ่ง","บ้านเหล่านกชุม","บ้านเหล่านกชุมวิทยาสรรค์","บ้านเหล่าน้อย","บ้านเหล่าน้อย (ศรีคุรุราษฎร์วิทยา)","บ้านเหล่านางาม","บ้านเหล่านาดี","บ้านเหล่าโนนคูณ","บ้านเหล่าบะดาโนนอุดม","บ้านเหล่าบาก","บ้านเหล่าบากสามัคคี","บ้านเหล่าบ้านถ่อน","บ้านเหล่าประชานุเคราะห์","บ้านเหล่าป่าก๋อย","บ้านเหล่าป่าฝาง","บ้านเหล่าป่าสา","บ้านเหล่าเป้า","บ้านเหล่าผักใส่","บ้านเหล่าผักหวาน","บ้านเหล่าฝ้าย","บ้านเหล่าฝ้ายศาลาสามัคคี","เหล่าพรวนป่ากุงโนนสวาง","บ้านเหล่าพ่อหา","บ้านเหล่าพัฒนา","บ้านเหล่าพิทยาคม","บ้านเหล่าโพธิ์","บ้านเหล่าโพธิ์ศรี","บ้านเหล่าโพนค้อเหล่าราษฎร์วิทยา","บ้านเหล่าโพนงาม","บ้านเหล่าโพนทองขอนขว้าง","บ้านเหล่าภูพานวิทยา","บ้านเหล่าภูมีคำธาตุ","บ้านเหล่าม่วงโนนตาล","บ้านเหล่ามะเขียว","บ้านเหล่าเมย","บ้านเหล่ายางชุมสามัคคี","บ้านเหล่ายาว","บ้านเหล่ายูง","บ้านเหล่าเลิง","บ้านเหล่าศรีโหนโห่","บ้านเหล่าส้มป่อย","บ้านเหล่าสร้างถ่อ","บ้านเหล่าสำราญ","บ้านเหล่าสีแก้ว","บ้านเหล่าเสือโก้ก","บ้านเหล่าหญ้า","บ้านเหล่าหนองแคน","บ้านเหล่าหนองบัวดอนโพธิ์","บ้านเหล่าหนองยาง","บ้านเหล่าหนาด","บ้านเหล่าหมากคำ","บ้านเหล่าหมากจันทน์คำล่องประชานุกูล","บ้านเหล่าหมากบ้าเชียงสม","บ้านเหล่าหมากผาง","บ้านเหล่าหมี","บ้านเหล่าหลวง","บ้านเหล่าหลวงเตาถ่าน","บ้านเหล่าหันทราย","บ้านเหล่าหัวภู","บ้านเหล่าหุ่ง","บ้านเหล่าเหนือ","บ้านเหล่าใหญ่","บ้านเหล่าใหญ่ (คุรุศิษย์ประชานุสรณ์)","บ้านเหล่าใหญ่ (สมานราษฎร์ศรัทธาลัย)","บ้านเหล่าใหญ่ประชานุกูล","บ้านเหล่าอ้อ","บ้านเหล่าอ้อย","บ้านเหล่าอินทร์แปลง","บ้านเหล่าอุดมทรัพย์สมบูรณ์","บ้านเหล่าฮก","บ้านเหล่าไฮ หนองแวง ชาตะยานนท์","บ้านเหวตาบัว","บ้านเหว่อดงสวนผึ้ง (สุขนาคธรรม)","บ้านเหิบ","บ้านแห่ประชานุกูล","บ้านแห่ประชานุเคราะห์","ชุมชนบ้านแหง","บ้านแห่เจริญวิทย์","บ้านแหน","บ้านแห่บริหารวิทย์","บ้านแหร","บ้านแหลง (คุรุประชาสามัคคี)","บ้านแหล่งควาย","บ้านแหล่งแป้น","บ้านแหล่งหนู","บ้านแหลม","บ้านแหลมกรวด","บ้านแหลมกะเจา","บ้านแหลมจาก (รักเมืองไทย 27)","บ้านแหลมชนแดน","บ้านแหลมซ่าน","บ้านแหลมดิน (หัสนันท์อุปถัมภ์)","บ้านแหลมตง","บ้านแหลมตะคร้อ (ยงวัฒนาประชาสรรค์)","บ้านแหลมถ่อนสามัคคี","บ้านแหลมทราย","บ้านแหลมทอง","บ้านแหลมทอง (ราษฎร์สามัคคี)","บ้านแหลมทองพัฒนา","บ้านแหลมแท่น","บ้านแหลมไทร","บ้านแหลมนาว","บ้านแหลมไผ่","บ้านแหลมพร้าว","บ้านแหลมโพธิ์","บ้านแหลมมะขาม","บ้านแหลมยาง","บ้านแหลมยางนา","บ้านแหลมรัง ","บ้านแหลมสอม","บ้านแหลมสะแก","บ้านแหลมสัก","บ้านแหลมสันติ","บ้านแหลมสิงห์","บ้านแหลมหอย","บ้านแหลมหาด","บ้านแหลมหิน","บ้านแหลว","บ้านแหลไหล่","บ้านแห้ว","บ้านแห่เหนือ","บ้านโหง่นขาม","บ้านโหนด","บ้านโหมงราษฎร์พัฒนา","บ้านโหมน","บ้านโหมนสงเคราะห์","บ้านโหรา","บ้านโหล่นสามัคคี","บ้านโหล๊ะท่อม (ราษฎร์พิพัฒน์)","บ้านโหล๊ะเร็ด","บ้านโหล๊ะหาร","บ้านใหญ่","บ้านใหม่","เทศบาล 8 บ้านใหม่","บ้านใหม่พัฒนวิทย์","บ้านใหม่ประชาสามัคคี","บ้านใหม่ (วันครู 2503)","บ้านใหม่ (คุรุราษฎร์พัฒนา)","บ้านใหม่ (จีนาภักดิ์วิทยา)","บ้านใหม่ (ประกอบราษฎร์วิทยานุกูล)","บ้านใหม่ (ประชาอุปถัมภ์)","บ้านใหม่ (เยาวชนประชาสงเคราะห์)","บ้านใหม่ (ราษฎร์บูรณะ)","บ้านใหม่ (ศรีอินทร์พงษ์)","บ้านใหม่ (สมบัติทวีประชาสรรค์)","บ้านใหม่กิโล 8","บ้านใหม่เขานิยม","บ้านใหม่คลองเคียน","บ้านใหม่คลองเจริญ","บ้านใหม่คลองอังวะ","บ้านใหม่โคกพรม","บ้านใหม่จัดสรร","บ้านใหม่เจริญธรรม","บ้านใหม่เจริญผล","บ้านใหม่เจริญสุข","บ้านใหม่ฉมวก","บ้านใหม่ชัยเจริญ","บ้านใหม่ชัยพฤกษ์","บ้านใหม่ชัยมงคล","บ้านใหม่ชุมพร","บ้านใหม่โชคชัย","บ้านใหม่ตาแสง","บ้านใหม่ใต้","บ้านใหม่ถาวร","บ้านใหม่ทรัพย์เจริญ","บ้านใหม่ทหารบกพัฒนา","บ้านใหม่ทองประเสริฐ","บ้านใหม่ท่าต้นเกี๋ยง","บ้านใหม่ทุ่งดินขอ (เรืองฉายอุปถัมภ์)","บ้านใหม่ไทยเจริญ","บ้านใหม่ไทยพัฒนา","บ้านใหม่ไทรทอง","บ้านใหม่ธงชัย","บ้านใหม่นาดี","บ้านใหม่นาเพียง","บ้านใหม่น้ำเงิน","บ้านใหม่เนินสวรรค์","บ้านใหม่ปางค่า (ภูลังกาอนุสรณ์)","บ้านใหม่ปางเติม","บ้านใหม่ผ้าขาว","บ้านใหม่พนมทอง","บ้านใหม่พัฒนา","บ้านใหม่โพธิ์งาม","บ้านใหม่โพธิ์ทอง","บ้านใหม่ไพรมณี มิตรภาพที่ 118","บ้านใหม่ร่มเย็น","บ้านใหม่รัตนโกสินทร์","บ้านใหม่ราษฎร์ดำรง","บ้านใหม่ไร่อ้อย","บ้านใหม่วังเซือม","บ้านใหม่วังตะเคียน","บ้านใหม่วารีเย็น","บ้านใหม่วิทยา","บ้านใหม่วิไลวัลย์","บ้านใหม่ศรีจำปาทอง","บ้านใหม่ศรีชมภู","บ้านใหม่ศรีนคร","บ้านใหม่ศรีวิไลพุทไธจารย์","บ้านใหม่ศรีสุข","บ้านใหม่ศึกษา","บ้านใหม่สบปุง","บ้านใหม่สมบูรณ์","บ้านใหม่สระบุรี","โคกเพชรสระมโนรา","บ้านใหม่สวรรค์","บ้านใหม่สหสัมพันธ์","บ้านใหม่สันติ","บ้านใหม่สามัคคี","บ้านใหม่สารภี","บ้านใหม่สาริกา","บ้านใหม่สำโรง","บ้านใหม่สุขเกษม","บ้านใหม่สุขสันต์ และบ้านใหม่สุขสันต์สาขาบ้านมูเซอร์","บ้านใหม่เสรีธรรม","บ้านใหม่โสกส้มกบ","บ้านใหม่โสพิมพ์","บ้านใหม่หนองแก","บ้านใหม่หนองบัว","บ้านใหม่หนองยาง","บ้านใหม่หนองหอย","บ้านใหม่เหล่ายาว","บ้านไหนหนัง","บ้านไหล่ดุม-ตาเหมา","บ้านไหล่ทุ่ง","บ้านไหล่ธาตุ","บ้านไหล่น่าน","บ้านไหล่สูง","บ้านไหล่หิน","บ้านองสิต","บ้านองหลุ","บ้านอโณทัย","บ้านอ้นวิทยาประชาสรรค์","บ้านอ้น","บ้านอนันต์ ","บ้านอมกง","บ้านอมขูด","บ้านอมพาย","บ้านอมเม็ง","บ้านอรุโณทัย","บ้านอ้วน","บ้านอ้อวังหมากเห็บ","บ้านอ้อ","บ้านอ้อกระทิง","บ้านอ้อกระทุง","บ้านออดราษฎร์สามัคคี","บ้านอ้อตลิ่งชัน","บ้านออน","บ้านอ้อน","บ้านออนกลาง","บ้านออนหลวย และบ้านออนหลวย สาขาบ้านหัวฝาย","บ้านอ้อประชาสามัคคี","บ้านอ้อไพล","บ้านอ้อมกอ ","บ้านอ้อมแก้ว","บ้านอ้อมโรงหีบ","บ้านอ้อยช้าง","บ้านอ้อยวิทยาคาร","บ้านอะลาง","บ้านอะลางหัวขัว (ตังสกุลคุรุราษฎร์บำรุง)","อัคคะวิทยา","บ้านอังกอล","บ้านอังกัญเสกแอ (ประดิษฐ์ราษฎร์สามัคคี)","บ้านอังกุล","บ้านอังโกน-ห้วยทราย","บ้านอันโนง","บ้านอัยเยอร์เวง","บ้านอากาศ","บ้านอาคตหนองขอนประชาวิทย์","บ้านอาคุณ","บ้านอ่างกระพงศ์","บ้านอ่างกะป่อง","บ้านอ่างเก็บน้ำห้วยยาง","บ้านอ่างตะแบก","บ้านอ่างเตย","บ้านอ่างทอง","บ้านอ่างทอง (วันครู2502)","บ้านอ่างบูรพา","บ้านอ่างศิลา","บ้านอ่างหิน","บ้านอ่างหิน (เพียรพิทยาคาร)","บ้านอ่างหินน้อย","บ้านอาจญา","บ้านอาจสามารถ","บ้านอาชานุสรณ์","บ้านอาตะบือเระ","บ้านอาบช้าง","บ้านอาพืด","บ้านอาโพน","บ้านอาโพน (สหมิตรสงเคราะห์)","บ้านอ่าย","บ้านอ่ายนาผา","บ้านอ้ายลิ่ม (ลิ่มราษฎร์สามัคคี)","บ้านอายเลา","บ้านอาราง","บ้านอาลัย","บ้านอาเลา","บ้านอ่าวตะเคียน","บ้านอ่าวตาลคู่","บ้านอ่าวน้อย","บ้านอ่าวนาง","บ้านอ่าวน้ำ","บ้านอ่าวน้ำบ่อ","บ้านอ่าวน้ำเมา","บ้านอ่าวปอ","บ้านอ่าวพร้าว","บ้านอ่าวมะขาม","บ้านอ่าวมะม่วง","บ้านอ่าวยาง","บ้านอ่าวลึกน้อย","บ้านอาวอก","บ้านอาวุธ","บ้านอาแวะ","บ้านอาเหอูโต๊ะ","บ้านอาโห","แก่งอาฮง","บ้านอำปึล","บ้านอำปึลสนวน","บ้านอำปึล (ปอเกียพลินอุทิศ 3)","บ้านอำปึลกง","บ้านอำเภอ","บ้านอิงโค้ง","บ้านอิตื้อดอนหวายขมิ้น","บ้านอินทนิน","บ้านอินทนิล","บ้านอินทร์แปลง","บ้านอินทรานุสรณ์","บ้านอีกุด","บ้านอีเก้ง (รัฐประชานุกูล)","บ้านอีโคตร (สามัคคีราษฎร์บำรุง)","บ้านอีง่อง","บ้านอีเซ (คุรุราษฎร์วิทยา)","บ้านอีต้อม","บ้านอีเติ่ง","บ้านอีโต้","บ้านอีนอ","บ้านอีบุ๊","บ้านอีปาด","บ้านภักดีเจริญหัวนาโคกช้างมะนาย","บ้านอีมาดอีทราย","บ้านอีมุย","บ้านอี่เม้ง","บ้านอีโยะ","บ้านอีเลิศ","บ้านอี่เลี่ยน","บ้านอีสร้อย","บ้านอีโสด","บ้านอีหนา (รัฐประชานุกูล)","บ้านอีหมุน","บ้านอี่หล่ำ (ราษฎร์นุสรณ์)","บ้านอีหลุ่ง","บ้านอีอูด","บ้านอุดมชาติ","บ้านอุดมทรัพย์","บ้านอุดมธัญญา","บ้านอุดมบรรพต","บ้านอุดมศรีวิไลวิทยา","บ้านอุดมสามัคคี","บ้านอุได","บ้านอุแตบือราแง","บ้านอุทัยทอง","บ้านอุบลสามัคคี","บ้านอุปราช","บ้านอุ่ม","บ้านอุ่มกะทาด","บ้านอุ่มจาน","บ้านอุมดาเหนือ","บ้านอุ่มไผ่","บ้านอุ่มเม่า","บ้านอุ่มเม้า","บ้านอุมลอง","บ้านอุมโละเหนือ","บ้านอุ่มเหม้า","บ้านอุมุง","เทศบาลอุโมงค์ 1 (คันธาราษฎร์วิทยาทาน)","บ้านอุไร","บ้านอุโลก","บ้านอุโลกสี่หมื่น","บ้านอู่ตะเภา","บ้านอูนโคก","บ้านอูนดง","บ้านอูนนา","บ้านอูนยางคำ","บ้านอูบมุง","บ้านอูบมุงแก้งเกลี้ยง","บ้านอูเป๊าะ (บ้านป่าใส)","บ้านอูมวาบ","บ้านอูล่อง","บ้านอู่โลก","บ้านอู่หู่","บ้านเอ้","บ้านเอกสร้างเรือง","บ้านเอ็นอ้า","บ้านเอราวัณ","แม่สาวิทยาคาร (บ้านเอิน)","บ้านเอียด ","บ้านเอียน (สหราษฎร์บำรุง)","บ้านเอื้องโนนไร่โนนสาวิทยา","บ้านเอือด","บ้านเอือดใหญ่","บ้านเอื้อม","บ้านแอ่นจัดสรร","บ้านแอ่นใหม่","บ้านแอมเจริญ","บ้านแอแว","บ้านโอ่งทานราษฎร์บำรุง","บ้านโอดนาดี","บ้านโอทะลัน","บ้านไอกรอส","บ้านไอบาตู","บ้านไอร์โซ","บ้านไอร์แยง","บ้านไอสะเตียร์","บ้านฮวก","บ้านฮ่องกอม่วง","บ้านฮ่องข่า","บ้านฮ่องขาดหนองตะเคียน","บ้านฮ่องแข้ดำ","บ้านฮ่องทราย","บ้านฮ่องไผ่","บ้านฮ่องลี่","บ้านฮ่องสังข์","บ้านฮ่องสิมประชาสรร","บ้านฮ่องหอยห้วยว่านหอมประชาสรรค์","บ้านฮ่องห้า","บ้านฮ่องแฮ","บ้านฮ่องแฮ่พยอมหนองม่วง","บ้านฮ่อมต้อ","บ้านฮั่ว","บ้านฮากฮาน","บ้านฮ่างต่ำ","บ้านฮางโฮงประชาอุทิศ","บ้านฮี","บ้านฮูแตทูวอ","บ้านฮูแตยือลอ","บ้านฮูลู","บ้านเฮาะวิทยา","บ้านเฮี้ย","บ้านแฮดศึกษา","บ้านแฮหนามแท่ง","บ้านแฮะ","บ้านโฮ่ง","บ้านโฮ่ง (ลี้)","บ้านโฮ่งศีลาภรณ์","บ้านไฮ","บ้านไฮ (วันครู 2503)","บ้านไฮตาก","บ้านไฮน้อย","บ้านไฮ่ปลาโหล","บ้านไฮเลิง","บ้านไฮสร้อย (คุรุราษฎร์บำรุง)","บ้านไฮหย่อง","บ้านไฮหย่อง (ภูเงินประชานุกูล)","พระพุทธบาทวิทยา","บ้านไฮใหญ่","บ้าหนองไผ่น้อย","บำรุงพงศ์อุปถัมภ์","บำรุงราษฎร์วิทยาคม","บำรุงศิษย์ศึกษา","บีกริม","บึงของหลงวิทยา","บึงเขาย้อน (คงพันธุ์อุปถัมภ์)","บึงคำคู","บึงงามพัฒนา","บึงเทพยา","บึงพญาปราบ","บึงพัฒนาประชาร่วมจิตฯ","บึงมะนาววิทยา","บึงราชนก","บึงวิชัยสงเคราะห์","บึงวิทยาคาร","บึงศรีราชาพิทยาคม","บึงสว่างวิทยาคม","บึงสาลี","บึงสิงโต (สหากหะยีเลาะสมัดประชาสรรค์)","บึงสีไฟ","บึงไฮโนนสวางวิทยา","บุ่งคล้าวิทยาคมมิตรภาพที่ 194","บุ่งสะอาดวัฒนา","บุ่งหวายโกรกตาแป้นสามัคคี","บุญจิราธร","บุญญรักษ์วรานุสรณ์","บุญบันดาลวิทยานุสรณ์","บุญเรืองวิทยาคม","บุญลักษณ์อุปถัมภ์","บุญเลิศอนุสรณ์","บุญศรีสุวรรณราษฎร์สามัคคี","บุญสูงอุปถัมภ์","อนุบาลบุณฑริก","บุณยศรีสวัสดิ์","บุปผาราม","บุรพรัตน์วิทยาคาร","เบญจคามวิทยา","เบญจคามวิทยาประชาสรรค์","เบญจคามสามัคคี","เบญจม 2 บ้านน้ำรู","เบญจมราชาลัย ในพระบรมราชูปถัมภ์","เบญจมาศกุญชร","เบญจมิตรวิทยาคม","เบญจราษฎร์ศึกษา","เบญจลักษ์พิทยา","เบทาโกรวิทยา","เบิดพิทยาสรรค์","วังทรายคำวิทยา (ปงวังอนุสรณ์)","ปฐมวิทยาคาร","ปทุมคงคา","ปทุมมาศวิทยา","ปทุมวิทยากร","ปทุมานุกูล","ประกอบราษฎร์บำรุง","ประกาศธรรมคุณวิทยา","ประกิตเวชศักดิ์","ประโคนชัยวิทยา","ประชากรรังสฤษฏ์","ประชาเกษตรพัฒนา","ประชาชนอุทิศ","ประชานิคม 2","ประชานิคม 3","ประชานิคม 4","ประชานิคมวิทยา","ประชานิมิตพิทยานุกูล","ประชานิเวศน์ (ฝ่ายประถมศึกษา)","ประชานุเคราะห์วิทยา","ประชานุเคราะห์ศึกษา","ประชาบำรุง","ประชาบุษยวิทย์","ประชาบูรณะวิทยา","ประชาผดุงวิทย์ (ฟ้อน ฟุ้ง อุทิศ)","ประชาพัฒนา","ประชาพัฒนาบ้านแฮด","ประชาพัฒนาวิทย์","ประชาพิทักษ์","บ้านธาตุน้อยศรีบุญเรือง","ประชารักษ์ศึกษา","ประชารังสรรค์","ประชารัฐธรรมคุณ","ประชารัฐบำรุง","ประชารัฐบำรุง 2","ประชารัฐพัฒนา","ประชารัฐวิทยา","ประชารัฐวิทยาคาร","ประชารัฐวิทยาเสริม","ประชารัฐศึกษา","อนุบาลประชารัฐสามัคคี","ประชารัฐสามัคคี (ธนาคารกรุงเทพ 13)","ประชาราษฎร์บำเพ็ญ","ประชาราษฎร์สามัคคี","ประชาราษฏร์บำรุง","ประชาฤกษ์สมบูรณ์","ประชาวิทยรังสรรค์","ประชาวิทยาคาร","ประชาสงเคราะห์","ประชาสงเคราะห์พิทยา","ประชาสงเคราะห์รังสรรค์","ประชาสงเคราะห์อุปถัมภ์","ประชาสรรค์วิทยา","ประชาสวัสดิ์วิทยา","ประชาสันติ","ประชาสันติภาพ (วงศ์สุดใจอุปถัมภ์)","ประชาสามัคคี","ม่วงน้อยประชาสามัคคี","ประชาสามัคคีวิทยา","ประชาอุทิศ","ประชาอุทิศบ้านโคกม่วง","ประชาอุปถัมภ์","ประชาเอื้ออารี","ประชุมเขตศึกษา","ประดิษฐ์ศึกษา","ประดู่มะค่าประชาสรรค์","ประดู่วิทยา","ประโดกสามัคคี","ประตูชัย","ประถมฐานบินกำแพงแสน","อนุบาลดารณีท่าบ่อ","ประถมทวีธาภิเศก","ประถมนนทรี","ประถมปรีดาภรณ์","ประถมศึกษาธรรมศาสตร์","ประทุมนุสรณ์","ประพันธ์ - อารีย์ หงษ์สกุล (บ้านห้วยหลวง)","ประภัสสรวิทยา","ประภามนตรี","ประวิตร (หนองบ่อ)","ประสาทวิทยานนทบุรี","ประสาธน์ราษฎร์บำรุง","ประสานมิตรวิทยา","ประสานสามัคคีวิทยา","ประสิทธาราม","ประสิทธิ์ทวีสิน 2","ประสิทธิ์วิทยา","ประสิทธิ์วิทยาฯ","ประเสริฐแก้วอุทิศ","ประเสริฐ-น้อย รุจิรวงศ์ 1","ประเสริฐอิสลาม","ปรางค์กู่","ปรางค์ทองวิทยา","ปราณีเนาวบุตร","ปราโมชวิทยารามอินทรา","ปราสาท","ปราสาททองวิทยา","อนุบาลปราสาทศึกษาคาร","ปราสาทอนุสรณ์","ปรินส์รอยแยลส์วิทยาลัย","ปริยัติไพศาล","ปรีชานุศาสน์","ปรีดารามวิทยาคม","ปลวกแดงพิทยาคม","ปล้องวิทยาคม","ปลาค้าววิทยานุสรณ์","ปลาเค้าวิทยาคาร","ปลาปากราษฎร์บำรุง","ปลาปากวิทยา","ปลายนาวิทยา","ปอแดงวิทยา","ป้อมพระจุลจอมเกล้า","ปะโคสามัคคีวิทยา","ปะทิววิทยา","ปักธงชัยชุณหะวัณวิทยาคาร","ปัญจคามประชาสรรค์","ปัญญาประชาอุทิศ","บ้านปัวศรีพรม","ปากคลองชวดใหญ่","ปากคลองบางขนาก","ปากคลองมอญ","ปากคลองสอง","ปากจาบวิทยา","ปากช่อง 2","ปากน้ำราษฎร์บำรุง","ปากน้ำแหลมสิงห์ (วันครู 2503)","ปากบึงสิงโต","ป่ากล้วยพัฒนา","ป่ากล้วยเสริมวิทยา","ป่ากั้งวิทยา","ป่าขนุนเจริญวิทยา","ปางกุ่มวิทยา","ปางต้นผึ้ง","ปางตองประชาสรรค์","บ้านปางวัว","ป่าจี้วังแดงวิทยา","ป่าแดงคุรุราษฎร์บำรุง","ป่าแดงวิทยา","ป่าแดดวิทยาคม","ป่าตันวิทยา","ป่าบอนพิทยาคม","ป่าแป๋วิทยา","ป่าไม้งามโนนนาดีประชานุกูล","ป่าไม้อุทิศ 11","ป่าไม้อุทิศ 15 (บ้านม่วงเฒ่า)","ป่าไม้อุทิศ 2","ป่าไม้อุทิศ 3 (บ้านท่าช้าง)","ป่าไม้อุทิศ 4","ป่าไม้อุทิศ 6 (ค่ายลูกเสือแก่งซอง)","ป่าไม้อุทิศ 8","ป่าไม้อุทิศ 9","ป่าไม้อุทิศ1(บ้านลาด)","ป่าลานประสิทธิ์วิทยา","ป่าหวายศึกษา","ปิยะบุตร์","ปิยะพงษ์วิทยา","ปูแกง (อินทราราษฎร์อุปถัมภ์)","เปรมประชา (สายหยุด-เกษม สงเคราะห์)","เปี่ยมสุวรรณวิทยา","เปือยน้อยศึกษา","แปลงยาวพิทยาคม","โป่งเกตรัฐราษฎร์นุเคราะห์","โป่งขุนเพชร","โป่งเชือกศึกษาสถาน","โป่งทะลายใหม่เจริญ","โป่งนกเปล้า","โป่งหลวงวิทยา รัชมังคลาภิเษก","โปโลเล้าสามัคคีวิทยา","ผดุงมาตร","ผดุงวิทยา","ผลลีรุ่งเรือง","ผอบ ณ นคร 1","ผอบ ณ นคร 2","ผักแพวบำรุงวิทยา","ผังปาล์ม 3","ผังปาล์ม 2","ผังปาล์ม 4","ผังปาล์ม 7","ผาช่อวิทยา","ผาแดงวิทยา","ผาเต่าพัฒนา","ผ่านบางอนุสรณ์","ผ่านศึกสงเคราะห์","ผ่านศึกสงเคราะห์ 1","ผ่านศึกสงเคราะห์ 2","ผานาง-ผาเกิ้ง","ผาปังวิทยา","ผาสุกประชานุกูล","ผาสุกมณีจักร มิตรภาพที่ 116","บ้านผาฮาว","ผินสหราษฎร์พัฒนา","ไผ่งามวิทยา","ไผ่แถวอนุสรณ์","ไผทอุดมศึกษา","ไผ่สีสุก","ไผ่ใหญ่ (เกษตรกรอุปถัมภ์)","ฝางวิทยายน","ฝายหินหนองทุ่มหนองทองศึกษา","เฝ้าไร่วิทยา","พงษ์ภิญโญ 1","พงษ์ภิญโญ 2","พงสะตือ (รัฐ-ประชาสรรค์)","พญาไท","พญาไพรไตรมิตร","พญาเม็งราย","พนมดงรักวิทยา","พนมทวนชนูปถัมภ์","พนมรอกวิทยา","พนาลัยวิทยาเสริม","พนาสนวิทยา","พนาสวรรค์","พยัคฆภูมิพิสัย","พยุหะศึกษาคาร","พรพิทยาคม","พรพินิตพิทยาคาร","พรมลีศรีสว่าง","พรรณราชลเขต","พรศิริกุล","พรหมประสาทราษฎร์นุกูล","พรหมพิกุลทอง","พรหมยานุสรณ์","พรหมรังษี","พรหมานุเคราะห์","พระกลางวิทยาคาร","พระกุมารร้อยเอ็ด","พระกุมารศึกษา","พระกุมารสารคาม","พระครูวิทยา","พระจันทร์ศรีสุข","พระซองวิทยาคาร","พระซองสามัคคีวิทยา","พระตำหนักมหาราช","พระตำหนักสวนกุหลาบ","พระตำหนักสวนกุหลาบ มหามงคล","พระธาตุขามแก่น","วัดพระธาตุบังพวน","พระธาตุบังพวนวิทยา","พระบางวิทยา","พระบุบ้านหันราษฎร์ประสาท","พระปริยัติธรรมวัดโสธรวราราม","พระปริยัติธรรมแผนกสามัญ วัดสระเรียง","พระพรหมพิทยานุสรณ์","พระพิมลเสนี (พร้อม หงสกุล)","พระพุทธบาท","พระพุทธบาทเทสรังสีวิทยา","พระมารดานิจจานุเคราะห์","พระแม่มารี","พระแม่มารีสาธุประดิษฐ์","พระยาตาก","พระยาประเสริฐสุนทราศรัย","พระยามนธาตุราชศรีพิจิตร์","พระยืนวิทยาคาร","พระราชทานบ้านหนองหมู","พระราชประสงค์บ้านทรายขาว","พระราม 9 กาญจนาภิเษก","อนุบาลพระสมุทรเจดีย์","พระหฤทัยคอนแวนต์","พระหฤทัยพัฒนเวศม์","พระอินทร์ศึกษา (กล่อมสกุลอุทิศ)","พร้านีลวัชระ","พรุพีพิทยาคม","พฤกษวนารามวิทยา","พลร่มอนุสรณ์ มิตรภาพที่ 50","พลอยจาตุรจินดา","พลับพลาไชย","พลิ้ว","พวงทองอุปถัมภ์","พ่อขุนผาเมืองรำลึก","พ่อขุนผาเมืองอุปถัมภ์","พะทายพิทยาคม","พังตรุราษฎร์รังสรรค์","พังทุยพัฒนศึกษา","พังเทียม (คุรุสามัคคี 2)","พัชรพิทยาคม","พัฒน์พงศ์","พัฒนวิทย์ศึกษา","พัฒนเวชศึกษา","พัฒนศึกษา","พัฒนาคำแก้ว","พัฒนาต้นน้ำขุนคอง","พัฒนาต้นน้ำที่ 5 ขุนวาง","พัฒนานิคมวิทยา","พัฒนาบาลอ","พัฒนาประชานุเคราะห์","พัฒนาปากน้ำ","พัฒนาศรีผดุงอุดมวิทย์","พันดอนวิทยา","พานพสกสวัสดิ์","พานิชชีวอุปถัมภ์","พิกุลทอง","พิชัยดาบหัก 1","พิชัยวิทยา","พิชัยศึกษา","พิณพลราษฎร์ ตั้งตรงจิตร 12","พิทักษ์วิทยากุมุง","พินิจอนุสรณ์ (การกุศลของวัดในพระพุทธศาสนา)","พิบูลประชาบาล","พิบูลปัทมาคม","พิบูลมังสาหาร (วิภาคย์วิทยากร)","พิบูลย์รักษ์พิทยา","พิบูลอุปถัมภ์","พิบูลวิทยาคาร","พิบูลสงเคราะห์ 1","เทศบาลพิบูลสวัสดี","พิพัฒน์ราษฎร์บำรุง","พิมานประชาสันต์","พิมายสามัคคี 1","พิมูลวิทยา","พิรามอุทิศ","พิศาลวิทยา","พุขามครุฑมณีอุทิศ","พุทธโกศัยวิทยา","พุทธบารมี","พุทธมงคลนิมิตร","พุทธมงคลวิทยา","พุทธยาศรม","พุทธวิมุติวิทยา","พุทธอุทยาน","พุทธิโศภน","เพชรถนอม (คลองเสือน้อย)","เพชรพิทยาคม","เพชรมาตุคลา","เพชรรัตนราชสุดา","เพชรราษฎร์บำรุง","เพชรราษฎร์สามัคคี","เพชรหนองขาม","เพ็ชระศึกษา","เพลินพิศ","เพาะปัญญา","เพียปู่หนองเรือ","แพ่งพิทยาภูมิ","แพดพิทยารัตน์","โพฒิสารศึกษา","โพธิ์คำประชาสรรค์","โพธิ์ทองวิทยา","โพธิ์ทองหนองเตาปูนวิทยา","โพธิ์ทองหนองน้ำขุ่นเหนือ","โพธิธรรมสุวัฒน์","โพธิ์นิมิต","โพธิ์ราษฎร์บำรุง","โพธิ์ศรีโปร่งแควิทยาเสริม","โพธิ์ศรีสะอาดวิทยา","โพธิ์ศิลานาหว้า","โพธิ์สัยสว่างวิทย์","โพธิแสนวิทยา","โพนงามโคกวิทยาคาร","โพนงามศึกษา","โพนทองพิทยา","โพนทองพิทยาคม","โพนทองวิทยาคาร","โพนบกผดุงศาสตร์","โพนเพ็กพัฒนวิทยา","โพนศิลางามวิทยา","โพนสวางนางิ้ววิทยา","โพนสว่างป่าตองวิทยา","โพนสวางพิทยาคม","โพนสิมอนุเคราะห์","ไพบูลย์ประชานุกูล","ไพบูลย์วิทยาเต่านอ","ไพลศึกษาคาร","ไพลอำนวยวิทย์","ไพศาลวิทยา","ฟากท่าวิทยา","อนุบาลฟ้าหยาดราษฏร์นิยม","ภาณุฑัตกรีฑาเวทย์","ภาษานุสรณ์บางแค","ภิรมย์ภักดีบ้านห้วยสีดา","อนุบาลชุมชนภูกระดึง","ภูขัดรวมไทยพัฒนา","ภูคาประชาสรรค์","ภูเค็งพัฒนา","ภูซางใหญ่วิทยาคม","ภูดินวิทยา","ภูทองวิทยา","ภูปอวิทยา","ภูผาม่าน","ภูมิวิทยา","ภูแลนคาวิทยายน","ภูเวียงวิทยาคม","ภูห่านศึกษา","ภูฮังวิทยาคาร","วัดโภคาราม","มกุฎเมืองราชวิทยาลัย","มงฟอร์ตวิทยาลัย แผนกมัธยม","มณีพฤกษ์","มณีวัฒนา","มณีเสวตรอุปถัมภ์","มโนบุเรศรบำรุงการ","มรุกขนคร","ม่วงแก้ววิทยาคาร","ม่วงคำราษฎร์สามัคคี","ม่วงราษฎร์สามัคคี","ม่วงสามสิบ (อำนวยปัญญา)","ม่วงหนองแดงหนองกะเลา","มหาชนะชัย","มหาไชยโคกกว้างวิทยา","มหาตมาคานธีนุสรณ์(น้ำตกสายรุ้ง)","มหาไถ่ศึกษาภาคตะวันออกเฉียงเหนือ","มหาไถ่ศึกษาบ้านน้อยสามเหลี่ยม","มหาไถ่ศึกษาบ้านไผ่","มหาธิคุณวิทยา","มหาภาพกระจาดทองอุปถัมภ์","มหาราช 2","มหาราช 2 (ภูคำ)","มหาราช 3","บ้านมหาราช 3","มหาราช 4","มหาราช 7","มหาราชบ้านแสงอรุณ","มหาวชิราลงกรณราชวิทยาลัย","มหาวชิราวุธ จังหวัดสงขลา","มหาสวัสดิ์ (ราษฎรบำรุง)","มหิดล","มหิดลอนุสรณ์ (สันติภาพพัฒนา)","ม่อนดินแดงวิทยาคม","มะเขือดอนหมูโพธิ์ทองวิทยา","มะต้องประชาสรรค์","มะนาววิทยาเสริม","มัชฌิมวิทยา","มัธยมน้ำตาลอนุสรณ์","มัธยมบ้านทำเนียบ","มัธยมวัดควนวิเศษมูลนิธิ","มัธยมวัดหนองจอก","ทีปังกรวิทยาพัฒน์ (มัธยมวัดหัตถสารเกษตร) ในพระราชูปถัมภ์สมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร","มายอ (สถิตภูผา)","มารีวิทย์ สัตหีบ","มารีย์วิทยา","มารีย์อุปถัมภ์","มาเรียลัย","มาลาศีตะจิตต์","มาลาอีสงเคราะห์","เทศบาล 6 มิ่งเมือง","มิตรประชาราษฎร์","มิตรภาพ 2","มิตรภาพ 20","มิตรภาพ 39 (ส.ท.ถนอม อุประอนุสรณ์)","มิตรภาพ 6","มิตรภาพที่ 31 ","มิตรภาพที่ 32","มิตรภาพที่ ๓๔","มิตรภาพที่ 38 (บ้านหนองเรียง)","มิตรภาพโนนสมบูรณ์","มิตรมวลชน 1","มิตรมวลชน 3","มิตรมวลชน 5 (บ้านไทยเจริญ)","มิตรมวลชนเชียงใหม่","มิตรสัมพันธ์ (เพียวอนุสรณ์)","มิตรสัมพันธ์วิทยา","มุสลิมบำรุง","มีชัยวิทยา","มีนบุรี","มีนบุรีศึกษา","มุกดาลัย","มูลนิธิมหาราช 5","มูลนิธิวัดศรีอุบลรัตนาราม","มูลนิธิศึกษา","เมตตาจิตต","เมธีพิทยา","เมยวดีพิทยาคม","เมรี่อิมมาคุเลตคอนแวนต์","เมืองเกษตรวิสัย","เมืองเก่ากำแพงแสน","เมืองคง (คงคาวิทยา)","เมืองจากวิทยา","เมืองจำปาขัน","เมืองชุมพรบ้านเขาถล่ม","เมืองเดช","เมืองโดนสำโรง (รัฐประชานุกูล)","เมืองที","เมืองทุ่งวิทยา","เมืองนครพนม","เมืองนครราชสีมา","เมืองนราธิวาส","เมืองน้อยราษฎร์สงเคราะห์","เมืองบัววิทยา","เมืองปราจีนบุรี","เมืองปราณบุรี","เมืองปัตตานี","เมืองไผ่","เมืองพังงา","เมืองพัทยา 1","เมืองพาลุกากรภูมิ","เมืองโพธิ์ชัย"," อบจ.เมืองภูเก็ต","เมืองยาง ","เมืองร้อยเอ็ด","เมืองเลย","เมืองวาปีปทุม","เมืองสกลนคร (ธาตุนารายณ์เจงเวง)","เมืองสมุทรสงคราม","เมืองสมุทรสาคร","เมืองสุพรรณบุรี","เมืองสุรินทร์","เมืองสุวรรณภูมิ","เมืองหนองพอก","เมืองใหม่","เมืองใหม่ (ชลอราษฎร์รังสฤษฏ์)","เมืองใหม่วิทยา","เมืองใหม่สุวรรณภูมิ","เมืองอาจสามารถ","เมืองอารัมย์","เมืองอำนาจเจริญ","เมืองอุบล","แม่ก๋งวิทยา","บ้านแม่คำมีตำหนักธรรม (ตำหนักธรรมวิทยาคาร)","แม่เชียงรายวิทยา","แม่ต๋ำตาดควันวิทยาคม","แม่ถอดวิทยา","แม่ทะประชาสามัคคี","แม่แป้นวิทยา","แม่พริกวิทยา","แม่พุหอรบวิทยา","แม่มอกวิทยา","แม่เมาะวิทยา","แม่ยาววิทยา","แม่ระมาดวิทยาคม","แม่วะวิทยา","แม่วินสามัคคี","แม่สรวยวิทยาคม","แม่สอด","แม่สันวิทยา","บ้านแม่สานสามัคคี","แม่หลวงอุปถัมภ์ไทยคีรี","แม่หอพระวิทยาคม","โมคลานประชาสรรค์","ไม้แก้วประชานุเคราะห์","ไมตรีจิตไทย-อเมริกัน","ไม้ยาวิทยาคม","ยอดประชาสรรค์","ยะหริ่ง","ยะหาศิรยานุกูล","ยั่งยืนราษฎร์วิทยา","ยางคำวิทยา","ยางชุมน้อยพิทยาคม","ยางนาดีราษฎร์ดำรง","ยางเนียมพัฒนา","ยางบ่ารัฐประชามิตร","ยางเลียงราษฎร์พัฒนา","ยางหลวงพิทยาคม","ยางหล่อวิทยาคาร","ยางอู้มวิทยาคาร","ยางฮอมวิทยาคม","ย่านคีรี","ยิ่งสันต์วิทยา","ยุวสมาคมประจวบคีรีขันธ์อนุสรณ์","ยูงทองวิทยา","ยูเนสโกสัมมนา","เย็นศิระบ้านหมากแข้ง","เย็นสยามวิทยา","แย้มจาดวิชชานุสรณ์","บีคอนเฮาส์แย้มสอาดลาดพร้าว","โยธินนุกูล","ร่มเกล้า","ร่มเกล้า 2","ร่มเกล้าบ้านชมเจริญ","ร่มเกล้าปางตองในโครงการตามพระราชดำริ","ร่มเย็นประชาสรรค์","ร่วมจิตต์ประชา","ร่วมจิตประสาท","ร่วมใจประสิทธิ์","รวมไทยพัฒนา 1","รวมไทยพัฒนา 2","รวมไทยพัฒนา 3","รวมไทยพัฒนา 4","รวมไทยพัฒนา 5","รวมไทยพัฒนา 6","รวมมิตรพัฒนา","รวมมิตรวิทยา","ร่วมมิตรวิทยา","รวมมิตรวิทยา (คังคะเกตุอุปถัมภ์)","ร่วมราษฎร์วิทยานุกูล","รวมราษฎร์สามัคคี","รสลินคัคณางค์","ร่องเคาะวิทยา","ร่องตาทีวิทยา","ร่องธารวิทยา","ร่องเบ้อวิทยา","ร้องประดู่ (หนุนเภา-ประชาสงเคราะห์)","บ้านร่องส้าน","รอซีดี","รอดนิลวิทยา","อนุบาลรอดบำรุง","รอดโพธิ์ทองวิทยาสรรค์","ร่อนพิบูลย์","ระแงะ","ระดมวิทยานุสรณ์","ระดิ่งหินประชาสรรค์","ระนองพัฒนามิตรภาพที่ 60","ระวิราษฎร์บำรุง","รักชาติประชาบำรุง","รักไทย","รักไทยร่มเกล้าอุปถัมภ์","รักเมืองไทย 1 (มูลนิธิเตชะไพบูลย์)","รักเมืองไทย 2","รักเมืองไทย 6 บ้านโตนงาช้าง (เผียนประชาอุปถัมภ์)","รักษาทรัพย์พิทยากร","รักษาราชวิตร","รังงามวิทยา","รังสิตวิทยา","รัชดาภิเษก","รัชมังคลาภิเษกบ้านโนนป่าเลา","รัฐการุณวิทยา","รัฐเขื่อนพลเทพอุปถัมภ์","รัฐทวิคาม","รัฐประชา 509","รัฐประชานุสรณ์","รัฐประชาวิทยาคาร","รัฐประชาสามัคคี","รัฐราษฎร์นุเคราะห์","รัฐราษฎร์บำรุง","รัฐราษฎร์พัฒนา","อนุบาลรัฐราษฎร์รังสรรค์","รัฐราษฎร์วิทยา","รัฐราษฎร์สงเคราะห์","รัฐราษฎร์อุปถัมภ์","รัตนโกสินทร์ 9","รัตนโกสินทร์ 2","รัตนโกสินทร์สมโภช (ราชทัณฑ์อุปถัมภ์)","รัตนชัยศึกษา","รัตนประชานุสรณ์","รัตนประทีปวิทยา","รัตนวิทยาคม","รัตนาเอื้อวิทยา","รัษฏานุประดิษฐ์อนุสรณ์","ราชบพิธ","ราชประชานุเคราะห์","ราชประชานุเคราะห์ 11","ราชประชานุเคราะห์ 12","ราชประชานุเคราะห์ 13","ราชประชานุเคราะห์ 14","ราชประชานุเคราะห์ 16","ราชประชานุเคราะห์ 17","ราชประชานุเคราะห์ 18","ราชประชานุเคราะห์ 21","ราชประชานุเคราะห์ 22","ราชประชานุเคราะห์ 27","ราชประชานุเคราะห์ 28","ราชประชานุเคราะห์ 29","ราชประชานุเคราะห์ 3","ราชประชานุเคราะห์ 4","ราชประชานุเคราะห์ 5","ราชประชานุเคราะห์ 6","ราชประชานุเคราะห์ 7","ราชประชานุเคราะห์ 8","ราชประชานุเคราะห์ 1","ราชประชานุเคราะห์ 10","ราชประชานุเคราะห์ 15","ราชประชานุเคราะห์ 9","ราชประสงค์","ราชพัฒนา","ราชภักดี","ราชวิถี (ประสาทราษฎร์บำรุง)","ราชวินิต","ราชวินิตประถมบางแค","ราชเวชพิศาล","ราชสารสุธีอนุสรณ์","ราชานุเคราะห์","ราชานุบาล","รามราชพิทยาคม","รามวิทยาประชานุสรณ์","ราษฎร์จุฬาสามัคคี","ราษฎร์เจริญ","ราษฎร์ดำริ","ราษฎร์นิยม","ราษฎร์นิรมิตร","ราษฎรนุกูล","ราษฎร์นุเคราะห์","ราษฎร์บำรุงธรรม","ราษฎร์บำรุง","ราษฎร์ประชาอุทิศ","ราษฎร์ประดิษฐ์วิทยา","ราษฎร์พัฒนา","ราษฎร์พัฒนาสามัคคี","ราษฎร์ร่วมแรงรัฐ (กำจัดอุปถัมภ์)","ราษฎร์ร่วมสามัคคี","ราษฎร์รัฐพัฒนา","ราษฎร์ศรัทธาวิทยา","ราษฎร์ศุภประดิษฐ์","ราษฎร์สงเคราะห์วิทยา","ราษฎร์สโมสร","ราษฎร์สามัคคี","ราษฎร์อํานวย","ราษฎร์อุทิศ","ราษฎร์อุทิศ (ปูแล)","ราษฎร์อุปถัมภ์ สาขาหนองน้ำเขียว","ราษฎร์อุปถัมภ์","ร่ำเปิงวิทยา","ริม-ป่าคาประชานุเคราะห์","ริมฝั่งน่านวิทยา","ริมฝั่งว้าวิทยา","รือเสาะชนูปถัมภ์","รุ่งรัฐวิทยา","รุ่งเรืองวิทยา","รุ่งเรืองอุปถัมภ์","รุ่งวิทยาประชาอุปถัมภ์","รุ่งอรุณวิทยา","รุจิรพัฒน์","รุจีจินตกานนท์","เรณูวิทยาคาร","เรืองเจริญพัฒนา","เรืองดรุณีวิทยา","เรืองเดชประชานุเคราะห์","เรืองทองสามัคคี","โรงพยาบาลอานันทมหิดล","โรซารีโอวิทยา","โรตารี่ 1 บ้านพุน้ำร้อน","โรตารี่กรุงเทพ","โรตารี่สวรรคโลก 1","ไร่ใต้ประชาคม","ไร่อ้อย","ฤทธิณรงค์รอน","ฤทธิยะวรรณาลัย","ฤทัยทิพย์","ฤาษีพหลวิทยา","ล่องแพวิทยา","ล้อมแรดวิทยา","ลอยสายอนุสรณ์","ละมูลรอดศิริ","ละเมาะ","ละแมวิทยา","ละหานเจริญวิทยา","ละอายพิทยานุสรณ์","ละเอียดอุปถัมภ์","ลัดดาประชาสรรค์","ลาซาล","ลาดงาวิทยาคม (ปลั่ง ฤกษ์จารี)","ลาดตะเคียนราษฎร์บำรุง","วัดหลักชัย (ประชาบันลือฤทธิ์)","ลาดบัวหลวง (นิ่มนวลอุทิศ)","ลาดสว่างวิทยา","ลานกระบือวิทยา","ลำพะอง (ราษฎร์จำเริญบำรุง)","ลิ้นจี่อุทิศ","ลุงถ่อนราษฎร์อุทิศ","ลุ่มน้ำวิทยา","ลุ่มโป่งเสี้ยว","ลุมพลีชนูปถัมภ์","ลุ่มระวีวิทยา","ลูกจันทน์ปิยะอุย","เลยตาดโนนพัฒนา","เลอเดชประชานุสรณ์","เลิงถ่อนโนนสมบูรณ์","เลิดสิน","เลิศหล้า","ไลออนส์บ้านหนองปลา","วงศ์วิทย์","วชิรวิทย์ (ฝ่ายประถม)","วชิรสารศึกษา","วนาประชารัฐบำรุง","วนาสงเคราะห์","วนาสวรรค์","วรคามินอนุสรณ์","เซนต์ยอแซฟกาฬสินธุ์","วรนคร","วรพัฒน์","วรรธนะสาร","วราวัฒนา","วอแก้ววิทยา","วอนนภาศัพท์","วังกรดนุกูลศึกษา","วังกะอาม","วังก้านเหลือง","วังก้านเหลืองดรุณกิจ","วังเกาะเหล็กทุ่งสว่างวิทย์","วังแก้ววิทยา","วังไกลกังวล","วังเขาแก้ว(หงำอุปถัมภ์)","วังจระเข้","วังดอกไม้","วังตะโก (ช้องประชาพิทักษ์)","วังทองวิทยา","วังธราธิปวิทยา","วังนกไข่","วังน้อยวิทยาภูมิ","วังน้ำพุ","วังบงน้อยวิทยา","วังโป่งดํารงวิทย์","วังไผ่","วังพร้าววิทยา","วังโพธิ์สว่างศิลป์","วังโพน","วังม่วงวิทยาคม","วังมะเดื่อ","วังยางวิทยาคาร","วังยาวเจริญวิทย์","วังวารีวนราษฎร์วัฒนา","วังวิทยา","วังวิเศษ","วังศรีทอง","วังสมบูรณ์วิทยาคม","วังสวาทนิคมสงเคราะห์","วังสามหมอวิทยาคาร","วังสำโรง ","วังหลวง","วังหินประชาสรรค์","วังหินวิทยา","วังใหม่พัฒนา","วัชรชัย","วัฒนดรุณวิทย์","วัฒนราษฎร์ศึกษา","วัฒนศึกษา","วัฒโนทัยพายัพ","วัดกก","วัดกกแก้วบูรพา","วัดกกตาด","วัดกกตาล (สีมารัตน์วิทยา)","วัดกกเต็น","วัดกกม่วง","วัดกกแรต","วัดกกสับ","วัดกงตาก","วัดกงลาด","วัดกรงทอง","วัดกรมธรรม์","วัดกรอกยายชา","วัดกระแจะ","วัดกระโจม","วัดกระโจมทอง","วัดกระเฉท","วัดกระแชง ","วัดกระซ้าขาว","วัดกระดังงา","วัดกระดังงา (จันทร์ราษฎร์บำรุง)","วัดกระโดงทอง (พิบูลประสิทธิ์)","วัดกระต่ายเต้น","วัดกระทุ่ม (โสมประชาสรรค์)","วัดกระทุ่มปี่","วัดกระทุ่มแพ้ว","วัดกระทุ่มเสือปลา","วัดกระบังมังคลาราม (พิศาลประชาสรรค์)","วัดกรับพวง","วัดกร่างทองราษฎร์บูรณะ","วัดกร่างสามยอด","วัดกรุงศรีเจริญ","วัดกรุณา","วัดกลาง (พุฒราษฎร์อนุเคราะห์)","วัดกลาง","วัดกลาง (ธรรมวิธานราษฎร์วิทยา)","วัดกลาง (ประมวญราษฎร์บำรุงวิทย์)","วัดกลาง (ปากกรานสามัคคี)","วัดกลาง (รักษ์ราษฎร์อุปถัมภ์)","วัดกลางเกร็ด","วัดกลางครูเวียง","วัดกลางคลองวัฒนาราม","วัดกลางคลองสระบัว (สำลีเหลือบราษฎร์บำรุง)","วัดกลางคลองสาม","วัดกลางคลองสี่","วัดกลางคลองหลวง","วัดกลางชูศรีเจริญสุข","วัดกลางดง","วัดกลางแดด","วัดกลางธนรินทร์","วัดกลางบางแก้ว (พุทธวิถีประสิทธิ์)","วัดกลางบ้านดอน","วัดกลางพรหมนคร","วัดกลางราษฎร์บำรุง","วัดกลางวงศ์มณี","วัดกลางสุริยวงศ์","วัดกลางใหม่ (มิตรภาพที่ 24)","วัดกล้าชอุ่ม","วัดกษัตราธิราช","วัดกองแก้ว (ผาดกาบแก้ว)","วัดกองดิน","วัดกองทราย","วัดก้อนแก้ว(สำนักงานสลากกินแบ่งสงเคราะห์7)","วัดกอไผ่ (ปฏิพัทธ์สหราษฎร์)","วัดกะทิง (ขันธสโรอุปถัมภ์)","วัดกะทิง","วัดกะเปียด","วัดกะสังข์ (พิศิษฎ์นวการอุปถัมภ์)","วัดกะแส","วัดกะโสม","วัดกะเหรี่ยงคอม้า","วัดกัด","วัดกัลปพฤกษ์","วัดกัลยาณธรรมาราม","วัดกัลยานฤมิต","วัดก้างปลา","วัดกาญจนบริรักษ์","วัดกาญจนบุรีเก่า ","วัดกาญจนาราม","วัดกาญจนาราม (ประชาชนูทิศ)","วัดก้านเหลือง","วัดกาบบัว","วัดการ้อง","วัดกาหรํา","วัดกาหลง","วัดกาหลง (พึ่งสุนทรอุทิศ)","วัดกาโห่ใต้","วัดกาฬสินธุ์","วัดกำแพง","วัดกำแพงถม","วัดกำแพงแสน","วัดกำมะเชียร","วัดกำมะเสน","วัดกิ่งแก้ว","วัดกิ่วมื่น","วัดกุญชรวชิราราม (พัฒนาวิเทศประชาสรรค์)","วัดกุฎิ (ชุ่มประชารังสรรค์)","วัดกุฎิ (นันทวิเทศประชาสรรค์)","วัดกุฎีทอง","วัดกุฎีประสิทธิ์","วัดกุฎีลาย","วัดกุฏีเตี้ย","วัดกุดตะเคียน","วัดกุดนกเปล้า","วัดกุดน้ำใส","วัดกุดพิมาน","วัดกุดเวียน","วัดกุดสวาย","วัดกุ่ม (เรือนพูนพิทยา)","วัดกุ่มโคก","วัดกุ่มแต้","วัดกุยบุรี","วัดกู้ (นันทาภิวัฒน์วิทยา)","วัดกู่คำ","วัดกู่สามัคคี","วัดกู่เส้า","วัดเกตการาม (พรหมสุวัฒน์วิทยาคาร)","วัดเกตุ","วัดเกตุ (ประชารัฐอุปถัมภ์)","วัดเกตุน้อย (โสภณประชานุกูล)","วัดเกตุประภา","วัดเกตุสโมสร","วัดเกรียงไกร (โพธิ์ประสิทธิ์)","วัดเกรียงไกรเหนือ","วัดเกวียนหัก (สมบัติราษฎร์นุกูล)","วัดเกศแก้ว","วัดเกษตรกันทราราม","วัดเกษตรชลธี (เลื่อนประชาคาร)","วัดเกษตรธิการาม","วัดเกษตรนิคม","วัดเกษตราราม","วัดเกษทอง","วัดเกษมบำรุง","วัดเกษมรัตน์","วัดเกษมสุริยัมนาจ (เกษมวิทยาคาร)","วัดเก้าชั่ง","วัดเกาะ","วัดเกาะ(สําลีราษฎร์อุปถัมภ์)","วัดเกาะกระชาย","วัดเกาะกลอย","วัดเกาะกา","วัดเกาะแก้ว","วัดเกาะแก้วเวฬุวัน (พินิจค้าประชาสรรค์)","วัดเกาะแก้วสุวรรณาราม","วัดเกาะขวาง","วัดเกาะจันทาราม","วัดเกาะจาก","วัดเกาะจิก","วัดเกาะเซิงหวาย","วัดเกาะแดง","วัดเกาะตะเคียน (วาสน์วิทยานุกูล)","วัดเกาะโตนด","วัดเกาะถ้ำ","วัดเกาะน้อย","วัดเกาะเปา","วัดเกาะพิกุล","วัดเกาะมะไฟ","วัดเกาะมะม่วง","วัดเกาะยาง","วัดเกาะแรต (อุภัยเพชรพิทยาคาร)","วัดเกาะลอย (วิเวกวิทยาคาร)","วัดเกาะลอย","วัดเกาะลอย (ชุณหะวัตราษฎร์รังสรรค์)","วัดเกาะลันตา","วัดเกาะเลิ่ง","วัดเกาะวังไทร","วัดเกาะวิมุตตาราม","วัดเกาะศาลพระ","วัดเกาะสระ","วัดเกาะสวาด","วัดเกาะสุวรรณาราม","วัดเกาะหวาย","วัดเกิดการอุดม","วัดแก่งหางแมว","วัดแก่นจันทน์(จันทร์ เอียง ทับทิม ราษฎร์บำรุง)","วัดแกลงบน","วัดแก้ว","วัดแก้ว (ประโชติวิทยาภรณ์)","วัดแก้ว (รัตนบินวิทยาคาร)","วัดแก้วกระจ่าง","วัดแก้วเจริญ(เฟื้อบำรุง)","วัดแก้วแจ่มฟ้า","วัดแก้วตา (สุมนพรฉิมประชาสรรค์)","วัดแก้วฟ้า (ธรรมโชติประชานุกูล)","วัดแก้วศิลาราม","วัดแก้วสุวรรณ","วัดโกรกแก้ววงพระจันทร์","วัดโกรกประดู่","วัดโกศาวาส","วัดโกสินารายน์","วัดไก่","วัดไก่จ้น (ชลประทานอุปถัมภ์)","วัดไก่เตี้ย (วิทยสุนทร)","วัดไก่เตี้ย","วัดไก่เส่า (พันธุ์พิทยาคาร)","วัดขจรบำรุง","วัดขนงพระเหนือ","วัดขนอน","วัดขนอนบ้านกรด","วัดขนาน","วัดขนาบนาก","วัดขนุน (พรหมราษฎร์วิทยา)","วัดขนุน","วัดขรัวช่วย","วัดข่วงสิงห์","วัดขวาง","วัดขวิด (สำนักงานสลากกินแบ่งสงเคราะห์ 123)","วัดขอนชะโงก (เขียววิมลราษฎร์อุปถัมภ์)","วัดขอนหอม","วัดข่อย","วัดข่อยกลาง","วัดข่อยใต้","วัดขะจาว","วัดขิงกระชาย","วัดขี้ตุ่น","วัดขี้เหล็ก","วัดขุนกระทิง","วัดขุนคง","วัดขุนจ่าธรรมาราม","วัดขุนซ่อง","วัดขุนตัดหวาย","วัดขุนทิพย์ (สาครราษฎร์บำรุง)","วัดขุนไทยธาราราม","วัดขุนสงฆ์","วัดขุนสิทธิ์","วัดขุมแก้ว","วัดขุมทอง","วัดขุยโพธิ์","วัดเข็มทอง","วัดเขมาภิรัติการาม (เกษมราษฎร์บำรุง)","วัดเขา","วัดเขา (วันครู 2501)","วัดเขากระจิว มิตรภาพที่ 103","วัดเขากลอย","วัดเขากลาย","วัดเขากลิ้ง (รุ่งเจริญธรรม)","วัดเขากะโดน","วัดเขาแก้ว","วัดเขาแก้วมุขดาราม","วัดเขาไก่แจ้","วัดเขาขลุง","วัดเขาขุนพนม","วัดเขาคันธมาทน์","วัดเขาคีรีรมย์ (ฤทธิพรรณราษฎร์อุปถัมภ์)","วัดเขาฆ้องชัย","วัดเขางูสันติธรรม","วัดเขาจำปา(เทียนราษฎร์อุทิศ)","วัดเขาเจดีย์","วัดเขาเจริญธรรม","วัดเขาแจง","วัดเขาฉลาก","วัดเขาชะงุ้ม","วัดเขาเชิงเทียนเทพาราม","วัดเขาดาวเรือง","วัดเขาดิน","วัดเขาดิน (วันครู 2502)","วัดเขาดีสลัก","วัดเขาดุม","วัดเขาแดง","วัดเขาต่อ","วัดเขาตะเครา (ประสพประชาสรรค์)","วัดเขาตะพั้น","วัดเขาตาหน่วย","วัดเขาถ้ำกุญชร","วัดเขาทราย","วัดเขาทอง","วัดเขาทะโมน (เรือนวงศ์ทองศรี)","วัดเขาน้อย","วัดเขาน้อย (ปุ่นประชานุกูล)","วัดเขาน้อย (ศิลาทองวิทยาคาร)","วัดเขาน้อยจอมสวรรค์","วัดเขานางเภา","วัดเขาบ่อพลับ","วัดเขาปฐวี","วัดเขาปากช่อง","วัดเขาป้าเจ้","วัดเขาปิ่นทอง","วัดเขาปูน","วัดเขาผาแรต","วัดเขาไผ่ (เชี่ยววิทยาคุณ)","วัดเขาฝา","วัดเขาพนมไตรรัตน์","วัดเขาพนมนาง","วัดเขาพนมแบก","วัดเขาพนมพา","วัดเขาพระ","วัดเขาพระนิ่ม","วัดเขาพระยาสังฆาราม","วัดเขาโพธิ์ทอง","วัดเขาโพรกเพลง","วัดเขามโน","วัดเขามีเกียรติ","วัดเขายี่สาร (ประมุขเวชกิจ)","วัดเขารวก","วัดเขารักษ์","วัดเขาราษฎร์บำรุง","วัดเขารูปช้าง","วัดเขาโร","วัดเขาลาดวนาราม ","วัดเขาวง","วัดเขาวงก์","วัดเขาวงกฎ","วัดเขาวงกตรุจิรวงศาราม","วัดเขาวนาพุทธาราม","วัดเขาวัง (แสง ช่วงสุวนิช)","วัดเขาวิเศษ","วัดเขาศรีวิชัย","วัดเขาส้ม","วัดเขาสมอคอน","วัดเขาสมอระบัง","วัดเขาสมุก","วัดเขาสะพายแร้ง","วัดเขาส้าน","วัดเขาสามสิบหาบ","วัดเขาสำเภาทอง","วัดเขาสำรอง","วัดเขาสุวรรณประดิษฐ์","วัดเขาหนีบ","วัดเขาห้วยลุง","วัดเขาหินเทิน","วัดเขาใหญ่","วัดเขาอ้อ","วัดเขียน","วัดเขียนเขต","วัดเขียนลาย (ทองคำวิทยานุสรณ์)","วัดเขื่อน ","วัดเขื่อนเพชร (วชิรเวทประชาสรรค์)","วัดแขมหนู","วัดโขดหอย (ละเมียดราษฎร์นุเคราะห์)","วัดโขดหินมิตรภาพที่ 42","วัดโขมง","วัดคงคา","วัดคงคาเจริญ","วัดคงคาราม","วัดคงคาราม (คุ้มมั่นพุมมะระประชาสรรค์)","วัดคงคาราม (อินทราชผดุงศิลป์)","วัดคงคาล้อม","วัดคงคาเลียบ","วัดคงคาวดี","วัดคงคาวดี (ศรีสุวรรณโณศึกษา)","วัดคงคาวราราม","วัดคงคาสวัสดิ์","วัดคงษา (ประชา-รัฐอุปถัมภ์)","วัดคณฑี","วัดคมนียเขต","วัดคมบาง (เพิ่มพิทยากร)","วัดคร้อพนัน","วัดคร่อเรียงราย","วัดครุนอก","วัดครุใน (ปีตะนีลานนทศึกษา)","วัดคลอง 18","วัดคลองกระจง","วัดคลองเกษม","วัดคลองเกษมเหนือ","วัดคลองเก้า","วัดคลองขยัน","วัดคลองขวาง (จรูญชนม์ราษฎร์บำรุง)","วัดคลองขอม","วัดคลองข่อย","วัดคลองขุด","วัดคลองขุนศรี","วัดคลองเขื่อน (มงคลบุตรประชาสรรค์)","วัดคลองแขก","วัดคลองครุ","วัดคลองคาง (แดงประชานุกูล)","วัดคลองคูณ","วัดคลองโคน","วัดคลองเฆ่","วัดคลองงิ้ว","วัดคลองจินดา","วัดคลองเจริญ","วัดคลองเจ้า","วัดคลองเจ้า (แช่มชื่นราษฎร์บำรุง)","วัดคลองฉนวน","วัดคลองชัน","วัดคลองชากพง","วัดคลองต้นหมัน","วัดคลองตะเคียน","วัดคลองตัน","วัดคลองตันราษฎร์บํารุง","วัดคลองตาคล้าย","วัดคลองตาล","วัดคลองตาล (ศรีรัตนประชานุกูล)","วัดคลองตาสูตรสามัคคี","วัดคลองทองหลาง","วัดคลองธรรม","วัดคลองน้อย","วัดคลองโนน","วัดคลองบางเดื่อ","วัดคลองบ้านโพธิ์","วัดคลองบุญ","วัดคลองปูน","วัดคลองเป็ด","วัดคลองโป่ง (ธรรมภาณบำรุง)","วัดคลองพลู","วัดคลองพูล (บุญส่งอนุสรณ์)","วัดคลองโพธิ์","วัดคลองโพธิ์ศรี","วัดคลองมอญ (บัญญัติราษฎร์บำรุง)","วัดคลองมะเกลือ","วัดคลองเม่า","วัดคลองโมง","วัดคลองยอ","วัดคลองยาง","วัดคลองยาง ","วัดคลองสน","วัดคลองสวน (พิบูลธรรมขันธ์)","วัดคลองสวน (พรหมอุทิศวิทยาคาร)","วัดคลองสองหน่อ","วัดคลองสามแยก","วัดคลองสาลี","วัดคลองสำโรง","วัดคลองห้า","วัดคลองแห","วัดคลองใหญ่","วัดคลองใหม่","วัดควน","วัดควนกอ","วัดควนเกย","วัดควนโก","วัดควนขี้แรด","วัดควนเคร็ง","วัดควนเคี่ยม","วัดควนชม","วัดควนชะลิก","วัดควนถบ","วัดควนเถียะ","วัดควนท่าแร่","วัดควนไทร","วัดควนธานี","วัดควนนางพิมพ์","วัดควนนิมิตศิลา","วัดควนเนียง","วัดควนป้อม","วัดควนปันตาราม","วัดควนเผยอ","วัดควนเพ็ง","วัดควนแพรกหา","วัดควนมณี","วัดควนยาว","วัดควนยูง","วัดควนแร่","วัดควนลังมิตรภาพที่ 11","วัดควนวิไล","วัดควนวิเศษ","วัดควนศรี","วัดควนสมบูรณ์","วัดควนสระบัว","วัดควนสะตอ","วัดควนส้าน","วัดควนสามโพธิ์","วัดควนสีนวล","วัดควนสูง","วัดควนใส","วัดควนอินทร์นิมิตร","วัดควรนิยม","วัดคอกกระบือ (จอมประชาสรรค์)","วัดคอกช้าง","วัดคอกวัว","วัดคอลาด","วัดคันโช้ง","วัดคันทด","วัดคันธมาลี","วัดคันนาราม","วัดคันลัด","วัดค่ากลาง","วัดคานหาม","วัดค่าย (เล็กจุฬาประชานุสรณ์)","วัดคำพราน","วัดคำหยาด","วัดคิริวิหาร","วัดคีม","วัดคีรีกันทร์","วัดคีรีเขต","วัดคีรีเจริญผล","วัดคีรีภาวนาราม","วัดคีรีมาส","วัดคีรีรัตนาราม","วัดคีรีวง","วัดคีรีวงการาม","วัดคีรีวัน","วัดคุ้งกระถิน (ราษฎร์สามัคคึอุทิศ)","วัดคุ้งกร่าง (อาทรประชา)","วัดคุ้งตำหนัก","วัดคุ้งท่าเลา","วัดคุ้งนาบุญ","วัดคุ้งยาง","วัดคุ้งยางใหญ่","วัดคุ้งวารี","วัดคุ้งวารี (อำพันอุปถัมภ์)","วัดคุณหญิงส้มจีน มิตรภาพที่ 64","วัดคุณาราม","วัดคุยขวาง","วัดคุยม่วง","วัดคู้เกษมสโมสร (วิชัย-สายประชาสรรค์)","วัดคูขุด","วัดคูบัว","วัดคูมอญ","วัดคูเมือง","วัดคูยาง","วัดคู้ลำพัน","วัดคูวา (เลื่อนประชาสฤษฎ์)","วัดคู้สนามจันทร์(สามัคคีราษฎร์รังสรรค์","วัดคู่สร้าง","วัดคู้สลอด","วัดคูหาใน","วัดคูหาสวรรค์","วัดคูหาสุวรรณ (วันครู 2504)","วัดแค","วัดแคทราย(บุญประชาสรรค์)","วัดแคนอก (คณะราษฎร์บำรุง1)","วัดแคใน (ชื่นแย้มราษฎร์บำรุง)","วัดแคราย (มนต์ประชาสรรค์)","วัดโคก","วัดโคก (ภู่พิพัฒน์บำเพ็ญ)","วัดโคก (ธูปะเตมีย์อุปถัมภ์)","วัดโคกกรวด ","วัดโคกกระต่าย(วารราษฎร์อุปถัมภ์)","วัดโคกกรุง","วัดโคกกลาง","วัดโคกกะถิน","วัดโคกเกตุ (เสริมสมบูรณ์วงศ์)","วัดโคกโก","วัดโคกขาม(นรสิงห์อนุสรณ์)","วัดโคกขี้หนอน","วัดโคกขี้เหล็ก","วัดโคกเขมา","วัดโคกเขื่อน","วัดโคกคราม","วัดโคกโคเฒ่า","วัดโคกงาม","วัดโคกจันทน์","วัดโคกเจริญเนตร","วัดโคกแจง (ประชานุกุลวิทยา)","วัดโคกชะงาย (ติสสโรอำนวย)","วัดโคกช้าง (ราษฎร์บำรุง)","วัดโคกตะเคียน","วัดโคกทราง","วัดโคกทอง","วัดโคกทอง (บวรวิทยา)","อนุบาลวัดโคกท่าเจริญ","วัดโคกป่าแพง","วัดโคกพรมตั้งตรงจิตร 7","วัดโคกพระ","วัดโคกพระเจดีย์ (เอกเผ่าพิทยา)","วัดโคกพระเจริญ","วัดโคกพระศิลาราม","วัดโคกพิกุล","วัดโคกพุทรา","วัดโคกเพลาะ","วัดโคกโพธิ์","วัดโคกโพธิ์ (โอภาสราษฎร์สามัคคี)","วัดโคกโพธิกุญชร","วัดโคกโพธิ์สถิตย์","วัดโคกม่วง","วัดโคกมะกอก","วัดโคกมะเฟือง","วัดโคกมะม่วง","วัดโคกมะยม","วัดโคกเมรุ","วัดโคกยาง","วัดโคกยายเกตุ","วัดโคกแย้ม","วัดโคกล่าม ","วัดโคกลำดวน","วัดโคกเลียบ","วัดโคกศักดิ์ (เซี้ยนประชารัฐ)","วัดโคกสมานคุณ","วัดโคกสระน้อย","วัดโคกสลุง","วัดโคกสลุด","วัดโคกสวย","วัดโคกสว่าง","วัดโคกสะอาด","วัดโคกสังข์ ","วัดโคกสำโรง","วัดโคกสุก","วัดโคกสูง","วัดโคกเสลา","วัดโคกหญ้าคา","วัดโคกหนามแท่ง","วัดโคกหม้อ","บ้านโคกหม้อ","วัดโคกหม้อ (ประชาสามัคคี)","วัดโคกหมู","วัดโคกหัวข้าว","วัดโคกหาด","วัดโคกเหรียง","วัดโคกเหล็ก","วัดโคกใหญ่","วัดโคกอุดม","วัดโคธาราม","เทศบาลปลายบางวัดโคนอนราษฎร์บำรุง","วัดโคปูน","วัดโคศุภราช (รัฐราษฎร์บำรุง)","วัดฆ้อ","วัดฆะมัง","วัดโฆสิตาราม","วัดโฆสิทธาราม","วัดงิ้ว (เรือไทยสงเคราะห์)","วัดงิ้วงาม","วัดงิ้วเฒ่า","วัดงิ้วราย (พินพิทยาคาร)","วัดงิ้วราย","วัดโงกน้ำ","วัดจงกลณี (ประสิทธิ์วิทยา)","วัดจตุพิธวราวาส","วัดจรเข้ตาย (พินิจค้าประชาสรรค์)","วัดจรเข้น้อย","วัดจรเข้เผือก","วัดจรเข้ไล่","วัดจรเข้ใหญ่ ","วัดจระเข้ผอม","วัดจระเข้ใหญ่ ","วัดจอมเกษ","วัดจอมคีรี","วัดจอมแจ้ง","วัดจอมไตร","วัดจอมทอง","วัดจอมปราสาท (อุดมวิทยา)","วัดจักรคำภิมุข","วัดจักรวรรดิ","วัดจักรสีห์","วัดจักษา","วัดจังหูน","วัดจังโหลน","วัดจั่นเจริญศรี","วัดจันดี","วัดจันทน์","วัดจันทนาราม(ศรีรองเมืองอุทิศ)","วัดจันทนาราม","วัดจันทบุรี(พิมพ์ประชานุเคราะห์)","วัดจันทร์","วัดจันทร์(ผาดไสวประชาอุทิศ)","วัดจันทร์ (ลอมราษฎร์บำรุง)","วัดจันทร์เจริญสุข","วัดจันทร์ตะวันตกมิตรภาพที่ 73","วัดจันทร์ตะวันออก","วัดจันทร์ทอง","วัดจันทร์นิรมิตร","วัดจันทร์ประดิษฐาราม","วัดจันทร์ประสิทธิ์","วัดจันทร์มณี","วัดจันทร์เรือง","วัดจันทรังษีถาวร","วัดจันทราราม","วัดจันทราวาส (ศุขประสารราษฎร์)","วัดจันทราวาส","วัดจันทาราม","วัดจันทาราม (เติมไลราษฎร์อนุเคราะห์)","วัดจันทาราม (ตั้งตรงจิตร 5)","วัดจันพอ","วัดจันเสน","วัดจาก","วัดจาย (สุทธบุรราษฎร์)","วัดจำปา","วัดจำปาหล่อ","วัดจำปี","วัดจำรุง","วัดจิกพนม","วัดจิกลาด","วัดจินดาราม","วัดจุกกะเฌอ","วัดจุกเฌอ (สมณราษฎร์วิทยาคาร)","วัดจุมพล (วรพรตอุปถัมภ์)","วัดจุฬาจินดาราม","วัดจุฬามณี","วัดจุฬามณี (ชุณหะจัทนประชาสรรค์)","วัดจุฬามณี (มาลยานุสาวรีย์)","วัดจุฬามุนี","วัดเจ็ดยอด","วัดเจ็ดริ้ว (สาครกิจโกศล)","วัดเจดีย์","วัดเจดีย์งาม (เจริญศักดิ์ประชาสรรค์)","วัดเจดีย์ทอง (สุขวิทยาคาร)","วัดเจดีย์สามยอด","วัดเจดีย์หลวง","วัดเจติยาราม (บัณฑิตประชาพานิช)","วัดเจริญธรรม","วัดเจริญธรรม เผอิญศรีภูธรอุปถัมภ์","วัดเจริญธรรม (รัฐประชานุเคราะห์)","วัดเจริญบุญ","วัดเจริญผล","วัดเจริญภูผา","วัดเจริญร่มเมือง","วัดเจริญราษฎร์บำรุง","วัดเจริญราษฏร์","วัดเจริญศรีมณีผล (สุวรรณไวประชานุกูล)","วัดเจริญสุขาราม","วัดเจริญสุขาราม (วัฒนานุวรรัตน์)","เทศบาลวัดเจ้าเจ็ดนอก","วัดเจ้าเจ็ดใน","วัดเจ้าบุญเกิด","วัดเจ้าปลุก (เติมรัฐประชาสรรค์)","วัดเจ้าแปดทรงไตรย์","วัดเจ้าฟ้า (ยอดวิทยานุกูล)","วัดเจ้ามูล","วัดแจ้ง","วัดแจ้ง (เศียรคุรุราษฎร์บำรุง)","วัดแจ้งเจริญ (บุญเหลือประชาสงเคราะห์)","วัดแจ้งพรหมนคร","วัดแจ้งลําหิน","วัดแจ้งศิริสัมพันธ์ (สโมสรสากลอุทิศ)","วัดแจ่มอารมณ์","วัดฉวาก","วัดฉัตรทอง (เลื่อนประชานุกูล)","วัดฉัททันต์สนาน","วัดฉาง","วัดฉิมหลา","วัดเฉลิมพระเกียรติ","วัดเฉลิมมาศ","วัดเฉลิมลาภ","วัดชนสังขรณพิจิตร","วัดชนะสงคราม","วัดชนะสงสาร","วัดชนาธิการาม","วัดชนาราม","วัดชมนิมิตร","วัดชมพูนิมิต","วัดชมพูประดิษฐ์","วัดชมพูสถิต","วัดชยาราม","วัดชลคราม","วัดชลธาร","วัดชลธารประสิทธิ์","วัดชลธารวดี","วัดชลธาราม","วัดชลธาราสิงเห (เสาร์ศึกษาคาร)","วัดชลธีนิมิตร","วัดชลธีพฤกษาราม","วัดชลวาปีวิหาร","วัดชลอ","วัดช่องแกระ","วัดช่องเขา","วัดช่องแค","วัดช่องแบก","วัดช่องเปี่ยมราษฎร์","วัดช่องพราน (บุปผธรรมราษฎร์วิทยา)","วัดช่องลม","วัดช่องลม (ธรรมโชติ)","วัดช่องลมวรรณาราม (สมุทรประชานุกูล)","วัดช่องลาภ (โชคลาภประชาพัฒนา)","วัดช่อม่วง","วัดชะแล้","วัดชะอมสามัคคีธรรม","วัดชะอวด","วัดชัฏใหญ่","วัดชัน","วัดชันสูตร","วัดชัยเฉลิมมิตร (ไพศาลวิทยาคม)","วัดชัยชนะ","วัดชัยชนะสงคราม","วัดชัยธารามประดิษฐ์","วัดชัยธาราวาส","วัดชัยมงคล","วัดชัยมงคลปราสาทวิทยา","วัดชัยมังคลาราม","วัดชัยรัตน์ (ปัญญาประชานุกูล)","วัดชัยศรี","วัดชัยสถาน","วัดชัยสมพร","วัดชัยสิทธาราม","วัดชัยสุนทร","วัดชัยสุวรรณ","วัดชากกอไผ่","วัดชากผักกูด","วัดชากมะกรูด","วัดชากหมาก","วัดช้าง","วัดช่างกระดาษ","วัดช้างข้าม (ประชาช้างข้าม)","วัดช่างคำ","วัดช้างค้ำ","วัดช่างเคี่ยน","วัดช้างชนศิริราษฎร์บำรุง","วัดช่างทอง (บุญบำรุงราษฎร์)","วัดช้างทูน","วัดช้างแทงกระจาด (จันทร์จำนง)","วัดช้างนอน","วัดช่างเหล็ก (พิบูลเกียรติ)","วัดช่างเหล็ก (ส.ช.ก.)","วัดช้างใหญ่","วัดชายเคืองวนาราม (ส้มเช้ารัฐบำรุง)","วัดชายอรัญ","วัดชาวเหนือ","วัดชำป่างาม (สายรัฐประชาสรรค์)","วัดชำผักแพว","วัดชินวราราม (เจริญผลวิทยาเวศม์)","วัดชีธาราม","วัดชีปะขาว","วัดชีปะขาว ","วัดชีผ้าขาว (ประชานุเคราะห์)","วัดชีแวะ","วัดชุกพี้","วัดชุมนุมสงฆ์ (มงคลประชานุกูล)","วัดชุมประดิษฐ์","วัดชุมพลนิกายาราม","วัดชุมพลมณีรัตน์","วัดชุมแสง","วัดชุมแสงศรีวนาราม","วัดเชตุพน","วัดเชิงกระ","วัดเชิงกระบือ","วัดเชิงเขา (แดงอุทิศ)","วัดเชิงคีรี","วัดเชิงแตระ","วัดเชิงท่า","วัดเชิงเลน (นครใจราษฎร์)","วัดเชิงเลน","วัดเชียงราก","วัดเชี่ยวชาญกิจ","วัดแช่มอุทิศ","วัดโชคเกษม (เกษมราษฎร์บำรุง)","วัดโชติการาม","วัดโชติทายการาม","วัดโชติรส","วัดไชยนาราษฎร์","อนุบาลวัดไชยชุมพลชนะสงคราม","วัดไชยธารา (เกิดศิริประชาสรรค์)","วัดไชยนาม","วัดไชยภูมิ","วัดไชยมงคล","วัดไชโย","วัดซองพลู (วิฑิตราชประชานุสรณ์)","วัดซับเสือแมบ","วัดซึ้งบน","วัดซึ้งล่าง (ประชาอุทิศพิทยาคาร)","วัดเซ่าสิงห์","วัดเซิงหวาย","วัดเซิงหวาย (ประชารัฐอุทิศ)","วัดเซิดสำราญ (บ้านเซิดวิทยาคาร)","วัดญาณรังษาราม","วัดดงกะพี้","วัดดงกลาง","วัดดงแก้ว","วัดดงข่อย","วัดดงขี้เหล็ก","วัดดงแขวน","วัดดงโคกขาม","วัดดงชะพลู","วัดดงไชยมัน","อนุบาลวัดดงตาล (วโรสุธาประชาสรรค์)","วัดดงน้อย","วัดดงบัง (ดงบังบำรุงวิทย์)","วัดดงป่าคำ","วัดดงป่างิ้ว","วัดดงพลับ","วัดดงพิกุล","วัดดงเมือง","วัดดงยาง","วัดดงสระแก้ว","วัดดงสวอง","วัดดงสัก","วัดดงหนองหลวง","วัดดงหมี (ธรรมรสอุปถัมภ์)","วัดดอกไม้","วัดดอน","วัดดอนกระต่ายทอง (มิตรภาพที่ 41)","วัดดอนกระเบื้อง","วัดดอนกระเบื้อง (ดอนกระเบื้องราษฎร์บำรุง)","วัดดอนกลอย","วัดดอนกลาง","วัดดอนกอก (ล้วนประชาสรรค์)","วัดดอนกุฎี","วัดดอนแก้ว","วัดดอนไก่เตี้ย","วัดดอนขนาก","วัดดอนขมิ้น","วัดดอนขาด","วัดดอนขี้เหล็ก (กฤษณาประชาสรรค์)","วัดดอนไข่เต่า","วัดดอนคา","วัดดอนคา (ชอบธรรมประชาสรรค์)","วัดดอนใคร","วัดดอนโฆสิตาราม","วัดดอนจั่น","วัดดอนจันทน์","วัดดอนเจดีย์","วัดดอนเจดีย์ราษฎร์บูรณะ","วัดดอนแจง (ไสวราษฎร์วิทยาคาร)","วัดดอนชะเอม","วัดดอนชัย","วัดดอนชื่น","วัดดอนเซ่ง","วัดดอนดำรงธรรม","วัดดอนตรอ","วัดดอนตลุง (ราษฎร์ศรัทธาทาน)","วัดดอนตะโก (วังประชารัฐอุปถัมภ์)","วัดดอนตะเคียน","วัดดอนตะไล้","วัดดอนตาจีน","วัดดอนตาล","วัดดอนตูมกมลาวาส","วัดดอนเตาอิฐ","วัดดอนทราย","วัดดอนทราย (สัมฤทธิ์ราษฎร์นุเคราะห์)","วัดดอนทราย (ไชยประชาสรรค์)","วัดดอนทรายแก้ว","วัดดอนทอง (ประชารัฐบำรุง)","วัดดอนทอง (ราษฎร์ร่วมจิต)","วัดดอนทอง (สุวัณณะศรี ตัณฑิกุล ราษฎร์ศึกษาลัย)","วัดดอนท่านา (ถนอมกาญจนราษฎร์)","วัดดอนบุบผาราม","วัดดอนประดู่","วัดดอนเปา","วัดดอนผาสุก","วัดดอนผิงแดด (ผลสิริราษฎร์รังสรรค์)","วัดดอนพยอม","วัดดอนพรม (ฉายปัญญา)","วัดดอนพัฒนาราม","วัดดอนพุดซา","วัดดอนโพธิ์","วัดดอนโพธิ์ทอง ","วัดดอนโพธิ์ศรี","วัดดอนมะเกลือ (นันทราษฎร์รังสรรค์)","วัดดอนมะขามเทศ (กิติยานุกูล)","วัดดอนมะนาว","วัดดอนมะโนรา (รังสิยานุกูล)","วัดดอนมะปราง","วัดดอนมะม่วง","วัดดอนเมือง","วัดดอนเมือง (ทหารอากาศอุทิศ)","วัดดอนยอ","วัดดอนยอ (จิตธรรมอุปถัมถ์)","วัดดอนยาง","วัดดอนยายหนู","วัดดอนยายหอม (หลวงพ่อเงินอุปถัมภ์)","วัดดอนรวบ","วัดดอนรักษา","วัดดอนรังนก","วัดดอนไร่","วัดดอนลาน","วัดดอนศาลา (สิทธิราษฎร์รังรักษ์)","วัดดอนสงวน","วัดดอนสนวน","วัดดอนสัก","วัดดอนสักมิตรภาพที่ 231","วัดดอนสาลี","วัดดอนสำโรง","วัดดอนสีนนท์","วัดดอนสุโข","วัดดอนสุทธาวาส","วัดดอนเสลา (ปาน พูน รัฐ ราษฎร์บำรุง)","วัดดอนเสาเกียด","วัดดอนแสลบ","วัดดอนหวาย","วัดดอนหวาย (นครรัฐประสาท)","วัดดอนใหญ่","วัดดอนใหญ่ (ทรัพย์ประชาสรรค์)","วัดดอนอภัย","วัดดอย","วัดดอยแก้ว","วัดดานคุรุราษฎร์อุทิศ","วัดด่านช้าง","วัดด่านทับตะโก","วัดด่านสำโรง","วัดดาปานนิมิต มิตรภาพที่ 142","วัดดารา","วัดดาว","วัดดาวคะนอง","วัดดาวโด่ง (เอิบวิทยาคม)","วัดดาวเรือง","วัดดำรงบุล","วัดดิตถาราม","วัดดินดอน","วัดดินแดง","วัดดิสหงสาราม","วัดดิสานุการาม","วัดดีบอน","วัดดีหลวง","วัดดีหลวงนอก","วัดดุสิดาราม","วัดเดชานุสรณ์","วัดเด่นใหญ่","วัดเดิมเจ้า","วัดเดิมบาง","วัดแดง","วัดแดง (นนทคุณพิพัฒน์ราษฎร์อุปถัมภ์)","วัดโดน","วัดใดยาว","วัดใดวน","วัดใดใหญ่","วัดไดอีเผือก","วัดตกพรม","วัดต้นไคร้","วัดต้นชุมแสง","วัดต้นต้อง","วัดต้นตาล","วัดต้นตาล (ต้นตาลประชาสฤษฎิ์)","วัดต้นทอง","วัดต้นโพธิ์ศรีมหาโพธิ","วัดต้นสน (บุญมีโชติวิทยา)","วัดตปะโยคาราม","วัดตโปทาราม","วัดตรงบน","วัดตรณาราม","วัดตรัยรัตนากร","วัดตรีจินดาวัฒนาราม (เฉลิมรัฐราษฎร์นุกูล)","วัดตรีธาราราม","วัดตรีบุญญาราม","วัดตรีพาราสีมาเขต","วัดตรีเอการาม","วัดตลาด","วัดตลาด (อุดมวิทยา)","วัดตลาดโพธิ์","วัดตลาดใหม่ (อินทประชาสรรค์)","วัดตลิ่งชัน","วัดตลุกดู่","วัดตองปุ","วัดตอนิมิตร (สิทธิราษฎร์รังสรรค์)","วัดตะกล่ำ","วัดตะกาง","วัดตะกาดเง้า","วัดตะกู (เมตตาชนูปการ)","วัดตะกู (สมจิตรัชนีอุปถัมภ์)","วัดตะโกรวม","วัดตะโกสูง (เหรียญอุปถัมภ์)","วัดตะคร้ำเอน","วัดตะเคียน","วัดตะเคียนทอง","วัดตะเคียนเลื่อน (รังสีวุฒากาสอุปถัมภ์)","วัดตะเฆ่ (ม่วงงามนุเคราะห์)","วัดตะบอง (ธรรมาภิรมอุปถัมภ์)","วัดตะปอนน้อย","วัดตะปอนใหญ่","วัดตะพงนอก (รังษีปิยะราษฎรังสรรค์)","วัดตะพังคลี","วัดตะพังหม้อ","วัดตะแพน","วัดตะลุง","วัดตะลุงเก่า","วัดตะลุ่ม","วัดตะวันเรือง","วัดตะโหนด (ประชารักษ์เวสสถิตวิทยา)","วัดตะโหนด","วัดตะโหนดราย (พรหมสวัสดิ์สาทร)","วัดตะโหมด (หมุนคณานุสรณ์)","วัดตันติการามมิตรภาพที่ 109","วัดตันทาราม","วัดตากแดด","วัดตากแดด (รอดประชานุกูล)","วัดตากวน","วัดตาก้อง (รัฐราษฎร์บำรุง)","วัดตาขัน","วัดตาคลี (นิปุณทองคำประชาสรรค์)","วัดตานาด","วัดตาปะขาวหาย","วัดตาผา","วัดตาพลาย","วัดตายม","วัดตาล","วัดตาลกง (ธรรมศรียาทร)","วัดตาลเจ็ดช่อ","วัดตาลเดี่ยว","วัดตาลเตี้ย (สหประชาสรรค์)","วัดตาลเตี้ย","วัดตาลเรียง (เชยประชานุกูล)","วัดตาลล้อม","วัดตาลเสี้ยน (สีมาราษฎร์)","วัดตาลเอน (โศภนชนูปถัมภ์)","วัดตาลานใต้ (เจริญวิทยา)","วัดตาลานเหนือ (สัตบุศย์สมบูรณ์)","วัดตาสังใต้","วัดตาหลวงคง","วัดตำนาน (วรพัฒนประชาสรรค์)","วัดตำหนัก","วัดตำหนัก (ละเอียดชำนาญอนุศาสน์)","วัดตำหนักใต้ (วิลาศโอสถานนท์นุเคราะห์)","วัดตำหนักเหนือ (ชื่นวิทยานุสรณ์)","วัดตำหรุ มิตรภาพที่ 65","วัดตึก (จำลองศิลป์วิทยา)","วัดตึกราชา","วัดตุ๊กตา","วัดตุ้มหู","วัดตูม (สิริปุณยาประชาสรรค์)","วัดเตย","วัดเตว็ดใน","วัดเต่าทอง","วัดเตาปูน","วัดแตน","วัดแตระ (ปาลานุเคราะห์)","วัดโตนด","วัดโตนด (เชนวิทยา)","วัดโตนด (บุญชื่นอุปถัมภ์)","วัดโตนดด้วน","วัดโตนดเตี้ย","วัดโตนดหลวง (สุขประสิทธิ์วิทยา)","วัดใต้บ้านบ่อ (โพธิบุญราษฏร์บำรุง)","วัดไตรมารคสถิตตั้งตรงจิตร 11 ฯ","วัดไตรมิตรวราราม","วัดไตรรัตนากร","วัดไตรรัตนาราม","วัดไตรสามัคคี","วัดถนน","วัดถนนแค","วัดถนนหักน้อยดอนกลอย","วัดถนนเหล็ก","วัดถลุงทอง","เทศบาลวัดถลุงเหล็ก (ปูนซิเมนต์ไทยอุปถัมภ์)","วัดถอนสมอ","วัดถั่วทอง","วัดถ้ำเข้","วัดถ้ำเขาเงิน","วัดถ้ำเขาแดง","วัดถ้ำเขาล้าน","วัดถ้ำคีรีวงศ์","วัดถ้ำตะโก","วัดถ้ำเต่า","วัดถ้ำเทียนถวาย","วัดถ้ำผาสุขใจ","วัดถ้ำพระพุทธ","วัดถ้ำมังกรทอง","วัดถ้ำรงค์ (ผ่านผดุง)","วัดถ้ำวราราม","วัดถ้ำสิงขร","วัดถ้ำใหญ่","วัดถ้ำองจุ","วัดถ้ำอ่างหิน","วัดถิ่นปุรา (เดชสมบูรณ์)","วัดเถรแก้ว","วัดเถรพลาย","วัดเถลิงกิตติยาราม","วัดทด","วัดทรงกระเทียม","วัดทรงคนอง (กิมไน้บำรุงวิทย์)","วัดทรงธรรม","วัดทรงสุวรรณ","วัดทรายขาว","วัดทรายมูล","วัดทวยเทพ","วัดทวีพูลรังสรรค์","วัดทศทิศ","วัดทอง","วัดทอง (สามัคคยานุสรณ์)","วัดทอง (อุดมศิลปวิทยาคาร)","วัดทองกลาง (ประชากรอุปถัมภ์)","วัดท้องคุ้ง ","วัดท้องคุ้ง","วัดท้องคุ้ง ","วัดทองจรรยา","วัดท้องตม","วัดทองทรงธรรม (สามัคคีนฤมิต)","วัดทองทั่ว","วัดทองแท้ (จ่างอนุกูลพิทยา)","วัดทองแท่งนิสยาราม","วัดท้องไทร","วัดทองธรรมชาติ","วัดทองนพคุณ","วัดทองนพคุณ (เจริญราษฎร์วิทยาคาร)","วัดทองใน","วัดทองประดิษฐ์","วัดท้องฝาย","วัดทองพูน","วัดทองเพลง","วัดท้องโพลง","วัดทองย้อย (วุฒิกรประชานุกูล)","วัดท้องลับแล (ธรรมเนตรโสภณ)","วัดทองเลื่อน","วัดทองสะอาด","วัดทองหลาง","วัดทองหลาง (สุขชมวิทยาคาร)","วัดท้องอ่าว","วัดทะเลน้อย","วัดทะเลบก","วัดทะเลปัง","วัดทะเลมิตรภาพที่ 151","วัดทักษิณวารี","วัดทับกระดาน","วัดทับกฤชเหนือ","วัดทับทิม","วัดทับไทร","วัดทับปรู","วัดทับผึ้งน้อย","วัดทับยายเชียง","วัดทับหมัน","วัดทัพคล้าย","วัดทัพชุมพล","วัดทัพยายท้าว","วัดทัพหมัน","วัดทัพหลวง","วัดท่า","วัดท่ากง","วัดท่ากระทุ่ม","วัดท่ากระบือ (ท่ากระบือพิทยาคาร)","วัดท่ากระแส","วัดท่ากาน","วัดทากาศ","วัดท่ากุ่ม","วัดท่าเกวียน (สัยอุทิศ)","วัดท่าเกวียน (ศึกษาประชาสรรค์)","วัดท่าเกษม","วัดท่าแก้ว","วัดท่าโก","วัดท่าข่อย (สำนักงานสลากกินแบ่งรัฐบาล) สงเคราะห์ 126","วัดท่าข่อย (ศาสนกิจโกศล)","วัดท่าข้าม","วัดท่าข้าม (ประสานมงคลราษฎร์)","วัดท่าขาม (สะเทื้อนราษฎร์อุปถัมภ์)","วัดท่าเขา (ธรรมสุวรรณวิทยาคาร)","วัดท่าโขลง มิตรภาพที่ 135","วัดท่าโขลง (พยุงประชานุกูล)","วัดท่าคล้อ","วัดท่าควาย","วัดท่าคอย (สกุณอุปถัมภ์)","วัดท่าแค","วัดท่าแคลง (ท่าแคลงวิทยาคาร)","วัดทางกระบือ (เอื้อดีวิทยาคาร)","วัดทางกลาง (ประชาสามัคคีอุปถัมภ์)","วัดทางข้ามน้อย (ศรีวิไลประชาสรรค์)","วัดทางขึ้น","วัดทางพระ","วัดทางพูน","วัดทางยาว","วัดทางลัด","วัดทางหลวง (เทพราษฎร์รังสรรค์)","วัดทางหลวงโพธิ์ทอง","วัดท่างาม","วัดท่างิ้ว","วัดท่าจัด","วัดท่าเจริญ","วัดท่าฉนวน","วัดท่าชัย","วัดท่าช้าง","อนุบาลเดิมบางนางบวช (วัดท่าช้าง)","วัดท่าช้าง (ท่าช้างประกฤตศึกษา)","วัดท่าชุมนุม","วัดท่าไชย (ประชานุกูล)","วัดท่าซุงทักษิณาราม","วัดท่าซุด (เจริญศิลป์)","วัดท่าแซ","วัดท่าด่าน","วัดท่าดินแดง","วัดท่าต้นกวาว","วัดท่าต้นงิ้ว","วัดท่าตลาด","วัดท่าตลิ่งชัน","วัดท่าตอเลิศบุญยงค์วิทยา","วัดท่าตะโก","วัดท่าตะคร้อ","วัดท่าตะเคียน","วัดท่าตำหนัก (เทพวิทยเสถียร)","วัดท่าตุ้ม","วัดท่าเตียน","วัดท่าทราย","วัดท่าทราย (พิมพานุสร)","วัดท่าทอง","วัดท่าทอง (นิมมานโกวิทพิทยา)","วัดท่าไทร (ดิตถานุเคราะห์)","วัดท่านคร","วัดท่านา","วัดท่านางพรหม","วัดท่านางหอม","วัดท่าน้ำตื้น","วัดทาบทอง","วัดท่าบันเทิงธรรม","วัดท่าบัวทอง","วัดท่าบุญมี","วัดท่าโบสถ์ (สำนักงานสลากกินแบ่งสงเคราะห์ 343)","วัดท่าประดู่","วัดท่าปอ","วัดท่าโป่ง","วัดท่าพญา","วัดท่าพูด (นครผลประชานุกูล)","วัดท่าแพ","วัดท่าโพ","วัดท่าม่วง","วัดท่ามะขาม","วัดท่ามะขาม (ท่ามะขามประชาอุทิศ)","วัดท่ามะขามป้อม","วัดท่ามะนาว","วัดท่ามะปราง","วัดท่าเมรุ","วัดท่าไม้","วัดท้ายเกาะ","วัดท้ายตลาด (วิวัฒน์เกษนราประชานุกูล)","วัดท้ายทะเล","วัดท้ายโนต","วัดท้ายเมือง","วัดท้ายยอ","วัดท้ายย่าน","วัดท้ายลาด","วัดท้ายสำเภา","วัดท้ายหาด (พลอยเจียเส็ง)","วัดท่ายาง","วัดทายิการาม","วัดท่าเยี่ยม","วัดท่าราบ (วันชัยประชานุกูล)","วัดท่าเรียบ","วัดท่าเรือ","วัดท่าเรือ ","วัดท่าแรต","วัดท่าโรงตะวันตก","วัดท่าโรงตะวันออก","วัดท่าล้อ","วัดท่าลาดเหนือ","วัดท้าวโทะ","วัดท้าวอู่ทอง","วัดท่าวังหิน","วัดท่าวัว","วัดท่าศาลา","วัดท่าศาลาราม (เรือนบุญนาคาลัย)","วัดท่าสมอ (สำนักงานสลากกินแบ่งสงเคราะห์258)","วัดท่าสะท้อน","วัดท่าสะอ้าน ","วัดท่าสามัคคี","วัดท่าสำเภาใต้","วัดท่าสำเภาเหนือ","วัดท่าสี","วัดท่าสีโพธิ์เหนือ","วัดท่าสี่ร้อย","วัดท่าสุ่ม","วัดท่าเสม็ด","วัดท่าเสริม","วัดท่าเสา","วัดท่าโสม (คุณสารราษฎร์บำรุง)","วัดท่าหมื่นราม","วัดท่าหยี","วัดท่าหลวงพล (ถาวรวิทยา)","วัดท่าหอย","วัดท่าหัวแหวน","วัดท่าหาด","วัดท่าหิน","วัดท่าหิน (ดรุณศึกษา)","วัดท่าเหว","วัดท่าอิฐ","วัดทำนบ","วัดทำนบตางหน","วัดทำเลไทยโปรดสัตว์","วัดทำใหม่","วัดทุ่ง","วัดทุ่งกฐิน","วัดทุ่งกบิล","วัดทุ่งกระพังโหม","วัดทุ่งกลาง","วัดทุ่งข่า","วัดทุ่งขึงหนัง (ปรางปราณีต) มิตรภาพที่ 127","วัดทุ่งเข็น","วัดทุ่งครุ (พึ่งสายอนุสรณ์)","วัดทุ่งควายกิน","วัดทุ่งคา","วัดทุ่งฆ้อโฆสิตาราม","วัดทุ่งจาน","วัดทุ่งโจ้","วัดทุ่งชา","วัดทุ่งเซียด","วัดทุ่งตะลุมพุก","วัดทุ่งตาเปรี้ยว","วัดทุ่งโตนด","วัดทุ่งทะเลทราย","วัดทุ่งทะเลหญ้า","วัดทุ่งธงไชย","วัดทุ่งน้อย","วัดทุ่งนาไทย","วัดทุ่งนาใหม่","วัดทุ่งบัว","วัดทุ่งเบญจา","วัดทุ่งประดู่","วัดทุ่งปาจาน","วัดทุ่งผักกูด","วัดทุ่งแฝก","วัดทุ่งพระ","วัดทุ่งพิชัย (พรหมวิสุทธิ์อนุสรณ์)","วัดทุ่งพึ่ง","วัดทุ่งเพล (พรชำนิอุปถัมภ์)","วัดทุ่งโพ","วัดทุ่งโพธิ์","วัดทุ่งเฟื้อ","วัดทุ่งมน","วัดทุ่งมะสัง (มิตรภาพที่ 9)","วัดทุ่งยายชี","วัดทุ่งยาว","วัดทุ่งยาว (สิริราษฎร์สามัคคี)","วัดทุ่งแย้","วัดทุ่งรี","วัดทุ่งล้อม (ทองประชานุเคราะห์)","วัดทุ่งลุงมิตรภาพที่ 198","วัดทุ่งศาลา","วัดทุ่งเศรษฐี","วัดทุ่งสงวน (คุรุประชาสรรค์)","วัดทุ่งสบก","วัดทุ่งสมอ","วัดทุ่งสว่าง","วัดทุ่งส้าน","วัดทุ่งสาริกา (ที-สาโรจน์อุปถัมภ์)","วัดทุ่งสิงห์โต","วัดทุ่งสีหลง (ทองดีศรีวิทยาคาร)","วัดทุ่งหญ้าคมบาง","วัดทุ่งหลวง","วัดทุ่งหล่อ","วัดทุ่งหลุก","วัดทุ่งหวังใน","วัดทุ่งหินผุด","วัดทุ่งเหียง","วัดทุ่งใหญ่","วัดเทพกระษัตรี","วัดเทพกุญชรวราราม","วัดเทพคันธาราม","วัดเทพชุมนุม","วัดเทพธิดาราม","วัดเทพนิมิต","วัดเทพนิมิตร","วัดเทพนิมิตวนาราม","วัดเทพประชุมนิมิตร (สาครราษฎร์บำรุง)","วัดเทพประดิษฐ์","วัดเทพประสิทธิ์คณาวาส (ฉ่ำบุญรอดชนูทิศ)","วัดเทพนมเชือด","วัดเทพพนาราม","วัดเทพพิทักษ์","วัดเทพพิทักษ์บุญญาราม","วัดเทพมงคล","วัดเทพรังษี","วัดเทพรังสรรค์","วัดเทพรัตนวนาราม","วัดเทพราช","วัดเทพลีลา (สิงประสิทธิวิทยา)","วัดเทพสถาพร","วัดเทพสนทวารี","วัดเทพสุทธาวาส","วัดเทพสุธาวาส","วัดเทพอำไพ ","วัดเทพอุปการาม (อุป อุ่น พัฒนาประชาสรรค์)","วัดเทพาไพโรจน์","วัดเทพาราม","วัดเทวดาราม","วัดเทวประสาท","วัดเทวราช (บุญเรืองอนุสรณ์)","วัดเทวราชกุญชร","วัดเทวสิทธิ์","วัดเที่ยงพิมลมุข (เรืองวัฒนาคม)","วัดเทียนดัด (นครผลพิทยาคาร)","วัดเทียนถวาย","วัดโทเอก","วัดไทยวิวัฒนาราม","วัดไทยาวาส","วัดไทร","วัดไทร (สินศึกษาลัย)","วัดไทรโกบ","วัดไทรงาม","วัดไทรทอง","วัดไทรทอง (สาครราษฎร์สงเคราะห์)","วัดไทรน้อย","วัดไทรพอน","วัดไทรโพธิ์งาม","วัดไทรย์","วัดไทรย์นิโครธาราม","วัดไทรย้อย","วัดไทรโรงโขน","วัดไทรโสภณ (ปราสาททองโอสถสงเคราะห์)","วัดไทรใหญ่","วัดธงชัยธรรมจักร","วัดธงทอง","วัดธงไทยยาราม","วัดธงหงส์","วัดธนาภิมุข","วัดธรรมเกษตร (เกษตรานุเคราะห์)","วัดธรรมขันธ์ (ประชาสงเคราะห์)","วัดธรรมโฆษณ์","วัดธรรมจริยา","วัดธรรมจริยาวาส","วัดธรรมเจดีย์","วัดธรรมเจดีย์ศรีพิพัฒน์","วัดธรรมโชติ","วัดธรรมถาวร","วัดธรรมนิมิตต์","วัดธรรมประดิษฐ์","วัดธรรมประสิทธิ์","วัดธรรมปัญญา","วัดธรรมเผด็จ","วัดธรรมรักขิตาราม","วัดธรรมราษฏร์เจริญผล","วัดธรรมศาลา","วัดธรรมสถิต","วัดธรรมสถิติ์วราราม","วัดธรรมามูล","วัดธรรมาราม","วัดธรรมาวุธสรณาราม","วัดธรรมาวุธาราม","ดำรงค์วิทยา","วัดธรรมิการาม","วัดธรรมิกาวาส","วัดธัญญวารี","วัดธัญญะผล","วัดธัญญาราม","วัดธัญญารามราษฎร์บํารุง","วัดธาตุ","วัดธาตุ (ธรรมธาดากิจจานุสรณ์)","วัดธาตุทอง","วัดธารน้ำฉา","วัดธารน้ำไหล","วัดธารพูด (ประพันธ์ ทับ ประชาสวรรค์)","วัดธาราวง","วัดธาราสถิตย์","วัดนกกระจาบ (ศิริสรณ์ประชาสรรค์)","วัดนครเจดีย์","วัดนครเนื่องเขต (ศรีไพจิตร)","วัดนครโปรดสัตว์","วัดนทีคมเขต","วัดนทีมุขาราม","วัดนทีวัฒนาราม","วัดนนทรีย์","วัดนพคุณ","วัดนพคุณทอง","วัดนพรัตนาราม","วัดนมโฑ (สำนักงานสลากกินแบ่งสมทบสร้าง 338)","วัดนราภิรมย์","วัดน่วมกานนท์","วัดนวลจันทร์","วัดนอก","วัดนอกปากทะเล","วัดน้อมถวาย","วัดน้อย","วัดน้อย (วิเชียรสร้อยเกลียวอุปถัมภ์)","วัดน้อย (วิบูลย์ประชาสรรค์)","วัดน้อยนางหงษ์","วัดน้อยวรลักษณ์","วัดน้อยสามัคคีธรรม (ซับกระทิงเหนือ)","วัดน้อยแสงจันทร์ (จันทร์ศิริวิทยาคาร)","วัดนันทวัน","วัดนันทาราม","วัดนากระรอก","วัดนากลาง","วัดนากลางมิตรภาพที่ 163","วัดนากัน","วัดนากุน","วัดนาแก้ว","วัดนาขวาง","วัดนาขาม","วัดนาขุนแสน (แกละประชานุกูล)","วัดนาขุม","วัดนาเขลียง","วัดนาค","วัดนาคนิมิตร","วัดนาคปรก","วัดนาคราช","วัดนาคสโมสร (โบราณญาณบํารุง)","วัดนาคาวาส","วัดนาคู (จันทศึกษาคาร)","วัดนางแก้ว","วัดนางคุ่ม","วัดนางชำ (ประชารัฐรังสฤษฎ์)","วัดนางชี","วัดนางตรา","วัดนางนอง (พิพัฒน์)","วัดนางบวช","วัดนางประหลาด","วัดนางพระยา","วัดนางพิมพ์","วัดนางพิมพ์ (สมกิตติราษฎร์บำรุง)","เทศบาลวัดนางลาด","วัดนางลือ","วัดนางเล่ว","วัดนางสาว (ถาวรราษฎร์บำรุง)","วัดนางหนู","วัดนางเหล้า","วัดนางเหลียว","วัดนางเอื้อย","วัดนาจอมเทียน","วัดนาซา","วัดนาดีวราราม","วัดนาตาขวัญ","วัดนาท่อม","วัดนาทะเล","วัดนาทิการาม","วัดนาทุ่ง","วัดนานอน","วัดนาน้อย (สำนักงานสลากกินแบ่งสงเคราะห์)","วัดนาน้อย","วัดนาบุญ","วัดนาประดู่","วัดนาปรือ","วัดนาปะขอ","วัดนาผักขวง","วัดนาพรม (มนมหาวิริยาคาร)","วัดนาพระยา","วัดนาพร้าว","วัดนาเม็ง","วัดนายายอาม","วัดนายาว (สำนักงานสลากกินแบ่งสงเคราะห์ 411)","วัดนาร่อง","วัดนารังนก","วัดนาราเจริญสุข","วัดนารายณิการาม","วัดนารีประดิษฐ์","วัดนาล้อม","วัดนาวง","วัดนาวังหิน","วัดนาสมอ","วัดนาสัก","วัดนาหนอง (วิธานราษฎร์อนุกูล)","วัดนาหมอบุญ","วัดนาหม่อม","วัดนาหมอศรี","วัดนาหินลาด","วัดนาหูกวาง","วัดนาเหรง","วัดนาเหล่าบก (สัมฤทธิ์ราษฎร์วิทยา)","วัดนาอุ่น","วัดนาเอี้ยง","วัดน้ำขุ่น","วัดน้ำคบ","วัดน้ำคอก","วัดน้ำเคือง","วัดน้ำโค้ง (คำหล้าราษฎร์นุกูล)","วัดน้ำจั้น","วัดน้ำฉ่า (เกตตะพิทยาคาร)","วัดน้ำฉ่า","วัดน้ำดิบ","วัดน้ำตก","วัดน้ำเต้า","วัดน้ำเต้า (อุดมราษฎร์นิมิต)","วัดน้ำทรง","วัดน้ำโท้ง","วัดน้ำบ่อหลวง","วัดน้ำผึ้ง","วัดน้ำผุด","วัดน้ำพุ (สำนักงานสลากกินแบ่งสงเคราะห์ 54)","วัดน้ำพุ","วัดน้ำรอบ","วัดน้ำรัก","วัดน้ำสรง","วัดน้ำใส","วัดน้ำหัก","วัดน้ำไหล","วัดน้ำอาบ","วัดนิกรประสาท","วัดนิคมคีรี","วัดนิคมประทีป","วัดนิคมสถิต","วัดนิคมสามัคคีชัย","วัดนิโครธคุณากร","วัดนิโครธาราม (กิจสิพงษ์ วิทยาคาร)","วัดนิโครธาราม","วัดนิโครธาวาส","วัดนิเทศน์","วัดนิมมานรดี","วัดนิยมธรรมวราราม","วัดนิยมยาตรา","วัดนิลเพชร","วัดนิลาราม","วัดนิเวศน์ธรรมาราม","วัดนิเวศวุฒาราม","วัดนีลราษฎร์ศรัทธาบำรุง","วัดเนกขัมมาราม","วัดเนาวรัตนาราม","วัดเนินกระปรอก","วัดเนินกะพี้","วัดเนินเขาดิน","วัดเนินตามาก","วัดเนินถ่าน","วัดเนินทราย","วัดเนินปอ","วัดเนินผาสุก","วัดเนินพยอม","วัดเนินพระ","วัดเนินพระปรางค์","วัดเนินพิจิตร","วัดเนินพิชัย","วัดเนินโพธิ์ (สวาสดิ์ราษฎร์อุปถัมภ์)","วัดเนินมหาเชษฐ","วัดเนินมะขามงาม","วัดเนินมะคึก","วัดเนินไม้หอม","วัดเนินยาง","วัดเนินยาว","วัดเนินสมอ (พินิจวิทยา)","วัดเนินสะเดา","วัดเนินสะอาด","วัดเนินสัก","วัดเนินสูง (วิชัยนารายณ์ราษฎร์บำรุง)","วัดเนินสูง","วัดเนินหินแร่","วัดเนื้อร้อน","วัดโนนป่าแดง","วัดโนนศรีคูณ","วัดโนนสภาราม","วัดโนนสะเดา","วัดโนนสำราญ","วัดโนนสำราญ (ประชาสามัคคี)","วัดโนนเหล็ก (อุทัยประชาสรรค์)","วัดในกลาง","วัดในไร่","วัดบน ","วัดบรรไดทอง","วัดบรรพตวารีเขต","วัดบริรักษ์ประชาสาร","วัดบวกครกเหนือ","วัดบ่วงช้าง","วัดบ่อ (นันทวิทยา)นครปากเกร็ด๑","วัดบ่อกรุ ","วัดบ่อคู่","วัดบ่อเงิน","วัดบ่อโจง","วัดบ่อแดง (จอกประชานุกูล)","วัดบ่อตะกั่ว (พ่วงประชานุกูล)","วัดบ่อทรัพย์","วัดบ่อทรายเจริญธรรม","วัดบ่อทอง","วัดบอนใหญ่","วัดบ่อนอก (ทองวิทยา)","วัดบ่อน้ำจืด","วัดบ่อนิมิต","วัดบ่อบุญ (จารุราษฎร์บำรุง)","วัดบ่อปาบ","วัดบ่อพระอินทร์","วัดบ่อโพง","วัดบ่อภาค","วัดบ่อมะกรูด (รัตนราษฎร์รัฐอุปถัมภ์)","วัดบ่อมะปริง","วัดบ่อแร่ (วิจิตรราษฎร์บำรุง)","วัดบ่อล้อ","วัดบ่อโศรก","วัดบ่อสระวิทยาทาน","วัดบันไดช้าง (เทียบประดิษฐ์วิทยาคาร)","วัดบันไดทอง (วิเศษศึกษา)","วัดบันไดม้า","วัดบันลือคชาวาส","วัดบันลือธรรม ","วัดบัลลังก์","วัดบัวแก้ว","วัดบัวขวัญ","วัดบัวขวัญ (มีทับราษฎร์บำรุง)","วัดบัวงาม","วัดบัวงาม (โสภณปทุมรักษ์ประชาสรรค์)","วัดบัวทอง","วัดบัวปากท่า","วัดบัวโรย","วัดบัวลอย (สามัคคีสงเคราะห์)","วัดบัวสุวรรณประดิษฐ์","วัดบัวหลวง","วัดบัวหวั่น","วัดบางกระ","วัดบางกระเจ็ด (บุญมีอนุสรณ์)","วัดบางกระเจ้า","วัดบางกระดาน","วัดบางกระทุ่ม","วัดบางกระเบา(สิทธิสารานุกูล)","วัดบางกระสอบ (เชยบุญปลูกราษฎร์อุปถัมภ์)","วัดบางกล้วย","วัดบางกอบัว","วัดบางกะเจ้ากลาง","วัดบางกะไชย (สวนโพธิรัตนบำรุง)","วัดบางกะโด (สามัคคีวิทยาคาร)","วัดบางกะทิง (พิศิษฐ์วิทยาคาร)","วัดบางกะพี้ (พสกอำรุง)","วัดบางกำยาน","วัดบางกุฎีทอง","วัดบางเกลือ (ประชารัฐบำรุง)","วัดบางแก้ว","วัดบางแก้ว (บางแก้วพิทยาคม)","วัดบางไกรนอก (แย้มพร้อมอุปถัมภ์)","วัดบางขนุน (ทัดสุวรรณกลึงประชาสรรค์)","วัดบางขมิ้น (คำปุ่นราษฎร์บำรุง)","วัดบางขวน","วัดบางขวาก","วัดบางขันแตก (บำเพ็ญอยู่รังสฤษดิ์)","วัดบางขุด","วัดบางขุนไทร (ผดุงวิทยา)","วัดบางขุนนนท์","วัดบางเขียด","วัดบางแขม (จันทสรประชานุกูล)","วัดบางคนทีใน (วามโกประชานุกูล)","วัดบางคราม","วัดบางคา","วัดบางคาง","วัดบางคุระ","วัดบางเคียน","วัดบางแคกลาง (ไพลประชานุกูล)","วัดบางจะเกร็ง (ประโชติประชานุกูล)","วัดบางจักร (แพสิริประชาสรรค์)","วัดบางจิก","วัดบางฉนาก","วัดบางโฉลงนอก","วัดบางโฉลงใน","วัดบางชัน (ประภากรราษฎร์รังสฤษฏ์)","วัดบางช้างใต้ (กิตติวิทยากร)","วัดบางช้างเหนือ (นครแสงโสภานุเคราะห์)","ชุมชนวัดบางซ้ายนอก","วัดบางซ้ายใน","วัดบางไซ","วัดบางด้วน","วัดบางดี","วัดบางเดื่อ","วัดบางตลาด (ยอดสวัสดิ์ประชาสรรค์)","วัดบางตะพาน","วัดบางตะพาน (เขมจาโร)","วัดบางเตย","วัดบางเตยนอก","วัดบางเตยใน","วัดบางทราย (หลวงพิณพลราษฎร์ จูเกษกาญจน์)","วัดบางทวด","วัดบางทองคำ","วัดบางทะลุ (สุนทรธรรมานุสรณ์)","วัดบางทีง","วัดบางโทง","วัดบางไทร","เทศบาลวัดบางนมโค (ปานอุทิศ)","วัดบางน้อย (แจ่มประชานุกูล)","วัดบางน้อยใน","วัดบางนา (เส็งเลิศประชานุกูล)","วัดบางนาง","วัดบางนางเกรง","วัดบางนางเพ็ง","วัดบางนางลี่ใหญ่ (บริษัทเกลือไทยสงเคราะห์)","วัดบางนางเล็ก","วัดบางน้ำจืด (เนียมนิกรวิทยา)","วัดบางน้ำชน","วัดบางน้ำผึ้งนอก","วัดบางน้ำผึ้งใน (กรุณานุยุตตาคาร)","วัดบางบ่อ","วัดบางบอน","วัดบางบอน (พิมพ์ จันแต้อุปถัมภ์)","วัดบางบัวทอง (โศภณวิทยานุเคราะห์)","วัดบางบาล","วัดบางเบน","วัดบางใบไม้","วัดบางปรง (ประชาราษฎร์บำรุง)","วัดบางประจันต์ (หวังเจริญราษฎร์นุกูล)","วัดบางปรัง","วัดบางปรือ","วัดบางปลา","วัดบางปลา (สมุทรวันราษฎร์บำรุง)","วัดบางปลานัก (สหกรณ์สิริประชาบำรุง)","วัดบางปอ","วัดบางปะกอก","วัดบางปิ้ง (บริษัทเกลือไทยสงเคราะห์)","วัดบางปิดบน","วัดบางปิดล่าง (ราษฎร์สงเคราะห์)","วัดบางปูน","วัดบางเป้ง","วัดบางโปรง","วัดบางผึ้ง","วัดบางไผ่นารถ","วัดบางฝ้าย","วัดบางพระเนตรโรจน์อุปถัมภ์","วัดบางพระ","วัดบางพลัด (ป.สุวณโณ)","วัดบางพลา","วัดบางพลี (หงส์ร่วมราษฎร์รังสรรค์)","วัดบางพลีน้อย","วัดบางพลีใหญ่กลาง","วัดบางพลีใหญ่ใน","วัดบางพัง","วัดบางพา","วัดบางพึ่ง","วัดบางพูดใน (นนทวิทยา)","วัดบางพูน","วัดบางเพรียง","วัดบางเพลิง (คงสกุลมากอุทิศ)","วัดบางโพโอมาวาส","วัดบางภาษี (บุญเรือนบูรณะ)","วัดบางม่วง","วัดบางมะขาม","วัดบางมะเดื่อ","วัดบางมะฝ่อ ","เทศบาลวัดบางมะเฟือง","วัดบางยาง (บางยางพิทยาคาร)","วัดบางยิ่ว","วัดบางระโหง (ภิรมย์ศิริ)","วัดบางรักน้อย","วัดบางรักใหญ่ (สายอักษรศรี)","วัดบางโรง","วัดบางลาน","วัดบางลำภู","วัดบางลี่ (วุฒิพันธุ์วิทยา)","วัดบางลึก","วัดบางเลน","วัดบางวัว (สายเสริมวิทย์)","วัดบางศาลา","วัดบางสงบ (กองวารีวิทยานุสรณ์)","วัดบางสมัคร","วัดบางสระเก้า (พิสิฎฐวิทยาคาร)","วัดบางสวรรค์","วัดบางสะแก (วิทยารังสรรค์)","วัดบางสะแก (ล้อมประชานุกูล)","วัดบางสะพานประพันธ์ชนานุสรณ์","วัดบางสาม","วัดบางสาย (บางสายประชาสรรค์)","วัดเสาธงนอก","วัดบางเสียด","วัดบางแสม","วัดบางหญ้าแพรก","วัดบางหยี","วัดบางหรอด","วัดบางหลวง","วัดบางหว้า","วัดบางหอย","วัดบางหัวเสือ","วัดบางเหลียว","วัดบางแหวน","วัดบางใหญ่","วัดบางใหญ่ (ประภัสสรประชานุกูล)","วัดบางอ้อยช้าง (นันทศรีวิบูลย์บำรุง)","วัดบ้านกรวด","วัดบ้านกระเบื้อง","วัดบ้านกร่าง","วัดบ้านกรุ","วัดบ้านกล้วย (ผลราษฎร์บำรุง)","วัดบ้านกล้วย","วัดบ้านกลับ","วัดบ้านกลาง","วัดบ้านกลิ้ง","วัดบ้านก้อง","วัดบ้านกะชาย","วัดบ้านกะหาด","วัดบ้านกันทรารมย์","วัดบ้านกุดสังข์","วัดบ้านเก่า","วัดบ้านเก่างิ้ว","วัดบ้านเกาะ","แกสำโรงวิทยา","วัดบ้านแก","วัดบ้านขี้เหล็ก","วัดบ้านแขม","วัดบ้านคลอง","วัดบ้านคลองข่อย","วัดบ้านค้อหวาง","วัดบ้านค่าย","วัดบ้านแค","วัดบ้านโคก (มงคลประชาสรรค์)","วัดโคกเจริญ","วัดบ้านโคกพระ","วัดบ้านโคกเพ็ด","วัดบ้านโคกสีโนนรัง","วัดบ้านโคกหนองแวง","วัดบ้านโคกเหล็ก","วัดบ้านฆ้อง (พิพิธกิตติโสภณ)","วัดบ้านฆ้องน้อย","วัดบ้านงาม","วัดบ้านงิ้ว","วัดบ้านจอม","วัดบ้านจันดุม (คุรุธำรงราษฎร์อนุสรณ์)","วัดบ้านจ่า (เอี่ยมโหมดอนุสรณ์)","วัดบ้านจาน","วัดบ้านแจ่ม","วัดบ้านฉาง","วัดบ้านช้าง","วัดบ้านชุ้ง (อดุลประชาวิทย์)","วัดบ้านชุ้ง (อิสระวิทยา)","วัดบ้านชุมแสง","วัดบ้านซ่อง","วัดบ้านดง","วัดบ้านดอน","วัดบ้านดอนกลาง","วัดบ้านดอนโก่ย","วัดบ้านดอนชุมช้าง","วัดบ้านดอนตะหนิน","วัดบ้านดอนเต็ง","วัดบ้านด่าน","วัดบ้านด่านคนคบ","วัดบ้านด่านนอก (เสรีธรรมวิทยา)","วัดบ้านดาบ","วัดบ้านแดน","วัดบ้านตะโกตาพิ","วัดบ้านตะขบ ","วัดบ้านตะเภาหนุน","วัดบ้านตาล","วัดบ้านตาล ","วัดบ้านตาเสา","วัดบ้านตำแย","วัดบ้านถนนโพธิ์","วัดบ้านถลุงเหล็ก","วัดบ้านแถว ","วัดบ้านทราย","วัดบ้านทวน","วัดบ้านท่า","วัดบ้านท่าขมิ้น","วัดบ้านท่ามะไฟ","วัดบ้านท้ายน้ำ","วัดบ้านทึง","วัดบ้านทุ่ง","วัดบ้านทุ่งรี","วัดบ้านทุ่งสว่าง","วัดบ้านไทร (เสคุรุราษฏร์อนุสรณ์)","วัดบ้านธาตุใต้ (สนิทไชยวิทยาคาร)","วัดบ้านธิ","วัดบ้านน้อย","วัดบ้านนา","วัดบ้านนา (ประชาชนรังสฤษฎิ์)","บ้านนาพิบูลพิทยา","วัดบ้านนา (ฟินวิทยาคม)","วัดบ้านนางิ้ว","วัดบ้านน้ำคำ (สำนักงานสลากกินแบ่งสงเคราะห์ 159)","วัดบ้านเนิน","วัดบ้านโนน","วัดบ้านโนนกอก","วัดบ้านโนนประดู่","วัดบ้านโนนมาลัย","วัดบ้านใน","วัดบ้านบน","วัดบ้านบัลลังก์","วัดบ้านบาก","วัดบ้านบางลายใต้","วัดบ้านบางลายเหนือ","วัดบ้านบึงนาราง ","วัดบ้านบุขี้เหล็ก","วัดบ้านบุ่ง","วัดบ้านบุโพธิ์","วัดบ้านเบาน้อย","วัดบ้านประดาทอง","วัดบ้านประอาง (ประสาธน์คุรุราษฎร์พัฒนา)","วัดบ้านปราสาท","วัดบ้านปลัดปุ๊ก","วัดบ้านป้อก","วัดบ้านปะเคียบ","วัดบ้านปะทัดบุ","วัดบ้านป่า","วัดบ้านเป้า","วัดบ้านเปาะ","วัดบ้านไผ่","วัดบ้านไผ่ท่าโพใต้","วัดบ้านพระ","วัดบ้านพราน","วัดบ้านพร้าว","วัดบ้านพร้าวใน","วัดบ้านพริก","วัดบ้านพลัง","วัดบ้านพลับ","วัดบ้านพังน้อย","วัดบ้านเพชร","วัดบ้านแพน ","วัดบ้านโพธิ์","วัดบ้านโพธิ์ (มิตรภาพที่ 132)","วัดบ้านโพธิ์ตะวันตก","วัดบ้านโพธิ์ตะวันออก","วัดบ้านโพนเงิน","วัดบ้านไพบูลย์","วัดบ้านม่อน","วัดบ้านมะเกลือ","วัดบ้านมะค่า","วัดบ้านม้า","วัดบ้านมุง","วัดบ้านเมืองต่ำ","วัดบ้านเมืองฝาง","วัดบ้านเมืองโพธิ์","วัดบ้านเมืองสูง","วัดบ้านแม่ต๋ำ","วัดบ้านยาง","วัดบ้านยาง (ช้อยคุรุราษฏร์บำรุง)","วัดบ้านเย้ยสะแก","วัดบ้านราม","วัดบ้านรี","วัดบ้านรุน","วัดบ้านเรือน","วัดบ้านไร่","วัดบ้านไร่ (ประชานุกูล)","วัดบ้านลาด","วัดบ้านลำ","วัดบ้านลำ (บ้านลำวิทยาคาร)","วัดบ้านลำนัง","วัดบ้านลุ่ม","ชุมชนวัดบ้านแลง","วัดบ้านแลง","วัดบ้านวัง","วัดบ้านวังดินดาด","วัดบ้านวังไร่","วัดบ้านเวียงหนองล่อง","วัดบ้านศาลา","วัดบ้านศาลาดิน","วัดบ้านสนวน","วัดบ้านสร้าง","วัดบ้านสวน","วัดบ้านสวน (คงวิทยาคาร)","วัดบ้านสวายจีกน้อย","วัดบ้านสวายตางวน","บ้านสวายสอ (ประชาบูรณะ)","วัดบ้านส่อง","วัดบ้านส้อง","วัดบ้านสะแกซำ","วัดบ้านสัก","วัดบ้านสามเมือง","วัดบ้านสำราญราษฎร์","วัดบ้านสีดา","วัดบ้านสี่เหลี่ยม","วัดบ้านเสม็ด","วัดบ้านแสลงคง","วัดบ้านหนอง","วัดบ้านหนองกะทิง","วัดบ้านหนองขาม","วัดบ้านหนองแขม","บ้านหนองไข่ผำ","วัดบ้านหนองคึม","วัดบ้านหนองคู","วัดบ้านหนองดง","วัดบ้านหนองเดิ่น","วัดบ้านหนองตราดใหญ่","วัดบ้านหนองตลุมปุ๊ก","วัดบ้านหนองตะไก้","วัดบ้านหนองปลาไหล","วัดบ้านหนองพลวง","วัดบ้านหนองแวง","วัดบ้านหนองสะแบง","วัดบ้านหนองหญ้าปล้อง","วัดบ้านหนองหัวช้าง","วัดบ้านหม้อ (ประชารังษี)","วัดบ้านหมาก","วัดบ้านหมี่","วัดบ้านหมี่ใหญ่","วัดบ้านหลวง (บัวราษฎร์บำรุง)","วัดบ้านหลุก","วัดบ้านห้วยยาว","วัดบ้านหว้า (ชมพูวิทยา)","วัดบ้านหวาย","วัดบ้านหินโคน ","วัดบ้านหินตั้ง","วัดบ้านหินแห่","วัดบ้านหีบ","วัดบ้านเหมือง","วัดบ้านเหล่า","วัดบ้านแหลมกรวด (อินทรประดิษฐ์)","วัดบ้านโห้ง","วัดบ้านใหม่","วัดบ้านใหม่บน","วัดบ้านอ้อ (บ้านอ้อวิทยาคาร)","วัดบ้านอ่าง","วัดบ้านอิฐ (รัฐประชานุกูล)","วัดบ้านอุ่มจานโนนงิ้ว","วัดบ้านฮ่อง","วัดบำเพ็ญบุญ","วัดบึง","วัดบึง (สามัคคีราษฎร์)","วัดบึงกระจับ","วัดบึงกระจับ (รัฐประชาตันติธนานนท์)","วัดบึงกอก","วัดบึงคา","วัดบึงตาหอม","วัดบึงทองหลาง","วัดบึงน้ำกลัด","วัดบึงน้ำรักษ์","วัดบึงน้ำใส","วัดบึงบอน","วัดบึงบ้านสนม","วัดบึงพระ (เหรียญ-จั่น อนุสรณ์)","วัดบึงไม้","วัดบึงลาดสวาย","วัดบึงลำ","วัดบุญกันนาวาส","วัดบุญเกิด","วัดบุญเจริญ (รัฐราษฎร์รังสรรค์)","วัดบุญญราศรี","วัดบุญบันเทิง","วัดบุญลือ (อุเทสประชาสรรค์)","วัดบุญศิริวิทยาราม","วัดบุญสัมพันธ์","วัดบุณฑริการาม","วัดบุนนาค","วัดบุปผาราม","วัดบุปผาราม (คุณวุฒิอุปถัมภ์ มิตรภาพที่ 100)","วัดบุฝ้าย","วัดบุพนิมิต","วัดบุพพาราม","วัดบุยายใบ","วัดบุรีการาม","วัดบูรณาวาส","วัดบูรพาพิทยาราม","วัดเบญพาด","วัดโบกขรณี","วัดโบราณสถิตย์","วัดโบราณหลวง","วัดโบราณาราม","วัดโบสถ์","วัดโบสถ์ (บวรธรรมกิจวิทยา)","วัดโบสถ์ (วิบูลประภาราษฎร์สามัคคี)","วัดโบสถ์ (ประภาสวิทยาคาร)","วัดโบสถ์ (ประชานุกูล)","วัดโบสถ์ (ราษฎร์รังสฤษฏ์)","วัดโบสถ์ (วงศ์พานิช)","วัดโบสถ์ (ศุภพิทยาคาร)","วัดโบสถ์ (อินรัฐราษฎร์บำรุง)","วัดโบสถ์การ้อง","วัดโบสถ์เจริญธรรม","วัดโบสถ์ราษฎร์บำรุง","วัดโบสถ์วิทยา","วัดโบสถ์วิทยาคาร","วัดโบสถ์สมพรชัย","วัดโบสถ์สามัคคีธรรม","วัดโบสถ์อนุกูลสังฆกิจ","วัดปทุมคงคา","วัดปทุมทอง","วัดปทุมทองสุทธาราม","วัดปทุมนายก","วัดปทุมวนาราม","วัดปทุมวัน (โสนิกรประชาอนุสรณ์)","วัดปทุมสราวาส","วัดปทุมาวาส","วัดปรกเจริญ","วัดปรกสุธรรมาราม (สามัคคีพิทยาคาร)","วัดปรมัยยิกาวาส (แสนสวัสดิ์วิทยาคาร)","วัดประจ่า","วัดประจิมทิศาราม (เมฆประชาบำรุง)","วัดประเจียก","วัดประชาเกษม","วัดประชาโฆสิตาราม (สมบูรณ์ตาบอุทิศวิทยา)","วัดประชาธิการาม","วัดประชานาถ (เลื่อนสะเทื้อนราษฎร์รังสรรค์)","วัดประชานิมิตร","วัดประชาบำรุง","วัดประชาบำรุงกิจ","วัดประชารังสรรค์","วัดประชาราษฎร์บำรุง","วัดประชาวงศาราม","วัดประชาวาส","วัดประชาสรรค์","วัดประชุมชน","วัดประชุมชลธารา","วัดประชุมธรรม (สัจจะญาณ)","วัดประชุมมิตรบำรุง","วัดประชุมราษฏร์","วัดประชุมศึกษา","วัดประชุมสงฆ์","วัดประโชติการาม","วัดประณีต","วัดประดับ","วัดประดิษฐ์บุปผา","วัดประดิษฐาราม","วัดประดู่ (สุทธิ พานิชพงศ์ชนูปถัมภ์)","ทีปังกรวิทยาพัฒน์ (วัดประดู่) ในพระราชูปถัมภ์สมเด็จพระบรมโอรสาธิราชฯ สยามมกุฎราชกุมาร","วัดประดู่ฉิมพลี","วัดประดู่ทรงธรรม (จียพันธ์บำรุง)","วัดประดู่ทอง","วัดประดู่เรียง","วัดประดู่หอม","วัดประดู่หอม (สุขประชาสรรค์)","วัดประเดิม","วัดประตูเขียน","วัดประตูไชย (แก้วอุทิศ)","วัดประตูน้ำท่าไข่ (มงคลเพิ่มประชานุกูล)","วัดประตูใหญ่","วัดประทุมทายการาม","วัดประมุง (แจ่มราษฎร์รังสรรค์)","วัดประยุรวงศาวาส","วัดประยูรธรรมาราม","วัดประศาสน์โสภณ","วัดประศุก","วัดประสพ","วัดประสาท","วัดประสาทนิกร","วัดประสาทรังสฤษฎิ์","วัดประสาทวิถี","วัดประสาธน์รังสรรค์","วัดประสิทธาราม","วัดประสิทธิ์คุณากร","วัดประสิทธิเวช","วัดประเสริฐราษฎร์รังสรรค์วิทยา","วัดปรักรัก","วัดปรังกาสี","วัดปรางแก้ว","วัดปราโมทย์ (พิศสะอาดราษฎร์อำรุง)","วัดปราสาท","วัดปราสาททอง","วัดปริก","วัดปรีชาราษฎร์บำรุง","วัดปรีดาราม","วัดปรือกระเทียม","วัดปลดสัตว์","วัดปลวกเกตุ","วัดปลวกง่าม","วัดปลักปลา","วัดปลักปอม","วัดปลักไม้ลาย","วัดปลักแรต","วัดปลายคลองขุนศรี","วัดปลายนา","วัดปลายสระ","วัดปลาไหล","วัดป๊อกแป๊ก","วัดป้อมวิเชียรโชติการาม","วัดปะ","วัดปะโอ","วัดปัจจันตคาม","วัดปัจจันตาราม","วัดปัญจทายิกาวาส","วัดปัญจาภิรมย์","วัดปัณณาราม","วัดปัตติการาม","วัดป่า (ท่าขึ้น)","วัดป่า (โมคลาน)","วัดปากกราน","วัดปากกิเลน","วัดปากคลอง (ประชามหาราช)","วัดปากคลอง (ศุทธยาลัยอุทิศ)","วัดปากคลองกุ่ม","วัดปากคลองเกลียว","วัดปากคลองช้าง","วัดปากคลองบางคู้","วัดปากคลองปลากด","วัดปากคลองพระอาจารย์","วัดปากควน","วัดปากคู","วัดปากง่าม (ผ่องสอาดราษฎร์นุกูล)","วัดปากจ่า","วัดปากแจ่ม","วัดปากช่อง (จันทรานุมาศวิทยาคาร)","วัดปากดงท่าศาล","วัดปากด่าน","วัดปากตรง","ชุมชนวัดปากตรัง","วัดปากแตระ","วัดปากท่อ (ปากท่อวิทยาคาร)","วัดปากท่าซอง","วัดปากน้ำ (ประสาทวิทยาคาร)","วัดปากน้ำโจ้โล้ (สร้อยประชาสรรค์)","วัดปากน้ำ","วัดปากน้ำ (ไตรคามสามัคคี)","วัดปากน้ำ (พิบูลสงคราม)","วัดปากน้ำ (อมรวิมลจันทร์)","วัดปากน้ำพังราด","วัดปากน้ำละแม","วัดปากเนตร","วัดปากบ่อ (เหลืองราษฎร์บํารุง)","วัดปากบางท่าพญา","วัดปากบึง","วัดปากปรน","วัดปากประ","วัดปากพระ","วัดปากพิงตะวันตก","วัดปากแพรก","วัดปากไพร","วัดปากระวะ","วัดปากแรต","วัดป่ากล้วย","วัดปากล้อง","วัดปากสมุทร (ไวยวุฒิชนานุสรณ์)","วัดปากสระ","วัดปากห้วย","วัดปากห้วยไม้งาม","วัดปากเหมือง","วัดปากอ่าว (ญาณสาครวิทยาคาร)","วัดป่ากิ่ว","วัดป่าเกด","วัดป่าแก้ว","วัดป่าไก่ (ส่วนประชานุกูล)","วัดป่าขวาง","วัดป่าข่อยใต้","วัดป่าขาด","วัดป่าเขาสัมมะงา","วัดป่าคา","วัดป่าคาเจริญวิทยา","วัดปางเติม","วัดปางมะกล้วย","วัดปางมะโอ","วัดป่างิ้ว","วัดป่าช้า (สิริราษฎร์วิทยาคาร)","วัดป่าแดง","วัดป่าแดด","วัดป่าตอ","วัดป่าตัน","วัดป่าตาล","วัดป่าตึงห้วยยาบ","วัดป่าตึงเชตะวัน","วัดป่าถ้ำภูเตย","วัดปานประสิทธาราม","วัดป่าบอนต่ำ (ระแบบ-ถวิลประชาสรรค์)","วัดป่าบุก","วัดป่าไผ่","วัดป่าพระเจ้า","วัดป่าพฤกษ์","วัดป่ามะคาบ (สามัคคีพิทยาคาร)","วัดป่ามุนี","วัดป่ายาง","วัดป่ายุบ","วัดป่าระกำเหนือ","วัดป่าระกำ","วัดป่าเรไร","วัดป่าลาน","วัดป่าสวย","วัดป่าสะแก","วัดป่าสัก","วัดป่าหวาย","วัดป่าเหียง","วัดป่าไหม้","วัดปิ่นแก้ว","วัดปิยะวัฒนาราม","วัดปิยาราม","วัดปุณหังสนาวาส (ทิพย์สมบัติบุญ-ชุ่มอุทิศ)","วัดปู่เจ้า","วัดเปร็งราษฎร์บำรุง (ศรีวรพินิจวิทยาคาร)","วัดเปรมประชากร","วัดเปรมปรีชา","วัดเปรมศรัทธา","วัดเปาโรหิตย์","วัดเปาสามขา และวัดเปาสามขา สาขาบ้านวาก","วัดเปียน","วัดแปดแก้ว (สพันธ์พุ่มระชัฎกุล)","วัดแปลงเกต","วัดแปลงยาว (เจริญบุญประชาสวรรค์)","วัดโป่ง","วัดโป่งก้อนเส้า","วัดโป่งแค","วัดโป่งแดง","วัดโป่งตามุข","วัดหนองกาน้ำ","วัดโป่งปากดง (สง่า รุธิระราษฎร์วิทยา)","วัดโป่งมงคล","วัดโป่งแรด (ปคุณวิทยาคาร)","วัดโป่งสวรรค์","วัดโป่งหม้อข้าว","วัดโปรยฝน","วัดผดุงธรรม","วัดผลาหาร","วัดผักกาด","วัดผักกูด","วัดผาจักร","วัดผาณิตาราม","วัดผาทั่ง","วัดผาสุกมณีจักร","วัดผาสุการาม (สุวรรณวิทยาคาร)","วัดผาสุการาม","วัดผาสุกาวาส (พิศิษฎ์พิทยา)","วัดผึ่งแดด (บุญสืบวิชชนูปถัมภ์)","วัดผุสดีภูผาราม","วัดไผ่ (เหวย-บุญช่วยโสมนรินทร์อุปถัมภ์)","วัดไผ่เกาะโพธิ์งาม","วัดไผ่แก้ว (ศิริสวัสดิ์ประชาสรรค์)","วัดไผ่ขวาง (ราษฎร์วิทยาคาร)","วัดไผ่ขวาง","วัดโพธิ์สำราญ (วัดไผ่ขาด)","วัดไผ่ขาด","วัดไผ่ค่อม (แพรประชาอุปถัมภ์)","วัดไผ่งาม","วัดไผ่เงินโชตนาราม","วัดไผ่จรเข้","วัดไผ่ดำ (กัลยาพิริยะประชาสรรค์)","วัดไผ่ดำ (มิตรภาพที่ 183)","วัดไผ่เดี่ยว","วัดไผ่ตัน","วัดไผ่แตร","วัดไผ่โพธิ์ทอง","วัดไผ่มุ้ง","วัดไผ่รอบ","วัดไผ่โรงวัว","วัดไผ่ล้อม (อินทก์อุทัย)","วัดไผ่ล้อม","วัดไผ่ล้อม (โสภณวิทยา)","วัดไผ่ล้อม (เจริญราษฎร์วิทยาคม)","วัดไผ่ล้อม (ทองดีประชานุกูล)","วัดไผ่ลูกนก","วัดไผ่วง (ศุกรเสพย์วิทยาคาร)","วัดไผ่สามเกาะ (ปัญญาประชาสามัคคี)","วัดไผ่สามตำลึง","วัดไผ่สิงห์","วัดไผ่หลงราษฎร์เจริญ","วัดไผ่หูช้าง","วัดไผ่แหลม","วัดฝาง","วัดฝ่าพระบาทราษฎร์บำรุง","วัดฝาละมี","วัดพงษาราม (มณีนันทศึกษาลัย)","วัดพญาชมภู","วัดพญาปันแดน","วัดพนม","วัดพนมพนาวาส","วัดพนมพริก","วัดพนมวัน","วัดพนมเศษ","วัดพนัญเชิง (ไตรรัตนนายก)","วัดพนาสณฑ์","วัดพเนินพลู","วัดพรสวรรค์","วัดพรหมเกษร","วัดพรหมเทพาวาส","วัดพรหมประดิษฐ์","วัดพรหมประสิทธิ์","วัดพรหมเพชร","วัดพรหมรังษีมิตรภาพที่ 1","วัดพรหมรัตนาราม","วัดพรหมราช","วัดพรหมโลก","วัดพรหมวิหาร","วัดพรหมสาคร","วัดพรหมสุวรรณ (เจียมสนิธราษฎร์บำรุง)","วัดพรหมาสตร์","วัดพระเกิด","วัดพระเกิดคงคาราม","วัดพระแก้ว","วัดพระแก้ว ","วัดพระขาว (ประชานุเคราะห์)","วัดพระงาม (อรรถกฤษณ์ประชารัฐ)","วัดพระงาม","วัดพระเงิน (อิศราวิทย์อุปกรณ์)","วัดพระเจ้านั่งแท่น","วัดพระเจ้าเหลื้อม","วัดพระญาติการาม (ศุภสุขบำรุง)","อนุบาลวัดพระโต","วัดพระแท่นดงรัง","วัดพระธาตุ","วัดพระธาตุแช่แห้ง","วัดพระธาตุน้อย","วัดพระธาตุพนม ","วัดพระนอน","วัดพระนอนหนองผึ้ง","สาธิตวัดพระบรมธาตุ","วัดพระบรมธาตุไชยา","วัดพระบาท","บ้านแม่ปอน","วัดพระปฐมเจดีย์","วัดพระประทานพร","วัดพระประโทณเจดีย์","วัดพระปรางค์มุนี","วัดพระฝาง","วัดพระพรหม (ช้อยราษฎร์อุปถัมภ์)","วัดพระพุทธ","วัดพระพุทธฉาย","วัดพระพุทธบาทเขาลูกช้าง","วัดพระพุทธบาทน้อยมิตรภาพที่ 69","วัดพระเพรง","วัดพระมงกุฎ","วัดพระมหาธาตุ","วัดพระมอพิสัย","วัดพระยาทด (สุชลิตวิทยา)","วัดพระยาปลา","วัดพระรูป (จันทศรีสงเคราะห์)","วัดพระเลียบ","วัดศรีราษฎร์ (เอนกนาครราษฎร์บำรุง)","วัดพระศรีอารย์","วัดพระหลวง (อภิชัยราษฎร์สงเคราะห์)","วัดพระหอม","วัดพระอานนท์","วัดพระอาสน์","วัดพรานนก","วัดพร้าว","วัดพราหมณี","วัดพรุเตาะ","วัดพรุเตียว","วัดพรุพ้อ","วัดพรุศรี","วัดพฤกษะวันโชติการาม","วัดพลงช้างเผือก","วัดพลงไสว","วัดพลมานีย์","วัดพลวง","วัดพลสุวรรณ","วัดพลอยกระจ่างศรี (บุญยังราษฎร์นาวีอุปถัมภ์)","วัดพลับ (จันทบุรีชีบาอุทิศ)","วัดพลับพลา (อินทราษฎร์ประดิษฐ์)","วัดพลับพลา","วัดพลับพลาชัย","วัดพลา","วัดพ่วง","วัดพวงแก้ว","วัดพวงนิมิต","วัดพะโค","วัดพะงุ้น","วัดพะเนียงแตก (อุตรบำรุงพิทยาวาส ประยงค์อุปถัมภ์)","วัดพะยอม","วัดพะแสง","วัดพังกก","วัดพังกิ่ง","วัดพังงอน","วัดพังดาน","วัดพังตรี","วัดพังตรุ","วัดพังม่วง","วัดพังยอม","วัดพังยาง","วัดพังราด","วัดพังสิงห์","วัดพัฒนราษฎร์บำรุง","วัดพันชาลี","วัดพันตาเกิน","วัดพันตำลึง","วัดพันธุวงษ์ (ปรีชาเลี่ยมราษฎร์บำรุง)","วัดพันลาน","วัดท่าโพ (สาขาวัดพันสี)","วัดพานทอง","วัดพานิชธรรมิการาม","ชุมชนวัดพายทอง","วัดพิกุล","วัดพิกุลแก้ว","วัดพิกุลงาม","วัดพิกุลเงิน","วัดพิกุลทอง","วัดพิกุลทอง (แปลกประชาคาร)","วัดพิกุลวนาราม","วัดพิจารณ์โสภณ","วัดพิชัยยาราม","อนุบาลวัดพิชัยสงคราม","วัดพิบูลยาราม มิตรภาพที่ 232","วัดพิบูลวนาราม (รัฐ-สว่างชัยนาวาอุปถัมภ์)","วัดพิบูลสัณหธรรม","วัดพิพิธประสาทสุนทร","วัดพิมพาวาส (สีล้งสาราลัย)","วัดพิรุณศาสตร์","วัดพิศาลนฤมิต","วัดพิหารแดง","วัดพืชนิมิตร","วัดพืชอุดม","วัดพุแค","วัดพุฒ","วัดพุฒิปรางค์ปราโมทย์","วัดพุทธธรรมรังษี (อวยชัยอนุสรณ์)","วัดพุทธนิมิตร","วัดพุทธอุดมวิหาร","วัดพุทธิสาร","วัดพุทโธวาท","วัดพุทไธศวรรย์","วัดพุน้อย","วัดพุ่มบำเพ็ญธรรม","วัดเพ็งประดิษฐาราม","วัดเพ็ญญาติ","วัดเพ็ญมิตร","วัดเพรางาย","วัดเพรียง (วิเทศราษฎร์วัฒนา)","วัดเพิ่มทาน (ประยงค์ประชานุสรณ์)","วัดเพิ่มประสิทธิผล","วัดแพร่","วัดแพรกนกเอี้ยง","วัดแพรกษา","วัดแพะโคก","วัดโพเด็ด (พุ่มพูนพิทยา)","วัดโพทะเล","วัดโพทูล","วัดโพธิ์ศรี (สังวรราษฎร์นุสรณ์)","วัดโพธาราม","เทศบาลวัดโพธาราม (บุญมากพิทยาคาร)","วัดโพธาราม (โพธิพิทยากร)","วัดโพธาวาส (ภิรมอุปถัมถ์)","วัดโพธิ์","วัดโพธิ์ (คำคุ้มอรุณราษฎร์บำรุง)","วัดโพธิ์ (แจ่มวิทยาคาร)","วัดโพธิ์ (ชื่นศรีผดุง)","วัดโพธิ์ (นาควิทยานุสรณ์)","วัดโพธิ์ (ผักไห่วิทยาคาร)","วัดโพธิ์กรุ (ผินผดุง)","วัดโพธิ์กลาง","วัดโพธิ์เกรียบ","วัดโพธิ์เกษตร","วัดโพธิ์เก้าต้น","วัดโพธิ์แก้วเบญจธาราม","วัดโพธิ์ขวัญ","วัดโพธิ์เขียว","วัดโพธิ์งาม","วัดโพธิ์แจ้ (มาลีราษฎร์บำรุง)","วัดโพธิ์เฉลิมรักษ์","วัดโพธิ์ชัย","วัดโพธิญาณ (อ.ท.ผ.อุปถัมภ์)","วัดโพธิ์ดก","วัดโพธิ์แดน","วัดโพธิ์ตรุ","วัดโพธิ์ตะควน","วัดโพธิ์แตงใต้ ","วัดโพธิ์ทอง","วัดโพธิ์ทอง (วิศิษฐ์ประชานุเคราะห์)","วัดโพธิ์ทอง (วาสนานุกูล)","วัดโพธิ์ทองเจริญ","วัดโพธิ์ทองเจริญผล","วัดโพธิ์ทะเลสามัคคี","วัดโพธิ์ทัยมณี","วัดโพธิ์ท่าทราย","วัดโพธิ์แทน","วัดโพธิธรรมาราม","วัดโพธิ์นฤมิตร","วัดโพธิ์น้อย","วัดโพธิ์นิมิต","วัดโพธินิมิตร","วัดโพธิ์บัลลังก์","วัดโพธิ์บ้านอ้อย (ทองดีวิทยานุสรณ์)","วัดโพธิ์ประสิทธิ์","วัดโพธิ์ประสิทธิ์ (วิบูลย์บำรุง)","วัดโพธิ์เผือก","วัดโพธิมงคล","วัดโพธิ์เมืองสามัคคี","วัดโพธิยาราม","วัดโพธิ์ระหัต","วัดโพธิ์รัตนาราม","วัดโพธิ์ราษฎร์","วัดโพธิ์ราษฎร์บูรณะ","วัดโพธิ์ราษฏร์ศรัทธาธรรม","วัดโพธิ์เรียง","วัดโพธิ์ลอย","วัดโพธิ์ลอย (เรือนวงศ์ผดุง)","วัดโพธิ์ลังกามิตรภาพที่ 171","วัดโพธิ์เลื่อน","วัดโพธิวงษ์","วัดโพธิ์ศรี","วัดโพธิศรี","วัดโพธิ์ศรีบรรจง","วัดโพธิ์ศรีสุขาราม","วัดโพธิ์สังฆาราม","วัดโพธิ์สาวหาญ","วัดโพธิ์เสด็จ","วัดโพธิ์แสงกาญจนราษฎร์","วัดโพธิ์หนองยาว","วัดโพธิ์หอม","วัดโพธิ์เอน","วัดโพธิ์เอน ","วัดโพนทราย","วัดโพนทอง","วัดโพพระใน (รุ่งรังสฤษฎ์)","วัดโพรงงู","วัดโพรงจระเข้","วัดโพรงมะเดื่อ (ศรีวิทยากร)","วัดโพสพผลเจริญ","วัดไพรงาม","วัดไพร่ฟ้า","วัดไพรสณฑ์","วัดไพศาลสถิต","วัดภมรคติวัน","วัดภาชี ","วัดภูเขาทอง","วัดภูเขาหลัก","วัดภูนก","วัดภูมิบรรพต","วัดเภตราสุขารมย์","วัดโภคาภิวัฒน์","วัดมกุฏกษัตริยาราม","วัดมกุฎไทยาราม","วัดมงคล","วัดมงคลโคธาวาส","วัดมงคลถาวร (มงคลวิทยาสรรค์)","วัดมงคลธรรมนิมิต","วัดมงคลนิมิตร","วัดมงคลพุการาม","วัดมงคลรัตน์","วัดมงคลวราราม","วัดมงคลสถาน","วัดมงคลสถิต","วัดมงคลสถิตย์","วัดมณฑลประสิทธิ์ (อาจธวัชประชานุกูล)","วัดมณีเจริญมิตรภาพที่ 227","วัดมณีโชติ (เทียมประชานุเคราะห์)","วัดมณีเลื่อน","วัดมณีวรรณ (ประชารัฐวิทยาคาร)","วัดมณีศรีโสภณ","วัดมณีสรรค์ (ไสวประชานุสรณ์)","วัดมโนรม","วัดมโนราษฎร์","วัดมรรครังสฤษดิ์","วัดมฤคทายวัน (วิจิตรชวนะนันท์ราษฎร์อุปถัมภ์)","วัดมวกเหล็กใน","วัดม่วง","วัดม่วงก็อง","วัดม่วงค่อม","วัดม่วงคัน","วัดม่วงงาม","วัดม่วงเจริญผล","วัดม่วงชุม","วัดม่วงตารศ (สำอางค์เจริญผล)","วัดม่วงน้อย","วัดม่วงหวาน (ส่วนกระบวนยุทธประชาสรรค์)","วัดมหาการ","วัดมหาชัยวนาราม","วัดมหาดไทย (ผลประมุขวิทยา)","วัดมหาถูปาราม","วัดมหานาม","วัดมหาโพธิใต้","วัดมหาโลก (มหาโลกวิทยาคาร)","วัดมหาวงษ์","วัดมหาวนาราม","วัดมหาสอน ","วัดมหิงษาราม","วัดมหิงสาวาส","วัดมหิสสราราม","วัดมเหยงค์","วัดมเหยงคณ์","วัดมะกรูด","วัดมะกอกแก้ว","วัดมะกอกงอ","วัดมะกอก-นาบัว","วัดมะเกลือ (กาญจนลักษณ์วิทยา)","วัดมะขาม (ศรีวิทยาคาร)","วัดมะขาม","วัดมะขามคลาน","วัดมะขามเรียง","วัดมะค่า","วัดมะเดื่อ","วัดมะตูม","วัดมะทาย","วัดมะนาวหวาน","วัดมะนาวหวาน (ราษฎร์วิริยะบำรุง)","วัดมะปราง","วัดมะปรางงาม","วัดมะฝ่อ (สรรพวิทยา)","วัดมะพร้าวสูง","วัดมะเฟือง","วัดมะม่วงตลอด","วัดมะม่วงทอง","วัดมะม่วงสองต้น","วัดมะสง มิตรภาพที่ 55","วัดมะเห-ยงคณ์ (ประชาเนรมิต)","วัดมังคลาราม","วัดมัชฌิมภูผา","วัดมัชฌิมภูมิ","วัดมัชฌิมาราม","วัดมาบข่า","วัดมาบแค","วัดมาบชลูด","วัดมาบปลาเค้า (ธรรมโชติผดุง)","วัดมาบไผ่ (สำนักงานสลากกินแบ่งสงเคราะห์ 341)","วัดมาบพระจันทร์ (รัฐบำรุงประชาวิทยา)","วัดมาบโพธิ์","วัดมาบมะขาม","เทศบาลวัดมารวิชัย (เกษมปกาสิตอนุสรณ์)","วัดมิตรภาพวนาราม","วัดมุขธารา","วัดมุจลินท์ (รัฐประชานุเคราะห์)","วัดมุจลินทราวาส","วัดมุจลินทวาปีวิหาร (เพชรานุกูลกิจ)","วัดมุจลินทาราม","วัดมูลจินดาราม","วัดมูลเหล็ก","วัดเมตารางค์","วัดเมธังกราวาส (เทศรัฐราษฎร์นุกูล)","วัดเมมสุวรรณาราม","วัดเมืองสาตร","วัดเมืองใหม่","วัดแม่กะ","วัดแม่กำปอง และวัดแม่กำปอง สาขาบ้านป๊อก และวัดแม่กำปอง สาขาบ้านแม่ลาย","วัดแม่แก้ดน้อย","วัดแม่เฉย","วัดแม่เตย","วัดแม่ทะ (ดำรงประชานุเคราะห์)","วัดแม่เปียะ","วัดแม่ผาแหน","วัดแม่เลย","วัดแม่สะลาบ","วัดโมคลาน","วัดโมลี (นันทวิมล)","วัดไม้ตราสมาชิการาม","วัดไม้ฝาด","วัดไม้เรียง","วัดไม้เสียบ","วัดไม้เสี่ยว","วัดยกกระบัตร","วัดยม (เครือวรศรราษฎร์บำรุง)","วัดยมนาตามธรรม","วัดยวด","วัดยอดพระพิมล","วัดยอดสุวรรณคีรี","วัดยั้งเมิน","วัดยาง","วัดยาง (เย็นประชาสรรค์)","วัดยาง ณ รังสี","วัดยาง (มีมานะวิทยา)","วัดยางเกาะ","วัดยางขาว","วัดยางแขวนอู่","วัดยางคลี","วัดยางค้อม","วัดยางคอยเกลือ","วัดยางงาม","วัดยางงาม (พิบูลสุนทรราษฎร์รังสฤษฏ์)","วัดยางงาม (ประชาพัฒนา)","วัดยางช้าย","วัดยางทอง","วัดยางทอง (รัตนประชานุกูล)","วัดยางนอน","วัดยางมณี","วัดยางมณี (ชวนประชาสรรค์)","วัดยางยี่แส","วัดยางศรีเจริญ","วัดยางสว่างอารมณ์","วัดยางสุทธาราม","วัดยางหัก","วัดยางเอน","วัดยางเอน (ประชานุเคราะห์)","ยางโองน้ำพิทยาคม","วัดย่านซื่อ","วัดย่านยาว","วัดย่านยาวประชานุกูล","วัดย่านรี","วัดย่านอ่างทอง (นิยมประมุข)","วัดยายดา","วัดยุคลราษฏร์สามัคคี","วัดเย้ยปราสาท","วัดเยื้องคงคาราม","วัดโยธาธรรม","วัดโยธานิมิต","วัดโยธินประดิษฐ์","วัดโยธีราษฎร์ศรัทธาราม","วัดร่มเมือง","วัดรวก (สายราษฎร์สงเคราะห์)","วัดรวก (พร้อมพิทยาคาร)","วัดร่องแซง (กุลไพศาลวิทยา)","วัดร้องธาร","วัดร่องเย็น (สารแก้วประชาสงเคราะห์)","วัดร้องวัวแดง (ศรีจันทร์วิทยาคาร)","วัดร่องส้าว","วัดร้องอ้อ","วัดร่อนนา","วัดระฆังทอง","วัดระนาม","วัดระเบาะไผ่","วัดรักขิตวัน","วัดรังงาม","วัดรังษีสุทธาวาส","วัดรังสิต","วัดรังสิตาวาส","วัดรัตนชมภู","วัดรัตนโชติการาม","วัดรัตนวราราม","วัดรัตนาราม","วัดรัษฎาราม","วัดรางกร่าง","วัดรางกำหยาด","วัดรางจระเข้ ","วัดรางฉนวน","วัดรางบัวทอง","วัดรางปลาหมอ","วัดใหม่ดอนทราย","วัดรางเสน่ห์นครจันทร์","วัดราชช้างขวัญ","วัดราชปักษี","วัดราชสกุณา (ราชฎร์รังสฤษฎ์)","วัดราชสิงขร","วัดราชสิทธาราม","วัดราชาธิวาส","วัดรามแก้ว","วัดรามัญ","วัดรายชะโด","วัดราษฎร์เจริญ","วัดราษฎร์เจริญ (สรกิจพิจารณ์อุปถัมภ์)","วัดราษฎร์เจริญพร","วัดราษฎร์เจริญศรัทธาธรรม","วัดราษฎร์ธรรมาราม","วัดราษฎร์นิยม (นิติเกษตรบำรุง)","วัดราษฎร์นิยมธรรม","วัดราษฎร์นิยมธรรม (พิบูลสงคราม)","วัดราษฎร์บำรุง","วัดราษฎรบํารุง","วัดราษฎร์บำเพ็ญ (กริ่ง สง่า ศิษย์อุปถัมภ์)","วัดราษฎรบำรุง","วัดราษฎร์บำรุงศักดิ์","ชุมชนวัดวังจิก สาขาวัดราษฎร์บูรณะ","วัดราษฎร์บูรณะ","วัดราษฎร์บูรณาราม","วัดราษฎร์ประดิษฐ์","วัดราษฎร์ประสิทธิ์","วัดราษฎร์ปุณณาราม","วัดราษฎร์โพธิ์ทอง","วัดราษฎร์รังษี","วัดราษฎร์รังสรรค์","วัดราษฎร์วราราม","วัดราษฎร์ศรัทธา","วัดราษฎร์ศรัทธากะยาราม","วัดราษฎร์ศรัทธาทํา","วัดราษฎร์ศรัทธาทำ","วัดราษฎร์ศรัทธาธรรม","วัดราษฎร์ศรัทธาราม","วัดราษฎร์สมานฉันท์","วัดราษฎร์สโมสร","วัดราษฎร์สโมสร (ไพโรจน์วิทยา)","วัดราษฎร์สามัคคี","วัดราษฎร์อุปถัมภ์","วัดราษฏร์เจริญวราราม","วัดรำพัน (สุขสวัสดิพิชาญราษฎร์)","วัดรุ้ง (วิบูลย์วิทยาคาร)","วัดเรือแข่ง (ประชาอุปถัมภ์)","วัดแร่ราษฎร์สุทัศน์","วัดโรง (ขาวประชาสรรค์)","วัดโรงเข้","วัดโรงเข้ (พุฒประชาสรรค์)","วัดโรงช้าง (ธรรมกิตต์วิทยา)","วัดโรงธรรมมิตรภาพที่ 70","วัดโรงม้า","วัดโรงวัว","วัดโรงเหล็ก","วัดโรจนาราม","วัดละหารไร่","วัดไร่ขิง (สุนทรอุทิศ)","วัดไร่อ้อย","วัดฤกษ์บุญมี","วัดฤกษ์หร่ายสามัคคี","วัดฤทธิ์ (คำหมื่นปทุมานุสสรณ์)","วัดฤาไชย (ฤาไชยศึกษาคาร)","วัดฤๅษีสถิต","วัดล่องกะเบา","วัดลอน","วัดละมุด","วัดละมุด (ละมุดวิทยาคาร)","วัดละมุด (ร.ส.พ.ราษฎร์บํารุง)","เทศบาล 1 วัดละไม","วัดละลวด","วัดลักษณาราม (สมุทรราษฎร์วิทยาคาร)","วัดลัฎฐิวนาราม","วัดลัฏฐิวนาราม","วัดลัด (บางตะบูนวิทยาคาร)","วัดลัดทรายมูล","วัดลั่นทม","วัดลากค้อน","วัดล่าง (บวรวิทยายน 3)","วัดลาดกระจับ","วัดลาดเขาปูน","วัดลาดเค้า (ประชารัฐวิทยา)","วัดลาดชะโด (ประกาศวิทยาคาร)","วัดลาดชิด (ลาดชิดวิทยาคาร)","วัดลาดตาล","วัดลาดทราย","วัดลาดทิพยรส","วัดลาดน้ำขาว","วัดลาดบัว","วัดลาดบัวขาว","วัดลาดบัวหลวง (สหมิตรศึกษา)","วัดลาดประทุมคงคาราม","วัดลาดประทุมทอง","วัดลาดปลาเค้า","วัดลาดปลาดุก","วัดลาดเป้ง","วัดลาดเป็ด (ราษฎร์บำรุง)","วัดลาดพร้าว","วัดลาดโพธิ์ (รวมราษฎร์วิทยาคาร)","วัดลาดยาว","วัดลาดระโหง","วัดลาดศรัทธาราม","วัดลาดสนุ่น","วัดลาดสะแก","วัดลาดสาลี่","วัดลาดสิงห์","วัดลาดหญ้า ","วัดลาดหญ้าไทร (สิงหวิทยาคาร)","วัดลาดหญ้าแพรก","วัดลาดหลุมแก้ว","วัดลาดหวาย","วัดลานคา","วัดลานช้าง","วัดลานแซะ","วัดล้านตอง","วัดลานตากฟ้า","วัดลานนา","วัดลานนาบุญ (น้อม หงสะเดชอุปถัมภ์)","วัดล่ามช้าง","วัดลาย (ทวีปัญญา)","วัดลายมิตรภาพที่ 80","วัดลำสำรอง","วัดลำชะล่า","บ้านลำชิง","วัดลำดวน","วัดลำตะเคียน (วิริยศึกษา)","วัดลำนาว","วัดลำน้ำ (กัลยาณราษฎร์บำรุง)","วัดลำใน","วัดลำบัว","วัดลำประดา","วัดลำประดากลาง","วัดลำประดาใต้","วัดลำประดาเหนือ","วัดลำพญา","วัดลำพดจินดาราม","วัดลำพยอม","วัดลำพระยา (แช่มช้อยวิทยา)","วัดลำพะยา","วัดลำพันบอง","วัดลำโพ (คล้อยประชารังสฤษฎ์)","วัดลำมหาชัย (รัฐอนุสรณ์)","วัดลำลูกบัว","วัดลำเหย","วัดลำใหม่","วัดลิ้นทอง (จอมวิสิษฐ์ราษฎร์บำรุง)","วัดลิรัญดอน","วัดลุ่ม","วัดลุมพินี","วัดเลขธรรมกิตต์ (กรีเมธอุทิศ)","วัดเลา (คณะศิษย์เทพสิทธิอุทิศ)","อนุบาลวัดเลาขวัญ","วัดเลาเต่า","วัดเลียบ","วัดเลียบ (หร่ำวิทยานุกูล)","วัดโลกา","วัดวงฆ้อง","วัดวงเดือน","วัดวงษ์ภาศน์","วัดวงษ์วารี","วัดวงษ์สวรรค์","วัดวชิรประดิษฐ์","วัดวชิราลงกรณวราราม","วัดวนาราม","วัดวนาสันต์ (โศกนาคสามัคคี)","วัดวรจันทร์","วัดวรดิษฐ์","วัดวรพรตสังฆาวาส","วัดวรภูมิ (วรไวทยาวาส)","วัดวรุณดิตถาราม","วัดวัง (กิ่ม บุญอยู่ อุทิศ)","วัดวังกระชัน","วัดวังกลม","วัดวังก์วิเวการาม","วัดวังกอง","วัดวังกะจะ","วัดวังกะจับ","วัดวังกะพี้ (วิเชียรประชานุกูล)","วัดวังกุ่ม","วัดวังกุลา","วัดวังกู่","วัดวังขนายทายิการาม","วัดวังขรณ์","วัดวังขรี","วัดวังขามป้อม","วัดวังครก","วัดวังคัน","วัดวังค่า","วัดวังไคร้","วัดวังไคร้ (วชิรานุกูลประชาสรรค์)","วัดวังฆ้อง","อนุบาลดงเจริญ (วังงิ้ว)","วัดวังงิ้วงาม","วัดวังจะอ้าย (บุญราษฎร์วิทยาคม)","วัดวังจิก","วัดวังชะโด","วัดวังแดง","วัดวังแดงเหนือ ","วัดวังตะกู","วัดวังตะกู (เสรีเริงฤทธิ์อุปถัมภ์)","วัดวังตะขบ","วัดวังตูม","วัดวังใต้","วัดวังทอง","วัดวังทิพย์พันธาราม","วัดวังไทร","วัดวังน้ำขาว","วัดวังน้ำขาว (จินดาประชานุกูล)","วัดวังน้ำเขียว","วัดวังน้ำเต้า","วัดวังน้ำเย็น","วัดวังบัว (ศรสายราษฎร์บำรุง)","วัดวังบุญ","วัดวังปลาจีด","วังเป็ด","วัดวังผักรุง","วัดวังผาปูน","วัดวังไผ่","วัดวังพระนอน","วัดวังพลับใต้","วัดวังพลับเหนือ","วัดวังพิกุล","วัดวังม่วง","วัดวังมหากร","วัดวังมะด่าน","วัดวังมะเดื่อ","วัดวังมะนาว","วัดวังม้า(ชลประสิทธิ์วิทยา)","วัดวังไม้แก่น","วัดวังยาง","วัดวังยายฉิม","วัดวังเย็น (รัฐราษฎร์ประสาทวิทยา)","วัดวังเย็น","วัดวังรีบุญเลิศ","วัดวังเรือน","วัดวังแร่","วัดวังแรต","วัดวังเลน","วัดวังวน","วัดวังเวียน","วัดวังศาลา","วัดวังสรรพรส","วัดวังสวรรค์ (ประชาบำรุง)","วัดวังสวัสดี","วัดวังสะแกง","วัดวังสัมพันธ์","วัดวังสาริกา","วัดวังสำเภาล่ม","วัดวังสำโรง","วัดวังสิงห์คำ","วัดวังหงส์","วัดวังหมัน","วัดวังหมู (นิมมานโกวิท)","วัดวังหลวง","วัดวังหว้า","วัดวังหวาย","วัดวังหัวแหวน","วัดวังหิน (เจียงบรรจงราษฎร์นุเคราะห์)","วัดวังหิน","วัดวังหินเพลิง","วัดวังหินแรง","วัดวังหีบ","วัดวังหูทิพย์","วัดวังใหญ่","วัดวังอิทก","วัดวัชคามคชทวีป","วัดวัฒนารังษี","วัดวันดาว","วัดวันยาวล่าง","วัดวันอุทิศ (สิริกมลฉ่ำราษฎร์บำรุง)","วัดวัวหลุง","วัดวาปีรัตนาราม","วัดวารีวง","วัดวาลุการาม","วัดวาส","วัดวิจิตรรังสรรค์","วัดวิจิตรังสิตาราม","วัดวิชิตธาราราม","วัดวิมลประชาราษฎร์","วัดวิมลมรรคาราม","วัดวิโรจนาราม","วัดวิวิตตาราม","วัดวิเวกวราราม (ศุภกิจวิบูลอุปถัมภ์)","วัดวิเวกวายุพัด","วัดวิเวการาม","วัดวิสุทธาราม","วัดวิสุทธิยาราม","วัดวิสุทธิวงศ์","วัดวิหารขาว","วัดวิหารเบิก (กาญจนานุกูล)","วัดวุ้งสุทธาวาส","วัดเวตวันธรรมาวาส","วัดเววน","วัดเวฬุวัน","วัดเวฬุวนาราม","วัดเวียงคอย","วัดเวียงทุน","วัดเวียงสระ","วัดศรลัมพ์ราษฎร์สามัคคีธรรม","วัดศรัทธาธรรม","วัดศรัทธาภิรม","วัดศรัทธาราม","วัดศรัทธาราษฎร์","วัดศรัทธาเรืองศรี","วัดศรีกัลยานุสรณ์","วัดศรีกุญชร","วัดศรีเขตนันทาราม","วัดศรีคงคาราม","วัดศรีคัคณางค์","วัดศรีจอมทอง","วัดศรีจันดาธรรม","วัดศรีจุฬา","วัดศรีเจริญธรรม","วัดศรีเฉลิมเขต","วัดศรีชุม","วัดศรีไชย","วัดศรีดอก (ประชาพัฒนา)","วัดศรีดอนชัย","วัดศรีทอง","วัดศรีธาราม","วัดศรีนวลธรรมวิมล","วัดศรีบังวัน","วัดศรีบัวทอง","วัดศรีบุญชู-วังไฮ","วัดศรีบุญเรือง","วัดศรีประชา","วัดศรีประชาราม","เทศบาลวัดศรีประชาสรรค์","วัดศรีประชุมชน","วัดศรีปรีดานุเคราะห์","วัดศรีพโลทัย","วัดศรีโพธาราม","วัดศรีโพธิ์ (เริงทรัพย์วิทยาคาร)","วัดศรีภวังค์","วัดศรีภูมิ(ศึกษาประชานุสรณ์)","วัดศรีมงคล","วัดศรีมงคล (สถิตมงคลราษฎร์อุปถัมภ์)","วัดศรีมหาโพธิ์","วัดศรีเมือง","วัดศรีรัตนวราราม","วัดศรีรัตนาราม","วัดศรีรัตนาราม (รัตนราษฎร์สงเคราะห์)","วัดศรีล้อม","วัดศรีโลหะราษฎร์บํารุง","วัดศรีวนาราม","วัดศรีวารีน้อย","วัดศรีวิชัย","วัดศรีวิเทศสังฆาราม","วัดศรีวิสารวาจา","วัดศรีวิสุทธาราม (วิไลราษฎร์อุปถัมภ์)","วัดศรีศรัทธาราม","วัดศีรษะคีรี","วัดศรีสโมสร","วัดศรีสร้อยเพชร","วัดศรีสวรรค์สังฆาราม","วัดศรีสวัสดิ์","วัดศรีสังวร","วัดศรีสัจจาวาส","วัดศรีสาคร","วัดศรีสำราญ","วัดศรีสุดาจันทร์","วัดศรีสุตาราม","วัดศรีสุทธาราม","วัดศรีสุทธาวาส","วัดศรีสุนทร","วัดศรีสุนทร (มิตรภาพ 15)","วัดศรีสุพรรณ์","วัดศรีสุวรรณ","วัดศรีสุวรรณคงคาราม(ราษฎร์สงเคราะห์)","วัดศรีสุวรรณาราม","วัดศรีอัมพวัลย์","วัดศรีอุดม (ประภัสสรราษฎร์สฤษฎร์)","วัดศรีอุทุมพร","วัดศรีอุปลาราม","วัดศาลเจ้า (เรือง เล็บครุฑ)","วัดศาลากุล","วัดศาลาเขื่อน (อุภัยเพชร)","วัดศาลาดิน (วิศิษฐ์ราษฎร์รังสรรค์)","วัดศาลาแดง","วัดศาลาตึกสิทธิชัยวิศาล","วัดศาลาท่าทราย","วัดศาลาไพ","วัดศาลาลอย","วัดศาลาหลวงบน","วัดศาลาหลวงล่าง","วัดศิริจันทราราม","วัดศิริชัยนิมิตร","วัดศิริบรรพต","วัดศิริบูรณาราม","วัดศิริมงคล","วัดศิริสุขาราม","วัดศิลา","วัดศิลาชลเขต","วัดศิลามูล","วัดศิลาราย","วัดศิวาราม","วัดศีรษะเกษ","วัดศีรษะทอง (น้อยชมประชานุกูล)","ชุมชนวัดศีลขันธารามวิทยาคม","วัดศุขเกษม","วัดเศวตศิลาราม","วัดสกุณปักษี","วัดสกุณาราม (ประสิทธิ์ชัยประชาสรรค์)","วัดสงฆาราม","วัดสง่างาม","วัดสฏางค์","วัดสถานีหนองตาด","วัดสถิตโพธาราม","วัดสถิตย์ชลธาร","วัดสน (ดำราษฎร์ประดิษฐ์)","วัดสนธิธรรม","วัดสนามคลีตะวันตก","วัดสนามคลีตะวันออก","วัดสนามจันทร์","วัดสนามชัย","วัดสนามช้าง","วัดสนามไชย","วัดสนามทองมิตรภาพที่ 180","วัดสนามนอก","วัดสนามแย้","วัดสนามสุทธาวาส (พรหมประชานุกูล)","วัดสบกเขียว","วัดสบจาง","วัดสบแม่ทำ","วัดสพานสูง (รถไฟนุเคราะห์)","วัดสมควร","วัดสมณาวาส","วัดสมถะ (สมถวิทยาคาร)","วัดสมบูรณ์สามัคคี(ปากช่องประชานุกูล)","วัดสมบูรณาราม","วัดส้มป่อย","วัดสมหวัง","วัดสมอ","วัดสมอ (วุฒาประชานุเคราะห์)","วัดสมอแข (พิณพลราษฎร์บำรุง)","วัดสมอโพรง","วัดสมอสุวรรณาราม","วัดสมัยคงคา","วัดสมัยสุวรรณ","วัดสมานประชาชน","วัดสมานมิตรมงคล","วัดสมานรัตนาราม","วัดสมุทรโคดม","วัดสมุทรธาราม","เทศบาล 3 วัดสมุทราราม","วัดสมุหเขตตาราม","วัดสมุหประดิษฐ์ (วันครู 2501)","วัดสมุห์พร้อมศิษย์สามัคคีวนาราม","วัดสมุหราษฎร์บํารุง","วัดสโมสร","วัดสโมสรสันนิบาต","วัดสรรเพชญ (ทวีวิทยาคม)","วัดสร้อยทอง","วัดสร้อยฟ้า (สุวรรณโพธาประชานุกูล)","วัดสระ","วัดสระกระเบื้อง","วัดสระกร่างเจริญธรรม","วัดสระกลอยสามัคคีธรรม","วัดสระกะเทียม","เทศบาล 2 วัดสระเกศ","วัดสระเกษ","วัดสระแก้ว","วัดสระข่อย","วัดสระโคล่","วัดสระไคร","วัดสระจันทร์","วัดสระด่าน","วัดสระดู่","วัดสระดู่(บู่บำรุงวิทย์)","วัดสระตะโก (หันประชาสามัคคี)","วัดสระทอง","วัดสระเนินพระราม","วัดสระบัว","วัดสระประดิษฐ์","วัดสระประทุม","วัดสระประทุม (มิตรภาพที่ 54)","วัดสระพัง","วัดสระพังลาน","วัดสระเพลง","วัดสระโพธิ์","วัดสระมะเกลือ","วัดสระมะเขือ","วัดสระไม้แดง","วัดสระยายโสม","วัดสระศรีเจริญ","วัดสระสองตอน (พุทธโสธรอุปถัมภ์)","วัดสระสี่มุม","วัดสระสี่เหลี่ยม","วัดสร้างบุญ","วัดสร่างโศก","วัดสร่างโศก (อบศรีประชาอุปถัมภ์)","วัดสลัก","วัดสลักได","วัดสลักเพชร","วัดสลักเหนือ","วัดสลุด","วัดสวนแก้ว","วัดสวนขวัญ","วัดสวนขัน","วัดสวนดอก","วัดสวนแตง","วัดสวนทองรวมมิตร","วัดสวนพล","วัดสวนพลู","วัดสวนพิกุล","วัดสวนมะเดื่อสามัคคี","วัดสวนศิขรบรรพต","วัดสวนส้ม (สุขประนุกูล)","วัดสวนส้ม (ชื่นสินอนุสรณ์)","วัดสวนหมาก","วัดสวนหลวง","วัดสวนอัมพวัน","วัดสวรรค์นิมิต","วัดสวรรค์ประชากร","วัดสว่าง","วัดสว่างภพ","วัดสว่างมนัส","วัดสว่างวงษ์ (ตาคลีประชานุกูล)","วัดสว่างอารมณ์","วัดสว่างอารมณ์ (กัลยา ณ ราษฎร์)","วัดสว่างอารมณ์ (ศรีวัฒนานุกูล)","วัดสหกรณ์รังสรรค์","วัดสอ","วัดส่องคบ (ท้ายเมืองอนุสรณ์)","วัดสองคลอง","วัดสองคอนกลาง","วัดสองแคว","บ้านสองแควเหนือ","วัดสองพี่น้อง","วัดสองแพรก","วัดสองห้อง","วัดสอนดีศรีเจริญ","วัดสอนประดิษฐ์วราราม","วัดสะแก","วัดสะแก (สุทธิธรรมาประชาสงเคราะห์)","วัดสะแกงาม (จีระศฤงฆ์อุทิศ)","วัดสะแกราบ","วัดสะเดา","วัดสะตอน้อย","วัดสะตือ","วัดสะตือสิงห์","วัดสะทัง","วัดสะนำ","วัดสะพาน","วัดสะพาน (ศิษย์สมพงษ์อุทิศ)","วัดสะพานคง","วัดสะพานหิน","วัดสะพานหิน (วงศ์วานประชาสรรค์)","วัดสะแล่ง","วัดสะอาดราษฎร์บำรุง","วัดสัก (จันทร์ศิริจำเริญประชาสรรค์)","วัดสังกัสรัตนคีรี","วัดสังข์กระจาย (แจ่มวิชาสอน)","วัดสังขประดิษฐ์","วัดสังขสุทธาวาส","วัดสังฆจายเถร","วัดสังฆราชาวาส","วัดสังฆวราราม","วัดสังฆวิถี","วัดสังฆาราม (ปลื้มประชาสงเคราะห์)","วัดสังโฆสิตาราม","วัดสังวรพิมลไพบูลย์ (จันทานุกูล)","วัดสัตตวนาราม","วัดสัตตศิลาอาสน์","วัดสันคู","วัดสันโค้ง","วัดสันดอนมูล","วัดสันต้นธง","วัดสันตยาราม","วัดสันติการาม","วัดสันติคีรีรมย์","วัดสันติธรรม","วัดสันติธรรมราษฎร์บำรุง","วัดสันติวราราม","วัดสันติวัฒนาราม","วัดสันติวัน","วัดสันติวิหาร(ขันธสาประชานุเคราะห์)","วัดสันทราย","วัดสันทรายมูล (มงคลวิทยา)","วัดสันป่าสักและบ้านหนองบัว","วัดสันมะกรูด","วัดสันมะฮกฟ้า","วัดสัปรสเทศ","วัดสัมปทวน (บางแก้วพุทธิยาคาร)","วัดสัมปทวน","วัดสัมพันธ์","วัดสัมพันธมิตร","วัดสัมมาราม","วัดสากเหล็ก","วัดสาธุการาม","วัดสาธุชนาราม (สินประชานุกูล)","วัดสาธุประชาสรรค์","วัดสามกอ","วัดสามกอ (วงศ์ประชารัฐ)","วัดสามกอง","วัดสามโก้","วัดสามขาว","วัดสามควายเผือก","วัดสามง่าม","วัดสามง่าม (คงทองอนุสรณ์)","วัดสามง่าม (วันครู 2501)","วัดสามเงา","วัดสามจุ่น","วัดสามชุก","วัดสามตุ่ม","วัดสามทอง","วัดสามบัณฑิต","วัดสามประชุม (วันครู 2504)","วัดสามผาน","วัดสามพัน","วัดสามเพลง","วัดสามแพรก","วัดสามแยก (เสียงไพโรจน์-รัฐ-ประชาสรรค์)","วัดสามร่ม (ไพบูลย์ปัญญา)","วัดสามเรือน","วัดสามเรือน ","วัดสามหลัง","วัดสามัคคิยาราม","วัดสามัคคีธรรม","วัดสามัคคีธรรม(หนู-บุตรอุปถัมภ์)","วัดสามัคคีธรรมาราม","วัดสามัคคีนุกูล","วัดสามัคคีภิรมย์","วัดสามัคคีศรัทธาราม","วัดสามัคยาราม","วัดสามี (ปุญญมุนีอุทิศ)","วัดสายลำโพงกลาง","วัดสายลำโพงใต้","วัดสายลำโพงเหนือ","วัดสายห้วยแก้ว","วัดสารคุณสโมสร","วัดสารนารถธรรมาราม","วัดสารภี","วัดสารภีวิทยาคาร","วัดสารวนาราม","วัดสารวัน","วัดสารอด","วัดสาริการาม","วัดสาลวนาราม","วัดสาลวัน","วัดสาลี","วัดสาลีโขภิตาราม (อุ่น-สลากกินแบ่งสงเคราะห์)","วัดสาแล","วัดสาวชะโงก","วัดสำนักกะท้อน","วัดสำนักขัน","วัดสำนักคร้อ","วัดสำนักตะฆ่า","วัดสำนักบก","วัดสำเภาทอง","วัดสำมะกัน","วัดสำราญ","วัดสำโรง","วัดสำโรง (หิรัญราษฎร์ภักดีวิทยา)","วัดสำโรงชัย","วัดสำโรงเหนือ","วัดสิงขร","วัดสิงห์ (วรประสิทธิ์วิทยา)","วัดสิงห์","วัดสิงห์ (ขจิตพุทธสรศึกษา)","วัดสิงห์ (แจ่มชื่นวิทยาคม)","วัดสิงห์ทอง","วัดสิงห์ทอง ","วัดสิงห์ศรีสว่าง","วัดสิงห์สุทธาวาส","วัดสิทธาราม","วัดสิทธิโชค","วัดสิทธิวิมล (สุวรรณราษฎร์ปัญญา)","วัดสิทธิสารประดิษฐ์","วัดสิริจันทรนิมิตร (ประกิจประชานุกูล)","วัดสิริมงคล","วัดสิริสุทธาวาส","วัดสีกุก (สุ่นสามัคคีราษฎร์วิทยา)","วัดสี่ซับศรีเจริญธรรม","วัดสี่แยกราษฎร์บำรุง","วัดสี่ร้อย","วัดสีล้ง","วัดสีสุก","วัดสีหยัง","วัดสีหราษฎร์ศรัทธา","วัดสุกรีย์บุญญาราม","วัดสุขกร","วัดสุขเกษม","วัดสุขใจ","วัดสุขบุญฑริการาม","วัดสุขไพรวัน","วัดสุขวราราม","วัดสุขวัฒนาราม","วัดสุขสำราญ","วัดสุขุม","วัดสุคนธาราม","วัดสุคันธศีลาราม (หอมศีลวิทยาคาร)","วัดสุคันธารมย์","วัดสุคันธาราม (สุคันธวิทยาคาร)","วัดสุคันธาวาส","วัดสุชน","สุดินสหราษฎร์","วัดสุตธรรมมาราม","วัดสุทธาราม","วัดสุทธาวาส","วัดสุทธิมงคล","วัดสุธรรมาราม","เทศบาลวัดสุธาโภชน์ (ไวทย์วรวิทย์)","วัดสุนทรเทพคีรี","วัดสุนทรเทพมุนีมิตรภาพที่ 188","วัดสุนทรธรรมิการาม","ชุมชนวัดสุนทรนิวาส","วัดสุนทรพิชิตาราม","วัดสุนทรวารี","วัดสุนทรสถิต (สามัคคีวิทยาคม)","วัดสุนทราราม","วัดสุนทราวาส","วัดสุนทริกาวาส","วัดสุนันทาราม","วัดสุบรรณาราม","วัดสุพรรณพนมทอง","วัดสุภาษิตาราม","วัดสุมมติเทพฐาปนาราม","วัดสุมังคลาราม","วัดสุวรรณ","วัดสุวรรณโกฏิ","วัดสุวรรณคีรี","สุวรรณคีรี","วัดสุวรรณคีรีเขต","วัดสุวรรณคีรีวงก์","วัดสุวรรณคูหา","วัดสุวรรณโฆษิต","วัดสุวรรณจินดาราม","วัดสุวรรณเจดีย์เลิศบุญยงค์อนุสรณ์","วัดสุวรรณตะไล","วัดสุวรรณเตมีย์","วัดสุวรรณนิมิต","วัดสุวรรณมงคล","ชุมชนวัดสุวรรณรังสรรค์","วัดสุวรรณรัตนาราม","วัดสุวรรณราชหงษ์","วัดสุวรรณวิหารน้อย","วัดสุวรรณากร","วัดสุวรรณนาคี","วัดสุวรรณารัญญิกาวาส","วัดสุวรรณาราม","วัดสุวรรณาวาส","วัดสูงเนินราษฎรบำรุง","วัดเสด็จ","วัดเสด็จ (สุทธิวิทยานุสรณ์)","วัดเสถียรรัตนาราม","วัดเสนาณรงค์","วัดเสนาสน์","วัดเสนีวงศ์","วัดเสม็ด (วุฒิสุนทรวิทยา)","วัดเสม็ดงาม (เพิ่มพิทยาคาร)","วัดเสม็ดจวน","วัดเสม็ดใต้","วัดเสม็ดโพธิ์ศรี (อุชุกวิทยาคาร)","วัดเสม็ดเหนือ (ชิตประชาสรรค์)","วัดเสมียนนารี","วัดเสาธง","วัดเสาธงกลาง","วัดเสาธงเก่า (ถึงสุขประชาสรรค์)","วัดเสาธงทอง","วัดเสาธงหิน","วัดเสาหิน","วัดเสือข้าม","วัดแสงดาว (เทพประชานุสรณ์)","วัดแสงประดิษฐ์","วัดแสงมณี","วัดแสงรังสรรค์","วัดแสงสรรค์","วัดแสงสว่าง","วัดแสงอุทัย","วัดแสนตอ","วัดแสนตอ (วรวัตตวิทยาคาร)","วัดแสนภุมราวาส","วัดแสนภูดาษ","วัดแสลง (เขมราษฎร์วิทยาคาร)","วัดโสดาประดิษฐาราม","วัดโสภณเจติการาม","วัดโสภณประชาราม","วัดโสภณาราม","วัดโสภณาราม (ปลั่งร่วมราษฎร์บํารุง)","วัดโสภา","วัดโสมนัส","วัดโสมสิริวัฒนาราม","วัดใสประดู่","วัดไสกระดาน","วัดไสค้าน","วัดไสมะนาว","วัดหงษ์","วัดหงส์แก้ว","วัดหงส์ปทุมาวาส","วัดหงส์รัตนาราม","วัดหญ้า","วัดหญ้าไทร (ราษฎร์ประสิทธิ์)","วัดหญ้าปล้อง","วัดหนองกก","วัดหนองกบ (ขุนทองประชานุเคราะห์)","วัดหนองกบ (ไทยกล้าประชานุกูล)","วัดหนองกรด","วัดหนองกระโดน","วัดหนองกระทุ่ม (พ่วงแสงวิทยาคม)","วัดหนองกระทุ่ม","วัดหนองกระทุ่ม (สังฆรักษ์ราษฎร์บำรุง)","วัดหนองกระบอก","วัดหนองกระเบียน","วัดหนองกระเบื้อง","วัดหนองกระพี้","วัดหนองกระสังสามัคคี","วัดหนองกรับ","วัดหนองกร่าง","วัดหนองกราด (สังวรอุปถัมภ์)","วัดหนองกลอย","วัดหนองกลางดง","วัดหนองกลางด่าน","วัดหนองกอไผ่","วัดหนองกะขะ (บุญยิ่งประชานุกูล)","วัดหนองกะธาตุ","วัดหนองกะพ้อ","วัดหนองกาทอง (ม่วงนิรมิตร)","วัดหนองกีบม้า","วัดหนองกุ่ม","วัดหนองเกตุ","วัดหนองเกตุน้อย","วัดหนองเกตุใหญ่","วัดหนองเก้าข่า","วัดหนองแก","วัดหนองแก (กล่อมวิทยาคาร)","วัดหนองแก้ว","วัดหนองโก","วัดหนองขอน","วัดหนองขานาง","วัดหนองขาม (ไตรราษฏร์อำรุง)","วัดหนองขุนปราบ","วัดหนองเขนง","วัดหนองเขื่อน","วัดหนองเขื่อนช้าง","วัดหนองแขม","วัดหนองคณฑี (พลานุกูล)","วัดหนองครก","วัดหนองครอบ","วัดหนองคล่อ","วัดหนองคล้า","วัดหนองคล้า (สำนักงานสลากกินแบ่งสงเคราะห์ 153)","วัดหนองควง (ปริยัติพุทธสรราษฎร์นุเคราะห์)","วัดหนองคัน (ไจ พิทยาคาร)","วัดหนองคันจาม","วัดหนองคันทรง","วัดหนองคุ้ม","วัดหนองคู","วัดหนองคูน้อย","วัดหนองเค็ด","วัดหนองเครือบุญ","วัดหนองเคี่ยม","วัดหนองง้าว","วัดหนองจอก","วัดหนองจอก (ศรีสรรค์พานิช)","วัดหนองจอกใหญ่","วัดหนองจับเต่า","วัดหนองจิก","วัดหนองจิก (บุญมีประชานุกูล)","วัดหนองจิกเภา","วัดหนองจิกรี (เจริญสุขประชานุเคราะห์)","วัดหนองแจง","วัดหนองชันจันทนาราม","วัดหนองชิ่ม","วัดหนองชุมแสง","วัดหนองแช่แว่น","วัดหนองซิว","วัดหนองแซง","วัดหนองดินแดง","วัดหนองดี","วัดหนองตะโก","วัดหนองตะครอง","วัดหนองตะเฆ่","วัดหนองตะแบก","วัดหนองตางู","วัดหนองตาโชติ","วัดหนองตาเดี้ยง","วัดหนองตาตน","วัดหนองตาบุญ","วัดหนองตามิ่ง","วัดหนองตาเรือง","วัดหนองตาสาม","วัดหนองตาหลวง","วัดหนองติม","วัดหนองเตยตั้งตรงจิตร 8","วัดหนองเต่า","วัดหนองเต่าดำ","วัดหนองแตน","วัดหนองทราย","วัดหนองทองทราย","วัดหนองทางบุญ","วัดหนองไทร","วัดหนองนกไข่","วัดหนองนกยูง","วัดหนองน้อย","วัดหนองนา","วัดหนองนาดงกวาง","วัดหนองนาง","วัดหนองนางปุ๋ย","วัดหนองนาดำ","วัดหนองน้ำเขียว","วัดหนองน้ำเขียว (วันดาคุณอุปถัมภ์)","วัดหนองน้ำเต้า","วัดหนองน้ำทิพย์","วัดหนองน้ำส้ม (เจียนวิทยาคาร)","วัดหนองบอนแดง","วัดหนองบัว","วัดหนองบัว (ปทุมาภิพัฒน์)","วัดหนองบัว (พิทักษ์ราษฎร์บำรุง)","วัดหนองบัว (รัฐปทุมราษฎร์อุปถัมภ์)","วัดหนองบัวขาว","วัดหนองบัวค่าย","วัดหนองบัวยอดแก้ว","วัดบ้านหนองบัวศาลา","วัดหนองเบน","วัดหนองปรง (บุญมานุสรณ์)","วัดหนองประทุน","อนุบาลหนองปรือ","วัดหนองปรือ (สุทธาถนอมราษฎร์บำรุง)","ราชวินิตสุวรรณภูมิ","วัดหนองปรือ (สามัคคีราษฎร์บำรุง)","วัดหนองปล่อง","วัดหนองปล้อง","วัดหนองปลากะดี่","วัดหนองปลาซิว","วัดหนองปลาดุก","วัดหนองปลาหมอ","วัดหนองปล้อง สาขาวัดหนองปลาหมอ (มิตรภาพ 215)","วัดหนองปลาไหล (ปานพลอุปถัมภ์)","วัดหนองปลาไหล","วัดหนองปลิง","วัดหนองป่าครั่ง","วัดหนองปาตอง (อัมพรรัฐประชาสรรค์)","วัดหนองเป็ด","วัดหนองเป้า","วัดหนองเปาะ","วัดหนองผักชี","วัดหนองผักนาก","วัดหนองไผ่","วัดหนองไผ่ไพศาลี","วัดหนองพรมหน่อ","วัดหนองพลวง","วัดหนองพลับ","วัดหนองพะยอม","วัดหนองพะวา","วัดหนองพังค่า (ประชานุกูล)","วัดหนองพังตรุ","วัดหนองพังนาค","วัดหนองพันจันทร์","วัดหนองพันท้าว (พรประชาวิทยาคาร)","วัดหนองพันเทา","วัดหนองพันเรือ (สำนักงานสลากกินแบ่งสมทบ 167)","วัดหนองพิมาน","วัดหนองแพงพวย","วัดหนองโพ (นิวาสานุสรณ์)","วัดหนองโพธิ์","วัดหนองโพธิ์ (ศิลปวิทยาคม)","วัดหนองโพรง","วัดหนองแฟบ","วัดหนองมน","วัดหนองมน (ลอยเคลือบประชานุกูล)","วัดหนองม่วง (หงส์วิทยาคาร)","วัดหนองม่วง","วัดหนองม่วงใหม่","วัดหนองมะกอก","วัดหนองมะคัง","วัดหนองเมือง","วัดหนองไม้แก่น","วัดหนองไม้ซุง","วัดหนองไม้เหลือง (ธรรมโชติประชาธร)","วัดหนองไม้เอื้อย","วัดหนองยวง","วัดหนองยาง","วัดหนองยายทรัพย์","วัดหนองยาว","วัดหนองยาวใต้","วัดหนองยาวสูง","วัดหนองระแหงเหนือ","วัดหนองราง","วัดหนองรี","วัดหนองเรือโกลน","วัดหนองโรง","วัดหนองไร่","วัดหนองลาน","วัดหนองลำเจียก","วัดหนองโว้ง (อรรถกิจวิทยาคาร)","วัดหนองศาลา (ประชานุกูล)","วัดหนองศาลา (ธรรมกรประสาท)","อนุบาลระยองวัดหนองสนม","วัดหนองสนวน","วัดหนองส้ม","วัดหนองสมณะ","วัดหนองสมัคร (มูลนิธิสุขาวดีอุปถัมภ์)","วัดหนองสมาน","วัดหนองสรวง (ถิรอุทิศ)","วัดหนองสระ","วัดหนองสลิด","วัดหนองสองห้อง","วัดหนองสะเดา","วัดหนองสะเดา (สุนทรพิทยา)","วัดหนองสังข์","วัดหนองสังข์ทอง","วัดหนองสีงา (ประถมบูรณ์รัฐราษฎร์สงเคราะห์)","วัดหนองสีดา","วัดหนองสีนวล","วัดหนองสุทธะ","วัดหนองสุ่ม","วัดหนองเสม็ด (อรรถพรสงเคราะห์)","วัดหนองเสือ","วัดหนองเสือ (รัฐราษฎร์พัฒนา)","วัดหนองเสือ (เรืองวิทยานุกูล)","วัดหนองเสือ (ประชาอุทิศ)","วัดหนองโสน","วัดหนองหญ้าปล้อง","วัดหนองหญ้ารังกา","วัดหนองหม้อ","วัดหนองหม้อแกง","วัดหนองหมู","วัดหนองหมูใต้ (ไพบูลย์วิทยาคาร)","วัดหนองหล่ม","วัดหนองหลวง","วัดหนองหลอด","วัดหนองหลั้ว","วัดหนองหลุม","วัดหนองหว้า","วัดหนองหว้า (เสธิยสาธร)","วัดหนองหอย","วัดหนองหัวโพ","วัดหนองหิน","วัดหนองหิน (วิเชียรประชานุกูล)","วัดหนองหูช้าง","วัดหนองเหมือด","วัดหนองเหียง","วัดหนองแหน (รัตนศิริราษฎร์)","วัดหนองแหวน (วิจิตรราษฏร์บำรุง)","วัดหนองอ้อ","วัดหนองอ้อ (คงคสุวรรณราษฎร์นุเคราะห์)","วัดหนองอ้อ (ธรรมธรใยประชาสามัคคี)","วัดหนองออน","วัดหนองอ่างทอง","วัดหนองเอี่ยน","วัดหน่อสุวรรณ","วัดหนัง","วัดหนา","วัดหน้าเขา","วัดหน้าโคก (วิสุทธิศึกษา)","วัดหน้าต่างใน (จงนิลอุปถัมภ์)","วัดหน้าถ้ำ (พุทธไสยานุสรณ์)","วัดหน้าพระธาตุ","วัดหนามแดง (คัณฑาโรราษฎร์บำรุง)","วัดหนามแดง (เขียวอุทิศ)","วัดหนามพุงดอ","วัดหน้าเมือง","วัดหน้าสตน","วัดหมกแถว","วัดหมาย","วัดหมื่นเกลา","วัดหมูดุด","วัดหรังแคบ","วัดหลวง","วัดหลวง (คลึงวิทยาคม)","วัดหลวง (วิทยาประชาสรรค์)","วัดหลวงครู","วัดหลวงท้ายตลาด (แจ้งยุบลราษฎร์อุทิศ)","วัดหลวงพรหมาวาส","วัดหลวงพ่อขาว","วัดหลวงพ่อเขียว","วัดหลวงแพ่ง (อินทรประชานุกูล)","วัดหลวงวิทยา","วัดหลวงสิริบูรณาราม","วัดหลวงสุวรรณาราม","วัดหล่อเจริญราษฎร์วราราม","วัดหลักแก้ว","วัดหลักช้าง","วัดหลักศิลา","วัดหลักสองราษฎร์บํารุง","วัดหลักสี่","วัดหลักสี่ราษฎร์สโมสร","วัดหลักหกรัตนาราม","วัดหลังถ้ำวิทยาคาร","วัดหล่ายโพธิ์","วัดหลุมข้าว","วัดห้วงกระได","วัดห้วงน้ำขาว","วัดห้วงโสม","วัดห้วงหิน","วัดห้วย","วัดห้วยกรวด","อนุบาลห้วยกระเจา","วัดห้วยแก้ว","วัดห้วยขมิ้น","วัดห้วยขานาง","วัดห้วยคงคาวราวาส","วัดห้วยคราม","วัดห้วยคันแหลน (ประชารัฐรังสรรค์)","วัดห้วยคิง","วัดห้วยคู","วัดห้วยคู้สามัคคี","วัดห้วยจระเข้ (เกตุอร่ามอุปถัมภ์)","วัดห้วยดั้ง","วัดห้วยดุก","วัดห้วยเดื่อ","วัดห้วยตะโก (บูรณธนิตราษฎร์รังสรรค์)","วัดห้วยตะเคียน","วัดห้วยตะแคง (พรประชานุกูล)","วัดห้วยโต้","วัดห้วยทราย","วัดห้วยทราย (อดิเรกสารประชานุสรณ์)","วัดห้วยทองหลาง","วัดห้วยธารทหาร","วัดห้วยนาง (วันครู2501)","วัดห้วยน้ำเย็น","วัดห้วยบง (บริษัทข้าวไทยจำกัดสงเคราะห์3)","วัดห้วยปลาดุก (อนันตกูลอุปถัมภ์)","วัดห้วยโป่ง (จันทร์ราษฎร์บำรุง)","วัดห้วยโป่ง","วัดห้วยผักชี","วัดห้วยไผ่","วัดห้วยพระ","วัดห้วยพระจันทร์","วัดห้วยพลู","วัดห้วยพุด","วัดห้วยม่วง","วัดห้วยม้าโก้ง","วัดห้วยยาง","วัดห้วยยาบ","วัดห้วยรอบ","วัดห้วยเรียงกลาง","วัดห้วยเรียงใต้","วัดห้วยโรง","วัดห้วยโรง (หนึ่งนฤมิตรพิทยาคาร)","วัดห้วยไร่","วัดห้วยลาด","วัดห้วยลำไย","วัดห้วยลี่","วัดห้วยสะพาน","วัดห้วยสุวรรณวนาราม","วัดห้วยเสือ (มงคลประชาสรรค์)","วัดห้วยหม้าย (หมายประชากร)","วัดห้วยหมู (อมรธรรมรัตราษฎร์บำรุง)","วัดห้วยหวายหนองเติ่นพัฒนา","วัดห้วยหวาย","วัดห้วยหิน","วัดห้วยแห้ง","วัดห้วยแหยง (ราษฎร์ภูเก็ตอุทิศ)","วัดหวัง","วัดหว้า","วัดหว่านบุญ","วัดหวายกรอง","วัดหวายเหนียว ","วัดหว้าเอน","วัดหอกลอง","วัดหอไกร","วัดห้องสูง","วัดหอมเกร็ด","วัดหอยกัน","วัดหอระฆัง","วัดหันตรา (เวช สมาน ราษฏร์นุกูล)","วัดหัวกรด","วัดหัวกระสังข์ (มะลิเสงี่ยมราษฎร์สามัคคี)","วัดหัวกรูด","วัดหัวกลับ","วัดหัวกะทุ่ม","วัดหัวเขา","วัดหัวเขาชัยสน","วัดหัวเขาสมอคร้า","วัดหัวควน","วัดหัวค่าย (พิศาลอุปถัมภ์)","วัดหัวคุ้ง","วัดหัวคู้","วัดหัวเค็ด","วัดหัวงิ้ว","วัดหัวดง","วัดหัวดงใต้ (บางทองประชาสรรค์)","วัดหัวดงเหนือ (บรรพตานุสสรณ์)","วัดหัวเด่น","วัดหัวตะพาน","วัดหัวตะพาน (ประชาบำรุง)","วัดหัวเตย","วัดหัวถนน","วัดหัวถนน (สภาจังหวัด2502)","วัดหัวไทร","วัดหัวนอน","วัดหัวนา","วัดหัวป่า (ศุกรศรประชาสรรค์)","วัดหัวป่า (รักเมืองไทย 38)","วัดหัวโป่ง มิตรภาพที่ 224","วัดหัวไผ่","วัดหัวฝาย","วัดหัวโพ (หัวโพประศาสน์วิทยา)","วัดหัวโพธิ์","วัดหัวเมือง","วัดหัวยาง (รัฐราษฎร์นุเคราะห์)","วัดหัววัง (เรืองประชา)","วัดหัวว่าว","วัดหัวเวียง ","วัดหัวสวน (ละม่อมประชาสรรค์)","วัดหัวสะแกตก","วัดหัวสะพาน","วัดหัวสำโรง","วัดหัวหมอน","วัดหัวหว้า","วัดหัวหิน","วัดหัวหิน (ล้นพิบูลย์ประชาสรรค์)","วัดหัวอิฐ","วัดหางแขยง (สถิตราษฎร์บำรุง)","วัดหางตลาด","วัดหางไหล","วัดหาดแตงโมจันทรประเสริฐ","วัดหาดทนง","วัดหาดทราย (เรือนมั่นนิรมิต)","วัดหาดทรายแก้ว","วัดหาดทรายงาม","วัดหาดปู่ด้าย","วัดหาดมูลกระบือ","วัดหาดส้มแป้น","วัดหาดสองแคว (สมบูรณ์วิทยาคาร)","วัดหาดสะแก","วัดหาดสูง","วัดหาดเสลา (ไพศาลศิริราษฎร์อุปถัมภ์)","วัดหาดใหญ่","วัดหาดอาษา","วัดหานโพธิ์","วัดหินเกลี้ยง","วัดหินดาด","วัดหินดาษ","วัดหินมงคล","วัดหินลาด","วัดหุบกระทิง","วัดหุบมะกล่ำ","วัดหุบเมย","วัดหุบรัก (ไพรประชาอุปถัมภ์)","วัดหูกวาง (เปรื่องอุ่นอุทิศ)","วัดหูรอ","วัดหูแร่","วัดเหนือ","วัดเหนือวน","วัดเหมก","วัดเหมสูง","วัดเหมืองกวัก","วัดเหมืองค่า (ประชารัฐอุปถัมภ์)","วัดเหมืองง่า","วัดเหมืองประชาราม","วัดเหล่าขวัญ (จ่างอนุเคราะห์)","วัดเหล่าปงเสือ","วัดแหลม","วัดแหลมกลัด","วัดแหลมเขาจันทร์ (รัฐประชาสามัคคี)","วัดแหลมคาง","วัดแหลมแค","วัดแหลมจองถนน","วัดแหลมเจดีย์","วัดแหลมฉบัง","วัดแหลมดินสอ","วัดแหลมตะลุมพุก","วัดแหลมโตนด","วัดแหลมทอง","วัดแหลมทองธรรมจักร","วัดแหลมบ่อท่อ","วัดแหลมปอ","วัดแหลมไผ่","วัดแหลมไผ่ศรี (รัฐราษฎร์สามัคคี)","วัดแหลมพระธาตุ","วัดแหลมพ้อ","วัดแหลมโพธิ์","วัดแหลมฟ้าผ่า","วัดแหลมมะเกลือ","วัดแหลมมะขาม (กัลป์ยาณกิตติวิทยา) และสาขาบ้านแหลมทองหลาง","วัดแหลมไม้ย้อย","วัดแหลมยาง","วัดแหลมวัง (จันทรมุขประชา)","วัดแหลมหว้า","วัดแหลมหิน","วัดโหละคล้า","วัดโหล๊ะจันกระ","วัดใหญ่","วัดใหญ่ (สามไถผาสุขประเสริฐ)","วัดใหญ่ (นากประสุตประชานุสรณ์)","วัดใหญ่ (บุญเอี่ยมอนุเคราะห์)","วัดใหญ่จอมปราสาท","วัดใหญ่ชัยมงคล (ภาวนารังสี)","วัดใหญ่บ้านบ่อ (บ้านบ่อราษฎร์บํารุง)","วัดใหญ่สว่างอารมณ์ (สโมสรสหมิตรอุทิศ)","วัดใหญ่อ่างทอง (เทียนประชาสรรค์)","วัดใหม่","วัดใหม่ (ประพิตรประชาคาร)","วัดใหม่กวางทอง","วัดใหม่เกตุงาม","วัดใหม่ขุนนวน","วัดใหม่จำปาทอง","วัดใหม่เจริญผล","วัดใหม่ช่องลม","วัดใหม่ดงเจริญ","วัดใหม่ดงสัก","วัดใหม่ต้านทาน","วัดใหม่ทอน","วัดใหม่ทางข้าม","วัดใหม่ท่าโพธิ์","วัดใหม่ท่าศิริ (สุพรรณวิทยาคาร)","วัดใหม่ไทยบำรุง","วัดใหม่นครบาล (น้อยไววนิชกุลสงเคราะห์)","วัดใหม่นพรัตน์","วัดใหม่เนินพยอม","วัดใหม่บางคล้า (อุดมกิจประชาสรรค์)","วัดใหม่บำรุงธรรม","วัดใหม่ปทุมสูตร","วัดใหม่ประชุมชนมิตรภาพที่ 76","วัดใหม่ผดุงเขต","วัดใหม่พงษ์โสภณ","วัดใหม่พรหมสุวรรณ","วัดใหม่พิบูลย์ผล","วัดใหม่เพชรรัตน์","วัดใหม่โพธิ์ทอง","วัดใหม่โพธิ์เย็น","วัดใหม่ภูมิเจริญ","วัดใหม่รัตนเจดีย์","วัดใหม่ราษฎร์ทรงธรรม","วัดใหม่ราษฎร์บำรุง","วัดใหม่ราษฎร์บำรุงเจริญธรรม","วัดใหม่ราษฎร์ศรัทธาราม","วัดใหม่ลำนกแขวก","วัดใหม่วงเดือน","วัดใหม่วังหว้า","วัดใหม่ศรัทธาราษฎร์","วัดใหม่สรรคบุรีวิทยา (สำนักงานสลากกินแบ่งรัฐบาล)","วัดใหม่สระพลอย","วัดใหม่สามัคคี","วัดใหม่สามัคคีธรรม","วัดใหม่สำราญ","วัดใหม่สำโรง","วัดใหม่สิทธาวาส","วัดใหม่สี่หมื่น (ยงค์ประชาเรืองวิทยานุกูล)","วัดใหม่สุคนธาราม (ปิ่นรัตนราษฎร์)","วัดใหม่แสงมรกต","วัดใหม่หนองคต (ราษฎร์แต่งตั้ง)","วัดใหม่หนองพะอง (ทับทองวิทยาธาร)","วัดใหม่ห้วยลึก (บุญญานุสาสน์ประชาสรรค์)","วัดองครักษ์","วัดอดิศร","วัดอนุกุญชราราม","วัดอบทม","วัดอภยาราม","วัดอมรญาติสมาคม (อมรวิทยาคาร)","วัดอมรประสิทธิ์","วัดอมรวดี (อมรวิทยาคาร)","วัดอมรินทราราม","วัดอมฤต (สุทธิประสิทธิ์)","วัดอมลอง","วัดอรัญคามวารี","วัดอรัญญวาสี","วัดอรัญญาราม","วัดอรัญญิก","วัดอรัญญิการาม","วัดอรัญญิกาวาส","วัดอรัญญิกาวาส (เจริญธรรมวิทยา)","วัดอรัญญิกาวาสน์","วัดอรัญไพรศรี","วัดอรัญวาสิการาม","วัดอริยวงศาราม (หนองน้ำขาว)","วัดอรุณรังษี","วัดอรุณรัตนคีรี","วัดอ้อมน้อย (มิตรครูราษฎร์รังสรรค์)","เทศบาล 2 วัดอ้อมใหญ่ (นครราษฎร์วิทยาคาร)","วัดอ้ออีเขียว (รัฐราษฎร์มิตรผลอนุกูล)","วัดอัฒฑศาสนาราม","วัดอัมพร (คุรุราษฎร์รังสรรค์)","วัดอัมพวนาราม","วัดอัมพวนาราม (ดงมะม่วง)","วัดอัมพวนาราม (มิตรภาพที่ 89)","วัดอัมพวัน","วัดอัมพวัน (ประชาชนูทิศ)","วัดอัมพวัน (ทองโสภณวิทยาคาร)","วัดอัมพวา (วัฒนราษฎร์อุปถัมภ์)","วัดอัมพาราม","วัดอัมพาวาส","วัดอัมภาราม (เทิ่งอนุสรณ์)","วัดอัยยิการาม","วัดอ่างทอง","วัดอ่างทอง (อ่างทองพิทยาคาร)","วัดอารีทวีวนาราม","วัดอารีราษฎร์","วัดอ่าวช้างไล่","วัดอ่าวบัว","วัดอ่าวใหญ่","วัดอาวุธวิกสิตาราม","วัดอินกัลยา","วัดอินจำปา (มงคลคุรุราษฎร์)","วัดอินทการาม","วัดอินทนิน","วัดอินทบูรพา","วัดอินทร์","วัดอินทร์ไตรย์","วัดอินทร์ศรัทธาราษฎร์","วัดอินทราพิบูลย์","วัดอินทราวาส","วัดอินทรีย์","วัดอินทอารี (สำนักงานสลากกินแบ่งสงเคราะห์ 289)","วัดอินทะวิชัย","วัดอินทาราม","วัดอินทาราม (คำเทศวิทยาคาร)","วัดอินทาราม (พิชัญวิทยาคาร)","วัดอินทาราม ","วัดอินทาราม (สงค์วอนอุทิศ)","วัดอินทาราม (เสนาณรงค์อุปถัมภ์3)","วัดอิมอญ","วัดอิมั้ง (พานิชราษฎร์อุทิศ)","วัดอิสาณ","วัดอุตมิงค์ (จันทสิริราษฎร์รังสรรค์)","วัดอุทการาม","วัดอุทยาราม","วัดอุทัย (เชาวนวิทยา)","วัดอุทุมพราราม","วัดอุบลวนาราม","วัดอุบลวรรณา (นิ่มพิณมุขประชานุกูล)","วัดอุเบกขาราม","วัดอุโปสถาราม","วัดอุเม็ง","วัดอุโลม (วิสูตรอนุสรณ์)","วัดอู่แก้ว","วัดอู่ข้าว","วัดอู่ตะเภา","วัดอู่ตะเภา (สถิตราษฎร์นุกูล)","วัดอู่ยา","วัดเอกราช","วัดเอนกดิษฐาราม","วัดเอี่ยมประดิษฐ์","วัดโอ่ (ปิปผลิกประชาสรรค์)","วัดฮ่องกอก","อนุบาลบ้านแพ้ว (วันครู 2500)","วันครู 2502","วันครู 2503 (บ้านหนองบัว)","วันครู 2504","วันครู (2504)","วันเจริญสามัคคี","วันมหาราช (ผาณิตพิเชฐวงศ์)","วันอาสาพัฒนา 2520","วัลลภานุสรณ์","วานิชวิทยา","วาริชภูมิพิทยาคาร","วิชากร","วิชิตสงคราม","วิชูทิศ","วิเชียรชม","วิเชียรประชาสรรค์","วิฑูรย์ประชารักษ์","วิทยสัมพันธ์","วิทยานนท์","วิทยาประชาคม","วิทยาราษฎร์นุกูล","วิทยาศึกษา","วิริยะเธียรวิทยา","วิรุณเทพ","วิเวกธรรมประสิทธิ์วิทยา","วุฒิชัยวิทยา","วุฒิศักดิ์คุรุราษฏร์อุปถัมภ์","เวตวันวิทยา","เวทีราษฎร์บำรุง","เวฬุวันวิทยา","เวียงเชียงรุ้งวิทยา","เวียงตาลพิทยาคม","เวียงวงกตพิทยาคม","เวียงเศรษฐีวิทยา","แวงน้อยศึกษา","แวงใหญ่วิทยาคม","อุ่นไอรัก เชียงใหม่","ศรีกุดหว้าเรืองเวทย์","ศรีแก้งคร้อ","ศรีแก้วพิทยา","ศรีโกสุมวิทยามิตรภาพที่ 209","ศรีคีรีมาศวิทยา","ศรีคูณวิทยบัลลังก์","ศรีชลสินธุ์","ศรีฐานกระจายศึกษา","ศรีณรงค์พิทยาลัย","ศรีตระกูลวิทยา","ศรีถ้อยสุนทรราษฎร์วิทยา","ศรีเทพประชาสรรค์","ศรีธรรมราชศึกษา","ศรีธวัชวิทยาลัย","ศรีนครมูลนิธิ","ศรีนคร","ศรีนครินทร์วิทยานุเคราะห์","ศรีนาชื่น","ศรีเนห์รู","ศรีบางไทร","ศรีบุญเรืองวิทยาคาร","ศรีประสิทธิ์วิทยา","ศรีไผทสมันต์","ศรีพัฒนาราม","ศรีพูลราษฎร์สามัคคี","ศรีโพนทองวิทยา","ศรีภิรมย์พิทยา","ศรีมหาโพธิ์ (ประชาสรรค์)","ศรีเมืองแอม","ศรีลังกาวิทยา","บ้านศรีลานนา","ศรีวิทยา","ศรีเวียงสาวิทยาคาร","ศรีสมบูรณ์วิทยา","ศรีสระวงศ์","ศรีสวัสดิ์","ศรีสว่างวงศ์","ศรีสว่างสามัคคี","ศรีสองรักษ์วิทยา","ศรีสุขวิทยา","ศรีเสลี่ยมวิทยา","ศรีอุทัยธรรมพัฒนา","ศรีอุทิศ","ศรีเอี่ยมอนุสรณ์","ศาลจ้าวอาม้า","ศาลเจ้า (ห้าวนุกูลวิทยา)","ศาลแม่อากาศ (โรจน์มณี)","อนุบาลศาลาแดง","ศาลาพัน","ศาลาลอย","ศาลาวิทยา","ศาลาสามัคคี","ศิริบ้านไร่","ศิริพงศ์วิทยา","ศิริเพ็ญ","ศิริมังคลาจารย์","ศิริราษฎร์พัฒนา","ศิริราษฎร์วิทยา","ศิริราษฎร์วิทยาคาร","ศิริราษฎร์สามัคคี","ศิลปศาสตร์วิทยา","ศีลรวี","ศิลาทองพิทยาสรรค์","ศิลาโป่งคำ","ศิษย์เก่าพยาบาลศิริราชบ้านดง","ศิษย์เก่าวังหลังวัฒนา (บ้านโคกสะอาด)","ศึกษาเกษตรศิลป์","ศึกษากุลบุตร","ศึกษานารี","ศึกษานารีอนุสรณ์ 1 บ้านแม่เมืองน้อย","ศึกษานารีอนุสรณ์ 2 บ้านแม่สลัก","ศึกษาประชาคม","โสตศึกษาจังหวัดกาญจนบุรี (ศึกษาพิเศษกาญจนบุรี)","ศรีสังวาลย์ขอนแก่น","นครศรีธรรมราชปัญญานุกูล (ศึกษาพิเศษนครศรีธรรมราช)","นครสวรรค์ปัญญานุกูล","ศึกษาลัย","ศึกษาศาสตร์","ศึกษาสงเคราะห์เชียงใหม่","ราชประชานุเคราะห์ 47","ราชประชานุเคราะห์ 57","ศุภวรรณ","ศูนย์การบินทหารบกอุปถัมภ์","ศูนย์ปางมะผ้า ในโครงการตามพระราชดำริ","บ้านน้อยห้วยรินวิทยา","บ้านแปลง 2","ศูนย์อพยพแปลง 8","เศรษฐพานิชวิทยา"," ส.ไทยเสรีอุตสาหกรรม 2"," ส.ไทยเสรีอุตสาหกรรม 3","สกลนคร (วันครู2501)","สกัด 40 (กิตตินาคประชานุกูล)","สกัด 80","สกัดนาควิทยา","สกาดพัฒนา","สกุลดีประชาสรรค์","สกุลศึกษา","สงเปลือยวิทยายน","สงยางสงเปลือยวิทยาคม","สง่าพัฒนา","สง่ารวมราษฎร์","สตรีจุลนาค","สตรีพังงา","สตรีวรนาถบางเขน","สตรีวิทยาอุปถัมภ์ 2","สตรีศรีบำรุง","สตรีศึกษา 2","สตรีสมุทรปราการ","สถาพรศึกษา","สนธิราษฎร์บำรุง","สนมศึกษาคาร","สนวนโคกเม็ก","สนามบิน","สบต๋ำวิทยา (แปงภักดีอุปถัมภ์)","สบเปิงวิทยา","สบมายสามัคคีวิทยา","สบเมาะวิทยา","สมเด็จเจ้าพะโคะ","สมเด็จประชานุเคราะห์","สมเด็จพระปิยมหาราชรมณียเขต","สมเด็จพระราชชนนี (บ้านแก่งเรือง)","สมเด็จพระศรีนครินทราบรมราชชนนี84พรรษา","สมเด็จหลวงพ่อทวดวัดช้างให้","สมนึกวิทิศวรการ","สมบูรณ์ประชาสรรค์","สมบูรณ์วัฒนา","สมบูรณ์ศาสตร์พัฒนา","ส้มป่อยพิทยาคม","สมพงษ์วิทยา","สมฤดีสมุทรสาคร","สมสรร","สมสะอาดดงมุขวิทยา","สมสะอาดพิทยาสรรพ์","สมสะอาดสวนฝ้าย","สมอคอนวิทยาคาร","สมาคมจักรยานสมัครเล่น","สมาคมไทย-ออสเตรเลียน","สมาคมนักเรียนเก่าราชินี","สมาคมป่าไม้แห่งประเทศไทยอุทิศ","สมาคมพยาบาลไทย","สมาคมเลขานุการสตรี 1","สมาคมเลขานุการสตรี 2","สมาคมเลขานุการสตรี 3","สมาคมไลออนส์ (บ้านอ่างศิลา)","สมาคมสื่อมวลชนกีฬาสมัครเล่นและดารา","สมานมิตรวิทยา","สมุทรมณีรัตน์","สยามกลการ 3","สยามกลการ 4 (บ้านนาซิ่ง)","สรรเพชญอัฏฐมาพิทยาคม","สระกำแพงวิทยาคม","สระแก้วโคกกลาง","สระแก้วราษฎร์บำรุง","สระแก้ววิทยานุกูล","สระขุดดงสำราญวิทยา","สระไข่น้ำขุนีวิทยา","สระใครไชยานุเคราะห์","สระงาม","สระน้ำใสวิทยา","สระปทุม","สระประดู่","สระพระขมาดไพร","สระโพนทอง","สระยายชีมิตรภาพที่ 79","สระวิทยา","สร้างแก้วรัฐราษฎร์บำรุง","สร้างมิ่งประสิทธิ์ผล","สรีพรรณสันติภาพนาฝาย","สฤษดิเดช","สลากกินแบ่งสงเคราะห์ 134","สวนป่าเขาชะอางค์","สวนป่าคลองตาเพชรบน","สวนป่าประชาอุปถัมภ์","สวนป่าแม่กะสี","สวนป่าแม่กะสี สาขาปางสัก","สวนป่าองค์พระ","สวนป่าอุปถัมภ์","สวนหม่อน","สวนหมากสงเคราะห์","สวนหลวงสาธิตสำนักงานการประถมศึกษาจังหวัดอุตรดิตถ์","สวนอักษร","สวัสดี","สว่างกิจวิทยา","สว่างวัฒนา","สว่างวิทย์","สว่างวิทยา","สว่างศรัทธาธรรมสถาน","สว่างศรีโคกคึม","สว่างศิริพัฒนา","สว่างอารมณ์วิทยาคม","สวายวิทยาคาร","สหกรณ์กสิกรรมชายทะเล","สหกรณ์ดำริ","สหกรณ์นิคม","สหกรณ์นิคมกสิกรรมทุ่งสง","สหกรณ์นิคมเกลือ","สหกรณ์นิคมบ้านคลองปลาดุกลาย","สหกรณ์นิคมอ่าวลึก 1","สหกรณ์นิคมอ่าวลึก 2","สหกรณ์นิคมอ่าวลึก 3","สหกรณ์นิคมอุปถัมภ์","สหกรณ์บำรุงวิทย์","สหกรณ์ประชานุกูล","สหกรณ์ประชาอุทิศ","สหคามวิทยาคาร","สหชาติเศรษฐกิจวิทยา","สหธาตุสามัคคี (บำเพ็ญพิทยาคาร)","สหประชาสรร","สหประชาสรรค์","สหภาพแรงงานการไฟฟ้านครหลวง","สหมิตรวิทยา","สหราษฎร์นุเคราะห์","สหราษฎร์บํารุง","สหราษฎร์บำรุง","สหราษฎร์รังสฤษดิ์","สหราษฎร์วิทยา","สหราษฎร์วิทยานุสรณ์","สหราษฎร์อนุกูล","สหวิทย์","สหวิทยาคม","สหสามัคคีวิทยา","สหะพาณิชย์ แผนกสามัญ","สหัสขันธ์วิทยาคม","สหัสหงษ์มหาคุณ","สองพี่น้อง (สายปัญญาสมาคมในพระบรมราชินูปถัมภ์)","สองพี่น้องวิทยา","ส่องแสงวิทยา","สองห้องประชาบำรุง","สองห้องราษฎร์บูรณะ","สองห้องแวงน้อยวิทยา","สอนแก้วว่องไววิทยา","สอนคนตาบอดภาคเหนือในพระบรมราชินูปถัมภ์จังหวัดเชียงใหม่","สอนดี (ประชารัฐอนุสรณ์)","สะแกโดดประชาสรรค์","สะแกโพรงอนุสรณ์","สะแกราชวิทยาคม","สะบ้าย้อย","สะพานที่ 3","สะพานหินวิทยาคม","สะอาดไชยศรี","สะอาดนาดีศิลาวิทย์","สะอาดโนนงามวิทยา","สะอาดประชาสรรพ์","สะอาดสมศรีวิทยา","สักงามประชาสรรค์ (เกษตรศาสตร์อนุสรณ์ 37)","สังข์บุญธรรมราษฎร์นุสรณ์","สังข์อํ่าวิทยา","สังขะวิทยาคม","สังคมพัฒนา","สังฆรักษ์บํารุง","สังวาลย์วิท 2","สังวาลย์วิท 5","สังวาลย์วิท 7","สังวาลย์วิทย์ 1","สังวาลย์วิทย์ 3","สังวาลย์วิทย์ 6","สังวาลย์วิทยา","สัตตปทุมบำรุง","สัตหีบวิทยาคม","สันกำแพง","สันกำแพงคันธาอนุสรณ์","สันติพัฒนา","เซนต์กาเบรียลสันติพัฒนา","สันติวนา","สันติวิทยา","อนุบาลค้อวัง","สันติสุขเจริญราษฎร์","สันทรายหลวง","สันป่าตอง (สุวรรณราษฎร์วิทยาคาร)","สันป่าตึงวิทยาคาร","บ้านสันป่าม่วง","สันป่ายางวิทยาคาร","สันป่าสักวิทยา","สันโป่งวิทยา","สันมหาพนวิทยา","สันมะค่าบกน้อยสามัคคี","สันสลีหลวง-สันนายาว","สัมพันธมิตรวิทยา","สากเหล็กวิทยา","สาธิตเทศบาลบ้านเชตวัน","สามขาพิทยาคม","สามขาราษฎร์บำรุง","สามขาสว่างวิทย์","สามเงาวิทยาคม","สามชัย","สามชัยอุดมวิทย์","มัธยมศึกษาจุฬาภรณ์","สามบ่อวิทยา","สามพรานวิทยา","สามพันตาราษฎร์อุทิศ","สามพานประชาสรรค์","สามเพื่อนพัฒนา","สามมิตร","สามแยกเจ้าพระยา","สามแยกบางคูลัด (จั่นเพชรวิทยาคาร)","สามแยกบ้านเนียง (สิทธิพันธ์อนุกูล)","สามแยกป่าถล่ม","สามวาวิทยา","สามสวนวิทยา","สามเสนวิทยาลัย","สามหมอวิทยา","สามัคคี","สามัคคีคุรุราษฏร์บำรุง","สามัคคีเทพอำนวย","สามัคคีธรรม","สามัคคีธรรมราษฎร์บำรุง","สามัคคีธรรมานุสรณ์","สามัคคีบัวขาว","สามัคคีบำรุง","สามัคคีประชาราษฎร์","สามัคคีประชาสรรค์","สามัคคีพัฒนา","สามัคคีมีชัยวิทยา","สามัคคีรถไฟ","สามัคคีร่วมจิต","สามัคคีราษฎร์บำรุง","สามัคคีราษฎร์รังสรรค์","สามัคคีวัฒนา","สามัคคีวิทยา","สามัคคีวิทยา (เชื้อผู้ดีอุปถัมภ์)","สามัคคีวิทยา (สหกรณ์อุปถัมภ์)","สามัคคีวิทยาคม","สามัคคีวิทยาคม 2","สามัคคีวิทยาคาร","เทศบาล 3 สามัคคีวิทยาคาร","สามัคคีศรีวิชัย","สามัคคีศึกษา","สามัคคีสกุลอรุณวิทยา","สามัคคีสันม่วง","สามัคคีสำราญวิทย์","สามัคคีอนุสรณ์","สามัคยาราม","สายธรรม","สายน้ำทิพย์","สายประสิทธิ์วิทยา","สายปัญญาสมาคม","สายป่าแดงวิทยา","สายมิตรศึกษา","สายสมร","สารภีอุทิศ","สาวะถีพิทยาสรรพ์","สาริกา","สาลิกาวิทยา","สาวแหวิทยา","สาหร่ายวิทยาคม","สำนักขุนเณร (หลวงพ่อเขียนอุทิศ)","สำนักงานสลากกินแบ่งที่ 75","สำนักสงฆ์ศรีวิชัย","สำนักสงฆ์ห้วยเรือ","สำราญ - ประภาศรี","สำราญราษฎร์บำรุง","สำเริงวิทยา","สิงห์คอมพิทยา","สิงห์โคกดงมันเหล่างามวิทยาคม","สิงหฤกษ์ประสิทธิ์","สิงห์สะอาด","สิงห์สามัคคีวิทยา","สิทธิพยากรณ์","สิทธิ์สุนทรบำรุง","สิทธิสุนทรอุทิศ","สินรินทร์วิทยา","สินแร่สยาม","สินสังวาลย์อุทิศ","สิริเกศน้อมเกล้า","สิริแก้วเจริญ","สิริปุณโณ","สิริภัทรวิทยา","สิริมังคลานุสรน์","สีกัน (วัฒนานันท์อุปถัมภ์)","สีกายวิทยาคม","สีดาประชาสรรค์","สี่แยกเขาดิน","สี่แยกบางเตย","สี่แยกศรีอรัญวิทยา","สีวะรา","สีออศิลปศาสตร์","สุขเนตร","สุขพรหมมีศรัทธาญาติ","อนุบาลสุขสวัสดิ์","สุขานารี","สุขานารี 2 (หนองขอน)","สุโขทัย","สุคิริน","สุตะโชติประชาสรรค์","สุทธสิริโสภา","สุธรรมเจริญมิตรภาพที่ 130","สุนทรภู่พิทยา","สุนทรวัฒนา","สุนทรวิจิตร","สุนทราภิบาล","สุพรรณภูมิ","สุภวิทย์","สุภาคมศึกษา","สุมเส้าวิทยา","สุรินทร์ภักดี","อนุบาลสุริยาอุทัยพิมาย","สุลักขณะ","สุวพรรณสนิทวงศ์พิทยา","อนุบาลสุวรรณคูหา","สุวรรณไพบูลย์","สุวรรณวงศ์","สุวรรณาคารสงเคราะห์","สุวิทย์เสรีอนุสรณ์","สุเหร่าเกาะไร่","สุเหร่าเขียว","สุเหร่าคลอง 14 (น้ำรักษ์ประชาสรรค์)","สุเหร่าคลอง 15","สุเหร่าคลอง 18","สุเหร่าคลอง 19","สุเหร่าคลอง 20 (เลาะหมุดหวังประชานุกูล)","สุเหร่าคลองหกวา (ทิพยราษฎร์)","สุเหร่าคลองใหญ่ (อนุกูลศึกษา)","สุเหร่าคลองใหม่","สุเหร่าคู้","สุเหร่าแคราย","สุเหร่าจรเข้น้อย","สุเหร่าซีรอ","สุเหร่าดอนกลาง","สุเหร่าดอนเกาะกา (เกาะกาประชาสรรค์)","สุเหร่าดารุลนาอีม","สุเหร่าทรายกองดิน","สุเหร่าบางกะสี","สุเหร่าบางปลา","สุเหร่าบ้านไร่","สุเหร่าปากคลอง 20","สุเหร่าปากคลองลำรี","สุเหร่าลากค้อน","สุเหร่าลาดน้ำขาว (เปร็งประชาสรรค์)","สุเหร่าลำแขก","สุเหร่าลำชะล่า (ลำชะล่าประชาสรรค์)","สุเหร่าสมอเซ","สุเหร่าสมอเอก (ธนาคารกรุงเทพฯ 15)","สุเหร่าแสนแสบ","สุเหร่าหลวงแพ่ง","สุเหร่าหัวหมากน้อย","สุเหร่าใหม่เจริญ","สุเหร่าใหม่ปากคลอง 17","สูงเนินวิทยาคม","สูงเม่นวิทยาคาร","เสกวิทยาคม","เสด็จวนชยางค์กูลวิทยา","เสนพงศ์","เสนศิริอนุสรณ์","เสนางคนิคม","เสนาณรงค์วิทยา (กองทัพบกอุปถัมภ์)","เสนานิคม","เสนานุเคราะห์","เสนารัฐวิทยาคาร","เสมาสามัคคี","เสมาอุปถัมภ์","เสริมขวาวิทยา","เสริมงามวิทยาคม","เสริมปัญญา","เสริมเสาเล้าวิทยา","เสรี-สมใจ","เสลภูมิสามัคคี","เสสะเวชวิทยา","เสาวนิต (บ้านวังแฮ)","แสงทองสมบูรณ์วิทยา","แสงบัวทอง","แสงประทีปรัฐบำรุง","แสงประเสริฐ","แสนจําหน่ายวิทยา","แสนชื่นปานนุกูล","แสนทองวิทยา","ชลกันยานุกูล แสนสุข","แสมขาววิทยาคาร","แสลมวิทยา","โสกตลับราษฎร์อุทิศ","โสกเต็นวิทยาคม","โสกห้างศึกษา และบ้านหนองโน","โสตทัศนศึกษาจุฬาลงกรณ์มหาวิทยาลัย","โสตศึกษาจังหวัดขอนแก่น","โสตศึกษาจังหวัดนครศรีธรรมราช","โสภณประชาเทวารุทธารักษ์","โสภณวรวัฒน์วิทยา","โสภโณประชาสรรค์","โสภาพพิทยาภรณ์","หกสิบพรรษาวิทยาคม อุบลราชธานี","หงษ์หยกบำรุง","หงสประภาสประสิทธิ์","หน่อคำประชานุเคราะห์","หนองกกสามัคคี","หนองกรดวิทยา","หนองกระแหล่งกระเดาวิทยา","หนองกราดวัฒนา","หนองกลาย (ราษฎร์อุทิศวิทยา)","หนองกาวคุรุราษฎร์บำรุง","หนองกุงไทยวิทยาคม","หนองกุงจารย์ผางวิทยา","หนองกุงเซินหนองโนพัฒนา","บ้านหนองกุงประชารัฐบำรุง","หนองกุงพิทยาคม","หนองกุงราษฎร์วิทยา","หนองกุงวังแสง","หนองกุงวันชาติ","หนองกุงวิทยาคม","หนองกุงศรีวิทยาคม","หนองกุงสมเด็จ","หนองกุงห้วยเสียววิทยา","หนองแกสระแก้ววิทยา","หนองขามวิทยา","หนองขามวิทยาคาร","หนองขาหย่างวิทยา","หนองแขมประชาสรรค์","หนองแข้วิทยา","หนองคอนเตรียมราษฎร์บำรุง","หนองคูโคกขุมดิน","หนองคูวังเดือนห้าวิทยา","หนองแคนวิทยา","หนองงูเห่าศาสตร์ประเสริฐ","หนองจระเข้เรืองศิลป์","หนองจอกพิทยานุสสรณ์มัธยม","หนองฉันเพลฮ่องแซงประชาสรร","หนองช้าง","หนองชาดพิทยาคม","หนองชุมแสงวิทยา","หนองชุมแสงศรัทธาคาร","หนองซนพิทยาคม","หนองซองแมวผดุงวิทย์","หนองแซงวิทยา","หนองแซงวิทยาคม","บ้านหนองด้วงวังประทุม","หนองแดงวิทโยดม","หนองแดงสร้างประทายพัฒนา","หนองตอวิทยา","หนองตากยาตั้งวิริยะราษฎร์บำรุง","หนองตาไก้วิทยากร","หนองตุวิทยา","หนองตูมหนองงูเหลือม","หนองเต่าวิทยา","หนองแต้วรวิทย์","หนองแต้ศึกษาประชาสรรค์","หนองโตง ","หนองทุ่มวิทยา","หนองทุ่มสงเคราะห์","หนองนกเขียนสามัคคี","หนองนาเกลือวิทยา","หนองนาแซงวิทยา","หนองน้ำขุ่น","หนองน้ำใส","หนองโนวิทยา","หนองโนวิทยาคม","หนองโนวิทยาคาร","หนองบัวโดน ","หนองบัวกลาง","หนองบัวคุรุรัฐประชาสรรพ์","หนองบัวโจดดงลิงวิทยา","หนองบัวชุม","หนองบัวทองวิทยาเสริม","หนองบัวนอก","หนองบัวใน","หนองบัวบานเย็นวิทยา","หนองบัวระเหววิทยาคาร","หนองบัวราษฎร์นิยม","หนองบัวราษฎร์บำรุง","หนองบัวรีราษฎร์อุทิศ","หนองบัวลอย","หนองบัววิทยา","หนองบัววิทยายน","หนองบัววิทยาสรรพ์","หนองบัววิทยาเสริม","หนองบัวหน่วยอำนวยวิทย์","หนองบัวคุรุประชาสรรค์","หนองบัวใหญ่ (เขตการทางนครราชสีมาสงเคราะห์ 4)","หนองบ้านเก่าสามัคคี","หนองเบ็นเจริญวิทย์","หนองเบนประภากร","หนองประดู่วิทยา","บ้านหนองปรือแก้ว","หนองปรือแดง (ศิริราษฎร์ปการ)","หนองปรือพิทยาคม","หนองปลาโดผดุงราษฎร์","หนองปลาปากจำปาทอง","หนองปะโอประชาอุทิศ","หนองแปนโนนสูงนาเชือกราษฎร์บำรุง","หนองผักฉีด","บ้านหนองผือดอนม่วง","หนองผือเทพนิมิต","หนองไผ่ผดุงกิจวิทยา","หนองไผ่พรเจริญ","หนองไผ่พิทยาคม","หนองไผ่รัฐบำรุง","หนองไผ่วิทยา","หนองแฝกหนองหว้าวิทยา","หนองพลวงพิทยา","หนองพลวงมิตรประชา","หนองพอกพัฒนาประชานุสรณ์","หนองพอกวิทยายน","หนองโพธิ์ประชานุกูล","หนองโพธิ์วิทยาคม","หนองโพนนาหม่อ","หนองโพนโนนสมบูรณ์","หนองโพนวิทยายน","หนองโพนสูง","หนองฟ้าเลื่อนอำนวยวิทย์","หนองม่วงน้อยนานิคมสามัคคี","หนองม่วงหนองแวง","หนองมะเกลือบำรุงวิทย์","หนองมะเขือซองแมวโคกไม้งามวิทยา","หนองมะค่า","หนองมันปลาวิทยา","หนองเม็กวิทยา","หนองเมยสามัคคี","หนองไม้พลวงวิทยาคม","หนองยอดู่ในวิทยา","หนองรีประชานิมิต","หนองรีมงคลสุขสวัสดิ์","หนองลวกราษฎร์บำรุง","หนองแวงคุรุราษฎร์รังสรรค์","หนองแวงบึงงาม","หนองแวงประชานุกูล","หนองแวงประชาสรรพ์","หนองแวงพิทยาคม","หนองแวงม่วง","หนองแวงเรือประชาศึกษา","หนองแวงวิทยา","หนองแวงวิทยาคม","หนองแวงวิทยานุกูล","หนองแวงแสน","หนองแวงหนองน้อยวิทยาคาร","หนองแวงเหนือ","หนองสนมราษฎร์อำนวย","หนองสระพังวิทยาคาร","หนองสระสำราญราษฎร์","หนองสวงวิทยาคม","หนองสะแกประชานุกูล","หนองสังข์ราษฎร์บำรุง","หนองสำโรงวิทยา","หนองสิมโนนสวรรค์","หนองสูงสามัคคีวิทยา","หนองแสงถวิลราษฎร์","บ้านหนองแสงโนนสมบูรณ์","หนองแสงประชาสรรค์","หนองแสงราษฎร์พัฒนา","หนองแสงวิทยา","หนองแสงวิทยาเสริม","บ้านหนองแสน","หนองโสนวิทยา","หนองใสพรเจริญวิทยา","หนองหญ้าปล้อง","หนองหญ้าปล้อง (กม.78)","หนองหญ้าปล้องโนนสว่าง","หนองหมื่นถ่านวิทยา","หนองหล่มวิทยาคาร","หนองหลวงประชาบำรุง","หนองหลวงวิทยานุกูล","หนองหว้าวิทยา","หนองหอไตรราษฎร์บำรุง","หนองหัวช้าง","หนองห้างฉวีวิทย์","หนองห้างอำนวยวิทย์","หนองหินวิทยาคม","หนองหูลิงเจริญเวทย์","หนองแห่โนนสมบูรณ์","หนองแห้วคุรุราษฎร์บูรณะ","หนองแห้ววังมนศึกษา","หนองใหญ่วิทยา","หนองไหลคึมน้อยวิทยา","หนองอ้อบำเพ็ญ","หนองอ้อวิทยาคม","หนองอารีพิทยา","หนองอิเฒ่าวิทยา","หนองอีบุตรไพรเวทย์","บ้านหนองไฮ (ประชานุกูลวิทยา)","หนองไฮแจ้งบูรณวิทยา","หนองไฮประชารัฐ","หนองไฮภูเขาทอง","หนองไฮวิทยา","หน้าพระลาน (พิบูลสงเคราะห์)","หน้าศูนย์เครื่องมือกล","หมอนสูงประชาสรรค์","หม่อมเจ้าเจริญใจ จิตรพงศ์","หมู่บ้านตัวอย่าง","หมู่บ้านตัวอย่าง (ป่าดงหินกอง)","หมู่บ้านทับทิมสยาม 07","หมู่บ้านป่าไม้","บ้านป่าไม้โนนสวรรค์","หมู่บ้านป่าไม้ซับลังกา","หมู่บ้านป่าไม้พระราชประสงค์ 1","หมู่บ้านป่าไม้ห้วยจันทน์","หมู่บ้านเศรษฐกิจ (พุ่มประดับราษฎร์สามัคคี)","หมู่บ้านสหกรณ์ 2","โป่งน้ำร้อนวิทยา","หมู่สี่พัฒนา","หมู่ห้าสามัคคี","หรเทพ (รุ่งเรืองประชาสามัคคี)","หรรษาสุจิตต์วิทยา","หลวงพ่อแช่มวัดตาก้องอนุสรณ์","หลวงพ่อแช่มอุปถัมภ์","หลวงพัฒนาบ้านขุนวาง","หลวงแพทย์โกศลอุปถัมภ์","หลวงสินธุ์ราษฎร์รังสฤษฎ์","หลักด่านวิทยา","หลักเมืองกมลาไสย","หลักเมืองมหาสารคาม","หลุงกัง","ห้วยแก้ววิทยา","ห้วยซ้อวิทยาคม รัชมังคลาภิเษก","ห้วยขี้นกวิทยา","ห้วยคตพิทยาคม","ห้วยซวกคกเลาใต้","ห้วยต้อนพิทยาคม","ห้วยต้อนวิทยา","ห้วยตาเปอะ","ห้วยตูมวิทยาคาร","ห้วยเตยวิทยา","ห้วยทรายวิทยา","ห้วยทรายวิทยาคม","ห้วยทับทันวิทยาคม","ห้วยบงวิทยา","ห้วยปลาใยผดุงวิทยา","ห้วยปลาไหล","ห้วยผึ้งพิทยา","ห้วยพลู","ห้วยพลูพิทยา","ห้วยพุกวิทยา","ห้วยมะทอโคกล่ามวิทยา","ห้วยเม็กราษฎร์นุกูล","ห้วยเม็กวิทยาคม","ห้วยยอด (กลึงวิทยาคาร)","ห้วยยางดงวิทยา","ห้วยยางวิทยาสรรพ์","ห้วยยางศึกษา","ห้วยไร่วิทยานุกูล","ห้วยไร่หาดทรายมูล","ห้วยลึกผดุงวิทยา","ห้วยวารีใต้","ห้วยหว้าวิทยาคม","ห้วยหินลาด","ห้วยใหญ่","ห้วยไหวัฒนา","หวลถวิลวิทยา","หว่านท่าสมอวิทยา","หว้านไพรสามัคคี","หอคำพิทยาสรรค์","ห้องแซงวิทยาคม","หัดไทยวิทยาอุทิศ","หัวขวาวิทยา","หัวเขาแก้ว","หัวเขาราษฎร์บำรุง","หัวคูประชาอุทิศ","หัวงัววิทยาคม","หัวงัววิทยาคาร","หัวซาวิทยา","หัวดงวิทยา","หัวไทร(เรือนประชาบาล)","หัวนาคำจรูญศิลป์","หัวนางามวิทยา","หัวนานคร","หัวนาศึกษาวิทย์","หัวฝายวิทยาคาร","หัวสระวิทยา","หัวห้วยหัวฝาย","หัวหาดวิทยา","หัวหินราษฎร์บำรุง","ห้างฉัตรวิทยา","หาญใจพิทยาคม","หาดคำบอนวัฒนา","หาดเจ้าสำราญ (พรหมานุกูล)","หาดทรายทอง","หาดทรายทองวิทยาคาร","หาดปากเมง","หาดสนุกราษฏร์บำรุง","หาดสำราญ","หาดเสี้ยววิทยา","หาดใหญ่พิทยาคม","หามแหโพนทองวิทยาคม","หินกอง (พิบูลอนุสรณ์)","หินกองวิทยา","หินโงมวิทยา","หินตั้งพิทยากร","หินฝนวิทยาคม","หินลาดนารายณ์สาร","หินฮาวคุรุประชาสรรค์","หิรัญพงษ์อนุสรณ์","เหมืองควนกรด","เหมือดแอ่หนองบัว","เหล่ากลางร่วมวงศ์วิทยา","เหล่าขุมมันท่าสะอาด","เหล่าเขืองโนนเสียววิทยา","เหล่าประชาอุทิศ","เหล่าฝ้ายผดุงวิทย์","เหล่าสูงวิทยา","เหล่าหลวงวิทยาคาร","เหล่าใหญ่วนาสณฑ์ผดุงเวทย์","เหล่าใหญ่วิทยา","เหล่าอ้อยบำรุงวิทย์","เหล่าไฮงามวิทยาสูง","แหลมทองผดุงวิทย์","แหลมทองวิทยานุสรณ์","แหลมทองอุปถัมภ์","แหลมนกแก้ว","แหลมพันวา","แหลมรวกบำรุง","ไหล่หินวิทยา"," อ.ฮ.ลิงค์ (ในพระอุปถัมภ์สมเด็จพระศรีนครินทร์) และ อ.ฮ.ลิงค์ สาขาบ้านท่าลิงลม","องค์การสวนยาง 1","องค์การสวนยาง 2","องค์การสวนยาง 3","องค์การอุตสาหกรรมป่าไม้ 17","องค์การอุตสาหกรรมป่าไม้ 18","องค์การอุตสาหกรรมป่าไม้ 2","องค์การอุตสาหกรรมป่าไม้ 7 (สวนป่าสมเด็จ)","องค์การอุตสาหกรรมป่าไม้ 9","องค์การอุตสาหกรรมป่าไม้ 6","อดุลวิหารกิจ(คุรุราษฎร์วิทยา)","อนุบรรพต","อนุบาลกงไกรลาศ","อนุบาลกงหรา","อนุบาลกบินทร์บุรี","อนุบาลกระบี่","อนุบาลกระสัง","อนุบาลกันทรวิชัย","อนุบาลกันทรารมย์","อนุบาลกาญจนบุรี","อนุบาลกาฬสินธุ์","อนุบาลกำแพงเพชร","อนุบาลกุมภวาปี","อนุบาลกุยบุรี(วัดวังยาว)","อนุบาลกุสุมาลย์","อนุบาลกู่แก้ว","อนุบาลเก้าเลี้ยว (วัดเก้าเลี้ยว)","อนุบาลเกาะคา (น้ำตาลอนุเคราะห์)","อนุบาลเกาะจันทน์","อนุบาลเกาะช้าง","อนุบาลโกรกพระ (ประชาชนูทิศ)","อนุบาลโกสัมพีนคร (บ้านท่าคูณ)","อนุบาลขอนแก่น","หนองไผ่มอดินแดง","อนุบาลขาณุวรลักษบุรี","อนุบาลขามสะแกแสง (คีรีรัฐประชานุเคราะห์)","อนุบาลขุนตาล (ป่าตาลเจดีย์)","อนุบาลขุนยวม","อนุบาลขุนหาญ (สิ)","อนุบาลเขาค้อ (เจริญทองนิ่มวิทยา)","อนุบาลเขาฉกรรจ์","อนุบาลเขาชัยสน","อนุบาลคลองขลุง","อนุบาลคลองลาน","อนุบาลคลองหาด สาขาบ้านใหม่ไทย","อนุบาลควนกาหลง","อนุบาลควนโดน","อนุบาลค่ายบางระจัน","อนุบาลคีรีมาศ (วัดบึง)","อนุบาลคูเมือง","อนุบาลแคนดง","อนุบาลโคกเจริญ","อนุบาลโคกศรีสุพรรณ","อนุบาลโคกใหม่ละหานทราย","อนุบาลงาว (ภาณุนิยม)","สักสันเชียงใหม่วิทยาคม","อนุบาลจอมบึง","อนุบาลจอมสวรรค์ (บ้านบ่อก๊าง)","อนุบาลจอมหมอกแก้ว","อนุบาลจังหวัดทหารบกลพบุรี","อนุบาลจันจว้าใต้(บ้านกิ่วพร้าว)","อนุบาลจันทบุรี","อนุบาลจุน (บ้านบัวสถาน)","อนุบาลจุมพลโพนพิสัย","อนุบาลแจ้ห่ม","อนุบาลเฉลิมพระเกียรติจังหวัดบุรีรัมย์","อนุบาลชนแดน","อนุบาลชลบุรี","อนุบาลชัยนาท","อนุบาลชัยภูมิ","อนุบาลชานุมาน","อนุบาลชำนิ","บ้านน้ำโสมประชาสรรค์ (ถิรธัมโมอุปถัมภ์)","อนุบาลชุมชนวัดหนองบัว (รัตนวงศ์ราษฎร์บำรุง)","อนุบาลชุมตาบง","อนุบาลชุมพร","อนุบาลชุมแสง (วัดทับกฤชกลาง)","อนุบาลเชียงของ","อนุบาลเชียงคำ (วัดพระธาตุสบแวน)","อนุบาลเชียงม่วน","อนุบาลเชียงราย","อนุบาลเชียงแสน (ปางหมอปวงชัยบานราษฎร์ศึกษา)","อนุบาลเชียงใหม่","อนุบาลโชคชัย (บ้านแม่เลียบแม่บง)","อนุบาลไชยวาน","อนุบาลวัดสระเกษ (หลวงพ่อโต๊ะอุปถัมภ์)","อนุบาลเซกา","อนุบาลโซ่พิสัย","อนุบาลดงมหาวัน","อนุบาลดอกคำใต้ (ชุมชนสันช้างหิน) ","อนุบาลดอนไผ่","อนุบาลดอนพุด (พิพัฒน์ดวงราษฎร์บำรุง)","อนุบาลดอยหลวง","อนุบาลด่านช้าง","อนุบาลดำเนินสะดวก (วัดโคกบำรุงราษฎร์ รตนลาโภประชาสรรค์)","อนุบาลตรัง","อนุบาลตราด","อนุบาลตลาดแค","อนุบาลตับเต่า(ไคร้สามัคคีวิทยา)","อนุบาลตาก","อนุบาลตากฟ้า","อนุบาลตาคลี (ทหารอากาศบำรุง)","อนุบาลตาดควัน","อนุบาลตาพระยา","อนุบาลเต่างอย","อนุบาลเถิน (ท่านางอุปถัมภ์)","อนุบาลทรายทองวัฒนา","อนุบาลทองผาภูมิ","อนุบาลทับกวาง","อนุบาลทับสะแก","อนุบาลทัพทัน (อุดมพิทยา)","ขุนขวากพิทยา","บ้านแม่หะป่าไร่ศรียางชุม","อนุบาลท่าช้าง","อนุบาลท่าแซะ","อนุบาลท่าตะโก","ทานตะวันวิทยา (ห้วยบง-ดงเจริญ)","อนุบาลท่าปลา (ชุมชนร่วมจิต)","อนุบาลท่าแพ","อนุบาลท่ามะกา (วัดลูกแกประชาชนูทิศ)","อนุบาลท่าวุ้ง","อนุบาลท่าหลวง","อนุบาลทุ่งฝน","อนุบาลทุ่งเสลี่ยม (บ้านเหมืองนา)","อนุบาลทุ่งหว้า","อนุบาลเทพสถิต","อนุบาลเทศบาลเมืองนครพนม (ยงใจยุทธ)","เวียงเทิง (เทิงทำนุประชา)","อนุบาลไทยรัฐวิทยา 5 (วัดตลิ่งต่ำ)","อนุบาลไทรงาม สาขาหนองไม้แดง","อนุบาลไทรโยค","อนุบาลธรรมศิริวิทยาคาร","อนุบาลนครนายก","อนุบาลนครปฐม","อนุบาลนครพนม","อนุบาลนครราชสีมา","อนุบาลนครศรีธรรมราช","อนุบาลนครสวรรค์","อนุบาลนนทบุรี","อนุบาลนราธิวาส","อนุบาลนางรอง (สังขกฤษณ์อนุสรณ์)","อนุบาลนางแล (บ้านทุ่ง)","อนุบาลนาดี","อนุบาลน้ำหนาว","อนุบาลนิคมเปงจาน","อนุบาลเนินขาม","อนุบาลโนนคูณ (โนนค้อวิทยาคาร)","อนุบาลโนนดินแดง","อนุบาลโนนสะอาด","อนุบาลโนนสุวรรณ","อนุบาลบรบือ","อนุบาลบรรพตพิสัย (วัดส้มเสี้ยว)","อนุบาลบ่อทอง","อนุบาลบ่อพลอยราษฎร์รังสรรค์","บัวสลีวิทยา","อนุบาลบางกรวย (วัดศรีประวัติ)","อนุบาลบางคนที (วัดเกาะใหญ่เลี้ยงล้อมอนุกูล)","อนุบาลบางแพ (ชุมชนวัดบางแพใต้ฯ)","อนุบาลบางมูลนาก ","อนุบาลบางระจัน","อนุบาลบางละมุง","อนุบาลบางสะพาน","อนุบาลบางสะพานน้อย","อนุบาลบางใหญ่","อนุบาลบ้านกรวด","อนุบาลบ้านก้องวิทยา","อนุบาลบ้านเขว้า","อนุบาลบ้านคอกช้าง","อนุบาลบ้านคา","อนุบาลบ้านโคก","อนุบาลบ้านด่านลานหอย","อนุบาลบ้านเตาถ่าน","อนุบาลบ้านท่าพระยาจักร","อนุบาลบ้านท่าสะอ้าน","อนุบาลบ้านนา (วัดช้าง)","อนุบาลบ้านเนินสำลี","อนุบาลบ้านบางพระ (ฉิ่งนาวิกอนุสรณ์) ศรีราชา","อนุบาลบ้านบึง (อำนาจคณูปถัมภ์)","บ้านป่าเขว้า","อนุบาลบ้านโป่ง (วัดปลักแรด)","อนุบาลบ้านผือพิทยาภูมิ","อนุบาลบ้านพระเนตร (แก้วสุวรรณประสิทธิ์)","อนุบาลบ้านเพนียด","อนุบาลบ้านเพียมิตรภาพที่ 138","อนุบาลบ้านม่วง","อนุบาลแม่ลาน้อย","อนุบาลบ้านไร่","อนุบาลบ้านสะเดา","อนุบาลบ้านหนองคล้า (จงจินต์ รุจิรวงศ์ อุปถัมภ์2)","อนุบาลบ้านหมอ","อนุบาลบ้านหมี่","อนุบาลบ้านใหม่ไชยพจน์ (ฉลาดราษฎร์บำรุง)","อนุบาลบึงบูรพ์","อนุบาลบึงสามพัน (ซับสมอทอด)","อนุบาลบึงสามัคคี (บ้านทุ่งสนุ่น)","อนุบาลบุรีรัมย์","อนุบาลเบญจลักษ์","อนุบาลปง","อนุบาลปทุมธานี","อนุบาลปทุมราชวงศา","อนุบาลประโคนชัย (อำนวยกิจราษฎร์วิทยาคาร)","อนุบาลประจวบคีรีขันธ์","อนุบาลประจักษ์ศิลปาคม","อนุบาลประจันตคาม","อนุบาลปรางค์กู่","อนุบาลปราจีนบุรี","อนุบาลปราณบุรี (บ้านเมืองเก่า)","บ้านปล้องตลาด","อนุบาลปะคำ","อนุบาลปะทิว (บางสนพิพิธราษฏร์บำรุง)","อนุบาลปัตตานี","อนุบาลปากคาด","อนุบาลปากท่อ","อนุบาลปากพะยูน","อนุบาลปางมะผ้า","อนุบาลปางศิลาทอง","ป่างิ้ววิทยา","บ้านป่าซาง (ซางดรุณานุสาสน์)","เทศบาล 1 (ป่าแดด)","ป่าติ้วร่มโพธาภินันท์นุกูล","บ้านป่าบงแม่จัน","อนุบาลป่าบอน","อนุบาลป่าพะยอม","อนุบาลป่าโมก (วัดโบสถ์สายทอง)","อนุบาลปาย (เวียงใต้)","โป่งแพร่วิทยา","บ้านทุ่งเจ้า","อนุบาลพนมทวน (วัดรางหวาย)","อนุบาลพนัสศึกษาลัย","อนุบาลพนา (อุดมวิทยากร)","อนุบาลพยัคฆภูมิพิสัย","อนุบาลพยุห์","อนุบาลพยุหะคีรี (วัดพระปรางค์เหลือง)","อนุบาลพรเจริญ","อนุบาลพรประดิษฐ์","อนุบาลพรรณานิคม","อนุบาลพรหมบุรี (วัดกุฎีทอง)","อนุบาลพระนครศรีอยุธยา","อนุบาลพระบรมราชานุสรณ์ดอนเจดีย์","อนุบาลพรานกระต่าย","อนุบาลพะโต๊ะ","อนุบาลพะเยา","อนุบาลพังงา","อนุบาลพัฒนานิคม","อนุบาลพัทลุง","อนุบาลพาน (ป่ากว๋าวมิตรภาพที่ 68)","อนุบาลพานทองวัดหนองกระทุ่ม","อนุบาลพิจิตร","อนุบาลพิบูลย์รักษ์","อนุบาลพิบูลเวศม์","อนุบาลพิษณุโลก","อนุบาลพุทธยาคม (วัดเขาบางทราย)","อนุบาลพุทไธสง (โอกาสประชานุกูล)","อนุบาลเพชรบุรี","อนุบาลเพชรบูรณ์","อนุบาลเพ็ญประชานุกูล","อนุบาลแพร่","อนุบาลโพธาราม (ชุมชนวัดบ้านสิงห์)","อนุบาลโพธิ์ทอง","อนุบาลโพธิ์ศรีสุวรรณ","อนุบาลโพนทอง","อนุบาลโพนนาแก้ว","อนุบาลไพรบึง","อนุบาลไพโรจน์","อนุบาลไพศาลี (โคกเดื่อประชาสรรค์)","อนุบาลฟากท่า (วัดวังขวัญวันครู 2503)","อนุบาลภูกามยาวและสาขาพระธาตุภูปอ","อนุบาลภูเก็ต","อนุบาลภูซาง (บ้านดอนตัน)","อนุบาลภูเวียง","อนุบาลภูสิงห์","อนุบาลมณีราษฎร์คณาลัย","อนุบาลมโนรมย์","อนุบาลมวกเหล็ก","อนุบาลมหาสารคาม","อนุบาลมะนัง","อนุบาลมุกดาหาร","สันสะลีกวิทยา","อนุบาลเมือง (ท่าหลวงสงเคราะห์)","อนุบาลเมืองกำแพงเพชร (บ้านนครชุม)","อนุบาลเมืองจันทร์ (บ้านปลาซิว)","อนุบาลเมืองชัยนาท","บ้านเมืองชุม","อนุบาลเมืองชุมพร (วัดสุบรรณนิมิตร)","อนุบาลเมืองเชียงราย (สันทรายราษฎร์ดรุณานุเคราะห์)","อนุบาลเมืองนครนายก (ศรีประชานคร)","อนุบาลเมืองนครสวรรค์ (เขากบวิวรณ์สุขวิทยา)","อนุบาลเมืองบุรีรัมย์ (บ้านบัว)","อนุบาลเมืองประจวบคีรีขันธ์ (สละชีพ)","อนุบาลเมืองปราจีนบุรี","อนุบาลเมืองปาน (บ้านทุ่งกว๋าว)","อนุบาลเมืองพะเยาบ้านโทกหวาก","เมืองเพชรบูรณ์","อนุบาลเมืองราชบุรี","อนุบาลเมืองลำปาง (ธงชัยศึกษา)","อนุบาลเมืองสตูล","อนุบาลเมืองสระแก้ว","อนุบาลเมืองสิงห์บุรี","อนุบาลเมืองสุโขทัย","อนุบาลเมืองอ่างทอง (วัดท้องคุ้งตั้งตรงจิตร 3)","อนุบาลเมืองอุทัยธานี","อนุบาลแม่ขะจาน","บ้านแม่คำ (ประชานุเคราะห์)","บ้านแม่จัน (เชียงแสนประชานุสาสน์)","อนุบาลแม่ใจ (บ้านศรีถ้อย)","บ้านแม่ต๋ำกลาง","อนุบาลแม่ทะ (ชุมชนบ้านน้ำโท้ง-บ้านฮ่อมอุปถัมภ์)","อนุบาลแม่เปิน (บ้านตลุกตาสาม)","อนุบาลแม่พริก (สุนันทสังฆประสิทธิ์)","อนุบาลแม่ฟ้าหลวง","อนุบาลแม่เมาะ (ชุมชน 1)","บ้านป่ากว๋าว-ดอนชัย","อนุบาลแม่ลาว","อนุบาลแม่วงก์ (บ้านมฤคทายวัน)","อนุบาลแม่สรวย","อนุบาลแม่สะเรียง (บ้านโป่ง)","อนุบาลแม่สาย (สายศิลปศาสตร์)","อนุบาลแม่ฮ่องสอน","ห้วยก้างราษฎร์วิทยา","อนุบาลยโสธร","อนุบาลยะลา","อนุบาลยางชุมน้อย (หน่วยคุรุราษฎร์รังสรรค์)","อนุบาลยางฮอม","อนุบาลร้อยเอ็ด","อนุบาลระนอง","อนุบาลระยอง","อนุบาลราชบุรี","อนุบาลราษีไศลท่าโพธิ์มิตรภาพที่ 204","อนุบาลริมกก (บ้านสันต้นเปา)","อนุบาลลพบุรี","อนุบาลละงู","อนุบาลลาดยาว","อนุบาลลานกระบือ","อนุบาลลานสัก","อนุบาลลำนารายณ์","อนุบาลลำปลายมาศ","อนุบาลลำปาง (เขลางค์รัตน์อนุสรณ์)","อนุบาลลำพูน","เทศบาลอำนาจ","อนุบาลลุมพุก (วันครู2503)","อนุบาลเลย","อนุบาลเลิงนกทา","อนุบาลวชิรบารมี (ต้นประดู่)","อนุบาลวังน้ำเย็นมิตรภาพที่ 179","อนุบาลวังโป่ง","อนุบาลวังม่วง","อนุบาลวังสมบูรณ์","อนุบาลวังสามหมอ","อนุบาลวังหิน","อนุบาลวังเหนือ","อนุบาลวัฒนานคร","อนุบาลวัดกลางดอนเมืองชลบุรี","อนุบาลวัดคลองใหญ่","อนุบาลวัดช่องลม","อนุบาลวัดน้ำเชี่ยว","อนุบาลวัดบ้านสร้าง","อนุบาลวัดปรินายก","อนุบาลวัดป่าเลไลยก์","อนุบาลวัดปิตุลาธิราชรังสฤษฎิ์","อนุบาลวัดพระพุทธบาท","อนุบาลวัดเพลง (หรีดศรัทธาประชานุกูล)","อนุบาลเกาะกูด","อนุบาลวัดสระแก้ว","อนุบาลวัดสวนหงส์","อนุบาลวัดสิงห์","อนุบาลวัดหนองขุนชาติ (อุทิศพิทยาคาร)","อนุบาลวัดหนองเต่า สาขาวัดวังปลากด","อนุบาลวัดหนองม่วง","อนุบาลวัดอรัญญิกาวาส","อนุบาลวัดอ่างทอง","อนุบาลวัดอุทยานนที","อนุบาลวัดอู่ตะเภา","อนุบาลวัดในเรืองศรีวิเชียรบุรี","อนุบาลบึงกาฬวิศิษฐ์อำนวยศิลป์","อนุบาลวิหารแดง","อนุบาลทุ่งทรายพัฒนา","เวียงกาหลงวิทยา","อนุบาลเวียงแก่น","อนุบาลเวียงชัย","อนุบาลเวียงเชียงรุ้ง","อนุบาลเวียงป่าเป้า","รงเรียนเวียงห้าววิทยา","อนุบาลศรีค้ำ","อนุบาลศรีเชียงใหม่","ศรีดอนไชยวิทยา","อนุบาลศรีเทพ (สว่างวัฒนา)","อนุบาลศรีนคร (ไทยธัญญานุกูล)","อนุบาลศรีนครินทร์","อนุบาลศรีบรรพต","อนุบาลศรีประจันต์","อนุบาลศรีประชานุกูล","ศรีโพธิ์เงินวิทยา","อนุบาลศรีมหาโพธิ","อนุบาลศรีมโหสถ","อนุบาลศรีรัตนะ","อนุบาลศรีวัฒนาวิทยา","อนุบาลศรีวิไล","อนุบาลศรีสวัสดิ์","อนุบาลศรีสะเกษ","อนุบาลศรีสัชนาลัย (บ้านหาดสูง)","อนุบาลศรีสำโรง","อนุบาลศรีสุทโธ","อนุบาลศรีอรัญโญทัย","อนุบาลศิลาลาด","อนุบาลสกลนคร","อนุบาลสงขลา","อนุบาลสตึก (ประชาอนุสรณ์)","อนุบาลสตูล","ชุมชนสถาน (ราษฎร์ดรุณวิทย์)","อนุบาลสบปราบ","อนุบาลสบเมย (คอนผึ้ง)","อนุบาลสมเด็จพระวันรัต","อนุบาลสมุทรสงคราม","อนุบาลสมุทรสาคร","อนุบาลสรรคบุรี","อนุบาลสรรพยา","อนุบาลสระบุรี","อนุบาลสระโบสถ์","อนุบาลสร้างคอม","อนุบาลสวนผึ้ง","อนุบาลสวรรคโลก (คุ้งวารีวิทยา)","อนุบาลสว่างแดนดิน","อนุบาลสว่างอารมณ์","อนุบาลสวี (บ้านนาโพธิ์)","อนุบาลสังขละบุรี","อนุบาลสังคม","สันทราย (พรหมณีวิทยา)","สันทรายงามวิทยา","บ้านเด่นศาลา","อนุบาลสากเหล็ก","อนุบาลสามโก้ (บ้านลำสนุ่น)","อนุบาลสามง่าม","อนุบาลสามร้อยยอด (บ้านหนองแก)","อนุบาลสามเสนฯ","อนุบาลสาสนสิทธิ์อำนวย","อนุบาลสิงห์บุรี","อนุบาลสีชมพู","อนุบาลสุโขทัย","อนุบาลสุพรรณบุรี","อนุบาลสุราษฎร์ธานี","อนุบาลสุรินทร์","อนุบาลเสนางคนิคม","อนุบาลเสริมงาม","อนุบาลเสาไห้","อนุบาลแสวงหา","อนุบาลหนองกี่","อนุบาลหนองขาหย่าง","อนุบาลหนองคาย","อนุบาลหนองควาย","อนุบาลหนองแค (วัดใหญ่วันนาเนตรสวัสดิ์อุปถัมภ์)","อนุบาลหนองแซงศีลวุฒาจารย์","อนุบาลหนองโดน (สนิทประชากร)","อนุบาลหนองบัว (เทพวิทยาคม)","อนุบาลหนองบัวลำภู","อนุบาลหนองไผ่","อนุบาลหนองมะโมง","หนองแรดวิทยา","อนุบาลหนองวัวซอ","อนุบาลหนองแสง","อนุบาลหนองหงส์","อนุบาลหนองหญ้าไซ (วัดหนองหลวง)","อนุบาลหนองหานวิทยายน","อนุบาลหนองใหญ่ (ศิริวรราษฏร์บำรุง)","อนุบาลหล่มเก่า","อนุบาลหล่มสัก (ชุมชนบ้านศรีสะอาด)","อนุบาลห้วยคต (บ้านชุมทหารวิทยา)","อนุบาลห้วยทับทัน","อนุบาลห้วยราช","อนุบาลห้วยสัก","อนุบาลหันคา (วัดท่ากฤษณา-สุชัยประชาสรรค์)","อนุบาลหัวตะพาน (รัตนวารี)","อนุบาลหัวหิน (บ้านหนองขอน)","อนุบาลห้างฉัตร","อนุบาลองครักษ์ (ผดุงองครักษ์ประชา)","อนุบาลอรุณรังษี","อนุบาลอำนาจเจริญ","อนุบาลน้ำเกลี้ยง (เขิน)","อนุบาลอำเภอปากพลี","อนุบาลอำเภอลำสนธิ (บ้านหนองรี)","อนุบาลอินทร์บุรี (วัดโพธิ์ศรี)","อนุบาลอุดรธานี","อนุบาลอุตรดิตถ์","อนุบาลอุทุมพรพิสัย","อนุบาลอุบลรัตน์","อนุบาลอุบลราชธานี","อนุบาลฮ่องลี่ (ค่ายเม็งรายอุปถัมภ์)","อนุราชประสิทธิ์","อนุสรณ์รัฐประชา","อพป.คลองน้ำใส","อภัยดำรงธรรม","อภัยสุพรรณภูมิ","อมตวิทยา","อมรสิริสามัคคี","อมรินทร์ราษฎร์วิทยา","อมรินทราวารี","อยู่ประชานุเคราะห์","อยู่เป็นสุขอนุสรณ์","อรพิมพ์วิทยา","อรพิมพ์วิทยา สาขาบ้านหนองบัวขาว","อรพิมวิทยา","อรัญญิการาม","อรุณประดิษฐ","อรุณเมธา","อ่อนวิมลราษฎร์วิทยา","แม่ออนวิทยาลัย","อักษรเทพประสิทธิ์","อักษรศึกษา","อักษรอดุลวิทยา","อัมพรจินตกานนท์","อัมพวันวิทยา","อัมพวันศึกษา","อัสสัมชัญธนบุรี","อัสสัมชัญแผนกประถม","อัสสัมชัญศึกษา","อ่างทองพัฒนา","อ่างทองพัฒนา (สำนักงานสลากกินแบ่งสงเคราะห์ 4)","อ่างทองราษฎร์วิทยา","อ่างทองวิทยาคม","อ่างหนองแหนประชาสามัคคี","อ่างห้วยยาง","อาจวิทยาคาร","อาทรสังขะวัฒนะ 1 วัดลาดบัว","อาทรสังขะวัฒนะ 2 วัดวังตะกู","อานันท์","อานันทนวิทยา","อายุรกิจโกศล","อ่าวกะพ้อ","อ่าวมะม่วง","อ่าวลึก","อาสนาราม(เปล่งอุปถัมภ์)","อาสินศึกษา","อาโอยาม่า 2","อำนวยกนกศิริอนุสรณ์","อำนวยเวทย์","อำนวยศิลป์ธนบุรี","อำนวยศิลป์สารกิจ","อินทนนท์วิทยา","อินทรนาวีราษฎร์อุปถัมภ์","อินทรศักดิ์ศึกษาลัย (บ้านยาง)","อินทรัมพรรย์อนุสรณ์","อิสลามบํารุง","บ้านอิสานเศรษฐกิจ","อุดมคงคาคีรีเขต","อุดมพัฒน์ฟินิคซฯอุปถัมภ์","อุดมพัฒนา","อุดมมิตรพัฒนา","อุดมราชภักดี","อุดมวิทยานุกูล","อุดมสามัคคี","อุดมอักษรพิทยาคม","อุดรพิทยานุกูล 2","อุดรวัฒนานุสรณ์","อุตรกิจ","เตรียมอุดมศึกษาน้อมเกล้า อุตรดิตถ์","องค์การอุตสาหกรรมป่าไม้ 8","อุทยานอุทิศ","อุเทนวิทยาคาร","อุบลปัญญานุกูล","อุบลรัตน์พิทยาคม","อุบลวิทยาคม","อุปรีศรีวิทยา","อุปลพันธุ์โรจนประสิทธิ์","อุปัชฌาย์พวนอุทิศ","อุ่มเม่าวิทยา","บ้านอุ่มยางหนองดั่ง","อุ่มเหม้าประชาสรรค์","อุ่มเหม้าวิทยาคาร","อุสาหะวิทยา","เอกชัย","เอกศิลป์ราษฎร์พัฒนา","เอี่ยมสุรีย์ (อนุบาลเมืองสมุทรปราการ)","โอสถสภาอุปถัมภ์","ไอยรานุสรณ์","ฮ่องฮีวิทยา","ฮอดพิทยาคม","ฮั่วเคี้ยววิทยาลัย","วัดบำเพ็ญพรต (ประมาณราษฎร์วิทยานุสรณ์)","เทศบาล 2 (รัฐราษฎร์บำรุง)","เทศบาล 3 ห้าธันวาคม","เทศบาล 2 (วัดหลวงปรีชากูล)","เทศบาลเขาท่าพระ","เทศบาลแหลมฉบัง 1","เทศบาล 1 (เกริกกฤตยาอุปถัมภ์)","เทศบาล 1 (ถนนภูผาภักดี)","เทศบาล 1 (สังขวิทย์)","เทศบาล 1 ทรงพลวิทยา","เทศบาล 2 (วัดกะพังสุรินทร์)","เทศบาล 2 (วัดทุ่งสวน)","เทศบาล 2 (คลองจิหลาด)","เทศบาล 3 (เทศบาลสงเคราะห์)","เทศบาล 3 (วัดแสงธรรมสุทธาราม)","เทศบาล 4 (บ้านทรายทอง)","เทศบาล 5 (พหลโยธินรามินฯ)","เทศบาล 6 (ตันตยาภิรม)","เทศบาล 1 (ปราจีนราษฎร์รังสฤษฎ์)","เทศบาล 1 วัดแจ้ง","เทศบาล 1 วัดศรีเมือง","เทศบาล 1 วัดแหลมใต้ ","เทศบาล 1 ศรีกิตติวรรณนุสรณ์","เทศบาล 2 ","เทศบาล 2 (แม่ต๋ำดรุณเวทย์)","เทศบาล 2 วัดทินกรนิมิต ","เทศบาลขลุง (บุรวิทยาคาร)","เทศบาลดอกเงิน","เทศบาลบ้านเขานิเวศน์","เทศบาลบ้านคลองภาษี","เทศบาล 1 (บ้านท่าตะเภา)","เทศบาลบ้านบางตาหยาด","เทศบาลบ้านศรีมงคล","เทศบาลบ้านสามเหลี่ยม","เทศบาลบ้านเสนารังสรรค์","เทศบาลบ้านหนองใหญ่","เทศบาลบ้านหัวหิน","เทศบาลเมืองปทุมธานี","เทศบาลเมืองแม่ฮ่องสอน","เทศบาลวัดจอมคีรีนาคพรต","เทศบาลวัดช่องคีรีศรีสิทธิวราราม","เทศบาลวัดชุมพลคีรี","มัธยมศึกษาเทศบาลเมืองทุ่งสง","เทศบาลวัดไทรใต้","เทศบาลวัดธรรมิการาม (ปิยแหวนรังสรรค์)","เทศบาลวัดบุญญวาสวิหาร","เทศบาลวัดพรหมจริยาวาส","เทศบาลวัดมณีไพรสณฑ์","เทศบาลวัดละหาร","เทศบาลวัดวรนาถบรรพต","เทศบาลวัดศรีสมบูรณ์","เทศบาลวัดอุปนันทาราม","เทศบาลสรรพสามิตบำรุง","เมืองพัทยา 10 (บ้านเกาะล้าน)","เมืองพัทยา 3 (วัดสว่างฟ้าพฤฒาราม)","เมืองพัทยา 7 (บ้านหนองพังแค)","เมืองพัทยา 8 (พัทธยานุกูล)","ชุมชนป้อมเพชร","เทศบาล 1 บ้านจะบังติกอ","สาธิตเทศบาลวัดเพชรจริก","เทศบาล 4","เทศบาลนครนนท์วิทยา ๕ ทานสัมฤทธิ์","เทศบาล 1 (สำนักงานสลากกินแบ่งรัฐบาลอุปถัมภ์)","เทศบาล 1 (บ้านหนองสาหร่าย)","เทศบาลแหลมฉบัง 2 (มูลนิธิไต้ล้ง-เซ็ง พรประภา)","ทีโอเอวิทยา (เทศบาล 1)","เทศบาล 1 (กบินทร์ราษฎรอำรุง)","เทศบาล 1 (บ้านกาแป๊ะ)","เทศบาล 1 (บ้านชุมแสง)","เทศบาล 1 (ราษฎรบำรุง)","เทศบาล 1 (วัดเทวสังฆาราม) ในพระสังฆราชูปถัมภ์","เทศบาล 1 (วัดสัตตนารถปริวัตร)","เทศบาล 1 ตลาดเก่า","เทศบาล 2 (คลองระนง)","เทศบาล 2 (บ้านกาแป๊ะกอตอ)","เทศบาล 2 (บ้านตันหยงมะลิ)","เทศบาล 2 (ประชาภิบาล)","เทศบาล 2 (วัดช่องลม)","เทศบาล 2 วัดบ้านโป่ง","เทศบาล 2 วัตตานีนรสโมสร","เทศบาล 3 (5 ธันวามหาราช)","เทศบาล 3 (บ้านนาตาล่วง)","เทศบาล 3 (บ้านบ่อ)","เทศบาล 3 (บ้านยะกัง)","เทศบาล 3 ท่าแดง","เทศบาล 3 บ้านปากน้ำ","เทศบาล 3 ประชายินดี","เทศบาล 3 วัดสันติพลาราม","เทศบาล 4 (บ้านกำปงตาโก๊ะ)","เทศบาล 4 (วัดมหาธาตุวรวิหาร)","เทศบาล 4 (วัดมัชฌิมภูมิ)","ชากังราววิทยา (อินทร์-ชุ่ม ดีสารอุปถัมภ์)","เทศบาล 4 วัดนพวงศาราม","เทศบาล 5 (วัดควนขัน)","เทศบาล 5 (วัดประชาภิรมย์)","เทศบาล 5 อาคารสลากฯ","เทศบาล 6 (ถนนโคกเคียน)","เทศบาล 6 (ประชาสันติ์)","เทศบาล 7 (วัดประสิทธิชัย)","เทศบาล 1 ","เทศบาล 1 (พะเยาประชานุกูล)","เทศบาล 1 (วิทยานารี)","เทศบาล 2 (เมืองเก่าวิทยา)","เทศบาล 2 บ้านตลาดเก่า","เทศบาล 2 วัดกลางทุมมาวาส","เทศบาล 2 วัดโพธิ์","เทศบาล  2  หนองบัว","เทศบาล 3 วัดเกาะแก้วนครสวรรค์","เทศบาล 3 (บ้านกุนุงจนอง)","เทศบาล 3 (ปรางค์กู่วิทยาคาร)","เทศบาล 3 (วัดแก้วพิจิตร)","เทศบาล 3 (อินทรัมพรรย์ บุญประคองพิทยาคม)","เทศบาล 3 บ้านต่ำบุญศิริ","เทศบาล 3 วัดนครอินทร์","เทศบาล 3 ศรีทรายมูล","เทศบาล 4 (ภูมินทร์ราษฎร์นุกูล)","เทศบาล 4 สันป่าก่อ","เทศบาล 5 (แก้วปัญญาอุปถัมภ์)","เทศบาล 5 (บดินทร์เดชาประสิทธิ์)","เทศบาล 5 เด่นห้า","เทศบาล 6 (รัฐประชาอุทิศ)","เทศบาล 6 (วัดศรีมงคล)","เทศบาลเขาพิทักษ์","เทศบาลตะพานหินวิทยาคาร","เทศบาลบ้านเขาเต่า","เทศบาลบ้านค่าย","เทศบาล 5 บ้านตะเกียบ (ไกรลาสวิทยาทาน)","เทศบาลบ้านตะลุบัน","เทศบาลบ้านนาเหนือ","เทศบาลบ้านโนนชัย","เทศบาลบ้านโนนทัน","เทศบาลบ้านโนนหนองวัด","เทศบาลบ้านป่าแดง","เทศบาลบ้านย่านยาว","เทศบาลบ้านศรีฐาน","เทศบาลบ้านศรีตะกั่วป่า","เทศบาลบ้านสมอโพรง","เทศบาลบ้านสักงอย","เทศบาลบ้านหนองบัว","เทศบาลบ้านหนองแวง","เทศบาลปากพนัง 1","เทศบาลปากพนัง 2","เทศบาลมาบตาพุด","เทศบาลวัดเกตการาม","เทศบาลวัดคงคาสวัสดิ์","เทศบาลวัดแค","เทศบาลวัดโคกสะท้อน","เทศบาลวัดเชียงยืน","เทศบาลวัดโชค (ธรรมเสนานีวรคุณ)","เทศบาลวัดดอนแก้ว","เทศบาลวัดตรังคภูมิพุทธาวาส","เทศบาลวัดท่าโพธิ์","เทศบาลวัดท้าวโคตร","เทศบาลวัดไทรเหนือ","เทศบาลวัดนาควารี","เทศบาลวัดบุญญาวาส","เทศบาลวัดประชุมคงคาราม","เทศบาลวัดป่าแพ่ง","เทศบาลวัดไผ่ล้อม","เทศบาลวัดมเหยงคณ์","เทศบาลวัดรามประดิษฐ์","เทศบาลวัดศรีทวี","เทศบาลวัดศรีปิงเมือง","เทศบาลวัดศรีสุพรรณ","เทศบาลวัดศาลามีชัย","เทศบาลวัดสุคตวราราม","เทศบาลวัดเสมาเมือง","เทศบาลวัดเสาธงทอง","เทศบาลวัดหนองแก","เทศบาลวัดหมื่นเงินกอง","เทศบาลวัดหัวข่วง","เทศบาลวัดหัวยาง","เทศบาลวัดใหญ่","เทศบาลสวนสนุก","เมืองพัทยา 2 (เจริญราษฎร์อุทิศ)","เมืองพัทยา 4 (วัดหนองใหญ่)","เมืองพัทยา 5 (บ้านเนินพัทยาเหนือ)","เมืองพัทยา 6 (วัดธรรมสามัคคี)","เมืองพัทยา 9 (วัดโพธิสัมพันธ์)","เทศบาล 1 สุขวิทยากรตั้งตรงจิตร 15","เทศบาล 4 วัดใต้โพธิ์ค้ำ","กลางคลองสอง (พร ดีเจริญ)","ไขศรีปราโมชอนุสรณ์","คชเผือกอนุสรณ์","คลองกะจะ (พงษ์สมบัติบำรุง)","คลองกุ่ม (เสรีไทย อนุสรณ์)","คลองต้นไทร (สุขล้อมอุทิศ)","คลองทรงกระเทียม","คลองบางพรหม","มนต์จรัสสิงห์อนุสรณ์","คลองปักหลัก","คลองมหาสวัสดิ์","คลองรางจาก","คลองลำเจียก","คลองสอง","คลองหนองใหญ่","คารีอุปถัมภ์","เคหะชุมชนลาดกระบัง","เคหะทุ่งสองห้องวิทยา 2","งามมานะ (แผน-ทับอุทิศ)","จินดาบำรุง","แจ่มจันทร์","ฉิมพลี","ชุมทางตลิ่งชัน","ชูสินทองประดิษฐ์อนุสรณ์","ซอยแอนเนกซ์ (กาญจนาภิเษก 2)","แดงเป้า(สิงสุขบูรณะ)","ตำบลขุมทอง (ประชาอุทิศ)","ทุ่งสองห้อง (คุปตัษเฐียรอุทิศ)","เทพวิทยา","นาหลวง","บางเขน (ไว้สาลีอนุสรณ์)","บางแคเหนือ (ชั้น-จำนงค์ ฉ่องสวนอ้อยอนุสรณ์)","บางเชือกหนัง (พูนบำเพ็ญอนุสรณ)","บางมด (ตันเปาว์วิทยาคาร)","บ้านขุนประเทศ","บ้านเจียรดับ","บ้านนายผล (แม้นสุวรรณอุปถัมภ์)","บ้านนายสี","บ้านนายเหรียญ","บ้านแบนชะโด","บ้านลาดพร้าว","บ้านลำต้นกล้วย","บำรุงรวิวรรณวิทยา (ทุ่งสีกัน)","ปทุมวัน","ประชานุกูล","ประชาราษฎร์อุปถัมภ์วิทยา","ประชาอุทิศ (จันทาบอนุสรณ์)","ประภาสวิทยา","ประสานสามัคคี (บ้านทับยาว)","ปลูกจิต","ผ่องพลอยอนุสรณ์","พรพระร่วงประสิทธิ์","พรหมราษฎร์รังสรรค์","พหลโยธิน (พ่วงเจริญอุปถัมภ์)","พิชัยพัฒนา","เพชรเกษม (จตุรงค์สงครามอนุสรณ์)","ขุมทอง (เพชรทองคำอุปถัมภ์)","เพี้ยนพินอนุสรณ์","รางราชพฤกษ์ (นุชมีอุทิศ)","ลำเจดีย์","ลำบุหรี่พวง","ลำผักชี","ลำสาลี (ราษฎร์บำรุง)","วัดไก่เตี้ย (สวัสดิ์ประชานุกูล)","วัดคณิกาผล","วัดคฤหบดี (จันทรสถิตย์)","วัดคลองเตย","วัดคู้บอน","วัดจันทรสโมสร","วัดเจ้าอาม","วัดฉัตรแก้วจงกลณี","วัดชัยพฤกษมาลา","วัดช่างเหล็ก","วัดดงมูลเหล็ก","วัดดวงแข","วัดดุสิตาราม","วัดใต้ (ราษฎรนิรมิต)","วัดทรัพย์สโมสร","วัดทองสุทธาราม","วัดทิพพาวาส","วัดเทพากร (เลี่ยมมาตุทิศ)","วัดเทวสุนทร","วัดไทร (ถาวรพรหมานุกูล)","วัดธรรมาภิรตาราม","วัดนินสุขาราม","วัดบรมนิวาส","วัดบางขุนเทียนนอก","วัดบางนานอก","วัดบางนาใน (รื่น ศยามานนท์)","วัดบางประทุนนอก","บางไผ่ (บ้านนายพันแก้วขาว)","วัดบางเสาธง","วัดบำรุงรื่น","วัดบึงบัว","วัดบุณยประดิษฐ์","วัดปฐมบุตรอิศราราม","วัดปทุมวนาราม ในพระราชูปถัมภ์สมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี","วัดประชาระบือธรรม","วัดประชาศรัทธาธรรม","วัดประดู่ธรรมาธิปัตย์","วัดปลูกศรัทธา","วัดปากน้ำฝั่งเหนือ","วัดปากบ่อ","วัดปุรณาวาส","วัดแป้นทอง (สามวาวิทยา)","วัดพรหมสุวรรณสามัคคี","วัดพระพิเรนทร์","วัดพระยาทำ","วัดพระยาสุเรนทร์","วัดพิชัย","วัดพิชัยญาติ","วัดโพธิ์ (ราษฎร์ผดุงผล)","วัดโพธิ์แก้ว (กระวลราษฎร์วิทยา)","วัดภาษี","วัดมงคลวราราม (สมพรพสกสรรค์)","วัดม่วงแค","วัดมหาพฤฒาราม","วัดมะกอก (วิสุทธิวิทยาคาร)","วัดมะลิ","วัดมัชฌันติการาม","วัดยานนาวา","วัดยายร่ม","วัดรวก","วัดรัชฎาธิฐาน","วัดราชโกษา","วัดราชผาติการาม","วัดลาดกระบัง (ศีลาภิรัตอุปถัมภ์)","วัดลานบุญ","วัดลำกระดาน","วัดลำต้อยติ่ง","วัดเลียบราษฎร์บำรุง","วัดวิมุตยาราม","วัดวิเศษการ","วัดเวฬุวนาราม (สินทรัพย์อนุสรณ์)","วัดศรีสุก","วัดศรีสุดาราม","วัดศาลาครืน","วัดพระยาศิริไอยสวรรค์","วัดเศวตฉัตร","วัดสวัสดิวารีสีมาราม","วัดสังฆราชา","วัดสัมพันธวงศ์","วัดสามัคคีสุทธาวาส","วัดสิตาราม","วัดสีชมพู","วัดสุทธาโภชน์","วัดสุทธิสะอาด","วัดแสนเกษม","วัดหนองแขม (สหราษฎร์บูรณะ)","วัดหนองจอก (ภักดีนรเศรษฐ)","วัดหนองใหญ่","วัดหัวลำโพง","วัดใหม่กระทุ่มล้ม","วัดใหม่เจริญราษฎร์","วัดอัมพวา","วัดอุดมรังสี (ป.ปีติวรรณอุปถัมภ์)","วิจิตรวิทยา","ศิริวังวิทยาคาร","ศูนย์รวมน้ำใจ","สถานีพรมแดน","สวนลุมพินี","สามแยกคลองหลอแหล","สามแยกท่าไข่","สามเสนนอก (ประชาราษฎร์อนุกูล)","สุเหร่าเกาะขุนเณร","สุเหร่าคลองเก้า","สุเหร่าคลองจั่น","สุเหร่าคลองสิบ","สุเหร่าคลองสิบเอ็ด","สุเหร่าคลองสี่","สุเหร่าคลองหนึ่ง (มานะราษฎร์บำรุง)","สุเหร่าจรเข้ขบ (กุลางกูรอุปถัมภ์)","สุเหร่าดอนสะแก","สุเหร่าทับช้าง","สุเหร่าทับช้างคลองบน","สุเหร่าทางควาย","สุเหร่านาตับ","สุเหร่าบางมะเขือ (ปรีดี พนมยงค์ อนุสรณ์)","สุเหร่าบ้านเกาะ","สุเหร่าบ้านดอน","สุเหร่าบ้านม้า","สุเหร่าบึงหนองบอน","สุเหร่าลาดบัวขาว","สุเหร่าลาดพร้าว","สุเหร่าลำนายโส","สุเหร่าวังใหญ่","สุเหร่าศาลาแดง","สุเหร่าศาลาลอย","สุเหร่าสนามกลางลำ","สุเหร่าสามวา (ซุน เวทย์สฤษฎ์ อุทิศ)","สุเหร่าสามอิน","สุเหร่าหะยีมินา","สุเหร่าใหม่","สุเหร่าอีรั้ว","แสงหิรัญวิทยา","หนองจอกพิทยานุสรณ์","หลวงแพ่ง (บำรุงรัฐกิจ)","หัวหมาก","ออเงิน (อ่อน-เหม อนุสรณ์)","อิสลามลำไทร","นีรชาศึกษา","นราธิปพิทยา","นวลวรรณศึกษา","อนุบาลบูรณะศึกษา","ศรีวรการ","เจริญสุขวิทยา","อนุบาลรัษฎา","เจริญวัยวิทยา","บัวใหญ่วิทยา","เรืองศรีวิทยา","สัญลักษณ์วิทยา","เทเรซาอุปถัมภ์","พาณิชสงเคราะห์","จงซันเซียะเซียว","แหลมทองวิทยา","อนุบาลอยู่วิทยา","มารีพิทักษ์","อะเดร์รอซะอิสลามียะห์","เซนต์เทเรซาแสงทอง","สุนทรวิทยา","ศาสนูปถัมภ์ปากพะยูน มูลนิธิ","หัวเฉียว","สิ่นหมิน","แก่นจันทร์วิทยา","ราษฎร์วิทยา","อนุบาลกาญจนาวิทยา","ใจจำนงศึกษา","ศิริวัฒน์วิทยา","หยกฟ้า","สันติธรรมวิทยาคม","มารีย์พิทักษ์สว่างแดนดิน","บุสตานุดดีน","วชิรานุกูล","ส่งเสริมศาสนาวิทยามูลนิธิ","สายเพชรศึกษา","เฉลิมไฉไลวิทยา","ดรุณานุเคราะห์","วิริยะวิทยามูลนิธิ","พวงคราม","พีระวิทยา","ราษฎร์ศึกษา","โพธิเสนวิทยา","เซนต์ปอลหนองคาย","คุณากรณ์","ภราดานุสรณ์","สหบำรุงวิทยา (มูลนิธิ)","อนุบาลอรณิชชา","อัสสละฟียะฮ์วิทยาลัย","อนุบาลไพศาลวิทย์","พุทธยาคมศรียาภัย","เจ้าฟ้าอุบลรัตน์","สัตยาไส","สายชล","เทศบาล 5 (บ้านศรีบุญเรือง)","กระแซง (คุรุราษฎร์นุกูล)","วัดป่าถ่อน","ทีปังกรวิทยาพัฒน์ (วัดโบสถ์) ในพระราชูปถัมภ์ฯ","เทศบาล 7 (ศิรินาวินวิทยา)","เทศบาล 4 (บ้านเชียงราย)","เทศบาล 6 (วัดป่ารวก)","เทศบาล 3 (บุญทวงศ์อนุกูล)","เทศบาล 1 (บ้านแสนเมืองมูล)","พุ่ยฮัว","ปัญจทรัพย์","พร้อมพรรณวิทยา","อำนวยพิทยา","ผะดุงศิษย์พิทยา","อัสสัมชัญ","ชินวร","ถนอมพิศวิทยา","วีรศิลป์","ดรุณากาญจนบุรี","สตรีมารดาพิทักษ์","อำนวยวิทย์ จันทบุรี","สาคริชวิทยา","สหศาสตร์ศึกษา","จุ๋งฮัวโชะเซียว","ทิพยรัตน์วิทยา","ธาดาอนุสรณ์","บอสโกพิทักษ์","ประสารวิทยา","พระหฤทัยนนทบุรี","มัธยมวัดใหม่กรงทอง","ยอแซฟอยุธยา","ผดุงราษฎร์","หมิงซิน","บวรรัตนศาสตร์","เทพินทร์พิทยา","ดุสิตวิทยา","อัสสัมชัญคอนแวนต์ ลำนารายณ์","วินิตศึกษา ในพระราชูปถัมภ์ สมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี","เมธีวุฒิกร ","มารีวิทยา","ธิดานุเคราะห์","อาษาวิทยา","ไพฑูรย์วิทยา","เทพมิตรศึกษา","อุดรคริสเตียนวิทยา","อนุบาลไผทวิทยา","ชาญกิจวิทยา","บางบัว (เพ่งตั้งตรงจิตรวิทยาคาร)","วัฒนานุศาสน์","อนุบาลจันทราพระกิตติคุณ","กสิณธรวิทยา","เลิศพัฒนาศึกษา","มงคลญาณปริยัติ","พระปริยัติธรรมแม่แตงวิทยา","ศรีอยุธยา ในพระอุปถัมภ์สมเด็จพระเจ้าภคินีเธอ เจ้าฟ้าเพชรรัตนราชสุดา สิริโสภาพัณณวดี","ร่มเกล้า กาญจนบุรี (ในโครงการพระราชดำริ)","เทพนารี","เซนต์แอนโทนี","ชัยนาทพิทยาคม","ครบุรี","นารีรัตน์จังหวัดแพร่","มหาชนะชัยวิทยาคม","เลยพิทยาคม","ร้องกวางอนุสรณ์","สูงเม่นชนูปถัมภ์","วังจันทร์วิทยา","ศรีสงครามวิทยา","ระยองวิทยาคม","ชะรัดชนูปถัมภ์","เตรียมอุดมศึกษาพัฒนาการ เชียงราย","โพธิ์ไทรงามวิทยาคม","ปราจีนกัลยาณี","กบินทร์วิทยา","ราชวินิตบางแก้ว","หาดอมราอักษรลักษณ์วิทยา","นวมินทราชินูทิศ เตรียมอุดมศึกษาพัฒนาการ","อุทัยวิทยาคม","พิมายวิทยา","กุดชุมวิทยาคม","พังโคนวิทยาคม","ธาตุนารายณ์วิทยา","สตรีอ่างทอง","วิเศษชัยชาญ ","อ่างทองปัทมโรจน์วิทยาคม","โพธิ์ทอง ","โคราชพิทยาคม","นวมินทราชูทิศ กรุงเทพมหานคร","ศรีราชา","วรนารีเฉลิม จังหวัดสงขลา","จุฬาภรณราชวิทยาลัย นครศรีธรรมราช","ทัพทันอนุสรณ์","หนองฉางวิทยา","เดชะปัตตนยานุกูล","ทรายมูลวิทยา","ดอนมดแดงวิทยาคม","สตรีชัยภูมิ","ชุมพลโพนพิสัย","โพธิ์ตากพิทยาคม","บุญวาทย์วิทยาลัย","คริสตสงเคราะห์","ดาราจรัส","หล่มเก่าพิทยาคม","ชะอวด","ปะเหลียนผดุงศิษย์","ย่านตาขาวรัฐชนูปถัมภ์","ชัยบาดาลวิทยา","โคกสำโรงวิทยา","คณะราษฎร์บำรุงปทุมธานี","พานพิทยาคม","กาบเชิงวิทยา","มัธยมทับทิมสยาม 04","สุรพินท์พิทยา","เชียงคำวิทยาคม","จอมพระประชาสรรค์","รัตนบุรี","ประสาทวิทยาคาร","สุรวิทยาคาร","ศีขรภูมิพิสัย","สนมวิทยาคาร","สิรินธร","รามวิทยา รัชมังคลาภิเษก","วีรวัฒน์โยธิน","สังขะ","ลานสักวิทยา","อุดมดรุณี","จุนวิทยาคม","พะเยาพิทยาคม","ดอกคำใต้วิทยาคม","ท่าตูมประชาเสริมวิทย์","บางปลาม้า ","ธีรกานท์บ้านโฮ่ง","ปายวิทยาคาร","เทิงวิทยาคม","บางมูลนากภูมิวิทยาคม","เขาทรายทับคล้อพิทยา","อำนาจเจริญ","ภูเก็ตวิทยาลัย","สตรีภูเก็ต","เมืองถลาง","ตากพิทยาคม","ผดุงปัญญา","เทศบาลวัดคลองโพธิ์","พิชัย","พนาศึกษา","หัวตะพานวิทยาคม","สตรีสิริเกศ","ตระกาศประชาสามัคคี","สกลนครพัฒนศึกษา","บ้านม่วงพิทยาคม","มัธยมวาริชภูมิ","น้ำพองพัฒนศึกษา รัชมังคลาภิเษก","วัดป่าประดู่","สตรีระนอง","หนองหิ้งพิทยา","พิชัยรัตนาคาร","ชำนาญสามัคคีวิทยา","อัมพวันวิทยาลัย","สมุทรสาครบูรณะ","โพธิ์คีรีราชศึกษา","สิงห์สมุทร","คลองลานวิทยา","เขื่องในพิทยาคาร","เดชอุดม","ขามทะเลสอวิทยา","ละหานทรายรัชดาภิเษก","ปากเกร็ด","นครสวรรค์","สตรีนครสวรรค์","นวมินทราชูทิศ มัชฌิม","ตากฟ้าวิชาประสิทธิ์","ตาคลีประชาสรรค์","หนองบัว","หนองไผ่","สตรีประเสริฐศิลป์","กำแพงเพชรพิทยาคม","สามชุกรัตนโภคาราม","บ้านหมอ ","หนองแค ","เสาไห้ ","ท่าวุ้งวิทยาคาร","ค้อวังวิทยาคม","สตรีราชินูทิศ","ไชยวานวิทยา","บ้านดุงวิทยา","หนองวัวซอพิทยาคม","น้ำโสมพิทยาคม","ห้วยเกิ้งพิทยาคาร","เตรียมอุดมศึกษาพัฒนาการ อุดรธานี","ศรีธาตุพิทยาคม","ทุ่งฝนวิทยาคาร","เพ็ญพิทยาคม","อุดรพิชัยรักษ์พิทยา","หนองหานวิทยา","เบญญาพัฒน์","แม่สะเรียง ","เบญจมราชูทิศ","ชลราษฎรอำรุง","จักรคำคณาทร","ปราจิณราษฎรอำรุง","พร้าววิทยาคม","สันทรายวิทยาคม","อุตรดิตถ์ดรุณี","สายปัญญารังสิต","บุรีรัมย์พิทยาคม","สุรนารีวิทยา 2","สะแกราชธวัชศึกษา","จักราชวิทยา","เลิงนกทา","ศรีสะเกษวิทยาลัย","กันทรารมณ์","โพนทองพัฒนาวิทยา","สิชลคุณาธารวิทยา","กัลยาณีศรีธรรมราช","ท่านครญาณวโรภาสอุทิศ","เมืองนครศรีธรรมราช","ชะอวดวิทยาคาร","รัษฎา","สภาราชินี จังหวัดตรัง","ดัดดรุณี","แม่สายประสิทธิ์ศาสตร์","ปากคาดพิทยาคม","ทุ่งสง","เซกา","ปทุมเทพวิทยาคาร","นาสวรรค์พิทยาคม","พรเจริญวิทยา","กาญจนานุเคราะห์","จันทร์หุ่นบำเพ็ญ","ทุ่งใหญ่เฉลิมราชอนุสรณ์ รัชมังคลาภิเษก","สตรีทุ่งสง","ยางตลาดวิทยาคาร","ธาตุพนม","ดอยสะเก็ดวิทยาคม","เชียงคาน","นางรอง","ศรีชมภูวิทยา","พิมานพิทยาสรรค์","สตึก","กำแพงวิทยา","สมุทรสาครวิทยาลัย","กาญจนาภิเษกวิทยาลัย นครปฐม (พระตำหนักสวนกุหลาบมัธยม)","สตรีปากพนัง","โพธาวัฒนาเสนี","สายธรรมจันทร์","ปากพนัง","ทุ่งสงวิทยา","คุรุราษฎร์รังสฤษฎ์","ห้วยยอด","โพธิ์ไทรพิทยาคาร","ลำปางกัลยาณี","เบญจมราชรังสฤษฎิ์","คลองพนสฤษดิ์พิทยา","ชุมแพศึกษา","หล่มสักวิทยาคม","กระสังพิทยาคม","ท่าศาลาประสิทธิ์ศึกษา","บางปะกอกวิทยาคม","เทศบาล 1 (ห้วยมุด)","เทศบาล 5 วสุนธราภิวัฒก์","สตรีพัทลุง","เทศบาล 2 (บ้านอู่มาด)","นราธิวาส","บึงสามพันวิทยาคม","เทศบาล 3 (บ้านคลองหา - นาเตรียะ)","เทศบาล 4 (บ้านทุ่งคาเกรียน)","แก้งคร้อวิทยา","นิยมศิลป์อนุสรณ์","ท่าบ่อ","นวมินทราชินูทิศ เตรียมอุดมศึกษาน้อมเกล้า","ขุนหาญวิทยาสรรค์","ศรีกระนวนวิทยาคม","มัญจาศึกษา","พนัสพิทยาคาร","ปทุมรัตต์พิทยาคม","คอนสวรรค์","นาทวีวิทยาคม","เฉลิมราชประชาอุทิศ","ศรีรัตนวิทยา","บ้านเป้าวิทยา","บำเหน็จณรงค์วิทยาคม","วัดมหาบุศย์ (พิทักษ์ถาวรคุณ)","คงคาราม","กมลาไสย","นครพนมวิทยาคม","โซ่พิสัยพิทยาคม","สังคมวิทยา","กุดเรือคำพิทยาคาร","กีฬาจังหวัดสุพรรณบุรี","กีฬาจังหวัดขอนแก่น","กีฬาจังหวัดอุบลราชธานี","กีฬาจังหวัดนครศรีธรรมราช","กีฬาจังหวัดนครสวรรค์","กีฬาจังหวัดศรีสะเกษ","กีฬาจังหวัดอ่างทอง","กีฬาจังหวัดลำปาง","กีฬาจังหวัดยะลา","กีฬาจังหวัดชลบุรี","กรุงเทพคริสเตียนวิทยาลัย","อนุบาลสองภาษาบ้านต้นไม้","สารสาสน์พิทยา","ปัญญาศักดิ์","สมบุญวิทย์","ไทยคริสเตียนสะพานเหลือง","สารสาสน์วิเทศบางบอน","อยู่เย็นวิทยา","สารสาสน์วิเทศศึกษา","ขอนแก่นวิเทศศึกษา","บูรพาพัฒนศาสตร์","พลวิทยาระบบสองภาษา","เศรษฐเสถียร ในพระราชูปถัมภ์","โสตศึกษาทุ่งมหาเมฆ","โสตศึกษาจังหวัดนนทบุรี","โสตศึกษาจังหวัดนครปฐม (ศึกษาพิเศษนครปฐม)","โสตศึกษาจังหวัดสงขลา","สอนคนตาบอดภาคใต้จังหวัดสุราษฎร์ธานี (สำนักบริหารงานกศ.พิเศษ)","ชุมพรปัญญานุกูล","สงขลาพัฒนาปัญญา","ภูเก็ตปัญญานุกูล","โสตศึกษาเทพรัตน์","สุพรรณบุรีปัญญานุกูล","เพชรบุรีปัญญานุกูล","โสตศึกษาจังหวัดตาก","พิษณุโลกปัญญานุกูล","พิจิตรปัญญานุกูล","โสตศึกษาจังหวัดเพชรบูรณ์","โสตศึกษาอนุสารสุนทร","กาวิละอนุกูล","น่านปัญญานุกูล","เชียงรายปัญญานุกูล","แพร่ปัญญานุกูล","โสตศึกษาจังหวัดอุดรธานี","โสตศึกษาจังหวัดมุกดาหาร","กาฬสินธุ์ปัญญานุกูล","โสตศึกษาจังหวัดร้อยเอ็ด","นครราชสีมาปัญญานุกูล (ศึกษาพิเศษนครราชสีมา)","โสตศึกษาจังหวัดชัยภูมิ","โสตศึกษาจังหวัดชลบุรี","ระยองปัญญานุกูล","โสตศึกษาจังหวัดปราจีนบุรี","ฉะเชิงเทราปัญญานุกูล","โสตศึกษาปานเลิศจังหวัดลพบุรี","ร่วมฤดีวิเทศศึกษา","บางกอกพัฒนา","สมาคมไทย-ญี่ปุ่น","นานาชาติเซนต์จอห์น","นานาชาติเอกมัย","นานาชาตินิสท์","ประชาคมนานาชาติ","อาร์บิสรัศมีนานาชาติ","อนุบาลนานาชาติเยาวรักษ์","นานาชาติเทร็ลล์","อนุบาลนานาชาติเซนต์ไมเคิล","นานาชาติดิเออร์ลี่เลิร์นนิ่งเซนเตอร์","นานาชาติโมเดิร์น กรุงเทพฯ","นานาชาติเซนต์สตีเฟ่นส์","อนุบาลนานาชาติเฟิรสต์สเตปส์","นานาชาติเค ไอ เอส","นานาชาติฮาร์โรว์","นานาชาติอินเตอร์เนชั่นแนลไพโอเนียร์ส","ดิ อเมริกัน สคูล ออฟ แบงค็อก สุขุมวิท","อนุบาลนานาชาติมอนเตสเซอรี่","นานาชาติเซนต์มาร์ค","นานาชาติแอ๊ดเวนต์รามคำแหง","นานาชาติเซนต์แอนดรูวส์ กรุงเทพ","สถานศึกษานานาชาติ","นานาชาติเชียงใหม่","ไทยซิกข์นานาชาติ","ดิ อเมริกัน สคูล ออฟ แบงค็อก","นานาชาติ คิว.เอส.ไอ.ภูเก็ต","นานาชาติภาคตะวันออก","คริสเตียนเยอรมันเชียงใหม่","นานาชาติเดอะรีเจ้นท์ พัทยา","นานาชาติสวนระยอง","นานาชาติลานนา","นานาชาติไทย-จีน","นานาชาติบริติช ภูเก็ต","นานาชาตินครพายัพ","นานาชาติอเมริกันแปซิฟิก","นานาชาติเซนต์แอนดรูว์ส กรีนวัลเล่ย์ ระยอง","นานาชาติเกรซ เชียงใหม่","สันติราษฎร์วิทยาลัย","ธารทองพิทยาคม","น้ำพองศึกษา","ชัยภูมิภักดีชุมพล","เนินมะปรางศึกษาวิทยา","ไพรบึงวิทยาคม","หนองพระพิทยา","หนองสองห้องวิทยา","วังโพรงพิทยาคม","บ้านกลางพิทยาคม","จอมสุรางค์อุปถัมภ์","น้ำรินพิทยาคม","สฤษดิ์เสนาพิทยาคม","พรหมพิรามวิทยา","บางปะอิน ","บ้านกร่างวิทยาคม","พิษณุโลกพิทยาคม","ท่าเรือ ","เนินสะอาดวิทยาคม","ทรัพย์ไพรวัลย์วิทยาคม","บางกระทุ่มพิทยาคม","นครไทย","เสนา ","ราชประชาสมาสัย ในพระบรมราชูปถัมภ์","ศรีสังวาลย์","สอนคนตาบอดกรุงเทพฯ","ปัญญาวุฒิกร","การศึกษาคนตาบอดขอนแก่น","การศึกษาคนตาบอดนครราชสีมา","แกลง ","เชียรใหญ่","เทศบาลวัดช่องลม (เปี่ยมวิทยาคม)","เทศบาลบ้านมหาชัย (อนุกูลราษฎร์)","อ่าวลึกประชาสรรค์","พระมหาไถ่ศึกษา","กาฬสินธุ์พิทยาสรรพ์","พระแสงวิทยา","เวียงสระ","ท่าชนะ","สุราษฎร์พิทยา","บ้านนาสาร","สุราษฎร์ธานี 2","หาดใหญ่วิทยาลัย 2","อนุบาลเฉลิมพล","อนุบาลเรวดี","อนุบาลปัญญา","เทพบดินทร์วิทยาเชียงใหม่","เมตตาศึกษา ในพระราชูปถัมภ์ฯ","เรยีนาเชลีวิทยาลัย","โกวิทธำรงเชียงใหม่","อนุบาลไชยโรจน์สิริล","ไมตรีจิตคริสเตียนเชียงใหม่","จิตราวิทยา","ดาราวิทยาลัย","พระหฤทัย","พิงครัตน์","มงฟอร์ตวิทยาลัย แผนกประถม","วรเชษฐอนุสรณ์","วิชัยวิทยา","สันติศึกษา","อนุบาลโชติวิทย์","อนุบาลโพธิรักษ์","ขาลสุวรรณอนุสรณ์","อนุบาลดรุณนิมิต","อนุบาลดรุณนิมิตวิทยา","อนุบาลดวงแก้ว","อนุบาลบ้านเด็ก","อนุบาลบ้านหมอ","อนุบาลพรรณี","พิมานเด็กเชียงใหม่","อนุบาลมยุรี","อนุบาลร่มเย็น","อนุบาลลานนา","อนุบาลวารี","อนุบาลสวนเด็กเชียงใหม่","อนุบาลสวนน้อย","อนุบาลสายดรุณ","อนุบาลอักษรธรรม","อนุบาลอัมพรพรรณ","อนุบาลอุบลลักษณ์","อนุศึกษา","เมืองเด็กวิทยา","เชียงใหม่มัธยม","เมฆขจรเชียงใหม่","อนุบาลจิตโรภาส","อนุบาลดรุณเกษม","ปราณีวิทยา","เอื้อวิทยา","อนุบาลฉัตรพฤกษ์","ไชยจีนะวิทยา","สุทธิวงศ์ดำรงวิทย์","ณัทชวิทย์","อนุบาลสุทธิวงศ์","อนุบาลวิลาวัลย์","อนุบาลสุมาลี","รังษีวิทยา","สายอักษร","อนุบาลสมฤทธิ์","อนุบาลสายอักษร","อนุบาลพรชัย","อนุบาลแม่บัวคลี่","อนุบาลร่มแก้ว","อนุบาลวัยพัฒนา","อนุบาลสิทธิโรจน์","อนุบาลขวัญดรุณ","พงษ์พิกุลเชียงใหม่","อนุบาล ต.วรศิลป์","อนุบาลวัยดรุณ","อนุบาลวีรยา","อนุบาลสันทราย","อนุบาลวิมานทิพย์","อนุบาลอมรศิริ","อนุบาลวรานีกูล","ช่องฟ้าซินเซิงวาณิชบำรุง","สืบนทีธรรม","อนุบาลดวงกมล","อนุบาลพิมมาลา","อนุบาลสุปราณี","อนุบาลสุรีย์วรรณ","อนุบาลเพลินพิศ","อนุบาลเรือนคำ","บุญพิทักษ์วิทยา","อนุบาลสุภาพรรณ","ลูกรักเชียงของ","กิตติคุณเทิงวิทยา","อนุบาลเด็กดี","เชียงรายวิทยาคม","คริสเตียนไพศาลศาสตร์","กองทัพบกอุปถัมภ์บริบูรณ์ธนวัฒน์","มารีย์รักษ์เชียงราย (แผนกอนุบาล)","บัณฑิตศึกษา","อนุบาลหวานใจ","นุชนาถอนุสรณ์","อนุบาลความหวังเวียงป่าเป้า","อนุบาลสุชาดา","อนุบาลอำพร","เรืองปัญญา","อนุบาลสวนเด็กแม่สรวย","พรพิกุลพิทยา","มานิตวิทยา","อนุบาลกฤษณา","ศิริมาตย์เทวี","อนุบาลคำนวณ","อนุบาลวัดเหมืองง่า (ฤทธิ์ไกรอุปถัมภ์)","อนุบาลศิริวัฒนา","เซนต์โยเซฟเพชรบุรี","ปริยัติรังสรรค์","ศึกษาปัญญา","สุวรรณรังสฤษฎิ์วิทยาลัย","อนุบาลเทพศึกษา","เปรมฤดี","อนุบาลแสงมิตร","อนุบาลโพธิ์ใหญ่พัฒนา","อนุบาลบันไดอิฐ","อนุบาลศศิมา","อนุบาลศึกษาปัญญา","อนุบาลวุฒิสารศึกษา","โฆษิตวิทยา","โลมนิลวงศ์อนุสรณ์","สำราญราษฎร์วิทยา","ดงขุยวิริยานุสรณ์","ศิริรัตน์วิทยา","สมอทอดศึกษา","อนุบาลพร้อมจิต","อุดมวิทยา","วิทยานนท์ศึกษา","ปาลพันธุ์วิทยา","สัมพันธ์วิทยา","เพชรพินิตศึกษา","อนุบาลกิลาพร","วีรสัมพันธ์วิทยา","ศรีปัญญา","สหวิทยศึกษา","อนุบาลแสงธรรม","บูรณวิทยา","อนุบาลสุภาพพิทยา","เมตตาศึกษา","ผดุงวิทย์","อนุบาลทิพยาหล่มสัก","มหาไถ่ศึกษาท่าบม","มหาไถ่ศึกษาเลย","แสงตะวันพัฒนา","อนุบาลพระศรีสงคราม","อนุบาลอรพัฒน์","อนุบาลประจันตะ","เด่นไชยวิทยา","อนุบาลภาวนา","เจริญราษฎร์","เจริญศิลป์","เทพพิทักษ์วิทยา","มารดาอุปถัมภ์","อนุบาลเพ็ญรัต","อนุบาลร้องกวาง","ระเบียบพิทยา","อนุบาลธนารัตน์","อนุบาลอำนวยพร","อนุพงศ์พัชรินทร์","อนุบาลจรัสศรี","อนุบาลบรรณวิทย์","อนุบาลกฤษณพรรณ","อนุบาลธารทิพย์","อนุบาลสิริอัมพร","โภคาพาณิชย์นุกูลมูลนิธิ","กิตติวิทยานุสรณ์","อิศรานุสรณ์","สังข์ทองวิทยา","อนุบาลลำทับ","อนุบาลรามเดชา","เจริญวุฒิวิทยา","แอ๊ดเวนตีสเอกมัย","ขจรศึกษา","คลองเตยวิทยา","ซินหยกฮั้วกงฮัก","ดรุณาลัยสุขุมวิท","พระโขนงวิทยา","วชิรสิน","วรรณวิทย์","วิศาลวิทย์","ศรีวิกรม์","สามัคคีสงเคราะห์","สิงฟ้า","อนุบาลเทพสนิท","อนุบาลใจดี","อนุบาลกุ๊กไก่","อนุบาลดารารัตน์","ทอสี","อนุบาลบ้านรัก","อนุบาลศรีวัฒนา","อนุบาลสี่พี่น้อง","อนุบาลอธิพร","จันทรวิทยา","บำรุงวิชา","พัฒนาวิทยา","สตรีวุฑฒิศึกษา","อนุบาลเชาวน์ดี","อนุบาลธีรชาต","อนุบาลนันทิยา","อนุบาลบ้านไทย","อนุบาลศันสนีย์","อนุบาลสุวาวรรณ","ขุมทองวิทยา","อนุบาลวรรณฤดี","อนุบาลสมศกุลนา","ฉัตรวิทยา","ทรงวิทย์ศึกษา","อนุบาลราชเดช","เซนต์จอห์น","เพชรรัชต์ในพระอุปถัมภ์ฯ","จินดานุกูล","ทับทอง","ธัชรินทร์วิทยาบางเขน","มาลากฤตยวิทยา","อนุบาลเซนต์จอห์น","อนุบาลเศรษฐบุตร","อนุบาลแย้มสอาด","อนุบาลโชติมา","อนุบาลไสวตาแตง","อนุบาลชนานันท์","อนุบาลดรุณตะวัน","อนุบาลปรางทิพย์","อนุบาลพุทธรักษา","อนุบาลสุดารักษ์","อนุบาลอาภาภิรมย์","อรรถมิตร","แม่พระประจักษ์","มาร์มาร่า จินดามณี","ธนบุรีศึกษา","บุญเสริมวิทยาธนบุรี","อนุบาลเสริมสุธี","อนุบาลบ้านยิ้ม","อนุบาลประเสริฐศิลป์","อนุบาลพรพิมพ์","เจริญวิทยศึกษา","บริบูรณ์ศิลป์ศึกษา","ผ่องเพ็ญวิทยาดอนเมือง","พระหฤทัยดอนเมือง","อนุบาลเกษร","อนุบาลธรรมาภรณ์","อนุบาลบริบูรณ์ศิลป์","แม่พระฟาติมา","กอบวิทยา","จันทรวิชา","จำนงค์พิทยา","จำนงค์วิทยา","นิธิปริญญา","ประไพพัฒน์","สามัคคีบำรุงวิทยา","อนุบาลเอกลักษณ์","อนุบาลชินณพงศ์","อนุบาลปานตา","อนุบาลสมใจ","อนุบาลสัตย์สงวนอนุสรณ์","เซนต์คาเบรียล","เซนต์ฟรังซีสซาเวียร์คอนแวนต์","เยาวชนศึกษา","โยนออฟอาร์ค","โยนออฟอาร์คแผนกอนุบาล","กันตะบุตร","คอนเซ็ปชัญ","จิตรลดา","ช่างอากาศอำรุง","กองทัพบกอุปถัมภ์สื่อสารสงเคราะห์","พันธะวัฒนา","พันธะศึกษา","พันธะศึกษาพิทยา","ราชวัตรวิทยา","ราชินีบน","วชิราวุธวิทยาลัย","ศรีดรุณ","สรรพาวุธบำรุง","อนุบาลกรแก้ว","อนุบาลธนสมบูรณ์อำนวยสงคราม","อนุบาลธรรมภิรักษ์เทเวศร์","อนุบาลยุววิทย์","อนุบาลศรีสัปดาห์","อนุบาลสาริน","อักษรเจริญ","กุศลศึกษา","นิลประพันธ์","ปิยะมิตร","ปิยะวิทยา ตลิ่งชัน","วรรัตน์ศึกษา","อนุบาลจารุเวช","อนุบาลนกน้อย","อนุบาลสร้างสรรค์","อนุบาลอภิรักษ์ชัยพฤกษ์","โชติกาญจน์","อนุบาลพลอยแก้ว","บูรณะศึกษา","บูรณะศึกษา แผนกอนุบาลทุ่งครุ","สารสาสน์ประชาอุทิศพิทยาคาร","อนุบาลบัณฑิตวิทย์","อนุบาลบ้านโดม","เกื้อวิทยา","แสงอรุณ","จรวยพรวิทยา","ดรุณวิทย์วิทยา","น้ำชลชนานุกูล","พรประสาทวิทยา","มณีวิทยา","มนตรีวิทยา","ฤดีศึกษา","ศิริรักษ์วิทยา","สหนิยมวิทยา","อนุบาลแสงอรุณ","อนุบาลแสงอรุณ ธนบุรี","อนุบาลซางตาครู้ส","อนุบาลพัชรินทร์พร","อนุบาลวรรณบูรณ์ศึกษา","เลิศอุบลอนุบาล","เอี่ยมพานิชวิทยา","กองทัพบกอุปถัมภ์เพชราวุธวิทยา","ปราโมชวิทยาทาน","ภูมิไพโรจน์วิทยา","จารุวรรณ","อนุบาลชัยพฤกษ์","อนุบาลปริญญา","อนุบาลพิมลทิพย์","อนุบาลวัดไตรรัตนาราม","อมาตยกุล","อุทัยวิทยา","อนุบาลเพื่อนรัก","สากลศึกษาบางแค","สารสาสน์ธนบุรี","อนุบาลเด่นหล้า","อนุบาลเศรษฐราณี","อนุบาลธีระนิตย์","อนุบาลยุวภัทร","อนุบาลวัฒนี","อนุบาลอนุบัณฑิต","อภิจิตอนุสรณ์","แสงมณี","ชาตศึกษา","ประสาทวิทยาอนุชน","ประสาทวิทยาอนุชน แผนกอนุบาล","ชัยพิทยพัฒน์ มูลนิธิชัยพัฒนา (จารุวัฒนานุกูล ท่าพระ)","สุโรจน์วิทยา","อนุบาลรุจิโรจน์","อนุบาลสัมพันธ์วิทยา","เทพกาญจนา","ดรุณวัฒนา","ดิลกศึกษา","นฤมลทิน ธนบุรี","บำรุงวิทยาธนบุรี","บุญยาจารย์","มงคลวิจิตรวิทยา","สุภัทรา","อนุบาลสุรวิทยา","อนุชนบางกอกน้อย","อนุบาลจันทยานนท์","อนุบาลจิรภา","อนุบาลฐนิตา","อนุบาลดรุณวัฒนา","อนุบาลธรรมภิรักษ์ธนบุรี","อนุบาลมีลำใย","อนุบาลสุนันท์ศึกษา","อานันท์วิทยา","วัฒนานนท์วิทยา","เพ็ญสมิทธ์","ณัฏฐวุฒิวิทยา","ถนอมบุตร","พร้อมมิตรพิทยา","หัวหมากวิทยานุสรณ์","อนุบาลเด็กสากล","อนุบาลใจทิพ","อนุบาลกรสุภา","อนุบาลกาญจนาพร","อนุบาลชุติมา","อนุบาลทับแก้ว","อนุบาลพิบูลสิน","อนุบาลภัทรบุตร","อนุบาลราชพงษา","อนุบาลวรรณทิพย์ชุมชนคลองจั่น","อนุบาลวิมลทิพย์","อนุบาลศรีนวล","อนุบาลหัวหมาก","จารุวัฒนานุกูล","รุ่งอรุณ","ศิรินุสรณ์วิทยา","สมิทธิพงษ์","อนุบาลเสริมวิทย์","อนุบาลคุ้มเกล้า","อนุบาลนพรัตน์","วรรณสว่างจิต","อนุบาลวันเฉลิม","สุพิชญา","อนุบาลอภิสรา","เปรมฤดีศึกษา","เสริมปัญญาอนุบาล","มูลนิธิสตรีไทยมุสลิม","วาสุเทวี","อนุบาลเพาะปัญญา","อนุบาลเล็กประยูร","อนุบาลจิตตานนท์","อนุบาลพรประสิทธิ์ ประดู่ 1","อนุบาลสุพิศมร","ซินไตท้ง","นวพัฒน์วิทยา","พิริยะโยธิน","รัตนวิทยาบางซื่อ","วีระพิทยา","อนุบาลเจริญจรัมพรวิทยา","อนุบาลแสงโสม","อนุบาลศักดิ์สงวนวิทยา","เปรมสันต์","สรรพาวุธวิทยา","สุทธิบงกช","อนุบาลเจริญพงศ์","อนุบาลนวลทอง","อนุบาลพัสวี","อนุบาลศรีศึกษา","อรรถวิทย์","อนุบาลดุสิต","อนุบาลทานตะวัน","เขมะสิริอนุสสรณ์","บางอ้อศึกษา","บูรณวิทย์","ประมุขวิทยา","พิมลวิทย์","รัตนกุลอนุบาล","ศรีอุลัย","ศิริมงคลศึกษา","ศิริมงคลศึกษา แผนกอนุบาล","สตรีบูรณวิทย์","สตรีบูรณวิทย์แผนกอนุบาล","อนุบาลแสงทองอนุสรณ์","อนุบาลคุณแม่","อนุบาลบุษกร","อนุบาลมูลนิธิมัสยิดดารุลอิหซาน","อนุบาลฤชากร","อารียาศึกษา","อุดมศาสตร์พัฒนา","เยนเฮส์เม็มโมเรียล","กว่างเจ้า","ยุหมินพัฒนา","สัจจพิทยา","อนุบาลเปล่งประสิทธิ์","อนุบาลเสริมมิตร","อนุบาลจิดาภา","อนุบาลชวนชื่น","อัสสัมชัญคอนแวนต์","อัสสัมชัญคอนแวนต์สีลม","อาทรศึกษา","เบญจมินทร์","โสมาภา","ภัสสรานุบาล","อนุบาลเครือคล้าย","อนุบาลแก้วฤทัย","อนุบาลจิราวิทย์","อนุบาลชินวร","อนุบาล ณ ฤดี","อนุบาลพุทธชาด","อนุบาลมารีนิรมล","อนุบาลสายสุดา","อนุบาลอินทรารักษ์","ประเสริฐธรรมวิทยา","มาแตร์เดอีวิทยาลัย","สีตบุตรบำรุง","สุนีพิทยา","อนุบาลแสงประเสริฐ","อนุบาลจุไรรัตน","อนุบาลสุนี","ปิยะจิตวิทยา","กฤตศิลป์วิทยา","ศุภกรณ์วิทยา","อนุบาลจินดาพร","อนุบาลจินดารัตน์","อนุบาลดิสกล","อนุบาลมารียา","อนุบาลยุคลธร","อนุบาลวันทา","อนุบาลศรินทิพย์","บำรุงอิสลามวิทยา","ประสาทวุฒิ","สมานศึกษาวิทยา","อนุบาลบ้านบาตร","เรวดี","ธำรงวิทย์","รุจิเสรีวิทยา","สวนบัว","สัตย์สงวนวิทยา","อนุบาลเบญจมาศ","อนุบาลเพ็ญสันต์","อนุบาลดรุณา","อนุบาลพิณทิพย์","เลียงแสงทองอนุบาล","ใจรักอนุบาล","นารีนิรมล","บพิธวิทยา","พิพัฒนา","มูลนิธิวัดราษฎร์ศรัทธาธรรมสงเคราะห์","สมถวิล","สมาหารศึกษา","อนุบาลปรานี","อนุบาลปาณยา","อนุบาลวัฒนาสาธิต","วัดวชิรธรรมสาธิต","อนุบาลสวนดรุณ","สยามสามไตร","พิมานวิทย์","ภารตวิทยาลัย","ราชินี","สตรีวรนาถ","สุพมาศพิทยาคม","เผดิมศึกษา","ฐานปัญญา","ดำรงเรืองวิทย์","เซนต์ปีเตอร์ ธนบุรี","ทองพูน","ผดุงกิจวิทยา","สุจิณณ์วดี","สุธรรมศึกษา","สุภาคมวิทยา","อนุบาลดารวี","อนุบาลธีรานุรักษ์","อนุบาลบ้านสวน","เทพอักษร","สุดใจวิทยา","อนุบาลเรืองวรรณ","อนุบาลจิตรเกษม","ตรีวิทยา","วรมงคล","เซนต์ยอแซฟยานนาวา","สารสาสน์เอกตรา","สารสาสน์พัฒนา","อนุบาลบ้านทรงไทย","อนุบาลพระแม่แห่งยุติธรรม","อนุบาลมงคลวรรณ","อนุบาลมณีรัตน์","อนุบาลมลิวัลย์","เซนต์ดอมินิก","โกวิทธำรง","บ้านครัววิทยา","วัฒนศิลป์วิทยาลัย","สตรีประเทืองวิทย์อุรุพงษ์","สมาคมสตรีไทย","สวนมิสกวัน","สัมมาชีวศิลป","อนุบาลจารุณี","อนุบาลพันธ์พิศวัฒนา","อนุบาลอิ่มเอม","อำนวยศิลป์","เมตตาวิทยา","เยาวลักษณ์วิทยาธนบุรี","โรจนนิมิตวิทยา","ขจรโรจน์วิทยา","ขจรโรจน์วิทยา แผนกอนุบาล","สมรรถภาพวิทยา","สารสาสน์สุขสวัสดิ์","อนุบาลเยาวมิตร","อนุบาลแสงอารีย์","อนุบาลบริบูรณ์ศึกษา","อนุบาลปัญญาศักดิ์","อนุบาลรังสิมา","อนุบาลสุพัชชา","เชิดเจิมศิลป์","ประเวศพิทยาคาร","ศึกษาพัฒนา","อนุบาลเคหะร่มเกล้า","อนุบาลวังทอง","อนุบาลพร้อม","กัลยวิทย์","บุญฤดี","ฤทธิไกรศึกษา","สันติสุขวิทยา","อนุบาลเฉลิมขวัญ","อนุบาลเยี่ยมนุช","อนุบาลโชคชัยลาดพร้าว","อนุบาลดวงปัญญา","อนุบาลทองฤทัย","อนุบาลนิรมล","อนุบาลบ้านแสนรัก","อนุบาลปราโมชพัฒนา","อนุบาลวรวรรณา","อนุบาลสังสิทธิ","สุขฤทัย","เศรษฐบุตรอุปถัมภ์","แต่งตั้งวิทยา","บางกอกศึกษา","ศิริกุลพิทยา","อนุบาลจิตต์นัฐดา","อนุบาลบ้านครู","อนุบาลรัชนีบูล","อนุบาลศรีวรางค์","อุดมศึกษา","แสงหิรัญ","ไทยคริสเตียน","พระแม่มารีพระโขนง","วัฒนาวิทยาลัย","อนุบาลมิตรเด็ก","ประสานวิทย์วัฒนา","ภักดีวิทยา","สวนรัฐวิทยา","อโศกวิทย์อ่อนนุช","อนุบาลเทพสุดา","อนุบาลใจปราณี","อนุบาลบ้านริมคลอง","อนุบาลศรีเสริมวิทย์","อนุบาลสายทิพย์","โสมาภานุสสรณ์","นรรัตน์รังสฤษดิ์","อนุบาลเฟื่องฟ้า","เผยอิง","กุหลาบวัฒนา","กุหลาบวิทยา","เซนต์หลุยส์ศึกษา","เธียรประสิทธิ์ศาสตร์","เบญจวรรณศึกษา","โกศลวิทยา","ชาญเวทย์ศึกษา","ตรอกจันทน์วิทยา","นิพัทธ์วิทยา","ศิลปวัฒนา","ศุภวิทย์","อนุบาลอนันตศานติศึกษา","อนุบาลแสงเรืองศึกษา","อนุบาลแสงอรุณพระนคร","อนุบาลจันทร์เจ้า","อนุบาลพิรินทร","อนุบาลอารีวิทย์","นิเวศน์วารินทร์","ประเทืองทิพย์วิทยา","ระเบียบศึกษา","วรนาถวิทยา","อนุบาลเพ็ญวิจิต","อนุบาลบ้านอัมรินทร์","อนุบาลปิยะวิทย์","อนุบาลมะลิวรรณวิทยา","อนุบาลรัตนฉัตร","อนุบาลฤทธิยะวรรณาลัย 2","กรพิทักษ์ศึกษา","จันทศิริวิทยาและเทคโนโลยีเอเซียบริหารธุรกิจ","วีรสุนทร","อนุบาลเสริมปัญญาพุดตาน","อนุบาลก้องหล้า","อนุบาลยุวมิตร","อนุบาลยูรดา","เซนต์เทเรซา","สุเหร่าคู้วิทยา","หนองจอกกงลิบฮัวเคียว","อนุบาลธนามาศ","เจริญผลวิทยา","กองทัพบกอุปถัมภ์ไกรอำนวยวิทยา","ชาลีสมุทร","สารินันทน์ศึกษา","อนุบาลทอฝัน","อนุบาลเยาวบุตร","อนุบาลฉัตรเฉลิม","อนุบาลดวงจิต","อนุบาลธนินทร","อนุบาลน้องหนู","อนุบาลสว่างวรรณ","ชาญวิทย์","ดลวิทยา","สมฤทัย","สิริเทพ","อนุบาลโชคชัย","อนุบาลจุฑาภรณ์","อนุบาลทรงวิทย์","อนุบาลลีนา","อนุบาลวัฒนานิเวศน์","อนุบาลสีชมพูมอนเทสเซอริ","ชัยจิตต์วิทยา","ถาวรวิทยา","หมู่บ้านเด็ก","อนุบาลเมฆบัณฑิต","อนุบาลค่ายสุรสีห์","ยู่เฉียวเซียะเสี้ยว","อำนวยวิทย์กาญจนบุรี","สารสาสน์วิเทศกาญจนบุรี","วินัยนุกูล","ศิริวิทยานุบาล","อนุชนศึกษา","สหคริสเตียนศึกษา","เขาวงวิทยา","อนุบาลสมฤทัย","ชาญยุทธวิทยา","สตรีชาญยุทธวิทยา","อนุบาลแสงตะวัน","อนุบาลรัตนากาฬสินธุ์","อนุบาลบานเย็น","อนุบาลปิยวรรณ","แสงนิลทวนทองวิทยา","เซนต์ยอแซฟกุฉินารายณ์","เพิ่มพูนวิทยาคมกาฬสินธุ์","อนุบาลบุญมีวิทยา","คุรุมิตรประสิทธิ์ศิลป์","ไตรมิตรวิทยาเสริม","อนุบาลเปรมจิต","อนุบาลสรรพเลิศ","กาญจนะศึกษา","จงสวัสดิ์เจริญวิทยา","ทรัพย์สถิตย์วิทยาคาร","วรนาถวิทยากำแพงเพชร","วัฒนศิริวิทยา","องอาจวิทยา","อนุบาลจุฬารัตน์","อนุบาลวาริน","อุทิศศึกษา","วชิรนิติโสภณ","ศรีวรลักษณ์","สุมนเมธี","อนุบาลจิตรวีศึกษา","อนุบาลอุทิศศึกษา","เทพผดุงศิษย์ศึกษา","มิตรอารีวิทยาสิน","สหะราษฎร์ศึกษา","อนุบาลมิ่งขวัญ","วรรณวัฒน์ศึกษา","ดรุณานุกูล","อนุบาลธรรมรัตน์","อนุบาลดรุณานุกูลลานกระบือ","อนุบาลทันวิทยา","ขอนแก่นคริสเตียน","พระกุมารเยซูขอนแก่น","พัฒนาเด็ก","มหาไถ่ศึกษาขอนแก่น","วรรณรัตน์ศึกษา","สุรัสวดี","อนุบาลเคหะชุมชนขอนแก่น","อนุบาลเพชรรัตน์","อนุบาลเพียงนภา","อนุบาลแก้วกรุณา","กัลยาณีวิทยา","อนุบาลกุลศิริ","อนุบาลปิ่นทิพย์","อนุบาลพรทิพย์","อนุบาลพิมานเด็ก","อนุบาลภาคตะวันออกเฉียงเหนือ","อนุบาลมณีอนุสรณ์","อนุบาลคริสเตียนมารีย์พร","อนุบาลราตรี","อนุบาลสวนสน","พัฒนาการศึกษา","สุดารัตน์วิทยาคม","อนุบาลนวลน้อย","มหาไถ่ศึกษาโนนสมบูรณ์","อนุบาลศักดิ์สุภา","ชุมแพวิทยา","อนุบาลชุมแพ","อนุบาลรวมฤทัย","อนุบาลราษฎร์อำนวยศิลป์","มนตรีศึกษา","อนุบาลขวัญรัตน์","อนุบาลพูนสวัสดิ์","เอี่ยมไพศาล","กรุณาศึกษา","มูลนิธิบ้านไผ่วิทยา","อนุบาลมหาไถ่ศึกษาบ้านไผ่","มหาไถ่ศึกษาเมืองพล","อนุบาลพัฒนาเด็กศรีวิสุทธิ์","มัญจาคริสเตียน","อนุบาลสุดรัก","อนุบาลอภิรดี","บุญสมวิทยา","บุญสมอนุบาล","ลาซาลจันทบุรี (มารดาพิทักษ์)","อนุบาลกัลยา","อนุบาลประศาสน์วิทยา","ศรีหฤทัย","อำนวยศึกษา","ยอแซฟวิทยา","สุดแสวงวิทยา","ปะตงวิทยา","เซนต์หลุยส์ ฉะเชิงเทรา","ดาราสมุทร","ปัญจพิทยาคาร ","สันติภาพ","รุ่งโรจน์วิทยา","สุตะบำรุงพิทยาคาร","บางน้ำเปรี้ยวกงลิ","อนุบาลเจริญรัตน์","มารดานฤมล","วัฒนาลัย","อนุบาลขวัญตา","อนุบาลจันทรา","ประสาทวิทยา","จุฑาทิพย์","ธีราวิทยา","พนมอิทธิศึกษา","อนันต์วิทยา","เกษมวิทย์","เมืองชลพิทยา","แสนสุขศึกษา","กล่อมปฐมวัย","กาญจนะวิทยา","ธารทิพย์วิทยา","พงศ์สิริวิทยา","วุฒิวิทยา","ศุทธรัตน์","ศุทธรัตน์วัฒนาลัย","สถาพรพิทยา","นารานุบาล","สามมุกคริสเตียนวิทยา","สุขุมวิทยา","สุตา","อนุบาลบูรณิจฉ์","อนุบาลภักดีพรรณ","ร่มไม้","อนุบาลสมัครมิตรวัฒนา","อนุบาลสว่างวิทย์","ศรีมณีวิทยา","จุฬเทพ","ตันตรารักษ์","ทนาพรวิทยา","ผู้รู้ ญ ส.ส.80 ในมูลนิธิวักญาณสังวราราม","พัทธยาอรุโณทัย","มารีวิทย์","วุฒิโชติ","ศรีสุวิช","สาธิตอุดมศึกษา","อนุบาลเพ็ญศิริ","อนุบาลทนาพรวิทยา","บ้านรถไฟ","อนุบาลมารีวิทย์","อักษรพัทยา","เฮงฮั้ว","จิ้นฮั้ว","จิรพลวิทยา","บุญประทีปวิทยาคาร","สมคิดจิตต์วิทยา","นันทนวิทย์","บ้านเหล่าป่าเป้ด","อนุบาลพรประสงค์","เพลินจิตวิทยา","อนุบาลประชาสงเคราะห์","เฉลิมชัยศึกษา","เซนต์ปอลคอนแวนต์","ดวงมณี","บรรณพันธ์ศึกษา","บุญจิตวิทยา","มัธยมสัมมาชีวศิลปบางพระ","ประเสริฐสุข","อัสสัมชัญศรีราชา","จุฬเทพบางเสร่","ณัฏฐเวศม์","นาวิกโยธินบูรณะ","สัตหีบ","วัฒนะโชติ","วัฒนาชัยนาท","อักษรประสิทธิ์","อนุบาลกิตติกร","สวนวิทยา","อนุบาลบ้านสิทธิวงศ์","มงคลศึกษา","ไพเราะวิทยา (แผนกอนุบาล)","มารีย์อุปถัมภ์ชัยภูมิ","อนุบาลบ้านเด็กดี","พุฒิชัยวิทยา","อนุบาลณัฐพันธ์ 1","ศรีเทพบาล","มะนะศึกษา","อนุบาลบ้านทับทิม","อนุบาลเรืองชาญ","อนุบาลไพโรจน์วิทยา","ชุมพรศึกษา","ฝวาหมินกงลิ","สหศึกษา","นิรมลชุมพร","อนุบาลดรุณรัตน์","อนุบาลปานฤทัย","บุณยสมบัติวิทยา","ตาแจ้งวังตะกอ","หลังสวนเทศบาลอุปถัมภ์","หลังสวนคริสเตียน","อนุบาลเกษมวิทยา","โพธิ์วิเชียรชัย","ดรุโณทัย","ตรังคริสเตียนศึกษา","บุญเหลือเกื้อคง","บูรณะรำลึก","วิเศษกาญจน์","อนุบาลกันตังศึกษา","เมธาวิทยา","ทุ่งยาววิทยา","สว่างราษฎร์วิทยา","วิวัฒน์วิทยา","อนุบาลสว่างไสว","กิตติวิทยา","มารดานุสรณ์","สุนันทาวิทยา","นคราศึกษา","ตากกวง","เซนต์ฟรังซีสเซเวียร์มัธโนทัย","เซนต์ฟรังซีสเซเวียร์มัธโนทัย (แผนกอนุบาล)","อนุบาลสีห์อักษร","เซนต์โยเซฟแม่ระมาด","ภัทรวิทยา","ราษฎร์วิทยา (ตี่มิ้ง)","ศิริวรรณศึกษา","อนุบาลการุณย์","อิสลามศึกษา","ธรรมราชานุสรณ์","เหลียนหัว","นายกวัฒนากร วัดพราหมณี","นายกวัฒนากรวัดอุดมธานี","อนุบาลคุณากร","อนุบาลจุฬาทิพย์","นายกวัฒนากรบ้านนา","มาลาสวรรค์พิทยา","นักบุญยอแซฟอุปถัมภ์ หนองรี","อนุบาลคริสตสงเคราะห์","ธรรมาภิสมัย","บำรุงวิทยา","อนุบาลเสริมปัญญา","อนุบาลจันทร์สว่างกูล","อนุบาลศิริวรรณ","อนุบาลสุธีธร","อำนวยวิทย์นครปฐม","อนุบาลชโลทร","ราษฎร์บำรุงวิทยา","สหบำรุงวิทยา","เดชอนุสรณ์","เม่งฮั้วกงฮัก","แสงทองวิทยานครชัยศรี","จารุวรรณวิทยา","สาธิตวิทยา","เจี้ยนหัว","เทพนิมิตวัฒนา","เอกดรุณ","อนุบาลเอกปฐม","นักบุญเปโตร","นาคประสิทธิ์","ภัทรบุตร","ยอแซฟอุปถัมภ์","สกลวิทยา","ตงเจี่ย","สันตยานันท์","อนุบาลเรณูนคร","วัดบึงเหล็ก","อนุบาลเชษฐานงนุช","อนุบาลธาตุพนม","เซนต์ยอแซฟนาแก","อนุบาลมีสุข","โคราชวิทยา","โพธิ์พรรณวิทยา","ไชยมนัสศึกษา","มารีย์รักษ์","สมบูรณ์วิทยานุกูล","สุรนารายณ์วิทยา","อนุบาลเยาวนารถ","อนุบาลแสนยวิทยาภูมิ","อนุบาลกองบัญชาการช่วยรบที่ 2","อนุบาลค่ายสุรนารี","อนุบาลชัยศิริ","อนุบาลดวงแขวิทยา","อนุบาลบพิตร","อนุบาลบวรนครราชสีมา","อนุบาลบ้านคุณหนู","อนุบาลวัดสะแก","วัดสุทธจินดา","อนุบาลหลานย่าโม","อนุบาลอินทรา","อัสสัมชัญนครราชสีมา","อุบลรัตน์","อนุบาลแพรวไพลิน","อนุบาลเอราวัณ","จุ้ยฮั้ววิทยา","พิทักษ์ภูเบนทร์","พิทักษ์ภูเบนทร์ 7","พิทักษ์ภูเบนทร์ 2","มัธยมพุทธเกษตรวัดโนนเมือง","อนุบาลจรัสพงษ์","อนุบาลมีมั่งคั่ง","เหรียญทองวิทยา","พงษ์ศิริวิทยา","อมรศิลป์","ดงเค็งศึกษา","อนุบาลจินดา","มารีย์ธงชัย","อนุศาสน์วิทยา","แสงสุริยาวิทยา","กีรติศึกษา","ถนอมศิษย์วิทยา","บุญเจริญวิทยา","ประชานุสรณ์","สายสัมพันธ์","ธารทิพย์ศึกษา","วัฒนวิทยา","อนุบาลแก้วตา","พิทักษ์ภูเบนทร์ 3","อนุบาลบำรุงการ","เซนต์โยเซฟศึกษา","มงคลกุลวิทยา","อนุบาลจุรีพันธ์","เก้งเต๊ก","อนุบาลจิรเศรษฐ์","เกตุชาติศึกษา","ชุบธรรมวิทยา","ชูศิลป์วิทยา","นรรถยาพิศนุสรณ์","พระมหาธาตุมูลนิธิมัธยม","พริ้มพิทยานุสรณ์","มารีย์พิทักษ์ศึกษา","ศรีอนุบาล","สตรีจรัสพิชากร","มูลนิธิสหมิตรศึกษา","หนองนกประสาทศิลป์","อนุบาลดำรงค์ศาสน์","อนุบาลธนสาร","อนุบาลปิยะรัตน์","อนุบาลภิญญรัตน์","อนุบาลลูกรัก","อนุบาลวิเชียรรัตน์","อำมาตย์พิทยานุสรณ์","จันดีพิทยาคม","พิศิษฐ์อนุสรณ์","พึ่งตนเอง","อนุบาลเพ็ญอาภา","อุดมปัญญาจารย์","เจริญมิตร","เจริญวิทย์","ไพบูลย์วิทยา","ฉวางสงเคราะห์","ประสานศิลป์ศึกษา","อักษรวิทย์","ชะอวดวิทยา","มัธยมศักดิศิลปิน","อนุบาลพรอุดม","อนุบาลลูกแก้ว","จุฑาวิทย์","สตรีดำรงเวท","สระแก้ววิทยา","อนุบาลวัยวัฒน์","อนุบาลอินทิรา","อุบลวิทยา","อนุบาลไกรแก้ว","วิทยานุเคราะห์","สุขสวัสดิ์วิทยา","สุมณฑาศึกษา","กาญจนศึกษา","มนต์หทัย","รัตนศึกษา","รัตนศึกษาชนปรีดา","อนุบาลคำแหง","ประชาอุทิศมูลนิธิ","สหมิตรบำรุง","อนุบาลจิตพรรณ","เปรมฤทัยศึกษา","แพทยกิจพิทยา","ภูมิสถิตวิทยา","หลวงครูวิทยา","อนุบาลแพทยกิจพิทยา","อนุบาลชุมสุข","อนุบาลพรธิรา","พรหมประสาทวิทย์","อนุบาลกมลทิพย์","อนุบาลพิปูนวิทยา","โคกครามพิชากร","ทิพย์กองลาศวิทยา","มัธยมวีรศิลปิน","ร่อนพิบูลย์วิทยา","อนุบาลสกุลดี","บ้านเด็กศึกษา","รุจิธรรมวิทยา","คุณาธารวิทยา","ประสาทธรรมวิภัช","อนุบาลเจริญจิต","อนุบาลโชติกร","อนุบาลสิทธิพร","ไพศาลศึกษา","ราษฎร์นิยมวิทยา","ปวีณาวิทยา","แสงสวรรค์","ประชานุเคราะห์","ยุวบัณฑิตวิทยา","ลาซาลโชติรวีนครสวรรค์","วิชาวดี","วิสุทธิศึกษา","สหวิทยาศึกษา","อนุชนวัฒนา","อนุบาลปราณีวิทยา","อนุบาลสมบูรณ์","อนุศาสน์สวรรค์","โกรกพระพิทยาคม","กิจจานุศาสตร์","จิตศรัทธาวิทยานุสรณ์","ศรีอุทิศวิทยา","ขวัญชัยทับกฤช","วันทาศิริศึกษา","สหวิทยานุสรณ์","สหสาธิต","พิพัฒน์ศึกษา","รังสรรค์วิทยา","เคี่ยวมิ้นเซียะเซี่ยว","จันทนานุสรณ์","จันทร์ฉายวิทยา","ประดับวิทย์","ปรียาโชติ","วรนาถพิทยา","อำนวยวิทย์ (หน้ากองบิน 4)","เสรีวิทยา","เยาวชนพัฒนา","พยุหะวิทยา (วัดเขาแก้ว)","อนุบาลเสริมสวัสดิ์วิทยา","บูรพาศึกษา","พรหมอนุสรณ์","สันติวัน","เทพประทานพร","เล็กโกเมศอนุสรณ์","การัญศึกษา","ธัมมสิริศึกษา","นนทบุรีคริสเตียนวิทยา","พิทักษ์นครานุสรณ์","พัฒนวิทย์","ศรีรัตโนภาศ","สมานพิชากร","อนุบาลเพื่อนเด็ก","อนุบาลเรวดีนนทบุรี","อนุบาลดวงใจ","อนุบาลทรายทอง","อนุบาลนิตา","อนุบาลบรรลือทรัพย์","อนุบาลผึ้งน้อย","อนุบาลมณียา","อนุบาลยุวัจฉรา","อนุบาลสุรีลักษณ์","อนุบาลอัมพรรัตน์","อนุบาลอิศรานล","เปรมประชาวัฒนา","ญาโณทัย","อนุบาลกุลนันท์","รัตนบัณฑิตวิทยา","ศึกษาบัณฑิต","เทพพิมานพิทยา","กสิณธรเซนต์ปีเตอร์","ดรุณวิทย์ศึกษา","นันทนวรวิทย์","บางบัวทองราษฎร์บำรุง","พระแม่สกลสงเคราะห์","พึงรำลึก","ศิริมงคลศึกษา บางบัวทอง","อนุบาลเลิศวินิต","อนุบาลจัตุพร","จิรดา","ธนพร","เซนต์ฟรังซีสเซเวียร์","กุมุทมาส","ชลประทานวิทยา","ดารานุกูล นนทบุรี","พิชญศึกษา","มูลนิธิปากเกร็ดวิทยา","ฤกษบุตร์ (สะอิ้งอนุสรณ์)","วัฒนพฤกษา","วัฒนพฤกษา 2","อนุบาลจุติพร","อนุบาลระพีพรรณ","วรรณทิพย์วิทยา","อัมพรไพศาล","บางนราวิทยา","พิมานวิทย์นราธิวาส","สวนสวรรค์วิทยา","อนุบาลศรสมบูรณ์","วุฒิศาสน์วิทยา","พิพัฒน์ทักษิณอนุบาล","ภัทรียาอนุบาล","รือเสาะวิทยา","ศรีทักษิณ","เกษมทรัพย์","บุณยลาภนฤมิต","รังผึ้ง","อนุบาลบ้านสุชาดา","น่านคริสเตียนศึกษา","อนุบาลกุลหทัย","พระคุณานุบาลแม่จริม","อนุบาลนิธากร","อนุบาลอิมมานูเอลปัว","มารีย์อนุสรณ์","อนุบาลธีรา","ฮั่วเคี้ยว","อนุบาลกัลยาประสิทธิ์","มารดาวนารักษ์","เอื้อแววมณี","อนุบาลทศพร","อนุบาลสายสัมพันธ์","นิภาศิริ","บ้านใหม่วัฒนา","บ้านพลอย","ประคองศิลป์","พิทักษ์นครินทร์","อนุบาลเมืองเอก","อินทุสุตศึกษา","ทวิวิชช์","ยิ่งยศอนุสรณ์","แก้วสว่างวิทยา","ทิพพากรวิทยาการ","ธัญวิทย์","บรรจบรักษ์","มูลนิธิธัญวิทยา (ตงมิ้น)","รัตนโกสินทร์-รังสิต","วนิษา","ปิยวัฒนศาสตร์","รังสฤษฎ์สองภาษา","อนุบาลรังสิต","อนุบาลศิริเสนา","ประชุมวิทยา","เตรียมบัณฑิต (บริบูรณ์ศิลป์ศึกษา)","เฟื่องฟ้าวิทยา","ไกรลาศศึกษา","ผ่องสุวรรณวิทยา","ระเบียบวิทยา","วงศ์ไพฑูรย์วิทยา","ศรีจิตรา","สีวลี","อนุบาลทีปรกร","ประสานมิตร","อนุบาลลัดดาวรรณ","จันทรศึกษา","พระแม่มารีประจวบคีรีขันธ์","ศิริวิทยา","ห้วยหนำ","วราวัฒน์วิทยา","สหมิตรวิทยาคม","อรุณวิทยา","มัธยมนพคุณ","เชวงศักดิ์ศึกษา","กำเนิดวิทยา","ชินนุกูลวิทยา","รักษ์วิทยา","วันทามารีอา","วิเศษวิทยา","วิเศษศึกษา","สายวิทยา","มัธยมสาธุการวิทยา","สมถวิลหัวหิน","หัวหินวิทยาลัย","อนุบาลดรุณศึกษา","โชติพิทยากร","จงหมิน","ฉัตรลิตราศึกษา","สุธีวรราษฎร์รังสฤษฎ์","เจียหมิน","กบินทร์จริยาคม","มารีวิทยากบินทร์บุรี","อนุบาลอุดมวิทย์","ผะดุงศิษย์พิทยาประจันตคาม","เทวรักษ์","มารีวิทยาศรีมโหสถ","อามานะศักดิ์","จิปิภพพิทยา","บุญมีวิทยา","อนุบาลแสงสันติปอซัน","มัสญิดตะลุบัน","ฮั่วหนำ","ประสาทวิทย์","มัธยมผดุงวิทยา","ราษฎร์บำรุงศิลป์","อนุบาลเสนา","อนุบาลผดุงเสนา","แสงทวีปวิทยา","แสนโกศิกนุสรณ์","ไตรราชวิทยา","ไตรอรุณศึกษา","อนุบาลศูนย์ศิลปาชีพบางไทร","เสริมมิตรวิทยา","ประชาศึกษา","ศิริเสนาวิทยา","อรุณประเสริฐ","รอตเสวกวิทยา","ปิยมิตรวิทยา","อนุบาลคุณากรวิทยา","บุญสิษฐ์วิทยา","พินิตประสาธน์","อนุบาลดรุณวิทยา","จุนวิทยา","วัดบุญเกิดวิทยาแสงส่องหล้า 1","โคกกลอยวิทยา","สุทธินอนุสรณ์","อนุบาลนิลุบล","บุญแสวงวิทยา","เรวดีพัทลุง","เทศบาลจุ่งฮั่ว","มัธยมพัทลุงวิทยา","วีรนาทศึกษามูลนิธิ","อนุบาลช้างน้อย","อนุบาลธิดาเมตตาธรรมพัทลุง","อนุบาลเรวดีควนขนุน","อนุบาลธนะวิทย์","อนุบาลสุขคณะ","อนุบาลธรรมศาสตร์","ยอแซฟพิจิตร","เทศบาลราษฎร์เจริญ","อนุบาลวชิร","อนุบาลวชิรวิทย์","จันทวิทยา","นรบุตรศึกษา","บัณฑิตศึกษาลัย","โถงจื้อบางมูลนาก (สหสงเคราะห์วิทยา)","เซนต์นิโกลาส","โรจนวิทย์มาลาเบี่ยง และอนุบาลโรจนวิทย์มาลาเบี่ยง","ไทยกล้าวิทยา","ธีรธาดา พิษณุโลก","อนุบาลโรจนวิทย์","อนุบาลโรจนวิทย์ป้อมเพชร","อนุบาลประชาราษฎร์","อนุบาลวังจันทน์","อนุบาลห่วงดรุณวิทยา","อภิชาตบุตรวิทยา","ศึกษาวิทย์","เทศบาล 1 หนองตมศึกษา (จิ้นตง)","อินทุภูติพิทยา","เทพอำนวยวิทยา","ขจรเกียรติพัฒนา","ภูเก็ตไทยหัว","วิทยาสาธิต","อนุบาลกนกขวัญ","อนุบาลกาญจนวัฒน์วิทยา","อนุบาลบุษบง","อนุบาลภูเก็ตกุลธิดา","อนุบาลมุสลิมภูเก็ต","ถลางวิทยา","อนุบาลถลางวิทยา","จันทนภาศึกษา","อนุบาลเกียรติขจร","อนุบาลจอนวิทยกุล","อนุบาลกิติยา","อภิสิทธิ์ปัญญา","มัธยมวัดกลางโกสุม","อนุบาลพิสมัย","อนุบาลสายรุ้ง","มัธยมชาญวิทยา","เทศบาลนาเชือก","อนุบาลมาลีรัตน์","อนุบาลเอี่ยมสุข","รุ่งอรุณวิทย์","ท่านพระสารีบุตร","อนุบาลสุพร","ยโสธรวิทยาคาร","ศรีธรรมวิทยา","อนุบาลอินทร์-โฮม","อนุบาลบ้านเด็กยศวดี","ซ่งแย้ทิพยา","มารีย์นุเคราะห์","อนุบาลแก้วปัญญาอุปถัมภ์มหาชนะชัย","จงฝามูลนิธิ","ถนอมศรีศึกษา","ธีรวิทยา","วชิรศึกษา","เพ็ญศิริ","ผดุงประชา","มานะศึกษา","ยะลาบำรุงผดุงประชา","รังสีอนุสรณ์","รัชตะวิทยา","ศานติธรรม","อนุบาลประณีต","อนุบาลศรีบำรุง","อนุบาลศรีรามันห์","ช.วิทยา","ศรีศิลปวิทยาลัย","เสลภูมิวิทยาสันต์","ศรีอรุณวิทย์เสลภูมิ","สหมิตรพิทยา","อนุบาลบุญทวีวัฒนาวิทยา","อนุบาลเอกกุมาร","กมลวิทยา","การกุศลวัดบ้านก่อ","อนุบาลค่ายสมเด็จพระพุทธยอดฟ้าจุฬาโลกมหาราช","เชื้อจรูญวิทย์","ศรีอรุโณทัย","สหายวิทย์","อนุบาลกิจติมาพร","เซนต์โยเซฟระยอง","กวงฮั้ว","ตรีวิทย์ศึกษา","อารีย์วัฒนา","มณีวรรณวิทยา","วุฒินันท์","ศิริพรระยอง","สมคิดวิทยา","อนันต์ศึกษา","อัสสัมชัญระยอง","รุ่งนภาพิทยา","จินดาวัฒน์","อนุบาลหลานรัก","สัจจศึกษา","อรวินวิทยา","ดรุณาราชบุรี แผนกสองภาษา","ดรุณาราชบุรี","กองทัพบกอุปถัมภ์โยธินวิทยา","กองทัพบกอุปถัมภ์บูรณวิทยา","นารีวิทยา","พิบูลสงครามอุปถัมภ์ราชบุรี","สุริยวงศ์ ราชบุรี","แย้มวิทยการ","มัธยมวัดไทรราษฎร์อุปถัมภ์","ราษฎร์บำรุงวิทย์","ธารพระพรวิทยานุสรณ์","สมศักดิ์วิทยา","อนุบาลวัดสนามชัย ","ดำเนินวิทยา","วันทามารีอาราชบุรี","พัชรวิทยา","อนุบาลวัดโชติทายการามสงเคราะห์","อภิบาลกุลบุตร","ฮั่วเคี้ยวกงลิบไต้ฮึน","ธีรศาสตร์","นารีวุฒิ","บ้านโป่งวิทยาคม","วังตาลวิทยา","วัดบ้านโป่ง ","สารสิทธิ์พิทยาลัย","เรืองวิทย์พระหฤทัย","เมืองละโว้วิทยา","กำจรวิทย์","จินดารัตน์","กองทัพบกอุปถัมภ์ค่ายนารายณ์ศึกษา","กองทัพบกอุปถัมภ์สองเหล่าสร้าง","อนุบาลบรรจงรัตน์","บำรุงศึกษา","วรกิจพิทยา","วรนาถวิทยาลพบุรี","วรพิทยา","อนุบาลเย็นศิระ","จารึกล้อมวิทยา","ทศธรรมศึกษา","ศรีแก้วอนุกูล","แก้วประทานพรวิทยา","ทองทาบพิทยา","ยงค์สุรีศึกษา","อารีสวัสดิ์","ดอนทองราษฎร์วิทยา","รุ่งนิวัติวิทยา","พระวรสาร","สุเทพวิทยาลัย","เพ็ญพัฒนา","เพ็ญจิตตพงษ์ ","อนุบาลเพ็ญจิตตพงษ์","อักษรศิลป์","เคนเน็ตแม็คเคนซี","ไตรภพวิทยา","ประชาวิทย์","พินิจวิทยา","มัธยมวิทยา (มูลนิธิเพื่อการศึกษาประชาวิทย์ - มัธยมวิทยา)","ลำปางวิทยา","วิชชานารี","อนุบาลทิวฟ้า","อรุโณทัย","อัสสัมชัญลำปาง","ศักดิ์สุนันท์วิทยา","ดอนไชยวิทยา","ภินิตย์อัฐพิทยาลำปาง","อนุบาลสมฤทัยวิทยาลำปาง","เลาหจิตรวิทยาลำพูน","ใบบุญลำพูน","มงคลวิทยา","อนุบาลใบบุญ","รพีเลิศวิทยา","อรพินพิทยา","อนุบาลบ้านทา","อนุบาลสุทธิวงศ์ศึกษา","จิรพิทยา","บ้านโฮ่งวิทยา","อนุบาลกุลภัทร","ละอองทิพย์","ใบบุญป่าซาง","ธรรมสาธิตศึกษา","ธรรมสาธิตศึกษาแผนกอนุบาล","อนุบาลลี้","วัดมหาพุทธาราม","มานิตวิทยาคม","อรจันทร์วิทยา","ขุขันธ์ราษฎร์บำรุง","เคียวนำ","อุทุมพรวิทยา","เซนต์โยเซฟท่าแร่","เซนต์ยอแซฟสกลนคร","นิรมลวิทยา","อนุบาลจิตธิดา","ประภัสสรสกลนคร","อนุบาลร่วมฤทัย","อนุบาลร่มเกษ","อนุบาลเพ็ญจันทร์บ้านม่วง","เมธาศึกษา","อนุบาลปิยะธิดา","อนุบาลเพ็ญจันทร์","อนุบาลวาริชภูมิ","อนุบาลสุวรรณเทน","อนุบาลเทพา","แจ้งวิทยา","จุลสมัย","สงขลาวิทยามูลนิธิ","สตรีวชิรานุกูล","สายพิณ","สุมิตรา","หวังดี","นุกูลวิทยาสรรค์","อนุบาลสุพัตรา","ประชาบำรุงวิทย์","อนุบาลดิษฐพร","พรหมเจริญวิทยา","กิติคุณ","เจริญรัตน์ศึกษาวัฒนา","จิราภรณ์","สมพงศ์วิทยาจะทิ้งพระ","สุขเกษมวิทยา","อนุบาลเสนพงศ์","อนุบาลแก้วบุตร-คูสกุล","อนุบาลวงศ์วิทย์","บัวหลวง","เทพอำนวยหาดใหญ่","แสงทองวิทยา","กิตติวิทย์","ทิพรัตน์วิทยาคาร","ผดุงศาสตร์วิทยา","พลวิทยา","สมัยศึกษา","สมานคุณวิทยาทาน","สวัสดิ์บวร","สหศาสตร์วิทยาคาร","หาดใหญ่อำนวยวิทย์","อนุบาลกุลจินต์","อนุบาลบุญเลิศอนุสรณ์","จงหัว","ปิยนุสรณ์ศึกษา","อนุบาลทักษิณสยาม","อนุบาลรุ่งทิพย์","อนุบาลอมรรัตน์","อนุบาลเพชรกาญจน์","เฉลิมวิทยา","เซนต์โยเซฟทิพวัล","เซนต์โยเซฟบางนา","เสงี่ยมพิทยานุกุล","จตุพรวิทยา","ฉัตรสุดา","ซิกข์วิทยาลัย","ดรุณรัตน์","ดิษลี","ทรงวิทยา","นพคุณวิทยา","บุรารักษ์","ป้วยฮั้ว","มนตเสรี","มัธยมวัดศรีจันทร์ประดิษฐ์ฯ","ทรงสรรพวิทย์ (ล้วนพฤกษา)","ศรีวิทยาปากน้ำ","สิริวุฒิวิทยา","สุขเจริญผล","สุมานัน","อนุบาลเคหะบ้านใหม่","อนุบาลเทพดรุณ","อนุบาลเทพารักษ์","อนุบาลกิติมา","อนุบาลจตุรมุก","อนุบาลจันทนา","อนุบาลตันติภักดิ์","อนุบาลนนนที","อนุบาลบ้านไทรงาม","อนุบาลบ้านหนู","อนุบาลบุษยมาส","อนุบาลพัฒนาสุข","อนุบาลมิตรอุดม","อนุบาลรักษ์ดรุณ","สวนแพรกษาจงสิน","อนุบาลสวนปากน้ำ","อนุบาลสุวิชา","อนุบาลอนงค์เวท","อู่ทิพย์","อนุสาส์นวิทยา","อนุสาสน์วิทยาสมุทรปราการ","อัสสัมชัญสมุทรปราการ","อุ่นอารีวิทยา","อนุบาลวชิรา","ไพรีขยาด","บางพลีพัฒนศึกษาลัย","สันต์เสริมวิทย์","สาธิตบางนา","อนุบาลมงคลทิพย์","อนุบาลอังสนา","เยาวนารีคริสเตียน","กาญจนวิทยา","ณัฎฐเวศม์","เซนต์แมรี่","ปัญจนะวิทย์","สันติดรุณ","สายอนุสรณ์","สำราญวิทยา","อนุบาลเจริญวัย","อนุบาลเซ็นดาณี","อนุบาลบัวขาว","อนุบาลมารดา","อนุบาลศิริวิทย์","อนุบาลสดุดี","อำนวยวิทย์","เทพกรศึกษา","นพคุณศึกษา","สารสาสน์สมุทรสาร","อนุบาลเทพกร","กงหลีเจี้ยนหมิน","ประกอบวิทยา","นารีวัฒนา","อนุกูลวิทยา","เจริญศิลป์ศึกษา","มหาชัยคริสเตียนวิทยา","ศรีทัศน์ดำรงวิทย์","อนุบาลน้อมจิตต์","อนุสรณ์ศุภมาศ","อนุบาลสมฤดี","อันนาลัย","ปัญจพรพิทยา","ประชินนุสรณ์","สารสาสน์วิเทศบ้านแพ้ว","บ้านแพ้ววิทยา (ตี่ตง)","ชุมชนพัฒนา","อนุบาลจิตละมุน","อนุบาลบ้านจันทร์","พรพงษ์กุล","สำเร็จวิทยา","สว่างรัตน์พิฉายศึกษา","อนุบาลปิยะพร","อนุบาลยุววิทยา","แสงวิทยา","จินเต๊อะแก่งคอย","จำรัสวิทยา","มัธยมอนุกูลวิทยา","วัฒนานุกูลวิทยา","รอดณรงค์ศึกษา","บำรุงปัญญา","กลั่นวิทยา","อนุบาลวิชชากร","โพธิรัตน์วรานุสรณ์","อินทโมลีประทาน","ใจเพียรวิทยานุสรณ์","เจริญสอนวิทยา","วิจิตรศึกษา","นาคประดิษฐ์วิทยา","ปราสาทวิทยา","ศรีอุดมวิทยา","เทศบาล 1 (สหราษฎร์วิทยา)","สิงห์อุดมวิทยา","อุดมศิลป์ (โพธิลังการ์มูลนิธิ)","กวางตง","อนุบาลสายธรรม","อนุบาลสมประสงค์","ศรีสำโรงวิทยา","กวางวา","ป้วยมิ้ง","พระหฤทัยสวรรคโลก","ถวิลวิทยา","อนุบาลเขาพระ","อนุบาลพรประสาทวิทยา","อนุบาลยอดไม้งาม","อนุบาลอุทิศวิทยา","เอกชนการกุศลวัดสกุณปักษี","อนุบาลศุภลักษณ์","ดอนเจดีย์พิทยาคม","ปัญญาประเสริฐ","ปัญญาประเสริฐวิทยา","คี่ตี้","อนุบาลเตือนจิตร","อุภัยภาดาวิทยาลัย","ประทีปศึกษา","ศรีรัตน์วิทยา","ภาวนาภิมณฑ์พิทยา","ปรีดาวิทย์","ยอแซฟอุปถัมภ์อู่ทอง","รัตนไพศาล","สมถวิลอนุบาล","เซนต์โยเซฟเกาะสมุย","อนุบาลเพ็ญพักตร์","ธิดาแม่พระ","ตวงวิชช์พัฒนา","มานิตานุเคราะห์","ยุวศึกษา","ศรีมิลินท์อนุสรณ์","สัมพันธศึกษา","อนุบาลเสาวลักษณ์","อนุบาลกุลบุตร","อนุบาลค่ายวิภาวดีรังสิต","จอย","อนุบาลบูรณประภา","อนุบาลหนูน้อย","เวียงสระศึกษา","อนุบาลบัณฑิต","อนุบาลภิญพัฒน์","พุทธนิคม","อนุบาลกิตติญาณโสภิต","อนุบาลพุทธนิคม","อนุบาลขวัญชนก","อนุบาลขวัญยืน","อนุบาลชุลีกร","อนุบาลนงรัตน์","จงฮั้ว","อนุบาลกัญจนา","อนุบาลนวพร","อุปถัมภ์วิทยาพนม","อนุบาลดวงใจแม่","ดรุโณทัยพุนพิน","ธีราศรม พุนพิน","ปกรณ์พิทยา","พันธศึกษา","อนุบาลกองบิน 7","อนุบาลร่วมฤดี","อนุบาลวังบอนหอม","วาณิชย์นุกูล","สุรินทรศึกษา","แงงกวง","แงงกวง (ซ้ำ)","ราชตั้งใจวิทยา","อนุบาลโสมนัส","อนุบาลนิจจานุเคราะห์","อนุบาลศิริกุล","อนุบาลสาริกา","ฮั่วเคียวกงฮัก","อนุบาลเฝ้าไร่","มหาไถ่ศึกษาบึงกาฬ","อนุบาลฉัตรพงษ์","อนุบาลกมลวรรณ","อนุบาลดวงรัตน์","อนุบาลปัญญารัตน์","จริยานุสรณ์","อนุบาลกาบแก้วบัวบาน","อนุบาลสุดา","อนุบาลหนองบัวลำภูคริสเตียน","เฉลิมจักรศึกษา","สนามชัยสิทธิ์นุสรณ์","วรดิตถ์วิทยาประสูทน์","วัดสระแก้ว (รุ่งโรจน์ธนกุลอุปถัมภ์)","อนุบาลวงศ์สวัสดิ์วิทยา","สนิทวิทยา","อมราวิทยาภูมิ","อนุบาลนพเก้า","วิสุทธิวงศ์","มูลนิธิสุดีวิทยาวัดไชยาติการาม","เซนต์แมรี่ อุดรธานี","กระจ่างวิทย์","ดอนบอสโกวิทยา","ทรงธรรมวิทยา","มารีย์พิทักษ์อุดรธานี","พันธกิจวิทยา","สหกิจวิทยา","อนุบาลค่ายประจักษ์ศิลปาคม","อนุบาลลักษณ์สุข","อนุบาลอาภาพัชร","อุดรวิทยา","อนุบาลนันทวดี","เทพปัญญา","มหาไถ่ศึกษากุมภวาปี","อนุบาลวิฆเนศวร์","วิสุทธิวงศ์โพนสูง","ศศิกานต์วิทยา","อนุบาลกฤชานันท์","เปี่ยมเมธีวิทยาคาร","พิศาลศึกษาวิทยา","หวัวเฉียว","อนุบาลคริสเตียนอุตรดิตถ์","สหคริสเตียน","จรัสศิลป์","พิทักษ์ศิษย์วิทยา","อนุศิษย์วิทยา3","อนุศิษย์วิทยา 4","อุทัยวิทยาลัย","อนุบาลรจนา","จตุพร","ทองประสาทเวทย์","เยาวเรศศึกษา","พระกุมารอุบล","มหาชนะวิทยา","มารีย์นิรมล","สมเด็จ","อเนกวิทยา","อนุบาลกิตติคุณ","อัสสัมชัญอุบลราชธานี","อาเวมารีอา","อุบลวิทยากร","ฮั้วเฉียวกงฮัก อุบลราชธานี","ดำรงวิทยา","อนุบาลน้องหญิง","อนุบาลเพชรบุปผา","เทพพิทักษ์พิทยา","บ้านเด็กวารินชำราบ","ประสานวิทยาคม","สงเคราะห์ศึกษา","อนุบาลงามจิต","นิคม 2 อนุบาล","ตำรวจตระเวนชายแดนเฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัว เนื่องในวโรกาสพระราชพิธีมหามงคลเฉลิมพระชนมพรรษา 6 รอบ 5 ธันวาคม 2542 (นางอั้งไซอิม แซ่ตั้ง อุปถัมภ์)","ตำรวจตระเวนชายแดนบ้านหนองแขม","ตำรวจตระเวนชายแดนเบญจมะ 1"," ตชด.บ้านแม่ลอง"," ตชด.บ้านใหม่พัฒนาสันติ","ตำรวจตระเวนชายแดนไลออนส์มหาจักร 9","สโมสรไลออนส์รัตนโกสินทร์","ตำรวจตระเวนชายแดนฮียงไทยธำรงค์","ตำรวจตระเวนชายแดนทุติยะโพธิ์อนุสรณ์","ตำรวจตระเวนชายแดนอาโอยาม่า","ตำรวจตระเวนชายแดนเจ้าพ่อหลวงอุปถัมภ์ 2","ตำรวจตระเวนชายแดนรัปปาปอร์ต","ตำรวจตระเวนชายแดนอาชีวศึกษาเชียงราย-พะเยา","ตำรวจตระเวนชายแดนเทคนิคดุสิต","ตำรวจตระเวนชายแดนสมถวิลจินตมัย","ตำรวจตระเวนชายแดนชนัตถ์ปิยอุย","ตำรวจตระเวนชายแดนศรีสมวงศ์","ตำรวจตระเวนชายแดนบำรุงที่ 87","ตำรวจตระเวนชายแดนเจ้าพ่อหลวงอุปถัมภ์ 4","ตำรวจตระเวนชายแดนบำรุงที่ 112","ตำรวจตระเวนชายแดนสังวาลย์วิท 8","ตำรวจตระเวนชายแดนบ้านนาโต่ (วปรอ.344 อุปถัมภ์)","ตำรวจตระเวนชายแดนบ้านดอยล้าน","ตำรวจตระเวนชายแดนนเรศวรบ้านห้วยโสก","ตำรวจตระเวนชายแดนบ้านโป่งตะแบก","ตำรวจตระเวนชายแดนบ้านวังชมภู","ตำรวจตระเวนชายแดนเฉลิมราษฎร์บำรุง","ตำรวจตระเวนชายแดนบ้านนาปอ","ตำรวจตระเวนชายแดนบ้านหนองแคน","ตำรวจตระเวนชายแดนบ้านห้วยเป้า","ตำรวจตระเวนชายแดนฮิลมาร์พาเบิล","ตำรวจตระเวนชายแดนบ้านนานกปีด","ตำรวจตระเวนชายแดนแม่ลางิ้ว","ตำรวจตระเวนชายแดนบ้านตุน (ชมรม 9 สมาคมจีน)"," ตชด.บ้านบ้องตี้ล่าง","ตำรวจตระเวนชายแดนบ้านแม่น้ำน้อย","ตำรวจตระเวนชายแดนเฮงเค็ลไทย","ตำรวจตระเวนชายแดนวิจิตรวิทยาคาร","ตำรวจตระเวนชายแดนมิตรมวลชน 2","ตำรวจตระเวนชายแดนสหธนาคารกรุงเทพ","ตำรวจตระเวนชายแดนสุนทรเวช","ตำรวจตระเวนชายแดนบ้านเรดาร์ (มร.เจอร์เก้น มูลเดอร์ อุปถัมภ์)","ตำรวจตระเวนชายแดนบ้านทิไล่ป้า สาขาสุนทรเวช","ตำรวจตระเวนชายแดนบ้านบ่อชะอม","ตำรวจตระเวนชายแดนบ้านหางแมว","ตำรวจตระเวนชายแดนบ้านคลองแดง","ตำรวจตระเวนชายแดนบ้านน้ำแดง","ตำรวจตระเวนชายแดนบ้านคลองมะลิประเวศน์วิทยา","ตำรวจตระเวนชายแดนสิงคโปร์แอร์ไลสน์เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัว เนื่องในโอกาสพระราชพิธีมหามงคล 6 รอบ 5 ธันวาคม 2542","ตำรวจตระเวนชายแดนที่มีอาคารเฉลิมพระเกียรติ พระบาทสมเด็จพระเจ้าอยู่หัว (สมาคมแม่บ้านตำรวจอุปถัมภ์) บ้านนายาว","ตำรวจตระเวนชายแดนบ้านนาอิสาน (มูลนิธิสุมิตร เลิศสุมิตรกุล อุปถัมภ์)","ตำรวจตระเวนชายแดนสันตินิมิต","ตำรวจตระเวนชายแดนบ้านพันวาล","ตำรวจตระเวนชายแดนสิริราษฎร์","ตำรวจตระเวนชายแดนบ้านสวนเพชร","ตำรวจตระเวนชายแดนบ้านควนสามัคคี","ตำรวจตระเวนชายแดนบ้านห้วยเหมือง","ตำรวจตระเวนชายแดนสันติราษฎร์ประชาบำรุง","ตำรวจตระเวนชายแดนบ้านหินจอก","ตำรวจตระเวนชายแดนบ้านเขาฉลาด","ตำรวจตระเวนชายแดนบ้านท่ากุ่ม (มูลนิธิสุมิตร เลิศสุมิตรกุล อุปถัมภ์)","ตำรวจตระเวนชายแดนบ้านแพะ","ตำรวจตระเวนชายแดนบ้านแสมใหญ่","ตำรวจตระเวนชายแดนจาตุรจินดา","ตำรวจตระเวนชายแดนท่านผู้หญิงทวี มณีนุตร","ตำรวจตระเวนชายแดนบ้านถ้ำเสือ","ตำรวจตระเวนชายแดนศึกษาสงเคราะห์ 2","ตำรวจตระเวนชายแดนห้วยน้ำขุน","ตำรวจตระเวนชายแดนเทคนิคอาสา 1","ตำรวจตระเวนชายแดนบ้านกามาผาโด้","ตำรวจตระเวนชายแดน จุฬา-ธรรมศาสตร์ 3","ตำรวจตระเวนชายแดนบ้านมอเกอร์","ตำรวจตระเวนชายแดนบ้านแม่กลองใหญ่","ตำรวจตระเวนชายแดนบ้านแม่กลองคี","ตำรวจตระเวนชายแดนเลตองคุ","ตำรวจตระเวนชายแดนแม่จันทะ","ตำรวจตระเวนชายแดนหม่องกั๊วะ","ตำรวจตระเวนชายแดนบ้านหนองดู่","ตำรวจตระเวนชายแดนคอนราดเฮงเค็ล","ตำรวจตระเวนชายแดนชูทิศวิทยา","ตำรวจตระเวนชายแดนบ้านหาดทรายเพ","ตำรวจตระเวนชายแดนช่างกลปทุมวันอนุสรณ์ 8","ตำรวจตระเวนชายแดนที่มีอาคารเฉลิมพระเกียรติ พระบาทสมเด็จพระเจ้าอยู่หัว (สมาคมแม่บ้านตำรวจ อุปถัมภ์) บ้านนาสามัคคี","ตำรวจตระเวนชายแดนบ้านควนมีชัย","ตำรวจตระเวนชายแดนบ้านไร่ยาว","ตำรวจตระเวนชายแดนบ้านยูงงาม","ตำรวจตระเวนชายแดนบ้านเขาวัง","ตำรวจตระเวนชายแดนบ้านไอร์บือแต","ตำรวจตระเวนชายแดนการท่าอากาศยานแห่งประเทศไทย เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัว เนื่องในวโรกาสพระราชพิธีมหามงคลเฉลิมพระชนมพรรษา 6 รอบ 5 ธันวาคม 2542","ตำรวจตระเวนชายแดนบ้านตืองอช่างกลปทุมวันอนุสรณ์ 13","ตำรวจตระเวนชายแดนบ้านละโอ","ตำรวจตระเวนชายแดนบ้านลีนานนท์ (มูลนิธิสุมิตร เลิศสุมิตรกุล อุปถัมภ์)","ตำรวจตระเวนชายแดนพีระยานุเคราะห์มูลนิธิในพระอุปถ้มภ์ สมเด็จพระศรีนครินทราบรมราชชนนี เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัวฯ ในวโรกาสทรงครองราชย์ปีที่ 50","ตำรวจตระเวนชายแดนเฉลิมฉลองครบรอบ 100 ปี วันคล้ายวันพระราชสมภพ สมเด็จพระศรีนครินทราบรมราชชนนี 21 ตุลาคม 2543","ตำรวจตระเวนชายแดนผู้บังคับบัญชาลูกเสือรถไฟมักกะสัน","ตำรวจตระเวนชายแดนบ้านย่านซื่อ","ตำรวจตระเวนชายแดนบ้านเขาจ้าว","ตำรวจตระเวนชายแดนบ้านท่าวังหิน","นเรศวรห้วยผึ้ง","ตำรวจตระเวนชายแดนนเรศวรป่าละอู","ตำรวจตระเวนชายแดนบ้านคลองน้อย","ตำรวจตระเวนชายแดนบ้านแพรกตะคร้อ","ตำรวจตระเวนชายแดนพีระยานุเคราะห์ มูลนิธิในพระอุปถัมภ์สมเด็จพระศรีนครินทราบรมราชชนนี เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัวในวโรกาสครองราชย์ ปีที่ 50","ตำรวจตระเวนชายแดนเบตตี้ดูเมน","ตำรวจตระเวนชายแดนบ้านควนตะแบก","ตำรวจตระเวนชายแดนบ้านลาดเรือ","ตำรวจตระเวนชายแดนที่มีอาคารเฉลิมพระเกียรติ พระบาทสมเด็จพระเจ้าอยู่หัว (สมาคมแม่บ้านตำรวจ อุปถัมภ์) บ้านรักไทย","ตำรวจตระเวนชายแดนบ้านนุชเทียน","ตำรวจตระเวนชายแดนอาทรอุทิศ","ตำรวจตระเวนชายแดนบ้านศรีสวัสดิ์","ตำรวจตระเวนชายแดนสังวาลย์วิท 4","ตำรวจตระเวนชายแดนนิคมพิทักษ์ราษฎร์","ตำรวจตระเวนชายแดนบ้านปาโจแมเราะ","ตำรวจตระเวนชายแดนโรงงานยาสูบ 2","ตำรวจตระเวนชายแดนบ้านในวง","ตำรวจตระเวนชายแดนบ้านตะโกปิดทอง","ตำรวจตระเวนชายแดนบ้านถ้ำหิน","ตำรวจตระเวนชายแดนบ้านหนองใหญ่","ตำรวจตระเวนชายแดนเชิญ-พิศลยบุตร","ตำรวจตระเวนชายแดนบ้านประกอบออก","ตำรวจตระเวนชายแดนสื่อมวลชนกีฬา","ตำรวจตระเวนชายแดนบ้านชายควน","ตำรวจตระเวนชายแดนบ้านบาโรย","ตำรวจตระเวนชายแดนบ้านทุ่งสบายใจ","ตำรวจตระเวนชายแดนมหาราช 1","ตำรวจตระเวนชายแดนบ้านสำนักเอาะ","ตำรวจตระเวนชายแดนบ้านหาดทราย","ตำรวจตระเวนชายแดนยูงทองรัฐประชาสรรค์","ตำรวจตระเวนชายแดนบ้านส้านแดง","ตำรวจตระเวนชายแดนบ้านน้ำอ้อม","ตำรวจตระเวนชายแดนการบินไทย","ตำรวจตระเวนชายแดนบ้านคลองตะเคียนชัย","ตำรวจตระเวนชายแดนบ้านวังศรีทอง","ตำรวจตระเวนชายแดนบ้านทุ่งกบินทร์","บ้านคลองเจริญสุข","ตำรวจตระเวนชายแดนพีระยานุเคราะห์มูลนิธิในพระอุปถัมภ์สมเด็จพระศรีนครินทราบรมราชชนนี เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัว ในวโรกาสครองราชปีที่ 50","ตำรวจตระเวนชายแดนบ้านเขาสารภี","ตำรวจตระเวนชายแดนประชารัฐบำรุง 1","ตำรวจตระเวนชายแดนบ้านยางโพรง","ตำรวจตระเวนชายแดนบ้านกอเตย","ตำรวจตระเวนชายแดนเทคนิคมีนบุรีอนุสรณ์ 1","ตำรวจตระเวนชายแดนบ้านโคกแสลง","ตำรวจตระเวนชายแดนบ้านชำปะโต","ตำรวจตระเวนชายแดนบ้านรุน","ตำรวจตระเวนชายแดนพีระยานุเคราะห์มูลนิธิในพระอุปถัมภ์ สมเด็จพระศรีนครินทราบรมราชชนนี 2 เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัวฯ ในวโรกาสทรงครองราชย์ปีที่ 50","ตำรวจตระเวนชายแดนบ้านตาตุม","ตำรวจตระเวนชายแดนบ้านตาแตรว","ตำรวจตระเวนชายแดนบ้านห้วยดอกไม้","ตำรวจตระเวนชายแดนบ้านหนองตะไก้","ตำรวจตระเวนชายแดนบ้านนาแวง","บ้านสมประสงค์","ตำรวจตระเวนชายแดนบ้านห้วยเวียงงาม","ตำรวจตระเวนชายแดนบ้านเมืองทอง","ตำรวจตระเวนชายแดนบ้านนาชมภู (มูลนิธิสุมิตร เลิศสุมิตรกุล อุปถัมภ์)","ตำรวจตระเวนชายแดนบุญธรรม-บุญพริ้ง","ตำรวจตระเวนชายแดนยอดโพธิ์ทอง 1","ตำรวจตระเวนชายแดนบ้านปากลา","ตำรวจตระเวนชายแดนบ้านตาเอ็ม","ตำรวจตระเวนชายแดนบ้านห้วยฆ้อง","ตำรวจตระเวนชายแดนบ้านท่าแสนคูณ","ตำรวจตระเวนชายแดนบ้านคำสะอาด","ตำรวจตระเวนชายแดนบ้านป่าไม้","ตำรวจตระเวนชายแดนบ้านแก่งศรีโคตร","กาญจนาภิเษกสมโภชในพระราชูปถัมภ์","การศึกษาคนตาบอดลำปาง","การศึกษาคนตาบอดร้อยเอ็ด","อนุบาลโสตพัฒนา","สอนคนตาบอดพระมหาไถ่พัทยา","ซินจง","อนุบาลวัดธาตุทอง","มูลนิธิวัดปากบ่อ","รุ่งนภาอนุสรณ์ศาสตร์","วัดศรีทองนพคุณ","มารดาดรุณีรักษ์","รวมสินวิทยา","ปัญญาวิทยา","กงลี้จงซัน","ตังเอ็ง","ธรรมวาที","ประชาวิทยา","มูลนิธิภูมิตะวันวิทยา","เกี้ยวกวง","จ้องฮั้ว","ฮกเฮง","เจี้ยไช้","พะตงวิทยามูลนิธิ","สัมมาสิกขาสันติอโศก","สัมมาสิกขาปฐมอโศก","มัธยมพระราชทานนายาว","ประเสริฐวิทยาทาน","ธารทิพย์","สัมมาสิกขาศรีษะอโศก","สมาคมสงเคราะห์วิทยา","มูลนิธิรุ่งนภา","พุทธเกษตร","มุสลิมด้ารุลอุโลมวิทยา","มุสลิมวังทองวิทยา","ประกอบธรรมอิสลาม","บางกอกวิทยา (มูลนิธิ)","อิสลามสันติชน","แสงธรรมอิสลาม","ปัญญาสารธรรมมูลนิธิ","มุสลิมสันติธรรมมูลนิธิ","อัลมูวาห์ฮิดีน","ประทีปศาสน์","มัดร่อซาตุลอุลูมิดดีน","ญามีอุ้ลอิควาน","ท่าอิฐศึกษา","อัลอิสลามียะห์","นูรุดดิน","อิสลามวิทยาทาน","อัดดีนียาตุลอิสลามียะห์","ศิริธรรมวิทยา","เจริญศาสตร์","ดาราศาสน์วิทยา","ธรรมสตัมภ์วิทยา","เจริญวิทยานุสรณ์","อัลมัสโฮร์","อัตตัรกียะห์อิสลามียะห์","อัซซูลามียะห์ตูดีนียะห์","นิรันดรวิทยา","สุกัญศาสน์วิทยา","นราวิทย์อิสลาม","อิสลามบูรพา","อิสลามบูรณะโต๊ะนอ","พัฒนศาสน์วิทยา","ฮาซานียะห์","อดุลวิทยา","อัครศาสน์วิทยา","อนุรักษ์อิสลาม","มาฮัดมูฮัมมาดียะห์","ดารุลกุรอานิลการีม","ประทีปวิทยา","ดารุสสาลาม","ดาราวิทยา","อิบตีดาวิทยา","ดารุลอุลลม","นะห์ฎอตุลสูบาน","ต้นตันหยง","รอมาเนีย","จริยธรรมวิทยา","อัตเตาฟีกียะห์อิสลามียะห์","นะห์ฎอฎุลอิสลาฮียะห์","แสงธรรมวิทยา (มูลนิธิ)","อิสลามอนุศาสน์","ดารุลรอห์มาฮ์","ลำสนุ่น","อะห์มาดียะห์วิทยา","ซอลีฮียะห์อัดดีนียะห์","มูฮัมมาดียะห์","อิสลามสามัคคี","มูลนิธิอาซิซสถาน","พีระยานาวินคลองหินวิทยามูลนิธิ","บ้านลำหยัง","อิสลามประชาสงเคราะห์","อิสลามนิติวิทย์","อัลยามีอะห์อัลอิสลามียะห์","วัฒนธรรมอิสลาม","สมบูรณ์ศาสน์อิสลาม","วิทยาศีล","ดรุณมุสลิมวิทยา","ยุวอิสลามวิทยามูลนิธิ","สันนิธิอิสลาม","อิสลามศาสน์วิทยา","รัศมีสถาปนา","ศานติธรรมวิทยา","ปูยุดประชารักษ์","บำรุงอิสลาม","พัฒนาอิสลาม","สตรีพัฒนศึกษา ","วิทยาอิสลามมูลนิธิ","ศาสนูปถัมภ์","เตรียมศึกษาวิทยา","จงรักสัตย์วิทยา","ประสานวิทยามูลนิธิ","พิทักษ์ศาสน์วิทยา","ปอซันพัฒนา","อัลอิสลามียะห์วิทยา","ทวีวิทยาอิสลาม","แสงธรรมศึกษาปัตตานี","ส่งเสริมศาสน์","ดรุณศาสน์วิทยา","ราษฎร์ประชานุเคราะห์","อรุณศาสน์วิทยา","บำรุงมุสลีมีน","ศาสน์อิสลาม","ลาลอวิทยา","สามารถดีวิทยา","สายบุรีอิสลามวิทยา","แสงประทีปวิทยา","บากงพิทยา","ศาสน์สามัคคี","อิสลามศรีอยุธยามูลนิธิ","สังคมอิสลามวิทยา","ศึกษาธรรมอิสลามมูลนิธิ","สันติธรรมวิทยามูลนิธิ","พัฒนาวิทยามูลนิธิ","อิสลามิยะฮ์สหวิทยามูลนิธิ","มุสลิมวิทยา (ประชาอุปถัมภ์) มูลนิธิ","ปากพะยูน","อะมาดียะห์มูลนิธิ","มุสลิมวิทยาภูเก็ต","สุทธิศาสน์วิทยา","อาลาวียะห์วิทยา","ผดุงศีลวิทยา","คอยรียะห์วิทยามูลนิธิ","ธรรมวิทยามูลนิธิ","สตรีอิสลามวิทยามูลนิธิ","อาสาสุลดินวิทยา","มุสลิมศึกษา","อิสลาฮียะห์","อุดมศาสน์วิทยา","ตาร์เบียตุลวาตันมูลนิธิ","อิสลามประสานวิทย์","ดารุลอูโลมนิบงบารู","อิสลาฮุดดีนวิทยา","สตรีศาสนูปถัมภ์","ศาสโนวาทวิทยา","ดารุลฮูดาห์วิทยา","ศรีฟารีดาบารูวิทยา","มะฮัดดะวะห์อิสลามียะห์","มะอาหัดอิลสลามียะห์","ดำรงศาสน์วิทยา","นูโรลฮูดาห์","ตัสดีกียะห์","แสงธรรมวิทยา","ศาสนบำรุง (สอลิหุดดีน)","ดรุณวิทยา","สรรเสริญอิสลาม","ดีนูลอิสลาม","อัลมูตาวัสษิเต๊าะห์","จริยธรรมศึกษามูลนิธิ","เจริญธรรมวิทยา","ดำรงค์ศาสน์วิทยา","ส่งเสริมอิสลาม","สมบูรณ์ศาสน์","ส่งเสริมศาสนา","บำรุงศาสน์","อูลูมุดดีน","สายยิดวิทยามูลนิธิ","พัฒนาศาสตร์มูลนิธิ","สามัคคีศาสน์วิทยา","ศาสน์สันติธรรม","ศอลาหุดดีน","ท่าใหญ่วิทยา","ส่งเสริมวิทยามูลนิธิ","ธรรมศึกษามูลนิธิ","อรุณศาสน์วิทยามูลนิธิ","อิสลามวิทยามูลนิธิ","ดารุลอูลูม","ดารุลมาอาเรฟมูลนิธิ","ธรรมศาสน์วิทยา","ตัรกี้ยะตุลอุมมะห์","มำบาอูลอูลูม","แสงประทีปวิทยามูลนิธิ","อันซอเรียะห์อัดดีนียะห์","พัฒนาการศึกษามูลนิธิ","แสงธรรม","จริยธรรมอิสลามมูลนิธิ","ท่าคันโทวิทยาคาร","เมืองกระบี่","วัฒนานคร","ทัพพระยาพิทยา","วังน้ำเย็นวิทยาคม","ชุมชนบ้านท่าสะอาด","พนมเบญจา","เมืองราดวิทยาคม","บ้านตลาดเขตมิตรภาพที่ 105","บ้านวังกวาง และสวนป่าแม่สรอย","สายน้ำผึ้ง ในพระอุปถัมภ์ฯ","นวมินทราชินูทิศ เบญจมราชาลัย","นวมินทราชินูทิศ สตรีวิทยา 2","สารวิทยา","หอวัง","บางมดวิทยา ","มัธยมวัดสิงห์","วัดราชโอรส","ดอนเมืองจาตุรจินดา","ดอนเมืองทหารอากาศบำรุง","กุนนทีรุทธารามวิทยาคม","พิบูลประชาสรรค์","สุรศักดิ์มนตรี","เบญจมบพิตร","โยธินบูรณะ","วัดน้อยนพคุณ","โพธิสารพิทยากร","มหรรณพาราม","ทีปังกรวิทยาพัฒน์ (วัดน้อยใน) ในพระราชูปถัมภ์ฯ","อุบลรัตนราชกัญญาราชวิทยาลัย กรุงเทพมหานคร","สุวรรณพลับพลาพิทยาคม","ทีปังกรวิทยาพัฒน์ (ทวีวัฒนา) ในพระราชูปถัมภ์ฯ","นวมินทราชินูทิศ สตรีวิทยา พุทธมณฑล","วัดพุทธบูชา","อิสลามวิทยาลัยแห่งประเทศไทย","ธนบุรีวรเทพีพลารักษ์","มัธยมวัดดาวคนอง","รัตนโกสินทร์สมโภชบางเขน","ปัญญาวรคุณ","ราชวินิตบางแคปานขำ","ทวีธาภิเศก","วัดประดู่ในทรงธรรม","ชิโนรสวิทยาลัย","มัธยมวัดดุสิตาราม","มัธยมวัดนายโรง","สตรีวัดระฆัง","สวนอนันต์","สุวรรณารามวิทยาคม","เทพลีลา","บางกะปิ","มัธยมวัดบึงทองหลาง","ทวีธาภิเศก 2","พิทยาลงกรณ์พิทยาคม","รัตนโกสินทร์สมโภชบางขุนเทียน","ราชนันทาจารย์ สามเสนวิทยาลัย 2","ศีลาจารพิพัฒน์","โยธินบูรณะ 2 (สุวรรณสุทธาราม)","สิริรัตนาธร","นวลนรดิศวิทยาคม รัชมังคลาภิเษก","ศึกษานารีวิทยา","วัดบวรมงคล","วิมุตยารามพิทยากร","พุทธจักรวิทยา","สตรีวัดมหาพฤฒาราม","สุขุมนวพันธ์อุปถัมภ์","เตรียมอุดมศึกษา","ราชดำริ","วัดสระเกศ","สายปัญญา ในพระบรมราชินูปถัมภ์","พระโขนงพิทยาลัย","วชิรธรรมสาธิต","มัธยมวัดมกุฏกษัตริย์","วัดบวรนิเวศ","วัดราชบพิธ","วัดสังเวช","สตรีวิทยา","สวนกุหลาบวิทยาลัย","จันทร์ประดิษฐารามวิทยาคม","ไชยฉิมพลีวิทยาคม","วัดนวลนรดิศ","วัดรางบัว","สตรีวัดอัปสรสวรรค์","เศรษฐบุตรบำเพ็ญ","สตรีเศรษฐบุตรบำเพ็ญ","เจ้าพระยาวิทยาคม","มักกะสันพิทยา","แจงร้อนวิทยา","เทพศิรินทร์ ร่มเกล้า","พรตพิทยพยัต","รัตนโกสินทร์สมโภชลาดกระบัง","ลาดปลาเค้าพิทยาคม","สตรีวิทยา 2","นวมินทราชินูทิศ บดินทรเดชา","มัธยมวัดธาตุทอง","เตรียมอุดมศึกษาพัฒนาการ","เตรียมอุดมศึกษาน้อมเกล้า","ศรีพฤฒา","ไตรมิตรวิทยาลัย","ยานนาเวศวิทยาคม","วัดสุทธิวราราม","สตรีศรีสุริโยทัย","มัธยมวัดหนองแขม","ราชวินิตบางเขน","สองแคววิทยาคม","สันติสุข","เชียงดาววิทยาคม","ศึกษาสงเคราะห์เชียงดาว","อรุโณทัยวิทยาคม","ยุพราชวิทยาลัย","หอพระ","เวียงแหงวิทยาคม","แม่แจ่ม","ราชประชานุเคราะห์ 31","แม่แตง","สันป่ายางวิทยาคม","นวมินทราชูทิศ พายัพ","แม่ริมวิทยาคม","บ้านกาดวิทยาคม","แม่อายวิทยาคม","ราชประชานุเคราะห์ 30","ไชยปราการ","จอมทอง","ดอยเต่าวิทยาคม","ฝางชนูปถัมภ์","สะเมิงพิทยาคม","เทพศิรินทร์ เชียงใหม่","สันป่าตองวิทยาคม","สารภีพิทยาคม","หางดงรัฐราษฏร์อุปถัมภ์","แม่ตื่นวิทยาคม","อมก๋อยวิทยาคม","เวียงเชียงรุ้งวิทยาคม","เชียงแสนวิทยาคม","จุฬาภรณราชวิทยาลัย เชียงราย","ดอนชัยวิทยาคม","ดำรงราษฏร์สงเคราะห์","เม็งรายมหาราชวิทยาคม","ห้วยสักวิทยาคม","เวียงแก่นวิทยาคม","ดอนศิลาผางามวิทยาคม","เวียงชัยวิทยาคม","แม่เจดีย์วิทยาคม","เวียงป่าเป้าวิทยาคม","แม่จันวิทยาคม","ศึกษาสงเคราะห์แม่จัน","สันติคีรีวิทยาคม","วาวีวิทยาคม","วัดถ้ำปลาวิทยาคม","พานพิเศษพิทยา","แม่อ้อวิทยาคม","เขาย้อยวิทยา","ดอนยางวิทยา","บางจานวิทยา","เบญจมเทพอุทิศจังหวัดเพชรบุรี","พรหมานุสรณ์","แก่งกระจานวิทยา","ป่าเด็งวิทยา","จุฬาภรณราชวิทยาลัย เพชรบุรี","ชะอำคุณหญิงเนื่องบุรี","โตนดหลวงวิทยา","ห้วยทรายประชาสรรค์","ท่ายางวิทยา","หนองจอกวิทยา","บางตะบูนวิทยา","บ้านแหลมวิทยา","วชิรธรรมโศภิต","บ้านลาดวิทยา","หนองหญ้าปล้องวิทยา","ร่มเกล้าเขาค้อ เพชรบูรณ์","เนินพิทยาคม","เพชรบูรณ์วิทยา","องค์การบริหารส่วนจังหวัดเพชรบูรณ์ (วังชมภูวิทยาคม)","วิทยานุกูลนารี","สวนกุหลาบวิทยาลัย เพชรบูรณ์","ดงขุยวิทยาคม","น้ำหนาววิทยาคม","ซับบอนวิทยาคม","วังพิกุลพิทยาคม","ศรีมงคลวิทยาคม","วังโป่งพิทยาคม","วังโป่งศึกษา","โคกปรงวิทยาคม","ซับสมบูรณ์วิทยาคม","น้ำร้อนวิทยาคม","วังใหญ่วิทยาคม","นาสนุ่นวิทยาคม","เมืองศรีเทพ","ท่าด้วงพิทยาคม","นาเฉลียงพิทยาคม","เพชรละครวิทยา","กาญจนาภิเษกวิทยาลัย เพชรบูรณ์","ผาแดงวิทยาคม","ผาเมืองวิทยาคม","เมืองกลางวิทยาคม","ศรีจันทร์วิทยาคม รัชมังคลาภิเษก","เขาแก้ววิทยาสรรพ์","จุฬาภรณราชวิทยาลัย เลย","ธาตุพิทยาคม","นาอ้อวิทยา","น้ำสวยพิทยาสรรพ์","เลยอนุกูลวิทยา","ผาสามยอดวิทยาคม","ผาอินทร์แปลงวิทยา","เอราวัณวิทยาคม","พระแก้วอาสาวิทยา","วังโพนงามวิทยา","ท่าลี่วิทยา","นาแห้ววิทยา","นาด้วงวิทยา","คอนสาวิทยา","เชียงกลมวิทยา","ปากชมวิทยา","สันติวิทยาสรรพ์","ภูเรือวิทยา","ภูกระดึงวิทยาคม","ภูหลวงวิทยา","เขาหลวงวิทยา","เซไลวิทยาคม","ผาน้อยวิทยาคม","เลยสว่างวิทยาคม","วังทรายขาววิทยา","ราชประชานุเคราะห์ 52","เหมืองแบ่งวิทยาคม","วิไลเกียรติอุปถัมภ์","ถิ่นโอภาสวิทยา","ท่าข้ามวิทยาคม","พิริยาลัย","เมืองแพร่","ห้วยม้าวิทยาคม","ราชประชานุเคราะห์ 25","ลองวิทยา","วังชิ้นวิทยา","สรอยเสรีวิทยา","เวียงเทพวิทยา","สองพิทยาคม","บ้านกาศประชานุเคราะห์","พัฒนาประชาอุปถัมภ์","ม่วงไข่พิทยาคม","ห้องสอนศึกษา","แม่ลาน้อยดรุณสิกข์","ขุนยวมวิทยา","ปางมะผ้าพิทยาสรรพ์","ราชประชานุเคราะห์ 34","สบเมยวิทยาคม","คลองยางประชานุสรณ์","ลันตาราชประชาอุทิศ","เขาดินประชานุกูล","ราชประชานุเคราะห์ 37 (ศึกษาสงเคราะห์เขาพนม)","สินปุนคุณวิชญ์","หนองทะเลวิทยา","อำมาตย์พานิชนุกูล","เหนือคลองประชาบำรุง","กาญจนาภิเษกวิทยาลัย กระบี่","คลองท่อมราษฏร์รังสรรค์","ปลายพระยาวิทยาคม","ลำทับประชานุเคราะห์","คลองหินพิทยาคม","เทพมงคลรังษี","เทพศิรินทร์ ลาดหญ้ากาญจนบุรี","เลาขวัญราษฏร์บำรุง","ไทรโยคน้อยวิทยา","ไทรโยคมณีกาญจน์วิทยา","ทองผาภูมิวิทยา","ท่าม่วงราษฎร์บำรุง","วิสุทธรังษี","หนองขาวโกวิทพิทยาคม","ท่ามะกาปุญสิริวิทยา","ท่ามะกาวิทยาคม","ท่าเรือพิทยาคม","นิวิฐราษฏร์อุปถัมภ์","พระแท่นดงรังวิทยาคาร","บ่อพลอยรัชดาภิเษก","พนมทวนพิทยาคม ","ราชประชานุเคราะห์ 45","ศรีสวัสดิ์พิทยาคม","อุดมสิทธิศึกษา","ประชามงคล","ห้วยกระเจาพิทยาคม","ฆ้องชัยวิทยาคม","ไตรรัตนวิทยาคม","จำปาหลวงวิทยาคม","ดอนจานวิทยาคม","กาญจนาภิเษกวิทยาลัยกาฬสินธุ์","เขาวงพิทยาคาร","พุทโธภาวนาประชาสรรค์","แก่งนาจารย์พิทยาคม","ขมิ้นพิทยาสรรพ์","เมืองกาฬสินธุ์","เมืองเหนือวิทยาคม","หนองสอพิทยาคม","เหล่านาแกวิทยานุสรณ์","อนุกูลนารี","โคกศรีเมือง","ดอนไทรงามพิทยาคม","ธัญญาพัฒนวิทย์","ฟ้าแดดสูงยางวิทยาคาร","หนองห้างพิทยา","คำม่วง","เนินยางประชาสามัคคี","ดงกลางพัฒนศึกษา","บ่อแก้วญาณเวทีพัฒนา","บ้านนาคูพัฒนา ","นามนพิทยาคม","มอสวนขิงพิทยาสรรพ์","เขาพระนอนวิทยาคม","คลองขามวิทยาคาร","นาเชือกวิทยาคม","โนนสูงพิทยาคม","ลำปาววิทยาคม","วังมนวิทยาคาร","ร่องคำ","แก้วเสด็จพิทยาคม","ประชารัฐพัฒนศึกษา","ผาเสวยรังสรรค์","มหาไชยพิทยาคม","เมืองสมเด็จ","สมเด็จพิทยาคม","นามะเขือพัฒนศึกษา","โนนศิลาพิทยาคม","สหัสขันธ์ศึกษา","ดงมูลวิทยาคม","มัธยมภูฮังพัฒนวิทย์","หนองกุงศรีวิทยาคาร","หนองชุมแสงวิทยาคม","หนองบัวไชยวารพิทยาสรรพ์","คำเจริญวิทยาคม","ทรายมูลวิทยาคม","วังลิ้นฟ้าวิทยาคม","หัวหินวัฒนาลัย","นิคมหนองแก้วญาณเวที (พระราชบัณฑิตชัยทวี คุตตฺจิตฺโตอุปถัมภ์)","ระหานวิทยา","คณฑีพิทยาคม","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ กำแพงเพชร","ทุ่งโพธิ์ทะเลพิทยา","นครไตรตรึงษ์","นาบ่อคำวิทยาคม","วชิรปราการวิทยาคม","วังตะเคียนประชานุสรณ์","วัชรวิทยา","หนองกองพิทยาคม","โกสัมพีวิทยา","ไทรงามพิทยาคม","บ่อแก้ววิทยา","ขาณุวิทยา","โค้งไผ่วิทยา","ปางมะค่าวิทยาคม","สลกบาตรวิทยา","คลองขลุงราษฏร์รังสรรค์","วังแขมวิทยาคม","วังไทรวิทยาคม","คลองลานพัฒนาจินดาศักดิ์","สักงามวิทยา","ทุ่งทรายวิทยา","ปางศิลาทองศึกษา","พรานกระต่ายพิทยาคม","พิไกรวิทยา","เรืองวิทย์พิทยาคม","มัธยมพัชรกิติยาภา 2 กำแพงเพชร","ราษฎร์ปรีชาวิทยาคม","ซับสมบูรณ์พิทยาลัย","โนนศิลาวิทยาคม","สันติพัฒนกิจวิทยา","โนนโพธิ์ศรีวิทยาคม","หนองนาคำวิทยาคม","เขาสวนกวางวิทยานุกูล","กู่ทองพิทยาลัย","แก่นนครวิทยาลัย 2","ขอนแก่นพัฒนศึกษา","ขอนแก่นวิทยายน 2 (สมาน สุเมโธ)","ขอนแก่นวิทยายน 3","เตรียมอุดมศึกษาพัฒนาการ ขอนแก่น","นครขอนแก่น","พิศาลปุณณวิทยา","เทพศิรินทร์ ขอนแก่น","สีหราชเดโชชัย","โนนสะอาดวิทยาคาร","ก้านเหลืองวิทยาคม","ท่านางแนววิทยายน","ทุ่งใหญ่รัตนศึกษา","ยางคำพิทยาคม","หนองโนประชาสรรค์","แท่นศิลาทิพย์ศึกษา","ประชารัฐพัฒนาการ","จตุรมิตรวิทยาคาร","ชุมแพพิทยาคม","ชุมแพวิทยายน","ขัวเรียงศึกษา","มัธยมหนองเขียด","หนองเสาเล้าวิทยาคาร","โคกสูงประชาสรรพ์","ดงมันพิทยาคม","พระธาตุขามแก่นพิทยาลัย","ม่วงหวานพัฒนศึกษา","ลำน้ำพอง","บ้านลานวิทยาคม","ป่าหวายวิทยายน","ศรีเสมาวิทยาเสริม","พล","พลพัฒนศึกษา","เมืองพลพิทยาคม","โสกนกเต็นประชาอุปถัมภ์","กุดขอนแก่นวิทยาคม","เวียงนครวิทยาคม","คำแคนวิทยาคม","โคกนางามพิทยาสรรพ์","ท่าศาลาประชานุสรณ์","มัธยมโพนเพ็ก","เหล่าใหญ่นาข่าวิทยาคม","ซำยางวิทยายน","ผาขามวิทยายน","สีชมพูศึกษา","หนองตาไก้ศึกษา","มัธยมตลาดใหญ่วิทยา","หนองเรือวิทยา","เบญจมิตรวิทยา","ศรีหนองกาววิทยา","บัวแก้วพิทยาคม","บึงไทรพิทยาคม","พูวัดพิทยาคม","บางกะจะ","เบญจมานุสรณ์","ศรียานุสรณ์","แก่งหางแมวพิทยาคาร","แหลมสิงห์วิทยาคม ","เครือหวายวิทยาคม","โป่งน้ำร้อนวิทยาคม","หนองตาคงพิทยาคาร","คลองพลูวิทยา","ตกพรมวิทยาคาร","บ่อวิทยาคาร","ท่าใหม่ ","มัธยมวัดเขาสุกิม","ศรีรัตน์ราษฎร์นุเคราะห์","สะพานเลือกวิทยาคม","นายายอามพิทยาคม","มัธยมท่าแคลง","มะขามสรรเสริญ","ทุ่งขนานวิทยา","สอยดาววิทยา","เตรียมอุดมศึกษาเปร็งวิสุทธาธิบดี","เตรียมอุดมศึกษาพัฒนาการ สุวินทวงศ์","เบญจมราชรังสฤษฎิ์ 2","เบญจมราชรังสฤษฎิ์ 3 ชนะสงสารวิทยา","เบญจมราษฎร์รังสฤษฎ์ 4","เบญจมราชรังสฤษฎิ์ 5","วัดโสธรวรารามวรวิหาร","ไผ่แก้ววิทยา","หนองไม้แก่นวิทยา","ก้อนแก้วพิทยาคม","มัธยมสิริวัณวรี 3 ฉะเชิงเทรา","บางคล้าพิทยาคม","วัดเปี่ยมนิโครธาราม","การทำมาหากินวัดโพธิ์เฉลิมรักษ์ (อนุสรณ์วันเด็กแห่งชาติ ปี 2537)","ดอนฉิมพลีพิทยาคม","บางน้ำเปรี้ยววิทยา","ไผ่ดำพิทยาคม รัชมังคลาภิเษก","ผาณิตวิทยา","พุทธิรังสีพิบูล","พนมสารคาม ","หนองแหนวิทยา","ราชสาส์นวิทยา","ชำป่างามวิทยาคม","สนามชัยเขต","เกาะโพธิ์ถ้วยงามวิทยา","เกาะจันทร์พิทยาคาร","เกาะสีชัง","ชลกัลยานุกูล","อ่างศิลาพิทยาคม","บ้านสวน (จั่นอนุสรณ์)","บางละมุง","ผินแจ่มวิชาสอน","โพธิสัมพันธ์พิทยาคาร","คลองกิ่วยิ่งวิทยา","จุฬาภรณราชวิทยาลัย ชลบุรี","บ้านบึง ","ทุ่งเหียงพิทยาคม","หัวถนนวิทยา","อุทกวิทยาคม","พานทอง","พานทองสภาชนูปถัมภ์","ทุ่งศุขลาพิทยา ","สุรศักดิ์วิทยาคม","พลูตาหลวงวิทยา","หนองใหญ่ศิริวรวาทวิทยา","เนินขามรัฐประชานุเคราะห์","องค์การบริหารส่วนจังหวัดชัยนาท","ราชประชานุเคราะห์ 46","สาครพิทยาคม","อุลิตไพบูลย์ชนูปถัมภ์","ห้วยกรดวิทยา","ชยานุกิจพิทยาคม","บุญนาคพิทยาคม","สรรพยาวิทยา","ศรีสโมสรวิทยา","หันคาพิทยาคม","หันคาราษฏร์รังสฤษดิ์","เกษตรสมบูรณ์วิทยาคม","บ้านเดื่อวิทยาคม","บ้านหันวิทยา","ตรีประชาพัฒนศึกษา","โป่งนกประชาสามัคคี","มัธยมชัยมงคลรังงาม","กาญจนาภิเษกวิทยาลัย ชัยภูมิ","กุดตุ้มวิทยา","ชีลองวิทยา","บ้านค่ายวิทยา","ภูพระวิทยาคม","เมืองพญาแลวิทยา","สตรีชัยภูมิ 2","หนองไผ่วิทยานุสรณ์","ท่ามะไฟหวานวิทยาคม","นาหนองทุ่มวิทยา","มัธยมบ้านแก้งวิทยา","มัธยมหนองศาลา","หนองสังข์วิทยายน","ปู่ด้วงศึกษาลัย","คอนสารวิทยาคม","โนนคูณวิทยาคาร รัชมังคลาภิเษก","ห้วยยางวิทยาคม","กุดน้ำใสพิทยาคม","จัตุรัสวิทยาคาร","หนองบัวบานวิทยา","บ้านเขว้าวิทยายน","ลุ่มลำชีนิรมิตวิทยา","บ้านแท่นวิทยา","สระพังวิทยาคม","บางอำพันธ์วิทยาคม","เพชรพิทยาสรรค์","เริงรมย์วิทยาคม","ภักดีชุมพลวิทยา","โคกสะอาดวิทยา","พระธาตุหนองสามหมื่น","เพชรวิทยาคาร","ภูเขียว","หนองคอนไทยวิทยาคม","คูเมืองวิทยา","นางแดดวังชมภูวิทยา รัชมังคลาภิเษก","ห้วยแย้วิทยา","ปากน้ำชุมพรวิทยา","เมืองชุมพรวิทยา","ศรียาภัย","สอาดเผดิมวิทยา","ท่าข้ามวิทยา","ท่าแซะรัชดาภิเษก","ราชประชานุเคราะห์ 20","หงษ์เจริญวิทยาคม","มาบอำมฤตวิทยา","พะโต๊ะวิทยา","เขาทะลุพิทยาคม","ครนพิทยาคม","ด่านสวีวิทยา","นาสักวิทยา","สวีวิทยา","ชลธารวิทยา","ปากน้ำหลังสวนวิทยา","เมืองหลังสวน","สวนศรีวิทยา","หาดสำราญวิทยาคม","จุฬาภรณราชวิทยาลัย ตรัง","น้ำผุด","วิเชียรมาตุ","วิเชียรมาตุ 3","สภาราชินี 2","กันตังพิทยากร","สวัสดิ์รัตนาภิมุข","คันธพิทยาคาร","ทุ่งยาวผดุงศิษย์","ตรังรังสฤษฏ์","วิเชียรมาตุ 2","สิเกาประชาผดุงวิทย์","ในเตาพิทยาคม","บางดีวิทยาคม","ลำภูราเรืองวิทย์","ห้วยนางราษฎร์บำรุง","เกาะกูดวิทยาคม","เขาสมิงวิทยาคม ","ประณีตวิทยาคม","สะตอวิทยาคม รัชมังคลาภิเษก","เขาน้อยวิทยาคม","คีรีเวสรัตนเพียรอุปถัมภ์","ตราดสรรเสริญวิทยาคม","ตราษตระการคุณ","เนินทรายวิทยาคม","อ่าวใหญ่พิทยาคาร","แหลมงอบวิทยาคม","คลองใหญ่วิทยาคม","ราชประชานุเคราะห์ 49","หนองบอนวิทยาคม","นาโบสถ์พิทยาคม","วังเจ้าวิทยาคม","ถนอมราษฏร์บำรุง","วังประจบวิทยาคม","วังหินกิตติวิทยาคม","ราชประชานุเคราะห์ 55","แม่จะเราวิทยาคม","ด่านแม่ละเมาวิทยาคม","แม่กุวิทยาคม","แม่ปะวิทยาคม","สรรพวิทยาคม","ท่าสองยางวิทยาคม","บ้านตาก ","พบพระวิทยาคม","ยกกระบัตรวิทยาคม","อุ้มผางวิทยาคม","นครนายกวิทยาคม","นวมราชานุสรณ์","ปิยชาติพัฒนา","อุบลรัตน์ราชกัญญาราชวิทยาลัย","เมืองนครนายก","บ้านนา ","เลขธรรมกิตติ์วิทยาคม","ปากพลีวิทยาคาร","ภัทรพิทยาจารย์","องครักษ์","พระปฐมวิทยาลัย","พระปฐมวิทยาลัย 2 หลวงพ่อเงินอนุสรณ์","โพรงมะเดื่อวิทยาคม","ราชินีบูรณะ","วัดห้วยจรเข้วิทยาคม","ศรีวิชัยวิทยา","สระกะเทียมวิทยาคม","สิรินธรราชวิทยาลัย","กำแพงแสนวิทยา","มัธยมฐานบินกำแพงแสน","ศาลาตึกวิทยา","คงทองวิทยา","บ้านหลวงวิทยา","งิ้วรายบุญมีรังสฤษดิ์","อุบลรัตนราชกัญญาราชวิทยาลัย นครปฐม","เพิ่มวิทยา","ภัทรญาณวิทยา","แหลมบัววิทยา","บัวปากท่าวิทยา","บางเลนวิทยา","บางหลวงวิทยา","สถาพรวิทยา","รัตนโกสินทร์สมโภชบวรนิเวศศาลายา ในพระสังฆราชูปถัมภ์"," ภ.ป.ร. ราชวิทยาลัยฯ","วัดไร่ขิงวิทยา","วังยางวิทยาคม","หนองโพธิ์พิทยาคม","บ้านผึ้งวิทยาคม","ปิยะมหาราชาลัย","วังกระแสวิทยาคม","ศรีโคตรบูรณ์","ศรีบัวบานวิทยาคม","ดงดาวแจ้งพัฒนศึกษา","โพนสวรรค์ราษฏร์พัฒนา","เชียงยืนวิทยา","ไชยบุรีวิทยาคม","ท่าจำปาวิทยา","อุเทนพัฒนา","นาถ่อนพัฒนา","โพนแพงพิทยาคม","นาแกสามัคคีวิทยา","หนองบ่อวิทยานุกูล","นาทมวิทยา","ดอนเสียวแดงพิทยาคม","นางัวราษฎร์รังสรรค์","อุดมพัฒนศึกษา","ภูลังกาพิทยาคม","โคกสว่างประชาสรรค์","ธรรมโฆษิตวิทยา","มหาชัยวิทยาคม","มัธยมพัชรกิติยาภา 1 นครพนม","นาเดื่อพิทยาคม","บ้านข่าพิทยาคม","สนธิราษฎร์วิทยา","สามผงวิทยาคม","เทพารักษ์ราชวิทยาคม","มัธยมบึงปรือ","กระเบื้องนอกพิทยาคม","เมืองยางศึกษา","หนองหว้าพิทยาสรรค์","ทัพรั้งพิทยาคม","บุญเหลือวิทยานุสรณ์ 2","พระทองคำวิทยา","ช่องแมววิทยาคม","ลำทะเมนไชยพิทยาคม","สีดาวิทยา","หนองยางพิทยาคม","บุญวัฒนา","นครราชสีมาวิทยาลัย","บุญวัฒนา 2","บุญเหลือวิทยานุสรณ์","พุดซาพิทยาคม","มหิศราธิบดี","อุบลรัตนราชกัญญาราชวิทยาลัย นครราชสีมา","สุรธรรมพิทักษ์","ราชสีมาวิทยาลัย","สุรนารีวิทยา","สุขไพบูลย์วิริยะวิทยา","เสิงสาง","แก้งสนามนางพิทยาคม","บึงพะไล","โชคชัยสามัคคี","ดอนไพลพิทยาคม","ภู่วิทยา","มิตรภาพวิทยา","โนนไทยคุรุอุปถัมภ์","โนนไทยคุรุอุปถัมป์ 2","โตนดพิทยาคม","ธารปราสาทเพชรวิทยา","โนนสูงศรีธานี","มะค่าวิทยา","ขามสะแกแสง","เทพาลัย","เมืองคง","หนองบัวพิทยาคม","จระเข้หินสังฆกิจวิทยา","เฉลียงพิทยาคม","บ้านใหญ่พิทยาคม","บ้านใหม่พิทยาคม","มาบตะโกพิทยาคม","คลองเมืองพิทยาคม","ชุมพวงศึกษา","ตลาดไทรพิทยาคม","ปราสาทวิทยาคม","มัธยมด่านขุนทด","มัธยมประดู่วัฒนา","มัธยมหลวงพ่อคูณ ปริสุทโธ","หนองบัวละครวิทยา","เกล็ดลิ้นวิทยา","บัวใหญ่","บ้านเหลื่อมพิทยาสรรพ์","วังไม้แดงพิทยาคม","หันห้วยทรายพิทยาคม","ปักธงชัยประชานิรมิต","ลำพระเพลิงพิทยาคม","สมเด็จพระธีรญาณมุนี","กลางดงปุณณวิทยา","เขาใหญ่พิทยาคม","ปากช่องพิทยาคม","มัธยมวชิราลงกรณวราราม","ปากช่อง","นิคมพิมายศึกษา","พิมายดำรงวิทยาคม","วังน้ำเขียวพิทยาคม","วังหมีพิทยาคม","หนองงูเหลือมพิทยาคม","คลองไผ่วิทยา","สีคิ้ว","สีคิ้ววิทยาคาร","สีคิ้วหนองหญ้าขาว","หนองน้ำใสพิทยาคม","วังรางพิทยาคม","สองครพิทยาคม","สูงเนิน","หนองบุญมากประสงค์วิทยา","หนองบุนนากพิทยาคม","เมืองพลับพลาพิทยาคม","ห้วยแถลงพิทยาคม","หินดาดวิทยา","ช้างกลางประชานุกูล","คงคาประชารักษ์","นบพิตำวิทยา","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ นครศรีธรรมราช","ทางพูนวิทยาคาร","ธัญญาวดีศึกษา","ตรีนิมิตรวิทยา","ปากพูน","โยธินบำรุง","ท้องเนียนคณาภิบาล","ฉวางรัชดาภิเษก","ไม้เรียงประชาสรรค์","เกาะขันธ์ประชาภิบาล","ขอนหาดประชาสรรค์","ชะอวดเคร่งธรรมวิทยา","สระแก้วรัตนวิทย์","กรุงหยันวิทยาคาร","ทุ่งสังพิทยาคม","ทุ่งใหญ่วิทยาคม","เสม็ดจวนวิทยาคม","ก้างปลาวิทยาคม","ทุ่งสงสหประชาสรรค์","ราชประชานุเคราะห์ 19","นาบอน","บางขันวิทยา","วังหินวิทยาคม","โศภณคณาภรณ์","อินทร์ธานีวิทยาคม","พรหมคีรีพิทยาคม","เตรียมอุดมศึกษาภาคใต้","นางเอื้อยวิทยา","พิปูนสังฆรักษ์ประชาอุทิศ","ตระพังพิทยาคม","ร่อนพิบูลย์เกียรติวสุนธราภิวัฒก์","เสาธงวิทยา","สวนกุหลาบวิทยาลัย นครศรีธรรมราช","ฉลองรัฐราษฏร์อุทิศ","เทพราชพิทยาสรรค์","สิชลประชาสรรค์","นพคุณประชาสรรค์","หัวไทรบำรุงราษฏร์","เก้าเลี้ยววิทยา","หัวดงราชพรหมาภรณ์","สวนกุหลาบวิทยาลัย จิรประวัตินครสวรรค์","บ้านแก่งชัชวลิตวิทยา","บึงบอระเพ็ดวิทยา","แม่วงก์พิทยาคม","เขาทองพิทยาคม","ตะคร้อพิทยา","ไพศาลีพิทยา","วังข่อยพิทยา","ชุมแสงชนูทิศ","ทับกฤชพัฒนา","ห้วยน้ำหอมวิทยาคาร","อุดมธัญญาประชานุเคราะห์","จันเสนเอ็งสุวรรณอนุสรณ์","ช่องแคพิทยาคม","ทหารอากาศอนุสรณ์","ลาดทิพรสพิทยาคม","หนองโพพิทยา","ท่าตะโกพิทยาคม","รัฐราษฎร์อนุสรณ์","หนองกรดพิทยาคม","เขากะลาวิทยาคม","พยุหะพิทยาคม","ลาดยาววิทยาคม","วังเมืองชนประสิทธิ์วิทยาคม","วังบ่อวิทยา","เตรียมอุดมศึกษาพัฒนาการ นนทบุรี","นนทบุรีพิทยาคม","เบญจมราชานุสรณ์","นนทบุรีวิทยาลัย","รัตนาธิเบศร","วัดเขมาภิรตาราม","ศรีบุณยานนท์","สตรีนนทบุรี","ไทรน้อย","เทพศิรินทร์ นนทบุรี","บดินทรเดชา (สิงห์ สิงหเสนี) นนทบุรี","ศึกษาสงเคราะห์บางกรวย","บางบัวทอง","เตรียมอุดมศึกษาน้อมเกล้า นนทบุรี","นวมินทราชินูทิศ หอวัง นนทบุรี","โพธินิมิตวิทยาคม","สวนกุหลาบวิทยาลัย นนทบุรี","บูกิตประชาอุปถัมภ์","เฉลิมพระเกียรติกรมหลวงนราธิวาสราชนครินทร์ บางปอประชารักษ์","นราสิกขาลัย","เวียงสุวรรณวิทยาคม","ศึกษาสงเคราะห์นราธิวาส","สวนพระยาวิทยา","ตากใบ","บาเจาะ","ตันหยงมัส","เรียงราษฏร์อุปถัมภ์","ศรีวารินทร์","สุไหงโก-ลก","ธัญธารวิทยา","มัธยมสุไหงปาดี","สุคิรินวิทยา","น่านนคร","ศรีนครน่าน","เชียงกลาง ","พระธาตุพิทยาคม","น่านประชาอุทิศ","บ่อสวกวิทยาคาร","ศรีสวัสดิ์วิทยาคารจังหวัดน่าน","สตรีศรีน่าน","ตาลชุมพิทยาคม","ยาบหัวนาวิทยา","สา","สาธุกิจประชาสรรค์ รัชมังคลาภิเษก","แม่จริม","ท่าวังผาพิทยาคม","เมืองยมวิทยาคาร","สารธรรมวิทยาคาร","ทุ่งช้าง","ราชประชานุเคราะห์ 56","นาน้อย","นาหมื่นพิทยาคม","เมืองลีประชาสามัคคี","บ่อเกลือ","ปัว","มัธยมป่ากลาง","เมืองแงง","ศรัทธาศิลาเพชรรังสรรค์","ไตรเขตประชาสามัคคี รัชมังคลาภิเษก","สันติสุขพิทยาคม","แคนดงพิทยาคม","ดงพลองพิทยาคม","พนมรุ้ง","กนกศิลป์พิทยาคม","กลันทาพิทยาคม","บัวหลวงวิทยาคม","พระครูพิทยาคม","ภัทรบพิตร","สวายจีกพิทยาคม","สองห้องพิทยาคม","หนองตาดพิทยาคม","ร่มเกล้า บุรีรัมย์","ชุมแสงพิทยาคม","ลำดวนพิทยาคม","สูงเนินพิทยาคม","คูเมืองวิทยาคม","ตูมใหญ่วิทยา","มัธยมพรสำราญ","หนองขมารวิทยาคม","กู่สวนแตงพิทยาคม","ชำนิพิทยาคม","นาโพธิ์พิทยาคม","ถนนหักพิทยาคม","ทุ่งแสงทองพิทยาคม","นางรองพิทยาคม","พิมพ์รัฐประชาสรรค์","ราชประชานุเคราะห์ 51","สิงหวิทยาคม","เหลืองพนาวิทยาคม","โนนเจริญพิทยาคม","บ้านกรวดวิทยาคาร","รมย์บุรีพิทยาคม รัชมังคลาภิเษก","บ้านบุวิทยาสรรค์","ประโคนชัยพิทยาคม","ไพศาลพิทยาคม","เมืองตลุงพิทยาสรรพ์","แสลงโทนพิทยาคม","ไทยเจริญวิทยา","ปะคำพิทยาคม","พลับพลาชัยพิทยาคม","พุทไธสง","ตาจงพิทยาสรรค์","ร่วมจิตต์วิทยา","ละหานทรายวิทยา","จตุราษฏร์พิทยาคม","ตลาดโพธิ์พิทยาคม","ทะเมนชัยพิทยาคม","เมืองแฝกพิทยาคม","ลำปลายมาศ","จุฬาภรณราชวิทยาลัย บุรีรัมย์","เมืองแกพิทยาคม","ร่อนทองพิทยาคม","สมเสม็ดวิทยา","สะแกพิทยาคม","เมืองโพธิ์ชัยพิทยาคม","หนองกี่พิทยาคม","หนองหงส์พิทยาคม","ห้วยหินพิทยาคม","ห้วยราชพิทยาคม","ปทุมธานี ","ปทุมวิไล","หอวังปทุมธานี","ธรรมศาสตร์คลองหลวงวิทยาคม","สวนกุหลาบวิทยาลัย รังสิต","ธัญบุรี","ธัญรัตน์","จุฬาภรณราชวิทยาลัย ปทุมธานี","บัวแก้วเกษร","วรราชาทินัดดามาตุวิทยา","สุนทโรเมตตาประชาสรรค์","เทพศิรินทร์คลองสิบสาม ปทุมธานี","นวมินทราชินูทิศ สวนกุหลาบวิทยาลัย ปทุมธานี","มัธยมสังคีตวิทยา กรุงเทพมหานคร","เตรียมอุดมศึกษาพัฒนาการ ลำลูกกา","ชัยสิทธาวาส ","เตรียมอุดมศึกษาน้อมเกล้า ปทุมธานี","สามโคก","หนองเสือวิทยาคม","สามร้อยยอดวิทยาคม","ประจวบวิทยาลัย","หว้ากอวิทยาลัย","อ่าวน้อยวิทยานิคม","กุยบุรีวิทยา","ยางชุมวิทยา","ทับสะแกวิทยา","ห้วยยางวิทยา","บางสะพานวิทยา","บางสะพานน้อยวิทยาคม","เตรียมอุดมศึกษาพัฒนาการ ปราณบุรี","ปากน้ำปราณวิทยา","รัชตวิทยาคม","หนองพลับวิทยา","หัวหิน","หัวหินวิทยาคม","ไทยรัฐวิทยา 7","มัธยมวัดป่ามะไฟ","อดุลศาสนกิจศึกษา","กบินทร์บุรี","นนทรีวิทยาคม","วังดาลวิทยาคม","วังตะเคียนวิทยาคม","ทุ่งใหญ่วิทยาคาร","ร่มเกล้า ปราจีนบุรี","กระทุ่มแพ้ววิทยา","ชิตใจชื่น","ศรีรักษ์ราษฏร์บำรุง","สุวรรณวิทยา","ศรีมโหสถ","กรอกสมบูรณ์วิทยาคม","ศรีมหาโพธิ","แม่ลานวิทยา","ราชมุนีรังสฤษฏ์","ไม้แก่นกิตติวิทย์","วังกะพ้อพิทยาคม","ท่าข้ามวิทยาคาร","ประตูโพธิ์วิทยา","สะนอพิทยาคม","สายบุรี ","ปทุมคงคาอนุสรณ์","ยาบีบรรณวิทย์","ลาดงาประชาบำรุง","สาคลีวิทยา","ท่าหลวงวิทยานุกูล","ท่าช้างวิทยาคม","นครหลวง ","บางไทรวิทยา","บางซ้ายวิทยา","บางบาล","บางปะหัน","อุดมศีลวิทยา","บ้านแพรกประชาสรรค์","ผักไห่ ","ลาดชะโดสามัคคี","วัดโพธิ์ผักไห่ (เวชพันธุ์อนุสรณ์)","ปากกรานพิทยา","อยุธยานุสรณ์","อยุธยาวิทยาลัย","ภาชี ","มหาราช ","ลาดบัวหลวงไพโรจน์วิทยา","วังน้อย (พนมยงค์วิทยา)","วิเชียรกลิ่นสุคนธ์อุปถัมภ์","หนองน้ำส้มวิทยาคม","อุทัย","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ พะเยา","ดงเจนวิทยาคม","ภูซางวิทยาคม","ฝายกวางวิทยาคม","เชียงม่วนวิทยาคม","พะเยาประสาธน์วิทย์","ฟากกว๊านวิทยาคม","แม่ใจวิทยาคม","พญาลอวิทยาคม","ราชประชานุเคราะห์ 24","งำเมืองวิทยาคม","ถ้ำปินวิทยาคม","ขุนควรวิทยาคม","ปงพัฒนาวิทยาคม","ปงรัชดาภิเษก","เกาะยาววิทยา","ดีบุกพังงาวิทยายน","คุระบุรีชัยพัฒนาพิทยาคม","คลองเคียนรัฐราษฏร์รังสรรค์","ตะกั่วทุ่งงานทวีวิทยาคม","ทุ่งโพธิ์วิทยา","ตะกั่วป่า ","ตะกั่วป่าคีรีเขต","ทับปุดวิทยา","ท้ายเหมืองวิทยา","เขาชัยสน","หานโพธิ์พิทยาคม","ประภัสสรรังสิต","พรหมพินิตชัยบุรี","พัทลุง","พัทลุงพิทยาคม","วชิรธรรมสถิต","ศึกษาสงเคราะห์พัทลุง","กงหราพิชากร","ควนขนุน","ดอนศาลานำวิทยา","นาขยาดวิทยาคาร","ปัญญาวุธ","พนางตุง","อุดมวิทยายน","ตะโหมด","บางแก้วพิทยาคม","ควนพระสาครินทร์","ปากพะยูนพิทยาคาร","มัธยมเกาะหมาก","หารเทารังสีประชาสรรค์","ป่าพะยอมพิทยาคม","ตะแพนพิทยา","ศรีบรรพตพิทยาคม","วังงิ้ววิทยาคม","บางลายพิทยาคม","แหลมรังวิทยาคม","พิจิตรพิทยาคม","วังกรดพิทยา","สระหลวงพิทยาคม","หัวดงรัฐชนูปถัมภ์","ท่าเสาพิทยาคม","พิบูลธรรมเวทวิทยา","ห้วยยาวพิทยาคม","ดงเสือเหลืองพิทยาคม","ตะพานหิน","ทุ่งโพธิ์พิทยา","วังสำโรงวังหว้า","วันทีสถิตย์พิทยาคม","วังตะกูราษฏร์อุทิศ","วชิรบารมีพิทยาคม","วังโมกข์พิทยาคม","วังทรายพูนวิทยา","เนินปอรังนกชนูทิศ","สามง่ามชนูปถัมภ์","หนองโสนพิทยาคม","ไทรย้อยพิทยาคม","จ่านกร้อง","จุฬาภรณราชวิทยาลัย พิษณุโลก","เฉลิมขวัญสตรี","ดอนทองวิทยา","ท่าทองพิทยาคม","พุทธชินราชพิทยา","วังน้ำคู้ศึกษา","ชาติตระการวิทยา","สวนเมี่ยงวิทยา","นครชุมพิทยา รัชมังคลาภิเษก","นครบางยางพิทยาคม","นาบัววิทยา","บ่อโพธิ์วิทยา","บางกลางท่าวพิทยาคม","ยางโกลนวิทยา","ราชประชานุเคราะห์ 23","ศรีอินทราทิตย์พิทยาคม","เนินกุ่มวิทยา","ชุมแสงสงคราม ","บางระกำวิทยศึกษา","ประชาสงเคราะห์วิทยา","ดงประคำพิทยาคม","วังมะด่านพิทยาคม","วังทองพิทยาคม","วังพิกุลวิทยศึกษา","คันโช้งพิทยาคม","วัดโบสถ์ศึกษา","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ภูเก็ต","เชิงทะเลวิทยาคม ","วีรสตรีอนุสรณ์","กุดรังประชาสรรค์","เลิงแฝกประชาบำรุง","กู่ทองพิทยาคม","เชียงยืนพิทยาคม","ดอนเงินพิทยาคาร","เกิ้งวิทยานุกูล","โคกก่อพิทยาคม","ผดุงนารี","มหาชัยพิทยาคาร","มหาวิชานุกูล","สารคามพิทยาคม","มิตรภาพ","โกสุมวิทยาสรรค์","เขวาไร่ศึกษา","เขื่อนพิทยาสรรค์","โพนงามพิทยานุกูล","วังยาวศึกษาวิทย์","หนองบัวปิยนิมิตร","หนองเหล็กศึกษา","กันทรวิชัย","เขวาใหญ่พิทยาสรรค์","ท่าขอนยางพิทยาคม","นาสีนวนพิทยาสรรค์","มะค่าพิทยาคม","ศรีสุขพิทยาคม","ชื่นชมพิทยาคาร","นาเชือกพิทยาสรรค์","ปอพานพิทยาคม รัชมังคลาภิเษก","ดงบังพิสัยนวการนุสรณ์","นาดูนประชาสรรพ์","มัธยมดงยาง","โนนแดงวิทยาคม","โนนราษีวิทยา","บรบือ","บรบือวิทยาคาร","ยางวิทยาคม","หนองโกวิชาประสิทธิ์พิทยาคม","หนองม่วงวิทยาคาร","เหล่ายาววิทยาคาร","พยัคฆภูมิวิทยาคาร","เมืองเตาวิทยาคม","เวียงสะอาดพิทยาคม","นาภูพิทยาคม","มัธยมยางสีสุราช","ขามป้อมพิทยาคม","งัวบาวิทยาคม","ดงใหญ่วิทยาคม รัชมังคลาภิเษก","นาข่าวิทยาคม","วาปีปทุม","เสือโก้กวิทยาสรรค์","หัวเรือพิทยาคม","คำป่าหลายสรรพวิทย์","ดงมอนวิทยาคม","นวมินทราชูทิศ อีสาน","นาโสกวิทยาคาร","ผึ่งแดดวิทยาคาร","มุกดาวิทยานุกูล","มุกดาหาร","เมืองมุกวิทยาคม","คำชะอีพิทยาคม","คำชะอีวิทยาคาร","คำบกวิทยาคาร","ชัยปัญญาวิทยานุสรณ์","กกตูมประชาสรรค์ รัชมังคลาภิเษก","ดงหลวงวิทยา","ดอนตาลวิทยา","ผาเทิบวิทยา","โพธิ์ไทรวิทยา","โชคชัยวิทยา","ร่มเกล้าพิทยาสรรค์","แวงใหญ่พิทยาสรรค์","อุดมวิทย์","พลังราษฏร์พิทยาสรรพ์","หว้านใหญ่วิทยา","ยโสธรพิทยาคม","ยโสธรพิทยาสรรค์","นาโปร่งประชาสรรค์ (พลอากาศเอกจรูญ วุฒิกาญจน์ อุปถัมภ์)","ศรีแก้วประชาสรรค์","คำเตยวิทยา","น้ำคำวิทยาคม","กำแมดขันติธรรมวิทยาคม","โพนงามพิทยาคาร","เมืองกลางประชานุกูล","หนองแหนพัฒนวิทยาคม","กู่จานวิทยาคม","คำเขื่อนแก้วชนูปถัมภ์","โพนทันเจริญวิทย์","สมเด็จพระญาณสังวร ในพระสังฆราชูปถัมภ์","ดงมะไฟพิทยาคม","ป่าติ้ววิทยา","ตระกูลประเทืองวิทยาคม","จันทร์ประภัสสร์อนุสรณ์","เบตง ","คณะราษฎรบำรุง 2","คณะราษฎรบำรุงยะลา","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ยะลา","สตรียะลา","กาบังพิทยาคม","นิคมพัฒนวิทย์","รามันห์ศิริวิทย์","เชียงขวัญพิทยาคม","พลับพลาวิทยาคม","เทอดไทยวิทยาคม","ดูกอึ่งประชาสามัคคี","หนองฮีเจริญวิทย์","กู่กาสิงห์ประชาสรรค์","จตุรพักตรพิมานรัชดาภิเษก","จันทรุเบกษาอนุสรณ์","ทุ่งกุลาประชานุสรณ์","หนองผึ้งวิทยาคาร","เหล่าหลวงประชานุสรณ์","ขัติยะวงษา","พลาญชัยพิทยาคม","ร้อยเอ็ดวิทยาลัย","สตรีศึกษา","เมืองสรวงวิทยา","สูงยางวิทยาประชาสรรค์","ท่าม่วงวิทยาคม","โพธิ์ทองวิทยาคาร","วังหลวงวิทยาคม","เสลภูมิ","เสลภูมิพิทยาคม","เชียงใหม่ประชานุสรณ์","โพธิ์ชัยชนูปถัมภ์","สามขาวิทยา","คำนาดีพิทยาคม","โนนชัยศรีวิทยา","โพธิ์ศรีสว่างวิทยา","โพนทองวิทยายน","ม่วงมิตรวิทยาคม","โคกล่ามพิทยาคม","ดู่น้อยประชาสรรค์","ศึกษาสงเคราะห์ธวัชบุรี","จังหารฐิตวิริยาประชาสรรค์","ม่วงลาดวิทยาคาร","ธวัชบุรีวิทยาคม","เมืองน้อยวิทยาคม","โพนสูงประชาสรรค์","พนมไพรวิทยาคาร","โพธิ์ทองพิทยาคม","ศรีสมเด็จพิมพ์พัฒนาวิทยา","ช้างเผือกวิทยาคม","ทุ่งหลวงพลับพลาไชย","สุวรรณภูมิวิทยาลัย","สุวรรณภูมิพิทยไพศาล","หัวโทนวิทยา","หินกองวิทยาคาร","ผาน้ำทิพย์วิทยา","โพธิ์แก้วประชาสรรค์","หนองพอกวิทยาลัย","บ้านขี้เหล็กพิทยาคม","โพนเมืองประชารัฐ ","อาจสามารถวิทยา","สุขสำราญรังสรรค์","ราชประชานุเคราะห์ 38","กระบุรีวิทยา","ปากจั่นวิทยา","กะเปอร์วิทยา","ละอุ่นวิทยาคาร","เขาชะเมาวิทยา","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ระยอง","มาบตาพุดพันพิทยาคาร","ระยองวิทยาคม นิคมอุตสาหกรรม","ระยองวิทยาคมปากน้ำ","บ้านฉางกาญจนกุลวิทยา","แคทรายวิทยา","เบญจมราชูทิศ ราชบุรี","ราชโบริกานุเคราะห์","ช่องพรานวิทยา","ท่ามะขามวิทยา","หนองโพวิทยา","บ้านคาวิทยา","ด่านทับตะโกราษฏร์อุปถัมภ์","เตรียมอุดมศึกษาพัฒนาการดอนคลัง","เนกขัมวิทยา","ประสาทรัฐประชากิจ","บางแพปฐมพิทยา","โพหัก ","รัตนราษฎร์บำรุง","มัธยมวัดดอนตูม","หนองปลาหมอพิทยาคม","บรมราชินีนาถราชวิทยาลัย","ปากท่อพิทยาคม","วัดสันติการามวิทยา","โสภณศิริราษฏร์","สวนผึ้งวิทยา","โคกกะเทียมวิทยาลัย","โคกตูมวิทยา","ดงตาลวิทยา","บ้านข่อยวิทยา","พระนารายณ์","พิบูลวิทยาลัย","ยางรากวิทยา","จุฬาภรณราชวิทยาลัย ลพบุรี","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ลพบุรี","ชัยบาดาลพิทยาคม","บ้านเบิกวิทยาคม","ท่าหลวงวิทยาคม","บ้านชีวิทยา","บ้านหมี่วิทยา","ขุนรามวิทยา","โคกสลุงวิทยา","พัฒนานิคม","ลำสนธิวิทยา","สระโบสถ์วิทยาคาร","ราชประชานุเคราะห์ 33","หนองม่วงวิทยา","เถินวิทยา","เวียงมอกวิทยา","ทุ่งอุดมวิทยา","เมืองปานพัฒนวิทย์","เมืองปานวิทยา","กิ่วลมวิทยา","เขลางค์นคร","ปงแสนทองวิทยา","เมืองมายวิทยา","ศึกษาสงเคราะห์จิตต์อารี","สบจางวิทยา","แม่ทะพัฒนศึกษา","แม่ทะวิทยา","ประชาราชวิทยา","วังเหนือวิทยา","สบปราบพิทยาคม","บ้านแป้นพิทยาคม","ส่วนบุญโญปถัมภ์","อุโมงค์วิทยาคม","ทาขุมเงินวิทยาคาร","แม่ทาวิทยาคม","ทุ่งหัวช้างพิทยาคม","บ้านโฮ่งรัตนวิทยา","ราชประชานุเคราะห์ 26","ป่าตาลบ้านธิพิทยา","น้ำดิบวิทยาคม","ป่าซาง","วชิรป่าซาง","นาทรายวิทยาคม","แม่ตืนวิทยา","เวียงเจดีย์วิทยา","โพธิ์ศรีสุวรรณวิทยาคม","คลีกลิ้งพัฒนาทร","ศิลาลาดวิทยา","หนองหว้าประชาสรรค์","เมืองจันทร์วิทยาคม","วรคุณอุปถัมภ์","ไกรภักดีวิทยาคม","คูซอดประชาสรรค์","น้ำคำวิทยา","มัธยมโพนค้อ","ศรีสะเกษวิทยาลัย 2 ห้วยคล้า","โคกสะอาดวิทยาคม","บกวิทยาคม","กุญชรศิรวิทย์","โนนปูนวิทยาคม","กระแชงวิทยา","กันทรลักษ์วิทยาคม","กุดเสลาวิทยาคม","ดงรักวิทยา","บึงมะลูวิทยา","ภูมิซรอลวิทยา","สายธารวิทยา","กระดุมทองวิทยา","บัวน้อยวิทยา","ผักแพววิทยา","ละทายวิทยา","แวงแก้ววิทยา","หนองถ่มวิทยา","ขุขันธ์","ลมศักดิ์วิทยาคม","ปรือใหญ่วิทยบัลลังก์","สวงษ์วิทยาคม","สะเดาใหญ่ประชาสรรค์","กันทรอมวิทยาคม","นาแก้ววิทยา","พรานวิบูลวิทยา","โพธิ์วงศ์วิทยา","ไพรธรรมคุณวิทยา","ร่มโพธิ์วิทยา","เขื่อนช้างวิทยาคาร","บัวเจริญวิทยา","บึงบูรพ์","ตูมพิทยานุสรณ์","โนนกระสังวิทยาคม","พอกพิทยาคม รัชมังคลาภิเษก","สวายพิทยาคม","หนองคูวิทยา","โนนเพ็กวิทยาคม","พยุห์วิทยา","ภูสิงห์ประชาเสริมวิทย์","ละลมวิทยา","ลิ้นฟ้าพิทยาคม","จิกสังข์ทองวิทยา","เบญจประชาสรรค์","ไผ่งามพิทยาคม","เมืองแคนวิทยาคม","ราษีไศล","หวายคำวิทยา","โพธิ์ธาตุประชาสรรค์","หนองทุ่มศรีสำราญวิทยา","ผักไหมวิทยานุกูล","กำแพง","โคกหล่ามวิทยา","จตุรภูมิพิทยาคาร","ทุ่งไชยพิทยา รัชมังคลาภิเษก","ทุ่งสิมวิทยาคม","ประชาพัฒนศึกษา","เจริญศิลป์ศึกษา","เต่างอยพัฒนศึกษา","เฉลิมพระเกียรติฯ สกลนคร","ท่าแร่ศึกษา","สกลราชวิทยานุกูล","สกลราชวิทยานุกูล 2","ด่านม่วงคำพิทยาคม","โพนพิทยาคม","กุดบากพัฒนาศึกษา","ร่มไทรวิทยา","คำตากล้าราชประชาสงเคราะห์","ศึกษาประชาสามัคคี","นิคมน้ำอูนเจริญวิทยา","คำยางพิทยา","โพธิ์ชัยทองพิทยาคม","ช้างมิ่งพิทยานุกูล","เทพสวัสดิ์วิทยา","พรรณาวุฒาจารย์","ภูริทัตต์วิทยา","ราชประชานุเคราะห์ 53","ลำปลาหางวิทยา","เดื่อศรีไพรวัลย์","ธาตุทองอำนวยวิทย์","มัธยมวานรนิวาส","ธรรมบวรวิทยา","วาริชวิทยา","โคกสีวิทยาสรรค์","เตรียมอุดมศึกษา ภาคตะวันออกเฉียงเหนือ","บงเหนือวิทยาคม","แวงพิทยาคม","สว่างแดนดิน","หนองหลวงศึกษา","ส่องดาววิทยาคม","ท่าสงครามวิทยา","อากาศอำนวยศึกษา","เทพพิทยาภาณุมาศ","เกาะแต้วพิทยาสรรค์","ควนเนียงวิทยา","ปากจ่าวิทยา","จะนะชนูปถัมภ์","จะนะวิทยา","จะโหนงพิทยาคม","ไม้แก่นประชาอุทิศ","ธรรมโฆสิต","บางกล่ำวิทยา รัชมังคลาภิเษก","คลองแดนวิทยา","ตะเครียะวิทยาคม","ระโนด","ระโนดวิทยา","มัธยมสิริวัณวรี 2 สงขลา","รัตภูมิวิทยา","สทิงพระชนูปถัมภ์","สทิงพระวิทยา","กอบกุลวิทยาคม","ปาดังติณสูลานนท์","สะเดา ","เขาแดงกุศลวิทยา","สะบ้าย้อยวิทยา","รัตนพลวิทยา","สงขลาวิทยาคม","คูเต่าวิทยา","พะตงประธานคีรีวัฒน์","หาดใหญ่เจริญราษฎร์พิทยา","หาดใหญ่รัฐประชาสรรค์","หาดใหญ่วิทยาลัย","หาดใหญ่วิทยาลัยสมบูรณ์กุลกันยา","ปาล์มพัฒนวิทย์","จุฬาภรณราชวิทยาลัย สตูล","สตูลวิทยา","ควนโดนวิทยา","ควนกาหลงวิทยาคม","ท่าแพผดุงวิทย์","สาครพิทยาคาร","ท่าศิลาบำรุงราษฎร์","ทุ่งหว้าวรวิทย์","ละงูพิทยาคม","บดินทรเดชา (สิงห์ สิงหเสนี) สมุทรปราการ","นวมินทราชินูทิศ สวนกุหลาบวิทยาลัย สมุทรปราการ","เทพศิรินทร์ สมุทรปราการ","มัธยมด่านสำโรง","สมุทรปราการ","บางบ่อวิทยาคม","เปร็งวิสุทธาธิบดี","หลวงพ่อปานคลองด่านอนุสรณ์","บางพลีราษฏร์บำรุง","พูลเจริญวิทยาคม","เตรียมอุดมศึกษาน้อมเกล้า สมุทรปราการ","ราชประชาสมาสัย ฝ่ายมัธยม รัชดาภิเษก ในพระบรมราชูปถัมภ์","วิสุทธิกษัตรี","ป้อมนาคราชสวาทยานนท์","มัธยมวัดใหม่สมุทรกิจวิทยาคม","สาขลาสุทธีราอุปถัมภ์","ถาวรานุกูล","ท้ายหาด","ศรัทธาสมุทร","เมธีชุณหะวัณวิทยาลัย","สกลวิสุทธิ","เทพสุวรรณชาญวิทยา","วัดแก้วเจริญอำนวยวิทย์","วัดบางกะพ้อม (คงลาภยิ่งประชานุสรณ์)","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ สมุทรสาคร","พันท้ายนรสิงห์วิทยา","สมุทรสาครวุฒิชัย","กระทุ่มแบน ","กุศลวิทยา","อ้อมน้อยโสภณชนูปถัมภ์","วัดธรรมจริยาภิรมย์","วัดหลักสี่พิพัฒน์ราษฏร์อุปถัมภ์","หลักสองส่งเสริมวิทยา","เขาฉกรรจ์วิทยาคม","ทรัพย์สมบูรณ์วิทยาคม","ท่าเกษมพิทยา","บ้านแก้งวิทยา","สระแก้ว","สิริราชอนุสรณ์","คลองหาดพิทยาคม","ไทรเดี่ยววิทยา","ซับม่วงวิทยา","ตาพระยา","ทัพราชวิทยา","วังไพรวิทยาคม","วังหลังวิทยาคม","ซับนกแก้ววิทยา","ร่มเกล้าวัฒนานคร สระแก้ว รัชมังคลาภิเษก","คลองน้ำใสวิทยาคาร","อรัญประเทศ","เทพศิรินทร์ พุแค","สวนกุหลาบวิทยาลัย สระบุรี","สระบุรีวิทยาคม","โคกกระท้อนกิตติวุฒิวิทยา","แก่งคอย","บ้านท่ามะปรางวิทยา","สองคอนวิทยาคม","ดอนพุดวิทยา","พระพุทธบาท ","สุธีวิทยา","ซับน้อยเหนือวิทยาคม","มวกเหล็กวิทยา","ประเทียบวิทยาทาน","เตรียมอุดมศึกษาพัฒนาการ สระบุรี","หินกองวิทยาคม","หนองโดนวิทยา","สิงห์บุรี","สิงหพาหุ ","หัวไผ่วิทยาคม","ค่ายบางระจันวิทยาคม","ท่าช้างวิทยาคาร","บางระจันวิทยา","ศรีศักดิ์สุวรรณวิทยา","บ้านแป้งวิทยา","พรหมบุรีรัชดาภิเษก","ทองเอนวิทยา","ศรีวินิตวิทยาคม","อินทร์บุรี","บ้านสวนวิทยาคม","ยางซ้ายพิทยาคม","ลิไทพิทยาคม","สุโขทัยวิทยาคม","กงไกรลาศวิทยา","ไกรในวิทยาคม รัชมังคลาภิเษก","หนองตูมวิทยา","คีรีมาศพิทยาคม","บ้านใหม่เจริญผลพิทยาคม","ชัยมงคลพิทยา","ทุ่งเสลี่ยมชนูปถัมภ์","ตลิ่งชันวิทยานุสรณ์","บ้านด่านลานหอยวิทยา","ท่าชัยวิทยา","บ้านแก่งวิทยา","เมืองเชลียง","เมืองด้งวิทยา","ขุนไกรพิทยาคม","ศรีสำโรงชนูปถัมภ์","สวรรค์อนันต์วิทยา","สวรรค์อนันต์วิทยา 2","หนองกลับวิทยาคม","หนองปลาหมอวิทยาคม","ทุ่งคลีโคกช้างวิทยา","ธรรมโชติศึกษาลัย","บรรหารแจ่มใสวิทยา 7","บ่อกรุวิทยา","กรรณสูตศึกษาลัย","กาญจนาภิเษกวิทยาลัย สุพรรณบุรี","ตลิ่งชันวิทยา","สงวนหญิง","สวนแตงวิทยา","บรรหารแจ่มใสวิทยา 1","สระกระโจมโสภณพิทยา","ด่านช้างวิทยา","บรรหารแจ่มใสวิทยา 3","บางแม่หม้ายรัฐราษฏร์รังสฤษดิ์","หรรษาสุจิตต์วิทยา 2","วังหว้าราษฎร์สามัคคี","ศรีประจันต์","สรวงสุทธาวิทยา","บรรหารแจ่มใสวิทยา 5","บ่อสุพรรณวิทยา","บางลี่วิทยา","หนองวัลย์เปรียงวิทยา","ทุ่งแฝกพิทยาคม","บรรหารแจ่มใสวิทยา 6","หนองหญ้าไซวิทยา","ดอนคาวิทยา","สระยายโสมวิทยา","อู่ทอง","อู่ทองศึกษาลัย","ตะกุกใต้ศึกษา","มัธยมวิภาวดี","เกาะพะงันศึกษา","เกาะสมุย","ทีปราษฏร์พิทยา","เคียนซาพิทยาคม","บ้านเสด็จพิทยาคม","พ่วงพรมครวิทยา","สุราษฎร์พิทยา 2 (สร.2)","มัธยมพัชรกิติยาภา 3 สุราษฎร์ธานี","เมืองสุราษฏร์ธานี","ศึกษาสงเคราะห์สุราษฎร์ธานี (สำนักงานบริหารงานกศ.พิเศษ)","คลองฉนวนวิทยา","กาญจนาภิเษกวิทยาลัย สุราษฎร์ธานี","เขาพนมแบกศึกษา","ไชยาวิทยา","กาญจนดิษฐ์","ท่าเฟืองวิทยา","ท่าอุแทพิทยา","คีรีรัฐวิทยาคม","ชัยบุรีพิทยา","องค์การบริหารส่วนจังหวัดสุราษฎร์ธานี 1 (ดอนสักผดุงวิทย์)","ปากแพรกวิทยาคม","ท่าฉางวิทยาคาร","เสวียดวิทยา รัชมังคลาภิเษก","บ้านตาขุนวิทยา","รัชชประภาวิทยาคม","ควนสุบรรณวิทยา","ท่าชีวิทยาคม","พนมศึกษา","บางสวรรค์วิทยาคม","ท่าสะท้อนวิทยา","น้ำรอบวิทยา","บางเดือนสถิตย์พิทยาคม","พุนพินพิทยาคม","บึงนครประชาสรรค์","แร่วิทยา","โนนเทพ","ประดู่แก้วประชาสรรค์","โชคเพชรพิทยา","ตั้งใจวิทยาคม","ท่าสว่างวิทยา","นาดีวิทยา","พญารามวิทยา","มหิธรวิทยา","ศรีรามประชาสรรค์","สุรินทร์พิทยาคม","สุรินทร์ราชมงคล","แสงทรัพย์ประชาวิทยาคาร","โคกตะเคียนวิทยา","แนงมุดวิทยา","ปราสาทเบงวิทยา","บุแกรงวิทยาคม","เมืองลีงวิทยา","หนองสนิทวิทยา","ลำพลับพลาวิทยาคาร","ช้างบุญวิทยา","ทุ่งกุลาพิทยาคม","โนนแท่นพิทยาคม","พรมเทพพิทยาคม","เมืองแกพิทยาสรรค์","ลานทรายพิทยาคม","ศรีปทุมพิทยาคม","มัธยมศรีสำเภาลูน","โคกยางวิทยา","เชื้อเพลิงวิทยา","ตาเบาวิทยา","ทุ่งมนวิทยาคาร","ไทรแก้ววิทยา","แกศึกษาพัฒนา","ดอนแรดวิทยา","ทับโพธิ์พัฒนวิทย์","ธาตุศรีนคร","ขวาวใหญ่วิทยา","จารย์วิทยาคาร","มัธยมจารพัตวิทยา","ยางวิทยาคาร","วังข่าพัฒนา","ห้วยจริงวิทยา","หนองขุนศรีวิทยา","หนองอียอวิทยา","ตาคงวิทยา รัชมังคลาภิเษก","เทพอุดมวิทยา","พระแก้ววิทยา","สำโรงทาบวิทยาคม","เจ็ดสีวิทยาคาร","โสกก่ามวิทยา","เหล่าคามพิทยาคม รัชมังคลาภิเษก","นาดีพิทยาคม","วังหลวงพิทยาสรรพ์","ปทุมเทพวิทยาคาร 2 (กวนวันวิทยา)","ค่ายบกหวานวิทยา","เวียงคำวิทยาคาร","หนองคายวิทยาคาร","หินโงมพิทยาคม","โนนคำพิทยาคม","โพนทองประชาสรรค์","กุดบงพิทยาคาร","เซิมพิทยาคม","นาหนังพัฒนศึกษา","ปากสวยพิทยาคม","ร่มธรรมานุสรณ์","โคกคอนวิทยาคม","ถ่อนวิทยา","ท่าบ่อพิทยาคม","หนองนางพิทยาคม","ท่าดอกคำวิทยาคม","บึงโขงหลงวิทยาคม","บึงกาฬ","โพธิ์ทองวิทยานุสรณ์","หนองเข็งวิทยาคม","บุ่งคล้านคร","สมสนุกพิทยาคม","หนองยองพิทยาคม รัชมังคลาภิเษก","ศรีสำราญวิทยาคม","หนองหัวช้างวิทยา","ประชาบดีพิทยาคม","พระบาทนาสิงห์พิทยาคม","พระพุทธบาทวิทยาคม","พานพร้าว","วรลาโภนุสรณ์","ภูทอกวิทยา","ศรีวิไลวิทยา","น้ำสวยวิทยา","วังม่วงพิทยาคม","บ้านขามพิทยาคม","หนองบัวพิทยาคาร","หนองสวรรค์วิทยาคาร","โนนสังวิทยาคาร","หนองเรือพิทยาคม","กุดดินจี่พิทยาคม","คำแสนวิทยาสรรค์","ฝั่งแดงวิทยาสรรค์","นาแกวิทยา","นาวังศึกษาวิช","กุงแก้ววิทยาคาร","กุดสะเทียนวิทยาคาร","นากอกวิทยาคาร","ดงมะไฟวิทยาคม","สุวรรณคูหาพิทยาสรรค์","โยธินบูรณะ อ่างทอง","ริ้วหว้าวิทยาคม","แสวงหาวิทยาคม","ราชสถิตย์วิทยา","บางเสด็จวิทยาคม","ปาโมกข์วิทยาภูมิ","ไผ่วงวิทยา","วิเศษชัยชาญวิทยาคม","สามโก้วิทยาคม","คึมใหญ่วิทยา","นายมวิทยาคาร","นาวังวิทยา","น้ำปลีกศึกษา","ราชประชานุเคราะห์ 54","สร้างนกทาวิทยาคม","อำนาจเจริญ 2","คำเขื่อนแก้ววิทยาคม","ปทุมราชวงศา","ลือวิทยาคม","มัธยมแมด","ลืออำนาจวิทยาคม","จิกดู่วิทยา","จอมศรีพิทยาคาร","เชียงหวางพิทยาคาร","สุมเส้าพิทยาคาร","กุดจับประชาสรรค์","เชียงพังพัฒนวิช","ธาตุโพนทองวิทยาคม","ประจักษ์ศิลปาคาร","มัธยมสิริวัณวรี 1 อุดรธานี","ราชินูทิศ 2","สามพร้าววิทยา","อุดรธรรมานุสรณ์","อุดรธานีพิทยาคม","อุดรพัฒนศึกษา","อุดรพัฒนาการ","อุดรพิทยานุกูล","ทมนางามวิทยาคม","โพนสูงพัฒนศึกษา","เชียงเพ็งวิทยา","ภูพานวิทยา","กุมภวาปี","กุมภวาปีพิทยาสรรค์","แชแลพิทยานุสรณ์","เสอเพลอพิทยาคม","กู่แก้ววิทยา","ทุ่งฝนพัฒนศึกษา","ยูงทองพิทยาคม","น้ำซึมพิทยาคม","สามัคคีพิทยาคาร","ชัยนาคำวิทยา","ดงเย็นพิทยาคาร","ทรัพย์อุดมวิทยา","นาไหมพิทยาคม รัชมังคลาภิเษก","โนนสะอาดชุมแสงวิทยา","จำปาโมงวิทยาคาร","ภูพระบาทวิทยา","หนองหัวคูปวงประชานุเคราะห์","ประจักษ์ศิลปาคม","สามพาดพิทยาคาร","กุงเจริญพิทยาคม","ตาดทองพิทยาคม","ยิ่งยวดพิทยานุกูล","สร้างคอมวิทยา","หนองแสงวิทยศึกษา","แสงอร่ามพิทยาคม","หนองยางชุมพิทยาคม","พังงูพิทยาคม","ทุ่งกะโล่วิทยา","น้ำริดวิทยา","วังกะพี้พิทยาคม","แสนตอวิทยา","อุตรดิตถ์","ตรอนตรีสินธุ์","ทองแสนขันวิทยา","ท่าปลาประชาอุทิศ","น้ำปาดชนูปถัมภ์","บ้านโคกวิทยาคม","ดาราพิทยาคม","บ้านโคนพิทยา","ด่านแม่คำมันพิทยาคม","ลับแลพิทยาคม","ลับแลศรีวิทยา","การุ้งวิทยาคม","ทองหลางวิทยาคม","หนองจอกประชานุสรณ์","บ่อยางวิทยา","ทุ่งโพวิทยา","สมอทองปทีปพลีผลอุปถัมภ์","นาเยียศึกษา รัชมังคลาภิเษก","พะลานวิทยาคม","พังเคนพิทยา","น้ำขุ่นวิทยา","สว่างวีระวงศ์","แก้งเหนือพิทยาคม","เขมราฐพิทยาคม","เก่าขามวิทยา","ชีทวนวิทยาสามัคคี","นาคำวิทยา","บ้านไทยวิทยาคม","สหธาตุศึกษา","เสียมทองพิทยาคม","ท่าโพธิ์ศรีพิทยา","ทุ่งเทิงยิ่งวัฒนา","นากระแซงศึกษา","นาส่วงวิทยา","บัวงามวิทยา","นารีนุกูล","นารีนุกูล 2","เบ็ญจะมะมหาราช","ปทุมพิทยาคม","อุบลราชธานีศรีวนาลัย","พระวอพระตาวิทยานุสรณ์","ราชประชานุเคราะห์ 32","ศรีปทุมพิทยาคาร","หนองขอนวิทยา","หนองบ่อสามัคคีวิทยา","โขงเจียมวิทยาคม","เหล่างามพิทยาคม","กุดข้าวปุ้นวิทยา","ขุมคำวิทยาคาร","โนนสวางประชาสรรค์","เกษมสีมาวิทยาคาร","นาสะไมพิทยาคม","โนนกุงวิทยาคม","มัธยมตระการพืชผล","สะพือวิทยาคาร","เชียงแก้วพิทยาคม","ตาลสุมพัฒนา","ทุ่งศรีอุดม","ดงสว่างวิทยา","นาจะหลวย","โดมประดิษฐ์วิทยา","น้ำยืนวิทยา","นาโพธิ์วิทยา","บุณฑริกวิทยาคาร","ห้วยข่าพิทยาคม","โนนกลางวิทยาคม","พิบูลมังสาหาร","หนองบัวฮีวิทยาคม","อ่างศิลา","ดงยางวิทยาคม","ไผ่ใหญ่ศึกษา","ม่วงสามสิบอัมพวันวิทยา","ศรีน้ำคำศึกษา","ลือคำหาญวารินชำราบ","วารินชำราบ","วิจิตราพิทยา","ห้วยขะยุงวิทยา","ศรีเมืองวิทยาคาร","หนามแท่งพิทยาคม รัชมังคลาภิเษก","เอือดใหญ่พิทยา","โคกสว่างคุ้มวิทยานุสรณ์","สำโรงวิทยาคาร","เบ็ตตี้ดูเมน 2 ช่องเม็ก","สิรินธรวิทยานุสรณ์","ศึกษาสงเคราะห์แม่ฮ่องสอน","วชิรมกุฏ","บาลีสาธิตศึกษา","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีบุญเรือง","บาลีเตรียมอุดมศึกษา","พุทธศาสตร์วิทยา","วัดกาญจนสิงหาสน์วิทยา","พระปริยัติธรรมวัดพรหมรังษี","พระปริยัติธรรมวัดธรรมมงคล","พระปริยัติธรรมวัดเวตวันธรรมาวาส","พระปริยัติธรรมวัดมหาสวัสดิ์วิทยา","วัดโกเมศรัตนาราม","เตรียมพุทธศาสตร์","พระปริยัติธรรมแผนกสามัญศึกษา วัดเมืองยะลา","ธรรมจักรวิทยา","สาธิตศึกษาวิทยาลัยสงฆ์ภาคทักษิณ เทศบาลนครนครศรีธรรมราช","พระปริยัติธรรมวัดมะนาวหวาน","พระบรมธาตุพิทักษ์วิทยา","พระปริยัติธรรมวัดขนาน","แสงธรรมพิทยาคม พระปริยัติธรรมแผนกสามัญ","พระปริยัติธรรมวัดกรวด","พุทธรังษีพิทยาลัย","พุทธวิทยา","แสงทองวิทยาธรรม","วัดมัชฌิมาวิสุทธิเทพวิทยา","หลวงพ่อเดิมประสิทธิ์วิทยา","สิทธิธรรม","พระปริยัติธรรมวัดตโปทาราม","พระปริยัติธรรมแผนกสามัญศึกษา วัดถ้ำสิงโตทอง","พระปริยัติธรรมแผนกสามัญศึกษา วัดธรรมิการามวรวิหาร","วัดนิเวศธรรมประวัติ","ศรีเมืองทองวิทยา","วัดเกาะปริยัติวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดกวิศรารามราชวรวิหาร","พระปริยัติธรรมวัดลำนารายณ์","พระปริยัติธรรมแผนกสามัญศึกษา วัดโบสถ์อินทร์บุรี","พิพิธสุตคุณานุสรณ์","สังฆรักษ์วิทยา","วัดไผ่ดำ แผนกสามัญศึกษา","พระปริยัติธรรมแผนกสามัญศึกษา วัดโพธิ์ศรี","พระปริยัติธรรมแผนกสามัญศึกษา วัดมณีสถิตกปิฏฐาราม","พระปริยัติธรรมแผนกสามัญศึกษา อุทานอุทิศธรรมวิทยา","พระปริยัติธรรมวัดหนองปลิงวิทยา","คีรีวงศ์วิทยา","บาลีเตรียมอุดมศึกษาวัดโพธาราม","วัดไทรเหนือวิทยา","วัดท่าพระเจริญพรต","วัดโคกเดื่อวิทยา","วัดวาปีรัตนารามวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดส้มเสี้ยว","ปริยัติสามัญวัดไพรสณฑ์ศักดาราม","ปริยัติสามัญวัดสระเกศ","พระปริยัติสามัญวัดมหาธาตุ","พระปริยัติธรรมแผนกสามัญศึกษา วัดประชานิมิต","ราชธานีวิทยาลัย","วัดเหมืองนาวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดเสาหิน","พระปริยัติธรรมแผนกสามัญศึกษา วัดมงคลนิมิตร","วัดจันทร์วิทยา","วัดธรรมจักรวิทยา","สาธิตวิทยาลัยสงฆ์พุทธชินราช","หลวงพ่อเพชรวิทยา","สุนทรศึกษา","วิทิตธรรมคุณอุปถัมภ์","พระปริยัติธรรมวัดบ้านหม้อศึกษา","วัดพระแก้วดอนเต้าสุชาดาราม","ปริยัติวัดม่อนจำศีล","แม่สุกศึกษา","ชยาภิวัฒน์วิทยา (สงฆ์รัฐราษฎร์อุปถัมภ์)","พุทธิวงศ์วิทยา","โสภณจริยธรรมวิทยา","วัดเจดีย์หลวงวิทยา","วัดอำมาตย์วิทยา","วัดครึ่งใต้วิทยา","วัดวิเชตร์มณี","วัดสันหนองบัววิทยา","วัดป่าตาลใต้","วัดไชยสถานวิทยา","พระปริยัติธรรมวัดใหม่ใต้วิทยา (ร.ร.บ้านสันกอง)","วัดแม่คำวิทยา","บุญเรืองวิทยา","วัดเวียงชัยพิทยา","สุวรรณคณานุสรณ์","ห้วยข้าวก่ำวิทยา","วัดหย่วนวิทยา","วัดโพธาราม พระปริยัติธรรมแผนกสามัญศึกษา","วัดนาปรังวิทยา","ราชคฤห์วิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดปัวดอย","วัดป่าแขมวิทยา","วัดม่วงชุมวิทยา","ร้องเข็มวิทยา","วังฟ่อนวิทยา","ร้องแหย่งวิทยาคม","เชตวันวิทยา พระปริยัติธรรมแผนกสามัญศึกษา","วัดปรางค์","วัดราษฎร์บำรุงวิทยา","วัดน้ำไคร้นันทชัยศึกษา","วัดนาราบวิทยา","พระปริยัติธรรมวัดนิโครธาราม","พระปริยัติศาสนาภิพัฒน์วัดเมืองราม","วัดบุญยืน","วัดดอนมงคลสันติสุขวิทยา","สามัคคีวิทยาทาน","เชตุพนศึกษา","บาลีสาธิตศึกษา มหาจุฬาลงกรณราชวิทยาลัย วิทยาเขตเชียงใหม่ (วัดสวนดอก)","วัดวิเวกวนาราม","สมเด็จพระพุทธชินวงศ์","อภัยอริยศึกษา","สารภีปริยัศึกษา","เขื่อนผากวิทยา","วัดแม่ริมวิทยา","อินทารามวิทยา","พระปริยัติธรรมวัดพระบาทอุดม","วัดป่าไม้แดง","ฝางธรรมศึกษา","สันป่าตองศึกษา","โขงขาววิทยา","พระปริยัติธรรมวัดท่าตอน","วัดเจดีย์งามปริยัติวิทยา","วัดฉิมพลีวิทยา","วัดกู่สันหนองพิทยา","หางดงสังฆราษฎร์อุปถัมภ์","ธรรมเมธีศึกษา","วัดสะเมิงวิทยา","เวียงแหงปริยัติศึกษา","ดอยสะเก็ดผดุงศาสน์","บ้านโฮ่งหลวง","โสภณวิทยา","พระปริยัติธรรมวัดพระธาตุห้าดวง","อินทะวิทยา","หอปริยัติศึกษาวัดพระธาตุหริภุญชัย","พระปริยัติธรรมพระเจ้าตนหลวง","พรหมจักรสังวร","ปริยัติสามัญสามัคคีวิทยา วัดท่าศาลา","พระปริยัติธรรมแผนกสามัญศึกษา วัดทุ่งหัวช้าง","พระปริยัติธรรมพระชัยยะวงศาพัฒนา แผนกสามัญ","วัดโสมนัสสันตยาราม","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีสะอาด","ประสาทคณานุกิจวิทยา","อุตตรทิศวิทยา","วัดสว่างสามัคคี","วัดบูรพา","วัดโคเขตตาราม","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีชมชื่น","พระปริยัติธรรมแผนกสามัญศึกษา วัดศิรินทราวาส","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีสวาท","วัดมัชฌิมาวาส","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีสุธาทิพย์","พระปริยัติธรรมวัดมัชฌิมบุรี","พระปริยัติธรรมแผนกสามัญศึกษา วัดสังคาว","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีนคราราม","วัดพิศาลรัญญาวาส","สุวรรณารามวิทยา","วัดโพธิ์ชัยสมสะอาด","วัดศรีสระแก้ววิทยา","วัดศิริบุญธรรมวิทยา","ดอนธาตุนรงค์วิทยา","บาลีสาธิตศึกษา มจร.วัดศรีษะเกษ","วัดโกเสยเขต","วัดไตรภูมิ","พระปริยัติธรรมแผนกสามัญศึกษา วัดโพธิ์งาม","วัดศรีโสภณธรรมทาน","บาลีสาธิตศึกษา วัดเขตอุดม","วัดช้างเผือก","วัดพระธาตุวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดพระธาตุบังพวน","พระปริยัติธรรมวัดเวฬุวันวิทยา","วัดโพธิสมภาร","ดอนโพธิ์ธรรมสถาน","พระปริยัติธรรมศรีจันทร์วิทยา","โกวิทวิทยา","วัดวังสะพุงพัฒนาราม","ธรรมนิเทศก์วิทยา","วัดศรีวิชัยวนาราม","วัดศรีสุวรรณวนารามวิทยา","วัดศรีภูกระดึงพัฒนาราม","วัดสันติวนารามวิทยา","วัดศรีภูเรือ","วัดศรีบุญเรืองปริยัติศึกษา","วัดลาดปู่ทรงธรรมวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดโพธิ์คำ","พระปริยัติธรรมแผนกสามัญศึกษา วัดทุ่ง","ศรีสกลกิจการกุศลวัดศรีสุมังคล์","วัดพระธาตุศรีมงคล","เหล่าแมดวิทยา","ปริยัติธรรมแผนกสามัญศึกษา วัดสว่างภูมิดล","สารคุณวิทยา","พระปริยัติธรรมสามัญญาณสังวร","ประภัสสรวิทยา วัดศรีนวล","วัดท่าพระหงษ์เทศประดิษฐ์","ปริยัติธรรมปุญยสารโสภิตวิทยา","พระปริยัติธรรม จันทวิทยาคม","มิ่งเมืองธีรานุเคราะห์","วัดท่าน้ำพอง","ธรรมวิทย์ราษฎร์บำรุง","มัธยมวัดโพธิ์ชัยศึกษา","พระปริยัติธรรมแผนกสามัญศึกษา วัดโพธิ์กลาง","วัดบูรพารามวิทยาสรรค์","วัดหนองแวงวิทยา","พระปริยัติธรรมวัดแจ้งสว่างนอก","พระปริยัติธรรมวัดสว่างรังษีวิทยา","วัดจันทรประสิทธิ์","วัดประชาพัฒนาราม","ตราชูพิทยาคม","วัดตาลเรียงวิทยา","วัดท่ากระบือวิทยาสรรค์","วัดประสิทธิ์ธรรมสารวิทยา","วัดสระแก้วพิทยาคม","บาลีสาธิตศึกษา มจร.วัดทุ่งศรีเมือง","ดงบังอาทรกิจวิทยา","พระปริยัติธรรมวัดโพธิ์ตาก","ศรีมงคลศึกษากร","อัครธรรมวิทยา","กิตติวิทยากร","สาธุกิจวิทยากร","หนองขุ่นวิทยา","กิตติญาณวิทยา","เจริญทัศน์วิทยา","รังษีวิทยากร","วัดมงคลในวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดหนองเป็ด","วัดบ้านหนองไฮวิทยา","พระปริยัติธรรมอัมพวันวิทยา","วัดไชยมงคลวิทยา","พระปริยัติธรรมมุจลินวิทยา","พระปริยัติธรรมศรีอุดมวิทยา","ศรีเจริญวิทยาราม","วรรณวารีวิทยา","วัดเวียงเกษม","วัดสวายน้อยวิทยา","พระปริยัติธรรมม่วงสามสิบวิทยา","ศรีเจริญวิทยา","พระปริยัติธรรมวัดอำนาจเจริญ","พระปริยัติธรรมปัจฉิมวันวิทยา","บาลีสาธิตศึกษา มจร.วัดอภิสิทธิ์","พระปริยัติธรรมแผนกสามัญศึกษา วัดสุวรรณาวาส","วาปีคณานุสรณ์วิทยา","ปทุมพิทยากร","ปัจจิมเชียงยืน","อุทัยทิศวิทยา","วัดหัวหนองสังฆประชาสรรค์","พระปริยัติธรรมวัดหัวดงนาค่าย","ปริยัติธรรมทัพป่าจิกวิทยา","พระปริยัติธรรมวัดยางสีสุราช","สุนทรธรรมปริยัติแผนกสามัญศึกษา วัดกลางมิ่งเมือง","สุพรรณภูมิพิทยาวัดเหนือ","ปริยัติสารคุณ","ธีรปริยัติแผนกสามัญศึกษา วัดเวฬุวัน","สุเทพนครวิช","วิโรจน์ผดุงศาสน์","ศรีทองนพคุณวิทยา","สามัคคีปริยัติธรรม (วัดสุทัศน์)","พระปริยัติธรรมแผนกสามัญศึกษา วัดบูรพาภิราม","พระปริยัติธรรมทุ่งศรีเมืองวิทยา","เทพบัณฑิตวิทยาลัย","ปริยัติสามัญโพนทองวิทยานุสรณ์","พระปริยัติธรรมเจ้าพระยาบดินทรเดชา","ทรายมูลปริยัติวิทยา","พระปริยัติธรรมสามัญศึกษา วัดพระธาตุพนมวรมหาวิหาร","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีชมภู","พระปริยัติธรรมวัดศรีหนาถวิทยา","พระปริยัติธรรม วัดธาตุเรณูวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดศรีสงคราม","พระปริยัติธรรม วัดมหาธาตุ","พระปริยัติธรรมแผนกสามัญศึกษา วัดพระซองวิทยา","พระปริยัติธรรม แผนกสามัญศึกษา วัดศรีสว่าง","พระปริยัติธรรมแผนกสามัญศึกษา วัดธาตุประสิทธิ์","ศรีบุญเรืองวิทยา","ปริยัติสามัญนครราชสีมา","วิสุทธิพรตพิทยาคม","ศรีปริยัติคุณศึกษา แผนกสามัญศึกษา","สัทธรรมวิทยา","ดอนหวายพิทยาคม","พระปริยัติธรรมปักธงชัยวิทยา","บูรพาวิทยานุสรณ์","วัดตะกุดเครือปลอก","ปริยัติสามัญศึกษา อำเภอปากช่อง","ประชานิมิตรวิจัยศึกษา","พระปริยัติธรรมวัดบึงกิตติวิทยา","พุทธธรรมวิทยา","ประจักษ์วิทยานุสรณ์","วัดกลางเมืองเก่าวิทยา","วัดชัยภูมิวนาราม","วัดชัยภูมิพิทักษ์ (ผาเกิ้ง)","ปริยัติธีรวิทยา","สระมะค่าวิทยา","วัดท่าสว่างวิทยา (ปริยัติสามัญ)","พระปริยัติธรรมเย้ยปราสาทวิทยา","พระปริยัติธรรมโนนดินแดงวิทยาคม","ศรีเกษตรวิทยา","วัดไพรบึงวิทยา","พระปริยัติธรรมวัดบ้านโนนคูณวิทยา","กันทรลักษ์ธรรมวิทย์","วัดสระกำแพงใหญ่","พระปริยัติธรรมเกียรติแก้ววิทยา","ดวนใหญ่วิทยา","โพธิ์ศรีวิทยา","โพธิศึกษา","ปริยัติโกศลวิทยา","พระปริยัติธรรมรัตโนภาสวิมลศึกษา","พระปริยัติธรรมพันษีวิทยา","บาลีสาธิตวัดศาลาลอยสุรินทร์","วัดจอมพระ","พระปริยัติธรรมวัดโพธาราม แผนกสามัญศึกษา","ปริยัติคุณรสวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดอุดมธานี","พระปริยัติธรรมอำนวยวิทยา แผนกสามัญศึกษา","พระปริยัติธรรมวัดสุวรรณรังสรรค์","พระปริยัติธรรมแผนกสามัญศึกษา วัดแจ้ง","มังกรกมลาวาสวิทยาลัย","วัดหมื่นพุทธวิทยา","กุศลสมาครวิทยาลัย","สุนทรประดิษฐ์วิทยาลัย","มหาปัญญา","พระปริยัติธรรมวัดแก้วโกรวาราม","วัดสิริกาญจนาราม แผนกสามัญศึกษา","วชิรกุญชรมัธยม","ปริยัติสามัญวัดคฤหบดีสงฆ์","ชัยมงคลวิทยา","พระปริยัติธรรมสามัญวัดกลาง","พระปริยัติธรรมสามัญวัดสิมนาโก","วัดปฐมแพงศรี","วัดหนองบัวพัฒนาวิทยา","ไชยวารวิทยาเสริม","วัดจุกเฌอ","พระปริยัติธรรมแผนกสามัญศึกษา วัดทุ่งเหียง","พระปริยัติธรรมแผนกสามัญศึกษา วัดเนินบุญญาราม","วัดโพธิ์ทัตราชวิทยาลัย","ศรีนภเขตวิทยา พระปริยัติธรรมแผนกสามัญศึกษา","ประทาย","วัดบางกระดี่","วัดคลองภูมิ","บ้านบัวมล (เจริญราษฎร์อุทิศ)","วัดทองสัมฤทธิ์","วัดแสนสุข","สายไหม (ทัสนารมย์อนุสรณ์)","สุเหร่าบางชัน","คลองสองต้นนุ่น","คลองสาม","วัดบำเพ็ญเหนือ","วัดช่องนนทรี","หมู่บ้านเกาะโพธิ์","วัดสะแกงาม","วัดแสมดำ","บ้านหนองบอน (นัยนานนท์อนุสรณ์)","หนองบัวแดงวิทยา","วัดอ่างแก้ว (จีบ ปานขำ)","วัดชัยฉิมพลี","วัดโคนอน","วัดมะพร้าวเตี้ย","วัดวิจิตรการนิมิตร","วัดท่าพระ","วัดดีดวด","วัดราชคฤห์","วัดบางสะแกใน","สมโภชน์กรุงอนุสรณ์ (200 ปี)","ชุมชนสันมะเค็ด","สวนกล้วยห้วยชันวิทยาคาร","วัดหัวกระบือ","วัดปริวาศ","วังเล็กวิทยานุสรณ์ (คลองสี่)","บึงขวาง (มหาดไทยอุปถัมภ์)","ศาลาคู้","ประชาภิบาล","วัดเวฬุราชิณ","วัดบางสะแกนอก","วัดแจงร้อน","วัดสน","นิลราษฎร์อุปถัมภ์","สังฆประชานุสสรณ์","บ้านป่าสักปางไม้","ชุมชนบ้านดอนไชย","บ้านก้อมหนองมุง","บ้านเบญจ์โนนดู่","คลองแสนสุข (สิทธิไชยบำรุง)","อนุบาลชุมชนบางบ่อ (ศุภพิพัฒน์รังสรรค์)","ป่าตึงพิทยานุกูล","ชุมชนวัดโขดเขมาราม (ประชาประเสริฐวิทย์)","บ้านโล๊ะป่าห้า","บ้านดอนสีนวน","เรณูนครวิทยานุกูล","บ้านโนนงิ้วงาม","ชุมชนวัดปราสาท","บ้านอาวอย","บ้านหนองไข่น้ำลำพญากลาง","บ้านไสต้นวา","ที โอ เอ วิทยา (เทศบาล 1 วัดคำสายทอง)","บ้านนาแพงดอนไฮ","บ้านแจมป๋อง","วัดกันตทาราราม (สืบ-ลูกจันทร์ จึงประไพ)","วัดกัลยาณมิตร","วัดใหม่ยายนุ้ย","วัดใหญ่ศรีสุพรรณ","วัดราชวรินทร์","วัดบุคคโล","วัดขุนจันทร์","วัดประยุรวงศ์","วัดนาคกลาง","วัดใหม่พิเรนทร์","วัดธรรมมงคล (หลวงพ่อวิริยังค์อุปถัมภ์)","แก่นทองอุปถัมภ์","วัดอินทรวิหาร","วัดมหรรณพาราม ในพระราชูปถัมภ์สมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี","วัดใหม่อมตรส","วัดทัศนารุณสุนทริการาม","วัดพระยายัง","วัดตะล่อม","บางจาก (โกมลประเสริฐอุทิศ)","วัดประดู่บางจาก (พ่วงอุทิศ)","วัดทองศาลางาม","วัดสุทัศน์","วัดมหาธาตุ","วัดราชบูรณะ","วัดพระเชตุพน","วัดตรีทศเทพ","วัดราชนัดดา","วัดสมณานัมบริหาร (วัดญวนสะพานขาว)","เทศบาล 2 (อ่อนอุทิศ)","อนุบาลท่าม่วง","ชุมชนเทศบาลวัดมณีสถิตกปิฏฐาราม","เทศบาลวัดหลวงราชาวาส","เทศบาลวัดธรรมโศภิต","เทศบาลวัดอมฤตวารี","บางยี่ขันวิทยาคม","เทศบาล 3 (หล่ายอิงราษฎร์บำรุง)","บุ่งค้าวิทยาคม","วิทยาราษฎร์รังสรรค์","บ่อทองวงษ์จันทร์วิทยา","อนุบาลวัดนางนอง","วัดต้นโชค","เทศบาล 1 (แตงอ่อนเผดิมวิทยา)","อนุบาลเมืองพัทลุง","บ้านซำเบ็ง","บ้านพะโค","เทศบาล 10 (อนุบาลเทศบาลเมืองสระบุรี)","เทศบาล 2 (วัดศรีบุรีรตนาราม)","เทศบาล 8 (วัดเจดีย์งาม)","เทศบาล 4 (วัดบำรุงธรรม)","เทศบาล 1 (วัดทองพุ่มพวง)","เทศบาล 3 (วัดบ้านอ้อย)","เทศบาล 6 (วัดเชิงเขา)","เทศบาล 9 (วัดเขาคูบา)","เทศบาล 7 (วัดแก่งขนุน)","เทศบาล 5 (เทศบาล)","จอมแจ้งวิทยาคาร","เทศบาล 5 (วัดดาวเรือง)","มัธยมสาธิตวัดพระศรีมหาธาตุ มหาวิทยาลัยราชภัฏพระนคร","เทศบาล 4 วัดบางแพรกเหนือ","เทศบาลวัดไทยชุมพล (ดำรงประชาสรรค์)","เทศบาลเมืองสุโขทัย","คลองพิทยาลงกรณ์","วัดบัวผัน","แก้วขำทับอุปถัมภ์","วัดกระจับพินิจ","ราชมนตรี (ปลื้ม-เชื่อมนุกูล)","วัดบางโคล่นอก","วัดจันทร์ใน","วัดจันทร์นอก","วัดราษฎร์บำรุง (งามศิริวิทยาคาร)","ราษฎร์บูรณะ (มูฮำหมัดอุทิศ)","บ้านอีโก่ม","ประชาราษฎร์รังสรรค์","นาคำเจริญวิทย์","พูนสิน (เพชรสุขอุปถัมภ์)","บางจาก (นาคเผื่อนอุปถัมภ์)","เทศบาล 1 ","บ้านหนองม่วงหนองแวง","รัตนจีนะอุทิศ","วัดประเสริฐสุทธาวาส","บ้านท่ามะปริง","สุราษฎร์ธานี","เทศบาล 3 (รัฐราษฎร์พัฒนา)","ชุมแพชนูปถัมภ์","บ้านดงเมืองน้อย (อนุบาลดงเมืองน้อย)","บ้านเปียมตะลวก","อนุบาลศรีธาตุ","เทศบาล 4 (บ้านศาลากันตง)","เทศบาล 3 (บ้านหัวทาง)","เทศบาล 1 (วัดสตูลสันตยาราม)","เทศบาล 2 (วัดชนาธิปเฉลิม)","เทศบาล 1 (รัฐราษฎร์สงเคราะห์)","สาธิตมหาวิทยาลัยราชภัฎนครปฐม","บ้านซา","บ้านแมตวิทยาคาร","สาธิตมหาวิทยาลัยราชภัฎสงขลา","อนุบาลบึงนาราง (ห้วยแก้ว)","วัดด่าน (หวอด ทรัพย์ คงเที่ยง อนุสรณ์)","จุมปีวนิดาภรณ์ (เทศบาลบ้านภูมินทร์)","ดรุณวิทยา (เทศบาลบ้านสวนตาล)","สามัคคีวิทยาคาร (เทศบาลบ้านพระเนตร)","บ้านชำบอน","เทศบาล 1 ตลาดบางลี่ (พานิชอุทิศ)","ประจันตราษฎร์บำรุง","เทศบาลบ้านปาตาตีมอ (ท.3)","เทศบาลบ้านอุเมะ","เซนต์ราฟาแอล","เทศบาล 1 วัดโพธิ์แก้วนพคุณ","เทศบาล 2 (วัดเสถียรวัฒนดิษฐ์)","อนุบาลเทศบาล 3 พรหมรวมมิตร","ศรีณรงค์วิทยาคาร","บ้านตระกาศขอนแก่น","บ้านดูนบักตู้โนนตาแสง","บ้านสีสวาดเล็บขาว","อนุบาลตะพานหิน (หนองพะยอม)","ชุมชนสามพร้าว","บ้านสันติวัน","อนุบาลคลองท่อม","บ้านสันเจริญโป่งสะทอน","บ้านกลางใหญ่นิโรธรังสีอุปถุมภ์","บ้านซำบ้อ","เทศบาลวัดโบสถ์วรดิตถ์ (ศรีราษฎร์อุปกฤติ)","เทศบาลวัดพินิจธรรมสาร (วิบูลวิทย์อุปถัมภ์)","เทศบาลวัดแสนสุข","เทศบาลวัดอัมพวัน","เทศบาลศรีพนมมาศพิทยากร","เทศบาล 1 (บ้านโพธิ์กลาง)","เทศบาล 4 (บ้านแหลมทราย)","เทศบาล 3","บ้านนาดีโคกสวาท","อนุบาลยินดีวิทย์","บ้านโสกหาดสวรรค์","เทศบาล 1 วัดนางวัง (สหราษฎร์อุทิศ)","เทศบาล 2 วัดเกษมสรณาราม (วงศ์ประชานุเคราะห์)","บ้านคลองกก","ฐิติวิทยา","วัดพุมเรียง","ประชาสนธิ์นุสรณ์","บ้านกรับใหญ่","ชุมชนนาโสก","บ้านเสียววิทยา","บ้านนาคูณน้อยหนองหัวงัว","เทศบาล 3 วัดอัมพวันเจติยาราม","มัธยมศึกษาเทศบาล 3 ","เทศบาล 4 รัฐประชานุเคราะห์","บ้านคำไฮ","ราชประชานุเคราะห์ 2","เทศบาล 1 (เอ็งเสียงสามัคคี)","เทศบาล 2 (บ้านหาดใหญ่)","เทศบาล 3 โศภนพิทยาคุณานุสรณ์","เทศบาล 4 วัดคลองเรียน","เทศบาล 1 เชิงชุมประชานุกูล","เทศบาลวัดแจ้ง (ราชปริยัติบำรุง)","บ้านม่วงตึ๊ด","เทศบาล 5 วัดเกาะกลาง","เทศบาล 3 วัดสหมิตรมงคลฯ","เทศบาล 4 หนองแคอนุสรณ์","เทศบาล 2 วัดเสนานถมิตร","เทศบาล 1 นาเริ่งราษฎร์บำรุง","เทศบาล 1 กาฬสินธุ์พิทยาสิทธิ์","เตรียมอุดมศึกษาพัฒนาการ รัชดา","บ้านกองนาง","บ้านดอนแรด (จินดาวิทยาคาร)","อนุบาลเจริญศิลป์","กองทัพบกอุปถัมภ์รัชตวิทยา","เตรียมอุดมศึกษา ภาคเหนือ","เทศบาล 4 (ฉลองรัตน)","เทศบาล 1 สว่างวิทยา","เทศบาล 2 ชำนาญอนุเคราะห์","วัดขุมทอง (เจริญราษฎร์นุกูล)","เทศบาลชุมชนวิมลวิทยา","คีรีราษฎร์พัฒนา","วรรัตน์ศึกษานนทบุรี","ดี.มากาเร็ตฟุลเลอร์","เทศบาล 3 ยุวบูรณ์บำรุง","เฉลิมพระเกียรติสมเด็จพระศรีนครินทร์ ร้อยเอ็ด","มหาวีรานุวัตร","สาธิตวิทยาเชียงคำ","บ้านหาดแฮ่","ชุมชนใหม่","เฉลิมรัชวิทยาคม","สว่างราษฎร์บำรุง","บ้านทุ่งยั้งหัวฝายวิทยา","แหลมราษฎร์บำรุง","บ้านแวน","บรรจงรัตน์","พระวิสุทธิวงส์","วัดนาห้วย (แสงกล้าประชาสรรค์)","บ้านอ้อวิทยา","ภัทรนุสรณ์","สาธิตมหาวิทยาลัยราชภัฏเชียงใหม่","วัดสหราษฎร์บำรุง (วงษ์ กล้าแข็ง)","สาธิตมหาวิทยาลัยราชภัฏเชียงราย","บ้านโนนสว่าง 1","บ้านป่าไหม้","วัดลำมหาเมฆ (ประชาราตรีอนุสรณ์)","บุญคุ้มราษฎร์บำรุง","พระแม่มารีอุปถัมภ์","บ้านพระคือหนองโพธิ์วิทยา","สาธิตมหาวิทยาลัยราชภัฏนครสวรรค์","สาธิตมหาวิทยาลัยราชภัฏอุตรดิตถ์","วไลย","สาธิตมหาวิทยาลัยราชภัฏพิบูลสงคราม","สาธิตมหาวิทยาลัยราชภัฏมหาสารคาม","บ้านมะหินหลวง","สาธิตมหาวิทยาลัยราชภัฏเลย","สาธิตมหาวิทยาลัยราชภัฏอุดรธานี","สาธิตมหาวิทยาลัยราชภัฏนครราชสีมา","สาธิตมหาวิทยาลัยราชภัฏบุรีรัมย์","สาธิตมหาวิทยาลัยราชภัฏสุรินทร์","สาธิตมหาวิทยาลัยราชภัฏอุบลราชธานี","สาธิตมหาวิทยาลัยราชภัฏเทพสตรี","สาธิตมหาวิทยาลัยราชภัฏพระนครศรีอยุธยา","สาธิตมหาวิทยาลัยราชภัฏวไลยอลงกรณ์ ในพระบรมราชูปถัมภ์","วัดทุ่งมะกรูด","กมลาลักษณ์","บ้านระไซร์","สาธิตมหาวิทยาลัยราชภัฏรำไพพรรณี","สาธิตมหาวิทยาลัยราชภัฏนครศรีธรรมราช","บ้านป่าซางนาเงิน","สาธิตมหาวิทยาลัยราชภัฏยะลา","สาธิตอนุบาลจันทรเกษม (สาธิตมหาวิทยาลัยราชภัฏจันทรเกษม)","สาธิตมหาวิทยาลัยราชภัฏภูเก็ต","ชุมชนบ้านโนน-โนนสวรรค์","วัดกุ่มหัก (อินทโชติประสิทธิ์)","ประถมสาธิตมหาวิทยาลัยราชภัฏบ้านสมเด็จเจ้าพระยา","สาธิตละอออุทิศ มหาวิทยาลัยราชภัฏสวนดุสิต","สาธิตมหาวิทยาลัยราชภัฏสวนสุนันทา","บ้านแม่เปิน","สองพี่น้อง","อัตตัรบียะฮ์อิสลามียะฮ์","บ้านนา (คุรุราษฎร์อุทิศวิทยายน)","บ้านดอนยางกล้วยสำโรง","บ้านตะบัล","บ้านสำนักขาม","อนุบาลทุ่งมน","อนุบาลธษพลศึกษา","ทอรัก","เทศบาลป้อมแผลงไฟฟ้า","บ้านดงจันทน์","ท่าไร่วิทยา","ทุ่งฟ้าวิทยาคม","สาธิต","เทศบาล 3 บ้านบ่อฝ้าย","อนุบาลจิตอาทร","สุขเจริญผลแพรกษา","ประภามนตรี 2","อนุบาลเพชรงาม","ชุมชนโพนเมืองวิทยา","ไม้กลอนดอนหวาย","บ้านกระเบาตะหลุงวิทยา","เปรมติณสูลานนท์","อนุบาลบ่อพลอย","เหล่ากลางวิทยาคม","ดงบังนาแก้ววิทยา","บ้านบางปิ้ง","เทศบาล 2 พิบูลวิทยาคาร","บ้านอังกัญ-โคกบรรเลง","เทศบาลวัดตึกมหาชยาราม","บ้านหนองแสนตอโนนสร้างคำ","ท่าช้างราษฎร์บำรุง","มูลนิธิรุ่งนภานครราชสีมา 15 (3)","โนนไทย","วรรณรัตน์วิทยา","ชนะวิทยา","วัดนิกรรังสฤษฎ์","บ้านหนองแวงเหนือป่าก้าว","สวนเด็กสันกำแพง","บ้านม่วงป็อก","รัชมังคลาภิเษกบ้านนายอ","ไทยรัฐวิทยา 92 (ชุมชนนาข่า)","อนุบาลชุลีพร","เกียรติขนอมศึกษา","บ้านหินตั้งหนองอีเลิง","อนุบาลสาธิต","สาธิตมหาวิทยาลัยสงขลานครินทร์","สาธิตจุฬาลงกรณ์มหาวิทยาลัย (ฝ่ายประถม)","ธรรมากรวิทยานุกุล","สามัคคีพิทยาคม","พอจิตวิทยา","สายมิตรโนนไทย 6","สาธิตมหาวิทยาลัยมหาสารคาม (ฝ่ายมัธยม)","สาธิตมหาวิทยาลัยศรีนครินทรวิโรฒ ประสานมิตร (ฝ่ายมัธยม)","สาธิตมหาวิทยาลัยรามคำแหง (ฝ่ายประถม)","ศึกษาสรรค์","ปุญญสารวัดศรีโพธิ์ชัย","วารีเชียงใหม่","สาธิตแห่งมหาวิทยาลัยเกษตรศาสตร์ ศูนย์วิจัยและพัฒนาการศึกษา","สาธิตมหาวิทยาลัยเชียงใหม่","สาธิต ","สาธิตมหาวิทยาลัยขอนแก่น","สาธิตมหาวิทยาลัยศรีนครินทรวิโรฒ ปทุมวัน","สาธิตแห่งมหาวิทยาลัยเกษตรศาสตร์ วิทยาเขตกำแพงแสน","สาธิตมหาวิทยาลัยศิลปากร (มัธยมศึกษา)","บ้านแมดวิทยาคม","อนุบาลไผ่แก้ว","วัดประดู่โลกเชษฐ์ (สุวรรณประมุขวิทยาคาร)","ชำฆ้อพิทยาคม","พร้าวบูรพา","อัยยสิริ","ลักษณ์พงค์วิทยา","ชุมชนวัดคูบัว","เมืองจังหาร","กสิณธรอาคาเดมี่","ลิ้นฟ้าวิทยาคาร","เทศบาลดอนหัวฬ่อ 1 (บ้านมาบสามเกลียว)","พิทยรังสี","วัดนาเขื่อน","เสรีศึกษา","พิสิษฐ์พิทยา","ลพบุรีปัญญานุกูล จังหวัดลพบุรี","สุวรรณประสิทธิ์","ผดุงอิสลาม","กองทัพบกอุปถัมภ์อดิศรศึกษา","บ้านสำนักกอ","อนุบาลบ้านรักเรียน","อนุบาลศุภมน","จิ้นเตอะ","บ้านบักดอง","วัดสามเอก","โยธินบูรณะ เพชรบุรี","วัดสุขาราม","อุดรมงคลวิทยา","เบญจรงค์อนุสรณ์วิทยา","กองทัพบกอุปถัมภ์จักรพงษ์พิทยาลัย","บ้านขวาวโค้ง","ชุมพลนาคลัง","บ้านบ่อคำ","ชุมชนหนองแปนหินโงมวิทยา","อนุบาลพัฒนชัย","อนุบาลหนองกอง","วัดบุบผาราม (เตชาราษฏร์รังสรรค์)","อนุบาลศรีวิชัยรัตน์","แย้มสอาดรังสิต","นูรุลอิสลามหนองธงมูลนิธิ","มารดาทรงธรรม","อนุบาลณัฐชา","ชาญรัตน์วิทยา","เจ้าพ่อหลวงอุปถัมภ์ 7","บ้านราษฎร์นิยม","จริยอิสลามศึกษาอนุสรณ์","อุดมศึกษา รังสิต","แคมป์สนวิทยาคม","อำนวยวิทย์พัฒน์","อนุบาลหนองหิน","วรราชวิทยา","อนุบาลบุญพึ่ง","ราชวินิต มัธยม","ปิติศึกษา (เชียงรายมอนเตสเซอรี่)","บ้านหนองสมอประชาพัฒนา","ตัรบียะห์อิสลามียะห์","อนุบาลเปรมฤดี","อนุบาลสภาพร","คริสเตียนแสงประทีป","ไชยชุมพลศึกษา","อนุบาลอุดมพร","อนุบาลอำไพ","อนุบาลกุลภัสสร์","อนุบาลร่วมใจ","บ้านปลวกธาตุโสภาวิทยา","ทศพรวิทยา","สันกลางวิทยา","อนุบาลวาปีปทุม","เมตตาชนูปถัมภ์","กมลลักษณ์","วชิราลัย","วัดสุทธิรุจิราราม","อนุบาลไอรฎา","อนุบาลประภาพรรณ","มีนประสาทวิทยา","ฝางพิทยาคม","เทศบาลวัดแค (ธรรมวิธานราษฎร์บำรุง)","อนุบาลเทศบาลพระพุทธบาท","อนุบาลโพธิ์ประทับช้าง (ทุ่งใหญ่)","มหิดลวิทยานุสรณ์","โสตศึกษาจังหวัดสุรินทร์","อนุบาลนิมิตใหม่","ชุมชนเทศบาลวัดปาโมกข์ (นรสีห์วิทยาคาร)","ไพศาลวิทยาคม","บ้านมีชัย","บ้านใหม่ปฏิรูป","บ้านโละใหญ่","ฮิดายาตุดดีนนาวงวิทยา","เจริญวิชช์","อนุบาลอินทร","อนุบาลธิดารัตน์","วิมลวิทยา","วัดบ้านสวายสอ","วัดสว่างบูรพา","บ้านเด็กน้อยตรัง","วัดศรีสำราญราษฎร์บำรุง (แช่มประชาอุทิศ)","บ้านควนโต๊ะเหลง","บ้านราษฎร์ประสงค์","ดวงพร","บ้านโหละหนุน","เทศบาล 3 (วัดศาลาหัวยาง)","เทศบาล 1 (ถนนนครนอก)","เกตุพิชัยวิทยา","อุดมทรัพย์","บ้านวังรางใหญ่","อนุบาลวัดจังหูนสงเคราะห์","อนุบาลแก้วปัญญาอุปถัมภ์","รุ่งภิญโญ","องค์การอุตสาหกรรมป่าไม้ 20 (สวนป่าเทพสถิต)","ตำรวจตระเวนชายแดนชมรม 9 สมาคมจีนแห่งประเทศไทย เฉลิมพระเกียรติพระบาทสมเด็จพระเจ้าอยู่หัวฯ เนื่องในโอกาสพระราชพิธีมหามงคลเฉลิมพระชนมพรรษาครบ 6 รอบ 5 ธันวาคม 2542","สุอารีวิทยา","ผดุงวิทย์ (วัดศรีบุญเรือง)","ปิยะฉัตร","ชุมชนบ้านหนองบัวลาย","อนุบาลพิชาดา","สาธิตคริสเตียนวิทยา","บ้านปาดาฮัน","อนุบาลบุ่งคล้า","ดงง่ามนางาม","อนุบาลทับคล้อ","การศึกษาเด็กพิเศษมารีย์นิรมล","อนุบาลณัฐสุดา","บ้านเลิงเปือย","บ้านเปลือยดง","ไพโรจน์วิชชาลัย","อนุบาลฉัตรมงคล","อนุบาลเครือวัลย์","ธาตุดอนตูม","วัดสันกลางเหนือ","ผกาภรณ์ศึกษา","เทศบาลวัดหนองผา","อนุบาลช่องฟ้าซินเซิงวาณิชบำรุง","เด็กสากล","เจ้าพ่อหลวงอุปถัมภ์ 1","ขวัญเมือง","บ้านบุพราหมณ์อรุณอนุสรณ์","บ้านห้วยสาลิกา","อนุบาลอรุณโรจน์","อนุบาลภาสินี","เกวลินวิทยา","เซนต์โยเซฟเมืองเอก","วิภารัตน์","อนุบาลผ่องศรี","องค์การอุตสาหกรรมป่าไม้ 13","ไตรมิตรวิทยาคม","บ้านกาแลบือซา","วัดบางน้ำวน (รอดพิทยาคม)","เทศบาล 1 วัดประตูสาร","เทศบาล 2 วัดปราสาททอง","เทศบาล 3 วัดไชนาวาส","วัดราษฎร์อรุณ","นานาชาตินันทวรรณ","บ้านไทยนิยม","อนุบาลเจริญวัฒนา","เซนต์ยอแซฟศรีสงคราม","อนุบาลเทพกมล","อนุบาลจันทโชติ","อุทยานศึกษากระบี่","ยินดีวิทย์","อนุบาลเดือนฉาย","อนุบาลแห่งมหาวิทยาลัยธรรมศาสตร์ฯ","อนุบาลภูกระดึง","บ้านยือโร๊ะ","ล้อมรัก","อนุบาลเปล่งประสิทธิ์ศรีนครินทร์","พระปริยัติธรรมแผนกสามัญศึกษา วัดเสนหา","สายมิตรจอหอ 8","บ้านไผ่ประถมศึกษา","เก่านาโนมีวิทยา","บ้านเหว่อฟากห้วยกุดตอเรือ","เทศบาล 3 ศรีสว่าง","บุญญวิทยาคาร","เทศบาลวัดท้ายตลาด (กวีธรรมสาร)","มารีย์พิทักษ์พังโคน","แสงธรรมวิทยาตรังมูลนิธิ","วัดปากลัด (ผลาคารบำรุงวิทย์)","วัดอุทัยธาราม","บ้านชำทอง","อนุบาลเนตรระหงษ์","เทศบาลวัดแหลมสุวรรณาราม (วัฒนรวมวิทยา)","ชุมชนศรีสะอาด (เทศบาล 1)","คลองบางปิ้ง","เซนต์จอห์น บัปติสต์","เทศบาลวัดเจษฎาราม (เชยวิทยาทาน)","เทศบาลวัดป้อมแก้ว (อัครพงศ์ชนูปถัมภ์)","อนุบาลชื่นชม","โชคชัย","เทศบาลวัดโกรกกราก (กรับวิทยาทาน)","บ้านหนองจิกเหล่าเชือก","บ้านชำตก","บ้านชำสอง","บ้านชำหนึ่ง","บ้านวังสำโม","เทศบาลแสงวณิชอุปถัมภ์","เทศบาลวัดใหญ่ (ราชพงษ์)","บ้านท่าใหม่","อนุบาลเพื่อนลูกรัก","เทศบาลวัดธรรมนิมิต (พ่อค้าอุทิศ)","ราชประชานุเคราะห์ 48","คิชฌกูฏวิทยา","อนุบาลดวงจิต 2","วัดเกตุมศรีวราราม","บ้านหนองกะโดน","อนุบาลชุมพวงวิทยา","อนุบาลธารพระพร","อนุบาลรังสีวิทย์","แก้วนิมิตวิทยา","ศรีไพรวิทยา","บ้านควรดง","อนุบาลร่มฉัตร","ห้วยต้นนุ่นวิทยา","บ้านวังหลาม","ขาวสง่าเจริญวิทย์","อนุบาลพิมาย","อนุบาลเกียรติคุณ","บ้านดงหมูชัยเจริญ","โชคชัยกระบี่","มหาไถ่ศึกษาบ้านดุง","บ้านวังเฉลียง","เทศบาล 1 บ้านสะเดา","วัดมงคลวุฒาวาส (จรัส แตงน้อยอุปถัมภ์)","ศรีเจริญศึกษา","บ้านคางา","ดงเจริญพิทยาคม","พัฒนาเด็กประชาสโมสร","มะค่าสามัคคี","วัดวังน้ำ","เทศบาลวัดทรงธรรม","การกุศลวัดหนองแวง","อนุบาลโชคมณี","อนุบาลสาธิตพงษ์ภิญโญ","พิมพ์ใจวิทย์","องค์การอุตสาหกรรมป่าไม้ 19 (สวนป่าคอนสาร)","ศรีใครวิทยา","พระปริยัติธรรมานุสรณ์วัดฟ้าสวรรค์","วัดบ่อหลวงวิทยาธรรม","วัดท่าช้างวิทยา","เทศบาล 2 บ้านสะเดา","ลำไพลราษฎร์อุทิศ","อุ่นรัก 2 ภาษา","อนุบาลอำเภอบางมูลนาก (วัดห้วยเขน)","อนุบาลจงฝามูลนิธิ","อนุบาลแสงอรุณนาหว้า","บ้านท่าพยอม","อนุบาลมหาไถ่ศึกษาโพนสูง","ปัญญาศักดิ์ บางบอน","ตำรวจตระเวนชายแดนเจ้าพ่อหลวงอุปถัมภ์ 3 (ช่างกลปทุมวันอนุสรณ์ 4)","ตำรวจตระเวนชายแดนบ้านต้นมะม่วง","ตำรวจตระเวนชายแดนบ้านคลองวาย","อนุบาลพฤษชาติ","ทรงวิทยาเทพารักษ์","ดรุณานุกูลหัวถนน","บ้านเคาะสนวนสามัคคี","เจ้าแม่หลวงอุปถัมภ์ 1","อนุบาลโกญจนาท","ตำรวจตระเวนชายแดนบ้านป่าหมาก สาขา รร.ตชด.บ้านเขาจ้าว","ตำรวจตระเวนชายแดนการท่าอากาศยานแห่งประเทศไทย เฉลิมฉลองครบรอบ 100 ปี วันคล้ายวันพระราชสมภพสมเด็จพระศรีนครินทราบรมราชชนนี","ตำรวจตระเวนชายแดนชมรมอนุรักษ์พุทธศิลปไทยอนุสรณ์ 2","ตำรวจตระเวนชายแดนชมรมอนุรักษ์พุทธศิลปไทยอนุสรณ์ บ้านแสนคำลือ","ตำรวจตระเวนชายแดนบ้านป่าก่อ","อนุบาลภู่ขจร","กันตวรรณ","วัดใหม่ประเวศ (ศิริประชาบำรุง)","อนุบาลรัตนกาญจน์","สันหนองควาย","ศานติวิทยา","อนุบาลชนบทพัฒนา","บ้านดอเฮะ","บ้านเวียงลอ","โต๊ะดามียะห์","บ้านนาฉันทะญาณวีโรอนุสรณ์","บ้านชาติพัฒนาสันติสุข","วัดจอเจริญสุขุมวาท","สายมิตรปักธงชัย 7","บ้านท่ามะเขือ","อนุบาลท่าช้างเฉลิมพระเกียรติ","สายมิตรวังน้ำเขียว 5","ตำรวจตระเวนชายแดนการท่าอากาศยานแห่งประเทศไทยเฉลิมพระเกียรติสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี เนื่องในโอกาสทรงเจริญพระชนมายุ 4 รอบ 2 เมษายน 2546","ตำรวจตระเวนชายแดนบ้านโป่งลึก สาขานเรศวรห้วยโสก","อนุบาลหอเอกวิทยา","มุสลิมพัฒนศาสตร์","อนุสรณ์พรสวัสดิ์","บ้านแปลง 5","วัดบ้านขุนเตรียมพุทธศาสตร์","หมอนทองวิทยา","อรุณโรจน์","บุญสมบูรณ์ศึกษา","อนุบาลแสงทอง","นวลน้อยพิทยา","เปรมฤทัย","จรรยานุยุตวิทยา","คมพิสิฐวิทยา","บ้านหนองสะเดา","คูณวรวิชญ์","วัชรสหศึกษา","ตายุลอิสลาม","วัดบ้านกล้วย (เฟื้อราษฎร์บำรุง)","อนุบาลบุษยมาส ปู่เจ้าฯ","อนุบาลจินกาญจณ์ดา","อนุบาลน้ำผึ้ง","เสมาวิทยา","มูลนิธิชุมชนอิสลามศึกษา","วัดพระบรมธาตุไชยาวิทยา","อนุบาลวัดทุ่งสว่าง","บ้านป่าขุย","บ้านโซกเปือย","เมืองยาววิทยา","อนุบาลสกนวิชญ์","อนุบาลเรวดีศึกษา","ธีรธาดาปฐมวัยและภาษาต่างประเทศ พิษณุโลก","ชุลีมาศก์ศึกษา","อนุบาลบ้านสานฝัน","อนุบาลบังอร","กมลศรี","พิจิตรอินเตอร์","หนองบัวประชาสรรค์","สัมมาสิกขาหินผาฟ้าน้ำ","วัดพระพรหม","ศรีคิรินทร์วิทยา","มารีย์รักษ์เชียงราย (แผนกประถม)","พฤกษาวิทยา","อนุบาลปิยะอาทร","อนุบาลคริสเตียนลำพูน","อนุบาลสุพิชญา","อนุบาลนวลมณี","ปอวิทยา","ดรุณพัฒนา","อนุบาลดรุณพัฒนา","อำไพพิทยา","อนุบาลคริสเตียนสันกอง","อนุบาลหลวงครูวิทยา","เทพพิทักษ์","เตรียมทหาร","อนุบาลนันทรัตน์","ธนรัตน์วิทยา","สิริศึกษา","เทศบาลขามใหญ่บ้านหนองไผ่","ศักดาวิทยา","สายบุรีอิสลามวิทยา (ประถมศึกษา)","ดารุลฮิกมะห์","บ้านส้มกบ","บ้านอูตูม","อนุบาลศุภสร","พิชาภรณ์","กีญามุดดีน","บ้านโนนสะอาดราษฎร์อุปถัมภ์","อนุบาลสำราญยงค์","บ้านคอวัง","อนุบาลรสสุคนธ์อากาศ","สุทธิ์รักษ์","มะฮัดอิสลามอีมานียะฮ์มูลนิธิ","วัดบ้านเมืองดู่","สมเด็จปริยัติ","วัดบุณฑริกาวาส","ถาวรนิมิต","วัดป่าหนองดินดำวิทยาลัย","เซนฐ์ตวงพร","วัดนิคมประสาท (บุญชอบ สาครินทร์)","พระปริยัติธรรมศรีอริยวงศ์","ศรีสังวาลย์เชียงใหม่","อนุบาลพญาเม็งราย","สากลศึกษา บางบัวทอง","ปาณยา พัฒนาการ","อนุบาลปัวอินเตอร์คิดส์","พระกุมารสุรินทร์","โชติวิทยา","ธีราศรมสุราษฎร์","อุดมวิทยานุสรณ์","บ้านลำลอง","บ้านหวายโนนโพธิ์","บ้านถ้ำประชานุเคราะห์","วัดกุฎิขันติพลาภิรมสงเคราะห์","เฉลิมพระเกียรติ 48 พรรษา","วัดลำภู","อนุบาลปานตะวัน","บ้านโคกกระเพอ","มัธยมวัดเบญจมบพิตร","อนุบาลรุ่งภิญโญ","บ้านแกน้อย","อนุบาลชีวะรัตน์","กชนันท์อนุบาล","สายมิตรโชคชัย 3","ธนรัตน์อุปถัมภ์","ไชยพันธ์พงษ์พิทยา","บริบูรณ์ศิลป์รังสิต","อนุบาลบัณฑิตน้อย","ภักดีอนุสรณ์","เทศบาล 3 (เฉลิมพระเกียรติ 72 พรรษา)","อนุบาลสุรีพร","พระกุมารเยซู สิงห์บุรี","อนุบาลฟ้าสิรินทร์","การกุศลวัดร่มประดู่","อนุบาลจรันวิทยา","มเหสักข์พิทยา","บ้านป่าแชง","อนุบาลนิลวรรณ","อนุบาลทองสตา","สามชัยวิเทศศึกษา","ศูนย์อบรมเด็กก่อนเกณฑ์ในวัดป่าจันทรังษี","เพชรชูนุเคราะห์","วัดเขาย้อยไพบูลอุปถัมภ์","วัดอินทารามวิทยา","จินดาศึกษา","กิตติยารามวิทยา","ฆังคะทวีศิลป์","บ้านเจริญเมือง","อนุบาลสุภาพวิทยา","อนุบาลอรุณรัตน์","กฤชานันท์เขาสวนกวาง","สายมิตรหนองบุญมาก 11","บ้านเนินสายฝน (แหลมทอง)","บ้านนาเหลืองม่วงขวา","เทศบาล 5 วัดศรีสำราญ","เทศบาล 4 วัดโพธิ์อ้น","เทศบาล 3 วัดอัมพวัน (พวงวรินทร์ราษฎร์วิทยา)","เทศบาล 2 อำนวยวิทย์","กูตงวิทยา","เทศบาลพัฒนา","เทศบาลบ้านม่วง","เทศบาลวัดแก่งคอย","วังเด็กพัฒนา","อนุบาลเลิศนุวัฒน์","พิชญวิทย์","อันวารุ้ลอิสลาม","นูรุลอิงซานมูลนิธิ","บำรุงอิสลามมูลนิธิ","พัฒนาวิทยากร","อิสลามบาเจาะวิทยา","ดารุลมูญาฮีดีนวิทยา","ดารุลศาสน์วิทยา","ดารุลอามาน","ลำไพศานติวิทย์","มุสลีมีนศึกษา","อิสลามวิทยา","อิสลามวิทยานุเคราะห์","ศาสนธรรมวิทยา","สันติศาสตร์ศึกษา","อิสลามศึกษาดารุ้ลบิร","เลิศหล้ากาญจนาภิเษก","อนุบาลบ้านทิพย์","สารสาสน์วิเทศร่มเกล้า","สองภาษาลาดพร้าว","อนุบาลเปล่งประสิทธิ์ สายลม","ดรุณพัฒน์","อนุบาลปาริชาต","เขาพนมกาวหนองนกยาง","บ้านแม่ยางเปี้ยว (แก้วพิสณฑ์ประชานุกูล)","อนุบาลบัณฑิตวิทย์หนองแขม","อนุบาลภรณ์กมล","อนุบาลศรีชัยวิทยา","พัฒนปัญญา","วัดท่าโป๊ะ","อนุบาลนานาชาติสี่พี่น้อง","นานาชาติเซนต์สตีเฟ่นส์ เขาใหญ่","เทศบาลวัดประทุมคณาวาส (นิพัทธิ์หริณสูตร์)","บ้านโนนสว่างหนองตะนา","โพธารามพิทยาคม","บ้านห้วยผักหนาม","อนุบาลนันทพร","บ้านทุ่งน้ำขาว","เทศบาล 2 ","วัดสีดาราม (เทพเชยประชานุกูล)","พิชญบัณฑิต","สร้างพัฒนา","อนุบาลเจริญจิตวิทยา","อ้อมอารีพิทยา","บ้านม่วง สาขาบ้านชำบุ่น","เทศบาลวัดเกษมจิตตาราม","อนุบาลนิสารัตน์","เทศบาล 2 (วัดเกาะแก้ว)","เทศบาลบ้านกาหยี","เทศบาลบ้านหนองตาโผ่นมิตรภาพที่ 5","เทศบาลบ้านสุขสำราญ","บ้านปากห้วยฉลอง","บ้านโนนศรีสวัสดิ์โนนสวรรค์","บ้านมาบมะค่า","นานาชาติราไวย์โปรเกรสซีพ","บ้านแม่แก้วเหนือ","อนุบาลสิริพร","อนุบาลญาณนเรศว์รพิทยาคม","สาธิตจุฬาลงกรณ์มหาวิทยาลัย (ฝ่ายมัธยม)","ผังปาล์ม 1","บัวสามัคคีพิทยาสรรพ์","อนุบาลสุวัฒนา","สาธิตมหาวิทยาลัยรามคำแหง (ฝ่ายมัธยม)","หนองฉนวนวิทยาคม","อนุบาลไทรงาม","อนุบาลสุธินี","เทพประทาน","นิคมสร้างตนเองพัฒนาภาคใต้ 11","รังสีวิทยา","ธรรมมิสลาม ท่าอิฐ","บ้านหนองคล้าพงษ์ทอง","เพชรผดุงเวียงไชย","ชุมชนดอนม่วงงาม","วัดธรรมนาวา","ตำรวจตระเวนชายแดนบ้านประตูด่าน","บ้านคำก้อม","เทศบาลบ้านปากกะบาด","นาคคามพิทยาคม","อนุบาลจรูญลักษณ์","บำรุงศาสน์วิทยา","บ้านดงบัง (คุรุราษฎร์อุทิศ)","ศรีสุนทรสีลวิสุทธิ์","วัดเขาขวาง","บ้านแม่แจ๋ม","พุทธารักษ์","บัณฑิตวิทยา","บ้านนาป่าแซง (ประชาสามัคคี)","อนุบาลกานต์สินี (อรรถรักษ์)","บางปะอิน","ลำปลายมาศพัฒนา","อนุบาลวิจิตรา","วชิรวิทย์ (ฝ่ายมัธยม)","มัธยมประชานิเวศน์","มัธยมบ้านบางกะปิ","อนุบาลดอนเมืองบริรักษ์","บ้านหนองขุม (พูนแถมอุปถัมภ์)","วัดลำบัวลอย","วัดท่าช้าง (แสงปัญญาวิทยาคาร)","วัดใหม่บำเพ็ญผล","วัดสุวรรณศิริ","ราชประชานุเคราะห์ 39","ราชประชานุเคราะห์ 40","ราชประชานุเคราะห์ 41","ราชประชานุเคราะห์ 42","ราชประชานุเคราะห์ 43","ภรวิชญ์","อนุบาลสีสวาท","อนุบาลพนาสนธ์","บางกอกบัลวี","นานาชาติการ์เด้น กรุงเทพฯ","นานาชาตินีวา","อนุบาลนานาชาติทาเคโนโกะ","อนุบาลนานาชาติเมโลดี้ส","อนุบาลนานาชาติสบายใจ","อนุบาลนานาชาตินิวแบมบิโน","อนุบาลนานาชาติโคบาโตะ","นานาชาติเดอะรีเจนท์ กรุงเทพ","นานาชาติสิงคโปร์กรุงเทพ","นานาชาติบลูมมิ่ง บัดส์","อาร์ ซี อินเตอร์เนชั่นแนล สคูล","อนุบาลนานาชาติเพรพ","ประถมนานาชาติบรอมส์โกรฟ","อนุบาลนานาชาติเลิร์นนิ่ง โฮม","นานาชาติพระคุณกรุงเทพ","อนุบาลนานาชาติเวลส์","นานาชาติโชรส์เบอรี กรุงเทพ","นานาชาติชาร์เตอร์","อนุบาลนานาชาติตะลันต์","นานาชาติคินเคด","อนุบาลนานาชาติคิดส์อะคาเดมี่","นานาชาติเซนต์แอนดรูว์ส สาทร","ฝรั่งเศสนานาชาติ กรุงเทพ","นานาชาติทรีนิตี้","นานาชาติเกาหลี กรุงเทพ","นานาชาติแองโกลสิงคโปร์","พระมหาไถ่วิเทศศึกษา","บางกอกแอ๊ดเวนต์","นานาชาติเวลล์ส-ทองหล่อ","อนุบาลนานาชาติมัลเบอรี่เฮาส์","อนุบาล ไอ พี ซี อินเตอร์เนชั่นแนล","ประชาคมนานาชาติ บางนา","อนุบาลนานาชาติฮาร์โรว์","นานาชาติฮีทฟิลด์","นานาชาติแพนเอเซีย","นานาชาติแอ๊ดเวนต์ กรุงเทพ","ไทยซิกข์นานาชาติ กรุงเทพ","นานาชาติกีรพัฒน์","นานาชาติโมเดอร์น มอนเทสโซรี่ อินเตอร์เนชั่นแนลพรีสคูล","นานาชาติบริติชโคลัมเบีย","นานาชาติบีคอนเฮ้าท์แย้มสอาด","นานาชาติแอสคอต","นานาชาติบรอมส์โกรฟ","นานาชาติสาทรใหม่","นานาชาติเวลล์ส-อ่อนนุช","อินเตอร์เนชั่นแนลเกวลี (หทัยราษฎร์)","นานาชาติเซนต์แอนดรูว์ส บางนา","นานาชาติเปรม ติณสูลานนท์ อินเตอร์แนชชั่นแนล สคูล","นานาชาติคอนคอร์เดียน","นานาชาติแอ๊ดเวนติสมิชชัน","ดรุณสิกขาลัย","บ้านขามป้อมดอนยูง","เอื้ออำพน","เอกทวีวิทย์","บ้านคลองมดแดง สาขาป่าคา","การกุศลวัดกลาง","การกุศลวัดบ้านยางเครือ","ฟ้าใสวิทยา (มุทิตาศึกษา)","อนุบาลการกุศลวัดประชาชุมพล","การกุศลวัดหนองนกเอี้ยง","หทัยคริสเตียน","อนุบาลการกุศลวัดตระพังทอง","มัธยมสุวิทย์เสรีอนุสรณ์","กรุงเทพวิเทศศึกษา","การศึกษาคนตาบอดและคนตาบอดพิการซ้ำซ้อน ลพบุรี","บ้านธารทอง","บ้านห้วยหยวกป่าโซ","เชียงแสน อาคาเดมี","เพื่องฟ้าวิทยา","เพื่อชีวิตเชียงใหม่","เพื่อชีวิตพังงา (เบลูก้าอุปถัมภ์)","เยาววิทย์","การกุศลในพระพุทธศาสนา วัดในวังพระอารามหลวง","คอมมูนิต้า อินคอนโทร","ทรัพย์ธานีวิทยา","ธรรมจารินีวิทยา","นันตาศึกษา","บ้านป่าระไมวิทยา","บูรพาวิทยา ชลบุรี","ปิยมาตย์","พรเมตตาคริสเตียน","พีระยา นาวิน ในอุปถัมภ์ของพีระยานุเคราะห์มูลนิธิ ในพระอุปถัมภ์ของสมเด็จพระศรีนครินทราบรมราชชนนี","พุทธศาสตร์ศึกษาบ้านดอนโด่","มูลนิธิรุ่งนภายโสธร","ศูนย์พลาญข่อย 2 บ้านด่านเม่น","สัมมาสิกขาศาลีอโศก","อนุบาลตระการทิพย์","อนุบาลธันยธรณ์","บ้านปลาดาว","อนุบาลพุทธเมตตา","ศูนย์พลาญข่อย","บ้านลาดหลวง","บ้านป่าแฝกใต้","พิมพ์มณี","อนุบาลปัญญาพร","เลิศปัญญาวิทย","มีสิทธิ์ศึกษา","กีฬาจังหวัดตรัง","อนุบาลพัตรีรมยา","อนุบาลชลิดา","อนุบาลพรละมัย","ขจรเกียรติศึกษา","ประทีปศาสน์อิสมาอีลอนุสรณ์","ท้าวราษฎร์สงเคราะห์","อนุบาลอุ่นจิต","อนุบาลบ้านทิพย์รัตน์","สิทธาภัทร์","อนุบาลสันติสุข","พัฒนศาสน์วิทยา ท่าแซะ","อนุบาลอำนวยสุข","อนุบาลสุภาภรณ์","มารีย์วิทยา บางบัวทอง","สารสาสน์วิเทศบางบัวทอง","สารสาสน์วิเทศราชพฤกษ์","อนุบาลโชตะนันท์","อนุบาลนานาชาติแมจิเยียร์ส","อนุบาลบ้านพฤกษา","อนุบาลสวนเด็กบางแพรก","อนุบาลอันวิดา","บี เอฟ เอส","ประชาบดี","ประถมพฤกษา","อนุบาลธัญญาภรณ์","อนุบาลหมู่บ้านเด็กสานรัก","ตำรวจตระเวนชายแดนบ้านปิล็อกคี่ (ธนาคารอาคารสงเคราะห์อุปถัมภ์)","นานาชาติสยาม","นานาชาติอังกฤษแห่งภาคเหนือ (นวัตภูมิลำปาง)","นานาชาติเมธา","อนุบาลนานาชาติอเมริกันแปซิฟิก","นานาชาติเซนต์จอห์นแมรี","สิบสองวิทยา","อนุบาลปราณี","อนุบาลณิชดรุณ","ฉือจี้เชียงใหม่","อนุบาลแม่บัวไหล","อนุบาลชฎาพร","บ้านคุณแม่","นันทชาติเกรดสคูล","อนุบาลฮานาคริสเตียน","อนุบาลเต็มสิริวิทยา","อนุบาลบ้านบัว","เทศบาลท่าโขลง 1","สารสาสน์วิเทศน์รังสิต","อนุบาลเด่นปทุม","โชคชัยรังสิต","อนุบาลบ้านวังทอง","อนุบาลธราดล","จุฑารัตน์วิทยา","อนุบาลฟ้าใส","สยามกลการ 5","เอื้ออังกูรวิทยา","นภสร","อนุบาลพูนสุข","อนุบาลการะเกต","อนุบาลสาธิตศึกษา","นิธิวิทย์","บ้านโล๊ะ","อนุบาลพัดทอง","อนุบาลยุวพัฒน์นครสวรรค์","อนุบาลชื่นจิต","วัดพุทธนิมิตวิทยา","สัพพัญญูวิทยา","วัดพระธาตุดอยกองมูศึกษา","วัดแก่นเหนือวิทยา","วัดหนองบัวพิทยา พระปริยัติธรรมแผนกสามัญศึกษา","เวียงแก่นวิทยา","แม่ทะปริยัติศึกษา","เชียงกลางปริยัติศึกษา","โสภณวรคุณวิทยา","สัมฤทธิบุญวิทยา","พระธาตุเวียงฮ่อปริยัติศึกษา","พระปริยัติธรรมวัดนาสาร","พระปริยัติธรรมแผนก สามัญศึกษาวัดพิกุลทอง","พระปริยัติธรรมวัดผ่องพลอยวิริยาราม","พระปริยัติธรรมวัดไชยชุมพลชนะสงคราม","พระปริยัติธรรมวัดธรรมวัดหนองพันเทา","ปัจจันตเขตวิทยา","พระปริยัติธรรมวัดปิตุลาธิราชรังสฤษฎิ์","เทพสถิตวิทยาลัย","วัดประชานิมิตโสภิตธรรมภาณ","ศรีศาสนวิทยา","พระปริยัติธรรมแผนกสามัญศึกษา วัดแจ้งแสงอรุณวิทยา","พระปริยัติธรรมวัดสำราญนิเวศ","บ้านผาสุกหนองซองแมว","บ้านอ่างเสือดำ","วรเวทยากร","เทศบาลปลายบางวัดอุบลวนาราม","พระสุธรรมยานเถระวิทยา","อนุบาลวัดอินทารามสงเคราะห์","อนุบาลศิริเพชร","ตันติวัตร","อนุบาลบ้านน้องเล็ก","อนุบาลชนะพร","เยาวเรศวิทยา","เทศบาลเมืองท่าข้าม 1","เทศบาลเมืองท่าข้าม 2","เทศบาลเมืองท่าข้าม 3","เทศบาลเมืองท่าข้าม 4","พรรณทิพย์วิทยา","อนุบาลพินิจวิทยา","อนุบาลบุณยรักษ์","อนุบาลอนงค์นาฏ","สีวลีคลองหลวง","การกุศลวัดบูรพา","เทศบาล 1 หนองบัวลำภู","บ้านกกน้อยวิทยา","บ้านผาเสริฐ","บ้านอุ่นรัก","สันป่าตอง","บ้านบือแต","ห้วยเตยพรประสิทธิ์วิทยา","ปัณณวิชญ์","พิมพ์ประภาสงเคราะห์","อนุบาลบ้านนนท์","อนุบาลวัยใส","บ้านหนองแวงป่งสัง","สอนคนตาบอดสันติจินตนาจังหวัดแพร่","อนุบาลเสริมมิตรบางขุนเทียน","อนุบาลเด่นหล้า พระราม 5","อัสสัมชัญคอนแวนต์ ลพบุรี","อนุบาลศรีลานสัก","อนุบาลสีฟ้า","สีฟ้าพัฒนวิทย์","อนุบาลรัศมี","อนุบาลทองอุ่น","ไทยราษฎร์คีรี สาขาบ้านสามยอดอย","อนุบาลพุทธชาติ","บ้านคล้า","อนุบาลประภารัตน์","เจ้าคุณปริยัติมุนีวิทยา","อนุบาลอนันตะ","บ้านแม่ยุ้น","เทศบาลหนองหัวฟาน","ณัฐบรรจงวิทยา","ผดุงรัตน์ วัดสันฐาน","นานาชาติเซนต์แอนดรูวส์ สามัคคี","อักษรานานาชาติ"," อนุบาล คิราคิร่า คิดส์ นานาชาติ","เทศบาล 7 ฝั่งหมิ่น","มัธยมวัดธาตุ (รัตนวิมลอนุสรณ์)","ปรัชชาธร","อนุบาลบุญเกื้อวิทยา","อนุบาลบ้านสมถวิล","อนุบาลภูบดินทร์","อนุบาลพรวิรุฬห์","อนุบาลศรีซำสูง","วมินทร์วิทยา (ฮัวเหมิง)","เกศเกล้าวิทยา","ประนอมศรีสงเคราะห์","อนุบาลรวมบัณฑิต","พระปริยัติธรรมตลาดชัยวิทยา","รวมบัณฑิตศึกษา","อนุบาลฑิฆัมพร","อนุบาลธัญรดา","อนุบาลรุ่งรัศมี","นานาชาติไทย-สิงคโปร์","โกลบอลอินเดียนนานาชาติ","สาธิตปทุม","นานาชาติอังกฤษ กระบี่","สารสาสน์วิเทศนิมิตใหม่","เด็กสากลนิมิตใหม่","นานาชาติคริสเตียนกรุงเทพ","นานาชาติบางกอก พรีแพราธอรี แอนด์ เซ็กเคินเดอรี","นานาชาติกลอรี่","บ้านศรีคีรีรักษ์","สวนองุ่นเชียงใหม่","วิทยาการอิสลาม","ชุมพรบริหารธุรกิจ","เซนต์จอห์นท่าบม","ลัมแบรต์พิชญาลัย","อนุบาลศรทิพย์","ดาราวัฒนาอินเตอร์","อนุบาลวริศสา","เซนต์แมรี่ อุตรดิตถ์","สุคนธีรวิทย์","วัดคูเดื่อวิทยาคม","คริสเตียนแม่หละโกร","อนุบาล ก ไก่","เพชรผ่องพันธุ์วิทยา","อนุบาลสกุลจิตร","วิบูลวิทยา"," มอ.วิทยานุสรณ์","อนุบาลยุวธัช","ปัญโญทัย","แสนสนุกไตรทักษะ","เพลินพัฒนา","จิตตเมตต์ (ปฐมวัย)","อนุบาลช้างเผือก","อนุบาลเปี่ยมรัก","วิริยาลัยโป่งน้ำร้อน","เตรียมศึกษาสอยดาว","อนุบาลประยูรศรี","อนุบาลพลพันธ์","จิรวิทย์พิทยา","อนุบาลเพชรทวี","ตำรวจตระเวนชายแดนเฉลิมพระเกียรติสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี เนื่องในโอกาสทรงเจริญพระชนมายุ 50 พรรษา 2 เมษายน 2548 (บริษัทกรุงไทยการไฟฟ้าจำกัด อุปถัมภ์)","จรรยาอิสลาม","ศาสนศึกษา","อิสลามดำรงธรรม","พัฒนศาสน์วิทยา ท่าแร้ง","ณัฐญาศึกษา","เสริมปัญญา (ไวยกัญญาอนุเคราะห์)","กีฬาเทศบาลนครสุราษฎร์ธานี","กีฬาเทศบาลนครนครราชสีมา (อนุสรณ์ 70 ปี เทศบาล)","องค์การบริหารส่วนจังหวัดกำแพงเพชร","กีฬาองค์การบริหารส่วนจังหวัดยโสธร","กีฬาจังหวัดหนองคาย","กีฬาเทศบาลเมืองทุ่งสง","กีฬาเทศบาลนครนครปฐม","กีฬาองค์การบริหารส่วนจังหวัดพิษณุโลก","กีฬาท้องถิ่นจังหวัดร้อยเอ็ด องค์การบริหารจังหวัดร้อยเอ็ด","อนุบาลน้ำเพชร","บ้านใหม่ (ราษฎร์สามัคคี)","สามัคคีอิสลามวิทยา","อนุบาลสมบูรณ์วิทย์","บ้านห้วยอื้น","แย้มสะอาดหัวหิน","อนุบาลปรารถนา","ก็พัฒนศึกษา","สมถวิลวิเทศศึกษา ห้วยมงคล","เขตพื้นที่การศึกษาแม่ฮ่องสอน เขต 1","ซำขอนแก่นวิทย์","บ้านจ่าโบ่","แสงโสม","เทศบาลคลองตำหรุ","อนุบาลชโลบล","หัสดีศึกษา","การกุศลหลวงปู่ศรีจันทร์วัณณาโภ","อนุบาลปิยะพัฒนา","อัตตาภิวัฒน์","อนุบาลศักดิ์ปทุม","อนุบาลสวนแก้ว","ทานตะวันไตรภาษา","อนุบาลจินลดา","อนุบาลกิตติเวศม์","เทศบาล 1 วัดเทพมงคล","บูรณะพัทศึกษา มูลนิธิ","ฟีนิกซ์วิทยา","บ้านกลางวิทยานุกูล","แม่สวรรค์หลวง","โนนสวางวิทยาสรรค์ สาขาห้วยหินเกิ้ง","อนุบาลสุขสัมพันธ์","วัดขุนซ่อง สาขาโป่งเกตุ","ตากสินศึกษา","เตรียมศึกษานายายอาม","วัดเขาหนองปลาไหล","บ้านโชคดี","อนุบาลสุธิชา","สารสาสน์วิเทศเชียงใหม่","นภาเชียงใหม่","บริรักศึกษาเชียงใหม่","ไสวนันทวิทย์","ปิยบุตร","พระปริยัติธรรมแผนกสามัญ วัดสุวรรณมงคล","ปัญญาประทีป","กมลวิชญ์ศึกษา","บ้านวังกรวด","บ้านหนองกก (ประชาพัฒนา)","พิสุทธิ์วิทยาคม 1","อนุบาลอัจฉรา","บ้านไร่โคกสูง","กาญจนศึกษาพัฒนาการ","มัธยมบุญคงอุปการ","อนุบาลวงศ์สวัสดิ์พัฒนา","อนุบาลชาญวิทย์","อนุบาลบรรลือทรัพย์ 2","อนุบาลสันติวัน","อนุบาลนานาชาติมังกรน้อย","อนุบาลบวรพรรณ 2","นนทบุรีศึกษา","ภรภัทร","อนุบาลชนิดา","แสนสุข","มูลนิธิรุ่งนภาโนนดินแดง","บวรวิทยา 2","อนุบาลในฝันพระนครศรีอยุธยา","เตรียมนานาชาติพระนครศรีอยุธยา","อนุบาลบ้านดรุณ","อนุบาลบางปะอิน","เอกอโยธยา","เซนต์แมรี","ตรีภัทร","สิริวัฒนา","บ้านกะหลิม","บ้านแม่เกาะ","บ้านอุมดาใต้","อนุบาลศรอารีย์","อนุบาลฝนทิพย์","อนุบาลเวชประสิทธิ์","อนุบาลร่มโพธิ์","อนุบาลรักภาษา","สองภาษาระยอง","อนุบาลทิพวัลย์","สว่างคูณวิทยา","เพชรชูศึกษา","อนุบาลท่าแพพัฒนา","พรรษนันท์ศึกษา","อัฟุรกอนวิทยา","สุไหงอุเปวิทยา","ภูริภรณ์ชัยศึกษา","อนุบาลมุสลิมสตูล","อนุบาลโอบอ้อม","สตูลศานติศึกษา","นิด้าศึกษาศาสตร์","ดารุลมุอ์มิน","สมถวิล สระบุรี","การกุศลวัดละไม","คริสเตียนสุราษฎร์ธานี","ดารุสสลามวิทยา","ปัญญาดี","วิทยาลัยเทคโนโลยีสุราษฎร์ธานี","อนุบาลเมธัส","อนุบาลศรีสุรัตน์","อุ่นรักเกาะสมุย","อนุบาลเสริมสุข","อนุบาลอุทัยทิพย์","เต็มฤทัยศึกษา","อนุบาลช่อผกา","บ้านลำอีซู สาขาบ้านหนองสำโรง","เซนต์โยเซพแม่แจ่ม","บ้านแม่วาก","บ้านแม่แฮเหนือ สาขาแม่แจ๊ะ","บ้านขุนแปะ สาขาแม่จร","บ้านขุนกลาง สาขาแม่ยะน้อย","บ้านทุ่งแก สาขาแก้วกลางดอย","บ้านห้วยปู สาขาแม่ตะละใต้","บ้านจันทร์ สาขาแจ่มน้อย","พัฒนศาสน์วิทยา คลองยาง","เซนต์แอนดรูว์","โกศลภัทรวิทย์","บ้านน้ำปัวพัฒนา","อนุบาลสมนึก","เทศบาลอ้อมน้อย","อนุบาลเทศบาลอ้อมน้อย","ปัทมดรุณวิทย์","อนุบาลธัญญาดา","บ้านหนองแดน สาขาบ้านโละโคะ","วิทยาลัยนาฏศิลปจันทบุรี","สันถวไมตรีศึกษา","เทศบาลท่าตูม","สียัดพัฒนา","อนุบาลศรีวรการแปลงยาว","ตำรวจตระเวนชายแดนบ้านเทพภูเงิน","ตำรวจตระเวนชายแดนบ้านน้ำขุ่น","ภัทรดล","อนุบาลภัทรดล","บ้านผาศักดิ์ทรัพย์เจริญ","เทศบาล 5 (วัดหัวป้อมนอก)","อนุบาลกมลนิตย์","อนุบาลศรีมณี","อนุบาลบุญพร้อง","เมทนีดล","อนุบาลดีเลิศ","วิทยาลัยนาฏศิลปนครปฐม","วิทยาลัยนาฏศิลปกาฬสินธุ์","วิทยาลัยนาฏศิลปเชียงใหม่","วิทยาลัยนาฏศิลปนครศรีธรรมราช","วิทยาลัยนาฏศิลปนครราชสีมา","วิทยาลัยนาฏศิลปพัทลุง","วิทยาลัยนาฏศิลปร้อยเอ็ด","วิทยาลัยนาฏศิลปลพบุรี","วิทยาลัยนาฏศิลปสุโขทัย","วิทยาลัยนาฎศิลปสุพรรณบุรี","วิทยาลัยนาฏศิลปอ่างทอง","อนุบาลบ้านจ่าสม","วิศานุสรณ์","พระกุมารเยซูเชียงของ","อนุบาลสุขเจริญพิทยา","พิงค์พระนครวิทยา","พิชญ์ชนกหนองแขม","อำนวยศิษย์ศึกษา","พิชญ์ชนก","สารสาสน์วิเทศธนบุรี","วลีรัตน์วิทยา","อนุบาลทอฟ้า","พรพิมพ์ พระราม 2","อนุบาลบ้านพลอยภูมิ","อนุบาลแสนสนุกไตรทักษะบางมด","อนุบาลจันทรัตน์","บ้านเด็กดี 2","บ้านท่าหินโงม สาขาวังคำแคน","บ้านทรัพย์เจริญ สาขาบ้านหลักแดน","อนุบาลบ้านรักเด็ก","อนุบาลหลวงภักดี","อนุบาลราษฏร์อุทิศ","ธรรมวัตรวิทยา (วัดดอนมูล)","อนุกูลวิทยา (วัดดอนแก้ว)","ปรีชาญาณศึกษา พบพระ","บ้านวังน้ำเย็น","คำถาวรเจริญวิทย์","บ้านโนนสมบูรณ์วิทยา","อนุบาลวรรณรัตน์","อนุบาลโสธิญา","อนุบาลวัดเสมาเมือง","บ้านคลองไทร สาขาแม่เรวา","บ้านยอดห้วยแก้ว สาขาปางข้าวสาร","อนุบาลทินนโชติ","อนุบาลผลิใบ","อนุบาลสุขใจ","ปัญญวิทย์","สาธิตแห่งมหาวิทยาลัยรังสิต","สารสาสน์วิเทศคลองหลวง","อนุบาลสุรัชนันท์","อนุบาลดวงตะวัน","บ้านวังทองวัฒนา","จันทร์กระจ่างศึกษา","รักษาทรัพย์พิทยากร (นาดี)","ดารุลบารอกะฮฺ","นูรุลอิสลามภูมีวิทยา","ปัตตานีดารุสลาม","ส่งเสริมอิสลามศึกษา","นูรุลฮีดายะห์อัลอิสลามียะห์","อนุบาลบ้านสวนเด็ก","อนุบาลสุนทรารม","บ้านเขาสามยอด","ค่ายลูกเสือจังหวัดกาฬสินธุ์","บ้านบัวหุ่ง (รัฐราษฎร์สามัคคี)","องค์การบริหารส่วนจังหวัดเชียงราย","วัดนาเยียวิทยา","สมาคมไทย-ญี่ปุ่น ศรีราชา","บ้านแม่กา สาขาบ้านแม่ต๋ำน้อย","อนุบาลจำเนียร","อนุบาลมารีรักพังงา","อนุบาลไพรัช","ศรัทธาธรรม","ดาริสสลามวิทยา","บ้านนาบอน (อิสลามศึกษา) มูลนิธิ","ดรุณศาสตร์สหวิทยามูลนิธิ","อิสลามศาสตร์มูลนิธิ","ศาสนวิทยามูลนิธิ","ธรรมศาสน์วิทยามูลนิธิ","อนุบาลสินธนา","ดารุสลามมูลนิธิ","บางแก้วอิสลามศึกษา (หนองบ่อ)","ประทีปศาสน์วิทยา","เพชรบูรณ์การ์เด้นฮิลล์","วัดซับบอนวิทยา","บ้านเค็ม (รัฐประสาทราษฎร์บำรุง)","บ้านแม่แฮด","อนุบาลคำชะอี","อนุบาลยศวดีนิคมคำสร้อย","มาอาหัดดารุสสลาม","นับเงิน","งามมีศรีพัฒนา","นารายณ์วิทยา ท่าหลวง","บ้านแม่กองวะ","อนุบาลเจริญสว่าง","มูลมังหลวงปู่ชอบฐานสโม","ประจันตวิทยา","อนุบาลศุภกรผาขาว","อนุบาลณัฐพันธุ์ 3","หฤทัยคริสเตียน","วิถีพุทธภูกระดึงวิทยา","บ้านพนมชัย","ท่านผู้หญิงจันทิมาพึ่งบารมี","บ้านพะเนาว์ราษฎร์บำรุง สาขานาขาม","นาเพียงสว่างวิทยานุกูล สาขาศรีคงคำ","อนุบาลรพีพร","อนุบาลชนิกานต์","อนุบาลภนิตา","อนุบาลภวิกา","อนุบาลเก่งดีมีสุข","บ้านสันติสุขสระแก้ว","บ้านแสนสุขสามัคคี","ประภามนตรี 3","สารสาสน์วิเทศสุวรรณภูมิ","อิสลามสมุทรปราการ (มะซออนุสรณ์)","ล้อมรักแม่กลอง","อนุบาลบ้านทอฝัน","อนุบาลคลองหาด","บ้านคลองหาด สาขาเขาช่องแคบ","ศรีตาพระยา","พูลเจริญวิทยา","อนุบาลจันทรอัมพร","มัธยมพุทธนิคม","บ้านเคี่ยมเพาะ","อนุบาลบ้านครู (รุ่งธรรม)","ประสงค์วิทยานุสรณ์ (กลางนุรักษ์อุปถัมภ์)","อนุบาลบัณฑิตา","อนุบาลขวัญแม่","อนุบาลปิยะพัฒน์","อนุบาลเพียรจรัส","ปัญญาทิพย์","บุตรเพชรวิทยา","บ้านหนองอุ สาขาเหล่านาดี","บ้านหนองขามท่างาม สาขาบ้านกุดหัวแฮด","บ้านโป่งปุ้น","บ้านห้วยคอม สาขาบ้านเพีย","ชุมชนไกรลาศวิทยาคม สาขาวัดศรีสะอาดโพธิ์ชัย","อนุบาลวัดหนองเต่า","อนุบาลวัดหนองเต่า สาขาบ้านหนองน้ำขุ่น","วัดบุญลือ สาขาวัดเขาพะแวง","บ้านวังเตย สาขาบ้านสาลี","บ้านสระนารายณ์ สาขาบ้านหนองตะคลอง","บ้านหนองแว่น สาขาวัดหนองหลวง","บ้านบ่อยาง สาขาบ้านบ่อชุมแสง","อนุบาลทีปังกรรัศมีโชติ","บ้านโป่งเป้า สาขาบ้านคำจ้าว","อนุบาลอุดมพันธ์","วัดไร่น้อย","อนุบาลต้นกล้า","อนุบาลสุภัทรกาญจน์","วุฒิศาสตร์วิทยานุสรณ์","รุ่งอรุณศึกษา","เอกภาพศาสนวิชญ์","อนุบาลคณาพร","ดวงแก้ววิทยา","ทองคำวิทยานุสรณ์","ภูมิสวรรค์วิทยา","อนุบาลดวงแก้วพิทยา","อนุบาลกานตราช","ทุ่งโพวิทยา สาขาบ้านทุ่งสบาย","ต้นกล้า","อนุบาลเทศบาลตำบลโคกสำโรง","อนุบาลพรเทพ","การกุศลวัดสถานสงเคราะห์","อนุบาลศรีจันทร์","อนุบาลสกุลรัตน์","บ้านตันหยง สาขาบ้านเตียง","อนุบาลเกาะแก้ว","อนุบาลภาคภูมิ","อนุบาลสุนันทา","สาธิตดวงฤทัย ทัยกมลวิชชาลัย","อนุบาลสงกรานต์","อนุบาลวรัญญู","ศรีแสงธรรม","มัธยมพระราชทานเฉลิมพระเกียรติ","ท่านผู้หญิงสง่า อิงคุลานนท์","บ้านกอก-จูน","วัดป่านาเชือก","บ้านนาหนุน 2","อนุบาลสุวรรณรัตน์","อนุบาลจริยปัญญา","อนุบาลอิมมานูเอลเชียงกลาง","อนุบาลทะกอง","บ้านน้ำสอด สาขาน้ำเพาะ","บ้านยอดดอยวัฒนา สาขาน้ำหมาว","บ้านบ่อหลวง สาขาห้วยโป่ง","อนุบาลจีเนียสคิดส์","อนุบาลปาลินา ติวานนท์","อนุบาลรุ้งเพชร","บ้านหนองยู","บ้านป่าพอก","พัฒนศาสตร์","สามัคคีธรรมวิทยา","อนุบาลสุวรรณภักดี","นานาชาติท๊อฟซี่ เทอร์วี่","นานาชาติแอ๊ดเวนตีส กรุงเทพ","อนุบาลนานาชาติออยสก้า","นานาชาติเครซเซนต์","นานาชาติโจซูอิกัน กรุงเทพ","เจริญศาสน์วิทยา","คัมภีร์วิทยา","อัลฟัลลา อัสอิสลามี","ดาราวิทย์","ประทีปธรรมวิทยา","ดารุลไอตัมวัลมาซากีน","ลุกมานูลฮากีม","ธรรมอิสลามศึกษา","อนุบาลสุรียาพร","บ้านอุดมสุข","พัฒนาอิสลามวิทยา","อนุบาลญัณญาร์","แสงจริยธรรม","พัฒนศาสน์โกตาบารู","ผดุงศาสน์วิทยา","อามานะวิทยา","ธรรมพิทยาคารมูลนิธิ","อิสลามพัฒนา","เตรียมวิทยาอาฆง","ศาลาฟี","บ้านดอนวิทยามูลนิธิ","นิติอิสลาม","นาวาวิทย์","เร๊าะห์มานียะห์","สันติวิทย์","ธรรมวิทยามูลนิธิสงขลา","มูลนิธิอิติซอมวิทยา","ทางธรรมวิทยา","ประทีปศาสตร์อิสลาม","จริยศาสน์อิสลาม","มิฟตาฮุดดีน","ศาสนอุปถัมภ์","ฤทธิยะวรรณาลัย 2","อนุบาลบรรดิษฐน้อย","หาดใหญ่วิทยาคาร","การกุศลวัดบ้านโดด","สาธิตศิลปกมลวิชชาลัย","นางศิริฤดี นิรามย์","นางชนม์ศุภางค์ เงินพจน์ด้วง","นางพรทิพย์ นิลพัฒน์","นายสมศักดิ์ อินทรธวัช","นายสรายุธ ส่งเสริมสวัสดิ์","นายไพจิตร มาศมาลัย","นายไชยเสริฐ ชนาเทพาพร","บ้านเรียนบ้านสวนป่าสุขใจ","น.พ.เกรียงศักดิ์ ลาภจตุรพิธ","นางอรอำไพ ณะกัณฑ์","นางประภามาศ ปานเจริญ","นายวีรวัฒน์ กังวานนวกุล","นางวิภา วงศ์มัชฌิมา","นางธันยาพร พลอยมนตรี","นายสุรพร สูงกิจบูลย์","นางสุพินดา ไกรเสม","นายวีรเดช ธนธีรโชติ","นางสาวพบจันทร์ ลีลาศาสตร์สุนทร","นางชุมมาศ แป้งหอม","นางสาวจิราพัชร จันทร์แก้ว","นางณฤดี ถาวรบุตร","นายศุภกฤต สำราญชัยกร","นางภควรรณ ไชยมณีกร","นางวลัยพร บุษกร","นางวาริสา โพธิ์ดำ","นางสลิลา ภิไรงาม","นางสุมาลี แสวงทอง","นายจิรายุ คุณโฑ","นายชัยมงคล รุ่งจำรัสรัศมี","นายชูชาติชาย มูฮัมหมัดซอดิก","นายวิโรจน์ ป้อมขุนพรม","นายสนธยา สุขถาวร","นายสุรชัย แซ่ม้า","นายอาทิตย์ เลิศธนาปกรณ์","นางวัชราภรณ์ วัฒนขำ","นางอารยา สร้อยสน","นางสถาพร ศักดิ์ชัยพานิชกุล","นายกำราบ พานทอง","นายอำหรน หลังนุ้ย","นางสุกฤตา คลังวิเชียร","อนุบาลบ้านพลอยเพลิน","เทศบาลคลองท่อมใต้","สาธิตมหาวิทยาลัยศรีนครินทรวิโรฒ ประสานมิตร (ฝ่ายประถม)","วัดหนองโว้งวิทยา"," อบจ.สาธิตร่วมพัฒนา","ลูกรักป่าแดด","เทศบาลวัดกิตติสังฆาราม","สาธิตละอออุทิศ สาขาลำปาง มหาวิทยาลัยราชภัฏสวนดุสิต","การศึกษาคนตาบอดธรรมสากลหาดใหญ่","สันติรักษ์","เทศบาล 1 สังกัดเทศบาลตำบลบางปู","อนุบาลทรัพย์ปัญญา","เจริญสุข","เทศบาลหนองแก","อนุบาลทิพย์ปัญญา","อนุบาลสมปอง","อนุบาลแสนสนุก","ชุมชนวัดเทพมงคล สาขาวัดป่าหวาย","อนุบาลวลัยพร","วิทยปัญญา","เสนาบดี","บ้านพุสวรรค์","สาธิตมหาวิทยาลัยศิลปากร (ปฐมวัยและประถมศึกษา)","เทศบาล 10 อนุบาลหนูดี","กีฬาจังหวัดตราด","กีฬานครนนท์วิทยา 6 (ศูนย์เฉลิมพระเกียรติ)"," เอ.เจ. เนินมะปราง","อนุบาลช้าง","นันทบุรีวิทยา พระปริยัติธรรม","เทศบาลเฉลิมพระเกียรติสมเด็จพระเทพรัตนราชสุดาฯ สยามบรมราชกุมารี","สวนกุหลาบวิทยาลัย ธนบุรี","สวนกุหลาบวิทยาลัย ชลบุรี","มัธยมนาคนาวาอุปถัมภ์","เทศบาลตำบลจักราช","ยอดดวงใจ","อนุบาลปรมินทร์","อนุบาลลากูน่า ภูเก็ต","มัธยมสาธิตมหาวิทยาลัยนเรศวร","พัฒนาปัญญา","มัธยมธษพล","เทศบาล 4 (รักษ์เมืองสิงห์)","อนุบาลลูกขวัญ","อนุบาลเทศบาลด่านสำโรง","วิทยาสรรค์ศึกษา","ศูนย์การศึกษาพิเศษ ประจำจังหวัดเชียงราย","ศูนย์การศึกษาพิเศษ ประจำจังหวัดลำปาง","ศูนย์การศึกษาพิเศษ เขตการศึกษา 7 จังหวัดพิษณุโลก","ศูนย์การศึกษาพิเศษ เขตการศึกษา 1 จังหวัดนครปฐม","ศูนย์การศึกษาพิเศษ ประจำจังหวัดนครศรีธรรมราช","ศูนย์การศึกษาพิเศษ เขตการศึกษา 10 จังหวัดอุบลราชธานี","นานาชาติธาราพัฒนา","นานาชาติ ชลบุรี","นานาชาติมูลตรีภักดี","นานาชาติเชียงราย","อนุบาลนานาชาติฮานาคริสเตียน","นานาชาติแอ๊ดเวนติสมิชชัน-โคราช","นานาชาติ เฮดสตาร์ท","นานาชาติ ยูดับเบิลยูซี ประเทศไทย","นานาชาติสมุย","อนุบาลนานาชาติ เดอะไทนี่ซี๊ด","นานาชาติเซนต์แอนดรูว์ส ดุสิต","นานาชาติ มอนเตสซอรี่ อะแคเดอมี่ แบงค็อก","นานาชาติเบิร์คลีย์","นานาชาติเดอะรีเจ้นท์-พระราม 9","นานาชาติไอวี่บาวนด์","สาธิตละอออุทิศ สาขานครนายก มหาวิทยาลัยราชภัฏสวนดุสิต","พระปริยัติธรรมพรหมวชิรญาณ","พระปริยัติธรรมพระราหุล","พระปริยัติธรรมวัดสองพี่น้อง","มหามงคลรัฐวิทยา","วิจิตรธรรมวิทยา","พระปริยัติธรรม แผนกสามัญศึกษาวัดอ่างแก้ว","พระปริยัติธรรมวัดประชานิยม","วัดธาตุกุดกว้าง","ร่มโพธิ์ทองธรรมวิทย์","พระปริยัติธรรมวัดกลางปุญญาคม","ปริยัติสามัญวัดโพนชัย","วัดถิ่นฐานรังสิตวิทยา","วัดศรีบุญเรืองวิทยา","วัดขามชุมวิทยาสรรพ์","ดำรงธรรมศาสนวิชชาลัย","ปรางค์กู่วิทยา","พระปริยัติธรรม แผนกสามัญศึกษาวัดดงคำ","สวัสดิ์วิทยา","มงคลธรรมวัฒน์วิทยา","พระปริยัติธรรมวัดไชยมงคล","พระปริยัติธรรมวัดไตรวิทยาราม","พุทธศาสตร์ศึกษา","วัดฝังหมิ่นวิทยา","วัดดงชัยพิทยา","พระปริยัติธรรมสามัญอุ้มผางวิทยา","พระปริยัติธรรมวัดภูเก็ต","พระปริยัติธรรมวัดพระธาตุแช่แห้ง","นันทจริมเขตศึกษา","พระปริยัติธรรมธีรราชมหามุนี","ทิพย์ปาละวิทยานุสรณ์","อนุบาลรือเสาะ","เทศบาล 1 (ในระบบสาธิตมหาวิทยาลัยรามคำแหง)","อนุบาลบ้านศรีมงคล","เทศบาลคำตากล้า","ศูนย์การศึกษาพิเศษส่วนกลาง","ศูนย์การศึกษาพิเศษ เขตการศึกษา 2 จังหวัดยะลา","ศูนย์การศึกษาพิเศษ เขตการศึกษา 3 จังหวัดสงขลา","ศูนย์การศึกษาพิเศษ เขตการศึกษา 4 จังหวัดตรัง","ศูนย์การศึกษาพิเศษ เขตการศึกษา 5 จังหวัดสุพรรณบุรี","ศูนย์การศึกษาพิเศษ เขตการศึกษา 6 จังหวัดลพบุรี","ศูนย์การศึกษาพิเศษ เขตการศึกษา 8 จังหวัดเชียงใหม่","ศูนย์การศึกษาพิเศษ เขตการศึกษา 9 จังหวัดขอนแก่น","ศูนย์การศึกษาพิเศษ เขตการศึกษา 11 จังหวัดนครราชสีมา","ศูนย์การศึกษาพิเศษ เขตการศึกษา 12 จังหวัดชลบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดกระบี่","ศูนย์การศึกษาพิเศษ ประจำจังหวัดกาญจนบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดกาฬสินธุ์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดกำแพงเพชร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดจันทบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดฉะเชิงเทรา","ศูนย์การศึกษาพิเศษ ประจำจังหวัดชัยนาท","ศูนย์การศึกษาพิเศษ ประจำจังหวัดชัยภูมิ","ศูนย์การศึกษาพิเศษ ประจำจังหวัดชุมพร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดตราด","ศูนย์การศึกษาพิเศษ ประจำจังหวัดตาก","ศูนย์การศึกษาพิเศษมหาจักรีสิรินธร ประจำจังหวัดนครนายก ","ศูนย์การศึกษาพิเศษ ประจำจังหวัดนครพนม","ศูนย์การศึกษาพิเศษ ประจำจังหวัดนครสวรรค์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดนนทบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดนราธิวาส","ศูนย์การศึกษาพิเศษ ประจำจังหวัดน่าน","ศูนย์การศึกษาพิเศษ ประจำจังหวัดบุรีรัมย์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดปทุมธานี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดประจวบคีรีขันธ์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดปราจีนบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดปัตตานี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดพระนครศรีอยุธยา","ศูนย์การศึกษาพิเศษ ประจำจังหวัดพะเยา","ศูนย์การศึกษาพิเศษ ประจำจังหวัดพังงา","ศูนย์การศึกษาพิเศษ ประจำจังหวัดพัทลุง","ศูนย์การศึกษาพิเศษ ประจำจังหวัดพิจิตร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดเพชรบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดเพชรบูรณ์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดแพร่","ศูนย์การศึกษาพิเศษ ประจำจังหวัดภูเก็ต","ศูนย์การศึกษาพิเศษ ประจำจังหวัดมหาสารคาม","ศูนย์การศึกษาพิเศษ ประจำจังหวัดมุกดาหาร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดแม่ฮ่องสอน","ศูนย์การศึกษาพิเศษ ประจำจังหวัดยโสธร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดร้อยเอ็ด","ศูนย์การศึกษาพิเศษ ประจำจังหวัดระนอง","ศูนย์การศึกษาพิเศษ ประจำจังหวัดระยอง","ศูนย์การศึกษาพิเศษ ประจำจังหวัดราชบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดลำพูน","ศูนย์การศึกษาพิเศษ ประจำจังหวัดเลย","ศูนย์การศึกษาพิเศษ ประจำจังหวัดศรีสะเกษ","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสกลนคร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสตูล","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสมุทรปราการ","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสมุทรสงคราม","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสมุทรสาคร","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสระแก้ว","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสระบุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสิงห์บุรี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสุโขทัย","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสุราษฎร์ธานี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดสุรินทร์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดหนองคาย","ศูนย์การศึกษาพิเศษ ประจำจังหวัดหนองบัวลำภู","ศูนย์การศึกษาพิเศษ ประจำจังหวัดอ่างทอง","ศูนย์การศึกษาพิเศษ ประจำจังหวัดอำนาจเจริญ","ศูนย์การศึกษาพิเศษ ประจำจังหวัดอุดรธานี","ศูนย์การศึกษาพิเศษ ประจำจังหวัดอุตรดิตถ์","ศูนย์การศึกษาพิเศษ ประจำจังหวัดอุทัยธานี","มัธยมปุรณาวาส","ชุมชนสว่างวิทยา สาขาบ้านหนองบัวขาว","มัธยมตากสินระยอง","อนุบาลธนาวิทย์","อนุบาลวรัญญาวิทย์","วรัญญาวิทย์","อนุบาลน้ำทอง","เซนต์ฟรังซิสเซเวียร์ แพร่","พระราชดำริ ","อนุบาลสาธิต ม.อ. ปัตตานี","ปทุมคงคา สมุทรปราการ","บ้านเด็กรามอินทรา","ธรรมิกวิทยา (การศึกษาวิทยาศาสตร์คนตาบอด)","อนุบาลบ้านเด็กดี 2","เทศบาลท่าลี่","นานาชาติ เอส ซี แอล","บ้านห้วยแม่ต้า (ราษฎร์รัฐพัฒนา)","อนุบาลเทศบาลแม่ลาน้อย","เทศบาล 1 ต้นยาง","เทศบาลตำบลเวียงเทิง","โพธิวัฒน์พิทยา","อุดรคริสเตียนศึกษา","อนุบาลมาเรียม","อนุบาลอ่าวนาง","อนุบาลเทศบาลเมืองป่าตอง","อนุบาลบ้านต้นรัก","บ้านต้นขาม","สาธิตมหาวิทยาลัยมหาสารคาม (ฝ่ายประถม)","มูลนิธิรุ่งนภาทุ่งเสมียนตราชัยภูมิ","เลิศหล้า ถนนเกษตร-นวมินทร์","นายภิภพ พานิชภักดิ์","น.ส.ณัฎฐนันท์ วิวัฒนากันตัง","บ้านเรียน ครอบครัวสุกสะอาด","นภสรณัฐนนท์","อนุบาลเมืองใหม่ชลบุรี","ธนินทรวิทยา","สาธิตอนุบาลพรเพชร","เทศบาลปากน้ำศิริวิทยานุสรณ์","ประภัสสรคุณธรรม","อนุบาลเทศบาลตำบลเจริญศิลป์","หทัยชาติ","อิสลามวิทยาลัยบึงน้ำรักษ์","สารสาสน์วิเทศชลบุรี","อนุบาลค่ายนวมินทราชินี กองทัพบกอุปถัมภ์","อนุบาลพิมลกิจจานุวัตร","มารีย์แก้งคร้อ","อนุบาลบ้านจ่าสม 2","อนุบาลวันชัยกูล","อนุบาลสายฝนศึกษา","อินทรศึกษา","บุญถึงวิทยานุสรณ์","อนุบาลเตรียมพัฒน์","วัดพระพุทธบาทเขากระโดง","อิสาณโกศลศึกษา","อนุบาลรัตนะ","มีชัยพัฒนา","ตุลยาธร","สายมิตรวังท่าช้าง","ประไพปัญญา","วิสิฐวิทยา (วัดนางแล)","วัดท่าพระเจริญพรตวิทยา","ธนศรี","บ้านกุดแคนโนนมันปลา","วัดเวตวันวิทยาราม","อนุบาลเดชอุดม","อนุบาลเปรมชนก","อนุบาลวรรณวิไล","ศรีอุดมปัญญาคม","อนุบาลสุพรรณิกา","ปลาขาววิทยานุสรณ์","อนุบาลไกยวินิจ","อนุบาลน้ำยืน","วัดศรีเจริญ","เตรียมบัณฑิต","ศิริเกษวิทยา","สุวดีวิทยา","บุญส่งวิทยานุสรณ์","ป่าเรียนวิทยา","มูหัมมาดีย๊ะห์วิทยา","แสงใหม่วิทยา","ศึกษาศาสน์","ดารุลมะฮ์ดียะห์","พัฒนปัญญา มัสยิดควนสันติ","อักษรศิริ","เตรียมบัณฑิตพิชชาลัย","นานาชาติอเมริกันเพรพสงขลา","กัลยาณชนรังสรรค์ มัสยิดบ้านเหนือ","สานฝันปันรักมูลนิธิ","คุณธรรมวิทยา","อนุบาลนครหาดใหญ่ (นะ สุวรรณวงศ์)","เตรียมอุดมศึกษา สุวินทวงศ์","เตรียมอุดมศึกษาพัฒนาการ สุวรรณภูมิ","มัธยมวัดสุทธาราม","ไตรพัฒน์ วอลดอร์ฟ","ยุวบัณฑิต","ตำรวจตระเวนชายแดนพลเอกนวล-คุณหญิงบานชื่น จันทร์ตรี","อนุบาลสุขประเสริฐ","อนุบาลเทศบาลตำบลเด่นชัย","ดอนแก้วเนรมิตปัญญา","สารสาสน์วิเทศล้านนา","อนุบาลภัททิรา","บ้านหนองก๋าย","บ้านเอียก","ดอนชัยวิทยาคาร","เบญจธัญพิทยา","อนุบาลเขียนปัญญา","อนุบาลนานาชาติคิดส์ คิงดอม","อนุบาลนานาชาติ เค็นซิงตัน","นานาชาติแฮมพ์ตั้น","นานาชาติแคลิฟอร์เนีย เพรพ","ขจรเกียรตินานาชาติ ภูเก็ต","องค์การบริหารส่วนตำบลโนนข่า","สาธิตมหาวิทยาลัยราชภัฏราชนครินทร์","เทศบาลแหลมฉบัง 3","บูกิตอิสลามียะห์","ดีนนียะห์อิสลามียะห์","สานียาติลอิสลามียะห์","มุคตารีวิทยา","อัลอีย๊ะวิทยา","สวรรค์วิทยาคาร","ดารุลอันวาห์","ดารุลฟุรกอน","ลัดดาวิทยา","อัลฮุสนียะห์อิสลามวิทยา","อิสลามศาสนธรรมวิทยา","แสงอรุณวิทยา","พิกุลศาสน์วิทยา","ธรรมศาสนิสลาม","รุ่งอรุณพัฒนา","ศาสน์อิสลามวิทยา","ศรัทธาพิทยา","อนุบาลณัฐกฤตา (แพรววิทยา)","วัดคลองนาพง","นิคมสร้างตนเองลําน้ำน่านสงเคราะห์ 5","คริสเตียนนานาชาติเชียงราย","อนุบาลพัฒนาต้นน้ำขุนคอง","ไฉไลพร","ชัยมงคลวิทย์","ภักดีศึกษามูลนิธิ","ศาสนศึกษามูลนิธิ","สารสาสน์วิเทศนครปฐม","เด็กสายรุ้ง","อนุบาลสิริโรจนา","อนุบาลวณลักษณ์","ญะบัลนูร","ดารุลอิสละห์","ศรีสวรรค์วิทยา","อัลเราะห์มานอนุสรณ์","อัสสาอาดะห์","เชาวน์ปัญญา","ดารุลอูลูมวิทยา","บูรณาการวิทยา","ปฏิบัติธรรมวิทยามูลนิธิ","ปัญญาพัฒน์พิทยา","ปัตตานีวิทยา","ปูลาพัฒนาวิทยา","มุสลิมสันติชน","ศานติวิทยาโสร่ง","สาส์นวิทยา","อนุบาลปัญญาศาสน์","อัลกรุอานและภาษากาลามุลลอฮ","อิสลามบำรุงศาสน์วิทยา","บ้านป่าพ้อ","ตำรวจตะเวนชายแดนท่านผู้หญิงประไพ ศิวะโกเศศ","ตำรวจตะเวนชายแดนรางวัลอินทิรา คานธี","ตำรวจตระเวนชายแดนบ้านโตแฮ","ตำรวจตระเวนชายแดนบ้านโกแประ","ตำรวจตะเวนชายแดนบ้านปอหมื้อ","ตำรวจตะเวนชายแดนบ้านจอปร่าคี","วัดสุธาสินี สาขาตำรวจตระเวนชายแดนเฮงเค็ลไทย","ตำรวจตระเวนชายแดนท่านผู้หญิงสุประภาดา เกษมสันต์","ตำรวจตระเวนชายแดนค็อกนิสไทย เฉลิมฉลองครบรอบ 100 ปี วันคล้ายวันพระราชสมภพ สมเด็จพระศรีนครินทราบรมราชชนนี","อนุบาลปรียาวรรณ","อนุบาลอัสสรัตน์","บ้านท่ารั้ว","วัดสันป่าค่า","ชุมชนบ้านบวกครกน้อย สาขาวัดป่าเป้า","อโศกวิทย์อ่อนนุช แผนกอนุบาล","สาธิตพัฒนา แผนกอนุบาล","สาธิตพัฒนา แผนกประถมศึกษาและมัธยมศึกษา","อนุบาลนวรัตน์","ทินกรพิทยานุสรณ์","เทศบาล 1 (เวียงเชียงแสน)","เทศบาล 1 (ชุมชนบ้านอุดมทอง)","เทศบาล 1 (ตำบลบ้านเพ)","ตะวันชัยวิทยา","สอนศาสนาศาสนูปถัมภ์","อนุบาลเทศบาลคลองตำหรุ","เทศบาลนาอ้อ","อนุบาลหนองป่าครั่ง","อนุบาลหนองป่าครั่ง 2","เมืองพัทยา 11 (มัธยมสาธิตพัทยา)","ภูมิสมิทธ์","สว่างบริบูรณ์วิทยา","เทศบาล 1 (วัดพรหมวิหาร)","เทศบาล 2 (วัดป่ายาง)","อนุบาลเทศบาลตำบลบ้านถ้ำ","อนุบาลเทศบาลตำบลด่านเกวียน","อนุบาลเทศบาลตำบลหนองปล้อง","เทศบาล 1 (สันติสุข)","องค์การบริหารส่วนตำบลแม่กรณ์","อนุบาลเทศบาลตำบลเวียงชัย","อนุบาลเทศบาลตำบลแม่อาย (บ้านเด่น)","เทศบาลเวียงฝาง","เทศบาลตำบลปริก","อนุบาลเทศบาลตำบลพบพระ","เทศบาล 1 (บางวัว)","ประสิทธิ์ศึกษาสงเคราะห์","ยุวทูตศึกษา 2","สีทองอุปถัมภ์","บ้านพิณโท","อนุบาลจิรายุ","สิรินคริสเตียน","วิถีธรรมแห่งมหาวิทยาลัยราชภัฏสกลนคร","เอกศึกษาขอนแก่น","อนุบาลโรจน์จิราภา","บ้านบัณฑิตน้อย","เทศบาลตำบลงิม (คือเวียงจ่ำ)","เทศบาลตลาดแค","เทศบาลเมืองท่าบ่อ (ท.1)","อนุบาลเทศบาลตำบลนาดี","เทศบาล 4 อนุบาลพระเจ้าใหญ่องค์ตื้อ","เทศบาล 2 อนุบาลสาธิต เทศบาลเมืองบ้านไผ่","อนุบาลลำปาว","มัธยมศาสตร์","กิตติรวี","ภูงามโนนสะอาด","เทศบาลเขาชัยสน","อนุบาลรัตนศึกษา","กองทัพบกอุปถัมภ์อนุบาลค่ายสรรพสิทธิประสงค์","บวรธรรมประยุตวิทยา","รุ่งรัศมีเดชาวิทย์","มัธยมเปี่ยมรัก","ธนพรวิทยา","ฮั้วเฉียวอุบลราชธานี 2","อนุบาลศรีชัยวัลย์","เทศบาล 1 (เฉลิมพระเกียรติฯ บ้านป่าซาง)","อนุบาลรัตนบัณฑิต","อนุบาลขวัญประชา","อนุบาลสุรสีห์","สาธิตมหาวิทยาลัยราชภัฏเพชรบุรี","นางยุพิน วีลเลอร์","นางภัทรี แม่นธนู","นายบัญชา พงศ์พิศาลธรรม","นายสุขี สมเงิน","นางชุติมณฑน์ ก้าวหน้า","นางธารินี ชลอร์","นายสุกัลย์ ปัญโญ","นางอุษณีย์ พงศ์ประยูร","นายโจน จันใด","นางคำกอง พิมมะทา","นางสาวธารเพียร หอมจันทร์","นายงานธรรม ชาวหินฟ้า","นายชูเกียรติ โกแมน","นายคริสตชน รุ่งเรือง","นางฮาบีบ๊ะฮ์ ยาชะรัด","นางสาวอาฎีฟะฮ์ ยาชะรัด","พ.ต.อ.ศักดิ์สิทธิ์ มีแสง","พ.ญ.มาลินี กุสลานันท์","นางอลิสรา วีระนพรัตน์","นางวริศรา เมธาวิศาล","นายธนากร วีระภาคย์การุณ","นางสาวคณิศรา พลายแก้ว","นายยศวัฒน์ จรินลินพัฒน์","นางสาวพึงพิศ วิริยะภาค","นายจิรพันธุ์ เด่นไพบูลย์","นางจารุมน กุศลสวัสดิ์","นางสมพร แอบบ็อตต์","นางอรพรรณ ลีทเกนฮอสท์","นายอังคณา ใจไว","นางอนัญญา กิตติผลบุญ","นายบัญชา ฮ่งภู่","นางสาวนูรอานูรอ เกษศิริ","นางพัชราพร ลีลากิตติโชค","นางอารีพันธ์ โอรี","นางจูลี ลี","นางสกลสุภา ลีละโกเมน","นายดาซูกี เจ๊ะหลง","นายสิทธิศักดิ์ บูรณพันธ์","นายวิชัย จตุภัทร์","นางสาวสุนิสา เปาะหมอ","นางรัชดาวรรณ เจริญสุข","นางฮามีดะ หมันเส็น","นางพิมพ์พา แสงทอง","นางสูเม้ย ลี","นางสาวปิ่นอนงค์ วงค์เสือ","นางรัตนวดี ใสส่อง","นายเผด็จ ชมภูคำ","นางนวล","นายกิตติรัตน์ กสิวรรณ","นายวิชุ ณ ตระกูล","นายปรีชา แสวงทอง","นายเทวราช อารีชาญ","นางอาฟิยะฮ์ หฤทัยพร","นางอาฟิยะ อารยะชุตินนท์","นางสาวฉัตรดา นุ้ยอีด","นางประดับใจ บุษกร","นายอนิศ บุษกร","นายวันชนะ เทพสาย","นางยุพดี อ้นคง","นางสาวสุรีพร น้อยคำ","นางสาวชีรีน ป้อมขุนพรม","นายธีรภัทร เทพพันธ์","นางชุติกาญจน์ ขวัญกลัด","นางนุจรี ประทีปะวณิช จอห์นส","นางสาววิไลลักษณ์ เศษน้อย","นายธวัชชัย ทิพย์มโนวร","นางสาวบุษกร บุญจวงสิริสกุล","นายอดิศักดิ์ ภูมิพัฒน์","นายคเณศ อึ้งอุดรภักดี","นางแก้วตา เจริญสุข","นางสาวชไนพร เต็งอำนวย","นายวัชรพงษ์ วงษ์วาด","นางนงลักษณ์ ทองนพรัตน์","นายชิตชัย สุวรรณเนตร","นายพุทธิไกร วิบุลสันติ","นายจุมพฏ ศรียะพันธ์","นางจิตติมา นิตินักปราชญ์","นายเอกชัย จินาจันทร์","บ้านเรียน ลิตเติ้ล เชียงใหม่","นางศมาภรณ์ อิวาชิตะ","นางรุ่งกาญจน์ กาญจนมณี คอสท์","นายผไท วงศ์อนุตรโรจน์","นายดาวิด ศิริชัย","นางสาวธีรพร อรุณกาญจนโรจน์","นางพึงพิศ ทวิลเด","นางนิลวรรณ สุวรรณเสถียร","นางเรืองรอง วิภาคะ","นายธนิก อุดมโสภกิจ","นายวัฒนา พรมเกษา","พ.ญ.กชาญา โชติชัยธนากร","นางสาวซาห์ราห์ เบิกค์","นางบุษราภรณ์ เจริญเกียรติ","นางสาวจุฬาวัลย์ พอดีจิตประภัส","นางชุติมาศ์ จันทร์พุ่ม","นางสาวธิดารัตน์ รัดไว้","นายมานะ ยะสะนพ","นายอรรณพ ยศโสภณ","นางอรอุมา เลเกอร์","นายอ้สสัน สายนุ้ย","นางนิรสา อีแวนส์","นายเหลี่ยน แซ่ลิ้ม","นายสาทิตย์ วงศ์หนองเตย","นายแอนดรูว์ มิตเทิลแมน","นางกนกวรรณ ตันติบรรพกุล","นางญาณา ชีวจิตรกูล","นางสาวปัทมา แก้วกอเอียด","นายวิทยา ศรีเกื้อ","นายโกตาอู ตระกูลวัฒนาศิลป์","นางมาลินี อัสมิมานะ","นายมูฮัมมัดอารีฟีน","นายโซ นัย สะอิด","นางสาวสิริกัญญา ศาสนวงศ์","นางสุรางค์รัตน คำภีระ","นางประพันธ์ แสนพรม","นางมยุรีย์ เหี้ยมหาญ","นางรัศมี สองเมือง","นางสุมาลี ยอดระบำ","นางยุวดี เฉิน","นางสิริกุล ติรนันท์มงคล","นางดารณี วโรดมจิตร","ดร.ปริญ เกตุนิ่ม","นางชนิกา เพียรเจริญ","นางพภัสสรณ์ สมพรานนท์","นางสาววนิดา เต๊ะหมะ","นางสาวทัศริน พละวงศ์","นายนวัตกรณ์ ศรีตุลากร","นายอัมรี มะ","นายฉาฝีอี โส๊ะตรี","นางสาวศิริพรรณ งามจรัสศรีวิชัย","นางชุติกาญจน์ มุรธัญลักษณ์ นายธนวัตร มุรธัญลักษณ์","นางสาววนิดา วงศาจันทร์","นายอธิรัตน์ สิงห์โต","นายเจษฎา พัฒนอนุอร","นางกรรณิกา ชัยวัฒน์","นางสุทธิพร สายเพ็ชร์","นายพงศธร ตรีกุล","นางสาวฝนทิพย์ สินเกิดสุข","นางโชติกา ดีมากด์","นายพรชัย เตชะไทยเจริญ","นายจตุพร สบาย","นางวารินี วันหมัด","นางสิริกัญญา มะหะหมัด","นายวรเทพ ธรรมสังคีติ","นางชตพร มะละกีมะ","นางกาญจนา หวันเหล็ม","นางสาวมาลินี มินสุวรรณ","นายอดุลย์ วงศ์เสงี่ยม","นางสาวซันมา บุญมาเลิศ","นางฉันทนา เกิดพุ่ม","นางสาวนาดียะห์ สาอ่ะ","นางมาเรียม บุญมาเลิศ","นางมณีนุช บริสุทธิ์","นางสุวรรณ หวังบู่","นางสาวอรยา สุขถาวร","นางอารีย์ สุขุมาภัย","นางรุจยา หมัดนะฮู","นางสาวศรสวรรค์ ภโวทัยรันฑร","นายกายารือตา เจะเลาะ","นางสาวปนัดดา เสาวภาคย์เศรษฐ์","นางสาวิตรี อัศอารีย์","นางกุศลิน ตอเล็บ","นายอดิศักดิ์ สาลีหมัด","นางสุมิตรา โซ๊ะวิเศษ","นางสาวอัศณีย์ แสนสะอาด","นางมีนา มานะ","นางศราวุธ นันทศิลป์","นายนริศ สมบุญยิ่ง","นางสุกัญญา สัตยรังษี","นายณัฐพร ชาญชุติวาณิช","นางสาววิตตรี เลาะหะหมัด","นางสาวสกาวรัตน์ วงศ์มั่นกิจการ","นางสาววัณณ์นภัสร์ โรจน์วณิชากรณ์","นางบุหงา ลิมโกมุท","นางสาวพัสนันท์ มณีรัตน์","นางสาวพีรฉัตร บุณยรัตนพันธ์","นางสาวดวงรัช แซ่จิว","นางจันทรัศม์ เหรียญประยูร","นายอนันธนา พึ่งบุญลือ","นายปริญญา คดดี","นายชยพัฒน์ ดิษฐเจริญ","นางวชิราภรณ์ ฉัตรวรนันท์","นางสาวรวีวรรณ ขยันการ","นางชวันลักษณ์ เกรียงปริญญากิจ","นางนวลนรี สวัสดิบุตร","นางปารมี ม้าเทศ","นางสาวศจินทร์ ประชาสันติ์","นางสาวนพรัตน์ บุญหวัง","นางสาวเปมิกา สกุลวงษ์","นายอุดมศักดิ์ ศาตะนันท์","นางสาวภณทรษ ศิริ์มหาอาริยะโพธิ์ญา","พันเอกกนก วีรวงศ์","นายศุภวัฒน์ ศรีรุ่งเรือง","นายปิ่น จวนสัมฤทธิ์","นางสาวพรรณวดี คณานุทร้พย์กุล","นางวริสรา แอบเอี่ยม","นายธนาทร ตรีชนะกิจ","นายนรินทร หวังนุช","นางสาวภัทรวรันธ์ นวัธศิลป์","นางสาวดวงสุดา ศิริธนาผล","นางสาวจารุมา ศักดิ์ดี","นายภูมิ ชุติกรโตบุลกุล","นางสาววชิรา คงภูบาล","นางวรรษา หรูวรรธนะ","นางสาวสุนทรี สวนประเสริฐ","นางขนิษฐา กอเซ็มมูซอ","นางสาววัสสาวดี วัฒนสุวรรณ","นายวันชัย ประวาลปัทม์","นางสาวธัญพร ทองธรรมชาติ","นางหทัยชนก คมเม่น","นางนันทินี แก้วมีจีน","นางสาวพึงพิศ วิริยภาค","นายธนู เปลวเทียนยิ่งทวี","นางอนุสรา ชูสิน","นายฮาซัน บินยาติม","นายซุกกรี สุหลง","นายกิตติพงษ์ ทุนเพิ่ม","นางดลสภรณ์ ป้อมเดช","นางคนัญญา อุทัยพัฒน์","นายทรงศักดิ์ วงศ์วัง","นางสาวหญิง สุพัฒนวงศ์","นางสาวกฤดาภรณ์ สังข์สม","นายเชษฐา ไชยลิ้นฟ้า","นางฤทัยทิพย์ แซ่ลิ้ม","นางวรรณนิภา บุญระยอง","นางลภัสตรา สิงห์ชาญ","นายประดิษฐ ทรงกลด","นายเต็มทวี คำสิงห์","นายประสิทธิ์ งามสิงห์","นายบุญเชิด แจ้งเวชฉาย","นายณัฐชัยยศ แสงพูนสุข","ด.ต.ธีระนันท์ เรือนแก้ว","นายชัชพงษ์ บัวโต","นายนุกูล ชูเมือง","นายชวลิต กัลยาณมิตร","นายพรเทพ พิสุทธิพงษ์บูรณ์","นายจักรกฤต คณฑีวงษ์","นายสหธนะ จรัสธนะสาร","นายทรงกลด จารุนนทรากุล","นางดุสิดา นวลจันทร์","นายเอกชัย ตั้งสุริยานนท์","นายกำธร เที่ยงตรงจิตต์","นายบัญชา มงคลสรรพ์","นายระพล พูลสวัสดิ์กิติกูล","นายสมบัติ อินตา","นายวัน หนูมั่น","นางสุดจิต ธาราพัฒน์","นายสุชาติ สุวรรณมาโจ","นายธนาสิท์ ไชยวุฒิ","นายไพบูลย์ ธรรมเรืองฤทธิ์","นางสาวสมฤทัย ปานเจริญ","นายบุญชัย เจริญยอดสุข","นายไพศาล สูงกิจบูลย์","นางฐปนา บางยี่ขัน","นางนูรียะฮ จินดาอภิรักษ์กุล","นางสาวศิริลักษณ์ อุกอาจ","นายส้ายเหวิน แซ่หม่า","นายสมชาย แซ่วั่ง","นายธนารักษ์ เส็มเส็น","นายอนุชิต ล่านพญาสกุล","นายอนันต์ เมืองมา","นายสมบัติ อาลี","นายอุด นามแสง","นางจามคำ อาจง","นางสาวหลงเหมย แซ่ลี้","นายภาณุวัฒน์ จินดาอภิรักษ์กุล","นางสายฝน วอลราพ","อนุบาลดารุลฮาดิส","นายวุฒิไกร ชิดรัมย์","อนุบาลบัณฑิตอักษร","เทศบาลเมืองเขาสามยอด 1","นายปกิต พนมกิตติวัฒน์","นายชูชาติ มาสีกุก","นางนริสรา ตอเล็บ","บึงกาฬพิทักษ์ศึกษา","เทศบาล 1 วัดลำลูกบัว","นายกัมปนาท ใจหลัก","อนุบาลเทศบาลตำบลหนองโดน","อนุบาลตรีพัฒน์","เกตุพิชัยวิทยา สระบุรี","ศิริอุบลวรรณ","อนุบาลรัชดา","อนุบาลเทศบาลตำบลร้องกวาง","สัมมาสิกขาราชธานีอโศก","งามจิตวารินชำราบ 2","อนุบาลภัทรวรรณ","อนุบาลจิรพัฒน์","อุดมจิตวิทยา","เทศบาล 8 (อนุบาลฝันที่เป็นจริง)","วรวิมลศึกษา","คงโครัดอุทิศ","อนุบาลสำโรง","บานเย็นศึกษา","อนุบาลงามทอง","อนุบาลเทศบาลตำบลควนกุน","เทศบาลตำบลปง","พลูหลวงวิทยา (วัดโคกพลู)","ศิลานครวิทยา","ทวารวดี","เทศบาลตำบลบางเตย","สาธิตเทศบาลนครระยอง (วัดตรีรัตนาราม)","นครระยองวิทยาคม (วัดโขดใต้)","อนุบาลพรบิดา","อนุบาลบ้านลูกรัก","อนุบาลองค์การบริหารส่วนตำบลทุ่งมะพร้าว","อนุบาลเพ็ชระ","อนุบาลเทศบาลนครภูเก็ต","อนุบาลเทศบาลตำบลย่านตาขาว","เทศบาลตำบลรัษฎา","เทศบาลหางดง (ประชาคมสร้างสรรค์)","เทศบาลแม่เมาะ","ธนาศิริวัฒนศึกษา","อนุบาลเทศบาลตำบลบางเลน","อนุบาลเทศบาลตำบลศรีเชียงใหม่","นายจางซึ่ง แซ่หม่า","อนุบาลนานาชาติ คินเดอร์แบร์ อคาเดมี","พิทักษ์เกียรติวิทยา","อนุบาลประกายดาว","อนุบาลยูเมะมิกิ","ฉัตรพฤกษ์วิทยา","อนุบาลอรวรรณ","นางน้ำเพชร กอแก้ว","นางพิชญา แช่มรัมย์","นางสันตยา เศรษฐกร","นายธนพัฒน์ ตั้งนิธิเศรษฐ์","นางสาวสุจิธรรม ไสยราษฎร์","ซิสเตอร์วไลพร รักยิ่งงาม","นางเพ็ญพร อัสมิมานะ","พระครูบุญชัย กิตติปัญโญ","พระครูสุพรหม ธรรมาภิวัฒน์","เทศบาล 6 (อนุบาลในฝัน)","อนุบาลเทศบาลตำบลดงเย็น","นานาชาติ เจ สแควร์","นานาชาติธีโอดอร์","อนุบาลนานาชาติ คิดส์ วิลเลจ","เทศบาล 2 (วัดนิรมิต)","เทศบาลป่าตันนาครัว","สันติธรรมวิทยา","อนุบาลพร้อมวิทย์","อนุบาลปาลินา","องค์การบริหารส่วนตำบลป่าตึง","เทศบาลตำบลเจดีย์หลวง 1","เทศบาล 1 (บ้านไร่หลวง)","เทศบาล 1 (อนุบาลเด็กน่ารัก)","อนุบาลบ้านยูงทอง","อนุบาลเทศบาลตำบลวัดธาตุ","อนุบาลลูกหนู","เทศบาลรัตนบุรี","เทศบาลตำบลแม่กุ","รีสอร์ทอนุบาลทุ่งสง","ศูนย์การศึกษาพิเศษประจำจังหวัดบึงกาฬ","อนุบาลองค์การบริหารส่วนตำบลป่าหุ่ง","พันธสัญญา","อนุบาลเทศบาลตำบลมัญจาคีรี","อนุบาลสาธิตเทศบาลพนา (เทศบาล 2)","นนท์ประสิทธิ์วิทยา","เทศบาล 1 (ป่าก่อดำ)","พระปริยัติธรรมโพธิธรรมวิทยา","พระปริยัติธรรมแผนกสามัญศึกษาวัดดาราราม ","เทศบาลเมืองขลุง 2","เทศบาล 2 (บางปู)","อนุบาลเทศบาลเมืองหนองปรือ","ฟ้าใส","ทวิพัฒน์","เทศบาลตำบลดงมะไฟ","อนุบาลธีรญาฟ้าใส","อนุบาลสุวรรณภูมิ (เทศบาล 1)","ยุวฑูตศึกษาพัฒนา","เทศบาลธาตุ","นานาชาติกระบี่","นานาชาติ ไบร์ทตัน คอลเลจ กรุงเทพ","อนุบาลนานาชาติเพรพ มอนเตสเซอรี่","อนุบาลนานาชาติ เอบีซี แพทเวยส์","อนุบาลนานาชาติแอนนาเบลส์ เออร์ลี่ เยียร์ส","นานาชาติแองโกลสิงคโปร์ สุขุมวิท 31","นานาชาติเวลล์ส","อนุบาลนานาชาติเวลล์ส","อักษรนานาชาติ สุขุมวิท 31","นานาชาติขอนแก่น","อนุบาลนานาชาติเลดี้เบิร์ดพัทยา","อนุบาลนานาชาติต้นหลิว","คริสเตียนมโนรมย์นานาชาติ","นานาชาติ เกนส์วิลล์ เชียงราย","นานาชาติฟิวเจอร์ลีดเดอร์ส","นานาชาติอเมริกันแปซิฟิก (ประถม)","นานาชาติสิงคโปร์เชียงใหม่","นานาชาติเซาท์อีส เอเชีย","นานาชาติปัญญาเด่น","นานาชาติแองโกลสิงคโปร์ นครราชสีมา","นานาชาติเวสลี่","นานาชาติ ดาวินชี่","นานาชาติ หัวหิน","นานาชาติอริสตา","นานาชาติเคมบริดจ์ คอลเลจ (ประเทศไทย)","นานาชาติปาล์มเฮ้าส์","โอ๊ค มีโดว์ อินเตอเนชั่นแนล","นานาชาติซิลเวอร์เฟิร์น","นานาชาติเซาเทิร์น หาดใหญ่","นานาชาติบลูมส์เบอรี่-หาดใหญ่","นานาชาติสิงคโปร์สุวรรณภูมิ","นานาชาติราฟเฟิลส์อเมริกกัน","นานาชาติประภามนตรี-สิงคโปร์","นานาชาตินอริชกรุงเทพ","นานาชาติ จอห์น ไวแอท มอนเตสซอรี","นานาชาติบริติชปัญญาดี สมุย","นานาชาติละไม","นานาชาติ สุราษฎร์ธานี","นานาชาติอุดรธานี","นานาชาติแอ๊ดแวนตีสมิชชั่นอุบล","อนุบาลมะขามหลวง","สาธิตนานาชาติมหาวิทยาลัยมหิดล","วารีเชียงใหม่อินเตอร์เนชั่นแนล"];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectInput = __webpack_require__(863);

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(114);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import to enforce the CSS injection order

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      width: '100%'
    },
    select: {
      '-moz-appearance': 'none', // Reset
      '-webkit-appearance': 'none', // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      paddingRight: theme.spacing.unit * 4,
      width: 'calc(100% - ' + theme.spacing.unit * 4 + 'px)',
      minWidth: theme.spacing.unit * 2, // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        background: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style
      },
      // Remove Firefox focus border
      '&:-moz-focusring': {
        color: 'transparent',
        textShadow: '0 0 0 #000'
      },
      // Remove IE11 arrow
      '&::-ms-expand': {
        display: 'none'
      }
    },
    selectMenu: {
      width: 'auto', // Fix Safari textOverflow
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      minHeight: '1.1875em', // Reset (19px), match the native input line-height
      lineHeight: '1.1875em' // Reset (19px), match the native input line-height
    },
    disabled: {
      cursor: 'default'
    },
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)', // Center vertically
      color: theme.palette.action.active,
      'pointer-events': 'none' // Don't block pointer events on the select under the icon.
    }
  };
}; // @inheritedComponent Input

function Select(props) {
  var autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      displayEmpty = props.displayEmpty,
      input = props.input,
      inputProps = props.inputProps,
      MenuProps = props.MenuProps,
      multiple = props.multiple,
      native = props.native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      other = (0, _objectWithoutProperties3.default)(props, ['autoWidth', 'children', 'classes', 'displayEmpty', 'input', 'inputProps', 'MenuProps', 'multiple', 'native', 'onClose', 'onOpen', 'open', 'renderValue']);


  return _react2.default.cloneElement(input, (0, _extends3.default)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _SelectInput2.default
  }, other, {
    inputProps: (0, _extends3.default)({}, inputProps, input ? input.props.inputProps : {}, {
      autoWidth: autoWidth,
      children: children,
      classes: classes,
      displayEmpty: displayEmpty,
      MenuProps: MenuProps,
      multiple: multiple,
      native: native,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue
    })
  }));
}

Select.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes2.default.element,
  /**
   * Properties applied to the `input` element.
   * When `native` is `true`, the properties are applied on the `select` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   */
  renderValue: _propTypes2.default.func,
  /**
   * The input value, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

Select.defaultProps = {
  autoWidth: false,
  displayEmpty: false,
  input: _react2.default.createElement(_Input2.default, null),
  multiple: false,
  native: false
};

Select.muiName = 'Select';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSelect' })(Select);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// istanbul ignore next
var statusDiv = typeof document === 'undefined' ? null : document.getElementById('a11y-status-message');

var statuses = [];

function setStatus(status) {
  var isSameAsLast = statuses[statuses.length - 1] === status;
  if (isSameAsLast) {
    statuses = [].concat(toConsumableArray(statuses), [status]);
  } else {
    statuses = [status];
  }
  var div = getStatusDiv();

  // Remove previous children
  while (div.lastChild) {
    div.removeChild(div.firstChild);
  }

  statuses.filter(Boolean).forEach(function (statusItem, index) {
    div.appendChild(getStatusChildDiv(statusItem, index));
  });
}

function getStatusChildDiv(status, index) {
  var display = index === statuses.length - 1 ? 'block' : 'none';

  var childDiv = document.createElement('div');
  childDiv.style.display = display;
  childDiv.textContent = status;

  return childDiv;
}

function getStatusDiv() {
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = document.createElement('div');
  statusDiv.setAttribute('id', 'a11y-status-message');
  statusDiv.setAttribute('role', 'status');
  statusDiv.setAttribute('aria-live', 'assertive');
  statusDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(statusDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    width: '1px'
  });
  document.body.appendChild(statusDiv);
  return statusDiv;
}

var idCounter = 1;

/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */
function cbToCb(cb) {
  return typeof cb === 'function' ? cb : noop;
}
function noop() {}

function findParent(finder, node, rootNode) {
  if (node !== null && node !== rootNode.parentNode) {
    if (finder(node)) {
      if (node === document.body && node.scrollTop === 0) {
        // in chrome body.scrollTop always return 0
        return document.documentElement;
      }
      return node;
    } else {
      return findParent(finder, node.parentNode, rootNode);
    }
  } else {
    return null;
  }
}

/**
 * Get the closest element that scrolls
 * @param {HTMLElement} node - the child element to start searching for scroll parent at
 * @param {HTMLElement} rootNode - the root element of the component
 * @return {HTMLElement} the closest parentNode that scrolls
 */
var getClosestScrollParent = findParent.bind(null, function (node) {
  return node.scrollHeight > node.clientHeight;
});

/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node - the element that should scroll into view
 * @param {HTMLElement} rootNode - the root element of the component
 * @param {Boolean} alignToTop - align element to the top of the visible area of the scrollable ancestor
 */
// eslint-disable-next-line complexity
function scrollIntoView(node, rootNode) {
  var scrollParent = getClosestScrollParent(node, rootNode);
  if (scrollParent === null) {
    return;
  }
  var scrollParentStyles = getComputedStyle(scrollParent);
  var scrollParentRect = scrollParent.getBoundingClientRect();
  var scrollParentBorderTopWidth = parseInt(scrollParentStyles.borderTopWidth, 10);
  var scrollParentBorderBottomWidth = parseInt(scrollParentStyles.borderBottomWidth, 10);
  var bordersWidth = scrollParentBorderTopWidth + scrollParentBorderBottomWidth;
  var scrollParentTop = scrollParentRect.top + scrollParentBorderTopWidth;
  var nodeRect = node.getBoundingClientRect();

  if (nodeRect.top < 0 && scrollParentRect.top < 0) {
    scrollParent.scrollTop += nodeRect.top;
    return;
  }

  if (nodeRect.top < 0) {
    // the item is above the viewport and the parent is not above the viewport
    scrollParent.scrollTop += nodeRect.top - scrollParentTop;
    return;
  }

  if (nodeRect.top > 0 && scrollParentRect.top < 0) {
    if (scrollParentRect.bottom > 0 && nodeRect.bottom + bordersWidth > scrollParentRect.bottom) {
      // the item is below scrollable area
      scrollParent.scrollTop += nodeRect.bottom - scrollParentRect.bottom + bordersWidth;
    }
    // item and parent top are on different sides of view top border (do nothing)
    return;
  }

  var nodeOffsetTop = nodeRect.top + scrollParent.scrollTop;
  var nodeTop = nodeOffsetTop - scrollParentTop;
  if (nodeTop < scrollParent.scrollTop) {
    // the item is above the scrollable area
    scrollParent.scrollTop = nodeTop;
  } else if (nodeTop + nodeRect.height + bordersWidth > scrollParent.scrollTop + scrollParentRect.height) {
    // the item is below the scrollable area
    scrollParent.scrollTop = nodeTop + nodeRect.height - scrollParentRect.height + bordersWidth;
  }
  // the item is within the scrollable area (do nothing)
}

/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */
function debounce(fn, time) {
  var timeoutId = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(function () {
      timeoutId = null;
      fn.apply(undefined, args);
    }, time);
  };
}

/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls
 * `event.preventDefault()`. Not sure this is the best
 * way to do this, but it seems legit...
 * @param {Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */
function composeEventHandlers() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return fns.some(function (fn) {
      fn && fn.apply(undefined, [event].concat(args));
      return event.defaultPrevented;
    });
  };
}

/**
 * This generates a unique ID for all autocomplete inputs
 * @param {String} prefix the prefix for the id
 * @return {String} the unique ID
 */
function generateId(prefix) {
  return prefix + '-' + idCounter++;
}

/**
 * Resets idCounter to 0. Used for SSR.
 */
function resetIdCounter() {
  idCounter = 0;
}

/**
 * Returns the first argument that is not undefined
 * @param {...*} args the arguments
 * @return {*} the defined value
 */
function firstDefined() {
  for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return args.find(function (a) {
    return typeof a !== 'undefined';
  });
}

// eslint-disable-next-line complexity
function getA11yStatusMessage(_ref) {
  var isOpen = _ref.isOpen,
      highlightedItem = _ref.highlightedItem,
      selectedItem = _ref.selectedItem,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount,
      itemToString = _ref.itemToString;

  if (!isOpen) {
    if (selectedItem) {
      return itemToString(selectedItem);
    } else {
      return '';
    }
  }

  if (!resultCount) {
    return 'No results.';
  } else if (!highlightedItem || resultCount !== previousResultCount) {
    return resultCount + ' ' + (resultCount === 1 ? 'result is' : 'results are') + ' available, use up and down arrow keys to navigate.';
  }
  return itemToString(highlightedItem);
}

/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */
function unwrapArray(arg, defaultValue) {
  arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */
function isDOMElement(element) {
  /* istanbul ignore if */
  if (element.nodeName) {
    // then this is preact
    return typeof element.nodeName === 'string';
  } else {
    // then we assume this is react
    return typeof element.type === 'string';
  }
}

/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */
function getElementProps(element) {
  // props for react, attributes for preact
  return element.props || /* istanbul ignore next (preact) */element.attributes;
}

/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */
function requiredProp(fnName, propName) {
  throw new Error('The property "' + propName + '" is required in "' + fnName + '"');
}

var stateKeys = ['highlightedIndex', 'inputValue', 'isOpen', 'selectedItem', 'type'];
/**
 * @param {Object} state The state object
 * @return {Object} State that is relevant to downshift
 */
function pickState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var result = {};
  stateKeys.forEach(function (k) {
    if (state.hasOwnProperty(k)) {
      result[k] = state[k];
    }
  });
  return result;
}

/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */
function isPlainObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/* eslint camelcase:0 */

var Downshift$1 = function (_Component) {
  inherits(Downshift, _Component);

  function Downshift() {
    var _ref;

    classCallCheck(this, Downshift);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = possibleConstructorReturn(this, (_ref = Downshift.__proto__ || Object.getPrototypeOf(Downshift)).call.apply(_ref, [this].concat(args)));

    _initialiseProps.call(_this);

    var state = _this.getState({
      highlightedIndex: _this.props.defaultHighlightedIndex,
      isOpen: _this.props.defaultIsOpen,
      inputValue: _this.props.defaultInputValue,
      selectedItem: _this.props.defaultSelectedItem
    });
    if (state.selectedItem) {
      state.inputValue = _this.props.itemToString(state.selectedItem);
    }
    _this.state = state;
    return _this;
  }
  // itemCount can be changed asynchronously
  // from within downshift (so it can't come from a prop)
  // this is why we store it as an instance and use
  // getItemCount rather than just use items.length
  // (to support windowing + async)


  createClass(Downshift, [{
    key: 'getState',


    /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * This will perform a shallow merge of the given state object
     * with the state coming from props
     * (for the controlled component scenario)
     * This is used in state updater functions so they're referencing
     * the right state regardless of where it comes from.
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */
    value: function getState() {
      var _this2 = this;

      var stateToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;

      return Object.keys(stateToMerge).reduce(function (state, key) {
        state[key] = _this2.isControlledProp(key) ? _this2.props[key] : stateToMerge[key];
        return state;
      }, {});
    }

    /**
     * This determines whether a prop is a "controlled prop" meaning it is
     * state which is controlled by the outside of this component rather
     * than within this component.
     * @param {String} key the key to check
     * @return {Boolean} whether it is a controlled controlled prop
     */

  }, {
    key: 'isControlledProp',
    value: function isControlledProp(key) {
      return this.props[key] !== undefined;
    }
  }, {
    key: 'getItemCount',
    value: function getItemCount() {
      // things read better this way. They're in priority order:
      // 1. `this.itemCount`
      // 2. `this.props.itemCount`
      // 3. `this.items.length`
      /* eslint-disable no-negated-condition */
      if (this.itemCount != null) {
        return this.itemCount;
      } else if (this.props.itemCount !== undefined) {
        return this.props.itemCount;
      } else {
        return this.items.length;
      }
      /* eslint-enable no-negated-condition */
    }

    // eslint-disable-next-line complexity

  }, {
    key: 'internalSetState',


    // any piece of our state can live in two places:
    // 1. Uncontrolled: it's internal (this.state)
    //    We will call this.setState to update that state
    // 2. Controlled: it's external (this.props)
    //    We will call this.props.onStateChange to update that state
    //
    // In addition, we'll call this.props.onChange if the
    // selectedItem is changed.
    value: function internalSetState(stateToSet, cb) {
      var _this3 = this;

      var isItemSelected = void 0,
          onChangeArg = void 0;

      var onStateChangeArg = {};
      var isStateToSetFunction = typeof stateToSet === 'function';

      // we want to call `onInputValueChange` before the `setState` call
      // so someone controlling the `inputValue` state gets notified of
      // the input change as soon as possible. This avoids issues with
      // preserving the cursor position.
      // See https://github.com/paypal/downshift/issues/217 for more info.
      if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
        this.props.onInputValueChange(stateToSet.inputValue, _extends({}, this.getStateAndHelpers(), stateToSet));
      }
      return this.setState(function (state) {
        state = _this3.getState(state);
        stateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;

        // Your own function that could modify the state that will be set.
        stateToSet = _this3.props.stateReducer(state, stateToSet);

        // checks if an item is selected, regardless of if it's different from
        // what was selected before
        // used to determine if onSelect and onChange callbacks should be called
        isItemSelected = stateToSet.hasOwnProperty('selectedItem');
        // this keeps track of the object we want to call with setState
        var nextState = {};
        // this is just used to tell whether the state changed
        var nextFullState = {};
        // we need to call on change if the outside world is controlling any of our state
        // and we're trying to update that state. OR if the selection has changed and we're
        // trying to update the selection
        if (isItemSelected && stateToSet.selectedItem !== state.selectedItem) {
          onChangeArg = stateToSet.selectedItem;
        }
        stateToSet.type = stateToSet.type || Downshift.stateChangeTypes.unknown;

        Object.keys(stateToSet).forEach(function (key) {
          // onStateChangeArg should only have the state that is
          // actually changing
          if (state[key] !== stateToSet[key]) {
            onStateChangeArg[key] = stateToSet[key];
          }
          // the type is useful for the onStateChangeArg
          // but we don't actually want to set it in internal state.
          // this is an undocumented feature for now... Not all internalSetState
          // calls support it and I'm not certain we want them to yet.
          // But it enables users controlling the isOpen state to know when
          // the isOpen state changes due to mouseup events which is quite handy.
          if (key === 'type') {
            return;
          }
          nextFullState[key] = stateToSet[key];
          // if it's coming from props, then we don't care to set it internally
          if (!_this3.isControlledProp(key)) {
            nextState[key] = stateToSet[key];
          }
        });

        // if stateToSet is a function, then we weren't able to call onInputValueChange
        // earlier, so we'll call it now that we know what the inputValue state will be.
        if (isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) {
          _this3.props.onInputValueChange(stateToSet.inputValue, _extends({}, _this3.getStateAndHelpers(), stateToSet));
        }

        return nextState;
      }, function () {
        // call the provided callback if it's a callback
        cbToCb(cb)();

        // only call the onStateChange and onChange callbacks if
        // we have relevant information to pass them.
        var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
        if (hasMoreStateThanType) {
          _this3.props.onStateChange(onStateChangeArg, _this3.getStateAndHelpers());
        }

        if (isItemSelected) {
          _this3.props.onSelect(stateToSet.selectedItem, _this3.getStateAndHelpers());
        }

        if (onChangeArg !== undefined) {
          _this3.props.onChange(onChangeArg, _this3.getStateAndHelpers());
        }
        // this is currently undocumented and therefore subject to change
        // We'll try to not break it, but just be warned.
        _this3.props.onUserAction(onStateChangeArg, _this3.getStateAndHelpers());
      });
    }
  }, {
    key: 'getStateAndHelpers',
    value: function getStateAndHelpers() {
      var _getState = this.getState(),
          highlightedIndex = _getState.highlightedIndex,
          inputValue = _getState.inputValue,
          selectedItem = _getState.selectedItem,
          isOpen = _getState.isOpen;

      var _props = this.props,
          id = _props.id,
          itemToString = _props.itemToString;
      var getRootProps = this.getRootProps,
          getButtonProps = this.getButtonProps,
          getLabelProps = this.getLabelProps,
          getInputProps = this.getInputProps,
          getItemProps = this.getItemProps,
          openMenu = this.openMenu,
          closeMenu = this.closeMenu,
          toggleMenu = this.toggleMenu,
          selectItem = this.selectItem,
          selectItemAtIndex = this.selectItemAtIndex,
          selectHighlightedItem = this.selectHighlightedItem,
          setHighlightedIndex = this.setHighlightedIndex,
          clearSelection = this.clearSelection,
          clearItems = this.clearItems,
          reset = this.reset,
          setItemCount = this.setItemCount,
          unsetItemCount = this.unsetItemCount;

      return {
        // prop getters
        getRootProps: getRootProps,
        getButtonProps: getButtonProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getItemProps: getItemProps,

        // actions
        reset: reset,
        openMenu: openMenu,
        closeMenu: closeMenu,
        toggleMenu: toggleMenu,
        selectItem: selectItem,
        selectItemAtIndex: selectItemAtIndex,
        selectHighlightedItem: selectHighlightedItem,
        setHighlightedIndex: setHighlightedIndex,
        clearSelection: clearSelection,
        clearItems: clearItems,
        setItemCount: setItemCount,
        unsetItemCount: unsetItemCount,

        //props
        itemToString: itemToString,
        id: id,

        // state
        highlightedIndex: highlightedIndex,
        inputValue: inputValue,
        isOpen: isOpen,
        selectedItem: selectedItem
      };
    }

    //////////////////////////// ROOT

    //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT

    //////////////////////////// BUTTON

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON

    /////////////////////////////// LABEL

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL

    /////////////////////////////// INPUT

  }, {
    key: 'getItemId',

    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT

    /////////////////////////////// ITEM
    value: function getItemId(index) {
      return this.props.id + '-item-' + index;
    }
    //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this4 = this;

      // the _isMounted property is because we have `updateStatus` in a `debounce`
      // and we don't want to update the status if the component has been umounted
      this._isMounted = true;
      /* istanbul ignore if (react-native) */
      {
        // this.isMouseDown helps us track whether the mouse is currently held down.
        // This is useful when the user clicks on an item in the list, but holds the mouse
        // down long enough for the list to disappear (because the blur event fires on the input)
        // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
        // trigger hiding the menu.
        var onMouseDown = function () {
          _this4.isMouseDown = true;
        };
        var onMouseUp = function (event) {
          _this4.isMouseDown = false;
          if ((event.target === _this4._rootNode || !_this4._rootNode.contains(event.target)) && _this4.getState().isOpen) {
            _this4.reset({ type: Downshift.stateChangeTypes.mouseUp }, function () {
              return _this4.props.onOuterClick(_this4.getStateAndHelpers());
            });
          }
        };
        this.props.environment.addEventListener('mousedown', onMouseDown);
        this.props.environment.addEventListener('mouseup', onMouseUp);

        this.cleanup = function () {
          _this4._isMounted = false;
          _this4.props.environment.removeEventListener('mousedown', onMouseDown);
          _this4.props.environment.removeEventListener('mouseup', onMouseUp);
        };
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.isControlledProp('selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }

      var current = this.props.highlightedIndex === undefined ? this.state : this.props;
      var prev = prevProps.highlightedIndex === undefined ? prevState : prevProps;

      if (current.highlightedIndex !== prev.highlightedIndex && !this.avoidScrolling) {
        this.scrollHighlightedItemIntoView();
      }

      this.updateStatus();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cleanup(); // avoids memory leak
    }

    // eslint-disable-next-line complexity

  }, {
    key: 'render',
    value: function render() {
      var children = unwrapArray(this.props.render || this.props.children, noop);
      // because the items are rerendered every time we call the children
      // we clear this out each render and
      this.clearItems();
      // we reset this so we know whether the user calls getRootProps during
      // this render. If they do then we don't need to do anything,
      // if they don't then we need to clone the element they return and
      // apply the props for them.
      this.getRootProps.called = false;
      this.getRootProps.refKey = undefined;
      this.getRootProps.suppressRefError = undefined;
      // we do something similar for getLabelProps
      this.getLabelProps.called = false;
      // and something similar for getInputProps
      this.getInputProps.called = false;
      var element = unwrapArray(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called) {
        if (!this.getRootProps.suppressRefError) {
          validateGetRootPropsCalledCorrectly(element, this.getRootProps);
        }
        return element;
      } else if (isDOMElement(element)) {
        // they didn't apply the root props, but we can clone
        // this and apply the props ourselves
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(element, this.getRootProps(getElementProps(element)));
      } else {
        // they didn't apply the root props, but they need to
        // otherwise we can't query around the autocomplete
        throw new Error('downshift: If you return a non-DOM element, you must use apply the getRootProps function');
      }
    }
  }]);
  return Downshift;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Downshift$1.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultHighlightedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  defaultSelectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  defaultInputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultIsOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getA11yStatusMessage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemToString: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onInputValueChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onUserAction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOuterClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  selectedItemChanged: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stateReducer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  itemCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  environment: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    addEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    removeEventListener: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    document: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      getElementById: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
      activeElement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
      body: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
    })
  }),
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  inputValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  highlightedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  breakingChanges: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    resetInputOnSelection: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  })
  /* eslint-enable */
};
Downshift$1.defaultProps = {
  defaultHighlightedIndex: null,
  defaultSelectedItem: null,
  defaultInputValue: '',
  defaultIsOpen: false,
  getA11yStatusMessage: getA11yStatusMessage,
  id: generateId('downshift'),
  itemToString: function itemToString(i) {
    if (i == null) {
      return '';
    }
    if (false) {
      //eslint-disable-next-line no-console
      console.warn('downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.', 'The object that was passed:', i);
    }
    return String(i);
  },
  onStateChange: function onStateChange() {},
  onInputValueChange: function onInputValueChange() {},
  onUserAction: function onUserAction() {},
  onChange: function onChange() {},
  onSelect: function onSelect() {},
  onOuterClick: function onOuterClick() {},
  selectedItemChanged: function selectedItemChanged(prevItem, item) {
    return prevItem !== item;
  },
  environment: typeof window === 'undefined' /* istanbul ignore next (ssr) */
  ? {} : window,
  stateReducer: function stateReducer(state, stateToSet) {
    return stateToSet;
  },
  breakingChanges: {}
};
Downshift$1.stateChangeTypes = {
  unknown: '__autocomplete_unknown__',
  mouseUp: '__autocomplete_mouseup__',
  itemMouseEnter: '__autocomplete_item_mouseenter__',
  keyDownArrowUp: '__autocomplete_keydown_arrow_up__',
  keyDownArrowDown: '__autocomplete_keydown_arrow_down__',
  keyDownEscape: '__autocomplete_keydown_escape__',
  keyDownEnter: '__autocomplete_keydown_enter__',
  clickItem: '__autocomplete_click_item__',
  blurInput: '__autocomplete_blur_input__',
  changeInput: '__autocomplete_change_input__',
  keyDownSpaceButton: '__autocomplete_keydown_space_button__',
  clickButton: '__autocomplete_click_button__',
  blurButton: '__autocomplete_blur_button__',
  controlledPropUpdatedSelectedItem: '__autocomplete_controlled_prop_updated_selected_item__'
};

var _initialiseProps = function () {
  var _this5 = this;

  this.input = null;
  this.items = [];
  this.itemCount = null;
  this.previousResultCount = 0;

  this.setItemCount = function (count) {
    return _this5.itemCount = count;
  };

  this.unsetItemCount = function () {
    return _this5.itemCount = null;
  };

  this.getItemNodeFromIndex = function (index) {
    return _this5.props.environment.document.getElementById(_this5.getItemId(index));
  };

  this.setHighlightedIndex = function () {
    var highlightedIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.props.defaultHighlightedIndex;
    var otherStateToSet = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({ highlightedIndex: highlightedIndex }, otherStateToSet));
  };

  this.scrollHighlightedItemIntoView = function () {
    /* istanbul ignore else (react-native) */
    {
      var node = _this5.getItemNodeFromIndex(_this5.getState().highlightedIndex);
      var rootNode = _this5._rootNode;
      scrollIntoView(node, rootNode);
    }
  };

  this.openAndHighlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, _extends({ isOpen: true }, otherStateToSet));
  };

  this.highlightDefaultIndex = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.setHighlightedIndex(undefined, otherStateToSet);
  };

  this.moveHighlightedIndex = function (amount, otherStateToSet) {
    if (_this5.getState().isOpen) {
      _this5.changeHighlightedIndex(amount, otherStateToSet);
    } else {
      _this5.openAndHighlightDefaultIndex(otherStateToSet);
    }
  };

  this.changeHighlightedIndex = function (moveAmount, otherStateToSet) {
    var itemsLastIndex = _this5.getItemCount() - 1;
    if (itemsLastIndex < 0) {
      return;
    }

    var _getState2 = _this5.getState(),
        highlightedIndex = _getState2.highlightedIndex;

    var baseIndex = highlightedIndex;
    if (baseIndex === null) {
      baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    }
    var newIndex = baseIndex + moveAmount;
    if (newIndex < 0) {
      newIndex = itemsLastIndex;
    } else if (newIndex > itemsLastIndex) {
      newIndex = 0;
    }
    _this5.setHighlightedIndex(newIndex, otherStateToSet);
  };

  this.clearSelection = function (cb) {
    _this5.internalSetState({
      selectedItem: null,
      inputValue: '',
      isOpen: false
    }, cb);
  };

  this.selectItem = function (item, otherStateToSet, cb) {
    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(_extends({
      isOpen: false,
      highlightedIndex: _this5.props.defaultHighlightedIndex,
      selectedItem: item,
      inputValue: _this5.isControlledProp('selectedItem') && _this5.props.breakingChanges.resetInputOnSelection ? _this5.props.defaultInputValue : _this5.props.itemToString(item)
    }, otherStateToSet), cb);
  };

  this.selectItemAtIndex = function (itemIndex, otherStateToSet, cb) {
    var item = _this5.items[itemIndex];
    if (item == null) {
      return;
    }
    _this5.selectItem(item, otherStateToSet, cb);
  };

  this.selectHighlightedItem = function (otherStateToSet, cb) {
    return _this5.selectItemAtIndex(_this5.getState().highlightedIndex, otherStateToSet, cb);
  };

  this.rootRef = function (node) {
    return _this5._rootNode = node;
  };

  this.getRootProps = function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref4$suppressRefErro = _ref4.suppressRefError,
        suppressRefError = _ref4$suppressRefErro === undefined ? false : _ref4$suppressRefErro;

    var _ref3$refKey = _ref3.refKey,
        refKey = _ref3$refKey === undefined ? 'ref' : _ref3$refKey,
        rest = objectWithoutProperties(_ref3, ['refKey']);

    // this is used in the render to know whether the user has called getRootProps.
    // It uses that to know whether to apply the props automatically
    _this5.getRootProps.called = true;
    _this5.getRootProps.refKey = refKey;
    _this5.getRootProps.suppressRefError = suppressRefError;
    return _extends(defineProperty({}, refKey, _this5.rootRef), rest);
  };

  this.keyDownHandlers = {
    ArrowDown: function ArrowDown(event) {
      event.preventDefault();
      var amount = event.shiftKey ? 5 : 1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowDown
      });
    },
    ArrowUp: function ArrowUp(event) {
      event.preventDefault();
      var amount = event.shiftKey ? -5 : -1;
      this.moveHighlightedIndex(amount, {
        type: Downshift$1.stateChangeTypes.keyDownArrowUp
      });
    },
    Enter: function Enter(event) {
      if (this.getState().isOpen) {
        event.preventDefault();
        this.selectHighlightedItem({
          type: Downshift$1.stateChangeTypes.keyDownEnter
        });
      }
    },
    Escape: function Escape(event) {
      event.preventDefault();
      this.reset({ type: Downshift$1.stateChangeTypes.keyDownEscape });
    }
  };
  this.buttonKeyDownHandlers = _extends({}, this.keyDownHandlers, {
    ' ': function _(event) {
      event.preventDefault();
      this.toggleMenu({ type: Downshift$1.stateChangeTypes.keyDownSpaceButton });
    }
  });

  this.getButtonProps = function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onClick = _ref5.onClick,
        onKeyDown = _ref5.onKeyDown,
        onBlur = _ref5.onBlur,
        rest = objectWithoutProperties(_ref5, ['onClick', 'onKeyDown', 'onBlur']);

    var _getState3 = _this5.getState(),
        isOpen = _getState3.isOpen;

    var enabledEventHandlers = {
      onClick: composeEventHandlers(onClick, _this5.button_handleClick),
      onKeyDown: composeEventHandlers(onKeyDown, _this5.button_handleKeyDown),
      onBlur: composeEventHandlers(onBlur, _this5.button_handleBlur)
    };
    var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
    return _extends({
      type: 'button',
      role: 'button',
      'aria-label': isOpen ? 'close menu' : 'open menu',
      'aria-expanded': isOpen,
      'aria-haspopup': true
    }, eventHandlers, rest);
  };

  this.button_handleKeyDown = function (event) {
    if (_this5.buttonKeyDownHandlers[event.key]) {
      _this5.buttonKeyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.button_handleClick = function (event) {
    event.preventDefault();
    // handle odd case for Safari and Firefox which
    // don't give the button the focus properly.
    /* istanbul ignore if (can't reasonably test this) */
    if (_this5.props.environment.document.activeElement === _this5.props.environment.document.body) {
      event.target.focus();
    }
    _this5.toggleMenu({ type: Downshift$1.stateChangeTypes.clickButton });
  };

  this.button_handleBlur = function () {
    if (!_this5.isMouseDown) {
      _this5.reset({ type: Downshift$1.stateChangeTypes.blurButton });
    }
  };

  this.getLabelProps = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this5.getLabelProps.called = true;
    if (_this5.getInputProps.called && props.htmlFor && props.htmlFor !== _this5.inputId) {
      throw new Error('downshift: You provided the htmlFor of "' + props.htmlFor + '" for your label, but the id of your input is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, props.htmlFor, generateId('downshift-input'));
    return _extends({}, props, {
      htmlFor: _this5.inputId
    });
  };

  this.getInputProps = function () {
    var _ref7;

    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onKeyDown = _ref6.onKeyDown,
        onBlur = _ref6.onBlur,
        onChange = _ref6.onChange,
        onInput = _ref6.onInput,
        rest = objectWithoutProperties(_ref6, ['onKeyDown', 'onBlur', 'onChange', 'onInput']);

    _this5.getInputProps.called = true;
    if (_this5.getLabelProps.called && rest.id && rest.id !== _this5.inputId) {
      throw new Error('downshift: You provided the id of "' + rest.id + '" for your input, but the htmlFor of your label is "' + _this5.inputId + '". You must either remove the id from your input or set the htmlFor of the label equal to the input id.');
    }
    _this5.inputId = firstDefined(_this5.inputId, rest.id, generateId('downshift-input'));
    var onChangeKey = void 0;
    /* istanbul ignore next (preact) */
    onChangeKey = 'onChange';

    var _getState4 = _this5.getState(),
        inputValue = _getState4.inputValue,
        isOpen = _getState4.isOpen,
        highlightedIndex = _getState4.highlightedIndex;

    var eventHandlers = rest.disabled ? {} : (_ref7 = {}, defineProperty(_ref7, onChangeKey, composeEventHandlers(onChange, onInput, _this5.input_handleChange)), defineProperty(_ref7, 'onKeyDown', composeEventHandlers(onKeyDown, _this5.input_handleKeyDown)), defineProperty(_ref7, 'onBlur', composeEventHandlers(onBlur, _this5.input_handleBlur)), _ref7);
    return _extends({
      role: 'combobox',
      'aria-autocomplete': 'list',
      'aria-expanded': isOpen,
      'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this5.getItemId(highlightedIndex) : null,
      autoComplete: 'off',
      value: inputValue
    }, eventHandlers, rest, {
      id: _this5.inputId
    });
  };

  this.input_handleKeyDown = function (event) {
    if (event.key && _this5.keyDownHandlers[event.key]) {
      _this5.keyDownHandlers[event.key].call(_this5, event);
    }
  };

  this.input_handleChange = function (event) {
    _this5.internalSetState({
      type: Downshift$1.stateChangeTypes.changeInput,
      isOpen: true,
      inputValue: event.target.value
    });
  };

  this.input_handleBlur = function () {
    if (!_this5.isMouseDown) {
      _this5.reset({ type: Downshift$1.stateChangeTypes.blurInput });
    }
  };

  this.getItemProps = function () {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var onMouseMove = _ref8.onMouseMove,
        onMouseDown = _ref8.onMouseDown,
        onClick = _ref8.onClick,
        index = _ref8.index,
        _ref8$item = _ref8.item,
        item = _ref8$item === undefined ? requiredProp('getItemProps', 'item') : _ref8$item,
        rest = objectWithoutProperties(_ref8, ['onMouseMove', 'onMouseDown', 'onClick', 'index', 'item']);

    if (index === undefined) {
      _this5.items.push(item);
      index = _this5.items.indexOf(item);
    } else {
      _this5.items[index] = item;
    }

    var onSelectKey = 'onClick';
    return _extends(defineProperty({
      id: _this5.getItemId(index),
      // onMouseMove is used over onMouseEnter here. onMouseMove
      // is only triggered on actual mouse movement while onMouseEnter
      // can fire on DOM changes, interrupting keyboard navigation
      onMouseMove: composeEventHandlers(onMouseMove, function () {
        if (index === _this5.getState().highlightedIndex) {
          return;
        }
        _this5.setHighlightedIndex(index, {
          type: Downshift$1.stateChangeTypes.itemMouseEnter
        });

        // We never want to manually scroll when changing state based
        // on `onMouseMove` because we will be moving the element out
        // from under the user which is currently scrolling/moving the
        // cursor
        _this5.avoidScrolling = true;
        setTimeout(function () {
          return _this5.avoidScrolling = false;
        }, 250);
      }),
      onMouseDown: composeEventHandlers(onMouseDown, function (event) {
        // This prevents the activeElement from being changed
        // to the item so it can remain with the current activeElement
        // which is a more common use case.
        event.preventDefault();
      })
    }, onSelectKey, composeEventHandlers(onClick, function () {
      _this5.selectItemAtIndex(index);
    })), rest);
  };

  this.clearItems = function () {
    _this5.items = [];
  };

  this.reset = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref9) {
      var selectedItem = _ref9.selectedItem;
      return _extends({
        isOpen: false,
        highlightedIndex: _this5.props.defaultHighlightedIndex,
        inputValue: _this5.props.itemToString(selectedItem)
      }, otherStateToSet);
    }, cbToCb(cb));
  };

  this.toggleMenu = function () {
    var otherStateToSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments[1];

    otherStateToSet = pickState(otherStateToSet);
    _this5.internalSetState(function (_ref10) {
      var isOpen = _ref10.isOpen;

      return _extends({ isOpen: !isOpen }, otherStateToSet);
    }, function () {
      var _getState5 = _this5.getState(),
          isOpen = _getState5.isOpen;

      if (isOpen) {
        _this5.highlightDefaultIndex();
      }
      cbToCb(cb)();
    });
  };

  this.openMenu = function (cb) {
    _this5.internalSetState({ isOpen: true }, cbToCb(cb));
  };

  this.closeMenu = function (cb) {
    _this5.internalSetState({ isOpen: false }, cbToCb(cb));
  };

  this.updateStatus = debounce(function () {
    if (!_this5._isMounted) {
      return;
    }
    var state = _this5.getState();
    var item = _this5.items[state.highlightedIndex] || {};
    var resultCount = _this5.getItemCount();
    var status = _this5.props.getA11yStatusMessage(_extends({
      itemToString: _this5.props.itemToString,
      previousResultCount: _this5.previousResultCount,
      resultCount: resultCount,
      highlightedItem: item
    }, state));
    _this5.previousResultCount = resultCount;
    /* istanbul ignore else (react-native) */
    setStatus(status);
  }, 200);
};

function validateGetRootPropsCalledCorrectly(element, _ref2) {
  var refKey = _ref2.refKey;

  var refKeySpecified = refKey !== 'ref';
  var isComposite = !isDOMElement(element);
  if (isComposite && !refKeySpecified) {
    throw new Error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
  } else if (!isComposite && refKeySpecified) {
    throw new Error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + refKey + '"');
  }
  if (!getElementProps(element)[refKey]) {
    throw new Error('downshift: You must apply the ref prop "' + refKey + '" from getRootProps onto your root element.');
  }
}

/*
 * Fix importing in typescript after rollup compilation
 * https://github.com/rollup/rollup/issues/1156
 * https://github.com/Microsoft/TypeScript/issues/13017#issuecomment-268657860
 */
Downshift$1.default = Downshift$1;
Downshift$1.resetIdCounter = resetIdCounter;

/* harmony default export */ __webpack_exports__["a"] = (Downshift$1);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _url = __webpack_require__(867);

var _url2 = _interopRequireDefault(_url);

var _queryString = __webpack_require__(873);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaults = {
  redirectQueryParamName: 'redirect',
  locationSelector: function locationSelector(_ref) {
    var location = _ref.location;
    return location;
  }
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      redirectQueryParamName = _defaults$args.redirectQueryParamName,
      locationSelector = _defaults$args.locationSelector;

  var getRedirectQueryParam = function getRedirectQueryParam(props) {
    var location = locationSelector(props);
    var query = (0, _queryString.parse)(location.search);
    return query[redirectQueryParamName];
  };

  var createRedirectLoc = function createRedirectLoc(allowRedirectBack) {
    return function (props, redirectPath) {
      var location = locationSelector(props);
      var redirectLoc = _url2.default.parse(redirectPath, true);

      var query = void 0;

      if (allowRedirectBack) {
        query = _defineProperty({}, redirectQueryParamName, '' + location.pathname + location.search + location.hash);
      } else {
        query = {};
      }

      query = _extends({}, query, redirectLoc.query);

      return {
        pathname: redirectLoc.pathname,
        hash: redirectLoc.hash,
        search: (0, _queryString.stringify)(query)
      };
    };
  };

  return {
    getRedirectQueryParam: getRedirectQueryParam,
    createRedirectLoc: createRedirectLoc
  };
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BottomNavigation = __webpack_require__(882);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BottomNavigation).default;
  }
});

var _BottomNavigationAction = __webpack_require__(883);

Object.defineProperty(exports, 'BottomNavigationAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BottomNavigationAction).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return testAnswer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(110);
var testAnswer=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["j" /* TEST_ANSWER */],'userId','testType','testIndex','question','answer','trait');

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(890);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(385);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

var _StepIcon = __webpack_require__(393);

var _StepIcon2 = _interopRequireDefault(_StepIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center'
    },
    horizontal: {},
    vertical: {},
    alternativeLabel: {
      flexDirection: 'column'
    },
    disabled: {
      cursor: 'default'
    },
    label: {
      color: theme.palette.text.secondary
    },
    labelActive: {
      color: theme.palette.text.primary,
      fontWeight: 500
    },
    labelCompleted: {
      color: theme.palette.text.primary,
      fontWeight: 500
    },
    labelAlternativeLabel: {
      textAlign: 'center',
      marginTop: theme.spacing.unit * 2
    },
    iconContainer: {},
    iconContainerNoAlternative: {
      paddingRight: theme.spacing.unit
    },
    labelContainer: {
      width: '100%'
    }
  };
};

function StepLabel(props) {
  var _classNames, _classNames3;

  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);


  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, classes[orientation], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.alternativeLabel, alternativeLabel), _classNames), classNameProp)
    }, other),
    icon && _react2.default.createElement(
      'span',
      {
        className: (0, _classnames2.default)(classes.iconContainer, (0, _defineProperty3.default)({}, classes.iconContainerNoAlternative, !alternativeLabel))
      },
      _react2.default.createElement(_StepIcon2.default, {
        completed: completed,
        active: active,
        icon: icon,
        alternativeLabel: alternativeLabel
      })
    ),
    _react2.default.createElement(
      'span',
      { className: classes.labelContainer },
      _react2.default.createElement(
        _Typography2.default,
        {
          variant: 'body1',
          component: 'span',
          className: (0, _classnames2.default)(classes.label, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.labelAlternativeLabel, alternativeLabel), (0, _defineProperty3.default)(_classNames3, classes.labelCompleted, completed), (0, _defineProperty3.default)(_classNames3, classes.labelActive, active), _classNames3))
        },
        children
      ),
      optional
    )
  );
}

StepLabel.propTypes =  false ? {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes2.default.node,
  /**
   * Custom styles for component.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Override the default icon.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * The optional node to display.
   */
  optional: _propTypes2.default.node,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

StepLabel.defaultProps = {
  active: false,
  alternativeLabel: false,
  completed: false,
  disabled: false,
  last: false,
  orientation: 'horizontal'
};

StepLabel.muiName = 'StepLabel';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepLabel' })(StepLabel);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _CheckCircle = __webpack_require__(929);

var _CheckCircle2 = _interopRequireDefault(_CheckCircle);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _StepPositionIcon = __webpack_require__(930);

var _StepPositionIcon2 = _interopRequireDefault(_StepPositionIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block'
    },
    completed: {
      color: theme.palette.primary.main
    }
  };
};

function StepIcon(props) {
  var completed = props.completed,
      icon = props.icon,
      active = props.active,
      classes = props.classes;


  if (typeof icon === 'number' || typeof icon === 'string') {
    if (completed) {
      return _react2.default.createElement(_CheckCircle2.default, { className: (0, _classnames2.default)(classes.root, classes.completed) });
    }
    return _react2.default.createElement(_StepPositionIcon2.default, { className: classes.root, position: icon, active: active });
  }

  return icon;
}

StepIcon.propTypes =  false ? {
  /**
   * Whether this step is active.
   */
  active: _propTypes2.default.bool,
  /**
   * Classses for component style customizations.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.node.isRequired
} : {};

StepIcon.defaultProps = {
  active: false,
  completed: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepIcon' })(StepIcon);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

var _colorManipulator = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: '1px solid\n    ' + (theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.8)),
      textAlign: 'left'
    },
    numeric: {
      textAlign: 'right',
      flexDirection: 'row-reverse' // can be dynamically inherited at runtime by contents
    },
    typeHead: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightMedium,
      position: 'relative' // Workaround for Tooltip positioning issue.
    },
    typeBody: {
      fontSize: theme.typography.pxToRem(13),
      color: theme.palette.text.primary
    },
    typeFooter: {
      borderBottom: 0,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12)
    },
    paddingDefault: {
      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 7 + 'px ' + theme.spacing.unit / 2 + 'px ' + theme.spacing.unit * 3 + 'px',
      '&:last-child': {
        paddingRight: theme.spacing.unit * 3
      }
    },
    paddingDense: {
      paddingRight: theme.spacing.unit * 3
    },
    paddingCheckbox: {
      padding: '0 12px'
    }
  };
};

function TableCell(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      sortDirection = props.sortDirection,
      numeric = props.numeric,
      padding = props.padding,
      scopeProp = props.scope,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'sortDirection', 'numeric', 'padding', 'scope', 'variant']);
  var table = context.table;

  var Component = void 0;
  if (component) {
    Component = component;
  } else {
    Component = table && table.head ? 'th' : 'td';
  }

  var scope = scopeProp;
  if (!scope && table && table.head) {
    scope = 'col';
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.numeric, numeric), (0, _defineProperty3.default)(_classNames, classes['padding' + (0, _helpers.capitalize)(padding)], padding !== 'none' && padding !== 'default'), (0, _defineProperty3.default)(_classNames, classes.paddingDefault, padding !== 'none'), (0, _defineProperty3.default)(_classNames, classes.typeHead, variant ? variant === 'head' : table && table.head), (0, _defineProperty3.default)(_classNames, classes.typeBody, variant ? variant === 'body' : table && table.body), (0, _defineProperty3.default)(_classNames, classes.typeFooter, variant ? variant === 'footer' : table && table.footer), _classNames), classNameProp);

  var ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className, 'aria-sort': ariaSort, scope: scope }, other),
    children
  );
}

TableCell.propTypes =  false ? {
  /**
   * The table cell contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, content will align to the right.
   */
  numeric: _propTypes2.default.bool,
  /**
   * Sets the padding applied to the cell.
   */
  padding: _propTypes2.default.oneOf(['default', 'checkbox', 'dense', 'none']),
  /**
   * Set scope attribute.
   */
  scope: _propTypes2.default.string,
  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes2.default.oneOf(['asc', 'desc', false]),
  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: _propTypes2.default.oneOf(['head', 'body', 'footer'])
} : {};

TableCell.defaultProps = {
  numeric: false,
  padding: 'default'
};

TableCell.contextTypes = {
  table: _propTypes2.default.object.isRequired
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableCell' })(TableCell);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' });

var KeyboardArrowLeft = function KeyboardArrowLeft(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
KeyboardArrowLeft = (0, _pure2.default)(KeyboardArrowLeft);
KeyboardArrowLeft.muiName = 'SvgIcon';

exports.default = KeyboardArrowLeft;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' });

var KeyboardArrowRight = function KeyboardArrowRight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
KeyboardArrowRight = (0, _pure2.default)(KeyboardArrowRight);
KeyboardArrowRight.muiName = 'SvgIcon';

exports.default = KeyboardArrowRight;

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["e"] = __spread;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["c"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spread;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(400);
module.exports = __webpack_require__(230);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(401).enable();
  window.Promise = __webpack_require__(403);
}

// fetch() polyfill for making API calls.
__webpack_require__(404);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(115);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(229);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(229);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 404 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(115),n=__webpack_require__(231),p=__webpack_require__(116),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),l=__webpack_require__(407),B=__webpack_require__(115),C=__webpack_require__(116),ba=__webpack_require__(408),da=__webpack_require__(409),ea=__webpack_require__(159),fa=__webpack_require__(410),ia=__webpack_require__(413),D=__webpack_require__(231);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(116);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(411);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(412);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(232);

var _PathUtils = __webpack_require__(117);

var _createTransitionManager = __webpack_require__(235);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(416);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(237);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(72);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(118);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(239);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(32);
/* unused harmony reexport delay */
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(58);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(422);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(237);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(72);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(72);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(32);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["h" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(32);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(58);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(238);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(161);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(116);
var invariant = __webpack_require__(425);
var ReactPropTypesSecret = __webpack_require__(426);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(446);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(247);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(435);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(433);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(243);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(437);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(245);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(246);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(247);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(248);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(447);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(161);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(251);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history,
        isSSR = _props.isSSR;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);

    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  isSSR: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(163);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (MemoryRouter);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(117);

var _LocationUtils = __webpack_require__(232);

var _createTransitionManager = __webpack_require__(235);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Prompt);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(453);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(454);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(455);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(456);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(89);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(249);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(249);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(164);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(458)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(163);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (StaticRouter);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(165);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(250);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* unused harmony default export */ var _unused_webpack_default_export = (withRouter);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMatchSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(73);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(252);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRoot__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_MainContainer__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signin_SigninContainer__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_AppBarContainer__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_LoadingContainer__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__profile_ProfileContainer__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__route__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__test_TestContainer__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main_TermsOfServiceComponent__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main_PrivacyComponent__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__search_SearchContainer__ = __webpack_require__(978);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){var history=this.props.history;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__main_AppBarContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["ConnectedRouter"],{history:history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/signin',component:Object(__WEBPACK_IMPORTED_MODULE_9__route__["b" /* UserIsNotAuthenticated */])(__WEBPACK_IMPORTED_MODULE_5__signin_SigninContainer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_9__route__["a" /* UserIsAuthenticated */])(__WEBPACK_IMPORTED_MODULE_4__main_MainContainer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/profile',component:Object(__WEBPACK_IMPORTED_MODULE_9__route__["a" /* UserIsAuthenticated */])(__WEBPACK_IMPORTED_MODULE_8__profile_ProfileContainer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/test',component:Object(__WEBPACK_IMPORTED_MODULE_9__route__["a" /* UserIsAuthenticated */])(__WEBPACK_IMPORTED_MODULE_10__test_TestContainer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/search',component:Object(__WEBPACK_IMPORTED_MODULE_9__route__["a" /* UserIsAuthenticated */])(__WEBPACK_IMPORTED_MODULE_13__search_SearchContainer__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/termsOfService',component:__WEBPACK_IMPORTED_MODULE_11__main_TermsOfServiceComponent__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{exact:true,path:'/privacy',component:__WEBPACK_IMPORTED_MODULE_12__main_PrivacyComponent__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{to:'/'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__main_LoadingContainer__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withRoot__["a" /* default */])(App));

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Reboot__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Reboot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Reboot__);
// A theme with custom primary and secondary color.
// It's optional.
var theme=Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["createMuiTheme"])({palette:{primary:{light:"#ff5f52",main:"#c62828",dark:"#8e0000",contrastText:"#ffffff"},secondary:{main:'#f9a825',light:'#ffd95a',dark:'#c17900',contrastText:"#000000"}},fontFamily:'Kanit',typography:{fontFamily:'Kanit'}});function withRoot(Component){function WithRoot(props){// MuiThemeProvider makes the theme available down the React tree
// thanks to React context.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["MuiThemeProvider"],{theme:theme},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Reboot___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,props));}return WithRoot;}/* harmony default export */ __webpack_exports__["a"] = (withRoot);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(467);
module.exports = __webpack_require__(21).Object.assign;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(26);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(468) });


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(92);
var gOPS = __webpack_require__(175);
var pIE = __webpack_require__(122);
var toObject = __webpack_require__(75);
var IObject = __webpack_require__(168);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(61)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(74);
var toLength = __webpack_require__(120);
var toAbsoluteIndex = __webpack_require__(470);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(171);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createTypography;

var _deepmerge = __webpack_require__(123);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === undefined ? '"Roboto", "Helvetica", "Arial", sans-serif' : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === undefined ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === undefined ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === undefined ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === undefined ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === undefined ? 16 : _ref$htmlFontSize,
      other = (0, _objectWithoutProperties3.default)(_ref, ['fontFamily', 'fontSize', 'fontWeightLight', 'fontWeightRegular', 'fontWeightMedium', 'htmlFontSize']);

  function pxToRem(value) {
    return value / htmlFontSize + 'rem';
  }

  return (0, _deepmerge2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    display4: {
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: round(128 / 112) + 'em',
      marginLeft: '-.06em',
      color: palette.text.secondary
    },
    display3: {
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: round(73 / 56) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display2: {
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(48 / 45) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    display1: {
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(41 / 34) + 'em',
      marginLeft: '-.04em',
      color: palette.text.secondary
    },
    headline: {
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(32.5 / 24) + 'em',
      color: palette.text.primary
    },
    title: {
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24.5 / 21) + 'em',
      color: palette.text.primary
    },
    subheading: {
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(24 / 16) + 'em',
      color: palette.text.primary
    },
    body2: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: round(24 / 14) + 'em',
      color: palette.text.primary
    },
    body1: {
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(20.5 / 14) + 'em',
      color: palette.text.primary
    },
    caption: {
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: round(16.5 / 12) + 'em',
      color: palette.text.secondary
    },
    button: {
      fontSize: pxToRem(fontSize),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily
    }
  }, other, {
    clone: false // No need to clone deep
  });
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dark = exports.light = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createPalette;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(123);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _indigo = __webpack_require__(259);

var _indigo2 = _interopRequireDefault(_indigo);

var _pink = __webpack_require__(260);

var _pink2 = _interopRequireDefault(_pink);

var _grey = __webpack_require__(261);

var _grey2 = _interopRequireDefault(_grey);

var _red = __webpack_require__(262);

var _red2 = _interopRequireDefault(_red);

var _common = __webpack_require__(176);

var _common2 = _interopRequireDefault(_common);

var _colorManipulator = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = exports.light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common2.default.white,
    default: _grey2.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};

var dark = exports.dark = {
  text: {
    primary: _common2.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey2.default[800],
    default: '#303030'
  },
  action: {
    active: _common2.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === undefined ? {
    light: _indigo2.default[300],
    main: _indigo2.default[500],
    dark: _indigo2.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === undefined ? {
    light: _pink2.default.A200,
    main: _pink2.default.A400,
    dark: _pink2.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === undefined ? {
    light: _red2.default[300],
    main: _red2.default[500],
    dark: _red2.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === undefined ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === undefined ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === undefined ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties3.default)(palette, ['primary', 'secondary', 'error', 'type', 'contrastThreshold', 'tonalOffset']);


  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(contrast >= 3, ['Material-UI: the contrast ratio of ' + contrast + ':1 for ' + contrastText + ' on ' + background, 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color, mainShade, lightShade, darkShade) {
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
  }

  augmentColor(primary, 500, 300, 700);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error, 500, 300, 700);

  var types = { dark: dark, light: light };

   false ? (0, _warning2.default)(types[type], 'Material-UI: the palette type `' + type + '` is not supported.') : void 0;

  var paletteOutput = (0, _deepmerge2.default)((0, _extends3.default)({
    // A collection of common colors.
    common: _common2.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey2.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep
  });

  return paletteOutput;
}

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(2);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = createMixins;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends4.default)({
    gutters: function gutters(styles) {
      return (0, _extends4.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty3.default)({}, breakpoints.up('sm'), (0, _extends4.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty3.default)(_toolbar, breakpoints.up('xs') + ' and (orientation: landscape)', {
      minHeight: 48
    }), (0, _defineProperty3.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(475);
var $Object = __webpack_require__(21).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(26);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(42), 'Object', { defineProperty: __webpack_require__(38).f });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return [(arguments.length <= 0 ? undefined : arguments[0]) + 'px ' + (arguments.length <= 1 ? undefined : arguments[1]) + 'px ' + (arguments.length <= 2 ? undefined : arguments[2]) + 'px ' + (arguments.length <= 3 ? undefined : arguments[3]) + 'px rgba(0, 0, 0, ' + shadowKeyUmbraOpacity + ')', (arguments.length <= 4 ? undefined : arguments[4]) + 'px ' + (arguments.length <= 5 ? undefined : arguments[5]) + 'px ' + (arguments.length <= 6 ? undefined : arguments[6]) + 'px ' + (arguments.length <= 7 ? undefined : arguments[7]) + 'px rgba(0, 0, 0, ' + shadowKeyPenumbraOpacity + ')', (arguments.length <= 8 ? undefined : arguments[8]) + 'px ' + (arguments.length <= 9 ? undefined : arguments[9]) + 'px ' + (arguments.length <= 10 ? undefined : arguments[10]) + 'px ' + (arguments.length <= 11 ? undefined : arguments[11]) + 'px rgba(0, 0, 0, ' + shadowAmbientShadowOpacity + ')'].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

exports.default = shadows;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(478);
module.exports = __webpack_require__(21).Object.keys;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(75);
var $keys = __webpack_require__(92);

__webpack_require__(263)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
module.exports = __webpack_require__(21).Number.isNaN;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(26);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

exports.default = zIndex;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/guidelines/layout/metrics-keylines.html#metrics-keylines-baseline-grids
  unit: 8
};

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(266);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Extracts a styles object with only props that contain function values.
 */
exports['default'] = function (styles) {
  // eslint-disable-next-line no-shadow
  function extract(styles) {
    var to = null;

    for (var key in styles) {
      var value = styles[key];
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

      if (type === 'function') {
        if (!to) to = {};
        to[key] = value;
      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
        var extracted = extract(value);
        if (extracted) {
          if (!to) to = {};
          to[key] = extracted;
        }
      }
    }

    return to;
  }

  return extract(styles);
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(268);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(126);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(271);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(490);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(491);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(497);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(498);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(179);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(270);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(125);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(499);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(500);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.0";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(492);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(493);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(494);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(495);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(496);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
exports['default'] = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new classes[key](name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(94);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(94);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(178);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(178);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(125);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(268);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(94);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(125);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(179);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(76);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(124);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.type = 'text/css';
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(503);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(505);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(507);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(180);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(508);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(510);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(126);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(180);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(509);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(126);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(180);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _brcast = __webpack_require__(537);

var _brcast2 = _interopRequireDefault(_brcast);

var _themeListener = __webpack_require__(187);

var _themeListener2 = _interopRequireDefault(_themeListener);

var _exactProp = __webpack_require__(97);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component takes a `theme` property.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
var MuiThemeProvider = function (_React$Component) {
  (0, _inherits3.default)(MuiThemeProvider, _React$Component);

  function MuiThemeProvider(props, context) {
    (0, _classCallCheck3.default)(this, MuiThemeProvider);

    // Get the outer theme from the context, can be null
    var _this = (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).call(this, props, context));

    _this.broadcast = (0, _brcast2.default)();
    _this.unsubscribeId = null;
    _this.outerTheme = null;
    _this.outerTheme = _themeListener2.default.initial(context);
    // Propagate the theme so it can be accessed by the children
    _this.broadcast.setState(_this.mergeOuterLocalTheme(_this.props.theme));
    return _this;
  }

  (0, _createClass3.default)(MuiThemeProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _ref;

      var _props = this.props,
          sheetsManager = _props.sheetsManager,
          disableStylesGeneration = _props.disableStylesGeneration;

      var muiThemeProviderOptions = this.context.muiThemeProviderOptions || {};

      if (sheetsManager !== undefined) {
        muiThemeProviderOptions.sheetsManager = sheetsManager;
      }

      if (disableStylesGeneration !== undefined) {
        muiThemeProviderOptions.disableStylesGeneration = disableStylesGeneration;
      }

      return _ref = {}, (0, _defineProperty3.default)(_ref, _themeListener.CHANNEL, this.broadcast), (0, _defineProperty3.default)(_ref, 'muiThemeProviderOptions', muiThemeProviderOptions), _ref;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe on the outer theme, if present
      this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (outerTheme) {
        _this2.outerTheme = outerTheme;
        // Forward the parent theme update to the children
        _this2.broadcast.setState(_this2.mergeOuterLocalTheme(_this2.props.theme));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Propagate a local theme update
      if (this.props.theme !== nextProps.theme) {
        this.broadcast.setState(this.mergeOuterLocalTheme(nextProps.theme));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unsubscribeId !== null) {
        _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
      }
    }
    // We are not using the React state in order to avoid unnecessary rerender.

  }, {
    key: 'mergeOuterLocalTheme',


    // Simple merge between the outer theme and the local theme
    value: function mergeOuterLocalTheme(localTheme) {
      // To support composition of theme.
      if (typeof localTheme === 'function') {
         false ? (0, _warning2.default)(this.outerTheme, ['Material-UI: you are providing a theme function property ' + 'to the MuiThemeProvider component:', '<MuiThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n')) : void 0;
        return localTheme(this.outerTheme);
      }

      if (!this.outerTheme) {
        return localTheme;
      }

      return (0, _extends3.default)({}, this.outerTheme, localTheme);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return MuiThemeProvider;
}(_react2.default.Component);

MuiThemeProvider.propTypes =  false ? {
  /**
   * You can only provide a single element with react@15, a node with react@16.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server side.
   * You can significantly speed up the traversal with this property.
   */
  disableStylesGeneration: _propTypes2.default.bool,
  /**
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: _propTypes2.default.object,
  /**
   * A theme object.
   */
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired
} : {};

MuiThemeProvider.propTypes =  false ? (0, _exactProp2.default)(MuiThemeProvider.propTypes, 'MuiThemeProvider') : {};

MuiThemeProvider.childContextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
  muiThemeProviderOptions: _propTypes2.default.object
});

MuiThemeProvider.contextTypes = (0, _extends3.default)({}, _themeListener2.default.contextTypes, {
  muiThemeProviderOptions: _propTypes2.default.object
});

exports.default = MuiThemeProvider;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(514);
module.exports = __webpack_require__(21).Object.getPrototypeOf;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(75);
var $getPrototypeOf = __webpack_require__(272);

__webpack_require__(263)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(516), __esModule: true };

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(181);
__webpack_require__(274);
module.exports = __webpack_require__(184).f('iterator');


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(171);
var defined = __webpack_require__(170);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(127);
var descriptor = __webpack_require__(91);
var setToStringTag = __webpack_require__(128);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(52)(IteratorPrototype, __webpack_require__(34)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(38);
var anObject = __webpack_require__(60);
var getKeys = __webpack_require__(92);

module.exports = __webpack_require__(42) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(41).document;
module.exports = document && document.documentElement;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(522);
var step = __webpack_require__(275);
var Iterators = __webpack_require__(96);
var toIObject = __webpack_require__(74);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(182)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(524), __esModule: true };

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(525);
__webpack_require__(279);
__webpack_require__(528);
__webpack_require__(529);
module.exports = __webpack_require__(21).Symbol;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(41);
var has = __webpack_require__(62);
var DESCRIPTORS = __webpack_require__(42);
var $export = __webpack_require__(26);
var redefine = __webpack_require__(273);
var META = __webpack_require__(185).KEY;
var $fails = __webpack_require__(61);
var shared = __webpack_require__(173);
var setToStringTag = __webpack_require__(128);
var uid = __webpack_require__(121);
var wks = __webpack_require__(34);
var wksExt = __webpack_require__(184);
var wksDefine = __webpack_require__(186);
var enumKeys = __webpack_require__(526);
var isArray = __webpack_require__(276);
var anObject = __webpack_require__(60);
var isObject = __webpack_require__(47);
var toIObject = __webpack_require__(74);
var toPrimitive = __webpack_require__(167);
var createDesc = __webpack_require__(91);
var _create = __webpack_require__(127);
var gOPNExt = __webpack_require__(527);
var $GOPD = __webpack_require__(278);
var $DP = __webpack_require__(38);
var $keys = __webpack_require__(92);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(277).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(122).f = $propertyIsEnumerable;
  __webpack_require__(175).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(183)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(52)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(92);
var gOPS = __webpack_require__(175);
var pIE = __webpack_require__(122);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(74);
var gOPN = __webpack_require__(277).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(186)('asyncIterator');


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(186)('observable');


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(531), __esModule: true };

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(532);
module.exports = __webpack_require__(21).Object.setPrototypeOf;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(26);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(533).set });


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(47);
var anObject = __webpack_require__(60);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(59)(Function.call, __webpack_require__(278).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(535), __esModule: true };

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(536);
var $Object = __webpack_require__(21).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(26);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(127) });


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createBroadcast (initialState) {
  var listeners = {};
  var id = 1;
  var _state = initialState;

  function getState () {
    return _state
  }

  function setState (state) {
    _state = state;
    var keys = Object.keys(listeners);
    var i = 0;
    var len = keys.length;
    for (; i < len; i++) {
      // if a listener gets unsubscribed during setState we just skip it
      if (listeners[keys[i]]) { listeners[keys[i]](state); }
    }
  }

  // subscribe to changes and return the subscriptionId
  function subscribe (listener) {
    if (typeof listener !== 'function') {
      throw new Error('listener must be a function.')
    }
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    return currentId
  }

  // remove subscription by removing the listener function
  function unsubscribe (id) {
    listeners[id] = undefined;
  }

  return { getState: getState, setState: setState, subscribe: subscribe, unsubscribe: unsubscribe }
}

/* harmony default export */ __webpack_exports__["default"] = (createBroadcast);


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(539), __esModule: true };

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(279);
__webpack_require__(181);
__webpack_require__(274);
__webpack_require__(540);
__webpack_require__(547);
__webpack_require__(550);
__webpack_require__(552);
module.exports = __webpack_require__(21).Map;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(541);
var validate = __webpack_require__(286);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(543)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(38).f;
var create = __webpack_require__(127);
var redefineAll = __webpack_require__(280);
var ctx = __webpack_require__(59);
var anInstance = __webpack_require__(281);
var forOf = __webpack_require__(129);
var $iterDefine = __webpack_require__(182);
var step = __webpack_require__(275);
var setSpecies = __webpack_require__(542);
var DESCRIPTORS = __webpack_require__(42);
var fastKey = __webpack_require__(185).fastKey;
var validate = __webpack_require__(286);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var core = __webpack_require__(21);
var dP = __webpack_require__(38);
var DESCRIPTORS = __webpack_require__(42);
var SPECIES = __webpack_require__(34)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(41);
var $export = __webpack_require__(26);
var meta = __webpack_require__(185);
var fails = __webpack_require__(61);
var hide = __webpack_require__(52);
var redefineAll = __webpack_require__(280);
var forOf = __webpack_require__(129);
var anInstance = __webpack_require__(281);
var isObject = __webpack_require__(47);
var setToStringTag = __webpack_require__(128);
var dP = __webpack_require__(38).f;
var each = __webpack_require__(544)(0);
var DESCRIPTORS = __webpack_require__(42);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(59);
var IObject = __webpack_require__(168);
var toObject = __webpack_require__(75);
var toLength = __webpack_require__(120);
var asc = __webpack_require__(545);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(546);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(47);
var isArray = __webpack_require__(276);
var SPECIES = __webpack_require__(34)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(26);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(548)('Map') });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(285);
var from = __webpack_require__(549);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(129);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(551)('Map');


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(26);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(553)('Map');


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(26);
var aFunction = __webpack_require__(255);
var ctx = __webpack_require__(59);
var forOf = __webpack_require__(129);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(555), __esModule: true };

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(556);
module.exports = -0x1fffffffffffff;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(26);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ns$jss$ns$sheetOptio;

var _propTypes = __webpack_require__(1);

var _ns = __webpack_require__(288);

var ns = _interopRequireWildcard(_ns);

var _propTypes2 = __webpack_require__(558);

var _propTypes3 = _interopRequireDefault(_propTypes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports['default'] = (_ns$jss$ns$sheetOptio = {}, _defineProperty(_ns$jss$ns$sheetOptio, ns.jss, _propTypes3['default'].jss), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetOptions, _propTypes.object), _defineProperty(_ns$jss$ns$sheetOptio, ns.sheetsRegistry, _propTypes3['default'].registry), _defineProperty(_ns$jss$ns$sheetOptio, ns.managers, _propTypes.object), _ns$jss$ns$sheetOptio);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

exports['default'] = {
  jss: (0, _propTypes.shape)({
    options: (0, _propTypes.shape)({
      createGenerateClassName: _propTypes.func.isRequired
    }).isRequired,
    createStyleSheet: _propTypes.func.isRequired,
    removeStyleSheet: _propTypes.func.isRequired
  }),
  registry: (0, _propTypes.shape)({
    add: _propTypes.func.isRequired,
    toString: _propTypes.func.isRequired
  })
};

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _deepmerge = __webpack_require__(123);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// < 1kb payload overhead when lodash/merge is > 3kb.

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!theme.overrides || !name || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends3.default)({}, styles);

    (0, _keys2.default)(overrides).forEach(function (key) {
       false ? (0, _warning2.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', 'Fix the `' + key + '` key of `theme.overrides.' + name + '`.'].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge2.default)(stylesWithOverrides[key], overrides[key]);
    });

    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

exports.default = getStylesCreator;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__(90);

var _exactProp = __webpack_require__(97);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased', // Antialiasing.
        MozOsxFontSmoothing: 'grayscale', // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      body: {
        margin: 0, // Remove the margin in all browsers.
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        }
      }
    }
  };
};

/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

var Reboot = function (_React$Component) {
  (0, _inherits3.default)(Reboot, _React$Component);

  function Reboot() {
    (0, _classCallCheck3.default)(this, Reboot);
    return (0, _possibleConstructorReturn3.default)(this, (Reboot.__proto__ || (0, _getPrototypeOf2.default)(Reboot)).apply(this, arguments));
  }

  (0, _createClass3.default)(Reboot, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return Reboot;
}(_react2.default.Component);

Reboot.propTypes =  false ? {
  /**
   * You can only provide a single element with react@15, a node with react@16.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired
} : {};

Reboot.propTypes =  false ? (0, _exactProp2.default)(Reboot.propTypes, 'Reboot') : {};

Reboot.defaultProps = {
  children: null
};

exports.default = (0, _styles.withStyles)(styles, { name: 'MuiReboot' })(Reboot);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_IconButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_icons_SentimentVerySatisfied__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_icons_SentimentVerySatisfied___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_icons_SentimentVerySatisfied__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_List__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Divider__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_Divider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_icons_HighlightOff__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_icons_HighlightOff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_icons_HighlightOff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Avatar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_Form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__action__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__search_action__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_Card__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_icons_Extension__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_material_ui_icons_Extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_material_ui_icons_Extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_icons_InsertEmoticon__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_material_ui_icons_InsertEmoticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_material_ui_icons_InsertEmoticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_icons_Work__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_material_ui_icons_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_material_ui_icons_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_share__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_Progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_material_ui_Progress__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getImageLocation(image){return'https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2Fjobs%2F'+image+'.png?alt=media';}var MainContainer=function(_Component){_inherits(MainContainer,_Component);function MainContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainContainer.__proto__||Object.getPrototypeOf(MainContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={jobsCount:0},_this.matchLevel=0,_this.cognitiveMatch=0,_this.softskillsMatch=0,_this.wpMatch=0,_this.matchText=['ไม่เหมาะสม','เหมาะสมเพียงเล็กน้อย','ค่อนข้างเหมาะสม','เหมาะสม','เหมาะสมมากที่สุด'],_this.cogMatchText=[['ไม่เหมาะสม โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการอย่างมาก','ไม่เหมาะสม โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการอย่างมาก'],['มีความเหมาะสมเพียงเล็กน้อย โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการพอสมควร','มีความเหมาะสมเพียงเล็กน้อย โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการพอสมควร'],['ค่อนข้างเหมาะสม โดยท่านมีความสามารถในการเรียนรู้ต่ำกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการเล็กน้อย','ค่อนข้างเหมาะสม โดยท่านมีความสามารถในการเรียนรู้สูงกว่าค่าเฉลี่ยที่คณะ/สาขาต้องการเล็กน้อย'],['มีความเหมาะสม เมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ'],['มีความเหมาะสมมากที่สุด เมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ']],_this.ssMatchText=['ไม่เหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีไม่สอดคล้องกับชุดทักษะของผู้ที่ประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวโดยสิ้นเชิง ','มีความเหมาะสมเพียงเล็กน้อยเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีไม่ค่อยสอดคล้องกับชุดทักษะของผู้ที่ประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวมากนัก ','ค่อนข้างเหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีน่าจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวพอสมควร','มีความเหมาะสมเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวได้','มีความเหมาะสมมากที่สุดเมื่อเปรียบเทียบกับระดับที่คณะ/สาขาต้องการ โดยทักษะในการปฏิบัติงานที่ท่านมีจะมีส่วนส่งเสริมให้ท่านประสบความสำเร็จในการเรียนและการประกอบอาชีพในสายงานดังกล่าวอย่างมีนัยสำคัญ'],_this.wpMatchText=['ไม่เหมาะสม ท่านอาจรู้สึกไม่มีความสุขกับการเรียนและการทำงานในสายงานนี้อยู่บ่อยครั้ง','มีความเหมาะสมเพียงเล็กน้อย ท่านอาจรู้สึกไม่มีความสุขกับการเรียนและการทำงานในสายงานนี้ในบางครั้ง','ค่อนข้างเหมาะสม ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าวพอสมควร','มีความเหมาะสม ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าว','มีความเหมาะสมมากที่สุด ท่านมีแนวโน้มจะมีความสุขกับการเรียนและการทำงานในสายงานดังกล่าวอย่างมาก '],_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MainContainer,[{key:'getCogMatchText',value:function getCogMatchText(score,jobScore,matchingScore){var level=this.getLevel(matchingScore);if(level<3){if(score<jobScore){//console.log(this.cogMatchText[level])
return this.cogMatchText[level][0];}else{//console.log(this.cogMatchText[level])
return this.cogMatchText[level][1];}}else{return this.cogMatchText[level];}}},{key:'getLevel',value:function getLevel(score){if(score<=50){return 0;}else if(score<=62.5){return 1;}else if(score<=75){return 2;}else if(score<=87.5){return 3;}else{return 4;}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){//console.log(nextProps)
if(!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(nextProps.profile)){if(!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(nextProps.profile.jobs)){this.setState({jobsCount:Object.keys(nextProps.profile.jobs).length});}else{this.setState({jobsCount:0});}}this.forceUpdate();}},{key:'componentDidMount',value:function componentDidMount(){if(!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile)){if(!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.jobs))this.setState({jobsCount:Object.keys(this.props.profile.jobs).length});}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Grid___default.a,{container:true,style:{marginTop:"8px"},className:this.props.classes.centerGrid,spacing:0},!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile)&&this.props.profile.currentTest!=='finished'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.jobs)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_List___default.a,null,Object.keys(this.props.profile.jobs).map(function(jobId,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_List__["ListItem"],null,Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(_this2.props.profile.currentTest)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Avatar___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_icons_HighlightOff___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__search_action__["b" /* jobSearchDelete */])(jobId,_this2.props.profile.jobs));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_List__["ListItemText"],{primary:_this2.props.profile.jobs[jobId].name+' - '+_this2.props.profile.jobs[jobId].department,secondary:_this2.props.profile.jobs[jobId].faculty+' - '+_this2.props.profile.jobs[jobId].university})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Divider___default.a,{inset:true})));})),!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile)&&Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.type)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a//disabled={this.state.jobsCount >= 3 || this.props.profile.type === undefined}
,{variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/profile'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27'))),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.currentTest)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,{disabled:this.state.jobsCount>=3||this.props.profile.type===undefined,variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/search'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E13\u0E30\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E43\u0E08'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,className:this.props.classes.formControl},this.props.profile.currentIndex===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,{disabled:this.state.jobsCount<1,variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__action__["c" /* testStart */])());}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default.a,{disabled:this.state.jobsCount<1,variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8_react_router_redux__["push"])('/test'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E15\u0E48\u0E2D'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.currentTest)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{type:'caption',style:{margin:'16px'}},'\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E32\u0E02\u0E32\u0E27\u0E34\u0E0A\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E43\u0E08\u0E44\u0E14\u0E49 3 \u0E2A\u0E32\u0E02\u0E32',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E32\u0E02\u0E32\u0E27\u0E34\u0E0A\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E14\u0E49')):!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile)?!Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["isEmpty"])(this.props.profile.matching)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,Object.keys(this.props.profile.matching).map(function(jobId,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card___default.a,{style:{display:'flex',marginBottom:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card__["CardMedia"],{style:{width:'50px',height:'59px',marginLeft:'8px',marginTop:'8px',paddingLeft:'16px',paddingRight:'16px'},image:'https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2F%E0%B8%A3%E0%B8%B0%E0%B8%94%E0%B8%B1%E0%B8%9A%E0%B8%94%E0%B8%B2%E0%B8%A7-0'+(_this2.matchLevel=_this2.getLevel(_this2.props.profile.matching[jobId].totalMatch))+'.png?alt=media',title:_this2.props.profile.jobs[jobId].image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card__["CardMedia"],{style:{width:'151px',height:'151px'},image:'https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/images%2Fjobs%2F'+_this2.props.profile.jobs[jobId].image+'.png?alt=media',title:_this2.props.profile.jobs[jobId].image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'headline'},_this2.props.profile.jobs[jobId].name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'caption',color:'textSecondary'},_this2.props.profile.jobs[jobId].department),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'caption',color:'textSecondary'},_this2.props.profile.jobs[jobId].faculty+' - '+_this2.props.profile.jobs[jobId].university),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'headline',color:'primary'},_this2.matchText[_this2.matchLevel]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'title',color:'primary'},Math.floor(_this2.props.profile.matching[jobId].totalMatch)+'%')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Divider___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'column'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_material_ui_Card__["CardContent"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_material_ui_icons_Extension___default.a,{style:{marginRight:'8px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'body1'},'\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E19\u0E04\u0E13\u0E30/\u0E2A\u0E32\u0E02\u0E32\u0E19\u0E35\u0E49 '+(_this2.cognitiveMatch=Math.floor(_this2.props.profile.matching[jobId].cognitiveMatch))+'%\n                                            \u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32 '+_this2.getCogMatchText(_this2.cognitiveMatch,_this2.props.profile.jobs[jobId].ZCOG,_this2.cognitiveMatch))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_material_ui_icons_InsertEmoticon___default.a,{style:{marginRight:'8px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'body1'},'\u0E17\u0E31\u0E01\u0E29\u0E30\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E19\u0E04\u0E13\u0E30/\u0E2A\u0E32\u0E02\u0E32\u0E19\u0E35\u0E49 '+(_this2.softskillsMatch=Math.floor(_this2.props.profile.matching[jobId].softskillsMatch))+'%\n                                            \u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32 '+_this2.ssMatchText[_this2.getLevel(_this2.softskillsMatch)])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_material_ui_icons_Work___default.a,{style:{marginRight:'8px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_material_ui_Typography___default.a,{variant:'body1',component:'p'},'\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E19\u0E43\u0E08\u0E43\u0E19\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E19\u0E04\u0E13\u0E30/\u0E2A\u0E32\u0E02\u0E32\u0E19\u0E35\u0E49 '+(_this2.wpMatch=Math.floor(_this2.props.profile.matching[jobId].wpMatch))+'%\n                                            \u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32 '+_this2.wpMatchText[_this2.getLevel(_this2.wpMatch)])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_share__["b" /* FacebookShareButton */],{quote:'\u0E04\u0E38\u0E13\u0E2A\u0E21\u0E1A\u0E31\u0E15\u0E34\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E01\u0E31\u0E1A '+_this2.props.profile.jobs[jobId].name+' '+Math.floor(_this2.props.profile.matching[jobId].totalMatch)+'%',url:'https://mycareer.ai/',children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'\u0E41\u0E0A\u0E23\u0E4C\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_share__["a" /* FacebookIcon */],{size:32}))}))))))));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_material_ui_Progress__["LinearProgress"],{style:{width:'350px',marginBottom:'100px',marginTop:'100px'},color:'secondary',variant:'indeterminate'})));}}]);return MainContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_5_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function(_ref2){var profile=_ref2.firebase.profile;return{profile:profile};}))(MainContainer));

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(63);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(14);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.button, {
      lineHeight: '1.4em', // Improve readability for multiline button.
      boxSizing: 'border-box',
      minWidth: theme.spacing.unit * 11,
      minHeight: 36,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 2 + 'px',
      borderRadius: 2,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        // Reset on mouse devices
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.12),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),
    label: {
      width: '100%',
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },
    flatPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    flatSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.12),
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    colorInherit: {
      color: 'inherit'
    },
    raised: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&$keyboardFocused': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      }
    },
    keyboardFocused: {},
    raisedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    raisedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on mouse devices
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    fab: {
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      fontSize: 24,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      }
    },
    mini: {
      width: 40,
      height: 40
    },
    sizeSmall: {
      padding: theme.spacing.unit - 1 + 'px ' + theme.spacing.unit + 'px',
      minWidth: theme.spacing.unit * 8,
      minHeight: 32,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
    },
    sizeLarge: {
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px',
      minWidth: theme.spacing.unit * 14,
      minHeight: 40,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize + 1)
    },
    fullWidth: {
      width: '100%'
    }
  };
};

function Button(props) {
  var _classNames;

  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      disabled = props.disabled,
      disableFocusRipple = props.disableFocusRipple,
      fullWidth = props.fullWidth,
      mini = props.mini,
      size = props.size,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled', 'disableFocusRipple', 'fullWidth', 'mini', 'size', 'variant']);


  var fab = variant === 'fab';
  var raised = variant === 'raised';
  var flat = !raised && !fab;
  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.raised, raised || fab), (0, _defineProperty3.default)(_classNames, classes.fab, fab), (0, _defineProperty3.default)(_classNames, classes.mini, fab && mini), (0, _defineProperty3.default)(_classNames, classes.colorInherit, color === 'inherit'), (0, _defineProperty3.default)(_classNames, classes.flatPrimary, flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.flatSecondary, flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes.raisedPrimary, !flat && color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.raisedSecondary, !flat && color === 'secondary'), (0, _defineProperty3.default)(_classNames, classes['size' + (0, _helpers.capitalize)(size)], size !== 'medium'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames), classNameProp);

  var children = childrenProp;

  if (fab) {
    children = _react2.default.Children.map(children, function (child) {
      if ((0, _reactHelpers.isMuiElement)(child, ['Icon', 'SvgIcon'])) {
        return _react2.default.cloneElement(child, { fontSize: true });
      }
      return child;
    });
  }

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: className,
      disabled: disabled,
      focusRipple: !disableFocusRipple,
      keyboardFocusedClassName: classes.keyboardFocused
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      children
    )
  );
}

Button.propTypes =  false ? {
  /**
   * The content of the button.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes2.default.string,
  /**
   * If `true`, and `fab` is `true`, will use mini floating action button styling.
   */
  mini: _propTypes2.default.bool,
  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  /**
   * @ignore
   */
  type: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  variant: _propTypes2.default.oneOf(['flat', 'raised', 'fab'])
} : {};

Button.defaultProps = {
  color: 'default',
  disabled: false,
  disableFocusRipple: false,
  disableRipple: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  type: 'button',
  variant: 'flat'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButton' })(Button);

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _ownerWindow = __webpack_require__(290);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _keyboardFocus = __webpack_require__(564);

var _TouchRipple = __webpack_require__(565);

var _TouchRipple2 = _interopRequireDefault(_TouchRipple);

var _createRippleHandler = __webpack_require__(575);

var _createRippleHandler2 = _interopRequireDefault(_createRippleHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent', // Reset default value
    outline: 'none',
    border: 0,
    margin: 0, // Remove the margin in Safari
    borderRadius: 0,
    padding: 0, // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none', // Reset
    '-webkit-appearance': 'none', // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    }
  },
  disabled: {
    pointerEvents: 'none', // Disable link interactions
    cursor: 'default'
  }
};

// Don't automatically add the role="button" property on these components.
// It's invalid HTML syntax.
var INVALID_COMPONENT_ROLE = ['a'];

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = function (_React$Component) {
  (0, _inherits3.default)(ButtonBase, _React$Component);

  function ButtonBase() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonBase.__proto__ || (0, _getPrototypeOf2.default)(ButtonBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      keyboardFocused: false
    }, _this.onKeyboardFocusHandler = function (event) {
      _this.keyDown = false;
      _this.setState({ keyboardFocused: true });

      if (_this.props.onKeyboardFocus) {
        _this.props.onKeyboardFocus(event);
      }
    }, _this.onRippleRef = function (node) {
      _this.ripple = node;
    }, _this.ripple = null, _this.keyDown = false, _this.button = null, _this.keyboardFocusTimeout = null, _this.keyboardFocusCheckTime = 50, _this.keyboardFocusMaxCheckTimes = 5, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          component = _this$props.component,
          focusRipple = _this$props.focusRipple,
          onKeyDown = _this$props.onKeyDown,
          onClick = _this$props.onClick;

      var key = (0, _keycode2.default)(event);

      // Check if key is already down to avoid repeats being counted as multiple activations
      if (focusRipple && !_this.keyDown && _this.state.keyboardFocused && _this.ripple && key === 'space') {
        _this.keyDown = true;
        event.persist();
        _this.ripple.stop(event, function () {
          _this.ripple.start(event);
        });
      }

      if (onKeyDown) {
        onKeyDown(event);
      }

      // Keyboard accessibility for non interactive elements
      if (event.target === _this.button && onClick && component && component !== 'a' && component !== 'button' && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      }
    }, _this.handleKeyUp = function (event) {
      if (_this.props.focusRipple && (0, _keycode2.default)(event) === 'space' && _this.ripple && _this.state.keyboardFocused) {
        _this.keyDown = false;
        event.persist();
        _this.ripple.stop(event, function () {
          return _this.ripple.pulsate(event);
        });
      }
      if (_this.props.onKeyUp) {
        _this.props.onKeyUp(event);
      }
    }, _this.handleMouseDown = (0, _createRippleHandler2.default)(_this, 'MouseDown', 'start', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      if (_this.state.keyboardFocused) {
        _this.setState({ keyboardFocused: false });
      }
    }), _this.handleMouseUp = (0, _createRippleHandler2.default)(_this, 'MouseUp', 'stop'), _this.handleMouseLeave = (0, _createRippleHandler2.default)(_this, 'MouseLeave', 'stop', function (event) {
      if (_this.state.keyboardFocused) {
        event.preventDefault();
      }
    }), _this.handleTouchStart = (0, _createRippleHandler2.default)(_this, 'TouchStart', 'start'), _this.handleTouchEnd = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleTouchMove = (0, _createRippleHandler2.default)(_this, 'TouchEnd', 'stop'), _this.handleBlur = (0, _createRippleHandler2.default)(_this, 'Blur', 'stop', function () {
      clearTimeout(_this.keyboardFocusTimeout);
      (0, _keyboardFocus.focusKeyPressed)(false);
      _this.setState({ keyboardFocused: false });
    }), _this.handleFocus = function (event) {
      if (_this.props.disabled) {
        return;
      }

      // Fix for https://github.com/facebook/react/issues/7769
      if (!_this.button) {
        _this.button = event.currentTarget;
      }

      event.persist();
      (0, _keyboardFocus.detectKeyboardFocus)(_this, _this.button, function () {
        _this.onKeyboardFocusHandler(event);
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.button = (0, _reactDom.findDOMNode)(this);
      (0, _keyboardFocus.listenForFocusKeys)((0, _ownerWindow2.default)(this.button));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // The blur won't fire when the disabled state is set on a focused input.
      // We need to book keep the focused state manually.
      if (!this.props.disabled && nextProps.disabled && this.state.keyboardFocused) {
        this.setState({
          keyboardFocused: false
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (this.props.focusRipple && nextState.keyboardFocused && !this.state.keyboardFocused && !this.props.disableRipple) {
        this.ripple.pulsate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.button = null;
      clearTimeout(this.keyboardFocusTimeout);
    } // Used to help track keyboard activation keyDown

  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          buttonRef = _props.buttonRef,
          centerRipple = _props.centerRipple,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          component = _props.component,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          focusRipple = _props.focusRipple,
          keyboardFocusedClassName = _props.keyboardFocusedClassName,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus,
          onKeyboardFocus = _props.onKeyboardFocus,
          onKeyDown = _props.onKeyDown,
          onKeyUp = _props.onKeyUp,
          onMouseDown = _props.onMouseDown,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onTouchEnd = _props.onTouchEnd,
          onTouchMove = _props.onTouchMove,
          onTouchStart = _props.onTouchStart,
          tabIndex = _props.tabIndex,
          type = _props.type,
          other = (0, _objectWithoutProperties3.default)(_props, ['buttonRef', 'centerRipple', 'children', 'classes', 'className', 'component', 'disabled', 'disableRipple', 'focusRipple', 'keyboardFocusedClassName', 'onBlur', 'onFocus', 'onKeyboardFocus', 'onKeyDown', 'onKeyUp', 'onMouseDown', 'onMouseLeave', 'onMouseUp', 'onTouchEnd', 'onTouchMove', 'onTouchStart', 'tabIndex', 'type']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, keyboardFocusedClassName || '', this.state.keyboardFocused), _classNames), classNameProp);

      var buttonProps = {};

      var ComponentProp = component;

      if (!ComponentProp) {
        if (other.href) {
          ComponentProp = 'a';
        } else {
          ComponentProp = 'button';
        }
      }

      if (ComponentProp === 'button') {
        buttonProps.type = type || 'button';
        buttonProps.disabled = disabled;
      } else if (INVALID_COMPONENT_ROLE.indexOf(ComponentProp) === -1) {
        buttonProps.role = 'button';
      }

      return _react2.default.createElement(
        ComponentProp,
        (0, _extends3.default)({
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          onMouseDown: this.handleMouseDown,
          onMouseLeave: this.handleMouseLeave,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleTouchEnd,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          tabIndex: disabled ? -1 : tabIndex,
          className: className,
          ref: buttonRef
        }, buttonProps, other),
        children,
        !disableRipple && !disabled ? _react2.default.createElement(_TouchRipple2.default, { innerRef: this.onRippleRef, center: centerRipple }) : null
      );
    }
  }]);
  return ButtonBase;
}(_react2.default.Component);

ButtonBase.propTypes =  false ? {
  /**
   * Use that property to pass a ref callback to the native button component.
   */
  buttonRef: _propTypes2.default.func,
  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * The default value is a `button`.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the base button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: _propTypes2.default.bool,
  /**
   * The CSS class applied while the component is keyboard focused.
   */
  keyboardFocusedClassName: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onKeyboardFocus: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  type: _propTypes2.default.string
} : {};

ButtonBase.defaultProps = {
  centerRipple: false,
  disableRipple: false,
  focusRipple: false,
  tabIndex: 0,
  type: 'button'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiButtonBase' })(ButtonBase);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusKeyPressed = focusKeyPressed;
exports.detectKeyboardFocus = detectKeyboardFocus;
exports.listenForFocusKeys = listenForFocusKeys;

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(130);

var _contains2 = _interopRequireDefault(_contains);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak

var internal = {
  focusKeyPressed: false
};

function focusKeyPressed(pressed) {
  if (typeof pressed !== 'undefined') {
    internal.focusKeyPressed = Boolean(pressed);
  }

  return internal.focusKeyPressed;
}

function detectKeyboardFocus(instance, element, callback) {
  var attempt = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

   false ? (0, _warning2.default)(instance.keyboardFocusCheckTime, 'Material-UI: missing instance.keyboardFocusCheckTime') : void 0;
   false ? (0, _warning2.default)(instance.keyboardFocusMaxCheckTimes, 'Material-UI: missing instance.keyboardFocusMaxCheckTimes') : void 0;

  instance.keyboardFocusTimeout = setTimeout(function () {
    var doc = (0, _ownerDocument2.default)(element);

    if (focusKeyPressed() && (doc.activeElement === element || (0, _contains2.default)(element, doc.activeElement))) {
      callback();
    } else if (attempt < instance.keyboardFocusMaxCheckTimes) {
      detectKeyboardFocus(instance, element, callback, attempt + 1);
    }
  }, instance.keyboardFocusCheckTime);
}

var FOCUS_KEYS = ['tab', 'enter', 'space', 'esc', 'up', 'down', 'left', 'right'];

function isFocusKey(event) {
  return FOCUS_KEYS.indexOf((0, _keycode2.default)(event)) !== -1;
}

var handleKeyUpEvent = function handleKeyUpEvent(event) {
  if (isFocusKey(event)) {
    internal.focusKeyPressed = true;
  }
};

function listenForFocusKeys(win) {
  // The event listener will only be added once per window.
  // Duplicate event listeners will be ignored by addEventListener.
  // Also, this logic is client side only, we don't need a teardown.
  win.addEventListener('keyup', handleKeyUpEvent);
}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.DELAY_RIPPLE = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _TransitionGroup = __webpack_require__(571);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Ripple = __webpack_require__(573);

var _Ripple2 = _interopRequireDefault(_Ripple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DURATION = 550;
var DELAY_RIPPLE = exports.DELAY_RIPPLE = 80;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'block',
      position: 'absolute',
      overflow: 'hidden',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      zIndex: 0
    },
    wrapper: {
      opacity: 1
    },
    wrapperLeaving: {
      opacity: 0,
      animation: 'mui-ripple-exit ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    wrapperPulsating: {
      position: 'absolute',
      left: 0,
      top: 0,
      display: 'block',
      width: '100%',
      height: '100%',
      animation: 'mui-ripple-pulsate 2500ms ' + theme.transitions.easing.easeInOut + ' 200ms infinite'
    },
    '@keyframes mui-ripple-enter': {
      '0%': {
        transform: 'scale(0)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    '@keyframes mui-ripple-exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes mui-ripple-pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    ripple: {
      width: 50,
      height: 50,
      left: 0,
      top: 0,
      opacity: 0,
      position: 'absolute',
      borderRadius: '50%',
      background: 'currentColor'
    },
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: 'mui-ripple-enter ' + DURATION + 'ms ' + theme.transitions.easing.easeInOut
    },
    rippleFast: {
      animationDuration: '200ms'
    }
  };
};

/**
 * @ignore - internal component.
 */

var TouchRipple = function (_React$Component) {
  (0, _inherits3.default)(TouchRipple, _React$Component);

  function TouchRipple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TouchRipple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextKey: 0,
      ripples: []
    }, _this.ignoringMouseDown = false, _this.startTimer = null, _this.startTimerCommit = null, _this.pulsate = function () {
      _this.start({}, { pulsate: true });
    }, _this.start = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments[2];
      var _options$pulsate = options.pulsate,
          pulsate = _options$pulsate === undefined ? false : _options$pulsate,
          _options$center = options.center,
          center = _options$center === undefined ? _this.props.center || options.pulsate : _options$center,
          _options$fakeElement = options.fakeElement,
          fakeElement = _options$fakeElement === undefined ? false : _options$fakeElement;


      if (event.type === 'mousedown' && _this.ignoringMouseDown) {
        _this.ignoringMouseDown = false;
        return;
      }

      if (event.type === 'touchstart') {
        _this.ignoringMouseDown = true;
      }

      var element = fakeElement ? null : _reactDom2.default.findDOMNode(_this);
      var rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      };

      // Get the size of the ripple
      var rippleX = void 0;
      var rippleY = void 0;
      var rippleSize = void 0;

      if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
      } else {
        var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
        var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
      }

      if (center) {
        rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);

        // For some reason the animation is broken on Mobile Chrome if the size if even.
        if (rippleSize % 2 === 0) {
          rippleSize += 1;
        }
      } else {
        var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
      }

      // Touche devices
      if (event.touches) {
        // Prepare the ripple effect.
        _this.startTimerCommit = function () {
          _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
        };
        // Deplay the execution of the ripple effect.
        _this.startTimer = setTimeout(function () {
          _this.startTimerCommit();
          _this.startTimerCommit = null;
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      } else {
        _this.startCommit({ pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb });
      }
    }, _this.startCommit = function (params) {
      var pulsate = params.pulsate,
          rippleX = params.rippleX,
          rippleY = params.rippleY,
          rippleSize = params.rippleSize,
          cb = params.cb;

      var ripples = _this.state.ripples;

      // Add a ripple to the ripples array.
      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_Ripple2.default, {
        key: _this.state.nextKey,
        classes: _this.props.classes,
        timeout: {
          exit: DURATION,
          enter: DURATION
        },
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);

      _this.setState({
        nextKey: _this.state.nextKey + 1,
        ripples: ripples
      }, cb);
    }, _this.stop = function (event, cb) {
      clearTimeout(_this.startTimer);
      var ripples = _this.state.ripples;

      // The touch interaction occures to quickly.
      // We still want to show ripple effect.

      if (event.type === 'touchend' && _this.startTimerCommit) {
        event.persist();
        _this.startTimerCommit();
        _this.startTimerCommit = null;
        _this.startTimer = setTimeout(function () {
          _this.stop(event, cb);
        }, 0);
        return;
      }

      _this.startTimerCommit = null;

      if (ripples && ripples.length) {
        _this.setState({
          ripples: ripples.slice(1)
        }, cb);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TouchRipple, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.startTimer);
    }

    // Used to filter out mouse emulated events on mobile.

    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.

    // This is the hook called once the previous timeout is ready.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          center = _props.center,
          classes = _props.classes,
          className = _props.className,
          other = (0, _objectWithoutProperties3.default)(_props, ['center', 'classes', 'className']);


      return _react2.default.createElement(
        _TransitionGroup2.default,
        (0, _extends3.default)({
          component: 'span',
          enter: true,
          exit: true,
          className: (0, _classnames2.default)(classes.root, className)
        }, other),
        this.state.ripples
      );
    }
  }]);
  return TouchRipple;
}(_react2.default.Component);

TouchRipple.propTypes =  false ? {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

TouchRipple.defaultProps = {
  center: false
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiTouchRipple' })(TouchRipple);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(567), __esModule: true };

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(181);
__webpack_require__(568);
module.exports = __webpack_require__(21).Array.from;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(59);
var $export = __webpack_require__(26);
var toObject = __webpack_require__(75);
var call = __webpack_require__(282);
var isArrayIter = __webpack_require__(283);
var toLength = __webpack_require__(120);
var createProperty = __webpack_require__(569);
var getIterFn = __webpack_require__(284);

$export($export.S + $export.F * !__webpack_require__(570)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(38);
var createDesc = __webpack_require__(91);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(34)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var Ripple = function (_React$Component) {
  (0, _inherits3.default)(Ripple, _React$Component);

  function Ripple() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Ripple);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ripple.__proto__ || (0, _getPrototypeOf2.default)(Ripple)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      rippleVisible: false,
      rippleLeaving: false
    }, _this.handleEnter = function () {
      _this.setState({
        rippleVisible: true
      });
    }, _this.handleExit = function () {
      _this.setState({
        rippleLeaving: true
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Ripple, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          pulsate = _props.pulsate,
          rippleX = _props.rippleX,
          rippleY = _props.rippleY,
          rippleSize = _props.rippleSize,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'pulsate', 'rippleX', 'rippleY', 'rippleSize']);
      var _state = this.state,
          rippleVisible = _state.rippleVisible,
          rippleLeaving = _state.rippleLeaving;


      var className = (0, _classnames2.default)(classes.wrapper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.wrapperLeaving, rippleLeaving), (0, _defineProperty3.default)(_classNames, classes.wrapperPulsating, pulsate), _classNames), classNameProp);

      var rippleClassName = (0, _classnames2.default)(classes.ripple, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.rippleVisible, rippleVisible), (0, _defineProperty3.default)(_classNames2, classes.rippleFast, pulsate), _classNames2));

      var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
      };

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ onEnter: this.handleEnter, onExit: this.handleExit }, other),
        _react2.default.createElement(
          'span',
          { className: className },
          _react2.default.createElement('span', { className: rippleClassName, style: rippleStyles })
        )
      );
    }
  }]);
  return Ripple;
}(_react2.default.Component);

Ripple.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes2.default.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes2.default.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes2.default.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes2.default.number
} : {};

Ripple.defaultProps = {
  pulsate: false
};

exports.default = Ripple;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function createRippleHandler(instance, eventName, action, cb) {
  return function handleEvent(event) {
    if (cb) {
      cb.call(instance, event);
    }

    if (event.defaultPrevented) {
      return false;
    }

    if (instance.ripple) {
      instance.ripple[action](event);
    }

    if (instance.props && typeof instance.props['on' + eventName] === 'function') {
      instance.props['on' + eventName](event);
    }

    return true;
  };
}

exports.default = createRippleHandler;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventsFromInput = exports.pathStrToObj = undefined;

var _remove2 = __webpack_require__(579);

var _remove3 = _interopRequireDefault(_remove2);

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _isObject2 = __webpack_require__(17);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _flatMap2 = __webpack_require__(635);

var _flatMap3 = _interopRequireDefault(_flatMap2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _populate = __webpack_require__(143);

var _query = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathStrToObj = exports.pathStrToObj = function pathStrToObj(path) {
  var pathObj = { path: path, type: 'value', isQuery: false };
  var queryId = (0, _query.getQueryIdFromPath)(path);

  if (queryId) {
    var pathArray = path.split('#');
    pathObj = _extends({}, pathObj, {
      queryId: queryId,
      isQuery: true,
      path: pathArray[0],
      queryParams: pathArray[1].split('&')
    });
    if ((0, _populate.getPopulates)(pathArray[1].split('&'))) {
      pathObj.populates = (0, _populate.getPopulates)(pathArray[1].split('&'));
      pathObj.queryParams = (0, _remove3.default)(pathArray[1].split('&'), function (p) {
        return p.indexOf('populate') === -1;
      });
    }
  }

  return pathObj;
};

var getEventsFromInput = exports.getEventsFromInput = function getEventsFromInput(paths) {
  return (0, _flatMap3.default)(paths, function (path) {
    if ((0, _isString3.default)(path)) {
      return [pathStrToObj(path)];
    }

    if ((0, _isArray3.default)(path)) {
      return [{ type: 'first_child', path: path[0] }, { type: 'child_added', path: path[0] }, { type: 'child_removed', path: path[0] }, { type: 'child_moved', path: path[0] }, { type: 'child_changed', path: path[0] }];
    }

    if ((0, _isObject3.default)(path)) {
      if (!path.path) {
        throw new Error('Path is a required parameter within definition object');
      }
      var strPath = path.path;

      if (path.storeAs) {
        strPath += '@' + path.storeAs;
      }

      if (path.queryParams) {
        strPath += '#' + path.queryParams.join('&');
      }

      path = _extends({}, pathStrToObj(strPath), path);
      return [path];
    }

    throw new Error('Invalid Path Definition: ' + path + '. Only strings, objects, and arrays accepted.');
  });
};

exports.default = { getEventsFromInput: getEventsFromInput };

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    basePullAt = __webpack_require__(633);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(581),
    getMatchData = __webpack_require__(625),
    matchesStrictComparable = __webpack_require__(305);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(131),
    baseIsEqual = __webpack_require__(190);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(133);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(133);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(133);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(133);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(132);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 588 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 589 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 590 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(132),
    Map = __webpack_require__(188),
    MapCache = __webpack_require__(189);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(40),
    isMasked = __webpack_require__(593),
    isObject = __webpack_require__(17),
    toSource = __webpack_require__(293);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(594);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 595 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(597),
    ListCache = __webpack_require__(132),
    Map = __webpack_require__(188);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(598),
    hashDelete = __webpack_require__(599),
    hashGet = __webpack_require__(600),
    hashHas = __webpack_require__(601),
    hashSet = __webpack_require__(602);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(134);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(134);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(134);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(134);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(135);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(135);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(135);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(135);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(131),
    equalArrays = __webpack_require__(294),
    equalByTag = __webpack_require__(613),
    equalObjects = __webpack_require__(616),
    getTag = __webpack_require__(83),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(137),
    isTypedArray = __webpack_require__(193);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(189),
    setCacheAdd = __webpack_require__(610),
    setCacheHas = __webpack_require__(611);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 610 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    Uint8Array = __webpack_require__(296),
    eq = __webpack_require__(101),
    equalArrays = __webpack_require__(294),
    mapToArray = __webpack_require__(614),
    setToArray = __webpack_require__(615);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 614 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 615 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(297);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 619 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isLength = __webpack_require__(194),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(302);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(65),
    root = __webpack_require__(22);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(304),
    keys = __webpack_require__(81);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(190),
    get = __webpack_require__(102),
    hasIn = __webpack_require__(307),
    isKey = __webpack_require__(198),
    isStrictComparable = __webpack_require__(304),
    matchesStrictComparable = __webpack_require__(305),
    toKey = __webpack_require__(66);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(628);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(189);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    arrayMap = __webpack_require__(141),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(103);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(309),
    basePropertyDeep = __webpack_require__(632),
    isKey = __webpack_require__(198),
    toKey = __webpack_require__(66);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(140);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(199),
    isIndex = __webpack_require__(82);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(140),
    baseSlice = __webpack_require__(311);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(312),
    map = __webpack_require__(142);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    isArguments = __webpack_require__(136),
    isArray = __webpack_require__(13);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(85),
    isArrayLike = __webpack_require__(56);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 638 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(56);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(85);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 641 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(105);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(299),
    baseFilter = __webpack_require__(644),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(85);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(646),
    hasUnicode = __webpack_require__(204),
    unicodeSize = __webpack_require__(647);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(309);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(649);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signInWithPhoneNumber = exports.linkWithCredential = exports.reloadAuth = exports.updateEmail = exports.updateAuth = exports.updateProfile = exports.verifyPasswordResetCode = exports.confirmPasswordReset = exports.resetPassword = exports.createUser = exports.logout = exports.login = exports.init = exports.handleRedirectResult = exports.createUserProfile = exports.watchUserProfile = exports.handleProfileWatchResponse = exports.unWatchUserProfile = undefined;

var _omit2 = __webpack_require__(323);

var _omit3 = _interopRequireDefault(_omit2);

var _forEach2 = __webpack_require__(202);

var _forEach3 = _interopRequireDefault(_forEach2);

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isString2 = __webpack_require__(67);

var _isString3 = _interopRequireDefault(_isString2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(49);

var _helpers = __webpack_require__(332);

var _auth = __webpack_require__(217);

var _populate = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var dispatchLoginError = function dispatchLoginError(dispatch, authError) {
  return dispatch({
    type: _constants.actionTypes.LOGIN_ERROR,
    authError: authError
  });
};

var unWatchUserProfile = exports.unWatchUserProfile = function unWatchUserProfile(firebase) {
  var _firebase$_ = firebase._,
      authUid = _firebase$_.authUid,
      _firebase$_$config = _firebase$_.config,
      userProfile = _firebase$_$config.userProfile,
      useFirestoreForProfile = _firebase$_$config.useFirestoreForProfile;

  if (firebase._.profileWatch) {
    if (useFirestoreForProfile && firebase.firestore) {
      firebase._.profileWatch();
    } else {
      firebase.database().ref().child(userProfile + '/' + authUid).off('value', firebase._.profileWatch);
    }
    firebase._.profileWatch = null;
  }
};

var getProfileFromSnap = function getProfileFromSnap(snap) {
  if (snap && snap.val) {
    return snap.val();
  }

  if (snap && snap.data && snap.exists) {
    return snap.data();
  }
  return null;
};

var handleProfileWatchResponse = exports.handleProfileWatchResponse = function handleProfileWatchResponse(dispatch, firebase, userProfileSnap) {
  var _firebase$_$config2 = firebase._.config,
      profileParamsToPopulate = _firebase$_$config2.profileParamsToPopulate,
      autoPopulateProfile = _firebase$_$config2.autoPopulateProfile,
      useFirestoreForProfile = _firebase$_$config2.useFirestoreForProfile;

  var profile = getProfileFromSnap(userProfileSnap);
  if (!profileParamsToPopulate || useFirestoreForProfile || !(0, _isArray3.default)(profileParamsToPopulate) && !(0, _isString3.default)(profileParamsToPopulate)) {
    if (useFirestoreForProfile && profileParamsToPopulate) {
      console.warn('Profile population is not yet supported for Firestore');
    }
    dispatch({ type: _constants.actionTypes.SET_PROFILE, profile: profile });
  } else {
    (0, _populate.promisesForPopulate)(firebase, userProfileSnap.key, profile, profileParamsToPopulate).then(function (data) {
      (0, _forEach3.default)(data, function (result, path) {
        dispatch({
          type: _constants.actionTypes.SET,
          path: path,
          data: result,
          timestamp: Date.now(),
          requesting: false,
          requested: true
        });
      });
      if (!autoPopulateProfile) {
        dispatch({ type: _constants.actionTypes.SET_PROFILE, profile: profile });
      } else {
        var populates = (0, _populate.getPopulateObjs)(profileParamsToPopulate);
        var _profile = userProfileSnap.val();
        dispatch({
          type: _constants.actionTypes.SET_PROFILE,
          profile: (0, _helpers.populate)({ profile: _profile, data: data }, 'profile', populates)
        });
      }
    }).catch(function (err) {
      dispatch({
        type: _constants.actionTypes.UNAUTHORIZED_ERROR,
        authError: 'Error during profile population: ' + err.message
      });

      dispatch({ type: _constants.actionTypes.SET_PROFILE, profile: profile });
    });
  }
};

var watchUserProfile = exports.watchUserProfile = function watchUserProfile(dispatch, firebase) {
  var _firebase$_2 = firebase._,
      authUid = _firebase$_2.authUid,
      _firebase$_2$config = _firebase$_2.config,
      userProfile = _firebase$_2$config.userProfile,
      useFirestoreForProfile = _firebase$_2$config.useFirestoreForProfile;

  unWatchUserProfile(firebase);

  if (userProfile) {
    if (useFirestoreForProfile && firebase.firestore) {
      firebase._.profileWatch = firebase.firestore().collection(userProfile).doc(authUid).onSnapshot(function (userProfileSnap) {
        return handleProfileWatchResponse(dispatch, firebase, userProfileSnap);
      });
    } else if (firebase.database) {
      firebase._.profileWatch = firebase.database().ref().child(userProfile + '/' + authUid).on('value', function (userProfileSnap) {
        return handleProfileWatchResponse(dispatch, firebase, userProfileSnap);
      });
    } else {
      throw new Error('Real Time Database or Firestore must be included to enable user profile');
    }
  }
};

var createUserProfile = exports.createUserProfile = function createUserProfile(dispatch, firebase, userData, profile) {
  var config = firebase._.config;

  if (!config.userProfile || !firebase.database && !firebase.firestore) {
    return Promise.resolve(userData);
  }

  if ((0, _isFunction3.default)(config.profileFactory)) {
    try {
      profile = config.profileFactory(userData, profile);
    } catch (err) {
      console.error('Error occured within profileFactory function:', err.message || err);

      return Promise.reject(err);
    }
  }

  if (config.useFirestoreForProfile) {
    return firebase.firestore().collection(config.userProfile).doc(userData.uid).get().then(function (profileSnap) {
      if (!config.updateProfileOnLogin && profileSnap.exists) {
        return profileSnap.data();
      }

      var newProfile = {};

      if ((0, _isFunction3.default)(config.profileFactory)) {
        newProfile = profile;
      } else {
        var userDataObject = userData.toJSON ? userData.toJSON() : userData;

        newProfile = _extends({}, (0, _omit3.default)(userDataObject, config.keysToRemoveFromAuth), {
          avatarUrl: userDataObject.photoURL });
      }

      return profileSnap.ref.set(newProfile, { merge: true }).then(function () {
        return newProfile;
      });
    }).catch(function (err) {
      dispatch({ type: _constants.actionTypes.UNAUTHORIZED_ERROR, authError: err });
      return Promise.reject(err);
    });
  }

  return firebase.database().ref().child(config.userProfile + '/' + userData.uid).once('value').then(function (profileSnap) {
    return !config.updateProfileOnLogin && profileSnap.val() !== null ? profileSnap.val() : profileSnap.ref.update(profile).then(function () {
      return profile;
    });
  }).catch(function (err) {
    dispatch({ type: _constants.actionTypes.UNAUTHORIZED_ERROR, authError: err });
    return Promise.reject(err);
  });
};

var setupPresence = function setupPresence(dispatch, firebase) {
  if (!firebase.database || !firebase.database.ServerValue) {
    return;
  }
  var ref = firebase.database().ref();
  var _firebase$_3 = firebase._,
      _firebase$_3$config = _firebase$_3.config,
      presence = _firebase$_3$config.presence,
      sessions = _firebase$_3$config.sessions,
      authUid = _firebase$_3.authUid;

  var amOnline = ref.child('.info/connected');
  var onlineRef = ref.child((0, _isFunction3.default)(presence) ? presence(firebase.auth().currentUser, firebase) : presence).child(authUid);
  var sessionsRef = (0, _isFunction3.default)(sessions) ? sessions(firebase.auth().currentUser, firebase) : sessions;
  if (sessionsRef) {
    sessionsRef = ref.child(sessions);
  }
  amOnline.on('value', function (snapShot) {
    if (!snapShot.val()) return;

    if (sessionsRef) {
      dispatch({ type: _constants.actionTypes.SESSION_START, payload: authUid });

      var session = sessionsRef.push({
        startedAt: firebase.database.ServerValue.TIMESTAMP,
        user: authUid
      });

      if ((0, _isFunction3.default)(session.setPriority)) {
        session.setPriority(authUid);
      }
      session.child('endedAt').onDisconnect().set(firebase.database.ServerValue.TIMESTAMP, function () {
        dispatch({ type: _constants.actionTypes.SESSION_END });
      });
    }

    onlineRef.set(true);
    onlineRef.onDisconnect().remove();
  });
};

var handleAuthStateChange = function handleAuthStateChange(dispatch, firebase, authData) {
  var config = firebase._.config;

  if (!authData) {
    if ((0, _isFunction3.default)(config.onAuthStateChanged)) {
      firebase._.config.onAuthStateChanged(authData, firebase, dispatch);
    }
    dispatch({
      type: _constants.actionTypes.AUTH_EMPTY_CHANGE,
      preserve: config.preserveOnEmptyAuthChange
    });
  } else {
    firebase._.authUid = authData.uid;
    if (config.presence) {
      setupPresence(dispatch, firebase);
    }

    dispatch({
      type: _constants.actionTypes.LOGIN,
      auth: authData,
      preserve: config.preserveOnLogin
    });

    watchUserProfile(dispatch, firebase);

    if ((0, _isFunction3.default)(config.onAuthStateChanged)) {
      config.onAuthStateChanged(authData, firebase, dispatch);
    }
  }
};

var handleRedirectResult = exports.handleRedirectResult = function handleRedirectResult(dispatch, firebase, authData) {
  if (typeof firebase._.config.onRedirectResult === 'function') {
    firebase._.config.onRedirectResult(authData, firebase, dispatch);
  }
  if (authData && authData.user) {
    var user = authData.user;


    firebase._.authUid = user.uid;
    watchUserProfile(dispatch, firebase);

    dispatch({
      type: _constants.actionTypes.LOGIN,
      auth: user,
      preserve: firebase._.config.preserveOnLogin
    });

    createUserProfile(dispatch, firebase, user, {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    });
  }
};

var init = exports.init = function init(dispatch, firebase) {
  if (!firebase.auth) {
    return;
  }
  dispatch({ type: _constants.actionTypes.AUTHENTICATION_INIT_STARTED });

  firebase.auth().onAuthStateChanged(function (authData) {
    return handleAuthStateChange(dispatch, firebase, authData);
  });

  if (firebase._.config.enableRedirectHandling && (0, _isFunction3.default)(firebase.auth().getRedirectResult) && typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('http') !== -1) {
    firebase.auth().getRedirectResult().then(function (authData) {
      return handleRedirectResult(dispatch, firebase, authData);
    }).catch(function (error) {
      dispatchLoginError(dispatch, error);
      return Promise.reject(error);
    });
  }

  firebase.auth().currentUser;

  dispatch({ type: _constants.actionTypes.AUTHENTICATION_INIT_FINISHED });
};

var login = exports.login = function login(dispatch, firebase, credentials) {
  var _firebase$auth;

  if (firebase._.config.resetBeforeLogin) {
    dispatchLoginError(dispatch, null);
  }

  var _getLoginMethodAndPar = (0, _auth.getLoginMethodAndParams)(firebase, credentials),
      method = _getLoginMethodAndPar.method,
      params = _getLoginMethodAndPar.params;

  return (_firebase$auth = firebase.auth())[method].apply(_firebase$auth, _toConsumableArray(params)).then(function (userData) {
    if (!userData) return Promise.resolve(null);

    if (method === 'signInWithEmailAndPassword') {
      return { user: userData };
    }

    if (method === 'signInWithCustomToken') {
      if (!firebase._.config.updateProfileOnLogin) {
        return { user: userData };
      }
      return createUserProfile(dispatch, firebase, userData, credentials.profile);
    }

    if (method === 'signInWithPhoneNumber') {
      return _extends({}, userData, {
        confirm: function confirm(code) {
          return userData.confirm(code).then(function (_ref) {
            var user = _ref.user,
                additionalUserInfo = _ref.additionalUserInfo;
            return createUserProfile(dispatch, firebase, user, {
              phoneNumber: user.providerData[0].phoneNumber,
              providerData: user.providerData
            }).then(function (profile) {
              return { profile: profile, user: user, additionalUserInfo: additionalUserInfo };
            });
          });
        }
      });
    }

    var user = userData.user || userData;

    return createUserProfile(dispatch, firebase, user, {
      email: user.email,
      displayName: user.providerData[0].displayName || user.email,
      avatarUrl: user.providerData[0].photoURL,
      providerData: user.providerData
    }).then(function (profile) {
      return _extends({ profile: profile }, userData);
    });
  }).catch(function (err) {
    dispatchLoginError(dispatch, err);
    return Promise.reject(err);
  });
};

var logout = exports.logout = function logout(dispatch, firebase) {
  return firebase.auth().signOut().then(function () {
    dispatch({
      type: _constants.actionTypes.LOGOUT,
      preserve: firebase._.config.preserveOnLogout
    });
    firebase._.authUid = null;
    unWatchUserProfile(firebase);
    return firebase;
  });
};

var createUser = exports.createUser = function createUser(dispatch, firebase, _ref2, profile) {
  var email = _ref2.email,
      password = _ref2.password,
      signIn = _ref2.signIn;

  dispatchLoginError(dispatch, null);

  if (!email || !password) {
    var error = new Error('Email and Password are required to create user');
    dispatchLoginError(dispatch, error);
    return Promise.reject(error);
  }

  return firebase.auth().createUserWithEmailAndPassword(email, password).then(function (userData) {
    return firebase.auth().currentUser || !!signIn && signIn === false ? createUserProfile(dispatch, firebase, userData, profile || { email: email }) : login(dispatch, firebase, { email: email, password: password }).then(function () {
      return createUserProfile(dispatch, firebase, userData, profile || { email: email });
    }).catch(function (err) {
      if (err) {
        switch (err.code) {
          case 'auth/user-not-found':
            dispatchLoginError(dispatch, new Error('The specified user account does not exist.'));
            break;
          default:
            dispatchLoginError(dispatch, err);
        }
      }
      return Promise.reject(err);
    });
  }).catch(function (err) {
    dispatchLoginError(dispatch, err);
    return Promise.reject(err);
  });
};

var resetPassword = exports.resetPassword = function resetPassword(dispatch, firebase, email) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().sendPasswordResetEmail(email).catch(function (err) {
    if (err) {
      switch (err.code) {
        case 'auth/user-not-found':
          dispatchLoginError(dispatch, new Error('The specified user account does not exist.'));
          break;
        default:
          dispatchLoginError(dispatch, err);
      }
      return Promise.reject(err);
    }
  });
};

var confirmPasswordReset = exports.confirmPasswordReset = function confirmPasswordReset(dispatch, firebase, code, password) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().confirmPasswordReset(code, password).catch(function (err) {
    if (err) {
      switch (err.code) {
        case 'auth/expired-action-code':
          dispatchLoginError(dispatch, new Error('The action code has expired.'));
          break;
        case 'auth/invalid-action-code':
          dispatchLoginError(dispatch, new Error('The action code is invalid.'));
          break;
        case 'auth/user-disabled':
          dispatchLoginError(dispatch, new Error('The user is disabled.'));
          break;
        case 'auth/user-not-found':
          dispatchLoginError(dispatch, new Error('The user is not found.'));
          break;
        case 'auth/weak-password':
          dispatchLoginError(dispatch, new Error('The password is not strong enough.'));
          break;
        default:
          dispatchLoginError(dispatch, err);
      }
      return Promise.reject(err);
    }
  });
};

var verifyPasswordResetCode = exports.verifyPasswordResetCode = function verifyPasswordResetCode(dispatch, firebase, code) {
  dispatchLoginError(dispatch, null);
  return firebase.auth().verifyPasswordResetCode(code).catch(function (err) {
    if (err) {
      dispatchLoginError(dispatch, err);
    }
    return Promise.reject(err);
  });
};

var updateProfile = exports.updateProfile = function updateProfile(dispatch, firebase, profileUpdate) {
  var config = firebase._.config;

  dispatch({
    type: _constants.actionTypes.PROFILE_UPDATE_START,
    payload: profileUpdate
  });

  var updatePromise = config.useFirestoreForProfile ? _auth.updateProfileOnFirestore : _auth.updateProfileOnRTDB;
  return updatePromise(firebase, profileUpdate).then(function (snap) {
    dispatch({
      type: _constants.actionTypes.PROFILE_UPDATE_SUCCESS,
      payload: config.useFirestoreForProfile ? snap.data() : snap.val()
    });
    return snap;
  }).catch(function (error) {
    dispatch({ type: _constants.actionTypes.PROFILE_UPDATE_ERROR, error: error });
    return Promise.reject(error);
  });
};

var updateAuth = exports.updateAuth = function updateAuth(dispatch, firebase, authUpdate, updateInProfile) {
  dispatch({ type: _constants.actionTypes.AUTH_UPDATE_START, payload: authUpdate });

  if (!firebase.auth().currentUser) {
    var error = new Error('User must be logged in to update auth.');
    dispatch({ type: _constants.actionTypes.AUTH_UPDATE_ERROR, payload: error });
    return Promise.reject(error);
  }

  return firebase.auth().currentUser.updateProfile(authUpdate).then(function (payload) {
    dispatch({
      type: _constants.actionTypes.AUTH_UPDATE_SUCCESS,
      payload: firebase.auth().currentUser
    });
    if (updateInProfile) {
      return updateProfile(dispatch, firebase, authUpdate);
    }
    return payload;
  }).catch(function (error) {
    dispatch({ type: _constants.actionTypes.AUTH_UPDATE_ERROR, error: error });
    return Promise.reject(error);
  });
};

var updateEmail = exports.updateEmail = function updateEmail(dispatch, firebase, newEmail, updateInProfile) {
  dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_START, payload: newEmail });

  if (!firebase.auth().currentUser) {
    var error = new Error('User must be logged in to update email.');
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_ERROR, error: error });
    return Promise.reject(error);
  }

  return firebase.auth().currentUser.updateEmail(newEmail).then(function (payload) {
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_SUCCESS, payload: newEmail });
    if (updateInProfile) {
      return updateProfile(dispatch, firebase, { email: newEmail });
    }
    return payload;
  }).catch(function (error) {
    dispatch({ type: _constants.actionTypes.EMAIL_UPDATE_ERROR, error: error });
    return Promise.reject(error);
  });
};

var reloadAuth = exports.reloadAuth = function reloadAuth(dispatch, firebase) {
  dispatch({ type: _constants.actionTypes.AUTH_RELOAD_START });

  if (!firebase.auth().currentUser) {
    var error = new Error('User must be logged in to reload auth.');
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_ERROR, error: error });
    return Promise.reject(error);
  }

  return firebase.auth().currentUser.reload().then(function () {
    var auth = firebase.auth().currentUser;
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_SUCCESS, payload: auth });
    return auth;
  }).catch(function (error) {
    dispatch({ type: _constants.actionTypes.AUTH_RELOAD_ERROR, error: error });
    return Promise.reject(error);
  });
};

var linkWithCredential = exports.linkWithCredential = function linkWithCredential(dispatch, firebase, credential) {
  dispatch({ type: _constants.actionTypes.AUTH_LINK_START });

  if (!firebase.auth().currentUser) {
    var error = new Error('User must be logged in to link with credential.');
    dispatch({ type: _constants.actionTypes.AUTH_LINK_ERROR, error: error });
    return Promise.reject(error);
  }

  return firebase.auth().currentUser.linkWithCredential(credential).then(function (auth) {
    dispatch({ type: _constants.actionTypes.AUTH_LINK_SUCCESS, payload: auth });
    return auth;
  }).catch(function (error) {
    dispatch({ type: _constants.actionTypes.AUTH_LINK_ERROR, error: error });
    return Promise.reject(error);
  });
};

var signInWithPhoneNumber = exports.signInWithPhoneNumber = function signInWithPhoneNumber(firebase, dispatch, phoneNumber, applicationVerifier) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  return login(dispatch, firebase, _extends({
    phoneNumber: phoneNumber,
    applicationVerifier: applicationVerifier
  }, options));
};

exports.default = {
  dispatchLoginError: dispatchLoginError,
  unWatchUserProfile: unWatchUserProfile,
  watchUserProfile: watchUserProfile,
  init: init,
  createUserProfile: createUserProfile,
  login: login,
  logout: logout,
  createUser: createUser,
  resetPassword: resetPassword,
  confirmPasswordReset: confirmPasswordReset,
  verifyPasswordResetCode: verifyPasswordResetCode,
  updateAuth: updateAuth,
  updateProfile: updateProfile,
  updateEmail: updateEmail,
  reloadAuth: reloadAuth,
  signInWithPhoneNumber: signInWithPhoneNumber
};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(68),
    keysIn = __webpack_require__(147);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17),
    isPrototype = __webpack_require__(139),
    nativeKeysIn = __webpack_require__(653);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 653 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(68),
    getSymbols = __webpack_require__(192);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(68),
    getSymbolsIn = __webpack_require__(326);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(207),
    cloneDataView = __webpack_require__(658),
    cloneRegExp = __webpack_require__(659),
    cloneSymbol = __webpack_require__(660),
    cloneTypedArray = __webpack_require__(328);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(207);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 659 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(662),
    baseUnary = __webpack_require__(195),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(83),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(664),
    baseUnary = __webpack_require__(195),
    nodeUtil = __webpack_require__(196);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(83),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(208);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(312);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(668),
    defineProperty = __webpack_require__(318),
    identity = __webpack_require__(105);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 668 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 669 */
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(149),
    baseRest = __webpack_require__(333),
    customDefaultsMerge = __webpack_require__(671),
    mergeWith = __webpack_require__(675);

/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = baseRest(function(args) {
  args.push(undefined, customDefaultsMerge);
  return apply(mergeWith, undefined, args);
});

module.exports = defaultsDeep;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(334),
    isObject = __webpack_require__(17);

/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (isObject(objValue) && isObject(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

module.exports = customDefaultsMerge;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(335),
    cloneBuffer = __webpack_require__(325),
    cloneTypedArray = __webpack_require__(328),
    copyArray = __webpack_require__(106),
    initCloneObject = __webpack_require__(329),
    isArguments = __webpack_require__(136),
    isArray = __webpack_require__(13),
    isArrayLikeObject = __webpack_require__(673),
    isBuffer = __webpack_require__(137),
    isFunction = __webpack_require__(40),
    isObject = __webpack_require__(17),
    isPlainObject = __webpack_require__(208),
    isTypedArray = __webpack_require__(193),
    safeGet = __webpack_require__(336),
    toPlainObject = __webpack_require__(674);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(56),
    isObjectLike = __webpack_require__(23);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(68),
    keysIn = __webpack_require__(147);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(334),
    createAssigner = __webpack_require__(337);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(677),
    baseEach = __webpack_require__(85),
    baseIteratee = __webpack_require__(55),
    baseReduce = __webpack_require__(678),
    isArray = __webpack_require__(13);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 678 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(680),
    baseEvery = __webpack_require__(681),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(13),
    isIterateeCall = __webpack_require__(200);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(85);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(212),
    func = convert('unset', __webpack_require__(715));

func.placeholder = __webpack_require__(150);
module.exports = func;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(684),
    fallbackHolder = __webpack_require__(150);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 684 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(686),
  'assign': __webpack_require__(324),
  'clone': __webpack_require__(708),
  'curry': __webpack_require__(709),
  'forEach': __webpack_require__(146),
  'isArray': __webpack_require__(13),
  'isError': __webpack_require__(710),
  'isFunction': __webpack_require__(40),
  'isWeakMap': __webpack_require__(711),
  'iteratee': __webpack_require__(712),
  'keys': __webpack_require__(197),
  'rearg': __webpack_require__(713),
  'toInteger': __webpack_require__(349),
  'toPath': __webpack_require__(714)
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(213);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(151),
    root = __webpack_require__(22);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(149),
    createCtor = __webpack_require__(151),
    createHybrid = __webpack_require__(340),
    createRecurry = __webpack_require__(343),
    getHolder = __webpack_require__(348),
    replaceHolders = __webpack_require__(216),
    root = __webpack_require__(22);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 689 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(214),
    getData = __webpack_require__(344),
    getFuncName = __webpack_require__(692),
    lodash = __webpack_require__(694);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 691 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(693);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 693 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(214),
    LodashWrapper = __webpack_require__(345),
    baseLodash = __webpack_require__(215),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(23),
    wrapperClone = __webpack_require__(695);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(214),
    LodashWrapper = __webpack_require__(345),
    copyArray = __webpack_require__(106);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 696 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 697 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(146),
    arrayIncludes = __webpack_require__(699);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(700);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(701),
    baseIsNaN = __webpack_require__(702),
    strictIndexOf = __webpack_require__(703);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 701 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(106),
    isIndex = __webpack_require__(82);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(149),
    createCtor = __webpack_require__(151),
    root = __webpack_require__(22);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(341),
    composeArgsRight = __webpack_require__(342),
    replaceHolders = __webpack_require__(216);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(350);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(205);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(213);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObjectLike = __webpack_require__(23),
    isPlainObject = __webpack_require__(208);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(83),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(205),
    baseIteratee = __webpack_require__(55);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(213),
    flatRest = __webpack_require__(209);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(141),
    copyArray = __webpack_require__(106),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(103),
    stringToPath = __webpack_require__(306),
    toKey = __webpack_require__(66),
    toString = __webpack_require__(104);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(199);

/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : baseUnset(object, path);
}

module.exports = unset;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(717),
    hasIn = __webpack_require__(307);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(140),
    baseSet = __webpack_require__(201),
    castPath = __webpack_require__(84);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44),
    isObjectLike = __webpack_require__(23);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(104);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(104),
    upperFirst = __webpack_require__(721);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(722);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(723),
    hasUnicode = __webpack_require__(204),
    stringToArray = __webpack_require__(724),
    toString = __webpack_require__(104);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(311);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(725),
    hasUnicode = __webpack_require__(204),
    unicodeToArray = __webpack_require__(726);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 726 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteFile = exports.uploadFiles = exports.uploadFile = undefined;

var _isFunction2 = __webpack_require__(40);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _map2 = __webpack_require__(142);

var _map3 = _interopRequireDefault(_map2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(49);

var _actions = __webpack_require__(320);

var _storage = __webpack_require__(728);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FILE_UPLOAD_START = _constants.actionTypes.FILE_UPLOAD_START,
    FILE_UPLOAD_ERROR = _constants.actionTypes.FILE_UPLOAD_ERROR,
    FILE_UPLOAD_PROGRESS = _constants.actionTypes.FILE_UPLOAD_PROGRESS,
    FILE_UPLOAD_COMPLETE = _constants.actionTypes.FILE_UPLOAD_COMPLETE,
    FILE_DELETE_START = _constants.actionTypes.FILE_DELETE_START,
    FILE_DELETE_ERROR = _constants.actionTypes.FILE_DELETE_ERROR,
    FILE_DELETE_COMPLETE = _constants.actionTypes.FILE_DELETE_COMPLETE;

var uploadFileWithProgress = function uploadFileWithProgress(dispatch, firebase, _ref) {
  var path = _ref.path,
      file = _ref.file;

  var uploadEvent = firebase.storage().ref(path + '/' + file.name).put(file);

  var unListen = uploadEvent.on(firebase.storage.TaskEvent.STATE_CHANGED, {
    next: function next(snapshot) {
      dispatch({
        type: FILE_UPLOAD_PROGRESS,
        path: path,
        payload: {
          snapshot: snapshot,
          percent: Math.floor(snapshot.bytesTransferred / snapshot.totalBytes * 100)
        }
      });
    },
    error: function error(err) {
      dispatch({ type: FILE_UPLOAD_ERROR, path: path, payload: err });
      unListen();
    },
    complete: function complete() {
      dispatch({ type: FILE_UPLOAD_COMPLETE, path: path, payload: file });
      unListen();
    }
  });
  return uploadEvent;
};

var uploadFile = exports.uploadFile = function uploadFile(dispatch, firebase, config) {
  if (!firebase.storage) {
    throw new Error('Firebase storage is required to upload files');
  }
  var path = config.path,
      file = config.file,
      dbPath = config.dbPath,
      _config$options = config.options,
      options = _config$options === undefined ? { progress: false } : _config$options;

  var nameFromOptions = options.name && (0, _isFunction3.default)(options.name) ? options.name(file, firebase, config) : options.name;
  var filename = nameFromOptions || file.name;

  dispatch({ type: FILE_UPLOAD_START, payload: _extends({}, config, { filename: filename }) });

  var uploadPromise = function uploadPromise() {
    return options.progress ? uploadFileWithProgress(dispatch, firebase, { path: path, file: file }) : firebase.storage().ref(path + '/' + filename).put(file);
  };

  return uploadPromise().then(function (uploadTaskSnaphot) {
    if (!dbPath || !firebase.database) {
      dispatch({
        type: FILE_UPLOAD_COMPLETE,
        meta: _extends({}, config, { filename: filename }),
        payload: { uploadTaskSnaphot: uploadTaskSnaphot }
      });
      return { uploadTaskSnaphot: uploadTaskSnaphot };
    }
    var _uploadTaskSnaphot$me = uploadTaskSnaphot.metadata,
        name = _uploadTaskSnaphot$me.name,
        fullPath = _uploadTaskSnaphot$me.fullPath,
        downloadURLs = _uploadTaskSnaphot$me.downloadURLs;
    var fileMetadataFactory = firebase._.config.fileMetadataFactory;

    var fileData = (0, _isFunction3.default)(fileMetadataFactory) ? fileMetadataFactory(uploadTaskSnaphot, firebase) : {
      name: name,
      fullPath: fullPath,
      downloadURL: downloadURLs[0],
      createdAt: firebase.database.ServerValue.TIMESTAMP
    };

    return firebase.database().ref(dbPath).push(fileData).then(function (metaDataSnapshot) {
      var payload = {
        snapshot: metaDataSnapshot,
        key: metaDataSnapshot.key,
        File: fileData,
        uploadTaskSnaphot: uploadTaskSnaphot,
        metaDataSnapshot: metaDataSnapshot
      };
      dispatch({
        type: FILE_UPLOAD_COMPLETE,
        meta: _extends({}, config, { filename: filename }),
        payload: payload
      });
      return payload;
    });
  }).catch(function (err) {
    dispatch({ type: FILE_UPLOAD_ERROR, path: path, payload: err });
    return Promise.reject(err);
  });
};

var uploadFiles = function uploadFiles(dispatch, firebase, _ref2) {
  var files = _ref2.files,
      other = _objectWithoutProperties(_ref2, ['files']);

  return Promise.all((0, _map3.default)(files, function (file) {
    return uploadFile(dispatch, firebase, _extends({ file: file }, other));
  }));
};

exports.uploadFiles = uploadFiles;
var deleteFile = exports.deleteFile = function deleteFile(dispatch, firebase, _ref3) {
  var path = _ref3.path,
      dbPath = _ref3.dbPath;
  return (0, _actions.wrapInDispatch)(dispatch, {
    method: _storage.deleteFile,
    args: [firebase, { path: path, dbPath: dbPath }],
    types: [FILE_DELETE_START, FILE_DELETE_COMPLETE, FILE_DELETE_ERROR]
  });
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deleteFile = exports.deleteFile = function deleteFile(firebase, _ref) {
  var path = _ref.path,
      dbPath = _ref.dbPath;
  return firebase.storage().ref(path).delete().then(function () {
    return !dbPath || !firebase.database ? { path: path } : firebase.database().ref(dbPath).remove().then(function () {
      return { path: path, dbPath: dbPath };
    });
  });
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirebaseConnect = undefined;

var _isEqual2 = __webpack_require__(353);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _query = __webpack_require__(352);

var _utils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFirebaseConnect = exports.createFirebaseConnect = function createFirebaseConnect() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function () {
    var dataOrFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (WrappedComponent) {
      var FirebaseConnect = function (_Component) {
        _inherits(FirebaseConnect, _Component);

        function FirebaseConnect() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, FirebaseConnect);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirebaseConnect.__proto__ || Object.getPrototypeOf(FirebaseConnect)).call.apply(_ref, [this].concat(args))), _this), _this.firebaseEvents = [], _this.firebase = null, _this.prevData = null, _this.store = _this.context[storeKey], _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(FirebaseConnect, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            var _store = this.store,
                firebase = _store.firebase,
                dispatch = _store.dispatch;

            var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
            this.prevData = inputAsFunc(this.props, this.store);

            var ref = firebase.ref,
                helpers = firebase.helpers,
                storage = firebase.storage,
                database = firebase.database,
                auth = firebase.auth;

            this.firebase = _extends({ ref: ref, storage: storage, database: database, auth: auth }, helpers);

            this._firebaseEvents = (0, _utils.getEventsFromInput)(this.prevData);

            (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _store2 = this.store,
                firebase = _store2.firebase,
                dispatch = _store2.dispatch;

            (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(np) {
            var _store3 = this.store,
                firebase = _store3.firebase,
                dispatch = _store3.dispatch;

            var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
            var data = inputAsFunc(np, this.store);

            if (!(0, _isEqual3.default)(data, this.prevData)) {
              this.prevData = data;

              (0, _query.unWatchEvents)(firebase, dispatch, this._firebaseEvents);

              this._firebaseEvents = (0, _utils.getEventsFromInput)(data);

              (0, _query.watchEvents)(firebase, dispatch, this._firebaseEvents);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
              firebase: this.firebase
            }));
          }
        }]);

        return FirebaseConnect;
      }(_react.Component);

      FirebaseConnect.displayName = 'FirebaseConnect(' + (0, _utils.getDisplayName)(WrappedComponent) + ')';
      FirebaseConnect.wrappedComponent = WrappedComponent;
      FirebaseConnect.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);


      return (0, _hoistNonReactStatics2.default)(FirebaseConnect, WrappedComponent);
    };
  };
};

exports.default = createFirebaseConnect();

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFirestoreConnect = undefined;

var _isEqual2 = __webpack_require__(353);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createFirestoreConnect = exports.createFirestoreConnect = function createFirestoreConnect() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function () {
    var dataOrFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return function (WrappedComponent) {
      var FirestoreConnect = function (_Component) {
        _inherits(FirestoreConnect, _Component);

        function FirestoreConnect() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, FirestoreConnect);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FirestoreConnect.__proto__ || Object.getPrototypeOf(FirestoreConnect)).call.apply(_ref, [this].concat(args))), _this), _this.prevData = null, _this.store = _this.context[storeKey], _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(FirestoreConnect, [{
          key: 'componentWillMount',
          value: function componentWillMount() {
            var _store = this.store,
                firebase = _store.firebase,
                firestore = _store.firestore;

            if (firebase.firestore && firestore) {
              var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
              this.prevData = inputAsFunc(this.props, this.store);

              firestore.setListeners(this.prevData);
            }
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _store2 = this.store,
                firebase = _store2.firebase,
                firestore = _store2.firestore;

            if (firebase.firestore && this.prevData) {
              firestore.unsetListeners(this.prevData);
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(np) {
            var _store3 = this.store,
                firebase = _store3.firebase,
                firestore = _store3.firestore;

            var inputAsFunc = (0, _utils.createCallable)(dataOrFn);
            var data = inputAsFunc(np, this.store);

            if (firebase.firestore && !(0, _isEqual3.default)(data, this.prevData)) {
              firestore.unsetListeners(this.prevData);
              this.prevData = data;

              firestore.setListeners(data);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _store4 = this.store,
                firebase = _store4.firebase,
                firestore = _store4.firestore;

            return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
              firebase: _extends({}, firebase, firebase.helpers),
              firestore: firestore
            }));
          }
        }]);

        return FirestoreConnect;
      }(_react.Component);

      FirestoreConnect.wrappedComponent = WrappedComponent;
      FirestoreConnect.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, 'FirestoreConnect');
      FirestoreConnect.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);


      return (0, _hoistNonReactStatics2.default)(FirestoreConnect, WrappedComponent);
    };
  };
};

exports.default = createFirestoreConnect();

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWithFirebase = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createWithFirebase = exports.createWithFirebase = function createWithFirebase() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function (WrappedComponent) {
    var withFirebase = function (_Component) {
      _inherits(withFirebase, _Component);

      function withFirebase() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, withFirebase);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = withFirebase.__proto__ || Object.getPrototypeOf(withFirebase)).call.apply(_ref, [this].concat(args))), _this), _this.store = _this.context[storeKey], _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(withFirebase, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
            dispatch: this.store.dispatch,
            firebase: this.store.firebase
          }));
        }
      }]);

      return withFirebase;
    }(_react.Component);

    withFirebase.wrappedComponent = WrappedComponent;
    withFirebase.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, 'withFirebase');
    withFirebase.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);


    return (0, _hoistNonReactStatics2.default)(withFirebase, WrappedComponent);
  };
};

exports.default = createWithFirebase();

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWithFirestore = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(46);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _utils = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createWithFirestore = exports.createWithFirestore = function createWithFirestore() {
  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  return function (WrappedComponent) {
    var withFirestore = function (_Component) {
      _inherits(withFirestore, _Component);

      function withFirestore() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, withFirestore);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = withFirestore.__proto__ || Object.getPrototypeOf(withFirestore)).call.apply(_ref, [this].concat(args))), _this), _this.store = _this.context[storeKey], _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(withFirestore, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
            dispatch: this.store.dispatch,
            firestore: this.store.firestore,
            firebase: this.store.firebase
          }));
        }
      }]);

      return withFirestore;
    }(_react.Component);

    withFirestore.wrappedComponent = WrappedComponent;
    withFirestore.displayName = (0, _utils.wrapDisplayName)(WrappedComponent, 'withFirestore');
    withFirestore.contextTypes = _defineProperty({}, storeKey, _propTypes2.default.object.isRequired);


    return (0, _hoistNonReactStatics2.default)(withFirestore, WrappedComponent);
  };
};

exports.default = createWithFirestore();

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirebase = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createFirebaseInstance = __webpack_require__(291);

var _auth = __webpack_require__(217);

var _constants = __webpack_require__(49);

var _actions = __webpack_require__(322);

var firebaseInstance = void 0;

exports.default = function (instance, otherConfig) {
  return function (next) {
    return function (reducer, initialState, middleware) {
      var store = next(reducer, initialState, middleware);

      if (!instance.SDK_VERSION && !instance.firebase_ && !instance.database) {
        throw new Error('v2.0.0-beta and higher require passing a firebase app instance or a firebase library instance. View the migration guide for details.');
      }

      var configs = _extends({}, _constants.defaultConfig, otherConfig);
      firebaseInstance = (0, _createFirebaseInstance.createFirebaseInstance)(instance.firebase_ || instance, configs, store.dispatch);

      _actions.authActions.init(store.dispatch, firebaseInstance);
      store.firebase = firebaseInstance;

      if (configs.attachAuthIsReady) {
        store.firebaseAuthIsReady = (0, _auth.createAuthIsReady)(store, configs);
      }

      return store;
    };
  };
};

var getFirebase = exports.getFirebase = function getFirebase() {
  if (!firebaseInstance) {
    throw new Error('Firebase instance does not yet exist. Check your compose function.');
  }

  return firebaseInstance;
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducers = __webpack_require__(211);

var _reducers2 = __webpack_require__(735);

exports.default = (0, _reducers.combineReducers)({
  requesting: _reducers2.requestingReducer,
  requested: _reducers2.requestedReducer,
  timestamps: _reducers2.timestampsReducer,
  data: _reducers2.dataReducer,
  ordered: _reducers2.orderedReducer,
  auth: _reducers2.authReducer,
  authError: _reducers2.authErrorReducer,
  profile: _reducers2.profileReducer,
  listeners: _reducers2.listenersReducer,
  isInitializing: _reducers2.isInitializingReducer,
  errors: _reducers2.errorsReducer
});
module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderedReducer = exports.dataReducer = exports.listenersReducer = exports.errorsReducer = exports.profileReducer = exports.authErrorReducer = exports.authReducer = exports.timestampsReducer = exports.requestedReducer = exports.requestingReducer = exports.isInitializingReducer = undefined;

var _assign2 = __webpack_require__(736);

var _assign3 = _interopRequireDefault(_assign2);

var _setWith2 = __webpack_require__(738);

var _setWith3 = _interopRequireDefault(_setWith2);

var _isObject2 = __webpack_require__(17);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(13);

var _isArray3 = _interopRequireDefault(_isArray2);

var _get2 = __webpack_require__(102);

var _get3 = _interopRequireDefault(_get2);

var _omit2 = __webpack_require__(323);

var _omit3 = _interopRequireDefault(_omit2);

var _pick2 = __webpack_require__(351);

var _pick3 = _interopRequireDefault(_pick2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__(49);

var _reducers = __webpack_require__(211);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var START = _constants.actionTypes.START,
    SET = _constants.actionTypes.SET,
    SET_PROFILE = _constants.actionTypes.SET_PROFILE,
    MERGE = _constants.actionTypes.MERGE,
    LOGIN = _constants.actionTypes.LOGIN,
    LOGOUT = _constants.actionTypes.LOGOUT,
    LOGIN_ERROR = _constants.actionTypes.LOGIN_ERROR,
    CLEAR_ERRORS = _constants.actionTypes.CLEAR_ERRORS,
    REMOVE = _constants.actionTypes.REMOVE,
    NO_VALUE = _constants.actionTypes.NO_VALUE,
    SET_LISTENER = _constants.actionTypes.SET_LISTENER,
    UNSET_LISTENER = _constants.actionTypes.UNSET_LISTENER,
    AUTHENTICATION_INIT_STARTED = _constants.actionTypes.AUTHENTICATION_INIT_STARTED,
    AUTHENTICATION_INIT_FINISHED = _constants.actionTypes.AUTHENTICATION_INIT_FINISHED,
    AUTH_EMPTY_CHANGE = _constants.actionTypes.AUTH_EMPTY_CHANGE,
    AUTH_LINK_SUCCESS = _constants.actionTypes.AUTH_LINK_SUCCESS,
    UNAUTHORIZED_ERROR = _constants.actionTypes.UNAUTHORIZED_ERROR,
    AUTH_UPDATE_SUCCESS = _constants.actionTypes.AUTH_UPDATE_SUCCESS,
    AUTH_RELOAD_SUCCESS = _constants.actionTypes.AUTH_RELOAD_SUCCESS,
    PROFILE_UPDATE_SUCCESS = _constants.actionTypes.PROFILE_UPDATE_SUCCESS;
var isInitializingReducer = exports.isInitializingReducer = function isInitializingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case AUTHENTICATION_INIT_STARTED:
      return true;
    case AUTHENTICATION_INIT_FINISHED:
      return false;
    default:
      return state;
  }
};

var requestingReducer = exports.requestingReducer = function requestingReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var type = _ref.type,
      path = _ref.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), true));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), false));
    default:
      return state;
  }
};

var requestedReducer = exports.requestedReducer = function requestedReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments[1];
  var type = _ref2.type,
      path = _ref2.path;

  switch (type) {
    case START:
      return _extends({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), false));
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), true));
    default:
      return state;
  }
};

var timestampsReducer = exports.timestampsReducer = function timestampsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref3 = arguments[1];
  var type = _ref3.type,
      path = _ref3.path;

  switch (type) {
    case START:
    case NO_VALUE:
    case SET:
      return _extends({}, state, _defineProperty({}, (0, _reducers.getSlashStrPath)(path), Date.now()));
    default:
      return state;
  }
};

var createDataReducer = function createDataReducer() {
  var actionKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data';
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
      case SET:
        return (0, _setWith3.default)(Object, (0, _reducers.getDotStrPath)(action.path), action[actionKey], state);
      case MERGE:
        var previousData = (0, _get3.default)(state, (0, _reducers.getDotStrPath)(action.path), {});
        var mergedData = (0, _assign3.default)(previousData, action[actionKey]);
        return (0, _setWith3.default)(Object, (0, _reducers.getDotStrPath)(action.path), mergedData, state);
      case NO_VALUE:
        return (0, _setWith3.default)(Object, (0, _reducers.getDotStrPath)(action.path), null, state);
      case REMOVE:
        if (actionKey === 'data') {
          return (0, _reducers.recursiveUnset)((0, _reducers.getDotStrPath)(action.path), state);
        }
        return state;
      case LOGOUT:
        if (action.preserve) {
          if ((0, _isArray3.default)(action.preserve)) {
            return (0, _pick3.default)(state, action.preserve);
          } else if ((0, _isObject3.default)(action.preserve)) {
            return action.preserve[actionKey] ? (0, _reducers.preserveValuesFromState)(state, action.preserve[actionKey], {}) : {};
          }
          throw new Error('Invalid preserve parameter. It must be an Object or an Array');
        }
        return {};
      default:
        return state;
    }
  };
};

var authReducer = exports.authReducer = function authReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case AUTH_UPDATE_SUCCESS:
      if (!action.auth) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      var auth = action.auth.toJSON ? action.auth.toJSON() : action.auth;

      if (action.preserve && action.preserve.auth) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.auth, _extends({}, auth, {
          isEmpty: false,
          isLoaded: true
        }));
      }
      return _extends({}, auth, { isEmpty: false, isLoaded: true });
    case AUTH_LINK_SUCCESS:
    case AUTH_RELOAD_SUCCESS:
      if (!action.payload) {
        return {
          isEmpty: true,
          isLoaded: true
        };
      }
      return _extends({}, action.payload.toJSON ? action.payload.toJSON() : action.payload, {
        isEmpty: false,
        isLoaded: true
      });
    case LOGIN_ERROR:
    case AUTH_EMPTY_CHANGE:
    case LOGOUT:
      if (action.preserve && action.preserve.auth) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.auth, {
          isLoaded: true,
          isEmpty: true
        });
      }
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var authErrorReducer = exports.authErrorReducer = function authErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case LOGIN:
    case LOGOUT:
      return null;
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      return action.authError;
    default:
      return state;
  }
};

var profileReducer = exports.profileReducer = function profileReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false, isEmpty: true };
  var action = arguments[1];

  switch (action.type) {
    case SET_PROFILE:
      if (!action.profile) {
        return _extends({}, state, {
          isEmpty: true,
          isLoaded: true
        });
      }
      return _extends({}, action.profile, {
        isEmpty: false,
        isLoaded: true
      });
    case PROFILE_UPDATE_SUCCESS:
      return _extends({}, state, action.payload);
    case LOGIN:
      if (action.preserve && action.preserve.profile) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.profile, {
          isLoaded: true,
          isEmpty: true
        });
      }
      return {
        isEmpty: true,
        isLoaded: false
      };
    case LOGOUT:
    case AUTH_EMPTY_CHANGE:
      if (action.preserve && action.preserve.profile) {
        return (0, _reducers.preserveValuesFromState)(state, action.preserve.profile, {
          isLoaded: true,
          isEmpty: true
        });
      }
      return { isLoaded: true, isEmpty: true };
    default:
      return state;
  }
};

var errorsReducer = exports.errorsReducer = function errorsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case LOGIN_ERROR:
    case UNAUTHORIZED_ERROR:
      if (!(0, _isArray3.default)(state)) {
        throw new Error('Errors state must be an array');
      }
      return [].concat(_toConsumableArray(state), [action.authError]);
    case LOGOUT:
    case CLEAR_ERRORS:
      if (action.preserve && action.preserve.errors) {
        if (typeof action.preserve.errors !== 'function') {
          throw new Error('Preserve for the errors state currently only supports functions');
        }
        return state.filter(action.preserve.errors);
      }
      return [];
    default:
      return state;
  }
};

var listenersById = function listenersById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref4 = arguments[1];
  var type = _ref4.type,
      path = _ref4.path,
      payload = _ref4.payload;

  switch (type) {
    case SET_LISTENER:
      return _extends({}, state, _defineProperty({}, payload.id, {
        id: payload.id,
        path: path
      }));
    case UNSET_LISTENER:
      return (0, _omit3.default)(state, [payload.id]);
    default:
      return state;
  }
};

var allListeners = function allListeners() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref5 = arguments[1];
  var type = _ref5.type,
      path = _ref5.path,
      payload = _ref5.payload;

  switch (type) {
    case SET_LISTENER:
      return [].concat(_toConsumableArray(state), [payload.id]);
    case UNSET_LISTENER:
      return state.filter(function (lId) {
        return lId !== payload.id;
      });
    default:
      return state;
  }
};

var listenersReducer = exports.listenersReducer = (0, _reducers.combineReducers)({
  byId: listenersById,
  allIds: allListeners
});

var dataReducer = exports.dataReducer = createDataReducer();

var orderedReducer = exports.orderedReducer = createDataReducer('ordered');

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(212),
    func = convert('assign', __webpack_require__(737));

func.placeholder = __webpack_require__(150);
module.exports = func;


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(144),
    copyObject = __webpack_require__(68),
    createAssigner = __webpack_require__(337),
    isArrayLike = __webpack_require__(56),
    isPrototype = __webpack_require__(139),
    keys = __webpack_require__(81);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(212),
    func = convert('setWith', __webpack_require__(739));

func.placeholder = __webpack_require__(150);
module.exports = func;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(201);

/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : baseSet(object, path, value, customizer);
}

module.exports = setWith;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(14);

var _reactHelpers = __webpack_require__(54);

__webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ensure CSS specificity

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      width: theme.spacing.unit * 6,
      height: theme.spacing.unit * 6,
      padding: 0,
      borderRadius: '50%',
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      })
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    },
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};

/**
 * Refer to the [Icons](/style/icons) section of the documentation
 * regarding the available icon options.
 */
function IconButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'disabled']);


  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), className),
      centerRipple: true,
      focusRipple: true,
      disabled: disabled
    }, other),
    _react2.default.createElement(
      'span',
      { className: classes.label },
      _react2.default.Children.map(children, function (child) {
        if ((0, _reactHelpers.isMuiElement)(child, ['Icon', 'SvgIcon'])) {
          return _react2.default.cloneElement(child, { fontSize: true });
        }
        return child;
      })
    )
  );
}

IconButton.propTypes =  false ? {
  /**
   * The icon element.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
  /**
   * If `true`, the button will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple will be disabled.
   */
  disableRipple: _propTypes2.default.bool
} : {};

IconButton.defaultProps = {
  color: 'default',
  disabled: false,
  disableRipple: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIconButton' })(IconButton);

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block',
      fill: 'currentColor',
      height: 24,
      width: 24,
      userSelect: 'none',
      flexShrink: 0,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    },
    fontSize: {
      width: '1em',
      height: '1em'
    }
  };
};

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'fontSize', 'nativeColor', 'titleAccess', 'viewBox']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, classes.fontSize, fontSize), _classNames), classNameProp);

  return _react2.default.createElement(
    'svg',
    (0, _extends3.default)({
      className: className,
      focusable: 'false',
      viewBox: viewBox,
      color: nativeColor,
      'aria-hidden': titleAccess ? 'false' : 'true'
    }, other),
    titleAccess ? _react2.default.createElement(
      'title',
      null,
      titleAccess
    ) : null,
    children
  );
}

SvgIcon.propTypes =  false ? {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes2.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
  /**
   * If `true`, the icon size will be determined by the font-size.
   */
  fontSize: _propTypes2.default.bool,
  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes2.default.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes2.default.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes2.default.string
} : {};

SvgIcon.defaultProps = {
  color: 'inherit',
  fontSize: false,
  viewBox: '0 0 24 24'
};

SvgIcon.muiName = 'SvgIcon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSvgIcon' })(SvgIcon);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' });

var SentimentVerySatisfied = function SentimentVerySatisfied(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SentimentVerySatisfied = (0, _pure2.default)(SentimentVerySatisfied);
SentimentVerySatisfied.muiName = 'SvgIcon';

exports.default = SentimentVerySatisfied;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _setDisplayName = __webpack_require__(354);

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__(98);

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        _classCallCheck(this, ShouldUpdate);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

exports.default = shouldUpdate;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _shallowEqual = __webpack_require__(159);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _shallowEqual2.default;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _createBreakpoints = __webpack_require__(93);

var _requirePropFactory = __webpack_require__(747);

var _requirePropFactory2 = _interopRequireDefault(_requirePropFactory);

var _Hidden = __webpack_require__(355);

var _Hidden2 = _interopRequireDefault(_Hidden);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GUTTERS = [0, 8, 16, 24, 40]; // A grid component using the following libs as inspiration.
//
// For the implementation:
// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/

var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  // For the auto layouting
  var styles = (0, _defineProperty3.default)({}, 'grid-' + breakpoint, {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: '100%'
  });

  GRID_SIZES.forEach(function (size) {
    if (typeof size === 'boolean') {
      // Skip the first one as handle above.
      return;
    }

    // Only keep 6 significant numbers.
    var width = Math.round(size / 12 * 10e6) / 10e4 + '%';

    /* eslint-disable max-len */
    // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/b0508a975d711d6b24c01f57dd5445c22699fac4/scss/mixins/_grid.scss#L69
    /* eslint-enable max-len */
    styles['grid-' + breakpoint + '-' + size] = {
      flexBasis: width,
      maxWidth: width
    };
  });

  // No need for a media query for the first size.
  if (breakpoint === 'xs') {
    (0, _extends3.default)(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateGutter(theme, breakpoint) {
  var styles = {};

  GUTTERS.forEach(function (spacing, index) {
    if (index === 0) {
      // Skip the default style.
      return;
    }

    styles['spacing-' + breakpoint + '-' + spacing] = {
      margin: -spacing / 2,
      width: 'calc(100% + ' + spacing + 'px)',
      '& > $typeItem': {
        padding: spacing / 2
      }
    };
  });

  return styles;
}

// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
var styles = exports.styles = function styles(theme) {
  return (0, _extends3.default)({
    typeContainer: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },
    typeItem: {
      boxSizing: 'border-box',
      flex: '0 0 auto',
      margin: '0' // For instance, it's useful when used with a `figure` element.
    },
    zeroMinWidth: {
      minWidth: 0
    },
    'direction-xs-column': {
      flexDirection: 'column'
    },
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },
    'align-items-xs-center': {
      alignItems: 'center'
    },
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },
    'align-content-xs-center': {
      alignContent: 'center'
    },
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },
    'justify-xs-center': {
      justifyContent: 'center'
    },
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    }
  }, generateGutter(theme, 'xs'), _createBreakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};

function Grid(props) {
  var _classNames;

  var alignContent = props.alignContent,
      alignItems = props.alignItems,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      container = props.container,
      direction = props.direction,
      hidden = props.hidden,
      item = props.item,
      justify = props.justify,
      lg = props.lg,
      md = props.md,
      zeroMinWidth = props.zeroMinWidth,
      sm = props.sm,
      spacing = props.spacing,
      wrap = props.wrap,
      xl = props.xl,
      xs = props.xs,
      other = (0, _objectWithoutProperties3.default)(props, ['alignContent', 'alignItems', 'classes', 'className', 'component', 'container', 'direction', 'hidden', 'item', 'justify', 'lg', 'md', 'zeroMinWidth', 'sm', 'spacing', 'wrap', 'xl', 'xs']);


  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeContainer, container), (0, _defineProperty3.default)(_classNames, classes.typeItem, item), (0, _defineProperty3.default)(_classNames, classes.zeroMinWidth, zeroMinWidth), (0, _defineProperty3.default)(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), (0, _defineProperty3.default)(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), (0, _defineProperty3.default)(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), (0, _defineProperty3.default)(_classNames, classes['align-items-xs-' + String(alignItems)], alignItems !== Grid.defaultProps.alignItems), (0, _defineProperty3.default)(_classNames, classes['align-content-xs-' + String(alignContent)], alignContent !== Grid.defaultProps.alignContent), (0, _defineProperty3.default)(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), (0, _defineProperty3.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty3.default)(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), (0, _defineProperty3.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty3.default)(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), (0, _defineProperty3.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty3.default)(_classNames, classes['grid-md-' + String(md)], md && md !== true), (0, _defineProperty3.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty3.default)(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), (0, _defineProperty3.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty3.default)(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);
  var gridProps = (0, _extends3.default)({ className: className }, other);

  if (hidden) {
    return _react2.default.createElement(
      _Hidden2.default,
      hidden,
      _react2.default.createElement(Component, gridProps)
    );
  }

  return _react2.default.createElement(Component, gridProps);
}

Grid.propTypes =  false ? {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: _propTypes2.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: _propTypes2.default.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: _propTypes2.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  /**
   * If provided, will wrap with [Hidden](/api/hidden) component and given properties.
   */
  hidden: _propTypes2.default.object,
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: _propTypes2.default.bool,
  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: _propTypes2.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: _propTypes2.default.oneOf(GUTTERS),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: _propTypes2.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: _propTypes2.default.oneOf([true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: _propTypes2.default.bool
} : {};

Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  component: 'div',
  container: false,
  direction: 'row',
  item: false,
  justify: 'flex-start',
  zeroMinWidth: false,
  spacing: 16,
  wrap: 'wrap'
};

// Add a wrapper component to generate some helper messages in the development
// environment.
/* eslint-disable react/no-multi-comp */
// eslint-disable-next-line import/no-mutable-exports
var GridWrapper = Grid;

if (false) {
  GridWrapper = function GridWrapper(props) {
    return _react2.default.createElement(Grid, props);
  };

  var requireProp = (0, _requirePropFactory2.default)('Grid');
  GridWrapper.propTypes = {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('zeroMinWidth')
  };
}

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGrid' })(GridWrapper);

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//  weak

var requirePropFactory = function requirePropFactory(componentNameInError) {
  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error('The property `' + propFullNameSafe + '` of ' + ('`' + componentNameInError + '` must be used on `' + requiredProp + '`.'));
      }

      return null;
    };
  };
  return requireProp;
};

exports.default = requirePropFactory;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HiddenJs = __webpack_require__(749);

var _HiddenJs2 = _interopRequireDefault(_HiddenJs);

var _HiddenCss = __webpack_require__(752);

var _HiddenCss2 = _interopRequireDefault(_HiddenCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Responsively hides children based on the selected implementation.
 */
function Hidden(props) {
  var implementation = props.implementation,
      other = (0, _objectWithoutProperties3.default)(props, ['implementation']);


  if (implementation === 'js') {
    return _react2.default.createElement(_HiddenJs2.default, other);
  }

  return _react2.default.createElement(_HiddenCss2.default, other);
}

Hidden.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
} : {};

Hidden.defaultProps = {
  implementation: 'js',
  lgDown: false,
  lgUp: false,
  mdDown: false,
  mdUp: false,
  smDown: false,
  smUp: false,
  xlDown: false,
  xlUp: false,
  xsDown: false,
  xsUp: false
};

exports.default = Hidden;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createBreakpoints = __webpack_require__(93);

var _withWidth = __webpack_require__(152);

var _withWidth2 = _interopRequireDefault(_withWidth);

var _exactProp = __webpack_require__(97);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;


  var visible = true;

  // `only` check is faster to get out sooner if used.
  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }

  // Allow `only` to be combined with other props. If already hidden, no need to check others.
  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
      var _breakpoint = _createBreakpoints.keys[_i];
      var breakpointUp = props[_breakpoint + 'Up'];
      var breakpointDown = props[_breakpoint + 'Down'];
      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * You can use this property when choosing the `js` implementation with server side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty componenent during the first mount.
   * In some situation you might want to use an heristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * http://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes2.default.string.isRequired,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
};

HiddenJs.propTypes = (0, _exactProp2.default)(HiddenJs.propTypes, 'HiddenJs');

exports.default = (0, _withWidth2.default)()(HiddenJs);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passiveOption = undefined;

var _defineProperty = __webpack_require__(177);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineProperty(object, property, attr) {
  return (0, _defineProperty2.default)(object, property, attr);
}

// Passive options
// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
var passiveOption = exports.passiveOption = function () {
  var cache = null;

  return function () {
    if (cache !== null) {
      return cache;
    }

    var supportsPassiveOption = false;

    try {
      window.addEventListener('test', null, defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      }));
    } catch (err) {
      //
    }

    cache = supportsPassiveOption;

    return supportsPassiveOption;
  }();
}();

exports.default = {};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(22);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _createBreakpoints = __webpack_require__(93);

var _helpers = __webpack_require__(14);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };

  return _createBreakpoints.keys.reduce(function (acc, key) {
    acc['only' + (0, _helpers.capitalize)(key)] = (0, _defineProperty3.default)({}, theme.breakpoints.only(key), hidden);
    acc[key + 'Up'] = (0, _defineProperty3.default)({}, theme.breakpoints.up(key), hidden);
    acc[key + 'Down'] = (0, _defineProperty3.default)({}, theme.breakpoints.down(key), hidden);

    return acc;
  }, {});
};

/**
 * @ignore - internal component.
 */
function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'lgDown', 'lgUp', 'mdDown', 'mdUp', 'only', 'smDown', 'smUp', 'xlDown', 'xlUp', 'xsDown', 'xsUp']);


   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0 || (0, _keys2.default)(other).length === 1 && other.hasOwnProperty('ref'), 'Material-UI: unsupported properties received ' + (0, _keys2.default)(other).join(', ') + ' by `<Hidden />`.') : void 0;

  var classNames = [];

  if (className) {
    classNames.push(className);
  }

  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
    var breakpoint = _createBreakpoints.keys[i];
    var breakpointUp = props[breakpoint + 'Up'];
    var breakpointDown = props[breakpoint + 'Down'];

    if (breakpointUp) {
      classNames.push(classes[breakpoint + 'Up']);
    }
    if (breakpointDown) {
      classNames.push(classes[breakpoint + 'Down']);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      classNames.push(classes['only' + (0, _helpers.capitalize)(breakpoint)]);
    });
  }

  return _react2.default.createElement(
    'div',
    { className: classNames.join(' ') },
    children
  );
}

HiddenCss.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for server
   * side rendering.
   */
  implementation: _propTypes2.default.oneOf(['js', 'css']),
  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: _propTypes2.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: _propTypes2.default.bool,
  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: _propTypes2.default.bool,
  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: _propTypes2.default.bool
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiHiddenCss' })(HiddenCss);

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    },
    padding: {
      paddingTop: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    dense: {
      paddingTop: theme.spacing.unit / 2,
      paddingBottom: theme.spacing.unit / 2
    },
    subheader: {
      paddingTop: 0
    }
  };
};

var List = function (_React$Component) {
  (0, _inherits3.default)(List, _React$Component);

  function List() {
    (0, _classCallCheck3.default)(this, List);
    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
  }

  (0, _createClass3.default)(List, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        dense: this.props.dense
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          dense = _props.dense,
          disablePadding = _props.disablePadding,
          subheader = _props.subheader,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'component', 'dense', 'disablePadding', 'subheader']);

      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense && !disablePadding), (0, _defineProperty3.default)(_classNames, classes.padding, !disablePadding), (0, _defineProperty3.default)(_classNames, classes.subheader, subheader), _classNames), classNameProp);

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: className }, other),
        subheader,
        children
      );
    }
  }]);
  return List;
}(_react2.default.Component);

List.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes2.default.bool,
  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes2.default.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes2.default.node
} : {};

List.defaultProps = {
  component: 'ul',
  dense: false,
  disablePadding: false
};

List.childContextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiList' })(List);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: 36,
      height: 36,
      fontSize: theme.typography.pxToRem(18),
      marginRight: 4
    },
    icon: {
      width: 20,
      height: 20,
      fontSize: theme.typography.pxToRem(20)
    }
  };
};

/**
 * It's a simple wrapper to apply the `dense` mode styles to `Avatar`.
 */
function ListItemAvatar(props, context) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  if (context.dense === undefined) {
     false ? (0, _warning2.default)(false, 'Material-UI: <ListItemAvatar> is a simple wrapper to apply the dense styles\n      to <Avatar>. You do not need it unless you are controlling the <List> dense property.') : void 0;
    return props.children;
  }

  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.root, context.dense), classNameProp, children.props.className),
    childrenClassName: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.icon, context.dense), children.props.childrenClassName)
  }, other));
}

ListItemAvatar.propTypes =  false ? {
  /**
   * The content of the component, normally `Avatar`.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemAvatar.contextTypes = {
  dense: _propTypes2.default.bool
};

ListItemAvatar.muiName = 'ListItemAvatar';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemAvatar' })(ListItemAvatar);

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto',
      minWidth: 0,
      padding: '0 16px',
      '&:first-child': {
        paddingLeft: 0
      }
    },
    inset: {
      '&:first-child': {
        paddingLeft: theme.spacing.unit * 7
      }
    },
    dense: {
      fontSize: theme.typography.pxToRem(13)
    },
    primary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    secondary: {
      '&$textDense': {
        fontSize: 'inherit'
      }
    },
    textDense: {}
  };
};

function ListItemText(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      disableTypography = props.disableTypography,
      inset = props.inset,
      primary = props.primary,
      secondary = props.secondary,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'disableTypography', 'inset', 'primary', 'secondary']);
  var dense = context.dense;

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.dense, dense), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    primary && (disableTypography ? primary : _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'subheading',
        className: (0, _classnames2.default)(classes.primary, (0, _defineProperty3.default)({}, classes.textDense, dense))
      },
      primary
    )),
    secondary && (disableTypography ? secondary : _react2.default.createElement(
      _Typography2.default,
      {
        variant: 'body1',
        className: (0, _classnames2.default)(classes.secondary, (0, _defineProperty3.default)({}, classes.textDense, dense)),
        color: 'textSecondary'
      },
      secondary
    ))
  );
}

ListItemText.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, that can be useful to can render an h4 instead of a
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: _propTypes2.default.bool,
  primary: _propTypes2.default.node,
  secondary: _propTypes2.default.node
} : {};

ListItemText.defaultProps = {
  disableTypography: false,
  inset: false,
  primary: false,
  secondary: false
};

ListItemText.contextTypes = {
  dense: _propTypes2.default.bool
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemText' })(ListItemText);

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 24,
      marginRight: theme.spacing.unit * 2,
      width: 24,
      color: theme.palette.action.active,
      flexShrink: 0
    }
  };
};

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
function ListItemIcon(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.cloneElement(children, (0, _extends3.default)({
    className: (0, _classnames2.default)(classes.root, classNameProp, children.props.className)
  }, other));
}

ListItemIcon.propTypes =  false ? {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `material-ui-icons` SVG icon component.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemIcon' })(ListItemIcon);

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      right: 4,
      top: '50%',
      marginTop: -theme.spacing.unit * 3
    }
  };
};

function ListItemSecondaryAction(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ListItemSecondaryAction.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListItemSecondaryAction' })(ListItemSecondaryAction);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorInherit: {
      color: 'inherit'
    },
    inset: {
      paddingLeft: theme.spacing.unit * 9
    },
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};

function ListSubheader(props) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      Component = props.component,
      disableSticky = props.disableSticky,
      inset = props.inset,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'component', 'disableSticky', 'inset']);

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'), (0, _defineProperty3.default)(_classNames, classes.inset, inset), (0, _defineProperty3.default)(_classNames, classes.sticky, !disableSticky), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

ListSubheader.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'inherit']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes2.default.bool,
  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: _propTypes2.default.bool
} : {};

ListSubheader.defaultProps = {
  color: 'default',
  component: 'li',
  disableSticky: false,
  inset: false
};

ListSubheader.muiName = 'ListSubheader';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiListSubheader' })(ListSubheader);

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      height: 1,
      margin: 0, // Reset browser default style.
      border: 'none',
      flexShrink: 0
    },
    inset: {
      marginLeft: 72
    },
    default: {
      backgroundColor: theme.palette.divider
    },
    light: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
    },
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    }
  };
};

function Divider(props) {
  var _classNames;

  var absolute = props.absolute,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      inset = props.inset,
      light = props.light,
      other = (0, _objectWithoutProperties3.default)(props, ['absolute', 'classes', 'className', 'component', 'inset', 'light']);


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.absolute, absolute), (0, _defineProperty3.default)(_classNames, classes.inset, inset), _classNames), light ? classes.light : classes.default, classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Divider.propTypes =  false ? {
  absolute: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the divider will be indented.
   */
  inset: _propTypes2.default.bool,
  /**
   * If `true`, the divider will have a lighter color.
   */
  light: _propTypes2.default.bool
} : {};

Divider.defaultProps = {
  absolute: false,
  component: 'hr',
  inset: false,
  light: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDivider' })(Divider);

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' });

var HighlightOff = function HighlightOff(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

HighlightOff = (0, _pure2.default)(HighlightOff);
HighlightOff.muiName = 'SvgIcon';

exports.default = HighlightOff;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1,
      padding: 0
    },
    focused: {
      color: theme.palette.primary[theme.palette.type === 'light' ? 'dark' : 'light']
    },
    error: {
      color: theme.palette.error.main
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
};

function FormLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      disabledProp = props.disabled,
      errorProp = props.error,
      focusedProp = props.focused,
      requiredProp = props.required,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'component', 'disabled', 'error', 'focused', 'required']);
  var muiFormControl = context.muiFormControl;


  var required = requiredProp;
  var focused = focusedProp;
  var disabled = disabledProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }
    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.focused, focused), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.error, error), _classNames), classNameProp);

  var asteriskClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.error, error));

  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: className }, other),
    children,
    required && _react2.default.createElement(
      'span',
      { className: asteriskClassName },
      '\u2009*'
    )
  );
}

FormLabel.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes2.default.bool,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool
} : {};

FormLabel.defaultProps = {
  component: 'label'
};

FormLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormLabel' })(FormLabel);

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROWS_HEIGHT = 19;

var styles = exports.styles = {
  root: {
    position: 'relative', // because the shadow has position: 'absolute',
    width: '100%'
  },
  textarea: {
    width: '100%',
    height: '100%',
    resize: 'none',
    font: 'inherit',
    padding: 0,
    cursor: 'inherit',
    boxSizing: 'border-box',
    lineHeight: 'inherit',
    border: 'none',
    outline: 'none',
    background: 'transparent'
  },
  shadow: {
    resize: 'none',
    // Overflow also needed to here to remove the extra row
    // added to textareas in Firefox.
    overflow: 'hidden',
    // Visibility needed to hide the extra text area on ipads
    visibility: 'hidden',
    position: 'absolute',
    height: 'auto',
    whiteSpace: 'pre-wrap'
  }
};

/**
 * @ignore - internal component.
 */

var Textarea = function (_React$Component) {
  (0, _inherits3.default)(Textarea, _React$Component);

  function Textarea() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Textarea.__proto__ || (0, _getPrototypeOf2.default)(Textarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: null
    }, _this.shadow = null, _this.singlelineShadow = null, _this.input = null, _this.value = null, _this.handleResize = (0, _debounce2.default)(function (event) {
      _this.syncHeightWithShadow(event);
    }, 166), _this.handleRefInput = function (node) {
      _this.input = node;
      if (_this.props.textareaRef) {
        _this.props.textareaRef(node);
      }
    }, _this.handleRefSinglelineShadow = function (node) {
      _this.singlelineShadow = node;
    }, _this.handleRefShadow = function (node) {
      _this.shadow = node;
    }, _this.handleChange = function (event) {
      _this.value = event.target.value;

      if (typeof _this.props.value === 'undefined' && _this.shadow) {
        // The component is not controlled, we need to update the shallow value.
        _this.shadow.value = _this.value;
        _this.syncHeightWithShadow(event);
      }

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Textarea, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // <Input> expects the components it renders to respond to 'value'
      // so that it can check whether they are dirty
      this.value = this.props.value || this.props.defaultValue || '';
      this.setState({
        height: Number(this.props.rows) * ROWS_HEIGHT
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncHeightWithShadow(null);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value || Number(nextProps.rowsMax) !== Number(this.props.rowsMax)) {
        this.syncHeightWithShadow(null, nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'syncHeightWithShadow',
    value: function syncHeightWithShadow(event) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;

      if (this.shadow && this.singlelineShadow) {
        // The component is controlled, we need to update the shallow value.
        if (typeof this.props.value !== 'undefined') {
          this.shadow.value = props.value == null ? '' : String(props.value);
        }

        var lineHeight = this.singlelineShadow.scrollHeight;
        var newHeight = this.shadow.scrollHeight;

        // Guarding for jsdom, where scrollHeight isn't present.
        // See https://github.com/tmpvar/jsdom/issues/1013
        if (newHeight === undefined) {
          return;
        }

        if (Number(props.rowsMax) >= Number(props.rows)) {
          newHeight = Math.min(Number(props.rowsMax) * lineHeight, newHeight);
        }

        newHeight = Math.max(newHeight, lineHeight);

        if (this.state.height !== newHeight) {
          this.setState({
            height: newHeight
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          className = _props.className,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          rows = _props.rows,
          rowsMax = _props.rowsMax,
          textareaRef = _props.textareaRef,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'defaultValue', 'onChange', 'rows', 'rowsMax', 'textareaRef', 'value']);


      return _react2.default.createElement(
        'div',
        { className: classes.root, style: { height: this.state.height } },
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefSinglelineShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: '1',
          readOnly: true,
          'aria-hidden': 'true',
          value: ''
        }),
        _react2.default.createElement('textarea', {
          ref: this.handleRefShadow,
          className: (0, _classnames2.default)(classes.shadow, classes.textarea),
          tabIndex: -1,
          rows: rows,
          'aria-hidden': 'true',
          readOnly: true,
          defaultValue: defaultValue,
          value: value
        }),
        _react2.default.createElement('textarea', (0, _extends3.default)({
          rows: rows,
          className: (0, _classnames2.default)(classes.textarea, className),
          defaultValue: defaultValue,
          value: value,
          onChange: this.handleChange,
          ref: this.handleRefInput
        }, other))
      );
    }
  }]);
  return Textarea;
}(_react2.default.Component);

Textarea.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * @ignore
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Use that property to pass a ref callback to the native textarea element.
   */
  textareaRef: _propTypes2.default.func,
  /**
   * @ignore
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
} : {};

Textarea.defaultProps = {
  rows: 1
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTextarea' })(Textarea);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -14,
      marginRight: theme.spacing.unit * 2 // used for row presentation of radio/checkbox
    },
    disabled: {
      color: theme.palette.text.disabled,
      cursor: 'default'
    },
    label: {}
  };
};

/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
/* eslint-disable jsx-a11y/label-has-for */

function FormControlLabel(props, context) {
  var checked = props.checked,
      classes = props.classes,
      classNameProp = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['checked', 'classes', 'className', 'control', 'disabled', 'inputRef', 'label', 'name', 'onChange', 'value']);
  var muiFormControl = context.muiFormControl;

  var disabled = disabledProp;

  if (typeof control.props.disabled !== 'undefined') {
    if (typeof disabled === 'undefined') {
      disabled = control.props.disabled;
    }
  }

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp);

  return _react2.default.createElement(
    'label',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.cloneElement(control, {
      disabled: disabled,
      checked: typeof control.props.checked === 'undefined' ? checked : control.props.checked,
      name: control.props.name || name,
      onChange: control.props.onChange || onChange,
      value: control.props.value || value,
      inputRef: control.props.inputRef || inputRef
    }),
    _react2.default.createElement(
      _Typography2.default,
      { component: 'span', className: classes.label },
      label
    )
  );
}

FormControlLabel.propTypes =  false ? {
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes2.default.element,
  /**
   * If `true`, the control will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The text to be used in an enclosing label element.
   */
  label: _propTypes2.default.node,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

FormControlLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiFormControlLabel' })(FormControlLabel);

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Card(props) {
  var raised = props.raised,
      other = (0, _objectWithoutProperties3.default)(props, ['raised']);


  return _react2.default.createElement(_Paper2.default, (0, _extends3.default)({ elevation: raised ? 8 : 2 }, other));
} // @inheritedComponent Paper

Card.propTypes =  false ? {
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the card will use raised styling.
   */
  raised: _propTypes2.default.bool
} : {};

Card.defaultProps = {
  raised: false
};

exports.default = Card;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var shadows = {};
  theme.shadows.forEach(function (shadow, index) {
    shadows['shadow' + index] = {
      boxShadow: shadow
    };
  });

  return (0, _extends3.default)({
    root: {
      backgroundColor: theme.palette.background.paper
    },
    rounded: {
      borderRadius: 2
    }
  }, shadows);
};

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'square', 'elevation']);


   false ? (0, _warning2.default)(elevation >= 0 && elevation < 25, 'Material-UI: this elevation `' + elevation + '` is not implemented.') : void 0;

  var className = (0, _classnames2.default)(classes.root, classes['shadow' + elevation], (0, _defineProperty3.default)({}, classes.rounded, !square), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes2.default.number,
  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes2.default.bool
} : {};

Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPaper' })(Paper);

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      padding: theme.spacing.unit * 2,
      '&:last-child': {
        paddingBottom: theme.spacing.unit * 3
      }
    }
  };
};

function CardContent(props) {
  var classes = props.classes,
      className = props.className,
      Component = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component']);


  return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other));
}

CardContent.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

CardContent.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardContent' })(CardContent);

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    height: 52,
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    boxSizing: 'border-box'
  },
  action: {
    margin: '0 4px'
  }
};

function CardActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['disableActionSpacing', 'children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

CardActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the card actions do not have additional margin.
   */
  disableActionSpacing: _propTypes2.default.bool
} : {};

CardActions.defaultProps = {
  disableActionSpacing: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardActions' })(CardActions);

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  rootMedia: {
    width: '100%'
  }
};

var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];

function CardMedia(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      Component = props.component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'image', 'src', 'style']);


   false ? (0, _warning2.default)(Boolean(image || src), 'Material-UI: either `image` or `src` property must be specified.') : void 0;

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0, _extends3.default)({ backgroundImage: 'url(' + image + ')' }, style) : style;
  var composedClassName = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.root, !isMediaComponent), (0, _defineProperty3.default)(_classNames, classes.rootMedia, isMediaComponent), _classNames), className);

  return _react2.default.createElement(Component, (0, _extends3.default)({
    className: composedClassName,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other));
}

CardMedia.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes2.default.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes2.default.string,
  /**
   * @ignore
   */
  style: _propTypes2.default.object
} : {};

CardMedia.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardMedia' })(CardMedia);

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing.unit * 2
    },
    avatar: {
      flex: '0 0 auto',
      marginRight: theme.spacing.unit * 2
    },
    action: {
      flex: '0 0 auto',
      alignSelf: 'flex-start',
      marginTop: theme.spacing.unit * -1,
      marginRight: theme.spacing.unit * -2
    },
    content: {
      flex: '1 1 auto'
    },
    title: {},
    subheader: {}
  };
};

function CardHeader(props) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      subheader = props.subheader,
      title = props.title,
      other = (0, _objectWithoutProperties3.default)(props, ['action', 'avatar', 'classes', 'className', 'component', 'subheader', 'title']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    avatar && _react2.default.createElement(
      'div',
      { className: classes.avatar },
      avatar
    ),
    _react2.default.createElement(
      'div',
      { className: classes.content },
      _react2.default.createElement(
        _Typography2.default,
        {
          variant: avatar ? 'body2' : 'headline',
          component: 'span',
          className: classes.title
        },
        title
      ),
      subheader && _react2.default.createElement(
        _Typography2.default,
        {
          variant: avatar ? 'body2' : 'body1',
          component: 'span',
          color: 'textSecondary',
          className: classes.subheader
        },
        subheader
      )
    ),
    action && _react2.default.createElement(
      'div',
      { className: classes.action },
      action
    )
  );
}

CardHeader.propTypes =  false ? {
  /**
   * The action to display in the card header.
   */
  action: _propTypes2.default.node,
  /**
   * The Avatar for the Card Header.
   */
  avatar: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The content of the component.
   */
  subheader: _propTypes2.default.node,
  /**
   * The content of the Card Title.
   */
  title: _propTypes2.default.node
} : {};

CardHeader.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCardHeader' })(CardHeader);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FacebookShareCount__ = __webpack_require__(771);
/* unused harmony reexport FacebookShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlusShareCount__ = __webpack_require__(775);
/* unused harmony reexport GooglePlusShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkedinShareCount__ = __webpack_require__(778);
/* unused harmony reexport LinkedinShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PinterestShareCount__ = __webpack_require__(779);
/* unused harmony reexport PinterestShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VKShareCount__ = __webpack_require__(780);
/* unused harmony reexport VKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OKShareCount__ = __webpack_require__(781);
/* unused harmony reexport OKShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RedditShareCount__ = __webpack_require__(782);
/* unused harmony reexport RedditShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TumblrShareCount__ = __webpack_require__(783);
/* unused harmony reexport TumblrShareCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__ = __webpack_require__(784);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__FacebookShareButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GooglePlusShareButton__ = __webpack_require__(788);
/* unused harmony reexport GooglePlusShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LinkedinShareButton__ = __webpack_require__(789);
/* unused harmony reexport LinkedinShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TwitterShareButton__ = __webpack_require__(790);
/* unused harmony reexport TwitterShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PinterestShareButton__ = __webpack_require__(791);
/* unused harmony reexport PinterestShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__VKShareButton__ = __webpack_require__(792);
/* unused harmony reexport VKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OKShareButton__ = __webpack_require__(793);
/* unused harmony reexport OKShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TelegramShareButton__ = __webpack_require__(794);
/* unused harmony reexport TelegramShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__WhatsappShareButton__ = __webpack_require__(795);
/* unused harmony reexport WhatsappShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__RedditShareButton__ = __webpack_require__(796);
/* unused harmony reexport RedditShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__EmailShareButton__ = __webpack_require__(797);
/* unused harmony reexport EmailShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TumblrShareButton__ = __webpack_require__(798);
/* unused harmony reexport TumblrShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__LivejournalShareButton__ = __webpack_require__(799);
/* unused harmony reexport LivejournalShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__MailruShareButton__ = __webpack_require__(800);
/* unused harmony reexport MailruShareButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FacebookIcon__ = __webpack_require__(801);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_22__FacebookIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__TwitterIcon__ = __webpack_require__(802);
/* unused harmony reexport TwitterIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__GooglePlusIcon__ = __webpack_require__(803);
/* unused harmony reexport GooglePlusIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__LinkedinIcon__ = __webpack_require__(804);
/* unused harmony reexport LinkedinIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__PinterestIcon__ = __webpack_require__(805);
/* unused harmony reexport PinterestIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__VKIcon__ = __webpack_require__(806);
/* unused harmony reexport VKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__OKIcon__ = __webpack_require__(807);
/* unused harmony reexport OKIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__TelegramIcon__ = __webpack_require__(808);
/* unused harmony reexport TelegramIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__WhatsappIcon__ = __webpack_require__(809);
/* unused harmony reexport WhatsappIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__RedditIcon__ = __webpack_require__(810);
/* unused harmony reexport RedditIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__TumblrIcon__ = __webpack_require__(811);
/* unused harmony reexport TumblrIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__MailruIcon__ = __webpack_require__(812);
/* unused harmony reexport MailruIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__EmailIcon__ = __webpack_require__(813);
/* unused harmony reexport EmailIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__LivejournalIcon__ = __webpack_require__(814);
/* unused harmony reexport LivejournalIcon */







































/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(57);




function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getFacebookShareCount));

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(773);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)))

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(774);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);




function getGooglePlusShareCount(shareUrl, callback) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_ieDetection__["a" /* default */])(11)) {
    /* eslint-disable no-console */
    console.error('Google plus share count is not supported in <=IE10!');
    /* eslint-enable no-console */
    return;
  }

  var xhr = new XMLHttpRequest();

  xhr.open('POST', 'https://clients6.google.com/rpc');
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8');

  xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    method: 'pos.plusones.get',
    id: 'p',
    params: {
      nolog: true,
      id: shareUrl,
      source: 'widget',
      userId: '@viewer',
      groupId: '@self'
    },
    jsonrpc: '2.0',
    key: 'p',
    apiVersion: 'v1'
  }));

  xhr.onload = function onSuccessdata() {
    var data = JSON.parse(this.responseText);
    callback(data ? data.result.metadata.globalCounts.count : undefined);
  };

  xhr.onerror = function onErrordata() {};
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getGooglePlusShareCount));

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(777), __esModule: true };

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(21);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);





function getLinkedinShareCount(shareUrl, callback) {
  var url = 'https://www.linkedin.com/countserv/count/share';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl,
    format: 'jsonp'
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getLinkedinShareCount));

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);





function getPinterestShareCount(shareUrl, callback) {
  var url = 'https://api.pinterest.com/v1/urls/count.json';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getPinterestShareCount));

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);





function getVKShareCount(shareUrl, callback) {
  if (!window.VK) {
    window.VK = {
      Share: {
        count: function count(index, _count) {
          return window.VK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://vk.com/share.php';
  var index = window.VK.callbacks.length;

  window.VK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    act: 'count',
    index: index,
    url: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getVKShareCount));

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);





function getOKShareCount(shareUrl, callback) {
  if (!window.OK) {
    window.OK = {
      Share: {
        count: function count(index, _count) {
          return window.OK.callbacks[index](_count);
        }
      },
      callbacks: []
    };
  }

  var url = 'https://connect.ok.ru/dk';
  var index = window.OK.callbacks.length;

  window.ODKL = {
    updateCount: function updateCount(a, b) {
      window.OK.callbacks[index](b);
    }
  };
  window.OK.callbacks.push(callback);

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(url + (0, __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    'st.cmd': 'extLike',
    uid: 'odklcnt0',
    ref: shareUrl
  }));
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getOKShareCount));

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__ = __webpack_require__(57);




function getRedditShareCount(shareUrl, callback) {
  var endpoint = 'https://www.reddit.com/api/info.json?limit=1&url=' + shareUrl;

  __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint, { param: 'jsonp' }, function (err, response) {
    callback(!err && response && response.data && response.data.children.length > 0 && response.data.children[0].data.score ? response.data.children[0].data.score : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_shareCountFactory__["a" /* default */])(getRedditShareCount));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__ = __webpack_require__(57);





function getTumblrShareCount(shareUrl, callback) {
  var endpoint = 'http://api.tumblr.com/v2/share/stats';

  return __WEBPACK_IMPORTED_MODULE_0_jsonp___default()(endpoint + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({
    url: shareUrl
  }), function (err, data) {
    callback(data ? data.note_count : undefined);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2__utils_shareCountFactory__["a" /* default */])(getTumblrShareCount));

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function facebookLink(url, _ref) {
  var quote = _ref.quote,
      hashtag = _ref.hashtag;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'facebook.url');

  return 'https://www.facebook.com/sharer/sharer.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    u: url,
    quote: quote,
    hashtag: hashtag
  });
}

var FacebookShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('facebook', facebookLink, function (props) {
  /* eslint-disable no-console */
  if (props.picture) {
    console.warn('FacebookShareButton warning: picture is a deprecated prop.');
  }

  if (props.title) {
    console.warn('FacebookShareButton warning: title is a deprecated prop. Use "quote" instead.');
  }

  if (props.description) {
    console.warn('FacebookShareButton warning: description is a deprecated prop.\n      Use "quote" instead.');
  }
  /* eslint-enable no-console */

  return {
    quote: props.quote,
    hashtag: props.hashtag
  };
}, {
  quote: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  hashtag: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookShareButton);

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":""}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(786);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(787);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(220)))

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 787 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(29);





function googlePlusLink(url) {
  __WEBPACK_IMPORTED_MODULE_0_assert___default()(url, 'googlePlus.url');

  return 'https://plus.google.com/share' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ url: url });
}

var GooglePlusShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('googlePlus', googlePlusLink, undefined, undefined, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusShareButton);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function linkedinLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'linkedin.url');

  return 'https://linkedin.com/shareArticle' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    summary: description
  });
}

var LinkedinShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('linkedin', linkedinLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 750,
  windowHeight: 600
});

/* unused harmony default export */ var _unused_webpack_default_export = (LinkedinShareButton);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function twitterLink(url, _ref) {
  var title = _ref.title,
      via = _ref.via,
      _ref$hashtags = _ref.hashtags,
      hashtags = _ref$hashtags === undefined ? [] : _ref$hashtags;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'twitter.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(Array.isArray(hashtags), 'twitter.hashtags is not an array');

  return 'https://twitter.com/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title,
    via: via,
    hashtags: hashtags.join(',')
  });
}

var TwitterShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('twitter', twitterLink, function (props) {
  return {
    hashtags: props.hashtags,
    title: props.title,
    via: props.via
  };
}, {
  hashtags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string),
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (TwitterShareButton);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function pinterestLink(url, _ref) {
  var media = _ref.media,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'pinterest.url');
  __WEBPACK_IMPORTED_MODULE_1_assert___default()(media, 'pinterest.media');

  return 'https://pinterest.com/pin/create/button/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    media: media,
    description: description
  });
}

var PinterestShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('pinterest', pinterestLink, function (props) {
  return {
    media: props.media,
    description: props.description
  };
}, {
  media: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 1000,
  windowHeight: 730
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestShareButton);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function vkLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'vk.url');

  return 'https://vk.com/share.php' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    image: image
  });
}

var VKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('vk', vkLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKShareButton);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function okLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'ok.url');

  return 'https://connect.ok.ru/offer' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageUrl: image
  });
}

var OKShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('ok', okLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKShareButton);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function telegramLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'telegram.url');

  return 'https://telegram.me/share/' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    text: title
  });
}

var TelegramShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('telegram', telegramLink, function (props) {
  return {
    title: props.title,
    via: props.via
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  via: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramShareButton);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function whatsappLink(url, _ref) {
  var title = _ref.title,
      separator = _ref.separator;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'whatsapp.url');
  return 'https://api.whatsapp.com/send' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    text: title ? title + separator + url : url
  });
}

var WhatsappShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('whatsapp', whatsappLink, function (props) {
  return {
    title: props.title,
    separator: props.separator
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  separator: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  separator: ' ',
  windowWidth: 550,
  windowHeight: 400
});

/* unused harmony default export */ var _unused_webpack_default_export = (WhatsappShareButton);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function redditLink(url, _ref) {
  var title = _ref.title;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'reddit.url');

  return 'https://www.reddit.com/submit' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title
  });
}

var RedditShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('reddit', redditLink, function (props) {
  return {
    title: props.title
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (RedditShareButton);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__ = __webpack_require__(29);





function emailLink(url, _ref) {
  var subject = _ref.subject,
      body = _ref.body;

  return 'mailto:' + Object(__WEBPACK_IMPORTED_MODULE_1__utils_objectToGetParams__["a" /* default */])({ subject: subject, body: body || subject });
}

var EmailShareButton = Object(__WEBPACK_IMPORTED_MODULE_2__utils_createShareButton__["a" /* default */])('email', emailLink, function (props) {
  return {
    subject: props.subject,
    body: props.body
  };
}, {
  subject: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  body: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  openWindow: false,
  onClick: function onClick(link) {
    window.location.href = link;
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (EmailShareButton);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function tumblrLink(url, _ref) {
  var title = _ref.title,
      caption = _ref.caption,
      tags = _ref.tags,
      posttype = _ref.posttype;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'tumblr.url');

  return 'https://www.tumblr.com/widgets/share/tool' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    canonicalUrl: url,
    title: title,
    caption: caption,
    tags: tags,
    posttype: posttype
  });
}

var TumblrShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('tumblr', tumblrLink, function (props) {
  return {
    title: props.title,
    tags: props.tags.join(','),
    caption: props.caption,
    posttype: props.posttype
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  caption: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  posttype: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  tags: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)
}, {
  tags: [],
  posttype: 'link',
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrShareButton);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function livejournalLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'livejournal.url');

  return 'https://www.livejournal.com/update.bml' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    subject: title,
    event: description
  });
}

var LivejournalShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('livejournal', livejournalLink, function (props) {
  return {
    title: props.title,
    description: props.description
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalShareButton);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_assert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_assert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__ = __webpack_require__(29);







function mailruLink(url, _ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image;

  __WEBPACK_IMPORTED_MODULE_1_assert___default()(url, 'mailru.url');

  return 'https://connect.mail.ru/share' + Object(__WEBPACK_IMPORTED_MODULE_2__utils_objectToGetParams__["a" /* default */])({
    url: url,
    title: title,
    description: description,
    imageurl: image
  });
}

var MailruShareButton = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createShareButton__["a" /* default */])('mailru', mailruLink, function (props) {
  return {
    title: props.title,
    description: props.description,
    image: props.image
  };
}, {
  title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  image: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
}, {
  windowWidth: 660,
  windowHeight: 460
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruShareButton);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var FacebookIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('facebook', {
  icon: 'M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z',
  mask: 'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
  color: '#3b5998'
});

/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var TwitterIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('twitter', {
  icon: 'M48,22.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C41.7,19.8,40,19,38.2,19c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8c0,0,0,0.1,0,0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1c2.9,1.9,6.4,2.9,10.1,2.9c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C46,24.5,47.1,23.4,48,22.1z',
  mask: 'M0,0v64h64V0H0z M44.7,25.5c0,0.3,0,0.6,0,0.8C44.7,35,38.1,45,26.1,45c-3.7,0-7.2-1.1-10.1-2.9 c0.5,0.1,1,0.1,1.6,0.1c3.1,0,5.9-1,8.2-2.8c-2.9-0.1-5.3-2-6.1-4.6c0.4,0.1,0.8,0.1,1.2,0.1c0.6,0,1.2-0.1,1.7-0.2 c-3-0.6-5.3-3.3-5.3-6.4c0,0,0-0.1,0-0.1c0.9,0.5,1.9,0.8,3,0.8c-1.8-1.2-2.9-3.2-2.9-5.5c0-1.2,0.3-2.3,0.9-3.3 c3.2,4,8.1,6.6,13.5,6.9c-0.1-0.5-0.2-1-0.2-1.5c0-3.6,2.9-6.6,6.6-6.6c1.9,0,3.6,0.8,4.8,2.1c1.5-0.3,2.9-0.8,4.2-1.6 c-0.5,1.5-1.5,2.8-2.9,3.6c1.3-0.2,2.6-0.5,3.8-1C47.1,23.4,46,24.5,44.7,25.5z',
  color: '#00aced'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TwitterIcon);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var GooglePlusIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('google', {
  icon: 'M25.3,30.1v3.8h6.3c-0.3,1.6-1.9,4.8-6.3,4.8c-3.8,0-6.9-3.1-6.9-7s3.1-7,6.9-7c2.2,0,3.6,0.9,4.4,1.7l3-2.9c-1.9-1.8-4.4-2.9-7.4-2.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1c6.4,0,10.7-4.5,10.7-10.9c0-0.7-0.1-1.3-0.2-1.8H25.3L25.3,30.1z M49.8,28.9h-3.2v-3.2h-3.2v3.2h-3.2v3.2h3.2v3.2h3.2v-3.2h3.2',
  mask: 'M0,0v64h64V0H0z M31.3,19.1c0.3,0.3,0.6,0.7,0.9,1.2c0.3,0.4,0.5,0.9,0.7,1.5c0.2,0.6,0.3,1.3,0.3,2.1 c0,1.4-0.3,2.6-0.9,3.4c-0.3,0.4-0.6,0.8-0.9,1.2c-0.4,0.4-0.8,0.7-1.2,1.1c-0.2,0.2-0.5,0.5-0.7,0.8c-0.2,0.3-0.4,0.7-0.4,1.1 c0,0.4,0.1,0.8,0.4,1c0.2,0.3,0.4,0.5,0.6,0.7l1.4,1.1c0.8,0.7,1.6,1.5,2.2,2.3c0.6,0.8,0.9,2,0.9,3.3c0,1.9-0.9,3.7-2.6,5.2 c-1.8,1.6-4.3,2.4-7.7,2.4c-2.8,0-4.9-0.6-6.3-1.8c-1.4-1.1-2.1-2.4-2.1-3.9c0-0.7,0.2-1.6,0.7-2.5c0.4-0.9,1.2-1.7,2.4-2.4 c1.3-0.7,2.7-1.2,4.1-1.5c1.4-0.2,2.6-0.3,3.5-0.4c-0.3-0.4-0.5-0.8-0.8-1.2c-0.3-0.4-0.4-0.9-0.4-1.5c0-0.4,0-0.6,0.2-0.9 c0.1-0.2,0.2-0.5,0.2-0.7c-0.5,0.1-0.9,0.1-1.3,0.1c-2.1,0-3.8-0.7-4.9-2c-1.2-1.2-1.8-2.7-1.8-4.3c0-2,0.8-3.8,2.5-5.4 c1.1-0.9,2.3-1.6,3.5-1.8c1.2-0.2,2.3-0.4,3.4-0.4h8L33,18.4h-2.5C30.7,18.6,31,18.8,31.3,19.1z M48,32h-4.3v4.2h-2.5V32H37v-2.5 h4.2v-4.3h2.5v4.3H48V32z M27.1,19.1c-0.6-0.5-1.4-0.7-2.2-0.7c-1.1,0-2,0.5-2.7,1.3c-0.6,0.9-0.9,1.9-0.9,3c0,1.5,0.4,3,1.3,4.5 c0.4,0.7,0.9,1.4,1.6,1.9c0.6,0.5,1.4,0.8,2.2,0.8c1.1,0,1.9-0.4,2.6-1.1c0.3-0.5,0.6-1,0.7-1.6c0.1-0.5,0.1-1,0.1-1.4 c0-1.6-0.4-3.2-1.2-4.8C28.2,20.2,27.7,19.5,27.1,19.1z M26.9,36.2c-0.2,0-0.7,0-1.6,0.1c-0.8,0.1-1.7,0.3-2.5,0.6 c-0.2,0.1-0.5,0.2-0.9,0.4c-0.4,0.2-0.7,0.4-1.1,0.7c-0.4,0.3-0.7,0.7-0.9,1.2c-0.3,0.5-0.4,1.1-0.4,1.8c0,1.4,0.6,2.6,1.9,3.5 c1.2,0.9,2.9,1.4,5,1.4c1.9,0,3.3-0.4,4.3-1.3c1-0.8,1.5-1.8,1.5-3.1c0-1-0.3-1.9-1-2.7c-0.7-0.7-1.8-1.6-3.3-2.6 C27.5,36.2,27.2,36.2,26.9,36.2z',
  color: '#dd4b39'
});

/* unused harmony default export */ var _unused_webpack_default_export = (GooglePlusIcon);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var LinkedinIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('linkedin', {
  icon: 'M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z',
  mask: 'M0,0v64h64V0H0z M25.8,44h-5.4V26.6h5.4V44z M23.1,24.3c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 c1.7,0,3.1,1.4,3.1,3.1C26.2,22.9,24.8,24.3,23.1,24.3z M46,44h-5.4v-8.4c0-2,0-4.6-2.8-4.6c-2.8,0-3.2,2.2-3.2,4.5V44h-5.4V26.6 h5.2V29h0.1c0.7-1.4,2.5-2.8,5.1-2.8c5.5,0,6.5,3.6,6.5,8.3V44z',
  color: '#007fb1'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LinkedinIcon);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var PinterestIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('pinterest', {
  icon: 'M32,16c-8.8,0-16,7.2-16,16c0,6.6,3.9,12.2,9.6,14.7c0-1.1,0-2.5,0.3-3.7 c0.3-1.3,2.1-8.7,2.1-8.7s-0.5-1-0.5-2.5c0-2.4,1.4-4.1,3.1-4.1c1.5,0,2.2,1.1,2.2,2.4c0,1.5-0.9,3.7-1.4,5.7 c-0.4,1.7,0.9,3.1,2.5,3.1c3,0,5.1-3.9,5.1-8.5c0-3.5-2.4-6.1-6.7-6.1c-4.9,0-7.9,3.6-7.9,7.7c0,1.4,0.4,2.4,1.1,3.1 c0.3,0.3,0.3,0.5,0.2,0.9c-0.1,0.3-0.3,1-0.3,1.3c-0.1,0.4-0.4,0.6-0.8,0.4c-2.2-0.9-3.3-3.4-3.3-6.1c0-4.5,3.8-10,11.4-10 c6.1,0,10.1,4.4,10.1,9.2c0,6.3-3.5,11-8.6,11c-1.7,0-3.4-0.9-3.9-2c0,0-0.9,3.7-1.1,4.4c-0.3,1.2-1,2.5-1.6,3.4 c1.4,0.4,3,0.7,4.5,0.7c8.8,0,16-7.2,16-16C48,23.2,40.8,16,32,16z',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#cb2128'
});

/* unused harmony default export */ var _unused_webpack_default_export = (PinterestIcon);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var VKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('vk', {
  icon: 'M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  mask: 'M0,0v64h64V0H0z M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z',
  color: '#45668e'
});

/* unused harmony default export */ var _unused_webpack_default_export = (VKIcon);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var OKIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('ok', {
  icon: 'M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z ',
  mask: 'M45,1H5C2.8,1,1,2.8,1,5v40c0,2.2,1.8,4,4,4h40c2.2,0,4-1.8,4-4V5C49,2.8,47.2,1,45,1z',
  color: '#f2720c'
});

/* unused harmony default export */ var _unused_webpack_default_export = (OKIcon);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var TelegramIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('telegram', {
  icon: 'm45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#37aee2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TelegramIcon);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var WhatsappIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('whatsapp', {
  icon: 'm42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915',
  mask: 'M0,0v64h64V0H0z M32,48c-1.6,0-3.1-0.2-4.5-0.7c0.6-1,1.3-2.2,1.6-3.4c0.2-0.7,1.1-4.4,1.1-4.4 c0.6,1.1,2.2,2,3.9,2c5.1,0,8.6-4.7,8.6-11c0-4.7-4-9.2-10.1-9.2c-7.6,0-11.4,5.5-11.4,10c0,2.8,1,5.2,3.3,6.1 c0.4,0.1,0.7,0,0.8-0.4c0.1-0.3,0.2-1,0.3-1.3c0.1-0.4,0.1-0.5-0.2-0.9c-0.6-0.8-1.1-1.7-1.1-3.1c0-4,3-7.7,7.9-7.7 c4.3,0,6.7,2.6,6.7,6.1c0,4.6-2,8.5-5.1,8.5c-1.7,0-2.9-1.4-2.5-3.1c0.5-2,1.4-4.2,1.4-5.7c0-1.3-0.7-2.4-2.2-2.4 c-1.7,0-3.1,1.8-3.1,4.1c0,1.5,0.5,2.5,0.5,2.5s-1.8,7.4-2.1,8.7c-0.3,1.2-0.3,2.6-0.3,3.7C19.9,44.2,16,38.6,16,32 c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16C48,40.8,40.8,48,32,48z',
  color: '#2cb742'
});

/* unused harmony default export */ var _unused_webpack_default_export = (WhatsappIcon);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var RedditIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('reddit', {
  icon: 'm 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z',
  color: '#5f99cf'
});

/* unused harmony default export */ var _unused_webpack_default_export = (RedditIcon);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var TumblrIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('tumblr', {
  icon: 'M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#2c4762'
});

/* unused harmony default export */ var _unused_webpack_default_export = (TumblrIcon);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var MailruIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('mailru', {
  icon: 'M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#168DE2'
});

/* unused harmony default export */ var _unused_webpack_default_export = (MailruIcon);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var EmailIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('email', {
  icon: 'M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z',
  mask: 'M41.1,25H22.9l9.1,7.1L41.1,25z M44,26.6l-12,9.3l-12-9.3V39h24V26.6z M0,0v64h64V0H0z M47,42H17V22h30V42z',
  color: '#7f7f7f'
});

/* unused harmony default export */ var _unused_webpack_default_export = (EmailIcon);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__ = __webpack_require__(30);


var LivejournalIcon = Object(__WEBPACK_IMPORTED_MODULE_0__utils_iconFactory__["a" /* default */])('livejournal', {
  icon: 'M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z',
  mask: 'M0,0v64h64V0H0z M35.4,47c-6.5,0.1-9-4.7-9-8v-9.8h-3v-3.9c4.6-1.6,5.6-5.7,5.9-8.1c0-0.2,0.1-0.2,0.2-0.2 c0.1,0,4.4,0,4.4,0v7.6h6v4.5h-6v9.3c0,1.3,0.5,3,2.9,3c0.8,0,1.9-0.3,2.4-0.5l1.4,4.3C40.1,46,37.6,47,35.4,47z',
  color: '#21A5D8'
});

/* unused harmony default export */ var _unused_webpack_default_export = (LivejournalIcon);

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIZE = 50;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1);
  // https://gist.github.com/gre/1650294
  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    svg: {},
    svgIndeterminate: {
      animation: 'mui-progress-circular-rotate 1.4s linear infinite'
    },
    circle: {
      stroke: 'currentColor',
      strokeLinecap: 'round'
    },
    circleIndeterminate: {
      animation: 'mui-progress-circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
    },
    '@keyframes mui-progress-circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes mui-progress-circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-120px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function CircularProgress(props) {
  var _classNames2;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      max = props.max,
      min = props.min,
      size = props.size,
      style = props.style,
      thickness = props.thickness,
      value = props.value,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'max', 'min', 'size', 'style', 'thickness', 'value', 'variant']);


  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var relVal = getRelativeValue(value, min, max) * 100;
    var circumference = 2 * Math.PI * (SIZE / 2 - 5);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(relVal);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = ((100 - relVal) / 100 * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = (easeIn((100 - relVal) / 100) * circumference).toFixed(3) + 'px';
      rootStyle.transform = 'rotate(' + (easeOut(relVal / 70) * 270).toFixed(3) + 'deg)';
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), className),
      style: (0, _extends3.default)({ width: size, height: size }, rootStyle, style),
      role: 'progressbar'
    }, rootProps, other),
    _react2.default.createElement(
      'svg',
      {
        className: (0, _classnames2.default)(classes.svg, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.svgIndeterminate, variant === 'indeterminate'), (0, _defineProperty3.default)(_classNames2, classes.svgStatic, variant === 'static'), _classNames2)),
        viewBox: '0 0 ' + SIZE + ' ' + SIZE
      },
      _react2.default.createElement('circle', {
        className: (0, _classnames2.default)(classes.circle, (0, _defineProperty3.default)({}, classes.circleIndeterminate, variant === 'indeterminate')),
        style: circleStyle,
        cx: SIZE / 2,
        cy: SIZE / 2,
        r: SIZE / 2 - 5,
        fill: 'none',
        strokeWidth: thickness
      })
    )
  );
}

CircularProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary', 'inherit']),
  /**
   * The max value of progress in determinate variant.
   */
  max: _propTypes2.default.number,
  /**
   * The min value of progress in determinate variant.
   */
  min: _propTypes2.default.number,
  /**
   * The size of the circle.
   */
  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * The thickness of the circle.
   */
  thickness: _propTypes2.default.number,
  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'static'])
} : {};

CircularProgress.defaultProps = {
  color: 'primary',
  max: 100,
  min: 0,
  size: 40,
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCircularProgress', flip: false })(CircularProgress);

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRANSITION_DURATION = 4; // 400ms

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5
    },
    primaryColor: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6)
    },
    primaryColorBar: {
      backgroundColor: theme.palette.primary.main
    },
    primaryDashed: {
      background: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.primary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    secondaryColor: {
      backgroundColor: (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4)
    },
    secondaryColorBar: {
      backgroundColor: theme.palette.secondary.main
    },
    secondaryDashed: {
      background: 'radial-gradient(' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.4) + ' 0%, ' + (0, _colorManipulator.lighten)(theme.palette.secondary.light, 0.6) + ' 16%, transparent 42%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: 'buffer 3s infinite linear'
    },
    bufferBar2: {
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    rootBuffer: {
      backgroundColor: 'transparent'
    },
    rootQuery: {
      transform: 'rotate(180deg)'
    },
    indeterminateBar1: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    indeterminateBar2: {
      width: 'auto',
      willChange: 'left, right',
      animation: 'mui-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    determinateBar1: {
      willChange: 'transform',
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    bufferBar1: {
      zIndex: 1,
      transition: 'transform .' + TRANSITION_DURATION + 's linear'
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes mui-indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes mui-indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
function LinearProgress(props) {
  var _classNames, _classNames2, _classNames3, _classNames4;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color', 'value', 'valueBuffer', 'variant']);


  var dashedClass = (0, _classnames2.default)(classes.dashed, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.primaryDashed, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.secondaryDashed, color === 'secondary'), _classNames));

  var rootClassName = (0, _classnames2.default)(classes.root, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.primaryColor, color === 'primary'), (0, _defineProperty3.default)(_classNames2, classes.secondaryColor, color === 'secondary'), (0, _defineProperty3.default)(_classNames2, classes.rootBuffer, variant === 'buffer'), (0, _defineProperty3.default)(_classNames2, classes.rootQuery, variant === 'query'), _classNames2), className);
  var primaryClassName = (0, _classnames2.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.primaryColorBar, color === 'primary'), (0, _defineProperty3.default)(_classNames3, classes.secondaryColorBar, color === 'secondary'), (0, _defineProperty3.default)(_classNames3, classes.indeterminateBar1, variant === 'indeterminate' || variant === 'query'), (0, _defineProperty3.default)(_classNames3, classes.determinateBar1, variant === 'determinate'), (0, _defineProperty3.default)(_classNames3, classes.bufferBar1, variant === 'buffer'), _classNames3));
  var secondaryClassName = (0, _classnames2.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, classes.bufferBar2, variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.primaryColorBar, color === 'primary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.primaryColor, color === 'primary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.secondaryColorBar, color === 'secondary' && variant !== 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.secondaryColor, color === 'secondary' && variant === 'buffer'), (0, _defineProperty3.default)(_classNames4, classes.indeterminateBar2, variant === 'indeterminate' || variant === 'query'), _classNames4));
  var inlineStyles = { primary: {}, secondary: {} };
  var rootProps = {};

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      inlineStyles.primary.transform = 'scaleX(' + value / 100 + ')';
      rootProps['aria-valuenow'] = Math.round(value);
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a value property ' + 'when using the determinate or buffer variant of LinearProgress .') : void 0;
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      inlineStyles.secondary.transform = 'scaleX(' + (valueBuffer || 0) / 100 + ')';
    } else {
       false ? (0, _warning2.default)(false, 'Material-UI: you need to provide a valueBuffer property ' + 'when using the buffer variant of LinearProgress.') : void 0;
    }
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: rootClassName, role: 'progressbar' }, rootProps, other),
    variant === 'buffer' ? _react2.default.createElement('div', { className: dashedClass }) : null,
    _react2.default.createElement('div', { className: primaryClassName, style: inlineStyles.primary }),
    variant === 'determinate' ? null : _react2.default.createElement('div', { className: secondaryClassName, style: inlineStyles.secondary })
  );
}

LinearProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes2.default.number,
  /**
   * The variant of progress indicator. Use indeterminate or query
   * when there is no progress value.
   */
  variant: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};

LinearProgress.defaultProps = {
  color: 'primary',
  variant: 'indeterminate'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiLinearProgress' })(LinearProgress);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Typography_Typography__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Typography_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Typography_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_swipeable_views__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_swipeable_views___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_swipeable_views__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Card__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_social_login_buttons_lib_buttons_GoogleLoginButton__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_social_login_buttons_lib_buttons_GoogleLoginButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_social_login_buttons_lib_buttons_GoogleLoginButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_social_login_buttons_lib_buttons_FacebookLoginButton__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_social_login_buttons_lib_buttons_FacebookLoginButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_social_login_buttons_lib_buttons_FacebookLoginButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_utils_withWidth__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_utils_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_utils_withWidth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_redux_dom_link__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_redux_dom_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_router_redux_dom_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_router__ = __webpack_require__(73);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { connect } from 'react-redux'
//import Button from 'material-ui/Button'
//import IconButton from 'material-ui/IconButton'
//import Input, { InputLabel, InputAdornment } from 'material-ui/Input'
//import { FormControl, FormHelperText } from 'material-ui/Form'
//import Email from 'material-ui-icons/Email'
//import Visibility from 'material-ui-icons/Visibility'
//import VisibilityOff from 'material-ui-icons/VisibilityOff'
//import ArrowForward from 'material-ui-icons/ArrowForward'
var SignInContainer=function(_Component){_inherits(SignInContainer,_Component);function SignInContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SignInContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SignInContainer.__proto__||Object.getPrototypeOf(SignInContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={email:"",password:"",showPassword:false,index:0,signInLoading:false},_this.handleMouseDownPassword=function(event){event.preventDefault();},_this.handleClickShowPasssword=function(){_this.setState({showPassword:!_this.state.showPassword});},_this.handleChange=function(prop){return function(event){_this.setState(_defineProperty({},prop,event.target.value));};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SignInContainer,[{key:'render',value:function render(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_14_react_redux_firebase__["isEmpty"])(this.props.firebase.auth)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_router__["a" /* Redirect */],{to:{pathname:'signin'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{container:true,style:{marginTop:"0px"},className:this.props.classes.centerGrid,spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{item:true,xs:12,md:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{className:this.props.classes.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_swipeable_views___default.a,{index:this.state.index,onChangeIndex:function onChangeIndex(index){return _this2.setState({index:index});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Card___default.a,{className:this.props.classes.card},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Card__["CardContent"],{style:{width:"500px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Typography_Typography___default.a,{variant:'headline'},'\u0E19\u0E27\u0E31\u0E15\u0E01\u0E23\u0E23\u0E21\u0E01\u0E32\u0E23\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E13\u0E30\u0E14\u0E49\u0E27\u0E22 AI')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{item:true,xs:12,md:4,className:this.props.classes.itemGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{style:{flexDirection:'row'},className:this.props.classes.centerGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{item:true,xs:6,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react_social_login_buttons_lib_buttons_FacebookLoginButton___default.a,{onClick:function onClick(){return _this2.props.firebase.login({provider:'facebook',type:'popup'});},text:this.props.width==='xs'?"Facebook":"เข้าสู่ระบบด้วย Facebook"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Grid___default.a,{item:true,xs:6,md:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_social_login_buttons_lib_buttons_GoogleLoginButton___default.a,{onClick:function onClick(){return _this2.props.firebase.login({provider:'google',type:'popup'});},text:this.props.width==='xs'?"Google":"เข้าสู่ระบบด้วย Google"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Typography_Typography___default.a,{type:'caption'},'\u0E02\u0E49\u0E32\u0E1E\u0E40\u0E08\u0E49\u0E32\u0E44\u0E14\u0E49\u0E2D\u0E48\u0E32\u0E19 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_redux_dom_link___default.a,{to:'/termsOfService'},'\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23'),' \u0E41\u0E25\u0E30 ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_router_redux_dom_link___default.a,{to:'/privacy'},'\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E14\u0E49\u0E27\u0E22\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27'),' \u0E41\u0E25\u0E49\u0E27'))));}}]);return SignInContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_14_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* styles */]),__WEBPACK_IMPORTED_MODULE_12_material_ui_utils_withWidth___default()())(SignInContainer));

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwipeableViews = __webpack_require__(819);

var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SwipeableViews2.default;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _properties = __webpack_require__(367);

var _properties2 = _interopRequireDefault(_properties);

var _on = __webpack_require__(820);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(821);

var _off2 = _interopRequireDefault(_off);

var _reactSwipeableViewsCore = __webpack_require__(822);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on2.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, options);
    }
  };
}

var styleInjected = false;

// Support old version of iOS and IE 10.
// To be deleted in 2019.
function injectStyle() {
  // Inject once for all the instances
  if (!styleInjected) {
    var style = document.createElement('style');
    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ';

    if (document.body) {
      document.body.appendChild(style);
    }
    styleInjected = true;
  }
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};

var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return 'translate(' + -translate + '%, 0)';
    },
    'x-reverse': function xReverse(translate) {
      return 'translate(' + translate + '%, 0)';
    },
    y: function y(translate) {
      return 'translate(0, ' + -translate + '%)';
    },
    'y-reverse': function yReverse(translate) {
      return 'translate(0, ' + translate + '%)';
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;


  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
}

// We are using a 2x2 rotation matrix.
function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];

  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if (
    // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' ||
    // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
}

// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
var nodeHowClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;


  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;
    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];

    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeHowClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews = function (_Component) {
  (0, _inherits3.default)(SwipeableViews, _Component);

  function SwipeableViews() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwipeableViews);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indexLatest: null,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      isFirstRender: true,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    }, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.indexCurrent = null, _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;

      // Latency and rapid rerenders on some devices can leave
      // a period where rootNode briefly equals null.

      if (_this.rootNode === null) {
        return;
      }

      var touch = applyRotationMatrix(event.touches[0], axis);

      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;

      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);

        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);

        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
      }
    }, _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);
        return;
      }

      // Latency and rapid rerenders on some devices
      // can leave a period where rootNode briefly equals null.
      if (_this.rootNode === null) {
        return;
      }

      // We are not supposed to hanlde this touch move.
      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;


      var touch = applyRotationMatrix(event.touches[0], axis);

      // We don't know yet.
      if (_this.isSwiping === undefined) {
        var dx = Math.abs(_this.startX - touch.pageX);
        var dy = Math.abs(_this.startY - touch.pageY);

        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;

        // We let the parent handle the scroll.
        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        }

        // We are likely to be swiping, let's prevent the scroll event.
        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      }

      // We are swiping, let's prevent the scroll event.
      event.preventDefault();

      // Low Pass filter.
      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX;

      // Add support for native scroll elements.


      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        });

        // We abort the touch move handler.
        if (hasFoundNativeHandler) {
          return;
        }
      }

      // We are moving toward the edges.
      if (startX) {
        _this.startX = startX;
      } else if (nodeHowClaimedTheScroll === null) {
        nodeHowClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    }, _this.handleSwipeEnd = function () {
      nodeHowClaimedTheScroll = null;

      // The touch start event can be cancel.
      // Makes sure that a starting point is set.
      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;

      var indexNew = void 0;

      // Quick movement
      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);
      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        }

        // Manually calling handleTransitionEnd in that case as isn't otherwise.
        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    }, _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
      _this.handleSwipeStart(event);
    }, _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
      _this.handleSwipeEnd(event);
    }, _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
      event.persist();
      _this.handleSwipeStart(adaptMouse(event));
    }, _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
      _this.handleSwipeEnd(adaptMouse(event));
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    }, _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    }, _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      }

      // Ignore events bubbling up.
      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;

      _this.ignoreNextScrollEvents = true;
      // Reset the scroll position.
      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    }, _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];
        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SwipeableViews, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (false) {
        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
      }

      this.setIndexCurrent(this.props.index);
      this.setState({
        indexLatest: this.props.index
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function (event) {
        if (event.target !== _this3.containerNode) {
          return;
        }

        _this3.handleTransitionEnd();
      });

      // Block the thread to handle that event.
      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }
        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        isFirstRender: false
      });

      injectStyle();

      // Send all functions in an object if action param is set.
      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;


      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {
          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
        }

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
    }
  }, {
    key: 'setIndexCurrent',
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;

        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      }

      // Filters out when changing the children
      if (this.state.displaySameSlide) {
        return;
      }

      // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.
      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          action = _props.action,
          animateHeight = _props.animateHeight,
          animateTransitions = _props.animateTransitions,
          axis = _props.axis,
          children = _props.children,
          containerStyleProp = _props.containerStyle,
          disabled = _props.disabled,
          disableLazyLoading = _props.disableLazyLoading,
          enableMouseEvents = _props.enableMouseEvents,
          hysteresis = _props.hysteresis,
          ignoreNativeScroll = _props.ignoreNativeScroll,
          index = _props.index,
          onChangeIndex = _props.onChangeIndex,
          onSwitching = _props.onSwitching,
          onTransitionEnd = _props.onTransitionEnd,
          resistance = _props.resistance,
          slideStyleProp = _props.slideStyle,
          slideClassName = _props.slideClassName,
          springConfig = _props.springConfig,
          style = _props.style,
          threshold = _props.threshold,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'disableLazyLoading', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
      var _state = this.state,
          displaySameSlide = _state.displaySameSlide,
          heightLatest = _state.heightLatest,
          isDragging = _state.isDragging,
          isFirstRender = _state.isFirstRender,
          indexLatest = _state.indexLatest;

      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {};

      // There is no point to animate if we are already providing a height.
       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, 'react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;

      var slideStyle = (0, _extends3.default)({}, styles.slide, slideStyleProp);

      var transition = void 0;
      var WebkitTransition = void 0;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ', ' + createTransition('height', springConfig);
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      };

      // Apply the styles for SSR considerations
      if (disableLazyLoading || !isFirstRender) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
          ref: function ref(node) {
            _this4.rootNode = node;
          },
          style: (0, _extends3.default)({}, axisProperties.root[axis], style)
        }, other, touchEvents, mouseEvents, {
          onScroll: this.handleScroll
        }),
        _react2.default.createElement(
          'div',
          {
            ref: function ref(node) {
              _this4.containerNode = node;
            },
            style: (0, _extends3.default)({}, containerStyle, styles.container, containerStyleProp),
            className: 'react-swipeable-view-container'
          },
          _react.Children.map(children, function (child, indexChild) {
            if (!disableLazyLoading && isFirstRender && indexChild !== indexLatest) {
              return null;
            }

             false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;

            var ref = void 0;
            var hidden = true;

            if (indexChild === indexLatest) {
              hidden = false;

              if (animateHeight) {
                ref = function ref(node) {
                  _this4.activeSlide = node;
                  _this4.updateHeight();
                };
                slideStyle.overflowY = 'hidden';
              }
            }

            return _react2.default.createElement(
              'div',
              {
                ref: ref,
                style: slideStyle,
                className: slideClassName,
                'aria-hidden': hidden,
                'data-swipeable': 'true'
              },
              child
            );
          })
        )
      );
    }
  }]);
  return SwipeableViews;
}(_react.Component);

// Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';

SwipeableViews.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updateHeight() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes2.default.bool,
  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes2.default.bool,
  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * Use this property to provide your slides.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes2.default.bool,
  /**
   * This is the config used to disable lazyloding,
   * if `true` will render all the views in first rendering.
   */
  disableLazyLoading: _propTypes2.default.bool,
  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes2.default.bool,
  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes2.default.number,
  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes2.default.bool,
  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes2.default.number,
  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   * @param {object} meta Meta data containing more information about the event.
   */
  onChangeIndex: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onScroll: _propTypes2.default.func,
  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding
   * to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes2.default.func,
  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes2.default.bool,
  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes2.default.string,
  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes2.default.object,
  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes2.default.shape({
    duration: _propTypes2.default.string,
    easeFunction: _propTypes2.default.string,
    delay: _propTypes2.default.string
  }),
  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes2.default.object,
  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes2.default.number
} : {};

SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};

SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes2.default.shape({
    slideUpdateHeight: _propTypes2.default.func
  })
};

exports.default = SwipeableViews;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkIndexBounds = __webpack_require__(823);

Object.defineProperty(exports, 'checkIndexBounds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkIndexBounds).default;
  }
});

var _computeIndex = __webpack_require__(824);

Object.defineProperty(exports, 'computeIndex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_computeIndex).default;
  }
});

var _constant = __webpack_require__(368);

Object.defineProperty(exports, 'constant', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_constant).default;
  }
});

var _getDisplaySameSlide = __webpack_require__(825);

Object.defineProperty(exports, 'getDisplaySameSlide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDisplaySameSlide).default;
  }
});

var _mod = __webpack_require__(826);

Object.defineProperty(exports, 'mod', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mod).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;


  var childrenCount = _react.Children.count(children);

   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
};

exports.default = checkIndexBounds;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = __webpack_require__(0);

var _constant = __webpack_require__(368);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;


  var indexMax = _react.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX = void 0;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

exports.default = getDisplaySameSlide;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

exports.default = mod;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SocialLoginButtonProvider = __webpack_require__(369);

var _SocialLoginButtonProvider2 = _interopRequireDefault(_SocialLoginButtonProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    text: 'Login with Google',
    icon: 'gplus',
    style: { background: '#cb3f22' },
    activeStyle: { background: '#a5331c' }
};

/**
 * Google login button.
 * For props check {@link SocialLoginButton}
 */
var GoogleLoginButton = function GoogleLoginButton(props) {
    return _react2.default.createElement(_SocialLoginButtonProvider2.default, { defaults: defaults, props: props });
};

exports.default = GoogleLoginButton;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(829);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Icon = function Icon(_ref) {
    var name = _ref.name,
        _ref$size = _ref.size,
        size = _ref$size === undefined ? 26 : _ref$size,
        _ref$format = _ref.format,
        format = _ref$format === undefined ? function (name) {
        return 'demo-icon icon-' + name;
    } : _ref$format;
    return _react2.default.createElement('i', { className: format(name),
        style: { fontSize: size } });
};

var SocialLoginButton = (_temp = _class = function (_Component) {
    _inherits(SocialLoginButton, _Component);

    function SocialLoginButton() {
        var _ref2;

        _classCallCheck(this, SocialLoginButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref2 = SocialLoginButton.__proto__ || Object.getPrototypeOf(SocialLoginButton)).call.apply(_ref2, [this].concat(args)));

        _this.state = { hovered: false };

        _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SocialLoginButton, [{
        key: 'handleMouseEnter',
        value: function handleMouseEnter() {
            this.setState({ hovered: true });
        }
    }, {
        key: 'handleMouseLeave',
        value: function handleMouseLeave() {
            this.setState({ hovered: false });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            if (typeof this.props.onClick === 'function') {
                this.props.onClick();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                customStyle = _props.style,
                activeStyle = _props.activeStyle,
                children = _props.children,
                _props$text = _props.text,
                text = _props$text === undefined ? children : _props$text,
                icon = _props.icon,
                iconFormat = _props.iconFormat,
                _props$iconSize = _props.iconSize,
                iconSize = _props$iconSize === undefined ? '26px' : _props$iconSize,
                _props$size = _props.size,
                size = _props$size === undefined ? '50px' : _props$size;
            var hovered = this.state.hovered;


            var buttonStyles = _extends({}, styles.button, {
                lineHeight: typeof text === 'string' ? size : 'auto',
                height: size
            }, customStyle, hovered && activeStyle);

            var childrenCount = _react2.default.Children.count(children);

            // classic usage of this button
            if (childrenCount === 0) {
                return _react2.default.createElement(
                    'div',
                    { style: buttonStyles, onClick: this.handleClick, onMouseEnter: this.handleMouseEnter,
                        onMouseLeave: this.handleMouseLeave },
                    icon && _react2.default.createElement(
                        'span',
                        { style: _extends({}, styles.icon, { height: size, lineHeight: size }) },
                        _react2.default.createElement(Icon, { name: icon, size: iconSize, format: iconFormat })
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        text
                    )
                );
            }

            // children provided, rendering children as text
            return _react2.default.createElement(
                'div',
                { style: buttonStyles, onClick: this.handleClick, onMouseEnter: this.handleMouseEnter,
                    onMouseLeave: this.handleMouseLeave },
                _react2.default.createElement('span', { style: styles.spanFix }),
                text
            );
        }
    }]);

    return SocialLoginButton;
}(_react.Component), _class.propTypes = {

    /** Will be triggered when clicked on the button. */
    onClick: _propTypes2.default.func,

    /** Custom button styles */
    style: _propTypes2.default.object,

    /** activeStyle styles will be applied instead of style when mouse hovers above the element */
    activeStyle: _propTypes2.default.object,

    /** This text will be displayed */
    text: _propTypes2.default.string,

    /** This icon will be displayed */
    icon: _propTypes2.default.string,

    /** Box will have this size */
    size: _propTypes2.default.string,

    /** Icon will have this size. Eg. 26px */
    iconSize: _propTypes2.default.string,

    /** Format icon className. Eg. (name) => `fa-icon fa-icon-${name}` */
    iconFormat: _propTypes2.default.func
}, _temp);
exports.default = SocialLoginButton;


var styles = {
    spanFix: {
        height: '100%', display: 'inline-block', verticalAlign: 'middle'
    },
    button: {
        fontSize: '120%',
        color: '#ffffff',
        margin: 5,
        cursor: 'pointer',
        boxShadow: '#b5b5b5 0 1px 2px',
        borderRadius: 3,
        userSelect: 'none',
        overflow: 'hidden',
        padding: '0 10px'
    },
    icon: {
        paddingRight: '10px',
        float: 'left'
    }
};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!./social-login-font.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!./social-login-font.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(undefined);
// imports


// module
exports.push([module.i, "@font-face {\r\n  font-family: 'social-login-font';\r\n  src: url(" + __webpack_require__(0) + ");\r\n  src: url(" + __webpack_require__(0) + "#iefix) format('embedded-opentype'),\r\n       url(" + __webpack_require__(4) + ") format('woff2'),\r\n       url(" + __webpack_require__(5) + ") format('woff'),\r\n       url(" + __webpack_require__(6) + ") format('truetype'),\r\n       url(" + __webpack_require__(7) + "#social-login-font) format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\r\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\r\n/*\r\n@media screen and (-webkit-min-device-pixel-ratio:0) {\r\n  @font-face {\r\n    font-family: 'social-login-font';\r\n    src: url('../font/social-login-font.svg?96078194#social-login-font') format('svg');\r\n  }\r\n}\r\n*/\r\n \r\n [class^=\"icon-\"]:before, [class*=\" icon-\"]:before {\r\n  font-family: \"social-login-font\";\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  speak: none;\r\n \r\n  display: inline-block;\r\n  text-decoration: inherit;\r\n  width: 1em;\r\n  margin-right: .2em;\r\n  text-align: center;\r\n  /* opacity: .8; */\r\n \r\n  /* For safety - reset parent styles, that can break glyph codes*/\r\n  font-variant: normal;\r\n  text-transform: none;\r\n \r\n  /* fix buttons height, for twitter bootstrap */\r\n  line-height: 1em;\r\n \r\n  /* Animation center compensation - margins should be symmetric */\r\n  /* remove if not needed */\r\n  margin-left: .2em;\r\n \r\n  /* you can be more comfortable with increased icons size */\r\n  /* font-size: 120%; */\r\n \r\n  /* Font smoothing. That was taken from TWBS */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n \r\n  /* Uncomment for 3D effect */\r\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\r\n}\r\n \r\n.icon-twitter:before { content: '\\F099'; } /* '' */\r\n.icon-github-circled:before { content: '\\F09B'; } /* '' */\r\n.icon-gplus:before { content: '\\F0D5'; } /* '' */\r\n.icon-linkedin:before { content: '\\F0E1'; } /* '' */\r\n.icon-instagram:before { content: '\\F16D'; } /* '' */\r\n.icon-windows:before { content: '\\F17A'; } /* '' */\r\n.icon-vkontakte:before { content: '\\F189'; } /* '' */\r\n.icon-facebook-official:before { content: '\\F230'; } /* '' */\r\n.icon-amazon:before { content: '\\F270'; } /* '' */", ""]);

// exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff2;base64,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"

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(9);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ })
/******/ ]);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SocialLoginButtonProvider = __webpack_require__(369);

var _SocialLoginButtonProvider2 = _interopRequireDefault(_SocialLoginButtonProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    text: 'Login with Facebook',
    icon: 'facebook-official',
    style: { background: "#3b5998" },
    activeStyle: { background: "#293e69" }
};
/**
 * Facebook login button.
 * For props check {@link SocialLoginButton}
 * @extends {SocialLoginButton}
 */
var FacebookLoginButton = function FacebookLoginButton(props) {
    return _react2.default.createElement(_SocialLoginButtonProvider2.default, { defaults: defaults, props: props });
};

exports.default = FacebookLoginButton;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(832);
var invariant = __webpack_require__(35);
var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);
var react_redux_1 = __webpack_require__(36);
var react_router_redux_1 = __webpack_require__(33);
var isModifiedEvent = function (event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, target = _a.target;
            if (onClick) {
                onClick(e);
            }
            if (!e.defaultPrevented && // onClick prevented default
                e.button === 0 && // ignore right clicks
                !target && // let browser handle "target=_blank" etc.
                !isModifiedEvent(e) // ignore clicks with modifier keys
            ) {
                e.preventDefault();
                var _b = _this.props, pushUrl = _b.pushUrl, replace = _b.replace, replaceUrl = _b.replaceUrl, to = _b.to;
                if (replace) {
                    replaceUrl(to);
                }
                else {
                    pushUrl(to);
                }
            }
        };
        return _this;
    }
    Link.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, pushUrl = _a.pushUrl, replace = _a.replace, replaceUrl = _a.replaceUrl, to = _a.to, props = tslib_1.__rest(_a, ["innerRef", "pushUrl", "replace", "replaceUrl", "to"]);
        invariant(this.context.router, 'You should not use <Link> outside a <Router>');
        var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
        return React.createElement("a", tslib_1.__assign({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
    };
    Link.defaultProps = {
        replace: false,
    };
    Link.propTypes = {
        onClick: PropTypes.func,
        target: PropTypes.string,
        replace: PropTypes.bool,
        to: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]).isRequired,
        innerRef: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func
        ])
    };
    Link.contextTypes = {
        router: PropTypes.shape({
            history: PropTypes.shape({
                push: PropTypes.func.isRequired,
                replace: PropTypes.func.isRequired,
                createHref: PropTypes.func.isRequired
            }).isRequired
        }).isRequired
    };
    return Link;
}(React.Component));
exports.default = react_redux_1.connect(undefined, {
    pushUrl: react_router_redux_1.push,
    replaceUrl: react_router_redux_1.replace,
})(Link);
//# sourceMappingURL=Link.js.map

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toolbar__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_material_ui_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Avatar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_Avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_utils_ClickAwayListener__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_utils_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_utils_ClickAwayListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_popper__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_transitions_Grow__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_transitions_Grow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_transitions_Grow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Menu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_Menu__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppBarContainer=function(_Component){_inherits(AppBarContainer,_Component);function AppBarContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AppBarContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AppBarContainer.__proto__||Object.getPrototypeOf(AppBarContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={menuOpen:false},_this.handleMenuClick=function(){_this.setState({menuOpen:!_this.state.menuOpen});},_this.handleClose=function(){if(!_this.state.menuOpen){return;}// setTimeout to ensure a close event comes after a target click event
_this.timeout=setTimeout(function(){_this.setState({menuOpen:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AppBarContainer,[{key:'render',value:function render(){var _this2=this;//console.log('-----APPBAR PROPS-----', this.props)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_AppBar___default.a,{style:{position:"static",zIndex:"1000"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_material_ui_Toolbar___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_material_ui_Typography___default.a,{variant:'title',color:'inherit',style:{flex:1}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'white-logo.svg',alt:'logo',height:'40px'})),Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_firebase__["isEmpty"])(this.props.auth)?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_popper__["Manager"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_popper__["Target"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_Avatar___default.a//onClick={()=>this.props.firebase.logout()}
,{'aria-owns':this.state.menuOpen?'menu-list':null,'aria-haspopup':'true',onClick:this.handleMenuClick,alt:this.props.auth.displayName,src:this.props.auth.photoURL,style:{height:'40px',cursor:'pointer'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_popper__["Popper"],{placement:'left',eventsEnabled:this.state.menuOpen,className:__WEBPACK_IMPORTED_MODULE_14_classnames___default()(_defineProperty({},this.props.classes.popperClose,!this.state.menuOpen))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_utils_ClickAwayListener___default.a,{onClickAway:this.handleClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_transitions_Grow___default.a,{'in':this.state.menuOpen,id:'menu-list',style:{transformOrigin:'0 0 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Paper___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Menu__["MenuList"],{role:'menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Menu__["MenuItem"],{onClick:this.handleClose},'\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Menu__["MenuItem"],{onClick:function onClick(){return _this2.props.firebase.logout();}},'\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E23\u0E30\u0E1A\u0E1A'))))))))));}}]);return AppBarContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function(_ref2){var auth=_ref2.firebase.auth;return{auth:auth};}))(AppBarContainer));

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var styles = exports.styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box', // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionSticky: {
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },
    positionStatic: {
      position: 'static'
    },
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};

function AppBar(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'position']);


  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, 'mui-fixed', position === 'fixed'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, component: 'header', elevation: 4, className: className }, other),
    children
  );
}

AppBar.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'primary', 'secondary', 'default']),
  /**
   * The positioning type. The behavior of the different options is described
   * [here](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: _propTypes2.default.oneOf(['fixed', 'absolute', 'sticky', 'static'])
} : {};

AppBar.defaultProps = {
  color: 'primary',
  position: 'fixed'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAppBar' })(AppBar);

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    }, theme.mixins.toolbar),
    gutters: theme.mixins.gutters({})
  };
};

function Toolbar(props) {
  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableGutters = props.disableGutters,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableGutters']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.gutters, !disableGutters), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

Toolbar.propTypes =  false ? {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: _propTypes2.default.bool
} : {};

Toolbar.defaultProps = {
  disableGutters: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiToolbar' })(Toolbar);

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(839);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;


      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      return _extends({
        position: data.offsets.popper.position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return _this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _this._handlePopperRef = function (node) {
      _this._popperNode = node;
      if (node) {
        _this._createPopper();
      } else {
        _this._destroyPopper();
      }
      if (_this.props.innerRef) {
        _this.props.innerRef(node);
      }
    }, _this._scheduleUpdate = function () {
      _this._popper && _this._popper.scheduleUpdate();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._destroyPopper();
        this._createPopper();
      }
      if (lastProps.children !== this.props.children) {
        this._scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });
      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }
      this._popper = new _popper2.default(this._getTargetNode(), this._popperNode, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // TODO: look into setTimeout scheduleUpdate call, without it, the popper will not position properly on creation
      setTimeout(function () {
        return _this2._scheduleUpdate();
      });
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var popperProps = {
          ref: this._handlePopperRef,
          style: popperStyle,
          'data-placement': popperPlacement,
          'data-x-out-of-boundaries': popperHide
        };
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = this._handlePopperRef;
      } else {
        componentProps.innerRef = this._handlePopperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.9
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE10$1() && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _contains = __webpack_require__(130);

var _contains2 = _interopRequireDefault(_contains);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _ownerWindow = __webpack_require__(290);

var _ownerWindow2 = _interopRequireDefault(_ownerWindow);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Modal = __webpack_require__(155);

var _Modal2 = _interopRequireDefault(_Modal);

var _Grow = __webpack_require__(223);

var _Grow2 = _interopRequireDefault(_Grow);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
} // @inheritedComponent Modal

function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? n + 'px' : n;
  }).join(' ');
}

// Sum the scrollTop between two elements.
function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentNode;
    scrollTop += element.scrollTop;
  }
  return scrollTop;
}

var styles = exports.styles = {
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100vw - 32px)',
    maxHeight: 'calc(100vh - 32px)',
    '&:focus': {
      outline: 'none'
    }
  }
};

var Popover = function (_React$Component) {
  (0, _inherits3.default)(Popover, _React$Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillUnmount = function () {
      _this.handleResize.cancel();
    }, _this.setPositioningStyles = function (element) {
      if (element && element.style) {
        var positioning = _this.getPositioningStyle(element);
        element.style.top = positioning.top;
        element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
      }
    }, _this.getPositioningStyle = function (element) {
      var _this$props = _this.props,
          anchorEl = _this$props.anchorEl,
          marginThreshold = _this$props.marginThreshold;

      // Check if the parent has requested anchoring on an inner content node

      var contentAnchorOffset = _this.getContentAnchorOffset(element);
      // Get the offset of of the anchoring element
      var anchorOffset = _this.getAnchorOffset(contentAnchorOffset);

      var elemRect = {
        width: element.clientWidth,
        height: element.clientHeight
      };
      // Get the transform origin point on the element itself
      var transformOrigin = _this.getTransformOrigin(elemRect, contentAnchorOffset);

      // Calculate element positioning
      var top = anchorOffset.top - transformOrigin.vertical;
      var left = anchorOffset.left - transformOrigin.horizontal;
      var bottom = top + elemRect.height;
      var right = left + elemRect.width;

      // Use the parent window of the anchorEl if provided
      var containerWindow = (0, _ownerWindow2.default)(anchorEl);

      // Window thresholds taking required margin into account
      var heightThreshold = containerWindow.innerHeight - marginThreshold;
      var widthThreshold = containerWindow.innerWidth - marginThreshold;

      // Check if the vertical axis needs shifting
      if (top < marginThreshold) {
        var diff = top - marginThreshold;
        top -= diff;
        transformOrigin.vertical += diff;
      } else if (bottom > heightThreshold) {
        var _diff = bottom - heightThreshold;
        top -= _diff;
        transformOrigin.vertical += _diff;
      }

       false ? (0, _warning2.default)(elemRect.height < heightThreshold || !elemRect.height || !heightThreshold, ['Material-UI: the popover component is too tall.', 'Some part of it can not be seen on the screen (' + (elemRect.height - heightThreshold) + 'px).', 'Please consider adding a `max-height` to improve the user-experience.'].join('\n')) : void 0;

      // Check if the horizontal axis needs shifting
      if (left < marginThreshold) {
        var _diff2 = left - marginThreshold;
        left -= _diff2;
        transformOrigin.horizontal += _diff2;
      } else if (right > widthThreshold) {
        var _diff3 = right - widthThreshold;
        left -= _diff3;
        transformOrigin.horizontal += _diff3;
      }

      return {
        top: top + 'px',
        left: left + 'px',
        transformOrigin: getTransformOriginValue(transformOrigin)
      };
    }, _this.transitionEl = undefined, _this.handleGetOffsetTop = getOffsetTop, _this.handleGetOffsetLeft = getOffsetLeft, _this.handleEnter = function (element) {
      if (_this.props.onEnter) {
        _this.props.onEnter(element);
      }

      _this.setPositioningStyles(element);
    }, _this.handleResize = (0, _debounce2.default)(function () {
      var element = _reactDom2.default.findDOMNode(_this.transitionEl);
      _this.setPositioningStyles(element);
    }, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Popover, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.action) {
        this.props.action({
          updatePosition: this.handleResize
        });
      }
    }
  }, {
    key: 'getAnchorOffset',


    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    value: function getAnchorOffset(contentAnchorOffset) {
      var _props = this.props,
          anchorEl = _props.anchorEl,
          anchorOrigin = _props.anchorOrigin,
          anchorReference = _props.anchorReference,
          anchorPosition = _props.anchorPosition;


      if (anchorReference === 'anchorPosition') {
        return anchorPosition;
      }

      var anchorElement = anchorEl || document.body;
      var anchorRect = anchorElement.getBoundingClientRect();
      var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';

      return {
        top: anchorRect.top + this.handleGetOffsetTop(anchorRect, anchorVertical),
        left: anchorRect.left + this.handleGetOffsetLeft(anchorRect, anchorOrigin.horizontal)
      };
    }

    // Returns the vertical offset of inner content to anchor the transform on if provided

  }, {
    key: 'getContentAnchorOffset',
    value: function getContentAnchorOffset(element) {
      var _props2 = this.props,
          getContentAnchorEl = _props2.getContentAnchorEl,
          anchorReference = _props2.anchorReference;

      var contentAnchorOffset = 0;

      if (getContentAnchorEl && anchorReference === 'anchorEl') {
        var contentAnchorEl = getContentAnchorEl(element);

        if (contentAnchorEl && (0, _contains2.default)(element, contentAnchorEl)) {
          var scrollTop = getScrollParent(element, contentAnchorEl);
          contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
        }

        // != the default value
         false ? (0, _warning2.default)(this.props.anchorOrigin.vertical === 'top', ['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` property to the popover component.', 'Only use one of the two properties.', 'Set `getContentAnchorEl` to null or left `anchorOrigin.vertical` unchanged.'].join('\n')) : void 0;
      }

      return contentAnchorOffset;
    }

    // Return the base transform origin using the element
    // and taking the content anchor offset into account if in use

  }, {
    key: 'getTransformOrigin',
    value: function getTransformOrigin(elemRect) {
      var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transformOrigin = this.props.transformOrigin;

      return {
        vertical: this.handleGetOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
        horizontal: this.handleGetOffsetLeft(elemRect, transformOrigin.horizontal)
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          anchorEl = _props3.anchorEl,
          anchorOrigin = _props3.anchorOrigin,
          anchorPosition = _props3.anchorPosition,
          anchorReference = _props3.anchorReference,
          children = _props3.children,
          classes = _props3.classes,
          containerProp = _props3.container,
          elevation = _props3.elevation,
          getContentAnchorEl = _props3.getContentAnchorEl,
          marginThreshold = _props3.marginThreshold,
          onEnter = _props3.onEnter,
          onEntered = _props3.onEntered,
          onEntering = _props3.onEntering,
          onExit = _props3.onExit,
          onExited = _props3.onExited,
          onExiting = _props3.onExiting,
          open = _props3.open,
          PaperProps = _props3.PaperProps,
          role = _props3.role,
          transformOrigin = _props3.transformOrigin,
          TransitionProp = _props3.transition,
          transitionDuration = _props3.transitionDuration,
          action = _props3.action,
          other = (0, _objectWithoutProperties3.default)(_props3, ['anchorEl', 'anchorOrigin', 'anchorPosition', 'anchorReference', 'children', 'classes', 'container', 'elevation', 'getContentAnchorEl', 'marginThreshold', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'role', 'transformOrigin', 'transition', 'transitionDuration', 'action']);

      // If the container prop is provided, use that
      // If the anchorEl prop is provided, use its parent body element as the container
      // If neither are provided let the Modal take care of choosing the container

      var container = containerProp || (anchorEl ? (0, _ownerDocument2.default)(anchorEl).body : undefined);

      var transitionProps = {};
      // The provided transition might not support the auto timeout value.
      if (TransitionProp === _Grow2.default) {
        transitionProps.timeout = transitionDuration;
      }

      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({ container: container, open: open, BackdropProps: { invisible: true } }, other),
        _react2.default.createElement(
          TransitionProp,
          (0, _extends3.default)({
            appear: true,
            'in': open,
            onEnter: this.handleEnter,
            onEntered: onEntered,
            onEntering: onEntering,
            onExit: onExit,
            onExited: onExited,
            onExiting: onExiting,
            role: role,
            ref: function ref(node) {
              _this2.transitionEl = node;
            }
          }, transitionProps),
          _react2.default.createElement(
            _Paper2.default,
            (0, _extends3.default)({
              className: classes.paper,

              elevation: elevation
            }, PaperProps),
            _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
            children
          )
        )
      );
    }
  }]);
  return Popover;
}(_react2.default.Component);

Popover.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updatePosition() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * This is the DOM element that may be used
   * to set the position of the popover.
   */
  anchorEl: _propTypes2.default.object,
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: _propTypes2.default.oneOf(['anchorEl', 'anchorPosition']),
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it's using the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * The elevation of the popover.
   */
  elevation: _propTypes2.default.number,
  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` property.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: _propTypes2.default.func,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: _propTypes2.default.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the component is entering.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the component has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the component is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the component is exiting.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the component has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the component is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the popover is visible.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

Popover.defaultProps = {
  anchorReference: 'anchorEl',
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  elevation: 8,
  marginThreshold: 16,
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  transition: _Grow2.default,
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiPopover' })(Popover);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _activeElement = __webpack_require__(375);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(130);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(78);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _RefHolder = __webpack_require__(376);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _Portal = __webpack_require__(377);

var _Portal2 = _interopRequireDefault(_Portal);

var _addEventListener = __webpack_require__(845);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _helpers = __webpack_require__(14);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ModalManager = __webpack_require__(378);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Backdrop = __webpack_require__(380);

var _Backdrop2 = _interopRequireDefault(_Backdrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
} // @inheritedComponent Portal

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      width: '100%',
      height: '100%',
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      top: 0,
      left: 0
    },
    hidden: {
      visibility: 'hidden'
    }
  };
};

var Modal = function (_React$Component) {
  (0, _inherits3.default)(Modal, _React$Component);

  function Modal(props, context) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props, context));

    _this.dialog = null;
    _this.mounted = false;
    _this.mountNode = null;

    _this.handleRendered = function () {
      _this.autoFocus();

      if (_this.props.onRendered) {
        _this.props.onRendered();
      }
    };

    _this.handleOpen = function () {
      var doc = getOwnerDocument(_this);
      var container = getContainer(_this.props.container, doc.body);

      _this.props.manager.add(_this, container);
      _this.onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this.handleDocumentKeyDown);
      _this.onFocusinListener = (0, _addEventListener2.default)(document, 'focus', _this.enforceFocus, true);
    };

    _this.handleClose = function () {
      _this.props.manager.remove(_this);
      _this.onDocumentKeydownListener.remove();
      _this.onFocusinListener.remove();
      _this.restoreLastFocus();
    };

    _this.handleExited = function () {
      _this.setState({ exited: true });
      _this.handleClose();
    };

    _this.handleBackdropClick = function (event) {
      if (event.target !== event.currentTarget) {
        return;
      }

      if (_this.props.onBackdropClick) {
        _this.props.onBackdropClick(event);
      }

      if (!_this.props.disableBackdropClick && _this.props.onClose) {
        _this.props.onClose(event, 'backdropClick');
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (!_this.isTopModal() || (0, _keycode2.default)(event) !== 'esc') {
        return;
      }

      if (_this.props.onEscapeKeyDown) {
        _this.props.onEscapeKeyDown(event);
      }

      if (!_this.props.disableEscapeKeyDown && _this.props.onClose) {
        _this.props.onClose(event, 'escapeKeyDown');
      }
    };

    _this.checkForFocus = function () {
      if (_inDOM2.default) {
        _this.lastFocus = (0, _activeElement2.default)();
      }
    };

    _this.enforceFocus = function () {
      if (_this.props.disableEnforceFocus || !_this.mounted || !_this.isTopModal()) {
        return;
      }

      var dialogElement = _this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(_this));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        dialogElement.focus();
      }
    };

    _this.state = {
      exited: !_this.props.open
    };
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      if (this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.setState({ exited: false });
      } else if (!getHasTransition(nextProps)) {
        // Otherwise let handleExited take care of marking exited.
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (!this.props.open && nextProps.open) {
        this.checkForFocus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open && !this.props.open && !getHasTransition(this.props)) {
        // Otherwise handleExited will call this.
        this.handleClose();
      } else if (!prevProps.open && this.props.open) {
        this.handleOpen();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.props.open || getHasTransition(this.props) && !this.state.exited) {
        this.handleClose();
      }
    }
  }, {
    key: 'getDialogElement',
    value: function getDialogElement() {
      return _reactDom2.default.findDOMNode(this.dialog);
    }
  }, {
    key: 'autoFocus',
    value: function autoFocus() {
      if (this.props.disableAutoFocus) {
        return;
      }

      var dialogElement = this.getDialogElement();
      var currentActiveElement = (0, _activeElement2.default)(getOwnerDocument(this));

      if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
        this.lastFocus = currentActiveElement;

        if (!dialogElement.hasAttribute('tabIndex')) {
           false ? (0, _warning2.default)(false, ['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n')) : void 0;
          dialogElement.setAttribute('tabIndex', -1);
        }

        dialogElement.focus();
      }
    }
  }, {
    key: 'restoreLastFocus',
    value: function restoreLastFocus() {
      if (this.props.disableRestoreFocus) {
        return;
      }

      if (this.lastFocus) {
        this.lastFocus.focus();
        this.lastFocus = null;
      }
    }
  }, {
    key: 'isTopModal',
    value: function isTopModal() {
      return this.props.manager.isTopModal(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          BackdropComponent = _props.BackdropComponent,
          BackdropProps = _props.BackdropProps,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          container = _props.container,
          disableAutoFocus = _props.disableAutoFocus,
          disableBackdropClick = _props.disableBackdropClick,
          disableEnforceFocus = _props.disableEnforceFocus,
          disableEscapeKeyDown = _props.disableEscapeKeyDown,
          disableRestoreFocus = _props.disableRestoreFocus,
          hideBackdrop = _props.hideBackdrop,
          keepMounted = _props.keepMounted,
          onBackdropClick = _props.onBackdropClick,
          onClose = _props.onClose,
          onEscapeKeyDown = _props.onEscapeKeyDown,
          onRendered = _props.onRendered,
          open = _props.open,
          manager = _props.manager,
          other = (0, _objectWithoutProperties3.default)(_props, ['BackdropComponent', 'BackdropProps', 'children', 'classes', 'className', 'container', 'disableAutoFocus', 'disableBackdropClick', 'disableEnforceFocus', 'disableEscapeKeyDown', 'disableRestoreFocus', 'hideBackdrop', 'keepMounted', 'onBackdropClick', 'onClose', 'onEscapeKeyDown', 'onRendered', 'open', 'manager']);
      var exited = this.state.exited;

      var hasTransition = getHasTransition(this.props);
      var childProps = {};

      if (!keepMounted && !open && (!hasTransition || exited)) {
        return null;
      }

      // It's a Transition like component
      if (hasTransition) {
        childProps.onExited = (0, _helpers.createChainedFunction)(this.handleExited, children.props.onExited);
      }

      if (children.props.role === undefined) {
        childProps.role = children.props.role || 'document';
      }

      if (children.props.tabIndex === undefined) {
        childProps.tabIndex = children.props.tabIndex || '-1';
      }

      return _react2.default.createElement(
        _Portal2.default,
        {
          ref: function ref(node) {
            _this2.mountNode = node ? node.getMountNode() : node;
          },
          container: container,
          onRendered: this.handleRendered
        },
        _react2.default.createElement(
          'div',
          (0, _extends3.default)({
            className: (0, _classnames2.default)(classes.root, className, (0, _defineProperty3.default)({}, classes.hidden, exited))
          }, other),
          hideBackdrop ? null : _react2.default.createElement(BackdropComponent, (0, _extends3.default)({ open: open, onClick: this.handleBackdropClick }, BackdropProps)),
          _react2.default.createElement(
            _RefHolder2.default,
            {
              ref: function ref(node) {
                _this2.dialog = node;
              }
            },
            _react2.default.cloneElement(children, childProps)
          )
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

Modal.propTypes =  false ? {
  /**
   * A backdrop component. Useful for custom backdrop rendering.
   */
  BackdropComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the `Backdrop` element.
   */
  BackdropProps: _propTypes2.default.object,
  /**
   * A single child content element.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: _propTypes2.default.bool,
  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: _propTypes2.default.bool,
  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: _propTypes2.default.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: _propTypes2.default.bool,
  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: _propTypes2.default.bool,
  /**
   * Always keep the children in the DOM.
   * This property can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: _propTypes2.default.bool,
  /**
   * A modal manager used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container.
   */
  manager: _propTypes2.default.object,
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes2.default.func,
  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` property took effect.
   */
  onRendered: _propTypes2.default.func,
  /**
   * If `true`, the modal is open.
   */
  open: _propTypes2.default.bool.isRequired
} : {};

Modal.defaultProps = {
  disableAutoFocus: false,
  disableBackdropClick: false,
  disableEnforceFocus: false,
  disableEscapeKeyDown: false,
  disableRestoreFocus: false,
  hideBackdrop: false,
  keepMounted: false,
  // Modals don't open on the server so this won't conflict with concurrent requests.
  manager: new _ModalManager2.default(),
  BackdropComponent: _Backdrop2.default
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiModal' })(Modal);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(97);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * This component shares many concepts with
 * [react-overlays](https://react-bootstrap.github.io/react-overlays/#portals)
 * But has been forked in order to fix some bugs, reduce the number of dependencies
 * and take the control of our destiny.
 */

var Portal = function (_React$Component) {
  (0, _inherits3.default)(Portal, _React$Component);

  function Portal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Portal.__proto__ || (0, _getPrototypeOf2.default)(Portal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setContainer(this.props.container);
      this.forceUpdate(this.props.onRendered);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.container !== this.props.container) {
        this.setContainer(nextProps.container);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mountNode = null;
    }
  }, {
    key: 'setContainer',
    value: function setContainer(container) {
      this.mountNode = getContainer(container, getOwnerDocument(this).body);
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return this.mountNode ? _reactDom2.default.createPortal(children, this.mountNode) : null;
    }
  }]);
  return Portal;
}(_react2.default.Component);

Portal.propTypes =  false ? {
  /**
   * The children to render into the `container`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it's using the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  /**
   * Callback fired once the children has been mounted into the `container`.
   */
  onRendered: _propTypes2.default.func
} : {};

Portal.propTypes =  false ? (0, _exactProp2.default)(Portal.propTypes, 'Portal') : {};

exports.default = Portal;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(25);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _exactProp = __webpack_require__(97);

var _exactProp2 = _interopRequireDefault(_exactProp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}

function getOwnerDocument(element) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(element));
}

/**
 * @ignore - internal component.
 *
 * This module will soon be gone. We should drop it as soon as React@15.x support stop.
 */

var LegacyPortal = function (_React$Component) {
  (0, _inherits3.default)(LegacyPortal, _React$Component);

  function LegacyPortal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LegacyPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LegacyPortal.__proto__ || (0, _getPrototypeOf2.default)(LegacyPortal)).call.apply(_ref, [this].concat(args))), _this), _this.getMountNode = function () {
      return _this.mountNode;
    }, _this.mountOverlayTarget = function () {
      if (!_this.overlayTarget) {
        _this.overlayTarget = document.createElement('div');
        _this.mountNode = getContainer(_this.props.container, getOwnerDocument(_this).body);
        _this.mountNode.appendChild(_this.overlayTarget);
      }
    }, _this.unmountOverlayTarget = function () {
      if (_this.overlayTarget) {
        _this.mountNode.removeChild(_this.overlayTarget);
        _this.overlayTarget = null;
      }
      _this.mountNode = null;
    }, _this.unrenderOverlay = function () {
      if (_this.overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this.overlayTarget);
        _this.overlayInstance = null;
      }
    }, _this.renderOverlay = function () {
      var overlay = _this.props.children;
      _this.mountOverlayTarget();
      var initialRender = !_this.overlayInstance;
      _this.overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this.overlayTarget, function () {
        if (initialRender && _this.props.onRendered) {
          _this.props.onRendered();
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LegacyPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.renderOverlay();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.overlayTarget && nextProps.container !== this.props.container) {
        this.mountNode.removeChild(this.overlayTarget);
        this.mountNode = getContainer(nextProps.container, getOwnerDocument(this).body);
        this.mountNode.appendChild(this.overlayTarget);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderOverlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.unrenderOverlay();
      this.unmountOverlayTarget();
    }

    /**
     * @public
     */

  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return LegacyPortal;
}(_react2.default.Component);

LegacyPortal.propTypes =  false ? {
  children: _propTypes2.default.element.isRequired,
  container: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
  onRendered: _propTypes2.default.func
} : {};

LegacyPortal.propTypes =  false ? (0, _exactProp2.default)(LegacyPortal.propTypes, 'LegacyPortal') : {};

exports.default = LegacyPortal;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node, event, handler, capture) {
  node.addEventListener(event, handler, capture);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, capture);
    }
  };
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(379);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(848);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(850);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(851);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(367);

var _isTransform = __webpack_require__(852);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(849);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(379);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBody = isBody;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(854);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(48);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

// Do we have a scroll bar?
function isOverflowing(container) {
  var doc = (0, _ownerDocument2.default)(container);
  var win = (0, _isWindow2.default)(doc);

  /* istanbul ignore next */
  if (!win && !isBody(container)) {
    return container.scrollHeight > container.clientHeight;
  }

  // Takes in account potential non zero margin on the body.
  var style = window.getComputedStyle(doc.body);
  var marginLeft = parseInt(style.getPropertyValue('margin-left'), 10);
  var marginRight = parseInt(style.getPropertyValue('margin-right'), 10);

  return marginLeft + doc.body.clientWidth + marginRight < win.innerWidth;
}

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;
var BLACKLIST = ['template', 'script', 'style'];

function isHidable(node) {
  return node.nodeType === 1 && BLACKLIST.indexOf(node.tagName.toLowerCase()) === -1;
}

function siblings(container, mount, callback) {
  mount = [].concat(mount); // eslint-disable-line no-param-reassign
  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      callback(node);
    }
  });
}

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ListItem = __webpack_require__(356);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      height: theme.spacing.unit * 3,
      boxSizing: 'content-box',
      width: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&$selected': {
        backgroundColor: theme.palette.action.selected
      }
    }),
    selected: {}
  };
}; // @inheritedComponent ListItem

function MenuItem(props) {
  var classes = props.classes,
      classNameProp = props.className,
      component = props.component,
      selected = props.selected,
      role = props.role,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'selected', 'role']);


  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.selected, selected), classNameProp);

  return _react2.default.createElement(_ListItem2.default, (0, _extends3.default)({
    button: true,
    role: role,
    tabIndex: -1,
    className: className,
    component: component
  }, other));
}

MenuItem.propTypes =  false ? {
  /**
   * Menu item contents.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * @ignore
   */
  role: _propTypes2.default.string,
  /**
   * Use to apply selected styling.
   */
  selected: _propTypes2.default.bool
} : {};

MenuItem.defaultProps = {
  component: 'li',
  role: 'menuitem',
  selected: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMenuItem' })(MenuItem);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_transitions_Fade__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_transitions_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_transitions_Fade__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Snackbar__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Snackbar__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadingContainer=function(_Component){_inherits(LoadingContainer,_Component);function LoadingContainer(){_classCallCheck(this,LoadingContainer);return _possibleConstructorReturn(this,(LoadingContainer.__proto__||Object.getPrototypeOf(LoadingContainer)).apply(this,arguments));}_createClass(LoadingContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Snackbar___default.a,{open:this.props.loading.isLoading,transition:__WEBPACK_IMPORTED_MODULE_2_material_ui_transitions_Fade___default.a,action:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Progress__["CircularProgress"],{size:25}),SnackbarContentProps:{'aria-describedby':'message-id'},message:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{id:'message-id'},this.props.loading.message,' ')});}}]);return LoadingContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{loading:state.loading};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,null)(LoadingContainer));

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends8 = __webpack_require__(2);

var _extends9 = _interopRequireDefault(_extends8);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _transitions = __webpack_require__(53);

var _ClickAwayListener = __webpack_require__(222);

var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);

var _helpers = __webpack_require__(14);

var _Slide = __webpack_require__(224);

var _Slide2 = _interopRequireDefault(_Slide);

var _SnackbarContent = __webpack_require__(383);

var _SnackbarContent2 = _interopRequireDefault(_SnackbarContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var gutter = theme.spacing.unit * 3;
  var top = { top: 0 };
  var bottom = { bottom: 0 };
  var right = { justifyContent: 'flex-end' };
  var left = { justifyContent: 'flex-start' };
  var topSpace = { top: gutter };
  var bottomSpace = { bottom: gutter };
  var rightSpace = { right: gutter };
  var leftSpace = { left: gutter };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };

  return {
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 0,
      right: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    anchorTopCenter: (0, _extends9.default)({}, top, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
    anchorBottomCenter: (0, _extends9.default)({}, bottom, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({}, center))),
    anchorTopRight: (0, _extends9.default)({}, top, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      left: 'auto'
    }, topSpace, rightSpace))),
    anchorBottomRight: (0, _extends9.default)({}, bottom, right, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      left: 'auto'
    }, bottomSpace, rightSpace))),
    anchorTopLeft: (0, _extends9.default)({}, top, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      right: 'auto'
    }, topSpace, leftSpace))),
    anchorBottomLeft: (0, _extends9.default)({}, bottom, left, (0, _defineProperty3.default)({}, theme.breakpoints.up('md'), (0, _extends9.default)({
      right: 'auto'
    }, bottomSpace, leftSpace)))
  };
};

var Snackbar = function (_React$Component) {
  (0, _inherits3.default)(Snackbar, _React$Component);

  function Snackbar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Snackbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Used to only render active snackbars.
      exited: false
    }, _this.timerAutoHide = null, _this.handleMouseEnter = function (event) {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
      _this.handlePause();
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }
      _this.handleResume();
    }, _this.handleClickAway = function (event) {
      if (_this.props.onClose) {
        _this.props.onClose(event, 'clickaway');
      }
    }, _this.handlePause = function () {
      clearTimeout(_this.timerAutoHide);
    }, _this.handleResume = function () {
      if (_this.props.autoHideDuration != null) {
        if (_this.props.resumeHideDuration !== undefined) {
          _this.setAutoHideTimer(_this.props.resumeHideDuration);
          return;
        }
        _this.setAutoHideTimer((_this.props.autoHideDuration || 0) * 0.5);
      }
    }, _this.handleExited = function () {
      _this.setState({ exited: true });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Snackbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.open) {
        this.setState({ exited: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.setAutoHideTimer();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open) {
        this.setState({ exited: false });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.open !== this.props.open) {
        if (this.props.open) {
          this.setAutoHideTimer();
        } else {
          clearTimeout(this.timerAutoHide);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerAutoHide);
    }

    // Timer that controls delay before snackbar auto hides

  }, {
    key: 'setAutoHideTimer',
    value: function setAutoHideTimer() {
      var _this2 = this;

      var autoHideDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.props.onClose || this.props.autoHideDuration == null) {
        return;
      }

      clearTimeout(this.timerAutoHide);
      this.timerAutoHide = setTimeout(function () {
        if (!_this2.props.onClose || _this2.props.autoHideDuration == null) {
          return;
        }

        _this2.props.onClose(null, 'timeout');
      }, autoHideDuration || this.props.autoHideDuration || 0);
    }

    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.


    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          _props$anchorOrigin = _props.anchorOrigin,
          vertical = _props$anchorOrigin.vertical,
          horizontal = _props$anchorOrigin.horizontal,
          autoHideDuration = _props.autoHideDuration,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          message = _props.message,
          onClose = _props.onClose,
          onEnter = _props.onEnter,
          onEntered = _props.onEntered,
          onEntering = _props.onEntering,
          onExit = _props.onExit,
          onExited = _props.onExited,
          onExiting = _props.onExiting,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          open = _props.open,
          resumeHideDuration = _props.resumeHideDuration,
          SnackbarContentProps = _props.SnackbarContentProps,
          TransitionProp = _props.transition,
          transitionDuration = _props.transitionDuration,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'anchorOrigin', 'autoHideDuration', 'children', 'classes', 'className', 'message', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onExit', 'onExited', 'onExiting', 'onMouseEnter', 'onMouseLeave', 'open', 'resumeHideDuration', 'SnackbarContentProps', 'transition', 'transitionDuration']);


      if (!open && this.state.exited) {
        return null;
      }

      var transitionProps = {};

      // The provided transition might not support the direction property.
      if (TransitionProp === _Slide2.default) {
        transitionProps.direction = vertical === 'top' ? 'down' : 'up';
      }

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onFocus: this.handleResume, onBlur: this.handlePause },
        _react2.default.createElement(
          _ClickAwayListener2.default,
          { onClickAway: this.handleClickAway },
          _react2.default.createElement(
            'div',
            (0, _extends9.default)({
              className: (0, _classnames2.default)(classes.root, classes['anchor' + (0, _helpers.capitalize)(vertical) + (0, _helpers.capitalize)(horizontal)], className),
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }, other),
            _react2.default.createElement(
              TransitionProp,
              (0, _extends9.default)({
                appear: true,
                'in': open,
                onEnter: onEnter,
                onEntered: onEntered,
                onEntering: onEntering,
                onExit: onExit,
                onExited: (0, _helpers.createChainedFunction)(this.handleExited, onExited),
                onExiting: onExiting,
                timeout: transitionDuration
              }, transitionProps),
              children || _react2.default.createElement(_SnackbarContent2.default, (0, _extends9.default)({ message: message, action: action }, SnackbarContentProps))
            )
          )
        )
      );
    }
  }]);
  return Snackbar;
}(_react2.default.Component);

Snackbar.propTypes =  false ? {
  /**
   * The action to display.
   */
  action: _propTypes2.default.node,
  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['left', 'center', 'right'])]),
    vertical: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['top', 'center', 'bottom'])])
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: _propTypes2.default.number,
  /**
   * If you wish the take control over the children of the component you can use this property.
   * When used, you replace the `SnackbarContent` component with the children.
   */
  children: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key property to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: _propTypes2.default.any,
  /**
   * The message to display.
   */
  message: _propTypes2.default.node,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the transition is entering.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the transition has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the transition is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired before the transition is exiting.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the transition has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * If true, `Snackbar` is open.
   */
  open: _propTypes2.default.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` property isn't specified, it does nothing.
   * If `autoHideDuration` property is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes2.default.number,
  /**
   * Properties applied to the `SnackbarContent` element.
   */
  SnackbarContentProps: _propTypes2.default.object,
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Snackbar.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center'
  },
  transition: _Slide2.default,
  transitionDuration: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withStyles2.default)(styles, { flip: false, name: 'MuiSnackbar' })(Snackbar);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schools__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downshift__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_List__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_Menu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Input__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_Form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_ui_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__action__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router_redux__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var types=['นักเรียนมัธยม','นักศึกษา','ครู/อาจารย์','ผู้ปกครอง','อื่นๆ'];var classLevels=['ม. 6','ม. 5','ม. 4','ม. 3','ม. 2','ม. 1'];function renderInput(inputProps){var InputProps=inputProps.InputProps,classes=inputProps.classes,ref=inputProps.ref,other=_objectWithoutProperties(inputProps,['InputProps','classes','ref']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a,Object.assign({style:{width:'100%'}},other,{inputRef:ref,InputProps:Object.assign({classes:{input:classes.input}},InputProps)}));}function renderSchool(params){var school=params.school,index=params.index,itemProps=params.itemProps,highlightedIndex=params.highlightedIndex,selectedItem=params.selectedItem;var isHighlighted=highlightedIndex===index;var isSelected=selectedItem===school;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu__["MenuItem"],Object.assign({},itemProps,{key:school,selected:isHighlighted,component:'div',style:{fontWeight:isSelected?500:400,width:'95%'}}),school);}function getSchools(inputValue){var count=0;return __WEBPACK_IMPORTED_MODULE_1__schools__["a" /* schools */].filter(function(school){var keep=(!inputValue||school.toLowerCase().includes(inputValue.toLowerCase()))&&count<10;if(keep){count+=1;}return keep;});}var ProfileContainer=function(_Component){_inherits(ProfileContainer,_Component);function ProfileContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ProfileContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ProfileContainer.__proto__||Object.getPrototypeOf(ProfileContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={name:"",level:"",school:"",type:"",anchorEl:null,anchorElClass:null,selectedIndex:-1,selectedClassIndex:-1},_this.handleClickListItem=function(event){_this.setState({anchorEl:event.currentTarget});},_this.handleClickClassListItem=function(event){_this.setState({anchorElClass:event.currentTarget});},_this.handleMenuItemClick=function(event,index){_this.setState({selectedIndex:index,anchorEl:null,type:types[index]});},_this.handleClassMenuItemClick=function(event,index){_this.setState({selectedClassIndex:index,anchorElClass:null,level:classLevels[index]});},_this.handleChange=function(prop){return function(event){_this.setState(_defineProperty({},prop,event.target.value));};},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProfileContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.setState({email:this.props.email});}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.props.profile.profileCompleted?this.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_19_react_router_redux__["push"])('/')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default.a,{container:true,style:{marginTop:"0px"},className:this.props.classes.centerGrid,spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default.a,{item:true,xs:12,md:4,className:this.props.classes.itemGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography___default.a,{type:'title',color:'default'},'\u0E01\u0E23\u0E2D\u0E01\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Input__["InputLabel"],{htmlFor:'email'},'\u0E0A\u0E37\u0E48\u0E2D-\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25 (\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Input___default.a,{className:this.props.classes.fullTextInput//type="email"
,onChange:this.handleChange('name'),value:this.state.name})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List___default.a,{component:'nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List__["ListItem"],{button:true,'aria-haspopup':'true','aria-controls':'lock-menu','aria-label':'When device is locked',onClick:this.handleClickListItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List__["ListItemText"],{primary:'\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49',secondary:types[this.state.selectedIndex]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu___default.a,{id:'lock-menu',anchorEl:this.state.anchorEl,open:Boolean(this.state.anchorEl),onClose:this.handleClose},types.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu__["MenuItem"],{key:option,selected:index===_this2.state.selectedIndex,onClick:function onClick(event){return _this2.handleMenuItemClick(event,index);}},option);}))),this.state.selectedIndex!==0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List___default.a,{component:'nav'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List__["ListItem"],{button:true,'aria-haspopup':'true','aria-controls':'lock-menu','aria-label':'\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E0A\u0E31\u0E49\u0E19',onClick:this.handleClickClassListItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_List__["ListItemText"],{primary:'\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E0A\u0E31\u0E49\u0E19',secondary:classLevels[this.state.selectedClassIndex]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu___default.a,{id:'lock-menu',anchorEl:this.state.anchorElClass,open:Boolean(this.state.anchorElClass),onClose:this.handleClose},classLevels.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Menu__["MenuItem"],{key:option,selected:index===_this2.state.selectedClassIndex,onClick:function onClick(event){return _this2.handleClassMenuItemClick(event,index);}},option);}))),this.state.selectedIndex!==0?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_downshift__["a" /* default */],{style:{width:'95%'},onChange:function onChange(selection){return _this2.setState({school:selection});}},function(_ref2){var getInputProps=_ref2.getInputProps,getItemProps=_ref2.getItemProps,isOpen=_ref2.isOpen,inputValue=_ref2.inputValue,selectedItem=_ref2.selectedItem,highlightedIndex=_ref2.highlightedIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,renderInput({fullWidth:true,classes:classes,InputProps:getInputProps({placeholder:'ค้นหาโรงเรียน',id:'integration-downshift'})}),isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{square:true,style:{width:'95%'}},getSchools(inputValue).map(function(school,index){return renderSchool({school:school,index:index,itemProps:getItemProps({item:school}),highlightedIndex:highlightedIndex,selectedItem:selectedItem});})):null);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_material_ui_Form__["FormControl"],{fullWidth:true,className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Button___default.a,{disabled:!this.state.name||!this.state.type//|| !this.state.school
,variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__action__["a" /* profileAdd */])(_this2.state.name,_this2.state.level,_this2.state.school,_this2.state.type));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E40\u0E23\u0E34\u0E48\u0E21\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A'))))));}}]);return ProfileContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function(_ref3){var profile=_ref3.firebase.profile;return{profile:profile};}))(ProfileContainer));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(114);

var _Input2 = _interopRequireDefault(_Input);

var _FormControl = __webpack_require__(360);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _FormHelperText = __webpack_require__(361);

var _FormHelperText2 = _interopRequireDefault(_FormHelperText);

var _Select = __webpack_require__(385);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 * - [FormControl](/api/form-control)
 * - [InputLabel](/api/input-label)
 * - [Input](/api/input)
 * - [FormHelperText](/api/form-helper-text)
 *
 * If you wish to alter the properties applied to the native input, you can do as follow:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 * - using the upper case props for passing values direct to the components.
 * - using the underlying components directly as shown in the demos.
 */
function TextField(props) {
  var autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      children = props.children,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      error = props.error,
      FormHelperTextProps = props.FormHelperTextProps,
      fullWidth = props.fullWidth,
      helperText = props.helperText,
      helperTextClassName = props.helperTextClassName,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      labelClassName = props.labelClassName,
      multiline = props.multiline,
      name = props.name,
      onChange = props.onChange,
      placeholder = props.placeholder,
      required = props.required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      select = props.select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['autoComplete', 'autoFocus', 'children', 'className', 'defaultValue', 'disabled', 'error', 'FormHelperTextProps', 'fullWidth', 'helperText', 'helperTextClassName', 'id', 'InputLabelProps', 'inputProps', 'InputProps', 'inputRef', 'label', 'labelClassName', 'multiline', 'name', 'onChange', 'placeholder', 'required', 'rows', 'rowsMax', 'select', 'SelectProps', 'type', 'value']);


   false ? (0, _warning2.default)(!select || Boolean(children), 'Material-UI: `children` must be passed when using the `TextField` component with `select`.') : void 0;

  var helperTextId = helperText && id ? id + '-helper-text' : undefined;
  var InputComponent = _react2.default.createElement(_Input2.default, (0, _extends3.default)({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: disabled,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onChange: onChange,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputProps));

  return _react2.default.createElement(
    _FormControl2.default,
    (0, _extends3.default)({
      'aria-describedby': helperTextId,
      className: className,
      error: error,
      fullWidth: fullWidth,
      required: required
    }, other),
    label && _react2.default.createElement(
      _Input.InputLabel,
      (0, _extends3.default)({ htmlFor: id, className: labelClassName }, InputLabelProps),
      label
    ),
    select ? _react2.default.createElement(
      _Select2.default,
      (0, _extends3.default)({ value: value, input: InputComponent }, SelectProps),
      children
    ) : InputComponent,
    helperText && _react2.default.createElement(
      _FormHelperText2.default,
      (0, _extends3.default)({ className: helperTextClassName, id: helperTextId }, FormHelperTextProps),
      helperText
    )
  );
} // @inheritedComponent FormControl

TextField.propTypes =  false ? {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: _propTypes2.default.string,
  /**
   * If `true`, the input will be focused during the first mount.
   */
  autoFocus: _propTypes2.default.bool,
  /**
   * @ignore
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The default value of the `Input` element.
   */
  defaultValue: _propTypes2.default.string,
  /**
   * If `true`, the input will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * Properties applied to the `FormHelperText` element.
   */
  FormHelperTextProps: _propTypes2.default.object,
  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes2.default.node,
  /**
   * The CSS class name of the helper text element.
   */
  helperTextClassName: _propTypes2.default.string,
  /**
   * The id of the `input` element.
   * Use that property to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `InputLabel` element.
   */
  InputLabelProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Input` element.
   */
  InputProps: _propTypes2.default.object,
  /**
   * Properties applied to the native `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /**
   * The label content.
   */
  label: _propTypes2.default.node,
  /**
   * The CSS class name of the label element.
   */
  labelClassName: _propTypes2.default.string,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes2.default.oneOf(['none', 'dense', 'normal']),
  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChange: _propTypes2.default.func,
  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: _propTypes2.default.string,
  /**
   * If `true`, the label is displayed as required.
   */
  required: _propTypes2.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * Render a `Select` element while passing the `Input` element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: _propTypes2.default.bool,
  /**
   * Properties applied to the `Select` element.
   */
  SelectProps: _propTypes2.default.object,
  /**
   * Type attribute of the `Input` element. It should be a valid HTML5 input type.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the `Input` element, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

TextField.defaultProps = {
  required: false,
  select: false
};

exports.default = TextField;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      maxHeight: '2em',
      alignItems: 'center'
    },
    positionStart: {
      marginRight: theme.spacing.unit
    },
    positionEnd: {
      marginLeft: theme.spacing.unit
    }
  };
};

function InputAdornment(props) {
  var _classNames;

  var children = props.children,
      Component = props.component,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      position = props.position,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'component', 'classes', 'className', 'disableTypography', 'position']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.positionStart, position === 'start'), (0, _defineProperty3.default)(_classNames, classes.positionEnd, position === 'end'), _classNames), className)
    }, other),
    typeof children === 'string' && !disableTypography ? _react2.default.createElement(
      _Typography2.default,
      { color: 'textSecondary' },
      children
    ) : children
  );
}

InputAdornment.propTypes =  false ? {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: _propTypes2.default.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes2.default.oneOf(['start', 'end'])
} : {};

InputAdornment.defaultProps = {
  component: 'div',
  disableTypography: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputAdornment' })(InputAdornment);

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Form = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      transformOrigin: 'top left'
    },
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, ' + theme.spacing.unit * 3 + 'px) scale(1)'
    },
    labelDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, ' + (theme.spacing.unit * 2.5 + 1) + 'px) scale(1)'
    },
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },
    animated: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },
    disabled: {
      color: theme.palette.text.disabled
    }
  };
}; // @inheritedComponent FormLabel

function InputLabel(props, context) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      disableAnimation = props.disableAnimation,
      disabled = props.disabled,
      FormControlClasses = props.FormControlClasses,
      marginProp = props.margin,
      shrinkProp = props.shrink,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableAnimation', 'disabled', 'FormControlClasses', 'margin', 'shrink']);
  var muiFormControl = context.muiFormControl;

  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.dirty || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var margin = marginProp;
  if (typeof margin === 'undefined' && muiFormControl) {
    margin = muiFormControl.margin;
  }

  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.formControl, muiFormControl), (0, _defineProperty3.default)(_classNames, classes.animated, !disableAnimation), (0, _defineProperty3.default)(_classNames, classes.shrink, shrink), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.labelDense, margin === 'dense'), _classNames), classNameProp);

  return _react2.default.createElement(
    _Form.FormLabel,
    (0, _extends3.default)({ 'data-shrink': shrink, className: className, classes: FormControlClasses }, other),
    children
  );
}

InputLabel.propTypes =  false ? {
  /**
   * The contents of the `InputLabel`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: _propTypes2.default.bool,
  /**
   * If `true`, apply disabled class.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: _propTypes2.default.bool,
  /**
   * If `true`, the input of this label is focused.
   */
  focused: _propTypes2.default.bool,
  /**
   * `classes` property applied to the `FormControl` element.
   */
  FormControlClasses: _propTypes2.default.object,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes2.default.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: _propTypes2.default.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes2.default.bool
} : {};

InputLabel.defaultProps = {
  disabled: false,
  disableAnimation: false
};

InputLabel.contextTypes = {
  muiFormControl: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiInputLabel' })(InputLabel);

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _ArrowDropDown = __webpack_require__(864);

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _Menu = __webpack_require__(372);

var _Menu2 = _interopRequireDefault(_Menu);

var _Input = __webpack_require__(219);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var SelectInput = function (_React$Component) {
  (0, _inherits3.default)(SelectInput, _React$Component);

  function SelectInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SelectInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectInput.__proto__ || (0, _getPrototypeOf2.default)(SelectInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.ignoreNextBlur = false, _this.displayNode = null, _this.isControlled = _this.props.open !== undefined, _this.update = _this.isControlled ? function (_ref2) {
      var event = _ref2.event,
          open = _ref2.open;

      if (open) {
        _this.props.onOpen(event);
      } else {
        _this.props.onClose(event);
      }
    } : function (_ref3) {
      var open = _ref3.open;
      return _this.setState({ open: open });
    }, _this.handleClick = function (event) {
      // Opening the menu is going to blur the. It will be focused back when closed.
      _this.ignoreNextBlur = true;
      _this.update({
        open: true,
        event: event
      });
    }, _this.handleClose = function (event) {
      _this.update({
        open: false,
        event: event
      });
    }, _this.handleItemClick = function (child) {
      return function (event) {
        if (!_this.props.multiple) {
          _this.update({
            open: false,
            event: event
          });
        }

        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;


        if (onChange) {
          var value = void 0;
          var target = void 0;

          if (event.target) {
            target = event.target;
          }

          if (_this.props.multiple) {
            value = Array.isArray(_this.props.value) ? [].concat((0, _toConsumableArray3.default)(_this.props.value)) : [];
            var itemIndex = value.indexOf(child.props.value);
            if (itemIndex === -1) {
              value.push(child.props.value);
            } else {
              value.splice(itemIndex, 1);
            }
          } else {
            value = child.props.value;
          }

          event.persist();
          event.target = (0, _extends3.default)({}, target, { value: value, name: name });

          onChange(event, child);
        }
      };
    }, _this.handleBlur = function (event) {
      if (_this.ignoreNextBlur === true) {
        // The parent components are relying on the bubbling of the event.
        event.stopPropagation();
        _this.ignoreNextBlur = false;
        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    }, _this.handleKeyDown = function (event) {
      if (_this.props.readOnly) {
        return;
      }

      if (['space', 'up', 'down'].includes((0, _keycode2.default)(event))) {
        event.preventDefault();
        // Opening the menu is going to blur the. It will be focused back when closed.
        _this.ignoreNextBlur = true;
        _this.update({
          open: true,
          event: event
        });
      }
    }, _this.handleSelectRef = function (node) {
      if (!_this.props.inputRef) {
        return;
      }

      _this.props.inputRef({
        node: node,
        // By pass the native input as we expose a rich object (array).
        value: _this.props.value
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SelectInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isControlled && this.props.open) {
        // Focus the display node so the focus is restored on this element once
        // the menu is closed.
        this.displayNode.focus();
        // Rerender with the resolve `displayNode` reference.
        this.forceUpdate();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoWidth = _props.autoWidth,
          children = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          displayEmpty = _props.displayEmpty,
          inputRef = _props.inputRef,
          _props$MenuProps = _props.MenuProps,
          MenuProps = _props$MenuProps === undefined ? {} : _props$MenuProps,
          multiple = _props.multiple,
          name = _props.name,
          native = _props.native,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          onClose = _props.onClose,
          onFocus = _props.onFocus,
          onOpen = _props.onOpen,
          openProp = _props.open,
          readOnly = _props.readOnly,
          renderValue = _props.renderValue,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'classes', 'className', 'disabled', 'displayEmpty', 'inputRef', 'MenuProps', 'multiple', 'name', 'native', 'onBlur', 'onChange', 'onClose', 'onFocus', 'onOpen', 'open', 'readOnly', 'renderValue', 'value']);

      var open = this.isControlled && this.displayNode ? openProp : this.state.open;

      if (native) {
         false ? (0, _warning2.default)(multiple === false, 'Material-UI: you can not use the `native` and `multiple` properties ' + 'at the same time on a `Select` component.') : void 0;
         false ? (0, _warning2.default)(!renderValue, 'Material-UI: the `renderValue` property is not used by the native implementation.') : void 0;
         false ? (0, _warning2.default)(!displayEmpty, 'Material-UI: the `displayEmpty` property is not used by the native implementation.') : void 0;

        return _react2.default.createElement(
          'div',
          { className: classes.root },
          _react2.default.createElement(
            'select',
            (0, _extends3.default)({
              className: (0, _classnames2.default)(classes.select, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
              name: name,
              disabled: disabled,
              onBlur: onBlur,
              onChange: onChange,
              onFocus: onFocus,
              value: value,
              readOnly: readOnly,
              ref: inputRef
            }, other),
            children
          ),
          _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon })
        );
      }

      if (value === undefined) {
        throw new Error('Material-UI: the `value` property is required ' + 'when using the `Select` component with `native=false`.');
      }

      var display = void 0;
      var displaySingle = '';
      var displayMultiple = [];
      var computeDisplay = false;

      // No need to display any value if the field is empty.
      if ((0, _Input.isDirty)(this.props) || displayEmpty) {
        if (renderValue) {
          display = renderValue(value);
        } else {
          computeDisplay = true;
        }
      }

      var items = _react2.default.Children.map(children, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }
        var selected = void 0;

        if (multiple) {
          if (!Array.isArray(value)) {
            throw new Error('Material-UI: the `value` property must be an array ' + 'when using the `Select` component with `multiple`.');
          }

          selected = value.indexOf(child.props.value) !== -1;
          if (selected && computeDisplay) {
            displayMultiple.push(child.props.children);
          }
        } else {
          selected = value === child.props.value;
          if (selected && computeDisplay) {
            displaySingle = child.props.children;
          }
        }

        return _react2.default.cloneElement(child, {
          role: 'option',
          selected: selected,
          onClick: _this2.handleItemClick(child)
        });
      });

      if (computeDisplay) {
        display = multiple ? displayMultiple.join(', ') : displaySingle;
      }

      var MenuMinWidth = this.displayNode && !autoWidth ? this.displayNode.clientWidth : undefined;

      return _react2.default.createElement(
        'div',
        { className: classes.root },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(classes.select, classes.selectMenu, (0, _defineProperty3.default)({}, classes.disabled, disabled), classNameProp),
            ref: function ref(node) {
              _this2.displayNode = node;
            },

            'aria-pressed': open ? 'true' : 'false',
            tabIndex: disabled ? null : 0,
            role: 'button',
            'aria-owns': open ? 'menu-' + (name || '') : null,
            'aria-haspopup': 'true',
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleBlur,
            onClick: disabled || readOnly ? null : this.handleClick,
            onFocus: onFocus
          },
          display
        ),
        _react2.default.createElement('input', (0, _extends3.default)({
          value: Array.isArray(value) ? value.join(',') : value,
          name: name,
          readOnly: readOnly,
          ref: this.handleSelectRef
        }, other, {
          type: 'hidden'
        })),
        _react2.default.createElement(_ArrowDropDown2.default, { className: classes.icon }),
        _react2.default.createElement(
          _Menu2.default,
          (0, _extends3.default)({
            id: 'menu-' + (name || ''),
            anchorEl: this.displayNode,
            open: open,
            onClose: this.handleClose
          }, MenuProps, {
            MenuListProps: (0, _extends3.default)({
              role: 'listbox'
            }, MenuProps.MenuListProps),
            PaperProps: (0, _extends3.default)({}, MenuProps.PaperProps, {
              style: (0, _extends3.default)({
                minWidth: MenuMinWidth
              }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
            })
          }),
          items
        )
      );
    }
  }]);
  return SelectInput;
}(_react2.default.Component);

SelectInput.propTypes =  false ? {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes2.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The CSS class name of the select element.
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the select will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   * You can only use it when the `native` property is `false` (default).
   */
  displayEmpty: _propTypes2.default.bool,
  /**
   * Use that property to pass a ref callback to the native select element.
   */
  inputRef: _propTypes2.default.func,
  /**
   * Properties applied to the `Menu` element.
   */
  MenuProps: _propTypes2.default.object,
  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   * You can only use it when the `native` property is `false` (default).
   */
  multiple: _propTypes2.default.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes2.default.string,
  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback
   * @param {object} child The react element that was selected
   */
  onChange: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Useful in controlled mode (see open).
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * Control `select` open state.
   * You can only use it when the `native` property is `false` (default).
   */
  open: _propTypes2.default.bool,
  /**
   * @ignore
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` property is `false` (default).
   */
  renderValue: _propTypes2.default.func,
  /**
   * The value of the component, required for a controlled component.
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))])
} : {};

exports.default = SelectInput;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' });

var ArrowDropDown = function ArrowDropDown(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};

ArrowDropDown = (0, _pure2.default)(ArrowDropDown);
ArrowDropDown.muiName = 'SvgIcon';

exports.default = ArrowDropDown;

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profileAdd; });
/* unused harmony export profileSuccess */
/* unused harmony export profileFailure */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(110);
var profileAdd=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["g" /* PROFILE_ADD */],'name','level','school','userType');var profileSuccess=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["i" /* PROFILE_SUCCESS */]);var profileFailure=Object(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["l" /* makeActionCreator */])(__WEBPACK_IMPORTED_MODULE_0__actionTypes__["h" /* PROFILE_FAILURE */]);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserIsAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UserIsNotAuthenticated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(33);
//import LoadingScreenComponent from './main/LoadingScreenComponent'; // change it to your custom component
var locationHelper=__WEBPACK_IMPORTED_MODULE_0_redux_auth_wrapper_history4_locationHelper___default()({});var UserIsAuthenticated=Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedReduxRedirect"])({wrapperDisplayName:'UserIsAuthenticated',//AuthenticatingComponent: LoadingScreenComponent,
allowRedirectBack:true,redirectPath:function redirectPath(state,ownProps){return locationHelper.getRedirectQueryParam(ownProps)||'/signin';},authenticatingSelector:function authenticatingSelector(_ref){var _ref$firebase=_ref.firebase,auth=_ref$firebase.auth,profile=_ref$firebase.profile,isInitializing=_ref$firebase.isInitializing;return!auth.isLoaded||isInitializing===true;},authenticatedSelector:function authenticatedSelector(_ref2){var auth=_ref2.firebase.auth;return auth.isLoaded&&!auth.isEmpty;},redirectAction:__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerActions"].replace});var UserIsNotAuthenticated=Object(__WEBPACK_IMPORTED_MODULE_1_redux_auth_wrapper_history4_redirect__["connectedReduxRedirect"])({wrapperDisplayName:'UserIsNotAuthenticated',//AuthenticatingComponent: LoadingScreenComponent,
allowRedirectBack:false,redirectPath:function redirectPath(state,ownProps){return locationHelper.getRedirectQueryParam(ownProps)||'/';},authenticatingSelector:function authenticatingSelector(_ref3){var _ref3$firebase=_ref3.firebase,auth=_ref3$firebase.auth,isInitializing=_ref3$firebase.isInitializing;return!auth.isLoaded||isInitializing===true;},authenticatedSelector:function authenticatedSelector(_ref4){var auth=_ref4.firebase.auth;return auth.isLoaded&&auth.isEmpty;},redirectAction:__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerActions"].replace});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(868);
var util = __webpack_require__(869);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(870);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)(module), __webpack_require__(15)))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(871);
exports.encode = exports.stringify = __webpack_require__(872);


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(874);
var objectAssign = __webpack_require__(115);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectedReduxRedirect = exports.connectedRouterRedirect = undefined;

var _locationHelper = __webpack_require__(387);

var _locationHelper2 = _interopRequireDefault(_locationHelper);

var _redirect = __webpack_require__(876);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _redirectUtil = (0, _redirect2.default)({
  locationHelperBuilder: _locationHelper2.default,
  getRouterRedirect: function getRouterRedirect(_ref) {
    var history = _ref.history;
    return history.replace;
  }
});

var connectedRouterRedirect = _redirectUtil.connectedRouterRedirect,
    connectedReduxRedirect = _redirectUtil.connectedReduxRedirect;
exports.connectedRouterRedirect = connectedRouterRedirect;
exports.connectedReduxRedirect = connectedReduxRedirect;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(36);

var _invariant = __webpack_require__(877);

var _invariant2 = _interopRequireDefault(_invariant);

var _authWrapper = __webpack_require__(878);

var _authWrapper2 = _interopRequireDefault(_authWrapper);

var _redirect = __webpack_require__(880);

var _redirect2 = _interopRequireDefault(_redirect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connectedDefaults = {
  authenticatingSelector: function authenticatingSelector() {
    return false;
  },
  allowRedirectBack: true,
  FailureComponent: _redirect2.default,
  redirectQueryParamName: 'redirect'
};

exports.default = function (_ref) {
  var locationHelperBuilder = _ref.locationHelperBuilder,
      getRouterRedirect = _ref.getRouterRedirect;


  var connectedRouterRedirect = function connectedRouterRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var redirect = function redirect(replace) {
      return function (props, path) {
        return replace(createRedirectLoc(allowRedirectBackFn(props, path))(props, path));
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(function (state, ownProps) {
      return {
        redirect: redirect(getRouterRedirect(ownProps))
      };
    })(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  var connectedReduxRedirect = function connectedReduxRedirect(args) {
    var allArgs = _extends({}, connectedDefaults, args);
    var FailureComponent = allArgs.FailureComponent,
        redirectPath = allArgs.redirectPath,
        authenticatedSelector = allArgs.authenticatedSelector,
        authenticatingSelector = allArgs.authenticatingSelector,
        allowRedirectBack = allArgs.allowRedirectBack,
        redirectAction = allArgs.redirectAction,
        redirectQueryParamName = allArgs.redirectQueryParamName;

    var _locationHelperBuilde2 = locationHelperBuilder({
      redirectQueryParamName: redirectQueryParamName
    }),
        createRedirectLoc = _locationHelperBuilde2.createRedirectLoc;

    var redirectPathSelector = void 0;
    if (typeof redirectPath === 'string') {
      redirectPathSelector = function redirectPathSelector() {
        return redirectPath;
      };
    } else if (typeof redirectPath === 'function') {
      redirectPathSelector = redirectPath;
    } else {
      (0, _invariant2.default)(false, 'redirectPath must be either a string or a function');
    }

    var allowRedirectBackFn = void 0;
    if (typeof allowRedirectBack === 'boolean') {
      allowRedirectBackFn = function allowRedirectBackFn() {
        return allowRedirectBack;
      };
    } else if (typeof allowRedirectBack === 'function') {
      allowRedirectBackFn = allowRedirectBack;
    } else {
      (0, _invariant2.default)(false, 'allowRedirectBack must be either a boolean or a function');
    }

    var createRedirect = function createRedirect(dispatch) {
      return {
        redirect: function redirect(props, path) {
          return dispatch(redirectAction(createRedirectLoc(allowRedirectBackFn(props, path))(props, path)));
        }
      };
    };

    var ConnectedFailureComponent = (0, _reactRedux.connect)(null, createRedirect)(FailureComponent);

    return function (DecoratedComponent) {
      return (0, _reactRedux.connect)(function (state, ownProps) {
        return {
          redirectPath: redirectPathSelector(state, ownProps),
          isAuthenticated: authenticatedSelector(state, ownProps),
          isAuthenticating: authenticatingSelector(state, ownProps)
        };
      })((0, _authWrapper2.default)(_extends({}, allArgs, { FailureComponent: ConnectedFailureComponent }))(DecoratedComponent));
    };
  };

  return {
    connectedRouterRedirect: connectedRouterRedirect,
    connectedReduxRedirect: connectedReduxRedirect
  };
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(879);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  AuthenticatingComponent: function AuthenticatingComponent() {
    return null;
  }, // dont render anything while authenticating
  FailureComponent: function FailureComponent() {
    return null;
  }, // dont render anything on failure of the predicate
  wrapperDisplayName: 'AuthWrapper'
};

exports.default = function (args) {
  var _defaults$args = _extends({}, defaults, args),
      AuthenticatingComponent = _defaults$args.AuthenticatingComponent,
      FailureComponent = _defaults$args.FailureComponent,
      wrapperDisplayName = _defaults$args.wrapperDisplayName;

  // Wraps the component that needs the auth enforcement


  function wrapComponent(DecoratedComponent) {
    var _class, _temp;

    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

    var UserAuthWrapper = (_temp = _class = function (_Component) {
      _inherits(UserAuthWrapper, _Component);

      function UserAuthWrapper() {
        _classCallCheck(this, UserAuthWrapper);

        return _possibleConstructorReturn(this, (UserAuthWrapper.__proto__ || Object.getPrototypeOf(UserAuthWrapper)).apply(this, arguments));
      }

      _createClass(UserAuthWrapper, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              isAuthenticated = _props.isAuthenticated,
              isAuthenticating = _props.isAuthenticating;

          if (isAuthenticated) {
            return _react2.default.createElement(DecoratedComponent, this.props);
          } else if (isAuthenticating) {
            return _react2.default.createElement(AuthenticatingComponent, this.props);
          } else {
            return _react2.default.createElement(FailureComponent, this.props);
          }
        }
      }]);

      return UserAuthWrapper;
    }(_react.Component), _class.displayName = wrapperDisplayName + '(' + displayName + ')', _class.propTypes = {
      isAuthenticated: _propTypes2.default.bool,
      isAuthenticating: _propTypes2.default.bool
    }, _class.defaultProps = {
      isAuthenticating: false
    }, _temp);


    return (0, _hoistNonReactStatics2.default)(UserAuthWrapper, DecoratedComponent);
  }

  return wrapComponent;
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Redirect = (_temp = _class = function (_Component) {
  _inherits(Redirect, _Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).apply(this, arguments));
  }

  _createClass(Redirect, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.redirect(this.props, this.props.redirectPath);
    }
  }, {
    key: 'render',
    value: function render() {
      // Redirect should happen before this is rendered
      return null;
    }
  }]);

  return Redirect;
}(_react.Component), _class.propTypes = {
  redirectPath: _propTypes2.default.string.isRequired,
  redirect: _propTypes2.default.func.isRequired
}, _temp);
exports.default = Redirect;

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_Extension__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_icons_Extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_Extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_icons_Person__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_icons_InsertEmoticon__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_icons_InsertEmoticon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_icons_InsertEmoticon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Work__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Work___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Work__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CognitiveTestContainer__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OtherTestContainer__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__testPool__ = __webpack_require__(226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TestContainer=function(_Component){_inherits(TestContainer,_Component);function TestContainer(){_classCallCheck(this,TestContainer);return _possibleConstructorReturn(this,(TestContainer.__proto__||Object.getPrototypeOf(TestContainer)).apply(this,arguments));}_createClass(TestContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__["isEmpty"])(this.props.profile)&&this.props.profile.currentTest==='cognitive'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__CognitiveTestContainer__["a" /* default */],{profile:this.props.profile}),!Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__["isEmpty"])(this.props.profile)&&this.props.profile.currentTest!=='cognitive'&&this.props.profile.currentTest!=='finished'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OtherTestContainer__["a" /* default */],{profile:this.props.profile}),!Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__["isEmpty"])(this.props.profile)&&!Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__["isEmpty"])(this.props.profile.currentTest)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation___default.a,{value:this.props.profile.currentTest,style:{position:'fixed',bottom:'0',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__["BottomNavigationAction"],{disabled:true,label:'\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49',value:'cognitive',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_icons_Extension___default.a,null)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__["BottomNavigationAction"],{disabled:true,label:'\u0E1A\u0E38\u0E04\u0E25\u0E34\u0E01\u0E20\u0E32\u0E1E',value:'personality',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_material_ui_icons_Person___default.a,null)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__["BottomNavigationAction"],{disabled:true,label:'\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E07\u0E32\u0E19',value:'softskills',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_icons_InsertEmoticon___default.a,null)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_BottomNavigation__["BottomNavigationAction"],{disabled:true,label:'\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E19\u0E43\u0E08',value:'wp',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_icons_Work___default.a,null)})));}}]);return TestContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_4_material_ui_styles_withTheme___default()(),Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function(_ref){var profile=_ref.firebase.profile;return{profile:profile};}))(TestContainer));

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};

function BottomNavigation(props) {
  var childrenProp = props.children,
      classes = props.classes,
      classNameProp = props.className,
      onChange = props.onChange,
      showLabels = props.showLabels,
      value = props.value,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'onChange', 'showLabels', 'value']);


  var className = (0, _classnames2.default)(classes.root, classNameProp);

  var children = _react2.default.Children.map(childrenProp, function (child, childIndex) {
    if (!_react2.default.isValidElement(child)) {
      return null;
    }

    var childValue = child.props.value || childIndex;
    return _react2.default.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  });

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    children
  );
}

BottomNavigation.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: _propTypes2.default.func,
  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: _propTypes2.default.bool,
  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes2.default.any
} : {};

BottomNavigation.defaultProps = {
  showLabels: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigation' })(BottomNavigation);

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      paddingTop: theme.spacing.unit,
      paddingBottom: 10,
      paddingLeft: 12,
      paddingRight: 12,
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1'
    },
    selected: {
      paddingTop: 6,
      color: theme.palette.primary.main
    },
    selectedIconOnly: {
      paddingTop: theme.spacing.unit * 2
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s'
    },
    selectedLabel: {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize)
    },
    hiddenLabel: {
      opacity: 0,
      transitionDelay: '0s'
    }
  };
}; // @inheritedComponent ButtonBase

var BottomNavigationAction = function (_React$Component) {
  (0, _inherits3.default)(BottomNavigationAction, _React$Component);

  function BottomNavigationAction() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BottomNavigationAction);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BottomNavigationAction.__proto__ || (0, _getPrototypeOf2.default)(BottomNavigationAction)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;


      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BottomNavigationAction, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          icon = _props.icon,
          label = _props.label,
          onChange = _props.onChange,
          onClick = _props.onClick,
          selected = _props.selected,
          showLabelProp = _props.showLabel,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'icon', 'label', 'onChange', 'onClick', 'selected', 'showLabel', 'value']);


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.selected, selected), (0, _defineProperty3.default)(_classNames, classes.selectedIconOnly, !showLabelProp && !selected), _classNames), classNameProp);

      var labelClassName = (0, _classnames2.default)(classes.label, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.selectedLabel, selected), (0, _defineProperty3.default)(_classNames2, classes.hiddenLabel, !showLabelProp && !selected), _classNames2));

      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends3.default)({ className: className, focusRipple: true, onClick: this.handleChange }, other),
        _react2.default.createElement(
          'span',
          { className: classes.wrapper },
          icon,
          _react2.default.createElement(
            'span',
            { className: labelClassName },
            label
          )
        )
      );
    }
  }]);
  return BottomNavigationAction;
}(_react2.default.Component);

BottomNavigationAction.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The icon element.
   */
  icon: _propTypes2.default.node,
  /**
   * The label element.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  selected: _propTypes2.default.bool,
  /**
   * If `true`, the BottomNavigationAction will show its label.
   */
  showLabel: _propTypes2.default.bool,
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes2.default.any
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBottomNavigationAction' })(BottomNavigationAction);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' });

var Person = function Person(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Person = (0, _pure2.default)(Person);
Person.muiName = 'SvgIcon';

exports.default = Person;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__testPool__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Card__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_Progress__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getQuestionImage(key,index){return'https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/raven%2FQ%2FQ'+key+'-0'+index+'-01.jpg?alt=media';}function getAnswerImage(key,index,choice){return'https://firebasestorage.googleapis.com/v0/b/mycareer-ai.appspot.com/o/raven%2FA%2FQ'+key+'-0'+index+'-0'+(choice+1)+'.jpg?alt=media';}function shuffle(a){for(var i=a.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var _ref=[a[j],a[i]];a[i]=_ref[0];a[j]=_ref[1];}return a;}var CognitiveTestContainer=function(_Component){_inherits(CognitiveTestContainer,_Component);function CognitiveTestContainer(props){_classCallCheck(this,CognitiveTestContainer);//console.log(this.props)
var _this=_possibleConstructorReturn(this,(CognitiveTestContainer.__proto__||Object.getPrototypeOf(CognitiveTestContainer)).call(this,props));_this.index=0;_this.test={};_this.key='';_this.choices=shuffle([1,2,3,4,5]);_this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["a" /* cognitive */][_this.props.profile.currentIndex];_this.key=Object.keys(_this.test)[0];_this.index=Math.floor(Math.random()*_this.test[_this.key]+1);_this.choices=shuffle(_this.choices);return _this;}_createClass(CognitiveTestContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){//console.log('COGNITIVETESTCONTAINER GET NEW PROPS!', this.props)
this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["a" /* cognitive */][this.props.profile.currentIndex];this.key=Object.keys(this.test)[0];this.index=Math.floor(Math.random()*this.test[this.key]+1);this.choices=shuffle(this.choices);this.forceUpdate();}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{container:true,style:{marginTop:"8px"},className:this.props.classes.centerGrid,spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card___default.a,{elevation:4,style:{width:'372px   '}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Card__["CardContent"],{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Typography___default.a,{variant:'caption'},'\u0E41\u0E1A\u0E1A\u0E17\u0E14\u0E2A\u0E2D\u0E1A\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48 1 - \u0E40\u0E0A\u0E32\u0E27\u0E19\u0E4C\u0E1B\u0E31\u0E0D\u0E0D\u0E32'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Typography___default.a,{variant:'caption'},'\u0E08\u0E07\u0E1E\u0E34\u0E08\u0E32\u0E23\u0E13\u0E32\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E02\u0E2D\u0E07\u0E2D\u0E19\u0E38\u0E01\u0E23\u0E21\u0E20\u0E32\u0E1E\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E2B\u0E32\u0E20\u0E32\u0E1E\u0E17\u0E35\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E31\u0E21\u0E1E\u0E31\u0E19\u0E18\u0E4C\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E20\u0E32\u0E1E\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getQuestionImage(this.key,this.index),alt:'#',style:{width:'360px',margin:'6px 6px 0'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{container:true,justify:'center',direction:'row',style:{marginTop:"8px",flexGrow:1},spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,'cognitive',_this2.props.profile.currentIndex,_this2.key,_this2.choices[0],null));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getAnswerImage(this.key,this.index,this.choices[0]),alt:'#',style:{width:'104px',margin:'6px 6px 0'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,'cognitive',_this2.props.profile.currentIndex,_this2.key,_this2.choices[1],null));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getAnswerImage(this.key,this.index,this.choices[1]),alt:'#',style:{width:'104px',margin:'6px 6px 0'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,'cognitive',_this2.props.profile.currentIndex,_this2.key,_this2.choices[2],null));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getAnswerImage(this.key,this.index,this.choices[2]),alt:'#',style:{width:'104px',margin:'6px 6px 0'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,'cognitive',_this2.props.profile.currentIndex,_this2.key,_this2.choices[3],null));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getAnswerImage(this.key,this.index,this.choices[3]),alt:'#',style:{width:'104px',margin:'6px 6px 0'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Paper___default.a//style={{marginBottom: '100px'}}
,{onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,'cognitive',_this2.props.profile.currentIndex,_this2.key,_this2.choices[4],null));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:getAnswerImage(this.key,this.index,this.choices[4]),alt:'#',style:{width:'104px',margin:'6px 6px 0'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{container:true,style:{marginTop:"8px"},className:this.props.classes.centerGrid,spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Typography___default.a,{style:{textAlign:'center'}},this.props.profile.currentIndex+1+'/15')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('center',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Progress__["LinearProgress"],{style:{width:'350px',marginBottom:'100px'},color:'secondary',variant:'determinate',value:(this.props.profile.currentIndex+1)/15*100})))));}}]);return CognitiveTestContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function(_ref2){var auth=_ref2.firebase.auth;return{auth:auth};}))(CognitiveTestContainer));

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__testPool__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_Progress__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OtherTestContainer=function(_Component){_inherits(OtherTestContainer,_Component);function OtherTestContainer(props){_classCallCheck(this,OtherTestContainer);var _this=_possibleConstructorReturn(this,(OtherTestContainer.__proto__||Object.getPrototypeOf(OtherTestContainer)).call(this,props));_this.key='';_this.test={};_this.answerText=['ไม่ตรงเลย','ไม่ค่อยตรง','ปานกลาง','ค่อนข้างตรง','ตรงมาก'];_this.max=15;switch(_this.props.profile.currentTest){case'personality':_this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["b" /* personality */][_this.props.profile.currentIndex];break;case'softskills':_this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["c" /* softskills */][_this.props.profile.currentIndex];break;case'wp':_this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["d" /* wp */][_this.props.profile.currentIndex];_this.answerText=['สนใจมาก','สนใจ','เฉยๆ','ไม่ค่อยสนใจ','ไม่สนใจเลย'];break;default:console.log('INVALID TESTTYPE');}_this.key=Object.keys(_this.test)[0];return _this;}_createClass(OtherTestContainer,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){switch(this.props.profile.currentTest){case'personality':this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["b" /* personality */][this.props.profile.currentIndex];break;case'softskills':this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["c" /* softskills */][this.props.profile.currentIndex];break;case'wp':this.test=__WEBPACK_IMPORTED_MODULE_8__testPool__["d" /* wp */][this.props.profile.currentIndex];this.answerText=['สนใจมาก','สนใจ','เฉยๆ','ไม่ค่อยสนใจ','ไม่สนใจเลย'];break;default:console.log('INVALID TESTTYPE');}this.key=Object.keys(this.test)[0];}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{container:true,justify:'center',direction:'column',style:{marginTop:"8px",flexGrow:1,alignItems:'center'},spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Grid___default.a,{item:true,style:{margin:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card___default.a,{elevation:4,style:{width:'350px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__["CardContent"],{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{variant:'caption'},this.props.profile.currentTest==='personality'?'ส่วนที่ 2 - บุคลิกภาพ ':this.props.profile.currentTest==='softskills'?'ส่วนที่ 3 - การปฏิบัติงาน':'ส่วนที่ 4 - ความสนใจ '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{variant:'caption'},this.props.profile.currentTest==='personality'?'ข้อความต่อไปนี้ตรงกับบุคลิกของท่านเพียงใด':this.props.profile.currentTest==='softskills'?'ข้อความต่อไปนี้อธิบายการทำงานของท่านดีเพียงใด':'ท่านสนใจที่จะทำหรือเรียนรู้กิจกรรมนี้เพียงใด')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui__["a" /* Divider */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_Card__["CardActions"],{style:{justifyContent:'center',textAlign:'center',height:'100px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{variant:'headline',component:'h3'},this.key))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default.a,{onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,_this2.props.profile.currentTest,_this2.props.profile.currentIndex,_this2.key,_this2.test[_this2.key].score[0],_this2.test[_this2.key].trait));},variant:'raised',color:'secondary',style:{width:'350px',marginTop:'8px'}},this.answerText[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default.a,{onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,_this2.props.profile.currentTest,_this2.props.profile.currentIndex,_this2.key,_this2.test[_this2.key].score[1],_this2.test[_this2.key].trait));},variant:'raised',color:'secondary',style:{width:'350px',marginTop:'8px'}},this.answerText[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default.a,{onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,_this2.props.profile.currentTest,_this2.props.profile.currentIndex,_this2.key,_this2.test[_this2.key].score[2],_this2.test[_this2.key].trait));},variant:'raised',color:'secondary',style:{width:'350px',marginTop:'8px'}},this.answerText[2]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default.a,{onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,_this2.props.profile.currentTest,_this2.props.profile.currentIndex,_this2.key,_this2.test[_this2.key].score[3],_this2.test[_this2.key].trait));},variant:'raised',color:'secondary',style:{width:'350px',marginTop:'8px'}},this.answerText[3]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_material_ui_Button___default.a,{onClick:function onClick(){_this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__action__["a" /* testAnswer */])(_this2.props.auth.uid,_this2.props.profile.currentTest,_this2.props.profile.currentIndex,_this2.key,_this2.test[_this2.key].score[4],_this2.test[_this2.key].trait));},variant:'raised',color:'secondary',style:{width:'350px',marginTop:'8px'}},this.answerText[4]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.props.profile.currentTest==='personality'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{style:{textAlign:'center'}},this.props.profile.currentIndex+1,'/',this.max=40)):this.props.profile==='softskills'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{style:{textAlign:'center'}},this.props.profile.currentIndex+1,'/',this.max=28)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_material_ui_Typography___default.a,{style:{textAlign:'center'}},this.props.profile.currentIndex+1,'/',this.max=30)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Progress__["LinearProgress"],{style:{width:'350px'},color:'secondary',variant:'determinate',value:(this.props.profile.currentIndex+1)/this.max*100}))));}}]);return OtherTestContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function(_ref){var auth=_ref.firebase.auth;return{auth:auth};}))(OtherTestContainer));

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppBar__);
/* unused harmony reexport AppBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Avatar__);
/* unused harmony reexport Avatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Badge__);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BottomNavigation__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BottomNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__BottomNavigation__);
/* unused harmony reexport BottomNavigation */
/* unused harmony reexport BottomNavigationAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Button__);
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ButtonBase__);
/* unused harmony reexport ButtonBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Card__);
/* unused harmony reexport Card */
/* unused harmony reexport CardActions */
/* unused harmony reexport CardContent */
/* unused harmony reexport CardHeader */
/* unused harmony reexport CardMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Checkbox__);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Chip__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Chip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Chip__);
/* unused harmony reexport Chip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__utils_ClickAwayListener__);
/* unused harmony reexport ClickAwayListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dialog__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Dialog__);
/* unused harmony reexport Dialog */
/* unused harmony reexport DialogActions */
/* unused harmony reexport DialogContent */
/* unused harmony reexport DialogContentText */
/* unused harmony reexport DialogTitle */
/* unused harmony reexport withMobileDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Divider__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Divider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Divider__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Divider___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Drawer__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Drawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Drawer__);
/* unused harmony reexport Drawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ExpansionPanel__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ExpansionPanel__);
/* unused harmony reexport ExpansionPanel */
/* unused harmony reexport ExpansionPanelActions */
/* unused harmony reexport ExpansionPanelDetails */
/* unused harmony reexport ExpansionPanelSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Form__);
/* unused harmony reexport FormControl */
/* unused harmony reexport FormGroup */
/* unused harmony reexport FormLabel */
/* unused harmony reexport FormHelperText */
/* unused harmony reexport FormControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Hidden__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Hidden___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Hidden__);
/* unused harmony reexport Hidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Icon__);
/* unused harmony reexport Icon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__IconButton__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__IconButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__IconButton__);
/* unused harmony reexport IconButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Input__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Input__);
/* unused harmony reexport Input */
/* unused harmony reexport InputLabel */
/* unused harmony reexport InputAdornment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Grid__);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GridList__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GridList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__GridList__);
/* unused harmony reexport GridList */
/* unused harmony reexport GridListTile */
/* unused harmony reexport GridListTileBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__List__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__List__);
/* unused harmony reexport List */
/* unused harmony reexport ListItem */
/* unused harmony reexport ListItemAvatar */
/* unused harmony reexport ListItemIcon */
/* unused harmony reexport ListItemSecondaryAction */
/* unused harmony reexport ListItemText */
/* unused harmony reexport ListSubheader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Menu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Menu__);
/* unused harmony reexport Menu */
/* unused harmony reexport MenuItem */
/* unused harmony reexport MenuList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__MobileStepper__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__MobileStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__MobileStepper__);
/* unused harmony reexport MobileStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Modal__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Modal__);
/* unused harmony reexport Modal */
/* unused harmony reexport Backdrop */
/* unused harmony reexport ModalManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__Paper__);
/* unused harmony reexport Paper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Popover__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__Popover__);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Portal__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Portal__);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Progress__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__Progress__);
/* unused harmony reexport CircularProgress */
/* unused harmony reexport LinearProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Radio__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__Radio__);
/* unused harmony reexport Radio */
/* unused harmony reexport RadioGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Reboot__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Reboot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__Reboot__);
/* unused harmony reexport Reboot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Select__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__Select__);
/* unused harmony reexport Select */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Snackbar__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Snackbar__);
/* unused harmony reexport Snackbar */
/* unused harmony reexport SnackbarContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Stepper__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Stepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__Stepper__);
/* unused harmony reexport Stepper */
/* unused harmony reexport Step */
/* unused harmony reexport StepButton */
/* unused harmony reexport StepIcon */
/* unused harmony reexport StepContent */
/* unused harmony reexport StepLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__styles__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__styles__);
/* unused harmony reexport MuiThemeProvider */
/* unused harmony reexport withStyles */
/* unused harmony reexport withTheme */
/* unused harmony reexport createMuiTheme */
/* unused harmony reexport jssPreset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__colors__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__colors__);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SvgIcon__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__SvgIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__SvgIcon__);
/* unused harmony reexport SvgIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Switch__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__Switch__);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Table__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__Table__);
/* unused harmony reexport Table */
/* unused harmony reexport TableBody */
/* unused harmony reexport TableCell */
/* unused harmony reexport TableFooter */
/* unused harmony reexport TableHead */
/* unused harmony reexport TablePagination */
/* unused harmony reexport TableRow */
/* unused harmony reexport TableSortLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Tabs__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__Tabs__);
/* unused harmony reexport Tabs */
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__Typography__);
/* unused harmony reexport Typography */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__TextField__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__TextField__);
/* unused harmony reexport TextField */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Toolbar__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__Toolbar__);
/* unused harmony reexport Toolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Tooltip__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__Tooltip__);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__transitions__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__transitions__);
/* unused harmony reexport Slide */
/* unused harmony reexport Grow */
/* unused harmony reexport Fade */
/* unused harmony reexport Collapse */
/* unused harmony reexport Zoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_withWidth__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__utils_withWidth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__utils_withWidth__);
/* unused harmony reexport withWidth */
/** @license Material-UI v1.0.0-beta.34
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




































// eslint-disable-next-line import/first

















/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = __webpack_require__(889);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Badge).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RADIUS = 12;

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: -RADIUS,
      right: -RADIUS,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.pxToRem(RADIUS),
      width: RADIUS * 2,
      height: RADIUS * 2,
      borderRadius: '50%',
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1 // Render the badge on top of potential ripples.
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    }
  };
};

function Badge(props) {
  var badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      ComponentProp = props.component,
      other = (0, _objectWithoutProperties3.default)(props, ['badgeContent', 'children', 'classes', 'className', 'color', 'component']);


  var badgeClassName = (0, _classnames2.default)(classes.badge, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], color !== 'default'));

  return _react2.default.createElement(
    ComponentProp,
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    children,
    _react2.default.createElement(
      'span',
      { className: badgeClassName },
      badgeContent
    )
  );
}

Badge.propTypes =  false ? {
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes2.default.node.isRequired,
  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['default', 'primary', 'secondary', 'error']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

Badge.defaultProps = {
  color: 'default',
  component: 'span'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiBadge' })(Badge);

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = __webpack_require__(227);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _IndeterminateCheckBox = __webpack_require__(893);

var _IndeterminateCheckBox2 = _interopRequireDefault(_IndeterminateCheckBox);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

function Checkbox(props) {
  var _classNames;

  var checkedIcon = props.checkedIcon,
      classes = props.classes,
      color = props.color,
      icon = props.icon,
      indeterminate = props.indeterminate,
      indeterminateIcon = props.indeterminateIcon,
      other = (0, _objectWithoutProperties3.default)(props, ['checkedIcon', 'classes', 'color', 'icon', 'indeterminate', 'indeterminateIcon']);

  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      default: classes.default,
      checked: checkedClass,
      disabled: classes.disabled
    },
    icon: indeterminate ? indeterminateIcon : icon
  }, other));
}

Checkbox.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * If `true`, the component appears indeterminate.
   */
  indeterminate: _propTypes2.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: _propTypes2.default.node,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Checkbox.defaultProps = {
  color: 'secondary',
  indeterminate: false,
  indeterminateIcon: _react2.default.createElement(_IndeterminateCheckBox2.default, null)
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiCheckbox' })(Checkbox);

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' });

var CheckBoxOutlineBlank = function CheckBoxOutlineBlank(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBoxOutlineBlank = (0, _pure2.default)(CheckBoxOutlineBlank);
CheckBoxOutlineBlank.muiName = 'SvgIcon';

exports.default = CheckBoxOutlineBlank;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' });

var CheckBox = function CheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckBox = (0, _pure2.default)(CheckBox);
CheckBox.muiName = 'SvgIcon';

exports.default = CheckBox;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' });

var IndeterminateCheckBox = function IndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
IndeterminateCheckBox = (0, _pure2.default)(IndeterminateCheckBox);
IndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = IndeterminateCheckBox;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Chip = __webpack_require__(895);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _keycode = __webpack_require__(77);

var _keycode2 = _interopRequireDefault(_keycode);

var _Cancel = __webpack_require__(896);

var _Cancel2 = _interopRequireDefault(_Cancel);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _colorManipulator = __webpack_require__(63);

__webpack_require__(358);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// So we don't have any override priority issue.

var styles = exports.styles = function styles(theme) {
  var height = 32;
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);

  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: height,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: height / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      outline: 'none', // No outline on focused element in Chrome (as triggered by tabIndex prop)
      border: 'none', // Remove `button` border
      padding: 0 // Remove `button` padding
    },
    clickable: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1],
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
      }
    },
    deletable: {
      '&:focus': {
        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
      }
    },
    avatar: {
      marginRight: -4,
      width: height,
      height: height,
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(16)
    },
    avatarChildren: {
      width: 19,
      height: 19
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      userSelect: 'none',
      whiteSpace: 'nowrap',
      cursor: 'inherit'
    },
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      cursor: 'pointer',
      height: 'auto',
      margin: '0 4px 0 -8px',
      '&:hover': {
        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
      }
    }
  };
};

/**
 * Chips represent complex entities in small blocks, such as a contact.
 */

var Chip = function (_React$Component) {
  (0, _inherits3.default)(Chip, _React$Component);

  function Chip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Chip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
      // Stop the event from bubbling up to the `Chip`
      event.stopPropagation();
      var onDelete = _this.props.onDelete;

      if (onDelete) {
        onDelete(event);
      }
    }, _this.handleKeyDown = function (event) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onKeyDown = _this$props.onKeyDown;

      var key = (0, _keycode2.default)(event);

      if (onClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      } else if (onDelete && key === 'backspace') {
        event.preventDefault();
        onDelete(event);
      } else if (key === 'esc') {
        event.preventDefault();
        if (_this.chipRef) {
          _this.chipRef.blur();
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Chip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          avatarProp = _props.avatar,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          deleteIconProp = _props.deleteIcon,
          label = _props.label,
          onClick = _props.onClick,
          onDelete = _props.onDelete,
          onKeyDown = _props.onKeyDown,
          tabIndexProp = _props.tabIndex,
          other = (0, _objectWithoutProperties3.default)(_props, ['avatar', 'classes', 'className', 'component', 'deleteIcon', 'label', 'onClick', 'onDelete', 'onKeyDown', 'tabIndex']);


      var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.clickable, onClick), (0, _defineProperty3.default)({}, classes.deletable, onDelete), classNameProp);

      var deleteIcon = null;
      if (onDelete) {
        deleteIcon = deleteIconProp && _react2.default.isValidElement(deleteIconProp) ? _react2.default.cloneElement(deleteIconProp, {
          className: (0, _classnames2.default)(deleteIconProp.props.className, classes.deleteIcon),
          onClick: this.handleDeleteIconClick
        }) : _react2.default.createElement(_Cancel2.default, { className: classes.deleteIcon, onClick: this.handleDeleteIconClick });
      }

      var avatar = null;
      if (avatarProp && _react2.default.isValidElement(avatarProp)) {
        avatar = _react2.default.cloneElement(avatarProp, {
          className: (0, _classnames2.default)(classes.avatar, avatarProp.props.className),
          childrenClassName: (0, _classnames2.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
        });
      }

      var tabIndex = tabIndexProp;

      if (!tabIndex) {
        tabIndex = onClick || onDelete ? 0 : -1;
      }

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({
          role: 'button',
          className: className,
          tabIndex: tabIndex,
          onClick: onClick,
          onKeyDown: this.handleKeyDown,
          ref: function ref(node) {
            _this2.chipRef = node;
          }
        }, other),
        avatar,
        _react2.default.createElement(
          'span',
          { className: classes.label },
          label
        ),
        deleteIcon
      );
    }
  }]);
  return Chip;
}(_react2.default.Component);

Chip.propTypes =  false ? {
  /**
   * Avatar element.
   */
  avatar: _propTypes2.default.element,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes2.default.element,
  /**
   * The content of the label.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
} : {};

Chip.defaultProps = {
  component: 'div'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiChip' })(Chip);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' });

var Cancel = function Cancel(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
Cancel = (0, _pure2.default)(Cancel);
Cancel.muiName = 'SvgIcon';

exports.default = Cancel;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(898);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Dialog).default;
  }
});

var _DialogActions = __webpack_require__(899);

Object.defineProperty(exports, 'DialogActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogActions).default;
  }
});

var _DialogTitle = __webpack_require__(900);

Object.defineProperty(exports, 'DialogTitle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogTitle).default;
  }
});

var _DialogContent = __webpack_require__(901);

Object.defineProperty(exports, 'DialogContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogContent).default;
  }
});

var _DialogContentText = __webpack_require__(902);

Object.defineProperty(exports, 'DialogContentText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DialogContentText).default;
  }
});

var _withMobileDialog = __webpack_require__(903);

Object.defineProperty(exports, 'withMobileDialog', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withMobileDialog).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

var _Modal = __webpack_require__(155);

var _Modal2 = _interopRequireDefault(_Modal);

var _Fade = __webpack_require__(156);

var _Fade2 = _interopRequireDefault(_Fade);

var _transitions = __webpack_require__(53);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    paper: {
      display: 'flex',
      margin: theme.spacing.unit * 4,
      flexDirection: 'column',
      flex: '0 1 auto',
      position: 'relative',
      maxHeight: '90vh',
      overflowY: 'auto', // Fix IE11 issue, to remove at some point.
      '&:focus': {
        outline: 'none'
      }
    },
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 360)
    },
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm
    },
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md
    },
    fullWidth: {
      width: '100%'
    },
    fullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100%',
      borderRadius: 0
    }
  };
};

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
// @inheritedComponent Modal

function Dialog(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      fullScreen = props.fullScreen,
      fullWidth = props.fullWidth,
      disableBackdropClick = props.disableBackdropClick,
      disableEscapeKeyDown = props.disableEscapeKeyDown,
      maxWidth = props.maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      PaperProps = props.PaperProps,
      TransitionProp = props.transition,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'fullScreen', 'fullWidth', 'disableBackdropClick', 'disableEscapeKeyDown', 'maxWidth', 'onBackdropClick', 'onClose', 'onEnter', 'onEntered', 'onEntering', 'onEscapeKeyDown', 'onExit', 'onExited', 'onExiting', 'open', 'PaperProps', 'transition', 'transitionDuration']);


  return _react2.default.createElement(
    _Modal2.default,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, className),
      BackdropProps: {
        transitionDuration: transitionDuration
      },
      disableBackdropClick: disableBackdropClick,
      disableEscapeKeyDown: disableEscapeKeyDown,
      onBackdropClick: onBackdropClick,
      onEscapeKeyDown: onEscapeKeyDown,
      onClose: onClose,
      open: open,
      role: 'dialog'
    }, other),
    _react2.default.createElement(
      TransitionProp,
      {
        appear: true,
        'in': open,
        timeout: transitionDuration,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: onExited
      },
      _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          elevation: 24,
          className: (0, _classnames2.default)(classes.paper, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['paperWidth' + (maxWidth ? (0, _helpers.capitalize)(maxWidth) : '')], maxWidth), (0, _defineProperty3.default)(_classNames, classes.fullScreen, fullScreen), (0, _defineProperty3.default)(_classNames, classes.fullWidth, fullWidth), _classNames))
        }, PaperProps),
        children
      )
    )
  );
}

Dialog.propTypes =  false ? {
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes2.default.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: _propTypes2.default.bool,
  /**
   * If `true`, it will be full-screen
   */
  fullScreen: _propTypes2.default.bool,
  /**
   * If specified, stretches dialog to max width.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes2.default.oneOf(['xs', 'sm', 'md', false]),
  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes2.default.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes2.default.func,
  /**
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes2.default.func,
  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes2.default.func,
  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes2.default.bool.isRequired,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * Transition component.
   */
  transition: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Dialog.defaultProps = {
  fullScreen: false,
  fullWidth: false,
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  maxWidth: 'sm',
  transition: _Fade2.default,
  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen }
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialog' })(Dialog);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

__webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// So we don't have any override priority issue.

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      margin: theme.spacing.unit + 'px ' + theme.spacing.unit / 2 + 'px',
      flex: '0 0 auto'
    },
    action: {
      margin: '0 ' + theme.spacing.unit / 2 + 'px'
    },
    button: {
      minWidth: 64
    }
  };
};

function DialogActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    _react2.default.Children.map(children, function (child) {
      if (!_react2.default.isValidElement(child)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: classes.action },
        _react2.default.cloneElement(child, {
          className: (0, _classnames2.default)(classes.button, child.props.className)
        })
      );
    })
  );
}

DialogActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogActions' })(DialogActions);

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px       20px ' + theme.spacing.unit * 3 + 'px',
      flex: '0 0 auto'
    }
  };
};

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'disableTypography']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    disableTypography ? children : _react2.default.createElement(
      _Typography2.default,
      { variant: 'title' },
      children
    )
  );
}

DialogTitle.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: _propTypes2.default.bool
} : {};

DialogTitle.defaultProps = {
  disableTypography: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogTitle' })(DialogTitle);

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var spacing = theme.spacing.unit * 3;
  return {
    root: {
      flex: '1 1 auto',
      overflowY: 'auto',
      padding: '0 ' + spacing + 'px ' + spacing + 'px ' + spacing + 'px',
      '&:first-child': {
        paddingTop: spacing
      }
    }
  };
};

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

DialogContent.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContent' })(DialogContent);

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends3.default)({}, theme.typography.subheading, {
      color: theme.palette.text.secondary,
      margin: 0
    })
  };
};

function DialogContentText(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'p',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

DialogContentText.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDialogContentText' })(DialogContentText);

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withWidth = __webpack_require__(152);

var _withWidth2 = _interopRequireDefault(_withWidth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server side rendering.
 */
var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === undefined ? 'sm' : _options$breakpoint;


    function WithMobileDialog(props) {
      return _react2.default.createElement(Component, (0, _extends3.default)({ fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width) }, props));
    }

    WithMobileDialog.propTypes =  false ? {
      width: _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : {};

    return (0, _withWidth2.default)()(WithMobileDialog);
  };
};

exports.default = withMobileDialog;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Drawer = __webpack_require__(905);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Drawer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Modal = __webpack_require__(155);

var _Modal2 = _interopRequireDefault(_Modal);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Slide = __webpack_require__(224);

var _Slide2 = _interopRequireDefault(_Slide);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

var _helpers = __webpack_require__(14);

var _transitions = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSlideDirection(anchor) {
  if (anchor === 'left') {
    return 'right';
  } else if (anchor === 'right') {
    return 'left';
  } else if (anchor === 'top') {
    return 'down';
  }

  // (anchor === 'bottom')
  return 'up';
} // @inheritedComponent Modal

var styles = exports.styles = function styles(theme) {
  return {
    docked: {
      flex: '0 0 auto'
    },
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch', // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      '&:focus': {
        outline: 'none'
      }
    },
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100vh'
    },
    paperAnchorDockedLeft: {
      borderRight: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedTop: {
      borderBottom: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedRight: {
      borderLeft: '1px solid ' + theme.palette.divider
    },
    paperAnchorDockedBottom: {
      borderTop: '1px solid ' + theme.palette.divider
    },
    modal: {} // Just here so people can override the style.
  };
};

var Drawer = function (_React$Component) {
  (0, _inherits3.default)(Drawer, _React$Component);

  function Drawer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Drawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      // Let's assume that the Drawer will always be rendered on user space.
      // We use that state is order to skip the appear transition during the
      // initial mount of the component.
      firstMount: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Drawer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({
        firstMount: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          anchorProp = _props.anchor,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          elevation = _props.elevation,
          ModalProps = _props.ModalProps,
          onClose = _props.onClose,
          open = _props.open,
          PaperProps = _props.PaperProps,
          SlideProps = _props.SlideProps,
          theme = _props.theme,
          transitionDuration = _props.transitionDuration,
          variant = _props.variant,
          other = (0, _objectWithoutProperties3.default)(_props, ['anchor', 'children', 'classes', 'className', 'elevation', 'ModalProps', 'onClose', 'open', 'PaperProps', 'SlideProps', 'theme', 'transitionDuration', 'variant']);


      var anchor = anchorProp;
      if (theme.direction === 'rtl' && ['left', 'right'].includes(anchor)) {
        anchor = anchor === 'left' ? 'right' : 'left';
      }

      var drawer = _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({
          elevation: variant === 'temporary' ? elevation : 0,
          square: true,
          className: (0, _classnames2.default)(classes.paper, classes['paperAnchor' + (0, _helpers.capitalize)(anchor)], (0, _defineProperty3.default)({}, classes['paperAnchorDocked' + (0, _helpers.capitalize)(anchor)], variant !== 'temporary'))
        }, PaperProps),
        children
      );

      if (variant === 'permanent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          drawer
        );
      }

      var slidingDrawer = _react2.default.createElement(
        _Slide2.default,
        (0, _extends3.default)({
          'in': open,
          direction: getSlideDirection(anchor),
          timeout: transitionDuration,
          appear: !this.state.firstMount
        }, SlideProps),
        drawer
      );

      if (variant === 'persistent') {
        return _react2.default.createElement(
          'div',
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.docked, className) }, other),
          slidingDrawer
        );
      }

      // variant === temporary
      return _react2.default.createElement(
        _Modal2.default,
        (0, _extends3.default)({
          BackdropProps: {
            transitionDuration: transitionDuration
          },
          className: (0, _classnames2.default)(classes.modal, className),
          open: open,
          onClose: onClose
        }, other, ModalProps),
        slidingDrawer
      );
    }
  }]);
  return Drawer;
}(_react2.default.Component);

Drawer.propTypes =  false ? {
  /**
   * Side from which the drawer will appear.
   */
  anchor: _propTypes2.default.oneOf(['left', 'top', 'right', 'bottom']),
  /**
   * The contents of the drawer.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The elevation of the drawer.
   */
  elevation: _propTypes2.default.number,
  /**
   * Properties applied to the `Modal` element.
   */
  ModalProps: _propTypes2.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * If `true`, the drawer is open.
   */
  open: _propTypes2.default.bool,
  /**
   * Properties applied to the `Paper` element.
   */
  PaperProps: _propTypes2.default.object,
  /**
   * Properties applied to the `Slide` element.
   */
  SlideProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })]),
  /**
   * The type of drawer.
   */
  variant: _propTypes2.default.oneOf(['permanent', 'persistent', 'temporary'])
} : {};

Drawer.defaultProps = {
  anchor: 'left',
  elevation: 16,
  open: false,
  transitionDuration: { enter: _transitions.duration.enteringScreen, exit: _transitions.duration.leavingScreen },
  variant: 'temporary' // Mobile first.
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiDrawer', flip: false, withTheme: true })(Drawer);

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpansionPanel = __webpack_require__(907);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanel).default;
  }
});

var _ExpansionPanelActions = __webpack_require__(908);

Object.defineProperty(exports, 'ExpansionPanelActions', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelActions).default;
  }
});

var _ExpansionPanelDetails = __webpack_require__(909);

Object.defineProperty(exports, 'ExpansionPanelDetails', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelDetails).default;
  }
});

var _ExpansionPanelSummary = __webpack_require__(910);

Object.defineProperty(exports, 'ExpansionPanelSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpansionPanelSummary).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Collapse = __webpack_require__(228);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };

  return {
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        '&:before': {
          display: 'none'
        }
      },
      '&:last-child': {
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      }
    },
    expanded: {
      margin: theme.spacing.unit * 2 + 'px 0',
      '&:first-child': {
        marginTop: 0
      },
      '&:last-child': {
        marginBottom: 0
      },
      '&:before': {
        opacity: 0
      }
    },
    disabled: {
      backgroundColor: theme.palette.action.disabledBackground
    }
  };
}; // @inheritedComponent Paper

var ExpansionPanel = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanel, _React$Component);

  function ExpansionPanel() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpansionPanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanel.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expanded: false
    }, _this.isControlled = null, _this.handleChange = function (event) {
      var onChange = _this.props.onChange;

      var expanded = !_this.state.expanded;

      if (onChange) {
        onChange(event, expanded);
      }

      if (!_this.isControlled) {
        _this.setState({ expanded: expanded });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpansionPanel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          expanded = _props.expanded,
          defaultExpanded = _props.defaultExpanded;

      this.isControlled = expanded != null;
      this.setState({
        expanded: this.isControlled ? expanded : defaultExpanded
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlled) {
        this.setState({
          expanded: nextProps.expanded
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props2 = this.props,
          childrenProp = _props2.children,
          classes = _props2.classes,
          classNameProp = _props2.className,
          CollapsePropsProp = _props2.CollapseProps,
          defaultExpanded = _props2.defaultExpanded,
          disabled = _props2.disabled,
          expandedProp = _props2.expanded,
          onChange = _props2.onChange,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'classes', 'className', 'CollapseProps', 'defaultExpanded', 'disabled', 'expanded', 'onChange']);
      var expanded = this.state.expanded;


      var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), _classNames), classNameProp);

      var summary = null;

      var children = _react2.default.Children.map(childrenProp, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }

        if ((0, _reactHelpers.isMuiElement)(child, ['ExpansionPanelSummary'])) {
          summary = _react2.default.cloneElement(child, {
            disabled: disabled,
            expanded: expanded,
            onChange: _this2.handleChange
          });
          return null;
        }

        return child;
      });

      var CollapseProps = !expanded ? {
        'aria-hidden': 'true'
      } : null;

      return _react2.default.createElement(
        _Paper2.default,
        (0, _extends3.default)({ className: className, elevation: 1, square: true }, other),
        summary,
        _react2.default.createElement(
          _Collapse2.default,
          (0, _extends3.default)({ 'in': expanded, timeout: 'auto' }, CollapseProps, CollapsePropsProp),
          children
        )
      );
    }
  }]);
  return ExpansionPanel;
}(_react2.default.Component);

ExpansionPanel.propTypes =  false ? {
  /**
   * The content of the expansion panel.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Properties applied to the `Collapse` element.
   */
  CollapseProps: _propTypes2.default.object,
  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: _propTypes2.default.bool,
  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: _propTypes2.default.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} expanded The `expanded` state of the panel
   */
  onChange: _propTypes2.default.func
} : {};

ExpansionPanel.defaultProps = {
  defaultExpanded: false,
  disabled: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanel' })(ExpansionPanel);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      padding: theme.spacing.unit * 2 + 'px ' + theme.spacing.unit + 'px'
    },
    action: {
      marginLeft: theme.spacing.unit
    }
  };
};

function ExpansionPanelActions(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action)
  );
}

ExpansionPanelActions.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelActions' })(ExpansionPanelActions);

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
      padding: theme.spacing.unit + 'px ' + theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 3 + 'px'
    }
  };
};

function ExpansionPanelDetails(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'children', 'className']);


  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
    children
  );
}

ExpansionPanelDetails.propTypes =  false ? {
  /**
   * The content of the expansion panel details.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelDetails' })(ExpansionPanelDetails);

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _IconButton = __webpack_require__(107);

var _IconButton2 = _interopRequireDefault(_IconButton);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    root: {
      display: 'flex',
      minHeight: theme.spacing.unit * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 ' + theme.spacing.unit * 3 + 'px 0 ' + theme.spacing.unit * 3 + 'px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      }
    },
    expanded: {
      minHeight: 64
    },
    focused: {
      backgroundColor: theme.palette.grey[300]
    },
    disabled: {
      opacity: 0.38
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '& > :last-child': {
        paddingRight: theme.spacing.unit * 4
      }
    },
    contentExpanded: {
      margin: '20px 0'
    },
    expandIcon: {
      position: 'absolute',
      top: '50%',
      right: theme.spacing.unit,
      transform: 'translateY(-50%) rotate(0deg)',
      transition: theme.transitions.create('transform', transition)
    },
    expandIconExpanded: {
      transform: 'translateY(-50%) rotate(180deg)'
    }
  };
};

var ExpansionPanelSummary = function (_React$Component) {
  (0, _inherits3.default)(ExpansionPanelSummary, _React$Component);

  function ExpansionPanelSummary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExpansionPanelSummary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExpansionPanelSummary.__proto__ || (0, _getPrototypeOf2.default)(ExpansionPanelSummary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _this.handleFocus = function () {
      _this.setState({
        focused: true
      });
    }, _this.handleBlur = function () {
      _this.setState({
        focused: false
      });
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClick = _this$props.onClick;

      if (onChange) {
        onChange(event);
      }
      if (onClick) {
        onClick(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExpansionPanelSummary, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          disabled = _props.disabled,
          expanded = _props.expanded,
          expandIcon = _props.expandIcon,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disabled', 'expanded', 'expandIcon', 'onChange']);
      var focused = this.state.focused;


      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends3.default)({
          focusRipple: false,
          disableRipple: true,
          disabled: disabled,
          component: 'div',
          'aria-expanded': expanded,
          className: (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.disabled, disabled), (0, _defineProperty3.default)(_classNames, classes.expanded, expanded), (0, _defineProperty3.default)(_classNames, classes.focused, focused), _classNames), className)
        }, other, {
          onKeyboardFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onClick: this.handleChange
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)(classes.content, (0, _defineProperty3.default)({}, classes.contentExpanded, expanded)) },
          children
        ),
        expandIcon && _react2.default.createElement(
          _IconButton2.default,
          {
            disabled: disabled,
            className: (0, _classnames2.default)(classes.expandIcon, (0, _defineProperty3.default)({}, classes.expandIconExpanded, expanded)),
            component: 'div',
            tabIndex: '-1',
            'aria-hidden': 'true'
          },
          expandIcon
        )
      );
    }
  }]);
  return ExpansionPanelSummary;
}(_react2.default.Component);

ExpansionPanelSummary.propTypes =  false ? {
  /**
   * The content of the expansion panel summary.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * If `true`, the summary will be displayed in a disabled state.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * If `true`, expands the summary, otherwise collapse it.
   */
  expanded: _propTypes2.default.bool,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func
} : {};

ExpansionPanelSummary.defaultProps = {
  disabled: false
};

ExpansionPanelSummary.muiName = 'ExpansionPanelSummary';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiExpansionPanelSummary' })(ExpansionPanelSummary);

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(912);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Icon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      userSelect: 'none'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorAction: {
      color: theme.palette.action.active
    },
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    colorError: {
      color: theme.palette.error.main
    },
    fontSize: {
      width: '1em',
      height: '1em'
    }
  };
};

function Icon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      fontSize = props.fontSize,
      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'className', 'color', 'fontSize']);


  var className = (0, _classnames2.default)('material-icons', classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes['color' + (0, _helpers.capitalize)(color)], color !== 'inherit'), (0, _defineProperty3.default)(_classNames, classes.fontSize, fontSize), _classNames), classNameProp);

  return _react2.default.createElement(
    'span',
    (0, _extends3.default)({ className: className, 'aria-hidden': 'true' }, other),
    children
  );
}

Icon.propTypes =  false ? {
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['inherit', 'secondary', 'action', 'disabled', 'error', 'primary']),
  /**
   * If `true`, the icon size will be determined by the font-size.
   */
  fontSize: _propTypes2.default.bool
} : {};

Icon.defaultProps = {
  color: 'inherit',
  fontSize: false
};

Icon.muiName = 'Icon';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiIcon' })(Icon);

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GridList = __webpack_require__(914);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridList).default;
  }
});

var _GridListTile = __webpack_require__(915);

Object.defineProperty(exports, 'GridListTile', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridListTile).default;
  }
});

var _GridListTileBar = __webpack_require__(916);

Object.defineProperty(exports, 'GridListTileBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GridListTileBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
  }
};

function GridList(props) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      cols = props.cols,
      Component = props.component,
      spacing = props.spacing,
      style = props.style,
      other = (0, _objectWithoutProperties3.default)(props, ['cellHeight', 'children', 'classes', 'className', 'cols', 'component', 'spacing', 'style']);


  return _react2.default.createElement(
    Component,
    (0, _extends3.default)({
      className: (0, _classnames2.default)(classes.root, classNameProp),
      style: (0, _extends3.default)({ margin: -spacing / 2 }, style)
    }, other),
    _react2.default.Children.map(children, function (currentChild) {
      var childCols = currentChild.props.cols || 1;
      var childRows = currentChild.props.rows || 1;

      return _react2.default.cloneElement(currentChild, {
        style: (0, _extends3.default)({
          width: 100 / cols * childCols + '%',
          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
          padding: spacing / 2
        }, currentChild.props.style)
      });
    })
  );
}

GridList.propTypes =  false ? {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
  /**
   * Grid Tiles that will be in Grid List.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Number of columns.
   */
  cols: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Number of px for the spacing between tiles.
   */
  spacing: _propTypes2.default.number,
  /**
   * @ignore
   */
  style: _propTypes2.default.object
} : {};

GridList.defaultProps = {
  cellHeight: 180,
  cols: 2,
  component: 'ul',
  spacing: 4
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridList' })(GridList);

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = {
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },
  tile: {
    position: 'relative',
    display: 'block', // In case it's not renderd with a div.
    height: '100%',
    overflow: 'hidden'
  },
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var GridListTile = function (_React$Component) {
  (0, _inherits3.default)(GridListTile, _React$Component);

  function GridListTile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GridListTile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GridListTile.__proto__ || (0, _getPrototypeOf2.default)(GridListTile)).call.apply(_ref, [this].concat(args))), _this), _this.imgElement = null, _this.handleResize = (0, _debounce2.default)(function () {
      _this.fit();
    }, 166), _this.fit = function () {
      var imgElement = _this.imgElement;

      if (!imgElement) {
        return;
      }

      if (!imgElement.complete) {
        return;
      }

      if (imgElement.width / imgElement.height > imgElement.parentNode.offsetWidth / imgElement.parentNode.offsetHeight) {
        var _imgElement$classList, _imgElement$classList2;

        (_imgElement$classList = imgElement.classList).remove.apply(_imgElement$classList, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
        (_imgElement$classList2 = imgElement.classList).add.apply(_imgElement$classList2, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
      } else {
        var _imgElement$classList3, _imgElement$classList4;

        (_imgElement$classList3 = imgElement.classList).remove.apply(_imgElement$classList3, (0, _toConsumableArray3.default)(_this.props.classes.imgFullHeight.split(' ')));
        (_imgElement$classList4 = imgElement.classList).add.apply(_imgElement$classList4, (0, _toConsumableArray3.default)(_this.props.classes.imgFullWidth.split(' ')));
      }

      imgElement.removeEventListener('load', _this.fit);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GridListTile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureImageCover();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureImageCover();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
    }
  }, {
    key: 'ensureImageCover',
    value: function ensureImageCover() {
      if (!this.imgElement) {
        return;
      }

      if (this.imgElement.complete) {
        this.fit();
      } else {
        this.imgElement.addEventListener('load', this.fit);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          classes = _props.classes,
          className = _props.className,
          cols = _props.cols,
          Component = _props.component,
          rows = _props.rows,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'cols', 'component', 'rows']);


      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        _react2.default.createElement(
          'div',
          { className: classes.tile },
          _react2.default.Children.map(children, function (child) {
            if (child && child.type === 'img') {
              return _react2.default.cloneElement(child, {
                key: 'img',
                ref: function ref(node) {
                  _this2.imgElement = node;
                }
              });
            }

            return child;
          })
        )
      );
    }
  }]);
  return GridListTile;
}(_react2.default.Component);

GridListTile.propTypes =  false ? {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Width of the tile in number of grid cells.
   */
  cols: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Height of the tile in number of grid cells.
   */
  rows: _propTypes2.default.number
} : {};

GridListTile.defaultProps = {
  cols: 1,
  component: 'li',
  rows: 1
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTile' })(GridListTile);

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },
    rootBottom: {
      bottom: 0
    },
    rootTop: {
      top: 0
    },
    rootWithSubtitle: {
      height: 68
    },
    titleWrap: {
      flexGrow: 1,
      marginLeft: theme.mixins.gutters({}).paddingLeft,
      marginRight: theme.mixins.gutters({}).paddingRight,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },
    titleWrapActionLeft: {
      marginLeft: 0
    },
    titleWrapActionRight: {
      marginRight: 0
    },
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    actionIconPositionLeft: {
      order: -1
    },
    childImg: {
      height: '100%',
      transform: 'translateX(-50%)',
      position: 'relative',
      left: '50%'
    }
  };
};

function GridListTileBar(props) {
  var _classNames, _classNames2;

  var actionIcon = props.actionIcon,
      actionPosition = props.actionPosition,
      classes = props.classes,
      classNameProp = props.className,
      subtitle = props.subtitle,
      title = props.title,
      titlePosition = props.titlePosition,
      other = (0, _objectWithoutProperties3.default)(props, ['actionIcon', 'actionPosition', 'classes', 'className', 'subtitle', 'title', 'titlePosition']);


  var actionPos = actionIcon && actionPosition;
  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.rootBottom, titlePosition === 'bottom'), (0, _defineProperty3.default)(_classNames, classes.rootTop, titlePosition === 'top'), (0, _defineProperty3.default)(_classNames, classes.rootWithSubtitle, subtitle), _classNames), classNameProp);

  // Remove the margin between the title / subtitle wrapper, and the Action Icon
  var titleWrapClassName = (0, _classnames2.default)(classes.titleWrap, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionLeft, actionPos === 'left'), (0, _defineProperty3.default)(_classNames2, classes.titleWrapActionRight, actionPos === 'right'), _classNames2));

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.createElement(
      'div',
      { className: titleWrapClassName },
      _react2.default.createElement(
        'div',
        { className: classes.title },
        title
      ),
      subtitle ? _react2.default.createElement(
        'div',
        { className: classes.subtitle },
        subtitle
      ) : null
    ),
    actionIcon ? _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.actionIconPositionLeft, actionPos === 'left')) },
      actionIcon
    ) : null
  );
}

GridListTileBar.propTypes =  false ? {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: _propTypes2.default.node,
  /**
   * Position of secondary action IconButton.
   */
  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes2.default.node,
  /**
   * Title to be displayed on tile.
   */
  title: _propTypes2.default.node,
  /**
   * Position of the title bar.
   */
  titlePosition: _propTypes2.default.oneOf(['top', 'bottom'])
} : {};

GridListTileBar.defaultProps = {
  actionPosition: 'right',
  titlePosition: 'bottom'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGridListTileBar' })(GridListTileBar);

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileStepper = __webpack_require__(918);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MobileStepper).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(99);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

var _helpers = __webpack_require__(14);

var _Progress = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: theme.spacing.unit
    },
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    positionStatic: {},
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: theme.spacing.unit,
      height: theme.spacing.unit,
      margin: '0 2px'
    },
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },
    progress: {
      width: '50%'
    }
  };
}; // @inheritedComponent Paper

function MobileStepper(props) {
  var activeStep = props.activeStep,
      backButton = props.backButton,
      classes = props.classes,
      classNameProp = props.className,
      nextButton = props.nextButton,
      position = props.position,
      steps = props.steps,
      variant = props.variant,
      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'backButton', 'classes', 'className', 'nextButton', 'position', 'steps', 'variant']);


  var className = (0, _classnames2.default)(classes.root, classes['position' + (0, _helpers.capitalize)(position)], classNameProp);

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
    backButton,
    variant === 'dots' && _react2.default.createElement(
      'div',
      { className: classes.dots },
      [].concat((0, _toConsumableArray3.default)(new Array(steps))).map(function (_, step) {
        var dotClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.dotActive, step === activeStep), classes.dot);
        // eslint-disable-next-line react/no-array-index-key
        return _react2.default.createElement('div', { key: step, className: dotClassName });
      })
    ),
    variant === 'progress' && _react2.default.createElement(
      'div',
      { className: classes.progress },
      _react2.default.createElement(_Progress.LinearProgress, { variant: 'determinate', value: Math.ceil(activeStep / (steps - 1) * 100) })
    ),
    nextButton
  );
}

MobileStepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: _propTypes2.default.number,
  /**
   * A back button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  backButton: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A next button element. For instance, it can be be a `Button` or a `IconButton`.
   */
  nextButton: _propTypes2.default.node,
  /**
   * Set the positioning type.
   */
  position: _propTypes2.default.oneOf(['bottom', 'top', 'static']),
  /**
   * The total steps.
   */
  steps: _propTypes2.default.number.isRequired,
  /**
   * The type of mobile stepper to use.
   */
  variant: _propTypes2.default.oneOf(['text', 'dots', 'progress'])
} : {};

MobileStepper.defaultProps = {
  activeStep: 0,
  position: 'bottom',
  variant: 'dots'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiMobileStepper' })(MobileStepper);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(920);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Radio).default;
  }
});

var _RadioGroup = __webpack_require__(923);

Object.defineProperty(exports, 'RadioGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioGroup).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _SwitchBase = __webpack_require__(227);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

var _RadioButtonChecked = __webpack_require__(921);

var _RadioButtonChecked2 = _interopRequireDefault(_RadioButtonChecked);

var _RadioButtonUnchecked = __webpack_require__(922);

var _RadioButtonUnchecked2 = _interopRequireDefault(_RadioButtonUnchecked);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    default: {
      color: theme.palette.text.secondary
    },
    checked: {},
    checkedPrimary: {
      color: theme.palette.primary.main
    },
    checkedSecondary: {
      color: theme.palette.secondary.main
    },
    disabled: {
      color: theme.palette.action.disabled
    }
  };
};

var _ref = _react2.default.createElement(_RadioButtonUnchecked2.default, null);

var _ref2 = _react2.default.createElement(_RadioButtonChecked2.default, null);

function Radio(props) {
  var _classNames;

  var classes = props.classes,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'color']);

  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
    type: 'radio',
    icon: _ref,
    checkedIcon: _ref2,
    classes: {
      default: classes.default,
      checked: checkedClass,
      disabled: classes.disabled
    }
  }, other));
}

Radio.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Radio.defaultProps = {
  color: 'secondary'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiRadio' })(Radio);

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var RadioButtonChecked = function RadioButtonChecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
RadioButtonChecked = (0, _pure2.default)(RadioButtonChecked);
RadioButtonChecked.muiName = 'SvgIcon';

exports.default = RadioButtonChecked;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' });

var RadioButtonUnchecked = function RadioButtonUnchecked(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
RadioButtonUnchecked = (0, _pure2.default)(RadioButtonUnchecked);
RadioButtonUnchecked.muiName = 'SvgIcon';

exports.default = RadioButtonUnchecked;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = __webpack_require__(359);

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent FormGroup

var RadioGroup = function (_React$Component) {
  (0, _inherits3.default)(RadioGroup, _React$Component);

  function RadioGroup() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RadioGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioGroup)).call.apply(_ref, [this].concat(args))), _this), _this.radios = [], _this.focus = function () {
      if (!_this.radios || !_this.radios.length) {
        return;
      }

      var focusRadios = _this.radios.filter(function (n) {
        return !n.disabled;
      });

      if (!focusRadios.length) {
        return;
      }

      var selectedRadio = (0, _helpers.find)(focusRadios, function (n) {
        return n.checked;
      });

      if (selectedRadio) {
        selectedRadio.focus();
        return;
      }

      focusRadios[0].focus();
    }, _this.handleRadioChange = function (event, checked) {
      if (checked && _this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RadioGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          name = _props.name,
          value = _props.value,
          onChange = _props.onChange,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'value', 'onChange']);


      this.radios = [];

      return _react2.default.createElement(
        _FormGroup2.default,
        (0, _extends3.default)({ role: 'radiogroup' }, other),
        _react2.default.Children.map(children, function (child, index) {
          if (!_react2.default.isValidElement(child)) {
            return null;
          }

          return _react2.default.cloneElement(child, {
            key: index,
            name: name,
            inputRef: function inputRef(node) {
              if (node) {
                _this2.radios.push(node);
              }
            },
            checked: value === child.props.value,
            onChange: _this2.handleRadioChange
          });
        })
      );
    }
  }]);
  return RadioGroup;
}(_react2.default.Component);

RadioGroup.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * The name used to reference the value of the control.
   */
  name: _propTypes2.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes2.default.func,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback
   * @param {string} value The `value` of the selected radio button
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes2.default.func,
  /**
   * Value of the selected radio button.
   */
  value: _propTypes2.default.string
} : {};

exports.default = RadioGroup;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Stepper = __webpack_require__(925);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Stepper).default;
  }
});

var _Step = __webpack_require__(927);

Object.defineProperty(exports, 'Step', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Step).default;
  }
});

var _StepButton = __webpack_require__(928);

Object.defineProperty(exports, 'StepButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepButton).default;
  }
});

var _StepContent = __webpack_require__(931);

Object.defineProperty(exports, 'StepContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepContent).default;
  }
});

var _StepIcon = __webpack_require__(393);

Object.defineProperty(exports, 'StepIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepIcon).default;
  }
});

var _StepLabel = __webpack_require__(392);

Object.defineProperty(exports, 'StepLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StepLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Paper = __webpack_require__(20);

var _Paper2 = _interopRequireDefault(_Paper);

var _StepConnector = __webpack_require__(926);

var _StepConnector2 = _interopRequireDefault(_StepConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Paper

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      padding: theme.spacing.unit * 3
    },
    horizontal: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    vertical: {
      flexDirection: 'column'
    },
    alternativeLabel: {
      alignItems: 'flex-start'
    }
  };
};

function Stepper(props) {
  var activeStep = props.activeStep,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      connectorProp = props.connector,
      nonLinear = props.nonLinear,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['activeStep', 'alternativeLabel', 'children', 'classes', 'className', 'connector', 'nonLinear', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);

  var connector = _react2.default.isValidElement(connectorProp) ? _react2.default.cloneElement(connectorProp, { orientation: orientation }) : null;
  var childrenArray = _react2.default.Children.toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      index: index,
      orientation: orientation,
      active: false,
      completed: false,
      disabled: false,
      last: index + 1 === childrenArray.length,
      alternativeLabel: alternativeLabel,
      connector: connectorProp
    };

    if (activeStep === index) {
      controlProps.active = true;
    } else if (!nonLinear && activeStep > index) {
      controlProps.completed = true;
    } else if (!nonLinear && activeStep < index) {
      controlProps.disabled = true;
    }

    return [!alternativeLabel && connector && index > 0 && _react2.default.cloneElement(connector, {
      key: index // eslint-disable-line react/no-array-index-key
    }), _react2.default.cloneElement(step, (0, _extends3.default)({}, controlProps, step.props))];
  });

  return _react2.default.createElement(
    _Paper2.default,
    (0, _extends3.default)({ square: true, elevation: 0, className: className }, other),
    steps
  );
}

Stepper.propTypes =  false ? {
  /**
   * Set the active step (zero based index).
   */
  activeStep: _propTypes2.default.number,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * A component to be placed between each step.
   */
  connector: _propTypes2.default.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: _propTypes2.default.bool,
  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

Stepper.defaultProps = {
  activeStep: 0,
  alternativeLabel: false,
  connector: _react2.default.createElement(_StepConnector2.default, null),
  nonLinear: false,
  orientation: 'horizontal'
};

Stepper.muiName = 'Stepper';

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepper' })(Stepper);

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flex: '1 1 auto'
    },
    horizontal: {},
    vertical: {
      marginLeft: 12, // half icon
      padding: '0 0 ' + theme.spacing.unit + 'px'
    },
    alternativeLabel: {
      position: 'absolute',
      top: theme.spacing.unit + 4,
      left: 'calc(50% + 20px)',
      right: 'calc(-50% + 20px)'
    },
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: theme.spacing.unit * 3
    }
  };
};

/**
 * @ignore - internal component.
 */
function StepConnector(props) {
  var _classNames2;

  var alternativeLabel = props.alternativeLabel,
      classNameProp = props.className,
      classes = props.classes,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['alternativeLabel', 'className', 'classes', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);
  var lineClassName = (0, _classnames2.default)(classes.line, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes.lineHorizontal, orientation === 'horizontal'), (0, _defineProperty3.default)(_classNames2, classes.lineVertical, orientation === 'vertical'), _classNames2));

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.createElement('span', { className: lineClassName })
  );
}

StepConnector.propTypes =  false ? {
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Useful to extend the style applied to the component.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

StepConnector.defaultProps = {
  alternativeLabel: false,
  orientation: 'horizontal'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepConnector' })(StepConnector);

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {},
    horizontal: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      '&:first-child': {
        paddingLeft: 0
      },
      '&:last-child': {
        paddingRight: 0
      }
    },
    vertical: {},
    alternativeLabel: {
      flex: 1,
      position: 'relative'
    }
  };
};

function Step(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      connector = props.connector,
      disabled = props.disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'connector', 'disabled', 'index', 'last', 'orientation']);


  var className = (0, _classnames2.default)(classes.root, classes[orientation], (0, _defineProperty3.default)({}, classes.alternativeLabel, alternativeLabel), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.Children.map(children, function (child) {
      return _react2.default.cloneElement(child, (0, _extends3.default)({
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        icon: index + 1,
        last: last,
        orientation: orientation
      }, child.props));
    }),
    connector && alternativeLabel && !last && _react2.default.cloneElement(connector, { orientation: orientation, alternativeLabel: alternativeLabel })
  );
}

Step.propTypes =  false ? {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: _propTypes2.default.element,
  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   * Used internally for numbering.
   */
  index: _propTypes2.default.number,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

Step.defaultProps = {
  active: false,
  completed: false,
  disabled: false
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStep' })(Step);

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _StepLabel = __webpack_require__(392);

var _StepLabel2 = _interopRequireDefault(_StepLabel);

var _reactHelpers = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      padding: theme.spacing.unit * 3 + 'px ' + theme.spacing.unit * 2 + 'px',
      margin: -theme.spacing.unit * 3 + 'px ' + -theme.spacing.unit * 2 + 'px',
      boxSizing: 'content-box'
    }
  };
}; // @inheritedComponent ButtonBase

function StepButton(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'disabled', 'icon', 'last', 'optional', 'orientation']);


  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = (0, _reactHelpers.isMuiElement)(children, ['StepLabel']) ? _react2.default.cloneElement(children, childProps) : _react2.default.createElement(
    _StepLabel2.default,
    childProps,
    children
  );

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({ disabled: disabled, className: (0, _classnames2.default)(classes.root, classNameProp) }, other),
    child
  );
}

StepButton.propTypes =  false ? {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: _propTypes2.default.bool,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * The optional node to display.
   */
  optional: _propTypes2.default.node,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical'])
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepButton' })(StepButton);

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z' });

var CheckCircle = function CheckCircle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};
CheckCircle = (0, _pure2.default)(CheckCircle);
CheckCircle.muiName = 'SvgIcon';

exports.default = CheckCircle;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: theme.palette.text.disabled
    },
    active: {
      color: theme.palette.primary.main
    },
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref = _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12' });

function StepPositionIcon(props) {
  var position = props.position,
      classes = props.classes,
      classNameProp = props.className,
      active = props.active;

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active), classNameProp);

  return _react2.default.createElement(
    _SvgIcon2.default,
    { className: className },
    _ref,
    _react2.default.createElement(
      'text',
      { className: classes.text, x: '12', y: '16', textAnchor: 'middle' },
      position
    )
  );
}

StepPositionIcon.propTypes =  false ? {
  /**
   * Whether this step is active.
   */
  active: _propTypes2.default.bool,
  /**
   * Classses for component style customizations.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The step position as a number.
   */
  position: _propTypes2.default.node
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepPosition' })(StepPositionIcon);

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Collapse = __webpack_require__(228);

var _Collapse2 = _interopRequireDefault(_Collapse);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      marginTop: theme.spacing.unit,
      marginLeft: 12, // half icon
      paddingLeft: theme.spacing.unit + 12, // margin + half icon
      paddingRight: theme.spacing.unit,
      borderLeft: '1px solid ' + (theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },
    last: {
      borderLeft: 'none'
    },
    transition: {}
  };
};

function StepContent(props) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      classNameProp = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      Transition = props.transition,
      transitionDuration = props.transitionDuration,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'alternativeLabel', 'children', 'classes', 'className', 'completed', 'last', 'optional', 'orientation', 'transition', 'transitionDuration']);


   false ? (0, _warning2.default)(orientation === 'vertical', 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.last, last), classNameProp);

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: className }, other),
    _react2.default.createElement(
      Transition,
      {
        'in': active,
        className: classes.transition,
        timeout: transitionDuration,
        unmountOnExit: true
      },
      children
    )
  );
}

StepContent.propTypes =  false ? {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes2.default.bool,
  /**
   * Step content.
   */
  children: _propTypes2.default.node,
  /**
   * @ignore
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  completed: _propTypes2.default.bool,
  /**
   * @ignore
   */
  last: _propTypes2.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes2.default.bool,
  /**
   * @ignore
   */
  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
  /**
   * Collapse component.
   */
  transition: _propTypes2.default.func,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number }), _propTypes2.default.oneOf(['auto'])])
} : {};

StepContent.defaultProps = {
  transition: _Collapse2.default,
  transitionDuration: 'auto'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiStepContent' })(StepContent);

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(176);

Object.defineProperty(exports, 'common', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_common).default;
  }
});

var _red = __webpack_require__(262);

Object.defineProperty(exports, 'red', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_red).default;
  }
});

var _pink = __webpack_require__(260);

Object.defineProperty(exports, 'pink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pink).default;
  }
});

var _purple = __webpack_require__(933);

Object.defineProperty(exports, 'purple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_purple).default;
  }
});

var _deepPurple = __webpack_require__(934);

Object.defineProperty(exports, 'deepPurple', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepPurple).default;
  }
});

var _indigo = __webpack_require__(259);

Object.defineProperty(exports, 'indigo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_indigo).default;
  }
});

var _blue = __webpack_require__(935);

Object.defineProperty(exports, 'blue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blue).default;
  }
});

var _lightBlue = __webpack_require__(936);

Object.defineProperty(exports, 'lightBlue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightBlue).default;
  }
});

var _cyan = __webpack_require__(937);

Object.defineProperty(exports, 'cyan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_cyan).default;
  }
});

var _teal = __webpack_require__(938);

Object.defineProperty(exports, 'teal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_teal).default;
  }
});

var _green = __webpack_require__(939);

Object.defineProperty(exports, 'green', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_green).default;
  }
});

var _lightGreen = __webpack_require__(940);

Object.defineProperty(exports, 'lightGreen', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lightGreen).default;
  }
});

var _lime = __webpack_require__(941);

Object.defineProperty(exports, 'lime', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lime).default;
  }
});

var _yellow = __webpack_require__(942);

Object.defineProperty(exports, 'yellow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_yellow).default;
  }
});

var _amber = __webpack_require__(943);

Object.defineProperty(exports, 'amber', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_amber).default;
  }
});

var _orange = __webpack_require__(944);

Object.defineProperty(exports, 'orange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_orange).default;
  }
});

var _deepOrange = __webpack_require__(945);

Object.defineProperty(exports, 'deepOrange', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_deepOrange).default;
  }
});

var _brown = __webpack_require__(946);

Object.defineProperty(exports, 'brown', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_brown).default;
  }
});

var _grey = __webpack_require__(261);

Object.defineProperty(exports, 'grey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_grey).default;
  }
});

var _blueGrey = __webpack_require__(947);

Object.defineProperty(exports, 'blueGrey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_blueGrey).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};

exports.default = purple;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};

exports.default = deepPurple;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

exports.default = blue;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};

exports.default = lightBlue;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};

exports.default = cyan;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};

exports.default = teal;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

exports.default = green;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};

exports.default = lightGreen;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};

exports.default = lime;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};

exports.default = yellow;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};

exports.default = amber;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

exports.default = orange;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};

exports.default = deepOrange;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};

exports.default = brown;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};

exports.default = blueGrey;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(949);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _SwitchBase = __webpack_require__(227);

var _SwitchBase2 = _interopRequireDefault(_SwitchBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      // For correct alignment with the text.
      verticalAlign: 'middle'
    },
    bar: {
      borderRadius: 7,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      marginTop: -7,
      left: '50%',
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    },
    icon: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },
    iconChecked: {
      boxShadow: theme.shadows[2]
    },
    // For SwitchBase
    default: {
      zIndex: 1,
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {
      transform: 'translateX(14px)',
      '& + $bar': {
        opacity: 0.5
      }
    },
    checkedPrimary: {
      color: theme.palette.primary.main,
      '& + $bar': {
        backgroundColor: theme.palette.primary.main
      }
    },
    checkedSecondary: {
      color: theme.palette.secondary.main,
      '& + $bar': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    disabled: {
      color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800],
      '& + $bar': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      },
      '& $icon': {
        boxShadow: theme.shadows[1]
      }
    }
  };
};

function Switch(props) {
  var _classNames;

  var classes = props.classes,
      className = props.className,
      color = props.color,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'color']);

  var icon = _react2.default.createElement('span', { className: classes.icon });
  var checkedIcon = _react2.default.createElement('span', { className: (0, _classnames2.default)(classes.icon, classes.iconChecked) });
  var checkedClass = (0, _classnames2.default)(classes.checked, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.checkedPrimary, color === 'primary'), (0, _defineProperty3.default)(_classNames, classes.checkedSecondary, color === 'secondary'), _classNames));

  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(classes.root, className) },
    _react2.default.createElement(_SwitchBase2.default, (0, _extends3.default)({
      icon: icon,
      classes: {
        default: classes.default,
        checked: checkedClass,
        disabled: classes.disabled
      },
      checkedIcon: checkedIcon
    }, other)),
    _react2.default.createElement('span', { className: classes.bar })
  );
}

Switch.propTypes =  false ? {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes2.default.oneOf(['primary', 'secondary']),
  /**
   * @ignore
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * If `true`, the switch will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: _propTypes2.default.bool,
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes2.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes2.default.string,
  /**
   * Properties applied to the `input` element.
   */
  inputProps: _propTypes2.default.object,
  /**
   * Use that property to pass a ref callback to the native input component.
   */
  inputRef: _propTypes2.default.func,
  /*
   * @ignore
   */
  name: _propTypes2.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback
   * @param {boolean} checked The `checked` value of the switch
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * The input component property `type`.
   */
  type: _propTypes2.default.string,
  /**
   * The value of the component.
   */
  value: _propTypes2.default.string
} : {};

Switch.defaultProps = {
  color: 'secondary'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiSwitch' })(Switch);

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Table = __webpack_require__(951);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Table).default;
  }
});

var _TableBody = __webpack_require__(952);

Object.defineProperty(exports, 'TableBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableBody).default;
  }
});

var _TableCell = __webpack_require__(394);

Object.defineProperty(exports, 'TableCell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableCell).default;
  }
});

var _TableFooter = __webpack_require__(953);

Object.defineProperty(exports, 'TableFooter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableFooter).default;
  }
});

var _TableHead = __webpack_require__(954);

Object.defineProperty(exports, 'TableHead', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableHead).default;
  }
});

var _TablePagination = __webpack_require__(955);

Object.defineProperty(exports, 'TablePagination', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TablePagination).default;
  }
});

var _TableRow = __webpack_require__(957);

Object.defineProperty(exports, 'TableRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableRow).default;
  }
});

var _TableSortLabel = __webpack_require__(958);

Object.defineProperty(exports, 'TableSortLabel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableSortLabel).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      overflow: 'hidden'
    }
  };
};

var Table = function (_React$Component) {
  (0, _inherits3.default)(Table, _React$Component);

  function Table() {
    (0, _classCallCheck3.default)(this, Table);
    return (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).apply(this, arguments));
  }

  (0, _createClass3.default)(Table, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {}
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'component']);


      return _react2.default.createElement(Component, (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, classNameProp) }, other));
    }
  }]);
  return Table;
}(_react2.default.Component);

Table.propTypes =  false ? {
  /**
   * The content of the table, normally `TableHeader` and `TableBody`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

Table.defaultProps = {
  component: 'table'
};

Table.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTable' })(Table);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableBody = function (_React$Component) {
  (0, _inherits3.default)(TableBody, _React$Component);

  function TableBody() {
    (0, _classCallCheck3.default)(this, TableBody);
    return (0, _possibleConstructorReturn3.default)(this, (TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableBody, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          body: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['component']);


      return _react2.default.createElement(Component, other);
    }
  }]);
  return TableBody;
}(_react2.default.Component);

TableBody.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableBody.defaultProps = {
  component: 'tbody'
};

TableBody.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = TableBody;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableFooter = function (_React$Component) {
  (0, _inherits3.default)(TableFooter, _React$Component);

  function TableFooter() {
    (0, _classCallCheck3.default)(this, TableFooter);
    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableFooter, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          footer: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['component']);


      return _react2.default.createElement(Component, other);
    }
  }]);
  return TableFooter;
}(_react2.default.Component);

TableFooter.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableFooter.defaultProps = {
  component: 'tfoot'
};

TableFooter.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = TableFooter;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableHead = function (_React$Component) {
  (0, _inherits3.default)(TableHead, _React$Component);

  function TableHead() {
    (0, _classCallCheck3.default)(this, TableHead);
    return (0, _possibleConstructorReturn3.default)(this, (TableHead.__proto__ || (0, _getPrototypeOf2.default)(TableHead)).apply(this, arguments));
  }

  (0, _createClass3.default)(TableHead, [{
    key: 'getChildContext',
    value: function getChildContext() {
      // eslint-disable-line class-methods-use-this
      return {
        table: {
          head: true
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          other = (0, _objectWithoutProperties3.default)(_props, ['component']);


      return _react2.default.createElement(Component, other);
    }
  }]);
  return TableHead;
}(_react2.default.Component);

TableHead.propTypes =  false ? {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
} : {};

TableHead.defaultProps = {
  component: 'thead'
};

TableHead.childContextTypes = {
  table: _propTypes2.default.object
};

exports.default = TableHead;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Input = __webpack_require__(114);

var _Input2 = _interopRequireDefault(_Input);

var _Menu = __webpack_require__(113);

var _Select = __webpack_require__(391);

var _Select2 = _interopRequireDefault(_Select);

var _TableCell = __webpack_require__(394);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _Toolbar = __webpack_require__(221);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Typography = __webpack_require__(24);

var _Typography2 = _interopRequireDefault(_Typography);

var _TablePaginationActions = __webpack_require__(956);

var _TablePaginationActions2 = _interopRequireDefault(_TablePaginationActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent TableCell

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },
    toolbar: {
      height: 56,
      minHeight: 56,
      paddingRight: 2
    },
    spacer: {
      flex: '1 1 100%'
    },
    caption: {
      flexShrink: 0
    },
    input: {
      fontSize: 'inherit',
      flexShrink: 0
    },
    selectRoot: {
      marginRight: theme.spacing.unit * 4,
      marginLeft: theme.spacing.unit,
      color: theme.palette.text.secondary
    },
    select: {
      paddingLeft: theme.spacing.unit,
      paddingRight: theme.spacing.unit * 2
    },
    selectIcon: {
      top: 1
    },
    actions: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing.unit * 2.5
    }
  };
};

/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = function (_React$Component) {
  (0, _inherits3.default)(TablePagination, _React$Component);

  function TablePagination() {
    (0, _classCallCheck3.default)(this, TablePagination);
    return (0, _possibleConstructorReturn3.default)(this, (TablePagination.__proto__ || (0, _getPrototypeOf2.default)(TablePagination)).apply(this, arguments));
  }

  (0, _createClass3.default)(TablePagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var count = nextProps.count,
          onChangePage = nextProps.onChangePage,
          rowsPerPage = nextProps.rowsPerPage;

      var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
      if (this.props.page > newLastPage) {
        onChangePage(null, newLastPage);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          Actions = _props.Actions,
          backIconButtonProps = _props.backIconButtonProps,
          classes = _props.classes,
          colSpanProp = _props.colSpan,
          Component = _props.component,
          count = _props.count,
          labelDisplayedRows = _props.labelDisplayedRows,
          labelRowsPerPage = _props.labelRowsPerPage,
          nextIconButtonProps = _props.nextIconButtonProps,
          onChangePage = _props.onChangePage,
          onChangeRowsPerPage = _props.onChangeRowsPerPage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage,
          rowsPerPageOptions = _props.rowsPerPageOptions,
          other = (0, _objectWithoutProperties3.default)(_props, ['Actions', 'backIconButtonProps', 'classes', 'colSpan', 'component', 'count', 'labelDisplayedRows', 'labelRowsPerPage', 'nextIconButtonProps', 'onChangePage', 'onChangeRowsPerPage', 'page', 'rowsPerPage', 'rowsPerPageOptions']);


      var colSpan = void 0;

      if (Component === _TableCell2.default || Component === 'td') {
        colSpan = colSpanProp || 1000; // col-span over everything
      }

      return _react2.default.createElement(
        Component,
        (0, _extends3.default)({ className: classes.root, colSpan: colSpan }, other),
        _react2.default.createElement(
          _Toolbar2.default,
          { className: classes.toolbar },
          _react2.default.createElement('div', { className: classes.spacer }),
          rowsPerPageOptions.length > 1 && _react2.default.createElement(
            _Typography2.default,
            { variant: 'caption', className: classes.caption },
            labelRowsPerPage
          ),
          rowsPerPageOptions.length > 1 && _react2.default.createElement(
            _Select2.default,
            {
              classes: {
                root: classes.selectRoot,
                select: classes.select,
                icon: classes.selectIcon
              },
              input: _react2.default.createElement(_Input2.default, {
                classes: {
                  root: classes.input
                },
                disableUnderline: true
              }),
              value: rowsPerPage,
              onChange: onChangeRowsPerPage
            },
            rowsPerPageOptions.map(function (rowsPerPageOption) {
              return _react2.default.createElement(
                _Menu.MenuItem,
                { key: rowsPerPageOption, value: rowsPerPageOption },
                rowsPerPageOption
              );
            })
          ),
          _react2.default.createElement(
            _Typography2.default,
            { variant: 'caption', className: classes.caption },
            labelDisplayedRows({
              from: count === 0 ? 0 : page * rowsPerPage + 1,
              to: Math.min(count, (page + 1) * rowsPerPage),
              count: count,
              page: page
            })
          ),
          _react2.default.createElement(Actions, {
            backIconButtonProps: backIconButtonProps,
            count: count,
            nextIconButtonProps: nextIconButtonProps,
            onChangePage: onChangePage,
            page: page,
            rowsPerPage: rowsPerPage
          })
        )
      );
    }
  }]);
  return TablePagination;
}(_react2.default.Component);

TablePagination.propTypes =  false ? {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  Actions: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Properties applied to the back arrow `IconButton` component.
   */
  backIconButtonProps: _propTypes2.default.object,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  colSpan: _propTypes2.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * The total number of rows.
   */
  count: _propTypes2.default.number.isRequired,
  /**
   * Useful to customize the displayed rows label.
   */
  labelDisplayedRows: _propTypes2.default.func,
  /**
   * Useful to customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: _propTypes2.default.node,
  /**
   * Properties applied to the next arrow `IconButton` component.
   */
  nextIconButtonProps: _propTypes2.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes2.default.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage: _propTypes2.default.func,
  /**
   * The zero-based index of the current page.
   */
  page: _propTypes2.default.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes2.default.number.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: _propTypes2.default.array
} : {};

TablePagination.defaultProps = {
  Actions: _TablePaginationActions2.default,
  component: _TableCell2.default,
  labelDisplayedRows: function labelDisplayedRows(_ref) {
    var from = _ref.from,
        to = _ref.to,
        count = _ref.count;
    return from + '-' + to + ' of ' + count;
  },
  labelRowsPerPage: 'Rows per page:',
  rowsPerPageOptions: [5, 10, 25]
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePagination' })(TablePagination);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _KeyboardArrowLeft = __webpack_require__(395);

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _KeyboardArrowRight = __webpack_require__(396);

var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _IconButton = __webpack_require__(107);

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      flexShrink: 0,
      color: theme.palette.text.secondary,
      marginLeft: theme.spacing.unit * 2.5
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

var _ref3 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref4 = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref5 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

var TablePaginationActions = function (_React$Component) {
  (0, _inherits3.default)(TablePaginationActions, _React$Component);

  function TablePaginationActions() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TablePaginationActions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TablePaginationActions.__proto__ || (0, _getPrototypeOf2.default)(TablePaginationActions)).call.apply(_ref, [this].concat(args))), _this), _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    }, _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TablePaginationActions, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          backIconButtonProps = _props.backIconButtonProps,
          classes = _props.classes,
          count = _props.count,
          nextIconButtonProps = _props.nextIconButtonProps,
          onChangePage = _props.onChangePage,
          page = _props.page,
          rowsPerPage = _props.rowsPerPage,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['backIconButtonProps', 'classes', 'count', 'nextIconButtonProps', 'onChangePage', 'page', 'rowsPerPage', 'theme']);


      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: classes.root }, other),
        _react2.default.createElement(
          _IconButton2.default,
          (0, _extends3.default)({
            onClick: this.handleBackButtonClick,
            disabled: page === 0
          }, backIconButtonProps),
          theme.direction === 'rtl' ? _ref2 : _ref3
        ),
        _react2.default.createElement(
          _IconButton2.default,
          (0, _extends3.default)({
            onClick: this.handleNextButtonClick,
            disabled: page >= Math.ceil(count / rowsPerPage) - 1
          }, nextIconButtonProps),
          theme.direction === 'rtl' ? _ref4 : _ref5
        )
      );
    }
  }]);
  return TablePaginationActions;
}(_react2.default.Component);

TablePaginationActions.propTypes =  false ? {
  /**
   * Properties applied to the back arrow `IconButton` component.
   */
  backIconButtonProps: _propTypes2.default.object,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * The total number of rows.
   */
  count: _propTypes2.default.number.isRequired,
  /**
   * Properties applied to the next arrow `IconButton` component.
   */
  nextIconButtonProps: _propTypes2.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: _propTypes2.default.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: _propTypes2.default.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes2.default.number.isRequired,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTablePaginationActions', withTheme: true })(TablePaginationActions);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      display: 'table-row',
      height: 48,
      '&:focus': {
        outline: 'none'
      },
      verticalAlign: 'middle'
    },
    typeHead: {
      height: 56
    },
    typeFooter: {
      height: 56
    },
    selected: {
      backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
      : 'rgba(255, 255, 255, 0.08)'
    },
    hover: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    }
  };
};

/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */
function TableRow(props, context) {
  var _classNames;

  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      hover = props.hover,
      selected = props.selected,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'hover', 'selected']);
  var table = context.table;


  var className = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeHead, table && table.head), (0, _defineProperty3.default)(_classNames, classes.typeFooter, table && table.footer), (0, _defineProperty3.default)(_classNames, classes.hover, table && hover), (0, _defineProperty3.default)(_classNames, classes.selected, table && selected), _classNames), classNameProp);

  return _react2.default.createElement(Component, (0, _extends3.default)({ className: className }, other));
}

TableRow.propTypes =  false ? {
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * If `true`, the table row will shade on hover.
   */
  hover: _propTypes2.default.bool,
  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: _propTypes2.default.bool
} : {};

TableRow.defaultProps = {
  component: 'tr',
  hover: false,
  selected: false
};

TableRow.contextTypes = {
  table: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableRow' })(TableRow);

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _ArrowDownward = __webpack_require__(959);

var _ArrowDownward2 = _interopRequireDefault(_ArrowDownward);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:hover': {
        color: theme.palette.text.primary
      },
      '&:focus': {
        color: theme.palette.text.primary
      }
    },
    active: {
      color: theme.palette.text.primary,
      '& $icon': {
        opacity: 1
      }
    },
    icon: {
      height: 16,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none',
      width: 16
    },
    desc: {
      transform: 'rotate(0deg)'
    },
    asc: {
      transform: 'rotate(180deg)'
    }
  };
};

/**
 * A button based label for placing inside `TableCell` for column sorting.
 */
function TableSortLabel(props) {
  var active = props.active,
      classes = props.classes,
      classNameProp = props.className,
      children = props.children,
      direction = props.direction,
      other = (0, _objectWithoutProperties3.default)(props, ['active', 'classes', 'className', 'children', 'direction']);

  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.active, active), classNameProp);

  var iconClassName = (0, _classnames2.default)(classes.icon, (0, _defineProperty3.default)({}, classes[direction], !!direction));

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({ className: className, component: 'span', disableRipple: true }, other),
    children,
    _react2.default.createElement(_ArrowDownward2.default, { className: iconClassName })
  );
}

TableSortLabel.propTypes =  false ? {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: _propTypes2.default.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The current sort direction.
   */
  direction: _propTypes2.default.oneOf(['asc', 'desc'])
} : {};

TableSortLabel.defaultProps = {
  active: false,
  direction: 'desc'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTableSortLabel' })(TableSortLabel);

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _pure = __webpack_require__(19);

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = __webpack_require__(16);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore - internal component.
 */
var _ref = _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' });

var ArrowDownward = function ArrowDownward(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _ref
  );
};

ArrowDownward = (0, _pure2.default)(ArrowDownward);
ArrowDownward.muiName = 'SvgIcon';

exports.default = ArrowDownward;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(961);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _Tab = __webpack_require__(971);

Object.defineProperty(exports, 'Tab', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tab).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNan = __webpack_require__(264);

var _isNan2 = _interopRequireDefault(_isNan);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _reactScrollbarSize = __webpack_require__(962);

var _reactScrollbarSize2 = _interopRequireDefault(_reactScrollbarSize);

var _normalizeScrollLeft = __webpack_require__(965);

var _scroll = __webpack_require__(966);

var _scroll2 = _interopRequireDefault(_scroll);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _TabIndicator = __webpack_require__(969);

var _TabIndicator2 = _interopRequireDefault(_TabIndicator);

var _TabScrollButton = __webpack_require__(970);

var _TabScrollButton2 = _interopRequireDefault(_TabScrollButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
    },
    flexContainer: {
      display: 'flex'
    },
    scrollingContainer: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },
    scrollable: {
      overflowX: 'scroll'
    },
    centered: {
      justifyContent: 'center'
    },
    buttonAuto: (0, _defineProperty3.default)({}, theme.breakpoints.down('xs'), {
      display: 'none'
    })
  };
};

var Tabs = function (_React$Component) {
  (0, _inherits3.default)(Tabs, _React$Component);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indicatorStyle: {},
      scrollerStyle: {
        marginBottom: 0
      },
      showLeftScroll: false,
      showRightScroll: false,
      mounted: false
    }, _this.getConditionalElements = function () {
      var _this$props = _this.props,
          classes = _this$props.classes,
          buttonClassName = _this$props.buttonClassName,
          scrollable = _this$props.scrollable,
          scrollButtons = _this$props.scrollButtons,
          TabScrollButtonProp = _this$props.TabScrollButton,
          theme = _this$props.theme;

      var conditionalElements = {};
      conditionalElements.scrollbarSizeListener = scrollable ? _react2.default.createElement(_reactScrollbarSize2.default, {
        onLoad: _this.handleScrollbarSizeChange,
        onChange: _this.handleScrollbarSizeChange
      }) : null;

      var showScrollButtons = scrollable && (scrollButtons === 'auto' || scrollButtons === 'on');

      conditionalElements.scrollButtonLeft = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
        direction: theme && theme.direction === 'rtl' ? 'right' : 'left',
        onClick: _this.handleLeftScrollClick,
        visible: _this.state.showLeftScroll,
        className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.buttonAuto, scrollButtons === 'auto'), buttonClassName)
      }) : null;

      conditionalElements.scrollButtonRight = showScrollButtons ? _react2.default.createElement(TabScrollButtonProp, {
        direction: theme && theme.direction === 'rtl' ? 'left' : 'right',
        onClick: _this.handleRightScrollClick,
        visible: _this.state.showRightScroll,
        className: (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.buttonAuto, scrollButtons === 'auto'), buttonClassName)
      }) : null;

      return conditionalElements;
    }, _this.getTabsMeta = function (value, direction) {
      var tabsMeta = void 0;
      if (_this.tabs) {
        var rect = _this.tabs.getBoundingClientRect();
        // create a new object with ClientRect class props + scrollLeft
        tabsMeta = {
          clientWidth: _this.tabs ? _this.tabs.clientWidth : 0,
          scrollLeft: _this.tabs ? _this.tabs.scrollLeft : 0,
          scrollLeftNormalized: _this.tabs ? (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, direction) : 0,
          scrollWidth: _this.tabs ? _this.tabs.scrollWidth : 0,
          left: rect.left,
          right: rect.right
        };
      }

      var tabMeta = void 0;
      if (_this.tabs && value !== false) {
        var children = _this.tabs.children[0].children;

        if (children.length > 0) {
          var tab = children[_this.valueToIndex[value]];
           false ? (0, _warning2.default)(tab, 'Material-UI: the value provided `' + value + '` is invalid') : void 0;
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }
      return { tabsMeta: tabsMeta, tabMeta: tabMeta };
    }, _this.tabs = undefined, _this.valueToIndex = {}, _this.handleResize = (0, _debounce2.default)(function () {
      _this.updateIndicatorState(_this.props);
      _this.updateScrollButtonState();
    }, 166), _this.handleLeftScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(-_this.tabs.clientWidth);
      }
    }, _this.handleRightScrollClick = function () {
      if (_this.tabs) {
        _this.moveTabsScroll(_this.tabs.clientWidth);
      }
    }, _this.handleScrollbarSizeChange = function (_ref2) {
      var scrollbarHeight = _ref2.scrollbarHeight;

      _this.setState({
        scrollerStyle: {
          marginBottom: -scrollbarHeight
        }
      });
    }, _this.handleTabsScroll = (0, _debounce2.default)(function () {
      _this.updateScrollButtonState();
    }, 166), _this.moveTabsScroll = function (delta) {
      var theme = _this.props.theme;


      if (_this.tabs) {
        var multiplier = theme.direction === 'rtl' ? -1 : 1;
        var nextScrollLeft = _this.tabs.scrollLeft + delta * multiplier;
        // Fix for Edge
        var invert = theme.direction === 'rtl' && (0, _normalizeScrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
        _scroll2.default.left(_this.tabs, invert * nextScrollLeft);
      }
    }, _this.scrollSelectedIntoView = function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          value = _this$props2.value;

      var _this$getTabsMeta = _this.getTabsMeta(value, theme.direction),
          tabsMeta = _this$getTabsMeta.tabsMeta,
          tabMeta = _this$getTabsMeta.tabMeta;

      if (!tabMeta || !tabsMeta) {
        return;
      }

      if (tabMeta.left < tabsMeta.left) {
        // left side of button is out of view
        var nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.left - tabsMeta.left);
        _scroll2.default.left(_this.tabs, nextScrollLeft);
      } else if (tabMeta.right > tabsMeta.right) {
        // right side of button is out of view
        var _nextScrollLeft = tabsMeta.scrollLeft + (tabMeta.right - tabsMeta.right);
        _scroll2.default.left(_this.tabs, _nextScrollLeft);
      }
    }, _this.updateScrollButtonState = function () {
      var _this$props3 = _this.props,
          scrollable = _this$props3.scrollable,
          scrollButtons = _this$props3.scrollButtons,
          theme = _this$props3.theme;


      if (_this.tabs && scrollable && scrollButtons !== 'off') {
        var _this$tabs = _this.tabs,
            scrollWidth = _this$tabs.scrollWidth,
            clientWidth = _this$tabs.clientWidth;

        var scrollLeft = (0, _normalizeScrollLeft.getNormalizedScrollLeft)(_this.tabs, theme.direction);

        var showLeftScroll = theme.direction === 'rtl' ? scrollWidth > clientWidth + scrollLeft : scrollLeft > 0;

        var showRightScroll = theme.direction === 'rtl' ? scrollLeft > 0 : scrollWidth > clientWidth + scrollLeft;

        if (showLeftScroll !== _this.state.showLeftScroll || showRightScroll !== _this.state.showRightScroll) {
          _this.setState({ showLeftScroll: showLeftScroll, showRightScroll: showRightScroll });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ mounted: true });
      this.updateIndicatorState(this.props);
      this.updateScrollButtonState();

      if (this.props.action) {
        this.props.action({
          updateIndicator: this.handleResize
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.updateScrollButtonState();

      // The index might have changed at the same time.
      // We need to check again the right indicator position.
      this.updateIndicatorState(this.props);

      if (this.state.indicatorStyle !== prevState.indicatorStyle) {
        this.scrollSelectedIntoView();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      this.handleTabsScroll.cancel();
    }
  }, {
    key: 'updateIndicatorState',
    value: function updateIndicatorState(props) {
      var theme = props.theme,
          value = props.value;

      var _getTabsMeta = this.getTabsMeta(value, theme.direction),
          tabsMeta = _getTabsMeta.tabsMeta,
          tabMeta = _getTabsMeta.tabMeta;

      var left = 0;

      if (tabMeta && tabsMeta) {
        var correction = theme.direction === 'rtl' ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        left = tabMeta.left - tabsMeta.left + correction;
      }

      var indicatorStyle = {
        left: left,
        // May be wrong until the font is loaded.
        width: tabMeta ? tabMeta.width : 0
      };

      if ((indicatorStyle.left !== this.state.indicatorStyle.left || indicatorStyle.width !== this.state.indicatorStyle.width) && !(0, _isNan2.default)(indicatorStyle.left) && !(0, _isNan2.default)(indicatorStyle.width)) {
        this.setState({ indicatorStyle: indicatorStyle });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames3,
          _this2 = this;

      var _props = this.props,
          action = _props.action,
          buttonClassName = _props.buttonClassName,
          centered = _props.centered,
          childrenProp = _props.children,
          classes = _props.classes,
          classNameProp = _props.className,
          fullWidth = _props.fullWidth,
          indicatorClassName = _props.indicatorClassName,
          indicatorColor = _props.indicatorColor,
          onChange = _props.onChange,
          scrollable = _props.scrollable,
          scrollButtons = _props.scrollButtons,
          TabScrollButtonProp = _props.TabScrollButton,
          textColor = _props.textColor,
          theme = _props.theme,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'buttonClassName', 'centered', 'children', 'classes', 'className', 'fullWidth', 'indicatorClassName', 'indicatorColor', 'onChange', 'scrollable', 'scrollButtons', 'TabScrollButton', 'textColor', 'theme', 'value']);


      var className = (0, _classnames2.default)(classes.root, classNameProp);
      var scrollerClassName = (0, _classnames2.default)(classes.scrollingContainer, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.fixed, !scrollable), (0, _defineProperty3.default)(_classNames3, classes.scrollable, scrollable), _classNames3));
      var tabItemContainerClassName = (0, _classnames2.default)(classes.flexContainer, (0, _defineProperty3.default)({}, classes.centered, centered && !scrollable));

      var indicator = _react2.default.createElement(_TabIndicator2.default, {
        style: this.state.indicatorStyle,
        className: indicatorClassName,
        color: indicatorColor
      });

      this.valueToIndex = {};
      var childIndex = 0;
      var children = _react2.default.Children.map(childrenProp, function (child) {
        if (!_react2.default.isValidElement(child)) {
          return null;
        }

        var childValue = child.props.value || childIndex;
        _this2.valueToIndex[childValue] = childIndex;
        var selected = childValue === value;

        childIndex += 1;
        return _react2.default.cloneElement(child, {
          fullWidth: fullWidth,
          indicator: selected && !_this2.state.mounted && indicator,
          selected: selected,
          onChange: onChange,
          textColor: textColor,
          value: childValue
        });
      });

      var conditionalElements = this.getConditionalElements();

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: className }, other),
        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
        conditionalElements.scrollbarSizeListener,
        _react2.default.createElement(
          'div',
          { className: classes.flexContainer },
          conditionalElements.scrollButtonLeft,
          _react2.default.createElement(
            'div',
            {
              className: scrollerClassName,
              style: this.state.scrollerStyle,
              ref: function ref(node) {
                _this2.tabs = node;
              },
              role: 'tablist',
              onScroll: this.handleTabsScroll
            },
            _react2.default.createElement(
              'div',
              { className: tabItemContainerClassName },
              children
            ),
            this.state.mounted && indicator
          ),
          conditionalElements.scrollButtonRight
        )
      );
    }
  }]);
  return Tabs;
}(_react2.default.Component);

Tabs.propTypes =  false ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * The CSS class name of the scroll button elements.
   */
  buttonClassName: _propTypes2.default.string,
  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes2.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes2.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The CSS class name of the indicator element.
   */
  indicatorClassName: _propTypes2.default.string,
  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary'])]),
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes2.default.func,
  /**
   * True invokes scrolling properties and allow for horizontally scrolling
   * (or swiping) the tab bar.
   */
  scrollable: _propTypes2.default.bool,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes2.default.oneOf(['auto', 'on', 'off']),
  /**
   * The component used to render the scroll buttons.
   */
  TabScrollButton: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes2.default.oneOf(['secondary', 'primary', 'inherit']),
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes2.default.any
} : {};

Tabs.defaultProps = {
  centered: false,
  fullWidth: false,
  indicatorColor: 'secondary',
  scrollable: false,
  scrollButtons: 'auto',
  TabScrollButton: _TabScrollButton2.default,
  textColor: 'inherit'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabs', withTheme: true })(Tabs);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScrollbarSize = __webpack_require__(963);

var _ScrollbarSize2 = _interopRequireDefault(_ScrollbarSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ScrollbarSize2.default;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _stifle = __webpack_require__(964);

var _stifle2 = _interopRequireDefault(_stifle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
	width: '100px',
	height: '100px',
	position: 'absolute',
	top: '-100000px',
	overflow: 'scroll',
	msOverflowStyle: 'scrollbar'
};

var ScrollbarSize = function (_Component) {
	(0, _inherits3.default)(ScrollbarSize, _Component);

	function ScrollbarSize() {
		var _ref;

		var _temp, _this, _ret;

		(0, _classCallCheck3.default)(this, ScrollbarSize);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ScrollbarSize.__proto__ || (0, _getPrototypeOf2.default)(ScrollbarSize)).call.apply(_ref, [this].concat(args))), _this), _this.setMeasurements = function () {
			_this.scrollbarHeight = _this.node.offsetHeight - _this.node.clientHeight;
			_this.scrollbarWidth = _this.node.offsetWidth - _this.node.clientWidth;
		}, _this.handleResize = (0, _stifle2.default)(function () {
			var onChange = _this.props.onChange;


			var prevHeight = _this.scrollbarHeight;
			var prevWidth = _this.scrollbarWidth;
			_this.setMeasurements();
			if (prevHeight !== _this.scrollbarHeight || prevWidth !== _this.scrollbarWidth) {
				onChange({ scrollbarHeight: _this.scrollbarHeight, scrollbarWidth: _this.scrollbarWidth });
			}
		}, 166), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	}

	(0, _createClass3.default)(ScrollbarSize, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var onLoad = this.props.onLoad;


			if (onLoad) {
				this.setMeasurements();
				onLoad({ scrollbarHeight: this.scrollbarHeight, scrollbarWidth: this.scrollbarWidth });
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.handleResize.cancel();
		}
	}, {
		key: 'render',
		// Corresponds to 10 frames at 60 Hz.

		value: function render() {
			var _this2 = this;

			var onChange = this.props.onChange;


			return _react2.default.createElement(
				'div',
				null,
				onChange ? _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }) : null,
				_react2.default.createElement('div', {
					style: styles,
					ref: function ref(node) {
						_this2.node = node;
					}
				})
			);
		}
	}]);
	return ScrollbarSize;
}(_react.Component);

ScrollbarSize.defaultProps = {
	onLoad: null,
	onChange: null
};
exports.default = ScrollbarSize;

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports = stifle;


function stifle (fn, wait) {
  if (typeof fn !== 'function' || typeof wait !== 'number') {
    throw new Error('stifle(fn, wait) -- expected a function and number of milliseconds, got (' + typeof fn + ', ' + typeof wait + ')');
  }

  var timer;    // Timer to fire after `wait` has elapsed
  var called;   // Keep track if it gets called during the `wait`

  var wrapper = function () {

    // Check if still "cooling down" from a previous call
    if (timer) {
      called = true;
    } else {
      // Start a timer to fire after the `wait` is over
      timer = setTimeout(afterWait, wait);
      // And call the wrapped function
      fn();
    }
  }

  // Add a cancel method, to kill and pending calls
  wrapper.cancel = function () {
    // Clear the called flag, or it would fire twice when called again later
    called = false;

    // Turn off the timer, so it won't fire after the wait expires
    if (timer) {
      clearTimeout(timer);
      timer = undefined;
    }
  }

  function afterWait() {
    // Empty out the timer
    timer = undefined;

    // If it was called during the `wait`, fire it again
    if (called) {
      called = false;
      wrapper();
    }
  }

  return wrapper;
}


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
exports._setScrollType = _setScrollType;
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
exports.detectScrollType = detectScrollType;
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}
exports.setNormalizedScrollLeft = setNormalizedScrollLeft;


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var raf = __webpack_require__(967)
var E_NOSCROLL = new Error('Element already at target scroll position')
var E_CANCELLED = new Error('Scroll cancelled')
var min = Math.min

module.exports = {
  left: make('scrollLeft'),
  top: make('scrollTop')
}

function make (prop) {
  return function scroll (el, to, opts, cb) {
    opts = opts || {}

    if (typeof opts == 'function') cb = opts, opts = {}
    if (typeof cb != 'function') cb = noop

    var start = +new Date
    var from = el[prop]
    var ease = opts.ease || inOutSine
    var duration = !isNaN(opts.duration) ? +opts.duration : 350
    var cancelled = false

    return from === to ?
      cb(E_NOSCROLL, el[prop]) :
      raf(animate), cancel

    function cancel () {
      cancelled = true
    }

    function animate (timestamp) {
      if (cancelled) return cb(E_CANCELLED, el[prop])

      var now = +new Date
      var time = min(1, ((now - start) / duration))
      var eased = ease(time)

      el[prop] = (eased * (to - from)) + from

      time < 1 ? raf(animate) : raf(function () {
        cb(null, el[prop])
      })
    }
  }
}

function inOutSine (n) {
  return 0.5 * (1 - Math.cos(Math.PI * n))
}

function noop () {}


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(968)

/**
 * `requestAnimationFrame()`
 */

var request = global.requestAnimationFrame
  || global.webkitRequestAnimationFrame
  || global.mozRequestAnimationFrame
  || fallback

var prev = +new Date
function fallback (fn) {
  var curr = +new Date
  var ms = Math.max(0, 16 - (curr - prev))
  var req = setTimeout(fn, ms)
  return prev = curr, req
}

/**
 * `cancelAnimationFrame()`
 */

var cancel = global.cancelAnimationFrame
  || global.webkitCancelAnimationFrame
  || global.mozCancelAnimationFrame
  || clearTimeout

if (Function.prototype.bind) {
  request = request.bind(global)
  cancel = cancel.bind(global)
}

exports = module.exports = request
exports.cancel = cancel


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create(),
      willChange: 'left, width'
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    }
  };
};

/**
 * @ignore - internal component.
 */
function TabIndicator(props) {
  var classes = props.classes,
      classNameProp = props.className,
      color = props.color,
      styleProp = props.style;

  var colorPredefined = ['primary', 'secondary'].indexOf(color) !== -1;
  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes['color' + (0, _helpers.capitalize)(color)], colorPredefined), classNameProp);

  var style = colorPredefined ? styleProp : (0, _extends3.default)({}, styleProp, {
    backgroundColor: color
  });

  return _react2.default.createElement('span', { className: className, style: style });
}

TabIndicator.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['primary', 'secondary'])]),
  /**
   * @ignore
   * The style of the root element.
   */
  style: _propTypes2.default.object
} : {};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabIndicator' })(TabIndicator);

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _KeyboardArrowLeft = __webpack_require__(395);

var _KeyboardArrowLeft2 = _interopRequireDefault(_KeyboardArrowLeft);

var _KeyboardArrowRight = __webpack_require__(396);

var _KeyboardArrowRight2 = _interopRequireDefault(_KeyboardArrowRight);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      color: 'inherit',
      flex: '0 0 ' + theme.spacing.unit * 7 + 'px'
    }
  };
};

/**
 * @ignore - internal component.
 */

var _ref = _react2.default.createElement(_KeyboardArrowLeft2.default, null);

var _ref2 = _react2.default.createElement(_KeyboardArrowRight2.default, null);

function TabScrollButton(props) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      onClick = props.onClick,
      visible = props.visible,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'direction', 'onClick', 'visible']);


  var className = (0, _classnames2.default)(classes.root, classNameProp);

  if (!visible) {
    return _react2.default.createElement('div', { className: className });
  }

  return _react2.default.createElement(
    _ButtonBase2.default,
    (0, _extends3.default)({ className: className, onClick: onClick, tabIndex: -1 }, other),
    direction === 'left' ? _ref : _ref2
  );
}

TabScrollButton.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Which direction should the button indicate?
   */
  direction: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Callback to execute for button press.
   */
  onClick: _propTypes2.default.func,
  /**
   * Should the button be present or just consume space.
   */
  visible: _propTypes2.default.bool
} : {};

TabScrollButton.defaultProps = {
  visible: true
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTabScrollButton' })(TabScrollButton);

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _keys = __webpack_require__(39);

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(2);

var _extends4 = _interopRequireDefault(_extends3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

var _ButtonBase = __webpack_require__(43);

var _ButtonBase2 = _interopRequireDefault(_ButtonBase);

var _helpers = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent ButtonBase

var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _extends4.default)({}, theme.typography.button, (0, _defineProperty3.default)({
      maxWidth: 264,
      position: 'relative',
      minWidth: 72,
      padding: 0,
      height: 48,
      flex: 'none',
      overflow: 'hidden'
    }, theme.breakpoints.up('md'), {
      minWidth: 160
    })),
    rootLabelIcon: {
      height: 72
    },
    rootInherit: {
      color: 'inherit',
      opacity: 0.7
    },
    rootPrimary: {
      color: theme.palette.text.secondary
    },
    rootPrimarySelected: {
      color: theme.palette.primary.main
    },
    rootPrimaryDisabled: {
      color: theme.palette.text.disabled
    },
    rootSecondary: {
      color: theme.palette.text.secondary
    },
    rootSecondarySelected: {
      color: theme.palette.secondary.main
    },
    rootSecondaryDisabled: {
      color: theme.palette.text.disabled
    },
    rootInheritSelected: {
      opacity: 1
    },
    rootInheritDisabled: {
      opacity: 0.4
    },
    fullWidth: {
      flexGrow: 1
    },
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },
    labelContainer: (0, _defineProperty3.default)({
      paddingTop: 6,
      paddingBottom: 6,
      paddingLeft: 12,
      paddingRight: 12
    }, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing.unit * 3,
      paddingRight: theme.spacing.unit * 3
    }),
    label: (0, _defineProperty3.default)({
      fontSize: theme.typography.pxToRem(theme.typography.fontSize),
      whiteSpace: 'normal'
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 1)
    }),
    labelWrapped: (0, _defineProperty3.default)({}, theme.breakpoints.down('sm'), {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize - 2)
    })
  };
};

var Tab = function (_React$Component) {
  (0, _inherits3.default)(Tab, _React$Component);

  function Tab() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      wrappedText: false
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          onClick = _this$props.onClick;


      if (onChange) {
        onChange(event, value);
      }

      if (onClick) {
        onClick(event);
      }
    }, _this.label = undefined, _this.checkTextWrap = function () {
      if (_this.label) {
        var wrappedText = _this.label.getClientRects().length > 1;
        if (_this.state.wrappedText !== wrappedText) {
          _this.setState({ wrappedText: wrappedText });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tab, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkTextWrap();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.wrappedText === prevState.wrappedText) {
        /**
         * At certain text and tab lengths, a larger font size may wrap to two lines while the smaller
         * font size still only requires one line.  This check will prevent an infinite render loop
         * fron occurring in that scenario.
         */
        this.checkTextWrap();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames2;

      var _props = this.props,
          classes = _props.classes,
          classNameProp = _props.className,
          disabled = _props.disabled,
          fullWidth = _props.fullWidth,
          icon = _props.icon,
          indicator = _props.indicator,
          labelProp = _props.label,
          onChange = _props.onChange,
          selected = _props.selected,
          styleProp = _props.style,
          textColor = _props.textColor,
          value = _props.value,
          other = (0, _objectWithoutProperties3.default)(_props, ['classes', 'className', 'disabled', 'fullWidth', 'icon', 'indicator', 'label', 'onChange', 'selected', 'style', 'textColor', 'value']);


      var label = void 0;

      if (labelProp !== undefined) {
        label = _react2.default.createElement(
          'span',
          { className: classes.labelContainer },
          _react2.default.createElement(
            'span',
            {
              className: (0, _classnames2.default)(classes.label, (0, _defineProperty3.default)({}, classes.labelWrapped, this.state.wrappedText)),
              ref: function ref(node) {
                _this2.label = node;
              }
            },
            labelProp
          )
        );
      }

      var className = (0, _classnames2.default)(classes.root, classes['root' + (0, _helpers.capitalize)(textColor)], (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, classes['root' + (0, _helpers.capitalize)(textColor) + 'Disabled'], disabled), (0, _defineProperty3.default)(_classNames2, classes['root' + (0, _helpers.capitalize)(textColor) + 'Selected'], selected), (0, _defineProperty3.default)(_classNames2, classes.rootLabelIcon, icon && label), (0, _defineProperty3.default)(_classNames2, classes.fullWidth, fullWidth), _classNames2), classNameProp);

      var style = {};

      if (textColor !== 'secondary' && textColor !== 'inherit') {
        style.color = textColor;
      }

      style = (0, _keys2.default)(style).length > 0 ? (0, _extends4.default)({}, style, styleProp) : styleProp;

      return _react2.default.createElement(
        _ButtonBase2.default,
        (0, _extends4.default)({
          focusRipple: true,
          className: className,
          style: style,
          role: 'tab',
          'aria-selected': selected,
          disabled: disabled
        }, other, {
          onClick: this.handleChange
        }),
        _react2.default.createElement(
          'span',
          { className: classes.wrapper },
          icon,
          label
        ),
        indicator
      );
    }
  }]);
  return Tab;
}(_react2.default.Component);

Tab.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * If `true`, the tab will be disabled.
   */
  disabled: _propTypes2.default.bool,
  /**
   * @ignore
   */
  fullWidth: _propTypes2.default.bool,
  /**
   * The icon element.
   */
  icon: _propTypes2.default.node,
  /**
   * @ignore
   * For server side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes2.default.node,
  /**
   * The label element.
   */
  label: _propTypes2.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes2.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes2.default.func,
  /**
   * @ignore
   */
  selected: _propTypes2.default.bool,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  textColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf(['secondary', 'primary', 'inherit'])]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes2.default.any
} : {};

Tab.defaultProps = {
  disabled: false,
  textColor: 'inherit'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTab' })(Tab);

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tooltip = __webpack_require__(973);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(6);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(25);

var _reactEventListener = __webpack_require__(45);

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

var _debounce = __webpack_require__(70);

var _debounce2 = _interopRequireDefault(_debounce);

var _warning = __webpack_require__(12);

var _warning2 = _interopRequireDefault(_warning);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPopper = __webpack_require__(371);

var _helpers = __webpack_require__(14);

var _RefHolder = __webpack_require__(376);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _common = __webpack_require__(176);

var _common2 = _interopRequireDefault(_common);

var _withStyles = __webpack_require__(4);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, no-underscore-dangle */

var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline',
      flexDirection: 'inherit' // Makes the wrapper more transparent.
    },
    popper: {
      zIndex: theme.zIndex.tooltip
    },
    popperClose: {
      pointerEvents: 'none'
    },
    tooltip: (0, _defineProperty3.default)({
      backgroundColor: theme.palette.grey[700],
      borderRadius: 2,
      color: _common2.default.white,
      fontFamily: theme.typography.fontFamily,
      opacity: 0,
      transform: 'scale(0)',
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      minHeight: 0,
      padding: theme.spacing.unit,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.round(16 / 14) + 'em'
    }, theme.breakpoints.up('sm'), {
      padding: theme.spacing.unit / 2 + 'px ' + theme.spacing.unit + 'px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: theme.typography.round(14 / 10) + 'em'
    }),
    tooltipLeft: (0, _defineProperty3.default)({
      transformOrigin: 'right center',
      margin: '0 ' + theme.spacing.unit * 3 + 'px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipRight: (0, _defineProperty3.default)({
      transformOrigin: 'left center',
      margin: '0 ' + theme.spacing.unit * 3 + 'px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),
    tooltipTop: (0, _defineProperty3.default)({
      transformOrigin: 'center bottom',
      margin: theme.spacing.unit * 3 + 'px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),
    tooltipBottom: (0, _defineProperty3.default)({
      transformOrigin: 'center top',
      margin: theme.spacing.unit * 3 + 'px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),
    tooltipOpen: {
      opacity: 0.9,
      transform: 'scale(1)'
    }
  };
};

function flipPlacement(placement) {
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}

var Tooltip = function (_React$Component) {
  (0, _inherits3.default)(Tooltip, _React$Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.enterTimer = null, _this.leaveTimer = null, _this.touchTimer = null, _this.isControlled = null, _this.popper = null, _this.children = null, _this.ignoreNonTouchEvents = false, _this.handleResize = (0, _debounce2.default)(function () {
      if (_this.popper) {
        _this.popper._popper.scheduleUpdate();
      }
    }, 166), _this.handleRequestOpen = function (event) {
      var children = _this.props.children;

      var childrenProps = children.props;

      if (event.type === 'focus' && childrenProps.onFocus) {
        childrenProps.onFocus(event);
      }

      if (event.type === 'mouseover' && childrenProps.onMouseOver) {
        childrenProps.onMouseOver(event);
      }

      if (_this.ignoreNonTouchEvents && event.type !== 'touchstart') {
        return;
      }

      clearTimeout(_this.leaveTimer);
      if (_this.props.enterDelay > 0) {
        _this.leaveTimer = setTimeout(function () {
          _this.requestOpen(event);
        }, _this.props.enterDelay);
      } else {
        _this.requestOpen(event);
      }
    }, _this.requestOpen = function (event) {
      if (!_this.isControlled) {
        _this.setState({ open: true });
      }

      if (_this.props.onOpen) {
        _this.props.onOpen(event, true);
      }
    }, _this.handleClose = function (event) {
      var children = _this.props.children;

      var childrenProps = children.props;

      if (event.type === 'blur' && childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(_this.leaveTimer);
      if (_this.props.leaveDelay) {
        _this.leaveTimer = setTimeout(function () {
          _this.requestClose(event);
        }, _this.props.leaveDelay);
      } else {
        _this.requestClose(event);
      }
    }, _this.requestClose = function (event) {
      _this.ignoreNonTouchEvents = false;

      if (!_this.isControlled) {
        _this.setState({ open: false });
      }

      if (_this.props.onClose) {
        _this.props.onClose(event, false);
      }
    }, _this.handleTouchStart = function (event) {
      _this.ignoreNonTouchEvents = true;
      var children = _this.props.children;

      var childrenProps = children.props;

      if (childrenProps.onTouchStart) {
        childrenProps.onTouchStart(event);
      }

      clearTimeout(_this.touchTimer);
      event.persist();
      _this.touchTimer = setTimeout(function () {
        _this.handleRequestOpen(event);
      }, 1e3);
    }, _this.handleTouchEnd = function (event) {
      var children = _this.props.children;

      var childrenProps = children.props;

      if (childrenProps.onTouchEnd) {
        childrenProps.onTouchEnd(event);
      }

      clearTimeout(_this.touchTimer);
      clearTimeout(_this.leaveTimer);
      event.persist();
      _this.leaveTimer = setTimeout(function () {
        _this.requestClose(event);
      }, 1500 + _this.props.leaveDelay);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var props = this.props;


      this.isControlled = props.open != null;

      if (!this.isControlled) {
        // not controlled, use internal state
        this.setState({
          open: false
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
       false ? (0, _warning2.default)(!this.children || !this.children.disabled || !this.children.tagName.toLowerCase() === 'button', ['Material-UI: you are providing a disabled button children to the Tooltip component.', 'A disabled element do not fire events.', 'But the Tooltip needs to listen to the children element events to display the title.', '', 'Place a `div` over top of the element.'].join('\n')) : void 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.enterTimer);
      clearTimeout(this.leaveTimer);
      this.handleResize.cancel();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProp = _props.children,
          classes = _props.classes,
          className = _props.className,
          disableTriggerFocus = _props.disableTriggerFocus,
          disableTriggerHover = _props.disableTriggerHover,
          disableTriggerTouch = _props.disableTriggerTouch,
          enterDelay = _props.enterDelay,
          id = _props.id,
          leaveDelay = _props.leaveDelay,
          onClose = _props.onClose,
          onOpen = _props.onOpen,
          openProp = _props.open,
          rawPlacement = _props.placement,
          _props$PopperProps = _props.PopperProps;
      _props$PopperProps = _props$PopperProps === undefined ? {} : _props$PopperProps;
      var PopperClassName = _props$PopperProps.PopperClassName,
          PopperOther = (0, _objectWithoutProperties3.default)(_props$PopperProps, ['PopperClassName']),
          theme = _props.theme,
          title = _props.title,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'classes', 'className', 'disableTriggerFocus', 'disableTriggerHover', 'disableTriggerTouch', 'enterDelay', 'id', 'leaveDelay', 'onClose', 'onOpen', 'open', 'placement', 'PopperProps', 'theme', 'title']);


      var placement = theme.direction === 'rtl' ? flipPlacement(rawPlacement) : rawPlacement;
      var open = this.isControlled ? openProp : this.state.open;
      var childrenProps = {};

      if (title === '') {
        open = false;
      }

      childrenProps['aria-describedby'] = id;

      if (!disableTriggerTouch) {
        childrenProps.onTouchStart = this.handleTouchStart;
        childrenProps.onTouchEnd = this.handleTouchEnd;
      }

      if (!disableTriggerHover) {
        childrenProps.onMouseOver = this.handleRequestOpen;
        childrenProps.onMouseLeave = this.handleClose;
      }

      if (!disableTriggerFocus) {
        childrenProps.onFocus = this.handleRequestOpen;
        childrenProps.onBlur = this.handleClose;
      }

       false ? (0, _warning2.default)(!childrenProp.props.title, ['Material-UI: you have been providing a `title` property to the child of <Tooltip />.', 'Remove this title property `' + childrenProp.props.title + '` or the Tooltip component.'].join('\n')) : void 0;

      return _react2.default.createElement(
        _reactEventListener2.default,
        { target: 'window', onResize: this.handleResize },
        _react2.default.createElement(
          _reactPopper.Manager,
          (0, _extends3.default)({ className: (0, _classnames2.default)(classes.root, className) }, other),
          _react2.default.createElement(
            _reactPopper.Target,
            null,
            function (_ref2) {
              var targetProps = _ref2.targetProps;
              return _react2.default.createElement(
                _RefHolder2.default,
                {
                  ref: function ref(node) {
                    _this2.children = (0, _reactDom.findDOMNode)(node);
                    targetProps.ref(_this2.children);
                  }
                },
                _react2.default.cloneElement(childrenProp, childrenProps)
              );
            }
          ),
          _react2.default.createElement(
            _reactPopper.Popper,
            (0, _extends3.default)({
              placement: placement,
              eventsEnabled: open,
              className: (0, _classnames2.default)(classes.popper, (0, _defineProperty3.default)({}, classes.popperClose, !open), PopperClassName)
            }, PopperOther, {
              ref: function ref(node) {
                _this2.popper = node;
              }
            }),
            function (_ref3) {
              var popperProps = _ref3.popperProps,
                  restProps = _ref3.restProps;

              var actualPlacement = popperProps['data-placement'] || placement;
              return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, popperProps, restProps, {
                  style: (0, _extends3.default)({}, popperProps.style, {
                    top: popperProps.style.top || 0,
                    left: popperProps.style.left || 0
                  }, restProps.style)
                }),
                _react2.default.createElement(
                  'div',
                  {
                    id: id,
                    role: 'tooltip',
                    'aria-hidden': !open,
                    className: (0, _classnames2.default)(classes.tooltip, (0, _defineProperty3.default)({}, classes.tooltipOpen, open), classes['tooltip' + (0, _helpers.capitalize)(actualPlacement.split('-')[0])])
                  },
                  title
                )
              );
            }
          )
        )
      );
    }
  }]);
  return Tooltip;
}(_react2.default.Component);

Tooltip.propTypes =  false ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes2.default.element.isRequired,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * Do not respond to focus events.
   */
  disableTriggerFocus: _propTypes2.default.bool,
  /**
   * Do not respond to hover events.
   */
  disableTriggerHover: _propTypes2.default.bool,
  /**
   * Do not respond to long press touch events.
   */
  disableTriggerTouch: _propTypes2.default.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   */
  enterDelay: _propTypes2.default.number,
  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * By providing this property, we can use aria-describedby to solve the accessibility issue.
   */
  id: _propTypes2.default.string,
  /**
   * The number of milliseconds to wait before hidding the tooltip.
   */
  leaveDelay: _propTypes2.default.number,
  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback
   */
  onClose: _propTypes2.default.func,
  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback
   */
  onOpen: _propTypes2.default.func,
  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes2.default.bool,
  /**
   * Tooltip placement
   */
  placement: _propTypes2.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Properties applied to the `Popper` element.
   */
  PopperProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes2.default.node.isRequired
} : {};

Tooltip.defaultProps = {
  disableTriggerFocus: false,
  disableTriggerHover: false,
  disableTriggerTouch: false,
  enterDelay: 0,
  leaveDelay: 0,
  placement: 'bottom'
};

exports.default = (0, _withStyles2.default)(styles, { name: 'MuiTooltip', withTheme: true })(Tooltip);

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Slide = __webpack_require__(224);

Object.defineProperty(exports, 'Slide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slide).default;
  }
});

var _Grow = __webpack_require__(223);

Object.defineProperty(exports, 'Grow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grow).default;
  }
});

var _Fade = __webpack_require__(156);

Object.defineProperty(exports, 'Fade', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Fade).default;
  }
});

var _Collapse = __webpack_require__(228);

Object.defineProperty(exports, 'Collapse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Collapse).default;
  }
});

var _Zoom = __webpack_require__(975);

Object.defineProperty(exports, 'Zoom', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Zoom).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(8);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(7);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(9);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(10);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(11);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Transition = __webpack_require__(79);

var _Transition2 = _interopRequireDefault(_Transition);

var _transitions = __webpack_require__(53);

var _withTheme = __webpack_require__(27);

var _withTheme2 = _interopRequireDefault(_withTheme);

var _utils = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @inheritedComponent Transition

var styles = {
  entering: {
    transform: 'scale(1)'
  },
  entered: {
    transform: 'scale(1)'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](https://material-ui-next.com/demos/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom = function (_React$Component) {
  (0, _inherits3.default)(Zoom, _React$Component);

  function Zoom() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Zoom);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Zoom.__proto__ || (0, _getPrototypeOf2.default)(Zoom)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = function (node) {
      var theme = _this.props.theme;

      (0, _utils.reflow)(node); // So the animation always start from the start.

      var _getTransitionProps = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'enter'
      }),
          transitionDuration = _getTransitionProps.duration,
          delay = _getTransitionProps.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.handleExit = function (node) {
      var theme = _this.props.theme;

      var _getTransitionProps2 = (0, _utils.getTransitionProps)(_this.props, {
        mode: 'exit'
      }),
          transitionDuration = _getTransitionProps2.duration,
          delay = _getTransitionProps2.delay;

      node.style.transition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });
      node.style.webkitTransition = theme.transitions.create('transform', {
        duration: transitionDuration,
        delay: delay
      });

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Zoom, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onEnter = _props.onEnter,
          onExit = _props.onExit,
          styleProp = _props.style,
          theme = _props.theme,
          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'onEnter', 'onExit', 'style', 'theme']);


      var style = (0, _extends3.default)({}, styleProp, _react2.default.isValidElement(children) ? children.props.style : {});

      return _react2.default.createElement(
        _Transition2.default,
        (0, _extends3.default)({ appear: true, onEnter: this.handleEnter, onExit: this.handleExit }, other),
        function (state, childProps) {
          return _react2.default.cloneElement(children, (0, _extends3.default)({
            style: (0, _extends3.default)({
              transform: 'scale(0)'
            }, styles[state], style)
          }, childProps));
        }
      );
    }
  }]);
  return Zoom;
}(_react2.default.Component);

Zoom.propTypes =  false ? {
  /**
   * A single child content element.
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes2.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes2.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes2.default.func,
  /**
   * @ignore
   */
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  theme: _propTypes2.default.object.isRequired,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({ enter: _propTypes2.default.number, exit: _propTypes2.default.number })])
} : {};

Zoom.defaultProps = {
  timeout: {
    enter: _transitions.duration.enteringScreen,
    exit: _transitions.duration.leavingScreen
  }
};

exports.default = (0, _withTheme2.default)()(Zoom);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsOfServiceComponent=function(_Component){_inherits(TermsOfServiceComponent,_Component);function TermsOfServiceComponent(){_classCallCheck(this,TermsOfServiceComponent);return _possibleConstructorReturn(this,(TermsOfServiceComponent.__proto__||Object.getPrototypeOf(TermsOfServiceComponent)).apply(this,arguments));}_createClass(TermsOfServiceComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default.a,{style:{width:'70%',margin:'auto',marginTop:'16px',padding:'16px'},className:this.props.classes.paper,elevation:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'headline'},'\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E01\u0E23\u0E38\u0E13\u0E32\u0E2D\u0E48\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E42\u0E14\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E04\u0E2D\u0E19\u0E0B\u0E31\u0E25\u0E15\u0E34\u0E49\u0E07 \u0E08\u0E33\u0E01\u0E31\u0E14 \u0E0B\u0E36\u0E48\u0E07\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E25\u0E39\u0E01\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E43\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D (\u0E0B\u0E36\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E08\u0E30\u0E40\u0E23\u0E35\u0E22\u0E01\u0E27\u0E48\u0E32 \u201C\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u201D) \u0E01\u0E33\u0E2B\u0E19\u0E14\u0E27\u0E48\u0E32\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07 \u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23 \u0E21\u0E2D\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49 \u0E41\u0E25\u0E30\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E14\u0E39\u0E41\u0E25\u0E19\u0E35\u0E49 (\u0E0B\u0E36\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E08\u0E30\u0E40\u0E23\u0E35\u0E22\u0E01\u0E27\u0E48\u0E32\u201D\u0E44\u0E0B\u0E15\u0E4C\u201D) \u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E14\u0E31\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u202F\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E21\u0E32\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E17\u0E48\u0E32\u0E19\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E49\u0E41\u0E25\u0E30\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E2B\u0E32\u0E01\u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E40\u0E2B\u0E47\u0E19\u0E14\u0E49\u0E27\u0E22\u0E01\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E19\u0E35\u0E49\u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C \u0E04\u0E33\u0E27\u0E48\u0E32 \u201C\u0E17\u0E48\u0E32\u0E19\u201D \u0E2B\u0E23\u0E37\u0E2D \u201C\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u201D \u0E2B\u0E21\u0E32\u0E22\u0E16\u0E36\u0E07\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C \u0E17\u0E31\u0E49\u0E07\u0E19\u0E35\u0E49\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E08\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07 \u0E23\u0E30\u0E07\u0E31\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E25\u0E34\u0E01\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49 \u0E0B\u0E36\u0E48\u0E07\u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48 \u0E10\u0E32\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E14\u0E49\u0E27\u0E22 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E15\u0E31\u0E49\u0E07\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E40\u0E08\u0E49\u0E07\u0E43\u0E2B\u0E49\u0E17\u0E23\u0E32\u0E1A \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E02\u0E31\u0E14\u0E01\u0E31\u0E19\u0E01\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49 \u0E43\u0E2B\u0E49\u0E22\u0E36\u0E14\u0E15\u0E32\u0E21\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E15\u0E01\u0E25\u0E07\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E25\u0E31\u0E01'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E27\u0E31\u0E2A\u0E14\u0E38 \u0E20\u0E32\u0E1E \u0E01\u0E23\u0E32\u0E1F\u0E1F\u0E34\u0E01\u0E2A\u0E4C \u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E41\u0E25\u0E30\u0E2A\u0E48\u0E27\u0E19\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C (\u0E0B\u0E36\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E08\u0E30\u0E40\u0E23\u0E35\u0E22\u0E01\u0E27\u0E48\u0E32 \u201C\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32") \u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E04\u0E38\u0E49\u0E21\u0E04\u0E23\u0E2D\u0E07\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u200B\u0E41\u0E25\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E42\u0E14\u0E22\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E30\u0E1A\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2D\u0E37\u0E48\u0E19 \u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E2D\u0E32\u0E08\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32 \u0E41\u0E25\u0E30\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E43\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E2A\u0E34\u0E19\u0E17\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E0D\u0E32\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E44\u0E14\u0E49 \u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E2D\u0E32\u0E08\u0E19\u0E33\u0E44\u0E1B\u0E2A\u0E39\u0E48\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E04\u0E48\u0E32\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22 \u0E41\u0E25\u0E30/\u0E2B\u0E23\u0E37\u0E2D \u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E1C\u0E34\u0E14\u0E17\u0E32\u0E07\u0E2D\u0E32\u0E0D\u0E32 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E14\u0E31\u0E14\u0E40\u0E40\u0E1B\u0E25\u0E07 \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E44\u0E1B\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48 \u0E08\u0E31\u0E14\u0E17\u0E33\u0E43\u0E2B\u0E21\u0E48 \u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 \u0E42\u0E1E\u0E2A\u0E15\u0E4C \u0E41\u0E22\u0E01\u0E2A\u0E48\u0E27\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E43\u0E14 \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E08\u0E32\u0E01\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E01\u0E48\u0E2D\u0E19 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E17\u0E33\u0E02\u0E36\u0E49\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E40\u0E2A\u0E35\u0E22\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E08\u0E32\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E0B\u0E2D\u0E23\u0E4C\u0E1F\u0E41\u0E27\u0E23\u0E4C\u0E43\u0E14\u0E46 \u0E0B\u0E36\u0E48\u0E07\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07 \u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E1A\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49 \u0E04\u0E27\u0E32\u0E21\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E01\u0E32\u0E23\u0E04\u0E32\u0E14\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19 \u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E21\u0E48\u0E04\u0E23\u0E1A\u0E16\u0E49\u0E27\u0E19 \u0E01\u0E32\u0E23\u0E2A\u0E30\u0E14\u0E38\u0E14 \u0E04\u0E27\u0E32\u0E21\u0E1A\u0E01\u0E1E\u0E23\u0E48\u0E2D\u0E07 \u0E04\u0E27\u0E32\u0E21\u0E25\u0E48\u0E32\u0E0A\u0E49\u0E32\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E44\u0E27\u0E23\u0E31\u0E2A\u0E43\u0E19\u0E23\u0E30\u0E1A\u0E1A\u0E04\u0E2D\u0E21\u0E1E\u0E34\u0E27\u0E40\u0E15\u0E2D\u0E23\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E32\u0E22\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E13\u0E25\u0E48\u0E21'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E40\u0E2A\u0E35\u0E22\u0E43\u0E14\u0E46 \u0E15\u0E48\u0E2D\u0E17\u0E48\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21 \u0E0B\u0E36\u0E48\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E32\u0E07\u0E2D\u0E49\u0E2D\u0E21 \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E1E\u0E34\u0E40\u0E28\u0E29\u0E17\u0E35\u0E48\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E08\u0E32\u0E30\u0E08\u0E07 \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E08\u0E32\u0E01\u0E40\u0E2B\u0E15\u0E38\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E41\u0E25\u0E49\u0E27\u0E41\u0E15\u0E48\u0E01\u0E23\u0E13\u0E35 \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E35\u0E48\u0E21\u0E32\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E1E\u0E36\u0E48\u0E07\u0E1E\u0E32 \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E48\u0E32\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E25\u0E07\u0E42\u0E17\u0E29 \u0E0B\u0E36\u0E48\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2B\u0E23\u0E37\u0E2D\u0E0B\u0E2D\u0E23\u0E4C\u0E1F\u0E41\u0E27\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E16\u0E36\u0E07\u0E41\u0E21\u0E49\u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E25\u0E30\u0E40\u0E25\u0E22 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E21\u0E49\u0E27\u0E48\u0E32\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E40\u0E17\u0E19\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E21\u0E2D\u0E1A\u0E2D\u0E33\u0E19\u0E32\u0E08\u0E08\u0E32\u0E01\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E41\u0E08\u0E49\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E44\u0E14\u0E49\u0E02\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E31\u0E49\u0E07\u0E2A\u0E2D\u0E07\u0E01\u0E23\u0E13\u0E35\u0E01\u0E47\u0E15\u0E32\u0E21 \u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E02\u0E49\u0E32\u0E07\u0E15\u0E49\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E01\u0E31\u0E1A\u0E17\u0E48\u0E32\u0E19 \u0E43\u0E19\u0E41\u0E07\u0E48\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E0B\u0E36\u0E48\u0E07\u0E40\u0E02\u0E49\u0E32\u0E02\u0E48\u0E32\u0E22\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14 \u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E15\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E08\u0E32\u0E01\u0E40\u0E2B\u0E15\u0E38\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E41\u0E25\u0E49\u0E27\u0E41\u0E15\u0E48\u0E01\u0E23\u0E13\u0E35 \u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E2A\u0E37\u0E1A\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07 \u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E42\u0E14\u0E22\u0E23\u0E27\u0E21\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E15\u0E48\u0E2D\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14 \u0E41\u0E25\u0E30\u0E2A\u0E32\u0E40\u0E2B\u0E15\u0E38\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E17\u0E33 (\u0E43\u0E19\u0E2A\u0E31\u0E0D\u0E0D\u0E32 \u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C [\u0E0B\u0E36\u0E48\u0E07\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E01\u0E32\u0E23\u0E25\u0E30\u0E40\u0E25\u0E22 \u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E04\u0E23\u0E48\u0E07\u0E04\u0E23\u0E31\u0E14] \u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E17\u0E32\u0E07\u0E01\u0E25\u0E31\u0E1A\u0E01\u0E31\u0E19) \u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E08\u0E48\u0E32\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E07\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E17\u0E4C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E17\u0E48\u0E32\u0E19\u0E21\u0E2D\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E2B\u0E49\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E17\u0E35\u0E48\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E17\u0E38\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E1E\u0E39\u0E14 \u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33 \u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14 \u0E20\u0E32\u0E1E\u0E01\u0E23\u0E32\u0E1F\u0E1F\u0E34\u0E01\u0E2A\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E42\u0E14\u0E22\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E0B\u0E15\u0E4C (\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E19\u0E35\u0E49\u0E40\u0E23\u0E35\u0E22\u0E01\u0E23\u0E27\u0E21\u0E27\u0E48\u0E32 \u201C\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u201D) \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14\u0E46 \u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 (\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E42\u0E06\u0E29\u0E13\u0E32) \u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E21\u0E32\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E49\u0E32\u0E22\u0E04\u0E25\u0E36\u0E07\u0E01\u0E31\u0E19 \u0E0B\u0E36\u0E48\u0E07\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E43\u0E19\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E41\u0E15\u0E48\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E08\u0E30\u0E01\u0E25\u0E48\u0E32\u0E27\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E43\u0E19\u0E22\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C\u0E41\u0E25\u0E30\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E48\u0E32\u0E15\u0E2D\u0E1A\u0E41\u0E17\u0E19\u0E41\u0E01\u0E48\u0E17\u0E48\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E04\u0E23\u0E01\u0E47\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E17\u0E48\u0E32\u0E19\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E08\u0E48\u0E32\u0E22\u0E04\u0E48\u0E32\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22 \u0E1B\u0E01\u0E1B\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E17\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E34\u0E15\u0E0B\u0E49\u0E33\u0E41\u0E25\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E14\u0E49\u0E27\u0E22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E31\u0E27\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E44\u0E14\u0E49\u0E0B\u0E36\u0E48\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E32\u0E08\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E48\u0E2D\u0E44\u0E0B\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E43\u0E08\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E17\u0E48\u0E32\u0E19\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E49\u0E27\u0E48\u0E32\u0E17\u0E48\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E48\u0E07 \u0E41\u0E25\u0E30\u0E17\u0E48\u0E32\u0E19 \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E15\u0E47\u0E21\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E04\u0E27\u0E32\u0E21\u0E19\u0E48\u0E32\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 \u0E17\u0E35\u0E48\u0E21\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E41\u0E25\u0E30\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E43\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E0B\u0E36\u0E48\u0E07\u0E1C\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E43\u0E19\u0E17\u0E32\u0E07\u0E02\u0E48\u0E21\u0E02\u0E39\u0E48 \u0E2A\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E17 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E37\u0E48\u0E2D\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E2B\u0E22\u0E32\u0E1A\u0E04\u0E32\u0E22 \u0E2D\u0E19\u0E32\u0E08\u0E32\u0E23 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E43\u0E14\u0E01\u0E47\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E2B\u0E32\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E0A\u0E48\u0E19\u0E19\u0E31\u0E49\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2A\u0E07\u0E27\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A \u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E22\u0E49\u0E32\u0E22 \u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E14\u0E17\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E32\u0E21\u0E14\u0E38\u0E25\u0E22\u0E1E\u0E34\u0E19\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E41\u0E15\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1C\u0E39\u0E49\u0E40\u0E14\u0E35\u0E22\u0E27 \u0E2B\u0E32\u0E01\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E38\u0E48\u0E07\u0E23\u0E49\u0E32\u0E22 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E01\u0E34\u0E14\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E37\u0E48\u0E2D\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07  \u0E2B\u0E22\u0E32\u0E1A\u0E04\u0E32\u0E22 \u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E44\u0E14\u0E49 \u0E41\u0E25\u0E30\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E25\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E32\u0E07\u0E28\u0E35\u0E25\u0E18\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E15\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E22\u0E2D\u0E21\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E16\u0E39\u0E01\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E44\u0E1B\u0E43\u0E19\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E40\u0E2B\u0E47\u0E19\u0E14\u0E49\u0E27\u0E22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E07\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E17\u0E4C'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E17\u0E48\u0E32\u0E19\u0E21\u0E2D\u0E1A\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E2B\u0E49\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E17\u0E35\u0E48\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E17\u0E38\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E33\u0E1E\u0E39\u0E14 \u0E04\u0E33\u0E41\u0E19\u0E30\u0E19\u0E33 \u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14 \u0E20\u0E32\u0E1E\u0E01\u0E23\u0E32\u0E1F\u0E1F\u0E34\u0E01\u0E2A\u0E4C \u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E01\u0E31\u0E1A\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E42\u0E14\u0E22\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E0B\u0E15\u0E4C (\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E19\u0E35\u0E49\u0E40\u0E23\u0E35\u0E22\u0E01\u0E23\u0E27\u0E21\u0E27\u0E48\u0E32 \u201C\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u201D) \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14\u0E46 \u0E40\u0E1B\u0E47\u0E19\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A \u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 (\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E41\u0E15\u0E48\u0E44\u0E21\u0E48\u0E08\u0E33\u0E01\u0E31\u0E14\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E42\u0E06\u0E29\u0E13\u0E32) \u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E25\u0E21\u0E32\u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E49\u0E32\u0E22\u0E04\u0E25\u0E36\u0E07\u0E01\u0E31\u0E19 \u0E0B\u0E36\u0E48\u0E07\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E43\u0E19\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32 \u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E41\u0E15\u0E48\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E01\u0E23\u0E13\u0E35\u0E17\u0E35\u0E48\u0E08\u0E30\u0E01\u0E25\u0E48\u0E32\u0E27\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E43\u0E19\u0E22\u0E48\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E0A\u0E49\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C\u0E41\u0E25\u0E30\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E48\u0E32\u0E15\u0E2D\u0E1A\u0E41\u0E17\u0E19\u0E41\u0E01\u0E48\u0E17\u0E48\u0E32\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E04\u0E23\u0E01\u0E47\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E17\u0E48\u0E32\u0E19\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E08\u0E48\u0E32\u0E22\u0E04\u0E48\u0E32\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22 \u0E1B\u0E01\u0E1B\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E17\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E43\u0E0A\u0E49\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E1C\u0E25\u0E34\u0E15\u0E0B\u0E49\u0E33\u0E41\u0E25\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E14\u0E49\u0E27\u0E22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E15\u0E31\u0E27\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E44\u0E14\u0E49\u0E0B\u0E36\u0E48\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E32\u0E08\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E15\u0E48\u0E2D\u0E44\u0E0B\u0E15\u0E4C\u0E42\u0E14\u0E22\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E43\u0E08\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E20\u0E32\u0E22\u0E43\u0E15\u0E49\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E17\u0E48\u0E32\u0E19\u0E23\u0E31\u0E1A\u0E23\u0E39\u0E49\u0E27\u0E48\u0E32\u0E17\u0E48\u0E32\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E48\u0E07 \u0E41\u0E25\u0E30\u0E17\u0E48\u0E32\u0E19 \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E15\u0E47\u0E21\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21 \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E04\u0E27\u0E32\u0E21\u0E19\u0E48\u0E32\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D \u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 \u0E17\u0E35\u0E48\u0E21\u0E32\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 \u0E41\u0E25\u0E30\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E43\u0E19\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E0B\u0E36\u0E48\u0E07\u0E1C\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E43\u0E19\u0E17\u0E32\u0E07\u0E02\u0E48\u0E21\u0E02\u0E39\u0E48 \u0E2A\u0E1A\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E17 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E2A\u0E37\u0E48\u0E2D\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07 \u0E2B\u0E22\u0E32\u0E1A\u0E04\u0E32\u0E22 \u0E2D\u0E19\u0E32\u0E08\u0E32\u0E23 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2D\u0E37\u0E48\u0E19\u0E43\u0E14\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E43\u0E14\u0E01\u0E47\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E2B\u0E32\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E0A\u0E48\u0E19\u0E19\u0E31\u0E49\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2A\u0E07\u0E27\u0E19\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E43\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A \u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E22\u0E49\u0E32\u0E22 \u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E14\u0E17\u0E2D\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E15\u0E32\u0E21\u0E14\u0E38\u0E25\u0E22\u0E1E\u0E34\u0E19\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E41\u0E15\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1C\u0E39\u0E49\u0E40\u0E14\u0E35\u0E22\u0E27 \u0E2B\u0E32\u0E01\u0E40\u0E2B\u0E47\u0E19\u0E27\u0E48\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E38\u0E48\u0E07\u0E23\u0E49\u0E32\u0E22 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E40\u0E01\u0E34\u0E14\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E37\u0E48\u0E2D\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2A\u0E35\u0E22\u0E07  \u0E2B\u0E22\u0E32\u0E1A\u0E04\u0E32\u0E22 \u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E49\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E44\u0E14\u0E49 \u0E41\u0E25\u0E30\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E25\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E32\u0E07\u0E28\u0E35\u0E25\u0E18\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E15\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E22\u0E2D\u0E21\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E16\u0E39\u0E01\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E44\u0E1B\u0E43\u0E19\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E44\u0E21\u0E48\u0E40\u0E2B\u0E47\u0E19\u0E14\u0E49\u0E27\u0E22'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E40\u0E02\u0E15\u0E1E\u0E37\u0E49\u0E19\u0E17\u0E35\u0E48\u0E04\u0E23\u0E2D\u0E1A\u0E04\u0E25\u0E38\u0E21\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E40\u0E27\u0E49\u0E19\u0E41\u0E15\u0E48\u0E08\u0E30\u0E23\u0E30\u0E1A\u0E38\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2D\u0E37\u0E48\u0E19 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E08\u0E31\u0E14\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E41\u0E25\u0E30\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E41\u0E25\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E44\u0E0B\u0E15\u0E4C\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E27\u0E48\u0E32\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E41\u0E25\u0E30\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E21\u0E35\u0E43\u0E2B\u0E49\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E43\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E08\u0E16\u0E39\u0E01\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E41\u0E25\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E19\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22\u0E41\u0E25\u0E30\u0E2D\u0E32\u0E08\u0E02\u0E36\u0E49\u0E19\u0E01\u0E31\u0E1A\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E17\u0E35\u0E48\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E16\u0E39\u0E01\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E41\u0E25\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E22\u0E39\u0E48 \u0E16\u0E49\u0E32\u0E17\u0E48\u0E32\u0E19\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E08\u0E32\u0E01\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E37\u0E48\u0E19\u0E0B\u0E36\u0E48\u0E07\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E16\u0E39\u0E01\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E41\u0E25\u0E30\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23 \u0E17\u0E48\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E49\u0E2D\u0E07\u0E16\u0E34\u0E48\u0E19\u0E02\u0E2D\u0E07\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48\u0E19\u0E31\u0E49\u0E19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E32\u0E08\u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E25\u0E32\u0E14\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E17\u0E32\u0E07\u0E40\u0E17\u0E04\u0E19\u0E34\u0E04\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E08\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E38\u0E07\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49 \u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E16\u0E39\u0E01\u0E08\u0E31\u0E14\u0E17\u0E33\u0E44\u0E27\u0E49\u0E43\u0E2B\u0E49\u0E43\u0E19\u0E25\u0E31\u0E01\u0E29\u0E13\u0E30 \u201C\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u201D \u0E41\u0E25\u0E30 \u201C\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u201D \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E43\u0E14\u0E46 \u0E17\u0E31\u0E49\u0E07\u0E2A\u0E34\u0E49\u0E19\u0E17\u0E31\u0E49\u0E07\u0E42\u0E14\u0E22\u0E0A\u0E31\u0E14\u0E41\u0E08\u0E49\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E42\u0E14\u0E22\u0E19\u0E31\u0E22\u0E15\u0E32\u0E21\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14\u0E17\u0E35\u0E48\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E0B\u0E36\u0E48\u0E07\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E14\u0E49\u0E32\u0E19\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E43\u0E19\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C \u0E01\u0E32\u0E23\u0E44\u0E21\u0E48\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E1A\u0E32\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E07 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E02\u0E31\u0E14\u0E02\u0E49\u0E2D\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E01\u0E1E\u0E23\u0E48\u0E2D\u0E07\u0E08\u0E30\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E0B\u0E15\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E1F\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E28\u0E08\u0E32\u0E01\u0E44\u0E27\u0E23\u0E31\u0E2A\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E48\u0E27\u0E19\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E15\u0E23\u0E32\u0E22\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E43\u0E19\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E04\u0E27\u0E32\u0E21\u0E41\u0E21\u0E48\u0E19\u0E22\u0E33 \u0E04\u0E27\u0E32\u0E21\u0E19\u0E48\u0E32\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E16\u0E37\u0E2D\u0E44\u0E14\u0E49 \u0E2B\u0E23\u0E37\u0E2D\u0E43\u0E19\u0E17\u0E32\u0E07\u0E2D\u0E37\u0E48\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E44\u0E21\u0E48\u0E21\u0E35\u0E1E\u0E31\u0E19\u0E18\u0E30\u0E2A\u0E31\u0E0D\u0E0D\u0E32\u0E17\u0E35\u0E48\u0E08\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E43\u0E2B\u0E49\u0E17\u0E31\u0E19\u0E40\u0E2B\u0E15\u0E38\u0E01\u0E32\u0E23\u0E13\u0E4C \u0E17\u0E48\u0E32\u0E19-\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27-\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E04\u0E48\u0E32\u0E43\u0E0A\u0E49\u0E08\u0E48\u0E32\u0E22\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E0B\u0E48\u0E2D\u0E21\u0E41\u0E0B\u0E21 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E02\u0E49\u0E32\u0E07\u0E15\u0E49\u0E19\u0E2D\u0E32\u0E08\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E17\u0E48\u0E32\u0E19\u0E43\u0E19\u0E41\u0E07\u0E48\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E17\u0E35\u0E48\u0E19\u0E33\u0E21\u0E32\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E2D\u0E32\u0E08\u0E44\u0E21\u0E48\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E21\u0E35\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E31\u0E19\u0E42\u0E14\u0E22\u0E19\u0E31\u0E22 \u0E19\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E21\u0E35\u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E04\u0E27\u0E23\u0E19\u0E33\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E2D\u0E37\u0E48\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E15\u0E48\u0E2D\u0E1C\u0E25\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E31\u0E19\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E32\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E01\u0E32\u0E23\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07\u0E16\u0E36\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E2D\u0E49\u0E32\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E27\u0E31\u0E15\u0E16\u0E38\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C \u0E23\u0E27\u0E21\u0E16\u0E36\u0E07\u0E01\u0E32\u0E23\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07\u0E43\u0E19\u0E01\u0E32\u0E23\u0E42\u0E06\u0E29\u0E13\u0E32 \u0E01\u0E32\u0E23\u0E0A\u0E48\u0E27\u0E22\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22 \u0E2B\u0E23\u0E37\u0E2D\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E40\u0E1B\u0E47\u0E19\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2B\u0E49\u0E32\u0E21\u0E01\u0E23\u0E30\u0E17\u0E33\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E04\u0E23\u0E48\u0E07\u0E04\u0E23\u0E31\u0E14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2B\u0E23\u0E37\u0E2D\u0E17\u0E48\u0E32\u0E19\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49 \u0E17\u0E48\u0E32\u0E19\u0E2D\u0E32\u0E08\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E17\u0E33\u0E25\u0E32\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E38\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49 \u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E09\u0E1A\u0E31\u0E1A\u0E17\u0E35\u0E48\u0E17\u0E33\u0E0B\u0E49\u0E33\u0E44\u0E27\u0E49\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49\u0E44\u0E14\u0E49\u0E17\u0E31\u0E19\u0E17\u0E35\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E25\u0E48\u0E27\u0E07\u0E2B\u0E19\u0E49\u0E32 \u0E2B\u0E32\u0E01\u0E17\u0E48\u0E32\u0E19\u0E25\u0E30\u0E40\u0E21\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E17\u0E35\u0E48\u0E27\u0E48\u0E32\u0E19\u0E35\u0E49 \u0E42\u0E14\u0E22\u0E17\u0E31\u0E49\u0E07\u0E19\u0E35\u0E49\u0E02\u0E36\u0E49\u0E19\u0E2D\u0E22\u0E39\u0E48\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E41\u0E15\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1C\u0E39\u0E49\u0E40\u0E14\u0E35\u0E22\u0E27 \u0E40\u0E21\u0E37\u0E48\u0E2D\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E17\u0E48\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E17\u0E33\u0E25\u0E32\u0E22\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E38\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E17\u0E35\u0E48\u0E44\u0E14\u0E49\u0E08\u0E32\u0E01\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49\u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14 \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E09\u0E1A\u0E31\u0E1A\u0E17\u0E35\u0E48\u0E17\u0E33\u0E0B\u0E49\u0E33\u0E44\u0E27\u0E49\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07 \u0E17\u0E48\u0E32\u0E19\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E44\u0E1B\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34\u0E08\u0E32\u0E01\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E40\u0E1B\u0E47\u0E19\u0E25\u0E32\u0E22\u0E25\u0E31\u0E01\u0E29\u0E13\u0E4C\u0E2D\u0E31\u0E01\u0E29\u0E23 \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E44\u0E23\u0E01\u0E47\u0E15\u0E32\u0E21\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E23\u0E27\u0E21\u0E17\u0E31\u0E49\u0E07\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E25\u0E34\u0E02\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E41\u0E25\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E21\u0E32\u0E15\u0E32\u0E21\u0E17\u0E35\u0E48\u0E23\u0E30\u0E1A\u0E38\u0E43\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E08\u0E33\u0E01\u0E31\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E22\u0E31\u0E07\u0E04\u0E07\u0E21\u0E35\u0E1C\u0E25\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A\u0E40\u0E15\u0E47\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E15\u0E48\u0E2D\u0E44\u0E1B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E31\u0E01\u0E29\u0E32\u0E41\u0E25\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E19\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E41\u0E25\u0E30\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E40\u0E02\u0E49\u0E32\u0E43\u0E08\u0E43\u0E14\u0E46 \u0E17\u0E31\u0E49\u0E07\u0E2A\u0E34\u0E49\u0E19\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E04\u0E34\u0E14\u0E40\u0E2B\u0E47\u0E19\u0E17\u0E35\u0E48\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E42\u0E14\u0E22\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E43\u0E14\u0E16\u0E39\u0E01\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2B\u0E21\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E27\u0E48\u0E32\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E41\u0E2A\u0E14\u0E07\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E2B\u0E23\u0E37\u0E2D\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E2B\u0E23\u0E37\u0E2D\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E08\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E44\u0E14\u0E49\u0E17\u0E38\u0E01\u0E40\u0E27\u0E25\u0E32 \u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E41\u0E25\u0E30\u0E19\u0E42\u0E22\u0E1A\u0E32\u0E22\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E01\u0E31\u0E1A\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E2D\u0E32\u0E08\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E44\u0E1B\u0E08\u0E32\u0E01\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E1A\u0E19\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27 \u0E2B\u0E32\u0E01\u0E17\u0E48\u0E32\u0E19\u0E15\u0E31\u0E14\u0E2A\u0E34\u0E19\u0E43\u0E08\u0E08\u0E30\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21\u0E17\u0E35\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E42\u0E22\u0E07\u0E01\u0E31\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E17\u0E48\u0E32\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E48\u0E22\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E40\u0E2D\u0E07 \u0E41\u0E25\u0E30\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E08\u0E30\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E43\u0E14\u0E46 \u0E08\u0E32\u0E01\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E0D\u0E40\u0E2A\u0E35\u0E22\u0E17\u0E35\u0E48\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19\u0E02\u0E2D\u0E07\u0E17\u0E48\u0E32\u0E19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'\u0E40\u0E1A\u0E47\u0E14\u0E40\u0E15\u0E25\u0E47\u0E14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'\u0E44\u0E2E\u0E23\u0E4C\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E08\u0E08\u0E30\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E19\u0E35\u0E49\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E43\u0E14\u0E01\u0E47\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E41\u0E08\u0E49\u0E07\u0E25\u0E48\u0E27\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E14\u0E49\u0E27\u0E22\u0E01\u0E32\u0E23\u0E19\u0E33\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E2B\u0E21\u0E48\u0E21\u0E32\u0E25\u0E07\u0E43\u0E19\u0E04\u0E33\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E19\u0E35\u0E49 \u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E17\u0E48\u0E32\u0E19\u0E22\u0E31\u0E07\u0E04\u0E07\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E13\u0E30\u0E19\u0E35\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E32\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E19\u0E33\u0E21\u0E32\u0E42\u0E1E\u0E2A\u0E15\u0E4C\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E08\u0E30\u0E2B\u0E21\u0E32\u0E22\u0E16\u0E36\u0E07\u0E27\u0E48\u0E32\u0E17\u0E48\u0E32\u0E19\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27 \u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E19\u0E35\u0E49\u0E08\u0E30\u0E16\u0E39\u0E01\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21\u0E41\u0E25\u0E30\u0E15\u0E35\u0E04\u0E27\u0E32\u0E21\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E04\u0E33\u0E19\u0E36\u0E07\u0E16\u0E36\u0E07\u0E2B\u0E25\u0E31\u0E01\u0E01\u0E32\u0E23\u0E43\u0E14\u0E46 \u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E04\u0E27\u0E32\u0E21\u0E02\u0E31\u0E14\u0E41\u0E22\u0E49\u0E07\u0E02\u0E2D\u0E07\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E2B\u0E32\u0E01\u0E21\u0E35\u0E2A\u0E48\u0E27\u0E19\u0E43\u0E14\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E16\u0E39\u0E01\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28\u0E27\u0E48\u0E32\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E15\u0E32\u0E21\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30 \u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E44\u0E1B\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A\u0E43\u0E0A\u0E49\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49 \u0E43\u0E2B\u0E49\u0E16\u0E37\u0E2D\u0E27\u0E48\u0E32\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E14\u0E31\u0E07\u0E01\u0E25\u0E48\u0E32\u0E27\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E16\u0E39\u0E01\u0E15\u0E31\u0E14\u0E2D\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E41\u0E25\u0E30\u0E08\u0E30\u0E44\u0E21\u0E48\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E1A\u0E31\u0E07\u0E04\u0E31\u0E1A\u0E43\u0E0A\u0E49\u0E02\u0E2D\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E2D\u0E37\u0E48\u0E19\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E49\u0E2D\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E19\u0E35\u0E49 \u0E2B\u0E25\u0E31\u0E01\u0E10\u0E32\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E32\u0E08\u0E40\u0E01\u0E34\u0E14\u0E02\u0E36\u0E49\u0E19\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E14\u0E49\u0E27\u0E22\u0E08\u0E38\u0E14\u0E1B\u0E23\u0E30\u0E2A\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E1C\u0E34\u0E14\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22\u0E08\u0E30\u0E16\u0E39\u0E01\u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E40\u0E08\u0E49\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48\u0E1C\u0E39\u0E49\u0E23\u0E31\u0E01\u0E29\u0E32\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22 \u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E19\u0E35\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E02\u0E49\u0E2D\u0E15\u0E01\u0E25\u0E07\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E1D\u0E48\u0E32\u0E22\u0E15\u0E48\u0E32\u0E07\u0E46 \u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E44\u0E0B\u0E15\u0E4C\u0E19\u0E35\u0E49'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null)));}}]);return TermsOfServiceComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* styles */])(TermsOfServiceComponent));

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrivacyComponent=function(_Component){_inherits(PrivacyComponent,_Component);function PrivacyComponent(){_classCallCheck(this,PrivacyComponent);return _possibleConstructorReturn(this,(PrivacyComponent.__proto__||Object.getPrototypeOf(PrivacyComponent)).apply(this,arguments));}_createClass(PrivacyComponent,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Paper___default.a,{style:{width:'70%',margin:'auto',marginTop:'16px',padding:'16px'},className:this.props.classes.paper,elevation:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'headline'},'mycareer.AI Privacy Policy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'Information that is gathered from visitors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'In common with other websites, log files are stored on the web server saving details such as the visitor\'s IP address, browser type, referring page and time of visit.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'Cookies may be used to remember visitor preferences when interacting with the website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'Where registration is required, the visitor\'s email, first name, last name and a username will be stored on the server. Students or others taking our tests through our system, or entering the mycareer.AI system through a third-party partner, may be required to provide additional contact information to us such as school, phone number, address as well as a transcript and/or other educational documents.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'How the Information is used'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'The information is used to enhance the visitor\'s experience when using the website to display personalized content and possibly advertising.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'E-mail addresses will not be sold, rented or leased to 3rd parties without the permission of the user. The mycareer.AI service does match students with their potential majors/departments/universities.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'By taking our tests, you are giving consent to mycareer.AI and partnered universities to view your assessment scores (if an assessment has been completed in our system). Additional consent is needed from you before those scores can be shared beyond the entities you have already given consent to when applying and/or taking the mycareer.AI assessment. Consent that you give to third-party partners (job boards, applicant tracking systems, etc.) with regards to information stored on their servers or access granted may entitle that third-party to data stored on mycareer.AI servers. The most common case is an application through external career finder sites/applications that use mycareer.AI algorithm. These external sites/applications have their own policies regarding privacy and terms of use. By agreeing to use the mycareer.AI Service through one of these third-parties, you also agree to allow said third-party access to your mycareer.AI data.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'E-mail may be sent to inform you of news of our services or offers by us or our affiliates as well as for support purposes.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'Visitor Options'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'If you have subscribed to one of our services, you may unsubscribe by following the instructions which are included in emails that you receive.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'You may be able to block cookies via your browser settings but this may prevent you from access to certain features of the website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'subheading'},'Cookies'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'Cookies are small digital signature files that are stored by your web browser that allow your preferences to be recorded when visiting the website. Also they may be used to track your return visits to the website.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_material_ui_Typography___default.a,{variant:'caption',component:'p'},'3rd party advertising companies may also use cookies for tracking purposes.')));}}]);return PrivacyComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_material_ui_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* styles */])(PrivacyComponent));

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schools__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_downshift__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Grid__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Button__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_ui_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_ui_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Menu__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_material_ui_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_material_ui_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_Form__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_ui_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Checkbox__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_material_ui_Checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_material_ui_Checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__action__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__universities__ = __webpack_require__(979);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/*
const universities = 
  {
    'จุฬาลงกรณ์มหาวิทยาลัย':
    {
      'คณะแพทยศาสตร์':
      {
        'หลักสูตรแพทยศาสตรบัณฑิต': 
        {
          'jobsTH': ['แพทย์', 'นักนิติวิทยาศาสตร์'],
          'jobsENG': ['Doctor', 'Forensic Scientist'],
          'image': 'หมอ',
        }
      },
      'คณะทันตแพทยศาสตร์':
      {
        'หลักสูตรทันตแพทยศาสตรบัณฑิต':
        {
          'jobsTH': ['ทันตแพทย์'],
          'jobsENG': ['Dentist'],
          'image': 'หมอฟัน',
        } 
      }
    }
  }
*/function renderInput(inputProps){var disabled=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var InputProps=inputProps.InputProps,classes=inputProps.classes,ref=inputProps.ref,other=_objectWithoutProperties(inputProps,['InputProps','classes','ref']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_material_ui_TextField___default.a,Object.assign({disabled:disabled,style:{width:'100%'}},other,{inputRef:ref,InputProps:Object.assign({classes:{input:classes.input}},InputProps)}));}function renderUniversity(params){var university=params.university,index=params.index,itemProps=params.itemProps,highlightedIndex=params.highlightedIndex,selectedItem=params.selectedItem;var isHighlighted=highlightedIndex===index;var isSelected=selectedItem===university;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Menu__["MenuItem"],Object.assign({},itemProps,{key:university,selected:isHighlighted,component:'div',style:{fontWeight:isSelected?500:400,width:'95%'}}),university);}function getUniversities(inputValue){var count=0;return Object.keys(__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */]).filter(function(university){var keep=(!inputValue||university.toLowerCase().includes(inputValue.toLowerCase()))&&count<10;if(keep){count+=1;}return keep;});}function renderFaculty(params){var faculty=params.faculty,index=params.index,itemProps=params.itemProps,highlightedIndex=params.highlightedIndex,selectedItem=params.selectedItem;var isHighlighted=highlightedIndex===index;var isSelected=selectedItem===faculty;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Menu__["MenuItem"],Object.assign({},itemProps,{key:faculty,selected:isHighlighted,component:'div',style:{fontWeight:isSelected?500:400,width:'95%'}}),faculty);}function getFaculties(inputValue,university){var count=0;//console.log(inputValue);
return Object.keys(__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][university]).filter(function(faculty){var keep=(!inputValue||faculty.toLowerCase().includes(inputValue.toLowerCase()))&&count<10;if(keep){count+=1;}return keep;});}function renderDepartment(params){var department=params.department,index=params.index,itemProps=params.itemProps,highlightedIndex=params.highlightedIndex,selectedItem=params.selectedItem;var isHighlighted=highlightedIndex===index;var isSelected=selectedItem===department;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_material_ui_Menu__["MenuItem"],Object.assign({},itemProps,{key:department,selected:isHighlighted,component:'div',style:{fontWeight:isSelected?500:400,width:'95%'}}),department);}function getDepartments(inputValue,university,faculty){var count=0;//console.log(university, faculty);
return Object.keys(__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][university][faculty]).filter(function(department){var keep=(!inputValue||department.toLowerCase().includes(inputValue.toLowerCase()))&&count<10;if(keep){count+=1;}return keep;});}function replaceAll(str,find,replace){return str.replace(new RegExp(find,'g'),replace);}function getJobs(jobs,jobsENG,checked){if(checked.includes(-1)){checked.splice(checked.indexOf(-1),1);}var result=new Array();var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=checked[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var c=_step.value;//console.log('-------------------',jobsENG[c])
result.push({jobTH:jobs[c],jobENG:replaceAll(replaceAll(jobsENG[c],',',''),'/','')});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return result;}var SearchContainer=function(_Component){_inherits(SearchContainer,_Component);function SearchContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchContainer.__proto__||Object.getPrototypeOf(SearchContainer)).call.apply(_ref,[this].concat(args))),_this),_this.state={university:"",faculty:"",department:"",checked:new Array(),name:""},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchContainer,[{key:'handleCheck',value:function handleCheck(index){if(index===-1){if(this.state.checked.includes(index)){this.setState({checked:new Array()});}else{this.setState({checked:[-1].concat(_toConsumableArray(Array(this.state.jobs.length).keys()))});}}else{var checkState=this.state.checked.slice();//console.log('--checkedstate--',checkState)
if(checkState.includes(-1)){checkState.splice(checkState.indexOf(-1),1);}if(this.state.checked.includes(index)){checkState.splice(this.state.checked.indexOf(index),1);//this.state.checked.indexOf(index))
//console.log(checkState)
}else{checkState.push(index);}this.setState({checked:checkState});}}},{key:'componentDidMount',value:function componentDidMount(){//this.setState({university: 'มหาวิทยาลัยธุรกิจบัณฑิตย์'})
}},{key:'render',value:function render(){var _this2=this;var classes=this.props.classes;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default.a,{container:true,style:{marginTop:"0px"},className:this.props.classes.centerGrid,spacing:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_material_ui_Grid___default.a,{item:true,xs:12,md:4,className:this.props.classes.itemGrid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_material_ui_Typography_Typography___default.a,{type:'title',color:'default'},'\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E32\u0E02\u0E32\u0E27\u0E34\u0E0A\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E43\u0E08'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_downshift__["a" /* default */],{style:{width:'95%'},onChange:function onChange(selection){return _this2.setState({university:selection,faculty:'',department:''});}},function(_ref2){var getInputProps=_ref2.getInputProps,getItemProps=_ref2.getItemProps,isOpen=_ref2.isOpen,inputValue=_ref2.inputValue,selectedItem=_ref2.selectedItem,highlightedIndex=_ref2.highlightedIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,renderInput({fullWidth:true,classes:classes,InputProps:getInputProps({placeholder:'ค้นหามหาวิทยาลัย',id:'integration-downshift'})},false),isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{square:true,style:{width:'95%'}},getUniversities(inputValue).map(function(university,index){return renderUniversity({university:university,index:index,itemProps:getItemProps({item:university}),highlightedIndex:highlightedIndex,selectedItem:selectedItem});})):null);})),!this.state.university?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_downshift__["a" /* default */],{style:{width:'95%'},onChange:function onChange(selection){return _this2.setState({faculty:selection,department:''});}},function(_ref3){var getInputProps=_ref3.getInputProps,getItemProps=_ref3.getItemProps,isOpen=_ref3.isOpen,inputValue=_ref3.inputValue,selectedItem=_ref3.selectedItem,highlightedIndex=_ref3.highlightedIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,renderInput({fullWidth:true,classes:classes,InputProps:getInputProps({placeholder:'\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E04\u0E13\u0E30\u0E43\u0E19 '+_this2.state.university,id:'integration-downshift'})}),isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{square:true,style:{width:'95%'}},getFaculties(inputValue,_this2.state.university).map(function(faculty,index){return renderFaculty({faculty:faculty,index:index,itemProps:getItemProps({item:faculty}),highlightedIndex:highlightedIndex,selectedItem:selectedItem});})):null);})),!this.state.university||!this.state.faculty?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_downshift__["a" /* default */],{style:{width:'95%'},onChange:function onChange(selection){_this2.setState({department:selection,jobs:__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][_this2.state.university][_this2.state.faculty][selection]['jobsTH'],jobsENG:__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][_this2.state.university][_this2.state.faculty][selection]['jobsENG'],image:__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][_this2.state.university][_this2.state.faculty][selection]['image'],name:__WEBPACK_IMPORTED_MODULE_18__universities__["a" /* universities */][_this2.state.university][_this2.state.faculty][selection]['name']});//console.log(universities[this.state.university][this.state.faculty][selection])
}},function(_ref4){var getInputProps=_ref4.getInputProps,getItemProps=_ref4.getItemProps,isOpen=_ref4.isOpen,inputValue=_ref4.inputValue,selectedItem=_ref4.selectedItem,highlightedIndex=_ref4.highlightedIndex;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,renderInput({fullWidth:true,classes:classes,InputProps:getInputProps({placeholder:'\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E32\u0E02\u0E32\u0E27\u0E34\u0E0A\u0E32\u0E43\u0E19 '+_this2.state.faculty,id:'integration-downshift'})}),isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_material_ui_Paper___default.a,{square:true,style:{width:'95%'}},getDepartments(inputValue,_this2.state.university,_this2.state.faculty).map(function(department,index){return renderDepartment({department:department,index:index,itemProps:getItemProps({item:department}),highlightedIndex:highlightedIndex,selectedItem:selectedItem});})):null);})),!this.state.university||!this.state.faculty||!this.state.department||!this.state.jobs?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControl"],{fullWidth:true,style:{width:'95%'},className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormHelperText"],null,'\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2D\u0E32\u0E0A\u0E35\u0E1E\u0E17\u0E35\u0E48\u0E2A\u0E19\u0E43\u0E08 \u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormGroup"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControlLabel"],{key:-1,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Checkbox___default.a,{key:-1,value:String(-1),onChange:function onChange(){return _this2.handleCheck(-1);},checked:this.state.checked.includes(-1)//checked={String(this.state.checked.includes(index))}
}),label:'\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14/\u0E44\u0E21\u0E48\u0E41\u0E19\u0E48\u0E43\u0E08/\u0E2D\u0E37\u0E48\u0E19\u0E46'}),this.state.jobs.map(function(job,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControlLabel"],{key:index,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_material_ui_Checkbox___default.a,_defineProperty({key:index,checked:true,value:String(index),onChange:function onChange(){return _this2.handleCheck(index);}},'checked',_this2.state.checked.includes(index))),label:job});}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_material_ui_Form__["FormControl"],{fullWidth:true,className:this.props.classes.formControl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_material_ui_Button___default.a,{disabled:!this.state.university||!this.state.faculty||!this.state.department||this.state.checked.length===0//|| !this.state.school
,variant:'raised',size:'large',color:'secondary',className:this.props.classes.fullButton,onClick:function onClick(){return _this2.props.dispatch(Object(__WEBPACK_IMPORTED_MODULE_17__action__["a" /* jobSearchAdd */])(_this2.state.university,_this2.state.faculty,_this2.state.department,getJobs(_this2.state.jobs,_this2.state.jobsENG,_this2.state.checked),_this2.state.image,_this2.props.profile.jobs,_this2.state.name));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'120%'}},'\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25'))))));}}]);return SearchContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_redux__["d" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux_firebase__["firebaseConnect"])(),__WEBPACK_IMPORTED_MODULE_2_material_ui_styles_withTheme___default()(),__WEBPACK_IMPORTED_MODULE_3_material_ui_styles_withStyles___default()(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* styles */]),Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function(_ref5){var profile=_ref5.firebase.profile;return{profile:profile};}))(SearchContainer));

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return universities; });
var universities={"มหาวิทยาลัยสงขลานครินทร์ (วิทยาเขตหาดใหญ่)":{"คณะการแพทย์แผนไทย":{"สาขาวิชาการแพทย์แผนไทย":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"แพทย์แผนไทย"}},"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"},"สาขากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต สาขาวิชาเภสัชศาสตร์":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"},"เภสัชศาสตรบัณฑิต สาขาวิชาการบริบาลทางเภสิชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะเทคนิคการแพทย์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"วิทยาลัยนานาชาติ":{"สาขาวิชาดิจิทัลมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"ดิจิทัลมีเดีย"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเหมืองแร่":{"jobsTH":["วิศวกรเหมืองแร่"],"jobsENG":["Mining and Geological Engineers"],"image":"วิศวกรเหมืองแร่","name":"วิศวะ เหมืองแร่"},"สาขาวิชาวิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ วัสดุ"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์ (นักศึกษาพิเศษ)":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์ (เรียนที่วิทยาเขตภูเก็ต)":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"}},"คณะวิทยาการการจัดการ":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาระบบสารสนเทศ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการบริหารทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"สาขาวิชาการจัดการ (หลักสูตรภาษาอังกฤษ)":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"},"สาขาวิชาการจัดประชุมนิทรรศการและการท่องเที่ยวเพื่อเป็นรางวัล":{"jobsTH":["ผู้วางแผนการประชุมนิทรรศการ","พนักงานในโรงแรม","ผู้จัดการด้านการจัดเตรียมอาหาร"],"jobsENG":["Meeting, Convention, and Event Planners","Hotel, Motel, and Resort Desk Clerks","Food Service Managers"],"image":"ผู้จัดการประชุม","name":"จัดประชุมนิทรรศการ"},"สาขาวิชารัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาและภาษาไทยประยุกต์":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาและภาษาไทยประยุกต์"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาชุมชนศึกษา":{"jobsTH":["ผู้นำชุมชน","นักบริการชุมชน"],"jobsENG":["Property, Real Estate, and Community Association Managers","Social and Community Service Managers"],"image":"นักพัฒนาชนบท","name":"ชุมชนศึกษา"}},"คณะวิทยาศาสตร์":{"สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูสอนวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"นักวิทยาศาสตร์ทั่วไป","name":"วิทยาศาสตร์ทั่วไป"}},"คณะทรัพยากรธรรมชาติ":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตวศาสตร์"},"สาขาวิชาวาริชศาสตร์":{"jobsTH":["นักวิจัยน้ำ","นักอนุรักษ์ทรัพยากรน้ำ"],"jobsENG":["Water Resource Specialists","Soil and Water Conservationists"],"image":"นักวิจัยน้ำ","name":"วาริชศาสตร์"},"สาขาวิชาทรัพยากรธรรมชาติ":{"jobsTH":["นักชีววิทยาสัตว์ป่า","นักป่าไม้","นักอนุรักษ์","ผู้ดูแลอุทยาน","นักนิเวศวิทยาอุตสาหกรรม"],"jobsENG":["Zoologists and Wildlife Biologists","Foresters","Soil and Water Conservationists","Park Naturalists","Industrial Ecologists"],"image":"นักอนุรักษ์","name":"ทรัพยากรธรรมชาติ"}},"คณะอุตสาหกรรมการเกษตร":{"สาขาวิชาอุตสาหกรรมการเกษตร":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"คนขายอุปกรณ์การเกษตร","name":"อุตสาหกรรมการเกษตร"}}},"จุฬาลงกรณ์มหาวิทยาลัย":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต สาขาเภสัชศาสตร์":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"},"เภสัชศาสตรบัณฑิต สาขาการบริบาลทางเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะสหเวชศาสตร์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชาโภชนาการและการกำหนดอาหาร":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"โภชนาการกำหนดอาหาร"}},"คณะวิทยาศาสตร์การกีฬา":{"วิทยาศาสตร์การกีฬาและการออกกำลังกาย":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยา การกีฬา"}},"คณะสัตวแพทย์":{"สัตวแพทยศาสตรบัณฑิต":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะรัฐศาสตร์":{"สาขาวิชาการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"รัฐศาสตร์การปกครอง"},"สาขาวิชาความสัมพันธ์ระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"สาขาวิชาสังคมวิทยาและมานุษยวิทยา":{"jobsTH":["อาจารย์ด้านสังคมวิทยา","อาจารย์ด้านมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Sociology Teachers","Anthropology and Archeology Teachers","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"},"สาขาวิชารัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"}},"คณะนิเทศศาสตร์":{"สาขาวิชาวารสารสนเทศ":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"วารสารสนเทศ"},"สาขาวิชาการกระจายเสียง":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"การกระจายเสียง"},"สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"สาขาวิชาการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"สาขาวิชาวาทวิทยา":{"jobsTH":["ผู้ประกาศข่าวหรือพิธีกร","ฝ่ายงานพัฒนาทรัพยากรมนุษย์","ผู้ประสานงานความร่วมมือ"],"jobsENG":["Radio and TV Announcers","Training and Development Specialists","Public Relations Specialists"],"image":"นักพูด","name":"วาทวิทยา"},"สาขาวิชาสื่อสารการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"สื่อสารการแสดง"},"สาขาวิชาการภาพยนตร์และภาพนิ่ง":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์","ช่างภาพ"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors","Photographers"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์และภาพนิ่ง"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมเรือ":{"jobsTH":["วิศวกรเรือ"],"jobsENG":["Marine Engineers"],"image":"วิศวกรเรือ","name":"วิศวะ เรือ"},"สาขาวิชาวิศวกรรมยานยนต์":{"jobsTH":["วิศวกรยานยนต์"],"jobsENG":["Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมทรัพยากรธรณี":{"jobsTH":["วิศวกรทรัพยากรธรณี"],"jobsENG":["Mining and Geological Engineers"],"image":"วิศวกรทรัพยากรธรณี","name":"วิศวะ ทรัพยากรธรณี"},"สาขาวิชาวิศวกรรมปิโตรเลียม":{"jobsTH":["วิศวกรปิโตรเลียม"],"jobsENG":["Petroleum Engineers"],"image":"วิศวกรปิโตรเลียม (ในแท่นขุดเจาะ)","name":"วิศวะ ปิโตรเลียม"},"สาขาวิชาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิชาวิศวกรรมสำรวจ":{"jobsTH":["วิศวกรสำรวจ"],"jobsENG":["Cartographers and Photogrammetrists"],"image":"วิศวกรสำรวจ","name":"วิศวะ สำรวจ"},"สาขาวิชาวิศวกรรมโลหการและวัสดุ":{"jobsTH":["วิศวกรโลหการและวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ โลหการและวัสดุ"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"}},"คณะสถาปัตยกรรมศาสตร์":{"สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาสถาปัตยกรรมภายใน":{"jobsTH":["สถาปนิกภายใน"],"jobsENG":["Architects, Except Landscape and Naval","Interior Designers"],"image":"นักออกแบบภายใน","name":"สถาปัตย์ ภายใน"},"สาขาวิชาสถาปัตยกรรมไทย":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก (บ้านเรือนไทย)","name":"สถาปัตย์ไทย"},"สาขาวิชาสถาปัตยกรรมผังเมือง":{"jobsTH":["นักวางผังเมือง"],"jobsENG":["Urban and Regional Planners"],"image":"นักวางผังเมือง","name":"สถาปัตย์ ผังเมือง"},"สาขาวิชาภูมิสถาปัตยกรรม":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"},"สาขาวิชาการออกแบบอุตสาหกรรม":{"jobsTH":["นักออกแบบอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบอุตสาหกรรม","name":"การออกแบบอุตสาหกรรม"}},"คณะพาณิชยศาสตร์และการบัญชี":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาการจัดการเพื่อเป็นผู้ประกอบการธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการจัดการโลจิสติกส์ระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"},"สาขาวิชาระบบสารสนเทศทางการจัดการ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"สาขาวิชาการธนาคารและการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาสถิติประยุกต์":{"jobsTH":["นักสถิติประยุกต์"],"jobsENG":["Statisticians"],"image":"นักสถิติ","name":"สถิติประยุกต์"},"สาขาวิชาสถิติคณิตศาสตร์":{"jobsTH":["นักสถิติ","นักคณิตศาสตร์","นักวิทยาศาสตร์ข้อมูล"],"jobsENG":["Statisticians","Mathematicians","Mathematicians"],"image":"นักสถิติ","name":"สถิติคณิตศาสตร์"},"สาขาวิชาการประกันภัย":{"jobsTH":["นักคณิตศาสตร์ประกันภัย"],"jobsENG":["Actuaries"],"image":"นักคณิตศาสตร์ประกันภัย","name":"การประกันภัย"},"สาขาวิชาเทคโนโลยีสารสนเทศเพื่อธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักวิเคราะห์ข้อมูลดิจิทัล","name":"เทคโนโลยีสารสนเทศเพื่อธุรกิจ"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะอักษรศาสตร์":{"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาวิชาภาษาสเปน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาสเปน"},"สาขาวิชาภาษาอิตาเลียน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอิตาเลียน"},"สาขาวิชาภาษาบาลีและสันสกฤต":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาบาลีและสันสกฤต"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษารัสเซีย":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษารัสเซีย"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาวิชาภูมิศาสตร์และภูมิสารสนเทศ":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์และภูมิสารสนเทศ"},"สาขาวิชาศิลปการละคร":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปการละคร"},"สาขาวิชาสารนิเทศศึกษา":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารนิเทศศึกษา"},"สาขาวิชาปรัชญา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญา"}},"คณะจิตวิทยา":{"สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"}},"คณะครุศาสตร์":{"สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"สาขาวิชาประถมศึกษา":{"jobsTH":["ครูประถม"],"jobsENG":["Elementary School Teachers"],"image":"ครูประถม","name":"ประถมศึกษา"},"สาขาวิชามัธยมศึกษา (วิทยาศาสตร์)":{"jobsTH":["ครูมัธยม"],"jobsENG":["Secondary School Teachers"],"image":"ครูมัธยม","name":"มัธยมศึกษา (วิทยาศาสตร์)"},"สาขาวิชามัธยมศึกษา (มนุษยศาสตร์และสังคมศาสตร์)":{"jobsTH":["ครูมัธยม"],"jobsENG":["Secondary School Teachers"],"image":"ครูมัธยม","name":"มัธยมศึกษา (มนุษยศาสตร์และสังคมศาสตร์)"},"สาขาสุขศึกษาและพลศึกษา":{"jobsTH":["ครูพลศึกษา","ครูสุขศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors","Health Educators"],"image":"ครูสอนสุขศึกษา","name":"สุขศึกษาและพลศึกษา"},"สาขาวิชาเทคโนโลยีการศึกษา":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"เทคโนโลยีการศึกษา"},"สาขาศิลปศึกษา":{"jobsTH":["ครูสอนศิลปะ"],"jobsENG":["Art, Drama, and Music Teachers"],"image":"ครูสอนศิลปะ","name":"ศิลปศึกษา"},"สาขาดนตรีศึกษา":{"jobsTH":["ครูสอนดนตรี","นักดนตรี"],"jobsENG":["Art, Drama, and Music Teachers","Musicians (Instrumental)"],"image":"นักดนตรี","name":"ดนตรีศึกษา"},"สาขาวิชาการศึกษานอกระบบโรงเรียน":{"jobsTH":["ครู"],"jobsENG":["School Teachers"],"image":"ครู","name":"การศึกษานอกระบบโรงเรียน"},"สาขาวิชาธุรกิจศึกษา":{"jobsTH":["ครูสอนด้านธุรกิจ"],"jobsENG":["Business Teachers"],"image":"ครูสอนธุรกิจ","name":"ธุรกิจศึกษา"},"สาขาวิชาจิตวิทยาการปรึกษา การแนะแนวและการศึกษาพิเศษ":{"jobsTH":["ครูแนะแนว"],"jobsENG":["Educational, Guidance, School, and Vocational Counselors"],"image":"ครูแนะแนว","name":"จิตวิทยาการปรึกษา การแนะแนวและการศึกษาพิเศษ"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาสัตววิทยา":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิทยาศาสตร์ (ดูสัตว์)","name":"สัตววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาพฤกษศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พฤกษศาสตร์"},"สาขาวิชาพันธุศาสตร์":{"jobsTH":["นักพันธุศาสตร์","ที่ปรึกษาด้านพันธุกรรม"],"jobsENG":["Geneticists","Genetic Counselors"],"image":"นักวิทยาศาสตร์ gregor mendel","name":"พันธุศาสตร์"},"สาขาวิชาเคมีวิศวกรรม":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"นักวิทยาศาสตร์ใส่แว่นมีหลอดทดลอง + เครื่องจักร","name":"เคมีวิศวกรรม"},"สาขาวิชาธรณีวิทยา":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักธรณีวิทยา","name":"ธรณีวิทยา"},"สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูสอนวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"นักวิทยาศาสตร์เสื้อกาวน์สีขาว","name":"วิทยาศาสตร์ทั่วไป"},"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์ มีรูปโลก","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาวิชาวิทยาศาสตร์ทางทะเล":{"jobsTH":["นักวิทยาศาสตร์ทางทะเล","นักเพาะเลี้ยงสัตว์น้ำ","ชาวประมง"],"jobsENG":["Water Resource Specialists","Farm and Ranch Managers","Fishers and Related Fishing Workers"],"image":"นักวิทยาศาสตร์ทางทะเล","name":"วิทยาศาสตร์ทางทะเล"},"สาขาวิชาชีวเคมี":{"jobsTH":["นักชีวเคมี"],"jobsENG":["Biochemists and Biophysicists"],"image":"นักวิทยาศาสตร์ชีวเคมี","name":"ชีวเคมี"},"สาขาวิชาวัสดุศาสตร์":{"jobsTH":["นักวิจัยและพัฒนา","ผู้ควบคุมคุณภาพการผลิต","นักวัสดุศาสตร์"],"jobsENG":["Research and Development Scientists","Quality Control Analysts","Materials Scientists"],"image":"นักวัสดุศาสตร์","name":"วัสดุศาสตร์"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาเทคโนโลยีทางภาพและการพิมพ์":{"jobsTH":["ช่างภาพ","นักออกแบบฟราฟิก","นักสร้างสรรค์สื่อมัลติมีเดีย","นักเทคโนโลยีกระบวนภาพและการพิมพ์"],"jobsENG":["Photographers","Graphic Designers","Multimedia Artists and Animators","Photographic Process Workers and Processing Machine Operators"],"image":"นักเทคโนโลยีการพิมพ์","name":"เทคโนโลยีทางภาพและการพิมพ์"},"สาขาวิชาเทคโนโลยีทางอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีทางอาหาร"}}},"มหาวิทยาลัยธรรมศาสตร์":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะแพทย์ศาสตร์":{"การแพทย์แผนไทยประยุกต์บัณฑิต":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"แพทย์แผนไทย"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต สาขาวิทยาศาสตร์เภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"},"เภสัชศาสตรบัณฑิต สาขาบริบาลทางเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะสหเวชศาสตร์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยา การกีฬา"}},"คณะสาธารณสุขศาสตร์":{"วิชาเอกอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"วิชาเอกอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"วิชาเอกการสร้างเสริมสุขภาพ":{"jobsTH":["เจ้าหน้าที่ส่งเสริมสุขภาพ","ผู้ให้คำปรึกษาด้านสุขภาพ"],"jobsENG":["Community Health Workers","Health Educators"],"image":"นักสร้างเสริมสุขภาพ","name":"สร้างเสริมสุขภาพ"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะรัฐศาสตร์":{"สาขาวิชาการเมืองการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองการปกครอง"},"สาขาวิชาบริหารรัฐกิจ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"บริหารรัฐกิจ"},"สาขาวิชาการระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"}},"คณะวารสารศาสตร์และสื่อสารมวลชน":{"สาขาวิชาหนังสือพิมพ์และสิ่งพิมพ์":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"หนังสือพิมพ์และสิ่งพิมพ์"},"สาขาวิชาวิทยุและโทรทัศน์":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"วิทยุโทรทัศน์"},"สาขาวิชาโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"สาขาวิชาประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"สาขาวิชาภาพยนตร์และภาพถ่าย":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์","ช่างภาพ"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors","Photographers"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์และภาพนิ่ง"},"สาขาวิชาบริหารการสื่อสาร":{"jobsTH":["นักประชาสัมพันธ์","ผู้ประกาศข่าว","นักวิเคราะห์ข่าว","ผู้จัดการด้านประชาสัมพันธ์"],"jobsENG":["Public Relations Specialists","Radio and Television Announcers","Broadcast News Analysts","Public Relations Managers"],"image":"ฝ่ายสื่อสารองค์กร","name":"บริหารการสื่อสาร"}},"คณะศิลปกรรมศาสตร์":{"สาขาวิชาการละคอน":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้จัดละคร"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"การละคอน"},"สาขาวิชาศิลปะการออกแบบพัสตราภรณ์":{"jobsTH":["นักออกแบบแฟชั่น","ช่างตัดเย็บ","ช่างแต่งหน้าทำผม"],"jobsENG":["Fashion Designers","Tailors, Dressmakers, and Custom Sewers","Hairdressers, Hairstylists, and Cosmetologists"],"image":"นักออกแบบแฟชัน","name":"ศิลปะการออกแบบพัสตราภรณ์"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมไฟฟ้า (ภาคไทย, TEP, TEPE)":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมอุตสาหการ (ภาคไทย, TEP)":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมโยธา (ภาคไทย, TEP, TEPE)":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมเคมี (ภาคไทย, TEP, TEPE)":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล (ภาคไทย, TEP, TEPE)":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์(ภาคไทย)":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมอุตสาหกรรม (TEPE)":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหกรรม"},"สาขาวิชาวิศวกรรมยานยนต์ (TEPE)":{"jobsTH":["วิศวกรยานยนต์"],"jobsENG":["Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"}},"สถาบันเทคโนโลยีนานาชาติสิรินธร":{"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และการสื่อสาร":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์และการสื่อสาร"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาเทคโนโลยีการจัดการ":{"jobsTH":["นักเทคโนโลยีการจัดการ","นักวิเคราะห์โลจิสติกส์"],"jobsENG":["Computer Systems Analysts","Logistics Analysts"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีการจัดการ"},"สาขาวิชาการจัดการวิศวกรรม":{"jobsTH":["ผู้บริหารงานวิศวกรรม"],"jobsENG":["Architectural and Engineering Managers"],"image":"นักบริหารงานวิศวกรรม","name":"การจัดการวิศวกรรม"}},"คณะสถาปัตยกรรมศาสตร์และการผังเมือง":{"สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรสถาปัตยกรรมภายในบัณฑิต":{"jobsTH":["สถาปนิกภายใน"],"jobsENG":["Architects, Except Landscape and Naval","Interior Designers"],"image":"นักออกแบบภายใน","name":"สถาปัตย์ ภายใน"},"หลักสูตรการผังเมืองบัณฑิต":{"jobsTH":["นักวางผังเมือง"],"jobsENG":["Urban and Regional Planners"],"image":"นักวางผังเมือง","name":"การผังเมือง"},"หลักสูตรภูมิสถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"},"สาขาวิชาสถาปัตยกรรม เพื่อการพัฒนาอสังหาริมทรัพย์":{"jobsTH":["ผู้รับผิดชอบโครงการอสังหาริมทรัพย์"],"jobsENG":["Property, Real Estate, and Community Association Managers"],"image":"สถาปนิกอสังหาฯ","name":"วิทยาฯ สถาปัตย์เพื่อพัฒนาอสังหาฯ"},"หลักสูตรการออกแบบพัฒนาชุมชนเมือง (หลักสูตรนานาชาติ)":{"jobsTH":["นักวางผังเมือง","เจ้าหน้าที่บริการสังคม"],"jobsENG":["Urban and Regional Planners","Social and Community Service Managers"],"image":"นักวางผังเมือง","name":"ออกแบบพัฒนาชุมชนเมือง"}},"คณะพาณิชยศาสตร์และการบัญชี":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการบริหารทรัพยากรมนุษย์และองค์การ":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"สาขาวิชาบริหารการปฏิบัติการ":{"jobsTH":["ผู้จัดการทั่วไป"],"jobsENG":["General and Operations Managers"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"บริหารการปฏิบัติการ"},"สาขาวิชาบริหารธุรกิจระหว่างประเทศโลจิสติกส์และการขนส่ง":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"},"สาขาวิชาระบบสารสนเทศเพื่อการจัดการ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"สาขาวิชาธุรกิจอสังหาริมทรัพย์":{"jobsTH":["นายหน้า","ตัวแทนขายอสังหาริมทรัพย์","นักประเมินราคา","ผู้จัดการโครงการ"],"jobsENG":["Real Estate Brokers","Real Estate Sales Agents","Appraisers, Real Estate","Property, Real Estate, and Community Association Managers"],"image":"นายหน้าขายที่ดิน","name":"ธุรกิจอสังหาริมทรัพย์"},"หลักสูตรควบบัญชีบัณฑิต และ บัญชีมหาบัณฑิต":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"หลักสูตรควบบริหารธุรกิจบัณฑิต":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศิลปศาสตร์":{"สาขาวิชาบรรณารักษศาสตร์และสารสนเทศศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"บรรณารักษ์ศาสตร์"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาวิชาภาษาศาสตร์":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาศาสตร์"},"สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"สาขาวิชาภาษาและวรรณคดีอังกฤษ":{"jobsTH":["นักเขียน","ครูสอนภาษาต่างประเทศ","ล่าม/นักแปล"],"jobsENG":["Poets, Lyricists and Creative Writers","Foreign Language and Literature Teachers, Postsecondary","Interpreters and Translators"],"image":"นักเขียน","name":"ภาษาและวรรณคดีอังกฤษ"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาปรัชญา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญา"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"สาขาวิชาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาวิชาภาษารัสเซีย":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษารัสเซีย"}},"คณะสังคมวิทยาและมานุษยวิทยา":{"สาขาวิชาสังคมวิทยาและมานุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Anthropologists","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"}},"คณะสังคมสงเคราะห์ศาสตร์":{"สาขาวิชาสังคมสงเคราะห์":{"jobsTH":["นักสังคมสงเคราะห์"],"jobsENG":["Child, Family, and School Social Workers"],"image":"นักสังคมสงเคราะห์","name":"สังคมสงเคราะห์"}},"คณะวิทยาศาสตร์และเทคโนโลยี":{"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีเพื่อการพัฒนายั่งยืน":{"jobsTH":["นักภูมิสารสนเทศ","บุคลากรสนับสนุนด้านผังเมือง"],"jobsENG":["Geographic Information Systems Technicians","City and Regional Planning Aides"],"image":"นักพัฒนาชนบท","name":"เทคโนโลยีเพื่อการพัฒนายั่งยืน"},"สาขาวิชาเทคโนโลยีการเกษตร":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เทคโนโลยีการเกษตร"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาฟิสิกส์อิเล็กทรอนิกส์":{"jobsTH":["นักฟิสิกส์"],"jobsENG":["Physicists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์อิเล็กทรอนิกส์"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีสิ่งทอ":{"jobsTH":["นักวิทยาศาสตร์และเทคโนโลยีสิ่งทอ"],"jobsENG":["Materials Scientists"],"image":"นักวิทยาศาสตร์สิ่งทอ","name":"วิทยาศาสตร์และเทคโนโลยีสิ่งทอ"},"สาขาวิชาวัสดุศาสตร์":{"jobsTH":["นักวิจัยและพัฒนา","ผู้ควบคุมคุณภาพการผลิต","นักวัสดุศาสตร์"],"jobsENG":["Research and Development Scientists","Quality Control Analysts","Materials Scientists"],"image":"นักวัสดุศาสตร์","name":"วัสดุศาสตร์"}}},"มหาวิทยาลัยเชียงใหม่":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต แผนวิทยาศาสตร์เภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"},"เภสัชศาสตรบัณฑิต แผนบริบาลเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะเทคนิคการแพทย์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขารังสีเทคนิค":{"jobsTH":["นักรังสีรักษา","นักรังสีเทคนิค","นักเวชศาสตร์นิวเคลียร์"],"jobsENG":["Radiation Therapists","Radiologic Technicians","Nuclear Medicine Technologists"],"image":"นักรังสีเทคนิค","name":"รังสีเทคนิค"},"สาขากิจกรรมบำบัด":{"jobsTH":["นักกิจกรรมบำบัด"],"jobsENG":["Recreational Therapists"],"image":"นักกายภาพบำบัด","name":"กิจกรรมบำบัด"},"สาขากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะสัตวแพทย์":{"สัตวแพทยศาสตรบัณฑิต":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะรัฐศาสตร์และรัฐประศาสนศาสตร์":{"สาขาวิชาการเมืองและการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองและการปกครอง"},"สาขาวิชาการระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"รัฐประศาสนศาสตรบัณฑิต ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"}},"คณะการสื่อสารมวลชน":{"สาขาวิทยุกระจายเสียงและวิทยุโทรทัศน์":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"วิทยุโทรทัศน์"},"สาขาการหนังสือพิมพ์และสื่อสิ่งพิมพ์":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"หนังสือพิมพ์และสิ่งพิมพ์"},"สาขาการประชาสัมพันธ์และการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร","ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers","Public Relations Specialists","Public Relations Managers"],"image":"คนโฆษณาสินค้า","name":"ประชาสัมพันธ์และโฆษณา"},"สาขาสื่อสารการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"สื่อสารการแสดง"},"สาขาสื่อใหม่":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักออกแบบ Graphic","name":"สื่อใหม่"}},"คณะวิจิตรศิลป์":{"สาขาวิชาศิลปะไทย":{"jobsTH":["ภัณฑารักษ์","นักออกแบบ","ช่างศิลป์ไทย"],"jobsENG":["Curators","Commercial and Industrial Designers","Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"ช่างศิลป์ไทย","name":"ศิลปะไทย"},"สาขาวิชาจิตรกรรม":{"jobsTH":["จิตรกร"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"จิตรกร","name":"จิตรกรรม"},"สาขาวิชาศิลปะภาพพิมพ์":{"jobsTH":["ศิลปินภาพพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"นักศิลปะการพิมพ์","name":"ศิลปะภาพพิมพ์"},"สาขาวิชาประติมากรรม":{"jobsTH":["ช่างประติมากรรม"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"ช่างปั้น","name":"ประติมากรรม"},"สาขาวิชาการออกแบบ":{"jobsTH":["นักออกแบบผลิตภัณฑ์","นักออกแบบแฟชัน","นักออกแบบกราฟิก"],"jobsENG":["Commercial and Industrial Designers","Fashion Designers","Graphic Designers"],"image":"นักออกแบบ","name":"การออกแบบ"},"สาขาวิชาศิลปะการถ่ายภาพ":{"jobsTH":["ช่างภาพ","ช่างอุปกรณ์ภาพถ่าย"],"jobsENG":["Photographers","Camera and Photographic Equipment Repairers"],"image":"ช่างภาพ","name":"ศิลปะการถ่ายภาพ"},"สาขาวิชาสื่อศิลปะและการออกแบบสื่อ":{"jobsTH":["นักออกแบบกราฟิก","นักออกแบบสื่อมัลติมีเดียแอนิเมชัน"],"jobsENG":["Graphic Designers","Multimedia Artists and Animators"],"image":"นักออกแบบ Graphic","name":"สื่อศิลปะและการออกแบบสื่อ"},"สาขาวิชาสหศาสตร์ศิลป์":{"jobsTH":["ศิลปิน"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"ศิลปิน","name":"สหศาสตร์ศิลป์"}},"วิทยาลัยศิลปะ สื่อ และเทคโนโลยี":{"สาขาวิชาวิศวกรรมซอฟต์แวร์ (หลักสูตรนานาชาติ)":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวกรรมซอฟต์แวร์"},"สาขาวิชาแอนนิเมชัน":{"jobsTH":["นักสร้างสรรค์แอนิเมชัน"],"jobsENG":["Multimedia Artists and Animators"],"image":"นักออกแบบ Graphic","name":"แอนนิเมชัน"},"สาขาวิชาการจัดการสมัยใหม่และเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"การจัดการสมัยใหม่และเทคโนโลยีสารสนเทศ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิศวกรรมเหมืองแร่":{"jobsTH":["วิศวกรเหมืองแร่"],"jobsENG":["Mining and Geological Engineers"],"image":"วิศวกรเหมืองแร่","name":"วิศวะ เหมืองแร่"},"สาขาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิศวกรรมเกษตร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ เกษตร"},"สาขาวิศวกรรมเครื่องกล (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิศวกรรมระบบสารสนเทศและเครือข่าย (หลักสูตรสองภาษา)":{"jobsTH":["วิศวกรสารสนเทศและเครือข่าย"],"jobsENG":["Computer Engineers"],"image":"วิศวกร IT","name":"วิศวะ สารสนเทศและเครือข่าย"}},"คณะสถาปัตยกรรมศาสตร์":{"หลักสูตรวิทยาศาสตรบัณฑิต (สถาปัตยกรรม)":{"jobsTH":["ผู้ปฏิบัติงานด้านสถาปัตย์"],"jobsENG":["Architectural Drafters"],"image":"นักออกแบบสถาปัตยกรรม","name":"วิทยาฯ สถาปัตย์"},"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรภูมิสถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาบริหารธุรกิจ (แผนการเงินและการธนาคาร แผนการจัดการ แผนการตลาด)":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงินและธนาคาร"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะมนุษยศาสตร์":{"สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"สาขาวิชาสารสนเทศศึกษา":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศึกษา"},"สาขาบ้านและชุมชน":{"jobsTH":["นักโภชนาการ","นักออกแบบ","นักพัฒนาชุมชน"],"jobsENG":["Dietitians and Nutritionists","Floral Designers","Social and Community Service Managers"],"image":"นักพัฒนาชนบท","name":"บ้านและชุมชน"},"สาขาปรัชญา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญา"},"สาขาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาไทย"},"สาขาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาการท่องเที่ยวและการโรงแรม":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การท่องเที่ยวและการโรงแรม"}},"คณะสังคมศาสตร์":{"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"สาขาวิชาสังคมวิทยาและมานุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Anthropologists","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"},"สาขาวิชาภูมิสารสนเทศศาสตร์ (หลักสูตรนานาชาติ)":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศศาสตร์"},"สาขาวิชาไทยศึกษา":{"jobsTH":["นักประวัติศาสตร์","นักเขียน"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers"],"image":"ผู้เชี่ยวชาญวัฒนธรรมไทย","name":"ไทยศึกษา"},"สาขาวิชาสังคมศาสตร์ (หลักสูตรนานาชาติ)":{"jobsTH":["นักสังคมศาสตร์"],"jobsENG":["Sociologists"],"image":"นักสังคมศาสตร์","name":"สังคมศาสตร์"}},"คณะศึกษาศาสตร์":{"สาขาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูสอนภาษาไทย","name":"ศึกษา ภาษาไทย"},"สาขาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"},"สาขาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["School Teachers"],"image":"ครูสอนสังคมศึกษา","name":"ศึกษา สังคมศึกษา"},"สาขาเคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา เคมี"},"สาขาฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ฟิสิกส์"},"สาขาชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ชีววิทยา"},"สาขาธุรกิจศึกษา":{"jobsTH":["ครูสอนด้านธุรกิจ"],"jobsENG":["Business Teachers"],"image":"ครูสอนธุรกิจ","name":"ศึกษา ธุรกิจศึกษา"},"สาขาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"สาขาประถมศึกษา":{"jobsTH":["ครูประถม"],"jobsENG":["Elementary School Teachers"],"image":"ครูประถม","name":"ศึกษา ประถมศึกษา"},"สาขาการศึกษาปฐมวัยและการศึกษาพิเศษ":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"ศึกษา การศึกษาปฐมวัยและการศึกษาพิเศษ"},"สาขาศิลปศึกษา":{"jobsTH":["ครูสอนศิลปะ"],"jobsENG":["Art, Drama, and Music Teachers"],"image":"ครูสอนศิลปะ","name":"ศึกษา ศิลปศึกษา"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเคมี เคมีอุตสาหกรรม ชีวเคมี และชีวเคมีเทคโนโลยี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาธรณีวิทยาและอัญมณีวิทยา":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักอัญมณีวิทยา","name":"ธรณีวิทยาและอัญมณีวิทยา"},"สาขาวิชาคณิตศาสตร์และสถิติ":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์และสถิติ"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"}},"คณะเกษตรศาสตร์":{"สาขาวิชาเศรษฐศาสตร์เกษตร":{"jobsTH":["นักเศรษฐศาสตร์การเกษตร"],"jobsENG":["Environmental Economists"],"image":"คนขายอุปกรณ์การเกษตร","name":"เศรษฐศาสตร์การเกษตร"},"สาขาวิชากีฏวิทยา ":{"jobsTH":["นักกีฏวิทยา"],"jobsENG":["Animal Scientists"],"image":"นักวิจัยแมลง","name":"กีฏวิทยา"},"สาขาโรคพืช":{"jobsTH":["นักวิจัยโรคพืช"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิจัยโรคพืช","name":"โรชพืช"},"สาขาพืชไร่":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชไร่","name":"พืชไร่"},"สาขาพืชสวน":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"พืชสวน"},"สาขาปฐพีศาสตร์":{"jobsTH":["นักวิทยาศาสร์สิ่งแวดล้อม","นักวิจัยดิน","นักอนุรักษ์ทรัพยากรดิน"],"jobsENG":["Environmental Scientists and Specialists, Including Health","Soil and Plant Scientists","Soil and Water Conservationists"],"image":"นักวิจัยดิน","name":"ปฐพีศาสตร์"},"สาขาส่งเสริมและเผยแพร่การเกษตร":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"เกษตรอำเภอ","name":"ส่งเสริมและเผยแพร่การเกษตร"},"สาขาสัตวศาสตร์และสัตว์น้ำ":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์น้ำ","name":"สัตวศาสตร์และสัตว์น้ำ"}},"คณะอุตสาหกรรมการเกษตร":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาเทคโนโลยีชีวภาพทางอุตสาหกรรมเกษตร":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพทางอุตสาหกรรมเกษตร"},"สาขาวิชาวิศวกรรมกระบวนการอาหาร":{"jobsTH":["นักวิจัยพัฒนาผลิตภัณฑ์","วิศวกรฝ่ายขาย","ผู้จัดการฝ่ายผลิต"],"jobsENG":["Commercial and Industrial Designers","Sales Engineers","Industrial Production Managers"],"image":"วิศวกรผลิตอาหาร","name":"วิศวกรรมกระบวนการอาหาร"},"สาขาวิชาเทคโนโลยีการพัฒนาผลิตภัณฑ์":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาผลิตภัณฑ์ ","name":"เทคโนโลยีการพัฒนาผลิตภัณฑ์"},"สาขาวิชาเทคโนโลยีการบรรจุ":{"jobsTH":["นักพัฒนาบรรจุภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาบรรจุภัณฑ์","name":"เทคโนโลยีการบรรจุ"},"สาขาวิชาเทคโนโลยีผลิตภัณฑ์ทางทะเล":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาผลิตภัณฑ์ทางทะเล","name":"เทคโนโลยีผลิตภัณฑ์ทางทะเล"}}},"มหาวิทยาลัยศรีนครินทรวิโรฒ":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะสหเวชศาสตร์":{"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชาการส่งเสริมสุขภาพ":{"jobsTH":["เจ้าหน้าที่ส่งเสริมสุขภาพ","ผู้ให้คำปรึกษาด้านสุขภาพ"],"jobsENG":["Community Health Workers","Health Educators"],"image":"นักสร้างเสริมสุขภาพ","name":"ส่งเสริมสุขภาพ"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะพลศึกษา":{"สาขาวิชาวิทยาศาสตร์การกีฬาและการออกกำลังกาย":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา","ผู้ตัดสินกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts","Umpires and Referees"],"image":"เทรนเนอร์","name":"วิทยาฯ การกีฬา"},"สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่สาธารณสุข","name":"สาธารณสุขศาสตร์"},"สาขาวิชาผู้นำนันทนาการ":{"jobsTH":["ผู้นำนันทนาการ","ผู้เชี่ยวชาญด้านนันทนาการ"],"jobsENG":["Recreation Workers","Recreation and Fitness Studies Teachers"],"image":"ผู้นำนันทนาการ","name":"นันทนาการ"},"การศึกษาบัณฑิต สาขาวิชาพลศึกษา":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูสอนพลศึกษา","name":"การศึกษา พลศึกษา"},"การศึกษาบัณฑิต สาขาวิชาสุขศึกษา ":{"jobsTH":["ครูสุขศึกษา"],"jobsENG":["Health Educators"],"image":"ครูสอนสุขศึกษา","name":"การศึกษา สุขศึกษา"},"การศึกษาบัณฑิต สาขาวิชาสุขศึกษาและพลศึกษา":{"jobsTH":["ครูพลศึกษา","ครูสุขศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors","Health Educators"],"image":"ครูสอนสุขศึกษา","name":"การศึกษา สุขศึกษาและพลศึกษา"}},"คณะสังคมศาสตร์":{"หลักสูตรรัฐศาสตรบัณฑิต วิชาเอกการเมืองการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองการปกครอง"},"หลักสูตรรัฐศาสตรบัณฑิต วิชาเอกรัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"หลักสูตรรัฐศาสตรบัณฑิต วิชาเอกความสัมพันธ์ระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"หลักสูตรบริหารธุรกิจบัณฑิต วิชาเอกการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"หลักสูตรบริหารธุรกิจบัณฑิต วิชาเอกการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"หลักสูตรบริหารธุรกิจบัณฑิต วิชาเอกธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการท่องเที่ยวและการโรงแรม (เอกคู่)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การท่องเที่ยวและโรงแรม"},"หลักสูตรบัญชีบัณฑิต":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการพัฒนาชุมชนเมือง":{"jobsTH":["นักพัฒนาชุมชน","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชุมชน","name":"การพัฒนาชุมชน"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาภูมิศาสตร์และภูมิสารสนเทศ":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์และภูมิสารสนเทศ"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["School Teachers"],"image":"ครูสอนสังคมศึกษา","name":"ศึกษา สังคมศึกษา"}},"วิทยาลัยนวัตกรรมสื่อสารสังคม":{"สาขาวิชานวัตกรรมสื่อสารสังคม":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักสื่อสารมวลชน","name":"นวัตกรรมสื่อสารสังคม"},"สาขาวิชานวัตกรรมการสื่อสาร":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"ฝ่ายสื่อสารองค์กร","name":"นวัตกรรมการสื่อสาร"},"สาขาวิชาภาพยนตร์และสื่อดิจิทัล":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์","ช่างภาพ","นักสร้างสรรค์สื่อมัลติมีเดีย"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors","Photographers","Multimedia Artists and Animators"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์และสื่อดิจิทัล"}},"คณะศิลปกรรมศาสตร์":{"สาขาวิชาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"สาขาวิชาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปะการแสดง"},"สาขาวิชาการออกแบบทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers"],"image":"นักออกแบบ","name":"การออกแบบทัศนศิลป์"},"สาขาวิชาดุริยางคศาสตร์สากล":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"ดุริยางคศาสตร์สากล"},"สาขาวิชาดนตรีศึกษา":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง","ครูสอนดนตรี"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors","Art, Drama, and Music Teachers, Postsecondary"],"image":"ครูสอนดนตรี","name":"ดนตรีศึกษา"},"สาขาวิชาศิลปศึกษา":{"jobsTH":["ครูสอนศิลปะ"],"jobsENG":["Art, Drama, and Music Teachers, Postsecondary"],"image":"ครูสอนศิลปะ","name":"ศิลปศึกษา"},"สาขาวิชานาฏศิลป":{"jobsTH":["นาฏศิลปิน","นักแสดง"],"jobsENG":["Dancers","Actors"],"image":"ครูสอนนาฏศิลป์","name":"นาฏศิลป"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมชีวการแพทย์":{"jobsTH":["วิศวกรชีวการแพทย์"],"jobsENG":["Biomedical Engineers"],"image":"วิศวกรชีวการแพทย์","name":"วิศวะ ชีวการแพทย์"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"}},"สำนักวิชาเศรษฐศาสตร์และนโยบายสาธารณะ":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะมนุษยศาสตร์":{"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาเพื่ออาชีพ":{"jobsTH":["ล่าม/นักแปล"],"jobsENG":["Interpreters and Translators"],"image":"ฝ่ายสื่อสารองค์กร","name":"ภาษาเพื่ออาชีพ"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาปรัชญาและศาสนา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญาและศาสนา"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาวรรณกรรมสำหรับเด็ก":{"jobsTH":["นักเขียน","ครูอนุบาล","ครูประถม"],"jobsENG":["Poets, Lyricists and Creative Writers","Kindergarten Teachers","Elementary School Teachers"],"image":"นักเขียน","name":"วรรณกรรมสำหรับเด็ก"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาสารสนเทศศึกษา":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศึกษา"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาตะวันออก":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาตะวันออก"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"การศึกษา ภาษาไทย"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูสอนภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูภาษาอังกฤษ","name":"การศึกษา ภาษาอังกฤษ"}},"วิทยาลัยโพธิวิชชาลัย":{"สาขาวิชาการจัดการภูมิสังคม":{"jobsTH":["นักพัฒนาสังคม","มัคคุเทศก์"],"jobsENG":["Social and Community Service Managers","Travel Guides"],"image":"นักพัฒนาชุมชนเมือง","name":"การจัดการภูมิสังคม"},"สาขาวิชาการจัดการภูมิวัฒนธรรม":{"jobsTH":["นักพัฒนาสังคม","มัคคุเทศก์"],"jobsENG":["Social and Community Service Managers","Travel Guides"],"image":"นักอนุรักษ์","name":"การจัดการภูมิวัฒนธรรม"}},"คณะศึกษาศาสตร์":{"สาขาวิชาประถมศึกษา":{"jobsTH":["ครูประถม"],"jobsENG":["Elementary School Teachers"],"image":"ครูประถม","name":"ประถมศึกษา"},"สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"}},"คณะวิทยาศาสตร์":{"หลักสูตรการศึกษาบัณฑิต สาขาวิชาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาเคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา เคมี"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ชีววิทยา"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ฟิสิกส์"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา วิทยาศาสตร์ทั่วไป"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอัญมณีและเครื่องประดับ":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักอัญมณีวิทยา","name":"อัญมณีและเครื่องประดับ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคหกรรมศาสตร์":{"jobsTH":["นักโภชนาการ","นักออกแบบ","นักพัฒนาชุมชน"],"jobsENG":["Dietitians and Nutritionists","Floral Designers","Social and Community Service Managers"],"image":"ครูสอนการงานอาชีพ","name":"คหกรรมศาสตร์"}},"คณะเทคโนโลยีและนวัตกรรมผลิตภัณฑ์การเกษตร":{"สาขาวิชาวิทยาศาสตร์การอาหารและโภชนาการ":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์การอาหารและโภชนาการ"},"สาขาวิชาเทคโนโลยีวัสดุพอลิเมอร์":{"jobsTH":["ผู้ควบคุมการผลิต","ผู้จัดการฝ่ายผลิต","ผู้ควบคุมคุณภาพ","นักวิจัยและพัฒนาผลิตภัณฑ์"],"jobsENG":["First-Line Supervisors of Production and Operating Workers","Industrial Production Managers","Quality Control Analysts","Research and Development Scientists"],"image":"นักวัสดุพอลิเมอร์","name":"เทคโนโลยีวัสดุพอลิเมอร์"},"สาขาวิชาเทคโนโลยีชีวภาพและผลิตภัณฑ์การเกษตร":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพและผลิตภัณฑ์การเกษตร"}},"คณะวัฒนธรรมสิ่งแวดล้อมและการท่องเที่ยวเชิงนิเวศ":{"สาขาวิชานวัตกรรมการจัดการการท่องเที่ยวแบบบูรณาการ":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"นวัตกรรมการจัดการท่องเที่ยว"},"สาขาวิชาเทคโนโลยีสิ่งแวดล้อมและการจัดการทรัพยากร":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"เทคโนโลยีสิ่งแวดล้อม"}},"วิทยาลัยนานาชาติเพื่อศึกษาความยั่งยืน":{"สาขาวิชาการจัดการการท่องเที่ยวอย่างยั่งยืน (หลักสูตรนานาชาติ)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ผู้เชี่ยวชาญด้านความยั่งยืน"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Sustainability Specialists"],"image":"นักอนุรักษ์","name":"การจัดการการท่องเที่ยวอย่างยั่งยืน"}}},"มหาวิทยาลัยขอนแก่น":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะเทคนิคการแพทย์":{"สาขาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"คณะสาธารณสุขศาสตร์":{"สาขาวิทยาศาสตร์อนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"สาขาอาชีวอนามัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะสัตวแพทย์":{"สัตวแพทยศาสตรบัณฑิต":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"รัฐประศาสนศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"สาขาวิชาสารสนเทศศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศึกษา"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาอังกฤษธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษธุรกิจ"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาการจัดการการพัฒนาสังคม":{"jobsTH":["ผู้นำชุมชน","นักบริการชุมชน"],"jobsENG":["Property, Real Estate, and Community Association Managers","Social and Community Service Managers"],"image":"นักพัฒนาชุมชนเมือง","name":"การจัดการพัฒนาสังคม"},"สาขาวิชาภาษาเยอรมันเพื่ออาชีพ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมันเพื่ออาชีพ"},"สาขาวิชาสังคมวิทยาและมนุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Anthropologists","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"},"สาขาวิชาภาษาสเปน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาสเปน"}},"วิทยาลัยการปกครองท้องถิ่น":{"หลักสูตรรัฐประศาสนศาสตรบัณฑิต สาขาวิชาการปกครองท้องถิ่น":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"อบต.","name":"การปกครองท้องถิ่น"},"หลักสูตรรัฐประศาสนศาสตรบัณฑิต สาขาวิชาการจัดการการคลัง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ","นักวิเคราะห์งบประมาณ"],"jobsENG":["Political Scientists and Public Administrators","Budget Analysts"],"image":"ข้าราชการ","name":"การจัดการการคลัง"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาการจัดการงานช่างและผังเมือง":{"jobsTH":["นักวิชาการผังเมือง"],"jobsENG":["Urban and Regional Planners"],"image":"นักวางผังเมือง","name":"การจัดการงานช่างและผังเมือง"}},"คณะศิลปกรรมศาสตร์":{"สาขาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"สาขาออกแบบนิเทศศิลป์":{"jobsTH":["จิตรกร/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers","Art Directors"],"image":"นักออกแบบ Graphic","name":"ออกแบบนิเทศศิลป์"},"สาขาดุริยางคศิลป์":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"ดุริยางคศิลป์"},"สาขาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปะการแสดง"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมเกษตร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ การเกษตร"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"}},"คณะสถาปัตยกรรมศาสตร์":{"สาขาวิชาสถาปัตยกรรมศาสตร์":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาการออกแบบอุตสาหกรรม":{"jobsTH":["นักออกแบบอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบอุตสาหกรรม","name":"สถาปัตย์ ออกแบบอุตสาหกรรม"}},"คณะวิทยาการการจัดการ":{"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการโรงแรมและอีเว้นท์":{"jobsTH":["ผู้วางแผนการประชุมนิทรรศการ","พนักงานในโรงแรม","ผู้จัดการด้านการจัดเตรียมอาหาร","ผู้จัดการด้านที่พัก"],"jobsENG":["Meeting, Convention, and Event Planners","Hotel, Motel, and Resort Desk Clerks","Food Service Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การโรงแรมและอีเว้นท์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"หลักสูตรเศรษฐศาสตรบัณฑิต สาขาวิชาเศรษฐศาสตร์":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"หลักสูตรบัญชีบัณฑิต สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"วิทยาลัยนานาชาติ":{"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชา กิจการระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"กิจการระหว่างประเทศ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชา ธุรกิจระดับโลก":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ","นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts","Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักธุรกิจ","name":"ธุรกิจระดับโลก"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชา การตลาดระหว่างประเทศ":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาดระหว่างประเทศ"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีมัลติมิเดียและแอนิเมชัน":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developers"],"image":"นักออกแบบ Graphic","name":"เทคโนโลยีมัลติมีเดียแอนิเมชัน"}},"คณะศึกษาศาสตร์":{"สาขาวิชาวิทยาศาสตร์ศึกษา":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"วิทยาศาสตร์ศึกษา"},"สาขาวิชาคณิตศาสตรศึกษา":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"คณิตศาสตร์ศึกษา"},"สาขาวิชาการสอนภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูภาษาไทย","name":"การสอนภาษาไทย"},"สาขาวิชาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["School Teachers"],"image":"ครูสอนสังคมศึกษา","name":"สังคมศึกษา"},"สาขาวิชาพลศึกษา":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูสอนพลศึกษา","name":"ศึกษา พลศึกษา"},"สาขาวิชาศิลปศึกษา":{"jobsTH":["ครูสอนศิลปะ"],"jobsENG":["Art, Drama, and Music Teachers"],"image":"ครูสอนศิลปะ","name":"ศึกษา ศิลปศึกษา"},"สาขาวิชาการสอนภาษาญี่ปุ่น":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาญี่ปุ่น","name":"ศึกษา ญี่ปุ่น"},"สาขาวิชาคอมพิวเตอร์ศึกษา":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"คอมพิวเตอร์ศึกษา"}},"คณะวิทยาศาสตร์":{"สาขาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาชีวเคมี":{"jobsTH":["นักชีวเคมี"],"jobsENG":["Biochemists and Biophysicists"],"image":"นักวิทยาศาสตร์ชีวเคมี","name":"ชีวเคมี"},"สาขาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาภูมิสารสนเทศศาสตร์":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศศาสตร์"},"สาขาเทคโนโลยีสารสนเทศและการสื่อสาร":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศและการสื่อสาร"},"สาขาสารสนเทศสถิติ":{"jobsTH":["นักสถิติ","โปรแกรมเมอร์","นักวิเคราะห์ระบบ"],"jobsENG":["Statisticians","Computer Programmers","Computer Systems Analysts"],"image":"นักสถิติ","name":"สารสนเทศสถิติ"},"สาขาวัสดุศาสตร์และนาโนเทคโนโลยี":{"jobsTH":["นักวัสดุศาสตร์"],"jobsENG":["Materials Scientists"],"image":"นักวัสดุศาสตร์","name":"วัสดุศาสตร์และนาโนเทคโนโลยี"}},"คณะเทคโนโลยี":{"สาขาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาเทคโนโลยีธรณี":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักธรณีวิทยา","name":"เทคโนโลยีธรณี"},"สาขาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาเทคโนโลยีการผลิต":{"jobsTH":["นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Quality Control Analysts","Research and Development Scientists"],"image":"นายช่างควบคุมการผลิต","name":"เทคโนโลยีการผลิต"}},"คณะเกษตรศาสตร์":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาเศรษฐศาสตร์การเกษตร":{"jobsTH":["นักเศรษฐศาสตร์การเกษตร"],"jobsENG":["Environmental Economists"],"image":"คนขายอุปกรณ์การเกษตร","name":"เศรษฐศาสตร์การเกษตร"},"สาขาวิชาการประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"การประมง"},"สาขาวิชาทรัพยากรที่ดินและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสร์สิ่งแวดล้อม","นักวิจัยดิน","นักอนุรักษ์ทรัพยากรดิน"],"jobsENG":["Environmental Scientists and Specialists, Including Health","Soil and Plant Scientists","Soil and Water Conservationists"],"image":"นักอนุรักษ์","name":"ทรัพยากรที่ดินและสิ่งแวดล้อม"}},"คณะวิทยาศาสตร์ประยุกต์และวิศวกรรมศาสตร์":{"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศและการสื่อสาร":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศและการสื่อสาร"},"สาขาวิชาการประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"การประมง"},"สาขาวิชาอุตสาหกรรมการเกษตร":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"คนขายอุปกรณ์การเกษตร","name":"อุตสาหกรรมการเกษตร"},"สาขาวิชาการจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"การจัดการทรัพยากรธรรมชาติและสิ่งแวดล้อม"},"สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา","ผู้ตัดสินกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts","Umpires and Referees"],"image":"เทรนเนอร์","name":"วิทยาศาสตร์การกีฬา"}}},"มหาวิทยาลัยบูรพา":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะสหเวชศาสตร์":{"สาขาวิชาชีวเวชศาสตร์":{"jobsTH":["นักวิทยาศาสตร์การแพทย์","นักเซลล์วิทยา","ผู้ช่วยนักโภชนาการ"],"jobsENG":["Medical Scientists","Molecular and Cellular Biologists","Dietitians and Nutritionists"],"image":"นักวิทยาศาสตร์ชีวการแพทย์","name":"ชีวเวชศาสตร์"},"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขาพยาธิวิทยากายวิภาค":{"jobsTH":["นักพยาธิวิทยา"],"jobsENG":["Pathologists"],"image":"นักพยาธิวิทยา","name":"พยาธิวิทยากายวิภาค"},"กายภาพบำบัดบัณฑิต":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"คณะสาธารณสุขศาสตร์":{"สาขาสุขศาสตร์อุตสาหกรรมและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"สาขาสุขศึกษาและพฤติกรรมสุขภาพ":{"jobsTH":["นักสุขศึกษา","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Health Educators","Community Health Workers"],"image":"นักสร้างเสริมสุขภาพ","name":"สุขศึกษาและส่งเสริมสุขภาพ"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะรัฐศาสตร์และนิติศาสตร์":{"รัฐศาสตรบัณฑิต สาขาวิชารัฐศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐศาสตร์"},"รัฐประศาสนศาสตรบัณฑิต สาขาวิชาการบริหารทั่วไป":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"รัฐประศาสนศาสตร์"},"สาขาวิชานิติศาสตร์":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะวิทยาศาสตร์การกีฬา":{"สาขาวิชาสื่อสารมวลชนทางกีฬา":{"jobsTH":["ผู้ประกาศข่าวกีฬา","นักการตลาดกีฬา"],"jobsENG":["Radio and TV Announcers","Marketing Specialists"],"image":"นักข่าวสายกีฬา","name":"สื่อสารการกีฬา"},"สาขาวิชากีฬาศึกษาและบริหารจัดการกีฬา":{"jobsTH":["ผู้จัดการนักกีฬา","ผู้ตัดสิน","ผู้ฝึกสอนกีฬา"],"jobsENG":["Agents and Business Managers of Artists, Performers, and Athletes","Umpires, Referees, and Other Sports Officials","Athletic Trainers"],"image":"ผู้จัดการทีม","name":"กีฬาศึกษาและบริหารจัดการกีฬา"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์เอกประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์เอกการโฆษณาและการสื่อสารการตลาด":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"การโฆษณาและการสื่อสาร"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์เอกวารสารศาสตร์":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"วารสารศาสตร์"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์เอกวาทวิทยาและสื่อสารการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"วาทวิทยาและสื่อสารการแสดง"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์เอกภาพยนตร์และโทรทัศน์":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์และโทรทัศน์"},"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาสารสนเทศศึกษา":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศึกษา"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาเกาหลี":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเกาหลี"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาศาสนาและปรัชญา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ศาสนาและปรัชญา"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาการพัฒนาชุมชน":{"jobsTH":["นักพัฒนาชุมชน","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"การพัฒนาชุมชน"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาฝรั่งเศสเพื่อการสื่อสาร":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศสเพื่อการสื่อสาร"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาการจัดการทรัพยากร-วัฒนธรรม":{"jobsTH":["นักประวัติศาสตร์","นักมานุษยวิทยา"],"jobsENG":["Historians","Anthropologists"],"image":"นักอนุรักษ์","name":"การจัดการทรัพยากร-วัฒนธรรม"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาการจัดการบริการสังคม":{"jobsTH":["นักพัฒนาชุมชน","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"การจัดการบริการสังคม"},"สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"}},"คณะศิลปกรรมศาสตร์":{"สาขาจิตรกรรม":{"jobsTH":["จิตรกร"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"จิตรกร","name":"จิตรกรรม"},"สาขากราฟิกอารต์และกราฟิกมีเดีย":{"jobsTH":["นักออกแบบกราฟิก","นักออกแบบสื่อมัลติมีเดียแอนิเมชัน"],"jobsENG":["Graphic Designers","Multimedia Artists and Animators"],"image":"นักออกแบบ Graphic","name":"กราฟิกอารต์และกราฟิกมีเดีย"},"สาขานิเทศศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers"],"image":"นักออกแบบ Graphic","name":"นิเทศศิลป์"},"สาขาเซรามิกส์":{"jobsTH":["ศิลปินงานเซรามิกส์","นักออกแบบผลิตภัณฑ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Commercial and Industrial Designers"],"image":"ช่างปั้น","name":"เซรามิกส์"},"สาขาดนตรีและการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","นักดนตรี"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Musicians (Instrumental)"],"image":"นักดนตรี","name":"ดนตรีและการแสดง"},"สาขาการออกแบบผลิตภัณฑ์":{"jobsTH":["นักออกแบบผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบผลิตภัณฑ์","name":"การออกแบบผลิตภัณฑ์"}},"คณะวิทยาการสารสนเทศ":{"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาวิศวกรรมซอฟต์แวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวกรรมซอฟต์แวร์"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"}},"คณะการจัดการและการท่องเที่ยว":{"หลักสูตรบัญชีบัณฑิต สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"บัญชี","name":"บัญชี"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การจัดการโรงแรม"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"}},"วิทยาลัยนานาชาติ":{"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาบริหารธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"บริหารธุรกิจ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการโลจิสติกส์ หลักสูตรนานาชาติ":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"จัดการโลจิสติกส์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการการท่องเที่ยวและการโรงแรมนานาชาติ":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"จัดการการท่องเที่ยวและการโรงแรม"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาศิลปศาสตร์ หลักสูตรนานาชาติ":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists"],"image":"ฝ่ายสื่อสารองค์กร","name":"ศิลปศาสตร์"}},"คณะโลจิสติกส์":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการเดินเรือ":{"jobsTH":["วิศวกรเรือ","เจ้าหน้าที่ขับเคลื่อนเรือ","กัปตัน"],"jobsENG":["Ship Engineers","Pilots, Ship","Ship and Boat Captains"],"image":"นักโลจิสติกส์","name":"วิทยาการเดินเรือ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาการจัดการอุตสาหกรรมพาณิชยนาวี":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ตัวแทนส่งสินค้า","ผู้จัดการห่วงโซ่อุปทาน"],"jobsENG":["Logistics Analysts","Freight Forwarders","Supply Chain Managers"],"image":"นักโลจิสติกส์","name":"การจัดการอุตสาหกรรมพาณิชยนาวี"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"จัดการโลจิสติกส์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการค้าระหว่างประเทศและการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"}},"คณะภูมิสารสนเทศศาสตร์":{"สาขาวิชาภูมิสารสนเทศ":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศศาสตร์"}},"คณะศึกษาศาสตร์":{"หลักสูตรการศึกษาบัณฑิต สาขาวิชาการสอนคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"การสอนคณิตศาสตร์"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาการสอนภาษาต่างประเทศ (ภาษาจีน)":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาจีน","name":"การสอนภาษาจีน"},"หลักสูตรการศึกษาบัณฑิต สาขาวิชาเทคโนโลยีการศึกษา":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"คนคุมห้องโสตทัศนศึกษา","name":"เทคโนโลยีการศึกษา"},"หลักสูตรโครงการครูนานาชาติ (หลักสูตร 2 ปริญญา) สาขาวิชาการสอนคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"การสอนคณิตศาสตร์"},"หลักสูตรโครงการครูนานาชาติ (หลักสูตร 2 ปริญญา) สาขาวิชาการสอนเคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"การสอนเคมี"},"หลักสูตรโครงการครูนานาชาติ (หลักสูตร 2 ปริญญา) สาขาวิชาการสอนชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"การสอนชีววิทยา"},"หลักสูตรโครงการครูนานาชาติ (หลักสูตร 2 ปริญญา) สาขาวิชาการสอนฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"การสอนฟิสิกส์"}},"คณะวิทยาศาสตร์":{"สาขาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาชีวเคมี":{"jobsTH":["นักชีวเคมี"],"jobsENG":["Biochemists and Biophysicists"],"image":"นักวิทยาศาสตร์ชีวเคมี","name":"ชีวเคมี"},"สาขาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาฟิสิกส์ประยุกต์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์"},"สาขาวาริชศาสตร์":{"jobsTH":["นักวิจัยน้ำ","นักอนุรักษ์ทรัพยากรน้ำ"],"jobsENG":["Water Resource Specialists","Soil and Water Conservationists"],"image":"นักวิจัยน้ำ","name":"วาริชศาสตร์"},"สาขาวิทยาศาสตร์และเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีอาหาร"},"สาขาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"}}},"มหาวิทยาลัยศิลปากร":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะศึกษาศาสตร์":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยา การกีฬา"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูภาษาไทย","name":"ศึกษา ภาษาไทย"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["School Teachers"],"image":"ครูสอนสังคมศึกษา","name":"ศึกษา สังคมศึกษา"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"ศึกษา การศึกษาปฐมวัย"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาการประถมศึกษา":{"jobsTH":["ครูประถม"],"jobsENG":["Elementary School Teachers"],"image":"ครูประถม","name":"ศึกษา การประถมศึกษา"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาการสอนภาษาจีน":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาจีน","name":"ศึกษา การสอนภาษาจีน"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีการศึกษา":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"คนคุมห้องโสตทัศนศึกษา","name":"ศึกษา เทคโนโลยีการศึกษา"},"หลักสูตรศึกษาศาสตรบัณฑิต สาขาวิชาการศึกษาตลอดชีวิต":{"jobsTH":["ครู"],"jobsENG":["School Teachers"],"image":"ครูทั่วไป","name":"ศึกษา การศึกษาตลอดชีวิต"}},"คณะเทคโนโลยีสารสนเทศและการสื่อสาร":{"วิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศธุรกิจ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"นักธุรกิจ E-Commerce","name":"เทคโนโลยีสารสนเทศธุรกิจ"},"วิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศเพื่อการออกแบบ":{"jobsTH":["นักออกแบบกราฟฟิก","ผู้กำกับศิลป์","นักพัฒนาเว็บไซต์","นักพัฒนาเกม"],"jobsENG":["Graphic Designers","Art Directors","Web Developers","Video Game Designers"],"image":"นักออกแบบ Graphic","name":"เทคโนโลยีสารสนเทศการออกแบบ"},"นิเทศนศาสตรบัณฑิต สาขาวิชาการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"นิเทศนศาสตรบัณฑิต สาขาวิชาการลูกค้าสัมพันธ์":{"jobsTH":["ฝ่ายบริการลูกค้า","นักการตลาด"],"jobsENG":["Customer Service Representatives","Marketing Specialists"],"image":"ฝ่ายบริการลูกค้า","name":"ลูกค้าสัมพันธ์"},"นิเทศนศาสตรบัณฑิต สาขาวิชาวารสารและหนังสือพิมพ์":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"วารสารและหนังสือพิมพ์"},"นิเทศนศาสตรบัณฑิต สาขาวิชาภาพยนตร์":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์"},"นิเทศนศาสตรบัณฑิต สาขาวิชาวิทยุและโทรทัศน์":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"วิทยุโทรทัศน์"}},"คณะวิศวกรรมศาสตร์และเทคโนโลยีอุตสาหกรรม":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาปิโตรเคมีและวัสดุพอลิเมอร์":{"jobsTH":["วิศวกรปิโตรเลียม"],"jobsENG":["Petroleum Engineers"],"image":"วิศวกรปิโตรเลียม (ในแท่นขุดเจาะ)","name":"วิศวะ ปิโตรเคมีและพอลิเมอร์"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบคอมพิวเตอร์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์และระบบคอมพิวเตอร์"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมการจัดการและโลจิสติกส์":{"jobsTH":["วิศวกรโลจิสติกส์"],"jobsENG":["Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ การจัดการและโลจิสติกส์"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวัสดุขั้นสูงและนาโนเทคโนโลยี":{"jobsTH":["วิศวกรวัสดุ","วิศวกรนาโน"],"jobsENG":["Materials Engineers","Nanosystems Engineers"],"image":"วิศวกรวัสดุ","name":"วิศวะ วัสดุขั้นสูงและนาโนฯ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมกระบวนการชีวภาพ":{"jobsTH":["วิศวกรเทคโนโลยีชีวภาพ"],"jobsENG":["Biochemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ กระบวนการชีวภาพ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยา เทคโนโลยีอาหาร"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"วิทยา เทคโนโลยีชีวภาพ"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาธุรกิจวิศวกรรม":{"jobsTH":["นักธุรกิจวิศวกรรม"],"jobsENG":["Sales Engineers"],"image":"นักบริหารงานวิศวกรรม","name":"เทคโนโลยี ธุรกิจวิศวกรรม"}},"คณะวิทยาการการจัดการ":{"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการชุมชน":{"jobsTH":["ผู้นำชุมชน","นักบริการชุมชน"],"jobsENG":["Property, Real Estate, and Community Association Managers","Social and Community Service Managers"],"image":"นักพัฒนาชุมชนเมือง","name":"การจัดการชุมชน"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจทั่วไป":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การจัดการโรงแรม"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจและภาษาอังกฤษ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักเจรจาทางธุรกิจ","name":"การจัดการธุรกิจและภาษาอังกฤษ"},"หลักสูตรรัฐประศาสนศาสตรบัณฑิต สาขาวิชารัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"}},"คณะอักษรศาสตร์":{"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาวิชาภาษาเกาหลี":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเกาหลี"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาปรัชญาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ปรัชญาประวัติศาสตร์"},"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"สาขาวิชาการละคร":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"การละคร"},"สาขาวิชาสังคีตศิลป์ไทย":{"jobsTH":["นักแสดง","นักร้อง","นักดนตรีไทย","นักนาฏยลีลา"],"jobsENG":["Actors","Singers","Musicians, Instrumental","Dancers"],"image":"ครูสอนนาฏศิลป์","name":"สังคีตศิลป์ไทย"},"สาขาวิชาสังคมศาสตร์การพัฒนา":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักสังคมศาสตร์","name":"สังคมศาสตร์การพัฒนา"},"สาขาวิชาสารสนเทศศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศาสตร์"},"สาขาวิชาบรรณารักษศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"บรรณารักษศาสตร์"}},"คณะโบราณคดี":{"สาขาวิชาโบราณคดี":{"jobsTH":["ภัณฑารักษ์","นักประวัติศาสตร์","นักเขียน"],"jobsENG":["Curators","Historians","Poets, Lyricists and Creative Writers"],"image":"นักโบราณคดี","name":"โบราณคดี"},"สาขาวิชาประวัติศาสตร์ศิลปะ":{"jobsTH":["นักประวัติศาสตร์","ศิลปิน"],"jobsENG":["Historians","Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"นักประวัติศาสตร์ศิลปะ","name":"ประวัติศาสตร์ศิลปะ"},"สาขาวิชามานุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา"],"jobsENG":["Anthropologists"],"image":"นักมานุษยวิทยา","name":"มานุษยวิทยา"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"}}},"มหาวิทยาลัยมหิดล":{"คณะแพทยศาสตร์ศิริราชพยาบาล":{"กายอุปกรณศาสตรบัณฑิต":{"jobsTH":["นักกายอุปกรณ์"],"jobsENG":["Orthotists and Prosthetists"],"image":"นักกายอุปกรณ์","name":"กายอุปกรณ์"},"การแพทย์แผนไทยประยุกต์บัณฑิต ":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"แพทย์แผนไทย"},"เทคโนโลยีบัณฑิต":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยี"},"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะแพทยศาสตร์โรงพยาบาลรามาธิบดี":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"},"วิทยาศาสตรบัณฑิต สาขาวิชาความผิดปกติของการสื่อความหมาย":{"jobsTH":["นักแก้ไขการได้ยิน","นักแก้ไขการพูด"],"jobsENG":["Audiologists","Speech-Language Pathologists"],"image":"นักบำบัดการพูด","name":"วิทยา ความผิดปกติการสื่อความหมาย"},"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"แพทย์แผนไทย","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะเทคนิคการแพทย์":{"สาขาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขารังสีเทคนิค":{"jobsTH":["นักรังสีรักษา","นักรังสีเทคนิค","นักเวชศาสตร์นิวเคลียร์"],"jobsENG":["Radiation Therapists","Radiologic Technicians","Nuclear Medicine Technologists"],"image":"นักรังสีเทคนิค","name":"รังสีเทคนิค"}},"คณะกายภาพบำบัด":{"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชากิจกรรมบำบัด":{"jobsTH":["นักกิจกรรมบำบัด"],"jobsENG":["Recreational Therapists"],"image":"นักกายภาพบำบัด","name":"กิจกรรมบำบัด"}},"วิทยาลัยวิทยาศาสตร์และเทคโนโลยีการกีฬา":{"สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยา การกีฬา"},"สาขาวิชาการออกกำลังกายและการกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา","ผู้ตัดสินกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts","Umpires and Referees"],"image":"เทรนเนอร์","name":"การออกกำลังกายและกีฬา"}},"คณะสาธารณสุขศาสตร์":{"สาขาวิชาวิทยาศาสตร์อนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"วิทยา อนามัยสิ่งแวดล้อม"},"สาขาวิชาสุขศึกษาและส่งเสริมสุขภาพ":{"jobsTH":["เจ้าหน้าที่ส่งเสริมสุขภาพ","ผู้ให้คำปรึกษาด้านสุขภาพ"],"jobsENG":["Community Health Workers","Health Educators"],"image":"นักสร้างเสริมสุขภาพ","name":"สุขศึกษาและส่งเสริมสุขภาพ"},"สาขาวิชาอนามัยชุมชน":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่อนามัยชุมชน","name":"อนามัยชุมชน"},"สาขาวิชาโภชนวิทยาและการกำหนดอาหาร":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"โภชนาการกำหนดอาหาร"},"สาขาวิชาวิทยาศาสตร์การอาหารเพื่อสุขภาพ":{"jobsTH":["นักวิทยาศาสตร์อาหาร"],"jobsENG":["Food Scientists and Technologists"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์อาหาร"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะสัตวแพทย์":{"สัตวแพทยศาสตรบัณฑิต":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะเทคโนโลยีสารสนเทศและการสื่อสาร":{"วิชาเทคโนโลยีสารสนเทศและการสื่อสาร":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศและการสื่อสาร"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมไฟฟ้า/ วิศวกรรมไฟฟ้าสื่อสาร":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมชีวการแพทย์":{"jobsTH":["วิศวกรชีวการแพทย์"],"jobsENG":["Biomedical Engineers"],"image":"วิศวกรชีวการแพทย์","name":"วิศวะ ชีวการแพทย์"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"}},"คณะสังคมศาสตร์และมนุษยศาสตรื":{"สาขาวิชาเวชระเบียน":{"jobsTH":["นักเวชระเบียน"],"jobsENG":["Medical Records and Health Information Technicians"],"image":"เจ้าหน้าที่ฝ่ายทะเบียน","name":"เวชระเบียน"}},"วิทยาลัยศาสนศึกษา":{"สาขาวิชาศาสนศึกษา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ศาสนศึกษา"}},"คณะวิทยาศาสตร์":{"สาขาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาพฤกษศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พฤกษศาสตร์"}},"คณะสิ่งแวดล้อมและทรัพยากรธรรมชาติ":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม"}}},"มหาวิทยาลัยเทคโนโลยีสุรนารี":{"คณะสำนักวิชาแพทยศาสตร์":{"วิทยาศาสตรบัณฑิต สาขาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักอาชีวอนามัยและความปลอดภัย","name":"วิทยา อาชีวอนามัยความปลอดภัย"},"วิทยาศาสตรบัณฑิต สาขาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"วิทยา อนามัยสิ่งแวดล้อม"},"แพทยศาสตร์บัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะเทคโนโลยีสังคม":{"หลักสูตรเทคโนโลยีสารสนเทศ สาขาระบบสารสนเทศเพื่อการจัดการ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"ระบบสารสนเทศเพื่อการจัดการ"},"หลักสูตรเทคโนโลยีสารสนเทศ สาขาสารสนเทศศึกษา":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"คนคุมห้องโสตทัศนศึกษา","name":"สารสนเทศศึกษา"},"หลักสูตรเทคโนโลยีสารสนเทศ สาขาซอฟต์แวร์วิสาหกิจ":{"jobsTH":["นักพัฒนาซอฟแวร์","นักวิเคราะห์ระบบงาน","นักพัฒนาเว็บไซต์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Software Developers, Applications","Network Consultants","Web Developers","Database Administrators"],"image":"นักพัฒนา Software","name":"ซอฟต์แวร์วิสาหกิจ"},"หลักสูตรเทคโนโลยีการจัดการ สาขาการจัดการการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"หลักสูตรเทคโนโลยีการจัดการ สาขาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"จัดการโลจิสติกส์"},"หลักสูตรเทคโนโลยีการจัดการ สาขาการจัดการผู้ประกอบการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"ผู้ประกอบการ"}},"คณะวิทยาศาสตร์":{"สาขาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยาศาสตร์การกีฬา"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"}},"คณะเทคโนโลยีการเกษตร":{"สาขาเทคโนโลยีการผลิตพืช":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการผลิตพืช"},"สาขาเทคโนโลยีการผลิตสัตว์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์","นักเทคโนโลยีการเกษตร"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders","Agricultural Technicians"],"image":"นักวิจัยสัตว์ป่า","name":"เทคโนโลยีการผลิตสัตว์"},"สาขาเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีอาหาร"}}},"มหาวิทยาลัยรังสิต":{"วิทยาลัยแพทยศาสตร์":{"แพทยศาสตร์บัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientists"],"image":"หมอ","name":"แพทย์"}},"คณะทันตแพทยศาสตร์":{"ทันตแพทยศาสตร์บัณฑิต":{"jobsTH":["ทันตแพทย์"],"jobsENG":["Dentists"],"image":"หมอฟัน","name":"ทันตแพทย์"}},"คณะการแพทย์แผนตะวันออก":{"วิทยาศาสตร์บัณฑิต สาขาการแพทย์แผนตะวันออก":{"jobsTH":["แพทย์แผนตะวันออก","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนจีน","name":"แพทย์แผนตะวันออก"},"การแพทย์แผนไทยบัณฑิต":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"แพทย์แผนไทย"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะวิทยาศาสตร์":{"สาขาวิทยาศาสตร์ชีวการแพทย์":{"jobsTH":["นักวิทยาศาสตร์การแพทย์","อาจารย์ด้านวิทยาศาสตร์สุขภาพ"],"jobsENG":["Medical Scientists","Health Specialties Teachers"],"image":"นักวิทยาศาสตร์ชีวการแพทย์","name":"วิทยาฯ ชีวการแพทย์"},"สาขาเคมีประยุกต์":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา"],"jobsENG":["Chemists","Research and Development Scientists"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมีประยุกต์"},"วิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมชีวการแพทย์":{"jobsTH":["วิศวกรชีวการแพทย์"],"jobsENG":["Biomedical Engineers"],"image":"วิศวกรชีวการแพทย์","name":"วิศวะ ชีวการแพทย์"}},"คณะทัศนมาตรศาสตร์ ":{"หลักสูตรทัศนมาตรศาสตรบัณฑิต":{"jobsTH":["นักทัศนมาตร"],"jobsENG":["Optometrists"],"image":"จักษุแพทย์","name":"ทัศนมาตรศาสตร์"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"วิทยาลัยบริหารรัฐกิจและรัฐศาสตร์":{"รัฐศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐศาสตร์"}},"คณะนิเทศศาสตร์":{"สาขาวิชาวิทยุกระจายเสียงและวิทยุโทรทัศน์":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"วิทยุโทรทัศน์"},"สาขาวิชาวารสารศาสตร์":{"jobsTH":["ผู้ประกาศข่าวหรือพิธีกร","บรรณาธิการ","นักเขียน"],"jobsENG":["Radio and TV Announcers","Copy Editors","Writers and Authors"],"image":"บรรณาธิการวารสาร","name":"วารสาร"},"สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"สาขาวิชาการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"สาขาวิชาการภาพยนตร์และวีดิทัศน์":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์และวีดิทัศน์"},"สาขาวิชาสื่อสารการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"สื่อสารการแสดง"},"สาขาวิชาสื่อสารการตลาด":{"jobsTH":["นักสื่อสารการตลาด","นักการตลาด","ผู้จัดการฝ่ายการตลาด"],"jobsENG":["Online Marketing Strategists","Marketing Specialists","Marketing Managers"],"image":"นักการตลาด","name":"สื่อสารการตลาด"},"สาขาวิชามัลติมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developers"],"image":"นักออกแบบ Graphic","name":"มัลติมีเดีย"},"สาขาวิชาสื่อสารการกีฬา":{"jobsTH":["ผู้ประกาศข่าวกีฬา","นักการตลาดกีฬา"],"jobsENG":["Radio and TV Announcers","Marketing Specialists"],"image":"นักข่าวสายกีฬา","name":"สื่อสารการกีฬา"}},"International College":{"Bachelor of Communication Arts":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"},"Bachelor of Science - Information and Communication Technology":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศและการสื่อสาร"},"Bachelor of Business Administration":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"},"Bachelor of Business Administration - International Business":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"Bachelor of Business Administration - International Hospitality and Tourism":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การท่องเที่ยวและการโรงแรม"},"Bachelor of Business Administration - Asian Business Management":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การบริหารธุรกิจในเอเชีย"},"Bachelor of Business Administration - International Marketing and Online Business":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาดและธุรกิจออนไลน์"},"Bachelor of Accountacy":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"Bachelor of Arts - International Relations and Development":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"Bachelor of Arts - Philosophy":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญา"},"Bachelor of Arts - Politics and Economics":{"jobsTH":["นักเศรษฐศาสตร์","นักรัฐศาสตร์"],"jobsENG":["Economists","Political Scientists"],"image":"นักการเมือง","name":"รัฐศาสตร์และเศรษฐศาสตร์"}},"วิทยาลัยดนตรี":{"แขนงวิชาการประพันธ์เพลง":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง","ครูสอนดนตรี"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors","Art, Drama, and Music Teachers, Postsecondary"],"image":"นักแต่งเพลง","name":"การประพันธ์เพลง"},"แขนงวิชาการแสดงดนตรี":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"การแสดงดนตรี"},"แขนงวิชาการแสดงดนตรีและการสอน":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง","ครูสอนดนตรี"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors","Art, Drama, and Music Teachers, Postsecondary"],"image":"นักดนตรี","name":"การแสดงดนตรีและการสอน"},"แขนงวิชาดนตรีแจ๊สศึกษา":{"jobsTH":["นักดนตรี","นักร้อง","นักประพันธ์เพลง","ผู้อำนวยเพลง","ครูสอนดนตรี"],"jobsENG":["Musicians, Instrumental","Singers","Music Composers and Arrangers","Music Directors","Art, Drama, and Music Teachers, Postsecondary"],"image":"นักดนตรี","name":"ดนตรีแจ๊สศึกษา"},"แขนงวิชาการผลิตดนตรี":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"การผลิตดนตรี"},"แขนงวิชาดนตรีประกอบภาพยนตร์และมัลติมีเดีย":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","นักตัดต่อ"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Film and Video Editors"],"image":"นักประพันธ์เพลง","name":"ดนตรีประกอบภาพยนตร์และมัลติมีเดีย"}},"คณะศิลปะและการออกแบบ":{"สาขาวิชาการออกแบบภายใน":{"jobsTH":["นักออกแบบภายใน"],"jobsENG":["Interior Designers"],"image":"นักออกแบบภายใน","name":"การออกแบบภายใน"},"สาขาวิชาศิลปะภาพถ่าย":{"jobsTH":["ช่างภาพ","ช่างอุปกรณ์ภาพถ่าย"],"jobsENG":["Photographers","Camera and Photographic Equipment Repairers"],"image":"ช่างภาพ","name":"ศิลปะภาพถ่าย"},"สาขาวิชาการออกแบบนิเทศศิลป์":{"jobsTH":["จิตรกร/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers","Art Directors"],"image":"นักออกแบบ Graphic","name":"การออกแบบนิเทศศิลป์"},"สาขาวิชาการออกแบบผลิตภัณฑ์":{"jobsTH":["นักออกแบบผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบผลิตภัณฑ์","name":"การออกแบบผลิตภัณฑ์"},"สาขาวิชาแฟชั่นดีไซน์":{"jobsTH":["นักออกแบบแฟชั่น","ช่างตัดเย็บ","ช่างแต่งหน้าทำผม"],"jobsENG":["Fashion Designers","Tailors, Dressmakers, and Custom Sewers","Hairdressers, Hairstylists, and Cosmetologists"],"image":"นักออกแบบแฟชัน","name":"แฟชั่นดีไซน์"}},"คณะเทคโนโลยีสารสนเทศ":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสารสนเทศการแพทย์":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"สารสนเทศการแพทย์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสารสนเทศการลงทุน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นักวิเคราะห์หุ้น","name":"สารสนเทศการลงทุน"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาคอมพิวเตอร์เกมมัลติมีเดีย":{"jobsTH":["นักออกแบบเกม"],"jobsENG":["Video Game Designers"],"image":"คนออกแบบเกม","name":"คอมพิวเตอร์เกมมัลติมีเดีย"}},"คณะดิจิทัลอาร์ต":{"สาขาวิชาคอมพิวเตอร์อาร์ต":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers"],"image":"นักออกแบบ Graphic","name":"คอมพิวเตอร์อาร์ต"},"สาขาวิชาวิชวลเอฟเฟค":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers"],"image":"นักออกแบบ Graphic","name":"วิชวลเอฟเฟค"}},"สถาบันการบิน":{"สาขาวิชานักบินพาณิชย์":{"jobsTH":["นักบิน"],"jobsENG":["Pilots"],"image":"นักบิน (กัปตัน)","name":"นักบินพาณิชย์"}},"วิทยาลัยวิศวกรรมศาสตร์":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมยานยนต์":{"jobsTH":["วิศวกรยานยนต์"],"jobsENG":["Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมการซ่อมบำรุงอากาศยาน":{"jobsTH":["วิศวกรการบินและอวกาศ"],"jobsENG":["Aerospace Engineers"],"image":"ช่างเครื่องบิน","name":"วิศวะ ซ่อมบำรุงอากาศยาน"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาเทคโนโลยีอุตสาหกรรม":{"jobsTH":["นักเทคโนโลยีอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบผลิตภัณฑ์","name":"เทคโนโลยี เทคโนโลยีอุตสาหกรรม"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาซ่อมบำรุงอากาศยาน":{"jobsTH":["ช่างซ่อมบำรุงอากาศยาน"],"jobsENG":["Aviation Inspectors"],"image":"ช่างเครื่องบิน","name":"เทคโนโลยี ซ่อมบำรุงอากาศยาน"}},"คณะสถาปัตยกรรมศาสตร์":{"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรศิลปบัณฑิต สาขาวิชานวัตกรรมการออกแบบ":{"jobsTH":["นักออกแบบผลิตภัณฑ์","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Commercial and Industrial Designers","Graphic Designers","Art Directors"],"image":"นักออกแบบ","name":"นวัตกรรมการออกแบบ"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการจัดการอุตสาหกรรม":{"jobsTH":["ผู้จัดการฝ่ายผลิต","ผู้ควบคุมคุณภาพการผลิต","นักวิเคราะห์โลจิสติกส์"],"jobsENG":["Industrial Production Managers","Quality Control Analysts","Logistics Analysts"],"image":"ผู้จัดการโรงงาน","name":"การจัดการอุตสาหกรรม"},"สาขาวิชาระบบสารสนเทศคอมพิวเตอร์":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"สาขาวิชาการเงินและการลงทุน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการจัดการทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"สาขาวิชาการจัดการธุรกิจอิเล็กทรอนิกส์":{"jobsTH":["นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Search Marketing Strategists","Online Merchants"],"image":"นักธุรกิจ E-Commerce","name":"จัดการธุรกิจอิเล็กทรอนิกส์"},"สาขาวิชาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"},"สาขาวิชาการจัดการธุรกิจค้าปลีก":{"jobsTH":["ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ","นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา","เจ้าของกิจการค้าปลีก"],"jobsENG":["Consultants (Business, Management or Strategy)","Business Intelligence Analysts","Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers","Sales Managers"],"image":"ผู้จัดการร้านค้า","name":"จัดการธุรกิจค้าปลีก"}},"คณะบัญชี":{"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"วิทยาลัยการท่องเที่ยวและบริการ":{"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจด้านการบิน":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","ตัวแทนขนส่ง","ตัวแทนจองตั๋วโดยสาร"],"jobsENG":["Flight Attendants","Cargo and Freight Agents","Reservation and Transportation Ticket Agents and Travel Clerks"],"image":"ผู้จัดการสายการบิน","name":"บริหารธุรกิจการบิน"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"มัคคุเทศก์","name":"จัดการการท่องเที่ยว"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการการโรงแรมและภัตตาคาร":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ผู้จัดการด้านบริการอาหาร"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Food Service Managers"],"image":"ผู้จัดการโรงแรม","name":"โรงแรมและภัตตาคาร"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาศิลปะและเทคโนโลยีการประกอบอาหาร":{"jobsTH":["ผู้จัดการด้านบริการอาหาร","เชฟ"],"jobsENG":["Food Service Managers","Chefs and Head Cooks"],"image":"พ่อครัว","name":"ศิลปะเทคโนโลยีประกอบอาหาร"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาไทยเพื่อการสื่อสาร":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาไทยเพื่อการสื่อสาร"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาอิสลามศึกษาและภาษาอาหรับ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"อิสลามศึกษาและภาษาอาหรับ"}},"วิทยาลัยนวัตกรรมสังคม":{"สาขาวิชาผู้นำทางสังคม ธุรกิจ และการเมือง":{"jobsTH":["นักการเมือง"],"jobsENG":["Political Scientists"],"image":"นักการเมือง","name":"สังคมธุรกิจการเมือง"},"สาขาวิชาการบริหารการพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชุมชนเมือง","name":"การบริหารการพัฒนาสังคม"}},"คณะเทคโนโลยีอาหาร":{"สาขาวิชาเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิชาเทคโนโลยีอาหาร"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"วิชาเทคโนโลยีชีวภาพ"}}},"มหาวิทยาลัยอัสสัมชัญ":{"คณะเทคนิคการแพทย์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientists","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"}},"คณะกายภาพบำบัด":{"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะนิเทศศาสตร์":{"สาขาวิชาการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"สาขาวิชาการสื่อสารผ่านสื่อดิจิทัล":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developers"],"image":"นักการตลาด","name":"สื่อสารผ่านสื่อดิจิทัล"},"สาขาวิชาการสื่อสารการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"สื่อสารการแสดง"},"สาขาวิชาการออกแบบนิเทศศิลป์":{"jobsTH":["นักออกแบบกราฟฟิก","นักออกแบบโฆษณา","ผู้กำกับศิลป์"],"jobsENG":["Graphic Designers","Copy Writers","Art Directors"],"image":"นักออกแบบ Graphic","name":"การออกแบบนิเทศศิลป์"},"สาขาวิชากระบวนจินตภาพคอมพิวเตอร์":{"jobsTH":["ผู้ผลิตภาพยนตร์และแอนิเมชัน","นักตัดต่อ"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors"],"image":"นักออกแบบ Graphic","name":"กระบวนจินตภาพคอมพิวเตอร์"}},"คณะดนตรี":{"สาขาวิชาธุรกิจดนตรี":{"jobsTH":["ผู้จัดการศิลปิน","นักร้อง","นักดนตรี"],"jobsENG":["Agents and Business Managers of Artists, Performers, and Athletes","Singers","Musicians, Instrumental"],"image":"นักดนตรี","name":"ธุรกิจดนตรี"},"สาขาวิชาการแสดงดนตรี":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"การแสดงดนตรี"}},"คณะวิทยาศาสตร์และเทคโนโลยี":{"สาขาวิชาวิทยาการคอมพิวเตอร์ ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมไฟฟ้าและอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรไฟฟ้า","วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electrical Engineers","Electronics Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้าและอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์และเครือข่าย":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์และเครือข่าย"},"สาขาวิชาวิศวกรรมโทรคมนาคมและอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ โทรคมนาคมและอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมเมคคาทรอนิกส์":{"jobsTH":["วิศวกรเมคคาทรอนิกส์"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ เมคคาทรอนิกส์"},"สาขาวิชาวิศวกรรมการบิน-วิชาเอกนักบินพาณิชย์ตรี":{"jobsTH":["นักบิน"],"jobsENG":["Pilots"],"image":"นักบิน (กัปตัน)","name":"วิศวะ การบิน นักบินพาณิชย์"},"สาขาวิชาวิศวกรรมการบิน-วิชาเอกซ่อมบำรุงอากาศยาน":{"jobsTH":["วิศวกรการบินและอวกาศ"],"jobsENG":["Aerospace Engineers"],"image":"ช่างเครื่องบิน","name":"วิศวะ การบิน ซ่อมบำรุง"}},"คณะสถาปัตยกรรมศาสตร์และการออกแบบ":{"สาขาวิชาสถาปัตยกรรมศาสตร์":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาสถาปัตยกรรมภายใน":{"jobsTH":["สถาปนิกภายใน"],"jobsENG":["Architects, Except Landscape and Naval","Interior Designers"],"image":"นักออกแบบภายใน","name":"สถาปัตย์ ภายใน"},"สาขาวิชาออกแบบภายใน":{"jobsTH":["นักออกแบบภายใน"],"jobsENG":["Interior Designers"],"image":"นักออกแบบภายใน","name":"ออกแบบภายใน"},"สาขาวิชาออกแบบผลิตภัณฑ์":{"jobsTH":["นักออกแบบผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบผลิตภัณฑ์","name":"ออกแบบผลิตภัณฑ์"}},"คณะบริหารธุรกิจและเศรษฐศาสตร์":{"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการเงินและการธนาคาร":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงินและธนาคาร"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"บัญชี","name":"บัญชี"},"สาขาวิชาระบบสารสนเทศธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศธุรกิจ"},"สาขาวิชาการจัดการการท่องเที่ยวและการบริการ":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยวและบริการ"},"สาขาวิชาการจัดการธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"สาขาวิชาธุรกิจอสังหาริมทรัพย์":{"jobsTH":["นายหน้า","ตัวแทนขายอสังหาริมทรัพย์","นักประเมินราคา","ผู้จัดการโครงการ"],"jobsENG":["Real Estate Brokers","Real Estate Sales Agents","Appraisers, Real Estate","Property, Real Estate, and Community Association Managers"],"image":"นายหน้าขายที่ดิน","name":"ธุรกิจอสังหาริมทรัพย์"},"สาขาวิชาการจัดการอุตสาหกรรม":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"การจัดการอุตสาหกรรม"},"สาขาวิชาการประกันภัย":{"jobsTH":["ตัวแทนประกันภัย","พนักงานนโยบายประกัยภัย","ผู้พิจารณาประกันภัย","ผู้เชี่ยวชาญการบริหารความเสี่ยง","ที่ปรึกษาการเงินส่วนบุคคล"],"jobsENG":["Insurance Sales Agents","Insurance Policy Processing Clerks","Insurance Underwriters","Risk Management Specialists","Personal Financial Advisors"],"image":"คนขายประกัน","name":"ประกันภัย"},"สาขาวิชาการจัดการ(กลุ่มวิชาพาณิชยศาสตร์)":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"สาขาวิชาเศรษฐศาสตร์ธุรกิจ":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาอังกฤษธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษธุรกิจ"},"สาขาวิชาภาษาฝรั่งเศสธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศสธุรกิจ"},"สาขาวิชาภาษาจีนธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีนธุรกิจ"},"สาขาวิชาภาษาญี่ปุ่นธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่นธุรกิจ"}},"คณะเทคโนโลยีชีวภาพ":{"สาขาวิชาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิชาเทคโนโลยีการอาหาร"},"สาขาวิชาอุตสาหกรรมเกษตร":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"นักวิจัยการเกษตร","name":"วิชาอุตสาหกรรมเกษตร"},"สาขาวิชาอุตสาหกรรมเกษตร และวิชาจุลชีววิทยาอุตสาหกรรม ( หลักสูตร 2 ปริญญา )":{"jobsTH":["นักวิทยาศาสตร์การเกษตร","ผู้ควบคุมการผลิต","นักจุลชีววิทยา"],"jobsENG":["Agricultural Technicians","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Microbiologists"],"image":"นักวิจัยการเกษตร","name":"วิชาอุตสาหกรรมเกษตร และวิชาจุลชีววิทยาอุตสาหกรรม ( หลักสูตร 2 ปริญญา )"}}},"มหาวิทยาลัยเกษตรศาสตร์ (วิทยาเขตสกลนคร)":{"คณะสาธารณสุขศาสตร์":{"สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุขศาสตร์"}},"คณะวิทยาศาสตร์และวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเครื่องกลและการผลิต":{"jobsTH":["วิศวกรเครื่องกล","วิศวกรการผลิต"],"jobsENG":["Mechanical Engineers","Manufacturing Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกลและการผลิต"},"สาขาวิชาวิศวกรรมไฟฟ้าและคอมพิวเตอร์":{"jobsTH":["วิศวกรไฟฟ้า","วิศวกรคอมพิวเตอร์"],"jobsENG":["Electrical Engineers","Computer Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้าและคอมพิวเตอร์"},"สาขาวิชาวิศวกรรมโยธาและสิ่งแวดล้อม":{"jobsTH":["วิศวกรโยธา","วิศวกรสิ่งแวดล้อม"],"jobsENG":["Civil Engineers","Environmental Engineers"],"image":"วิศวะกรโยธา","name":"วิศวะ โยธาและสิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาเคมีประยุกต์":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมีประยุกต์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"}},"คณะศิลปศาสตร์และวิทยาการการจัดการ":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"สาขาวิชาการจัดการโรงแรมและท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การจัดการโรงแรมและการท่องเที่ยว"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"}},"คณะทรัพยากรธรรมชาติและอุตสาหกรรมเกษตร":{"สาขาวิชาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาอาหารปลอดภัยและโภชนาการ":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"อาหารปลอดภัยและโภชนาการ"},"สาขาวิชาทรัพยากรเกษตร":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"ทรัพยากรเกษตร"},"สาขาวิชาทรัพยากรเกษตรและการจัดการการผลิต":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"ทรัพยากรเกษตรและการจัดการการผลิต"},"สาขาวิชาประมง (เพาะเลี้ยงสัตว์น้า)":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"เจ้าของฟาร์มเลี้ยงสัตว์","name":"สัตวศาสตร์"}}},"มหาวิทยาลัยมหิดล (วิทยาเขตอำนาจเจริญ)":{"คณะสาธารณสุขศาสตร์":{"สาธารณสุขศาสตรบัณฑิต":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่สาธารณสุข","name":"สาธารณสุขศาสตร์"}}},"มหาวิทยาลัยสงขลานครินทร์ (วิทยาเขตปัตตานี)":{"คณะพยาบาลศาสตร์":{"สาขาวิชาพยาบาลศาสตร์":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะรัฐศาสตร์":{"สาขาวิชาการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองการปกครอง"},"สาขาวิชาการปกครองท้องถิ่น":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"อบต.","name":"การปกครองท้องถิ่น"},"สาขาวิชาความสัมพันธ์ระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"สาขาวิชานโยบายสาธารณะ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"เจ้าหน้าที่กระทรวง","name":"นโยบายสาธารณะ"}},"คณะวิทยาการสื่อสาร":{"สาขาวิชานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"},"สาขาวิชานวัตกรรมการออกแบบและสร้างสรรค์สื่อ":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักออกแบบ Graphic","name":"ออกแบบและสร้างสรรค์สื่อ"},"สาขาวิชาเทคโนโลยีสารสนเทศและการสื่อสารเพื่อการจัดการ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศการสื่อสาร"}},"คณะศิลปกรรมศาสตร์":{"สาขาวิชาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"สาขาวิชาศิลปะประยุกต์":{"jobsTH":["นักออกแบบผลิตภัณฑ์","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Commercial and Industrial Designers","Graphic Designers","Art Directors"],"image":"ศิลปิน","name":"ศิลปะประยุกต์"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"สาขาวิชาบริหารธุรกิจ แขนงวิชาการจัดการทรัพยากรมนุษย์และองค์การ":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"สาขาวิชาเศรษฐศาสตร์แขนงวิชาเศรษฐศาสตร์การพัฒนา":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"สาขาวิชาเศรษฐศาสตร์แขนงวิชาเศรษฐกิจอาเซียน":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"สาขาวิชาภาษาและวรรณคดีไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"นักเขียน","name":"ภาษาและวรรณคดีไทย"},"สาขาวิชาภาษาจีน (หลักสูตรปกติ)":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาจีน (หลักสูตรนานาชาติ)":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาเกาหลี":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเกาหลี"},"สาขาวิชาภาษาอาหรับ - ภาษาอาหรับธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอาหรับ"},"สาขาวิชามลายูศึกษา":{"jobsTH":["นักการทูต","นักวิชาการมลายูศึกษา"],"jobsENG":["Public Relations Specialists","Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ผู้เชี่ยวชาญเกี่ยวกับประเทศมาเลเซีย","name":"มลายูศึกษา"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาวิชาการจัดการสารสนเทศ":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"การจัดการสารสนเทศ"},"สาขาวิชาสังคมวิทยาและมานุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Anthropologists","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"},"สาขาวิชาพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"พัฒนาสังคม"},"สาขาวิชาปรัชญาและศาสนา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญาและศาสนา"},"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"}},"วิทยาลัยอิสลามศึกษา":{"สาขาวิชาอิสลามศึกษา":{"jobsTH":["นักวิชาการอิสลามศึกษา"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"อิสลามศึกษา"},"สาขาวิชาอิสลามศึกษา (หลักสูตรนานาชาติ)":{"jobsTH":["นักวิชาการอิสลามศึกษา"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"อิสลามศึกษา"},"สาขาวิชาตะวันออกกลางศึกษา":{"jobsTH":["นักการทูต","นักวิชาการตะวันออกกลางศึกษา"],"jobsENG":["Public Relations Specialists","Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ผู้เชี่ยวชาญตะวันออกกลาง","name":"ตะวันออกกลางศึกษา"},"สาขาวิชากฎหมายอิสลาม":{"jobsTH":["ดะโต๊ะยุติธรรม","พนักงานคุมประพฤติ","นักกฎหมายอิสลาม"],"jobsENG":["Judges, Magistrate Judges, and Magistrates","Probation Officers and Correctional Treatment Specialists","Lawyers"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"กฎหมายอิสลาม"},"สาขาวิชาการสอนอิสลามศึกษา":{"jobsTH":["ครูสอนอิสลามศึกษา"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ครูสอนอิสลามศึกษา","name":"การสอนอิสลามศึกษา"},"สาขาวิชาเศรษฐศาสตร์และการจัดการในอิสลาม":{"jobsTH":["ผู้จัดการด้านการเงิน","ผู้บริหารงานทั่วไป","นักเศรษฐศาสตร์"],"jobsENG":["Financial Managers, Branch or Department","General and Operations Managers","Economists"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"เศรษฐศาสตร์และการจัดการในอิสลาม"}},"คณะศึกษาศาสตร์":{"วิชาเอกเคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา เคมี"},"วิชาเอกฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ฟิสิกส์"},"วิชาเอกชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ชีววิทยา"},"วิชาเอกวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา วิทยาศาสตร์ทั่วไป"},"วิชาเอกคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"วิชาเอกสุขศึกษา":{"jobsTH":["ครูสุขศึกษา"],"jobsENG":["Health Educators"],"image":"ครูสอนสุขศึกษา","name":"ศึกษา สุขศึกษา"},"วิชาเอกเทคโนโลยีสารสนเทศและการประเมินผลการศึกษา":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ศึกษา เทคโนโลยีสารสนเทศและการประเมินผลการศึกษา"},"วิชาเอกจิตวิทยา":{"jobsTH":["ครูแนะแนว"],"jobsENG":["Educational, Guidance, School, and Vocational Counselors"],"image":"ครูแนะแนว","name":"ศึกษา จิตวิทยา"},"วิชาเอกการประถมศึกษา":{"jobsTH":["ครูประถม"],"jobsENG":["Elementary School Teachers"],"image":"ครูประถม","name":"ศึกษา การประถมศึกษา"},"วิชาเอกพลศึกษา":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูสอนพลศึกษา","name":"ศึกษา พลศึกษา"},"วิชาเอกศิลปศึกษา":{"jobsTH":["ครูสอนศิลปะ"],"jobsENG":["Art, Drama, and Music Teachers"],"image":"ครูสอนศิลปะ","name":"ศึกษา ศิลปศึกษา"},"วิชาเอกเทคโนโลยีและสื่อสารการศึกษา":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ศึกษา เทคโนโลยีและสื่อสารการศึกษา"},"วิชาเอกภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูภาษาไทย","name":"ศึกษา ภาษาไทย"},"วิชาเอกภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"}},"คณะวิทยาศาสตร์และเทคโนโลยี":{"สาขาวิชาเทคโนโลยียาง":{"jobsTH":["นักวิทยาศาสตร์ยาง"],"jobsENG":["Materials Scientists"],"image":"นักวิทยาศาสตร์ยาง","name":"เทคโนโลยียาง"},"สาขาวิชาเทคโนโลยีการประมง(การเพาะเลี้ยงสัตว์น้าชายฝั่ง)":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"เทคโนโลยีการประมง(การเพาะเลี้ยงสัตว์น้าชายฝั่ง)"},"สาขาวิชาเทคโนโลยีการประมง(อุตสาหกรรมผลิตภัณฑ์ประมง)":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์","นักเทคโนโลยีการเกษตร"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders","Agricultural Technicians"],"image":"ชาวประมง","name":"เทคโนโลยีการประมง(อุตสาหกรรมผลิตภัณฑ์ประมง)"},"สาขาวิชาเทคโนโลยีการเกษตร(เทคโนโลยีการผลิตพืช)":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีการเกษตร(เทคโนโลยีการผลิตพืช)"},"สาขาวิชาเทคโนโลยีการเกษตร(เทคโนโลยีการผลิตสัตว์)":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์","นักเทคโนโลยีการเกษตร"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders","Agricultural Technicians"],"image":"เจ้าของฟาร์มเลี้ยงสัตว์","name":"เทคโนโลยีการเกษตร(เทคโนโลยีการผลิตสัตว์)"},"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาวิทยาศาสตร์การอาหารและโภชนาการ":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์การอาหารและโภชนาการ"},"สาขาวิชาเคมี - ชีววิทยา":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี","นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators","Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี - ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาเคมีอุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมีอุตสาหการ","name":"เคมีอุตสาหกรรม"},"สาขาวิชาวิทยาศาสตร์นิเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"วิทยาศาสตร์นิเทศ"},"สาขาวิชาโภชนศาสตร์และการกำหนดอาหาร":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"โภชนศาสตร์และการกำหนดอาหาร"}}},"มหาวิทยาลัยเกษตรศาสตร์":{"คณะสัตวแพทย์":{"สัตวแพทยศาสตรบัณฑิต":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะเทคนิคการสัตวแพทย์":{"สาขาวิชาเทคนิคการสัตวแพทย์":{"jobsTH":["นักเทคนิคการแพทย์สัตว์"],"jobsENG":["Veterinary Technologists and Technicians"],"image":"นักเทคนิคสัตวแพทย์","name":"เทคนิคสัตวแพทย์"},"สาขาวิชาการพยาบาลสัตว์":{"jobsTH":["พยาบาลดูแลสัตว์"],"jobsENG":["Veterinary Assistants and Laboratory Animal Caretakers"],"image":"พยาบาลสัตว์","name":"พยาบาลสัตว์"}}},"มหาวิทยาลัยกรุงเทพ":{"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะนิเทศศาสตร์":{"สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"ประชาสัมพันธ์"},"สาขาวิชาวารสารศาสตร์":{"jobsTH":["บรรณาธิการ","นักเขียน","ผู้ประกาศข่าว","นักประชาสัมพันธ์"],"jobsENG":["Copy Editors","Writers and Authors","Radio and TV Announcers","Public Relations Specialists"],"image":"บรรณาธิการวารสาร","name":"วารสาร"},"สาขาวิชาการโฆษณา":{"jobsTH":["ผู้ผลิตสื่อโฆษณา","ตัวแทนขายโฆษณา","ผู้จัดการฝ่ายโฆษณาองค์กร"],"jobsENG":["Copy Writers","Advertising Sales Agents","Advertising Managers"],"image":"คนโฆษณาสินค้า","name":"โฆษณา"},"สาขาวิชาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปะการแสดง"},"สาขาวิชาวิทยุกระจายเสียงและวิทยุโทรทัศน์":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"วิทยุโทรทัศน์"},"สาขาวิชาภาพยนตร์":{"jobsTH":["ผู้กำกับ","นักเขียนบท","นักตัดต่อภาพยนตร์"],"jobsENG":["Directors","Writers and Authors","Film and Video Editors"],"image":"ผู้กำกับภาพยนตร์","name":"ภาพยนตร์"},"สาขาวิชาการสื่อสารตรา":{"jobsTH":["ผู้จัดการแบรนด์","นักสื่อสารการตลาด"],"jobsENG":["Marketing Managers","Online Marketing Strategists"],"image":"นักธุรกิจ","name":"การสื่อสารตรา"}},"คณะศิลปกรรมศาสตร์":{"สาขาวิชาการออกแบบนิเทศศิลป์":{"jobsTH":["จิตรกร/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers","Art Directors"],"image":"นักออกแบบ Graphic","name":"การออกแบบนิเทศศิลป์"},"สาขาวิชาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"สาขาวิชาการออกแบบแฟชั่น และสิ่งทอ":{"jobsTH":["นักออกแบบแฟชั่น","ช่างตัดเย็บ","ช่างแต่งหน้าทำผม"],"jobsENG":["Fashion Designers","Tailors, Dressmakers, and Custom Sewers","Hairdressers, Hairstylists, and Cosmetologists"],"image":"นักออกแบบแฟชัน","name":"การออกแบบแฟชั่นและสิ่งทอ"},"สาขาวิชาการออกแบบผลิตภัณฑ์":{"jobsTH":["นักออกแบบผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบผลิตภัณฑ์","name":"การออกแบบผลิตภัณฑ์"}},"คณะวิทยาศาสตร์และเทคโนโลยี":{"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาวิศวกรรมซอฟต์แวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวกรรมซอฟต์แวร์"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมมัลติมีเดียและระบบอินเทอร์เน็ต":{"jobsTH":["ผู้จัดการโครงการด้านไอที","นักสร้างสรรค์สื่อมัลติมีเดีย","นักพัฒนาซอฟต์แวร์","นักพัฒนาเว็บไซต์","นักตัดต่อ"],"jobsENG":["Information Technology Project Managers","Multimedia Artists and Animators","Software Developers, Applications","Web Developers","Film and Video Editors"],"image":"วิศวกรมัลติมีเดีย","name":"วิศวะ มัลติมีเดียและระบบอินเทอร์เน็ต"}},"คณะสถาปัตยกรรมศาสตร์":{"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรศิลปบัณฑิต สาขาวิชาการออกแบบภายใน":{"jobsTH":["นักออกแบบภายใน"],"jobsENG":["Interior Designers"],"image":"นักออกแบบภายใน","name":"ออกแบบภายใน"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"คอมพิวเตอร์ธุรกิจ"},"สาขาวิชาการจัดการธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"สาขาวิชาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"}},"คณะบัญชี":{"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"บัญชี","name":"บัญชี"}},"วิทยาลัยนานาชาติ":{"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักข่าว","name":"นิเทศศาสตร์"},"สาขาวิชาภาษาอังกฤษธุรกิจ":{"jobsTH":["ล่าม/นักแปล"],"jobsENG":["Interpreters and Translators"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษธุรกิจ"},"สาขาวิชาการจัดการท่องเที่ยวนานาชาติ":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"จัดการท่องเที่ยว"},"สาขาวิชาคอมพิวเตอร์กราฟิกส์และมัลติมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developers"],"image":"นักออกแบบ Graphic","name":"คอมพิวเตอร์กราฟิกและมัลติมีเดีย"}},"คณะการสร้างเจ้าของธุรกิจและการบริหารกิจการ หลักสูตรบริหารธุรกิจบัณฑิต":{"สาขาวิชาการเป็นเจ้าของธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การเป็นเจ้าของธุรกิจ"},"สาขาวิชาความเป็นผู้ประกอบการ (หลักสูตรนานาชาติ)":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"ผู้ประกอบการ"}},"คณะมนุษยศาสตร์และการจัดการการท่องเที่ยว":{"สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"มัคคุเทศก์","name":"จัดการการท่องเที่ยว"},"สาขาวิชาการจัดการการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"จัดการการโรงแรม"},"สาขาวิชาการจัดการธุรกิจสายการบิน":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","ตัวแทนขนส่ง","ตัวแทนจองตั๋วโดยสาร"],"jobsENG":["Flight Attendants","Cargo and Freight Agents","Reservation and Transportation Ticket Agents and Travel Clerks"],"image":"ผู้จัดการสายการบิน","name":"จัดการธุรกิจสายการบิน"},"สาขาวิชาการจัดการการโรงแรมและภัตตาคาร (หลักสูตรนานาชาติ)":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ผู้จัดการด้านบริการอาหาร"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Food Service Managers"],"image":"ผู้จัดการโรงแรม","name":"จัดการโรงแรมและภัตตาคาร"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาจีนเพื่อการท่องเที่ยวและการโรงแรม":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"ภาษาจีนเพื่อการท่องเที่ยวและการโรงแรม"},"สาขาวิชาภาษาจีนเพื่อธุรกิจระหว่างประเทศ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"นักธุรกิจจีน","name":"ภาษาจีนเพื่อธุรกิจระหว่างประเทศ"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}}},"มหาวิทยาลัยเกษตรศาสตร์ (วิทยาเขตบางเขน)":{"คณะสังคมศาสตร์":{"สาขาวิชานิติศาสตร์":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"},"สาขาวิชารัฐศาสตร์ การปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองการปกครอง"},"สาขาวิชารัฐศาสตร์ รัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"สาขาวิชารัฐศาสตร์ ความสัมพันธ์ระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"},"สาขาวิชารัฐศาสตร์ บริหารงานยุติธรรมและความปลอดภัย":{"jobsTH":["ตำรวจ","เจ้าพนักงานสอบสวน","นักการเมืองและนักบริหารภาครัฐ","เจ้าพนักงานคุมประพฤติ","เจ้าพนักงานราชทัณฑ์"],"jobsENG":["Police Officers","Detectives and Investigators","Political Scientists and Public Administrators","Probation Officers","Correctional Officers"],"image":"เจ้าพนักงานคุมประพฤติ","name":"บริหารงานยุติธรรม"},"สาขาวิชาจิตวิทยา (สาขาจิตวิทยาอุตสาหกรรมและองค์การ)":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Industrial-Organizational Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยาอุตสาหกรรมและองค์กร"},"สาขาวิชาจิตวิทยา (สาขาจิตวิทยาคลินิก)":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Clinical Psychologists"],"image":"ผู้ให้คำปรึกษาด้านจิตวิทยา","name":"จิตวิทยาคลินิก"},"สาขาวิชาจิตวิทยา (สาขาจิตวิทยาพัฒนาการ)":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["School Psychologists"],"image":"ผู้ให้คำปรึกษาด้านการเรียนรู้และพัฒนาของเด็ก","name":"จิตวิทยาพัฒนาการ"},"สาขาวิชาจิตวิทยา (สาขาจิตวิทยาชุมชน)":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยาชุมชน"},"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาวิชาสังคมวิทยาและมานุษยวิทยา":{"jobsTH":["นักมานุษยวิทยา","นักสังคมวิทยา"],"jobsENG":["Anthropologists","Sociologists"],"image":"นักสังคมวิทยา","name":"สังคมวิทยาและมานุษยวิทยา"}},"คณะมนุษยศาสตร์":{"สาขาวิชาสื่อสารมวลชน":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"สื่อสารมวลชน"},"สาขาวิชาปรัชญาและศาสนา":{"jobsTH":["นักปรัชญา"],"jobsENG":["Philosophy and Religion Teachers, Postsecondary"],"image":"นักคิด","name":"ปรัชญาและศาสนา"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาเยอรมัน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเยอรมัน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาวรรณคดี กลุ่มวรรณคดีไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"วรรณคดีไทย"},"สาขาวิชาวรรณคดี กลุ่มวรรณคดีอังกฤษ":{"jobsTH":["นักเขียน","ครูสอนภาษาต่างประเทศ","ล่าม/นักแปล"],"jobsENG":["Poets, Lyricists and Creative Writers","Foreign Language and Literature Teachers, Postsecondary","Interpreters and Translators"],"image":"นักเขียน","name":"วรรณคดีอังกฤษ"},"สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยว"},"สาขาวิชาภาษาตะวันออก กลุ่มวิชาภาษาจีนธุรกิจ ภาคพิเศษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีนธุรกิจ"},"สาขาวิชาภาษาตะวันออก กลุ่มวิชาภาษาญี่ปุ่นธุรกิจ ภาคพิเศษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่นธุรกิจ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมการบินและอวกาศ":{"jobsTH":["วิศวกรการบินและอวกาศ"],"jobsENG":["Aerospace Engineers"],"image":"ช่างเครื่องบิน","name":"วิศวะ การบินและอวกาศ"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมไฟฟ้าเครื่องกลการผลิต":{"jobsTH":["วิศวกรไฟฟ้า","วิศวกรเครื่องกล","วิศวกรการผลิต"],"jobsENG":["Electrical Engineers","Mechanical Engineers","Manufacturing Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้าเครื่องกลการผลิต"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมโยธา-ทรัพยากรน้ำ":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ วัสดุ"},"สาขาวิชาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"}},"สถาบันสมทบวิทยาลัยชลประทาน":{"สาขาวิชาวิศวกรรมโยธา-ชลประทาน":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา-ชลประทาน"}},"คณะสถาปัตยกรรมศาสตร์":{"สาขาวิชาสถาปัตยกรรมศาสตร์":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาภูมิสถาปัตยกรรมศาสตร์":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"สาขาวิชาการจัดการการผลิต":{"jobsTH":["ผู้จัดการฝ่ายผลิต","ผู้จัดการฝ่ายจัดซื้อ","ผู้บริหารระดับสูง"],"jobsENG":["Industrial Production Managers","Purchasing Managers","ผู้บริหารระดับสูง"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการการผลิต"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศึกษาศาสตร์":{"สาขาวิชาการสอนคณิตศาสตร์ (หลักสูตร 5 ปี)":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"การสอนคณิตศาสตร์"},"สาขาวิชาการสอนวิทยาศาสตร์ (หลักสูตร 5 ปี)":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"การสอนวิทยาศาสตร์"},"สาขาวิชาคหกรรมศาสตรศึกษา (หลักสูตร 5 ปี)":{"jobsTH":["ครูสอนคหกรรม"],"jobsENG":["Agricultural Sciences Teachers"],"image":"ครูสอนคหกรรม","name":"คหกรรมศาสตรศึกษา"},"สาขาวิชาธุรกิจและคอมพิวเตอร์ศึกษา (หลักสูตร 5 ปี)":{"jobsTH":["ครูสอนด้านธุรกิจ","ครูสอนคอมพิวเตอร์"],"jobsENG":["Business Teachers","Computer Science Teachers"],"image":"ครูสอนบัญชี","name":"ธุรกิจและคอมพิวเตอร์ศึกษา"},"สาขาวิชาสุขศึกษา (หลักสูตร 5 ปี)":{"jobsTH":["ครูสุขศึกษา"],"jobsENG":["Health Educators"],"image":"ครูสอนสุขศึกษา","name":"สุขศึกษา"},"สาขาวิชาพลศึกษา (หลักสูตร 5 ปี)":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูสอนพลศึกษา","name":"พลศึกษา"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาเคมีอุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมีอุตสาหการ","name":"เคมีอุตสาหกรรม"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาสัตววิทยา":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตววิทยา"},"สาขาวิชาพฤกษศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พฤกษศาสตร์"},"สาขาวิชาพันธุศาสตร์":{"jobsTH":["นักพันธุศาสตร์","ที่ปรึกษาด้านพันธุกรรม"],"jobsENG":["Geneticists","Genetic Counselors"],"image":"นักวิทยาศาสตร์ gregor mendel","name":"พันธุศาสตร์"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาชีวเคมี":{"jobsTH":["นักชีวเคมี"],"jobsENG":["Biochemists and Biophysicists"],"image":"นักวิทยาศาสตร์ชีวเคมี","name":"ชีวเคมี"},"สาขาวิชาวิทยาศาสตร์ชีวภาพรังสี (เรียนเหมือนเทคนิคการแพทย์รังสี แต่เรียนรังสีในพืชในสัตว์ด้วย ทำงานในห้องรังสีแบบเทคนิคการแพทย์ได้ แต่เป็นผู้แนะนำนักรังสีวิทยาอีกที)":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา","นักเทคนิครังสี"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians","Radiologic Technicians"],"image":"นักรังสีวิทยา","name":"วิทยาศาสตร์ชีวภาพรังสี"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาวิทยาศาสตร์พื้นพิภพ":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักธรณีวิทยา","name":"วิทยาศาสตร์พื้นพิภพ"},"สาขาวิชาวิทยาศาสตร์นิวเคลียร์ (เรียนเกี่ยวกับนิวเคลียร์) ถ้าใช้คำว่า physicist จะเหมาะสมไหมครับ คิดว่าใกล้เคียงสุดแล้ว)":{"jobsTH":["นักวิทยาศาสตร์นิวเคลียร์"],"jobsENG":["Nuclear Monitoring Technicians"],"image":"นักวิทยาศาสตร์นิวเคลียร์","name":"วิทยาศาสตร์นิวเคลียร์"},"สาขาวิชาวิทยาการคอมพิวเตอร์ ภาคพิเศษ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาสถิติ ภาคพิเศษ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาวิทยาศาสตร์ชีวภาพและเทคโนโลยี (หลักสูตรนานาชาติ)":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์ชีวภาพและเทคโนโลยี"}},"คณะเกษตร":{"สาขาวิชาวิทยาศาสตร์เกษตร":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"วิทยาศาสตร์เกษตร"},"สาขาวิชาการจัดการศัตรูพืชและสัตว์":{"jobsTH":["นักวิจัยศัตรูพืชและสัตว์"],"jobsENG":["Soil and Plant Scientists"],"image":"เกษตรกรฉีดยาฆ่าหญ้า","name":"การจัดการศัตรูพืชและสัตว์"},"สาขาวิชาเคมีการเกษตร":{"jobsTH":["เจ้าหน้าที่ควบคุมศัตรูพืช","นักวิจัยและพัฒนา","นักวิทยาศาสตร์การเกษตร"],"jobsENG":["Pesticide Handlers, Sprayers, and Applicators, Vegetation","Research and Development Scientists","Agricultural Technicians"],"image":"นักวิจัยสารเคมีเกษตร","name":"เคมีการเกษตร"},"สาขาวิชาคหกรรมศาสตร์":{"jobsTH":["นักโภชนาการ","นักออกแบบ","นักพัฒนาชุมชน"],"jobsENG":["Dietitians and Nutritionists","Floral Designers","Social and Community Service Managers"],"image":"ครูสอนการงานอาชีพ","name":"คหกรรมศาสตร์"},"สาขาวิชาอาหารและโภชนาการ":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"อาหารและโภชนาการ"},"สาขาวิชาเกษตรเขตร้อน":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวสวนแบบไฮโซ","name":"เกษตรเขตร้อน"},"สาขาวิชาเกษตรเขตร้อน นานาชาติ":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวสวนแบบไฮโซ","name":"เกษตรเขตร้อน"}},"คณะวนศาสตร์":{"สาขาวิชาวนศาสตร์":{"jobsTH":["นักอนุรักษ์ป่าไม้","ที่ปรึกษาด้านเกษตรกรรม","นักวิทยาศาสตร์สิ่งแวดล้อม"],"jobsENG":["Forest and Conservation Technicians","Farm and Home Management Advisors","Environmental Scientists and Specialists, Including Health"],"image":"เจ้าหน้าที่ป่าไม้","name":"วนศาสตร์"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีทางไม้":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"ช่างไม้","name":"วิทยาศาสตร์และเทคโนโลยีทางไม้"},"สาขาวิชาเทคโนโลยีเยื่อและกระดาษ":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"คนผลิตกระดาษ","name":"เทคโนโลยีเยื่อและกระดาษ"}},"คณะอุตสาหกรรมการเกษตร":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีสิ่งทอ":{"jobsTH":["นักวิทยาศาสตร์และเทคโนโลยีสิ่งทอ"],"jobsENG":["Materials Scientists"],"image":"นักวิทยาศาสตร์สิ่งทอ","name":"วิทยาศาสตร์และเทคโนโลยีสิ่งทอ"},"สาขาวิชาวิศวกรรมอาหาร":{"jobsTH":["นักวิจัยพัฒนาผลิตภัณฑ์","วิศวกรฝ่ายขาย","ผู้จัดการฝ่ายผลิต"],"jobsENG":["Commercial and Industrial Designers","Sales Engineers","Industrial Production Managers"],"image":"วิศวกรผลิตอาหาร","name":"วิศวกรรมอาหาร"}},"คณะประมง":{"สาขาวิชาประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}},"คณะสิ่งแวดล้อม":{"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์สิ่งแวดล้อม"}}},"มหาวิทยาลัยขอนแก่น (วิทยาลัยหนองคาย)":{"คณะสังคมศาสตร์บูรณาการ":{"สาขาวิชานิติศาสตร์":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"},"สาขาวิชารัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"สาขาวิชาเศรษฐศาสตร์":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยว"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"บัญชี","name":"บัญชี"}}},"มหาวิทยาลัยบูรพา (วิทยาเขตสระแก้ว)":{"คณะวิทยาศาสตร์และสังคมศาสตร์":{"รัฐประศาสนศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"คอมพิวเตอร์ธุรกิจ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"จัดการทรัพยากรมนุษย์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการจัดการโลจิสติกส์และการค้าชายแดน":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"จัดการโลจิสติกส์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาทรัพยากรธรรมชาติและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"ทรัพยากรธรรมชาติและสิ่งแวดล้อม"}},"คณะเทคโนโลยีการเกษตร":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาเทคโนโลยีผลิตภัณฑ์ธรรมชาติ":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาผลิตภัณฑ์","name":"เทคโนโลยีผลิตภัณฑ์ธรรมชาติ"}}},"มหาวิทยาลัยแม่โจ้ (แพร่)":{"คณะรัฐศาสตร์":{"รัฐศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐศาสตร์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"สาขาวิชาระบบสารสนเทศธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศธุรกิจ"},"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะศิลปศาสตร์":{"สาขาวิชาพัฒนาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"มัคคุเทศก์","name":"พัฒนาการท่องเที่ยว"},"สาขาวิชาการจัดการชุมชน":{"jobsTH":["ผู้นำชุมชน","นักบริการชุมชน"],"jobsENG":["Property, Real Estate, and Community Association Managers","Social and Community Service Managers"],"image":"นักพัฒนาชนบท","name":"การจัดการชุมชน"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเทคโนโลยีการผลิตพืช":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการผลิตพืช"},"สาขาวิชาเทคโนโลยีการผลิตสัตว์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์","นักเทคโนโลยีการเกษตร"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders","Agricultural Technicians"],"image":"นักวิจัยสัตว์ป่า","name":"เทคโนโลยีการผลิตสัตว์"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาเกษตรป่าไม้":{"jobsTH":["นักป่าไม้","นักอนุรักษ์ป่าไม้"],"jobsENG":["Foresters","Forest and Conservation Technicians"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"เกษตรป่าไม้"}}},"มหาวิทยาลัยแม่โจ้ (ชุมพร)":{"คณะรัฐศาสตร์":{"รัฐศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐศาสตร์"}},"คณะศิลปศาสตร์":{"สาขาวิชาพัฒนาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"มัคคุเทศก์","name":"พัฒนาการท่องเที่ยว"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเทคโนโลยีการผลิตพืช":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการผลิตพืช"},"สาขาวิชาการประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}}},"มหาวิทยาลัยธรรมศาสตร์ (ศูนย์ลำปาง)":{"คณะศิลปกรรมศาสตร์":{"สาขาวิชาออกแบบหัตถอุตสาหกรรม":{"jobsTH":["นักออกแบบผลิตภัณฑ์","ช่างฝีมือ"],"jobsENG":["Commercial and Industrial Designers","Craft Artists"],"image":"นักออกแบบหัตถกรรม","name":"ออกแบบหัตถอุตสาหกรรม"}},"วิทยาลัยสหวิทยาการ":{"สาขาสหวิทยาการสังคมศาสตร์":{"jobsTH":["นักสังคมศาสตร์"],"jobsENG":["Sociologists"],"image":"นักสังคมศาสตร์","name":"สังคมศาสตร์"},"สาขาปรัชญา การเมือง และเศรษฐศาสตร์":{"jobsTH":["นักเขียน/นักคิด","นักการเมือง","นักเศรษฐศาสตร์"],"jobsENG":["Poets, Lyricists and Creative Writers","Political Scientists","Economists"],"image":"นักการเมือง","name":"ปรัชญา การเมือง เศรษฐศาสตร์"}}},"มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี":{"คณะครุศาสตร์อุตสาหกรรมและเทคโนโลยี":{"หลักสูตรศิลปบัณฑิต สาขาวิชามีเดียอาตส์":{"jobsTH":["นักออกแบบกราฟิก","นักออกแบบสื่อมัลติมีเดียแอนิเมชัน"],"jobsENG":["Graphic Designers","Multimedia Artists and Animators"],"image":"นักออกแบบ Graphic","name":"มีเดียอาตส์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีการพิมพ์และบรรจุภัณฑ์":{"jobsTH":["ผู้ประกอบการโรงพิมพ์","ผู้ปฏิบัติการด้านบรรจุภัณฑ์","นักออกแบบผลิตภัณฑ์"],"jobsENG":["Printing Press Operators","Packaging and Filling Machine Operators and Tenders","Commercial and Industrial Designers"],"image":"นักพัฒนาบรรจุภัณฑ์","name":"เทคโนโลยีการพิมพ์และบรรจุภัณฑ์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคอมพิวเตอร์ประยุกต์–มัลติมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักออกแบบ Graphic","name":"คอมพิวเตอร์ประยุกต์–มัลติมีเดีย"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักออกแบบ Graphic","name":"เทคโนโลยีมีเดีย"},"หลักสูตรเทคโนโลยีบัณฑิต สาขานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักข่าว","name":"นิเทศศาสตร์"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาเทคโนโลยีคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"เทคโนโลยีคอมพิวเตอร์"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาเทคโนโลยีการศึกษาทางการแพทย์":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีการศึกษาทางการแพทย์"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมเครื่องกล"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมโยธา"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมไฟฟ้า"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมอุตสาหการ"}},"คณะเทคโนโลยีสารสนเทศ":{"สาขาวิชาวิทยาการคอมพิวเตอร์ Computer Science (หลักสูตรภาษาอังกฤษ)":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ Information Technology (หลักสูตรภาษาไทย)":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมระบบควบคุมและเครื่องมือวัด":{"jobsTH":["วิศวกรระบบควบคุมและเครื่องมือวัด"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรระบบควบคุมและเครื่องมือวัด","name":"วิศวะ ระบบควบคุมและเครื่องมือวัด"},"สาขาวิชาวิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรไฟฟ้า","วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electrical Engineers","Electronics Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้าสื่อสารและอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมเมคคาทรอนิกส์":{"jobsTH":["วิศวกรเมคคาทรอนิกส์"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ เมคคาทรอนิกส์"},"สาขาวิชาวิศวกรรมเครื่องมือ":{"jobsTH":["วิศวกรเครื่องมือ"],"jobsENG":["Manufacturing Engineers"],"image":"วิศวกรผลิตเครื่องมือ","name":"วิศวะ เครื่องมือ"},"สาขาวิชาวิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ วัสดุ"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิชาวิศวกรรมเครื่องกล (พลังงาน เศรษฐศาสตร์และสิ่งแวดล้อม)":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมไฟฟ้า (ระบบไฟฟ้าอิเล็กทรอนิกส์กำลังและพลังงาน":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมโยธา (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์ (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมเคมี (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมไฟฟ้าสื่อสารและอิเล็กทรอนิกส์ (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรไฟฟ้า","วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electrical Engineers","Electronics Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้าสื่อสารและอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมอัตโนมัติ (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรอัตโนมัติ"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ อัตโนมัติ"},"สาขาวิชาวิศวกรรมสิ่งแวดล้อม (หลักสูตรนานาชาติ)":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาฟิสิกส์ประยุกต์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาวิทยาการคอมพิวเตอร์ประยุกต์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์ประยุกต์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"}}},"มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ (วิทยาเขตศาลายา)":{"วิทยาลัยช่างทองหลวง":{"สาขางานช่างทองหลวง":{"jobsTH":["ช่างศิลป์ไทย"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"ช่างศิลป์ไทย","name":"ช่างทองหลวง"}}},"สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง":{"คณะเทคโนโลยีสารสนเทศ":{"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมโทรคมนาคม":{"jobsTH":["วิศวกรโทรคมนาคม"],"jobsENG":["Telecommunications Engineering Specialists"],"image":"วิศวกรโทรคมนาคม","name":"วิศวะ โทรคมนาคม"},"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมระบบควบคุม":{"jobsTH":["วิศวกรระบบควบคุมและเครื่องมือวัด"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ระบบควบคุม"},"สาขาวิชาวิศวกรรมการวัดคุม":{"jobsTH":["วิศวกรระบบควบคุมและเครื่องมือวัด"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ การวัดคุม"},"สาขาวิชาวิศวกรรมสารสนเทศ":{"jobsTH":["วิศวกรสารสนเทศ"],"jobsENG":["Computer Engineers"],"image":"วิศวกร IT","name":"วิศวะ สารสนเทศ"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมเกษตร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ เกษตร"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาวิศวกรรมอาหาร":{"jobsTH":["วิศวกรอาหาร"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรผลิตอาหาร","name":"วิศวะ อาหาร"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมแมคคาทรอนิกส์":{"jobsTH":["วิศวกรเมคคาทรอนิกส์"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ แมคคาทรอนิกส์"},"สาขาวิชาวิศวกรรมอัตโนมัติ":{"jobsTH":["วิศวกรอัตโนมัติ"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ อัตโนมัติ"},"สาขาวิชาวิศวกรรมพลังงานไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ พลังงานไฟฟ้า"},"สาขาวิชาวิศวกรรมชีวการแพทย์":{"jobsTH":["วิศวกรชีวการแพทย์"],"jobsENG":["Biomedical Engineers"],"image":"วิศวกรชีวการแพทย์","name":"วิศวะ ชีวการแพทย์"}},"วิทยาลัยนานาชาติ":{"วิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมซอฟต์แวร์ (หลักสูตรนานาชาติ)":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวะ ซอฟต์แวร์"}},"วิทยาลัยการบริหารและจัดการ":{"สาขาวิชาบริหารธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"}},"คณะครุศาสตร์อุตสาหกรรม":{"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาครุศาสตร์วิศวกรรม":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรม"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาครุศาสตร์การออกแบบ":{"jobsTH":["ครูสอนด้านออกแบบ"],"jobsENG":["Architecture Teachers, Postsecondary"],"image":"ครูสอนออกแบบ","name":"ครุ การออกแบบ"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาการออกแบบสภาพแวดล้อมภายใน":{"jobsTH":["ครูสอนด้านออกแบบ"],"jobsENG":["Architecture Teachers, Postsecondary"],"image":"ครูสอนออกแบบ","name":"ครุ การออกแบบสภาพแวดล้อมภายใน"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาสถาปัตยกรรม":{"jobsTH":["ครูสอนสถาปัตยกรรม"],"jobsENG":["Architecture Teachers"],"image":"ครูสอนสถาปัตย์","name":"ครุ สถาปัตยกรรม"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาครุศาสตร์เกษตร":{"jobsTH":["ครูสอนการเกษตร"],"jobsENG":["Agricultural Sciences Teachers"],"image":"ครูสอนการเกษตร","name":"ครุ เกษตร"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเคมีอุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักเคมีอุตสาหกรรม","name":"เคมีอุตสาหกรรม"},"สาขาวิชาเคมีสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักเคมีสิ่งแวดล้อม","name":"เคมีสิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาจุลชีววิทยาอุตสาหกรรม":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยาอุตสาหกรรม"},"สาขาวิชาฟิสิกส์ประยุกต์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์"},"สาขาวิชาสถิติประยุกต์":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติประยุกต์"}},"คณะเทคโนโลยีการเกษตร":{"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตวศาสตร์"},"สาขาวิชาวิทยาศาสตร์การประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"วิทยาศาสตร์การประมง"},"สาขาวิชาพัฒนาการเกษตร":{"jobsTH":["นักพัฒนาชุมชน","นักประชาสัมพันธ์การเกษตร","นักวิทยาศาสตร์การเกษตร"],"jobsENG":["Social and Community Service Managers","Public Relations Specialists","Agricultural Technicians"],"image":"นักวิจัยการเกษตร","name":"พัฒนาการเกษตร"},"สาขาวิชานิเทศศาสตร์เกษตร":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"เกษตรอำเภอ","name":"นิเทศศาสตร์เกษตร"},"สาขาวิชาการจัดการทรัพยากรดินและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสร์สิ่งแวดล้อม","นักวิจัยดิน","นักอนุรักษ์ทรัพยากรดิน"],"jobsENG":["Environmental Scientists and Specialists, Including Health","Soil and Plant Scientists","Soil and Water Conservationists"],"image":"นักอนุรักษ์","name":"การจัดการทรัพยากรดินและสิ่งแวดล้อม"},"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"}},"คณะอุตสาหกรรมการเกษตร":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาเทคโนโลยีการหมักในอุตสาหกรรม":{"jobsTH":["ผู้ควบคุมคุณภาพในการผลิต","นักวิจัยและพัฒนา"],"jobsENG":["Quality Control Analysts","Research and Development Scientists"],"image":"เจ้าของโรงเบียร์","name":"เทคโนโลยีการหมักในอุตสาหกรรม"},"สาขาวิชาวิศวกรรมแปรรูปอาหาร":{"jobsTH":["นักวิจัยพัฒนาผลิตภัณฑ์","วิศวกรฝ่ายขาย","ผู้จัดการฝ่ายผลิต"],"jobsENG":["Commercial and Industrial Designers","Sales Engineers","Industrial Production Managers"],"image":"วิศวกรผลิตอาหาร","name":"วิศวกรรมแปรรูปอาหาร"}}},"มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ (วิทยาเขตปราจีนบุรี)":{"คณะเทคโนโลยีและการจัดการอุตสาหกรรม":{"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคอมพิวเตอร์ช่วยออกแบบและบริหารงานก่อสร้าง":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"คอมพิวเตอร์ช่วยออกแบบและบริหารงานก่อสร้าง"}}},"มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าพระนครเหนือ":{"วิทยาลัยเทคโนโลยีอุตสาหกรรม":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาการจัดการเทคโนโลยีการผลิตและสารสนเทศ (โครงการสมทบพิเศษ)":{"jobsTH":["นักเทคโนโลยีจัดการการผลิต","โปรแกรมเมอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Manufacturing Production Technicians","Computer Programmers","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"การจัดการเทคโนโลยีการผลิตและสารสนเทศ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาเทคโนโลยีวิศวกรรมอุตสาหการ แขนงวิชาการผลิตเครื่องเรือน (โครงการปกติ)":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาเทคโนโลยีวิศวกรรมอุตสาหการ แขนงวิชาการจัดการกระบวนการผลิต (โครงการสมทบพิเศษ)":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"}},"คณะครุศาสตร์อุตสาหกรรม":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมโยธาและการศึกษา":{"jobsTH":["วิศวกรโยธา","ครูสอนด้านวิศวกรรม"],"jobsENG":["Civil Engineers","Engineering Teachers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา/การศึกษา"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมเครื่องกล"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมการผลิตและอุตสาหการ":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมการผลิตและอุตสาหการ"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาวิศวกรรมแมคคาทรอนิกส์":{"jobsTH":["ครูด้านวิศวกรรม"],"jobsENG":["Engineering Teachers"],"image":"ครูช่างกล","name":"ครุ วิศวกรรมแมคคาทรอนิกส์"},"หลักสูตรครุศาสตร์อุตสาหกรรมบัณฑิต สาขาวิชาเทคโนโลยีคอมพิวเตอร์":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ครุ เทคโนโลยีคอมพิวเตอร์"}},"คณะวิทยาศาสตร์ประยุกต์":{"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาคณิตศาสตร์เชิงวิทยาการคอมพิวเตอร์":{"jobsTH":["นักคณิตศาสตร์ประกันภัย","นักวิเคราะห์ระบบ"],"jobsENG":["Actuaries","Computer Systems Analysts"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์เชิงวิทยาการคอมพิวเตอร์"},"สาขาวิชาเคมีอุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักเคมีอุตสาหกรรม","name":"เคมีอุตสาหกรรม"},"สาขาวิชาเทคโนโลยีอุตสาหกรรมเกษตร":{"jobsTH":["นักเทคโนโลยีอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีอุตสาหกรรมเกษตร"},"สาขาวิชาเทคโนโลยีสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"เทคโนโลยีสิ่งแวดล้อม"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีทางอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีทางอาหาร"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาฟิสิกส์อุตสาหกรรมและอุปกรณ์การแพทย์":{"jobsTH":["นักวิทยาศาสตร์การแพทย์","นักเซลล์วิทยา","นักเทคนิคอุปกรณ์การแพทย์"],"jobsENG":["Medical Scientists","Molecular and Cellular Biologists","Medical Appliance Technicians"],"image":"นักวิทยาศาสตร์ชีวการแพทย์","name":"ฟิสิกส์อุตสาหกรรมและอุปกรณ์การแพทย์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาวิทยาการคอมพิวเตอร์ (โครงการพิเศษสองภาษา)":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์ (โครงการพิเศษสองภาษา)"},"สาขาวิชาสถิติประยุกต์":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติประยุกต์"},"สาขาวิชาสถิติธุรกิจและการประกันภัย":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล","นักคณิตศาสตร์ประกันภัย"],"jobsENG":["Statisticians","Database Administrators","Actuaries"],"image":"นักสถิติ","name":"สถิติธุรกิจและการประกันภัย"},"สาขาวิชาฟิสิกส์วิศวกรรม(หลักสูตรสองภาษา) แขนงวิชาวิศวกรรมไมโครและนาโนอิเล็กทรอนิกส์":{"jobsTH":["นักฟิสิกส์"],"jobsENG":["Physicists"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"ฟิสิกส์วิศวกรรม"},"สาขาวิชาฟิสิกส์วิศวกรรม (หลักสูตรสองภาษา) แขนงวิชาวิทยาศาสตร์และวิศวกรรมวัสดุ":{"jobsTH":["นักฟิสิกส์"],"jobsENG":["Physicists"],"image":"วิศวกรวัสดุ","name":"ฟิสิกส์วิศวกรรม"}},"คณะเทคโนโลยีและการจัดการอุตสาหกรรม":{"หลักสูตรอุตสาหกรรมศาสตรบัณฑิต สาขาวิชาการจัดการอุตสาหกรรม":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"ผู้จัดการโรงงาน","name":"การจัดการอุตสาหกรรม"},"หลักสูตรอุตสาหกรรมศาสตรบัณฑิต สาขาวิชาเทคโนโลยีเครื่องจักรกลเกษตร":{"jobsTH":["ผู้ควบคุมเครื่องจักรกลการเกษตร","ช่างอุปกรณ์การเกษตร"],"jobsENG":["Agricultural Equipment Operators","Farm Equipment Mechanics and Service Technicians"],"image":"คนขายอุปกรณ์การเกษตร","name":"เทคโนโลยีเครื่องจักรกลเกษตร"}},"คณะอุตสาหกรรมการเกษตร":{"สาขาวิชาเทคโนโลยีอุตสาหกรรมเกษตรและการจัดการ":{"jobsTH":["นักเทคโนโลยีอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีอุตสาหกรรมเกษตรและการจัดการ"},"สาขาวิชาพัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักวิจัยการเกษตร","name":"พัฒนาผลิตภัณฑ์อุตสาหกรรมเกษตร"},"สาขาวิชาวิทยาศาสตร์การอาหารและโภชนาการ":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์การอาหารและโภชนาการ"}},"คณะวิทยาศาสตร์ พลังงานและสิ่งแวดล้อม":{"สาขาวิชากระบวนการอุตสาหกรรมเคมีและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม","เจ้าหน้าที่ควบคุมคุณภาพ"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors","Quality Control Analysts"],"image":"นักอนุรักษ์","name":"กระบวนการอุตสาหกรรมเคมีและสิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีพลังงานและการจัดการ":{"jobsTH":["ผู้ตรวจประเมินด้านพลังงาน"],"jobsENG":["Energy Auditors"],"image":"คนคุมโรงไฟฟ้านิวเคลียร์","name":"เทคโนโลยีพลังงานและการจัดการ"}}},"มหาวิทยาลัยเกษตรศาสตร์ (วิทยาเขตศรีราชา)":{"วิทยาลัยพาณิชยนาวีนานาชาติ":{"สาขาวิชาวิศวกรรมต่อเรือและเครื่องกลเรือ":{"jobsTH":["วิศวกรเรือ"],"jobsENG":["Marine Engineers"],"image":"วิศวกรเรือ","name":"วิศวะ เรือ"},"สาขาวิชาวิทยาศาสตร์การเดินเรือ":{"jobsTH":["กัปตันเรือ","คนขับเรือ","เจ้าหน้าที่ประจำเรือ"],"jobsENG":["Ship and Boat Captains","Pilots, Ship","Sailors and Marine Oilers"],"image":"กัปตันเรือ","name":"วิทยาศาสตร์การเดินเรือ"}},"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"}},"คณะวิทยาการการจัดการ":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาธุรกิจระหว่างประเทศ":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"สาขาวิชาการจัดการโรงแรมและท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การจัดการโรงแรมและการท่องเที่ยว"},"สาขาวิชาการบัญชีบริหาร":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชีบริหาร"},"สาขาวิชาการจัดการโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม","นักลงทุน"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists","Securities and Commodities Traders"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะวิทยาศาสตร์":{"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"}}},"มหาวิทยาลัยเกษตรศาสตร์ (วิทยาเขตกำแพงแสน)":{"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเกษตร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ เกษตร"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมการอาหาร":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ การอาหาร"},"สาขาวิชาวิศวกรรมโยธา-ชลประทาน":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์และอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรคอมพิวเตอร์","วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Computer Engineers","Electronics Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์และอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมอุตสาหการ-โลจิสติกส์":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"}},"คณะศิลปศาสตร์และวิทยาศาสตร์":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการบัญชีบริหาร":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาการจัดการโรงแรมและท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การท่องเที่ยวและการโรงแรม"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาวิทยาศาสตร์ชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักชีวะวิทยา","name":"วิทยาศาสตร์ชีวภาพ"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultants","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาคณิตศาสตร์ประยุกต์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์ประยุกต์"}},"คณะศึกษาศาสตร์และพัฒนศาสตร์":{"สาขาวิชาเกษตรและสิ่งแวดล้อมศึกษา (ครู + นักเกษตร + นักสิ่งแวดล้อม)":{"jobsTH":["ครูสอนการเกษตร"],"jobsENG":["Agricultural Sciences Teachers"],"image":"ครูสอนการเกษตร","name":"เกษตรและสิ่งแวดล้อมศึกษา"},"สาขาวิชาพลศึกษาและสุขศึกษา":{"jobsTH":["ครูพลศึกษา","ครูสุขศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors","Health Educators"],"image":"ครูสอนสุขศึกษา","name":"พลศึกษาและสุขศึกษา"},"สาขาวิชาภาษาอังกฤษศึกษา":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ภาษาอังกฤษศึกษา"},"สาขาวิชาคณิตศาสตร์ศึกษา":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"คณิตศาสตร์ศึกษา"},"สาขาวิชาวิทยาศาสตร์ศึกษา":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"วิทยาศาสตร์ศึกษา"}},"คณะเกษตร":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาเครื่องจักรกลและเมคคาทรอนิกส์เกษตร":{"jobsTH":["ผู้ควบคุมเครื่องจักรกลการเกษตร","ช่างอุปกรณ์การเกษตร"],"jobsENG":["Agricultural Equipment Operators","Farm Equipment Mechanics and Service Technicians"],"image":"ช่างคุมเครื่องจักรการเกษตร","name":"เครื่องจักรกลและเมคคาทรอนิกส์เกษตร"},"สาขาวิชาเทคโนโลยีชีวภาพทางการเกษตร":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพทางการเกษตร"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"เจ้าของฟาร์มเลี้ยงสัตว์","name":"สัตวศาสตร์"}},"โครงการขยายโอกาสทางการศึกษา":{"สาขาวิชาประมง (สาขาเพาะเลี้ยงสัตว์น้ำ)":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}}},"มหาวิทยาลัยมหิดล (วิทยาเขตกาญจนบุรี)":{"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมสิ่งแวดล้อมและการจัดการภัยพิบัติ":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อมและการจัดการภัยพิบัติ"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการ"}},"คณะบัญชี":{"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาชีววิทยาเชิงอนุรักษ์":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยาเชิงอนุรักษ์"},"สาขาวิชาวิทยาศาสตร์การเกษตร":{"jobsTH":["นักวิทยาศาสตร์การเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"นักวิจัยการเกษตร","name":"วิทยาศาสตร์การเกษตร"},"สาขาวิชาธรณีศาสตร์":{"jobsTH":["นักธรณีวิทยา"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักธรณีวิทยา","name":"ธรณีศาสตร์"}}},"สถาบันเทคโนโลยีพระจอมเกล้าเจ้าคุณทหารลาดกระบัง (วิทยาเขตชุมพรเขตอุดมศักดิ์)":{"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมพลังงาน":{"jobsTH":["วิศวกรพลังงาน"],"jobsENG":["Energy Engineers"],"image":"วิศวกรพลังงาน","name":"วิศวะ พลังงาน"}},"คณะบริหารธุรกิจ":{"สาขาวิชาบริหารธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"}},"คณะวิทยาศาสตร์":{"สาขาวิชาวิทยาศาสตร์การประมงและทรัพยากรทางน้ำ":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"วิทยาศาสตร์การประมงและทรัพยากรทางน้ำ"},"สาขาวิชาพืชสวน":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"พืชสวน"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตวศาสตร์"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"}}},"สถาบันเทคโนโลยีพระจอมเกล้าพระนครเหนือ":{"คณะวิศวกรรมศาสตร์":{"สาขาวิชาวิศวกรรมการผลิต":{"jobsTH":["วิศวกรการผลิต"],"jobsENG":["Manufacturing Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ การผลิต"},"สาขาวิชาวิศวกรรมหุ่นยนต์และระบบอัตโนมัติ (หลักสูตรสองภาษา)":{"jobsTH":["วิศวกรหุ่นยนต์และระบบอัตโนมัติ"],"jobsENG":["Robotics Engineers"],"image":"วิศวกรผลิตหุ่นยนต์","name":"วิศวะ หุ่นยนต์และระบบอัตโนมัติ"},"สาขาวิชาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิชาวิศวกรรมการบินและอวกาศ":{"jobsTH":["วิศวกรการบินและอวกาศ"],"jobsENG":["Aerospace Engineers"],"image":"ช่างเครื่องบิน","name":"วิศวะ การบินและอวกาศ"},"สาขาวิชาวิศวกรรมไฟฟ้า (โครงการพิเศษสองภาษา)":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมไฟฟ้า แขนงวิชาวิศวกรรมโทรคมนาคม":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมไฟฟ้า แขนงวิชาวิศวกรรมไฟฟ้ากำลังและควบคุมอัตโนมัติ":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิชาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาวิชาวิศวกรรมขนถ่ายวัสดุ":{"jobsTH":["วิศวกรขนถ่ายวัสดุ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ ขนถ่ายวัสดุ"},"สาขาวิชาวิศวกรรมโลจิสติกส์":{"jobsTH":["วิศวกรโลจิสติกส์"],"jobsENG":["Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ โลจิสติกส์"},"สาขาวิชาวิศวกรรมโลจิสติกส์ (โครงการสมทบพิเศษ)":{"jobsTH":["วิศวกรโลจิสติกส์"],"jobsENG":["Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ โลจิสติกส์"},"สาขาวิชาวิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ วัสดุ"},"สาขาวิชาวิศวกรรมวัสดุ แขนงวิชาวิศวกรรมโลหะการ (โครงการพิเศษนานาชาติ)":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ วัสดุ-โลหการ"},"สาขาวิชาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"}},"คณะสถาปัตยกรรมศาสตร์และการออกแบบ":{"หลักสูตรศิลปบัณฑิต สาขาวิชาออกแบบภายใน":{"jobsTH":["นักออกแบบภายใน"],"jobsENG":["Interior Designers"],"image":"นักออกแบบภายใน","name":"ออกแบบภายใน"},"หลักสูตรศิลปบัณฑิต สาขาวิชาออกแบบเซรามิกส์":{"jobsTH":["ศิลปินงานเซรามิกส์","นักออกแบบผลิตภัณฑ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Commercial and Industrial Designers"],"image":"ช่างปั้น","name":"ออกแบบเซรามิกส์"},"หลักสูตรศิลปบัณฑิต สาขาวิชาศิลปประยุกต์และการออกแบบผลิตภัณฑ์":{"jobsTH":["นักออกแบบผลิตภัณฑ์","นักออกแบบกราฟิก","ผู้กำกับศิลป์"],"jobsENG":["Commercial and Industrial Designers","Graphic Designers","Art Directors"],"image":"นักออกแบบผลิตภัณฑ์","name":"ศิลปะประยุกต์และการออกแบบ"},"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการออกแบบสำนักงานอัตโนมัติและการจัดการธุรกิจ":{"jobsTH":["นักออกแบบสำนักงานอัตโนมัติ"],"jobsENG":["Mechatronics Engineers"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"การออกแบบสำนักงานอัตโนมัติ"}},"วิทยาลัยนานาชาติ":{"สาขาวิชาการค้าระหว่างประเทศและธุรกิจโลจิสติกส์ (หลักสูตรนานาชาติ)":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"โลจิสติกส์"}}},"สถาบันเทคโนโลยีสุรนารี":{"คณะวิศวกรรมศาสตร์":{"สาขาวิศวกรรมการผลิต":{"jobsTH":["วิศวกรการผลิต"],"jobsENG":["Manufacturing Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ การผลิต"},"สาขาวิศวกรรมเกษตรและอาหาร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ เกษตรและอาหาร"},"สาขาวิศวกรรมขนส่งและโลจิสติกส์":{"jobsTH":["วิศวกรโลจิสติกส์"],"jobsENG":["Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ ขนส่งและโลจิสติกส์"},"สาขาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมฯ (ประกอบคอม)","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"สาขาวิศวกรรมเซรามิก":{"jobsTH":["วิศวกรเซรามิก"],"jobsENG":["Materials Engineers"],"image":"วิศวกรเซรามิก","name":"วิศวะ เซรามิก"},"สาขาวิศวกรรมโทรคมนาคม":{"jobsTH":["วิศวกรโทรคมนาคม"],"jobsENG":["Telecommunications Engineering Specialists"],"image":"วิศวกรโทรคมนาคม","name":"วิศวะ โทรคมนาคม"},"สาขาวิศวกรรมพอลิเมอร์":{"jobsTH":["วิศวกรพอลิเมอร์"],"jobsENG":["Petroleum Engineers"],"image":"วิศวกรโพลิเมอร์","name":"วิศวะ พอลิเมอร์"},"สาขาวิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"สาขาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"สาขาวิศวกรรมยานยนต์":{"jobsTH":["วิศวกรยานยนต์"],"jobsENG":["Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"},"สาขาวิศวกรรมโลหการ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรโลหการ","name":"วิศวะ โลหการ"},"สาขาวิศวกรรมสิ่งแวดล้อม ผลิตภัณฑ์":{"jobsTH":["วิศวะสิ่งแวดล้อมผลิตภัณฑ์"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม ผลิตภัณฑ์"},"สาขาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"สาขาเทคโนโลยีธรณี":{"jobsTH":["นักเทคโนโลยีธรณี"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"นักธรณีวิทยา","name":"เทคโนโลยีธรณี"},"สาขาวิศวกรรมอากาศยาน":{"jobsTH":["วิศวกรการบินและอวกาศ"],"jobsENG":["Aerospace Engineers"],"image":"ช่างเครื่องบิน","name":"วิศวะ อากาศยาน"},"สาขาวิศวกรรมอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์"},"สาขาวิศวกรรมธรณี":{"jobsTH":["วิศวกรธรณี"],"jobsENG":["Geoscientists, Except Hydrologists and Geographers"],"image":"วิศวกรธรณี","name":"วิศวะ ธรณี"},"สาขาวิศวกรรมออกแบบ":{"jobsTH":["วิศวกรออกแบบ"],"jobsENG":["Commercial and Industrial Designers"],"image":"วิศวกรออกแบบ","name":"วิศวะ ออกแบบ"}}},"สถาบันเทคโนโลยีพระจอมเกล้าพระนครเหนือ (วิทยาเขตระยอง)":{"คณะวิศวกรรมศาสตร์และเทคโนโลยี":{"สาขาวิชาเทคโนโลยีวิศวกรรมกระบวนการเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"},"สาขาวิชาเทคโนโลยีวิศวกรรมการวัดคุมและอัตโนมัติ แขนงวิชาวิศวกรรมการวัดคุม":{"jobsTH":["วิศวกรอัตโนมัติ"],"jobsENG":["Mechatronics Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ วัดคุมและอัตโนมัติ"},"สาขาวิชาเทคโนโลยีวิศวกรรมอุตสาหการและโลจิสติกส์":{"jobsTH":["วิศวกรอุตสาหการ","วิศวกรโลจิสติกส์"],"jobsENG":["Industrial Engineers","Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ โลจิสติกส์"},"สาขาวิชาเทคโนโลยีวิศวกรรมเครื่องกลและยานยนต์":{"jobsTH":["วิศวกรเครื่องกล","วิศวกรยานยนต์"],"jobsENG":["Mechanical Engineers","Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"},"สาขาวิชาเทคโนโลยีวิศวกรรมวัสดุและกระบวนการผลิต แขนงวิชาวิศวกรรมพอลิเมอร์":{"jobsTH":["วิศวกรวัสดุ","วิศวกรพอลิเมอร์"],"jobsENG":["Materials Engineers","Petroleum Engineers"],"image":"วิศวกรวัสดุ","name":"วิศวะ วัสดุพอลิเมอร์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาบริหารธุรกิจอุตสาหกรรมและโลจิสติกส์":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักธุรกิจ","name":"บริหารธุรกิจอุตสาหกรรมและโลจิสติกส์"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"บัญชี","name":"บัญชี"},"สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักธุรกิจ E-Commerce","name":"คอมพิวเตอร์ธุรกิจ"}}},"มหาวิทยาลัยสงขลานครินทร์ (วิทยาเขตตรัง)":{"โครงการจัดตั้งคณะสถาปัตยกรรมศาสตร์":{"สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"}},"คณะพาณิชยศาสตร์และการจัดการ":{"สาขาวิชาการจัดการสารสนเทศและคอมพิวเตอร์":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"การจัดการสารสนเทศและคอมพิวเตอร์"},"สาขาวิชาการประกันภัยและการจัดการความเสี่ยง":{"jobsTH":["ตัวแทนประกันภัย","พนักงานนโยบายประกัยภัย","ผู้พิจารณาประกันภัย","ผู้เชี่ยวชาญการบริหารความเสี่ยง","ที่ปรึกษาการเงินส่วนบุคคล"],"jobsENG":["Insurance Sales Agents","Insurance Policy Processing Clerks","Insurance Underwriters","Risk Management Specialists","Personal Financial Advisors"],"image":"คนขายประกัน","name":"ประกันภัยและจัดการความเสี่ยง"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"สาขาวิชาการจัดการพาณิชย์อิเล็กทรอนิกส์":{"jobsTH":["นักพัฒนาซอฟแวร์","นักพัฒนาเว็บไซต์","ผู้ดูแลระบบเครือข่ายคอมพิวเตอร์","ผู้จัดการโครงการด้านเทคโนโลยีสารสนเทศ"],"jobsENG":["Software Developers, Applications","Web Developers","Network and Computer Systems Administrators","Information Technology Project Managers"],"image":"นักธุรกิจ E-Commerce","name":"การจัดการพาณิชย์อิเล็กทรอนิกส์"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"สาขาวิชาระบบสารสนเทศทางการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"ระบบสารสนเทศบัญชี"},"สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"สาขาวิชาการจัดการรัฐกิจและวิสาหกิจ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"การจัดการรัฐกิจและวิสาหกิจ"},"สาขาวิชาภาษาอังกฤษธุรกิจ":{"jobsTH":["ล่าม/นักแปล"],"jobsENG":["Interpreters and Translators"],"image":"นักธุรกิจ","name":"ภาษาอังกฤษธุรกิจ"},"สาขาวิชาศิลปะการแสดงและการจัดการ":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ","ผู้จัดการศิลปิน"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers","Agents and Business Managers of Artists, Performers, and Athletes"],"image":"นักแสดง","name":"ศิลปะการแสดงและการจัดการ"}}},"สถาบันเทคโนโลยีพระจอมเกล้าธนบุรี":{"คณะสถาปัตยกรรมศาสตร์และการออกแบบ":{"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาสถาปัตยกรรมภายใน":{"jobsTH":["สถาปนิกภายใน"],"jobsENG":["Architects, Except Landscape and Naval","Interior Designers"],"image":"นักออกแบบภายใน","name":"สถาปัตย์ ภายใน"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาการออกแบบอุตสาหกรรม":{"jobsTH":["นักออกแบบอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบอุตสาหกรรม","name":"การออกแบบอุตสาหกรรม"},"หลักสูตรศิลปบัณฑิต สาขาวิชาออกแบบนิเทศศิลป์":{"jobsTH":["นักออกแบบกราฟฟิก","นักออกแบบโฆษณา","ผู้กำกับศิลป์"],"jobsENG":["Graphic Designers","Copy Writers","Art Directors"],"image":"นักออกแบบ Graphic","name":"ออกแบบนิเทศศิลป์"}}},"มหาวิทยาลัยแม่โจ้":{"คณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม":{"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"หลักสูตรสถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาภูมิสถาปัตยกรรม":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"},"หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาเทคโนโลยีภูมิทัศน์":{"jobsTH":["นักออกแบบภูมิทัศน์"],"jobsENG":["Landscape Architects"],"image":"นักออกแบบ","name":"เทคโนโลยีภูมิทัศน์"}},"คณะบริหารธุรกิจ":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาดธุรกิจ","name":"การตลาด"},"สาขาวิชาการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงิน"},"สาขาวิชาระบบสารสนเทศธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศธุรกิจ"},"สาขาวิชาบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะพัฒนาการท่องเที่ยว":{"สาขาวิชาพัฒนาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"มัคคุเทศก์","name":"พัฒนาการท่องเที่ยว"}},"คณะเศรษฐศาสตร์":{"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","ผู้จัดการกองทุน"],"jobsENG":["Economists","Financial Analysts","Financial Advisors","Investment Fund Managers"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์สหกรณ์"},"วิทยาศาสตรบัณฑิต สาขาวิชาเศรษฐศาสตร์เกษตร ทรัพยากรและสิ่งแวดล้อม":{"jobsTH":["นักเศรษฐศาสตร์เกษตร","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์เกษตร"}},"คณะศิลปศาสตร์":{"สาขาวิชานิเทศศาสตร์บูรณาการ":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักข่าว","name":"นิเทศศาสตร์บูรณาการ"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"}},"คณะผลิตกรรมการเกษตร":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (พืชไร่)":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์ พืชไร่"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (พืชสวน)":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์ พืชสวน"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (อารักขาพืช)":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"เกษตรศาสตร์ อารักขาพืช"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (ปฐพีศาสตร์)":{"jobsTH":["นักวิทยาศาสร์สิ่งแวดล้อม","นักวิจัยดิน","นักอนุรักษ์ทรัพยากรดิน"],"jobsENG":["Environmental Scientists and Specialists, Including Health","Soil and Plant Scientists","Soil and Water Conservationists"],"image":"นักวิจัยดิน","name":"เกษตรศาสตร์ ปฐพีศาสตร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (เกษตรเคมี)":{"jobsTH":["เจ้าหน้าที่ควบคุมศัตรูพืช","นักวิจัยและพัฒนา","นักวิทยาศาสตร์การเกษตร"],"jobsENG":["Pesticide Handlers, Sprayers, and Applicators, Vegetation","Research and Development Scientists","Agricultural Technicians"],"image":"เกษตรกรฉีดยาฆ่าหญ้า","name":"เกษตรศาสตร์ เกษตรเคมี"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเกษตรศาสตร์ (วิทยาการสมุนไพร-สหวิทยาการ)":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"เกษตรศาสตร์ วิทยาการสมุนไพร-สหวิทยาการ"}},"วิทยาลัยพลังงาน":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาพลังงานทดแทน":{"jobsTH":["วิศวกรพลังงานทดแทน","ผู้เชี่ยวชาญด้านความยั่งยืน"],"jobsENG":["Energy Engineers","Sustainability Specialists"],"image":"นักวิทยาศาสตร์มีรูปโลก","name":"พลังงานทดแทน"}},"คณะสัตวศาสตร์และเทคโนโลยี":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิทยาศาสตร์ (ดูสัตว์)","name":"สัตวศาสตร์"}},"คณะเทคโนโลยีการประมงและทรัพยากรทางน้ํา":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาการประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}},"คณะวิศวกรรมและอุตสาหกรรมเกษตร":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมเกษตร":{"jobsTH":["วิศวกรการเกษตร"],"jobsENG":["Agricultural Engineers"],"image":"วิศวกรการเกษตร","name":"วิศวะ เกษตร"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิชาวิศวกรรมอาหาร":{"jobsTH":["วิศวกรอาหาร"],"jobsENG":["Food Scientists and Technologists"],"image":"วิศวกรผลิตอาหาร","name":"วิศวะ อาหาร"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีหลังการเก็บเกี่ยว":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เทคโนโลยีหลังการเก็บเกี่ยว"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยียางและพอลิเมอร์":{"jobsTH":["นักวิทยาศาสตร์ยางและพอลิเมอร์"],"jobsENG":["Materials Scientists"],"image":"นักวิทยาศาสตร์ยาง","name":"เทคโนโลยียางและพอลิเมอร์"}}},"มหาวิทยาลัยสงขลานครินทร์ (วิทยาเขตภูเก็ต)":{"คณะการบริหารและการท่องเที่ยว":{"สาขาวิชาการจัดการการบริการ (หลักสูตรนานาชาติ)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"การจัดการบริการ"},"สาขาวิชาการจัดการการท่องเที่ยว (หลักสูตรนานาชาติ)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"}},"คณะวิเทศศึกษา":{"สาขาวิชาวิเทศธุรกิจ :จีน (หลักสูตรนานาชาติ)":{"jobsTH":["ผู้เชี่ยวชาญด้านความสัมพันธ์ระหว่างประเทศ"],"jobsENG":["International Relations Specialists"],"image":"ผู้เชี่ยวชาญเกี่ยวกับจีน","name":"วิเทศธุรกิจจีน"},"สาขาวิชาจีนศึกษา (หลักสูตรนานาชาติ)":{"jobsTH":["นักประวัติศาสตร์","นักเขียน"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers"],"image":"ผู้เชี่ยวชาญเกี่ยวกับจีน","name":"จีนศึกษา"},"สาขาวิชาไทยศึกษา (หลักสูตรนานาชาติ)":{"jobsTH":["นักประวัติศาสตร์","นักเขียน"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers"],"image":"ผู้เชี่ยวชาญวัฒนธรรมไทย","name":"ไทยศึกษา"},"สาขาวิชาวิเทศศึกษา วิชาเอกวิเทศธุรกิจเกาหลี (หลักสูตรนานาชาติ)":{"jobsTH":["ผู้เชี่ยวชาญด้านความสัมพันธ์ระหว่างประเทศ"],"jobsENG":["International Relations Specialists"],"image":"ผู้เชี่ยวชาญเกี่ยวกับเกาหลี","name":"วิเทศธุรกิจเกาหลี"},"สาขาวิชาวิเทศศึกษา วิชาเอกเกาหลีศึกษา (หลักสูตรนานาชาติ)":{"jobsTH":["นักประวัติศาสตร์","นักเขียน"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers"],"image":"ผู้เชี่ยวชาญเกี่ยวกับเกาหลี","name":"เกาหลีศึกษา"}},"คณะเทคโนโลยีและสิ่งแวดล้อม":{"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาธุรกิจอิเล็กทรอนิกส์":{"jobsTH":["นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Search Marketing Strategists","Online Merchants"],"image":"นักธุรกิจ E Commerce","name":"ธุรกิจอิเล็กทรอนิกส์"},"สาขาวิชาวิศวกรรมซอฟต์แวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวกรรมซอฟต์แวร์"},"สาขาวิชาภูมิสารสนเทศสิ่งแวดล้อม":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศสิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีและการจัดการสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"เทคโนโลยีและการจัดการสิ่งแวดล้อม"}}},"มหาวิทยาลัยสงขลานครินทร์ (วิทยาเขตสุราษฎร์ธานี)":{"คณะศิลปศาสตร์และวิทยาการการจัดการ":{"สาขาวิชาพัฒนาธุรกิจ":{"jobsTH":["นักพัฒนาธุรกิจ"],"jobsENG":["Market Research Analysts and Marketing Specialists"],"image":"นักพัฒนาธุรกิจ","name":"พัฒนาธุรกิจ"},"สาขาวิชาการจัดการธุรกิจการท่องเที่ยว":{"jobsTH":["ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"ธุรกิจท่องเที่ยว"},"สาขาวิชาธุรกิจเทคโนโลยีสารสนเทศ":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants"],"image":"นักธุรกิจ E-Commerce","name":"ธุรกิจเทคโนโลยีสารสนเทศ"},"สาขาวิชาเศรษฐศาสตร์ธุรกิจ":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"สาขาวิชาภาษา การสื่อสารและธุรกิจ":{"jobsTH":["นักประชาสัมพันธ์","ผู้ประกาศข่าว","นักวิเคราะห์ข่าว","ผู้จัดการด้านประชาสัมพันธ์"],"jobsENG":["Public Relations Specialists","Radio and Television Announcers","Broadcast News Analysts","Public Relations Managers"],"image":"ฝ่ายสื่อสารองค์กร","name":"การสื่อสารและธุรกิจ"},"สาขาวิชาการจัดการรัฐกิจและวิสาหกิจ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Public Administrators"],"image":"ข้าราชการ","name":"การจัดการรัฐกิจและวิสาหกิจ"}},"คณะวิทยาศาสตร์และเทคโนโลยีอุตสาหกรรม":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการเกษตร":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"วิทยาศาสตร์และเทคโนโลยีการเกษตร"},"สาขาวิชาเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิตอาหาร","name":"เทคโนโลยีอาหาร"},"สาขาวิชาเทคโนโลยีอุตสาหกรรมยางพารา":{"jobsTH":["นักเทคโนโลยีอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักวิทยาศาสตร์ยาง","name":"เทคโนโลยีอุตสาหกรรมยางพารา"},"สาขาวิชาเทคโนโลยีการจัดการอุตสาหกรรม":{"jobsTH":["นักเทคโนโลยีอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักวิทยาศาสตร์อุตสาหกรรม","name":"เทคโนโลยีการจัดการอุตสาหกรรม"},"สาขาวิชาเคมีเพื่ออุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักเคมีอุตสาหกรรม","name":"เคมีเพื่ออุตสาหกรรม"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาเทคโนโลยีการจัดการสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"เทคโนโลยีการจัดการสิ่งแวดล้อม"},"สาขาวิชาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักอาชีวอนามัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาวิชาการจัดการงานวิศวกรรม":{"jobsTH":["นักธุรกิจวิศวกรรม"],"jobsENG":["Sales Engineers"],"image":"นักบริหารงานวิศวกรรม","name":"การจัดการงานวิศวกรรม"}}},"มหาวิทยาลัยบูรพา (วิทยาเขตปราจีนบุรี)":{"คณะเทคโนโลยีและการจัดการอุตสาหกรรม":{"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาการจัดการอุตสาหกรรมการท่องเที่ยวและการโรงแรม":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"ผู้จัดการโรงแรม","name":"จัดการการท่องเที่ยวและการโรงแรม"}}},"มหาวิทยาลัยบูรพา (วิทยาเขตจันทบุรี)":{"คณะวิทยาศาสตร์และศิลปศาสตร์":{"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาระบบสารสนเทศ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developers","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการจัดการโลจิสติกส์และการค้าชายแดน":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"จัดการโลจิสติกส์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ":{"jobsTH":["ล่าม/นักแปล"],"jobsENG":["Interpreters and Translators"],"image":"นักเจรจาทางธุรกิจ","name":"ภาษาอังกฤษเพื่อการสื่อสารทางธุรกิจ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรวิทยาศาสตรบัณฑิต และสาขาวิชาเทคโนโลยีการเกษตร (เน้นด้านพืช)":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการเกษตร"}},"คณะเทคโนโลยีทางทะเล":{"สาขาวิชาเทคโนโลยีทางทะเล":{"jobsTH":["นักวิทยาศาสตร์ทางทะเล","นักเพาะเลี้ยงสัตว์น้ำ","ชาวประมง"],"jobsENG":["Water Resource Specialists","Farm and Ranch Managers","Fishers and Related Fishing Workers"],"image":"นักวิจัยสัตว์น้ำ","name":"เทคโนโลยีทางทะเล"}},"คณะอัญมณี":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอัญมณีและเครื่องประดับ":{"jobsTH":["นักอัญมณีวิทยา","ผู้ตรวจสอบคุณภาพอัญมณี","เจ้าของธุรกิจอัญมณี"],"jobsENG":["Geoscientists","Quality Control Analysts","Chief Executives"],"image":"นักอัญมณีวิทยา","name":"วิทยาฯ อัญมณี"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาธุรกิจอัญมณีและเครื่องประดับ":{"jobsTH":["เจ้าของธุรกิจอัญมณี","ฝ่ายขายอัญมณี"],"jobsENG":["Chief Executives","Sales Manager"],"image":"เจ้าของร้านเพชร","name":"ธุรกิจอัญมณี"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาออกแบบเครื่องประดับ":{"jobsTH":["นักออกแบบเครื่องประดับ","ช่างทำเครื่องประดับ"],"jobsENG":["Fashion Designers","Jewelers"],"image":"ช่างเจียระไน","name":"ออกแบบเครื่องประดับ"}}},"มหาวิทยาลัยศิลปากร (วิทยาเขตสารสนเทศเพชรบุรี)":{"คณะสัตวศาสตร์และเทคโนโลยีการเกษตร":{"สาขาวิชาสัตวศาสตร์และเทคโนโลยีการเกษตร":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์","นักเทคโนโลยีการเกษตร"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders","Agricultural Technicians"],"image":"เจ้าของฟาร์มเลี้ยงสัตว์","name":"สัตวศาสตร์และเทคโนโลยีการเกษตร"},"สาขาวิชาเทคโนโลยีการผลิตสัตว์น้ำ":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"นักวิจัยสัตว์น้ำ","name":"เทคโนโลยีการผลิตสัตว์น้ำ"},"สาขาวิชาเทคโนโลยีการผลิตพืช":{"jobsTH":["ผู้ควบคุมการผลิต","นักเทคโนโลยีการเกษตร","ผู้ตรวจสอบคัดแยกผลิตผลเกษตรกรรม"],"jobsENG":["First-Line Supervisors of Agricultural Crop and Horticultural Workers","Agricultural Technicians","Graders and Sorters, Agricultural Products"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการผลิตพืช"}}},"มหาวิทยาลัยทักษิณ (วิทยาเขตสงขลา)":{"คณะศึกษาศาสตร์":{"สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"สาขาวิชาพลศึกษา":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูพลศึกษา","name":"ศึกษา พลศึกษา"},"สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูสอนภาษาไทย","name":"ศึกษา ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคอมพิวเตอร์ช่":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["Social Sciences Teachers, All Other"],"image":"ครูสอนสังคมศาสตร์","name":"ศึกษา สังคมศาสตร์"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"สาขาวิชาวิทยาศาสตร์ เคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา เคมี"},"สาขาวิชาวิทยาศาสตร์ ฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ฟิสิกส์"},"สาขาวิชาวิทยาศาสตร์ ชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ชีววิทยา"},"สาขาวิชาเทคโนโลยีและการสื่อสารการศึกษา":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"คนคุมห้องโสตทัศนศึกษา","name":"ศึกษา เทคโนโลยีและการสื่อสารการศึกษา"},"สาขาวิชาการวัดและประเมินทางการศึกษา":{"jobsTH":["นักวางแผนการศึกษา"],"jobsENG":["Instructional Coordinators"],"image":"ครูสอนคอมพิวเตอร์","name":"ศึกษา การวัดและประเมินทางการศึกษา"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์"],"jobsENG":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูภาษาไทย","name":"ภาษาไทย"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษามลายู":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษามลายู"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการจัดการทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"การจัดการทรัพยากรมนุษย์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาการพัฒนาชุมชน":{"jobsTH":["นักพัฒนาชุมชน","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"การพัฒนาชุมชน"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาสารสนเทศศึกษา":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศึกษา"},"หลักสูตรรัฐประศาสนศาสตรบัณฑิต สาขาวิชาการปกครองท้องถิ่น":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"อบต","name":"การปกครองท้องถิ่น"}},"คณะศิลปกรรมศาสตร์":{"หลักสูตรดุริยางคศาสตรบัณฑิต สาขาวิชาดุริยางคศาสตร์ไทย":{"jobsTH":["นักแสดง","นักร้อง","นักดนตรีไทย","นักนาฏยลีลา"],"jobsENG":["Actors","Singers","Musicians, Instrumental","Dancers"],"image":"ครูสอนนาฏศิลป์","name":"ดุริยางคศาสตร์ไทย"},"หลักสูตรดุริยางคศาสตรบัณฑิต สาขาวิชาดุริยางคศาสตร์สากล":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"ดุริยางคศาสตร์สากล"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปะการแสดง"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาศิลปะการออกแบบ":{"jobsTH":["นักออกแบบ"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"นักออกแบบ","name":"ศิลปะการออกแบบ"}},"คณะเศรษฐศาสตร์และบริหารธุรกิจ":{"เศรษฐศาสตร์บัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาบริหารธุรกิจ การตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาวิชาบริหารธุรกิจ การประกอบการและการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การประกอบการและการจัดการ"},"หลักสูตรบริหารธุรกิจบัณฑิต สาขาการจัดการการค้าปลีก":{"jobsTH":["ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ","นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา","เจ้าของกิจการค้าปลีก"],"jobsENG":["Consultants (Business, Management or Strategy)","Business Intelligence Analysts","Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers","Sales Managers"],"image":"ผู้จัดการร้านค้า","name":"การจัดการการค้าปลีก"},"หลักสูตรบัญชีบัณฑิต สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}}},"มหาวิทยาลัยทักษิณ (วิทยาเขตพัทลุง)":{"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักฟิสิกส์","name":"ฟิสิกส์"},"สาขาวิชาเทคโนโลยีการจัดการพลังงาน":{"jobsTH":["นักวิทยาศาสตร์พลังงาน"],"jobsENG":["Energy Engineers"],"image":"วิศวกรพลังงาน","name":"เทคโนโลยีการจัดการพลังงาน"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาวิทยาศาสตร์การเพาะเลี้ยงสัตว์น้ำ":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"การเพาะเลี้ยงสัตว์น้ำ"},"สาขาวิชาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์ มีรูปโลก","name":"วิทยาศาสตร์สิ่งแวดล้อม"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาเคมีอุตสาหกรรม":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมีอุตสาหการ","name":"เคมีอุตสาหกรรม"}},"คณะเทคโนโลยีและการพัฒนาชุมชน":{"สาขาวิชาพืชศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พืชศาสตร์"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["นักวิจัยสัตว์ป่า"],"jobsENG":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"image":"นักวิทยาศาสตร์ (ดูสัตว์)","name":"สัตวศาสตร์"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีอาหาร"},"สาขาวิชาเทคโนโลยีการเกษตรเพื่อการพัฒนาชุมชน":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"นักพัฒนาชนบท","name":"เทคโนโลยีการเกษตรเพื่อการพัฒนาชุมชน"}},"คณะวิทยาการสุขภาพและการกีฬา":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุขศาสตร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสุขศาสตร์อุตสาหกรรมและความปลอดภัย":{"jobsTH":["นักอาชีวอนามัย"],"jobsENG":["Industrial Safety and Health Engineers"],"image":"นักอาชีวอนามัยและความปลอดภัย","name":"สุขศาสตร์อุตสาหกรรมและความปลอดภัย"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา","ผู้ตัดสินกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts","Umpires and Referees"],"image":"เทรนเนอร์","name":"วิทยาฯ กีฬา"},"หลักสูตรการแพทย์แผนไทยบัณฑิต สาขาวิชาการแพทย์แผนไทย":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"การแพทย์แผนไทย"}}},"มหาวิทยาลัยนครพนม":{"คณะศิลปศาสตร์และวิทยาศาสตร์":{"หลักสูตรรัฐประศาสนศาสตร์บัณฑิต สาขารัฐประศาสนศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"หลักสูตรศิลปศาสตรบัณฑิต สาขาการพัฒนาสังคมและสิ่งแวดล้อม":{"jobsTH":["ผู้นำชุมชน","นักบริการชุมชน"],"jobsENG":["Property, Real Estate, and Community Association Managers","Social and Community Service Managers"],"image":"นักพัฒนาชุมชนเมือง","name":"การพัฒนาสังคมและสิ่งแวดล้อม"},"หลักสูตรนิติศาสตรบัณฑิต สาขานิติศาสตร์":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"},"หลักสูตรครุศาสตรบัณฑิต สาขาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"หลักสูตรครุศาสตรบัณฑิต สาขาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ครุ ภาษาอังกฤษ"},"หลักสูตรครุศาสตรบัณฑิต สาขาคอมพิวเตอร์":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ครุ คอมพิวเตอร์"},"หลักสูตรครุศาสตรบัณฑิต สาขาวิทยาศาสตร์":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ครุ วิทยาศาสตร์"},"หลักสูตรครุศาสตรบัณฑิต สาขาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["Social Sciences Teachers, All Other"],"image":"ครูสอนสังคมศึกษา","name":"ครุ สังคมศึกษา"}},"คณะวิทยาการจัดการและเทคโนโลยีสารสนเทศ":{"หลักสูตรบัญชีบัณฑิต สาขาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"},"หลักสูตรบัญชีบัณฑิต สาขาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"หลักสูตรบัญชีบัณฑิต สาขาการจัดการกีฬา":{"jobsTH":["ผู้จัดการนักกีฬา","ผู้ตัดสิน","ผู้ฝึกสอนกีฬา"],"jobsENG":["Agents and Business Managers of Artists, Performers, and Athletes","Umpires, Referees, and Other Sports Officials","Athletic Trainers"],"image":"ผู้จัดการทีม","name":"การจัดการกีฬา"},"หลักสูตรบัญชีบัณฑิต สาขาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developer","Computer Systems Analysts"],"image":"นักธุรกิจ E-Commerce","name":"คอมพิวเตอร์ธุรกิจ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"}},"คณะเทคโนโลยีอุตสาหกรรม":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาวิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"หลักสูตรครุศาสตรบัณฑิต สาขาครุศาสตร์อุตสาหกรรมไฟฟ้าและอิเล็กทรอนิกส์":{"jobsTH":["นักเทคโนโลยีไฟฟ้า","นักเทคโนโลยีอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineering Technologists","Electrical Engineering Technologists"],"image":"ครูช่างกล","name":"ครุศาสตร์อุตสาหกรรมไฟฟ้าอิเล็กทรอนิกส์"}},"คณะเกษตรและเทคโนโลยี":{"สาขาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาเทคโนโลยีอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"เทคโนโลยีอาหาร"},"สาขาเครื่องจักรกลเกษตร":{"jobsTH":["ผู้ควบคุมเครื่องจักรกลการเกษตร","ช่างอุปกรณ์การเกษตร"],"jobsENG":["Agricultural Equipment Operators","Farm Equipment Mechanics and Service Technicians"],"image":"ช่างคุมเครื่องจักรการเกษตร","name":"เครื่องจักรกลเกษตร"}},"วิทยาลัยการท่องเที่ยวและอุตสาหกรรมบริการ":{"สาขาการท่องเที่ยวและอุตสาหกรรมบริการ":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยวและบริการ"},"สาขาการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การโรงแรม"}},"วิทยาลัยธาตุพนม":{"หลักสูตรวิศวกรรมศาสตรบัณฑิต สาขาเทคโนโลยีพลังงาน":{"jobsTH":["วิศวกรพลังงาน"],"jobsENG":["Energy Engineers"],"image":"วิศวกรพลังงาน","name":"วิศวะ เทคโนโลยีพลังงาน"}},"วิทยาลัยการบินนานาชาติ ":{"บริหารธุรกิจบัณฑิต สาขาการบริหารการบิน":{"jobsTH":["บิน","ตรวจ","ควบคุม"],"jobsENG":["Airline Pilots, Copilots, and Flight Engineers","Aviation Inspectors","Air Traffic Controllers"],"image":"ผู้จัดการสายการบิน","name":"บริหารการบิน"}}},"มหาวิทยาลัยนราธิวาสราชนครินทร์":{"คณะแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientist"],"image":"หมอ","name":"แพทยศาสตร์"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาลศาสตร์"}},"คณะเกษตรศาสตร์":{"สาขาวิชาพืชศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พืชศาสตร์"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตวศาสตร์"}},"คณะวิทยาการการจัดการ":{"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"การจัดการเทคโนโลยีสารสนเทศ"},"บัญชีบัณฑิต สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"},"รัฐประศาสนศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"}},"คณะวิศวกรรมศาสตร์":{"วิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"วิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์กำลัง"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์กำลัง"},"เทคโนโลยีวิศวกรรมอิเล็กทรอนิกส์":{"jobsTH":["วิศวกรอิเล็กทรอนิกส์"],"jobsENG":["Electronics Engineers"],"image":"วิศวกรอิเล็กทรอนิกส์","name":"วิศวะ อิเล็กทรอนิกส์"},"วิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรยานยนต์"],"jobsENG":["Automotive Engineers"],"image":"วิศวกรยานยนต์","name":"วิศวะ ยานยนต์"},"วิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"}},"คณะวิทยาศาสตร์และเทคโนโลยี":{"สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูสอนวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"นักวิทยาศาสตร์เสื้อกาวน์สีขาว","name":"วิทยาศาสตร์ทั่วไป"},"สาขาวิชาชีววิทยาประยุกต์":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยาประยุกต์"},"สาขาวิชาฟิสิกส์ประยุกต์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์"}},"สถาบันอิสลามและอาหรับศึกษา":{"สาขาวิชากฎหมายอิสลาม":{"jobsTH":["ดะโต๊ะยุติธรรม","พนักงานคุมประพฤติ","นักกฎหมายอิสลาม"],"jobsENG":["Judges, Magistrate Judges, and Magistrates","Probation Officers and Correctional Treatment Specialists","Lawyers"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"กฎหมายอิสลาม"},"สาขาวิชาภาษาอาหรับ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอาหรับ"},"สาขาวิชาอิสลามศึกษา":{"jobsTH":["นักวิชาการอิสลามศึกษา"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ผู้เชี่ยวชาญอิสลาม","name":"อิสลามศึกษา"}}},"มหาวิทยาลัยนเรศวร":{"คณะเกษตรศาสตร์ ทรัพยากรธรรมชาติและสิ่งแวดล้อม":{"สาขาวิชาวิทยาศาสตร์เกษตร":{"jobsTH":["นักวิทยาศาสตร์การเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"วิทยาศาสตร์การเกษตร"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาทรัพยากรธรรมชาติและสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"ทรัพยากรธรรมชาติและสิ่งแวดล้อม"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีอาหารสัตว์":{"jobsTH":["นักวิทยาศาสตร์อาหารสัตว์"],"jobsENG":["Food Science Technicians"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีอาหารสัตว์"},"สาขาวิชาภูมิศาสตร์":{"jobsTH":["นักภูมิศาสตร์","หน่วยสนับสนุนการวางผังเมือง","ครูสอนภูมิศาสตร์"],"jobsENG":["Geographers","City and Regional Planning Aides","Geography Teachers, Postsecondary"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์"},"สาขาวิชาวิทยาศาสตร์การประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"วิทยาศาสตร์การประมง"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาฟิสิกส์ประยุกต์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"}},"คณะวิศวกรรมศาสตร์":{"วิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมพิวเตอร์","name":"วิศวะ คอมพิวเตอร์"},"วิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"วิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"วิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"วิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"วิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรวัสดุ","name":"วิศวะ วัสดุ"},"วิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"วิศวกรรมเคมี":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมี"}},"คณะสถาปัตยกรรมศาสตร์":{"สถาปัตยกรรมศาสตรบัณฑิต":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"ศิลปกรรมศาสตรบัณฑิต สาขาวิชาการออกแบบผลิตภัณฑ์และบรรจุภัณฑ์":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาผลิตภัณฑ์","name":"การออกแบบผลิตภัณฑ์"},"ศิลปกรรมศาสตรบัณฑิต สาขาวิชาการออกแบบสื่อนวัตกรรม":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักออกแบบกราฟิก","นักการตลาดดิจิทัล","ผู้ประกอบธุรกิจออนไลน์","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Graphic Designers","Search Marketing Strategists","Online Merchants","Web Developers"],"image":"นักออกแบบ Graphic","name":"การออกแบบสื่อนวัตกรรม"},"ศิลปกรรมศาสตรบัณฑิต สาขาวิชาออกแบบทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","นักออกแบบกราฟิก"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Graphic Designers"],"image":"นักออกแบบ","name":"การออกแบบทัศนศิลป์"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต สาขาวิชาบริบาลเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัชศาสตร์"},"วิทยาศาสตรบัณฑิต สาขาวิชาวิทยาศาสตร์เครื่องสำอางค์และผลิตภัณฑ์ธรรมชาติ":{"jobsTH":["นักวิทยาศาสตร์เครื่องสำอาง"],"jobsENG":["Chemical Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"วิทยาศาสตร์ เครื่องสำอาง"}},"คณะวิทยาศาสตร์การแพทย์":{"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาวิทยาศาสตร์การแพทย์":{"jobsTH":["นักวิทยาศาสตร์การแพทย์"],"jobsENG":["Medical Scientists, Except Epidemiologists"],"image":"นักวิทยาศาสตร์ชีวการแพทย์","name":"วิทยาศาสตร์การแพทย์"},"สาขาวิชาพยาธิวิทยากายวิภาค":{"jobsTH":["นักพยาธิวิทยา"],"jobsENG":["Pathologists"],"image":"นักพยาธิวิทยา","name":"พยาธิวิทยากายวิภาค"},"สาขาวิชาชีวเคมีและชีววิทยาโมเลกุล":{"jobsTH":["นักชีวเคมี","นักชีววิทยาโมเลกุล"],"jobsENG":["Biochemists and Biophysicists","Molecular and Cellular Biologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"ชีวเคมีและชีววิทยาโมเลกุล"}},"คณะสหเวชศาสตร์":{"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientist","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขาวิชาเทคโนโลยีหัวใจและทรวงอก":{"jobsTH":["นักเทคโนโลยีหัวใจ"],"jobsENG":["Cardiovascular Technologists and Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคโนโลยีหัวใจและทรวงอก"},"สาขาวิชารังสีเทคนิค":{"jobsTH":["นักรังสีรักษา","นักรังสีเทคนิค","นักเวชศาสตร์นิวเคลียร์"],"jobsENG":["Radiation Therapists","Radiologic Technicians","Nuclear Medicine Technologists"],"image":"นักรังสีเทคนิค","name":"รังสีเทคนิค"},"ทัศนมาตรศาสตรบัณฑิต":{"jobsTH":["นักทัศนมาตร"],"jobsENG":["Optometrists"],"image":"จักษุแพทย์","name":"ทัศนมาตร"}},"คณะสาธารณสุขศาสตร์":{"สาธารณสุขศาสตรบัณฑิต":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุข"},"สาขาวิชาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"สาขาวิชาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"การแพทย์แผนไทยประยุกต์บัณฑิต":{"jobsTH":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนไทย","name":"การแพทย์แผนไทย"}},"คณะนิตศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะมนุษยศาสตร์":{"สาขาวิชาพม่าศึกษา":{"jobsTH":["ผู้เชี่ยวชาญด้านวัฒนธรรมพม่า"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"พม่าศึกษา"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาไทย":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาไทย"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาเกาหลี":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเกาหลี"}},"คณะบริหารธุรกิจ เศรษฐศาสตร์และการสื่อสาร":{"นิเทศศาสตรบัณฑิต สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"การประชาสัมพันธ์"},"นิเทศศาสตรบัณฑิต สาขาวิชาการสื่อสารมวลชน":{"jobsTH":["ผู้ผลิตรายการ","นักเขียนบท","ผู้ประกาศหรือพิธีกร"],"jobsENG":["Producers","Writers and Authors","Radio and TV Announcers"],"image":"นักข่าว","name":"การสื่อสารมวลชน"},"นิเทศศาสตรบัณฑิต สาขาวิชาสารสนเทศเพื่อการสื่อสาร":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"สารสนเทศเพื่อการสื่อสาร"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการธุรกิจ"},"บริหารธุรกิจบัณฑิต สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["นักคุมเครือข่ายคอมพิวเตอร์องค์กร"],"jobsENG":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"คอมพิวเตอร์ธุรกิจ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการเงินและการธนาคาร":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงินและการธนาคาร"},"ศิลปศาสตรบัณฑิต สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเทียว"},"บัญชีบัณฑิต":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"เศรษฐศาสตร์บัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะศึกษาศาสตร์":{"สาขาวิชาคอมพิวเตอร์":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ศึกษา คอมพิวเตอร์"},"สาขาวิชาฟิสิกส์":{"jobsTH":["ครูสอนฟิสิกส์"],"jobsENG":["Physics Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ฟิสิกส์"},"สาขาวิชาเคมี":{"jobsTH":["ครูสอนเคมี"],"jobsENG":["Chemistry Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["ครูสอนชีววิทยา"],"jobsENG":["Biological Science Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา ชีววิทยา"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูสอนภาษาไทย","name":"ศึกษา ภาษาไทย"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"},"สาขาวิชาพลศึกษาและวิทยาศาสตร์การออกกำลังกาย":{"jobsTH":["ครูพลศึกษา"],"jobsENG":["Fitness Trainers and Aerobics Instructors"],"image":"ครูสอนพลศึกษา","name":"ศึกษา พลศึกษาและวิทยาศาสตร์การออกกำลังกาย"}},"คณะสังคมศาสตร์":{"รัฐศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นักการเมือง","name":"รัฐศาสตร์"},"วิทยาศาสตรบัณฑิต สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"ศิลปศาสตรบัณฑิต สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"ศิลปศาสตรบัณฑิต สาขาวิชาพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"พัฒนาสังคม"}},"วิทยาลัยนานาชาติ":{"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจระหว่างประเทศ (นานาชาติ)":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"การจัดการธุรกิจระหว่างประเทศ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจท่องเที่ยว (นานาชาติ)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการธุรกิจท่องเที่ยว"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการทรัพยากรมนุษย์ (นานาชาติ)":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"การจัดการทรัพยากรมนุษย์"}}},"มหาวิทยาลัยพะเยา":{"คณะเกษตรศาสตร์และทรัพยากรธรรมชาติ":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["เจ้าของฟาร์มเลี้ยงสัตว์"],"jobsENG":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"image":"นักวิทยาศาสตร์ (ดูสัตว์)","name":"สัตวศาสตร์"},"สาขาวิชาความปลอดภัยทางอาหารในธุรกิจเกษตร":{"jobsTH":["นักวิทยาศาสตร์อาหาร"],"jobsENG":["Food Scientists and Technologists"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"ความปลอดภัยทางอาหาร"},"สาขาวิชาการประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"การประมง"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["นักวิทยาศาสตร์อาหาร"],"jobsENG":["Food Scientists and Technologists"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีอาหาร"}},"คณะเทคโนโลยีสารสนเทศและการสื่อสาร":{"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["ผู้ควบคุมระบบคอมพิวเตอร์"],"jobsENG":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาภูมิสารสนเทศศาสตร์":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศ"},"สาขาวิชาเทคโนโลยีคอมพิวเตอร์เคลื่อนที่":{"jobsTH":["นักวิเคราะห์ระบบคอมพิวเตอร์"],"jobsENG":["Computer Systems Analysts"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีคอมพิวเตอร์เคลื่อนที่"},"วิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมพิวเตอร์","name":"วิศวะ คอมพิวเตอร์"},"วิศวกรรมซอฟแวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวะ ซอฟต์แวร์"},"บริหารธุรกิจบัณฑิต สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developer","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"คอมพิวเตอร์ธุรกิจ"},"ศิลปะกรรมศาสตรบัณฑิต สาขาวิชาคอมพิวเตอร์กราฟิกและมัลติมีเดีย":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developer"],"image":"นักออกแบบ graphic","name":"คอมพิวเตอร์ธุรกิจกราฟิกมัลติมีเดีย"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะแพทยศาสตร์":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาปฏิบัติการฉุกเฉินการแพทย์":{"jobsTH":["นักเวชกิจฉุกเฉิน"],"jobsENG":["Emergency Medical Technicians and Paramedics"],"image":"หมอ","name":"เวชกิจฉุกเฉิน"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสาธารณสุขศาสตร์อนามัยชุมชน":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่อนามัยชุมชน","name":"อนามัยชุมชน"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสาธารณสุขศาสตร์อนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาส่งเสริมสุขภาพ":{"jobsTH":["นักสุขศึกษา","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Health Educators","Community Health Workers"],"image":"นักสร้างเสริมสุขภาพ","name":"ส่งเสริมสุขภาพ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อนามัยและความปลอดภัย"}},"คณะเภสัชศาสตร์":{"สาขาวิชาบริบาลเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะวิทยาการจัดการและสารสนเทศศาสตร์":{"นิเทศศาสนบัณฑิต สาขาวิชาการประชาสัมพันธ์":{"jobsTH":["นักประชาสัมพันธ์","ผู้จัดการฝ่ายประชาสัมพันธ์องค์กร"],"jobsENG":["Public Relations Specialists","Public Relations Managers"],"image":"พนักงานต้อนรับ","name":"การประชาสัมพันธ์"},"นิเทศศาสนบัณฑิต สาขาวิชาการสื่อสาร":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"ฝ่ายสื่อสารองค์กร","name":"การสื่อสาร"},"นิเทศศาสนบัณฑิต สาขาสื่อใหม่":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developer"],"image":"นักออกแบบ graphic","name":"สื่อใหม่"},"บริหารธุรกิจบัณฑิต สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยว"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการธุรกิจ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการเงินและการธนาคาร":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงินและการธนาคาร"},"บริหารธุรกิจบัณฑิต สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"บัญชีบัณฑิต":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"}},"คณะวิทยาศาสตร์":{"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี"],"jobsENG":["Chemists"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาอุตสาหกรรมเคมีและเทคโนโลยีวัสดุ":{"jobsTH":["นักอุตสาหกรรมเคมี"],"jobsENG":["Materials Scientists"],"image":"นักวัสดุศาสตร์","name":"อุตสาหกรรมเคมีเทคโนโลยีวัสดุ"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยาฯ กีฬา"}},"คณะวิทยาศาสตร์การแพทย์":{"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาชีวเคมี":{"jobsTH":["นักชีวเคมี"],"jobsENG":["Biochemists and Biophysicists"],"image":"นักวิทยาศาสตร์ชีวเคมี","name":"ชีวเคมี"},"สาขาวิชาโภชนาการและโภชนบำบัด":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"โภชนาการ"}},"คณะวิศวกรรมศาสตร์":{"วิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"วิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"วิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"วิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาไทย"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"พัฒนาสังคม"},"รัฐศาสตรบัณฑิต":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นักการเมือง","name":"รัฐศาสตร์"}},"คณะสถาปัตยกรรมศาสตรืและศิลปกรรมศาสตร์":{"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาศิลปะและการออกแบบ":{"jobsTH":["นักออกแบบผลิตภัณฑ์","นักออกแบบแฟชัน","นักออกแบบกราฟิก"],"jobsENG":["Commercial and Industrial Designers","Fashion Designers","Graphic Designers"],"image":"นักออกแบบ","name":"ศิลปะและการออกแบบ"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง","name":"ศิลปะการแสดง"},"สถาปัตยกรรมศาสตรบัณฑิต สาขาวิชาสถาปัตยกรรมศาสตร์":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาดุริยางคศาสตร์สากล":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors"],"image":"นักดนตรี","name":"ดุริยางคศาสตร์"}},"คณะสหเวชศาสตร์":{"กายภาพบำบัดบัณฑิต":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"วิทยาศาสตรบัณฑิต สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientist","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"}},"วิทยาลัยพลังงานและสิ่งแวดล้อม":{"วิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"},"สาขาวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักวิทยาศาสตร์ มีรูปโลก","name":"วิทยาศาสตร์สิ่งแวดล้อม"}}},"มหาวิทยาลัยมหาสารคาม":{"คณะแพทยศาสตร์":{"การแพทย์แผนไทยประยุกต์บัณฑิต":{"jobsTH":["แพทย์แผนไทย"],"jobsENG":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"image":"แพทย์แผนไทย","name":"การแพทย์แผนไทย"},"วิทยาศาสตรบัณฑิต สาขาวิชาเวชกิจฉุกเฉิน":{"jobsTH":["นักเวชกิจฉุกเฉิน"],"jobsENG":["Emergency Medical Technicians and Paramedics"],"image":"นักกายภาพบำบัด","name":"เวชกิจฉุกเฉิน"}},"คณะเภสัชศาสตร์":{"สาขาวิชาบริบาลทางเภสัชกรรม":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"คณะสาธารณสุขศาสตร์":{"สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุขศาสตร์"},"สาขาวิชาโภชนาการและการจัดการความปลอดภัยในอาหาร":{"jobsTH":["นักโภชนาการ","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Dietitians and Nutritionists","Community Health Workers"],"image":"นักโภชนาการ","name":"โภชนาการและความปลอดภัย"},"สาขาวิชาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเคมี":{"jobsTH":["นักเคมี"],"jobsENG":["Chemists"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาฟิสิกส์ประยุกต์ (พลังงาน)":{"jobsTH":["นักฟิสิกส์ประยุกต์"],"jobsENG":["Energy Engineers"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์พลังงาน"},"สาขาวิชาฟิสิกส์ประยุกต์ (อิเล็กทรอนิกส์)":{"jobsTH":["นักฟิสิกส์ประยุกต์"],"jobsENG":["Electronics Engineering Technologists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์ประยุกต์อิเล็กทรอนิกส์"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาสถิติ":{"jobsTH":["นักสถิติ","นักวิเคราะห์ข้อมูล"],"jobsENG":["Statisticians","Database Administrators"],"image":"นักสถิติ","name":"สถิติ"},"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"}},"คณะเทคโนโลยี":{"สาขาวิชาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาเทคโนโลยีการเกษตร":{"jobsTH":["นักเทคโนโลยีการเกษตร"],"jobsENG":["Agricultural Technicians"],"image":"นักวิจัยพืชสวน","name":"เทคโนโลยีการเกษตร"},"สาขาวิชาพัฒนาผลิตภัณฑ์อาหาร":{"jobsTH":["นักพัฒนาผลิตภัณฑ์"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักพัฒนาผลิตภัณฑ์","name":"พัฒนาผลิตภัณฑ์อาหาร"},"สาขาวิชาสัตวศาสตร์":{"jobsTH":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"นักวิจัยสัตว์ป่า","name":"สัตวศาสตร์"},"สาขาวิชาประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}},"คณะสัตวแพทยศาสตร์":{"สาขาวิชาสัตวแพทยศาสตร์":{"jobsTH":["สัตวแพทย์"],"jobsENG":["Veterinarians"],"image":"สัตวแพทย์","name":"สัตวแพทย์"}},"คณะสิ่งแวดล้อมและทรัพยากรศาสตร์":{"สาขาวิชาเทคโนโลยีสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"เทคโนโลยีสิ่งแวดล้อม"},"สาขาวิชาการจัดการสิ่งแวดล้อมและทรัพยากร":{"jobsTH":["นักนิเทศวิทยา"],"jobsENG":["Industrial Ecologists"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"การจัดการสิ่งแวดล้อม"},"สาขาวิชาสิ่งแวดล้อมศึกษา":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม"],"jobsENG":["Environmental Scientists and Specialists, Including Health"],"image":"นักวิทยาศาสตร์ มีรูปโลก","name":"สิ่งแวดล้อมศึกษา"}},"คณะวิทยาการสารสนเทศ":{"หลักสูตรศิลปศาสตรบัณฑิต สาขาวิชาสารสนเทศศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศาสตร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาคอมพิวเตอร์แอนิเมชั่นและเกม":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developer"],"image":"นักออกแบบ graphic","name":"คอมพิวเตอร์แอนิเมชันและเกม"},"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาภูมิสารสนเทศ":{"jobsTH":["นักภูมิศาสตร์","นักสำรวจภูมิสารสนเทศ","นักเทคนิคภูมิสารสนเทศ"],"jobsENG":["Geographers","Geodetic Surveyors","Geographic Information Systems Technicians"],"image":"นักสำรวจ","name":"ภูมิสารสนเทศ"},"หลักสูตรนิเทศศาสตรบัณฑิต สาขาวิชานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"}},"คณะวิศวกรรมศาสตร์ ":{"วิศวกรรมศาสตร์":{"jobsTH":["วิศวกร"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรทั่วไป","name":"วิศวะ"}},"คณะสถาปัตยกรรมศาสตร์ ผังเมืองและนฤมิตศิลป์":{"สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาสถาปัตยกรรมผังเมือง":{"jobsTH":["นักวางผังเมือง"],"jobsENG":["Urban and Regional Planners"],"image":"นักวางผังเมือง","name":"สถาปัตย์ ผังเมือง"},"สาขาวิชาสถาปัตยกรรมภายใน":{"jobsTH":["สถาปนิกภายใน"],"jobsENG":["Architects, Except Landscape and Naval","Interior Designers"],"image":"นักออกแบบภายใน","name":"สถาปัตย์ ภายใน"},"สาขาวิชาภูมิสถาปัตยกรรม":{"jobsTH":["ภูมิสถาปนิก"],"jobsENG":["Landscape Architects"],"image":"สถาปนิก Landscape","name":"ภูมิสถาปัตย์"},"หลักสูตรศิลปกรรมศาสตรบัณฑิต สาขาวิชานฤมิตศิลป์":{"jobsTH":["ศิลปิน"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators"],"image":"ศิลปิน","name":"นฤมิตศิลป์"}},"คณะการบัญชีและการจัดการ":{"บัญชีบัณฑิต":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"บัญชี"},"บริหารธุรกิจบัณฑิต สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"บริหารธุรกิจบัณฑิต สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developer","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"คอมพิวเตอร์ธุรกิจ"},"บริหารธุรกิจบัณฑิต สาขาวิชาธุรกิจระหว่างประเทศ (นานาชาติ)":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการบริหารการเงิน":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การบริหารการเงิน"},"บริหารธุรกิจบัณฑิต สาขาวิชาเทคโนโลยีสารสนเทศธุรกิจ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการการประกอบการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"การจัดการการประกอบการ"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการพาณิชย์อิเล็กทรอนิกส์":{"jobsTH":["นักพัฒนาซอฟแวร์","นักพัฒนาเว็บไซต์","ผู้ดูแลระบบเครือข่ายคอมพิวเตอร์","ผู้จัดการโครงการด้านเทคโนโลยีสารสนเทศ"],"jobsENG":["Software Developers, Applications","Web Developers","Network and Computer Systems Administrators","Information Technology Project Managers"],"image":"นักธุรกิจ E-Commerce","name":"การจัดการพาณิชย์อิเล็กทรอนิกส์"},"บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"การจัดการทรัพยากรมนุษย์"},"เศรษฐศาสตรบัณฑิต":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"คณะการท่องเที่ยวและการโรงแรม":{"สาขาวิชาการจัดการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการท่องเที่ยว"},"สาขาวิชาการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การโรงแรม"},"สาขาวิชาการจัดการท่องเที่ยวนานาชาติ (ภาษาอังกฤษ)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการท่องเที่ยวนานาชาติ"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"สาขาวิชาภาษาไทย":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาไทย"},"สาขาวิชาภาษาเพื่อการสร้างสรรค์งานสื่อสิ่งพิมพ์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"ฝ่ายสื่อสารองค์กร","name":"ภาษาเพื่อการสร้างสรรค์สื่อสิ่งพิมพ์"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาอังกฤษธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษธุรกิจ"},"สาขาวิชาภาษาอังกฤษเพื่อการสื่อสารนานาชาติ (ภาษาอังกฤษ)":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษเพื่อการสื่อสาร"},"สาขาวิชาภาษาฝรั่งเศส":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาฝรั่งเศส"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาการพัฒนาชุมชน":{"jobsTH":["นักพัฒนาชุมชน","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"การพัฒนาชุมชน"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาวิชาภาษาเกาหลี":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเกาหลี"},"สาขาวิชาภาษาและวัฒนธรรมอาเซียน เขมร":{"jobsTH":["ผู้เชี่ยวชาญวัฒนธรรมเขมร"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาวัฒนธรรมเขมร"},"สาขาวิชาภาษาและวัฒนธรรมอาเซียน ลาว":{"jobsTH":["ผู้เชี่ยวชาญวัฒนธรรมลาว"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาวัฒนธรรมลาว"},"สาขาวิชาภาษาและวัฒนธรรมอาเซียน พม่า":{"jobsTH":["ผู้เชี่ยวชาญวัฒนธรรมพม่า"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาวัฒนธรรมพม่า"},"สาขาวิชาภาษาและวัฒนธรรมอาเซียน เวียดนาม":{"jobsTH":["ผู้เชี่ยวชาญวัฒนธรรมเวียดนาม"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาวัฒนธรรมเวียดนาม"},"สาขาวิชาภูมิศาสตร์พัฒนาเพื่อการจัดการทรัพยากร":{"jobsTH":["นักภูมิศาสตร์"],"jobsENG":["Geographers"],"image":"นักภูมิศาสตร์","name":"ภูมิศาสตร์เพื่อจัดการทรัพยากร"}},"คณะศึกษาศาสตร์":{"สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ศึกษา วิทยาศาสตร์ทั่วไป"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ศึกษา คณิตศาสตร์"},"สาขาวิชาสังคมศึกษา":{"jobsTH":["ครูสอนสังคมศึกษา"],"jobsENG":["Social Sciences Teachers, All Other"],"image":"ครูสอนสังคมศึกษา","name":"ศึกษา สังคมศึกษา"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ศึกษา ภาษาอังกฤษ"},"สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูสอนภาษาไทย","name":"ศึกษา ภาษาไทย"},"สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"สาขาวิชาเทคโนโลยีและสื่อสารการศึกษา":{"jobsTH":["ช่างภาพ","นักตัดต่อ","นักวิชาการโสตทัศนศึกษา"],"jobsENG":["Photographers","Film and Video Editors","Audio-Visual and Multimedia Collections Specialists"],"image":"คนคุมห้องโสตทัศนศึกษา","name":"เทคโนโลยีและสื่อสารการศึกษา"},"สาขาวิชาจิตวิทยา":{"jobsTH":["นักจิตวิทยา"],"jobsENG":["Counseling Psychologists"],"image":"นักจิตวิทยา","name":"จิตวิทยา"},"สาขาวิชาวิทยาศาสตร์การกีฬา":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยาฯ กีฬา"}},"คณะศิลปกรรมศาสตร์":{"สาขาวิชาทัศนศิลป์":{"jobsTH":["จิตรกร/นักประติมากรรม/นักวาดประกอบเรื่อง","ช่างภาพ","สำนักพิมพ์"],"jobsENG":["Fine Artists, Including Painters, Sculptors, and Illustrators","Photographers","Printing Press Operators"],"image":"ศิลปิน","name":"ทัศนศิลป์"},"สาขาวิชาศิลปะการแสดง":{"jobsTH":["นักแสดง","นักร้อง","ผู้กำกับ","นักเขียนบท","ผู้ผลิตรายการ"],"jobsENG":["Actors","Singers","Directors","Writers and Authors","Producers"],"image":"นักแสดง ","name":"ศิลปะการแสดง"}},"คณะวัฒนธรรมศาสตร์":{"สาขาวิชาการจัดการวัฒนธรรม":{"jobsTH":["นักมานุษยวิทยา","ผู้เชี่ยวชาญด้านวัฒนธรรม"],"jobsENG":["Anthropologists","Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"นักมานุษยวิทยา","name":"การจัดการวัฒนธรรม"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"วิทยาลัยการเมืองการปกครอง":{"สาขาวิชาการเมืองการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การเมืองการปกครอง"},"สาขาวิชารัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"สาขาวิชาความสัมพันธ์ระหว่างประเทศ":{"jobsTH":["นักการทูต","โฆษกด้านระหว่างประเทศ","ฝ่ายข่าวกรอง"],"jobsENG":["Political Scientists","Public Relations Specialists","Intelligence Analysts"],"image":"นักการทูต","name":"ความสัมพันธ์ระหว่างประเทศ"}},"วิทยาลัยดุริยางคศิลป์":{"สาขาวิชาดุริยางคศิลป์":{"jobsTH":["นักดนตรี","นักประพันธ์เพลง","ผู้อำนวยเพลง","นักร้อง"],"jobsENG":["Musicians, Instrumental","Music Composers and Arrangers","Music Directors","Singers"],"image":"นักดนตรี","name":"ดุริยางคศิลป์"}}},"มหาวิทยาลัยแม่ฟ้าหลวง":{"สำนักวิชาศิลปศาสตร์":{"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาจีนธุรกิจ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีนธุรกิจ"},"สาขาวิชาการสอนภาษาจีน":{"jobsTH":["ครูสอนภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"การสอนภาษาจีน"},"สาขาวิชาการพัฒนาระหว่างประเทศ":{"jobsTH":["ผู้เชี่ยวชาญด้านระหว่างประเทศ"],"jobsENG":["International Relations Specialists"],"image":"นักการทูต","name":"การพัฒนาระหว่างประเทศ"},"สาขาวิชาภาษาและวัฒนธรรมจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary"],"image":"ล่าม/นักแปล","name":"ภาษาและวัฒนธรรมจีน"}},"สำนักวิชาวิทยาศาสตร์":{"สาขาวิชาเคมีประยุกต์ (เคมีผลิตภัณฑ์ธรรมชาติ)":{"jobsTH":["นักเคมี"],"jobsENG":["Chemical Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมีประยุกต์ (เคมีผลิตภัณฑ์ธรรมชาติ)"},"สาขาวิชาเคมีประยุกต์ (วิทยาศาสตร์และเทคโนโลยีพอลิเมอร์)":{"jobsTH":["นักเคมี"],"jobsENG":["Chemical Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมีประยุกต์ (วิทยาศาสตร์และเทคโนโลยีพอลิเมอร์)"},"สาขาวิชาเคมีประยุกต์ (เคมีวิเคราะห์)":{"jobsTH":["นักเคมี"],"jobsENG":["Chemical Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมีประยุกต์ (เคมีวิเคราะห์)"},"สาขาวิชาวิทยาศาสตร์ชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิทยาศาสตร์สิ่งแวดล้อม","name":"วิทยาศาสตร์ชีวภาพ"},"สาขาวิชาวิศวกรรมวัสดุ":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Material Engineers"],"image":"วิศวกรวัสดุ","name":"วิศวกรรมวัสดุ"}},"สำนักวิชาการจัดการ":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"},"สาขาวิชาเศรษฐศาสตร์":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"},"สาขาวิชาบริหารธุรกิจ":{"jobsTH":["นักธุรกิจ"],"jobsENG":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"},"สาขาวิชาการจัดการการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การจัดการการท่องเที่ยว"},"สาขาวิชาการจัดการอุตสาหกรรมการบริการ (เน้นบริหารการโรงแรม)":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การจัดการอุตสาหกรรมการบริการ (เน้นบริหารการโรงแรม)"},"สาขาวิชาการจัดการโลจิสติกส์และโซ่อุปทาน":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"การจัดการโลจิสติกส์และโซ่อุปทาน"},"สาขาวิชาการจัดการธุรกิจการบิน (งานบริการทางการบิน)":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","ตัวแทนขนส่ง","ตัวแทนจองตั๋วโดยสาร"],"jobsENG":["Flight Attendants","Cargo and Freight Agents","Reservation and Transportation Ticket Agents and Travel Clerks"],"image":"พนักงานต้อนรับ","name":"การจัดการธุรกิจการบิน (งานบริการทางการบิน)"},"สาขาวิชาการจัดการธุรกิจการบิน (ธุรกิจโลจิสติกส์ทางการบิน)":{"jobsTH":["นักวิเคราะห์โลจิสติกส์","ผู้จัดการฝ่ายโลจิสติกส์","ตัวแทนขนส่งสินค้า"],"jobsENG":["Logistics Analysts","Logistics Managers","Freight Forwarders"],"image":"นักโลจิสติกส์","name":"การจัดการธุรกิจการบิน (ธุรกิจโลจิสติกส์ทางการบิน)"},"สาขาวิชาการจัดการธุรกิจการบิน (การปฏิบัติการทางการบิน)":{"jobsTH":["บิน","ตรวจ","ควบคุม"],"jobsENG":["Airline Pilots, Copilots, and Flight Engineers","Aviation Inspectors","Air Traffic Controllers"],"image":"นักบิน (กัปตัน)","name":"การจัดการธุรกิจการบิน (การปฏิบัติการทางการบิน)"}},"สำนักวิชาเทคโนโลยีสารสนเทศ":{"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["ผู้ควบคุมระบบคอมพิวเตอร์"],"jobsENG":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาวิศวกรรมซอฟแวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวะ ซอฟแวร์"},"สาขาวิชาเทคโนโลยีมัลติมีเดียและการสร้างภาพเคลื่อนไหว":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developer"],"image":"นักออกแบบ Graphic","name":"เทคโนโลยีมัลติมีเดียและการสร้างภาพเคลื่อนไหว"},"สาขาวิชาวิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมพิวเตอร์","name":"วิศวะ คอมพิวเตอร์"},"สาขาวิชาวิศวกรรมการสื่อสารและสารสนเทศ":{"jobsTH":["วิศวกรการสื่อสาร"],"jobsENG":["Electronics Engineers, Except Computer"],"image":"วิศวกรการสื่อสาร","name":"วิศวะ การสื่อสารและสารสนเทศ"},"สาขาวิชาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาเทคโนโลยีการจัดการผลิตผลเกษตรและการบรรจุ":{"jobsTH":["นักเทคโนโลยีการเกษตร","นักวิทยาศาสตร์การอาหาร"],"jobsENG":["Agricultural Technicians","Food Science Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีการจัดการผลิตผลเกษตรและการบรรจุ"}},"สำนักวิชานิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"สำนักวิชาวิทยาศาสตร์เครื่องสำอาง":{"สาขาวิชาวิทยาศาสตร์เครื่องสำอาง":{"jobsTH":["นักวิทยาศาสตร์เครื่องสำอาง"],"jobsENG":["Chemical Technicians"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"วิทยาศาสตร์เครื่องสำอาง"},"สาขาวิชาเทคโนโลยีความงดงาม":{"jobsTH":["ผู้เชี่ยวชาญด้านความงาม"],"jobsENG":["Skincare Specialists"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เทคโนโลยีความงดงาม"},"สาขาวิชาการแพทย์แผนไทยประยุกต์":{"jobsTH":["แพทย์แผนไทย"],"jobsENG":["แพทย์แผนไทย","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"image":"แพทย์แผนไทย","name":"การแพทย์แผนไทยประยุกต์"},"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"},"สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุขศาสตร์"},"สาขาวิชาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"สาขาวิชาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาวิชาวิทยาศาสตร์การกีฬาและสุขภาพ":{"jobsTH":["นักกีฬา","ผู้ควบคุมการฝึกนักกีฬา","โค้ชกีฬา"],"jobsENG":["Athletes","Athletic Trainers","Coaches and Scouts"],"image":"เทรนเนอร์","name":"วิทยาฯ กีฬา"},"สาขาวิชาการแพทย์แผนจีน":{"jobsTH":["แพทย์แผนตะวันออก","แพทย์บำบัดด้วยการนวด","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Doctors","Massage Therapists","Community Health Workers"],"image":"แพทย์แผนจีน","name":"การแพทย์แผนจีน"}},"สำนักวิชาพยาบาลศาสตร์":{"สาขาวิชาพยาบาลศาสตร์":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}}},"มหาวิทยาลัยวลัยลักษณ์":{"สำนักวิชาศิลปศาสตร์":{"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"},"สาขาวิชาภาษาจีน":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีน"},"สาขาวิชาอาเซียนศึกษา":{"jobsTH":["ผู้เชี่ยวชาญด้านอาเซียน"],"jobsENG":["Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"นักการเมือง","name":"อาเซียนศึกษา"},"สาขาวิชารัฐศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นักการเมือง","name":"รัฐศาสตร์"},"สาขาวิชาหลักสูตรไทยศึกษาบูรณาการ":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ไทยศึกษาบูรณาการ"}},"สำนักวิชาสารสนเทศศาสตร์":{"สาขาวิชานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาการจัดการสารสนเทศดิจิทัล":{"jobsTH":["ผู้ควบคุมระบบคอมพิวเตอร์"],"jobsENG":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"image":"เจ้าหน้าที่ฝ่าย IT","name":"การจัดการสารสนเทศ"},"สาขาวิชาเทคโนโลยีมัลติมีเดียและแอนิเมชัน":{"jobsTH":["นักสร้างสรรค์สื่อมัลติมีเดีย","นักตัดต่อ","นักพัฒนาเว็บไซต์"],"jobsENG":["Multimedia Artists and Animators","Film and Video Editors","Web Developer"],"image":"นักออกแบบ graphic","name":"เทคโนโลยีมัลติมีเดียและแอนิเมชัน"},"สาขาวิชาวิศวกรรมซอฟแวร์":{"jobsTH":["ผู้พัฒนาซอฟแวร์","ผู้พัฒนาระบบซอฟแวร์","วิศวกรซอฟแวร์"],"jobsENG":["Software Developers, Applications","Software Developers, Systems Software","Software Quality Assurance Engineers and Testers"],"image":"วิศวกร Software","name":"วิศวะ ซอฟต์แวร์"}},"สำนักวิชาวิทยาศาสตร์":{"สาขาวิชาวิทยาศาสตร์เชิงคำนวณ":{"jobsTH":["นักวิทยาศาสตร์เชิงคำนวณ"],"jobsENG":["Mathematicians"],"image":"นักคณิตศาสตร์","name":"วิทยาศาสตร์เชิงคำนวณ"}},"สำนักวิชาการจัดการ":{"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"},"สาขาวิชาบริหารธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"นักธุรกิจ","name":"บริหารธุรกิจ"},"สาขาวิชาอุตสาหกรรมท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"อุตสาหกรรมท่องเที่ยว"},"สาขาวิชาหลักสูตรเศรษฐศาสตร์":{"jobsTH":["นักเศรษฐศาสตร์","โบรกเกอร์","นักวิเคราะห์การเงิน","ที่ปรึกษาด้านการเงิน","นักลงทุน","ผู้จัดการกองทุน","นักเศรษฐศาสตร์สิ่งแวดล้อม"],"jobsENG":["Economists","Stockbrokers","Financial Analysts","Financial Advisors","Investment Fund Managers","Environmental Economists"],"image":"นักเศรษฐศาสตร์","name":"เศรษฐศาสตร์"}},"สำนักวิชาเทคโนโลยีการเกษตร":{"สาขาวิชาเกษตรศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"เกษตรศาสตร์"},"สาขาวิชาอุตสาหกรรมเกษตร":{"jobsTH":["ผู้จัดการฟาร์ม","ผู้ควบคุมการผลิต","ตัวแทนจำหน่ายสินค้าเกษตรกรรม"],"jobsENG":["Farm and Ranch Managers","First-Line Supervisors of Agricultural Crop and Horticultural Workers","Buyers and Purchasing Agents, Farm Products"],"image":"คนขายอุปกรณ์การเกษตร","name":"อุตสาหกรรมเกษตร"}},"สำนักวิชาวิศวกรรมศาสตร์และทรัพยากร":{"วิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"วิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"วิศวกรรมคอมพิวเตอร์":{"jobsTH":["วิศวกรคอมพิวเตอร์"],"jobsENG":["Computer Engineers"],"image":"วิศวกรคอมพิวเตอร์","name":"วิศวะ คอมพิวเตอร์"},"วิศวกรรมวัสดุ (พอลิเมอร์ ยาง ไม้)":{"jobsTH":["วิศวกรวัสดุ"],"jobsENG":["Materials Engineers"],"image":"วิศวกรวัสดุ","name":"วิศวะ วัสดุ"},"วิศวกรรมเคมีและกระบวนการวิทยาศาสตร์สิ่งแวดล้อม":{"jobsTH":["วิศวกรเคมี","วิศวกรอุตสาหการ"],"jobsENG":["Chemical Engineers","Industrial Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมีและสิ่งแวดล้อม"},"สาขาวิชาเทคโนโลยีการจัดการทรัพยากรทะเลและชายฝั่ง":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อมทางทะเล","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"เทคโนโลยีการจัดการทรัพยากรทะเล"}},"สำนักวิชาสหเวชศาสตร์และสาธารณสุขศาสตร์":{"สาขาวิชาเทคนิคการแพทย์":{"jobsTH":["นักเทคนิคการแพทย์","นักนิติวิทยาศาสตร์","นักเทคนิคห้องปฏิบัติการทางการแพทย์"],"jobsENG":["Medical and Clinical Laboratory Technologists","Forensic Scientist","Medical and Clinical Laboratory Technicians"],"image":"นักเทคนิคการแพทย์","name":"เทคนิคการแพทย์"},"สาขาวิชาอนามัยสิ่งแวดล้อม":{"jobsTH":["นักอนามัยสิ่งแวดล้อม","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Environmental Scientists","Community Health Workers"],"image":"นักอนามัยสิ่งแวดล้อม","name":"อนามัยสิ่งแวดล้อม"},"สาขาวิชาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาวิชากายภาพบำบัด":{"jobsTH":["นักกายภาพบำบัด"],"jobsENG":["Physical Therapists"],"image":"นักกายภาพบำบัด","name":"กายภาพบำบัด"}},"สำนักวิชาพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}},"สำนักวิชาเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"สำนักวิชาสถาปัตยกรรมศาสตร์และการออกแบบ":{"สาขาวิชาสถาปัตยกรรม":{"jobsTH":["สถาปนิก"],"jobsENG":["Architects, Except Landscape and Naval"],"image":"สถาปนิก","name":"สถาปัตย์"},"สาขาวิชาการออกแบบอุตสาหกรรม":{"jobsTH":["นักออกแบบอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบอุตสาหกรรม","name":"การออกแบบอุตสาหกรรม"}},"สำนักวิชาแพทยศาสตร์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientist"],"image":"หมอ","name":"แพทยศาสตร์"}}},"มหาวิทยาลัยอุบลราชธานี":{"คณะเกษตรศาสตร์":{"สาขาวิชาพืชไร พืชสวน สัตวศาสตร์":{"jobsTH":["เกษตรกร","เจ้าหน้าที่ตรวจสอบเกษตรกรรม","นักเทคโนโลยีการเกษตร","ที่ปรึกษาด้านการเกษตร","นักพัฒนาชุมชน","ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"jobsENG":["Farm and Ranch Managers","Agricultural Inspectors","Agricultural Technicians","Farm and Home Management Advisors","Social and Community Service Managers","First-Line Supervisors of Animal Husbandry and Animal Care Workers","Animal Scientists","Animal Breeders"],"image":"ชาวนา (ดูไฮเทคหน่อย)","name":"พืชไร่ พืชสวน สัตวศาสตร์"},"สาขาเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"เทคโนโลยีการอาหาร"},"สาขาวิชาประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"}},"คณะวิทยาศาสตร์":{"สาขาวิชาจุลชีววิทยา":{"jobsTH":["นักจุลชีววิทยา"],"jobsENG":["Microbiologists"],"image":"นักวิทยาศาสตร์ส่องกล้องจุลทรรศน์","name":"จุลชีววิทยา"},"สาขาวิชาเคมี":{"jobsTH":["นักเคมี","นักวิจัยและพัฒนา","ผู้ปฏิบัติงานทางเคมี"],"jobsENG":["Chemists","Research and Development Scientists","Chemical Plant and System Operators"],"image":"นักวิทยาศาสตร์เคมี (มีหลอดทดลอง)","name":"เคมี"},"สาขาวิชาฟิสิกส์":{"jobsTH":["นักฟิสิกส์","นักวิชาการฟิสิกส์","นักวิเคราะห์ควบคุมคุณภาพ","นักวิจัยและพัฒนา"],"jobsENG":["Physicists","Physics Teachers, Postsecondary","Quality Control Analysts","Research and Development Scientists"],"image":"นักวิทยาศาสตร์ฟิสิกส์ (เอาคล้ายๆ ไอน์สไตน์)","name":"ฟิสิกส์"},"สาขาวิชาวิทยาการคอมพิวเตอร์":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ที่ปรึกษาด้านระบบเครือข่าย","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล","ผู้เชี่ยวชาญด้านความมั่งคงปลอดภัยไซเบอร์"],"jobsENG":["Computer Scientists (Research and Design)","Network Consultant","Computer Programmers","Computer Systems Analysts","Database Administrators","Information Security Specialists"],"image":"โปรแกรมเมอร์","name":"วิทยาการคอมพิวเตอร์"},"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"},"สาขาวิชาสุขาภิบาลสิ่งแวดล้อม":{"jobsTH":["นักสุขาภิบาลสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists and Specialists, Including Health"],"image":"นักอนามัยสิ่งแวดล้อม","name":"สุขาภิบาลสิ่งแวดล้อม"},"สาขาวิชาอาชีวอนามัยและความปลอดภัย":{"jobsTH":["นักชีวอนามัยและความปลอดภัย","เจ้าหน้าที่สาธารณสุข"],"jobsENG":["Occupational Health and Safety Specialists","Community Health Workers"],"image":"นักชีวอนามัยและความปลอดภัย","name":"อาชีวอนามัยและความปลอดภัย"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการยาง":{"jobsTH":["นักวิทยาศาสตร์ยาง"],"jobsENG":["Materials Scientists"],"image":"นักวิทยาศาสตร์ยาง","name":"วิทยาศาสตร์เทคโนโลยียาง"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["นักคณิตศาสตร์","นักคณิตศาสตร์ประกันภัย","นักสถิติ"],"jobsENG":["Mathematicians","Actuaries","Statisticians"],"image":"นักคณิตศาสตร์","name":"คณิตศาสตร์"},"สาขาวิชาชีววิทยา":{"jobsTH":["นักชีววิทยา","นักวิเคราะห์คุณภาพ","บุคลากรสนับสนุนด้านชีววิทยา"],"jobsENG":["Biologists","Quality Control Analysts","Biological Technicians"],"image":"นักชีวะวิทยา","name":"ชีววิทยา"}},"คณะวิศวกรรมศาสตร์":{"วิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"วิศวกรรมอุตสาหการ":{"jobsTH":["วิศวกรอุตสาหการ"],"jobsENG":["Industrial Engineers"],"image":"วิศวกรอุตสาหการ","name":"วิศวะ อุตสาหการ"},"วิศวกรรมไฟฟ้า":{"jobsTH":["วิศวกรไฟฟ้า"],"jobsENG":["Electrical Engineers"],"image":"วิศวกรไฟฟ้า","name":"วิศวะ ไฟฟ้า"},"วิศวกรรมโยธา":{"jobsTH":["วิศวกรโยธา"],"jobsENG":["Civil Engineers"],"image":"วิศวกรโยธา","name":"วิศวะ โยธา"},"วิศวกรรมเคมีและชีวภาพ":{"jobsTH":["วิศวกรเคมี"],"jobsENG":["Chemical Engineers"],"image":"วิศวกรเคมี","name":"วิศวะ เคมีชีวภาพ"},"วิศวกรรมสิ่งแวดล้อม":{"jobsTH":["วิศวกรสิ่งแวดล้อม"],"jobsENG":["Environmental Engineers"],"image":"วิศวกรสิ่งแวดล้อม","name":"วิศวะ สิ่งแวดล้อม"}},"คณะเภสัชศาสตร์":{"เภสัชศาสตรบัณฑิต":{"jobsTH":["เภสัชกร"],"jobsENG":["Pharmacists"],"image":"เภสัชกร","name":"เภสัช"}},"คณะศิลปศาสตร์":{"สาขาวิชาภาษาอังกฤษและการสื่อสาร":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษสื่สาร"},"สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยว "},"สาขาวิชาการพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"การพัฒนาสังคม"},"สาขาวิชาภาษาจีนและการสื่อสาร":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาจีนและการสื่อสาร"},"สาขาวิชาภาษาไทยและการสื่อสาร":{"jobsTH":["นักเขียน","ครูภาษาไทย"],"jobsENG":["Poets, Lyricists and Creative Writers","English Language and Literature Teachers, Postsecondary"],"image":"ครูสอนภาษาไทย","name":"ภาษาไทยและการสื่อสาร"},"สาขาวิชาภาษาญี่ปุ่น":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาญี่ปุ่น"},"สาขาวิชานิเทศศาสตร์":{"jobsTH":["นักประชาสัมพันธ์","นักการตลาด","บรรณาธิการ","ผู้ประกาศข่าว","นักเขียน"],"jobsENG":["Public Relations Specialists","Market Research Analysts and Marketing Specialists","Editors","Radio and Television Announcers","Copy Writers"],"image":"นักสื่อสารมวลชน","name":"นิเทศศาสตร์"},"สาขาวิชาประวัติศาสตร์":{"jobsTH":["นักประวัติศาสตร์","นักเขียน","ครูประวัติศาสตร์"],"jobsENG":["Historians","Poets, Lyricists and Creative Writers","History Teachers, Postsecondary"],"image":"นักประวัติศาสตร์","name":"ประวัติศาสตร์"},"สาขาภาษาเวียดนามและการสื่อสาร":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาเวียดนามและการสื่อสาร"}},"คณะบริหารศาสตร์":{"สาขาวิชาการจัดการธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการธุรกิจ"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการจัดการโรงแรม":{"jobsTH":["พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก"],"jobsENG":["Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers"],"image":"ผู้จัดการโรงแรม","name":"การจัดการโรงแรม"},"สาขาวิชาการเงินและธนาคาร":{"jobsTH":["นักวิเคราะห์การเงิน","ผู้จัดการฝ่ายการเงิน","ผู้ตรวจสอบการเงิน","ที่ปรึกษาด้านการเงิน","โบรคเกอร์"],"jobsENG":["Financial Managers","Financial Examiners","Financial Advisors","Stockbrokers"],"image":"นายธนาคาร","name":"การเงินการธนาคาร"},"สาขาวิชาระบบสารสนเทศเพื่อการจัดการ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developer","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"ระบบสารสนเทศเพื่อการจัดการ"},"สาขาวิชาการจัดการธุรกิจระหว่างประเทศ (ภาษาอังกฤษ)":{"jobsTH":["นักวิเคราะห์การเงิน","ฝ่ายขายหลักทรัพย์","ผู้จัดการด้านการตลาด","นักเศรษฐศาสตร์","นักลงทุน","ผู้จัดการฝ่ายขาย","ผู้ให้บริการพิธีศุลกากร","นักประชาสัมพันธ์","ผู้จัดการฝ่ายโฆษณา","เจ้าหน้าที่ฝ่ายทรัพยากรมนุษย์"],"jobsENG":["Financial Analysts","Sales Agents, Securities and Commodities","Marketing Managers","Economists","Securities and Commodities Traders","Sales Managers","Customs Brokers","Public Relations Specialists","Advertising and Promotions Managers","Human Resources Specialists"],"image":"นักธุรกิจ","name":"ธุรกิจระหว่างประเทศ"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"}},"คณะนิติศาสตร์":{"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"}},"คณะรัฐศาสตร์":{"การปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การปกครอง"},"การปกครองท้องถิ่น":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"อบต.","name":"การปกครองท้องถิ่น"},"การบริหารองค์การ":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"การบริหารองค์การ"}},"คณะศิลปประยุกต์และการออกแบบ":{"สาขาวิชาการออกแบบอุตสาหกรรม":{"jobsTH":["นักออกแบบอุตสาหกรรม"],"jobsENG":["Commercial and Industrial Designers"],"image":"นักออกแบบอุตสาหกรรม","name":"การออกแบบอุตสาหกรรม"}},"วิทยาลัยแพทยศาสตร์และการสาธารณสุข":{"หลักสูตรวิทยาศาสตรบัณฑิต สาขาวิชาสาธารณสุขศาสตร์":{"jobsTH":["นักวิชาการสาธารณสุข"],"jobsENG":["Community Health Workers"],"image":"เจ้าหน้าที่ควบคุมโรค","name":"สาธารณสุขศาสตร์"}},"คณะพยาบาลศาสตร์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}}},"มหาวิทยาลัยอุบลราชธานี (มุกดาหาร)":{"คณะบริหารธุรกิจ":{"สาขาวิชาการจัดการธุรกิจ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการธุรกิจ"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"}},"คณะวิทยาศาสตร์":{"สาขาวิชาเทคโนโลยีสารสนเทศ":{"jobsTH":["นักวิทยาการคอมพิวเตอร์","ผู้จัดการฝ่ายเทคโนโลยีสารสนเทศ","นักเขียนโปรแกรม","นักวิเคราะห์ระบบงานคอมพิวเตอร์","ผู้ดูแลระบบฐานข้อมูล"],"jobsENG":["Computer Scientists (Research and Design)","Computer and Information Systems Managers","Computer Programmers","Computer Systems Analysts","Database Administrators"],"image":"ผู้ควบคุมระบบคอมพิวเตอร์","name":"เทคโนโลยีสารสนเทศ"}}},"มหาวิทยาลัยนวมินทราธิราช":{"คณะพยาบาลศาสตร์เกื้อการุณย์":{"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"}}},"มหาวิทยาลัยกาฬสินธุ์":{"คณะเทคโนโลยีอุตสาหกรรมเกษตร":{"สาขาวิชาสัตวศาสตร์":{"jobsTH":["นักวิจัยสัตว์ป่า"],"jobsENG":["ผู้ควบคุมการปศุสัตว์","นักวิจัยสัตว์","ผู้เพาะเลี้ยงสัตว์"],"image":"นักวิทยาศาสตร์ (ดูสัตว์)","name":"สัตวศาสตร์"},"สาขาวิชาพืชศาสตร์":{"jobsTH":["นักพฤกษศาสตร์"],"jobsENG":["Soil and Plant Scientists"],"image":"นักวิทยาศาสตร์ต้นไม้ มีเรือนกระจก","name":"พืชศาสตร์"},"สาขาวิชาประมง":{"jobsTH":["ชาวประมง","ผู้จัดการฟาร์ม","ที่ปรึกษาการจัดการฟาร์ม","ผู้ควบคุมงานประมง"],"jobsENG":["Fishers and Related Fishing Workers","Farm and Ranch Managers","Farm and Home Management Advisors","First-Line Supervisors of Aquacultural Workers"],"image":"ชาวประมง","name":"ประมง"},"สาขาวิชาเทคโนโลยีชีวภาพ":{"jobsTH":["นักเทคโนโลยีชีวภาพ"],"jobsENG":["Biological Technicians"],"image":"นักวิจัยการเกษตร","name":"เทคโนโลยีชีวภาพ"},"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีการอาหาร":{"jobsTH":["ผู้ควบคุมการผลิตอาหาร","นักวิทยาศาสตร์อาหาร","ผู้ควบคุมคุณภาพ"],"jobsENG":["Food Batchmakers","Food Science Technicians","Quality Control Analysts"],"image":"นักวิทยาศาสตร์ผลิดอาหาร","name":"วิทยาศาสตร์และเทคโนโลยีการอาหาร"},"สาขาวิชาเทคนิคการสัตวแพทย์":{"jobsTH":["นักเทคนิคการแพทย์สัตว์"],"jobsENG":["Veterinary Technologists and Technicians"],"image":"นักเทคนิคสัตวแพทย์","name":"เทคนิคการสัตวแพทย์"},"สาขาวิชาเครื่องจักรกลเกษตร":{"jobsTH":["ผู้ควบคุมเครื่องจักรกลการเกษตร","ช่างอุปกรณ์การเกษตร"],"jobsENG":["Agricultural Equipment Operators","Farm Equipment Mechanics and Service Technicians"],"image":"ช่างคุมเครื่องจักรการเกษตร","name":"เครื่องจักรกลเกษตร"},"วิศวกรรมเครื่องกล":{"jobsTH":["วิศวกรเครื่องกล"],"jobsENG":["Mechanical Engineers"],"image":"วิศวกรเครื่องกล","name":"วิศวะ เครื่องกล"},"วิศวกรรมโลจิสติกส์":{"jobsTH":["วิศวกรโลจิสติกส์"],"jobsENG":["Logistics Engineers"],"image":"วิศวกรโลจิสติกส์","name":"วิศวะ โลจิสติกส์"}},"คณะเทคโนโลยีสังคม":{"สาขาวิชาการจัดการ":{"jobsTH":["ผู้บริหารระดับสูง","ผู้จัดการฝ่ายบริหารงานทั่วไป","ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ"],"jobsENG":["Top Executives","Administrative Services Managers","Consultants (Business, Management or Strategy)","Business Intelligence Analysts"],"image":"ผู้จัดการองค์กรธุรกิจ","name":"การจัดการ"},"สาขาวิชาการตลาด":{"jobsTH":["นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา"],"jobsENG":["Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers"],"image":"นักการตลาด","name":"การตลาด"},"สาขาวิชาการจัดการธุรกิจค้าปลีก":{"jobsTH":["ที่ปรึกษาด้านธุรกิจ","นักวิเคราะห์เพื่อพัฒนาธุรกิจ","นักการตลาด","นักวิจัยการตลาด","นักพัฒนาการตลาด","ผู้จัดการด้านการตลาด","นักการตลาดออนไลน์","ผู้จัดการด้านโฆษณา","เจ้าของกิจการค้าปลีก"],"jobsENG":["Consultants (Business, Management or Strategy)","Business Intelligence Analysts","Marketing Specialists","Market Research Analysts","Business Development Specialists","Marketing Managers","Online Marketing Strategists","Advertising Managers","Sales Managers"],"image":"ผู้จัดการร้านค้า","name":"การจัดการธุรกิจค้าปลีก"},"สาขาวิชาการบัญชี":{"jobsTH":["นักบัญชี","ผู้สอบบัญชี","ที่ปรึกษาด้านภาษี","นักงบประมาณ"],"jobsENG":["Accountants","Auditors","Tax Consultants","Budget Analysts"],"image":"นักบัญชี","name":"การบัญชี"},"สาขาวิชาภาษาอังกฤษเพื่อการสื่อสารสากล":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษเพื่อการสื่อสารสากล"},"สาขาวิชาการท่องเที่ยว":{"jobsTH":["พนักงานต้อนรับบนเครื่องบิน","พนักงานบริการในโรงแรม","ผู้จัดการด้านบริการ","ผู้จัดการด้านที่พัก","ตัวแทนท่องเที่ยว","มัคคุเทศก์"],"jobsENG":["Flight Attendants","Hotel, Motel, and Resort Desk Clerks","Administrative Services Managers","Lodging Managers","Travel Agents","Travel Guides"],"image":"มัคคุเทศก์","name":"การท่องเที่ยว"}},"คณะศิลปศาสตร์และวิทยาศาสตร์":{"สาขาวิชาวิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม":{"jobsTH":["นักวิทยาศาสตร์สิ่งแวดล้อม","ผู้ตรวจสอบด้านสิ่งแวดล้อม"],"jobsENG":["Environmental Scientists","Environmental Compliance Inspectors"],"image":"นักอนุรักษ์","name":"วิทยาศาสตร์และเทคโนโลยีสิ่งแวดล้อม"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ล่าม/นักแปล","ครูสอนภาษาต่างประเทศ","พนักงานต้องรับบนเครื่องบิน"],"jobsENG":["Interpreters and Translators","Foreign Language and Literature Teachers, Postsecondary","Flight Attendants"],"image":"ล่าม/นักแปล","name":"ภาษาอังกฤษ"}},"คณะรัฐศาสตร์และนิติศาสตร์":{"รัฐประศาสนศาสตร์":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"รัฐประศาสนศาสตร์"},"การปกครองท้องถิ่น":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"อบต","name":"การปกครองท้องถิ่น"},"อาชญาวิทยาและการบริหารงานตำรวจ":{"jobsTH":["ตำรวจ","เจ้าพนักงานสอบสวน","นักการเมืองและนักบริหารภาครัฐ","เจ้าพนักงานคุมประพฤติ","เจ้าพนักงานราชทัณฑ์"],"jobsENG":["Police Officers","Detectives and Investigators","Political Scientists and Public Administrators","Probation Officers","Correctional Officers"],"image":"เจ้าพนักงานคุมประพฤติ","name":"อาชญาวิทยาและการบริหารงานตำรวจ"},"การบริหารทรัพยากรมนุษย์":{"jobsTH":["ผู้เชี่ยวชาญการบริหารทรัพยากรมนุษย์","ผู้เชี่ยวชาญด้านการฝึกอบรมและพัฒนาศักยภาพบุคลากร","นักจิตวิทยาองค์กร","ที่ปรึกษาด้านพัฒนาองค์กร"],"jobsENG":["Human Resources Specialists","Training and Development Specialists","Industrial-Organizational Psychologists","Management Analysts"],"image":"เจ้าหน้าที่ฝ่าย HR","name":"การบริหารทรัพยากรมนุษย์"},"การจัดการภาครัฐและเอกชน":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"ข้าราชการ","name":"การจัดการภาครัฐและเอกชน"},"นิติศาสตรบัณฑิต":{"jobsTH":["อาจารย์สอนกฎหมาย","ผู้พิพากษา","อัยการ","ที่ปรึกษากฎหมายและทนายความ","ตำรวจหรือพนักงานสอบสวน"],"jobsENG":["Law Teachers","Judges","Prosecutors","Lawyers","Police Detectives"],"image":"ผู้พิพากษา","name":"นิติศาสตร์"},"สาขาวิชาการปกครอง":{"jobsTH":["นักการเมืองและนักบริหารภาครัฐ"],"jobsENG":["Political Scientists and Public Administrators"],"image":"นายอำเภอ","name":"การปกครอง"}},"คณะบริหารธุรกิจ":{"สาขาวิชาคอมพิวเตอร์ธุรกิจ":{"jobsTH":["ผู้จัดการด้านคอมพิวเตอร์และสารสนเทศ","นักพัฒนาระบบ","นักวิเคราะห์ระบบ"],"jobsENG":["Computer and Information Systems Managers","Application Developer","Computer Systems Analysts"],"image":"นักคุมเครือข่ายคอมพิวเตอร์องค์กร","name":"คอมพิวเตอร์ธุรกิจ"}},"คณะมนุษยศาสตร์และสังคมศาสตร์":{"สาขาวิชาการจัดการทางวัฒนธรรม":{"jobsTH":["นักมานุษยวิทยา","ผู้เชี่ยวชาญด้านวัฒนธรรม"],"jobsENG":["Anthropologists","Area, Ethnic, and Cultural Studies Teachers, Postsecondary"],"image":"นักมานุษยวิทยา","name":"การจัดการทางวัฒนธรรม"},"สาขาวิชาสารสนเทศศาสตร์":{"jobsTH":["บรรณารักษ์","เจ้าหน้าที่ห้องสมุด"],"jobsENG":["Librarians","Library Assistants, Clerical"],"image":"บรรณารักษ์","name":"สารสนเทศศาสตร์"},"สาขาวิชาพัฒนาสังคม":{"jobsTH":["นักพัฒนาสังคม","วิทยากรฝึกอบรม"],"jobsENG":["Social and Community Service Managers","Training and Development Specialists"],"image":"นักพัฒนาชนบท","name":"พัฒนาสังคม"}},"คณะสาธารณสุขศาสตร์":{"สาขาวิชาการจัดการสุขภาพท้องถิ่นและชุมชน":{"jobsTH":["เจ้าหน้าที่สาธารณสุขชุมชน"],"jobsENG":["Community Health Workers"],"image":NaN,"name":"การจัดการสุขภาพท้องถิ่นและชุมชน"}},"คณะครุศาสตร์":{"สาขาวิชาการศึกษาปฐมวัย":{"jobsTH":["ครูอนุบาล"],"jobsENG":["Kindergarten Teachers"],"image":"ครูอนุบาล","name":"การศึกษาปฐมวัย"},"สาขาวิชาคอมพิวเตอร์":{"jobsTH":["ครูสอนคอมพิวเตอร์"],"jobsENG":["Computer Science Teachers"],"image":"ครูสอนคอมพิวเตอร์","name":"ครุ คอมพิวเตอร์"},"สาขาวิชาภาษาอังกฤษ":{"jobsTH":["ครูภาษาต่างประเทศ"],"jobsENG":["Foreign Language and Literature Teachers"],"image":"ครูสอนภาษาอังกฤษ","name":"ครุ ภาษาอังกฤษ"},"สาขาวิชาภาษาไทย":{"jobsTH":["ครูภาษาไทย"],"jobsENG":["English Language and Literature Teachers"],"image":"ครูสอนภาษาไทย","name":"ครุ ภาษาไทย"},"สาขาวิชาวิทยาศาสตร์ทั่วไป":{"jobsTH":["ครูวิทยาศาสตร์"],"jobsENG":["Atmospheric, Earth, Marine, and Space Sciences Teachers"],"image":"ครูสอนวิทยาศาสตร์","name":"ครุ วิทยาศาสตร์ทั่วไป"},"สาขาวิชาคณิตศาสตร์":{"jobsTH":["ครูคณิตศาสตร์"],"jobsENG":["Mathematical Science Teachers"],"image":"ครูสอนคณิตศาสตร์","name":"ครุ คณิตศาสตร์"}}},"ราชวิทยาลัยจุฬาภรณ์":{"วิทยาลัยวิทยาศาสตร์การแพทย์เจ้าฟ้าจุฬาภรณ์":{"แพทยศาสตรบัณฑิต":{"jobsTH":["แพทย์","นักนิติวิทยาศาสตร์"],"jobsENG":["Doctors","Forensic Scientist"],"image":"หมอ","name":"แพทยศาสตรบัณฑิต"},"พยาบาลศาสตรบัณฑิต":{"jobsTH":["พยาบาล","อาจารย์พยาบาล","พยาบาลดูแลตามบ้าน"],"jobsENG":["Practical Nurses (PNs)","Nursing Instructors and Teachers","Home Health Aides"],"image":"พยาบาล","name":"พยาบาล"},"วิทยาศาสตรบัณฑิต รังสีเทคนิค":{"jobsTH":["นักรังสีรักษา","นักรังสีเทคนิค","นักเวชศาสตร์นิวเคลียร์"],"jobsENG":["Radiation Therapists","Radiologic Technicians","Nuclear Medicine Technologists"],"image":"นักรังสีเทคนิค","name":"รังสีเทคนิค"},"วิทยาศาสตรบัณฑิต สาขาชีวสารสนเทศและชีววิทยาระบบ (นานาชาติ)":{"jobsTH":["นักชีวสารสนเทศ","นักชีววิทยา"],"jobsENG":["Bioinformatics Scientists","Biologists"],"image":"นักชีวะวิทยา","name":"ชีวสารสนเทศชีววิทยาระบบ"}}}};

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Saga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_saga__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__search_saga__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__test_saga__ = __webpack_require__(985);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(signinRequest),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(stopLoading),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(startTest),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(signinSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(Saga);function signinRequest(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function signinRequest$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["a" /* loadingStart */])('โหลดข้อมูลผู้ใช้...'));case 2:case'end':return _context.stop();}}},_marked,this);}function stopLoading(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function stopLoading$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["b" /* loadingStop */])());case 2:case'end':return _context2.stop();}}},_marked2,this);}function startTest(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startTest$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.t0=Object(__WEBPACK_IMPORTED_MODULE_5_react_redux_firebase__["getFirebase"])();_context3.t1={currentTest:'cognitive',currentIndex:0,startTime:Date.now()};_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_router_redux__["push"])('/test'));case 4:_context3.t2=_context3.sent;_context3.t0.updateProfile.call(_context3.t0,_context3.t1,_context3.t2);case 6:case'end':return _context3.stop();}}},_marked3,this);}function signinSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function signinSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@reactReduxFirebase/LOGIN',signinRequest);case 2:_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@reactReduxFirebase/SET_PROFILE',stopLoading);case 4:_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@reactReduxFirebase/AUTH_EMPTY_CHANGE',stopLoading);case 6:_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@test/START',startTest);case 8:case'end':return _context4.stop();}}},_marked4,this);}function Saga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function Saga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(signinSaga),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_3__profile_saga__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_4__search_saga__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* fork */])(__WEBPACK_IMPORTED_MODULE_7__test_saga__["a" /* default */])]);case 2:case'end':return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(982);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 982 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ProfileSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addProfile),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(ProfileSaga);function addProfile(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addProfile$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["a" /* loadingStart */])("เพิ่มรายละเอียด..."));case 2:_context.prev=2;Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({name:payload.name,level:payload.level,school:payload.school,type:payload.userType,profileCompleted:true});_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["b" /* loadingStop */])());case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])('/'));case 8:_context.next=12;break;case 10:_context.prev=10;_context.t0=_context['catch'](2);case 12:case'end':return _context.stop();}}},_marked,this,[[2,10]]);}function ProfileSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function ProfileSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@profile/ADD',addProfile);case 2:case'end':return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = JobSearchSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteJob),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addJob),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(JobSearchSaga);function deleteJob(payload){var jobs;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteJob$(_context){while(1){switch(_context.prev=_context.next){case 0://console.log('---------------DELETE JOB----------------')
jobs=payload.jobs;jobs[payload.jobId]=null;Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({jobs:jobs});case 3:case'end':return _context.stop();}}},_marked,this);}function addJob(payload){var score,n,j,jobName;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addJob$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["a" /* loadingStart */])("เพิ่มสาขาวิชาที่สนใจ..."));case 2:score={COG:0,CPN:0,LOM:0,PCS:0,PEW:0,PIS:0,PPM:0,SMC:0,WCEO:0,WCII:0,WIAM:0,WICH:0,WPAM:0,WPPM:0//const n = Object.keys(payload.jobs).length
};n=1;j=0;//for(let j in Object.keys(payload.jobs)) {
jobName=payload.jobs[j].jobENG;Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().ref('jobs/'+jobName).once('value').then(function(snapshot){var wpMean=0,ssMean=0;score.COG+=snapshot.val().COG/n;//SS
score.CPN+=snapshot.val().CPN/n;ssMean+=snapshot.val().CPN/n;score.LOM+=snapshot.val().LOM/n;ssMean+=snapshot.val().LOM/n;score.PCS+=snapshot.val().PCS/n;ssMean+=snapshot.val().PCS/n;score.PEW+=snapshot.val().PEW/n;ssMean+=snapshot.val().PEW/n;score.PIS+=snapshot.val().PIS/n;ssMean+=snapshot.val().PIS/n;score.PPM+=snapshot.val().PPM/n;ssMean+=snapshot.val().PPM/n;score.SMC+=snapshot.val().SMC/n;ssMean+=snapshot.val().SMC/n;ssMean/=7;var ssSD=Math.pow(score.CPN-ssMean,2)+Math.pow(score.LOM-ssMean,2)+Math.pow(score.PCS-ssMean,2)+Math.pow(score.PEW-ssMean,2)+Math.pow(score.PIS-ssMean,2)+Math.pow(score.PPM-ssMean,2)+Math.pow(score.SMC-ssMean,2);ssSD=Math.sqrt(ssSD/(7-1));score.ZCPN=(score.CPN-ssMean)/ssSD;score.ZLOM=(score.LOM-ssMean)/ssSD;score.ZPCS=(score.PCS-ssMean)/ssSD;score.ZPEW=(score.PEW-ssMean)/ssSD;score.ZPIS=(score.PIS-ssMean)/ssSD;score.ZPPM=(score.PPM-ssMean)/ssSD;score.ZSMC=(score.SMC-ssMean)/ssSD;///--------WP
score.WCEO+=snapshot.val().WCEO/n;wpMean+=snapshot.val().WCEO/n;score.WCII+=snapshot.val().WCII/n;wpMean+=snapshot.val().WCII/n;score.WIAM+=snapshot.val().WIAM/n;wpMean+=snapshot.val().WIAM/n;score.WICH+=snapshot.val().WICH/n;wpMean+=snapshot.val().WICH/n;score.WPAM+=snapshot.val().WPAM/n;wpMean+=snapshot.val().WPAM/n;score.WPPM+=snapshot.val().WPPM/n;wpMean+=snapshot.val().WPPM/n;wpMean/=6;var wpSD=Math.pow(score.WCEO-wpMean,2)+Math.pow(score.WCII-wpMean,2)+Math.pow(score.WIAM-wpMean,2)+Math.pow(score.WICH-wpMean,2)+Math.pow(score.WPAM-wpMean,2)+Math.pow(score.WPPM-wpMean,2);wpSD=Math.sqrt(wpSD/(6-1));score.ZWCEO=(score.WCEO-wpMean)/wpSD;score.ZWCII=(score.WCII-wpMean)/wpSD;score.ZWIAM=(score.WIAM-wpMean)/wpSD;score.ZWICH=(score.WICH-wpMean)/wpSD;score.ZWPAM=(score.WPAM-wpMean)/wpSD;score.ZWPPM=(score.WPPM-wpMean)/wpSD;score.Zextraversion=0.60465996;score.Zagreeableness=0.519496586;score.Zconscientiousness=0.77498671;score.ZdesireToLearn=0.264006462;score.Zmastery=-0.076647037;score.ZotherReferencedGoals=-1.354097657;score.Zcompetitiveness=-0.161810412;score.Zworry=-1.524424407;score.Zemotionality=-0.757954035;score.ZselfEfficacy=1.711783831;score.ZCOG=(2- -2)*((score.COG-0)/(100-0))+-2;if(parseInt(j)+1===n){try{var jobs={university:payload.university,faculty:payload.faculty,department:payload.department,selectedJobs:payload.jobs,image:payload.image,score:score,name:payload.name};var temp={};if(payload.oldJobs){temp=payload.oldJobs;}var id=Date.now();temp[id]=jobs;Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({jobs:temp});}catch(err){console.log('-----SAGA ERROR-----',err);}}});//}
_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["b" /* loadingStop */])());case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])('/'));case 11:case'end':return _context2.stop();}}},_marked2,this);}function JobSearchSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function JobSearchSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@jobSearch/ADD',addJob);case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@jobSearch/DELETE',deleteJob);case 4:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TestSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(230);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(stopLoading),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(answerTest),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(TestSaga);var perMatch={'extraversion':0.27,'agreeableness':0.26,'conscientiousness':0.29,'desireToLearn':0.23,'mastery':0.19,'otherReferencedGoals':0.04,'competitiveness':0.18,'worry':0.02,'emotionality':0.11,'selfEfficacy':0.40};var _wpZ={},_ssZ={},_perZ={},_cog=0,_finalScore={};function stopLoading(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function stopLoading$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["b" /* loadingStop */])());case 2:case'end':return _context.stop();}}},_marked,this);}function answerTest(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function answerTest$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["c" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__action__["a" /* loadingStart */])('ส่งคำตอบ...'));case 2:Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().ref('tests/'+payload.userId+'/'+payload.testType+'/'+payload.testIndex).set({q:payload.question,a:payload.answer,trait:payload.trait,time:Date.now()}).then(function(){switch(payload.testType){case'cognitive':if(payload.testIndex===14){Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentTest:'personality',currentIndex:0});}else{Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentIndex:payload.testIndex+1});}break;case'personality':if(payload.testIndex===39){Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentTest:'softskills',currentIndex:0});}else{Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentIndex:payload.testIndex+1});}break;case'softskills':if(payload.testIndex===27){Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentTest:'wp',currentIndex:0});}else{Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentIndex:payload.testIndex+1});}break;case'wp':if(payload.testIndex===29){//getFirebase().updateProfile({currentTest: 'finished', currentIndex: null})
//Calculate Score
Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().ref('tests/'+payload.userId).once('value',function(snapshot){var score=snapshot.val();//COG
var cogScore=0;var cogN=Object.keys(score.cognitive).length;for(var cog in Object.keys(score.cognitive)){score.cognitive[cog].a===1?cogScore+=1:null;}cogScore=cogScore/cogN*100;//nsole.log('---FINAL SCORE---', score)
//console.log('----COGSCORE---', cogScore)
_cog=cogScore;//PERSONALITY
var perScore={'extraversion':0,'agreeableness':0,'conscientiousness':0,'desireToLearn':0,'mastery':0,'otherReferencedGoals':0,'competitiveness':0,'worry':0,'emotionality':0,'selfEfficacy':0};var perZ={'Zextraversion':0,'Zagreeableness':0,'Zconscientiousness':0,'ZdesireToLearn':0,'Zmastery':0,'ZotherReferencedGoals':0,'Zcompetitiveness':0,'Zworry':0,'Zemotionality':0,'ZselfEfficacy':0};for(var per in Object.keys(score.personality)){var trait=score.personality[per].trait;perScore[trait]+=score.personality[per].a*5;}var perSum=0;for(var _trait in perScore){//console.log(trait)
perSum+=perScore[_trait];}var perMean=perSum/10;var perSD=0;for(var _trait2 in perScore){perSD+=Math.pow(perScore[_trait2]-perMean,2);}perSD=Math.sqrt(perSD/(10-1));for(var _trait3 in perScore){perZ['Z'+_trait3]=(perScore[_trait3]-perMean)/perSD;}_perZ=perZ;//console.log('---PERSCORE---', perScore)+
//SOFTSKILLS
var ssScore={'CPN':0.0,'PPM':0.0,'SMC':0.0,'PIS':0.0,'LOM':0.0,'PCS':0.0,'PEW':0.0};var ssZ={'ZCPN':0,'ZPPM':0,'ZSMC':0,'ZPIS':0,'ZLOM':0,'ZPCS':0,'ZPEW':0};for(var ss in Object.keys(score.softskills)){var _trait4=score.softskills[ss].trait;ssScore[_trait4]+=score.softskills[ss].a*5;}var ssSum=0;for(var _trait5 in ssScore){//console.log(trait)
ssSum+=ssScore[_trait5];}var ssMean=ssSum/7;var ssSD=0;for(var _trait6 in ssScore){ssSD+=Math.pow(ssScore[_trait6]-ssMean,2);}ssSD=Math.sqrt(ssSD/(7-1));for(var _trait7 in ssScore){ssZ['Z'+_trait7]=(ssScore[_trait7]-ssMean)/ssSD;}_ssZ=ssZ;//console.log('---SSSCORE---', ssScore)
//WP
var wpScore={'WPPM':0.0,'WIAM':0.0,'WCII':0.0,'WICH':0.0,'WCEO':0.0,'WPAM':0.0};var wpZ={'ZWPPM':0,'ZWIAM':0,'ZWCII':0,'ZWICH':0,'ZWCEO':0,'ZWPAM':0};for(var wp in Object.keys(score.wp)){var _trait8=score.wp[wp].trait;wpScore[_trait8]+=score.wp[wp].a*4;}var wpSum=0;for(var _trait9 in wpScore){//console.log(trait)
wpSum+=wpScore[_trait9];}var wpMean=wpSum/6;var wpSD=0;for(var _trait10 in wpScore){wpSD+=Math.pow(wpScore[_trait10]-wpMean,2);}wpSD=Math.sqrt(wpSD/(6-1));for(var _trait11 in wpScore){wpZ['Z'+_trait11]=(wpScore[_trait11]-wpMean)/wpSD;}_wpZ=wpZ;var finalScore=Object.assign({},{COG:cogScore},{ZCOG:4*(cogScore/100)-2},ssScore,wpScore,wpZ,ssZ,perZ);_finalScore=finalScore;Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({score:finalScore,currentTest:'finished',currentIndex:null});Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().ref('users/'+payload.userId+'/jobs').once('value',function(snapshot){var jobs=snapshot.val();var matching={};for(var j in jobs){var wpMatch=0;var job=jobs[j];var diff={};for(var s in job.score){if(s[0]==='Z'){var jobScore=job.score[s];if(jobScore>2)jobScore=2;if(jobScore<-2)jobScore=-2;var myScore=_finalScore[s];if(myScore>2)myScore=2;if(myScore<-2)myScore=-2;diff[s]=(myScore-jobScore)*25;if(s[1]==='W'){//console.log(diff[s])
wpMatch+=Math.abs(diff[s]);}}}wpMatch/=6;var cognitiveMatch=Math.abs(diff.ZCOG);var softskillsMatch=(Math.abs(diff.Zagreeableness)+Math.abs(diff.Zcompetitiveness)+Math.abs(diff.Zconscientiousness)+Math.abs(diff.ZdesireToLearn)+Math.abs(diff.Zemotionality)+Math.abs(diff.Zextraversion)+Math.abs(diff.Zmastery)+Math.abs(diff.ZotherReferencedGoals)+Math.abs(diff.ZselfEfficacy)+Math.abs(diff.Zworry))/20+(Math.abs(diff.ZCPN)+Math.abs(diff.ZLOM)+Math.abs(diff.ZPCS)+Math.abs(diff.ZPEW)+Math.abs(diff.ZPIS)+Math.abs(diff.ZPPM)+Math.abs(diff.ZSMC))/14;matching[j]=Object.assign({},diff,{cognitiveMatch:100-Math.abs(cognitiveMatch)},{softskillsMatch:100-Math.abs(softskillsMatch)},{wpMatch:100-Math.abs(wpMatch)},{totalMatch:(100-Math.abs(wpMatch)+(100-Math.abs(cognitiveMatch))+(100-Math.abs(softskillsMatch)))/3});}Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({matching:matching});});__WEBPACK_IMPORTED_MODULE_5__index__["store"].dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["push"])('/'));});}else{Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_firebase__["getFirebase"])().updateProfile({currentIndex:payload.testIndex+1});}break;default:console.log('INVALID TESTTYPE!!!');}});case 3:case'end':return _context2.stop();}}},_marked2,this);}function TestSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function TestSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@test/ANSWER',answerTest);case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* takeEvery */])('@@reactReduxFirebase/PROFILE_UPDATE_SUCCESS',stopLoading);case 4:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_firebase__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_redux_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actionTypes__ = __webpack_require__(110);
function loading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isLoading:true,message:'โหลดข้อมูล...'};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3__actionTypes__["e" /* LOADING_START */]:return Object.assign({},{isLoading:true,message:action.message});case __WEBPACK_IMPORTED_MODULE_3__actionTypes__["f" /* LOADING_STOP */]:return Object.assign({},{isLoading:false});default:return state;}}var reducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({//auth: authReducer,
loading:loading,router:__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["routerReducer"],firebase:__WEBPACK_IMPORTED_MODULE_2_react_redux_firebase__["firebaseStateReducer"]});/* harmony default export */ __webpack_exports__["a"] = (reducer);

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(51));
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(993);
__webpack_require__(996);
__webpack_require__(998);
__webpack_require__(999);
__webpack_require__(1001);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");

module.exports = firebase;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function() {var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},ba="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this;function ca(a,b){if(b){var c=ba;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}
function da(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function ea(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:da(a)}}
ca("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ba.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(v){m||(m=!0,p.call(h,v))}}var h=this,m=!1;return{resolve:g(this.o),reject:g(this.g)}};b.prototype.o=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.u(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.l(g):this.h(g)}};
b.prototype.l=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.v(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.m()};b.prototype.m=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.u=function(g){var h=this.f();
g.Ja(h.resolve,h.reject)};b.prototype.v=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(H,U){return"function"==typeof H?function(ta){try{p(H(ta))}catch(ld){v(ld)}}:U}var p,v,z=new b(function(H,U){p=H;v=U});this.Ja(m(g,p),m(h,v));return z};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Ja=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=ea(g),v=p.next();!v.done;v=p.next())d(v.value).Ja(h,m)})};b.all=function(g){var h=ea(g),m=h.next();return m.done?d([]):new b(function(p,v){function z(ta){return function(ld){H[ta]=ld;U--;0==U&&p(H)}}var H=[],U=0;do H.push(void 0),U++,d(m.value).Ja(z(H.length-1),v),m=h.next();while(!m.done)})};return b});var fa=fa||{},l=this;
function n(a){return"string"==typeof a}function ha(a){return"boolean"==typeof a}var ia=/^[\w+/_-]+[=]{0,2}$/,ja=null;function ka(){}
function la(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ma(a){return null===a}function na(a){return"array"==la(a)}function oa(a){var b=la(a);return"array"==b||"object"==b&&"number"==typeof a.length}function q(a){return"function"==la(a)}function r(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var pa="closure_uid_"+(1E9*Math.random()>>>0),qa=0;function ra(a,b,c){return a.call.apply(a.bind,arguments)}
function sa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function t(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?t=ra:t=sa;return t.apply(null,arguments)}
function ua(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var va=Date.now||function(){return+new Date};function u(a,b){function c(){}c.prototype=b.prototype;a.qb=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.cd=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)}};function wa(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function w(a){if(Error.captureStackTrace)Error.captureStackTrace(this,w);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}u(w,Error);w.prototype.name="CustomError";function xa(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");w.call(this,c+a[d])}u(xa,w);xa.prototype.name="AssertionError";function ya(a,b){throw new xa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function za(a,b){this.c=a;this.f=b;this.b=0;this.a=null}za.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Aa(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ba(){this.b=this.a=null}var Da=new za(function(){return new Ca},function(a){a.reset()});Ba.prototype.add=function(a,b){var c=Da.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ea(){var a=Fa,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Ca(){this.next=this.b=this.a=null}Ca.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Ca.prototype.reset=function(){this.next=this.b=this.a=null};var Ga=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(n(a))return n(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},x=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=n(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};function Ha(a,b){for(var c=n(a)?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
var Ia=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e=n(a)?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Ja=Array.prototype.some?function(a,b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};
function Ka(a){a:{var b=La;for(var c=a.length,d=n(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:n(a)?a.charAt(b):a[b]}function Ma(a,b){return 0<=Ga(a,b)}function Na(a,b){b=Ga(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function y(a,b){var c=0;Ha(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Oa(a){return Array.prototype.concat.apply([],arguments)}
function Pa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Qa=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},Ra=/&/g,Sa=/</g,Ta=/>/g,Ua=/"/g,Va=/'/g,Wa=/\x00/g,Xa=/[\x00&<>"']/;function A(a,b){return-1!=a.indexOf(b)}function Ya(a,b){return a<b?-1:a>b?1:0};var Za;a:{var $a=l.navigator;if($a){var ab=$a.userAgent;if(ab){Za=ab;break a}}Za=""}function B(a){return A(Za,a)};function bb(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function cb(a){for(var b in a)return!1;return!0}function db(a){var b={},c;for(c in a)b[c]=a[c];return b}var eb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function fb(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<eb.length;f++)c=eb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function gb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function hb(a){Xa.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(Ra,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace(Sa,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(Ta,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(Ua,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(Va,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(Wa,"&#0;")));return a};function ib(a){l.setTimeout(function(){throw a;},0)}var jb;
function kb(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!B("Presto")&&(a=function(){var e=document.createElement("IFRAME");e.style.display="none";e.src="";document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write("");e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=t(function(m){if(("*"==h||m.origin==h)&&m.data==
g)this.port1.onmessage()},this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!B("Trident")&&!B("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.yb;c.yb=null;e()}};return function(e){d.next={yb:e};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(e){var f=document.createElement("SCRIPT");
f.onreadystatechange=function(){f.onreadystatechange=null;f.parentNode.removeChild(f);f=null;e();e=null};document.documentElement.appendChild(f)}:function(e){l.setTimeout(e,0)}};function lb(a,b){mb||nb();ob||(mb(),ob=!0);Fa.add(a,b)}var mb;function nb(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);mb=function(){a.then(pb)}}else mb=function(){var b=pb;!q(l.setImmediate)||l.Window&&l.Window.prototype&&!B("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(jb||(jb=kb()),jb(b)):l.setImmediate(b)}}var ob=!1,Fa=new Ba;function pb(){for(var a;a=Ea();){try{a.a.call(a.b)}catch(b){ib(b)}Aa(Da,a)}ob=!1};function C(a,b){this.a=qb;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ka)try{var c=this;a.call(b,function(d){rb(c,sb,d)},function(d){if(!(d instanceof tb))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}rb(c,ub,d)})}catch(d){rb(this,ub,d)}}var qb=0,sb=2,ub=3;function vb(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}vb.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var wb=new za(function(){return new vb},function(a){a.reset()});
function xb(a,b,c){var d=wb.get();d.g=a;d.b=b;d.f=c;return d}function D(a){if(a instanceof C)return a;var b=new C(ka);rb(b,sb,a);return b}function E(a){return new C(function(b,c){c(a)})}function yb(a,b,c){zb(a,b,c,null)||lb(ua(b,a))}function Ab(a){return new C(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,v){d--;e[p]=v;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],yb(m,ua(f,h),g);else b(e)})}
function Bb(a){return new C(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Eb:!0,value:p}:{Eb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],yb(g,ua(e,f,!0),ua(e,f,!1));else b(d)})}C.prototype.then=function(a,b,c){return Cb(this,q(a)?a:null,q(b)?b:null,c)};C.prototype.$goog_Thenable=!0;k=C.prototype;k.ia=function(a,b){a=xb(a,a,b);a.c=!0;Db(this,a);return this};k.s=function(a,b){return Cb(this,null,a,b)};
k.cancel=function(a){this.a==qb&&lb(function(){var b=new tb(a);Eb(this,b)},this)};function Eb(a,b){if(a.a==qb)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==qb&&1==d?Eb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Fb(c),Gb(c,e,ub,b)))}a.c=null}else rb(a,ub,b)}function Db(a,b){a.b||a.a!=sb&&a.a!=ub||Hb(a);a.f?a.f.next=b:a.b=b;a.f=b}
function Cb(a,b,c,d){var e=xb(null,null,null);e.a=new C(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof tb?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;Db(a,e);return e.a}k.Lc=function(a){this.a=qb;rb(this,sb,a)};k.Mc=function(a){this.a=qb;rb(this,ub,a)};
function rb(a,b,c){a.a==qb&&(a===c&&(b=ub,c=new TypeError("Promise cannot resolve to itself")),a.a=1,zb(c,a.Lc,a.Mc,a)||(a.i=c,a.a=b,a.c=null,Hb(a),b!=ub||c instanceof tb||Ib(a,c)))}function zb(a,b,c,d){if(a instanceof C)return Db(a,xb(b||ka,c||null,d)),!0;if(wa(a))return a.then(b,c,d),!0;if(r(a))try{var e=a.then;if(q(e))return Jb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Jb(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function Hb(a){a.h||(a.h=!0,lb(a.Xb,a))}function Fb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.Xb=function(){for(var a;a=Fb(this);)Gb(this,a,this.a,this.i);this.h=!1};
function Gb(a,b,c,d){if(c==ub&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Kb(b,c,d);else try{b.c?b.g.call(b.f):Kb(b,c,d)}catch(e){Lb.call(null,e)}Aa(wb,b)}function Kb(a,b,c){b==sb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Ib(a,b){a.g=!0;lb(function(){a.g&&Lb.call(null,b)})}var Lb=ib;function tb(a){w.call(this,a)}u(tb,w);tb.prototype.name="cancel";function Mb(){0!=Nb&&(Ob[this[pa]||(this[pa]=++qa)]=this);this.qa=this.qa;this.ja=this.ja}var Nb=0,Ob={};Mb.prototype.qa=!1;function Pb(a){if(!a.qa&&(a.qa=!0,a.va(),0!=Nb)){var b=a[pa]||(a[pa]=++qa);if(0!=Nb&&a.ja&&0<a.ja.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Ob[b]}}Mb.prototype.va=function(){if(this.ja)for(;this.ja.length;)this.ja.shift()()};function Qb(a){Qb[" "](a);return a}Qb[" "]=ka;function Rb(a,b){var c=Sb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Tb=B("Opera"),Ub=B("Trident")||B("MSIE"),Vb=B("Edge"),Wb=Vb||Ub,Xb=B("Gecko")&&!(A(Za.toLowerCase(),"webkit")&&!B("Edge"))&&!(B("Trident")||B("MSIE"))&&!B("Edge"),Yb=A(Za.toLowerCase(),"webkit")&&!B("Edge");function Zb(){var a=l.document;return a?a.documentMode:void 0}var $b;
a:{var ac="",bc=function(){var a=Za;if(Xb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Vb)return/Edge\/([\d\.]+)/.exec(a);if(Ub)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Yb)return/WebKit\/(\S+)/.exec(a);if(Tb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();bc&&(ac=bc?bc[1]:"");if(Ub){var cc=Zb();if(null!=cc&&cc>parseFloat(ac)){$b=String(cc);break a}}$b=ac}var Sb={};
function dc(a){return Rb(a,function(){for(var b=0,c=Qa(String($b)).split("."),d=Qa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=Ya(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||Ya(0==g[2].length,0==h[2].length)||Ya(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var ec;var fc=l.document;
ec=fc&&Ub?Zb()||("CSS1Compat"==fc.compatMode?parseInt($b,10):5):void 0;var gc=Object.freeze||function(a){return a};var hc=!Ub||9<=Number(ec),ic=Ub&&!dc("9"),jc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",ka,b),l.removeEventListener("test",ka,b)}catch(c){}return a}();function kc(a,b){this.type=a;this.b=this.target=b;this.Kb=!0}kc.prototype.preventDefault=function(){this.Kb=!1};function lc(a,b){kc.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Xb){a:{try{Qb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=n(a.pointerType)?a.pointerType:mc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}u(lc,kc);var mc=gc({2:"touch",3:"pen",4:"mouse"});lc.prototype.preventDefault=function(){lc.qb.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,ic)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};lc.prototype.f=function(){return this.a};var nc="closure_listenable_"+(1E6*Math.random()|0),oc=0;function pc(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Na=e;this.key=++oc;this.oa=this.Ia=!1}function qc(a){a.oa=!0;a.listener=null;a.proxy=null;a.src=null;a.Na=null};function rc(a){this.src=a;this.a={};this.b=0}rc.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=sc(a,b,d,e);-1<g?(b=a[g],c||(b.Ia=!1)):(b=new pc(b,this.src,f,!!d,e),b.Ia=c,a.push(b));return b};function tc(a,b){var c=b.type;c in a.a&&Na(a.a[c],b)&&(qc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function sc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.oa&&f.listener==b&&f.capture==!!c&&f.Na==d)return e}return-1};var uc="closure_lm_"+(1E6*Math.random()|0),vc={},wc=0;function xc(a,b,c,d,e){if(d&&d.once)yc(a,b,c,d,e);else if(na(b))for(var f=0;f<b.length;f++)xc(a,b[f],c,d,e);else c=zc(c),a&&a[nc]?Ac(a,b,c,r(d)?!!d.capture:!!d,e):Bc(a,b,c,!1,d,e)}
function Bc(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=r(e)?!!e.capture:!!e,h=Cc(a);h||(a[uc]=h=new rc(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=Dc();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)jc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(Ec(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");wc++}}
function Dc(){var a=Fc,b=hc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function yc(a,b,c,d,e){if(na(b))for(var f=0;f<b.length;f++)yc(a,b[f],c,d,e);else c=zc(c),a&&a[nc]?Gc(a,b,c,r(d)?!!d.capture:!!d,e):Bc(a,b,c,!0,d,e)}
function Hc(a,b,c,d,e){if(na(b))for(var f=0;f<b.length;f++)Hc(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=zc(c),a&&a[nc])?(a=a.m,b=String(b).toString(),b in a.a&&(f=a.a[b],c=sc(f,c,d,e),-1<c&&(qc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=Cc(a))&&(b=a.a[b.toString()],a=-1,b&&(a=sc(b,c,d,e)),(c=-1<a?b[a]:null)&&Ic(c))}
function Ic(a){if("number"!=typeof a&&a&&!a.oa){var b=a.src;if(b&&b[nc])tc(b.m,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(Ec(c),d):b.addListener&&b.removeListener&&b.removeListener(d);wc--;(c=Cc(b))?(tc(c,a),0==c.b&&(c.src=null,b[uc]=null)):qc(a)}}}function Ec(a){return a in vc?vc[a]:vc[a]="on"+a}
function Jc(a,b,c,d){var e=!0;if(a=Cc(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.oa&&(f=Kc(f,d),e=e&&!1!==f)}return e}function Kc(a,b){var c=a.listener,d=a.Na||a.src;a.Ia&&Ic(a);return c.call(d,b)}
function Fc(a,b){if(a.oa)return!0;if(!hc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new lc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=Jc(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=Jc(d[e],a,!1,b),c=c&&f}return c}return Kc(a,
new lc(b,this))}function Cc(a){a=a[uc];return a instanceof rc?a:null}var Lc="__closure_events_fn_"+(1E9*Math.random()>>>0);function zc(a){if(q(a))return a;a[Lc]||(a[Lc]=function(b){return a.handleEvent(b)});return a[Lc]};function F(){Mb.call(this);this.m=new rc(this);this.Qb=this;this.Va=null}u(F,Mb);F.prototype[nc]=!0;F.prototype.addEventListener=function(a,b,c,d){xc(this,a,b,c,d)};F.prototype.removeEventListener=function(a,b,c,d){Hc(this,a,b,c,d)};
F.prototype.dispatchEvent=function(a){var b,c=this.Va;if(c)for(b=[];c;c=c.Va)b.push(c);c=this.Qb;var d=a.type||a;if(n(a))a=new kc(a,c);else if(a instanceof kc)a.target=a.target||c;else{var e=a;a=new kc(d,c);fb(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=Mc(g,d,!0,a)&&e}g=a.b=c;e=Mc(g,d,!0,a)&&e;e=Mc(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=Mc(g,d,!1,a)&&e;return e};
F.prototype.va=function(){F.qb.va.call(this);if(this.m){var a=this.m,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,qc(d[e]);delete a.a[c];a.b--}}this.Va=null};function Ac(a,b,c,d,e){a.m.add(String(b),c,!1,d,e)}function Gc(a,b,c,d,e){a.m.add(String(b),c,!0,d,e)}
function Mc(a,b,c,d){b=a.m.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.oa&&g.capture==c){var h=g.listener,m=g.Na||g.src;g.Ia&&tc(a.m,g);e=!1!==h.call(m,d)&&e}}return e&&0!=d.Kb};function Nc(a,b,c){if(q(a))c&&(a=t(a,c));else if(a&&"function"==typeof a.handleEvent)a=t(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function Oc(a){var b=null;return(new C(function(c,d){b=Nc(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(c){l.clearTimeout(b);throw c;})};function Pc(a){if(a.S&&"function"==typeof a.S)return a.S();if(n(a))return a.split("");if(oa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Qc(a){if(a.U&&"function"==typeof a.U)return a.U();if(!a.S||"function"!=typeof a.S){if(oa(a)||n(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
function Rc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(oa(a)||n(a))x(a,b,void 0);else for(var c=Qc(a),d=Pc(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Sc(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Sc)for(c=a.U(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=Sc.prototype;k.S=function(){Tc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.U=function(){Tc(this);return this.a.concat()};
k.clear=function(){this.b={};this.c=this.a.length=0};function Tc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Uc(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Uc(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return Uc(this.b,a)?this.b[a]:b};k.set=function(a,b){Uc(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
k.forEach=function(a,b){for(var c=this.U(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Uc(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Vc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Wc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Xc(a,b){this.b=this.i=this.f="";this.m=null;this.g=this.c="";this.h=!1;var c;a instanceof Xc?(this.h=void 0!==b?b:a.h,Yc(this,a.f),this.i=a.i,this.b=a.b,Zc(this,a.m),this.c=a.c,$c(this,ad(a.a)),this.g=a.g):a&&(c=String(a).match(Vc))?(this.h=!!b,Yc(this,c[1]||"",!0),this.i=bd(c[2]||""),this.b=bd(c[3]||"",!0),Zc(this,c[4]),this.c=bd(c[5]||"",!0),$c(this,c[6]||"",!0),this.g=bd(c[7]||"")):(this.h=!!b,this.a=new cd(null,this.h))}
Xc.prototype.toString=function(){var a=[],b=this.f;b&&a.push(dd(b,ed,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.i)&&a.push(dd(b,ed,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.m,null!=c&&a.push(":",String(c));if(c=this.c)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(dd(c,"/"==c.charAt(0)?fd:gd,!0));(c=this.a.toString())&&a.push("?",c);(c=this.g)&&a.push("#",dd(c,hd));return a.join("")};
Xc.prototype.resolve=function(a){var b=new Xc(this),c=!!a.f;c?Yc(b,a.f):c=!!a.i;c?b.i=a.i:c=!!a.b;c?b.b=a.b:c=null!=a.m;var d=a.c;if(c)Zc(b,a.m);else if(c=!!a.c){if("/"!=d.charAt(0))if(this.b&&!this.c)d="/"+d;else{var e=b.c.lastIndexOf("/");-1!=e&&(d=b.c.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(A(e,"./")||A(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.c=d:c=""!==a.a.toString();c?$c(b,ad(a.a)):c=!!a.g;c&&(b.g=a.g);return b};function Yc(a,b,c){a.f=c?bd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function Zc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.m=b}else a.m=null}function $c(a,b,c){b instanceof cd?(a.a=b,id(a.a,a.h)):(c||(b=dd(b,jd)),a.a=new cd(b,a.h))}function G(a,b,c){a.a.set(b,c)}function kd(a,b){return a.a.get(b)}
function md(a){return a instanceof Xc?new Xc(a):new Xc(a,void 0)}function nd(a,b){var c=new Xc(null,void 0);Yc(c,"https");a&&(c.b=a);b&&(c.c=b);return c}function bd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function dd(a,b,c){return n(a)?(a=encodeURI(a).replace(b,od),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function od(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
var ed=/[#\/\?@]/g,gd=/[#\?:]/g,fd=/[#\?]/g,jd=/[#\?@]/g,hd=/#/g;function cd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function pd(a){a.a||(a.a=new Sc,a.b=0,a.c&&Wc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function qd(a){var b=Qc(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new cd(null,void 0);a=Pc(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];na(f)?rd(c,e,f):c.add(e,f)}return c}k=cd.prototype;
k.add=function(a,b){pd(this);this.c=null;a=sd(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function td(a,b){pd(a);b=sd(a,b);Uc(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Uc(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Tc(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function ud(a,b){pd(a);b=sd(a,b);return Uc(a.a.b,b)}k.forEach=function(a,b){pd(this);this.a.forEach(function(c,d){x(c,function(e){a.call(b,e,d,this)},this)},this)};
k.U=function(){pd(this);for(var a=this.a.S(),b=this.a.U(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.S=function(a){pd(this);var b=[];if(n(a))ud(this,a)&&(b=Oa(b,this.a.get(sd(this,a))));else{a=this.a.S();for(var c=0;c<a.length;c++)b=Oa(b,a[c])}return b};k.set=function(a,b){pd(this);this.c=null;a=sd(this,a);ud(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
k.get=function(a,b){if(!a)return b;a=this.S(a);return 0<a.length?String(a[0]):b};function rd(a,b,c){td(a,b);0<c.length&&(a.c=null,a.a.set(sd(a,b),Pa(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.U(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.S(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
function ad(a){var b=new cd;b.c=a.c;a.a&&(b.a=new Sc(a.a),b.b=a.b);return b}function sd(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function id(a,b){b&&!a.f&&(pd(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(td(this,d),rd(this,e,c))},a));a.f=b};var vd=!Ub||9<=Number(ec);function wd(a,b){this.a=a===xd&&b||"";this.b=yd}wd.prototype.na=!0;wd.prototype.ma=function(){return this.a};wd.prototype.toString=function(){return"Const{"+this.a+"}"};function zd(a){if(a instanceof wd&&a.constructor===wd&&a.b===yd)return a.a;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"}var yd={},xd={};function Ad(){this.a="";this.b=Bd}Ad.prototype.na=!0;Ad.prototype.ma=function(){return this.a.toString()};Ad.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function Cd(a){if(a instanceof Ad&&a.constructor===Ad&&a.b===Bd)return a.a;ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+la(a));return"type_error:TrustedResourceUrl"}
function Dd(a,b){var c=zd(a);if(!Ed.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(Fd,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof wd?zd(d):encodeURIComponent(String(d))});return Gd(a)}var Fd=/%{(\w+)}/g,Ed=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,Bd={};
function Gd(a){var b=new Ad;b.a=a;return b};function Hd(){this.a="";this.b=Id}Hd.prototype.na=!0;Hd.prototype.ma=function(){return this.a.toString()};Hd.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Jd(a){if(a instanceof Hd&&a.constructor===Hd&&a.b===Id)return a.a;ya("expected object of type SafeUrl, got '"+a+"' of type "+la(a));return"type_error:SafeUrl"}var Kd=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function Ld(a){if(a instanceof Hd)return a;a="object"==typeof a&&a.na?a.ma():String(a);Kd.test(a)||(a="about:invalid#zClosurez");return Md(a)}var Id={};function Md(a){var b=new Hd;b.a=a;return b}Md("about:blank");function Nd(){this.a="";this.b=Od}Nd.prototype.na=!0;Nd.prototype.ma=function(){return this.a.toString()};Nd.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Pd(a){if(a instanceof Nd&&a.constructor===Nd&&a.b===Od)return a.a;ya("expected object of type SafeHtml, got '"+a+"' of type "+la(a));return"type_error:SafeHtml"}var Od={};function Qd(a){var b=new Nd;b.a=a;return b}Qd("<!DOCTYPE html>");Qd("");Qd("<br>");function Rd(a,b){a.src=Cd(b);if(null===ja)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ia.test(b)){ja=b;break b}ja=""}b=ja;b&&a.setAttribute("nonce",b)};function Sd(a){var b=document;return n(a)?b.getElementById(a):a}function Td(a,b){bb(b,function(c,d){c&&"object"==typeof c&&c.na&&(c=c.ma());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:Ud.hasOwnProperty(d)?a.setAttribute(Ud[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
var Ud={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function Vd(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!vd&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',hb(g.name),'"');if(g.type){f.push(' type="',hb(g.type),'"');var h={};fb(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=e.createElement(f);g&&(n(g)?f.className=g:na(g)?f.className=g.join(" "):Td(f,g));2<d.length&&Wd(e,f,d);return f}
function Wd(a,b,c){function d(g){g&&b.appendChild(n(g)?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!oa(f)||r(f)&&0<f.nodeType?d(f):x(Xd(f)?Pa(f):f,d)}}function Xd(a){if(a&&"number"==typeof a.length){if(r(a))return"function"==typeof a.item||"string"==typeof a.item;if(q(a))return"function"==typeof a.item}return!1};function Yd(a){var b=[];Zd(new $d,a,b);return b.join("")}function $d(){}
function Zd(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(na(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Zd(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),ae(d,c),c.push(":"),Zd(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":ae(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var be={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ce=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
function ae(a,b){b.push('"',a.replace(ce,function(c){var d=be[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),be[c]=d);return d}),'"')};/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function de(){var a=I();return Ub&&!!ec&&11==ec||/Edge\/\d+/.test(a)}function ee(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function fe(a,b){b=b||l.window;var c="about:blank";a&&(c=Jd(Ld(a)).toString());b.location.href=c}function ge(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<ge(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function he(){var a=I();a=ie(a)!=je?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Ub||!ec||9<ec}function ke(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function le(a){a=a||l.window;try{a.close()}catch(b){}}
function me(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,A(c,"crios/")&&(b.target="_blank"));ie(I())==ne&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof Hd?c:Ld("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");(B("iPhone")&&!B("iPod")&&!B("iPad")||B("iPad")||B("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c?(g=d.document.createElement("A"),b instanceof Hd||b instanceof Hd||(b="object"==typeof b&&b.na?b.ma():String(b),Kd.test(b)||(b="about:invalid#zClosurez"),b=Md(b)),g.href=Jd(b),g.setAttribute("target",
c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={}):a.noreferrer?(g=d.open("",c,g),a=Jd(b).toString(),g&&(Wb&&A(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Qd('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+hb(a)+'">'),g.document.write(Pd(a)),g.document.close())):(g=d.open(Jd(b).toString(),c,g))&&a.noopener&&(g.opener=null);if(g)try{g.focus()}catch(h){}return g}
function oe(a){return new C(function(b){function c(){Oc(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var pe=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,qe=/^[^@]+@[^@]+$/;function re(){var a=null;return(new C(function(b){"complete"==l.document.readyState?b():(a=function(){b()},yc(window,"load",a))})).s(function(b){Hc(window,"load",a);throw b;})}
function se(){return te(void 0)?re().then(function(){return new C(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))}function te(a){a=a||I();return!("file:"!==ue()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function ve(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function we(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function xe(){return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node")?"Node":we()?"Worker":"Browser"}function ye(){var a=xe();return"ReactNative"===a||"Node"===a}function ze(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
var ne="Firefox",je="Chrome";
function ie(a){var b=a.toLowerCase();if(A(b,"opera/")||A(b,"opr/")||A(b,"opios/"))return"Opera";if(A(b,"iemobile"))return"IEMobile";if(A(b,"msie")||A(b,"trident/"))return"IE";if(A(b,"edge/"))return"Edge";if(A(b,"firefox/"))return ne;if(A(b,"silk/"))return"Silk";if(A(b,"blackberry"))return"Blackberry";if(A(b,"webos"))return"Webos";if(!A(b,"safari/")||A(b,"chrome/")||A(b,"crios/")||A(b,"android"))if(!A(b,"chrome/")&&!A(b,"crios/")||A(b,"edge/")){if(A(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return je;else return"Safari";return"Other"}var Ae={Sc:"FirebaseCore-web",Uc:"FirebaseUI-web"};function Be(a,b){b=b||[];var c=[],d={},e;for(e in Ae)d[Ae[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=xe();"Browser"===c?(d=I(),c=ie(d)):"Worker"===c&&(d=I(),c=ie(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return l.navigator&&l.navigator.userAgent||""}
function J(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Ce(){try{var a=l.localStorage,b=De();if(a)return a.setItem(b,"1"),a.removeItem(b),de()?!!l.indexedDB:!0}catch(c){return we()&&!!l.indexedDB}return!1}function Ee(){return(Fe()||"chrome-extension:"===ue()||te())&&!ye()&&Ce()&&!we()}function Fe(){return"http:"===ue()||"https:"===ue()}function ue(){return l.location&&l.location.protocol||null}
function Ge(a){a=a||I();return ke(a)||ie(a)==ne?!1:!0}function He(a){return"undefined"===typeof a?null:Yd(a)}function Ie(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Je(a){if(null!==a)return JSON.parse(a)}function De(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ke(a){a=a||I();return"Safari"==ie(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Le(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Me(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=xe();this.b=ke(a)||"ReactNative"===b}
Me.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Fe()||"chrome-extension:"===ue()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Ne(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
function Oe(){var a=l.document,b=null;return Ne()||!a?D():(new C(function(c){b=function(){Ne()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Pe(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function Qe(){return!(!J("fireauth.oauthhelper",l)&&!J("fireauth.iframe",l))}
function Re(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function Se(){var a=l.navigator;return a&&a.serviceWorker?D().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).s(function(){return null}):D(null)};var Te={};function Ue(a){Te[a]||(Te[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Ve;try{var We={};Object.defineProperty(We,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(We,"abcd",{configurable:!0,enumerable:!0,value:2});Ve=2==We.abcd}catch(a){Ve=!1}function K(a,b,c){Ve?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function Xe(a){var b={};L(b,a);return b}function Ye(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function Ze(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function $e(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,$e(a[c]))}return b};function af(a){var b={},c=a[bf],d=a[cf];a=a[df];if(!a||a!=ef&&!c)throw Error("Invalid provider user info!");b[ff]=d||null;b[gf]=c||null;K(this,hf,a);K(this,jf,$e(b))}var ef="EMAIL_SIGNIN",bf="email",cf="newEmail",df="requestType",gf="email",ff="fromEmail",jf="data",hf="operation";function M(a,b){this.code=kf+a;this.message=b||lf[a]||""}u(M,Error);M.prototype.w=function(){return{code:this.code,message:this.message}};M.prototype.toJSON=function(){return this.w()};function mf(a){var b=a&&a.code;return b?new M(b.substring(kf.length),a.message):null}
var kf="auth/",lf={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-or-invalid-nonce":"The OIDC ID token requires a valid unhashed nonce.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
"operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.",
"quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.","rejected-credential":"The request contains malformed or mismatching credentials.",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.",
"unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.",
"user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function nf(a){var b=a[of];if("undefined"===typeof b)throw new M("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new M("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[pf];if(c&&"object"===typeof c){b=c[qf];var d=c[rf];c=c[sf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new M("argument-error",rf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new M("argument-error",sf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new M("argument-error",qf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new M("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new M("argument-error",pf+" property must be a non null object when specified.");this.f=null;if((b=a[tf])&&"object"===
typeof b)if(b=b[uf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new M("argument-error",uf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new M("argument-error",tf+" property must be a non null object when specified.");b=a[vf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new M("argument-error",vf+" property must be a boolean when specified.");this.c=!!b;a=a[wf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
typeof a&&!a.length))throw new M("argument-error",wf+" property must be a non empty string when specified.");this.i=a||null}var pf="android",wf="dynamicLinkDomain",vf="handleCodeInApp",tf="iOS",of="url",rf="installApp",sf="minimumVersion",qf="packageName",uf="bundleId";
function xf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function yf(a){return Ia(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var zf=null,Af=null;function Bf(a){var b="";Cf(a,function(c){b+=String.fromCharCode(c)});return b}function Cf(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),v=Af[p];if(null!=v)return v;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}Df();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
function Df(){if(!zf){zf={};Af={};for(var a=0;65>a;a++)zf[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Af[zf[a]]=a,62<=a&&(Af["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};function Ef(a){this.c=a.sub;va();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null;this.b=!!a.is_anonymous||"anonymous"==this.a}Ef.prototype.f=function(){return this.b};function Ff(a){return(a=Gf(a))&&a.sub&&a.iss&&a.aud&&a.exp?new Ef(a):null}function Gf(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(Bf(a))}catch(d){}return null};var Hf={Yc:{ab:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://securetoken.googleapis.com/v1/token",id:"p"},$c:{ab:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ib:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},ad:{ab:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ib:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function If(a){for(var b in Hf)if(Hf[b].id===a)return a=Hf[b],{firebaseEndpoint:a.ab,secureTokenEndpoint:a.ib};return null}var Jf;Jf=If("__EID__")?"__EID__":void 0;var Kf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Lf=["client_id","response_type","scope","redirect_uri","state"],Mf={Tc:{Oa:"locale",Ba:500,Aa:600,Pa:"facebook.com",hb:Lf},Vc:{Oa:null,Ba:500,Aa:620,Pa:"github.com",hb:Lf},Wc:{Oa:"hl",Ba:515,Aa:680,Pa:"google.com",hb:Lf},bd:{Oa:"lang",Ba:485,Aa:705,Pa:"twitter.com",hb:Kf}};function Nf(a){for(var b in Mf)if(Mf[b].Pa==a)return Mf[b];return null};function Of(a){var b={};b["facebook.com"]=Pf;b["google.com"]=Qf;b["github.com"]=Rf;b["twitter.com"]=Sf;var c=a&&a[Tf];try{if(c)return b[c]?new b[c](a):new Uf(a);if("undefined"!==typeof a[Vf])return new Wf(a)}catch(d){}return null}var Vf="idToken",Tf="providerId";
function Wf(a){var b=a[Tf];if(!b&&a[Vf]){var c=Ff(a[Vf]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function Uf(a){Wf.call(this,a);a=Je(a.rawUserInfo||"{}");K(this,"profile",$e(a||{}))}u(Uf,Wf);
function Pf(a){Uf.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}u(Pf,Uf);function Rf(a){Uf.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}u(Rf,Uf);function Qf(a){Uf.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}u(Qf,Uf);
function Sf(a){Uf.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}u(Sf,Uf);function Xf(a){this.a=md(a)};function Yf(a){var b=md(a),c=kd(b,"link"),d=kd(md(c),"link");b=kd(b,"deep_link_id");return kd(md(b),"link")||b||d||c||a};function Zf(){}function $f(a,b){return a.then(function(c){if(c[ag]){var d=Ff(c[ag]);if(!d||b!=d.c)throw new M("user-mismatch");return c}throw new M("user-mismatch");}).s(function(c){throw c&&c.code&&c.code==kf+"user-not-found"?new M("user-mismatch"):c;})}function bg(a,b){if(b)this.a=b;else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",a)}bg.prototype.la=function(a){return cg(a,dg(this))};
bg.prototype.b=function(a,b){var c=dg(this);c.idToken=b;return eg(a,c)};bg.prototype.f=function(a,b){return $f(fg(a,dg(this)),b)};function dg(a){return{pendingToken:a.a,requestUri:"http://localhost"}}bg.prototype.w=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};function gg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new bg(a.providerId,a.pendingToken)}catch(b){}return null}
function hg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&K(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new M("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}
hg.prototype.la=function(a){return cg(a,ig(this))};hg.prototype.b=function(a,b){var c=ig(this);c.idToken=b;return eg(a,c)};hg.prototype.f=function(a,b){var c=ig(this);return $f(fg(a,c),b)};
function ig(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:qd(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
hg.prototype.w=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
function jg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new hg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function kg(a,b){this.Dc=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.zb={};this.cb=(Nf(a)||{}).Oa||null;this.$a=null}
kg.prototype.Da=function(a){this.zb=db(a);return this};function lg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new M("argument-error",'SAML provider IDs must be prefixed with "saml."');kg.call(this,a,[])}u(lg,kg);function N(a){kg.call(this,a,Lf);this.a=[]}u(N,kg);N.prototype.ua=function(a){Ma(this.a,a)||this.a.push(a);return this};N.prototype.Fb=function(){return Pa(this.a)};
N.prototype.credential=function(a,b){var c;r(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new M("argument-error","credential failed: must provide the ID token and/or the access token.");return new hg(this.providerId,c,this.providerId)};function mg(){N.call(this,"facebook.com")}u(mg,N);K(mg,"PROVIDER_ID","facebook.com");K(mg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
function ng(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new mg).credential({accessToken:b})}function og(){N.call(this,"github.com")}u(og,N);K(og,"PROVIDER_ID","github.com");K(og,"GITHUB_SIGN_IN_METHOD","github.com");
function pg(a){if(!a)throw new M("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;r(a)&&(b=a.accessToken);return(new og).credential({accessToken:b})}function qg(){N.call(this,"google.com");this.ua("profile")}u(qg,N);K(qg,"PROVIDER_ID","google.com");K(qg,"GOOGLE_SIGN_IN_METHOD","google.com");function rg(a,b){var c=a;r(a)&&(c=a.idToken,b=a.accessToken);return(new qg).credential({idToken:c,accessToken:b})}function sg(){kg.call(this,"twitter.com",Kf)}u(sg,kg);
K(sg,"PROVIDER_ID","twitter.com");K(sg,"TWITTER_SIGN_IN_METHOD","twitter.com");function tg(a,b){var c=a;r(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new M("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new hg("twitter.com",c,"twitter.com")}
function ug(a,b,c){this.a=a;this.c=b;K(this,"providerId","password");K(this,"signInMethod",c===vg.EMAIL_LINK_SIGN_IN_METHOD?vg.EMAIL_LINK_SIGN_IN_METHOD:vg.EMAIL_PASSWORD_SIGN_IN_METHOD)}ug.prototype.la=function(a){return this.signInMethod==vg.EMAIL_LINK_SIGN_IN_METHOD?O(a,wg,{email:this.a,oobCode:this.c}):O(a,xg,{email:this.a,password:this.c})};
ug.prototype.b=function(a,b){return this.signInMethod==vg.EMAIL_LINK_SIGN_IN_METHOD?O(a,yg,{idToken:b,email:this.a,oobCode:this.c}):O(a,zg,{idToken:b,email:this.a,password:this.c})};ug.prototype.f=function(a,b){return $f(this.la(a),b)};ug.prototype.w=function(){return{email:this.a,password:this.c,signInMethod:this.signInMethod}};function Ag(a){return a&&a.email&&a.password?new ug(a.email,a.password,a.signInMethod):null}function vg(){L(this,{providerId:"password",isOAuthProvider:!1})}
function Bg(a,b){b=Cg(b);if(!b)throw new M("argument-error","Invalid email link!");return new ug(a,b,vg.EMAIL_LINK_SIGN_IN_METHOD)}function Cg(a){a=Yf(a);a=new Xf(a);var b=kd(a.a,"oobCode")||null;return"signIn"===(kd(a.a,"mode")||null)&&b?b:null}L(vg,{PROVIDER_ID:"password"});L(vg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(vg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});
function Dg(a){if(!(a.Ta&&a.Sa||a.Fa&&a.$))throw new M("internal-error");this.a=a;K(this,"providerId","phone");K(this,"signInMethod","phone")}Dg.prototype.la=function(a){return a.Ua(Eg(this))};Dg.prototype.b=function(a,b){var c=Eg(this);c.idToken=b;return O(a,Fg,c)};Dg.prototype.f=function(a,b){var c=Eg(this);c.operation="REAUTH";a=O(a,Gg,c);return $f(a,b)};
Dg.prototype.w=function(){var a={providerId:"phone"};this.a.Ta&&(a.verificationId=this.a.Ta);this.a.Sa&&(a.verificationCode=this.a.Sa);this.a.Fa&&(a.temporaryProof=this.a.Fa);this.a.$&&(a.phoneNumber=this.a.$);return a};function Hg(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};x(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new Dg(b)}return null}
function Eg(a){return a.a.Fa&&a.a.$?{temporaryProof:a.a.Fa,phoneNumber:a.a.$}:{sessionInfo:a.a.Ta,code:a.a.Sa}}function Ig(a){try{this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth()}catch(b){throw new M("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
Ig.prototype.Ua=function(a,b){var c=this.a.c;return D(b.verify()).then(function(d){if(!n(d))throw new M("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return Jg(c,{phoneNumber:a,recaptchaToken:d}).then(function(e){"function"===typeof b.reset&&b.reset();return e},function(e){"function"===typeof b.reset&&b.reset();throw e;});default:throw new M("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function Kg(a,b){if(!a)throw new M("missing-verification-id");if(!b)throw new M("missing-verification-code");return new Dg({Ta:a,Sa:b})}L(Ig,{PROVIDER_ID:"phone"});L(Ig,{PHONE_SIGN_IN_METHOD:"phone"});
function Lg(a){if(a.temporaryProof&&a.phoneNumber)return new Dg({Fa:a.temporaryProof,$:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return rg(f,c);case "facebook.com":return ng(c);case "github.com":return pg(c);case "twitter.com":return tg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new bg(b,g):new hg(b,{pendingToken:g,idToken:a.oauthIdToken,
accessToken:a.oauthAccessToken},b):(new N(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function Mg(a){if(!a.isOAuthProvider)throw new M("invalid-oauth-provider");};function Ng(a,b,c,d,e,f){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.h=f||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new M("invalid-auth-event");if(this.g&&!this.f)throw new M("invalid-auth-event");}else throw new M("invalid-auth-event");}Ng.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.i&&a.push(this.i);return a.join("-")};
Ng.prototype.w=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.h,error:this.a&&this.a.w()}};function Og(a){a=a||{};return a.type?new Ng(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&mf(a.error),a.postBody):null};/*

 Copyright 2018 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
function Pg(){this.b=null;this.a=[]}var Qg=null;Pg.prototype.subscribe=function(a){var b=this;this.a.push(a);this.b||(this.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=J("universalLinks.subscribe",l),"function"===typeof a&&a(null,this.b))};Pg.prototype.unsubscribe=function(a){y(this.a,function(b){return b==a})};function Rg(a){var b="unauthorized-domain",c=void 0,d=md(a);a=d.b;d=d.f;"chrome-extension"==d?c=gb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=gb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
M.call(this,b,c)}u(Rg,M);function Sg(a,b,c){M.call(this,a,c);a=b||{};a.Ab&&K(this,"email",a.Ab);a.$&&K(this,"phoneNumber",a.$);a.credential&&K(this,"credential",a.credential)}u(Sg,M);Sg.prototype.w=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.w();b&&fb(a,b);return a};Sg.prototype.toJSON=function(){return this.w()};
function Tg(a){if(a.code){var b=a.code||"";0==b.indexOf(kf)&&(b=b.substring(kf.length));var c={credential:Lg(a)};if(a.email)c.Ab=a.email;else if(a.phoneNumber)c.$=a.phoneNumber;else if(!c.credential)return new M(b,a.message||void 0);return new Sg(b,c,a.message)}return null};function Ug(){}Ug.prototype.c=null;function Vg(a){return a.c||(a.c=a.b())};var Wg;function Xg(){}u(Xg,Ug);Xg.prototype.a=function(){var a=Yg(this);return a?new ActiveXObject(a):new XMLHttpRequest};Xg.prototype.b=function(){var a={};Yg(this)&&(a[0]=!0,a[1]=!0);return a};
function Yg(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Wg=new Xg;function Zg(){}u(Zg,Ug);Zg.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new $g;throw Error("Unsupported browser");};Zg.prototype.b=function(){return{}};
function $g(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=t(this.dc,this);this.a.onerror=t(this.Gb,this);this.a.onprogress=t(this.ec,this);this.a.ontimeout=t(this.ic,this)}k=$g.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.dc=function(){this.status=200;this.response=this.responseText=this.a.responseText;ah(this,4)};k.Gb=function(){this.status=500;this.response=this.responseText="";ah(this,4)};k.ic=function(){this.Gb()};
k.ec=function(){this.status=200;ah(this,1)};function ah(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function bh(a,b,c){this.reset(a,b,c,void 0,void 0)}bh.prototype.a=null;var ch=0;bh.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ch++;d||va();delete this.a};function dh(a){this.f=a;this.b=this.c=this.a=null}function eh(a,b){this.name=a;this.value=b}eh.prototype.toString=function(){return this.name};var fh=new eh("SEVERE",1E3),gh=new eh("WARNING",900),hh=new eh("CONFIG",700),ih=new eh("FINE",500);function jh(a){if(a.c)return a.c;if(a.a)return jh(a.a);ya("Root logger has no level set.");return null}dh.prototype.log=function(a,b,c){if(a.value>=jh(this).value)for(q(b)&&(b=b()),a=new bh(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var kh={},lh=null;
function mh(a){lh||(lh=new dh(""),kh[""]=lh,lh.c=hh);var b;if(!(b=kh[a])){b=new dh(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=mh(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;kh[a]=b}return b};function nh(a,b){a&&a.log(ih,b,void 0)};function oh(a){this.f=a}u(oh,Ug);oh.prototype.a=function(){return new ph(this.f)};oh.prototype.b=function(a){return function(){return a}}({});function ph(a){F.call(this);this.u=a;this.readyState=qh;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.o="GET";this.g="";this.a=!1;this.h=mh("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}u(ph,F);var qh=0;k=ph.prototype;
k.open=function(a,b){if(this.readyState!=qh)throw this.abort(),Error("Error reopening a connection");this.o=a;this.g=b;this.readyState=1;rh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.o,credentials:void 0,cache:void 0};a&&(b.body=a);this.u.fetch(new Request(this.g,b)).then(this.hc.bind(this),this.Ma.bind(this))};
k.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,sh(this,!1));this.readyState=qh};
k.hc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,rh(this)),this.a&&(this.readyState=3,rh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.fc.bind(this),this.Ma.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,th(this)):a.text().then(this.gc.bind(this),this.Ma.bind(this)))))};function th(a){a.c.read().then(a.cc.bind(a)).catch(a.Ma.bind(a))}
k.cc=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?sh(this,!0):rh(this);3==this.readyState&&th(this)}};k.gc=function(a){this.a&&(this.response=this.responseText=a,sh(this,!0))};k.fc=function(a){this.a&&(this.response=a,sh(this,!0))};k.Ma=function(a){var b=this.h;b&&b.log(gh,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&sh(this,!0)};
function sh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;rh(a)}k.setRequestHeader=function(a,b){this.i.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log(gh,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
k.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log(gh,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function rh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function uh(a){F.call(this);this.headers=new Sc;this.D=a||null;this.c=!1;this.A=this.a=null;this.h=this.N=this.l="";this.f=this.I=this.i=this.G=!1;this.g=0;this.u=null;this.o=vh;this.v=this.O=!1}u(uh,F);var vh="";uh.prototype.b=mh("goog.net.XhrIo");var wh=/^https?$/i,xh=["POST","PUT"];
function yh(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.N=c;a.G=!1;a.c=!0;a.a=a.D?a.D.a():Wg.a();a.A=a.D?Vg(a.D):Vg(Wg);a.a.onreadystatechange=t(a.Jb,a);try{nh(a.b,zh(a,"Opening Xhr")),a.I=!0,a.a.open(c,String(b),!0),a.I=!1}catch(g){nh(a.b,zh(a,"Error opening Xhr: "+g.message));Ah(a,g);return}b=d||"";var f=new Sc(a.headers);e&&Rc(e,function(g,h){f.set(h,g)});e=Ka(f.U());d=l.FormData&&b instanceof
l.FormData;!Ma(xh,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.o&&(a.a.responseType=a.o);"withCredentials"in a.a&&a.a.withCredentials!==a.O&&(a.a.withCredentials=a.O);try{Bh(a),0<a.g&&(a.v=Ch(a.a),nh(a.b,zh(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.v)),a.v?(a.a.timeout=a.g,a.a.ontimeout=t(a.Ga,a)):a.u=Nc(a.Ga,a.g,a)),nh(a.b,zh(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){nh(a.b,
zh(a,"Send error: "+g.message)),Ah(a,g)}}function Ch(a){return Ub&&dc(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function La(a){return"content-type"==a.toLowerCase()}k=uh.prototype;k.Ga=function(){"undefined"!=typeof fa&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",nh(this.b,zh(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function Ah(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;Dh(a);Eh(a)}
function Dh(a){a.G||(a.G=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(nh(this.b,zh(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),Eh(this))};k.va=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),Eh(this,!0));uh.qb.va.call(this)};k.Jb=function(){this.qa||(this.I||this.i||this.f?Fh(this):this.wc())};k.wc=function(){Fh(this)};
function Fh(a){if(a.c&&"undefined"!=typeof fa)if(a.A[1]&&4==Gh(a)&&2==Hh(a))nh(a.b,zh(a,"Local request error detected and ignored"));else if(a.i&&4==Gh(a))Nc(a.Jb,0,a);else if(a.dispatchEvent("readystatechange"),4==Gh(a)){nh(a.b,zh(a,"Request complete"));a.c=!1;try{var b=Hh(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Vc)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
f=g.substr(0,g.length-1)}e=!wh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<Gh(a)?a.a.statusText:""}catch(m){nh(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+Hh(a)+"]";Dh(a)}}finally{Eh(a)}}}function Eh(a,b){if(a.a){Bh(a);var c=a.a,d=a.A[0]?ka:null;a.a=null;a.A=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(fh,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function Bh(a){a.a&&a.v&&(a.a.ontimeout=null);a.u&&(l.clearTimeout(a.u),a.u=null)}function Gh(a){return a.a?a.a.readyState:0}function Hh(a){try{return 2<Gh(a)?a.a.status:-1}catch(b){return-1}}function Ih(a){try{return a.a?a.a.responseText:""}catch(b){return nh(a.b,"Can not get responseText: "+b.message),""}}
k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.o){case vh:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(fh,"Response type "+this.o+" is not supported on this browser",void 0);return null}catch(b){return nh(this.b,"Can not get response: "+b.message),null}};function zh(a,b){return b+" ["+a.N+" "+a.l+" "+Hh(a)+"]"};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function Jh(a){var b=Kh;this.g=[];this.v=b;this.u=a||null;this.f=this.a=!1;this.c=void 0;this.l=this.A=this.i=!1;this.h=0;this.b=null;this.m=0}Jh.prototype.cancel=function(a){if(this.a)this.c instanceof Jh&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.m--,0>=b.m&&b.cancel())}this.v?this.v.call(this.u,this):this.l=!0;this.a||(a=new Lh(this),Mh(this),Nh(this,!1,a))}};Jh.prototype.o=function(a,b){this.i=!1;Nh(this,a,b)};function Nh(a,b,c){a.a=!0;a.c=c;a.f=!b;Oh(a)}
function Mh(a){if(a.a){if(!a.l)throw new Ph(a);a.l=!1}}function Qh(a,b){Rh(a,null,b,void 0)}function Rh(a,b,c,d){a.g.push([b,c,d]);a.a&&Oh(a)}Jh.prototype.then=function(a,b,c){var d,e,f=new C(function(g,h){d=g;e=h});Rh(this,d,function(g){g instanceof Lh?f.cancel():e(g)});return f.then(a,b,c)};Jh.prototype.$goog_Thenable=!0;function Sh(a){return Ja(a.g,function(b){return q(b[1])})}
function Oh(a){if(a.h&&a.a&&Sh(a)){var b=a.h,c=Th[b];c&&(l.clearTimeout(c.a),delete Th[b]);a.h=0}a.b&&(a.b.m--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.u,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(wa(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,Sh(a)||(c=!0)}}a.c=b;d&&(h=t(a.o,a,!0),d=t(a.o,a,!1),b instanceof Jh?(Rh(b,h,d),b.A=!0):b.then(h,d));c&&(b=
new Uh(b),Th[b.a]=b,a.h=b.a)}function Ph(){w.call(this)}u(Ph,w);Ph.prototype.message="Deferred has already fired";Ph.prototype.name="AlreadyCalledError";function Lh(){w.call(this)}u(Lh,w);Lh.prototype.message="Deferred was canceled";Lh.prototype.name="CanceledError";function Uh(a){this.a=l.setTimeout(t(this.c,this),0);this.b=a}Uh.prototype.c=function(){delete Th[this.a];throw this.b;};var Th={};function Vh(a){var b={},c=b.document||document,d=Cd(a).toString(),e=document.createElement("SCRIPT"),f={Lb:e,Ga:void 0},g=new Jh(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){Wh(e,!0);var p=new Xh(Yh,"Timeout reached for loading script "+d);Mh(g);Nh(g,!1,p)},m),f.Ga=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Wh(e,b.dd||!1,h),Mh(g),Nh(g,!0,null))};e.onerror=function(){Wh(e,!0,h);var p=new Xh(Zh,"Error while loading script "+
d);Mh(g);Nh(g,!1,p)};f=b.attributes||{};fb(f,{type:"text/javascript",charset:"UTF-8"});Td(e,f);Rd(e,a);$h(c).appendChild(e);return g}function $h(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function Kh(){if(this&&this.Lb){var a=this.Lb;a&&"SCRIPT"==a.tagName&&Wh(a,!0,this.Ga)}}
function Wh(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ka;a.onerror=ka;a.onreadystatechange=ka;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Zh=0,Yh=1;function Xh(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);w.call(this,c);this.code=a}u(Xh,w);function ai(a){this.f=a}u(ai,Ug);ai.prototype.a=function(){return new this.f};ai.prototype.b=function(){return{}};
function bi(a,b,c){this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||ci;this.f=db(a.secureTokenHeaders||di);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||ei;this.a=db(a.firebaseHeaders||fi);c&&(this.a["X-Client-Version"]=c,this.f["X-Client-Version"]=c);c="Node"==xe();c=l.XMLHttpRequest||c&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if(!c&&
!we())throw new M("internal-error","The XMLHttpRequest compatibility library was not found.");this.c=void 0;we()?this.c=new oh(self):ye()?this.c=new ai(c):this.c=new Zg}var gi,ag="idToken",ci=new Me(3E4,6E4),di={"Content-Type":"application/x-www-form-urlencoded"},ei=new Me(3E4,6E4),fi={"Content-Type":"application/json"};function hi(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
function ii(a,b){b?(a.a["X-Client-Version"]=b,a.f["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.f["X-Client-Version"])}function ji(a,b,c,d,e,f,g){he()||we()?a=t(a.o,a):(gi||(gi=new C(function(h,m){ki(h,m)})),a=t(a.l,a));a(b,c,d,e,f,g)}
bi.prototype.o=function(a,b,c,d,e,f){if(we()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new M("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new uh(this.c);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}Ac(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
JSON.parse(Ih(this))||null}catch(p){m=null}b&&b(m)});Gc(g,"ready",function(){h&&clearTimeout(h);Pb(this)});Gc(g,"timeout",function(){h&&clearTimeout(h);Pb(this);b&&b(null)});yh(g,a,c,d,e)};var li=new wd(xd,"https://apis.google.com/js/client.js?onload=%{onload}"),mi="__fcb"+Math.floor(1E6*Math.random()).toString();
function ki(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[mi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=Dd(li,{onload:mi});Qh(Vh(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
bi.prototype.l=function(a,b,c,d,e){var f=this;gi.then(function(){window.gapi.client.setApiKey(f.b);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).s(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
function ni(a,b){return new C(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?ji(a,a.i+"?key="+encodeURIComponent(a.b),function(e){e?e.error?d(oi(e)):e.access_token&&e.refresh_token?c(e):d(new M("internal-error")):d(new M("network-request-failed"))},"POST",qd(b).toString(),a.f,a.m.get()):d(new M("internal-error"))})}
function pi(a,b,c,d,e,f){var g=md(a.g+b);G(g,"key",a.b);f&&G(g,"cb",va().toString());var h="GET"==c;if(h)for(var m in d)d.hasOwnProperty(m)&&G(g,m,d[m]);return new C(function(p,v){ji(a,g.toString(),function(z){z?z.error?v(oi(z,e||{})):p(z):v(new M("network-request-failed"))},c,h?void 0:Yd(Ie(d)),a.a,a.h.get())})}function qi(a){a=a.email;if(!n(a)||!qe.test(a))throw new M("invalid-email");}function ri(a){"email"in a&&qi(a)}
function si(a,b){return O(a,ti,{identifier:b,continueUri:Fe()?ee():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function ui(a){return O(a,vi,{}).then(function(b){return b.authorizedDomains||[]})}function wi(a){if(!a[ag])throw new M("internal-error");}
function xi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new M("internal-error");}else{if(!a.sessionInfo)throw new M("missing-verification-id");if(!a.code)throw new M("missing-verification-code");}}bi.prototype.ob=function(){return O(this,yi,{})};bi.prototype.rb=function(a,b){return O(this,zi,{idToken:a,email:b})};bi.prototype.sb=function(a,b){return O(this,zg,{idToken:a,password:b})};var Ai={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=bi.prototype;
k.tb=function(a,b){var c={idToken:a},d=[];bb(Ai,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return O(this,zi,c)};k.kb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};fb(a,b);return O(this,Bi,a)};k.lb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};fb(a,b);return O(this,Ci,a)};k.jb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};fb(a,b);return O(this,Di,a)};function Jg(a,b){return O(a,Ei,b)}k.Ua=function(a){return O(this,Fi,a)};
function Gi(a,b,c){return O(a,Hi,{idToken:b,deleteProvider:c})}function Ii(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new M("internal-error");}function Ji(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new cd(a.postBody),ud(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
function Ki(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Tg(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Tg(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Tg(a)):a.errorMessage&&(b=Li(a.errorMessage));if(b)throw b;if(!a[ag])throw new M("internal-error");}function cg(a,b){b.returnIdpCredential=!0;return O(a,Mi,b)}function eg(a,b){b.returnIdpCredential=!0;return O(a,Ni,b)}
function fg(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return O(a,Oi,b)}function Pi(a){if(!a.oobCode)throw new M("invalid-action-code");}k.Za=function(a,b){return O(this,Qi,{oobCode:a,newPassword:b})};k.Ka=function(a){return O(this,Ri,{oobCode:a})};k.Wa=function(a){return O(this,Si,{oobCode:a})};
var Si={endpoint:"setAccountInfo",C:Pi,da:"email"},Ri={endpoint:"resetPassword",C:Pi,J:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b)throw new M("internal-error");}},Ti={endpoint:"signupNewUser",C:function(a){qi(a);if(!a.password)throw new M("weak-password");},J:wi,R:!0},ti={endpoint:"createAuthUri"},Ui={endpoint:"deleteAccount",T:["idToken"]},Hi={endpoint:"setAccountInfo",T:["idToken","deleteProvider"],C:function(a){if(!na(a.deleteProvider))throw new M("internal-error");}},wg=
{endpoint:"emailLinkSignin",T:["email","oobCode"],C:qi,J:wi,R:!0},yg={endpoint:"emailLinkSignin",T:["idToken","email","oobCode"],C:qi,J:wi,R:!0},Vi={endpoint:"getAccountInfo"},Ci={endpoint:"getOobConfirmationCode",T:["requestType"],C:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new M("internal-error");qi(a)},da:"email"},Di={endpoint:"getOobConfirmationCode",T:["idToken","requestType"],C:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new M("internal-error");},da:"email"},Bi={endpoint:"getOobConfirmationCode",
T:["requestType"],C:function(a){if("PASSWORD_RESET"!=a.requestType)throw new M("internal-error");qi(a)},da:"email"},vi={wb:!0,endpoint:"getProjectConfig",Ib:"GET"},Wi={wb:!0,endpoint:"getRecaptchaParam",Ib:"GET",J:function(a){if(!a.recaptchaSiteKey)throw new M("internal-error");}},Qi={endpoint:"resetPassword",C:Pi,da:"email"},Ei={endpoint:"sendVerificationCode",T:["phoneNumber","recaptchaToken"],da:"sessionInfo"},zi={endpoint:"setAccountInfo",T:["idToken"],C:ri,R:!0},zg={endpoint:"setAccountInfo",
T:["idToken"],C:function(a){ri(a);if(!a.password)throw new M("weak-password");},J:wi,R:!0},yi={endpoint:"signupNewUser",J:wi,R:!0},Mi={endpoint:"verifyAssertion",C:Ii,Qa:Ji,J:Ki,R:!0},Oi={endpoint:"verifyAssertion",C:Ii,Qa:Ji,J:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new M("user-not-found");if(a.errorMessage)throw Li(a.errorMessage);if(!a[ag])throw new M("internal-error");},R:!0},Ni={endpoint:"verifyAssertion",C:function(a){Ii(a);if(!a.idToken)throw new M("internal-error");
},Qa:Ji,J:Ki,R:!0},Xi={endpoint:"verifyCustomToken",C:function(a){if(!a.token)throw new M("invalid-custom-token");},J:wi,R:!0},xg={endpoint:"verifyPassword",C:function(a){qi(a);if(!a.password)throw new M("wrong-password");},J:wi,R:!0},Fi={endpoint:"verifyPhoneNumber",C:xi,J:wi},Fg={endpoint:"verifyPhoneNumber",C:function(a){if(!a.idToken)throw new M("internal-error");xi(a)},J:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Tg(a);wi(a)}},Gg={Wb:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyPhoneNumber",C:xi,J:wi};function O(a,b,c){if(!Ze(c,b.T))return E(new M("internal-error"));var d=b.Ib||"POST",e;return D(c).then(b.C).then(function(){b.R&&(c.returnSecureToken=!0);return pi(a,b.endpoint,d,c,b.Wb,b.wb||!1)}).then(function(f){e=f;return b.Qa?b.Qa(c,e):e}).then(b.J).then(function(){if(!b.da)return e;if(!(b.da in e))throw new M("internal-error");return e[b.da]})}function Li(a){return oi({error:{errors:[{message:a}],code:400,message:a}})}
function oi(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new M(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",ADMIN_ONLY_OPERATION:"admin-restricted-operation"};fb(d,
b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new M(d[e],b);!b&&a&&(b=He(a));return new M("internal-error",b)};function Yi(a){this.b=a;this.a=null;this.fb=Zi(this)}
function Zi(a){return $i().then(function(){return new C(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},aj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function bj(a,b){return a.fb.then(function(){return new C(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function cj(a,b){a.fb.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var dj=new wd(xd,"https://apis.google.com/js/api.js?onload=%{onload}"),ej=new Me(3E4,6E4),aj=new Me(5E3,15E3),fj=null;
function $i(){return fj?fj:fj=(new C(function(a,b){function c(){Le();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Le();b(Error("Network Error"))},timeout:ej.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=Dd(dj,{onload:d});D(Vh(d)).s(function(){b(Error("Network Error"))})}})).s(function(a){fj=null;throw a;})};function gj(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=nd(this.i,"/__/auth/iframe");G(this.a,"apiKey",this.g);G(this.a,"appName",this.h);this.b=null;this.c=[]}gj.prototype.toString=function(){this.f?G(this.a,"v",this.f):td(this.a.a,"v");this.b?G(this.a,"eid",this.b):td(this.a.a,"eid");this.c.length?G(this.a,"fw",this.c.join(",")):td(this.a.a,"fw");return this.a.toString()};function hj(a,b,c,d,e){this.o=a;this.l=b;this.c=c;this.m=d;this.h=this.g=this.i=null;this.a=e;this.f=null}
hj.prototype.toString=function(){var a=nd(this.o,"/__/auth/handler");G(a,"apiKey",this.l);G(a,"appName",this.c);G(a,"authType",this.m);if(this.a.isOAuthProvider){var b=this.a;try{var c=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ea()}catch(h){c=null}b.$a=c;G(a,"providerId",this.a.providerId);b=this.a;c=Ie(b.zb);for(var d in c)c[d]=c[d].toString();d=b.Dc;c=db(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.cb&&b.$a&&!c[b.cb]&&(c[b.cb]=b.$a);cb(c)||G(a,"customParameters",He(c))}"function"===typeof this.a.Fb&&
(b=this.a.Fb(),b.length&&G(a,"scopes",b.join(",")));this.i?G(a,"redirectUrl",this.i):td(a.a,"redirectUrl");this.g?G(a,"eventId",this.g):td(a.a,"eventId");this.h?G(a,"v",this.h):td(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!kd(a,g)&&G(a,g,this.b[g]);this.f?G(a,"eid",this.f):td(a.a,"eid");g=ij(this.c);g.length&&G(a,"fw",g.join(","));return a.toString()};function ij(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().ya()}catch(b){return[]}}
function jj(a,b,c,d,e){this.l=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.o=this.u=this.v=null;this.g=[];this.m=this.a=null}
function kj(a){var b=ee();return ui(a).then(function(c){a:{var d=md(b),e=d.f;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=md(g).b==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:pe.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new Rg(ee());})}
function lj(a){if(a.m)return a.m;a.m=re().then(function(){if(!a.u){var b=a.c,c=a.h,d=ij(a.b),e=new gj(a.l,a.f,a.b);e.f=b;e.b=c;e.c=Pa(d||[]);a.u=e.toString()}a.i=new Yi(a.u);mj(a)});return a.m}k=jj.prototype;k.Ea=function(a,b,c){var d=new M("popup-closed-by-user"),e=new M("web-storage-unsupported"),f=this,g=!1;return this.ga().then(function(){nj(f).then(function(h){h||(a&&le(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return oe(a)}).then(function(){if(!g)return Oc(c).then(function(){b(d)})})};
k.Mb=function(){var a=I();return!Ge(a)&&!Ke(a)};k.Hb=function(){return!1};
k.Db=function(a,b,c,d,e,f,g){if(!a)return E(new M("popup-blocked"));if(g&&!Ge())return this.ga().s(function(m){le(a);e(m)}),d(),D();this.a||(this.a=kj(oj(this)));var h=this;return this.a.then(function(){var m=h.ga().s(function(p){le(a);e(p);throw p;});d();return m}).then(function(){Mg(c);if(!g){var m=pj(h.l,h.f,h.b,b,c,null,f,h.c,void 0,h.h);fe(m,a)}}).s(function(m){"auth/network-request-failed"==m.code&&(h.a=null);throw m;})};
function oj(a){a.o||(a.v=a.c?Be(a.c,ij(a.b)):null,a.o=new bi(a.f,If(a.h),a.v));return a.o}k.Ca=function(a,b,c){this.a||(this.a=kj(oj(this)));var d=this;return this.a.then(function(){Mg(b);var e=pj(d.l,d.f,d.b,a,b,ee(),c,d.c,void 0,d.h);fe(e)}).s(function(e){"auth/network-request-failed"==e.code&&(d.a=null);throw e;})};k.ga=function(){var a=this;return lj(this).then(function(){return a.i.fb}).s(function(){a.a=null;throw new M("network-request-failed");})};k.Pb=function(){return!0};
function pj(a,b,c,d,e,f,g,h,m,p){a=new hj(a,b,c,d,e);a.i=f;a.g=g;a.h=h;a.b=db(m||null);a.f=p;return a.toString()}function mj(a){if(!a.i)throw Error("IfcHandler must be initialized!");cj(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Og(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})}
function nj(a){var b={type:"webStorageSupport"};return lj(a).then(function(){return bj(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.wa=function(a){this.g.push(a)};k.La=function(a){y(this.g,function(b){return b==a})};function qj(a){this.a=a||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new M("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=qj.prototype;k.get=function(a){return D(this.a.getItem(a)).then(function(b){return b&&Je(b)})};k.set=function(a,b){return D(this.a.setItem(a,He(b)))};k.P=function(a){return D(this.a.removeItem(a))};k.Y=function(){};k.ca=function(){};function rj(a){this.b=a;this.a={};this.c=t(this.f,this)}var sj=[];function tj(){var a=we()?self:null;x(sj,function(c){c.b==a&&(b=c)});if(!b){var b=new rj(a);sj.push(b)}return b}
rj.prototype.f=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];x(d,function(f){e.push(D().then(function(){return f(a.origin,a.data.data)}))});Bb(e).then(function(f){var g=[];x(f,function(h){g.push({fulfilled:h.Eb,value:h.value,reason:h.reason?h.reason.message:void 0})});x(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
eventType:b,response:g})})}};rj.prototype.subscribe=function(a,b){cb(this.a)&&this.b.addEventListener("message",this.c);"undefined"===typeof this.a[a]&&(this.a[a]=[]);this.a[a].push(b)};rj.prototype.unsubscribe=function(a,b){"undefined"!==typeof this.a[a]&&b?(y(this.a[a],function(c){return c==b}),0==this.a[a].length&&delete this.a[a]):b||delete this.a[a];cb(this.a)&&this.b.removeEventListener("message",this.c)};function uj(a){this.a=a}uj.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function vj(a){this.c=a;this.b=!1;this.a=[]}
function wj(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return E(Error("connection_unavailable"));var v=d?800:50,z="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new C(function(H,U){z?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),z.port1.start(),h=setTimeout(function(){U(Error("unsupported_event"))},v),g=function(ta){ta.data.eventId===e&&("ack"===ta.data.status?(clearTimeout(h),m=setTimeout(function(){U(Error("timeout"))},3E3)):"done"===ta.data.status?(clearTimeout(m),
"undefined"!==typeof ta.data.response?H(ta.data.response):U(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),U(Error("invalid_response"))))},p={messageChannel:z,onMessage:g},a.a.push(p),z.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[z.port2])):U(Error("connection_unavailable"))})).then(function(H){xj(a,p);return H}).s(function(H){xj(a,p);throw H;})}
function xj(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());y(a.a,function(e){return e==b})}}vj.prototype.close=function(){for(;0<this.a.length;)xj(this,this.a[0]);this.b=!0};function yj(){if(!zj())throw new M("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.l=l.indexedDB;this.type="indexedDB";this.g=this.m=this.f=this.i=null;this.u=!1;this.h=null;var a=this;we()&&self?(this.m=tj(),this.m.subscribe("keyChanged",function(b,c){return Aj(a).then(function(d){0<d.length&&x(a.a,function(e){e(d)});return{keyProcessed:Ma(d,c.key)}})}),this.m.subscribe("ping",function(){return D(["keyChanged"])})):Se().then(function(b){if(a.h=b)a.g=new vj(new uj(b)),wj(a.g,"ping",null,
!0).then(function(c){c[0].fulfilled&&Ma(c[0].value,"keyChanged")&&(a.u=!0)}).s(function(){})})}var Bj;function Cj(a){return new C(function(b,c){var d=a.l.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
function Dj(a){return new C(function(b,c){var d=a.l.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):Cj(a).then(function(){return Dj(a)}).then(function(f){b(f)}).s(function(f){c(f)})}})}
function Ej(a){a.o||(a.o=Dj(a));return a.o}function zj(){try{return!!l.indexedDB}catch(a){return!1}}function Fj(a){return a.objectStore("firebaseLocalStorage")}function Gj(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function Hj(a){return new C(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=yj.prototype;
k.set=function(a,b){var c=!1,d,e=this;return Ej(this).then(function(f){d=f;f=Fj(Gj(d,!0));return Hj(f.get(a))}).then(function(f){var g=Fj(Gj(d,!0));if(f)return f.value=b,Hj(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return Hj(g.add(f))}).then(function(){e.c[a]=b;return Ij(e,a)}).ia(function(){c&&e.b--})};function Ij(a,b){return a.g&&a.h&&Re()===a.h?wj(a.g,"keyChanged",{key:b},a.u).then(function(){}).s(function(){}):D()}
k.get=function(a){return Ej(this).then(function(b){return Hj(Fj(Gj(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.P=function(a){var b=!1,c=this;return Ej(this).then(function(d){b=!0;c.b++;return Hj(Fj(Gj(d,!0))["delete"](a))}).then(function(){delete c.c[a];return Ij(c,a)}).ia(function(){b&&c.b--})};
function Aj(a){return Ej(a).then(function(b){var c=Fj(Gj(b,!1));return c.getAll?Hj(c.getAll()):new C(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=ge(a.c,c);a.c=c}return d})}k.Y=function(a){0==this.a.length&&Jj(this);this.a.push(a)};
k.ca=function(a){y(this.a,function(b){return b==a});0==this.a.length&&Kj(this)};function Jj(a){function b(){a.f=setTimeout(function(){a.i=Aj(a).then(function(c){0<c.length&&x(a.a,function(d){d(c)})}).then(function(){b()}).s(function(c){"STOP_EVENT"!=c.message&&b()})},800)}Kj(a);b()}function Kj(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function Lj(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=D().then(function(){if(zj()){var d=De(),e="__sak"+d;Bj||(Bj=new yj);c=Bj;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.P(e)}).then(function(){return c}).s(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.Y(function(e){x(b.a,function(f){f(e)})});return d})}k=Lj.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.P=function(a){return this.b.then(function(b){return b.P(a)})};k.Y=function(a){this.a.push(a)};k.ca=function(a){y(this.a,function(b){return b==a})};function Mj(){this.a={};this.type="inMemory"}k=Mj.prototype;k.get=function(a){return D(this.a[a])};k.set=function(a,b){this.a[a]=b;return D()};k.P=function(a){delete this.a[a];return D()};k.Y=function(){};k.ca=function(){};function Nj(){if(!Oj()){if("Node"==xe())throw new M("internal-error","The LocalStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=Pj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type="localStorage"}function Pj(){try{var a=l.localStorage,b=De();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Oj(){var a="Node"==xe();a=Pj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Nj.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Je(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=He(b);null===d?c.P(a):c.a.setItem(a,d)})};k.P=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};
k.Y=function(a){l.window&&xc(l.window,"storage",a)};k.ca=function(a){l.window&&Hc(l.window,"storage",a)};function Qj(){this.type="nullStorage"}k=Qj.prototype;k.get=function(){return D(null)};k.set=function(){return D()};k.P=function(){return D()};k.Y=function(){};k.ca=function(){};function Rj(){if(!Sj()){if("Node"==xe())throw new M("internal-error","The SessionStorage compatibility library was not found.");throw new M("web-storage-unsupported");}this.a=Tj()||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Tj(){try{var a=l.sessionStorage,b=De();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function Sj(){var a="Node"==xe();a=Tj()||a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Rj.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Je(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=He(b);null===d?c.P(a):c.a.setItem(a,d)})};k.P=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};k.Y=function(){};
k.ca=function(){};function Uj(){var a={};a.Browser=Vj;a.Node=Wj;a.ReactNative=Xj;a.Worker=Yj;this.a=a[xe()]}var Zj,Vj={B:Nj,Ra:Rj},Wj={B:Nj,Ra:Rj},Xj={B:qj,Ra:Qj},Yj={B:Nj,Ra:Qj};var ak={Xc:"local",NONE:"none",Zc:"session"};function bk(a){var b=new M("invalid-persistence-type"),c=new M("unsupported-persistence-type");a:{for(d in ak)if(ak[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(xe()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Ce()&&"none"!==a)throw c;}}
function ck(){var a=!Ke(I())&&ve()?!0:!1,b=Ge(),c=Ce();this.o=a;this.h=b;this.m=c;this.a={};Zj||(Zj=new Uj);a=Zj;try{this.g=!de()&&Qe()||!l.indexedDB?new a.a.B:new Lj(we()?new Mj:new a.a.B)}catch(d){this.g=new Mj,this.h=!0}try{this.i=new a.a.Ra}catch(d){this.i=new Mj}this.l=new Mj;this.f=t(this.Ob,this);this.b={}}var dk;function ek(){dk||(dk=new ck);return dk}function fk(a,b){switch(b){case "session":return a.i;case "none":return a.l;default:return a.g}}
function gk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function hk(a,b,c){var d=gk(b,c),e=fk(a,b.B);return a.get(b,c).then(function(f){var g=null;try{g=Je(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=ck.prototype;k.get=function(a,b){return fk(this,a.B).get(gk(a,b))};function ik(a,b,c){c=gk(b,c);"local"==b.B&&(a.b[c]=null);return fk(a,b.B).P(c)}
k.set=function(a,b,c){var d=gk(a,c),e=this,f=fk(this,a.B);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.B&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=gk(a,b);this.m&&(this.b[a]=l.localStorage.getItem(a));cb(this.a)&&(fk(this,"local").Y(this.f),this.h||(de()||!Qe())&&l.indexedDB||!this.m||jk(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
k.removeListener=function(a,b,c){a=gk(a,b);this.a[a]&&(y(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);cb(this.a)&&(fk(this,"local").ca(this.f),kk(this))};function jk(a){kk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new lc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Ob(c))}},1E3)}function kk(a){a.c&&(clearInterval(a.c),a.c=null)}
k.Ob=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.Xa(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?fk(this,"local").ca(this.f):kk(this);if(this.o)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.Xa(b)};Ub&&ec&&10==ec&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else x(a,t(this.Xa,this))};k.Xa=function(a){this.a[a]&&x(this.a[a],function(b){b()})};function lk(a){this.a=a;this.b=ek()}var mk={name:"authEvent",B:"local"};function nk(a){return a.b.get(mk,a.a).then(function(b){return Og(b)})};function ok(){this.a=ek()};function pk(){this.b=-1};function qk(a,b){this.b=rk;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.m=l.Int32Array?new Int32Array(64):Array(64);void 0!==sk||(l.Int32Array?sk=new Int32Array(tk):sk=tk);this.reset()}var sk;u(qk,pk);for(var rk=64,uk=rk-1,vk=[],wk=0;wk<uk;wk++)vk[wk]=0;var xk=Oa(128,vk);qk.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Pa(this.h)};
function yk(a){for(var b=a.f,c=a.m,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,v=a.a[5]|0,z=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var H=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&v^~p&z;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
7))|0;g=g+(sk[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=z;z=v;v=p;p=m+g|0;m=h;h=e;e=d;d=g+H|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+v|0;a.a[6]=a.a[6]+z|0;a.a[7]=a.a[7]+f|0}
function zk(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(n(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(yk(a),e=0);else if(oa(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(yk(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var tk=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Ak(){qk.call(this,8,Bk)}u(Ak,qk);var Bk=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function Ck(a,b,c,d,e){this.l=a;this.i=b;this.m=c;this.o=d||null;this.u=e||null;this.h=b+":"+c;this.v=new ok;this.g=new lk(this.h);this.f=null;this.b=[];this.a=this.c=null}function Dk(a){return new M("invalid-cordova-configuration",a)}k=Ck.prototype;
k.ga=function(){return this.za?this.za:this.za=se().then(function(){if("function"!==typeof J("universalLinks.subscribe",l))throw Dk("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof J("BuildInfo.packageName",l))throw Dk("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",l))throw Dk("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",l))throw Dk("cordova-plugin-inappbrowser is not installed");
},function(){throw new M("cordova-not-ready");})};function Ek(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Fk(a){var b=new Ak;zk(b,a);a=[];var c=8*b.g;56>b.c?zk(b,xk,56-b.c):zk(b,xk,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;yk(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return yf(a)}
k.Ea=function(a,b){b(new M("operation-not-supported-in-this-environment"));return D()};k.Db=function(){return E(new M("operation-not-supported-in-this-environment"))};k.Pb=function(){return!1};k.Mb=function(){return!0};k.Hb=function(){return!0};
k.Ca=function(a,b,c){if(this.c)return E(new M("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,h=null,m=null;return this.c=D().then(function(){Mg(b);return Gk(d)}).then(function(){return Hk(d,a,b,c)}).then(function(){return(new C(function(p,v){g=function(){var z=J("cordova.plugins.browsertab.close",l);p();"function"===typeof z&&z();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.wa(g);h=function(){f||(f=Oc(2E3).then(function(){v(new M("redirect-cancelled-by-user"))}))};
m=function(){Ne()&&h()};e.addEventListener("resume",h,!1);I().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",m,!1)})).s(function(p){return Ik(d).then(function(){throw p;})})}).ia(function(){h&&e.removeEventListener("resume",h,!1);m&&e.removeEventListener("visibilitychange",m,!1);f&&f.cancel();g&&d.La(g);d.c=null})};
function Hk(a,b,c,d){var e=Ek(),f=new Ng(b,d,null,e,new M("no-auth-event")),g=J("BuildInfo.packageName",l);if("string"!==typeof g)throw new M("invalid-cordova-configuration");var h=J("BuildInfo.displayName",l),m={};if(I().toLowerCase().match(/iphone|ipad|ipod/))m.ibi=g;else if(I().toLowerCase().match(/android/))m.apn=g;else return E(new M("operation-not-supported-in-this-environment"));h&&(m.appDisplayName=h);e=Fk(e);m.sessionId=e;var p=pj(a.l,a.i,a.m,b,c,null,d,a.o,m,a.u);return a.ga().then(function(){var v=
a.h;return a.v.a.set(mk,f.w(),v)}).then(function(){var v=J("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof v)throw new M("invalid-cordova-configuration");var z=null;v(function(H){if(H){z=J("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof z)throw new M("invalid-cordova-configuration");z(p)}else{z=J("cordova.InAppBrowser.open",l);if("function"!==typeof z)throw new M("invalid-cordova-configuration");H=I();a.a=z(p,H.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||H.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
"_blank":"_system","location=yes")}})})}function Jk(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Gk(a){a.f||(a.f=a.ga().then(function(){return new C(function(b){function c(d){b(d);a.La(c);return!1}a.wa(c);Kk(a)})}));return a.f}function Ik(a){var b=null;return nk(a.g).then(function(c){b=c;c=a.g;return ik(c.b,mk,c.a)}).then(function(){return b})}
function Kk(a){function b(g){d=!0;e&&e.cancel();Ik(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=Yf(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=md(m),p=Je(kd(p,"firebaseError")||null),p=(p="object"===typeof p?mf(p):null)?new Ng(h.c,h.b,null,null,p):new Ng(h.c,h.b,m,h.f));m=p||c}Jk(a,m)})}var c=new Ng("unknown",null,null,null,new M("no-auth-event")),d=!1,e=Oc(500).then(function(){return Ik(a).then(function(){d||Jk(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==g.toLowerCase().indexOf(J("BuildInfo.packageName",
l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};Qg||(Qg=new Pg);Qg.subscribe(b)}k.wa=function(a){this.b.push(a);Gk(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new Ng("unknown",null,null,null,new M("no-auth-event")),a(b))})};k.La=function(a){y(this.b,function(b){return b==a})};function Lk(a){this.a=a;this.b=ek()}var Mk={name:"pendingRedirect",B:"session"};function Nk(a){return a.b.set(Mk,"pending",a.a)}function Ok(a){return ik(a.b,Mk,a.a)}function Pk(a){return a.b.get(Mk,a.a).then(function(b){return"pending"==b})};function Qk(a,b,c){this.i={};this.u=0;this.A=a;this.l=b;this.o=c;this.h=[];this.f=!1;this.m=t(this.bb,this);this.b=new Rk;this.v=new Sk;this.g=new Lk(this.l+":"+this.o);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.v;this.c.linkViaPopup=this.v;this.c.reauthViaPopup=this.v;this.a=Tk(this.A,this.l,this.o,Jf)}
function Tk(a,b,c,d){var e=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null;return te()?new Ck(a,b,c,e,d):new jj(a,b,c,e,d)}k=Qk.prototype;k.reset=function(){this.f=!1;this.a.La(this.m);this.a=Tk(this.A,this.l,this.o);this.i={}};k.Ya=function(){this.b.Ya()};function Uk(a){a.f||(a.f=!0,a.a.wa(a.m));var b=a.a;return a.a.ga().s(function(c){a.a==b&&a.reset();throw c;})}
function Vk(a){a.a.Mb()&&Uk(a).s(function(b){var c=new Ng("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));Wk(b)&&a.bb(c)});a.a.Hb()||Xk(a.b)}k.subscribe=function(a){Ma(this.h,a)||this.h.push(a);if(!this.f){var b=this;Pk(this.g).then(function(c){c?Ok(b.g).then(function(){Uk(b).s(function(d){var e=new Ng("unknown",null,null,null,new M("operation-not-supported-in-this-environment"));Wk(d)&&b.bb(e)})}):Vk(b)}).s(function(){Vk(b)})}};
k.unsubscribe=function(a){y(this.h,function(b){return b==a})};k.bb=function(a){if(!a)throw new M("invalid-auth-event");6E5<=va()-this.u&&(this.i={},this.u=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.xb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.u=va());b=!0;break}}Xk(this.b);return b};var Yk=new Me(2E3,1E4),Zk=new Me(3E4,6E4);Qk.prototype.fa=function(){return this.b.fa()};
function $k(a,b,c,d,e,f){return a.a.Db(b,c,d,function(){a.f||(a.f=!0,a.a.wa(a.m))},function(){a.reset()},e,f)}function Wk(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}Qk.prototype.Ca=function(a,b,c){var d=this,e;return Nk(this.g).then(function(){return d.a.Ca(a,b,c).s(function(f){if(Wk(f))throw new M("operation-not-supported-in-this-environment");e=f;return Ok(d.g).then(function(){throw e;})}).then(function(){return d.a.Pb()?new C(function(){}):Ok(d.g).then(function(){return d.fa()}).then(function(){}).s(function(){})})})};
Qk.prototype.Ea=function(a,b,c,d){return this.a.Ea(c,function(e){a.ha(b,null,e,d)},Yk.get())};var al={};function bl(a,b,c){var d=b+":"+c;al[d]||(al[d]=new Qk(a,b,c));return al[d]}function Rk(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}Rk.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
Rk.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(cl(this,!0,null,a.a),D()):b.xa(c,d)?dl(this,a,b):E(new M("invalid-auth-event")):(cl(this,!1,null,null),D())}else E(new M("invalid-auth-event"))};function Xk(a){a.g||(a.g=!0,cl(a,!1,null,null))}Rk.prototype.Ya=function(){this.g&&!this.i&&cl(this,!1,null,null)};
function dl(a,b,c){c=c.xa(b.c,b.b);var d=b.g,e=b.f,f=b.h,g=!!b.c.match(/Redirect$/);c(d,e,f).then(function(h){cl(a,g,h,null)}).s(function(h){cl(a,g,null,h)})}function el(a,b){a.b=function(){return E(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function fl(a,b){a.b=function(){return D(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function cl(a,b,c,d){b?d?el(a,d):fl(a,c):fl(a,{user:null});a.f=[];a.c=[]}
Rk.prototype.fa=function(){var a=this;return new C(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),gl(a))})};function gl(a){var b=new M("timeout");a.a&&a.a.cancel();a.a=Oc(Zk.get()).then(function(){a.b||(a.g=!0,cl(a,!0,null,b))})}function Sk(){}Sk.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.ha(a.c,null,a.a,a.b),D()):b.xa(c,d)?hl(a,b):E(new M("invalid-auth-event"))}else E(new M("invalid-auth-event"))};
function hl(a,b){var c=a.b,d=a.c;b.xa(d,c)(a.g,a.f,a.h).then(function(e){b.ha(d,e,null,c)}).s(function(e){b.ha(d,null,e,c)})};function il(){this.ub=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.ub},set:function(a){this.ub=a},enumerable:!1})};function jl(a,b){this.a=b;K(this,"verificationId",a)}jl.prototype.confirm=function(a){a=Kg(this.verificationId,a);return this.a(a)};function kl(a,b,c,d){return(new Ig(a)).Ua(b,c).then(function(e){return new jl(e,d)})};function ll(a){var b=Gf(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new M("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Pe(1E3*b.exp),authTime:Pe(1E3*b.auth_time),issuedAtTime:Pe(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,claims:b})};function ml(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}ml.prototype.start=function(){this.a=this.c;nl(this,!0)};function ol(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function nl(a,b){a.stop();a.b=Oc(ol(a,b)).then(function(){return Oe()}).then(function(){return a.h()}).then(function(){nl(a,!0)}).s(function(c){a.i(c)&&nl(a,!1)})}
ml.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function pl(a){this.f=a;this.b=this.a=null;this.c=0}pl.prototype.w=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function ql(a,b){var c=b[ag],d=b.refreshToken;b=rl(b.expiresIn);a.b=c;a.c=b;a.a=d}function sl(a,b){a.b=b.b;a.a=b.a;a.c=b.c}function rl(a){return va()+1E3*parseInt(a,10)}
function tl(a,b){return ni(a.f,b).then(function(c){a.b=c.access_token;a.c=rl(c.expires_in);a.a=c.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}pl.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?E(new M("user-token-expired")):a||!this.b||va()>this.c-3E4?this.a?tl(this,{grant_type:"refresh_token",refresh_token:this.a}):D(null):D({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function ul(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Pe(b||null),creationTime:Pe(a||null)})}function vl(a){return new ul(a.a,a.b)}ul.prototype.w=function(){return{lastLoginAt:this.b,createdAt:this.a}};function wl(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function xl(a,b){kc.call(this,a);for(var c in b)this[c]=b[c]}u(xl,kc);
function P(a,b,c){this.G=[];this.l=a.apiKey;this.o=a.appName;this.u=a.authDomain||null;a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null;this.c=new bi(this.l,If(Jf),a);this.h=new pl(this.c);yl(this,b[ag]);ql(this.h,b);K(this,"refreshToken",this.h.a);zl(this,c||{});F.call(this);this.I=!1;this.u&&Ee()&&(this.a=bl(this.u,this.l,this.o));this.N=[];this.i=null;this.A=Al(this);this.V=t(this.Ha,this);var d=this;this.ka=null;this.ta=function(e){d.pa(e.g)};this.X=null;this.O=[];this.sa=function(e){Bl(d,
e.c)};this.W=null}u(P,F);P.prototype.pa=function(a){this.ka=a;hi(this.c,a)};P.prototype.ea=function(){return this.ka};function Cl(a,b){a.X&&Hc(a.X,"languageCodeChanged",a.ta);(a.X=b)&&xc(b,"languageCodeChanged",a.ta)}function Bl(a,b){a.O=b;ii(a.c,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,a.O):null)}P.prototype.ya=function(){return Pa(this.O)};function Dl(a,b){a.W&&Hc(a.W,"frameworkChanged",a.sa);(a.W=b)&&xc(b,"frameworkChanged",a.sa)}P.prototype.Ha=function(){this.A.b&&(this.A.stop(),this.A.start())};
function El(a){try{return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.o).auth()}catch(b){throw new M("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Al(a){return new ml(function(){return a.F(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=a.h.c-va()-3E5;return 0<b?b:0})}function Fl(a){a.D||a.A.b||(a.A.start(),Hc(a,"tokenChanged",a.V),xc(a,"tokenChanged",a.V))}function Gl(a){Hc(a,"tokenChanged",a.V);a.A.stop()}
function yl(a,b){a.ra=b;K(a,"_lat",b)}function Hl(a,b){y(a.N,function(c){return c==b})}function Il(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return Bb(b).then(function(){return a})}function Jl(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function zl(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new ul(b.createdAt,b.lastLoginAt),providerData:[]})}K(P.prototype,"providerId","firebase");function Kl(){}function Ll(a){return D().then(function(){if(a.D)throw new M("app-deleted");})}function Ml(a){return Ia(a.providerData,function(b){return b.providerId})}
function Nl(a,b){b&&(Ol(a,b.providerId),a.providerData.push(b))}function Ol(a,b){y(a.providerData,function(c){return c.providerId==b})}function Pl(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
function Ql(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?K(a,"metadata",vl(b.metadata)):K(a,"metadata",new ul),x(b.providerData,function(c){Nl(a,c)}),sl(a.h,b.h),K(a,"refreshToken",a.h.a))}k=P.prototype;k.reload=function(){var a=this;return Q(this,Ll(this).then(function(){return Rl(a).then(function(){return Il(a)}).then(Kl)}))};
function Rl(a){return a.F().then(function(b){var c=a.isAnonymous;return Sl(a,b).then(function(){c||Pl(a,"isAnonymous",!1);return b})})}k.bc=function(a){return this.F(a).then(function(b){return new ll(b)})};k.F=function(a){var b=this;return Q(this,Ll(this).then(function(){return b.h.getToken(a)}).then(function(c){if(!c)throw new M("internal-error");c.accessToken!=b.ra&&(yl(b,c.accessToken),b.dispatchEvent(new xl("tokenChanged")));Pl(b,"refreshToken",c.refreshToken);return c.accessToken}))};
function Tl(a,b){b[ag]&&a.ra!=b[ag]&&(ql(a.h,b),a.dispatchEvent(new xl("tokenChanged")),yl(a,b[ag]),Pl(a,"refreshToken",a.h.a))}function Sl(a,b){return O(a.c,Vi,{idToken:b}).then(t(a.xc,a))}
k.xc=function(a){a=a.users;if(!a||!a.length)throw new M("internal-error");a=a[0];zl(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Ul(a),c=0;c<b.length;c++)Nl(this,b[c]);Pl(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function Ul(a){return(a=a.providerUserInfo)&&a.length?Ia(a,function(b){return new wl(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.yc=function(a){Ue("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.gb(a)};
k.gb=function(a){var b=this,c=null;return Q(this,a.f(this.c,this.uid).then(function(d){Tl(b,d);c=Vl(b,d,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};function Wl(a,b){return Rl(a).then(function(){if(Ma(Ml(a),b))return Il(a).then(function(){throw new M("provider-already-linked");})})}k.pc=function(a){Ue("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.eb(a)};
k.eb=function(a){var b=this,c=null;return Q(this,Wl(this,a.providerId).then(function(){return b.F()}).then(function(d){return a.b(b.c,d)}).then(function(d){c=Vl(b,d,"link");return Xl(b,d)}).then(function(){return c}))};k.qc=function(a,b){var c=this;return Q(this,Wl(this,"phone").then(function(){return kl(El(c),a,b,t(c.eb,c))}))};k.zc=function(a,b){var c=this;return Q(this,D().then(function(){return kl(El(c),a,b,t(c.gb,c))}),!0)};
function Vl(a,b,c){var d=Lg(b);b=Of(b);return Xe({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Xl(a,b){Tl(a,b);return a.reload().then(function(){return a})}k.rb=function(a){var b=this;return Q(this,this.F().then(function(c){return b.c.rb(c,a)}).then(function(c){Tl(b,c);return b.reload()}))};k.Pc=function(a){var b=this;return Q(this,this.F().then(function(c){return a.b(b.c,c)}).then(function(c){Tl(b,c);return b.reload()}))};
k.sb=function(a){var b=this;return Q(this,this.F().then(function(c){return b.c.sb(c,a)}).then(function(c){Tl(b,c);return b.reload()}))};
k.tb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Ll(this);var b=this;return Q(this,this.F().then(function(c){return b.c.tb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){Tl(b,c);Pl(b,"displayName",c.displayName||null);Pl(b,"photoURL",c.photoUrl||null);x(b.providerData,function(d){"password"===d.providerId&&(K(d,"displayName",b.displayName),K(d,"photoURL",b.photoURL))});return Il(b)}).then(Kl))};
k.Nc=function(a){var b=this;return Q(this,Rl(this).then(function(c){return Ma(Ml(b),a)?Gi(b.c,c,[a]).then(function(d){var e={};x(d.providerUserInfo||[],function(f){e[f.providerId]=!0});x(Ml(b),function(f){e[f]||Ol(b,f)});e[Ig.PROVIDER_ID]||K(b,"phoneNumber",null);return Il(b)}):Il(b).then(function(){throw new M("no-such-provider");})}))};
k.delete=function(){var a=this;return Q(this,this.F().then(function(b){return O(a.c,Ui,{idToken:b})}).then(function(){a.dispatchEvent(new xl("userDeleted"))})).then(function(){for(var b=0;b<a.G.length;b++)a.G[b].cancel("app-deleted");Cl(a,null);Dl(a,null);a.G=[];a.D=!0;Gl(a);K(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
k.xb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.aa||null)==b||"reauthViaRedirect"==a&&(this.aa||null)==b?!0:!1};k.ha=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};
k.xa=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?t(this.Bb,this):"reauthViaPopup"==a&&b==(this.g||null)?t(this.Cb,this):"linkViaRedirect"==a&&(this.aa||null)==b?t(this.Bb,this):"reauthViaRedirect"==a&&(this.aa||null)==b?t(this.Cb,this):null};k.rc=function(a){var b=this;return Yl(this,"linkViaPopup",a,function(){return Wl(b,a.providerId).then(function(){return Il(b)})},!1)};k.Ac=function(a){return Yl(this,"reauthViaPopup",a,function(){return D()},!0)};
function Yl(a,b,c,d,e){if(!Ee())return E(new M("operation-not-supported-in-this-environment"));if(a.i&&!e)return E(a.i);var f=Nf(c.providerId),g=De(a.uid+":::"),h=null;(!Ge()||ve())&&a.u&&c.isOAuthProvider&&(h=pj(a.u,a.l,a.o,b,c,null,g,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var m=me(h,f&&f.Ba,f&&f.Aa);d=d().then(function(){Zl(a);if(!e)return a.F().then(function(){})}).then(function(){return $k(a.a,m,b,c,g,!!h)}).then(function(){return new C(function(p,v){a.ha(b,null,new M("cancelled-popup-request"),a.g||null);
a.f=p;a.v=v;a.g=g;a.b=a.a.Ea(a,b,m,g)})}).then(function(p){m&&le(m);return p?Xe(p):null}).s(function(p){m&&le(m);throw p;});return Q(a,d,e)}k.sc=function(a){var b=this;return $l(this,"linkViaRedirect",a,function(){return Wl(b,a.providerId)},!1)};k.Bc=function(a){return $l(this,"reauthViaRedirect",a,function(){return D()},!0)};
function $l(a,b,c,d,e){if(!Ee())return E(new M("operation-not-supported-in-this-environment"));if(a.i&&!e)return E(a.i);var f=null,g=De(a.uid+":::");d=d().then(function(){Zl(a);if(!e)return a.F().then(function(){})}).then(function(){a.aa=g;return Il(a)}).then(function(h){a.ba&&(h=a.ba,h=h.b.set(am,a.w(),h.a));return h}).then(function(){return a.a.Ca(b,c,g)}).s(function(h){f=h;if(a.ba)return bm(a.ba);throw f;}).then(function(){if(f)throw f;});return Q(a,d,e)}
function Zl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new M("internal-error");throw new M("auth-domain-config-required");}}k.Bb=function(a,b,c){var d=this;this.b&&(this.b.cancel(),this.b=null);var e=null,f=this.F().then(function(g){return eg(d.c,{requestUri:a,postBody:c,sessionId:b,idToken:g})}).then(function(g){e=Vl(d,g,"link");return Xl(d,g)}).then(function(){return e});return Q(this,f)};
k.Cb=function(a,b,c){var d=this;this.b&&(this.b.cancel(),this.b=null);var e=null,f=D().then(function(){return $f(fg(d.c,{requestUri:a,sessionId:b,postBody:c}),d.uid)}).then(function(g){e=Vl(d,g,"reauthenticate");Tl(d,g);d.i=null;return d.reload()}).then(function(){return e});return Q(this,f,!0)};k.jb=function(a){var b=this,c=null;return Q(this,this.F().then(function(d){c=d;return"undefined"===typeof a||cb(a)?{}:xf(new nf(a))}).then(function(d){return b.c.jb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};
function Q(a,b,c){var d=cm(a,b,c);a.G.push(d);d.ia(function(){Na(a.G,d)});return d}function cm(a,b,c){return a.i&&!c?(b.cancel(),E(a.i)):b.s(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.i||a.dispatchEvent(new xl("userInvalidated")),a.i=d);throw d;})}k.toJSON=function(){return this.w()};
k.w=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.l,appName:this.o,authDomain:this.u,stsTokenManager:this.h.w(),redirectEventId:this.aa||null};this.metadata&&fb(a,this.metadata.w());x(this.providerData,function(b){a.providerData.push(Ye(b))});return a};
function dm(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[ag]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-va())/1E3;else return null;var d=new P(b,c,a);a.providerData&&x(a.providerData,function(e){e&&Nl(d,Xe(e))});a.redirectEventId&&(d.aa=a.redirectEventId);return d}
function em(a,b,c,d){var e=new P(a,b);c&&(e.ba=c);d&&Bl(e,d);return e.reload().then(function(){return e})}function fm(a,b,c,d){b=b||{apiKey:a.l,authDomain:a.u,appName:a.o};var e=a.h,f={};f[ag]=e.b;f.refreshToken=e.a;f.expiresIn=(e.c-va())/1E3;b=new P(b,f);c&&(b.ba=c);d&&Bl(b,d);Ql(b,a);return b};function gm(a){this.a=a;this.b=ek()}var am={name:"redirectUser",B:"session"};function bm(a){return ik(a.b,am,a.a)}function hm(a,b){return a.b.get(am,a.a).then(function(c){c&&b&&(c.authDomain=b);return dm(c||{})})};function im(a){this.a=a;this.b=ek();this.c=null;this.f=jm(this);this.b.addListener(km("local"),this.a,t(this.g,this))}im.prototype.g=function(){var a=this,b=km("local");lm(this,function(){return D().then(function(){return a.c&&"local"!=a.c.B?a.b.get(b,a.a):null}).then(function(c){if(c)return mm(a,"local").then(function(){a.c=b})})})};function mm(a,b){var c=[],d;for(d in ak)ak[d]!==b&&c.push(ik(a.b,km(ak[d]),a.a));c.push(ik(a.b,nm,a.a));return Ab(c)}
function jm(a){var b=km("local"),c=km("session"),d=km("none");return hk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(nm,a.a).then(function(h){return h?km(h):b})})})}).then(function(e){a.c=e;return mm(a,e.B)}).s(function(){a.c||(a.c=b)})}var nm={name:"persistence",B:"session"};function km(a){return{name:"authUser",B:a}}
im.prototype.mb=function(a){var b=null,c=this;bk(a);return lm(this,function(){return a!=c.c.B?c.b.get(c.c,c.a).then(function(d){b=d;return mm(c,a)}).then(function(){c.c=km(a);if(b)return c.b.set(c.c,b,c.a)}):D()})};function om(a){return lm(a,function(){return a.b.set(nm,a.c.B,a.a)})}function pm(a,b){return lm(a,function(){return a.b.set(a.c,b.w(),a.a)})}function qm(a){return lm(a,function(){return ik(a.b,a.c,a.a)})}
function rm(a,b){return lm(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return dm(c||{})})})}function lm(a,b){a.f=a.f.then(b,b);return a.f};function sm(a){this.l=!1;K(this,"settings",new il);K(this,"app",a);if(R(this).options&&R(this).options.apiKey)a=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION):null,this.c=new bi(R(this).options&&R(this).options.apiKey,If(Jf),a);else throw new M("invalid-api-key");this.N=[];this.o=[];this.I=[];this.Sb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.mc,this));this.O=void 0;this.Tb=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.nc,this));tm(this,null);this.h=new im(R(this).options.apiKey+":"+R(this).name);this.A=
new gm(R(this).options.apiKey+":"+R(this).name);this.V=S(this,um(this));this.i=S(this,vm(this));this.X=!1;this.ka=t(this.Kc,this);this.Ha=t(this.Z,this);this.ra=t(this.$b,this);this.sa=t(this.jc,this);this.ta=t(this.kc,this);wm(this);this.INTERNAL={};this.INTERNAL["delete"]=t(this.delete,this);this.INTERNAL.logFramework=t(this.tc,this);this.u=0;F.call(this);xm(this);this.G=[]}u(sm,F);function ym(a){kc.call(this,"languageCodeChanged");this.g=a}u(ym,kc);
function zm(a){kc.call(this,"frameworkChanged");this.c=a}u(zm,kc);k=sm.prototype;k.mb=function(a){a=this.h.mb(a);return S(this,a)};k.pa=function(a){this.W===a||this.l||(this.W=a,hi(this.c,this.W),this.dispatchEvent(new ym(this.ea())))};k.ea=function(){return this.W};k.Qc=function(){var a=l.navigator;this.pa(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};k.tc=function(a){this.G.push(a);ii(this.c,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,this.G):null);this.dispatchEvent(new zm(this.G))};
k.ya=function(){return Pa(this.G)};function xm(a){Object.defineProperty(a,"lc",{get:function(){return this.ea()},set:function(b){this.pa(b)},enumerable:!1});a.W=null}k.toJSON=function(){return{apiKey:R(this).options.apiKey,authDomain:R(this).options.authDomain,appName:R(this).name,currentUser:T(this)&&T(this).w()}};function Am(a){return a.Rb||E(new M("auth-domain-config-required"))}
function wm(a){var b=R(a).options.authDomain,c=R(a).options.apiKey;b&&Ee()&&(a.Rb=a.V.then(function(){if(!a.l){a.a=bl(b,c,R(a).name);a.a.subscribe(a);T(a)&&Jl(T(a));if(a.D){Jl(a.D);var d=a.D;d.pa(a.ea());Cl(d,a);d=a.D;Bl(d,a.G);Dl(d,a);a.D=null}return a.a}}))}k.xb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
k.ha=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};k.xa=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?t(this.Zb,this):null};
k.Zb=function(a,b,c){var d=this;a={requestUri:a,postBody:c,sessionId:b};this.b&&(this.b.cancel(),this.b=null);var e=null,f=null,g=cg(d.c,a).then(function(h){e=Lg(h);f=Of(h);return h});a=d.V.then(function(){return g}).then(function(h){return Bm(d,h)}).then(function(){return Xe({user:T(d),credential:e,additionalUserInfo:f,operationType:"signIn"})});return S(this,a)};
k.Ic=function(a){if(!Ee())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=Nf(a.providerId),d=De(),e=null;(!Ge()||ve())&&R(this).options.authDomain&&a.isOAuthProvider&&(e=pj(R(this).options.authDomain,R(this).options.apiKey,R(this).name,"signInViaPopup",a,null,d,__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION||null));var f=me(e,c&&c.Ba,c&&c.Aa);c=Am(this).then(function(g){return $k(g,f,"signInViaPopup",a,d,!!e)}).then(function(){return new C(function(g,h){b.ha("signInViaPopup",null,new M("cancelled-popup-request"),
b.g);b.f=g;b.v=h;b.g=d;b.b=b.a.Ea(b,"signInViaPopup",f,d)})}).then(function(g){f&&le(f);return g?Xe(g):null}).s(function(g){f&&le(f);throw g;});return S(this,c)};k.Jc=function(a){if(!Ee())return E(new M("operation-not-supported-in-this-environment"));var b=this,c=Am(this).then(function(){return om(b.h)}).then(function(){return b.a.Ca("signInViaRedirect",a)});return S(this,c)};
k.fa=function(){if(!Ee())return E(new M("operation-not-supported-in-this-environment"));var a=this,b=Am(this).then(function(){return a.a.fa()}).then(function(c){return c?Xe(c):null});return S(this,b)};
k.Oc=function(a){if(!a)return E(new M("null-user"));var b=this,c={};c.apiKey=R(this).options.apiKey;c.authDomain=R(this).options.authDomain;c.appName=R(this).name;var d=fm(a,c,b.A,b.ya());return S(this,this.i.then(function(){if(R(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(T(b)&&a.uid==T(b).uid)return Ql(T(b),a),b.Z(a);tm(b,d);Jl(d);return b.Z(d)}).then(function(){Cm(b)}))};
function Bm(a,b){var c={};c.apiKey=R(a).options.apiKey;c.authDomain=R(a).options.authDomain;c.appName=R(a).name;return a.V.then(function(){return em(c,b,a.A,a.ya())}).then(function(d){if(T(a)&&d.uid==T(a).uid)return Ql(T(a),d),a.Z(d);tm(a,d);Jl(d);return a.Z(d)}).then(function(){Cm(a)})}
function tm(a,b){T(a)&&(Hl(T(a),a.Ha),Hc(T(a),"tokenChanged",a.ra),Hc(T(a),"userDeleted",a.sa),Hc(T(a),"userInvalidated",a.ta),Gl(T(a)));b&&(b.N.push(a.Ha),xc(b,"tokenChanged",a.ra),xc(b,"userDeleted",a.sa),xc(b,"userInvalidated",a.ta),0<a.u&&Fl(b));K(a,"currentUser",b);b&&(b.pa(a.ea()),Cl(b,a),Bl(b,a.G),Dl(b,a))}k.pb=function(){var a=this,b=this.i.then(function(){if(!T(a))return D();tm(a,null);return qm(a.h).then(function(){Cm(a)})});return S(this,b)};
function Dm(a){var b=hm(a.A,R(a).options.authDomain).then(function(c){if(a.D=c)c.ba=a.A;return bm(a.A)});return S(a,b)}function um(a){var b=R(a).options.authDomain,c=Dm(a).then(function(){return rm(a.h,b)}).then(function(d){return d?(d.ba=a.A,a.D&&(a.D.aa||null)==(d.aa||null)?d:d.reload().then(function(){return pm(a.h,d).then(function(){return d})}).s(function(e){return"auth/network-request-failed"==e.code?d:qm(a.h)})):null}).then(function(d){tm(a,d||null)});return S(a,c)}
function vm(a){return a.V.then(function(){return a.fa()}).s(function(){}).then(function(){if(!a.l)return a.ka()}).s(function(){}).then(function(){if(!a.l){a.X=!0;var b=a.h;b.b.addListener(km("local"),b.a,a.ka)}})}
k.Kc=function(){var a=this;return rm(this.h,R(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=T(a)&&b){c=T(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Ql(T(a),b),T(a).F();if(T(a)||b)tm(a,b),b&&(Jl(b),b.ba=a.A),a.a&&a.a.subscribe(a),Cm(a)}})};k.Z=function(a){return pm(this.h,a)};k.$b=function(){Cm(this);this.Z(T(this))};k.jc=function(){this.pb()};k.kc=function(){this.pb()};
function Em(a,b){var c=null,d=null;return S(a,b.then(function(e){c=Lg(e);d=Of(e);return Bm(a,e)}).then(function(){return Xe({user:T(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.mc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(T(b))})};k.nc=function(a){var b=this;Fm(this,function(){a.next(T(b))})};k.vc=function(a,b,c){var d=this;this.X&&Promise.resolve().then(function(){q(a)?a(T(d)):q(a.next)&&a.next(T(d))});return this.Sb(a,b,c)};
k.uc=function(a,b,c){var d=this;this.X&&Promise.resolve().then(function(){d.O=d.getUid();q(a)?a(T(d)):q(a.next)&&a.next(T(d))});return this.Tb(a,b,c)};k.ac=function(a){var b=this,c=this.i.then(function(){return T(b)?T(b).F(a).then(function(d){return{accessToken:d}}):null});return S(this,c)};k.Ec=function(a){var b=this;return this.i.then(function(){return Em(b,O(b.c,Xi,{token:a}))}).then(function(c){var d=c.user;Pl(d,"isAnonymous",!1);b.Z(d);return c})};
k.Fc=function(a,b){var c=this;return this.i.then(function(){return Em(c,O(c.c,xg,{email:a,password:b}))})};k.Vb=function(a,b){var c=this;return this.i.then(function(){return Em(c,O(c.c,Ti,{email:a,password:b}))})};k.Nb=function(a){var b=this;return this.i.then(function(){return Em(b,a.la(b.c))})};k.nb=function(a){Ue("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Nb(a)};
k.ob=function(){var a=this;return this.i.then(function(){var b=T(a);if(b&&b.isAnonymous){var c=Xe({providerId:null,isNewUser:!1});return Xe({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Em(a,a.c.ob()).then(function(d){var e=d.user;Pl(e,"isAnonymous",!0);a.Z(e);return d})})};function R(a){return a.app}function T(a){return a.currentUser}k.getUid=function(){return T(this)&&T(this).uid||null};function Gm(a){return T(a)&&T(a)._lat||null}
function Cm(a){if(a.X){for(var b=0;b<a.o.length;b++)if(a.o[b])a.o[b](Gm(a));if(a.O!==a.getUid()&&a.I.length)for(a.O=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Gm(a))}}k.Ub=function(a){this.addAuthTokenListener(a);this.u++;0<this.u&&T(this)&&Fl(T(this))};k.Cc=function(a){var b=this;x(this.o,function(c){c==a&&b.u--});0>this.u&&(this.u=0);0==this.u&&T(this)&&Gl(T(this));this.removeAuthTokenListener(a)};
k.addAuthTokenListener=function(a){var b=this;this.o.push(a);S(this,this.i.then(function(){b.l||Ma(b.o,a)&&a(Gm(b))}))};k.removeAuthTokenListener=function(a){y(this.o,function(b){return b==a})};function Fm(a,b){a.I.push(b);S(a,a.i.then(function(){!a.l&&Ma(a.I,b)&&a.O!==a.getUid()&&(a.O=a.getUid(),b(Gm(a)))}))}
k.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,a.b.removeListener(km("local"),a.a,this.ka));this.a&&(this.a.unsubscribe(this),this.a.Ya());return Promise.resolve()};function S(a,b){a.N.push(b);b.ia(function(){Na(a.N,b)});return b}k.Yb=function(a){return S(this,si(this.c,a))};k.oc=function(a){return!!Cg(a)};
k.lb=function(a,b){var c=this;return S(this,D().then(function(){var d=new nf(b);if(!d.c)throw new M("argument-error",vf+" must be true when sending sign in link to email");return xf(d)}).then(function(d){return c.c.lb(a,d)}).then(function(){}))};k.Rc=function(a){return this.Ka(a).then(function(b){return b.data.email})};k.Za=function(a,b){return S(this,this.c.Za(a,b).then(function(){}))};k.Ka=function(a){return S(this,this.c.Ka(a).then(function(b){return new af(b)}))};
k.Wa=function(a){return S(this,this.c.Wa(a).then(function(){}))};k.kb=function(a,b){var c=this;return S(this,D().then(function(){return"undefined"===typeof b||cb(b)?{}:xf(new nf(b))}).then(function(d){return c.c.kb(a,d)}).then(function(){}))};k.Hc=function(a,b){return S(this,kl(this,a,b,t(this.nb,this)))};k.Gc=function(a,b){var c=this;return S(this,D().then(function(){var d=Bg(a,b||ee());return c.nb(d)}))};function Hm(){}Hm.prototype.render=function(){};Hm.prototype.reset=function(){};Hm.prototype.getResponse=function(){};Hm.prototype.execute=function(){};function Im(){this.a={};this.b=1E12}var Jm=null;Im.prototype.render=function(a,b){this.a[this.b.toString()]=new Km(a,b);return this.b++};Im.prototype.reset=function(a){var b=Lm(this,a);a=Mm(a);b&&a&&(b.delete(),delete this.a[a])};Im.prototype.getResponse=function(a){return(a=Lm(this,a))?a.getResponse():null};Im.prototype.execute=function(a){(a=Lm(this,a))&&a.execute()};function Lm(a,b){return(b=Mm(b))?a.a[b]||null:null}function Mm(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
function Km(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=Sd(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():xc(this.f,"click",this.i)}Km.prototype.getResponse=function(){Nm(this);return this.b};
Km.prototype.execute=function(){Nm(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=ze();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};Km.prototype.delete=function(){Nm(this);this.g=!0;clearTimeout(this.a);this.a=null;Hc(this.f,"click",this.i)};function Nm(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function Om(){}Om.prototype.g=function(){Jm||(Jm=new Im);return D(Jm)};Om.prototype.c=function(){};var Pm=null;function Qm(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Rm=new wd(xd,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Sm=new Me(3E4,6E4);
Qm.prototype.g=function(a){var b=this;return new C(function(c,d){var e=setTimeout(function(){d(new M("network-request-failed"))},Sm.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new M("internal-error"));delete l[b.a]};var f=Dd(Rm,{onload:b.a,hl:a||""});D(Vh(f)).s(function(){clearTimeout(e);d(new M("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
c(l.grecaptcha)})};Qm.prototype.c=function(){this.b--};var Tm=null;function Um(a,b,c,d,e,f,g){K(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.l=b;this.g=null;g?(Pm||(Pm=new Om),g=Pm):(Tm||(Tm=new Qm),g=Tm);this.o=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Vm])throw new M("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[Wm];if(!l.document)throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
if(!Sd(b)||!this.i&&Sd(b).hasChildNodes())throw new M("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new bi(a,f||null,e||null);this.v=d||function(){return null};var h=this;this.m=[];var m=this.a[Xm];this.a[Xm]=function(v){Ym(h,v);if("function"===typeof m)m(v);else if("string"===typeof m){var z=J(m,l);"function"===typeof z&&z(v)}};var p=this.a[Zm];this.a[Zm]=function(){Ym(h,null);if("function"===typeof p)p();else if("string"===typeof p){var v=
J(p,l);"function"===typeof v&&v()}}}var Xm="callback",Zm="expired-callback",Vm="sitekey",Wm="size";function Ym(a,b){for(var c=0;c<a.m.length;c++)try{a.m[c](b)}catch(d){}}function $m(a,b){y(a.m,function(c){return c==b})}function an(a,b){a.h.push(b);b.ia(function(){Na(a.h,b)});return b}k=Um.prototype;
k.za=function(){var a=this;return this.f?this.f:this.f=an(this,D().then(function(){if(Fe()&&!we())return re();throw new M("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.o.g(a.v())}).then(function(b){a.g=b;return O(a.u,Wi,{})}).then(function(b){a.a[Vm]=b.recaptchaSiteKey}).s(function(b){a.f=null;throw b;}))};
k.render=function(){bn(this);var a=this;return an(this,this.za().then(function(){if(null===a.c){var b=a.l;if(!a.i){var c=Sd(b);b=Vd("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){bn(this);var a=this;return an(this,this.render().then(function(b){return new C(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&($m(a,e),c(f))};a.m.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){bn(this);null!==this.c&&this.g.reset(this.c)};
function bn(a){if(a.D)throw new M("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){bn(this);this.D=!0;this.o.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=Sd(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};
function cn(a,b,c){var d=!1;try{this.b=c||__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app()}catch(g){throw new M("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new M("invalid-api-key");var e=this,f=null;try{f=this.b.auth().ya()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION?Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION,f):null;Um.call(this,c,a,b,function(){try{var g=e.b.auth().ea()}catch(h){g=
null}return g},f,If(Jf),d)}u(cn,Um);function dn(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new M("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=en.length)throw new M("internal-error",
"Argument validator received an unsupported number of arguments.");c=en[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new M("argument-error",a+" failed: "+d);}var en="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:n}}function fn(a,b){return{name:a||"",K:"a boolean",optional:!!b,M:ha}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:r}}function gn(a,b){return{name:a||"",K:"a function",optional:!!b,M:q}}function hn(a,b){return{name:a||"",K:"null",optional:!!b,M:ma}}function jn(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function kn(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof sm)}}}
function ln(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App)}}}function mn(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.la||!c)}}}
function nn(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function on(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&n(a.type)&&q(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(e){return a.M(e)||b.M(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=pn(d,a[c],b[c].j)}}function qn(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:ua(function(e){return this[e]},c),set:ua(function(e,f,g,h){dn(e,[g],[h],!0);this[f]=h},d,c,b[c].vb),enumerable:!0})}}function Z(a,b,c,d){a[b]=pn(b,c,d)}
function pn(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);dn(e,c,g);return b.apply(this,g)}if(!c)return b;var e=rn(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function rn(a){a=a.split(".");return a[a.length-1]};Y(sm.prototype,{Wa:{name:"applyActionCode",j:[V("code")]},Ka:{name:"checkActionCode",j:[V("code")]},Za:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Vb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Yb:{name:"fetchSignInMethodsForEmail",j:[V("email")]},fa:{name:"getRedirectResult",j:[]},oc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},uc:{name:"onAuthStateChanged",j:[X(W(),gn(),"nextOrObserver"),gn("opt_error",!0),gn("opt_completed",!0)]},vc:{name:"onIdTokenChanged",
j:[X(W(),gn(),"nextOrObserver"),gn("opt_error",!0),gn("opt_completed",!0)]},kb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),hn(null,!0),"opt_actionCodeSettings",!0)]},lb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},mb:{name:"setPersistence",j:[V("persistence")]},nb:{name:"signInAndRetrieveDataWithCredential",j:[mn()]},ob:{name:"signInAnonymously",j:[]},Nb:{name:"signInWithCredential",j:[mn()]},Ec:{name:"signInWithCustomToken",j:[V("token")]},
Fc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Gc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Hc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),on()]},Ic:{name:"signInWithPopup",j:[nn()]},Jc:{name:"signInWithRedirect",j:[nn()]},Oc:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",K:"an instance of Firebase User",optional:!!a,M:function(b){return!!(b&&b instanceof P)}}}(),hn(),"user")]},pb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
Qc:{name:"useDeviceLanguage",j:[]},Rc:{name:"verifyPasswordResetCode",j:[V("code")]}});qn(sm.prototype,{lc:{name:"languageCode",vb:X(V(),hn(),"languageCode")}});sm.Persistence=ak;sm.Persistence.LOCAL="local";sm.Persistence.SESSION="session";sm.Persistence.NONE="none";
Y(P.prototype,{"delete":{name:"delete",j:[]},bc:{name:"getIdTokenResult",j:[fn("opt_forceRefresh",!0)]},F:{name:"getIdToken",j:[fn("opt_forceRefresh",!0)]},pc:{name:"linkAndRetrieveDataWithCredential",j:[mn()]},eb:{name:"linkWithCredential",j:[mn()]},qc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),on()]},rc:{name:"linkWithPopup",j:[nn()]},sc:{name:"linkWithRedirect",j:[nn()]},yc:{name:"reauthenticateAndRetrieveDataWithCredential",j:[mn()]},gb:{name:"reauthenticateWithCredential",j:[mn()]},zc:{name:"reauthenticateWithPhoneNumber",
j:[V("phoneNumber"),on()]},Ac:{name:"reauthenticateWithPopup",j:[nn()]},Bc:{name:"reauthenticateWithRedirect",j:[nn()]},reload:{name:"reload",j:[]},jb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),hn(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},Nc:{name:"unlink",j:[V("provider")]},rb:{name:"updateEmail",j:[V("email")]},sb:{name:"updatePassword",j:[V("password")]},Pc:{name:"updatePhoneNumber",j:[mn("phone")]},tb:{name:"updateProfile",j:[W("profile")]}});
Y(Im.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(Hm.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(C.prototype,{ia:{name:"finally"},s:{name:"catch"},then:{name:"then"}});qn(il.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",vb:fn("appVerificationDisabledForTesting")}});Y(jl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});
Z(Zf,"fromJSON",function(a){a=n(a)?JSON.parse(a):a;for(var b,c=[jg,Ag,Hg,gg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(vg,"credential",function(a,b){return new ug(a,b)},[V("email"),V("password")]);Y(ug.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(mg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(mg,"credential",ng,[X(V(),W(),"token")]);Z(vg,"credentialWithLink",Bg,[V("email"),V("emailLink")]);
Y(og.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(og,"credential",pg,[X(V(),W(),"token")]);Y(qg.prototype,{ua:{name:"addScope",j:[V("scope")]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(qg,"credential",rg,[X(V(),X(W(),hn()),"idToken"),X(V(),hn(),"accessToken",!0)]);Y(sg.prototype,{Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(sg,"credential",tg,[X(V(),W(),"token"),V("secret",!0)]);
Y(N.prototype,{ua:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),hn()),"optionsOrIdToken"),X(V(),hn(),"accessToken",!0)]},Da:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(hg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(bg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Z(Ig,"credential",Kg,[V("verificationId"),V("verificationCode")]);Y(Ig.prototype,{Ua:{name:"verifyPhoneNumber",j:[V("phoneNumber"),on()]}});
Y(Dg.prototype,{w:{name:"toJSON",j:[V(null,!0)]}});Y(M.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Sg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(Rg.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(cn.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
(function(){if("undefined"!==typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL&&__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService){var a={Auth:sm,AuthCredential:Zf,Error:M};Z(a,"EmailAuthProvider",vg,[]);Z(a,"FacebookAuthProvider",mg,[]);Z(a,"GithubAuthProvider",og,[]);Z(a,"GoogleAuthProvider",qg,[]);Z(a,"TwitterAuthProvider",sg,[]);Z(a,"OAuthProvider",N,[V("providerId")]);Z(a,"SAMLAuthProvider",lg,[V("providerId")]);Z(a,"PhoneAuthProvider",Ig,[kn()]);Z(a,"RecaptchaVerifier",cn,[X(V(),jn(),"recaptchaContainer"),W("recaptchaParameters",
!0),ln()]);__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth",function(b,c){b=new sm(b);c({INTERNAL:{getUid:t(b.getUid,b),getToken:t(b.ac,b),addAuthTokenListener:t(b.Ub,b),removeAuthTokenListener:t(b.Cc,b)}});return b},a,function(b,c){if("create"===b)try{c.auth()}catch(d){}});__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({User:P})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(51));
var tslib_1 = __webpack_require__(992);
var util = __webpack_require__(87);
var logger$1 = __webpack_require__(158);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage();
};
/** A storage object that lasts across sessions */
var PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
var SessionStorage = createStoragefor('sessionStorage');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger$1.Logger('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
var LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
var sha1 = function (str) {
    var utf8Bytes = util.stringToByteArray(str);
    var sha1 = new util.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
var logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
var enableLogging = function (logger_, persistent) {
    util.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        logClient.logLevel = logger$1.LogLevel.VERBOSE;
        logger = logClient.log.bind(logClient);
        if (persistent)
            SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        logger = logger_;
    }
    else {
        logger = null;
        SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
var log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (logger === null && SessionStorage.get('logging_enabled') === true)
            enableLogging(true);
    }
    if (logger) {
        var message = buildLogMessage_.apply(null, var_args);
        logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
var logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
var error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
};
/**
 * @param {...string} var_args
 */
var fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, var_args);
    logClient.error(message);
    throw new Error(message);
};
/**
 * @param {...*} var_args
 */
var warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
    logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
var warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
var isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
var executeWhenDOMReady = function (fn) {
    if (util.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
var MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
var MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
var nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === MIN_NAME || b === MAX_NAME) {
        return -1;
    }
    else if (b === MIN_NAME || a === MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
var stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
var requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
var ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util.stringify(keys[i]);
        key += ':';
        key += ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
var splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
var each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
var doubleToIEEE754String = function (v) {
    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
var isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
var isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
var errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
var INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
var tryParseInt = function (str) {
    if (INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
var exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
var beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
var setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PROTOCOL_VERSION = '5';
var VERSION_PARAM = 'v';
var TRANSPORT_SESSION_PARAM = 's';
var REFERER_PARAM = 'r';
var FORGE_REF = 'f';
var FORGE_DOMAIN = 'firebaseio.com';
var LAST_SESSION_PARAM = 'ls';
var WEBSOCKET = 'websocket';
var LONG_POLLING = 'long_polling';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util.assert(typeof type === 'string', 'typeof type must == string');
        util.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.charAt(0) === '?') {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
var parseRepoInfo = function (dataURL) {
    var parsedUrl = parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
var parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
var isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
var isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
var isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
var validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > MAX_LEAF_SIZE_ / 3 &&
        util.stringLength(data) > MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util.forEach(data, function (key, value) {
        var curPath = new Path(key);
        validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    validateFirebaseMergePaths(errorPrefix, mergePaths);
};
var validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (isInvalidJSONNumber(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!isValidPriority(priority))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
var validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
var validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!isValidKey(key))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
var validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!isValidPathString(pathString))
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    validatePathString(fnName, argumentNumber, pathString, optional);
};
var validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
var validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
var validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validateWritablePath('OnDisconnect.remove', this.path_);
        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.set', this.path_);
        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
var nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
        var newWrapped = new NamedNode(MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    return Index;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new NamedNode(MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index));
var KEY_INDEX = new KeyIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
var priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
var validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' &&
                util.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var nodeFromJSON;
var MAX_NODE$1;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
function setMaxNode$1(val) {
    MAX_NODE$1 = val;
}
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index));
var PRIORITY_INDEX = new PriorityIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, LLRBNode.BLACK);
                buildPennant(chunkSize, LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap(mapSortFn || cmp, root);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util.safeGet(_this.indexSet_, indexName);
            util.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function NAME_ONLY_COMPARATOR(left, right) {
    return nameCompare(left.name, right.name);
}
function NAME_COMPARATOR(left, right) {
    return nameCompare(left, right);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === MAX_NODE$2) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
var MAX_NODE$2 = new MaxNode();
Object.defineProperties(NamedNode, {
    MIN: {
        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new NamedNode(MAX_NAME, MAX_NODE$2)
    }
});
/**
 * Reference Extensions
 */
KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode.__childrenNodeConstructor = ChildrenNode;
setMaxNode(MAX_NODE$2);
setMaxNode$1(MAX_NODE$2);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON$1(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON$1(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode.EMPTY_NODE;
        }
        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util.forEach(jsonObj_1, function (key, childData) {
            if (util.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON$1(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON$1(priority));
    }
}
setNodeFromJSON(nodeFromJSON$1);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        return new NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index));
var VALUE_INDEX = new ValueIndex();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON$1(indexValue);
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
        return new NamedNode(MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util.getCount(other.callbacks_);
                var thisCount = util.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PRIORITY_INDEX) {
            if ((startNode != null && !isValidPriority(startNode)) ||
                (endNode != null && !isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util.assert(params.getIndex() instanceof PathIndex ||
                params.getIndex() === VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util.validateArgCount('Query.on', 2, 4, arguments.length);
        validateEventType('Query.on', 1, eventType, false);
        util.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util.validateArgCount('Query.off', 0, 3, arguments.length);
        validateEventType('Query.off', 1, eventType, true);
        util.validateCallback('Query.off', 2, callback, true);
        util.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param failureCallbackOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
        var _this = this;
        util.validateArgCount('Query.once', 1, 4, arguments.length);
        validateEventType('Query.once', 1, eventType, false);
        util.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
var generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
var resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
var resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree();
    tree.forEachTree(new Path(''), function (path, node) {
        resolvedTree.remember(path, resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
var resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode(value, nodeFromJSON$1(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode(priority));
        }
        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType || (OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path(childName));
            return new AckUserWrite(Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap(stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite(this.source, Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path.Empty, childTree);
            }
        }
        else {
            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
                }
                else {
                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util.assert(type == Change.CHILD_ADDED ||
            type == Change.CHILD_CHANGED ||
            type == Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change.CHILD_ADDED && oldType == Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change.CHILD_REMOVED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change.CHILD_CHANGED &&
                oldType == Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode
                        ? serverCache
                        : ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === OperationType.MERGE &&
            operation.source.queryId !== null) {
            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
            return __referenceConstructor$1;
        },
        set: function (val) {
            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
            __referenceConstructor$1 = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util.safeGet(this.views_, queryId);
            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache(new CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
                        }
                        else {
                            var child = util.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
                            }
                        }
                    }
                }
                else {
                    throw util.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
            }
            else {
                util.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree.fromObject(changedChildren);
            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path.relativePath(queryPath, path);
            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        warn(errorMessage);
    };
    return AuthTokenProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util.deepCopy(this.counters_);
    };
    return StatsCollection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util.clone(newStats);
        if (this.last_) {
            util.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util.forEach(stats, function (stat, value) {
            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (logger) {
                    log('event: ' + eventData.toString());
                }
                exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// URL query parameters associated with longpolling
var FIREBASE_LONGPOLL_START_PARAM = 'start';
var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
var FIREBASE_LONGPOLL_ID_PARAM = 'id';
var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
var FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = logWrapper(connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(FORGE_DOMAIN) !== -1) {
                urlParams[REFERER_PARAM] = FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !isChromeExtensionContentScript() &&
                !isWindowsStoreApp() &&
                !util.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = LUIDGenerator();
            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                log('frame writing exception');
                if (e.stack) {
                    log(e.stack);
                }
                log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = logWrapper(this.connId);
        this.stats_ = StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
        if (!util.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(FORGE_DOMAIN) !== -1) {
            urlParams[REFERER_PARAM] = FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util.isNodeSdk()) {
                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + firebase.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = Object({"NODE_ENV":"production","PUBLIC_URL":""});
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (PersistentStorage.isInMemoryStorage ||
            PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection, WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = requireKey('t', parsedData);
        var data = requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (PROTOCOL_VERSION !== version) {
                warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util.stringify(msg));
        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req[ /*hash*/'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message[ /*data*/'d'];
            var status = message[ /*status*/'s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
            var warnings = util.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res[ /*status*/'s'];
                var data = res[ /*data*/'d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request[ /*hash*/'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result[ /*status*/'s'];
                if (status !== 'ok') {
                    var errorReason = result[ /* data */'d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[ /*body*/'b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            error('Unrecognized action received from server: ' +
                util.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (util.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        warn(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body) {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util.forEach(this.listens_, function (pathString, queries) {
            util.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + firebase.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor.getInstance().currentlyOnline();
        return util.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParameters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                }
                else if (error == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                'ns=' +
                _this.repoInfo_.namespace +
                util.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider(app);
        this.stats_ = StatsManager.getCollection(repoInfo_);
        if (forceRestClient || beingCrawled()) {
            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder();
        this.infoSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util.map(data, function (raw) {
                    return nodeFromJSON$1(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON$1(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util.map(data, function (raw) {
                return nodeFromJSON$1(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON$1(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path('/.info/' + pathString);
        var newNode = nodeFromJSON$1(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON$1(changedValue);
            changedChildren[changedKey] = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON$1(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util.isEmpty(childrenToMerge)) {
            log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON$1(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error = new Error(message);
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
            newChild = ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (indexValue === undefined) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter(this);
        }
        else {
            return new RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path)) {
            if (this.path.getFront() === null)
                validateRootPathString('Reference.child', 1, pathString, false);
            else
                validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util.validateArgCount('Reference.set', 1, 2, arguments.length);
        validateWritablePath('Reference.set', this.path);
        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util.validateArgCount('Reference.update', 1, 2, arguments.length);
        validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validateWritablePath('Reference.setWithPriority', this.path);
        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validateWritablePath('Reference.remove', this.path);
        util.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validateWritablePath('Reference.transaction', this.path);
        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            }
            else {
                deferred.resolve(new TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validateWritablePath('Reference.setPriority', this.path);
        validatePriority('Reference.setPriority', 1, priority, false);
        util.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util.validateArgCount('Reference.push', 0, 2, arguments.length);
        validateWritablePath('Reference.push', this.path);
        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validateWritablePath('Reference.onDisconnect', this.path);
        return new OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query));
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query.__referenceConstructor = Reference;
SyncPoint.__referenceConstructor = Reference;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus || (TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util.contains(newVal, '.priority')) {
            priorityForNode = util.safeGet(newVal, '.priority');
            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON$1(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
            else if (queue[i].status === TransactionStatus.SENT) {
                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            exceptionGuard(callbacks[i]);
        }
    }
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo)) {
            fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference(repo_, Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    Database.prototype.ref = function (path) {
        this.checkDeleted_('ref');
        util.validateArgCount('database.ref', 0, 1, arguments.length);
        if (path instanceof Reference) {
            return this.refFromURL(path.toString());
        }
        return path !== undefined ? this.root_.child(path) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parseRepoInfo(url);
        validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
var forceLongPolling = function () {
    WebSocketConnection.forceDisallow();
    BrowserPollConnection.forceAllow();
};
var forceWebSockets = function () {
    BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
var isWebSocketsAvailable = function () {
    return WebSocketConnection['isAvailable']();
};
var setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
var stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
var statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
var dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
var interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

var INTERNAL = /*#__PURE__*/Object.freeze({
  forceLongPolling: forceLongPolling,
  forceWebSockets: forceWebSockets,
  isWebSocketsAvailable: isWebSocketsAvailable,
  setSecurityDebugCallback: setSecurityDebugCallback,
  stats: stats,
  statsIncrementCounter: statsIncrementCounter,
  dataUpdateCount: dataUpdateCount,
  interceptServerData: interceptServerData
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DataConnection = PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
var RealTimeConnection = Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
var hijackHash = function (newHash) {
    var oldPut = PersistentConnection.prototype.put;
    PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
var ConnectionTarget = RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
var queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
var listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
var forceRestClient = function (forceRestClient) {
    RepoManager.getInstance().forceRestClient(forceRestClient);
};

var TEST_ACCESS = /*#__PURE__*/Object.freeze({
  DataConnection: DataConnection,
  RealTimeConnection: RealTimeConnection,
  hijackHash: hijackHash,
  ConnectionTarget: ConnectionTarget,
  queryIdentifier: queryIdentifier,
  listens: listens,
  forceRestClient: forceRestClient
});

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ServerValue = Database.ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference,
        Query: Query,
        Database: Database,
        DataSnapshot: DataSnapshot,
        enableLogging: enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util.isNodeSdk()) {
        module.exports = namespace;
    }
}
registerDatabase(firebase);

exports.DataSnapshot = DataSnapshot;
exports.Database = Database;
exports.OnDisconnect = OnDisconnect;
exports.Query = Query;
exports.Reference = Reference;
exports.ServerValue = ServerValue;
exports.enableLogging = enableLogging;
exports.registerDatabase = registerDatabase;
//# sourceMappingURL=index.cjs.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(220)))

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(51));
var logger = __webpack_require__(158);
var tslib_1 = __webpack_require__(994);
var util = __webpack_require__(87);
var webchannelWrapper = __webpack_require__(995);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The semver (www.semver.org) version of the SDK. */
var SDK_VERSION = firebase.SDK_VERSION;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logClient = new logger.Logger('@firebase/firestore');
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 2] = "SILENT";
})(LogLevel || (LogLevel = {}));
// Helper methods are needed because variables can't be exported as read/write
function getLogLevel() {
    if (logClient.logLevel === logger.LogLevel.DEBUG) {
        return LogLevel.DEBUG;
    }
    else if (logClient.logLevel === logger.LogLevel.SILENT) {
        return LogLevel.SILENT;
    }
    else {
        return LogLevel.ERROR;
    }
}
function setLogLevel(newLevel) {
    /**
     * Map the new log level to the associated Firebase Log Level
     */
    switch (newLevel) {
        case LogLevel.DEBUG:
            logClient.logLevel = logger.LogLevel.DEBUG;
            break;
        case LogLevel.ERROR:
            logClient.logLevel = logger.LogLevel.ERROR;
            break;
        case LogLevel.SILENT:
            logClient.logLevel = logger.LogLevel.SILENT;
            break;
        default:
            logClient.error("Firestore (" + SDK_VERSION + "): Invalid value passed to `setLogLevel`");
    }
}
function debug(tag, msg) {
    var obj = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj[_i - 2] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.DEBUG) {
        var args = obj.map(argToString);
        logClient.debug.apply(logClient, ["Firestore (" + SDK_VERSION + ") [" + tag + "]: " + msg].concat(args));
    }
}
function error(msg) {
    var obj = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        obj[_i - 1] = arguments[_i];
    }
    if (logClient.logLevel <= logger.LogLevel.ERROR) {
        var args = obj.map(argToString);
        logClient.error.apply(logClient, ["Firestore (" + SDK_VERSION + "): " + msg].concat(args));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */
function argToString(obj) {
    if (typeof obj === 'string') {
        return obj;
    }
    else {
        var platform = PlatformSupport.getPlatform();
        try {
            return platform.formatJSON(obj);
        }
        catch (e) {
            // Converting to JSON failed, just log the object directly
            return obj;
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */
function fail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "FIRESTORE (" + SDK_VERSION + ") INTERNAL ASSERTION FAILED: " + failure;
    error(message);
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */
function assert(assertion, message) {
    if (!assertion) {
        fail(message);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */
var PlatformSupport = /** @class */ (function () {
    function PlatformSupport() {
    }
    PlatformSupport.setPlatform = function (platform) {
        if (PlatformSupport.platform) {
            fail('Platform already defined');
        }
        PlatformSupport.platform = platform;
    };
    PlatformSupport.getPlatform = function () {
        if (!PlatformSupport.platform) {
            fail('Platform not set');
        }
        return PlatformSupport.platform;
    };
    return PlatformSupport;
}());
/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */
function emptyByteString() {
    return PlatformSupport.getPlatform().emptyByteString;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
var Code = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */
    OK: 'ok',
    /** The operation was cancelled (typically by the caller). */
    CANCELLED: 'cancelled',
    /** Unknown error or an error from a different error domain. */
    UNKNOWN: 'unknown',
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */
    INVALID_ARGUMENT: 'invalid-argument',
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    /** Some requested entity (e.g., file or directory) was not found. */
    NOT_FOUND: 'not-found',
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */
    ALREADY_EXISTS: 'already-exists',
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */
    PERMISSION_DENIED: 'permission-denied',
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */
    UNAUTHENTICATED: 'unauthenticated',
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */
    FAILED_PRECONDITION: 'failed-precondition',
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    ABORTED: 'aborted',
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */
    OUT_OF_RANGE: 'out-of-range',
    /** Operation is not implemented or not supported/enabled in this service. */
    UNIMPLEMENTED: 'unimplemented',
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */
    INTERNAL: 'internal',
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */
    UNAVAILABLE: 'unavailable',
    /** Unrecoverable data loss or corruption. */
    DATA_LOSS: 'data-loss'
};
/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */
var FirestoreError = /** @class */ (function (_super) {
    tslib_1.__extends(FirestoreError, _super);
    function FirestoreError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.message = message;
        _this.name = 'FirebaseError';
        // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function () { return _this.name + ": [code=" + _this.code + "]: " + _this.message; };
        return _this;
    }
    return FirestoreError;
}(Error));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */
function makeConstructorPrivate(cls, optionalMessage) {
    function PublicConstructor() {
        var error = 'This constructor is private.';
        if (optionalMessage) {
            error += ' ';
            error += optionalMessage;
        }
        throw new FirestoreError(Code.INVALID_ARGUMENT, error);
    }
    // Make sure instanceof checks work and all methods are exposed on the public
    // constructor
    PublicConstructor.prototype = cls.prototype;
    // Copy any static methods/members
    for (var staticProperty in cls) {
        if (cls.hasOwnProperty(staticProperty)) {
            PublicConstructor[staticProperty] = cls[staticProperty];
        }
    }
    return PublicConstructor;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/** Returns the given value if it's defined or the defaultValue otherwise. */
function defaulted(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
function forEachNumber(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var num = Number(key);
            if (!isNaN(num)) {
                fn(num, obj[key]);
            }
        }
    }
}
function values(obj) {
    var vs = [];
    forEach(obj, function (_, v) { return vs.push(v); });
    return vs;
}
function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
}
function isEmpty(obj) {
    assert(obj != null && typeof obj === 'object', 'isEmpty() expects object parameter.');
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function shallowCopy(obj) {
    assert(obj && typeof obj === 'object', 'shallowCopy() expects object parameter.');
    var result = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            result[key] = obj[key];
        }
    }
    return result;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Validates that no arguments were passed in the invocation of functionName.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateNoArgs('myFunction', arguments);
 */
function validateNoArgs(functionName, args) {
    if (args.length !== 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() does not support arguments, " +
            'but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */
function validateExactNumberOfArgs(functionName, args, numberOfArgs) {
    if (args.length !== numberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires " +
            formatPlural(numberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */
function validateAtLeastNumberOfArgs(functionName, args, minNumberOfArgs) {
    if (args.length < minNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires at least " +
            formatPlural(minNumberOfArgs, 'argument') +
            ', but was called with ' +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */
function validateBetweenNumberOfArgs(functionName, args, minNumberOfArgs, maxNumberOfArgs) {
    if (args.length < minNumberOfArgs || args.length > maxNumberOfArgs) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires between " + minNumberOfArgs + " and " +
            (maxNumberOfArgs + " arguments, but was called with ") +
            formatPlural(args.length, 'argument') +
            '.');
    }
}
/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */
function validateNamedArrayAtLeastNumberOfElements(functionName, value, name, minNumberOfElements) {
    if (!(value instanceof Array) || value.length < minNumberOfElements) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + name + " argument to be an " +
            'array with at least ' +
            (formatPlural(minNumberOfElements, 'element') + "."));
    }
}
/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */
function validateArgType(functionName, type, position, argument) {
    validateType(functionName, type, ordinal(position) + " argument", argument);
}
/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateOptionalArgType(functionName, type, position, argument) {
    if (argument !== undefined) {
        validateArgType(functionName, type, position, argument);
    }
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */
function validateNamedType(functionName, type, optionName, argument) {
    validateType(functionName, type, optionName + " option", argument);
}
/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */
function validateNamedOptionalType(functionName, type, optionName, argument) {
    if (argument !== undefined) {
        validateNamedType(functionName, type, optionName, argument);
    }
}
function validateArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (!(argument instanceof Array)) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + optionName + " " +
            ("option to be an array, but it was: " + valueDescription(argument)));
    }
    for (var i = 0; i < argument.length; ++i) {
        if (!validator(argument[i])) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires all " + optionName + " " +
                ("elements to be " + typeDescription + ", but the value at index " + i + " ") +
                ("was: " + valueDescription(argument[i])));
        }
    }
}
function validateOptionalArrayElements(functionName, optionName, typeDescription, argument, validator) {
    if (argument !== undefined) {
        validateArrayElements(functionName, optionName, typeDescription, argument, validator);
    }
}
/**
 * Validates that the provided named option equals one of the expected values.
 */
function validateNamedPropertyEquals(functionName, inputName, optionName, input, expected) {
    var expectedDescription = [];
    for (var _i = 0, expected_1 = expected; _i < expected_1.length; _i++) {
        var val = expected_1[_i];
        if (val === input) {
            return;
        }
        expectedDescription.push(valueDescription(val));
    }
    var actualDescription = valueDescription(input);
    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + actualDescription + " provided to function " + functionName + "() for option " +
        ("\"" + optionName + "\". Acceptable values: " + expectedDescription.join(', ')));
}
/**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */
function validateNamedOptionalPropertyEquals(functionName, inputName, optionName, input, expected) {
    if (input !== undefined) {
        validateNamedPropertyEquals(functionName, inputName, optionName, input, expected);
    }
}
/**
 * Validates that the provided argument is a valid enum.
 *
 * @param functionName Function making the validation call.
 * @param enums Array containing all possible values for the enum.
 * @param position Position of the argument in `functionName`.
 * @param argument Arugment to validate.
 */
function validateStringEnum(functionName, enums, position, argument) {
    if (!enums.some(function (element) { return element === argument; })) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid value " + valueDescription(argument) + " provided to function " +
            (functionName + "() for its " + ordinal(position) + " argument. Acceptable ") +
            ("values: " + enums.join(', ')));
    }
}
/** Helper to validate the type of a provided input. */
function validateType(functionName, type, inputName, input) {
    var valid = false;
    if (type === 'object') {
        valid = isPlainObject(input);
    }
    else if (type === 'non-empty string') {
        valid = typeof input === 'string' && input !== '';
    }
    else {
        valid = typeof input === type;
    }
    if (!valid) {
        var description = valueDescription(input);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + inputName + " " +
            ("to be of type " + type + ", but it was: " + description));
    }
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */
function isPlainObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        (Object.getPrototypeOf(input) === Object.prototype ||
            Object.getPrototypeOf(input) === null));
}
/** Returns a string describing the type / value of the provided input. */
function valueDescription(input) {
    if (input === undefined) {
        return 'undefined';
    }
    else if (input === null) {
        return 'null';
    }
    else if (typeof input === 'string') {
        if (input.length > 20) {
            input = input.substring(0, 20) + "...";
        }
        return JSON.stringify(input);
    }
    else if (typeof input === 'number' || typeof input === 'boolean') {
        return '' + input;
    }
    else if (typeof input === 'object') {
        if (input instanceof Array) {
            return 'an array';
        }
        else {
            var customObjectName = tryGetCustomObjectType(input);
            if (customObjectName) {
                return "a custom " + customObjectName + " object";
            }
            else {
                return 'an object';
            }
        }
    }
    else if (typeof input === 'function') {
        return 'a function';
    }
    else {
        return fail('Unknown wrong type: ' + typeof input);
    }
}
/** Hacky method to try to get the constructor name for an object. */
function tryGetCustomObjectType(input) {
    if (input.constructor) {
        var funcNameRegex = /function\s+([^\s(]+)\s*\(/;
        var results = funcNameRegex.exec(input.constructor.toString());
        if (results && results.length > 1) {
            return results[1];
        }
    }
    return null;
}
/** Validates the provided argument is defined. */
function validateDefined(functionName, position, argument) {
    if (argument === undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires a valid " + ordinal(position) + " " +
            "argument, but it was undefined.");
    }
}
/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */
function validateOptionNames(functionName, options, optionNames) {
    forEach(options, function (key, _) {
        if (optionNames.indexOf(key) < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Unknown option '" + key + "' passed to function " + functionName + "(). " +
                'Available options: ' +
                optionNames.join(', '));
        }
    });
}
/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */
function invalidClassError(functionName, type, position, argument) {
    var description = valueDescription(argument);
    return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + functionName + "() requires its " + ordinal(position) + " " +
        ("argument to be a " + type + ", but it was: " + description));
}
/** Converts a number to its english word representation */
function ordinal(num) {
    switch (num) {
        case 1:
            return 'first';
        case 2:
            return 'second';
        case 3:
            return 'third';
        default:
            return num + 'th';
    }
}
/**
 * Formats the given word as plural conditionally given the preceding number.
 */
function formatPlural(num, str) {
    return num + " " + str + (num === 1 ? '' : 's');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// tslint:disable-next-line:class-as-namespace
var AutoId = /** @class */ (function () {
    function AutoId() {
    }
    AutoId.newId = function () {
        // Alphanumeric characters
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var autoId = '';
        for (var i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        assert(autoId.length === 20, 'Invalid auto ID: ' + autoId);
        return autoId;
    };
    return AutoId;
}());
function primitiveComparator(left, right) {
    if (left < right)
        return -1;
    if (left > right)
        return 1;
    return 0;
}
/** Helper to compare nullable (or undefined-able) objects using isEqual(). */
function equals(left, right) {
    if (left !== null && left !== undefined) {
        return !!(right && left.isEqual(right));
    }
    else {
        // HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
        // smart enough.
        return left === right;
    }
}
/** Helper to compare arrays using isEqual(). */
function arrayEquals(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    for (var i = 0; i < left.length; i++) {
        if (!left[i].isEqual(right[i])) {
            return false;
        }
    }
    return true;
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */
function immediateSuccessor(s) {
    // Return the input string, with an additional NUL byte appended.
    return s + '\0';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Helper function to assert Uint8Array is available at runtime. */
function assertUint8ArrayAvailable() {
    if (typeof Uint8Array === 'undefined') {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Uint8Arrays are not available in this environment.');
    }
}
/** Helper function to assert Base64 functions are available at runtime. */
function assertBase64Available() {
    if (!PlatformSupport.getPlatform().base64Available) {
        throw new FirestoreError(Code.UNIMPLEMENTED, 'Blobs are unavailable in Firestore in this environment.');
    }
}
/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */
var Blob = /** @class */ (function () {
    function Blob(binaryString) {
        assertBase64Available();
        this._binaryString = binaryString;
    }
    Blob.fromBase64String = function (base64) {
        validateExactNumberOfArgs('Blob.fromBase64String', arguments, 1);
        validateArgType('Blob.fromBase64String', 'string', 1, base64);
        assertBase64Available();
        try {
            var binaryString = PlatformSupport.getPlatform().atob(base64);
            return new Blob(binaryString);
        }
        catch (e) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Failed to construct Blob from Base64 string: ' + e);
        }
    };
    Blob.fromUint8Array = function (array) {
        validateExactNumberOfArgs('Blob.fromUint8Array', arguments, 1);
        assertUint8ArrayAvailable();
        if (!(array instanceof Uint8Array)) {
            throw invalidClassError('Blob.fromUint8Array', 'Uint8Array', 1, array);
        }
        // We can't call array.map directly because it expects the return type to
        // be a Uint8Array, whereas we can convert it to a regular array by invoking
        // map on the Array prototype.
        var binaryString = Array.prototype.map
            .call(array, function (char) {
            return String.fromCharCode(char);
        })
            .join('');
        return new Blob(binaryString);
    };
    Blob.prototype.toBase64 = function () {
        validateExactNumberOfArgs('Blob.toBase64', arguments, 0);
        assertBase64Available();
        return PlatformSupport.getPlatform().btoa(this._binaryString);
    };
    Blob.prototype.toUint8Array = function () {
        validateExactNumberOfArgs('Blob.toUint8Array', arguments, 0);
        assertUint8ArrayAvailable();
        var buffer = new Uint8Array(this._binaryString.length);
        for (var i = 0; i < this._binaryString.length; i++) {
            buffer[i] = this._binaryString.charCodeAt(i);
        }
        return buffer;
    };
    Blob.prototype.toString = function () {
        return 'Blob(base64: ' + this.toBase64() + ')';
    };
    Blob.prototype.isEqual = function (other) {
        return this._binaryString === other._binaryString;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    Blob.prototype._compareTo = function (other) {
        return primitiveComparator(this._binaryString, other._binaryString);
    };
    return Blob;
}());
// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
// tslint:disable-next-line:variable-name We're treating this as a class name.
var PublicBlob = makeConstructorPrivate(Blob, 'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DatabaseInfo = /** @class */ (function () {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     * @param forceLongPolling Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     */
    function DatabaseInfo(databaseId, persistenceKey, host, ssl, forceLongPolling) {
        this.databaseId = databaseId;
        this.persistenceKey = persistenceKey;
        this.host = host;
        this.ssl = ssl;
        this.forceLongPolling = forceLongPolling;
    }
    return DatabaseInfo;
}());
/** The default database name for a project. */
var DEFAULT_DATABASE_NAME = '(default)';
/** Represents the database ID a Firestore client is associated with. */
var DatabaseId = /** @class */ (function () {
    function DatabaseId(projectId, database) {
        this.projectId = projectId;
        this.database = database ? database : DEFAULT_DATABASE_NAME;
    }
    Object.defineProperty(DatabaseId.prototype, "isDefaultDatabase", {
        get: function () {
            return this.database === DEFAULT_DATABASE_NAME;
        },
        enumerable: true,
        configurable: true
    });
    DatabaseId.prototype.isEqual = function (other) {
        return (other instanceof DatabaseId &&
            other.projectId === this.projectId &&
            other.database === this.database);
    };
    DatabaseId.prototype.compareTo = function (other) {
        return (primitiveComparator(this.projectId, other.projectId) ||
            primitiveComparator(this.database, other.database));
    };
    return DatabaseId;
}());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */
var ListenSequence = /** @class */ (function () {
    function ListenSequence(previousValue, sequenceNumberSyncer) {
        var _this = this;
        this.previousValue = previousValue;
        if (sequenceNumberSyncer) {
            sequenceNumberSyncer.sequenceNumberHandler = function (sequenceNumber) {
                return _this.setPreviousValue(sequenceNumber);
            };
            this.writeNewSequenceNumber = function (sequenceNumber) {
                return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);
            };
        }
    }
    ListenSequence.prototype.setPreviousValue = function (externalPreviousValue) {
        this.previousValue = Math.max(externalPreviousValue, this.previousValue);
        return this.previousValue;
    };
    ListenSequence.prototype.next = function () {
        var nextValue = ++this.previousValue;
        if (this.writeNewSequenceNumber) {
            this.writeNewSequenceNumber(nextValue);
        }
        return nextValue;
    };
    ListenSequence.INVALID = -1;
    return ListenSequence;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DOCUMENT_KEY_NAME = '__name__';
/**
 * Path represents an ordered sequence of string segments.
 */
var Path = /** @class */ (function () {
    function Path(segments, offset, length) {
        this.init(segments, offset, length);
    }
    /**
     * An initialization method that can be called from outside the constructor.
     * We need this so that we can have a non-static construct method that returns
     * the polymorphic `this` type.
     */
    Path.prototype.init = function (segments, offset, length) {
        if (offset === undefined) {
            offset = 0;
        }
        else if (offset > segments.length) {
            fail('offset ' + offset + ' out of range ' + segments.length);
        }
        if (length === undefined) {
            length = segments.length - offset;
        }
        else if (length > segments.length - offset) {
            fail('length ' + length + ' out of range ' + (segments.length - offset));
        }
        this.segments = segments;
        this.offset = offset;
        this.len = length;
    };
    /**
     * Constructs a new instance of Path using the same concrete type as `this`.
     * We need this instead of using the normal constructor, because polymorphic
     * `this` doesn't work on static methods.
     */
    Path.prototype.construct = function (segments, offset, length) {
        var path = Object.create(Object.getPrototypeOf(this));
        path.init(segments, offset, length);
        return path;
    };
    Object.defineProperty(Path.prototype, "length", {
        get: function () {
            return this.len;
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.isEqual = function (other) {
        return Path.comparator(this, other) === 0;
    };
    Path.prototype.child = function (nameOrPath) {
        var segments = this.segments.slice(this.offset, this.limit());
        if (nameOrPath instanceof Path) {
            nameOrPath.forEach(function (segment) {
                segments.push(segment);
            });
        }
        else if (typeof nameOrPath === 'string') {
            segments.push(nameOrPath);
        }
        else {
            fail('Unknown parameter type for Path.child(): ' + nameOrPath);
        }
        return this.construct(segments);
    };
    /** The index of one past the last segment of the path. */
    Path.prototype.limit = function () {
        return this.offset + this.length;
    };
    Path.prototype.popFirst = function (size) {
        size = size === undefined ? 1 : size;
        assert(this.length >= size, "Can't call popFirst() with less segments");
        return this.construct(this.segments, this.offset + size, this.length - size);
    };
    Path.prototype.popLast = function () {
        assert(!this.isEmpty(), "Can't call popLast() on empty path");
        return this.construct(this.segments, this.offset, this.length - 1);
    };
    Path.prototype.firstSegment = function () {
        assert(!this.isEmpty(), "Can't call firstSegment() on empty path");
        return this.segments[this.offset];
    };
    Path.prototype.lastSegment = function () {
        return this.get(this.length - 1);
    };
    Path.prototype.get = function (index) {
        assert(index < this.length, 'Index out of range');
        return this.segments[this.offset + index];
    };
    Path.prototype.isEmpty = function () {
        return this.length === 0;
    };
    Path.prototype.isPrefixOf = function (other) {
        if (other.length < this.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== other.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.isImmediateParentOf = function (potentialChild) {
        if (this.length + 1 !== potentialChild.length) {
            return false;
        }
        for (var i = 0; i < this.length; i++) {
            if (this.get(i) !== potentialChild.get(i)) {
                return false;
            }
        }
        return true;
    };
    Path.prototype.forEach = function (fn) {
        for (var i = this.offset, end = this.limit(); i < end; i++) {
            fn(this.segments[i]);
        }
    };
    Path.prototype.toArray = function () {
        return this.segments.slice(this.offset, this.limit());
    };
    Path.comparator = function (p1, p2) {
        var len = Math.min(p1.length, p2.length);
        for (var i = 0; i < len; i++) {
            var left = p1.get(i);
            var right = p2.get(i);
            if (left < right)
                return -1;
            if (left > right)
                return 1;
        }
        if (p1.length < p2.length)
            return -1;
        if (p1.length > p2.length)
            return 1;
        return 0;
    };
    return Path;
}());
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */
var ResourcePath = /** @class */ (function (_super) {
    tslib_1.__extends(ResourcePath, _super);
    function ResourcePath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourcePath.prototype.canonicalString = function () {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join('/');
    };
    ResourcePath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Creates a resource path from the given slash-delimited string.
     */
    ResourcePath.fromString = function (path) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        if (path.indexOf('//') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid path (" + path + "). Paths must not contain // in them.");
        }
        // We may still have an empty segment at the beginning or end if they had a
        // leading or trailing slash (which we allow).
        var segments = path.split('/').filter(function (segment) { return segment.length > 0; });
        return new ResourcePath(segments);
    };
    ResourcePath.EMPTY_PATH = new ResourcePath([]);
    return ResourcePath;
}(Path));
var identifierRegExp = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/** A dot-separated path for navigating sub-objects within a document. */
var FieldPath = /** @class */ (function (_super) {
    tslib_1.__extends(FieldPath, _super);
    function FieldPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */
    FieldPath.isValidIdentifier = function (segment) {
        return identifierRegExp.test(segment);
    };
    FieldPath.prototype.canonicalString = function () {
        return this.toArray()
            .map(function (str) {
            str = str.replace('\\', '\\\\').replace('`', '\\`');
            if (!FieldPath.isValidIdentifier(str)) {
                str = '`' + str + '`';
            }
            return str;
        })
            .join('.');
    };
    FieldPath.prototype.toString = function () {
        return this.canonicalString();
    };
    /**
     * Returns true if this field references the key of a document.
     */
    FieldPath.prototype.isKeyField = function () {
        return this.length === 1 && this.get(0) === DOCUMENT_KEY_NAME;
    };
    /**
     * The field designating the key of a document.
     */
    FieldPath.keyField = function () {
        return new FieldPath([DOCUMENT_KEY_NAME]);
    };
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */
    FieldPath.fromServerFormat = function (path) {
        var segments = [];
        var current = '';
        var i = 0;
        var addCurrentSegment = function () {
            if (current.length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, begin " +
                    "with '.', end with '.', or contain '..'");
            }
            segments.push(current);
            current = '';
        };
        var inBackticks = false;
        while (i < path.length) {
            var c = path[i];
            if (c === '\\') {
                if (i + 1 === path.length) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has trailing escape character: ' + path);
                }
                var next = path[i + 1];
                if (!(next === '\\' || next === '.' || next === '`')) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Path has invalid escape sequence: ' + path);
                }
                current += next;
                i += 2;
            }
            else if (c === '`') {
                inBackticks = !inBackticks;
                i++;
            }
            else if (c === '.' && !inBackticks) {
                addCurrentSegment();
                i++;
            }
            else {
                current += c;
                i++;
            }
        }
        addCurrentSegment();
        if (inBackticks) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Unterminated ` in path: ' + path);
        }
        return new FieldPath(segments);
    };
    FieldPath.EMPTY_PATH = new FieldPath([]);
    return FieldPath;
}(Path));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DocumentKey = /** @class */ (function () {
    function DocumentKey(path) {
        this.path = path;
        assert(DocumentKey.isDocumentKey(path), 'Invalid DocumentKey with an odd number of segments: ' +
            path.toArray().join('/'));
    }
    /** Returns true if the document is in the specified collectionId. */
    DocumentKey.prototype.hasCollectionId = function (collectionId) {
        return (this.path.length >= 2 &&
            this.path.get(this.path.length - 2) === collectionId);
    };
    DocumentKey.prototype.isEqual = function (other) {
        return (other !== null && ResourcePath.comparator(this.path, other.path) === 0);
    };
    DocumentKey.prototype.toString = function () {
        return this.path.toString();
    };
    DocumentKey.comparator = function (k1, k2) {
        return ResourcePath.comparator(k1.path, k2.path);
    };
    DocumentKey.isDocumentKey = function (path) {
        return path.length % 2 === 0;
    };
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromSegments = function (segments) {
        return new DocumentKey(new ResourcePath(segments.slice()));
    };
    /**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */
    DocumentKey.fromPathString = function (path) {
        return new DocumentKey(ResourcePath.fromString(path));
    };
    DocumentKey.EMPTY = new DocumentKey(new ResourcePath([]));
    return DocumentKey;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    return Deferred;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Wellknown "timer" IDs used when scheduling delayed operations on the
 * AsyncQueue. These IDs can then be used from tests to check for the presence
 * of operations or to run them early.
 *
 * The string values are used when encoding these timer IDs in JSON spec tests.
 */
var TimerId;
(function (TimerId) {
    /** All can be used with runDelayedOperationsEarly() to run all timers. */
    TimerId["All"] = "all";
    /**
     * The following 4 timers are used in persistent_stream.ts for the listen and
     * write streams. The "Idle" timer is used to close the stream due to
     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
     * the appropriate backoff delay has elapsed.
     */
    TimerId["ListenStreamIdle"] = "listen_stream_idle";
    TimerId["ListenStreamConnectionBackoff"] = "listen_stream_connection_backoff";
    TimerId["WriteStreamIdle"] = "write_stream_idle";
    TimerId["WriteStreamConnectionBackoff"] = "write_stream_connection_backoff";
    /**
     * A timer used in online_state_tracker.ts to transition from
     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
     * indefinitely for success or failure.
     */
    TimerId["OnlineStateTimeout"] = "online_state_timeout";
    /**
     * A timer used to update the client metadata in IndexedDb, which is used
     * to determine the primary leaseholder.
     */
    TimerId["ClientMetadataRefresh"] = "client_metadata_refresh";
    /** A timer used to periodically attempt LRU Garbage collection */
    TimerId["LruGarbageCollection"] = "lru_garbage_collection";
})(TimerId || (TimerId = {}));
/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 */
var DelayedOperation = /** @class */ (function () {
    function DelayedOperation(asyncQueue, timerId, targetTimeMs, op, removalCallback) {
        this.asyncQueue = asyncQueue;
        this.timerId = timerId;
        this.targetTimeMs = targetTimeMs;
        this.op = op;
        this.removalCallback = removalCallback;
        this.deferred = new Deferred();
        this.then = this.deferred.promise.then.bind(this.deferred.promise);
        this.catch = this.deferred.promise.catch.bind(this.deferred.promise);
        // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function (err) { });
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */
    DelayedOperation.createAndSchedule = function (asyncQueue, timerId, delayMs, op, removalCallback) {
        var targetTime = Date.now() + delayMs;
        var delayedOp = new DelayedOperation(asyncQueue, timerId, targetTime, op, removalCallback);
        delayedOp.start(delayMs);
        return delayedOp;
    };
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */
    DelayedOperation.prototype.start = function (delayMs) {
        var _this = this;
        this.timerHandle = setTimeout(function () { return _this.handleDelayElapsed(); }, delayMs);
    };
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */
    DelayedOperation.prototype.skipDelay = function () {
        return this.handleDelayElapsed();
    };
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */
    DelayedOperation.prototype.cancel = function (reason) {
        if (this.timerHandle !== null) {
            this.clearTimeout();
            this.deferred.reject(new FirestoreError(Code.CANCELLED, 'Operation cancelled' + (reason ? ': ' + reason : '')));
        }
    };
    DelayedOperation.prototype.handleDelayElapsed = function () {
        var _this = this;
        this.asyncQueue.enqueueAndForget(function () {
            if (_this.timerHandle !== null) {
                _this.clearTimeout();
                return _this.op().then(function (result) {
                    return _this.deferred.resolve(result);
                });
            }
            else {
                return Promise.resolve();
            }
        });
    };
    DelayedOperation.prototype.clearTimeout = function () {
        if (this.timerHandle !== null) {
            this.removalCallback(this);
            clearTimeout(this.timerHandle);
            this.timerHandle = null;
        }
    };
    return DelayedOperation;
}());
var AsyncQueue = /** @class */ (function () {
    function AsyncQueue() {
        // The last promise in the queue.
        this.tail = Promise.resolve();
        // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.delayedOperations = [];
        // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.operationInProgress = false;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */
    AsyncQueue.prototype.enqueueAndForget = function (op) {
        // tslint:disable-next-line:no-floating-promises
        this.enqueue(op);
    };
    /**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */
    AsyncQueue.prototype.enqueue = function (op) {
        var _this = this;
        this.verifyNotFailed();
        var newTail = this.tail.then(function () {
            _this.operationInProgress = true;
            return op()
                .catch(function (error$1) {
                _this.failure = error$1;
                _this.operationInProgress = false;
                var message = error$1.stack || error$1.message || '';
                error('INTERNAL UNHANDLED ERROR: ', message);
                // Escape the promise chain and throw the error globally so that
                // e.g. any global crash reporting library detects and reports it.
                // (but not for simulated errors in our tests since this breaks mocha)
                if (message.indexOf('Firestore Test Simulated Error') < 0) {
                    setTimeout(function () {
                        throw error$1;
                    }, 0);
                }
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw error$1;
            })
                .then(function (result) {
                _this.operationInProgress = false;
                return result;
            });
        });
        this.tail = newTail;
        return newTail;
    };
    /**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
     * the operation prior to its running.
     */
    AsyncQueue.prototype.enqueueAfterDelay = function (timerId, delayMs, op) {
        var _this = this;
        this.verifyNotFailed();
        assert(delayMs >= 0, "Attempted to schedule an operation with a negative delay of " + delayMs);
        // While not necessarily harmful, we currently don't expect to have multiple
        // ops with the same timer id in the queue, so defensively reject them.
        assert(!this.containsDelayedOperation(timerId), "Attempted to schedule multiple operations with timer id " + timerId + ".");
        var delayedOp = DelayedOperation.createAndSchedule(this, timerId, delayMs, op, function (op) { return _this.removeDelayedOperation(op); });
        this.delayedOperations.push(delayedOp);
        return delayedOp;
    };
    AsyncQueue.prototype.verifyNotFailed = function () {
        if (this.failure) {
            fail('AsyncQueue is already failed: ' +
                (this.failure.stack || this.failure.message));
        }
    };
    /**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */
    AsyncQueue.prototype.verifyOperationInProgress = function () {
        assert(this.operationInProgress, 'verifyOpInProgress() called when no op in progress on this queue.');
    };
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */
    AsyncQueue.prototype.drain = function () {
        return this.enqueue(function () { return Promise.resolve(); });
    };
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */
    AsyncQueue.prototype.containsDelayedOperation = function (timerId) {
        for (var _i = 0, _a = this.delayedOperations; _i < _a.length; _i++) {
            var op = _a[_i];
            if (op.timerId === timerId) {
                return true;
            }
        }
        return false;
    };
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
     *  all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */
    AsyncQueue.prototype.runDelayedOperationsEarly = function (lastTimerId) {
        var _this = this;
        // Note that draining may generate more delayed ops, so we do that first.
        return this.drain().then(function () {
            assert(lastTimerId === TimerId.All ||
                _this.containsDelayedOperation(lastTimerId), "Attempted to drain to missing operation " + lastTimerId);
            // Run ops in the same order they'd run if they ran naturally.
            _this.delayedOperations.sort(function (a, b) { return a.targetTimeMs - b.targetTimeMs; });
            for (var _i = 0, _a = _this.delayedOperations; _i < _a.length; _i++) {
                var op = _a[_i];
                op.skipDelay();
                if (lastTimerId !== TimerId.All && op.timerId === lastTimerId) {
                    break;
                }
            }
            return _this.drain();
        });
    };
    /** Called once a DelayedOperation is run or canceled. */
    AsyncQueue.prototype.removeDelayedOperation = function (op) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        var index = this.delayedOperations.indexOf(op);
        assert(index >= 0, 'Delayed operation not found.');
        this.delayedOperations.splice(index, 1);
    };
    return AsyncQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var escapeChar = '\u0001';
var encodedSeparatorChar = '\u0001';
var encodedNul = '\u0010';
var encodedEscape = '\u0011';
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */
function encode(path) {
    var result = '';
    for (var i = 0; i < path.length; i++) {
        if (result.length > 0) {
            result = encodeSeparator(result);
        }
        result = encodeSegment(path.get(i), result);
    }
    return encodeSeparator(result);
}
/** Encodes a single segment of a resource path into the given result */
function encodeSegment(segment, resultBuf) {
    var result = resultBuf;
    var length = segment.length;
    for (var i = 0; i < length; i++) {
        var c = segment.charAt(i);
        switch (c) {
            case '\0':
                result += escapeChar + encodedNul;
                break;
            case escapeChar:
                result += escapeChar + encodedEscape;
                break;
            default:
                result += c;
        }
    }
    return result;
}
/** Encodes a path separator into the given result */
function encodeSeparator(result) {
    return result + escapeChar + encodedSeparatorChar;
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */
function decode(path) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var length = path.length;
    assert(length >= 2, 'Invalid path ' + path);
    if (length === 2) {
        assert(path.charAt(0) === escapeChar && path.charAt(1) === encodedSeparatorChar, 'Non-empty path ' + path + ' had length 2');
        return ResourcePath.EMPTY_PATH;
    }
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var lastReasonableEscapeIndex = length - 2;
    var segments = [];
    var segmentBuilder = '';
    for (var start = 0; start < length;) {
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var end = path.indexOf(escapeChar, start);
        if (end < 0 || end > lastReasonableEscapeIndex) {
            fail('Invalid encoded resource path: "' + path + '"');
        }
        var next = path.charAt(end + 1);
        switch (next) {
            case encodedSeparatorChar:
                var currentPiece = path.substring(start, end);
                var segment = void 0;
                if (segmentBuilder.length === 0) {
                    // Avoid copying for the common case of a segment that excludes \0
                    // and \001
                    segment = currentPiece;
                }
                else {
                    segmentBuilder += currentPiece;
                    segment = segmentBuilder;
                    segmentBuilder = '';
                }
                segments.push(segment);
                break;
            case encodedNul:
                segmentBuilder += path.substring(start, end);
                segmentBuilder += '\0';
                break;
            case encodedEscape:
                // The escape character can be used in the output to encode itself.
                segmentBuilder += path.substring(start, end + 1);
                break;
            default:
                fail('Invalid encoded resource path: "' + path + '"');
        }
        start = end + 2;
    }
    return new ResourcePath(segments);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Timestamp = /** @class */ (function () {
    function Timestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
        if (nanoseconds < 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        if (nanoseconds >= 1e9) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp nanoseconds out of range: ' + nanoseconds);
        }
        // Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
        if (seconds < -62135596800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
        // This will break in the year 10,000.
        if (seconds >= 253402300800) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Timestamp seconds out of range: ' + seconds);
        }
    }
    Timestamp.now = function () {
        return Timestamp.fromMillis(Date.now());
    };
    Timestamp.fromDate = function (date) {
        return Timestamp.fromMillis(date.getTime());
    };
    Timestamp.fromMillis = function (milliseconds) {
        var seconds = Math.floor(milliseconds / 1000);
        var nanos = (milliseconds - seconds * 1000) * 1e6;
        return new Timestamp(seconds, nanos);
    };
    Timestamp.prototype.toDate = function () {
        return new Date(this.toMillis());
    };
    Timestamp.prototype.toMillis = function () {
        return this.seconds * 1000 + this.nanoseconds / 1e6;
    };
    Timestamp.prototype._compareTo = function (other) {
        if (this.seconds === other.seconds) {
            return primitiveComparator(this.nanoseconds, other.nanoseconds);
        }
        return primitiveComparator(this.seconds, other.seconds);
    };
    Timestamp.prototype.isEqual = function (other) {
        return (other.seconds === this.seconds && other.nanoseconds === this.nanoseconds);
    };
    Timestamp.prototype.toString = function () {
        return ('Timestamp(seconds=' +
            this.seconds +
            ', nanoseconds=' +
            this.nanoseconds +
            ')');
    };
    return Timestamp;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */
var SnapshotVersion = /** @class */ (function () {
    function SnapshotVersion(timestamp) {
        this.timestamp = timestamp;
    }
    // TODO(b/34176344): Once we no longer need to use the old alpha protos,
    // delete this constructor and use a timestamp-backed version everywhere.
    SnapshotVersion.fromMicroseconds = function (value) {
        var seconds = Math.floor(value / 1e6);
        var nanos = (value % 1e6) * 1e3;
        return new SnapshotVersion(new Timestamp(seconds, nanos));
    };
    SnapshotVersion.fromTimestamp = function (value) {
        return new SnapshotVersion(value);
    };
    SnapshotVersion.forDeletedDoc = function () {
        return SnapshotVersion.MIN;
    };
    SnapshotVersion.prototype.compareTo = function (other) {
        return this.timestamp._compareTo(other.timestamp);
    };
    SnapshotVersion.prototype.isEqual = function (other) {
        return this.timestamp.isEqual(other.timestamp);
    };
    /** Returns a number representation of the version for use in spec tests. */
    SnapshotVersion.prototype.toMicroseconds = function () {
        // Convert to microseconds.
        return this.timestamp.seconds * 1e6 + this.timestamp.nanoseconds / 1000;
    };
    SnapshotVersion.prototype.toString = function () {
        return 'SnapshotVersion(' + this.timestamp.toString() + ')';
    };
    SnapshotVersion.prototype.toTimestamp = function () {
        return this.timestamp;
    };
    SnapshotVersion.MIN = new SnapshotVersion(new Timestamp(0, 0));
    return SnapshotVersion;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap = /** @class */ (function () {
    function SortedMap(comparator, root) {
        this.comparator = comparator;
        this.root = root ? root : LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator, this.root
            .insert(key, value, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns a copy of the map, with the specified key removed.
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator, this.root
            .remove(key, this.comparator)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    // Returns the value of the node with the given key, or null.
    SortedMap.prototype.get = function (key) {
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    SortedMap.prototype.indexOf = function (key) {
        // Number of nodes that were pruned when descending right
        var prunedNodes = 0;
        var node = this.root;
        while (!node.isEmpty()) {
            var cmp = this.comparator(key, node.key);
            if (cmp === 0) {
                return prunedNodes + node.left.size;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else {
                // Count all nodes left of the node plus the node itself
                prunedNodes += node.left.size + 1;
                node = node.right;
            }
        }
        // Node not found
        return -1;
    };
    SortedMap.prototype.isEmpty = function () {
        return this.root.isEmpty();
    };
    Object.defineProperty(SortedMap.prototype, "size", {
        // Returns the total number of nodes in the map.
        get: function () {
            return this.root.size;
        },
        enumerable: true,
        configurable: true
    });
    // Returns the minimum key in the map.
    SortedMap.prototype.minKey = function () {
        return this.root.minKey();
    };
    // Returns the maximum key in the map.
    SortedMap.prototype.maxKey = function () {
        return this.root.maxKey();
    };
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root.inorderTraversal(action);
    };
    SortedMap.prototype.forEach = function (fn) {
        this.inorderTraversal(function (k, v) {
            fn(k, v);
            return false;
        });
    };
    SortedMap.prototype.toString = function () {
        var descriptions = [];
        this.inorderTraversal(function (k, v) {
            descriptions.push(k + ":" + v);
            return false;
        });
        return "{" + descriptions.join(', ') + "}";
    };
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root.reverseTraversal(action);
    };
    // Returns an iterator over the SortedMap.
    SortedMap.prototype.getIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, false);
    };
    SortedMap.prototype.getIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, false);
    };
    SortedMap.prototype.getReverseIterator = function () {
        return new SortedMapIterator(this.root, null, this.comparator, true);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key) {
        return new SortedMapIterator(this.root, key, this.comparator, true);
    };
    return SortedMap;
}()); // end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator = /** @class */ (function () {
    function SortedMapIterator(node, startKey, comparator, isReverse) {
        this.isReverse = isReverse;
        this.nodeStack = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move
                // to the next one
                this.nodeStack.push(node);
                if (this.isReverse) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        assert(this.nodeStack.length > 0, 'getNext() called on iterator when hasNext() is false.');
        var node = this.nodeStack.pop();
        var result = { key: node.key, value: node.value };
        if (this.isReverse) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack.length === 0)
            return null;
        var node = this.nodeStack[this.nodeStack.length - 1];
        return { key: node.key, value: node.value };
    };
    return SortedMapIterator;
}()); // end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode = /** @class */ (function () {
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left = left != null ? left : LLRBNode.EMPTY;
        this.right = right != null ? right : LLRBNode.EMPTY;
        this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    // Returns the minimum node in the tree.
    LLRBNode.prototype.min = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min();
        }
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.minKey = function () {
        return this.min().key;
    };
    // Returns the maximum key in the tree.
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    // Returns new tree, with the key/value added.
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var n = this;
        var cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.removeMin = function () {
        if (this.left.isEmpty()) {
            return LLRBNode.EMPTY;
        }
        var n = this;
        if (!n.left.isRed() && !n.left.left.isRed())
            n = n.moveRedLeft();
        n = n.copy(null, null, null, n.left.removeMin(), null);
        return n.fixUp();
    };
    // Returns new tree, with the specified item removed.
    LLRBNode.prototype.remove = function (key, comparator) {
        var smallest;
        var n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed() && !n.left.left.isRed()) {
                n = n.moveRedLeft();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed())
                n = n.rotateRight();
            if (!n.right.isEmpty() && !n.right.isRed() && !n.right.left.isRed()) {
                n = n.moveRedRight();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return LLRBNode.EMPTY;
                }
                else {
                    smallest = n.right.min();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp();
    };
    LLRBNode.prototype.isRed = function () {
        return this.color;
    };
    // Returns new tree after performing any needed rotations.
    LLRBNode.prototype.fixUp = function () {
        var n = this;
        if (n.right.isRed() && !n.left.isRed())
            n = n.rotateLeft();
        if (n.left.isRed() && n.left.left.isRed())
            n = n.rotateRight();
        if (n.left.isRed() && n.right.isRed())
            n = n.colorFlip();
        return n;
    };
    LLRBNode.prototype.moveRedLeft = function () {
        var n = this.colorFlip();
        if (n.right.left.isRed()) {
            n = n.copy(null, null, null, null, n.right.rotateRight());
            n = n.rotateLeft();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.moveRedRight = function () {
        var n = this.colorFlip();
        if (n.left.left.isRed()) {
            n = n.rotateRight();
            n = n.colorFlip();
        }
        return n;
    };
    LLRBNode.prototype.rotateLeft = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    LLRBNode.prototype.rotateRight = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    LLRBNode.prototype.colorFlip = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    // For testing.
    LLRBNode.prototype.checkMaxDepth = function () {
        var blackDepth = this.check();
        if (Math.pow(2.0, blackDepth) <= this.size + 1) {
            return true;
        }
        else {
            return false;
        }
    };
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    LLRBNode.prototype.check = function () {
        if (this.isRed() && this.left.isRed()) {
            throw fail('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed()) {
            throw fail('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        var blackDepth = this.left.check();
        if (blackDepth !== this.right.check()) {
            throw fail('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed() ? 0 : 1);
        }
    };
    // tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
    LLRBNode.EMPTY = null;
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}()); // end LLRBNode
// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
        this.size = 0;
    }
    // Returns a copy of the current node.
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    // Returns a copy of the tree, with the specified key/value added.
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value);
    };
    // Returns a copy of the tree, with the specified key removed.
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    LLRBEmptyNode.prototype.isRed = function () {
        return false;
    };
    // For testing.
    LLRBEmptyNode.prototype.checkMaxDepth = function () {
        return true;
    };
    LLRBEmptyNode.prototype.check = function () {
        return 0;
    };
    return LLRBEmptyNode;
}()); // end LLRBEmptyNode
LLRBNode.EMPTY = new LLRBEmptyNode();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */
var SortedSet = /** @class */ (function () {
    function SortedSet(comparator) {
        this.comparator = comparator;
        this.data = new SortedMap(this.comparator);
    }
    /**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */
    SortedSet.fromMapKeys = function (map) {
        var keys = new SortedSet(map.comparator);
        map.forEach(function (key) {
            keys = keys.add(key);
        });
        return keys;
    };
    SortedSet.prototype.has = function (elem) {
        return this.data.get(elem) !== null;
    };
    SortedSet.prototype.first = function () {
        return this.data.minKey();
    };
    SortedSet.prototype.last = function () {
        return this.data.maxKey();
    };
    Object.defineProperty(SortedSet.prototype, "size", {
        get: function () {
            return this.data.size;
        },
        enumerable: true,
        configurable: true
    });
    SortedSet.prototype.indexOf = function (elem) {
        return this.data.indexOf(elem);
    };
    /** Iterates elements in order defined by "comparator" */
    SortedSet.prototype.forEach = function (cb) {
        this.data.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */
    SortedSet.prototype.forEachInRange = function (range, cb) {
        var iter = this.data.getIteratorFrom(range[0]);
        while (iter.hasNext()) {
            var elem = iter.getNext();
            if (this.comparator(elem.key, range[1]) >= 0)
                return;
            cb(elem.key);
        }
    };
    /**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */
    SortedSet.prototype.forEachWhile = function (cb, start) {
        var iter;
        if (start !== undefined) {
            iter = this.data.getIteratorFrom(start);
        }
        else {
            iter = this.data.getIterator();
        }
        while (iter.hasNext()) {
            var elem = iter.getNext();
            var result = cb(elem.key);
            if (!result)
                return;
        }
    };
    /** Finds the least element greater than or equal to `elem`. */
    SortedSet.prototype.firstAfterOrEqual = function (elem) {
        var iter = this.data.getIteratorFrom(elem);
        return iter.hasNext() ? iter.getNext().key : null;
    };
    SortedSet.prototype.getIterator = function () {
        return new SortedSetIterator(this.data.getIterator());
    };
    SortedSet.prototype.getIteratorFrom = function (key) {
        return new SortedSetIterator(this.data.getIteratorFrom(key));
    };
    /** Inserts or updates an element */
    SortedSet.prototype.add = function (elem) {
        return this.copy(this.data.remove(elem).insert(elem, true));
    };
    /** Deletes an element */
    SortedSet.prototype.delete = function (elem) {
        if (!this.has(elem))
            return this;
        return this.copy(this.data.remove(elem));
    };
    SortedSet.prototype.isEmpty = function () {
        return this.data.isEmpty();
    };
    SortedSet.prototype.unionWith = function (other) {
        var result = this;
        other.forEach(function (elem) {
            result = result.add(elem);
        });
        return result;
    };
    SortedSet.prototype.isEqual = function (other) {
        if (!(other instanceof SortedSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.data.getIterator();
        var otherIt = other.data.getIterator();
        while (thisIt.hasNext()) {
            var thisElem = thisIt.getNext().key;
            var otherElem = otherIt.getNext().key;
            if (this.comparator(thisElem, otherElem) !== 0)
                return false;
        }
        return true;
    };
    SortedSet.prototype.toArray = function () {
        var res = [];
        this.forEach(function (targetId) {
            res.push(targetId);
        });
        return res;
    };
    SortedSet.prototype.toString = function () {
        var result = [];
        this.forEach(function (elem) { return result.push(elem); });
        return 'SortedSet(' + result.toString() + ')';
    };
    SortedSet.prototype.copy = function (data) {
        var result = new SortedSet(this.comparator);
        result.data = data;
        return result;
    };
    return SortedSet;
}());
var SortedSetIterator = /** @class */ (function () {
    function SortedSetIterator(iter) {
        this.iter = iter;
    }
    SortedSetIterator.prototype.getNext = function () {
        return this.iter.getNext().key;
    };
    SortedSetIterator.prototype.hasNext = function () {
        return this.iter.hasNext();
    };
    return SortedSetIterator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EMPTY_MAYBE_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function maybeDocumentMap() {
    return EMPTY_MAYBE_DOCUMENT_MAP;
}
function nullableMaybeDocumentMap() {
    return maybeDocumentMap();
}
var EMPTY_DOCUMENT_MAP = new SortedMap(DocumentKey.comparator);
function documentMap() {
    return EMPTY_DOCUMENT_MAP;
}
var EMPTY_DOCUMENT_VERSION_MAP = new SortedMap(DocumentKey.comparator);
function documentVersionMap() {
    return EMPTY_DOCUMENT_VERSION_MAP;
}
var EMPTY_DOCUMENT_KEY_SET = new SortedSet(DocumentKey.comparator);
function documentKeySet() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    var set = EMPTY_DOCUMENT_KEY_SET;
    for (var _a = 0, keys_1 = keys; _a < keys_1.length; _a++) {
        var key = keys_1[_a];
        set = set.add(key);
    }
    return set;
}
var EMPTY_TARGET_ID_SET = new SortedSet(primitiveComparator);
function targetIdSet() {
    return EMPTY_TARGET_ID_SET;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BATCHID_UNKNOWN = -1;
/**
 * A batch of mutations that will be sent as one unit to the backend.
 */
var MutationBatch = /** @class */ (function () {
    /**
     * @param batchId The unique ID of this mutation batch.
     * @param localWriteTime The original write time of this mutation.
     * @param baseMutations Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */
    function MutationBatch(batchId, localWriteTime, baseMutations, mutations) {
        this.batchId = batchId;
        this.localWriteTime = localWriteTime;
        this.baseMutations = baseMutations;
        this.mutations = mutations;
        assert(mutations.length > 0, 'Cannot create an empty mutation batch');
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */
    MutationBatch.prototype.applyToRemoteDocument = function (docKey, maybeDoc, batchResult) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToRemoteDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        var mutationResults = batchResult.mutationResults;
        assert(mutationResults.length === this.mutations.length, "Mismatch between mutations length\n      (" + this.mutations.length + ") and mutation results length\n      (" + mutationResults.length + ").");
        for (var i = 0; i < this.mutations.length; i++) {
            var mutation = this.mutations[i];
            if (mutation.key.isEqual(docKey)) {
                var mutationResult = mutationResults[i];
                maybeDoc = mutation.applyToRemoteDocument(maybeDoc, mutationResult);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */
    MutationBatch.prototype.applyToLocalView = function (docKey, maybeDoc) {
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(docKey), "applyToLocalDocument: key " + docKey + " should match maybeDoc key\n        " + maybeDoc.key);
        }
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (var _i = 0, _a = this.baseMutations; _i < _a.length; _i++) {
            var mutation = _a[_i];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, maybeDoc, this.localWriteTime);
            }
        }
        var baseDoc = maybeDoc;
        // Second, apply all user-provided mutations.
        for (var _b = 0, _c = this.mutations; _b < _c.length; _b++) {
            var mutation = _c[_b];
            if (mutation.key.isEqual(docKey)) {
                maybeDoc = mutation.applyToLocalView(maybeDoc, baseDoc, this.localWriteTime);
            }
        }
        return maybeDoc;
    };
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */
    MutationBatch.prototype.applyToLocalDocumentSet = function (maybeDocs) {
        var _this = this;
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        var mutatedDocuments = maybeDocs;
        this.mutations.forEach(function (m) {
            var mutatedDocument = _this.applyToLocalView(m.key, maybeDocs.get(m.key));
            if (mutatedDocument) {
                mutatedDocuments = mutatedDocuments.insert(m.key, mutatedDocument);
            }
        });
        return mutatedDocuments;
    };
    MutationBatch.prototype.keys = function () {
        return this.mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
    };
    MutationBatch.prototype.isEqual = function (other) {
        return (this.batchId === other.batchId &&
            arrayEquals(this.mutations, other.mutations) &&
            arrayEquals(this.baseMutations, other.baseMutations));
    };
    return MutationBatch;
}());
/** The result of applying a mutation batch to the backend. */
var MutationBatchResult = /** @class */ (function () {
    function MutationBatchResult(batch, commitVersion, mutationResults, streamToken, 
    /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */
    docVersions) {
        this.batch = batch;
        this.commitVersion = commitVersion;
        this.mutationResults = mutationResults;
        this.streamToken = streamToken;
        this.docVersions = docVersions;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */
    MutationBatchResult.from = function (batch, commitVersion, results, streamToken) {
        assert(batch.mutations.length === results.length, 'Mutations sent ' +
            batch.mutations.length +
            ' must equal results received ' +
            results.length);
        var versionMap = documentVersionMap();
        var mutations = batch.mutations;
        for (var i = 0; i < mutations.length; i++) {
            versionMap = versionMap.insert(mutations[i].key, results[i].version);
        }
        return new MutationBatchResult(batch, commitVersion, results, streamToken, versionMap);
    };
    return MutationBatchResult;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */
var PersistencePromise = /** @class */ (function () {
    function PersistencePromise(callback) {
        var _this = this;
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        // tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
        this.nextCallback = null;
        // tslint:disable-next-line:no-any Accept any result type for the error handler.
        this.catchCallback = null;
        // When the operation resolves, we'll set result or error and mark isDone.
        this.result = undefined;
        this.error = undefined;
        this.isDone = false;
        // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = false;
        callback(function (value) {
            _this.isDone = true;
            _this.result = value;
            if (_this.nextCallback) {
                // value should be defined unless T is Void, but we can't express
                // that in the type system.
                _this.nextCallback(value);
            }
        }, function (error) {
            _this.isDone = true;
            _this.error = error;
            if (_this.catchCallback) {
                _this.catchCallback(error);
            }
        });
    }
    PersistencePromise.prototype.catch = function (fn) {
        return this.next(undefined, fn);
    };
    PersistencePromise.prototype.next = function (nextFn, catchFn) {
        var _this = this;
        if (this.callbackAttached) {
            fail('Called next() or catch() twice for PersistencePromise');
        }
        this.callbackAttached = true;
        if (this.isDone) {
            if (!this.error) {
                return this.wrapSuccess(nextFn, this.result);
            }
            else {
                return this.wrapFailure(catchFn, this.error);
            }
        }
        else {
            return new PersistencePromise(function (resolve, reject) {
                _this.nextCallback = function (value) {
                    _this.wrapSuccess(nextFn, value).next(resolve, reject);
                };
                _this.catchCallback = function (error) {
                    _this.wrapFailure(catchFn, error).next(resolve, reject);
                };
            });
        }
    };
    PersistencePromise.prototype.toPromise = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.next(resolve, reject);
        });
    };
    PersistencePromise.prototype.wrapUserFunction = function (fn) {
        try {
            var result = fn();
            if (result instanceof PersistencePromise) {
                return result;
            }
            else {
                return PersistencePromise.resolve(result);
            }
        }
        catch (e) {
            return PersistencePromise.reject(e);
        }
    };
    PersistencePromise.prototype.wrapSuccess = function (nextFn, value) {
        if (nextFn) {
            return this.wrapUserFunction(function () { return nextFn(value); });
        }
        else {
            // If there's no nextFn, then R must be the same as T but we
            // can't express that in the type system.
            // tslint:disable-next-line:no-any
            return PersistencePromise.resolve(value);
        }
    };
    PersistencePromise.prototype.wrapFailure = function (catchFn, error) {
        if (catchFn) {
            return this.wrapUserFunction(function () { return catchFn(error); });
        }
        else {
            return PersistencePromise.reject(error);
        }
    };
    PersistencePromise.resolve = function (result) {
        return new PersistencePromise(function (resolve, reject) {
            resolve(result);
        });
    };
    PersistencePromise.reject = function (error) {
        return new PersistencePromise(function (resolve, reject) {
            reject(error);
        });
    };
    PersistencePromise.waitFor = function (
    // tslint:disable-next-line:no-any Accept all Promise types in waitFor().
    all) {
        return new PersistencePromise(function (resolve, reject) {
            var expectedCount = 0;
            var resolvedCount = 0;
            var done = false;
            all.forEach(function (element) {
                ++expectedCount;
                element.next(function () {
                    ++resolvedCount;
                    if (done && resolvedCount === expectedCount) {
                        resolve();
                    }
                }, function (err) { return reject(err); });
            });
            done = true;
            if (resolvedCount === expectedCount) {
                resolve();
            }
        });
    };
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */
    PersistencePromise.or = function (predicates) {
        var p = PersistencePromise.resolve(false);
        var _loop_1 = function (predicate) {
            p = p.next(function (isTrue) {
                if (isTrue) {
                    return PersistencePromise.resolve(isTrue);
                }
                else {
                    return predicate();
                }
            });
        };
        for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
            var predicate = predicates_1[_i];
            _loop_1(predicate);
        }
        return p;
    };
    /**
     * Given an iterable, call the given function on each element in the
     * collection and wait for all of the resulting concurrent PersistencePromises
     * to resolve.
     */
    PersistencePromise.forEach = function (collection, f) {
        var _this = this;
        var promises = [];
        collection.forEach(function (r, s) {
            promises.push(f.call(_this, r, s));
        });
        return this.waitFor(promises);
    };
    return PersistencePromise;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** A mutation queue for a specific user, backed by IndexedDB. */
var IndexedDbMutationQueue = /** @class */ (function () {
    function IndexedDbMutationQueue(
    /**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */
    userId, serializer, indexManager, referenceDelegate) {
        this.userId = userId;
        this.serializer = serializer;
        this.indexManager = indexManager;
        this.referenceDelegate = referenceDelegate;
        /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */
        // PORTING NOTE: Multi-tab only.
        this.documentKeysByBatchId = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */
    IndexedDbMutationQueue.forUser = function (user, serializer, indexManager, referenceDelegate) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        assert(user.uid !== '', 'UserID must not be an empty string.');
        var userId = user.isAuthenticated() ? user.uid : '';
        return new IndexedDbMutationQueue(userId, serializer, indexManager, referenceDelegate);
    };
    IndexedDbMutationQueue.prototype.checkEmpty = function (transaction) {
        var empty = true;
        var range = IDBKeyRange.bound([this.userId, Number.NEGATIVE_INFINITY], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, value, control) {
            empty = false;
            control.done();
        })
            .next(function () { return empty; });
    };
    IndexedDbMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) { return metadata.lastStreamToken; });
    };
    IndexedDbMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        return this.getMutationQueueMetadata(transaction).next(function (metadata) {
            metadata.lastStreamToken = convertStreamToken(streamToken);
            return mutationQueuesStore(transaction).put(metadata);
        });
    };
    IndexedDbMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
        var _this = this;
        var documentStore = documentMutationsStore(transaction);
        var mutationStore = mutationsStore(transaction);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // tslint:disable-next-line:no-any We write an empty object to obtain key
        return mutationStore.add({}).next(function (batchId) {
            assert(typeof batchId === 'number', 'Auto-generated key is not a number');
            var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
            var dbBatch = _this.serializer.toDbMutationBatch(_this.userId, batch);
            _this.documentKeysByBatchId[batchId] = batch.keys();
            var promises = [];
            for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                var mutation = mutations_1[_i];
                var indexKey = DbDocumentMutation.key(_this.userId, mutation.key.path, batchId);
                promises.push(mutationStore.put(dbBatch));
                promises.push(documentStore.put(indexKey, DbDocumentMutation.PLACEHOLDER));
                promises.push(_this.indexManager.addToCollectionParentIndex(transaction, mutation.key.path.popLast()));
            }
            return PersistencePromise.waitFor(promises).next(function () { return batch; });
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        var _this = this;
        return mutationsStore(transaction)
            .get(batchId)
            .next(function (dbBatch) {
            if (dbBatch) {
                assert(dbBatch.userId === _this.userId, "Unexpected user '" + dbBatch.userId + "' for mutation batch " + batchId);
                return _this.serializer.fromDbMutationBatch(dbBatch);
            }
            return null;
        });
    };
    IndexedDbMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var _this = this;
        if (this.documentKeysByBatchId[batchId]) {
            return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);
        }
        else {
            return this.lookupMutationBatch(transaction, batchId).next(function (batch) {
                if (batch) {
                    var keys = batch.keys();
                    _this.documentKeysByBatchId[batchId] = keys;
                    return keys;
                }
                else {
                    return null;
                }
            });
        }
    };
    IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var _this = this;
        var nextBatchId = batchId + 1;
        var range = IDBKeyRange.lowerBound([this.userId, nextBatchId]);
        var foundBatch = null;
        return mutationsStore(transaction)
            .iterate({ index: DbMutationBatch.userMutationsIndex, range: range }, function (key, dbBatch, control) {
            if (dbBatch.userId === _this.userId) {
                assert(dbBatch.batchId >= nextBatchId, 'Should have found mutation after ' + nextBatchId);
                foundBatch = _this.serializer.fromDbMutationBatch(dbBatch);
            }
            control.done();
        })
            .next(function () { return foundBatch; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        var _this = this;
        var range = IDBKeyRange.bound([this.userId, BATCHID_UNKNOWN], [this.userId, Number.POSITIVE_INFINITY]);
        return mutationsStore(transaction)
            .loadAll(DbMutationBatch.userMutationsIndex, range)
            .next(function (dbBatches) {
            return dbBatches.map(function (dbBatch) { return _this.serializer.fromDbMutationBatch(dbBatch); });
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, documentKey.path);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        var results = [];
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchId = indexKey[2];
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            var path = decode(encodedPath);
            if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                control.done();
                return;
            }
            // Look up the mutation batch in the store.
            return mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (!mutation) {
                    throw fail('Dangling document-mutation reference found: ' +
                        indexKey +
                        ' which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            });
        })
            .next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        var promises = [];
        documentKeys.forEach(function (documentKey) {
            var indexStart = DbDocumentMutation.prefixForPath(_this.userId, documentKey.path);
            var range = IDBKeyRange.lowerBound(indexStart);
            var promise = documentMutationsStore(transaction).iterate({ range: range }, function (indexKey, _, control) {
                var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                var path = decode(encodedPath);
                if (userID !== _this.userId || !documentKey.path.isEqual(path)) {
                    control.done();
                    return;
                }
                uniqueBatchIDs = uniqueBatchIDs.add(batchID);
            });
            promises.push(promise);
        });
        return PersistencePromise.waitFor(promises).next(function () {
            return _this.lookupMutationBatches(transaction, uniqueBatchIDs);
        });
    };
    IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isDocumentQuery(), "Document queries shouldn't go down this path");
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var queryPath = query.path;
        var immediateChildrenLength = queryPath.length + 1;
        // TODO(mcg): Actually implement a single-collection query
        //
        // This is actually executing an ancestor query, traversing the whole
        // subtree below the collection which can be horrifically inefficient for
        // some structures. The right way to solve this is to implement the full
        // value index, but that's not in the cards in the near future so this is
        // the best we can do for the moment.
        //
        // Since we don't yet index the actual properties in the mutations, our
        // current approach is to just return all mutation batches that affect
        // documents in the collection being queried.
        var indexPrefix = DbDocumentMutation.prefixForPath(this.userId, queryPath);
        var indexStart = IDBKeyRange.lowerBound(indexPrefix);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        return documentMutationsStore(transaction)
            .iterate({ range: indexStart }, function (indexKey, _, control) {
            var userID = indexKey[0], encodedPath = indexKey[1], batchID = indexKey[2];
            var path = decode(encodedPath);
            if (userID !== _this.userId || !queryPath.isPrefixOf(path)) {
                control.done();
                return;
            }
            // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            if (path.length !== immediateChildrenLength) {
                return;
            }
            uniqueBatchIDs = uniqueBatchIDs.add(batchID);
        })
            .next(function () { return _this.lookupMutationBatches(transaction, uniqueBatchIDs); });
    };
    IndexedDbMutationQueue.prototype.lookupMutationBatches = function (transaction, batchIDs) {
        var _this = this;
        var results = [];
        var promises = [];
        // TODO(rockwood): Implement this using iterate.
        batchIDs.forEach(function (batchId) {
            promises.push(mutationsStore(transaction)
                .get(batchId)
                .next(function (mutation) {
                if (mutation === null) {
                    throw fail('Dangling document-mutation reference found, ' +
                        'which points to ' +
                        batchId);
                }
                assert(mutation.userId === _this.userId, "Unexpected user '" + mutation.userId + "' for mutation batch " + batchId);
                results.push(_this.serializer.fromDbMutationBatch(mutation));
            }));
        });
        return PersistencePromise.waitFor(promises).next(function () { return results; });
    };
    IndexedDbMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        return removeMutationBatch(transaction.simpleDbTransaction, this.userId, batch).next(function (removedDocuments) {
            _this.removeCachedMutationKeys(batch.batchId);
            return PersistencePromise.forEach(removedDocuments, function (key) {
                return _this.referenceDelegate.removeMutationReference(transaction, key);
            });
        });
    };
    IndexedDbMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        delete this.documentKeysByBatchId[batchId];
    };
    IndexedDbMutationQueue.prototype.performConsistencyCheck = function (txn) {
        var _this = this;
        return this.checkEmpty(txn).next(function (empty) {
            if (!empty) {
                return PersistencePromise.resolve();
            }
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            var startRange = IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));
            var danglingMutationReferences = [];
            return documentMutationsStore(txn)
                .iterate({ range: startRange }, function (key, _, control) {
                var userID = key[0];
                if (userID !== _this.userId) {
                    control.done();
                    return;
                }
                else {
                    var path = decode(key[1]);
                    danglingMutationReferences.push(path);
                }
            })
                .next(function () {
                assert(danglingMutationReferences.length === 0, 'Document leak -- detected dangling mutation references when queue is empty. ' +
                    'Dangling keys: ' +
                    danglingMutationReferences.map(function (p) { return p.canonicalString(); }));
            });
        });
    };
    IndexedDbMutationQueue.prototype.containsKey = function (txn, key) {
        return mutationQueueContainsKey(txn, this.userId, key);
    };
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */
    IndexedDbMutationQueue.prototype.getMutationQueueMetadata = function (transaction) {
        var _this = this;
        return mutationQueuesStore(transaction)
            .get(this.userId)
            .next(function (metadata) {
            return (metadata ||
                new DbMutationQueue(_this.userId, BATCHID_UNKNOWN, 
                /*lastStreamToken=*/ ''));
        });
    };
    return IndexedDbMutationQueue;
}());
/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */
function mutationQueueContainsKey(txn, userId, key) {
    var indexKey = DbDocumentMutation.prefixForPath(userId, key.path);
    var encodedPath = indexKey[1];
    var startRange = IDBKeyRange.lowerBound(indexKey);
    var containsKey = false;
    return documentMutationsStore(txn)
        .iterate({ range: startRange, keysOnly: true }, function (key, value, control) {
        var userID = key[0], keyPath = key[1], /*batchID*/ _ = key[2];
        if (userID === userId && keyPath === encodedPath) {
            containsKey = true;
        }
        control.done();
    })
        .next(function () { return containsKey; });
}
/** Returns true if any mutation queue contains the given document. */
function mutationQueuesContainKey(txn, docKey) {
    var found = false;
    return mutationQueuesStore(txn)
        .iterateSerial(function (userId) {
        return mutationQueueContainsKey(txn, userId, docKey).next(function (containsKey) {
            if (containsKey) {
                found = true;
            }
            return PersistencePromise.resolve(!containsKey);
        });
    })
        .next(function () { return found; });
}
/**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */
function removeMutationBatch(txn, userId, batch) {
    var mutationStore = txn.store(DbMutationBatch.store);
    var indexTxn = txn.store(DbDocumentMutation.store);
    var promises = [];
    var range = IDBKeyRange.only(batch.batchId);
    var numDeleted = 0;
    var removePromise = mutationStore.iterate({ range: range }, function (key, value, control) {
        numDeleted++;
        return control.delete();
    });
    promises.push(removePromise.next(function () {
        assert(numDeleted === 1, 'Dangling document-mutation reference found: Missing batch ' +
            batch.batchId);
    }));
    var removedDocuments = [];
    for (var _i = 0, _a = batch.mutations; _i < _a.length; _i++) {
        var mutation = _a[_i];
        var indexKey = DbDocumentMutation.key(userId, mutation.key.path, batch.batchId);
        promises.push(indexTxn.delete(indexKey));
        removedDocuments.push(mutation.key);
    }
    return PersistencePromise.waitFor(promises).next(function () { return removedDocuments; });
}
function convertStreamToken(token) {
    if (token instanceof Uint8Array) {
        // TODO(b/78771403): Convert tokens to strings during deserialization
        assert(Object({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence.');
        return token.toString();
    }
    else {
        return token;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */
function mutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationBatch.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function documentMutationsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbDocumentMutation.store);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */
function mutationQueuesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbMutationQueue.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_BITS = 1;
var GeneratorIds;
(function (GeneratorIds) {
    GeneratorIds[GeneratorIds["QueryCache"] = 0] = "QueryCache";
    GeneratorIds[GeneratorIds["SyncEngine"] = 1] = "SyncEngine"; // The target IDs for limbo detection are odd (end in 1).
})(GeneratorIds || (GeneratorIds = {}));
/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the query cache (via
 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
 * two generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */
// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
// directly in SyncEngine and LocalStore.
var TargetIdGenerator = /** @class */ (function () {
    /**
     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
     * will use the seed value as the next target ID.
     */
    function TargetIdGenerator(generatorId, seed) {
        this.generatorId = generatorId;
        assert((generatorId & RESERVED_BITS) === generatorId, "Generator ID " + generatorId + " contains more than " + RESERVED_BITS + " reserved bits");
        this.seek(seed !== undefined ? seed : this.generatorId);
    }
    TargetIdGenerator.prototype.next = function () {
        var nextId = this.nextId;
        this.nextId += 1 << RESERVED_BITS;
        return nextId;
    };
    /**
     * Returns the ID that follows the given ID. Subsequent calls to `next()`
     * use the newly returned target ID as their base.
     */
    // PORTING NOTE: Multi-tab only.
    TargetIdGenerator.prototype.after = function (targetId) {
        this.seek(targetId + (1 << RESERVED_BITS));
        return this.next();
    };
    TargetIdGenerator.prototype.seek = function (targetId) {
        assert((targetId & RESERVED_BITS) === this.generatorId, 'Cannot supply target ID from different generator ID');
        this.nextId = targetId;
    };
    TargetIdGenerator.forQueryCache = function () {
        // We seed the query cache generator to return '2' as its first ID, as there
        // is no differentiation in the protocol layer between an unset number and
        // the number '0'. If we were to sent a target with target ID '0', the
        // backend would consider it unset and replace it with its own ID.
        var targetIdGenerator = new TargetIdGenerator(GeneratorIds.QueryCache, 2);
        return targetIdGenerator;
    };
    TargetIdGenerator.forSyncEngine = function () {
        // Sync engine assigns target IDs for limbo document detection.
        return new TargetIdGenerator(GeneratorIds.SyncEngine);
    };
    return TargetIdGenerator;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG = 'SimpleDb';
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */
var SimpleDb = /** @class */ (function () {
    function SimpleDb(db) {
        this.db = db;
        var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        if (iOSVersion === 12.2) {
            error('Firestore persistence suffers from a bug in iOS 12.2 ' +
                'Safari that may cause your app to stop working. See ' +
                'https://stackoverflow.com/q/56496296/110915 for details ' +
                'and a potential workaround.');
        }
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
     * mechanism, as only version-upgrade transactions are allowed to do things like create
     * objectstores.
     */
    SimpleDb.openOrCreate = function (name, version, schemaConverter) {
        assert(SimpleDb.isAvailable(), 'IndexedDB not supported in current environment.');
        debug(LOG_TAG, 'Opening database:', name);
        return new PersistencePromise(function (resolve, reject) {
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            var request = window.indexedDB.open(name, version);
            request.onsuccess = function (event) {
                var db = event.target.result;
                resolve(new SimpleDb(db));
            };
            request.onblocked = function () {
                reject(new FirestoreError(Code.FAILED_PRECONDITION, 'Cannot upgrade IndexedDB schema while another tab is open. ' +
                    'Close all tabs that access Firestore and reload this page to proceed.'));
            };
            request.onerror = function (event) {
                var error = event.target.error;
                if (error.name === 'VersionError') {
                    reject(new FirestoreError(Code.FAILED_PRECONDITION, 'A newer version of the Firestore SDK was previously used and so the persisted ' +
                        'data is not compatible with the version of the SDK you are now using. The SDK ' +
                        'will operate with persistence disabled. If you need persistence, please ' +
                        're-upgrade to a newer version of the SDK or else clear the persisted IndexedDB ' +
                        'data for your app to start fresh.'));
                }
                else {
                    reject(error);
                }
            };
            request.onupgradeneeded = function (event) {
                debug(LOG_TAG, 'Database "' + name + '" requires upgrade from version:', event.oldVersion);
                var db = event.target.result;
                // We are provided a version upgrade transaction from the request, so
                // we wrap that in a SimpleDbTransaction to allow use of our friendlier
                // API for schema migration operations.
                var txn = new SimpleDbTransaction(request.transaction);
                schemaConverter
                    .createOrUpgrade(db, txn, event.oldVersion, SCHEMA_VERSION)
                    .next(function () {
                    debug(LOG_TAG, 'Database upgrade to version ' + SCHEMA_VERSION + ' complete');
                });
            };
        }).toPromise();
    };
    /** Deletes the specified database. */
    SimpleDb.delete = function (name) {
        debug(LOG_TAG, 'Removing database:', name);
        return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();
    };
    /** Returns true if IndexedDB is available in the current environment. */
    SimpleDb.isAvailable = function () {
        if (typeof window === 'undefined' || window.indexedDB == null) {
            return false;
        }
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // If we are running in Node using the IndexedDBShim, `window` is defined,
        // but `window.navigator` is not. In this case, we support IndexedDB and
        // return `true`.
        if (window.navigator === undefined) {
            return Object({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES';
        }
        // Check the UA string to find out the browser.
        var ua = util.getUA();
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        var iOSVersion = SimpleDb.getIOSVersion(ua);
        var isUnsupportedIOS = 0 < iOSVersion && iOSVersion < 10;
        // Android browser: Disable for userse running version < 4.5.
        var androidVersion = SimpleDb.getAndroidVersion(ua);
        var isUnsupportedAndroid = 0 < androidVersion && androidVersion < 4.5;
        if (ua.indexOf('MSIE ') > 0 ||
            ua.indexOf('Trident/') > 0 ||
            ua.indexOf('Edge/') > 0 ||
            isUnsupportedIOS ||
            isUnsupportedAndroid) {
            return false;
        }
        else {
            return true;
        }
    };
    /** Helper to get a typed SimpleDbStore from a transaction. */
    SimpleDb.getStore = function (txn, store) {
        return txn.store(store);
    };
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */
    SimpleDb.getIOSVersion = function (ua) {
        var iOSVersionRegex = ua.match(/i(?:phone|pad|pod) os ([\d_]+)/i);
        var version = iOSVersionRegex
            ? iOSVersionRegex[1]
                .split('_')
                .slice(0, 2)
                .join('.')
            : '-1';
        return Number(version);
    };
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */
    SimpleDb.getAndroidVersion = function (ua) {
        var androidVersionRegex = ua.match(/Android ([\d.]+)/i);
        var version = androidVersionRegex
            ? androidVersionRegex[1]
                .split('.')
                .slice(0, 2)
                .join('.')
            : '-1';
        return Number(version);
    };
    SimpleDb.prototype.setVersionChangeListener = function (versionChangeListener) {
        this.db.onversionchange = function (event) {
            return versionChangeListener(event);
        };
    };
    SimpleDb.prototype.runTransaction = function (mode, objectStores, transactionFn) {
        var transaction = SimpleDbTransaction.open(this.db, mode, objectStores);
        var transactionFnResult = transactionFn(transaction)
            .catch(function (error) {
            // Abort the transaction if there was an error.
            transaction.abort(error);
            // We cannot actually recover, and calling `abort()` will cause the transaction's
            // completion promise to be rejected. This in turn means that we won't use
            // `transactionFnResult` below. We return a rejection here so that we don't add the
            // possibility of returning `void` to the type of `transactionFnResult`.
            return PersistencePromise.reject(error);
        })
            .toPromise();
        // As noted above, errors are propagated by aborting the transaction. So
        // we swallow any error here to avoid the browser logging it as unhandled.
        transactionFnResult.catch(function () { });
        // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
        // fire), but still return the original transactionFnResult back to the
        // caller.
        return transaction.completionPromise.then(function () { return transactionFnResult; });
    };
    SimpleDb.prototype.close = function () {
        this.db.close();
    };
    return SimpleDb;
}());
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */
var IterationController = /** @class */ (function () {
    function IterationController(dbCursor) {
        this.dbCursor = dbCursor;
        this.shouldStop = false;
        this.nextKey = null;
    }
    Object.defineProperty(IterationController.prototype, "isDone", {
        get: function () {
            return this.shouldStop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "skipToKey", {
        get: function () {
            return this.nextKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IterationController.prototype, "cursor", {
        set: function (value) {
            this.dbCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This function can be called to stop iteration at any point.
     */
    IterationController.prototype.done = function () {
        this.shouldStop = true;
    };
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */
    IterationController.prototype.skip = function (key) {
        this.nextKey = key;
    };
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */
    IterationController.prototype.delete = function () {
        return wrapRequest(this.dbCursor.delete());
    };
    return IterationController;
}());
/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */
var SimpleDbTransaction = /** @class */ (function () {
    function SimpleDbTransaction(transaction) {
        var _this = this;
        this.transaction = transaction;
        this.aborted = false;
        /**
         * A promise that resolves with the result of the IndexedDb transaction.
         */
        this.completionDeferred = new Deferred();
        this.transaction.oncomplete = function () {
            _this.completionDeferred.resolve();
        };
        this.transaction.onabort = function () {
            if (transaction.error) {
                _this.completionDeferred.reject(transaction.error);
            }
            else {
                _this.completionDeferred.resolve();
            }
        };
        this.transaction.onerror = function (event) {
            var error = checkForAndReportiOSError(event.target.error);
            _this.completionDeferred.reject(error);
        };
    }
    SimpleDbTransaction.open = function (db, mode, objectStoreNames) {
        return new SimpleDbTransaction(db.transaction(objectStoreNames, mode));
    };
    Object.defineProperty(SimpleDbTransaction.prototype, "completionPromise", {
        get: function () {
            return this.completionDeferred.promise;
        },
        enumerable: true,
        configurable: true
    });
    SimpleDbTransaction.prototype.abort = function (error) {
        if (error) {
            this.completionDeferred.reject(error);
        }
        if (!this.aborted) {
            debug(LOG_TAG, 'Aborting transaction:', error ? error.message : 'Client-initiated abort');
            this.aborted = true;
            this.transaction.abort();
        }
    };
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */
    SimpleDbTransaction.prototype.store = function (storeName) {
        var store = this.transaction.objectStore(storeName);
        assert(!!store, 'Object store not part of transaction: ' + storeName);
        return new SimpleDbStore(store);
    };
    return SimpleDbTransaction;
}());
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */
var SimpleDbStore = /** @class */ (function () {
    function SimpleDbStore(store) {
        this.store = store;
    }
    SimpleDbStore.prototype.put = function (keyOrValue, value) {
        var request;
        if (value !== undefined) {
            debug(LOG_TAG, 'PUT', this.store.name, keyOrValue, value);
            request = this.store.put(value, keyOrValue);
        }
        else {
            debug(LOG_TAG, 'PUT', this.store.name, '<auto-key>', keyOrValue);
            request = this.store.put(keyOrValue);
        }
        return wrapRequest(request);
    };
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */
    SimpleDbStore.prototype.add = function (value) {
        debug(LOG_TAG, 'ADD', this.store.name, value, value);
        var request = this.store.add(value);
        return wrapRequest(request);
    };
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */
    SimpleDbStore.prototype.get = function (key) {
        var _this = this;
        var request = this.store.get(key);
        // tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
        return wrapRequest(request).next(function (result) {
            // Normalize nonexistence to null.
            if (result === undefined) {
                result = null;
            }
            debug(LOG_TAG, 'GET', _this.store.name, key, result);
            return result;
        });
    };
    SimpleDbStore.prototype.delete = function (key) {
        debug(LOG_TAG, 'DELETE', this.store.name, key);
        var request = this.store.delete(key);
        return wrapRequest(request);
    };
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */
    SimpleDbStore.prototype.count = function () {
        debug(LOG_TAG, 'COUNT', this.store.name);
        var request = this.store.count();
        return wrapRequest(request);
    };
    SimpleDbStore.prototype.loadAll = function (indexOrRange, range) {
        var cursor = this.cursor(this.options(indexOrRange, range));
        var results = [];
        return this.iterateCursor(cursor, function (key, value) {
            results.push(value);
        }).next(function () {
            return results;
        });
    };
    SimpleDbStore.prototype.deleteAll = function (indexOrRange, range) {
        debug(LOG_TAG, 'DELETE ALL', this.store.name);
        var options = this.options(indexOrRange, range);
        options.keysOnly = false;
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, function (key, value, control) {
            // NOTE: Calling delete() on a cursor is documented as more efficient than
            // calling delete() on an object store with a single key
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
            // however, this requires us *not* to use a keysOnly cursor
            // (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
            // may want to compare the performance of each method.
            return control.delete();
        });
    };
    SimpleDbStore.prototype.iterate = function (optionsOrCallback, callback) {
        var options;
        if (!callback) {
            options = {};
            callback = optionsOrCallback;
        }
        else {
            options = optionsOrCallback;
        }
        var cursor = this.cursor(options);
        return this.iterateCursor(cursor, callback);
    };
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */
    SimpleDbStore.prototype.iterateSerial = function (callback) {
        var cursorRequest = this.cursor({});
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                var error = checkForAndReportiOSError(event.target.error);
                reject(error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                callback(cursor.primaryKey, cursor.value).next(function (shouldContinue) {
                    if (shouldContinue) {
                        cursor.continue();
                    }
                    else {
                        resolve();
                    }
                });
            };
        });
    };
    SimpleDbStore.prototype.iterateCursor = function (cursorRequest, fn) {
        var results = [];
        return new PersistencePromise(function (resolve, reject) {
            cursorRequest.onerror = function (event) {
                reject(event.target.error);
            };
            cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (!cursor) {
                    resolve();
                    return;
                }
                var controller = new IterationController(cursor);
                var userResult = fn(cursor.primaryKey, cursor.value, controller);
                if (userResult instanceof PersistencePromise) {
                    var userPromise = userResult.catch(function (err) {
                        controller.done();
                        return PersistencePromise.reject(err);
                    });
                    results.push(userPromise);
                }
                if (controller.isDone) {
                    resolve();
                }
                else if (controller.skipToKey === null) {
                    cursor.continue();
                }
                else {
                    cursor.continue(controller.skipToKey);
                }
            };
        }).next(function () {
            return PersistencePromise.waitFor(results);
        });
    };
    SimpleDbStore.prototype.options = function (indexOrRange, range) {
        var indexName = undefined;
        if (indexOrRange !== undefined) {
            if (typeof indexOrRange === 'string') {
                indexName = indexOrRange;
            }
            else {
                assert(range === undefined, '3rd argument must not be defined if 2nd is a range.');
                range = indexOrRange;
            }
        }
        return { index: indexName, range: range };
    };
    SimpleDbStore.prototype.cursor = function (options) {
        var direction = 'next';
        if (options.reverse) {
            direction = 'prev';
        }
        if (options.index) {
            var index = this.store.index(options.index);
            if (options.keysOnly) {
                return index.openKeyCursor(options.range, direction);
            }
            else {
                return index.openCursor(options.range, direction);
            }
        }
        else {
            return this.store.openCursor(options.range, direction);
        }
    };
    return SimpleDbStore;
}());
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */
function wrapRequest(request) {
    return new PersistencePromise(function (resolve, reject) {
        request.onsuccess = function (event) {
            var result = event.target.result;
            resolve(result);
        };
        request.onerror = function (event) {
            var error = checkForAndReportiOSError(event.target.error);
            reject(error);
        };
    });
}
// Guard so we only report the error once.
var reportedIOSError = false;
function checkForAndReportiOSError(error) {
    var iOSVersion = SimpleDb.getIOSVersion(util.getUA());
    if (iOSVersion >= 12.2 && iOSVersion < 13) {
        var IOS_ERROR = 'An internal error was encountered in the Indexed Database server';
        if (error.message.indexOf(IOS_ERROR) >= 0) {
            // Wrap error in a more descriptive one.
            var newError_1 = new FirestoreError('internal', "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + IOS_ERROR + "'. This is likely " +
                "due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 " +
                "for details and a potential workaround.");
            if (!reportedIOSError) {
                reportedIOSError = true;
                // Throw a global exception outside of this promise chain, for the user to
                // potentially catch.
                setTimeout(function () {
                    throw newError_1;
                }, 0);
            }
            return newError_1;
        }
    }
    return error;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IndexedDbQueryCache = /** @class */ (function () {
    function IndexedDbQueryCache(referenceDelegate, serializer) {
        this.referenceDelegate = referenceDelegate;
        this.serializer = serializer;
        // PORTING NOTE: We don't cache global metadata for the query cache, since
        // some of it (in particular `highestTargetId`) can be modified by secondary
        // tabs. We could perhaps be more granular (and e.g. still cache
        // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
        // to IndexedDb whenever we need to read metadata. We can revisit if it turns
        // out to have a meaningful performance impact.
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    IndexedDbQueryCache.prototype.allocateTargetId = function (transaction) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestTargetId = _this.targetIdGenerator.after(metadata.highestTargetId);
            return _this.saveMetadata(transaction, metadata).next(function () { return metadata.highestTargetId; });
        });
    };
    IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) {
            return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds, metadata.lastRemoteSnapshotVersion.nanoseconds));
        });
    };
    IndexedDbQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return getHighestListenSequenceNumber(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        var _this = this;
        return this.retrieveMetadata(transaction).next(function (metadata) {
            metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            if (lastRemoteSnapshotVersion) {
                metadata.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion.toTimestamp();
            }
            if (highestListenSequenceNumber > metadata.highestListenSequenceNumber) {
                metadata.highestListenSequenceNumber = highestListenSequenceNumber;
            }
            return _this.saveMetadata(transaction, metadata);
        });
    };
    IndexedDbQueryCache.prototype.addQueryData = function (transaction, queryData) {
        var _this = this;
        return this.saveQueryData(transaction, queryData).next(function () {
            return _this.retrieveMetadata(transaction).next(function (metadata) {
                metadata.targetCount += 1;
                _this.updateMetadataFromQueryData(queryData, metadata);
                return _this.saveMetadata(transaction, metadata);
            });
        });
    };
    IndexedDbQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        return this.saveQueryData(transaction, queryData);
    };
    IndexedDbQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        var _this = this;
        return this.removeMatchingKeysForTargetId(transaction, queryData.targetId)
            .next(function () { return targetsStore(transaction).delete(queryData.targetId); })
            .next(function () { return _this.retrieveMetadata(transaction); })
            .next(function (metadata) {
            assert(metadata.targetCount > 0, 'Removing from an empty query cache');
            metadata.targetCount -= 1;
            return _this.saveMetadata(transaction, metadata);
        });
    };
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */
    IndexedDbQueryCache.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var promises = [];
        return targetsStore(txn)
            .iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            if (queryData.sequenceNumber <= upperBound &&
                activeTargetIds[queryData.targetId] === undefined) {
                count++;
                promises.push(_this.removeQueryData(txn, queryData));
            }
        })
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () { return count; });
    };
    /**
     * Call provided function with each `QueryData` that we have cached.
     */
    IndexedDbQueryCache.prototype.forEachTarget = function (txn, f) {
        var _this = this;
        return targetsStore(txn).iterate(function (key, value) {
            var queryData = _this.serializer.fromDbTarget(value);
            f(queryData);
        });
    };
    IndexedDbQueryCache.prototype.retrieveMetadata = function (transaction) {
        return retrieveMetadata(transaction.simpleDbTransaction);
    };
    IndexedDbQueryCache.prototype.saveMetadata = function (transaction, metadata) {
        return globalTargetStore(transaction).put(DbTargetGlobal.key, metadata);
    };
    IndexedDbQueryCache.prototype.saveQueryData = function (transaction, queryData) {
        return targetsStore(transaction).put(this.serializer.toDbTarget(queryData));
    };
    /**
     * In-place updates the provided metadata to account for values in the given
     * QueryData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */
    IndexedDbQueryCache.prototype.updateMetadataFromQueryData = function (queryData, metadata) {
        var updated = false;
        if (queryData.targetId > metadata.highestTargetId) {
            metadata.highestTargetId = queryData.targetId;
            updated = true;
        }
        if (queryData.sequenceNumber > metadata.highestListenSequenceNumber) {
            metadata.highestListenSequenceNumber = queryData.sequenceNumber;
            updated = true;
        }
        return updated;
    };
    IndexedDbQueryCache.prototype.getQueryCount = function (transaction) {
        return this.retrieveMetadata(transaction).next(function (metadata) { return metadata.targetCount; });
    };
    IndexedDbQueryCache.prototype.getQueryData = function (transaction, query) {
        var _this = this;
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        var canonicalId = query.canonicalId();
        var range = IDBKeyRange.bound([canonicalId, Number.NEGATIVE_INFINITY], [canonicalId, Number.POSITIVE_INFINITY]);
        var result = null;
        return targetsStore(transaction)
            .iterate({ range: range, index: DbTarget.queryTargetsIndexName }, function (key, value, control) {
            var found = _this.serializer.fromDbTarget(value);
            // After finding a potential match, check that the query is
            // actually equal to the requested query.
            if (query.isEqual(found.query)) {
                result = found;
                control.done();
            }
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var promises = [];
        var store = documentTargetStore(txn);
        keys.forEach(function (key) {
            var path = encode(key.path);
            promises.push(store.put(new DbTargetDocument(targetId, path)));
            promises.push(_this.referenceDelegate.addReference(txn, key));
        });
        return PersistencePromise.waitFor(promises);
    };
    IndexedDbQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        var _this = this;
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        var store = documentTargetStore(txn);
        return PersistencePromise.forEach(keys, function (key) {
            var path = encode(key.path);
            return PersistencePromise.waitFor([
                store.delete([targetId, path]),
                _this.referenceDelegate.removeReference(txn, key)
            ]);
        });
    };
    IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        var store = documentTargetStore(txn);
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return store.delete(range);
    };
    IndexedDbQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var range = IDBKeyRange.bound([targetId], [targetId + 1], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var store = documentTargetStore(txn);
        var result = documentKeySet();
        return store
            .iterate({ range: range, keysOnly: true }, function (key, _, control) {
            var path = decode(key[1]);
            var docKey = new DocumentKey(path);
            result = result.add(docKey);
        })
            .next(function () { return result; });
    };
    IndexedDbQueryCache.prototype.containsKey = function (txn, key) {
        var path = encode(key.path);
        var range = IDBKeyRange.bound([path], [immediateSuccessor(path)], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        var count = 0;
        return documentTargetStore(txn)
            .iterate({
            index: DbTargetDocument.documentTargetsIndex,
            keysOnly: true,
            range: range
        }, function (_a, _, control) {
            var targetId = _a[0], path = _a[1];
            // Having a sentinel row for a document does not count as containing that document;
            // For the query cache, containing the document means the document is part of some
            // target.
            if (targetId !== 0) {
                count++;
                control.done();
            }
        })
            .next(function () { return count > 0; });
    };
    IndexedDbQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        var _this = this;
        return targetsStore(transaction)
            .get(targetId)
            .next(function (found) {
            if (found) {
                return _this.serializer.fromDbTarget(found);
            }
            else {
                return null;
            }
        });
    };
    return IndexedDbQueryCache;
}());
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */
function targetsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTarget.store);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */
function globalTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetGlobal.store);
}
function retrieveMetadata(txn) {
    var globalStore = SimpleDb.getStore(txn, DbTargetGlobal.store);
    return globalStore.get(DbTargetGlobal.key).next(function (metadata) {
        assert(metadata !== null, 'Missing metadata row.');
        return metadata;
    });
}
function getHighestListenSequenceNumber(txn) {
    return retrieveMetadata(txn).next(function (targetGlobal) { return targetGlobal.highestListenSequenceNumber; });
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */
function documentTargetStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbTargetDocument.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */
var MaybeDocument = /** @class */ (function () {
    function MaybeDocument(key, version) {
        this.key = key;
        this.version = version;
    }
    MaybeDocument.compareByKey = function (d1, d2) {
        return DocumentKey.comparator(d1.key, d2.key);
    };
    return MaybeDocument;
}());
/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */
var Document = /** @class */ (function (_super) {
    tslib_1.__extends(Document, _super);
    function Document(key, version, data, options, 
    /**
     * Memoized serialized form of the document for optimization purposes (avoids repeated
     * serialization). Might be undefined.
     */
    proto) {
        var _this = _super.call(this, key, version) || this;
        _this.data = data;
        _this.proto = proto;
        _this.hasLocalMutations = !!options.hasLocalMutations;
        _this.hasCommittedMutations = !!options.hasCommittedMutations;
        return _this;
    }
    Document.prototype.field = function (path) {
        return this.data.field(path);
    };
    Document.prototype.fieldValue = function (path) {
        var field = this.field(path);
        return field ? field.value() : undefined;
    };
    Document.prototype.value = function () {
        return this.data.value();
    };
    Document.prototype.isEqual = function (other) {
        return (other instanceof Document &&
            this.key.isEqual(other.key) &&
            this.version.isEqual(other.version) &&
            this.data.isEqual(other.data) &&
            this.hasLocalMutations === other.hasLocalMutations &&
            this.hasCommittedMutations === other.hasCommittedMutations);
    };
    Document.prototype.toString = function () {
        return ("Document(" + this.key + ", " + this.version + ", " + this.data.toString() + ", " +
            ("{hasLocalMutations: " + this.hasLocalMutations + "}), ") +
            ("{hasCommittedMutations: " + this.hasCommittedMutations + "})"));
    };
    Object.defineProperty(Document.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasLocalMutations || this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    Document.compareByField = function (field, d1, d2) {
        var v1 = d1.field(field);
        var v2 = d2.field(field);
        if (v1 !== undefined && v2 !== undefined) {
            return v1.compareTo(v2);
        }
        else {
            return fail("Trying to compare documents on fields that don't exist");
        }
    };
    return Document;
}(MaybeDocument));
/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */
var NoDocument = /** @class */ (function (_super) {
    tslib_1.__extends(NoDocument, _super);
    function NoDocument(key, version, options) {
        var _this = _super.call(this, key, version) || this;
        _this.hasCommittedMutations = !!(options && options.hasCommittedMutations);
        return _this;
    }
    NoDocument.prototype.toString = function () {
        return "NoDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(NoDocument.prototype, "hasPendingWrites", {
        get: function () {
            return this.hasCommittedMutations;
        },
        enumerable: true,
        configurable: true
    });
    NoDocument.prototype.isEqual = function (other) {
        return (other instanceof NoDocument &&
            other.hasCommittedMutations === this.hasCommittedMutations &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return NoDocument;
}(MaybeDocument));
/**
 * A class representing an existing document whose data is unknown (e.g. a
 * document that was updated without a known base document).
 */
var UnknownDocument = /** @class */ (function (_super) {
    tslib_1.__extends(UnknownDocument, _super);
    function UnknownDocument(key, version) {
        return _super.call(this, key, version) || this;
    }
    UnknownDocument.prototype.toString = function () {
        return "UnknownDocument(" + this.key + ", " + this.version + ")";
    };
    Object.defineProperty(UnknownDocument.prototype, "hasPendingWrites", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    UnknownDocument.prototype.isEqual = function (other) {
        return (other instanceof UnknownDocument &&
            other.version.isEqual(this.version) &&
            other.key.isEqual(this.key));
    };
    return UnknownDocument;
}(MaybeDocument));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */
var ObjectMap = /** @class */ (function () {
    function ObjectMap(mapKeyFn) {
        this.mapKeyFn = mapKeyFn;
        /**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */
        this.inner = {};
    }
    /** Get a value for this key, or undefined if it does not exist. */
    ObjectMap.prototype.get = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return undefined;
        }
        for (var _i = 0, matches_1 = matches; _i < matches_1.length; _i++) {
            var _a = matches_1[_i], otherKey = _a[0], value = _a[1];
            if (otherKey.isEqual(key)) {
                return value;
            }
        }
        return undefined;
    };
    ObjectMap.prototype.has = function (key) {
        return this.get(key) !== undefined;
    };
    /** Put this key and value in the map. */
    ObjectMap.prototype.set = function (key, value) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            this.inner[id] = [[key, value]];
            return;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                matches[i] = [key, value];
                return;
            }
        }
        matches.push([key, value]);
    };
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */
    ObjectMap.prototype.delete = function (key) {
        var id = this.mapKeyFn(key);
        var matches = this.inner[id];
        if (matches === undefined) {
            return false;
        }
        for (var i = 0; i < matches.length; i++) {
            if (matches[i][0].isEqual(key)) {
                if (matches.length === 1) {
                    delete this.inner[id];
                }
                else {
                    matches.splice(i, 1);
                }
                return true;
            }
        }
        return false;
    };
    ObjectMap.prototype.forEach = function (fn) {
        forEach(this.inner, function (_, entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                fn(k, v);
            }
        });
    };
    ObjectMap.prototype.isEmpty = function () {
        return isEmpty(this.inner);
    };
    return ObjectMap;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */
var RemoteDocumentChangeBuffer = /** @class */ (function () {
    function RemoteDocumentChangeBuffer() {
        this.changes = maybeDocumentMap();
        this.documentSizes = new ObjectMap(function (key) {
            return key.toString();
        });
    }
    /** Buffers a `RemoteDocumentCache.addEntry()` call. */
    RemoteDocumentChangeBuffer.prototype.addEntry = function (maybeDocument) {
        var changes = this.assertChanges();
        this.changes = changes.insert(maybeDocument.key, maybeDocument);
    };
    // NOTE: removeEntry() is intentionally omitted. If it needs to be added in
    // the future it must take byte counting into account.
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */
    RemoteDocumentChangeBuffer.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        var changes = this.assertChanges();
        var bufferedEntry = changes.get(documentKey);
        if (bufferedEntry) {
            return PersistencePromise.resolve(bufferedEntry);
        }
        else {
            // Record the size of everything we load from the cache so we can compute a delta later.
            return this.getFromCache(transaction, documentKey).next(function (getResult) {
                if (getResult === null) {
                    _this.documentSizes.set(documentKey, 0);
                    return null;
                }
                else {
                    _this.documentSizes.set(documentKey, getResult.size);
                    return getResult.maybeDocument;
                }
            });
        }
    };
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */
    RemoteDocumentChangeBuffer.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.getAllFromCache(transaction, documentKeys).next(function (_a) {
            var maybeDocuments = _a.maybeDocuments, sizeMap = _a.sizeMap;
            // Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `NullableMaybeDocumentMap` directly, without a conversion.
            sizeMap.forEach(function (documentKey, size) {
                _this.documentSizes.set(documentKey, size);
            });
            return maybeDocuments;
        });
    };
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */
    RemoteDocumentChangeBuffer.prototype.apply = function (transaction) {
        var result = this.applyChanges(transaction);
        // We should not buffer any more changes.
        this.changes = null;
        return result;
    };
    /** Helper to assert this.changes is not null and return it. */
    RemoteDocumentChangeBuffer.prototype.assertChanges = function () {
        assert(this.changes !== null, 'Changes have already been applied.');
        return this.changes;
    };
    return RemoteDocumentChangeBuffer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG = 'The remote document changelog no longer contains all changes for all ' +
    'local query views. It may be necessary to rebuild these views.';
var IndexedDbRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param {LocalSerializer} serializer The document serializer.
     * @param {IndexManager} indexManager The query indexes that need to be maintained.
     * @param keepDocumentChangeLog Whether to keep a document change log in
     * IndexedDb. This change log is required for Multi-Tab synchronization, but
     * not needed in clients that don't share access to their remote document
     * cache.
     */
    function IndexedDbRemoteDocumentCache(serializer, indexManager, keepDocumentChangeLog) {
        this.serializer = serializer;
        this.indexManager = indexManager;
        this.keepDocumentChangeLog = keepDocumentChangeLog;
        /** The last id read by `getNewDocumentChanges()`. */
        this._lastProcessedDocumentChangeId = 0;
    }
    Object.defineProperty(IndexedDbRemoteDocumentCache.prototype, "lastProcessedDocumentChangeId", {
        get: function () {
            return this._lastProcessedDocumentChangeId;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts up the remote document cache.
     *
     * Reads the ID of the last  document change from the documentChanges store.
     * Existing changes will not be returned as part of
     * `getNewDocumentChanges()`.
     */
    // PORTING NOTE: This is only used for multi-tab synchronization.
    IndexedDbRemoteDocumentCache.prototype.start = function (transaction) {
        var store = SimpleDb.getStore(transaction, DbRemoteDocumentChanges.store);
        return this.synchronizeLastDocumentChangeId(store);
    };
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    IndexedDbRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        var promises = [];
        if (entries.length > 0) {
            var documentStore = remoteDocumentsStore(transaction);
            var changedKeys = documentKeySet();
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], key = _a.key, doc = _a.doc;
                promises.push(documentStore.put(dbKey(key), doc));
                changedKeys = changedKeys.add(key);
                promises.push(this.indexManager.addToCollectionParentIndex(transaction, key.path.popLast()));
            }
            if (this.keepDocumentChangeLog) {
                promises.push(documentChangesStore(transaction).put({
                    changes: this.serializer.toDbResourcePaths(changedKeys)
                }));
            }
            promises.push(this.updateSize(transaction, sizeDelta));
        }
        return PersistencePromise.waitFor(promises);
    };
    /**
     * Removes a document from the cache. Note that this method does *not* do any
     * size accounting. It is the responsibility of the caller to count the bytes removed
     * and issue a final updateSize() call after removing documents.
     *
     * @param documentKey The key of the document to remove
     * @return The size of the document that was removed.
     */
    IndexedDbRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        // We don't need to keep changelog for these removals since `removeEntry` is
        // only used for garbage collection.
        var store = remoteDocumentsStore(transaction);
        var key = dbKey(documentKey);
        return store.get(key).next(function (document) {
            if (document) {
                return store.delete(key).next(function () { return dbDocumentSize(document); });
            }
            else {
                return PersistencePromise.resolve(0);
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? _this.serializer.fromDbRemoteDocument(dbRemoteDoc)
                : null;
        });
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        var _this = this;
        return remoteDocumentsStore(transaction)
            .get(dbKey(documentKey))
            .next(function (dbRemoteDoc) {
            return dbRemoteDoc
                ? {
                    maybeDocument: _this.serializer.fromDbRemoteDocument(dbRemoteDoc),
                    size: dbDocumentSize(dbRemoteDoc)
                }
                : null;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
            }
        }).next(function () { return results; });
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    IndexedDbRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        return this.forEachDbEntry(transaction, documentKeys, function (key, dbRemoteDoc) {
            if (dbRemoteDoc) {
                results = results.insert(key, _this.serializer.fromDbRemoteDocument(dbRemoteDoc));
                sizeMap = sizeMap.insert(key, dbDocumentSize(dbRemoteDoc));
            }
            else {
                results = results.insert(key, null);
                sizeMap = sizeMap.insert(key, 0);
            }
        }).next(function () {
            return { maybeDocuments: results, sizeMap: sizeMap };
        });
    };
    IndexedDbRemoteDocumentCache.prototype.forEachDbEntry = function (transaction, documentKeys, callback) {
        if (documentKeys.isEmpty()) {
            return PersistencePromise.resolve();
        }
        var range = IDBKeyRange.bound(documentKeys.first().path.toArray(), documentKeys.last().path.toArray());
        var keyIter = documentKeys.getIterator();
        var nextKey = keyIter.getNext();
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (potentialKeyRaw, dbRemoteDoc, control) {
            var potentialKey = DocumentKey.fromSegments(potentialKeyRaw);
            // Go through keys not found in cache.
            while (nextKey && DocumentKey.comparator(nextKey, potentialKey) < 0) {
                callback(nextKey, null);
                nextKey = keyIter.getNext();
            }
            if (nextKey && nextKey.isEqual(potentialKey)) {
                // Key found in cache.
                callback(nextKey, dbRemoteDoc);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
            // Skip to the next key (if there is one).
            if (nextKey) {
                control.skip(nextKey.path.toArray());
            }
            else {
                control.done();
            }
        })
            .next(function () {
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            while (nextKey) {
                callback(nextKey, null);
                nextKey = keyIter.hasNext() ? keyIter.getNext() : null;
            }
        });
    };
    IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        var _this = this;
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var results = documentMap();
        var immediateChildrenPathLength = query.path.length + 1;
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var startKey = query.path.toArray();
        var range = IDBKeyRange.lowerBound(startKey);
        return remoteDocumentsStore(transaction)
            .iterate({ range: range }, function (key, dbRemoteDoc, control) {
            // The query is actually returning any path that starts with the query
            // path prefix which may include documents in subcollections. For
            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
            // shouldn't match it. Fix this by discarding rows with document keys
            // more than one segment longer than the query path.
            if (key.length !== immediateChildrenPathLength) {
                return;
            }
            var maybeDoc = _this.serializer.fromDbRemoteDocument(dbRemoteDoc);
            if (!query.path.isPrefixOf(maybeDoc.key.path)) {
                control.done();
            }
            else if (maybeDoc instanceof Document && query.matches(maybeDoc)) {
                results = results.insert(maybeDoc.key, maybeDoc);
            }
        })
            .next(function () { return results; });
    };
    IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        assert(this.keepDocumentChangeLog, 'Can only call getNewDocumentChanges() when document change log is enabled');
        var changedKeys = documentKeySet();
        var changedDocs = maybeDocumentMap();
        var range = IDBKeyRange.lowerBound(this._lastProcessedDocumentChangeId + 1);
        var firstIteration = true;
        var changesStore = documentChangesStore(transaction);
        return changesStore
            .iterate({ range: range }, function (_, documentChange) {
            if (firstIteration) {
                firstIteration = false;
                // If our client was throttled for more than 30 minutes, another
                // client may have garbage collected the remote document changelog.
                if (_this._lastProcessedDocumentChangeId + 1 !== documentChange.id) {
                    // Reset the `lastProcessedDocumentChangeId` to allow further
                    // invocations to successfully return the changes after this
                    // rejection.
                    return _this.synchronizeLastDocumentChangeId(changesStore).next(function () {
                        return PersistencePromise.reject(new FirestoreError(Code.DATA_LOSS, REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG));
                    });
                }
            }
            changedKeys = changedKeys.unionWith(_this.serializer.fromDbResourcePaths(documentChange.changes));
            _this._lastProcessedDocumentChangeId = documentChange.id;
        })
            .next(function () {
            var documentPromises = [];
            changedKeys.forEach(function (key) {
                documentPromises.push(_this.getEntry(transaction, key).next(function (maybeDocument) {
                    var doc = maybeDocument ||
                        new NoDocument(key, SnapshotVersion.forDeletedDoc());
                    changedDocs = changedDocs.insert(key, doc);
                }));
            });
            return PersistencePromise.waitFor(documentPromises);
        })
            .next(function () { return changedDocs; });
    };
    /**
     * Removes all changes in the remote document changelog through `changeId`
     * (inclusive).
     */
    IndexedDbRemoteDocumentCache.prototype.removeDocumentChangesThroughChangeId = function (transaction, changeId) {
        var range = IDBKeyRange.upperBound(changeId);
        return documentChangesStore(transaction).delete(range);
    };
    IndexedDbRemoteDocumentCache.prototype.synchronizeLastDocumentChangeId = function (documentChangesStore) {
        var _this = this;
        // If there are no existing changes, we set `lastProcessedDocumentChangeId`
        // to 0 since IndexedDb's auto-generated keys start at 1.
        this._lastProcessedDocumentChangeId = 0;
        return documentChangesStore.iterate({ keysOnly: true, reverse: true }, function (key, value, control) {
            _this._lastProcessedDocumentChangeId = key;
            control.done();
        });
    };
    IndexedDbRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new IndexedDbRemoteDocumentChangeBuffer(this);
    };
    IndexedDbRemoteDocumentCache.prototype.getSize = function (txn) {
        return this.getMetadata(txn).next(function (metadata) { return metadata.byteSize; });
    };
    IndexedDbRemoteDocumentCache.prototype.getMetadata = function (txn) {
        return documentGlobalStore(txn)
            .get(DbRemoteDocumentGlobal.key)
            .next(function (metadata) {
            assert(!!metadata, 'Missing document cache metadata');
            return metadata;
        });
    };
    IndexedDbRemoteDocumentCache.prototype.setMetadata = function (txn, metadata) {
        return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key, metadata);
    };
    /**
     * Adds the given delta to the cached current size. Callers to removeEntry *must* call this
     * afterwards to update the size of the cache.
     *
     * @param sizeDelta
     */
    IndexedDbRemoteDocumentCache.prototype.updateSize = function (txn, sizeDelta) {
        var _this = this;
        return this.getMetadata(txn).next(function (metadata) {
            metadata.byteSize += sizeDelta;
            return _this.setMetadata(txn, metadata);
        });
    };
    return IndexedDbRemoteDocumentCache;
}());
function documentGlobalStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentGlobal.store);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache
 */
var IndexedDbRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbRemoteDocumentChangeBuffer, _super);
    function IndexedDbRemoteDocumentChangeBuffer(documentCache) {
        var _this = _super.call(this) || this;
        _this.documentCache = documentCache;
        return _this;
    }
    IndexedDbRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var toApply = [];
        changes.forEach(function (key, maybeDocument) {
            var doc = _this.documentCache.serializer.toDbRemoteDocument(maybeDocument);
            var previousSize = _this.documentSizes.get(key);
            // NOTE: if we ever decide we need to support doing writes without
            // reading first, this assert will need to change to do the read automatically.
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = dbDocumentSize(doc);
            delta += size - previousSize;
            toApply.push({ key: key, doc: doc });
        });
        return this.documentCache.addEntries(transaction, toApply, delta);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    IndexedDbRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return IndexedDbRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));
function isDocumentChangeMissingError(err) {
    return (err.code === Code.DATA_LOSS &&
        err.message === REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */
function remoteDocumentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocument.store);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocumentChanges object
 * store.
 */
function documentChangesStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbRemoteDocumentChanges.store);
}
function dbKey(docKey) {
    return docKey.path.toArray();
}
/**
 * Retrusn an approximate size for the given document.
 */
function dbDocumentSize(doc) {
    var value;
    if (doc.document) {
        value = doc.document;
    }
    else if (doc.unknownDocument) {
        value = doc.unknownDocument;
    }
    else if (doc.noDocument) {
        value = doc.noDocument;
    }
    else {
        throw fail('Unknown remote document type');
    }
    return JSON.stringify(value).length;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An in-memory implementation of IndexManager.
 */
var MemoryIndexManager = /** @class */ (function () {
    function MemoryIndexManager() {
        this.collectionParentIndex = new MemoryCollectionParentIndex();
    }
    MemoryIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
        this.collectionParentIndex.add(collectionPath);
        return PersistencePromise.resolve();
    };
    MemoryIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
        return PersistencePromise.resolve(this.collectionParentIndex.getEntries(collectionId));
    };
    return MemoryIndexManager;
}());
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */
var MemoryCollectionParentIndex = /** @class */ (function () {
    function MemoryCollectionParentIndex() {
        this.index = {};
    }
    // Returns false if the entry already existed.
    MemoryCollectionParentIndex.prototype.add = function (collectionPath) {
        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
        var collectionId = collectionPath.lastSegment();
        var parentPath = collectionPath.popLast();
        var existingParents = this.index[collectionId] ||
            new SortedSet(ResourcePath.comparator);
        var added = !existingParents.has(parentPath);
        this.index[collectionId] = existingParents.add(parentPath);
        return added;
    };
    MemoryCollectionParentIndex.prototype.getEntries = function (collectionId) {
        var parentPaths = this.index[collectionId] ||
            new SortedSet(ResourcePath.comparator);
        return parentPaths.toArray();
    };
    return MemoryCollectionParentIndex;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Schema Version for the Web client:
 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
 *    Cache
 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
 *    longer required because migration 3 unconditionally clears it.
 * 3. Dropped and re-created Query Cache to deal with cache corruption related
 *    to limbo resolution. Addresses
 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4. Multi-Tab Support.
 * 5. Removal of held write acks.
 * 6. Create document global for tracking document cache size.
 * 7. Ensure every cached document has a sentinel row with a sequence number.
 * 8. Add collection-parent index for Collection Group queries.
 */
var SCHEMA_VERSION = 8;
/** Performs database creation and schema upgrades. */
var SchemaConverter = /** @class */ (function () {
    function SchemaConverter(serializer) {
        this.serializer = serializer;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */
    SchemaConverter.prototype.createOrUpgrade = function (db, txn, fromVersion, toVersion) {
        var _this = this;
        assert(fromVersion < toVersion &&
            fromVersion >= 0 &&
            toVersion <= SCHEMA_VERSION, "Unexpected schema upgrade from v" + fromVersion + " to v{toVersion}.");
        if (fromVersion < 1 && toVersion >= 1) {
            createPrimaryClientStore(db);
            createMutationQueue(db);
            createQueryCache(db);
            createRemoteDocumentCache(db);
        }
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        var p = PersistencePromise.resolve();
        if (fromVersion < 3 && toVersion >= 3) {
            // Brand new clients don't need to drop and recreate--only clients that
            // potentially have corrupt data.
            if (fromVersion !== 0) {
                dropQueryCache(db);
                createQueryCache(db);
            }
            p = p.next(function () { return writeEmptyTargetGlobalEntry(txn); });
        }
        if (fromVersion < 4 && toVersion >= 4) {
            if (fromVersion !== 0) {
                // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                p = p.next(function () { return upgradeMutationBatchSchemaAndMigrateData(db, txn); });
            }
            p = p.next(function () {
                createClientMetadataStore(db);
                createRemoteDocumentChangesStore(db);
            });
        }
        if (fromVersion < 5 && toVersion >= 5) {
            p = p.next(function () { return _this.removeAcknowledgedMutations(txn); });
        }
        if (fromVersion < 6 && toVersion >= 6) {
            p = p.next(function () {
                createDocumentGlobalStore(db);
                return _this.addDocumentGlobal(txn);
            });
        }
        if (fromVersion < 7 && toVersion >= 7) {
            p = p.next(function () { return _this.ensureSequenceNumbers(txn); });
        }
        if (fromVersion < 8 && toVersion >= 8) {
            p = p.next(function () { return _this.createCollectionParentIndex(db, txn); });
        }
        return p;
    };
    SchemaConverter.prototype.addDocumentGlobal = function (txn) {
        var byteCount = 0;
        return txn
            .store(DbRemoteDocument.store)
            .iterate(function (_, doc) {
            byteCount += dbDocumentSize(doc);
        })
            .next(function () {
            var metadata = new DbRemoteDocumentGlobal(byteCount);
            return txn
                .store(DbRemoteDocumentGlobal.store)
                .put(DbRemoteDocumentGlobal.key, metadata);
        });
    };
    SchemaConverter.prototype.removeAcknowledgedMutations = function (txn) {
        var _this = this;
        var queuesStore = txn.store(DbMutationQueue.store);
        var mutationsStore = txn.store(DbMutationBatch.store);
        return queuesStore.loadAll().next(function (queues) {
            return PersistencePromise.forEach(queues, function (queue) {
                var range = IDBKeyRange.bound([queue.userId, BATCHID_UNKNOWN], [queue.userId, queue.lastAcknowledgedBatchId]);
                return mutationsStore
                    .loadAll(DbMutationBatch.userMutationsIndex, range)
                    .next(function (dbBatches) {
                    return PersistencePromise.forEach(dbBatches, function (dbBatch) {
                        assert(dbBatch.userId === queue.userId, "Cannot process batch " + dbBatch.batchId + " from unexpected user");
                        var batch = _this.serializer.fromDbMutationBatch(dbBatch);
                        return removeMutationBatch(txn, queue.userId, batch).next(function () { });
                    });
                });
            });
        });
    };
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */
    SchemaConverter.prototype.ensureSequenceNumbers = function (txn) {
        var documentTargetStore = txn.store(DbTargetDocument.store);
        var documentsStore = txn.store(DbRemoteDocument.store);
        return getHighestListenSequenceNumber(txn).next(function (currentSequenceNumber) {
            var writeSentinelKey = function (path) {
                return documentTargetStore.put(new DbTargetDocument(0, encode(path), currentSequenceNumber));
            };
            var promises = [];
            return documentsStore
                .iterate(function (key, doc) {
                var path = new ResourcePath(key);
                var docSentinelKey = sentinelKey(path);
                promises.push(documentTargetStore.get(docSentinelKey).next(function (maybeSentinel) {
                    if (!maybeSentinel) {
                        return writeSentinelKey(path);
                    }
                    else {
                        return PersistencePromise.resolve();
                    }
                }));
            })
                .next(function () { return PersistencePromise.waitFor(promises); });
        });
    };
    SchemaConverter.prototype.createCollectionParentIndex = function (db, txn) {
        // Create the index.
        db.createObjectStore(DbCollectionParent.store, {
            keyPath: DbCollectionParent.keyPath
        });
        var collectionParentsStore = txn.store(DbCollectionParent.store);
        // Helper to add an index entry iff we haven't already written it.
        var cache = new MemoryCollectionParentIndex();
        var addEntry = function (collectionPath) {
            if (cache.add(collectionPath)) {
                var collectionId = collectionPath.lastSegment();
                var parentPath = collectionPath.popLast();
                return collectionParentsStore.put({
                    collectionId: collectionId,
                    parent: encode(parentPath)
                });
            }
        };
        // Index existing remote documents.
        return txn
            .store(DbRemoteDocument.store)
            .iterate({ keysOnly: true }, function (pathSegments, _) {
            var path = new ResourcePath(pathSegments);
            return addEntry(path.popLast());
        })
            .next(function () {
            // Index existing mutations.
            return txn
                .store(DbDocumentMutation.store)
                .iterate({ keysOnly: true }, function (_a, _) {
                var userID = _a[0], encodedPath = _a[1], batchId = _a[2];
                var path = decode(encodedPath);
                return addEntry(path.popLast());
            });
        });
    };
    return SchemaConverter;
}());
function sentinelKey(path) {
    return [0, encode(path)];
}
/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */
var DbTimestamp = /** @class */ (function () {
    function DbTimestamp(seconds, nanoseconds) {
        this.seconds = seconds;
        this.nanoseconds = nanoseconds;
    }
    return DbTimestamp;
}());
/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */
var DbPrimaryClient = /** @class */ (function () {
    function DbPrimaryClient(ownerId, 
    /** Whether to allow shared access from multiple tabs. */
    allowTabSynchronization, leaseTimestampMs) {
        this.ownerId = ownerId;
        this.allowTabSynchronization = allowTabSynchronization;
        this.leaseTimestampMs = leaseTimestampMs;
    }
    /**
     * Name of the IndexedDb object store.
     *
     * Note that the name 'owner' is chosen to ensure backwards compatibility with
     * older clients that only supported single locked access to the persistence
     * layer.
     */
    DbPrimaryClient.store = 'owner';
    /**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */
    DbPrimaryClient.key = 'owner';
    return DbPrimaryClient;
}());
function createPrimaryClientStore(db) {
    db.createObjectStore(DbPrimaryClient.store);
}
/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */
var DbMutationQueue = /** @class */ (function () {
    function DbMutationQueue(
    /**
     * The normalized user ID to which this queue belongs.
     */
    userId, 
    /**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */
    lastAcknowledgedBatchId, 
    /**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */
    lastStreamToken) {
        this.userId = userId;
        this.lastAcknowledgedBatchId = lastAcknowledgedBatchId;
        this.lastStreamToken = lastStreamToken;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationQueue.store = 'mutationQueues';
    /** Keys are automatically assigned via the userId property. */
    DbMutationQueue.keyPath = 'userId';
    return DbMutationQueue;
}());
/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */
var DbMutationBatch = /** @class */ (function () {
    function DbMutationBatch(
    /**
     * The normalized user ID to which this batch belongs.
     */
    userId, 
    /**
     * An identifier for this batch, allocated using an auto-generated key.
     */
    batchId, 
    /**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */
    localWriteTimeMs, 
    /**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */
    baseMutations, 
    /**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */
    mutations) {
        this.userId = userId;
        this.batchId = batchId;
        this.localWriteTimeMs = localWriteTimeMs;
        this.baseMutations = baseMutations;
        this.mutations = mutations;
    }
    /** Name of the IndexedDb object store.  */
    DbMutationBatch.store = 'mutations';
    /** Keys are automatically assigned via the userId, batchId properties. */
    DbMutationBatch.keyPath = 'batchId';
    /** The index name for lookup of mutations by user. */
    DbMutationBatch.userMutationsIndex = 'userMutationsIndex';
    /** The user mutations index is keyed by [userId, batchId] pairs. */
    DbMutationBatch.userMutationsKeyPath = ['userId', 'batchId'];
    return DbMutationBatch;
}());
function createMutationQueue(db) {
    db.createObjectStore(DbMutationQueue.store, {
        keyPath: DbMutationQueue.keyPath
    });
    var mutationBatchesStore = db.createObjectStore(DbMutationBatch.store, {
        keyPath: DbMutationBatch.keyPath,
        autoIncrement: true
    });
    mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
    db.createObjectStore(DbDocumentMutation.store);
}
/**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */
function upgradeMutationBatchSchemaAndMigrateData(db, txn) {
    var v1MutationsStore = txn.store(DbMutationBatch.store);
    return v1MutationsStore.loadAll().next(function (existingMutations) {
        db.deleteObjectStore(DbMutationBatch.store);
        var mutationsStore = db.createObjectStore(DbMutationBatch.store, {
            keyPath: DbMutationBatch.keyPath,
            autoIncrement: true
        });
        mutationsStore.createIndex(DbMutationBatch.userMutationsIndex, DbMutationBatch.userMutationsKeyPath, { unique: true });
        var v3MutationsStore = txn.store(DbMutationBatch.store);
        var writeAll = existingMutations.map(function (mutation) {
            return v3MutationsStore.put(mutation);
        });
        return PersistencePromise.waitFor(writeAll);
    });
}
/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */
var DbDocumentMutation = /** @class */ (function () {
    function DbDocumentMutation() {
    }
    /**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */
    DbDocumentMutation.prefixForUser = function (userId) {
        return [userId];
    };
    /**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */
    DbDocumentMutation.prefixForPath = function (userId, path) {
        return [userId, encode(path)];
    };
    /**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */
    DbDocumentMutation.key = function (userId, path, batchId) {
        return [userId, encode(path), batchId];
    };
    DbDocumentMutation.store = 'documentMutations';
    /**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */
    DbDocumentMutation.PLACEHOLDER = new DbDocumentMutation();
    return DbDocumentMutation;
}());
function createRemoteDocumentCache(db) {
    db.createObjectStore(DbRemoteDocument.store);
}
/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbNoDocument = /** @class */ (function () {
    function DbNoDocument(path, readTime) {
        this.path = path;
        this.readTime = readTime;
    }
    return DbNoDocument;
}());
/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */
var DbUnknownDocument = /** @class */ (function () {
    function DbUnknownDocument(path, version) {
        this.path = path;
        this.version = version;
    }
    return DbUnknownDocument;
}());
/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
 * It represents either:
 *
 * - A complete document.
 * - A "no document" representing a document that is known not to exist (at
 * some version).
 * - An "unknown document" representing a document that is known to exist (at
 * some version) but whose contents are unknown.
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */
var DbRemoteDocument = /** @class */ (function () {
    function DbRemoteDocument(
    /**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */
    unknownDocument, 
    /**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */
    noDocument, 
    /**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */
    document, 
    /**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */
    hasCommittedMutations) {
        this.unknownDocument = unknownDocument;
        this.noDocument = noDocument;
        this.document = document;
        this.hasCommittedMutations = hasCommittedMutations;
    }
    DbRemoteDocument.store = 'remoteDocuments';
    return DbRemoteDocument;
}());
/**
 * Contains a single entry that has metadata about the remote document cache.
 */
var DbRemoteDocumentGlobal = /** @class */ (function () {
    /**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */
    function DbRemoteDocumentGlobal(byteSize) {
        this.byteSize = byteSize;
    }
    DbRemoteDocumentGlobal.store = 'remoteDocumentGlobal';
    DbRemoteDocumentGlobal.key = 'remoteDocumentGlobalKey';
    return DbRemoteDocumentGlobal;
}());
function createDocumentGlobalStore(db) {
    db.createObjectStore(DbRemoteDocumentGlobal.store);
}
/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */
var DbTarget = /** @class */ (function () {
    function DbTarget(
    /**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */
    targetId, 
    /**
     * The canonical string representing this query. This is not unique.
     */
    canonicalId, 
    /**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */
    readTime, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */
    resumeToken, 
    /**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */
    lastListenSequenceNumber, 
    /**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */
    query) {
        this.targetId = targetId;
        this.canonicalId = canonicalId;
        this.readTime = readTime;
        this.resumeToken = resumeToken;
        this.lastListenSequenceNumber = lastListenSequenceNumber;
        this.query = query;
    }
    DbTarget.store = 'targets';
    /** Keys are automatically assigned via the targetId property. */
    DbTarget.keyPath = 'targetId';
    /** The name of the queryTargets index. */
    DbTarget.queryTargetsIndexName = 'queryTargetsIndex';
    /**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */
    DbTarget.queryTargetsKeyPath = ['canonicalId', 'targetId'];
    return DbTarget;
}());
/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */
var DbTargetDocument = /** @class */ (function () {
    function DbTargetDocument(
    /**
     * The targetId identifying a target or 0 for a sentinel row.
     */
    targetId, 
    /**
     * The path to the document, as encoded in the key.
     */
    path, 
    /**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */
    sequenceNumber) {
        this.targetId = targetId;
        this.path = path;
        this.sequenceNumber = sequenceNumber;
        assert((targetId === 0) === (sequenceNumber !== undefined), 
        // tslint:disable-next-line:max-line-length
        'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');
    }
    /** Name of the IndexedDb object store.  */
    DbTargetDocument.store = 'targetDocuments';
    /** Keys are automatically assigned via the targetId, path properties. */
    DbTargetDocument.keyPath = ['targetId', 'path'];
    /** The index name for the reverse index. */
    DbTargetDocument.documentTargetsIndex = 'documentTargetsIndex';
    /** We also need to create the reverse index for these properties. */
    DbTargetDocument.documentTargetsKeyPath = ['path', 'targetId'];
    return DbTargetDocument;
}());
/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */
var DbTargetGlobal = /** @class */ (function () {
    function DbTargetGlobal(
    /**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */
    highestTargetId, 
    /**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */
    highestListenSequenceNumber, 
    /**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */
    lastRemoteSnapshotVersion, 
    /**
     * The number of targets persisted.
     */
    targetCount) {
        this.highestTargetId = highestTargetId;
        this.highestListenSequenceNumber = highestListenSequenceNumber;
        this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        this.targetCount = targetCount;
    }
    /**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */
    DbTargetGlobal.key = 'targetGlobalKey';
    DbTargetGlobal.store = 'targetGlobal';
    return DbTargetGlobal;
}());
/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */
var DbCollectionParent = /** @class */ (function () {
    function DbCollectionParent(
    /**
     * The collectionId (e.g. 'messages')
     */
    collectionId, 
    /**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */
    parent) {
        this.collectionId = collectionId;
        this.parent = parent;
    }
    /** Name of the IndexedDb object store. */
    DbCollectionParent.store = 'collectionParents';
    /** Keys are automatically assigned via the collectionId, parent properties. */
    DbCollectionParent.keyPath = ['collectionId', 'parent'];
    return DbCollectionParent;
}());
function createQueryCache(db) {
    var targetDocumentsStore = db.createObjectStore(DbTargetDocument.store, {
        keyPath: DbTargetDocument.keyPath
    });
    targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex, DbTargetDocument.documentTargetsKeyPath, { unique: true });
    var targetStore = db.createObjectStore(DbTarget.store, {
        keyPath: DbTarget.keyPath
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    targetStore.createIndex(DbTarget.queryTargetsIndexName, DbTarget.queryTargetsKeyPath, { unique: true });
    db.createObjectStore(DbTargetGlobal.store);
}
function dropQueryCache(db) {
    db.deleteObjectStore(DbTargetDocument.store);
    db.deleteObjectStore(DbTarget.store);
    db.deleteObjectStore(DbTargetGlobal.store);
}
/**
 * Creates the target global singleton row.
 *
 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
 */
function writeEmptyTargetGlobalEntry(txn) {
    var globalStore = txn.store(DbTargetGlobal.store);
    var metadata = new DbTargetGlobal(
    /*highestTargetId=*/ 0, 
    /*lastListenSequenceNumber=*/ 0, SnapshotVersion.MIN.toTimestamp(), 
    /*targetCount=*/ 0);
    return globalStore.put(DbTargetGlobal.key, metadata);
}
/**
 * An object store to store the keys of changed documents. This is used to
 * facilitate storing document changelogs in the Remote Document Cache.
 *
 * PORTING NOTE: This is used for change propagation during multi-tab syncing
 * and not needed on iOS and Android.
 */
var DbRemoteDocumentChanges = /** @class */ (function () {
    function DbRemoteDocumentChanges(
    /** The keys of the changed documents. */
    changes) {
        this.changes = changes;
    }
    /** Name of the IndexedDb object store.  */
    DbRemoteDocumentChanges.store = 'remoteDocumentChanges';
    /** Keys are auto-generated via the `id` property. */
    DbRemoteDocumentChanges.keyPath = 'id';
    return DbRemoteDocumentChanges;
}());
function createRemoteDocumentChangesStore(db) {
    db.createObjectStore(DbRemoteDocumentChanges.store, {
        keyPath: 'id',
        autoIncrement: true
    });
}
/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */
var DbClientMetadata = /** @class */ (function () {
    function DbClientMetadata(
    /** The auto-generated client id assigned at client startup. */
    clientId, 
    /** The last time this state was updated. */
    updateTimeMs, 
    /** Whether the client's network connection is enabled. */
    networkEnabled, 
    /** Whether this client is running in a foreground tab. */
    inForeground, 
    /**
     * The last change read from the DbRemoteDocumentChanges store.
     * Can be undefined for backwards compatibility.
     */
    lastProcessedDocumentChangeId) {
        this.clientId = clientId;
        this.updateTimeMs = updateTimeMs;
        this.networkEnabled = networkEnabled;
        this.inForeground = inForeground;
        this.lastProcessedDocumentChangeId = lastProcessedDocumentChangeId;
    }
    /** Name of the IndexedDb object store. */
    DbClientMetadata.store = 'clientMetadata';
    /** Keys are automatically assigned via the clientId properties. */
    DbClientMetadata.keyPath = 'clientId';
    return DbClientMetadata;
}());
function createClientMetadataStore(db) {
    db.createObjectStore(DbClientMetadata.store, {
        keyPath: DbClientMetadata.keyPath
    });
}
// Visible for testing
var V1_STORES = [
    DbMutationQueue.store,
    DbMutationBatch.store,
    DbDocumentMutation.store,
    DbRemoteDocument.store,
    DbTarget.store,
    DbPrimaryClient.store,
    DbTargetGlobal.store,
    DbTargetDocument.store
];
// V2 is no longer usable (see comment at top of file)
// Visible for testing
var V3_STORES = V1_STORES;
// Visible for testing
var V4_STORES = V3_STORES.concat([
    DbClientMetadata.store,
    DbRemoteDocumentChanges.store
]);
// V5 does not change the set of stores.
var V6_STORES = V4_STORES.concat([DbRemoteDocumentGlobal.store]);
// V7 does not change the set of stores.
var V8_STORES = V6_STORES.concat([DbCollectionParent.store]);
/**
 * The list of all default IndexedDB stores used throughout the SDK. This is
 * used when creating transactions so that access across all stores is done
 * atomically.
 */
var ALL_STORES = V8_STORES;

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A persisted implementation of IndexManager.
 */
var IndexedDbIndexManager = /** @class */ (function () {
    function IndexedDbIndexManager() {
        /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */
        this.collectionParentsCache = new MemoryCollectionParentIndex();
    }
    IndexedDbIndexManager.prototype.addToCollectionParentIndex = function (transaction, collectionPath) {
        assert(collectionPath.length % 2 === 1, 'Expected a collection path.');
        if (this.collectionParentsCache.add(collectionPath)) {
            assert(collectionPath.length >= 1, 'Invalid collection path.');
            var collectionId = collectionPath.lastSegment();
            var parentPath = collectionPath.popLast();
            return collectionParentsStore(transaction).put({
                collectionId: collectionId,
                parent: encode(parentPath)
            });
        }
        return PersistencePromise.resolve();
    };
    IndexedDbIndexManager.prototype.getCollectionParents = function (transaction, collectionId) {
        var parentPaths = [];
        var range = IDBKeyRange.bound([collectionId, ''], [immediateSuccessor(collectionId), ''], 
        /*lowerOpen=*/ false, 
        /*upperOpen=*/ true);
        return collectionParentsStore(transaction)
            .loadAll(range)
            .next(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (entry.collectionId !== collectionId) {
                    break;
                }
                parentPaths.push(decode(entry.parent));
            }
            return parentPaths;
        });
    };
    return IndexedDbIndexManager;
}());
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */
function collectionParentsStore(txn) {
    return IndexedDbPersistence.getStore(txn, DbCollectionParent.store);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** An enumeration of the different purposes we have for queries. */
var QueryPurpose;
(function (QueryPurpose) {
    /** A regular, normal query. */
    QueryPurpose[QueryPurpose["Listen"] = 0] = "Listen";
    /**
     * The query was used to refill a query after an existence filter mismatch.
     */
    QueryPurpose[QueryPurpose["ExistenceFilterMismatch"] = 1] = "ExistenceFilterMismatch";
    /** The query was used to resolve a limbo document. */
    QueryPurpose[QueryPurpose["LimboResolution"] = 2] = "LimboResolution";
})(QueryPurpose || (QueryPurpose = {}));
/**
 * An immutable set of metadata that the local store tracks for each query.
 */
var QueryData = /** @class */ (function () {
    function QueryData(
    /** The query being listened to. */
    query, 
    /**
     * The target ID to which the query corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */
    targetId, 
    /** The purpose of the query. */
    purpose, 
    /** The sequence number of the last transaction during which this query data was modified */
    sequenceNumber, 
    /** The latest snapshot version seen for this target. */
    snapshotVersion, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken) {
        if (snapshotVersion === void 0) { snapshotVersion = SnapshotVersion.MIN; }
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        this.query = query;
        this.targetId = targetId;
        this.purpose = purpose;
        this.sequenceNumber = sequenceNumber;
        this.snapshotVersion = snapshotVersion;
        this.resumeToken = resumeToken;
    }
    /**
     * Creates a new query data instance with an updated snapshot version and
     * resume token.
     */
    QueryData.prototype.copy = function (overwrite) {
        return new QueryData(this.query, this.targetId, this.purpose, overwrite.sequenceNumber === undefined
            ? this.sequenceNumber
            : overwrite.sequenceNumber, overwrite.snapshotVersion === undefined
            ? this.snapshotVersion
            : overwrite.snapshotVersion, overwrite.resumeToken === undefined
            ? this.resumeToken
            : overwrite.resumeToken);
    };
    QueryData.prototype.isEqual = function (other) {
        return (this.targetId === other.targetId &&
            this.purpose === other.purpose &&
            this.sequenceNumber === other.sequenceNumber &&
            this.snapshotVersion.isEqual(other.snapshotVersion) &&
            this.resumeToken === other.resumeToken &&
            this.query.isEqual(other.query));
    };
    return QueryData;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Serializer for values stored in the LocalStore. */
var LocalSerializer = /** @class */ (function () {
    function LocalSerializer(remoteSerializer) {
        this.remoteSerializer = remoteSerializer;
    }
    /** Decodes a remote document from storage locally to a Document. */
    LocalSerializer.prototype.fromDbRemoteDocument = function (remoteDoc) {
        if (remoteDoc.document) {
            return this.remoteSerializer.fromDocument(remoteDoc.document, !!remoteDoc.hasCommittedMutations);
        }
        else if (remoteDoc.noDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.noDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.noDocument.readTime);
            return new NoDocument(key, version, {
                hasCommittedMutations: !!remoteDoc.hasCommittedMutations
            });
        }
        else if (remoteDoc.unknownDocument) {
            var key = DocumentKey.fromSegments(remoteDoc.unknownDocument.path);
            var version = this.fromDbTimestamp(remoteDoc.unknownDocument.version);
            return new UnknownDocument(key, version);
        }
        else {
            return fail('Unexpected DbRemoteDocument');
        }
    };
    /** Encodes a document for storage locally. */
    LocalSerializer.prototype.toDbRemoteDocument = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            var doc = maybeDoc.proto
                ? maybeDoc.proto
                : this.remoteSerializer.toDocument(maybeDoc);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, 
            /* noDocument= */ null, doc, hasCommittedMutations);
        }
        else if (maybeDoc instanceof NoDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            var hasCommittedMutations = maybeDoc.hasCommittedMutations;
            return new DbRemoteDocument(
            /* unknownDocument= */ null, new DbNoDocument(path, readTime), 
            /* document= */ null, hasCommittedMutations);
        }
        else if (maybeDoc instanceof UnknownDocument) {
            var path = maybeDoc.key.path.toArray();
            var readTime = this.toDbTimestamp(maybeDoc.version);
            return new DbRemoteDocument(new DbUnknownDocument(path, readTime), 
            /* noDocument= */ null, 
            /* document= */ null, 
            /* hasCommittedMutations= */ true);
        }
        else {
            return fail('Unexpected MaybeDocumment');
        }
    };
    LocalSerializer.prototype.toDbTimestamp = function (snapshotVersion) {
        var timestamp = snapshotVersion.toTimestamp();
        return new DbTimestamp(timestamp.seconds, timestamp.nanoseconds);
    };
    LocalSerializer.prototype.fromDbTimestamp = function (dbTimestamp) {
        var timestamp = new Timestamp(dbTimestamp.seconds, dbTimestamp.nanoseconds);
        return SnapshotVersion.fromTimestamp(timestamp);
    };
    /** Encodes a batch of mutations into a DbMutationBatch for local storage. */
    LocalSerializer.prototype.toDbMutationBatch = function (userId, batch) {
        var _this = this;
        var serializedBaseMutations = batch.baseMutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        var serializedMutations = batch.mutations.map(function (m) {
            return _this.remoteSerializer.toMutation(m);
        });
        return new DbMutationBatch(userId, batch.batchId, batch.localWriteTime.toMillis(), serializedBaseMutations, serializedMutations);
    };
    /** Decodes a DbMutationBatch into a MutationBatch */
    LocalSerializer.prototype.fromDbMutationBatch = function (dbBatch) {
        var _this = this;
        var baseMutations = (dbBatch.baseMutations || []).map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var mutations = dbBatch.mutations.map(function (m) {
            return _this.remoteSerializer.fromMutation(m);
        });
        var timestamp = Timestamp.fromMillis(dbBatch.localWriteTimeMs);
        return new MutationBatch(dbBatch.batchId, timestamp, baseMutations, mutations);
    };
    /*
     * Encodes a set of document keys into an array of EncodedResourcePaths.
     */
    LocalSerializer.prototype.toDbResourcePaths = function (keys) {
        var encodedKeys = [];
        keys.forEach(function (key) {
            encodedKeys.push(encode(key.path));
        });
        return encodedKeys;
    };
    /** Decodes an array of EncodedResourcePaths into a set of document keys. */
    LocalSerializer.prototype.fromDbResourcePaths = function (encodedPaths) {
        var keys = documentKeySet();
        for (var _i = 0, encodedPaths_1 = encodedPaths; _i < encodedPaths_1.length; _i++) {
            var documentKey = encodedPaths_1[_i];
            keys = keys.add(new DocumentKey(decode(documentKey)));
        }
        return keys;
    };
    /** Decodes a DbTarget into QueryData */
    LocalSerializer.prototype.fromDbTarget = function (dbTarget) {
        var version = this.fromDbTimestamp(dbTarget.readTime);
        var query;
        if (isDocumentQuery(dbTarget.query)) {
            query = this.remoteSerializer.fromDocumentsTarget(dbTarget.query);
        }
        else {
            query = this.remoteSerializer.fromQueryTarget(dbTarget.query);
        }
        return new QueryData(query, dbTarget.targetId, QueryPurpose.Listen, dbTarget.lastListenSequenceNumber, version, dbTarget.resumeToken);
    };
    /** Encodes QueryData into a DbTarget for storage locally. */
    LocalSerializer.prototype.toDbTarget = function (queryData) {
        assert(QueryPurpose.Listen === queryData.purpose, 'Only queries with purpose ' +
            QueryPurpose.Listen +
            ' may be stored, got ' +
            queryData.purpose);
        var dbTimestamp = this.toDbTimestamp(queryData.snapshotVersion);
        var queryProto;
        if (queryData.query.isDocumentQuery()) {
            queryProto = this.remoteSerializer.toDocumentsTarget(queryData.query);
        }
        else {
            queryProto = this.remoteSerializer.toQueryTarget(queryData.query);
        }
        var resumeToken;
        if (queryData.resumeToken instanceof Uint8Array) {
            // TODO(b/78771403): Convert tokens to strings during deserialization
            assert(Object({"NODE_ENV":"production","PUBLIC_URL":""}).USE_MOCK_PERSISTENCE === 'YES', 'Persisting non-string stream tokens is only supported with mock persistence .');
            resumeToken = queryData.resumeToken.toString();
        }
        else {
            resumeToken = queryData.resumeToken;
        }
        // lastListenSequenceNumber is always 0 until we do real GC.
        return new DbTarget(queryData.targetId, queryData.query.canonicalId(), dbTimestamp, resumeToken, queryData.sequenceNumber, queryProto);
    };
    return LocalSerializer;
}());
/**
 * A helper function for figuring out what kind of query has been stored.
 */
function isDocumentQuery(dbQuery) {
    return dbQuery.documents !== undefined;
}

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferEntryComparator(_a, _b) {
    var aSequence = _a[0], aIndex = _a[1];
    var bSequence = _b[0], bIndex = _b[1];
    var seqCmp = primitiveComparator(aSequence, bSequence);
    if (seqCmp === 0) {
        // This order doesn't matter, but we can bias against churn by sorting
        // entries created earlier as less than newer entries.
        return primitiveComparator(aIndex, bIndex);
    }
    else {
        return seqCmp;
    }
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */
var RollingSequenceNumberBuffer = /** @class */ (function () {
    function RollingSequenceNumberBuffer(maxElements) {
        this.maxElements = maxElements;
        this.buffer = new SortedSet(bufferEntryComparator);
        this.previousIndex = 0;
    }
    RollingSequenceNumberBuffer.prototype.nextIndex = function () {
        return ++this.previousIndex;
    };
    RollingSequenceNumberBuffer.prototype.addElement = function (sequenceNumber) {
        var entry = [sequenceNumber, this.nextIndex()];
        if (this.buffer.size < this.maxElements) {
            this.buffer = this.buffer.add(entry);
        }
        else {
            var highestValue = this.buffer.last();
            if (bufferEntryComparator(entry, highestValue) < 0) {
                this.buffer = this.buffer.delete(highestValue).add(entry);
            }
        }
    };
    Object.defineProperty(RollingSequenceNumberBuffer.prototype, "maxValue", {
        get: function () {
            // Guaranteed to be non-empty. If we decide we are not collecting any
            // sequence numbers, nthSequenceNumber below short-circuits. If we have
            // decided that we are collecting n sequence numbers, it's because n is some
            // percentage of the existing sequence numbers. That means we should never
            // be in a situation where we are collecting sequence numbers but don't
            // actually have any.
            return this.buffer.last()[0];
        },
        enumerable: true,
        configurable: true
    });
    return RollingSequenceNumberBuffer;
}());
var GC_DID_NOT_RUN = {
    didRun: false,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var LruParams = /** @class */ (function () {
    function LruParams(
    // When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    cacheSizeCollectionThreshold, 
    // The percentage of sequence numbers that we will attempt to collect
    percentileToCollect, 
    // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    maximumSequenceNumbersToCollect) {
        this.cacheSizeCollectionThreshold = cacheSizeCollectionThreshold;
        this.percentileToCollect = percentileToCollect;
        this.maximumSequenceNumbersToCollect = maximumSequenceNumbersToCollect;
    }
    LruParams.withCacheSize = function (cacheSize) {
        return new LruParams(cacheSize, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    };
    LruParams.COLLECTION_DISABLED = -1;
    LruParams.MINIMUM_CACHE_SIZE_BYTES = 1 * 1024 * 1024;
    LruParams.DEFAULT_CACHE_SIZE_BYTES = 40 * 1024 * 1024;
    LruParams.DEFAULT_COLLECTION_PERCENTILE = 10;
    LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1000;
    LruParams.DEFAULT = new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    LruParams.DISABLED = new LruParams(LruParams.COLLECTION_DISABLED, 0, 0);
    return LruParams;
}());
/** How long we wait to try running LRU GC after SDK initialization. */
var INITIAL_GC_DELAY_MS = 1 * 60 * 1000;
/** Minimum amount of time between GC checks, after the first one. */
var REGULAR_GC_DELAY_MS = 5 * 60 * 1000;
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */
var LruScheduler = /** @class */ (function () {
    function LruScheduler(garbageCollector, asyncQueue, localStore) {
        this.garbageCollector = garbageCollector;
        this.asyncQueue = asyncQueue;
        this.localStore = localStore;
        this.gcTask = null;
    }
    LruScheduler.prototype.start = function () {
        assert(this.gcTask === null, 'Cannot start an already started LruScheduler');
        if (this.garbageCollector.params.cacheSizeCollectionThreshold !==
            LruParams.COLLECTION_DISABLED) {
            this.scheduleGC();
        }
    };
    LruScheduler.prototype.stop = function () {
        if (this.gcTask) {
            this.gcTask.cancel();
            this.gcTask = null;
        }
    };
    Object.defineProperty(LruScheduler.prototype, "started", {
        get: function () {
            return this.gcTask !== null;
        },
        enumerable: true,
        configurable: true
    });
    LruScheduler.prototype.scheduleGC = function () {
        var _this = this;
        assert(this.gcTask === null, 'Cannot schedule GC while a task is pending');
        var delay = this.hasRun ? REGULAR_GC_DELAY_MS : INITIAL_GC_DELAY_MS;
        debug('LruGarbageCollector', "Garbage collection scheduled in " + delay + "ms");
        this.gcTask = this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection, delay, function () {
            _this.gcTask = null;
            _this.hasRun = true;
            return _this.localStore
                .collectGarbage(_this.garbageCollector)
                .then(function () { return _this.scheduleGC(); })
                .catch(ignoreIfPrimaryLeaseLoss);
        });
    };
    return LruScheduler;
}());
/** Implements the steps for LRU garbage collection. */
var LruGarbageCollector = /** @class */ (function () {
    function LruGarbageCollector(delegate, params) {
        this.delegate = delegate;
        this.params = params;
    }
    /** Given a percentile of target to collect, returns the number of targets to collect. */
    LruGarbageCollector.prototype.calculateTargetCount = function (txn, percentile) {
        return this.delegate.getSequenceNumberCount(txn).next(function (targetCount) {
            return Math.floor((percentile / 100.0) * targetCount);
        });
    };
    /** Returns the nth sequence number, counting in order from the smallest. */
    LruGarbageCollector.prototype.nthSequenceNumber = function (txn, n) {
        var _this = this;
        if (n === 0) {
            return PersistencePromise.resolve(ListenSequence.INVALID);
        }
        var buffer = new RollingSequenceNumberBuffer(n);
        return this.delegate
            .forEachTarget(txn, function (target) { return buffer.addElement(target.sequenceNumber); })
            .next(function () {
            return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn, function (sequenceNumber) { return buffer.addElement(sequenceNumber); });
        })
            .next(function () { return buffer.maxValue; });
    };
    /**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */
    LruGarbageCollector.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.delegate.removeTargets(txn, upperBound, activeTargetIds);
    };
    /**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */
    LruGarbageCollector.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        return this.delegate.removeOrphanedDocuments(txn, upperBound);
    };
    LruGarbageCollector.prototype.collect = function (txn, activeTargetIds) {
        var _this = this;
        if (this.params.cacheSizeCollectionThreshold === LruParams.COLLECTION_DISABLED) {
            debug('LruGarbageCollector', 'Garbage collection skipped; disabled');
            return PersistencePromise.resolve(GC_DID_NOT_RUN);
        }
        return this.getCacheSize(txn).next(function (cacheSize) {
            if (cacheSize < _this.params.cacheSizeCollectionThreshold) {
                debug('LruGarbageCollector', "Garbage collection skipped; Cache size " + cacheSize + " " +
                    ("is lower than threshold " + _this.params.cacheSizeCollectionThreshold));
                return GC_DID_NOT_RUN;
            }
            else {
                return _this.runGarbageCollection(txn, activeTargetIds);
            }
        });
    };
    LruGarbageCollector.prototype.getCacheSize = function (txn) {
        return this.delegate.getCacheSize(txn);
    };
    LruGarbageCollector.prototype.runGarbageCollection = function (txn, activeTargetIds) {
        var _this = this;
        var upperBoundSequenceNumber;
        var sequenceNumbersToCollect, targetsRemoved;
        // Timestamps for various pieces of the process
        var startTs, countedTargetsTs, foundUpperBoundTs, removedTargetsTs, removedDocumentsTs;
        startTs = Date.now();
        return this.calculateTargetCount(txn, this.params.percentileToCollect)
            .next(function (sequenceNumbers) {
            // Cap at the configured max
            if (sequenceNumbers > _this.params.maximumSequenceNumbersToCollect) {
                debug('LruGarbageCollector', 'Capping sequence numbers to collect down ' +
                    ("to the maximum of " + _this.params.maximumSequenceNumbersToCollect + " ") +
                    ("from " + sequenceNumbers));
                sequenceNumbersToCollect = _this.params
                    .maximumSequenceNumbersToCollect;
            }
            else {
                sequenceNumbersToCollect = sequenceNumbers;
            }
            countedTargetsTs = Date.now();
            return _this.nthSequenceNumber(txn, sequenceNumbersToCollect);
        })
            .next(function (upperBound) {
            upperBoundSequenceNumber = upperBound;
            foundUpperBoundTs = Date.now();
            return _this.removeTargets(txn, upperBoundSequenceNumber, activeTargetIds);
        })
            .next(function (numTargetsRemoved) {
            targetsRemoved = numTargetsRemoved;
            removedTargetsTs = Date.now();
            return _this.removeOrphanedDocuments(txn, upperBoundSequenceNumber);
        })
            .next(function (documentsRemoved) {
            removedDocumentsTs = Date.now();
            if (getLogLevel() <= LogLevel.DEBUG) {
                var desc = 'LRU Garbage Collection\n' +
                    ("\tCounted targets in " + (countedTargetsTs - startTs) + "ms\n") +
                    ("\tDetermined least recently used " + sequenceNumbersToCollect + " in ") +
                    (foundUpperBoundTs - countedTargetsTs + "ms\n") +
                    ("\tRemoved " + targetsRemoved + " targets in ") +
                    (removedTargetsTs - foundUpperBoundTs + "ms\n") +
                    ("\tRemoved " + documentsRemoved + " documents in ") +
                    (removedDocumentsTs - removedTargetsTs + "ms\n") +
                    ("Total Duration: " + (removedDocumentsTs - startTs) + "ms");
                debug('LruGarbageCollector', desc);
            }
            return PersistencePromise.resolve({
                didRun: true,
                sequenceNumbersCollected: sequenceNumbersToCollect,
                targetsRemoved: targetsRemoved,
                documentsRemoved: documentsRemoved
            });
        });
    };
    return LruGarbageCollector;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Opaque interface representing a persistence transaction.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */
var PersistenceTransaction = /** @class */ (function () {
    function PersistenceTransaction() {
    }
    return PersistenceTransaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$1 = 'IndexedDbPersistence';
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data (such as the remote document
 * cache changelog) is garbage collected.
 */
var MAX_CLIENT_AGE_MS = 30 * 60 * 1000; // 30 minutes
/**
 * Oldest acceptable metadata age for clients that may participate in the
 * primary lease election. Clients that have not updated their client metadata
 * within 5 seconds are not eligible to receive a primary lease.
 */
var MAX_PRIMARY_ELIGIBLE_AGE_MS = 5000;
/**
 * The interval at which clients will update their metadata, including
 * refreshing their primary lease if held or potentially trying to acquire it if
 * not held.
 *
 * Primary clients may opportunistically refresh their metadata earlier
 * if they're already performing an IndexedDB operation.
 */
var CLIENT_METADATA_REFRESH_INTERVAL_MS = 4000;
/** User-facing error when the primary lease is required but not available. */
var PRIMARY_LEASE_LOST_ERROR_MSG = 'The current tab is not in the required state to perform this operation. ' +
    'It might be necessary to refresh the browser tab.';
var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG = 'Another tab has exclusive access to the persistence layer. ' +
    'To allow shared access, make sure to invoke ' +
    '`enablePersistence()` with `synchronizeTabs:true` in all tabs.';
var UNSUPPORTED_PLATFORM_ERROR_MSG = 'This platform is either missing' +
    ' IndexedDB or is known to have an incomplete implementation. Offline' +
    ' persistence has been disabled.';
// The format of the LocalStorage key that stores zombied client is:
//     firestore_zombie_<persistence_prefix>_<instance_key>
var ZOMBIED_CLIENTS_KEY_PREFIX = 'firestore_zombie';
var IndexedDbTransaction = /** @class */ (function (_super) {
    tslib_1.__extends(IndexedDbTransaction, _super);
    function IndexedDbTransaction(simpleDbTransaction, currentSequenceNumber) {
        var _this = _super.call(this) || this;
        _this.simpleDbTransaction = simpleDbTransaction;
        _this.currentSequenceNumber = currentSequenceNumber;
        return _this;
    }
    return IndexedDbTransaction;
}(PersistenceTransaction));
var IndexedDbPersistence = /** @class */ (function () {
    // Note that `multiClientParams` must be present to enable multi-client support while multi-tab
    // is still experimental. When multi-client is switched to always on, `multiClientParams` will
    // no longer be optional.
    function IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        this.persistenceKey = persistenceKey;
        this.clientId = clientId;
        this.queue = queue;
        this.multiClientParams = multiClientParams;
        this._started = false;
        this.isPrimary = false;
        this.networkEnabled = true;
        this.inForeground = false;
        /** The last time we garbage collected the Remote Document Changelog. */
        this.lastGarbageCollectionTime = Number.NEGATIVE_INFINITY;
        /** A listener to notify on primary state changes. */
        this.primaryStateListener = function (_) { return Promise.resolve(); };
        if (!IndexedDbPersistence.isAvailable()) {
            throw new FirestoreError(Code.UNIMPLEMENTED, UNSUPPORTED_PLATFORM_ERROR_MSG);
        }
        this.referenceDelegate = new IndexedDbLruDelegate(this, lruParams);
        this.dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
        this.serializer = new LocalSerializer(serializer);
        this.document = platform.document;
        this.allowTabSynchronization = multiClientParams !== undefined;
        this.queryCache = new IndexedDbQueryCache(this.referenceDelegate, this.serializer);
        this.indexManager = new IndexedDbIndexManager();
        this.remoteDocumentCache = new IndexedDbRemoteDocumentCache(this.serializer, this.indexManager, 
        /*keepDocumentChangeLog=*/ this.allowTabSynchronization);
        if (platform.window && platform.window.localStorage) {
            this.window = platform.window;
            this.webStorage = this.window.localStorage;
        }
        else {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
        }
    }
    IndexedDbPersistence.getStore = function (txn, store) {
        if (txn instanceof IndexedDbTransaction) {
            return SimpleDb.getStore(txn.simpleDbTransaction, store);
        }
        else {
            throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');
        }
    };
    IndexedDbPersistence.createIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    IndexedDbPersistence.createMultiClientIndexedDbPersistence = function (persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var persistence;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        persistence = new IndexedDbPersistence(persistenceKey, clientId, platform, queue, serializer, lruParams, multiClientParams);
                        return [4 /*yield*/, persistence.start()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, persistence];
                }
            });
        });
    };
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */
    IndexedDbPersistence.prototype.start = function () {
        var _this = this;
        assert(!this.started, 'IndexedDbPersistence double-started!');
        assert(this.window !== null, "Expected 'window' to be defined");
        return SimpleDb.openOrCreate(this.dbName, SCHEMA_VERSION, new SchemaConverter(this.serializer))
            .then(function (db) {
            _this.simpleDb = db;
            // NOTE: This is expected to fail sometimes (in the case of another tab already
            // having the persistence lock), so it's the first thing we should do.
            return _this.updateClientMetadataAndTryBecomePrimary();
        })
            .then(function () {
            _this.attachVisibilityHandler();
            _this.attachWindowUnloadHook();
            _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();
            return _this.startRemoteDocumentCache();
        })
            .then(function () {
            return _this.simpleDb.runTransaction('readonly', [DbTargetGlobal.store], function (txn) {
                return getHighestListenSequenceNumber(txn).next(function (highestListenSequenceNumber) {
                    var sequenceNumberSyncer = _this.multiClientParams
                        ? _this.multiClientParams.sequenceNumberSyncer
                        : undefined;
                    _this.listenSequence = new ListenSequence(highestListenSequenceNumber, sequenceNumberSyncer);
                });
            });
        })
            .then(function () {
            _this._started = true;
        })
            .catch(function (reason) {
            _this.simpleDb && _this.simpleDb.close();
            return Promise.reject(reason);
        });
    };
    IndexedDbPersistence.prototype.startRemoteDocumentCache = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', ALL_STORES, function (txn) {
            return _this.remoteDocumentCache.start(txn);
        });
    };
    IndexedDbPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        var _this = this;
        this.primaryStateListener = function (primaryState) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.started) {
                    return [2 /*return*/, primaryStateListener(primaryState)];
                }
                return [2 /*return*/];
            });
        }); };
        return primaryStateListener(this.isPrimary);
    };
    IndexedDbPersistence.prototype.setDatabaseDeletedListener = function (databaseDeletedListener) {
        var _this = this;
        this.simpleDb.setVersionChangeListener(function (event) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(event.newVersion === null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, databaseDeletedListener()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    IndexedDbPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        var _this = this;
        if (this.networkEnabled !== networkEnabled) {
            this.networkEnabled = networkEnabled;
            // Schedule a primary lease refresh for immediate execution. The eventual
            // lease update will be propagated via `primaryStateListener`.
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.started) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.updateClientMetadataAndTryBecomePrimary()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        }
    };
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */
    IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readwrite', ALL_STORES, function (txn) {
            var metadataStore = clientMetadataStore(txn);
            return metadataStore
                .put(new DbClientMetadata(_this.clientId, Date.now(), _this.networkEnabled, _this.inForeground, _this.remoteDocumentCache.lastProcessedDocumentChangeId))
                .next(function () {
                if (_this.isPrimary) {
                    return _this.verifyPrimaryLease(txn).next(function (success) {
                        if (!success) {
                            _this.isPrimary = false;
                            _this.queue.enqueueAndForget(function () {
                                return _this.primaryStateListener(false);
                            });
                        }
                    });
                }
            })
                .next(function () { return _this.canActAsPrimary(txn); })
                .next(function (canActAsPrimary) {
                var wasPrimary = _this.isPrimary;
                _this.isPrimary = canActAsPrimary;
                if (wasPrimary !== _this.isPrimary) {
                    _this.queue.enqueueAndForget(function () {
                        return _this.primaryStateListener(_this.isPrimary);
                    });
                }
                if (wasPrimary && !_this.isPrimary) {
                    return _this.releasePrimaryLeaseIfHeld(txn);
                }
                else if (_this.isPrimary) {
                    return _this.acquireOrExtendPrimaryLease(txn);
                }
            });
        });
    };
    IndexedDbPersistence.prototype.verifyPrimaryLease = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            return PersistencePromise.resolve(_this.isLocalClient(primaryClient));
        });
    };
    IndexedDbPersistence.prototype.removeClientMetadata = function (txn) {
        var metadataStore = clientMetadataStore(txn);
        return metadataStore.delete(this.clientId);
    };
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */
    IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var activeClients_1, inactiveClients_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isPrimary &&
                            !this.isWithinAge(this.lastGarbageCollectionTime, MAX_CLIENT_AGE_MS))) return [3 /*break*/, 2];
                        this.lastGarbageCollectionTime = Date.now();
                        inactiveClients_1 = [];
                        return [4 /*yield*/, this.runTransaction('maybeGarbageCollectMultiClientState', 'readwrite-primary', function (txn) {
                                var metadataStore = IndexedDbPersistence.getStore(txn, DbClientMetadata.store);
                                return metadataStore
                                    .loadAll()
                                    .next(function (existingClients) {
                                    activeClients_1 = _this.filterActiveClients(existingClients, MAX_CLIENT_AGE_MS);
                                    inactiveClients_1 = existingClients.filter(function (client) { return activeClients_1.indexOf(client) === -1; });
                                })
                                    .next(function () {
                                    // Delete metadata for clients that are no longer considered active.
                                    return PersistencePromise.forEach(inactiveClients_1, function (inactiveClient) {
                                        return metadataStore.delete(inactiveClient.clientId);
                                    });
                                })
                                    .next(function () {
                                    // Retrieve the minimum change ID from the set of active clients.
                                    // The primary client doesn't read from the document change log,
                                    // and hence we exclude it when we determine the minimum
                                    // `lastProcessedDocumentChangeId`.
                                    activeClients_1 = activeClients_1.filter(function (client) { return client.clientId !== _this.clientId; });
                                    if (activeClients_1.length > 0) {
                                        var processedChangeIds = activeClients_1.map(function (client) { return client.lastProcessedDocumentChangeId || 0; });
                                        var oldestChangeId = Math.min.apply(Math, processedChangeIds);
                                        return _this.remoteDocumentCache.removeDocumentChangesThroughChangeId(txn, oldestChangeId);
                                    }
                                });
                            })];
                    case 1:
                        _a.sent();
                        // Delete potential leftover entries that may continue to mark the
                        // inactive clients as zombied in LocalStorage.
                        // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                        // the client atomically, but we can't. So we opt to delete the IndexedDb
                        // entries first to avoid potentially reviving a zombied client.
                        inactiveClients_1.forEach(function (inactiveClient) {
                            _this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */
    IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes = function () {
        var _this = this;
        this.clientMetadataRefresher = this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh, CLIENT_METADATA_REFRESH_INTERVAL_MS, function () {
            return _this.updateClientMetadataAndTryBecomePrimary()
                .then(function () { return _this.maybeGarbageCollectMultiClientState(); })
                .then(function () { return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes(); });
        });
    };
    /** Checks whether `client` is the local client. */
    IndexedDbPersistence.prototype.isLocalClient = function (client) {
        return client ? client.ownerId === this.clientId : false;
    };
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */
    IndexedDbPersistence.prototype.canActAsPrimary = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store
            .get(DbPrimaryClient.key)
            .next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            if (currentLeaseIsValid) {
                if (_this.isLocalClient(currentPrimary) && _this.networkEnabled) {
                    return true;
                }
                if (!_this.isLocalClient(currentPrimary)) {
                    if (!currentPrimary.allowTabSynchronization) {
                        // Fail the `canActAsPrimary` check if the current leaseholder has
                        // not opted into multi-tab synchronization. If this happens at
                        // client startup, we reject the Promise returned by
                        // `enablePersistence()` and the user can continue to use Firestore
                        // with in-memory persistence.
                        // If this fails during a lease refresh, we will instead block the
                        // AsyncQueue from executing further operations. Note that this is
                        // acceptable since mixing & matching different `synchronizeTabs`
                        // settings is not supported.
                        //
                        // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                        // no longer be turned off.
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                    }
                    return false;
                }
            }
            if (_this.networkEnabled && _this.inForeground) {
                return true;
            }
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (existingClients) {
                // Process all existing clients and determine whether at least one of
                // them is better suited to obtain the primary lease.
                var preferredCandidate = _this.filterActiveClients(existingClients, MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function (otherClient) {
                    if (_this.clientId !== otherClient.clientId) {
                        var otherClientHasBetterNetworkState = !_this.networkEnabled && otherClient.networkEnabled;
                        var otherClientHasBetterVisibility = !_this.inForeground && otherClient.inForeground;
                        var otherClientHasSameNetworkState = _this.networkEnabled === otherClient.networkEnabled;
                        if (otherClientHasBetterNetworkState ||
                            (otherClientHasBetterVisibility &&
                                otherClientHasSameNetworkState)) {
                            return true;
                        }
                    }
                    return false;
                });
                return preferredCandidate === undefined;
            });
        })
            .next(function (canActAsPrimary) {
            if (_this.isPrimary !== canActAsPrimary) {
                debug(LOG_TAG$1, "Client " + (canActAsPrimary ? 'is' : 'is not') + " eligible for a primary lease.");
            }
            return canActAsPrimary;
        });
    };
    IndexedDbPersistence.prototype.shutdown = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // The shutdown() operations are idempotent and can be called even when
                        // start() aborted (e.g. because it couldn't acquire the persistence lease).
                        this._started = false;
                        this.markClientZombied();
                        if (this.clientMetadataRefresher) {
                            this.clientMetadataRefresher.cancel();
                        }
                        this.detachVisibilityHandler();
                        this.detachWindowUnloadHook();
                        return [4 /*yield*/, this.simpleDb.runTransaction('readwrite', [DbPrimaryClient.store, DbClientMetadata.store], function (txn) {
                                return _this.releasePrimaryLeaseIfHeld(txn).next(function () {
                                    return _this.removeClientMetadata(txn);
                                });
                            })];
                    case 1:
                        _a.sent();
                        this.simpleDb.close();
                        // Remove the entry marking the client as zombied from LocalStorage since
                        // we successfully deleted its metadata from IndexedDb.
                        this.removeClientZombiedEntry();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */
    IndexedDbPersistence.prototype.filterActiveClients = function (clients, activityThresholdMs) {
        var _this = this;
        return clients.filter(function (client) {
            return _this.isWithinAge(client.updateTimeMs, activityThresholdMs) &&
                !_this.isClientZombied(client.clientId);
        });
    };
    IndexedDbPersistence.prototype.getActiveClients = function () {
        var _this = this;
        return this.simpleDb.runTransaction('readonly', [DbClientMetadata.store], function (txn) {
            return clientMetadataStore(txn)
                .loadAll()
                .next(function (clients) {
                return _this.filterActiveClients(clients, MAX_CLIENT_AGE_MS).map(function (clientMetadata) { return clientMetadata.clientId; });
            });
        });
    };
    IndexedDbPersistence.clearPersistence = function (persistenceKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbName;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!IndexedDbPersistence.isAvailable()) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        dbName = persistenceKey + IndexedDbPersistence.MAIN_DATABASE;
                        return [4 /*yield*/, SimpleDb.delete(dbName)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(IndexedDbPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    IndexedDbPersistence.prototype.getMutationQueue = function (user) {
        assert(this.started, 'Cannot initialize MutationQueue before persistence is started.');
        return IndexedDbMutationQueue.forUser(user, this.serializer, this.indexManager, this.referenceDelegate);
    };
    IndexedDbPersistence.prototype.getQueryCache = function () {
        assert(this.started, 'Cannot initialize QueryCache before persistence is started.');
        return this.queryCache;
    };
    IndexedDbPersistence.prototype.getRemoteDocumentCache = function () {
        assert(this.started, 'Cannot initialize RemoteDocumentCache before persistence is started.');
        return this.remoteDocumentCache;
    };
    IndexedDbPersistence.prototype.getIndexManager = function () {
        assert(this.started, 'Cannot initialize IndexManager before persistence is started.');
        return this.indexManager;
    };
    IndexedDbPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$1, 'Starting transaction:', action);
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.simpleDb.runTransaction(mode === 'readonly' ? 'readonly' : 'readwrite', ALL_STORES, function (simpleDbTxn) {
            if (mode === 'readwrite-primary') {
                // While we merely verify that we have (or can acquire) the lease
                // immediately, we wait to extend the primary lease until after
                // executing transactionOperation(). This ensures that even if the
                // transactionOperation takes a long time, we'll use a recent
                // leaseTimestampMs in the extended (or newly acquired) lease.
                return _this.verifyPrimaryLease(simpleDbTxn)
                    .next(function (success) {
                    if (!success) {
                        error("Failed to obtain primary lease for action '" + action + "'.");
                        _this.isPrimary = false;
                        _this.queue.enqueueAndForget(function () {
                            return _this.primaryStateListener(false);
                        });
                        throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_LOST_ERROR_MSG);
                    }
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                })
                    .next(function (result) {
                    return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function () { return result; });
                });
            }
            else {
                return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function () {
                    return transactionOperation(new IndexedDbTransaction(simpleDbTxn, _this.listenSequence.next()));
                });
            }
        });
    };
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */
    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    IndexedDbPersistence.prototype.verifyAllowTabSynchronization = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (currentPrimary) {
            var currentLeaseIsValid = currentPrimary !== null &&
                _this.isWithinAge(currentPrimary.leaseTimestampMs, MAX_PRIMARY_ELIGIBLE_AGE_MS) &&
                !_this.isClientZombied(currentPrimary.ownerId);
            if (currentLeaseIsValid && !_this.isLocalClient(currentPrimary)) {
                if (!currentPrimary.allowTabSynchronization) {
                    throw new FirestoreError(Code.FAILED_PRECONDITION, PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);
                }
            }
        });
    };
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */
    IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease = function (txn) {
        var newPrimary = new DbPrimaryClient(this.clientId, this.allowTabSynchronization, Date.now());
        return primaryClientStore(txn).put(DbPrimaryClient.key, newPrimary);
    };
    IndexedDbPersistence.isAvailable = function () {
        return SimpleDb.isAvailable();
    };
    /**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */
    IndexedDbPersistence.buildStoragePrefix = function (databaseInfo) {
        // Use two different prefix formats:
        //
        //   * firestore / persistenceKey / projectID . databaseID / ...
        //   * firestore / persistenceKey / projectID / ...
        //
        // projectIDs are DNS-compatible names and cannot contain dots
        // so there's no danger of collisions.
        var database = databaseInfo.databaseId.projectId;
        if (!databaseInfo.databaseId.isDefaultDatabase) {
            database += '.' + databaseInfo.databaseId.database;
        }
        return 'firestore/' + databaseInfo.persistenceKey + '/' + database + '/';
    };
    /** Checks the primary lease and removes it if we are the current primary. */
    IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld = function (txn) {
        var _this = this;
        var store = primaryClientStore(txn);
        return store.get(DbPrimaryClient.key).next(function (primaryClient) {
            if (_this.isLocalClient(primaryClient)) {
                debug(LOG_TAG$1, 'Releasing primary lease.');
                return store.delete(DbPrimaryClient.key);
            }
            else {
                return PersistencePromise.resolve();
            }
        });
    };
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */
    IndexedDbPersistence.prototype.isWithinAge = function (updateTimeMs, maxAgeMs) {
        var now = Date.now();
        var minAcceptable = now - maxAgeMs;
        var maxAcceptable = now;
        if (updateTimeMs < minAcceptable) {
            return false;
        }
        else if (updateTimeMs > maxAcceptable) {
            error("Detected an update time that is in the future: " + updateTimeMs + " > " + maxAcceptable);
            return false;
        }
        return true;
    };
    IndexedDbPersistence.prototype.attachVisibilityHandler = function () {
        var _this = this;
        if (this.document !== null &&
            typeof this.document.addEventListener === 'function') {
            this.documentVisibilityHandler = function () {
                _this.queue.enqueueAndForget(function () {
                    _this.inForeground = _this.document.visibilityState === 'visible';
                    return _this.updateClientMetadataAndTryBecomePrimary();
                });
            };
            this.document.addEventListener('visibilitychange', this.documentVisibilityHandler);
            this.inForeground = this.document.visibilityState === 'visible';
        }
    };
    IndexedDbPersistence.prototype.detachVisibilityHandler = function () {
        if (this.documentVisibilityHandler) {
            assert(this.document !== null &&
                typeof this.document.addEventListener === 'function', "Expected 'document.addEventListener' to be a function");
            this.document.removeEventListener('visibilitychange', this.documentVisibilityHandler);
            this.documentVisibilityHandler = null;
        }
    };
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */
    IndexedDbPersistence.prototype.attachWindowUnloadHook = function () {
        var _this = this;
        if (typeof this.window.addEventListener === 'function') {
            this.windowUnloadHandler = function () {
                // Note: In theory, this should be scheduled on the AsyncQueue since it
                // accesses internal state. We execute this code directly during shutdown
                // to make sure it gets a chance to run.
                _this.markClientZombied();
                _this.queue.enqueueAndForget(function () {
                    // Attempt graceful shutdown (including releasing our primary lease),
                    // but there's no guarantee it will complete.
                    return _this.shutdown();
                });
            };
            this.window.addEventListener('unload', this.windowUnloadHandler);
        }
    };
    IndexedDbPersistence.prototype.detachWindowUnloadHook = function () {
        if (this.windowUnloadHandler) {
            assert(typeof this.window.removeEventListener === 'function', "Expected 'window.removeEventListener' to be a function");
            this.window.removeEventListener('unload', this.windowUnloadHandler);
            this.windowUnloadHandler = null;
        }
    };
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */
    IndexedDbPersistence.prototype.isClientZombied = function (clientId) {
        try {
            var isZombied = this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId)) !==
                null;
            debug(LOG_TAG$1, "Client '" + clientId + "' " + (isZombied ? 'is' : 'is not') + " zombied in LocalStorage");
            return isZombied;
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            error(LOG_TAG$1, 'Failed to get zombied client id.', e);
            return false;
        }
    };
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */
    IndexedDbPersistence.prototype.markClientZombied = function () {
        try {
            this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId), String(Date.now()));
        }
        catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            error('Failed to set zombie client id.', e);
        }
    };
    /** Removes the zombied client entry if it exists. */
    IndexedDbPersistence.prototype.removeClientZombiedEntry = function () {
        try {
            this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));
        }
        catch (e) {
            // Ignore
        }
    };
    IndexedDbPersistence.prototype.zombiedClientLocalStorageKey = function (clientId) {
        return ZOMBIED_CLIENTS_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */
    IndexedDbPersistence.MAIN_DATABASE = 'main';
    return IndexedDbPersistence;
}());
function isPrimaryLeaseLostError(err) {
    return (err.code === Code.FAILED_PRECONDITION &&
        err.message === PRIMARY_LEASE_LOST_ERROR_MSG);
}
/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */
function ignoreIfPrimaryLeaseLoss(err) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (isPrimaryLeaseLostError(err)) {
                debug(LOG_TAG$1, 'Unexpectedly lost primary lease');
            }
            else {
                throw err;
            }
            return [2 /*return*/];
        });
    });
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */
function primaryClientStore(txn) {
    return txn.store(DbPrimaryClient.store);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */
function clientMetadataStore(txn) {
    return txn.store(DbClientMetadata.store);
}
/** Provides LRU functionality for IndexedDB persistence. */
var IndexedDbLruDelegate = /** @class */ (function () {
    function IndexedDbLruDelegate(db, params) {
        this.db = db;
        this.garbageCollector = new LruGarbageCollector(this, params);
    }
    IndexedDbLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocmentCount(txn);
        var targetCountPromise = this.db.getQueryCache().getQueryCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    IndexedDbLruDelegate.prototype.orphanedDocmentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    IndexedDbLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.db.getQueryCache().forEachTarget(txn, f);
    };
    IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        return this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            return f(sequenceNumber);
        });
    };
    IndexedDbLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    IndexedDbLruDelegate.prototype.addReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    IndexedDbLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.db
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    IndexedDbLruDelegate.prototype.removeMutationReference = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */
    IndexedDbLruDelegate.prototype.isPinned = function (txn, docKey) {
        if (this.inMemoryPins.containsKey(docKey)) {
            return PersistencePromise.resolve(true);
        }
        else {
            return mutationQueuesContainKey(txn, docKey);
        }
    };
    IndexedDbLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var bytesRemoved = 0;
        var promises = [];
        var iteration = this.forEachOrphanedDocument(txn, function (docKey, sequenceNumber) {
            if (sequenceNumber <= upperBound) {
                var p = _this.isPinned(txn, docKey).next(function (isPinned) {
                    if (!isPinned) {
                        count++;
                        return _this.removeOrphanedDocument(txn, docKey).next(function (documentBytes) {
                            bytesRemoved += documentBytes;
                        });
                    }
                });
                promises.push(p);
            }
        });
        // Wait for iteration first to make sure we have a chance to add all of the
        // removal promises to the array.
        return iteration
            .next(function () { return PersistencePromise.waitFor(promises); })
            .next(function () {
            return _this.db.getRemoteDocumentCache().updateSize(txn, -bytesRemoved);
        })
            .next(function () { return count; });
    };
    /**
     * Clears a document from the cache. The document is assumed to be orphaned, so target-document
     * associations are not queried. We remove it from the remote document cache, as well as remove
     * its sentinel row.
     */
    IndexedDbLruDelegate.prototype.removeOrphanedDocument = function (txn, docKey) {
        var totalBytesRemoved = 0;
        var documentCache = this.db.getRemoteDocumentCache();
        return PersistencePromise.waitFor([
            documentTargetStore(txn).delete(sentinelKey$1(docKey)),
            documentCache.removeEntry(txn, docKey).next(function (bytesRemoved) {
                totalBytesRemoved += bytesRemoved;
            })
        ]).next(function () { return totalBytesRemoved; });
    };
    IndexedDbLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.db.getQueryCache().updateQueryData(txn, updated);
    };
    IndexedDbLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        return writeSentinelKey(txn, key);
    };
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */
    IndexedDbLruDelegate.prototype.forEachOrphanedDocument = function (txn, f) {
        var store = documentTargetStore(txn);
        var nextToReport = ListenSequence.INVALID;
        var nextPath;
        return store
            .iterate({
            index: DbTargetDocument.documentTargetsIndex
        }, function (_a, _b) {
            var targetId = _a[0], docKey = _a[1];
            var path = _b.path, sequenceNumber = _b.sequenceNumber;
            if (targetId === 0) {
                // if nextToReport is valid, report it, this is a new key so the
                // last one must not be a member of any targets.
                if (nextToReport !== ListenSequence.INVALID) {
                    f(new DocumentKey(decode(nextPath)), nextToReport);
                }
                // set nextToReport to be this sequence number. It's the next one we
                // might report, if we don't find any targets for this document.
                // Note that the sequence number must be defined when the targetId
                // is 0.
                nextToReport = sequenceNumber;
                nextPath = path;
            }
            else {
                // set nextToReport to be invalid, we know we don't need to report
                // this one since we found a target for it.
                nextToReport = ListenSequence.INVALID;
            }
        })
            .next(function () {
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            if (nextToReport !== ListenSequence.INVALID) {
                f(new DocumentKey(decode(nextPath)), nextToReport);
            }
        });
    };
    IndexedDbLruDelegate.prototype.getCacheSize = function (txn) {
        return this.db.getRemoteDocumentCache().getSize(txn);
    };
    return IndexedDbLruDelegate;
}());
function sentinelKey$1(key) {
    return [0, encode(key.path)];
}
/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */
function sentinelRow(key, sequenceNumber) {
    return new DbTargetDocument(0, encode(key.path), sequenceNumber);
}
function writeSentinelKey(txn, key) {
    return documentTargetStore(txn).put(sentinelRow(key, txn.currentSequenceNumber));
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TypeOrder;
(function (TypeOrder) {
    // This order is defined by the backend.
    TypeOrder[TypeOrder["NullValue"] = 0] = "NullValue";
    TypeOrder[TypeOrder["BooleanValue"] = 1] = "BooleanValue";
    TypeOrder[TypeOrder["NumberValue"] = 2] = "NumberValue";
    TypeOrder[TypeOrder["TimestampValue"] = 3] = "TimestampValue";
    TypeOrder[TypeOrder["StringValue"] = 4] = "StringValue";
    TypeOrder[TypeOrder["BlobValue"] = 5] = "BlobValue";
    TypeOrder[TypeOrder["RefValue"] = 6] = "RefValue";
    TypeOrder[TypeOrder["GeoPointValue"] = 7] = "GeoPointValue";
    TypeOrder[TypeOrder["ArrayValue"] = 8] = "ArrayValue";
    TypeOrder[TypeOrder["ObjectValue"] = 9] = "ObjectValue";
})(TypeOrder || (TypeOrder = {}));
/** Defines the return value for pending server timestamps. */
var ServerTimestampBehavior;
(function (ServerTimestampBehavior) {
    ServerTimestampBehavior[ServerTimestampBehavior["Default"] = 0] = "Default";
    ServerTimestampBehavior[ServerTimestampBehavior["Estimate"] = 1] = "Estimate";
    ServerTimestampBehavior[ServerTimestampBehavior["Previous"] = 2] = "Previous";
})(ServerTimestampBehavior || (ServerTimestampBehavior = {}));
/** Holds properties that define field value deserialization options. */
var FieldValueOptions = /** @class */ (function () {
    function FieldValueOptions(serverTimestampBehavior, timestampsInSnapshots) {
        this.serverTimestampBehavior = serverTimestampBehavior;
        this.timestampsInSnapshots = timestampsInSnapshots;
    }
    FieldValueOptions.fromSnapshotOptions = function (options, timestampsInSnapshots) {
        switch (options.serverTimestamps) {
            case 'estimate':
                return new FieldValueOptions(ServerTimestampBehavior.Estimate, timestampsInSnapshots);
            case 'previous':
                return new FieldValueOptions(ServerTimestampBehavior.Previous, timestampsInSnapshots);
            case 'none': // Fall-through intended.
            case undefined:
                return new FieldValueOptions(ServerTimestampBehavior.Default, timestampsInSnapshots);
            default:
                return fail('fromSnapshotOptions() called with invalid options.');
        }
    };
    return FieldValueOptions;
}());
/**
 * A field value represents a datatype as stored by Firestore.
 */
var FieldValue = /** @class */ (function () {
    function FieldValue() {
    }
    FieldValue.prototype.toString = function () {
        var val = this.value();
        return val === null ? 'null' : val.toString();
    };
    FieldValue.prototype.defaultCompareTo = function (other) {
        assert(this.typeOrder !== other.typeOrder, 'Default compareTo should not be used for values of same type.');
        var cmp = primitiveComparator(this.typeOrder, other.typeOrder);
        return cmp;
    };
    return FieldValue;
}());
var NullValue = /** @class */ (function (_super) {
    tslib_1.__extends(NullValue, _super);
    function NullValue() {
        var _this = _super.call(this) || this;
        _this.typeOrder = TypeOrder.NullValue;
        // internalValue is unused but we add it to work around
        // https://github.com/Microsoft/TypeScript/issues/15585
        _this.internalValue = null;
        return _this;
    }
    NullValue.prototype.value = function (options) {
        return null;
    };
    NullValue.prototype.isEqual = function (other) {
        return other instanceof NullValue;
    };
    NullValue.prototype.compareTo = function (other) {
        if (other instanceof NullValue) {
            return 0;
        }
        return this.defaultCompareTo(other);
    };
    NullValue.INSTANCE = new NullValue();
    return NullValue;
}(FieldValue));
var BooleanValue = /** @class */ (function (_super) {
    tslib_1.__extends(BooleanValue, _super);
    function BooleanValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BooleanValue;
        return _this;
    }
    BooleanValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BooleanValue.prototype.isEqual = function (other) {
        return (other instanceof BooleanValue &&
            this.internalValue === other.internalValue);
    };
    BooleanValue.prototype.compareTo = function (other) {
        if (other instanceof BooleanValue) {
            return primitiveComparator(this, other);
        }
        return this.defaultCompareTo(other);
    };
    BooleanValue.of = function (value) {
        return value ? BooleanValue.TRUE : BooleanValue.FALSE;
    };
    BooleanValue.TRUE = new BooleanValue(true);
    BooleanValue.FALSE = new BooleanValue(false);
    return BooleanValue;
}(FieldValue));
/** Base class for IntegerValue and DoubleValue. */
var NumberValue = /** @class */ (function (_super) {
    tslib_1.__extends(NumberValue, _super);
    function NumberValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.NumberValue;
        return _this;
    }
    NumberValue.prototype.value = function (options) {
        return this.internalValue;
    };
    NumberValue.prototype.compareTo = function (other) {
        if (other instanceof NumberValue) {
            return numericComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return NumberValue;
}(FieldValue));
/** Utility function to compare doubles (using Firestore semantics for NaN). */
function numericComparator(left, right) {
    if (left < right) {
        return -1;
    }
    else if (left > right) {
        return 1;
    }
    else if (left === right) {
        return 0;
    }
    else {
        // one or both are NaN.
        if (isNaN(left)) {
            return isNaN(right) ? 0 : -1;
        }
        else {
            return 1;
        }
    }
}
/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */
function numericEquals(left, right) {
    // Implemented based on Object.is() polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    if (left === right) {
        // +0 != -0
        return left !== 0 || 1 / left === 1 / right;
    }
    else {
        // NaN == NaN
        return left !== left && right !== right;
    }
}
var IntegerValue = /** @class */ (function (_super) {
    tslib_1.__extends(IntegerValue, _super);
    function IntegerValue(internalValue) {
        return _super.call(this, internalValue) || this;
    }
    IntegerValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof IntegerValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    return IntegerValue;
}(NumberValue));
var DoubleValue = /** @class */ (function (_super) {
    tslib_1.__extends(DoubleValue, _super);
    function DoubleValue(internalValue) {
        var _this = _super.call(this, internalValue) || this;
        _this.internalValue = internalValue;
        return _this;
    }
    DoubleValue.prototype.isEqual = function (other) {
        // NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
        // but that doesn't make them equal via isEqual().
        if (other instanceof DoubleValue) {
            return numericEquals(this.internalValue, other.internalValue);
        }
        else {
            return false;
        }
    };
    DoubleValue.NAN = new DoubleValue(NaN);
    DoubleValue.POSITIVE_INFINITY = new DoubleValue(Infinity);
    DoubleValue.NEGATIVE_INFINITY = new DoubleValue(-Infinity);
    return DoubleValue;
}(NumberValue));
// TODO(b/37267885): Add truncation support
var StringValue = /** @class */ (function (_super) {
    tslib_1.__extends(StringValue, _super);
    function StringValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.StringValue;
        return _this;
    }
    StringValue.prototype.value = function (options) {
        return this.internalValue;
    };
    StringValue.prototype.isEqual = function (other) {
        return (other instanceof StringValue && this.internalValue === other.internalValue);
    };
    StringValue.prototype.compareTo = function (other) {
        if (other instanceof StringValue) {
            return primitiveComparator(this.internalValue, other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return StringValue;
}(FieldValue));
var TimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(TimestampValue, _super);
    function TimestampValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    TimestampValue.prototype.value = function (options) {
        if (!options || options.timestampsInSnapshots) {
            return this.internalValue;
        }
        else {
            return this.internalValue.toDate();
        }
    };
    TimestampValue.prototype.isEqual = function (other) {
        return (other instanceof TimestampValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    TimestampValue.prototype.compareTo = function (other) {
        if (other instanceof TimestampValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        else if (other instanceof ServerTimestampValue) {
            // Concrete timestamps come before server timestamps.
            return -1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    return TimestampValue;
}(FieldValue));
/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */
var ServerTimestampValue = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampValue, _super);
    function ServerTimestampValue(localWriteTime, previousValue) {
        var _this = _super.call(this) || this;
        _this.localWriteTime = localWriteTime;
        _this.previousValue = previousValue;
        _this.typeOrder = TypeOrder.TimestampValue;
        return _this;
    }
    ServerTimestampValue.prototype.value = function (options) {
        if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Estimate) {
            return new TimestampValue(this.localWriteTime).value(options);
        }
        else if (options &&
            options.serverTimestampBehavior === ServerTimestampBehavior.Previous) {
            return this.previousValue ? this.previousValue.value(options) : null;
        }
        else {
            return null;
        }
    };
    ServerTimestampValue.prototype.isEqual = function (other) {
        return (other instanceof ServerTimestampValue &&
            this.localWriteTime.isEqual(other.localWriteTime));
    };
    ServerTimestampValue.prototype.compareTo = function (other) {
        if (other instanceof ServerTimestampValue) {
            return this.localWriteTime._compareTo(other.localWriteTime);
        }
        else if (other instanceof TimestampValue) {
            // Server timestamps come after all concrete timestamps.
            return 1;
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ServerTimestampValue.prototype.toString = function () {
        return '<ServerTimestamp localTime=' + this.localWriteTime.toString() + '>';
    };
    return ServerTimestampValue;
}(FieldValue));
var BlobValue = /** @class */ (function (_super) {
    tslib_1.__extends(BlobValue, _super);
    function BlobValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.BlobValue;
        return _this;
    }
    BlobValue.prototype.value = function (options) {
        return this.internalValue;
    };
    BlobValue.prototype.isEqual = function (other) {
        return (other instanceof BlobValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    BlobValue.prototype.compareTo = function (other) {
        if (other instanceof BlobValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return BlobValue;
}(FieldValue));
var RefValue = /** @class */ (function (_super) {
    tslib_1.__extends(RefValue, _super);
    function RefValue(databaseId, key) {
        var _this = _super.call(this) || this;
        _this.databaseId = databaseId;
        _this.key = key;
        _this.typeOrder = TypeOrder.RefValue;
        return _this;
    }
    RefValue.prototype.value = function (options) {
        return this.key;
    };
    RefValue.prototype.isEqual = function (other) {
        if (other instanceof RefValue) {
            return (this.key.isEqual(other.key) && this.databaseId.isEqual(other.databaseId));
        }
        else {
            return false;
        }
    };
    RefValue.prototype.compareTo = function (other) {
        if (other instanceof RefValue) {
            var cmp = this.databaseId.compareTo(other.databaseId);
            return cmp !== 0 ? cmp : DocumentKey.comparator(this.key, other.key);
        }
        return this.defaultCompareTo(other);
    };
    return RefValue;
}(FieldValue));
var GeoPointValue = /** @class */ (function (_super) {
    tslib_1.__extends(GeoPointValue, _super);
    function GeoPointValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.GeoPointValue;
        return _this;
    }
    GeoPointValue.prototype.value = function (options) {
        return this.internalValue;
    };
    GeoPointValue.prototype.isEqual = function (other) {
        return (other instanceof GeoPointValue &&
            this.internalValue.isEqual(other.internalValue));
    };
    GeoPointValue.prototype.compareTo = function (other) {
        if (other instanceof GeoPointValue) {
            return this.internalValue._compareTo(other.internalValue);
        }
        return this.defaultCompareTo(other);
    };
    return GeoPointValue;
}(FieldValue));
var ObjectValue = /** @class */ (function (_super) {
    tslib_1.__extends(ObjectValue, _super);
    function ObjectValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ObjectValue;
        return _this;
    }
    ObjectValue.prototype.value = function (options) {
        var result = {};
        this.internalValue.inorderTraversal(function (key, val) {
            result[key] = val.value(options);
        });
        return result;
    };
    ObjectValue.prototype.forEach = function (action) {
        this.internalValue.inorderTraversal(action);
    };
    ObjectValue.prototype.isEqual = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                if (next1.key !== next2.key || !next1.value.isEqual(next2.value)) {
                    return false;
                }
            }
            return !it1.hasNext() && !it2.hasNext();
        }
        return false;
    };
    ObjectValue.prototype.compareTo = function (other) {
        if (other instanceof ObjectValue) {
            var it1 = this.internalValue.getIterator();
            var it2 = other.internalValue.getIterator();
            while (it1.hasNext() && it2.hasNext()) {
                var next1 = it1.getNext();
                var next2 = it2.getNext();
                var cmp = primitiveComparator(next1.key, next2.key) ||
                    next1.value.compareTo(next2.value);
                if (cmp) {
                    return cmp;
                }
            }
            // Only equal if both iterators are exhausted
            return primitiveComparator(it1.hasNext(), it2.hasNext());
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ObjectValue.prototype.set = function (path, to) {
        assert(!path.isEmpty(), 'Cannot set field for empty path on ObjectValue');
        if (path.length === 1) {
            return this.setChild(path.firstSegment(), to);
        }
        else {
            var child = this.child(path.firstSegment());
            if (!(child instanceof ObjectValue)) {
                child = ObjectValue.EMPTY;
            }
            var newChild = child.set(path.popFirst(), to);
            return this.setChild(path.firstSegment(), newChild);
        }
    };
    ObjectValue.prototype.delete = function (path) {
        assert(!path.isEmpty(), 'Cannot delete field for empty path on ObjectValue');
        if (path.length === 1) {
            return new ObjectValue(this.internalValue.remove(path.firstSegment()));
        }
        else {
            // nested field
            var child = this.child(path.firstSegment());
            if (child instanceof ObjectValue) {
                var newChild = child.delete(path.popFirst());
                return new ObjectValue(this.internalValue.insert(path.firstSegment(), newChild));
            }
            else {
                // Don't actually change a primitive value to an object for a delete
                return this;
            }
        }
    };
    ObjectValue.prototype.contains = function (path) {
        return this.field(path) !== undefined;
    };
    ObjectValue.prototype.field = function (path) {
        assert(!path.isEmpty(), "Can't get field of empty path");
        var field = this;
        path.forEach(function (pathSegment) {
            if (field instanceof ObjectValue) {
                field = field.internalValue.get(pathSegment) || undefined;
            }
            else {
                field = undefined;
            }
        });
        return field;
    };
    ObjectValue.prototype.toString = function () {
        return this.internalValue.toString();
    };
    ObjectValue.prototype.child = function (childName) {
        return this.internalValue.get(childName) || undefined;
    };
    ObjectValue.prototype.setChild = function (childName, value) {
        return new ObjectValue(this.internalValue.insert(childName, value));
    };
    ObjectValue.EMPTY = new ObjectValue(new SortedMap(primitiveComparator));
    return ObjectValue;
}(FieldValue));
var ArrayValue = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayValue, _super);
    function ArrayValue(internalValue) {
        var _this = _super.call(this) || this;
        _this.internalValue = internalValue;
        _this.typeOrder = TypeOrder.ArrayValue;
        return _this;
    }
    ArrayValue.prototype.value = function (options) {
        return this.internalValue.map(function (v) { return v.value(options); });
    };
    /**
     * Returns true if the given value is contained in this array.
     */
    ArrayValue.prototype.contains = function (value) {
        for (var _i = 0, _a = this.internalValue; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element.isEqual(value)) {
                return true;
            }
        }
        return false;
    };
    ArrayValue.prototype.forEach = function (action) {
        this.internalValue.forEach(action);
    };
    ArrayValue.prototype.isEqual = function (other) {
        if (other instanceof ArrayValue) {
            if (this.internalValue.length !== other.internalValue.length) {
                return false;
            }
            for (var i = 0; i < this.internalValue.length; i++) {
                if (!this.internalValue[i].isEqual(other.internalValue[i])) {
                    return false;
                }
            }
            return true;
        }
        return false;
    };
    ArrayValue.prototype.compareTo = function (other) {
        if (other instanceof ArrayValue) {
            var minLength = Math.min(this.internalValue.length, other.internalValue.length);
            for (var i = 0; i < minLength; i++) {
                var cmp = this.internalValue[i].compareTo(other.internalValue[i]);
                if (cmp) {
                    return cmp;
                }
            }
            return primitiveComparator(this.internalValue.length, other.internalValue.length);
        }
        else {
            return this.defaultCompareTo(other);
        }
    };
    ArrayValue.prototype.toString = function () {
        var descriptions = this.internalValue.map(function (v) { return v.toString(); });
        return "[" + descriptions.join(',') + "]";
    };
    return ArrayValue;
}(FieldValue));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */
var FieldMask = /** @class */ (function () {
    function FieldMask(fields) {
        this.fields = fields;
        // TODO(dimond): validation of FieldMask
    }
    FieldMask.fromSet = function (fields) {
        return new FieldMask(fields);
    };
    FieldMask.fromArray = function (fields) {
        var fieldsAsSet = new SortedSet(FieldPath.comparator);
        fields.forEach(function (fieldPath) { return (fieldsAsSet = fieldsAsSet.add(fieldPath)); });
        return new FieldMask(fieldsAsSet);
    };
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */
    FieldMask.prototype.covers = function (fieldPath) {
        var found = false;
        this.fields.forEach(function (fieldMaskPath) {
            if (fieldMaskPath.isPrefixOf(fieldPath)) {
                found = true;
            }
        });
        return found;
    };
    /**
     * Applies this field mask to the provided object value and returns an object
     * that only contains fields that are specified in both the input object and
     * this field mask.
     */
    FieldMask.prototype.applyTo = function (data) {
        var filteredObject = ObjectValue.EMPTY;
        this.fields.forEach(function (fieldMaskPath) {
            if (fieldMaskPath.isEmpty()) {
                return data;
            }
            else {
                var newValue = data.field(fieldMaskPath);
                if (newValue !== undefined) {
                    filteredObject = filteredObject.set(fieldMaskPath, newValue);
                }
            }
        });
        return filteredObject;
    };
    FieldMask.prototype.isEqual = function (other) {
        return this.fields.isEqual(other.fields);
    };
    return FieldMask;
}());
/** A field path and the TransformOperation to perform upon it. */
var FieldTransform = /** @class */ (function () {
    function FieldTransform(field, transform) {
        this.field = field;
        this.transform = transform;
    }
    Object.defineProperty(FieldTransform.prototype, "isIdempotent", {
        /** Whether this field transform is idempotent. */
        get: function () {
            return this.transform.isIdempotent;
        },
        enumerable: true,
        configurable: true
    });
    FieldTransform.prototype.isEqual = function (other) {
        return (this.field.isEqual(other.field) && this.transform.isEqual(other.transform));
    };
    return FieldTransform;
}());
/** The result of successfully applying a mutation to the backend. */
var MutationResult = /** @class */ (function () {
    function MutationResult(
    /**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */
    version, 
    /**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */
    transformResults) {
        this.version = version;
        this.transformResults = transformResults;
    }
    return MutationResult;
}());
var MutationType;
(function (MutationType) {
    MutationType[MutationType["Set"] = 0] = "Set";
    MutationType[MutationType["Patch"] = 1] = "Patch";
    MutationType[MutationType["Transform"] = 2] = "Transform";
    MutationType[MutationType["Delete"] = 3] = "Delete";
})(MutationType || (MutationType = {}));
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */
var Precondition = /** @class */ (function () {
    function Precondition(updateTime, exists) {
        this.updateTime = updateTime;
        this.exists = exists;
        assert(updateTime === undefined || exists === undefined, 'Precondition can specify "exists" or "updateTime" but not both');
    }
    /** Creates a new Precondition with an exists flag. */
    Precondition.exists = function (exists) {
        return new Precondition(undefined, exists);
    };
    /** Creates a new Precondition based on a version a document exists at. */
    Precondition.updateTime = function (version) {
        return new Precondition(version);
    };
    Object.defineProperty(Precondition.prototype, "isNone", {
        /** Returns whether this Precondition is empty. */
        get: function () {
            return this.updateTime === undefined && this.exists === undefined;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */
    Precondition.prototype.isValidFor = function (maybeDoc) {
        if (this.updateTime !== undefined) {
            return (maybeDoc instanceof Document &&
                maybeDoc.version.isEqual(this.updateTime));
        }
        else if (this.exists !== undefined) {
            return this.exists === maybeDoc instanceof Document;
        }
        else {
            assert(this.isNone, 'Precondition should be empty');
            return true;
        }
    };
    Precondition.prototype.isEqual = function (other) {
        return (equals(this.updateTime, other.updateTime) &&
            this.exists === other.exists);
    };
    Precondition.NONE = new Precondition();
    return Precondition;
}());
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */
var Mutation = /** @class */ (function () {
    function Mutation() {
    }
    Mutation.prototype.verifyKeyMatches = function (maybeDoc) {
        if (maybeDoc != null) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply a mutation to a document with the same key');
        }
    };
    /**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */
    Mutation.getPostMutationVersion = function (maybeDoc) {
        if (maybeDoc instanceof Document) {
            return maybeDoc.version;
        }
        else {
            return SnapshotVersion.MIN;
        }
    };
    return Mutation;
}());
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */
var SetMutation = /** @class */ (function (_super) {
    tslib_1.__extends(SetMutation, _super);
    function SetMutation(key, value, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.value = value;
        _this.precondition = precondition;
        _this.type = MutationType.Set;
        return _this;
    }
    SetMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by SetMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        var version = mutationResult.version;
        return new Document(this.key, version, this.value, {
            hasCommittedMutations: true
        });
    };
    SetMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        return new Document(this.key, version, this.value, {
            hasLocalMutations: true
        });
    };
    Object.defineProperty(SetMutation.prototype, "isIdempotent", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SetMutation.prototype, "fieldMask", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    SetMutation.prototype.isEqual = function (other) {
        return (other instanceof SetMutation &&
            this.key.isEqual(other.key) &&
            this.value.isEqual(other.value) &&
            this.precondition.isEqual(other.precondition));
    };
    return SetMutation;
}(Mutation));
/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */
var PatchMutation = /** @class */ (function (_super) {
    tslib_1.__extends(PatchMutation, _super);
    function PatchMutation(key, data, fieldMask, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.data = data;
        _this.fieldMask = fieldMask;
        _this.precondition = precondition;
        _this.type = MutationType.Patch;
        return _this;
    }
    PatchMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by PatchMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, mutationResult.version, newData, {
            hasCommittedMutations: true
        });
    };
    PatchMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var version = Mutation.getPostMutationVersion(maybeDoc);
        var newData = this.patchDocument(maybeDoc);
        return new Document(this.key, version, newData, {
            hasLocalMutations: true
        });
    };
    Object.defineProperty(PatchMutation.prototype, "isIdempotent", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    PatchMutation.prototype.isEqual = function (other) {
        return (other instanceof PatchMutation &&
            this.key.isEqual(other.key) &&
            this.fieldMask.isEqual(other.fieldMask) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */
    PatchMutation.prototype.patchDocument = function (maybeDoc) {
        var data;
        if (maybeDoc instanceof Document) {
            data = maybeDoc.data;
        }
        else {
            data = ObjectValue.EMPTY;
        }
        return this.patchObject(data);
    };
    PatchMutation.prototype.patchObject = function (data) {
        var _this = this;
        this.fieldMask.fields.forEach(function (fieldPath) {
            if (!fieldPath.isEmpty()) {
                var newValue = _this.data.field(fieldPath);
                if (newValue !== undefined) {
                    data = data.set(fieldPath, newValue);
                }
                else {
                    data = data.delete(fieldPath);
                }
            }
        });
        return data;
    };
    return PatchMutation;
}(Mutation));
/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */
var TransformMutation = /** @class */ (function (_super) {
    tslib_1.__extends(TransformMutation, _super);
    function TransformMutation(key, fieldTransforms) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.fieldTransforms = fieldTransforms;
        _this.type = MutationType.Transform;
        // NOTE: We set a precondition of exists: true as a safety-check, since we
        // always combine TransformMutations with a SetMutation or PatchMutation which
        // (if successful) should end up with an existing document.
        _this.precondition = Precondition.exists(true);
        return _this;
    }
    TransformMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults != null, 'Transform results missing for TransformMutation.');
        if (!this.precondition.isValidFor(maybeDoc)) {
            // Since the mutation was not rejected, we know that the  precondition
            // matched on the backend. We therefore must not have the expected version
            // of the document in our cache and return an UnknownDocument with the
            // known updateTime.
            return new UnknownDocument(this.key, mutationResult.version);
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.serverTransformResults(maybeDoc, mutationResult.transformResults);
        var version = mutationResult.version;
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, version, newData, {
            hasCommittedMutations: true
        });
    };
    TransformMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        var doc = this.requireDocument(maybeDoc);
        var transformResults = this.localTransformResults(localWriteTime, baseDoc);
        var newData = this.transformObject(doc.data, transformResults);
        return new Document(this.key, doc.version, newData, {
            hasLocalMutations: true
        });
    };
    Object.defineProperty(TransformMutation.prototype, "isIdempotent", {
        get: function () {
            for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
                var fieldTransform = _a[_i];
                if (!fieldTransform.isIdempotent) {
                    return false;
                }
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransformMutation.prototype, "fieldMask", {
        get: function () {
            var fieldMask = new SortedSet(FieldPath.comparator);
            this.fieldTransforms.forEach(function (transform) { return (fieldMask = fieldMask.add(transform.field)); });
            return new FieldMask(fieldMask);
        },
        enumerable: true,
        configurable: true
    });
    TransformMutation.prototype.isEqual = function (other) {
        return (other instanceof TransformMutation &&
            this.key.isEqual(other.key) &&
            arrayEquals(this.fieldTransforms, other.fieldTransforms) &&
            this.precondition.isEqual(other.precondition));
    };
    /**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */
    TransformMutation.prototype.requireDocument = function (maybeDoc) {
        assert(maybeDoc instanceof Document, 'Unknown MaybeDocument type ' + maybeDoc);
        var doc = maybeDoc;
        assert(doc.key.isEqual(this.key), 'Can only transform a document with the same key');
        return doc;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */
    TransformMutation.prototype.serverTransformResults = function (baseDoc, serverTransformResults) {
        var transformResults = [];
        assert(this.fieldTransforms.length === serverTransformResults.length, "server transform result count (" + serverTransformResults.length + ") " +
            ("should match field transform count (" + this.fieldTransforms.length + ")"));
        for (var i = 0; i < serverTransformResults.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToRemoteDocument(previousValue, serverTransformResults[i]));
        }
        return transformResults;
    };
    /**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */
    TransformMutation.prototype.localTransformResults = function (localWriteTime, baseDoc) {
        var transformResults = [];
        for (var _i = 0, _a = this.fieldTransforms; _i < _a.length; _i++) {
            var fieldTransform = _a[_i];
            var transform = fieldTransform.transform;
            var previousValue = null;
            if (baseDoc instanceof Document) {
                previousValue = baseDoc.field(fieldTransform.field) || null;
            }
            transformResults.push(transform.applyToLocalView(previousValue, localWriteTime));
        }
        return transformResults;
    };
    TransformMutation.prototype.transformObject = function (data, transformResults) {
        assert(transformResults.length === this.fieldTransforms.length, 'TransformResults length mismatch.');
        for (var i = 0; i < this.fieldTransforms.length; i++) {
            var fieldTransform = this.fieldTransforms[i];
            var fieldPath = fieldTransform.field;
            data = data.set(fieldPath, transformResults[i]);
        }
        return data;
    };
    return TransformMutation;
}(Mutation));
/** A mutation that deletes the document at the given key. */
var DeleteMutation = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteMutation, _super);
    function DeleteMutation(key, precondition) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.precondition = precondition;
        _this.type = MutationType.Delete;
        return _this;
    }
    DeleteMutation.prototype.applyToRemoteDocument = function (maybeDoc, mutationResult) {
        this.verifyKeyMatches(maybeDoc);
        assert(mutationResult.transformResults == null, 'Transform results received by DeleteMutation.');
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        return new NoDocument(this.key, mutationResult.version, {
            hasCommittedMutations: true
        });
    };
    DeleteMutation.prototype.applyToLocalView = function (maybeDoc, baseDoc, localWriteTime) {
        this.verifyKeyMatches(maybeDoc);
        if (!this.precondition.isValidFor(maybeDoc)) {
            return maybeDoc;
        }
        if (maybeDoc) {
            assert(maybeDoc.key.isEqual(this.key), 'Can only apply mutation to document with same key');
        }
        return new NoDocument(this.key, SnapshotVersion.forDeletedDoc());
    };
    DeleteMutation.prototype.isEqual = function (other) {
        return (other instanceof DeleteMutation &&
            this.key.isEqual(other.key) &&
            this.precondition.isEqual(other.precondition));
    };
    Object.defineProperty(DeleteMutation.prototype, "isIdempotent", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeleteMutation.prototype, "fieldMask", {
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return DeleteMutation;
}(Mutation));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */
var LocalDocumentsView = /** @class */ (function () {
    function LocalDocumentsView(remoteDocumentCache, mutationQueue, indexManager) {
        this.remoteDocumentCache = remoteDocumentCache;
        this.mutationQueue = mutationQueue;
        this.indexManager = indexManager;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */
    LocalDocumentsView.prototype.getDocument = function (transaction, key) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKey(transaction, key)
            .next(function (batches) { return _this.getDocumentInternal(transaction, key, batches); });
    };
    /** Internal version of `getDocument` that allows reusing batches. */
    LocalDocumentsView.prototype.getDocumentInternal = function (transaction, key, inBatches) {
        return this.remoteDocumentCache.getEntry(transaction, key).next(function (doc) {
            for (var _i = 0, inBatches_1 = inBatches; _i < inBatches_1.length; _i++) {
                var batch = inBatches_1[_i];
                doc = batch.applyToLocalView(key, doc);
            }
            return doc;
        });
    };
    // Returns the view of the given `docs` as they would appear after applying
    // all mutations in the given `batches`.
    LocalDocumentsView.prototype.applyLocalMutationsToDocuments = function (transaction, docs, batches) {
        var results = nullableMaybeDocumentMap();
        docs.forEach(function (key, localView) {
            for (var _i = 0, batches_1 = batches; _i < batches_1.length; _i++) {
                var batch = batches_1[_i];
                localView = batch.applyToLocalView(key, localView);
            }
            results = results.insert(key, localView);
        });
        return results;
    };
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */
    LocalDocumentsView.prototype.getDocuments = function (transaction, keys) {
        var _this = this;
        return this.remoteDocumentCache
            .getEntries(transaction, keys)
            .next(function (docs) { return _this.getLocalViewOfDocuments(transaction, docs); });
    };
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */
    LocalDocumentsView.prototype.getLocalViewOfDocuments = function (transaction, baseDocs) {
        var _this = this;
        return this.mutationQueue
            .getAllMutationBatchesAffectingDocumentKeys(transaction, baseDocs)
            .next(function (batches) {
            var docs = _this.applyLocalMutationsToDocuments(transaction, baseDocs, batches);
            var results = maybeDocumentMap();
            docs.forEach(function (key, maybeDoc) {
                // TODO(http://b/32275378): Don't conflate missing / deleted.
                if (!maybeDoc) {
                    maybeDoc = new NoDocument(key, SnapshotVersion.forDeletedDoc());
                }
                results = results.insert(key, maybeDoc);
            });
            return results;
        });
    };
    /** Performs a query against the local view of all documents. */
    LocalDocumentsView.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        if (query.isDocumentQuery()) {
            return this.getDocumentsMatchingDocumentQuery(transaction, query.path);
        }
        else if (query.isCollectionGroupQuery()) {
            return this.getDocumentsMatchingCollectionGroupQuery(transaction, query);
        }
        else {
            return this.getDocumentsMatchingCollectionQuery(transaction, query);
        }
    };
    LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery = function (transaction, docPath) {
        // Just do a simple document lookup.
        return this.getDocument(transaction, new DocumentKey(docPath)).next(function (maybeDoc) {
            var result = documentMap();
            if (maybeDoc instanceof Document) {
                result = result.insert(maybeDoc.key, maybeDoc);
            }
            return result;
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionGroupQuery = function (transaction, query) {
        var _this = this;
        assert(query.path.isEmpty(), 'Currently we only support collection group queries at the root.');
        var collectionId = query.collectionGroup;
        var results = documentMap();
        return this.indexManager
            .getCollectionParents(transaction, collectionId)
            .next(function (parents) {
            // Perform a collection query against each parent that contains the
            // collectionId and aggregate the results.
            return PersistencePromise.forEach(parents, function (parent) {
                var collectionQuery = query.asCollectionQueryAtPath(parent.child(collectionId));
                return _this.getDocumentsMatchingCollectionQuery(transaction, collectionQuery).next(function (r) {
                    r.forEach(function (key, doc) {
                        results = results.insert(key, doc);
                    });
                });
            }).next(function () { return results; });
        });
    };
    LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery = function (transaction, query) {
        var _this = this;
        // Query the remote documents and overlay mutations.
        var results;
        return this.remoteDocumentCache
            .getDocumentsMatchingQuery(transaction, query)
            .next(function (queryResults) {
            results = queryResults;
            return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction, query);
        })
            .next(function (matchingMutationBatches) {
            for (var _i = 0, matchingMutationBatches_1 = matchingMutationBatches; _i < matchingMutationBatches_1.length; _i++) {
                var batch = matchingMutationBatches_1[_i];
                for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                    var mutation = _b[_a];
                    var key = mutation.key;
                    // Only process documents belonging to the collection.
                    if (!query.path.isImmediateParentOf(key.path)) {
                        continue;
                    }
                    var baseDoc = results.get(key);
                    var mutatedDoc = mutation.applyToLocalView(baseDoc, baseDoc, batch.localWriteTime);
                    if (mutatedDoc instanceof Document) {
                        results = results.insert(key, mutatedDoc);
                    }
                    else {
                        results = results.remove(key);
                    }
                }
            }
        })
            .next(function () {
            // Finally, filter out any documents that don't actually match
            // the query.
            results.forEach(function (key, doc) {
                if (!query.matches(doc)) {
                    results = results.remove(key);
                }
            });
            return results;
        });
    };
    return LocalDocumentsView;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */
var ReferenceSet = /** @class */ (function () {
    function ReferenceSet() {
        // A set of outstanding references to a document sorted by key.
        this.refsByKey = new SortedSet(DocReference.compareByKey);
        // A set of outstanding references to a document sorted by target id.
        this.refsByTarget = new SortedSet(DocReference.compareByTargetId);
    }
    /** Returns true if the reference set contains no references. */
    ReferenceSet.prototype.isEmpty = function () {
        return this.refsByKey.isEmpty();
    };
    /** Adds a reference to the given document key for the given ID. */
    ReferenceSet.prototype.addReference = function (key, id) {
        var ref = new DocReference(key, id);
        this.refsByKey = this.refsByKey.add(ref);
        this.refsByTarget = this.refsByTarget.add(ref);
    };
    /** Add references to the given document keys for the given ID. */
    ReferenceSet.prototype.addReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.addReference(key, id); });
    };
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */
    ReferenceSet.prototype.removeReference = function (key, id) {
        this.removeRef(new DocReference(key, id));
    };
    ReferenceSet.prototype.removeReferences = function (keys, id) {
        var _this = this;
        keys.forEach(function (key) { return _this.removeReference(key, id); });
    };
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */
    ReferenceSet.prototype.removeReferencesForId = function (id) {
        var _this = this;
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = [];
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            _this.removeRef(ref);
            keys.push(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.removeAllReferences = function () {
        var _this = this;
        this.refsByKey.forEach(function (ref) { return _this.removeRef(ref); });
    };
    ReferenceSet.prototype.removeRef = function (ref) {
        this.refsByKey = this.refsByKey.delete(ref);
        this.refsByTarget = this.refsByTarget.delete(ref);
    };
    ReferenceSet.prototype.referencesForId = function (id) {
        var emptyKey = DocumentKey.EMPTY;
        var startRef = new DocReference(emptyKey, id);
        var endRef = new DocReference(emptyKey, id + 1);
        var keys = documentKeySet();
        this.refsByTarget.forEachInRange([startRef, endRef], function (ref) {
            keys = keys.add(ref.key);
        });
        return keys;
    };
    ReferenceSet.prototype.containsKey = function (key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.refsByKey.firstAfterOrEqual(ref);
        return firstRef !== null && key.isEqual(firstRef.key);
    };
    return ReferenceSet;
}());
var DocReference = /** @class */ (function () {
    function DocReference(key, targetOrBatchId) {
        this.key = key;
        this.targetOrBatchId = targetOrBatchId;
    }
    /** Compare by key then by ID */
    DocReference.compareByKey = function (left, right) {
        return (DocumentKey.comparator(left.key, right.key) ||
            primitiveComparator(left.targetOrBatchId, right.targetOrBatchId));
    };
    /** Compare by ID then by key */
    DocReference.compareByTargetId = function (left, right) {
        return (primitiveComparator(left.targetOrBatchId, right.targetOrBatchId) ||
            DocumentKey.comparator(left.key, right.key));
    };
    return DocReference;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$2 = 'LocalStore';
/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */
var LocalStore = /** @class */ (function () {
    function LocalStore(
    /** Manages our in-memory or durable persistence. */
    persistence, initialUser) {
        this.persistence = persistence;
        /**
         * The set of document references maintained by any local views.
         */
        this.localViewReferences = new ReferenceSet();
        /** Maps a targetID to data about its query. */
        this.queryDataByTarget = {};
        assert(persistence.started, 'LocalStore was passed an unstarted persistence implementation');
        this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);
        this.mutationQueue = persistence.getMutationQueue(initialUser);
        this.remoteDocuments = persistence.getRemoteDocumentCache();
        this.queryCache = persistence.getQueryCache();
        this.localDocuments = new LocalDocumentsView(this.remoteDocuments, this.mutationQueue, this.persistence.getIndexManager());
    }
    /**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */
    // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    LocalStore.prototype.handleUserChange = function (user) {
        var _this = this;
        return this.persistence.runTransaction('Handle user change', 'readonly', function (txn) {
            // Swap out the mutation queue, grabbing the pending mutation batches
            // before and after.
            var oldBatches;
            return _this.mutationQueue
                .getAllMutationBatches(txn)
                .next(function (promisedOldBatches) {
                oldBatches = promisedOldBatches;
                _this.mutationQueue = _this.persistence.getMutationQueue(user);
                // Recreate our LocalDocumentsView using the new
                // MutationQueue.
                _this.localDocuments = new LocalDocumentsView(_this.remoteDocuments, _this.mutationQueue, _this.persistence.getIndexManager());
                return _this.mutationQueue.getAllMutationBatches(txn);
            })
                .next(function (newBatches) {
                var removedBatchIds = [];
                var addedBatchIds = [];
                // Union the old/new changed keys.
                var changedKeys = documentKeySet();
                for (var _i = 0, oldBatches_1 = oldBatches; _i < oldBatches_1.length; _i++) {
                    var batch = oldBatches_1[_i];
                    removedBatchIds.push(batch.batchId);
                    for (var _a = 0, _b = batch.mutations; _a < _b.length; _a++) {
                        var mutation = _b[_a];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                for (var _c = 0, newBatches_1 = newBatches; _c < newBatches_1.length; _c++) {
                    var batch = newBatches_1[_c];
                    addedBatchIds.push(batch.batchId);
                    for (var _d = 0, _e = batch.mutations; _d < _e.length; _d++) {
                        var mutation = _e[_d];
                        changedKeys = changedKeys.add(mutation.key);
                    }
                }
                // Return the set of all (potentially) changed documents and the list
                // of mutation batch IDs that were affected by change.
                return _this.localDocuments
                    .getDocuments(txn, changedKeys)
                    .next(function (affectedDocuments) {
                    return {
                        affectedDocuments: affectedDocuments,
                        removedBatchIds: removedBatchIds,
                        addedBatchIds: addedBatchIds
                    };
                });
            });
        });
    };
    /* Accept locally generated Mutations and commit them to storage. */
    LocalStore.prototype.localWrite = function (mutations) {
        var _this = this;
        var localWriteTime = Timestamp.now();
        var keys = mutations.reduce(function (keys, m) { return keys.add(m.key); }, documentKeySet());
        return this.persistence.runTransaction('Locally write mutations', 'readwrite', function (txn) {
            // Load and apply all existing mutations. This lets us compute the
            // current base state for all non-idempotent transforms before applying
            // any additional user-provided writes.
            return _this.localDocuments
                .getDocuments(txn, keys)
                .next(function (existingDocs) {
                // For non-idempotent mutations (such as `FieldValue.increment()`),
                // we record the base state in a separate patch mutation. This is
                // later used to guarantee consistent values and prevents flicker
                // even if the backend sends us an update that already includes our
                // transform.
                var baseMutations = [];
                for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
                    var mutation = mutations_1[_i];
                    var maybeDoc = existingDocs.get(mutation.key);
                    if (!mutation.isIdempotent) {
                        // Theoretically, we should only include non-idempotent fields
                        // in this field mask as this mask is used to populate the base
                        // state for all DocumentTransforms.  By  including all fields,
                        // we incorrectly prevent rebasing of idempotent transforms
                        // (such as `arrayUnion()`) when any non-idempotent transforms
                        // are present.
                        var fieldMask = mutation.fieldMask;
                        if (fieldMask) {
                            var baseValues = maybeDoc instanceof Document
                                ? fieldMask.applyTo(maybeDoc.data)
                                : ObjectValue.EMPTY;
                            // NOTE: The base state should only be applied if there's some
                            // existing document to override, so use a Precondition of
                            // exists=true
                            baseMutations.push(new PatchMutation(mutation.key, baseValues, fieldMask, Precondition.exists(true)));
                        }
                    }
                }
                return _this.mutationQueue
                    .addMutationBatch(txn, localWriteTime, baseMutations, mutations)
                    .next(function (batch) {
                    var changes = batch.applyToLocalDocumentSet(existingDocs);
                    return { batchId: batch.batchId, changes: changes };
                });
            });
        });
    };
    /** Returns the local view of the documents affected by a mutation batch. */
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.lookupMutationDocuments = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Lookup mutation documents', 'readonly', function (txn) {
            return _this.mutationQueue
                .lookupMutationKeys(txn, batchId)
                .next(function (keys) {
                if (keys) {
                    return _this.localDocuments.getDocuments(txn, keys);
                }
                else {
                    return PersistencePromise.resolve(null);
                }
            });
        });
    };
    /**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */
    LocalStore.prototype.acknowledgeBatch = function (batchResult) {
        var _this = this;
        return this.persistence.runTransaction('Acknowledge batch', 'readwrite-primary', function (txn) {
            var affected = batchResult.batch.keys();
            var documentBuffer = _this.remoteDocuments.newChangeBuffer();
            return _this.mutationQueue
                .acknowledgeBatch(txn, batchResult.batch, batchResult.streamToken)
                .next(function () {
                return _this.applyWriteToRemoteDocuments(txn, batchResult, documentBuffer);
            })
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () { return _this.mutationQueue.performConsistencyCheck(txn); })
                .next(function () { return _this.localDocuments.getDocuments(txn, affected); });
        });
    };
    /**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */
    LocalStore.prototype.rejectBatch = function (batchId) {
        var _this = this;
        return this.persistence.runTransaction('Reject batch', 'readwrite-primary', function (txn) {
            var affectedKeys;
            return _this.mutationQueue
                .lookupMutationBatch(txn, batchId)
                .next(function (batch) {
                assert(batch !== null, 'Attempt to reject nonexistent batch!');
                affectedKeys = batch.keys();
                return _this.mutationQueue.removeMutationBatch(txn, batch);
            })
                .next(function () {
                return _this.mutationQueue.performConsistencyCheck(txn);
            })
                .next(function () {
                return _this.localDocuments.getDocuments(txn, affectedKeys);
            });
        });
    };
    /** Returns the last recorded stream token for the current user. */
    LocalStore.prototype.getLastStreamToken = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last stream token', 'readonly', function (txn) {
            return _this.mutationQueue.getLastStreamToken(txn);
        });
    };
    /**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */
    LocalStore.prototype.setLastStreamToken = function (streamToken) {
        var _this = this;
        return this.persistence.runTransaction('Set last stream token', 'readwrite-primary', function (txn) {
            return _this.mutationQueue.setLastStreamToken(txn, streamToken);
        });
    };
    /**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */
    LocalStore.prototype.getLastRemoteSnapshotVersion = function () {
        var _this = this;
        return this.persistence.runTransaction('Get last remote snapshot version', 'readonly', function (txn) { return _this.queryCache.getLastRemoteSnapshotVersion(txn); });
    };
    /**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */
    LocalStore.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        var documentBuffer = this.remoteDocuments.newChangeBuffer();
        return this.persistence.runTransaction('Apply remote event', 'readwrite-primary', function (txn) {
            var promises = [];
            var authoritativeUpdates = documentKeySet();
            forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
                // Do not ref/unref unassigned targetIds - it may lead to leaks.
                var queryData = _this.queryDataByTarget[targetId];
                if (!queryData)
                    return;
                // When a global snapshot contains updates (either add or modify) we
                // can completely trust these updates as authoritative and blindly
                // apply them to our cache (as a defensive measure to promote
                // self-healing in the unfortunate case that our cache is ever somehow
                // corrupted / out-of-sync).
                //
                // If the document is only updated while removing it from a target
                // then watch isn't obligated to send the absolute latest version: it
                // can send the first version that caused the document not to match.
                change.addedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                change.modifiedDocuments.forEach(function (key) {
                    authoritativeUpdates = authoritativeUpdates.add(key);
                });
                promises.push(_this.queryCache
                    .removeMatchingKeys(txn, change.removedDocuments, targetId)
                    .next(function () {
                    return _this.queryCache.addMatchingKeys(txn, change.addedDocuments, targetId);
                }));
                // Update the resume token if the change includes one. Don't clear
                // any preexisting value.
                var resumeToken = change.resumeToken;
                if (resumeToken.length > 0) {
                    var oldQueryData = queryData;
                    queryData = queryData.copy({
                        resumeToken: resumeToken,
                        snapshotVersion: remoteEvent.snapshotVersion
                    });
                    _this.queryDataByTarget[targetId] = queryData;
                    if (LocalStore.shouldPersistQueryData(oldQueryData, queryData, change)) {
                        promises.push(_this.queryCache.updateQueryData(txn, queryData));
                    }
                }
            });
            var changedDocs = maybeDocumentMap();
            var updatedKeys = documentKeySet();
            remoteEvent.documentUpdates.forEach(function (key, doc) {
                updatedKeys = updatedKeys.add(key);
            });
            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
            // documents in advance in a single call.
            promises.push(documentBuffer.getEntries(txn, updatedKeys).next(function (existingDocs) {
                remoteEvent.documentUpdates.forEach(function (key, doc) {
                    var existingDoc = existingDocs.get(key);
                    // If a document update isn't authoritative, make sure we don't
                    // apply an old document version to the remote cache. We make an
                    // exception for SnapshotVersion.MIN which can happen for
                    // manufactured events (e.g. in the case of a limbo document
                    // resolution failing).
                    if (existingDoc == null ||
                        doc.version.isEqual(SnapshotVersion.MIN) ||
                        (authoritativeUpdates.has(doc.key) &&
                            !existingDoc.hasPendingWrites) ||
                        doc.version.compareTo(existingDoc.version) >= 0) {
                        documentBuffer.addEntry(doc);
                        changedDocs = changedDocs.insert(key, doc);
                    }
                    else {
                        debug(LOG_TAG$2, 'Ignoring outdated watch update for ', key, '. Current version:', existingDoc.version, ' Watch version:', doc.version);
                    }
                    if (remoteEvent.resolvedLimboDocuments.has(key)) {
                        promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn, key));
                    }
                });
            }));
            // HACK: The only reason we allow a null snapshot version is so that we
            // can synthesize remote events when we get permission denied errors while
            // trying to resolve the state of a locally cached document that is in
            // limbo.
            var remoteVersion = remoteEvent.snapshotVersion;
            if (!remoteVersion.isEqual(SnapshotVersion.MIN)) {
                var updateRemoteVersion = _this.queryCache
                    .getLastRemoteSnapshotVersion(txn)
                    .next(function (lastRemoteVersion) {
                    assert(remoteVersion.compareTo(lastRemoteVersion) >= 0, 'Watch stream reverted to previous snapshot?? ' +
                        remoteVersion +
                        ' < ' +
                        lastRemoteVersion);
                    return _this.queryCache.setTargetsMetadata(txn, txn.currentSequenceNumber, remoteVersion);
                });
                promises.push(updateRemoteVersion);
            }
            return PersistencePromise.waitFor(promises)
                .next(function () { return documentBuffer.apply(txn); })
                .next(function () {
                return _this.localDocuments.getLocalViewOfDocuments(txn, changedDocs);
            });
        });
    };
    /**
     * Returns true if the newQueryData should be persisted during an update of
     * an active target. QueryData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, QueryData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */
    LocalStore.shouldPersistQueryData = function (oldQueryData, newQueryData, change) {
        // Avoid clearing any existing value
        if (newQueryData.resumeToken.length === 0)
            return false;
        // Any resume token is interesting if there isn't one already.
        if (oldQueryData.resumeToken.length === 0)
            return true;
        // Don't allow resume token changes to be buffered indefinitely. This
        // allows us to be reasonably up-to-date after a crash and avoids needing
        // to loop over all active queries on shutdown. Especially in the browser
        // we may not get time to do anything interesting while the current tab is
        // closing.
        var timeDelta = newQueryData.snapshotVersion.toMicroseconds() -
            oldQueryData.snapshotVersion.toMicroseconds();
        if (timeDelta >= this.RESUME_TOKEN_MAX_AGE_MICROS)
            return true;
        // Otherwise if the only thing that has changed about a target is its resume
        // token it's not worth persisting. Note that the RemoteStore keeps an
        // in-memory view of the currently active targets which includes the current
        // resume token, so stream failure or user changes will still use an
        // up-to-date resume token regardless of what we do here.
        var changes = change.addedDocuments.size +
            change.modifiedDocuments.size +
            change.removedDocuments.size;
        return changes > 0;
    };
    /**
     * Notify local store of the changed views to locally pin documents.
     */
    LocalStore.prototype.notifyLocalViewChanges = function (viewChanges) {
        var _this = this;
        return this.persistence.runTransaction('notifyLocalViewChanges', 'readwrite', function (txn) {
            return PersistencePromise.forEach(viewChanges, function (viewChange) {
                _this.localViewReferences.addReferences(viewChange.addedKeys, viewChange.targetId);
                _this.localViewReferences.removeReferences(viewChange.removedKeys, viewChange.targetId);
                return PersistencePromise.forEach(viewChange.removedKeys, function (key) {
                    return _this.persistence.referenceDelegate.removeReference(txn, key);
                });
            });
        });
    };
    /**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */
    LocalStore.prototype.nextMutationBatch = function (afterBatchId) {
        var _this = this;
        return this.persistence.runTransaction('Get next mutation batch', 'readonly', function (txn) {
            if (afterBatchId === undefined) {
                afterBatchId = BATCHID_UNKNOWN;
            }
            return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn, afterBatchId);
        });
    };
    /**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */
    LocalStore.prototype.readDocument = function (key) {
        var _this = this;
        return this.persistence.runTransaction('read document', 'readonly', function (txn) {
            return _this.localDocuments.getDocument(txn, key);
        });
    };
    /**
     * Assigns the given query an internal ID so that its results can be pinned so
     * they don't get GC'd. A query must be allocated in the local store before
     * the store can be used to manage its view.
     */
    LocalStore.prototype.allocateQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Allocate query', 'readwrite', function (txn) {
            var queryData;
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (cached) {
                if (cached) {
                    // This query has been listened to previously, so reuse the
                    // previous targetID.
                    // TODO(mcg): freshen last accessed date?
                    queryData = cached;
                    return PersistencePromise.resolve();
                }
                else {
                    return _this.queryCache.allocateTargetId(txn).next(function (targetId) {
                        queryData = new QueryData(query, targetId, QueryPurpose.Listen, txn.currentSequenceNumber);
                        return _this.queryCache.addQueryData(txn, queryData);
                    });
                }
            })
                .next(function () {
                assert(!_this.queryDataByTarget[queryData.targetId], 'Tried to allocate an already allocated query: ' + query);
                _this.queryDataByTarget[queryData.targetId] = queryData;
                return queryData;
            });
        });
    };
    /**
     * Unpin all the documents associated with the given query. If
     * `keepPersistedQueryData` is set to false and Eager GC enabled, the method
     * directly removes the associated query data from the query cache.
     */
    // PORTING NOTE: `keepPersistedQueryData` is multi-tab only.
    LocalStore.prototype.releaseQuery = function (query, keepPersistedQueryData) {
        var _this = this;
        var mode = keepPersistedQueryData ? 'readwrite' : 'readwrite-primary';
        return this.persistence.runTransaction('Release query', mode, function (txn) {
            return _this.queryCache
                .getQueryData(txn, query)
                .next(function (queryData) {
                assert(queryData != null, 'Tried to release nonexistent query: ' + query);
                var targetId = queryData.targetId;
                var cachedQueryData = _this.queryDataByTarget[targetId];
                // References for documents sent via Watch are automatically removed when we delete a
                // query's target data from the reference delegate. Since this does not remove references
                // for locally mutated documents, we have to remove the target associations for these
                // documents manually.
                var removed = _this.localViewReferences.removeReferencesForId(targetId);
                delete _this.queryDataByTarget[targetId];
                if (!keepPersistedQueryData) {
                    return PersistencePromise.forEach(removed, function (key) {
                        return _this.persistence.referenceDelegate.removeReference(txn, key);
                    }).next(function () {
                        return _this.persistence.referenceDelegate.removeTarget(txn, cachedQueryData);
                    });
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    /**
     * Runs the specified query against all the documents in the local store and
     * returns the results.
     */
    LocalStore.prototype.executeQuery = function (query) {
        var _this = this;
        return this.persistence.runTransaction('Execute query', 'readonly', function (txn) {
            return _this.localDocuments.getDocumentsMatchingQuery(txn, query);
        });
    };
    /**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */
    LocalStore.prototype.remoteDocumentKeys = function (targetId) {
        var _this = this;
        return this.persistence.runTransaction('Remote document keys', 'readonly', function (txn) {
            return _this.queryCache.getMatchingKeysForTargetId(txn, targetId);
        });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getActiveClients = function () {
        return this.persistence.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.removeCachedMutationBatchMetadata = function (batchId) {
        this.mutationQueue.removeCachedMutationKeys(batchId);
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.setNetworkEnabled = function (networkEnabled) {
        this.persistence.setNetworkEnabled(networkEnabled);
    };
    LocalStore.prototype.applyWriteToRemoteDocuments = function (txn, batchResult, documentBuffer) {
        var _this = this;
        var batch = batchResult.batch;
        var docKeys = batch.keys();
        var promiseChain = PersistencePromise.resolve();
        docKeys.forEach(function (docKey) {
            promiseChain = promiseChain
                .next(function () {
                return documentBuffer.getEntry(txn, docKey);
            })
                .next(function (remoteDoc) {
                var doc = remoteDoc;
                var ackVersion = batchResult.docVersions.get(docKey);
                assert(ackVersion !== null, 'ackVersions should contain every doc in the write.');
                if (!doc || doc.version.compareTo(ackVersion) < 0) {
                    doc = batch.applyToRemoteDocument(docKey, doc, batchResult);
                    if (!doc) {
                        assert(!remoteDoc, 'Mutation batch ' +
                            batch +
                            ' applied to document ' +
                            remoteDoc +
                            ' resulted in null');
                    }
                    else {
                        documentBuffer.addEntry(doc);
                    }
                }
            });
        });
        return promiseChain.next(function () {
            return _this.mutationQueue.removeMutationBatch(txn, batch);
        });
    };
    LocalStore.prototype.collectGarbage = function (garbageCollector) {
        var _this = this;
        return this.persistence.runTransaction('Collect garbage', 'readwrite-primary', function (txn) { return garbageCollector.collect(txn, _this.queryDataByTarget); });
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getQueryForTarget = function (targetId) {
        var _this = this;
        if (this.queryDataByTarget[targetId]) {
            return Promise.resolve(this.queryDataByTarget[targetId].query);
        }
        else {
            return this.persistence.runTransaction('Get query data', 'readonly', function (txn) {
                return _this.queryCache
                    .getQueryDataForTarget(txn, targetId)
                    .next(function (queryData) { return (queryData ? queryData.query : null); });
            });
        }
    };
    // PORTING NOTE: Multi-tab only.
    LocalStore.prototype.getNewDocumentChanges = function () {
        var _this = this;
        return this.persistence.runTransaction('Get new document changes', 'readonly', function (txn) {
            return _this.remoteDocuments.getNewDocumentChanges(txn);
        });
    };
    /**
     * The maximum time to leave a resume token buffered without writing it out.
     * This value is arbitrary: it's long enough to avoid several writes
     * (possibly indefinitely if updates come more frequently than this) but
     * short enough that restarting after crashing will still have a pretty
     * recent resume token.
     */
    LocalStore.RESUME_TOKEN_MAX_AGE_MICROS = 5 * 60 * 1e6;
    return LocalStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryMutationQueue = /** @class */ (function () {
    function MemoryMutationQueue(indexManager, referenceDelegate) {
        this.indexManager = indexManager;
        this.referenceDelegate = referenceDelegate;
        /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */
        this.mutationQueue = [];
        /** Next value to use when assigning sequential IDs to each mutation batch. */
        this.nextBatchId = 1;
        /** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */
        this.lastStreamToken = emptyByteString();
        /** An ordered mapping between documents and the mutations batch IDs. */
        this.batchesByDocumentKey = new SortedSet(DocReference.compareByKey);
    }
    MemoryMutationQueue.prototype.checkEmpty = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.length === 0);
    };
    MemoryMutationQueue.prototype.acknowledgeBatch = function (transaction, batch, streamToken) {
        var batchId = batch.batchId;
        var batchIndex = this.indexOfExistingBatchId(batchId, 'acknowledged');
        assert(batchIndex === 0, 'Can only acknowledge the first batch in the mutation queue');
        // Verify that the batch in the queue is the one to be acknowledged.
        var check = this.mutationQueue[batchIndex];
        assert(batchId === check.batchId, 'Queue ordering failure: expected batch ' +
            batchId +
            ', got batch ' +
            check.batchId);
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.getLastStreamToken = function (transaction) {
        return PersistencePromise.resolve(this.lastStreamToken);
    };
    MemoryMutationQueue.prototype.setLastStreamToken = function (transaction, streamToken) {
        this.lastStreamToken = streamToken;
        return PersistencePromise.resolve();
    };
    MemoryMutationQueue.prototype.addMutationBatch = function (transaction, localWriteTime, baseMutations, mutations) {
        assert(mutations.length !== 0, 'Mutation batches should not be empty');
        var batchId = this.nextBatchId;
        this.nextBatchId++;
        if (this.mutationQueue.length > 0) {
            var prior = this.mutationQueue[this.mutationQueue.length - 1];
            assert(prior.batchId < batchId, 'Mutation batchIDs must be monotonically increasing order');
        }
        var batch = new MutationBatch(batchId, localWriteTime, baseMutations, mutations);
        this.mutationQueue.push(batch);
        // Track references by document key and index collection parents.
        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
            var mutation = mutations_1[_i];
            this.batchesByDocumentKey = this.batchesByDocumentKey.add(new DocReference(mutation.key, batchId));
            this.indexManager.addToCollectionParentIndex(transaction, mutation.key.path.popLast());
        }
        return PersistencePromise.resolve(batch);
    };
    MemoryMutationQueue.prototype.lookupMutationBatch = function (transaction, batchId) {
        return PersistencePromise.resolve(this.findMutationBatch(batchId));
    };
    MemoryMutationQueue.prototype.lookupMutationKeys = function (transaction, batchId) {
        var mutationBatch = this.findMutationBatch(batchId);
        assert(mutationBatch != null, 'Failed to find local mutation batch.');
        return PersistencePromise.resolve(mutationBatch.keys());
    };
    MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId = function (transaction, batchId) {
        var nextBatchId = batchId + 1;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        var rawIndex = this.indexOfBatchId(nextBatchId);
        var index = rawIndex < 0 ? 0 : rawIndex;
        return PersistencePromise.resolve(this.mutationQueue.length > index ? this.mutationQueue[index] : null);
    };
    MemoryMutationQueue.prototype.getAllMutationBatches = function (transaction) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey = function (transaction, documentKey) {
        var _this = this;
        var start = new DocReference(documentKey, 0);
        var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
        var result = [];
        this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
            assert(documentKey.isEqual(ref.key), "Should only iterate over a single key's batches");
            var batch = _this.findMutationBatch(ref.targetOrBatchId);
            assert(batch !== null, 'Batches in the index must exist in the main table');
            result.push(batch);
        });
        return PersistencePromise.resolve(result);
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys = function (transaction, documentKeys) {
        var _this = this;
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        documentKeys.forEach(function (documentKey) {
            var start = new DocReference(documentKey, 0);
            var end = new DocReference(documentKey, Number.POSITIVE_INFINITY);
            _this.batchesByDocumentKey.forEachInRange([start, end], function (ref) {
                assert(documentKey.isEqual(ref.key), "For each key, should only iterate over a single key's batches");
                uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
            });
        });
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery = function (transaction, query) {
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        // Use the query path as a prefix for testing if a document matches the
        // query.
        var prefix = query.path;
        var immediateChildrenPathLength = prefix.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        var startPath = prefix;
        if (!DocumentKey.isDocumentKey(startPath)) {
            startPath = startPath.child('');
        }
        var start = new DocReference(new DocumentKey(startPath), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        var uniqueBatchIDs = new SortedSet(primitiveComparator);
        this.batchesByDocumentKey.forEachWhile(function (ref) {
            var rowKeyPath = ref.key.path;
            if (!prefix.isPrefixOf(rowKeyPath)) {
                return false;
            }
            else {
                // Rows with document keys more than one segment longer than the query
                // path can't be matches. For example, a query on 'rooms' can't match
                // the document /rooms/abc/messages/xyx.
                // TODO(mcg): we'll need a different scanner when we implement
                // ancestor queries.
                if (rowKeyPath.length === immediateChildrenPathLength) {
                    uniqueBatchIDs = uniqueBatchIDs.add(ref.targetOrBatchId);
                }
                return true;
            }
        }, start);
        return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));
    };
    MemoryMutationQueue.prototype.findMutationBatches = function (batchIDs) {
        var _this = this;
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        var result = [];
        batchIDs.forEach(function (batchId) {
            var batch = _this.findMutationBatch(batchId);
            if (batch !== null) {
                result.push(batch);
            }
        });
        return result;
    };
    MemoryMutationQueue.prototype.removeMutationBatch = function (transaction, batch) {
        var _this = this;
        // Find the position of the first batch for removal. This need not be the
        // first entry in the queue.
        var batchIndex = this.indexOfExistingBatchId(batch.batchId, 'removed');
        assert(batchIndex === 0, 'Can only remove the first entry of the mutation queue');
        this.mutationQueue.shift();
        var references = this.batchesByDocumentKey;
        return PersistencePromise.forEach(batch.mutations, function (mutation) {
            var ref = new DocReference(mutation.key, batch.batchId);
            references = references.delete(ref);
            return _this.referenceDelegate.removeMutationReference(transaction, mutation.key);
        }).next(function () {
            _this.batchesByDocumentKey = references;
        });
    };
    MemoryMutationQueue.prototype.removeCachedMutationKeys = function (batchId) {
        // No-op since the memory mutation queue does not maintain a separate cache.
    };
    MemoryMutationQueue.prototype.containsKey = function (txn, key) {
        var ref = new DocReference(key, 0);
        var firstRef = this.batchesByDocumentKey.firstAfterOrEqual(ref);
        return PersistencePromise.resolve(key.isEqual(firstRef && firstRef.key));
    };
    MemoryMutationQueue.prototype.performConsistencyCheck = function (txn) {
        if (this.mutationQueue.length === 0) {
            assert(this.batchesByDocumentKey.isEmpty(), 'Document leak -- detected dangling mutation references when queue is empty.');
        }
        return PersistencePromise.resolve();
    };
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */
    MemoryMutationQueue.prototype.indexOfExistingBatchId = function (batchId, action) {
        var index = this.indexOfBatchId(batchId);
        assert(index >= 0 && index < this.mutationQueue.length, 'Batches must exist to be ' + action);
        return index;
    };
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */
    MemoryMutationQueue.prototype.indexOfBatchId = function (batchId) {
        if (this.mutationQueue.length === 0) {
            // As an index this is past the end of the queue
            return 0;
        }
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        var firstBatchId = this.mutationQueue[0].batchId;
        return batchId - firstBatchId;
    };
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */
    MemoryMutationQueue.prototype.findMutationBatch = function (batchId) {
        var index = this.indexOfBatchId(batchId);
        if (index < 0 || index >= this.mutationQueue.length) {
            return null;
        }
        var batch = this.mutationQueue[index];
        assert(batch.batchId === batchId, 'If found batch must match');
        return batch;
    };
    return MemoryMutationQueue;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MemoryQueryCache = /** @class */ (function () {
    function MemoryQueryCache(persistence) {
        this.persistence = persistence;
        /**
         * Maps a query to the data about that query
         */
        this.queries = new ObjectMap(function (q) { return q.canonicalId(); });
        /** The last received snapshot version. */
        this.lastRemoteSnapshotVersion = SnapshotVersion.MIN;
        /** The highest numbered target ID encountered. */
        this.highestTargetId = 0;
        /** The highest sequence number encountered. */
        this.highestSequenceNumber = 0;
        /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */
        this.references = new ReferenceSet();
        this.targetCount = 0;
        this.targetIdGenerator = TargetIdGenerator.forQueryCache();
    }
    MemoryQueryCache.prototype.getTargetCount = function (txn) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.forEachTarget = function (txn, f) {
        this.queries.forEach(function (_, queryData) { return f(queryData); });
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getLastRemoteSnapshotVersion = function (transaction) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    };
    MemoryQueryCache.prototype.getHighestSequenceNumber = function (transaction) {
        return PersistencePromise.resolve(this.highestSequenceNumber);
    };
    MemoryQueryCache.prototype.allocateTargetId = function (transaction) {
        var nextTargetId = this.targetIdGenerator.after(this.highestTargetId);
        this.highestTargetId = nextTargetId;
        return PersistencePromise.resolve(nextTargetId);
    };
    MemoryQueryCache.prototype.setTargetsMetadata = function (transaction, highestListenSequenceNumber, lastRemoteSnapshotVersion) {
        if (lastRemoteSnapshotVersion) {
            this.lastRemoteSnapshotVersion = lastRemoteSnapshotVersion;
        }
        if (highestListenSequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = highestListenSequenceNumber;
        }
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.saveQueryData = function (queryData) {
        this.queries.set(queryData.query, queryData);
        var targetId = queryData.targetId;
        if (targetId > this.highestTargetId) {
            this.highestTargetId = targetId;
        }
        if (queryData.sequenceNumber > this.highestSequenceNumber) {
            this.highestSequenceNumber = queryData.sequenceNumber;
        }
    };
    MemoryQueryCache.prototype.addQueryData = function (transaction, queryData) {
        assert(!this.queries.has(queryData.query), 'Adding a query that already exists');
        this.saveQueryData(queryData);
        this.targetCount += 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.updateQueryData = function (transaction, queryData) {
        assert(this.queries.has(queryData.query), 'Updating a non-existent query');
        this.saveQueryData(queryData);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeQueryData = function (transaction, queryData) {
        assert(this.targetCount > 0, 'Removing a target from an empty cache');
        assert(this.queries.has(queryData.query), 'Removing a non-existent target from the cache');
        this.queries.delete(queryData.query);
        this.references.removeReferencesForId(queryData.targetId);
        this.targetCount -= 1;
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.removeTargets = function (transaction, upperBound, activeTargetIds) {
        var _this = this;
        var count = 0;
        var removals = [];
        this.queries.forEach(function (key, queryData) {
            if (queryData.sequenceNumber <= upperBound &&
                !activeTargetIds[queryData.targetId]) {
                _this.queries.delete(key);
                removals.push(_this.removeMatchingKeysForTargetId(transaction, queryData.targetId));
                count++;
            }
        });
        return PersistencePromise.waitFor(removals).next(function () { return count; });
    };
    MemoryQueryCache.prototype.getQueryCount = function (transaction) {
        return PersistencePromise.resolve(this.targetCount);
    };
    MemoryQueryCache.prototype.getQueryData = function (transaction, query) {
        var queryData = this.queries.get(query) || null;
        return PersistencePromise.resolve(queryData);
    };
    MemoryQueryCache.prototype.getQueryDataForTarget = function (transaction, targetId) {
        // This method is only needed for multi-tab and we can't implement it
        // efficiently without additional data structures.
        return fail('Not yet implemented.');
    };
    MemoryQueryCache.prototype.addMatchingKeys = function (txn, keys, targetId) {
        this.references.addReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.addReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeys = function (txn, keys, targetId) {
        this.references.removeReferences(keys, targetId);
        var referenceDelegate = this.persistence.referenceDelegate;
        var promises = [];
        if (referenceDelegate) {
            keys.forEach(function (key) {
                promises.push(referenceDelegate.removeReference(txn, key));
            });
        }
        return PersistencePromise.waitFor(promises);
    };
    MemoryQueryCache.prototype.removeMatchingKeysForTargetId = function (txn, targetId) {
        this.references.removeReferencesForId(targetId);
        return PersistencePromise.resolve();
    };
    MemoryQueryCache.prototype.getMatchingKeysForTargetId = function (txn, targetId) {
        var matchingKeys = this.references.referencesForId(targetId);
        return PersistencePromise.resolve(matchingKeys);
    };
    MemoryQueryCache.prototype.containsKey = function (txn, key) {
        return PersistencePromise.resolve(this.references.containsKey(key));
    };
    return MemoryQueryCache;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function documentSizeMap() {
    return new SortedMap(DocumentKey.comparator);
}
var MemoryRemoteDocumentCache = /** @class */ (function () {
    /**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */
    function MemoryRemoteDocumentCache(indexManager, sizer) {
        this.indexManager = indexManager;
        this.sizer = sizer;
        this.docs = documentSizeMap();
        this.newDocumentChanges = documentKeySet();
        this.size = 0;
    }
    /**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */
    MemoryRemoteDocumentCache.prototype.addEntries = function (transaction, entries, sizeDelta) {
        var promises = [];
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            var key = entry.maybeDocument.key;
            this.docs = this.docs.insert(key, entry);
            this.newDocumentChanges = this.newDocumentChanges.add(key);
            promises.push(this.indexManager.addToCollectionParentIndex(transaction, key.path.popLast()));
        }
        this.size += sizeDelta;
        return PersistencePromise.waitFor(promises);
    };
    /**
     * Removes the specified entry from the cache and updates the size as appropriate.
     */
    MemoryRemoteDocumentCache.prototype.removeEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        if (entry) {
            this.docs = this.docs.remove(documentKey);
            this.size -= entry.size;
            return PersistencePromise.resolve(entry.size);
        }
        else {
            return PersistencePromise.resolve(0);
        }
    };
    MemoryRemoteDocumentCache.prototype.getEntry = function (transaction, documentKey) {
        var entry = this.docs.get(documentKey);
        return PersistencePromise.resolve(entry ? entry.maybeDocument : null);
    };
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntry = function (transaction, documentKey) {
        return PersistencePromise.resolve(this.docs.get(documentKey));
    };
    MemoryRemoteDocumentCache.prototype.getEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
        });
        return PersistencePromise.resolve(results);
    };
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */
    MemoryRemoteDocumentCache.prototype.getSizedEntries = function (transaction, documentKeys) {
        var _this = this;
        var results = nullableMaybeDocumentMap();
        var sizeMap = new SortedMap(DocumentKey.comparator);
        documentKeys.forEach(function (documentKey) {
            var entry = _this.docs.get(documentKey);
            results = results.insert(documentKey, entry ? entry.maybeDocument : null);
            sizeMap = sizeMap.insert(documentKey, entry ? entry.size : 0);
        });
        return PersistencePromise.resolve({ maybeDocuments: results, sizeMap: sizeMap });
    };
    MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery = function (transaction, query) {
        assert(!query.isCollectionGroupQuery(), 'CollectionGroup queries should be handled in LocalDocumentsView');
        var results = documentMap();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        var prefix = new DocumentKey(query.path.child(''));
        var iterator = this.docs.getIteratorFrom(prefix);
        while (iterator.hasNext()) {
            var _a = iterator.getNext(), key = _a.key, maybeDocument = _a.value.maybeDocument;
            if (!query.path.isPrefixOf(key.path)) {
                break;
            }
            if (maybeDocument instanceof Document && query.matches(maybeDocument)) {
                results = results.insert(maybeDocument.key, maybeDocument);
            }
        }
        return PersistencePromise.resolve(results);
    };
    MemoryRemoteDocumentCache.prototype.forEachDocumentKey = function (transaction, f) {
        return PersistencePromise.forEach(this.docs, function (key) { return f(key); });
    };
    MemoryRemoteDocumentCache.prototype.getNewDocumentChanges = function (transaction) {
        var _this = this;
        var changedDocs = maybeDocumentMap();
        this.newDocumentChanges.forEach(function (key) {
            var entry = _this.docs.get(key);
            var changedDoc = entry
                ? entry.maybeDocument
                : new NoDocument(key, SnapshotVersion.forDeletedDoc());
            changedDocs = changedDocs.insert(key, changedDoc);
        });
        this.newDocumentChanges = documentKeySet();
        return PersistencePromise.resolve(changedDocs);
    };
    MemoryRemoteDocumentCache.prototype.newChangeBuffer = function () {
        return new MemoryRemoteDocumentChangeBuffer(this.sizer, this);
    };
    MemoryRemoteDocumentCache.prototype.getSize = function (txn) {
        return PersistencePromise.resolve(this.size);
    };
    return MemoryRemoteDocumentCache;
}());
/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */
var MemoryRemoteDocumentChangeBuffer = /** @class */ (function (_super) {
    tslib_1.__extends(MemoryRemoteDocumentChangeBuffer, _super);
    function MemoryRemoteDocumentChangeBuffer(sizer, documentCache) {
        var _this = _super.call(this) || this;
        _this.sizer = sizer;
        _this.documentCache = documentCache;
        return _this;
    }
    MemoryRemoteDocumentChangeBuffer.prototype.applyChanges = function (transaction) {
        var _this = this;
        var changes = this.assertChanges();
        var delta = 0;
        var docs = [];
        changes.forEach(function (key, maybeDocument) {
            var previousSize = _this.documentSizes.get(key);
            assert(previousSize !== undefined, "Attempting to change document " + key.toString() + " without having read it first");
            var size = _this.sizer(maybeDocument);
            delta += size - previousSize;
            docs.push({ maybeDocument: maybeDocument, size: size });
        });
        return this.documentCache.addEntries(transaction, docs, delta);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getFromCache = function (transaction, documentKey) {
        return this.documentCache.getSizedEntry(transaction, documentKey);
    };
    MemoryRemoteDocumentChangeBuffer.prototype.getAllFromCache = function (transaction, documentKeys) {
        return this.documentCache.getSizedEntries(transaction, documentKeys);
    };
    return MemoryRemoteDocumentChangeBuffer;
}(RemoteDocumentChangeBuffer));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$3 = 'MemoryPersistence';
/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */
var MemoryPersistence = /** @class */ (function () {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */
    function MemoryPersistence(clientId, referenceDelegateFactory) {
        var _this = this;
        this.clientId = clientId;
        this.mutationQueues = {};
        this.listenSequence = new ListenSequence(0);
        this._started = false;
        this._started = true;
        this.referenceDelegate = referenceDelegateFactory(this);
        this.queryCache = new MemoryQueryCache(this);
        var sizer = function (doc) {
            return _this.referenceDelegate.documentSize(doc);
        };
        this.indexManager = new MemoryIndexManager();
        this.remoteDocumentCache = new MemoryRemoteDocumentCache(this.indexManager, sizer);
    }
    MemoryPersistence.createLruPersistence = function (clientId, serializer, params) {
        var factory = function (p) {
            return new MemoryLruDelegate(p, new LocalSerializer(serializer), params);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.createEagerPersistence = function (clientId) {
        var factory = function (p) {
            return new MemoryEagerDelegate(p);
        };
        return new MemoryPersistence(clientId, factory);
    };
    MemoryPersistence.prototype.shutdown = function () {
        // No durable state to ensure is closed on shutdown.
        this._started = false;
        return Promise.resolve();
    };
    Object.defineProperty(MemoryPersistence.prototype, "started", {
        get: function () {
            return this._started;
        },
        enumerable: true,
        configurable: true
    });
    MemoryPersistence.prototype.getActiveClients = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, [this.clientId]];
            });
        });
    };
    MemoryPersistence.prototype.setPrimaryStateListener = function (primaryStateListener) {
        // All clients using memory persistence act as primary.
        return primaryStateListener(true);
    };
    MemoryPersistence.prototype.setDatabaseDeletedListener = function () {
        // No op.
    };
    MemoryPersistence.prototype.setNetworkEnabled = function (networkEnabled) {
        // No op.
    };
    MemoryPersistence.prototype.getIndexManager = function () {
        return this.indexManager;
    };
    MemoryPersistence.prototype.getMutationQueue = function (user) {
        var queue = this.mutationQueues[user.toKey()];
        if (!queue) {
            queue = new MemoryMutationQueue(this.indexManager, this.referenceDelegate);
            this.mutationQueues[user.toKey()] = queue;
        }
        return queue;
    };
    MemoryPersistence.prototype.getQueryCache = function () {
        return this.queryCache;
    };
    MemoryPersistence.prototype.getRemoteDocumentCache = function () {
        return this.remoteDocumentCache;
    };
    MemoryPersistence.prototype.runTransaction = function (action, mode, transactionOperation) {
        var _this = this;
        debug(LOG_TAG$3, 'Starting transaction:', action);
        var txn = new MemoryTransaction(this.listenSequence.next());
        this.referenceDelegate.onTransactionStarted();
        return transactionOperation(txn)
            .next(function (result) {
            return _this.referenceDelegate
                .onTransactionCommitted(txn)
                .next(function () { return result; });
        })
            .toPromise();
    };
    MemoryPersistence.prototype.mutationQueuesContainKey = function (transaction, key) {
        return PersistencePromise.or(values(this.mutationQueues)
            .map(function (queue) { return function () { return queue.containsKey(transaction, key); }; }));
    };
    return MemoryPersistence;
}());
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */
var MemoryTransaction = /** @class */ (function () {
    function MemoryTransaction(currentSequenceNumber) {
        this.currentSequenceNumber = currentSequenceNumber;
    }
    return MemoryTransaction;
}());
var MemoryEagerDelegate = /** @class */ (function () {
    function MemoryEagerDelegate(persistence) {
        this.persistence = persistence;
    }
    MemoryEagerDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryEagerDelegate.prototype.addReference = function (txn, key) {
        this.orphanedDocuments.delete(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedDocuments.add(key);
        return PersistencePromise.resolve();
    };
    MemoryEagerDelegate.prototype.removeTarget = function (txn, queryData) {
        var _this = this;
        var cache = this.persistence.getQueryCache();
        return cache
            .getMatchingKeysForTargetId(txn, queryData.targetId)
            .next(function (keys) {
            keys.forEach(function (key) { return _this.orphanedDocuments.add(key); });
        })
            .next(function () { return cache.removeQueryData(txn, queryData); });
    };
    MemoryEagerDelegate.prototype.onTransactionStarted = function () {
        this.orphanedDocuments = new Set();
    };
    MemoryEagerDelegate.prototype.onTransactionCommitted = function (txn) {
        var _this = this;
        var cache = this.persistence.getRemoteDocumentCache();
        return PersistencePromise.forEach(this.orphanedDocuments, function (key) {
            return _this.isReferenced(txn, key).next(function (isReferenced) {
                if (!isReferenced) {
                    // Since this is the eager delegate and memory persistence,
                    // we don't care about the size of documents. We don't track
                    // the size of the cache for eager GC.
                    return cache.removeEntry(txn, key).next(function () { });
                }
                return PersistencePromise.resolve();
            });
        });
    };
    MemoryEagerDelegate.prototype.updateLimboDocument = function (txn, key) {
        var _this = this;
        return this.isReferenced(txn, key).next(function (isReferenced) {
            if (isReferenced) {
                _this.orphanedDocuments.delete(key);
            }
            else {
                _this.orphanedDocuments.add(key);
            }
        });
    };
    MemoryEagerDelegate.prototype.documentSize = function (doc) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    };
    MemoryEagerDelegate.prototype.isReferenced = function (txn, key) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); }
        ]);
    };
    return MemoryEagerDelegate;
}());
var MemoryLruDelegate = /** @class */ (function () {
    function MemoryLruDelegate(persistence, serializer, lruParams) {
        this.persistence = persistence;
        this.serializer = serializer;
        this.orphanedSequenceNumbers = new ObjectMap(function (k) { return encode(k.path); });
        this.garbageCollector = new LruGarbageCollector(this, lruParams);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    MemoryLruDelegate.prototype.onTransactionStarted = function () { };
    MemoryLruDelegate.prototype.onTransactionCommitted = function (txn) {
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.forEachTarget = function (txn, f) {
        return this.persistence.getQueryCache().forEachTarget(txn, f);
    };
    MemoryLruDelegate.prototype.getSequenceNumberCount = function (txn) {
        var docCountPromise = this.orphanedDocumentCount(txn);
        var targetCountPromise = this.persistence
            .getQueryCache()
            .getTargetCount(txn);
        return targetCountPromise.next(function (targetCount) {
            return docCountPromise.next(function (docCount) { return targetCount + docCount; });
        });
    };
    MemoryLruDelegate.prototype.orphanedDocumentCount = function (txn) {
        var orphanedCount = 0;
        return this.forEachOrphanedDocumentSequenceNumber(txn, function (_) {
            orphanedCount++;
        }).next(function () { return orphanedCount; });
    };
    MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber = function (txn, f) {
        var _this = this;
        return PersistencePromise.forEach(this.orphanedSequenceNumbers, function (key, sequenceNumber) {
            // Pass in the exact sequence number as the upper bound so we know it won't be pinned by
            // being too recent.
            return _this.isPinned(txn, key, sequenceNumber).next(function (isPinned) {
                if (!isPinned) {
                    return f(sequenceNumber);
                }
                else {
                    return PersistencePromise.resolve();
                }
            });
        });
    };
    MemoryLruDelegate.prototype.setInMemoryPins = function (inMemoryPins) {
        this.inMemoryPins = inMemoryPins;
    };
    MemoryLruDelegate.prototype.removeTargets = function (txn, upperBound, activeTargetIds) {
        return this.persistence
            .getQueryCache()
            .removeTargets(txn, upperBound, activeTargetIds);
    };
    MemoryLruDelegate.prototype.removeOrphanedDocuments = function (txn, upperBound) {
        var _this = this;
        var count = 0;
        var cache = this.persistence.getRemoteDocumentCache();
        var p = cache.forEachDocumentKey(txn, function (key) {
            return _this.isPinned(txn, key, upperBound).next(function (isPinned) {
                if (isPinned) {
                    return PersistencePromise.resolve();
                }
                else {
                    count++;
                    // The memory remote document cache does its own byte
                    // accounting on removal. This is ok because updating the size
                    // for memory persistence does not incur IO.
                    return cache.removeEntry(txn, key).next();
                }
            });
        });
        return p.next(function () { return count; });
    };
    MemoryLruDelegate.prototype.removeMutationReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeTarget = function (txn, queryData) {
        var updated = queryData.copy({
            sequenceNumber: txn.currentSequenceNumber
        });
        return this.persistence.getQueryCache().updateQueryData(txn, updated);
    };
    MemoryLruDelegate.prototype.addReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.removeReference = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.updateLimboDocument = function (txn, key) {
        this.orphanedSequenceNumbers.set(key, txn.currentSequenceNumber);
        return PersistencePromise.resolve();
    };
    MemoryLruDelegate.prototype.documentSize = function (maybeDoc) {
        var remoteDocument = this.serializer.toDbRemoteDocument(maybeDoc);
        var value;
        if (remoteDocument.document) {
            value = remoteDocument.document;
        }
        else if (remoteDocument.unknownDocument) {
            value = remoteDocument.unknownDocument;
        }
        else if (remoteDocument.noDocument) {
            value = remoteDocument.noDocument;
        }
        else {
            throw fail('Unknown remote document type');
        }
        return JSON.stringify(value).length;
    };
    MemoryLruDelegate.prototype.isPinned = function (txn, key, upperBound) {
        var _this = this;
        return PersistencePromise.or([
            function () { return _this.persistence.mutationQueuesContainKey(txn, key); },
            function () { return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key)); },
            function () { return _this.persistence.getQueryCache().containsKey(txn, key); },
            function () {
                var orphanedAt = _this.orphanedSequenceNumbers.get(key);
                return PersistencePromise.resolve(orphanedAt !== undefined && orphanedAt > upperBound);
            }
        ]);
    };
    MemoryLruDelegate.prototype.getCacheSize = function (txn) {
        return this.persistence.getRemoteDocumentCache().getSize(txn);
    };
    return MemoryLruDelegate;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Untyped Number alias we can use to check for ES6 methods / properties.
// tslint:disable-next-line:no-any variable-name
var NumberAsAny = Number;
/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MIN_SAFE_INTEGER = NumberAsAny.MIN_SAFE_INTEGER || -(Math.pow(2, 53) - 1);
/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */
var MAX_SAFE_INTEGER = NumberAsAny.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */
var isInteger = NumberAsAny.isInteger ||
    (function (value) {
        return typeof value === 'number' &&
            isFinite(value) &&
            Math.floor(value) === value;
    });
/**
 * Returns whether a variable is either undefined or null.
 */
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */
function isSafeInteger(value) {
    return (isInteger(value) &&
        value <= MAX_SAFE_INTEGER &&
        value >= MIN_SAFE_INTEGER);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$4 = 'ExponentialBackoff';
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */
var ExponentialBackoff = /** @class */ (function () {
    function ExponentialBackoff(
    /**
     * The AsyncQueue to run backoff operations on.
     */
    queue, 
    /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */
    timerId, 
    /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */
    initialDelayMs, 
    /**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */
    backoffFactor, 
    /**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */
    maxDelayMs) {
        this.queue = queue;
        this.timerId = timerId;
        this.initialDelayMs = initialDelayMs;
        this.backoffFactor = backoffFactor;
        this.maxDelayMs = maxDelayMs;
        this.timerPromise = null;
        /** The last backoff attempt, as epoch milliseconds. */
        this.lastAttemptTime = Date.now();
        this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */
    ExponentialBackoff.prototype.reset = function () {
        this.currentBaseMs = 0;
    };
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */
    ExponentialBackoff.prototype.resetToMax = function () {
        this.currentBaseMs = this.maxDelayMs;
    };
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */
    ExponentialBackoff.prototype.backoffAndRun = function (op) {
        var _this = this;
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        var desiredDelayWithJitterMs = Math.floor(this.currentBaseMs + this.jitterDelayMs());
        // Guard against lastAttemptTime being in the future due to a clock change.
        var delaySoFarMs = Math.max(0, Date.now() - this.lastAttemptTime);
        // Guard against the backoff delay already being past.
        var remainingDelayMs = Math.max(0, desiredDelayWithJitterMs - delaySoFarMs);
        if (this.currentBaseMs > 0) {
            debug(LOG_TAG$4, "Backing off for " + remainingDelayMs + " ms " +
                ("(base delay: " + this.currentBaseMs + " ms, ") +
                ("delay with jitter: " + desiredDelayWithJitterMs + " ms, ") +
                ("last attempt: " + delaySoFarMs + " ms ago)"));
        }
        this.timerPromise = this.queue.enqueueAfterDelay(this.timerId, remainingDelayMs, function () {
            _this.lastAttemptTime = Date.now();
            return op();
        });
        // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.currentBaseMs *= this.backoffFactor;
        if (this.currentBaseMs < this.initialDelayMs) {
            this.currentBaseMs = this.initialDelayMs;
        }
        if (this.currentBaseMs > this.maxDelayMs) {
            this.currentBaseMs = this.maxDelayMs;
        }
    };
    ExponentialBackoff.prototype.cancel = function () {
        if (this.timerPromise !== null) {
            this.timerPromise.cancel();
            this.timerPromise = null;
        }
    };
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */
    ExponentialBackoff.prototype.jitterDelayMs = function () {
        return (Math.random() - 0.5) * this.currentBaseMs;
    };
    return ExponentialBackoff;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$5 = 'PersistentStream';
/**
 * PersistentStream can be in one of 5 states (each described in detail below)
 * based on the following state transition diagram:
 *
 *          start() called             auth & connection succeeded
 * INITIAL ----------------> STARTING -----------------------------> OPEN
 *                             ^  |                                   |
 *                             |  |                    error occurred |
 *                             |  \-----------------------------v-----/
 *                             |                                |
 *                    backoff  |                                |
 *                    elapsed  |              start() called    |
 *                             \--- BACKOFF <---------------- ERROR
 *
 * [any state] --------------------------> INITIAL
 *               stop() called or
 *               idle timer expired
 */
var PersistentStreamState;
(function (PersistentStreamState) {
    /**
     * The streaming RPC is not yet running and there's no error condition.
     * Calling start() will start the stream immediately without backoff.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Initial"] = 0] = "Initial";
    /**
     * The stream is starting, either waiting for an auth token or for the stream
     * to successfully open. While in this state, isStarted() will return true but
     * isOpen() will return false.
     */
    PersistentStreamState[PersistentStreamState["Starting"] = 1] = "Starting";
    /**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted() and isOpen() will return true.
     */
    PersistentStreamState[PersistentStreamState["Open"] = 2] = "Open";
    /**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     */
    PersistentStreamState[PersistentStreamState["Error"] = 3] = "Error";
    /**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After waiting is complete, the stream will try to open.
     * While in this state isStarted() will return true but isOpen() will return
     * false.
     */
    PersistentStreamState[PersistentStreamState["Backoff"] = 4] = "Backoff";
})(PersistentStreamState || (PersistentStreamState = {}));
/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */
var BACKOFF_INITIAL_DELAY_MS = 1000;
/** Maximum backoff time in milliseconds */
var BACKOFF_MAX_DELAY_MS = 60 * 1000;
var BACKOFF_FACTOR = 1.5;
/** The time a stream stays open after it is marked idle. */
var IDLE_TIMEOUT_MS = 60 * 1000;
/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */
var PersistentStream = /** @class */ (function () {
    function PersistentStream(queue, connectionTimerId, idleTimerId, connection, credentialsProvider, listener) {
        this.queue = queue;
        this.idleTimerId = idleTimerId;
        this.connection = connection;
        this.credentialsProvider = credentialsProvider;
        this.listener = listener;
        this.state = PersistentStreamState.Initial;
        /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */
        this.closeCount = 0;
        this.idleTimer = null;
        this.stream = null;
        this.backoff = new ExponentialBackoff(queue, connectionTimerId, BACKOFF_INITIAL_DELAY_MS, BACKOFF_FACTOR, BACKOFF_MAX_DELAY_MS);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */
    PersistentStream.prototype.isStarted = function () {
        return (this.state === PersistentStreamState.Starting ||
            this.state === PersistentStreamState.Open ||
            this.state === PersistentStreamState.Backoff);
    };
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */
    PersistentStream.prototype.isOpen = function () {
        return this.state === PersistentStreamState.Open;
    };
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */
    PersistentStream.prototype.start = function () {
        if (this.state === PersistentStreamState.Error) {
            this.performBackoff();
            return;
        }
        assert(this.state === PersistentStreamState.Initial, 'Already started');
        this.auth();
    };
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */
    PersistentStream.prototype.stop = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isStarted()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.close(PersistentStreamState.Initial)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */
    PersistentStream.prototype.inhibitBackoff = function () {
        assert(!this.isStarted(), 'Can only inhibit backoff in a stopped state');
        this.state = PersistentStreamState.Initial;
        this.backoff.reset();
    };
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */
    PersistentStream.prototype.markIdle = function () {
        var _this = this;
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        if (this.isOpen() && this.idleTimer === null) {
            this.idleTimer = this.queue.enqueueAfterDelay(this.idleTimerId, IDLE_TIMEOUT_MS, function () { return _this.handleIdleCloseTimer(); });
        }
    };
    /** Sends a message to the underlying stream. */
    PersistentStream.prototype.sendRequest = function (msg) {
        this.cancelIdleCheck();
        this.stream.send(msg);
    };
    /** Called by the idle timer when the stream should close due to inactivity. */
    PersistentStream.prototype.handleIdleCloseTimer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (this.isOpen()) {
                    // When timing out an idle stream there's no reason to force the stream into backoff when
                    // it restarts so set the stream state to Initial instead of Error.
                    return [2 /*return*/, this.close(PersistentStreamState.Initial)];
                }
                return [2 /*return*/];
            });
        });
    };
    /** Marks the stream as active again. */
    PersistentStream.prototype.cancelIdleCheck = function () {
        if (this.idleTimer) {
            this.idleTimer.cancel();
            this.idleTimer = null;
        }
    };
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */
    PersistentStream.prototype.close = function (finalState, error$1) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assert(this.isStarted(), 'Only started streams should be closed.');
                        assert(finalState === PersistentStreamState.Error || isNullOrUndefined(error$1), "Can't provide an error when not in an error state.");
                        // Cancel any outstanding timers (they're guaranteed not to execute).
                        this.cancelIdleCheck();
                        this.backoff.cancel();
                        // Invalidates any stream-related callbacks (e.g. from auth or the
                        // underlying stream), guaranteeing they won't execute.
                        this.closeCount++;
                        if (finalState !== PersistentStreamState.Error) {
                            // If this is an intentional close ensure we don't delay our next connection attempt.
                            this.backoff.reset();
                        }
                        else if (error$1 && error$1.code === Code.RESOURCE_EXHAUSTED) {
                            // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                            error(error$1.toString());
                            error('Using maximum backoff delay to prevent overloading the backend.');
                            this.backoff.resetToMax();
                        }
                        else if (error$1 && error$1.code === Code.UNAUTHENTICATED) {
                            // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
                            // just expired.
                            this.credentialsProvider.invalidateToken();
                        }
                        // Clean up the underlying stream because we are no longer interested in events.
                        if (this.stream !== null) {
                            this.tearDown();
                            this.stream.close();
                            this.stream = null;
                        }
                        // This state must be assigned before calling onClose() to allow the callback to
                        // inhibit backoff or otherwise manipulate the state in its non-started state.
                        this.state = finalState;
                        // Notify the listener that the stream closed.
                        return [4 /*yield*/, this.listener.onClose(error$1)];
                    case 1:
                        // Notify the listener that the stream closed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */
    PersistentStream.prototype.tearDown = function () { };
    PersistentStream.prototype.auth = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Initial, 'Must be in initial state to auth');
        this.state = PersistentStreamState.Starting;
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        var closeCount = this.closeCount;
        this.credentialsProvider.getToken().then(function (token) {
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            if (_this.closeCount === closeCount) {
                // Normally we'd have to schedule the callback on the AsyncQueue.
                // However, the following calls are safe to be called outside the
                // AsyncQueue since they don't chain asynchronous calls
                _this.startStream(token);
            }
        }, function (error) {
            dispatchIfNotClosed(function () {
                var rpcError = new FirestoreError(Code.UNKNOWN, 'Fetching auth token failed: ' + error.message);
                return _this.handleStreamClose(rpcError);
            });
        });
    };
    PersistentStream.prototype.startStream = function (token) {
        var _this = this;
        assert(this.state === PersistentStreamState.Starting, 'Trying to start stream in a non-starting state');
        var dispatchIfNotClosed = this.getCloseGuardedDispatcher(this.closeCount);
        this.stream = this.startRpc(token);
        this.stream.onOpen(function () {
            dispatchIfNotClosed(function () {
                assert(_this.state === PersistentStreamState.Starting, 'Expected stream to be in state Starting, but was ' + _this.state);
                _this.state = PersistentStreamState.Open;
                return _this.listener.onOpen();
            });
        });
        this.stream.onClose(function (error) {
            dispatchIfNotClosed(function () {
                return _this.handleStreamClose(error);
            });
        });
        this.stream.onMessage(function (msg) {
            dispatchIfNotClosed(function () {
                return _this.onMessage(msg);
            });
        });
    };
    PersistentStream.prototype.performBackoff = function () {
        var _this = this;
        assert(this.state === PersistentStreamState.Error, 'Should only perform backoff when in Error state');
        this.state = PersistentStreamState.Backoff;
        this.backoff.backoffAndRun(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                assert(this.state === PersistentStreamState.Backoff, 'Backoff elapsed but state is now: ' + this.state);
                this.state = PersistentStreamState.Initial;
                this.start();
                assert(this.isStarted(), 'PersistentStream should have started');
                return [2 /*return*/];
            });
        }); });
    };
    // Visible for tests
    PersistentStream.prototype.handleStreamClose = function (error) {
        assert(this.isStarted(), "Can't handle server close on non-started stream");
        debug(LOG_TAG$5, "close with error: " + error);
        this.stream = null;
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return this.close(PersistentStreamState.Error, error);
    };
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */
    PersistentStream.prototype.getCloseGuardedDispatcher = function (startCloseCount) {
        var _this = this;
        return function (fn) {
            _this.queue.enqueueAndForget(function () {
                if (_this.closeCount === startCloseCount) {
                    return fn();
                }
                else {
                    debug(LOG_TAG$5, 'stream callback skipped by getCloseGuardedDispatcher.');
                    return Promise.resolve();
                }
            });
        };
    };
    return PersistentStream;
}());
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */
var PersistentListenStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentListenStream, _super);
    function PersistentListenStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.ListenStreamConnectionBackoff, TimerId.ListenStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        return _this;
    }
    PersistentListenStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Listen', token);
    };
    PersistentListenStream.prototype.onMessage = function (watchChangeProto) {
        // A successful response means the stream is healthy
        this.backoff.reset();
        var watchChange = this.serializer.fromWatchChange(watchChangeProto);
        var snapshot = this.serializer.versionFromListenResponse(watchChangeProto);
        return this.listener.onWatchChange(watchChange, snapshot);
    };
    /**
     * Registers interest in the results of the given query. If the query
     * includes a resumeToken it will be included in the request. Results that
     * affect the query will be streamed back as WatchChange messages that
     * reference the targetId.
     */
    PersistentListenStream.prototype.watch = function (queryData) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.addTarget = this.serializer.toTarget(queryData);
        var labels = this.serializer.toListenRequestLabels(queryData);
        if (labels) {
            request.labels = labels;
        }
        this.sendRequest(request);
    };
    /**
     * Unregisters interest in the results of the query associated with the
     * given targetId.
     */
    PersistentListenStream.prototype.unwatch = function (targetId) {
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        request.removeTarget = targetId;
        this.sendRequest(request);
    };
    return PersistentListenStream;
}(PersistentStream));
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */
var PersistentWriteStream = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentWriteStream, _super);
    function PersistentWriteStream(queue, connection, credentials, serializer, listener) {
        var _this = _super.call(this, queue, TimerId.WriteStreamConnectionBackoff, TimerId.WriteStreamIdle, connection, credentials, listener) || this;
        _this.serializer = serializer;
        _this.handshakeComplete_ = false;
        return _this;
    }
    Object.defineProperty(PersistentWriteStream.prototype, "handshakeComplete", {
        /**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */
        get: function () {
            return this.handshakeComplete_;
        },
        enumerable: true,
        configurable: true
    });
    // Override of PersistentStream.start
    PersistentWriteStream.prototype.start = function () {
        this.handshakeComplete_ = false;
        _super.prototype.start.call(this);
    };
    PersistentWriteStream.prototype.tearDown = function () {
        if (this.handshakeComplete_) {
            this.writeMutations([]);
        }
    };
    PersistentWriteStream.prototype.startRpc = function (token) {
        return this.connection.openStream('Write', token);
    };
    PersistentWriteStream.prototype.onMessage = function (responseProto) {
        // Always capture the last stream token.
        assert(!!responseProto.streamToken, 'Got a write response without a stream token');
        this.lastStreamToken = responseProto.streamToken;
        if (!this.handshakeComplete_) {
            // The first response is always the handshake response
            assert(!responseProto.writeResults || responseProto.writeResults.length === 0, 'Got mutation results for handshake');
            this.handshakeComplete_ = true;
            return this.listener.onHandshakeComplete();
        }
        else {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.backoff.reset();
            var results = this.serializer.fromWriteResults(responseProto.writeResults, responseProto.commitTime);
            var commitVersion = this.serializer.fromVersion(responseProto.commitTime);
            return this.listener.onMutationResult(commitVersion, results);
        }
    };
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */
    PersistentWriteStream.prototype.writeHandshake = function () {
        assert(this.isOpen(), 'Writing handshake requires an opened stream');
        assert(!this.handshakeComplete_, 'Handshake already completed');
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        var request = {};
        request.database = this.serializer.encodedDatabaseId;
        this.sendRequest(request);
    };
    /** Sends a group of mutations to the Firestore backend to apply. */
    PersistentWriteStream.prototype.writeMutations = function (mutations) {
        var _this = this;
        assert(this.isOpen(), 'Writing mutations requires an opened stream');
        assert(this.handshakeComplete_, 'Handshake must be complete before writing mutations');
        assert(this.lastStreamToken.length > 0, 'Trying to write mutation without a token');
        var request = {
            // Protos are typed with string, but we support UInt8Array on Node
            // tslint:disable-next-line:no-any
            streamToken: this.lastStreamToken,
            writes: mutations.map(function (mutation) { return _this.serializer.toMutation(mutation); })
        };
        this.sendRequest(request);
    };
    return PersistentWriteStream;
}(PersistentStream));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */
var Datastore = /** @class */ (function () {
    function Datastore(queue, connection, credentials, serializer) {
        this.queue = queue;
        this.connection = connection;
        this.credentials = credentials;
        this.serializer = serializer;
    }
    Datastore.prototype.newPersistentWriteStream = function (listener) {
        return new PersistentWriteStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.newPersistentWatchStream = function (listener) {
        return new PersistentListenStream(this.queue, this.connection, this.credentials, this.serializer, listener);
    };
    Datastore.prototype.commit = function (mutations) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            writes: mutations.map(function (m) { return _this.serializer.toMutation(m); })
        };
        return this.invokeRPC('Commit', params).then(function (response) {
            return _this.serializer.fromWriteResults(response.writeResults, response.commitTime);
        });
    };
    Datastore.prototype.lookup = function (keys) {
        var _this = this;
        var params = {
            database: this.serializer.encodedDatabaseId,
            documents: keys.map(function (k) { return _this.serializer.toName(k); })
        };
        return this.invokeStreamingRPC('BatchGetDocuments', params).then(function (response) {
            var docs = maybeDocumentMap();
            response.forEach(function (proto) {
                var doc = _this.serializer.fromMaybeDocument(proto);
                docs = docs.insert(doc.key, doc);
            });
            var result = [];
            keys.forEach(function (key) {
                var doc = docs.get(key);
                assert(!!doc, 'Missing entity in write response for ' + key);
                result.push(doc);
            });
            return result;
        });
    };
    /** Gets an auth token and invokes the provided RPC. */
    Datastore.prototype.invokeRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    /** Gets an auth token and invokes the provided RPC with streamed results. */
    Datastore.prototype.invokeStreamingRPC = function (rpcName, request) {
        var _this = this;
        return this.credentials
            .getToken()
            .then(function (token) {
            return _this.connection.invokeStreamingRPC(rpcName, request, token);
        })
            .catch(function (error) {
            if (error.code === Code.UNAUTHENTICATED) {
                _this.credentials.invalidateToken();
            }
            throw error;
        });
    };
    return Datastore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */
var Transaction = /** @class */ (function () {
    function Transaction(datastore) {
        this.datastore = datastore;
        // The version of each document that was read during this transaction.
        this.readVersions = documentVersionMap();
        this.mutations = [];
        this.committed = false;
    }
    Transaction.prototype.recordVersion = function (doc) {
        var docVersion;
        if (doc instanceof Document) {
            docVersion = doc.version;
        }
        else if (doc instanceof NoDocument) {
            // For deleted docs, we must use baseVersion 0 when we overwrite them.
            docVersion = SnapshotVersion.forDeletedDoc();
        }
        else {
            throw fail('Document in a transaction was a ' + doc.constructor.name);
        }
        var existingVersion = this.readVersions.get(doc.key);
        if (existingVersion !== null) {
            if (!docVersion.isEqual(existingVersion)) {
                // This transaction will fail no matter what.
                throw new FirestoreError(Code.ABORTED, 'Document version changed between two reads.');
            }
        }
        else {
            this.readVersions = this.readVersions.insert(doc.key, docVersion);
        }
    };
    Transaction.prototype.lookup = function (keys) {
        var _this = this;
        if (this.committed) {
            return Promise.reject('Transaction has already completed.');
        }
        if (this.mutations.length > 0) {
            return Promise.reject('Transactions lookups are invalid after writes.');
        }
        return this.datastore.lookup(keys).then(function (docs) {
            docs.forEach(function (doc) {
                if (doc instanceof NoDocument || doc instanceof Document) {
                    _this.recordVersion(doc);
                }
                else {
                    fail('Document in a transaction was a ' + doc.constructor.name);
                }
            });
            return docs;
        });
    };
    Transaction.prototype.write = function (mutations) {
        if (this.committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Transaction has already completed.');
        }
        this.mutations = this.mutations.concat(mutations);
    };
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */
    Transaction.prototype.precondition = function (key) {
        var version = this.readVersions.get(key);
        if (version) {
            return Precondition.updateTime(version);
        }
        else {
            return Precondition.NONE;
        }
    };
    /**
     * Returns the precondition for a document if the operation is an update.
     */
    Transaction.prototype.preconditionForUpdate = function (key) {
        var version = this.readVersions.get(key);
        if (version && version.isEqual(SnapshotVersion.forDeletedDoc())) {
            // The document doesn't exist, so fail the transaction.
            throw new FirestoreError(Code.FAILED_PRECONDITION, "Can't update a document that doesn't exist.");
        }
        else if (version) {
            // Document exists, base precondition on document update time.
            return Precondition.updateTime(version);
        }
        else {
            // Document was not read, so we just use the preconditions for a blind
            // update.
            return Precondition.exists(true);
        }
    };
    Transaction.prototype.set = function (key, data) {
        this.write(data.toMutations(key, this.precondition(key)));
    };
    Transaction.prototype.update = function (key, data) {
        this.write(data.toMutations(key, this.preconditionForUpdate(key)));
    };
    Transaction.prototype.delete = function (key) {
        this.write([new DeleteMutation(key, this.precondition(key))]);
        // Since the delete will be applied before all following writes, we need to
        // ensure that the precondition for the next write will be exists: false.
        this.readVersions = this.readVersions.insert(key, SnapshotVersion.forDeletedDoc());
    };
    Transaction.prototype.commit = function () {
        var _this = this;
        var unwritten = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach(function (mutation) {
            unwritten = unwritten.remove(mutation.key);
        });
        if (!unwritten.isEmpty()) {
            return Promise.reject(Error('Every document read in a transaction must also be written.'));
        }
        return this.datastore.commit(this.mutations).then(function () {
            _this.committed = true;
        });
    };
    return Transaction;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Describes the online state of the Firestore client. Note that this does not
 * indicate whether or not the remote store is trying to connect or not. This is
 * primarily used by the View / EventManager code to change their behavior while
 * offline (e.g. get() calls shouldn't wait for data from the server and
 * snapshot events should set metadata.isFromCache=true).
 */
var OnlineState;
(function (OnlineState) {
    /**
     * The Firestore client is in an unknown online state. This means the client
     * is either not actively trying to establish a connection or it is currently
     * trying to establish a connection, but it has not succeeded or failed yet.
     * Higher-level components should not operate in offline mode.
     */
    OnlineState[OnlineState["Unknown"] = 0] = "Unknown";
    /**
     * The client is connected and the connections are healthy. This state is
     * reached after a successful connection and there has been at least one
     * successful message received from the backends.
     */
    OnlineState[OnlineState["Online"] = 1] = "Online";
    /**
     * The client is either trying to establish a connection but failing, or it
     * has been explicitly marked offline via a call to disableNetwork().
     * Higher-level components should operate in offline mode.
     */
    OnlineState[OnlineState["Offline"] = 2] = "Offline";
})(OnlineState || (OnlineState = {}));
/** The source of an online state event. */
var OnlineStateSource;
(function (OnlineStateSource) {
    OnlineStateSource[OnlineStateSource["RemoteStore"] = 0] = "RemoteStore";
    OnlineStateSource[OnlineStateSource["SharedClientState"] = 1] = "SharedClientState";
})(OnlineStateSource || (OnlineStateSource = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$6 = 'OnlineStateTracker';
// To deal with transient failures, we allow multiple stream attempts before
// giving up and transitioning from OnlineState.Unknown to Offline.
// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
// @jdimond thinks that bug is sufficiently fixed so that we can set this back
// to 1. If that works okay, we could potentially remove this logic entirely.
var MAX_WATCH_STREAM_FAILURES = 1;
// To deal with stream attempts that don't succeed or fail in a timely manner,
// we have a timeout for OnlineState to reach Online or Offline.
// If the timeout is reached, we transition to Offline rather than waiting
// indefinitely.
var ONLINE_STATE_TIMEOUT_MS = 10 * 1000;
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */
var OnlineStateTracker = /** @class */ (function () {
    function OnlineStateTracker(asyncQueue, onlineStateHandler) {
        this.asyncQueue = asyncQueue;
        this.onlineStateHandler = onlineStateHandler;
        /** The current OnlineState. */
        this.state = OnlineState.Unknown;
        /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */
        this.watchStreamFailures = 0;
        /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */
        this.onlineStateTimer = null;
        /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */
        this.shouldWarnClientIsOffline = true;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */
    OnlineStateTracker.prototype.handleWatchStreamStart = function () {
        var _this = this;
        if (this.watchStreamFailures === 0) {
            this.setAndBroadcast(OnlineState.Unknown);
            assert(this.onlineStateTimer === null, "onlineStateTimer shouldn't be started yet");
            this.onlineStateTimer = this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout, ONLINE_STATE_TIMEOUT_MS, function () {
                _this.onlineStateTimer = null;
                assert(_this.state === OnlineState.Unknown, 'Timer should be canceled if we transitioned to a different state.');
                _this.logClientOfflineWarningIfNecessary("Backend didn't respond within " + ONLINE_STATE_TIMEOUT_MS / 1000 + " " +
                    "seconds.");
                _this.setAndBroadcast(OnlineState.Offline);
                // NOTE: handleWatchStreamFailure() will continue to increment
                // watchStreamFailures even though we are already marked Offline,
                // but this is non-harmful.
                return Promise.resolve();
            });
        }
    };
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */
    OnlineStateTracker.prototype.handleWatchStreamFailure = function (error) {
        if (this.state === OnlineState.Online) {
            this.setAndBroadcast(OnlineState.Unknown);
            // To get to OnlineState.Online, set() must have been called which would
            // have reset our heuristics.
            assert(this.watchStreamFailures === 0, 'watchStreamFailures must be 0');
            assert(this.onlineStateTimer === null, 'onlineStateTimer must be null');
        }
        else {
            this.watchStreamFailures++;
            if (this.watchStreamFailures >= MAX_WATCH_STREAM_FAILURES) {
                this.clearOnlineStateTimer();
                this.logClientOfflineWarningIfNecessary("Connection failed " + MAX_WATCH_STREAM_FAILURES + " " +
                    ("times. Most recent error: " + error.toString()));
                this.setAndBroadcast(OnlineState.Offline);
            }
        }
    };
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */
    OnlineStateTracker.prototype.set = function (newState) {
        this.clearOnlineStateTimer();
        this.watchStreamFailures = 0;
        if (newState === OnlineState.Online) {
            // We've connected to watch at least once. Don't warn the developer
            // about being offline going forward.
            this.shouldWarnClientIsOffline = false;
        }
        this.setAndBroadcast(newState);
    };
    OnlineStateTracker.prototype.setAndBroadcast = function (newState) {
        if (newState !== this.state) {
            this.state = newState;
            this.onlineStateHandler(newState);
        }
    };
    OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary = function (details) {
        var message = "Could not reach Cloud Firestore backend. " + details + "\n" +
            "This typically indicates that your device does not have a healthy " +
            "Internet connection at the moment. The client will operate in offline " +
            "mode until it is able to successfully connect to the backend.";
        if (this.shouldWarnClientIsOffline) {
            error(message);
            this.shouldWarnClientIsOffline = false;
        }
        else {
            debug(LOG_TAG$6, message);
        }
    };
    OnlineStateTracker.prototype.clearOnlineStateTimer = function () {
        if (this.onlineStateTimer !== null) {
            this.onlineStateTimer.cancel();
            this.onlineStateTimer = null;
        }
    };
    return OnlineStateTracker;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */
var RpcCode;
(function (RpcCode) {
    RpcCode[RpcCode["OK"] = 0] = "OK";
    RpcCode[RpcCode["CANCELLED"] = 1] = "CANCELLED";
    RpcCode[RpcCode["UNKNOWN"] = 2] = "UNKNOWN";
    RpcCode[RpcCode["INVALID_ARGUMENT"] = 3] = "INVALID_ARGUMENT";
    RpcCode[RpcCode["DEADLINE_EXCEEDED"] = 4] = "DEADLINE_EXCEEDED";
    RpcCode[RpcCode["NOT_FOUND"] = 5] = "NOT_FOUND";
    RpcCode[RpcCode["ALREADY_EXISTS"] = 6] = "ALREADY_EXISTS";
    RpcCode[RpcCode["PERMISSION_DENIED"] = 7] = "PERMISSION_DENIED";
    RpcCode[RpcCode["UNAUTHENTICATED"] = 16] = "UNAUTHENTICATED";
    RpcCode[RpcCode["RESOURCE_EXHAUSTED"] = 8] = "RESOURCE_EXHAUSTED";
    RpcCode[RpcCode["FAILED_PRECONDITION"] = 9] = "FAILED_PRECONDITION";
    RpcCode[RpcCode["ABORTED"] = 10] = "ABORTED";
    RpcCode[RpcCode["OUT_OF_RANGE"] = 11] = "OUT_OF_RANGE";
    RpcCode[RpcCode["UNIMPLEMENTED"] = 12] = "UNIMPLEMENTED";
    RpcCode[RpcCode["INTERNAL"] = 13] = "INTERNAL";
    RpcCode[RpcCode["UNAVAILABLE"] = 14] = "UNAVAILABLE";
    RpcCode[RpcCode["DATA_LOSS"] = 15] = "DATA_LOSS";
})(RpcCode || (RpcCode = {}));
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */
function isPermanentError(code) {
    switch (code) {
        case Code.OK:
            return fail('Treated status OK as error');
        case Code.CANCELLED:
        case Code.UNKNOWN:
        case Code.DEADLINE_EXCEEDED:
        case Code.RESOURCE_EXHAUSTED:
        case Code.INTERNAL:
        case Code.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case Code.UNAUTHENTICATED:
            return false;
        case Code.INVALID_ARGUMENT:
        case Code.NOT_FOUND:
        case Code.ALREADY_EXISTS:
        case Code.PERMISSION_DENIED:
        case Code.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case Code.ABORTED:
        case Code.OUT_OF_RANGE:
        case Code.UNIMPLEMENTED:
        case Code.DATA_LOSS:
            return true;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */
function isPermanentWriteError(code) {
    return isPermanentError(code) && code !== Code.ABORTED;
}
/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */
function mapCodeFromRpcStatus(status) {
    // tslint:disable-next-line:no-any lookup by string
    var code = RpcCode[status];
    if (code === undefined) {
        return undefined;
    }
    return mapCodeFromRpcCode(code);
}
/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */
function mapCodeFromRpcCode(code) {
    if (code === undefined) {
        // This shouldn't normally happen, but in certain error cases (like trying
        // to send invalid proto messages) we may get an error with no GRPC code.
        error('GRPC error has no .code');
        return Code.UNKNOWN;
    }
    switch (code) {
        case RpcCode.OK:
            return Code.OK;
        case RpcCode.CANCELLED:
            return Code.CANCELLED;
        case RpcCode.UNKNOWN:
            return Code.UNKNOWN;
        case RpcCode.DEADLINE_EXCEEDED:
            return Code.DEADLINE_EXCEEDED;
        case RpcCode.RESOURCE_EXHAUSTED:
            return Code.RESOURCE_EXHAUSTED;
        case RpcCode.INTERNAL:
            return Code.INTERNAL;
        case RpcCode.UNAVAILABLE:
            return Code.UNAVAILABLE;
        case RpcCode.UNAUTHENTICATED:
            return Code.UNAUTHENTICATED;
        case RpcCode.INVALID_ARGUMENT:
            return Code.INVALID_ARGUMENT;
        case RpcCode.NOT_FOUND:
            return Code.NOT_FOUND;
        case RpcCode.ALREADY_EXISTS:
            return Code.ALREADY_EXISTS;
        case RpcCode.PERMISSION_DENIED:
            return Code.PERMISSION_DENIED;
        case RpcCode.FAILED_PRECONDITION:
            return Code.FAILED_PRECONDITION;
        case RpcCode.ABORTED:
            return Code.ABORTED;
        case RpcCode.OUT_OF_RANGE:
            return Code.OUT_OF_RANGE;
        case RpcCode.UNIMPLEMENTED:
            return Code.UNIMPLEMENTED;
        case RpcCode.DATA_LOSS:
            return Code.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */
function mapRpcCodeFromCode(code) {
    if (code === undefined) {
        return RpcCode.OK;
    }
    switch (code) {
        case Code.OK:
            return RpcCode.OK;
        case Code.CANCELLED:
            return RpcCode.CANCELLED;
        case Code.UNKNOWN:
            return RpcCode.UNKNOWN;
        case Code.DEADLINE_EXCEEDED:
            return RpcCode.DEADLINE_EXCEEDED;
        case Code.RESOURCE_EXHAUSTED:
            return RpcCode.RESOURCE_EXHAUSTED;
        case Code.INTERNAL:
            return RpcCode.INTERNAL;
        case Code.UNAVAILABLE:
            return RpcCode.UNAVAILABLE;
        case Code.UNAUTHENTICATED:
            return RpcCode.UNAUTHENTICATED;
        case Code.INVALID_ARGUMENT:
            return RpcCode.INVALID_ARGUMENT;
        case Code.NOT_FOUND:
            return RpcCode.NOT_FOUND;
        case Code.ALREADY_EXISTS:
            return RpcCode.ALREADY_EXISTS;
        case Code.PERMISSION_DENIED:
            return RpcCode.PERMISSION_DENIED;
        case Code.FAILED_PRECONDITION:
            return RpcCode.FAILED_PRECONDITION;
        case Code.ABORTED:
            return RpcCode.ABORTED;
        case Code.OUT_OF_RANGE:
            return RpcCode.OUT_OF_RANGE;
        case Code.UNIMPLEMENTED:
            return RpcCode.UNIMPLEMENTED;
        case Code.DATA_LOSS:
            return RpcCode.DATA_LOSS;
        default:
            return fail('Unknown status code: ' + code);
    }
}
/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */
function mapCodeFromHttpStatus(status) {
    // The canonical error codes for Google APIs [1] specify mapping onto HTTP
    // status codes but the mapping is not bijective. In each case of ambiguity
    // this function chooses a primary error.
    //
    // [1]
    // https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
    switch (status) {
        case 200: // OK
            return Code.OK;
        case 400: // Bad Request
            return Code.INVALID_ARGUMENT;
        // Other possibilities based on the forward mapping
        // return Code.FAILED_PRECONDITION;
        // return Code.OUT_OF_RANGE;
        case 401: // Unauthorized
            return Code.UNAUTHENTICATED;
        case 403: // Forbidden
            return Code.PERMISSION_DENIED;
        case 404: // Not Found
            return Code.NOT_FOUND;
        case 409: // Conflict
            return Code.ABORTED;
        // Other possibilities:
        // return Code.ALREADY_EXISTS;
        case 416: // Range Not Satisfiable
            return Code.OUT_OF_RANGE;
        case 429: // Too Many Requests
            return Code.RESOURCE_EXHAUSTED;
        case 499: // Client Closed Request
            return Code.CANCELLED;
        case 500: // Internal Server Error
            return Code.UNKNOWN;
        // Other possibilities:
        // return Code.INTERNAL;
        // return Code.DATA_LOSS;
        case 501: // Unimplemented
            return Code.UNIMPLEMENTED;
        case 503: // Service Unavailable
            return Code.UNAVAILABLE;
        case 504: // Gateway Timeout
            return Code.DEADLINE_EXCEEDED;
        default:
            if (status >= 200 && status < 300)
                return Code.OK;
            if (status >= 400 && status < 500)
                return Code.FAILED_PRECONDITION;
            if (status >= 500 && status < 600)
                return Code.INTERNAL;
            return Code.UNKNOWN;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */
var DocumentSet = /** @class */ (function () {
    /** The default ordering is by key if the comparator is omitted */
    function DocumentSet(comp) {
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        if (comp) {
            this.comparator = function (d1, d2) {
                return comp(d1, d2) || DocumentKey.comparator(d1.key, d2.key);
            };
        }
        else {
            this.comparator = function (d1, d2) {
                return DocumentKey.comparator(d1.key, d2.key);
            };
        }
        this.keyedMap = documentMap();
        this.sortedSet = new SortedMap(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */
    DocumentSet.emptySet = function (oldSet) {
        return new DocumentSet(oldSet.comparator);
    };
    DocumentSet.prototype.has = function (key) {
        return this.keyedMap.get(key) != null;
    };
    DocumentSet.prototype.get = function (key) {
        return this.keyedMap.get(key);
    };
    DocumentSet.prototype.first = function () {
        return this.sortedSet.minKey();
    };
    DocumentSet.prototype.last = function () {
        return this.sortedSet.maxKey();
    };
    DocumentSet.prototype.isEmpty = function () {
        return this.sortedSet.isEmpty();
    };
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */
    DocumentSet.prototype.indexOf = function (key) {
        var doc = this.keyedMap.get(key);
        return doc ? this.sortedSet.indexOf(doc) : -1;
    };
    Object.defineProperty(DocumentSet.prototype, "size", {
        get: function () {
            return this.sortedSet.size;
        },
        enumerable: true,
        configurable: true
    });
    /** Iterates documents in order defined by "comparator" */
    DocumentSet.prototype.forEach = function (cb) {
        this.sortedSet.inorderTraversal(function (k, v) {
            cb(k);
            return false;
        });
    };
    /** Inserts or updates a document with the same key */
    DocumentSet.prototype.add = function (doc) {
        // First remove the element if we have it.
        var set = this.delete(doc.key);
        return set.copy(set.keyedMap.insert(doc.key, doc), set.sortedSet.insert(doc, null));
    };
    /** Deletes a document with a given key */
    DocumentSet.prototype.delete = function (key) {
        var doc = this.get(key);
        if (!doc) {
            return this;
        }
        return this.copy(this.keyedMap.remove(key), this.sortedSet.remove(doc));
    };
    DocumentSet.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSet))
            return false;
        if (this.size !== other.size)
            return false;
        var thisIt = this.sortedSet.getIterator();
        var otherIt = other.sortedSet.getIterator();
        while (thisIt.hasNext()) {
            var thisDoc = thisIt.getNext().key;
            var otherDoc = otherIt.getNext().key;
            if (!thisDoc.isEqual(otherDoc))
                return false;
        }
        return true;
    };
    DocumentSet.prototype.toString = function () {
        var docStrings = [];
        this.forEach(function (doc) {
            docStrings.push(doc.toString());
        });
        if (docStrings.length === 0) {
            return 'DocumentSet ()';
        }
        else {
            return 'DocumentSet (\n  ' + docStrings.join('  \n') + '\n)';
        }
    };
    DocumentSet.prototype.copy = function (keyedMap, sortedSet) {
        var newSet = new DocumentSet();
        newSet.comparator = this.comparator;
        newSet.keyedMap = keyedMap;
        newSet.sortedSet = sortedSet;
        return newSet;
    };
    return DocumentSet;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ChangeType;
(function (ChangeType) {
    ChangeType[ChangeType["Added"] = 0] = "Added";
    ChangeType[ChangeType["Removed"] = 1] = "Removed";
    ChangeType[ChangeType["Modified"] = 2] = "Modified";
    ChangeType[ChangeType["Metadata"] = 3] = "Metadata";
})(ChangeType || (ChangeType = {}));
var SyncState;
(function (SyncState) {
    SyncState[SyncState["Local"] = 0] = "Local";
    SyncState[SyncState["Synced"] = 1] = "Synced";
})(SyncState || (SyncState = {}));
/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */
var DocumentChangeSet = /** @class */ (function () {
    function DocumentChangeSet() {
        this.changeMap = new SortedMap(DocumentKey.comparator);
    }
    DocumentChangeSet.prototype.track = function (change) {
        var key = change.doc.key;
        var oldChange = this.changeMap.get(key);
        if (!oldChange) {
            this.changeMap = this.changeMap.insert(key, change);
            return;
        }
        // Merge the new change with the existing change.
        if (change.type !== ChangeType.Added &&
            oldChange.type === ChangeType.Metadata) {
            this.changeMap = this.changeMap.insert(key, change);
        }
        else if (change.type === ChangeType.Metadata &&
            oldChange.type !== ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: oldChange.type,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Modified &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Added,
                doc: change.doc
            });
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Added) {
            this.changeMap = this.changeMap.remove(key);
        }
        else if (change.type === ChangeType.Removed &&
            oldChange.type === ChangeType.Modified) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Removed,
                doc: oldChange.doc
            });
        }
        else if (change.type === ChangeType.Added &&
            oldChange.type === ChangeType.Removed) {
            this.changeMap = this.changeMap.insert(key, {
                type: ChangeType.Modified,
                doc: change.doc
            });
        }
        else {
            // This includes these cases, which don't make sense:
            // Added->Added
            // Removed->Removed
            // Modified->Added
            // Removed->Modified
            // Metadata->Added
            // Removed->Metadata
            fail('unsupported combination of changes: ' +
                JSON.stringify(change) +
                ' after ' +
                JSON.stringify(oldChange));
        }
    };
    DocumentChangeSet.prototype.getChanges = function () {
        var changes = [];
        this.changeMap.inorderTraversal(function (key, change) {
            changes.push(change);
        });
        return changes;
    };
    return DocumentChangeSet;
}());
var ViewSnapshot = /** @class */ (function () {
    function ViewSnapshot(query, docs, oldDocs, docChanges, mutatedKeys, fromCache, syncStateChanged, excludesMetadataChanges) {
        this.query = query;
        this.docs = docs;
        this.oldDocs = oldDocs;
        this.docChanges = docChanges;
        this.mutatedKeys = mutatedKeys;
        this.fromCache = fromCache;
        this.syncStateChanged = syncStateChanged;
        this.excludesMetadataChanges = excludesMetadataChanges;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */
    ViewSnapshot.fromInitialDocuments = function (query, documents, mutatedKeys, fromCache) {
        var changes = [];
        documents.forEach(function (doc) {
            changes.push({ type: ChangeType.Added, doc: doc });
        });
        return new ViewSnapshot(query, documents, DocumentSet.emptySet(documents), changes, mutatedKeys, fromCache, true, false);
    };
    Object.defineProperty(ViewSnapshot.prototype, "hasPendingWrites", {
        get: function () {
            return !this.mutatedKeys.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    ViewSnapshot.prototype.isEqual = function (other) {
        if (this.fromCache !== other.fromCache ||
            this.syncStateChanged !== other.syncStateChanged ||
            !this.mutatedKeys.isEqual(other.mutatedKeys) ||
            !this.query.isEqual(other.query) ||
            !this.docs.isEqual(other.docs) ||
            !this.oldDocs.isEqual(other.oldDocs)) {
            return false;
        }
        var changes = this.docChanges;
        var otherChanges = other.docChanges;
        if (changes.length !== otherChanges.length) {
            return false;
        }
        for (var i = 0; i < changes.length; i++) {
            if (changes[i].type !== otherChanges[i].type ||
                !changes[i].doc.isEqual(otherChanges[i].doc)) {
                return false;
            }
        }
        return true;
    };
    return ViewSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */
var RemoteEvent = /** @class */ (function () {
    function RemoteEvent(
    /**
     * The snapshot version this event brings us up to, or MIN if not set.
     */
    snapshotVersion, 
    /**
     * A map from target to changes to the target. See TargetChange.
     */
    targetChanges, 
    /**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */
    targetMismatches, 
    /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */
    documentUpdates, 
    /**
     * A set of which document updates are due only to limbo resolution targets.
     */
    resolvedLimboDocuments) {
        this.snapshotVersion = snapshotVersion;
        this.targetChanges = targetChanges;
        this.targetMismatches = targetMismatches;
        this.documentUpdates = documentUpdates;
        this.resolvedLimboDocuments = resolvedLimboDocuments;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    RemoteEvent.createSynthesizedRemoteEventForCurrentChange = function (targetId, current) {
        var _a;
        var targetChanges = (_a = {},
            _a[targetId] = TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId, current),
            _a);
        return new RemoteEvent(SnapshotVersion.MIN, targetChanges, targetIdSet(), maybeDocumentMap(), documentKeySet());
    };
    return RemoteEvent;
}());
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */
var TargetChange = /** @class */ (function () {
    function TargetChange(
    /**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */
    resumeToken, 
    /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */
    current, 
    /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */
    addedDocuments, 
    /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */
    modifiedDocuments, 
    /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */
    removedDocuments) {
        this.resumeToken = resumeToken;
        this.current = current;
        this.addedDocuments = addedDocuments;
        this.modifiedDocuments = modifiedDocuments;
        this.removedDocuments = removedDocuments;
    }
    /**
     * HACK: Views require TargetChanges in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized TargetChanges that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */
    // PORTING NOTE: Multi-tab only
    TargetChange.createSynthesizedTargetChangeForCurrentChange = function (targetId, current) {
        return new TargetChange(emptyByteString(), current, documentKeySet(), documentKeySet(), documentKeySet());
    };
    return TargetChange;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */
var DocumentWatchChange = /** @class */ (function () {
    function DocumentWatchChange(
    /** The new document applies to all of these targets. */
    updatedTargetIds, 
    /** The new document is removed from all of these targets. */
    removedTargetIds, 
    /** The key of the document for this change. */
    key, 
    /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */
    newDoc) {
        this.updatedTargetIds = updatedTargetIds;
        this.removedTargetIds = removedTargetIds;
        this.key = key;
        this.newDoc = newDoc;
    }
    return DocumentWatchChange;
}());
var ExistenceFilterChange = /** @class */ (function () {
    function ExistenceFilterChange(targetId, existenceFilter) {
        this.targetId = targetId;
        this.existenceFilter = existenceFilter;
    }
    return ExistenceFilterChange;
}());
var WatchTargetChangeState;
(function (WatchTargetChangeState) {
    WatchTargetChangeState[WatchTargetChangeState["NoChange"] = 0] = "NoChange";
    WatchTargetChangeState[WatchTargetChangeState["Added"] = 1] = "Added";
    WatchTargetChangeState[WatchTargetChangeState["Removed"] = 2] = "Removed";
    WatchTargetChangeState[WatchTargetChangeState["Current"] = 3] = "Current";
    WatchTargetChangeState[WatchTargetChangeState["Reset"] = 4] = "Reset";
})(WatchTargetChangeState || (WatchTargetChangeState = {}));
var WatchTargetChange = /** @class */ (function () {
    function WatchTargetChange(
    /** What kind of change occurred to the watch target. */
    state, 
    /** The target IDs that were added/removed/set. */
    targetIds, 
    /**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */
    resumeToken, 
    /** An RPC error indicating why the watch failed. */
    cause) {
        if (resumeToken === void 0) { resumeToken = emptyByteString(); }
        if (cause === void 0) { cause = null; }
        this.state = state;
        this.targetIds = targetIds;
        this.resumeToken = resumeToken;
        this.cause = cause;
    }
    return WatchTargetChange;
}());
/** Tracks the internal state of a Watch target. */
var TargetState = /** @class */ (function () {
    function TargetState() {
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */
        this.pendingResponses = 0;
        /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */
        this.documentChanges = snapshotChangesMap();
        /** See public getters for explanations of these fields. */
        this._resumeToken = emptyByteString();
        this._current = false;
        /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */
        this._hasPendingChanges = true;
    }
    Object.defineProperty(TargetState.prototype, "current", {
        /**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */
        get: function () {
            return this._current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "resumeToken", {
        /** The last resume token sent to us for this target. */
        get: function () {
            return this._resumeToken;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "isPending", {
        /** Whether this target has pending target adds or target removes. */
        get: function () {
            return this.pendingResponses !== 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TargetState.prototype, "hasPendingChanges", {
        /** Whether we have modified any state that should trigger a snapshot. */
        get: function () {
            return this._hasPendingChanges;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */
    TargetState.prototype.updateResumeToken = function (resumeToken) {
        if (resumeToken.length > 0) {
            this._hasPendingChanges = true;
            this._resumeToken = resumeToken;
        }
    };
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */
    TargetState.prototype.toTargetChange = function () {
        var addedDocuments = documentKeySet();
        var modifiedDocuments = documentKeySet();
        var removedDocuments = documentKeySet();
        this.documentChanges.forEach(function (key, changeType) {
            switch (changeType) {
                case ChangeType.Added:
                    addedDocuments = addedDocuments.add(key);
                    break;
                case ChangeType.Modified:
                    modifiedDocuments = modifiedDocuments.add(key);
                    break;
                case ChangeType.Removed:
                    removedDocuments = removedDocuments.add(key);
                    break;
                default:
                    fail('Encountered invalid change type: ' + changeType);
            }
        });
        return new TargetChange(this._resumeToken, this._current, addedDocuments, modifiedDocuments, removedDocuments);
    };
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */
    TargetState.prototype.clearPendingChanges = function () {
        this._hasPendingChanges = false;
        this.documentChanges = snapshotChangesMap();
    };
    TargetState.prototype.addDocumentChange = function (key, changeType) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.insert(key, changeType);
    };
    TargetState.prototype.removeDocumentChange = function (key) {
        this._hasPendingChanges = true;
        this.documentChanges = this.documentChanges.remove(key);
    };
    TargetState.prototype.recordPendingTargetRequest = function () {
        this.pendingResponses += 1;
    };
    TargetState.prototype.recordTargetResponse = function () {
        this.pendingResponses -= 1;
    };
    TargetState.prototype.markCurrent = function () {
        this._hasPendingChanges = true;
        this._current = true;
    };
    return TargetState;
}());
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */
var WatchChangeAggregator = /** @class */ (function () {
    function WatchChangeAggregator(metadataProvider) {
        this.metadataProvider = metadataProvider;
        /** The internal state of all tracked targets. */
        this.targetStates = {};
        /** Keeps track of the documents to update since the last raised snapshot. */
        this.pendingDocumentUpdates = maybeDocumentMap();
        /** A mapping of document keys to their set of target IDs. */
        this.pendingDocumentTargetMapping = documentTargetMap();
        /**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */
        this.pendingTargetResets = new SortedSet(primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */
    WatchChangeAggregator.prototype.handleDocumentChange = function (docChange) {
        for (var _i = 0, _a = docChange.updatedTargetIds; _i < _a.length; _i++) {
            var targetId = _a[_i];
            if (docChange.newDoc instanceof Document) {
                this.addDocumentToTarget(targetId, docChange.newDoc);
            }
            else if (docChange.newDoc instanceof NoDocument) {
                this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
            }
        }
        for (var _b = 0, _c = docChange.removedTargetIds; _b < _c.length; _b++) {
            var targetId = _c[_b];
            this.removeDocumentFromTarget(targetId, docChange.key, docChange.newDoc);
        }
    };
    /** Processes and adds the WatchTargetChange to the current set of changes. */
    WatchChangeAggregator.prototype.handleTargetChange = function (targetChange) {
        var _this = this;
        this.forEachTarget(targetChange, function (targetId) {
            var targetState = _this.ensureTargetState(targetId);
            switch (targetChange.state) {
                case WatchTargetChangeState.NoChange:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Added:
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        // We have a freshly added target, so we need to reset any state
                        // that we had previously. This can happen e.g. when remove and add
                        // back a target for existence filter mismatches.
                        targetState.clearPendingChanges();
                    }
                    targetState.updateResumeToken(targetChange.resumeToken);
                    break;
                case WatchTargetChangeState.Removed:
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    targetState.recordTargetResponse();
                    if (!targetState.isPending) {
                        _this.removeTarget(targetId);
                    }
                    assert(!targetChange.cause, 'WatchChangeAggregator does not handle errored targets');
                    break;
                case WatchTargetChangeState.Current:
                    if (_this.isActiveTarget(targetId)) {
                        targetState.markCurrent();
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                case WatchTargetChangeState.Reset:
                    if (_this.isActiveTarget(targetId)) {
                        // Reset the target and synthesizes removes for all existing
                        // documents. The backend will re-add any documents that still
                        // match the target before it sends the next global snapshot.
                        _this.resetTarget(targetId);
                        targetState.updateResumeToken(targetChange.resumeToken);
                    }
                    break;
                default:
                    fail('Unknown target watch change state: ' + targetChange.state);
            }
        });
    };
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */
    WatchChangeAggregator.prototype.forEachTarget = function (targetChange, fn) {
        if (targetChange.targetIds.length > 0) {
            targetChange.targetIds.forEach(fn);
        }
        else {
            forEachNumber(this.targetStates, fn);
        }
    };
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */
    WatchChangeAggregator.prototype.handleExistenceFilter = function (watchChange) {
        var targetId = watchChange.targetId;
        var expectedCount = watchChange.existenceFilter.count;
        var queryData = this.queryDataForActiveTarget(targetId);
        if (queryData) {
            var query = queryData.query;
            if (query.isDocumentQuery()) {
                if (expectedCount === 0) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    var key = new DocumentKey(query.path);
                    this.removeDocumentFromTarget(targetId, key, new NoDocument(key, SnapshotVersion.forDeletedDoc()));
                }
                else {
                    assert(expectedCount === 1, 'Single document existence filter with count: ' + expectedCount);
                }
            }
            else {
                var currentSize = this.getCurrentDocumentCountForTarget(targetId);
                if (currentSize !== expectedCount) {
                    // Existence filter mismatch: We reset the mapping and raise a new
                    // snapshot with `isFromCache:true`.
                    this.resetTarget(targetId);
                    this.pendingTargetResets = this.pendingTargetResets.add(targetId);
                }
            }
        }
    };
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */
    WatchChangeAggregator.prototype.createRemoteEvent = function (snapshotVersion) {
        var _this = this;
        var targetChanges = {};
        forEachNumber(this.targetStates, function (targetId, targetState) {
            var queryData = _this.queryDataForActiveTarget(targetId);
            if (queryData) {
                if (targetState.current && queryData.query.isDocumentQuery()) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    //
                    // TODO(dimond): Ideally we would have an explicit lookup query
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    var key = new DocumentKey(queryData.query.path);
                    if (_this.pendingDocumentUpdates.get(key) === null &&
                        !_this.targetContainsDocument(targetId, key)) {
                        _this.removeDocumentFromTarget(targetId, key, new NoDocument(key, snapshotVersion));
                    }
                }
                if (targetState.hasPendingChanges) {
                    targetChanges[targetId] = targetState.toTargetChange();
                    targetState.clearPendingChanges();
                }
            }
        });
        var resolvedLimboDocuments = documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the query cache.
        //
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.pendingDocumentTargetMapping.forEach(function (key, targets) {
            var isOnlyLimboTarget = true;
            targets.forEachWhile(function (targetId) {
                var queryData = _this.queryDataForActiveTarget(targetId);
                if (queryData && queryData.purpose !== QueryPurpose.LimboResolution) {
                    isOnlyLimboTarget = false;
                    return false;
                }
                return true;
            });
            if (isOnlyLimboTarget) {
                resolvedLimboDocuments = resolvedLimboDocuments.add(key);
            }
        });
        var remoteEvent = new RemoteEvent(snapshotVersion, targetChanges, this.pendingTargetResets, this.pendingDocumentUpdates, resolvedLimboDocuments);
        this.pendingDocumentUpdates = maybeDocumentMap();
        this.pendingDocumentTargetMapping = documentTargetMap();
        this.pendingTargetResets = new SortedSet(primitiveComparator);
        return remoteEvent;
    };
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.addDocumentToTarget = function (targetId, document) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var changeType = this.targetContainsDocument(targetId, document.key)
            ? ChangeType.Modified
            : ChangeType.Added;
        var targetState = this.ensureTargetState(targetId);
        targetState.addDocumentChange(document.key, changeType);
        this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(document.key, document);
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(document.key, this.ensureDocumentTargetMapping(document.key).add(targetId));
    };
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */
    // Visible for testing.
    WatchChangeAggregator.prototype.removeDocumentFromTarget = function (targetId, key, updatedDocument) {
        if (!this.isActiveTarget(targetId)) {
            return;
        }
        var targetState = this.ensureTargetState(targetId);
        if (this.targetContainsDocument(targetId, key)) {
            targetState.addDocumentChange(key, ChangeType.Removed);
        }
        else {
            // The document may have entered and left the target before we raised a
            // snapshot, so we can just ignore the change.
            targetState.removeDocumentChange(key);
        }
        this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, this.ensureDocumentTargetMapping(key).delete(targetId));
        if (updatedDocument) {
            this.pendingDocumentUpdates = this.pendingDocumentUpdates.insert(key, updatedDocument);
        }
    };
    WatchChangeAggregator.prototype.removeTarget = function (targetId) {
        delete this.targetStates[targetId];
    };
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */
    WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget = function (targetId) {
        var targetState = this.ensureTargetState(targetId);
        var targetChange = targetState.toTargetChange();
        return (this.metadataProvider.getRemoteKeysForTarget(targetId).size +
            targetChange.addedDocuments.size -
            targetChange.removedDocuments.size);
    };
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */
    WatchChangeAggregator.prototype.recordPendingTargetRequest = function (targetId) {
        // For each request we get we need to record we need a response for it.
        var targetState = this.ensureTargetState(targetId);
        targetState.recordPendingTargetRequest();
    };
    WatchChangeAggregator.prototype.ensureTargetState = function (targetId) {
        if (!this.targetStates[targetId]) {
            this.targetStates[targetId] = new TargetState();
        }
        return this.targetStates[targetId];
    };
    WatchChangeAggregator.prototype.ensureDocumentTargetMapping = function (key) {
        var targetMapping = this.pendingDocumentTargetMapping.get(key);
        if (!targetMapping) {
            targetMapping = new SortedSet(primitiveComparator);
            this.pendingDocumentTargetMapping = this.pendingDocumentTargetMapping.insert(key, targetMapping);
        }
        return targetMapping;
    };
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getQueryDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */
    WatchChangeAggregator.prototype.isActiveTarget = function (targetId) {
        return this.queryDataForActiveTarget(targetId) !== null;
    };
    /**
     * Returns the QueryData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */
    WatchChangeAggregator.prototype.queryDataForActiveTarget = function (targetId) {
        var targetState = this.targetStates[targetId];
        return targetState && targetState.isPending
            ? null
            : this.metadataProvider.getQueryDataForTarget(targetId);
    };
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */
    WatchChangeAggregator.prototype.resetTarget = function (targetId) {
        var _this = this;
        assert(!this.targetStates[targetId].isPending, 'Should only reset active targets');
        this.targetStates[targetId] = new TargetState();
        // Trigger removal for any documents currently mapped to this target.
        // These removals will be part of the initial snapshot if Watch does not
        // resend these documents.
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        existingKeys.forEach(function (key) {
            _this.removeDocumentFromTarget(targetId, key, /*updatedDocument=*/ null);
        });
    };
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */
    WatchChangeAggregator.prototype.targetContainsDocument = function (targetId, key) {
        var existingKeys = this.metadataProvider.getRemoteKeysForTarget(targetId);
        return existingKeys.has(key);
    };
    return WatchChangeAggregator;
}());
function documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$7 = 'RemoteStore';
// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES = 10;
/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */
var RemoteStore = /** @class */ (function () {
    function RemoteStore(
    /**
     * The local store, used to fill the write pipeline with outbound mutations.
     */
    localStore, 
    /** The client-side proxy for interacting with the backend. */
    datastore, asyncQueue, onlineStateHandler, connectivityMonitor) {
        var _this = this;
        this.localStore = localStore;
        this.datastore = datastore;
        /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */
        this.writePipeline = [];
        /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */
        this.listenTargets = {};
        this.watchChangeAggregator = null;
        /**
         * Set to true by enableNetwork() and false by disableNetwork() and indicates
         * the user-preferred network state.
         */
        this.networkEnabled = false;
        this.isPrimary = false;
        this.connectivityMonitor = connectivityMonitor;
        this.connectivityMonitor.addCallback(function (status) {
            asyncQueue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canUseNetwork()) return [3 /*break*/, 2];
                            debug(LOG_TAG$7, 'Restarting streams for network reachability change.');
                            return [4 /*yield*/, this.restartNetwork()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        });
        this.onlineStateTracker = new OnlineStateTracker(asyncQueue, onlineStateHandler);
        // Create streams (but note they're not started yet).
        this.watchStream = this.datastore.newPersistentWatchStream({
            onOpen: this.onWatchStreamOpen.bind(this),
            onClose: this.onWatchStreamClose.bind(this),
            onWatchChange: this.onWatchStreamChange.bind(this)
        });
        this.writeStream = this.datastore.newPersistentWriteStream({
            onOpen: this.onWriteStreamOpen.bind(this),
            onClose: this.onWriteStreamClose.bind(this),
            onHandshakeComplete: this.onWriteHandshakeComplete.bind(this),
            onMutationResult: this.onMutationResult.bind(this)
        });
    }
    /**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */
    RemoteStore.prototype.start = function () {
        return this.enableNetwork();
    };
    /** Re-enables the network. Idempotent. */
    RemoteStore.prototype.enableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.networkEnabled = true;
                        if (!this.canUseNetwork()) return [3 /*break*/, 3];
                        _a = this.writeStream;
                        return [4 /*yield*/, this.localStore.getLastStreamToken()];
                    case 1:
                        _a.lastStreamToken = _b.sent();
                        if (this.shouldStartWatchStream()) {
                            this.startWatchStream();
                        }
                        else {
                            this.onlineStateTracker.set(OnlineState.Unknown);
                        }
                        // This will start the write stream if necessary.
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 2:
                        // This will start the write stream if necessary.
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */
    RemoteStore.prototype.disableNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        // Set the OnlineState to Offline so get()s return from cache, etc.
                        this.onlineStateTracker.set(OnlineState.Offline);
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.disableNetworkInternal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.writeStream.stop()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.watchStream.stop()];
                    case 2:
                        _a.sent();
                        if (this.writePipeline.length > 0) {
                            debug(LOG_TAG$7, "Stopping write stream with " + this.writePipeline.length + " pending writes");
                            this.writePipeline = [];
                        }
                        this.cleanUpWatchStreamState();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.shutdown = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        debug(LOG_TAG$7, 'RemoteStore shutting down.');
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.connectivityMonitor.shutdown();
                        // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                        // triggering spurious listener events with cached data, etc.
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Starts new listen for the given query. Uses resume token if provided */
    RemoteStore.prototype.listen = function (queryData) {
        assert(!contains(this.listenTargets, queryData.targetId), 'listen called with duplicate targetId!');
        // Mark this as something the client is currently listening for.
        this.listenTargets[queryData.targetId] = queryData;
        if (this.shouldStartWatchStream()) {
            // The listen will be sent in onWatchStreamOpen
            this.startWatchStream();
        }
        else if (this.watchStream.isOpen()) {
            this.sendWatchRequest(queryData);
        }
    };
    /** Removes the listen from server */
    RemoteStore.prototype.unlisten = function (targetId) {
        assert(contains(this.listenTargets, targetId), 'unlisten called without assigned target ID!');
        delete this.listenTargets[targetId];
        if (this.watchStream.isOpen()) {
            this.sendUnwatchRequest(targetId);
        }
        if (isEmpty(this.listenTargets)) {
            if (this.watchStream.isOpen()) {
                this.watchStream.markIdle();
            }
            else if (this.canUseNetwork()) {
                // Revert to OnlineState.Unknown if the watch stream is not open and we
                // have no listeners, since without any listens to send we cannot
                // confirm if the stream is healthy and upgrade to OnlineState.Online.
                this.onlineStateTracker.set(OnlineState.Unknown);
            }
        }
    };
    /** {@link TargetMetadataProvider.getQueryDataForTarget} */
    RemoteStore.prototype.getQueryDataForTarget = function (targetId) {
        return this.listenTargets[targetId] || null;
    };
    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */
    RemoteStore.prototype.getRemoteKeysForTarget = function (targetId) {
        return this.syncEngine.getRemoteKeysForTarget(targetId);
    };
    /**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */
    RemoteStore.prototype.sendWatchRequest = function (queryData) {
        this.watchChangeAggregator.recordPendingTargetRequest(queryData.targetId);
        this.watchStream.watch(queryData);
    };
    /**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */
    RemoteStore.prototype.sendUnwatchRequest = function (targetId) {
        this.watchChangeAggregator.recordPendingTargetRequest(targetId);
        this.watchStream.unwatch(targetId);
    };
    RemoteStore.prototype.startWatchStream = function () {
        assert(this.shouldStartWatchStream(), 'startWatchStream() called when shouldStartWatchStream() is false.');
        this.watchChangeAggregator = new WatchChangeAggregator(this);
        this.watchStream.start();
        this.onlineStateTracker.handleWatchStreamStart();
    };
    /**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */
    RemoteStore.prototype.shouldStartWatchStream = function () {
        return (this.canUseNetwork() &&
            !this.watchStream.isStarted() &&
            !isEmpty(this.listenTargets));
    };
    RemoteStore.prototype.canUseNetwork = function () {
        return this.isPrimary && this.networkEnabled;
    };
    RemoteStore.prototype.cleanUpWatchStreamState = function () {
        this.watchChangeAggregator = null;
    };
    RemoteStore.prototype.onWatchStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                forEachNumber(this.listenTargets, function (targetId, queryData) {
                    _this.sendWatchRequest(queryData);
                });
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamClose = function (error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (error === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWatchStream(), 'Watch stream was stopped gracefully while still needed.');
                }
                this.cleanUpWatchStreamState();
                // If we still need the watch stream, retry the connection.
                if (this.shouldStartWatchStream()) {
                    this.onlineStateTracker.handleWatchStreamFailure(error);
                    this.startWatchStream();
                }
                else {
                    // No need to restart watch stream because there are no active targets.
                    // The online state is set to unknown because there is no active attempt
                    // at establishing a connection
                    this.onlineStateTracker.set(OnlineState.Unknown);
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWatchStreamChange = function (watchChange, snapshotVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastRemoteSnapshotVersion;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Mark the client as online since we got a message from the server
                        this.onlineStateTracker.set(OnlineState.Online);
                        if (watchChange instanceof WatchTargetChange &&
                            watchChange.state === WatchTargetChangeState.Removed &&
                            watchChange.cause) {
                            // There was an error on a target, don't wait for a consistent snapshot
                            // to raise events
                            return [2 /*return*/, this.handleTargetError(watchChange)];
                        }
                        if (watchChange instanceof DocumentWatchChange) {
                            this.watchChangeAggregator.handleDocumentChange(watchChange);
                        }
                        else if (watchChange instanceof ExistenceFilterChange) {
                            this.watchChangeAggregator.handleExistenceFilter(watchChange);
                        }
                        else {
                            assert(watchChange instanceof WatchTargetChange, 'Expected watchChange to be an instance of WatchTargetChange');
                            this.watchChangeAggregator.handleTargetChange(watchChange);
                        }
                        if (!!snapshotVersion.isEqual(SnapshotVersion.MIN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.getLastRemoteSnapshotVersion()];
                    case 1:
                        lastRemoteSnapshotVersion = _a.sent();
                        if (!(snapshotVersion.compareTo(lastRemoteSnapshotVersion) >= 0)) return [3 /*break*/, 3];
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        return [4 /*yield*/, this.raiseWatchSnapshot(snapshotVersion)];
                    case 2:
                        // We have received a target change with a global snapshot if the snapshot
                        // version is not equal to SnapshotVersion.MIN.
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */
    RemoteStore.prototype.raiseWatchSnapshot = function (snapshotVersion) {
        var _this = this;
        assert(!snapshotVersion.isEqual(SnapshotVersion.MIN), "Can't raise event for unknown SnapshotVersion");
        var remoteEvent = this.watchChangeAggregator.createRemoteEvent(snapshotVersion);
        // Update in-memory resume tokens. LocalStore will update the
        // persistent view of these when applying the completed RemoteEvent.
        forEachNumber(remoteEvent.targetChanges, function (targetId, change) {
            if (change.resumeToken.length > 0) {
                var queryData = _this.listenTargets[targetId];
                // A watched target might have been removed already.
                if (queryData) {
                    _this.listenTargets[targetId] = queryData.copy({
                        resumeToken: change.resumeToken,
                        snapshotVersion: snapshotVersion
                    });
                }
            }
        });
        // Re-establish listens for the targets that have been invalidated by
        // existence filter mismatches.
        remoteEvent.targetMismatches.forEach(function (targetId) {
            var queryData = _this.listenTargets[targetId];
            if (!queryData) {
                // A watched target might have been removed already.
                return;
            }
            // Clear the resume token for the query, since we're in a known mismatch
            // state.
            _this.listenTargets[targetId] = queryData.copy({
                resumeToken: emptyByteString()
            });
            // Cause a hard reset by unwatching and rewatching immediately, but
            // deliberately don't send a resume token so that we get a full update.
            _this.sendUnwatchRequest(targetId);
            // Mark the query we send as being on behalf of an existence filter
            // mismatch, but don't actually retain that in listenTargets. This ensures
            // that we flag the first re-listen this way without impacting future
            // listens of this target (that might happen e.g. on reconnect).
            var requestQueryData = new QueryData(queryData.query, targetId, QueryPurpose.ExistenceFilterMismatch, queryData.sequenceNumber);
            _this.sendWatchRequest(requestQueryData);
        });
        // Finally raise remote event
        return this.syncEngine.applyRemoteEvent(remoteEvent);
    };
    /** Handles an error on a target */
    RemoteStore.prototype.handleTargetError = function (watchChange) {
        var _this = this;
        assert(!!watchChange.cause, 'Handling target error without a cause');
        var error = watchChange.cause;
        var promiseChain = Promise.resolve();
        watchChange.targetIds.forEach(function (targetId) {
            promiseChain = promiseChain.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    // A watched target might have been removed already.
                    if (contains(this.listenTargets, targetId)) {
                        delete this.listenTargets[targetId];
                        this.watchChangeAggregator.removeTarget(targetId);
                        return [2 /*return*/, this.syncEngine.rejectListen(targetId, error)];
                    }
                    return [2 /*return*/];
                });
            }); });
        });
        return promiseChain;
    };
    /**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */
    RemoteStore.prototype.fillWritePipeline = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var lastBatchIdRetrieved, batch;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canAddToWritePipeline()) return [3 /*break*/, 4];
                        lastBatchIdRetrieved = this.writePipeline.length > 0
                            ? this.writePipeline[this.writePipeline.length - 1].batchId
                            : BATCHID_UNKNOWN;
                        return [4 /*yield*/, this.localStore.nextMutationBatch(lastBatchIdRetrieved)];
                    case 1:
                        batch = _a.sent();
                        if (!(batch === null)) return [3 /*break*/, 2];
                        if (this.writePipeline.length === 0) {
                            this.writeStream.markIdle();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.addToWritePipeline(batch);
                        return [4 /*yield*/, this.fillWritePipeline()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (this.shouldStartWriteStream()) {
                            this.startWriteStream();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */
    RemoteStore.prototype.canAddToWritePipeline = function () {
        return (this.canUseNetwork() && this.writePipeline.length < MAX_PENDING_WRITES);
    };
    // For testing
    RemoteStore.prototype.outstandingWrites = function () {
        return this.writePipeline.length;
    };
    /**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */
    RemoteStore.prototype.addToWritePipeline = function (batch) {
        assert(this.canAddToWritePipeline(), 'addToWritePipeline called when pipeline is full');
        this.writePipeline.push(batch);
        if (this.writeStream.isOpen() && this.writeStream.handshakeComplete) {
            this.writeStream.writeMutations(batch.mutations);
        }
    };
    RemoteStore.prototype.shouldStartWriteStream = function () {
        return (this.canUseNetwork() &&
            !this.writeStream.isStarted() &&
            this.writePipeline.length > 0);
    };
    RemoteStore.prototype.startWriteStream = function () {
        assert(this.shouldStartWriteStream(), 'startWriteStream() called when shouldStartWriteStream() is false.');
        this.writeStream.start();
    };
    RemoteStore.prototype.onWriteStreamOpen = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.writeStream.writeHandshake();
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.onWriteHandshakeComplete = function () {
        var _this = this;
        // Record the stream token.
        return this.localStore
            .setLastStreamToken(this.writeStream.lastStreamToken)
            .then(function () {
            // Send the write pipeline now that the stream is established.
            for (var _i = 0, _a = _this.writePipeline; _i < _a.length; _i++) {
                var batch = _a[_i];
                _this.writeStream.writeMutations(batch.mutations);
            }
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    RemoteStore.prototype.onMutationResult = function (commitVersion, results) {
        var _this = this;
        // This is a response to a write containing mutations and should be
        // correlated to the first write in our write pipeline.
        assert(this.writePipeline.length > 0, 'Got result for empty write pipeline');
        var batch = this.writePipeline.shift();
        var success = MutationBatchResult.from(batch, commitVersion, results, this.writeStream.lastStreamToken);
        return this.syncEngine.applySuccessfulWrite(success).then(function () {
            // It's possible that with the completion of this mutation another
            // slot has freed up.
            return _this.fillWritePipeline();
        });
    };
    RemoteStore.prototype.onWriteStreamClose = function (error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var errorHandling;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (error === undefined) {
                    // Graceful stop (due to stop() or idle timeout). Make sure that's
                    // desirable.
                    assert(!this.shouldStartWriteStream(), 'Write stream was stopped gracefully while still needed.');
                }
                // If the write stream closed due to an error, invoke the error callbacks if
                // there are pending writes.
                if (error && this.writePipeline.length > 0) {
                    errorHandling = void 0;
                    if (this.writeStream.handshakeComplete) {
                        // This error affects the actual write.
                        errorHandling = this.handleWriteError(error);
                    }
                    else {
                        // If there was an error before the handshake has finished, it's
                        // possible that the server is unable to process the stream token
                        // we're sending. (Perhaps it's too old?)
                        errorHandling = this.handleHandshakeError(error);
                    }
                    return [2 /*return*/, errorHandling.then(function () {
                            // The write stream might have been started by refilling the write
                            // pipeline for failed writes
                            if (_this.shouldStartWriteStream()) {
                                _this.startWriteStream();
                            }
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleHandshakeError = function (error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // Reset the token if it's a permanent error, signaling the write stream is
                // no longer valid. Note that the handshake does not count as a write: see
                // comments on isPermanentWriteError for details.
                if (isPermanentError(error.code)) {
                    debug(LOG_TAG$7, 'RemoteStore error before completed handshake; resetting stream token: ', this.writeStream.lastStreamToken);
                    this.writeStream.lastStreamToken = emptyByteString();
                    return [2 /*return*/, this.localStore
                            .setLastStreamToken(emptyByteString())
                            .catch(ignoreIfPrimaryLeaseLoss)];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.handleWriteError = function (error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                // Only handle permanent errors here. If it's transient, just let the retry
                // logic kick in.
                if (isPermanentWriteError(error.code)) {
                    batch = this.writePipeline.shift();
                    // In this case it's also unlikely that the server itself is melting
                    // down -- this was just a bad request so inhibit backoff on the next
                    // restart.
                    this.writeStream.inhibitBackoff();
                    return [2 /*return*/, this.syncEngine
                            .rejectFailedWrite(batch.batchId, error)
                            .then(function () {
                            // It's possible that with the completion of this mutation
                            // another slot has freed up.
                            return _this.fillWritePipeline();
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    RemoteStore.prototype.createTransaction = function () {
        return new Transaction(this.datastore);
    };
    RemoteStore.prototype.restartNetwork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.networkEnabled = false;
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 1:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        return [4 /*yield*/, this.enableNetwork()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteStore.prototype.handleCredentialChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.canUseNetwork()) return [3 /*break*/, 2];
                        // Tear down and re-create our network streams. This will ensure we get a fresh auth token
                        // for the new user and re-fill the write pipeline with new mutations from the LocalStore
                        // (since mutations are per-user).
                        debug(LOG_TAG$7, 'RemoteStore restarting streams for new credential');
                        return [4 /*yield*/, this.restartNetwork()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Toggles the network state when the client gains or loses its primary lease.
     */
    RemoteStore.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isPrimary = isPrimary;
                        if (!(isPrimary && this.networkEnabled)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.enableNetwork()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!!isPrimary) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.disableNetworkInternal()];
                    case 3:
                        _a.sent();
                        this.onlineStateTracker.set(OnlineState.Unknown);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return RemoteStore;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */
var GeoPoint = /** @class */ (function () {
    function GeoPoint(latitude, longitude) {
        validateExactNumberOfArgs('GeoPoint', arguments, 2);
        validateArgType('GeoPoint', 'number', 1, latitude);
        validateArgType('GeoPoint', 'number', 2, longitude);
        if (!isFinite(latitude) || latitude < -90 || latitude > 90) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Latitude must be a number between -90 and 90, but was: ' + latitude);
        }
        if (!isFinite(longitude) || longitude < -180 || longitude > 180) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Longitude must be a number between -180 and 180, but was: ' + longitude);
        }
        this._lat = latitude;
        this._long = longitude;
    }
    Object.defineProperty(GeoPoint.prototype, "latitude", {
        /**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */
        get: function () {
            return this._lat;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GeoPoint.prototype, "longitude", {
        /**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */
        get: function () {
            return this._long;
        },
        enumerable: true,
        configurable: true
    });
    GeoPoint.prototype.isEqual = function (other) {
        return this._lat === other._lat && this._long === other._long;
    };
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */
    GeoPoint.prototype._compareTo = function (other) {
        return (primitiveComparator(this._lat, other._lat) ||
            primitiveComparator(this._long, other._long));
    };
    return GeoPoint;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Query = /** @class */ (function () {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */
    function Query(path, collectionGroup, explicitOrderBy, filters, limit, startAt, endAt) {
        if (collectionGroup === void 0) { collectionGroup = null; }
        if (explicitOrderBy === void 0) { explicitOrderBy = []; }
        if (filters === void 0) { filters = []; }
        if (limit === void 0) { limit = null; }
        if (startAt === void 0) { startAt = null; }
        if (endAt === void 0) { endAt = null; }
        this.path = path;
        this.collectionGroup = collectionGroup;
        this.explicitOrderBy = explicitOrderBy;
        this.filters = filters;
        this.limit = limit;
        this.startAt = startAt;
        this.endAt = endAt;
        this.memoizedCanonicalId = null;
        this.memoizedOrderBy = null;
        if (this.startAt) {
            this.assertValidBound(this.startAt);
        }
        if (this.endAt) {
            this.assertValidBound(this.endAt);
        }
    }
    Query.atPath = function (path) {
        return new Query(path);
    };
    Object.defineProperty(Query.prototype, "orderBy", {
        get: function () {
            if (this.memoizedOrderBy === null) {
                var inequalityField = this.getInequalityFilterField();
                var firstOrderByField = this.getFirstOrderByField();
                if (inequalityField !== null && firstOrderByField === null) {
                    // In order to implicitly add key ordering, we must also add the
                    // inequality filter field for it to be a valid query.
                    // Note that the default inequality field and key ordering is ascending.
                    if (inequalityField.isKeyField()) {
                        this.memoizedOrderBy = [KEY_ORDERING_ASC];
                    }
                    else {
                        this.memoizedOrderBy = [
                            new OrderBy(inequalityField),
                            KEY_ORDERING_ASC
                        ];
                    }
                }
                else {
                    assert(inequalityField === null ||
                        (firstOrderByField !== null &&
                            inequalityField.isEqual(firstOrderByField)), 'First orderBy should match inequality field.');
                    this.memoizedOrderBy = [];
                    var foundKeyOrdering = false;
                    for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
                        var orderBy = _a[_i];
                        this.memoizedOrderBy.push(orderBy);
                        if (orderBy.field.isKeyField()) {
                            foundKeyOrdering = true;
                        }
                    }
                    if (!foundKeyOrdering) {
                        // The order of the implicit key ordering always matches the last
                        // explicit order by
                        var lastDirection = this.explicitOrderBy.length > 0
                            ? this.explicitOrderBy[this.explicitOrderBy.length - 1].dir
                            : Direction.ASCENDING;
                        this.memoizedOrderBy.push(lastDirection === Direction.ASCENDING
                            ? KEY_ORDERING_ASC
                            : KEY_ORDERING_DESC);
                    }
                }
            }
            return this.memoizedOrderBy;
        },
        enumerable: true,
        configurable: true
    });
    Query.prototype.addFilter = function (filter) {
        assert(this.getInequalityFilterField() == null ||
            !(filter instanceof FieldFilter) ||
            !filter.isInequality() ||
            filter.field.isEqual(this.getInequalityFilterField()), 'Query must only have one inequality field.');
        assert(!this.isDocumentQuery(), 'No filtering allowed for document query');
        var newFilters = this.filters.concat([filter]);
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), newFilters, this.limit, this.startAt, this.endAt);
    };
    Query.prototype.addOrderBy = function (orderBy) {
        assert(!this.startAt && !this.endAt, 'Bounds must be set after orderBy');
        // TODO(dimond): validate that orderBy does not list the same key twice.
        var newOrderBy = this.explicitOrderBy.concat([orderBy]);
        return new Query(this.path, this.collectionGroup, newOrderBy, this.filters.slice(), this.limit, this.startAt, this.endAt);
    };
    Query.prototype.withLimit = function (limit) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), limit, this.startAt, this.endAt);
    };
    Query.prototype.withStartAt = function (bound) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, bound, this.endAt);
    };
    Query.prototype.withEndAt = function (bound) {
        return new Query(this.path, this.collectionGroup, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, bound);
    };
    /**
     * Helper to convert a collection group query into a collection query at a
     * specific path. This is used when executing collection group queries, since
     * we have to split the query into a set of collection queries at multiple
     * paths.
     */
    Query.prototype.asCollectionQueryAtPath = function (path) {
        return new Query(path, 
        /*collectionGroup=*/ null, this.explicitOrderBy.slice(), this.filters.slice(), this.limit, this.startAt, this.endAt);
    };
    // TODO(b/29183165): This is used to get a unique string from a query to, for
    // example, use as a dictionary key, but the implementation is subject to
    // collisions. Make it collision-free.
    Query.prototype.canonicalId = function () {
        if (this.memoizedCanonicalId === null) {
            var canonicalId = this.path.canonicalString();
            if (this.isCollectionGroupQuery()) {
                canonicalId += '|cg:' + this.collectionGroup;
            }
            canonicalId += '|f:';
            for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
                var filter = _a[_i];
                canonicalId += filter.canonicalId();
                canonicalId += ',';
            }
            canonicalId += '|ob:';
            // TODO(dimond): make this collision resistant
            for (var _b = 0, _c = this.orderBy; _b < _c.length; _b++) {
                var orderBy = _c[_b];
                canonicalId += orderBy.canonicalId();
                canonicalId += ',';
            }
            if (!isNullOrUndefined(this.limit)) {
                canonicalId += '|l:';
                canonicalId += this.limit;
            }
            if (this.startAt) {
                canonicalId += '|lb:';
                canonicalId += this.startAt.canonicalId();
            }
            if (this.endAt) {
                canonicalId += '|ub:';
                canonicalId += this.endAt.canonicalId();
            }
            this.memoizedCanonicalId = canonicalId;
        }
        return this.memoizedCanonicalId;
    };
    Query.prototype.toString = function () {
        var str = 'Query(' + this.path.canonicalString();
        if (this.isCollectionGroupQuery()) {
            str += ' collectionGroup=' + this.collectionGroup;
        }
        if (this.filters.length > 0) {
            str += ", filters: [" + this.filters.join(', ') + "]";
        }
        if (!isNullOrUndefined(this.limit)) {
            str += ', limit: ' + this.limit;
        }
        if (this.explicitOrderBy.length > 0) {
            str += ", orderBy: [" + this.explicitOrderBy.join(', ') + "]";
        }
        if (this.startAt) {
            str += ', startAt: ' + this.startAt.canonicalId();
        }
        if (this.endAt) {
            str += ', endAt: ' + this.endAt.canonicalId();
        }
        return str + ')';
    };
    Query.prototype.isEqual = function (other) {
        if (this.limit !== other.limit) {
            return false;
        }
        if (this.orderBy.length !== other.orderBy.length) {
            return false;
        }
        for (var i = 0; i < this.orderBy.length; i++) {
            if (!this.orderBy[i].isEqual(other.orderBy[i])) {
                return false;
            }
        }
        if (this.filters.length !== other.filters.length) {
            return false;
        }
        for (var i = 0; i < this.filters.length; i++) {
            if (!this.filters[i].isEqual(other.filters[i])) {
                return false;
            }
        }
        if (this.collectionGroup !== other.collectionGroup) {
            return false;
        }
        if (!this.path.isEqual(other.path)) {
            return false;
        }
        if (this.startAt !== null
            ? !this.startAt.isEqual(other.startAt)
            : other.startAt !== null) {
            return false;
        }
        return this.endAt !== null
            ? this.endAt.isEqual(other.endAt)
            : other.endAt === null;
    };
    Query.prototype.docComparator = function (d1, d2) {
        var comparedOnKeyField = false;
        for (var _i = 0, _a = this.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            var comp = orderBy.compare(d1, d2);
            if (comp !== 0)
                return comp;
            comparedOnKeyField = comparedOnKeyField || orderBy.field.isKeyField();
        }
        // Assert that we actually compared by key
        assert(comparedOnKeyField, "orderBy used that doesn't compare on key field");
        return 0;
    };
    Query.prototype.matches = function (doc) {
        return (this.matchesPathAndCollectionGroup(doc) &&
            this.matchesOrderBy(doc) &&
            this.matchesFilters(doc) &&
            this.matchesBounds(doc));
    };
    Query.prototype.hasLimit = function () {
        return !isNullOrUndefined(this.limit);
    };
    Query.prototype.getFirstOrderByField = function () {
        return this.explicitOrderBy.length > 0
            ? this.explicitOrderBy[0].field
            : null;
    };
    Query.prototype.getInequalityFilterField = function () {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof FieldFilter && filter.isInequality()) {
                return filter.field;
            }
        }
        return null;
    };
    // Checks if any of the provided Operators are included in the query and
    // returns the first one that is, or null if none are.
    Query.prototype.findFilterOperator = function (operators) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (filter instanceof FieldFilter) {
                if (operators.indexOf(filter.op) >= 0) {
                    return filter.op;
                }
            }
        }
        return null;
    };
    Query.prototype.isDocumentQuery = function () {
        return (DocumentKey.isDocumentKey(this.path) &&
            this.collectionGroup === null &&
            this.filters.length === 0);
    };
    Query.prototype.isCollectionGroupQuery = function () {
        return this.collectionGroup !== null;
    };
    Query.prototype.matchesPathAndCollectionGroup = function (doc) {
        var docPath = doc.key.path;
        if (this.collectionGroup !== null) {
            // NOTE: this.path is currently always empty since we don't expose Collection
            // Group queries rooted at a document path yet.
            return (doc.key.hasCollectionId(this.collectionGroup) &&
                this.path.isPrefixOf(docPath));
        }
        else if (DocumentKey.isDocumentKey(this.path)) {
            // exact match for document queries
            return this.path.isEqual(docPath);
        }
        else {
            // shallow ancestor queries by default
            return this.path.isImmediateParentOf(docPath);
        }
    };
    /**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */
    Query.prototype.matchesOrderBy = function (doc) {
        for (var _i = 0, _a = this.explicitOrderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            // order by key always matches
            if (!orderBy.field.isKeyField() &&
                doc.field(orderBy.field) === undefined) {
                return false;
            }
        }
        return true;
    };
    Query.prototype.matchesFilters = function (doc) {
        for (var _i = 0, _a = this.filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            if (!filter.matches(doc)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Makes sure a document is within the bounds, if provided.
     */
    Query.prototype.matchesBounds = function (doc) {
        if (this.startAt && !this.startAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        if (this.endAt && this.endAt.sortsBeforeDocument(this.orderBy, doc)) {
            return false;
        }
        return true;
    };
    Query.prototype.assertValidBound = function (bound) {
        assert(bound.position.length <= this.orderBy.length, 'Bound is longer than orderBy');
    };
    return Query;
}());
var Filter = /** @class */ (function () {
    function Filter() {
    }
    return Filter;
}());
var Operator = /** @class */ (function () {
    function Operator(name) {
        this.name = name;
    }
    Operator.fromString = function (op) {
        switch (op) {
            case '<':
                return Operator.LESS_THAN;
            case '<=':
                return Operator.LESS_THAN_OR_EQUAL;
            case '==':
                return Operator.EQUAL;
            case '>=':
                return Operator.GREATER_THAN_OR_EQUAL;
            case '>':
                return Operator.GREATER_THAN;
            case 'array-contains':
                return Operator.ARRAY_CONTAINS;
            case 'in':
                return Operator.IN;
            case 'array-contains-any':
                return Operator.ARRAY_CONTAINS_ANY;
            default:
                return fail('Unknown FieldFilter operator: ' + op);
        }
    };
    Operator.prototype.toString = function () {
        return this.name;
    };
    Operator.prototype.isEqual = function (other) {
        return this.name === other.name;
    };
    Operator.LESS_THAN = new Operator('<');
    Operator.LESS_THAN_OR_EQUAL = new Operator('<=');
    Operator.EQUAL = new Operator('==');
    Operator.GREATER_THAN = new Operator('>');
    Operator.GREATER_THAN_OR_EQUAL = new Operator('>=');
    Operator.ARRAY_CONTAINS = new Operator('array-contains');
    Operator.IN = new Operator('in');
    Operator.ARRAY_CONTAINS_ANY = new Operator('array-contains-any');
    return Operator;
}());
var FieldFilter = /** @class */ (function (_super) {
    tslib_1.__extends(FieldFilter, _super);
    function FieldFilter(field, op, value) {
        var _this = _super.call(this) || this;
        _this.field = field;
        _this.op = op;
        _this.value = value;
        return _this;
    }
    /**
     * Creates a filter based on the provided arguments.
     */
    FieldFilter.create = function (field, op, value) {
        if (field.isKeyField()) {
            assert(value instanceof RefValue, 'Comparing on key, but filter value not a RefValue');
            assert(op !== Operator.ARRAY_CONTAINS &&
                op !== Operator.ARRAY_CONTAINS_ANY &&
                op !== Operator.IN, "'" + op.toString() + "' queries don't make sense on document keys.");
            return new KeyFieldFilter(field, op, value);
        }
        else if (value.isEqual(NullValue.INSTANCE)) {
            if (op !== Operator.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on null.');
            }
            return new FieldFilter(field, op, value);
        }
        else if (value.isEqual(DoubleValue.NAN)) {
            if (op !== Operator.EQUAL) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You can only perform equals comparisons on NaN.');
            }
            return new FieldFilter(field, op, value);
        }
        else if (op === Operator.ARRAY_CONTAINS) {
            return new ArrayContainsFilter(field, value);
        }
        else if (op === Operator.IN) {
            assert(value instanceof ArrayValue, 'IN filter has invalid value: ' + value.toString());
            return new InFilter(field, value);
        }
        else if (op === Operator.ARRAY_CONTAINS_ANY) {
            assert(value instanceof ArrayValue, 'ARRAY_CONTAINS_ANY filter has invalid value: ' + value.toString());
            return new ArrayContainsAnyFilter(field, value);
        }
        else {
            return new FieldFilter(field, op, value);
        }
    };
    FieldFilter.prototype.matches = function (doc) {
        var other = doc.field(this.field);
        // Only compare types with matching backend order (such as double and int).
        return (other !== undefined &&
            this.value.typeOrder === other.typeOrder &&
            this.matchesComparison(other.compareTo(this.value)));
    };
    FieldFilter.prototype.matchesComparison = function (comparison) {
        switch (this.op) {
            case Operator.LESS_THAN:
                return comparison < 0;
            case Operator.LESS_THAN_OR_EQUAL:
                return comparison <= 0;
            case Operator.EQUAL:
                return comparison === 0;
            case Operator.GREATER_THAN:
                return comparison > 0;
            case Operator.GREATER_THAN_OR_EQUAL:
                return comparison >= 0;
            default:
                return fail('Unknown FieldFilter operator: ' + this.op);
        }
    };
    FieldFilter.prototype.isInequality = function () {
        return ([
            Operator.LESS_THAN,
            Operator.LESS_THAN_OR_EQUAL,
            Operator.GREATER_THAN,
            Operator.GREATER_THAN_OR_EQUAL
        ].indexOf(this.op) >= 0);
    };
    FieldFilter.prototype.canonicalId = function () {
        // TODO(b/29183165): Technically, this won't be unique if two values have
        // the same description, such as the int 3 and the string "3". So we should
        // add the types in here somehow, too.
        return (this.field.canonicalString() + this.op.toString() + this.value.toString());
    };
    FieldFilter.prototype.isEqual = function (other) {
        if (other instanceof FieldFilter) {
            return (this.op.isEqual(other.op) &&
                this.field.isEqual(other.field) &&
                this.value.isEqual(other.value));
        }
        else {
            return false;
        }
    };
    FieldFilter.prototype.toString = function () {
        return this.field.canonicalString() + " " + this.op + " " + this.value.value();
    };
    return FieldFilter;
}(Filter));
/** Filter that matches on key fields (i.e. '__name__'). */
var KeyFieldFilter = /** @class */ (function (_super) {
    tslib_1.__extends(KeyFieldFilter, _super);
    function KeyFieldFilter(field, op, value) {
        return _super.call(this, field, op, value) || this;
    }
    KeyFieldFilter.prototype.matches = function (doc) {
        var refValue = this.value;
        var comparison = DocumentKey.comparator(doc.key, refValue.key);
        return this.matchesComparison(comparison);
    };
    return KeyFieldFilter;
}(FieldFilter));
/** A Filter that implements the array-contains operator. */
var ArrayContainsFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayContainsFilter, _super);
    function ArrayContainsFilter(field, value) {
        return _super.call(this, field, Operator.ARRAY_CONTAINS, value) || this;
    }
    ArrayContainsFilter.prototype.matches = function (doc) {
        var other = doc.field(this.field);
        return other instanceof ArrayValue && other.contains(this.value);
    };
    return ArrayContainsFilter;
}(FieldFilter));
/** A Filter that implements the IN operator. */
var InFilter = /** @class */ (function (_super) {
    tslib_1.__extends(InFilter, _super);
    function InFilter(field, value) {
        return _super.call(this, field, Operator.IN, value) || this;
    }
    InFilter.prototype.matches = function (doc) {
        var arrayValue = this.value;
        var other = doc.field(this.field);
        return other !== undefined && arrayValue.contains(other);
    };
    return InFilter;
}(FieldFilter));
/** A Filter that implements the array-contains-any operator. */
var ArrayContainsAnyFilter = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayContainsAnyFilter, _super);
    function ArrayContainsAnyFilter(field, value) {
        return _super.call(this, field, Operator.ARRAY_CONTAINS_ANY, value) || this;
    }
    ArrayContainsAnyFilter.prototype.matches = function (doc) {
        var arrayValue = this.value;
        var other = doc.field(this.field);
        return (other instanceof ArrayValue &&
            other.internalValue.some(function (lhsElem) {
                return arrayValue.contains(lhsElem);
            }));
    };
    return ArrayContainsAnyFilter;
}(FieldFilter));
/**
 * The direction of sorting in an order by.
 */
var Direction = /** @class */ (function () {
    function Direction(name) {
        this.name = name;
    }
    Direction.prototype.toString = function () {
        return this.name;
    };
    Direction.ASCENDING = new Direction('asc');
    Direction.DESCENDING = new Direction('desc');
    return Direction;
}());
/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */
var Bound = /** @class */ (function () {
    function Bound(position, before) {
        this.position = position;
        this.before = before;
    }
    Bound.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        var canonicalId = this.before ? 'b:' : 'a:';
        for (var _i = 0, _a = this.position; _i < _a.length; _i++) {
            var component = _a[_i];
            canonicalId += component.toString();
        }
        return canonicalId;
    };
    /**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */
    Bound.prototype.sortsBeforeDocument = function (orderBy, doc) {
        assert(this.position.length <= orderBy.length, "Bound has more components than query's orderBy");
        var comparison = 0;
        for (var i = 0; i < this.position.length; i++) {
            var orderByComponent = orderBy[i];
            var component = this.position[i];
            if (orderByComponent.field.isKeyField()) {
                assert(component instanceof RefValue, 'Bound has a non-key value where the key path is being used.');
                comparison = DocumentKey.comparator(component.key, doc.key);
            }
            else {
                var docValue = doc.field(orderByComponent.field);
                assert(docValue !== undefined, 'Field should exist since document matched the orderBy already.');
                comparison = component.compareTo(docValue);
            }
            if (orderByComponent.dir === Direction.DESCENDING) {
                comparison = comparison * -1;
            }
            if (comparison !== 0) {
                break;
            }
        }
        return this.before ? comparison <= 0 : comparison < 0;
    };
    Bound.prototype.isEqual = function (other) {
        if (other === null) {
            return false;
        }
        if (this.before !== other.before ||
            this.position.length !== other.position.length) {
            return false;
        }
        for (var i = 0; i < this.position.length; i++) {
            var thisPosition = this.position[i];
            var otherPosition = other.position[i];
            if (!thisPosition.isEqual(otherPosition)) {
                return false;
            }
        }
        return true;
    };
    return Bound;
}());
/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */
var OrderBy = /** @class */ (function () {
    function OrderBy(field, dir) {
        this.field = field;
        if (dir === undefined) {
            dir = Direction.ASCENDING;
        }
        this.dir = dir;
        this.isKeyOrderBy = field.isKeyField();
    }
    OrderBy.prototype.compare = function (d1, d2) {
        var comparison = this.isKeyOrderBy
            ? Document.compareByKey(d1, d2)
            : Document.compareByField(this.field, d1, d2);
        switch (this.dir) {
            case Direction.ASCENDING:
                return comparison;
            case Direction.DESCENDING:
                return -1 * comparison;
            default:
                return fail('Unknown direction: ' + this.dir);
        }
    };
    OrderBy.prototype.canonicalId = function () {
        // TODO(b/29183165): Make this collision robust.
        return this.field.canonicalString() + this.dir.toString();
    };
    OrderBy.prototype.toString = function () {
        return this.field.canonicalString() + " (" + this.dir + ")";
    };
    OrderBy.prototype.isEqual = function (other) {
        return this.dir === other.dir && this.field.isEqual(other.field);
    };
    return OrderBy;
}());
var KEY_ORDERING_ASC = new OrderBy(FieldPath.keyField(), Direction.ASCENDING);
var KEY_ORDERING_DESC = new OrderBy(FieldPath.keyField(), Direction.DESCENDING);

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Transforms a value into a server-generated timestamp. */
var ServerTimestampTransform = /** @class */ (function () {
    function ServerTimestampTransform() {
        this.isIdempotent = true;
    }
    ServerTimestampTransform.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return new ServerTimestampValue(localWriteTime, previousValue);
    };
    ServerTimestampTransform.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        return transformResult;
    };
    ServerTimestampTransform.prototype.isEqual = function (other) {
        return other instanceof ServerTimestampTransform;
    };
    ServerTimestampTransform.instance = new ServerTimestampTransform();
    return ServerTimestampTransform;
}());
/** Transforms an array value via a union operation. */
var ArrayUnionTransformOperation = /** @class */ (function () {
    function ArrayUnionTransformOperation(elements) {
        this.elements = elements;
        this.isIdempotent = true;
    }
    ArrayUnionTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayUnionTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_1 = function (toUnion) {
            if (!result.find(function (element) { return element.isEqual(toUnion); })) {
                result.push(toUnion);
            }
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toUnion = _a[_i];
            _loop_1(toUnion);
        }
        return new ArrayValue(result);
    };
    ArrayUnionTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayUnionTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayUnionTransformOperation;
}());
/** Transforms an array value via a remove operation. */
var ArrayRemoveTransformOperation = /** @class */ (function () {
    function ArrayRemoveTransformOperation(elements) {
        this.elements = elements;
        this.isIdempotent = true;
    }
    ArrayRemoveTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        // The server just sends null as the transform result for array operations,
        // so we have to calculate a result the same as we do for local
        // applications.
        return this.apply(previousValue);
    };
    ArrayRemoveTransformOperation.prototype.apply = function (previousValue) {
        var result = coercedFieldValuesArray(previousValue);
        var _loop_2 = function (toRemove) {
            result = result.filter(function (element) { return !element.isEqual(toRemove); });
        };
        for (var _i = 0, _a = this.elements; _i < _a.length; _i++) {
            var toRemove = _a[_i];
            _loop_2(toRemove);
        }
        return new ArrayValue(result);
    };
    ArrayRemoveTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof ArrayRemoveTransformOperation &&
            arrayEquals(other.elements, this.elements));
    };
    return ArrayRemoveTransformOperation;
}());
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */
var NumericIncrementTransformOperation = /** @class */ (function () {
    function NumericIncrementTransformOperation(operand) {
        this.operand = operand;
        this.isIdempotent = false;
    }
    NumericIncrementTransformOperation.prototype.applyToLocalView = function (previousValue, localWriteTime) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        // Return an integer value iff the previous value and the operand is an
        // integer.
        if (previousValue instanceof IntegerValue &&
            this.operand instanceof IntegerValue) {
            var sum = previousValue.internalValue + this.operand.internalValue;
            return new IntegerValue(sum);
        }
        else if (previousValue instanceof NumberValue) {
            var sum = previousValue.internalValue + this.operand.internalValue;
            return new DoubleValue(sum);
        }
        else {
            // If the existing value is not a number, use the value of the transform as
            // the new base value.
            return this.operand;
        }
    };
    NumericIncrementTransformOperation.prototype.applyToRemoteDocument = function (previousValue, transformResult) {
        assert(transformResult !== null, "Didn't receive transformResult for NUMERIC_ADD transform");
        return transformResult;
    };
    NumericIncrementTransformOperation.prototype.isEqual = function (other) {
        return (other instanceof NumericIncrementTransformOperation &&
            this.operand.isEqual(other.operand));
    };
    return NumericIncrementTransformOperation;
}());
function coercedFieldValuesArray(value) {
    if (value instanceof ArrayValue) {
        return value.internalValue.slice();
    }
    else {
        // coerce to empty array.
        return [];
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExistenceFilter = /** @class */ (function () {
    // TODO(b/33078163): just use simplest form of existence filter for now
    function ExistenceFilter(count) {
        this.count = count;
    }
    ExistenceFilter.prototype.isEqual = function (other) {
        return other && other.count === this.count;
    };
    return ExistenceFilter;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DIRECTIONS = (function () {
    var dirs = {};
    dirs[Direction.ASCENDING.name] = 'ASCENDING';
    dirs[Direction.DESCENDING.name] = 'DESCENDING';
    return dirs;
})();
var OPERATORS = (function () {
    var ops = {};
    ops[Operator.LESS_THAN.name] = 'LESS_THAN';
    ops[Operator.LESS_THAN_OR_EQUAL.name] = 'LESS_THAN_OR_EQUAL';
    ops[Operator.GREATER_THAN.name] = 'GREATER_THAN';
    ops[Operator.GREATER_THAN_OR_EQUAL.name] = 'GREATER_THAN_OR_EQUAL';
    ops[Operator.EQUAL.name] = 'EQUAL';
    ops[Operator.ARRAY_CONTAINS.name] = 'ARRAY_CONTAINS';
    ops[Operator.IN.name] = 'IN';
    ops[Operator.ARRAY_CONTAINS_ANY.name] = 'ARRAY_CONTAINS_ANY';
    return ops;
})();
// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var ISO_REG_EXP = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
function assertPresent(value, description) {
    assert(!isNullOrUndefined(value), description + ' is missing');
}
function parseInt64(value) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    if (typeof value === 'number') {
        return value;
    }
    else if (typeof value === 'string') {
        return Number(value);
    }
    else {
        return fail("can't parse " + value);
    }
}
/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */
var JsonProtoSerializer = /** @class */ (function () {
    function JsonProtoSerializer(databaseId, options) {
        this.databaseId = databaseId;
        this.options = options;
    }
    JsonProtoSerializer.prototype.emptyByteString = function () {
        if (this.options.useProto3Json) {
            return '';
        }
        else {
            return new Uint8Array(0);
        }
    };
    JsonProtoSerializer.prototype.unsafeCastProtoByteString = function (byteString) {
        // byteStrings can be either string or UInt8Array, but the typings say
        // it's always a string. Cast as string to avoid type check failing
        return byteString;
    };
    JsonProtoSerializer.prototype.fromRpcStatus = function (status) {
        var code = status.code === undefined
            ? Code.UNKNOWN
            : mapCodeFromRpcCode(status.code);
        return new FirestoreError(code, status.message || '');
    };
    /**
     * Returns a value for a number (or undefined) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */
    JsonProtoSerializer.prototype.toInt32Value = function (val) {
        if (!isNullOrUndefined(val)) {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            return { value: val };
        }
        else {
            return undefined;
        }
    };
    /**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as accepting "number" because that's what
     * our generated proto interfaces say Int32Value must be, but it actually
     * accepts { value: number } to match our serialization in toInt32Value().
     */
    JsonProtoSerializer.prototype.fromInt32Value = function (val) {
        var result;
        if (typeof val === 'object') {
            // tslint:disable-next-line:no-any We need to match generated Proto types.
            result = val.value;
        }
        else {
            // We accept raw numbers (without the {value: ... } wrapper) for
            // compatibility with legacy persisted data.
            result = val;
        }
        return isNullOrUndefined(result) ? null : result;
    };
    /**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */
    JsonProtoSerializer.prototype.toTimestamp = function (timestamp) {
        return {
            seconds: '' + timestamp.seconds,
            nanos: timestamp.nanoseconds
            // tslint:disable-next-line:no-any
        };
    };
    JsonProtoSerializer.prototype.fromTimestamp = function (date) {
        // The json interface (for the browser) will return an iso timestamp string,
        // while the proto js library (for node) will return a
        // google.protobuf.Timestamp instance.
        if (typeof date === 'string') {
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(this.options.useProto3Json,
            //   'The timestamp string format requires Proto3.');
            return this.fromIso8601String(date);
        }
        else {
            assert(!!date, 'Cannot deserialize null or undefined timestamp.');
            // TODO(b/37282237): Use strings for Proto3 timestamps
            // assert(!this.options.useProto3Json,
            //   'The timestamp instance format requires Proto JS.');
            var seconds = parseInt64(date.seconds || '0');
            var nanos = date.nanos || 0;
            return new Timestamp(seconds, nanos);
        }
    };
    JsonProtoSerializer.prototype.fromIso8601String = function (utc) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var nanos = 0;
        var fraction = ISO_REG_EXP.exec(utc);
        assert(!!fraction, 'invalid timestamp: ' + utc);
        if (fraction[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var nanoStr = fraction[1];
            nanoStr = (nanoStr + '000000000').substr(0, 9);
            nanos = Number(nanoStr);
        }
        // Parse the date to get the seconds.
        var date = new Date(utc);
        var seconds = Math.floor(date.getTime() / 1000);
        return new Timestamp(seconds, nanos);
    };
    /**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */
    JsonProtoSerializer.prototype.toBytes = function (bytes) {
        if (this.options.useProto3Json) {
            return bytes.toBase64();
        }
        else {
            // The typings say it's a string, but it needs to be a Uint8Array in Node.
            return this.unsafeCastProtoByteString(bytes.toUint8Array());
        }
    };
    /**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */
    JsonProtoSerializer.prototype.fromBlob = function (blob) {
        if (typeof blob === 'string') {
            assert(this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromBase64String(blob);
        }
        else {
            assert(!this.options.useProto3Json, 'Expected bytes to be passed in as Uint8Array, but got a string instead.');
            return Blob.fromUint8Array(blob);
        }
    };
    JsonProtoSerializer.prototype.toVersion = function (version) {
        return this.toTimestamp(version.toTimestamp());
    };
    JsonProtoSerializer.prototype.fromVersion = function (version) {
        assert(!!version, "Trying to deserialize version that isn't set");
        return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));
    };
    JsonProtoSerializer.prototype.toResourceName = function (databaseId, path) {
        return this.fullyQualifiedPrefixPath(databaseId)
            .child('documents')
            .child(path)
            .canonicalString();
    };
    JsonProtoSerializer.prototype.fromResourceName = function (name) {
        var resource = ResourcePath.fromString(name);
        assert(this.isValidResourceName(resource), 'Tried to deserialize invalid key ' + resource.toString());
        return resource;
    };
    JsonProtoSerializer.prototype.toName = function (key) {
        return this.toResourceName(this.databaseId, key.path);
    };
    JsonProtoSerializer.prototype.fromName = function (name) {
        var resource = this.fromResourceName(name);
        assert(resource.get(1) === this.databaseId.projectId, 'Tried to deserialize key from different project: ' +
            resource.get(1) +
            ' vs ' +
            this.databaseId.projectId);
        assert((!resource.get(3) && !this.databaseId.database) ||
            resource.get(3) === this.databaseId.database, 'Tried to deserialize key from different database: ' +
            resource.get(3) +
            ' vs ' +
            this.databaseId.database);
        return new DocumentKey(this.extractLocalPathFromResourceName(resource));
    };
    JsonProtoSerializer.prototype.toQueryPath = function (path) {
        return this.toResourceName(this.databaseId, path);
    };
    JsonProtoSerializer.prototype.fromQueryPath = function (name) {
        var resourceName = this.fromResourceName(name);
        // In v1beta1 queries for collections at the root did not have a trailing
        // "/documents". In v1 all resource paths contain "/documents". Preserve the
        // ability to read the v1beta1 form for compatibility with queries persisted
        // in the local query cache.
        if (resourceName.length === 4) {
            return ResourcePath.EMPTY_PATH;
        }
        return this.extractLocalPathFromResourceName(resourceName);
    };
    Object.defineProperty(JsonProtoSerializer.prototype, "encodedDatabaseId", {
        get: function () {
            var path = new ResourcePath([
                'projects',
                this.databaseId.projectId,
                'databases',
                this.databaseId.database
            ]);
            return path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    JsonProtoSerializer.prototype.fullyQualifiedPrefixPath = function (databaseId) {
        return new ResourcePath([
            'projects',
            databaseId.projectId,
            'databases',
            databaseId.database
        ]);
    };
    JsonProtoSerializer.prototype.extractLocalPathFromResourceName = function (resourceName) {
        assert(resourceName.length > 4 && resourceName.get(4) === 'documents', 'tried to deserialize invalid key ' + resourceName.toString());
        return resourceName.popFirst(5);
    };
    JsonProtoSerializer.prototype.isValidResourceName = function (path) {
        // Resource names have at least 4 components (project ID, database ID)
        return (path.length >= 4 &&
            path.get(0) === 'projects' &&
            path.get(2) === 'databases');
    };
    JsonProtoSerializer.prototype.toValue = function (val) {
        if (val instanceof NullValue) {
            return { nullValue: 'NULL_VALUE' };
        }
        else if (val instanceof BooleanValue) {
            return { booleanValue: val.value() };
        }
        else if (val instanceof IntegerValue) {
            return { integerValue: '' + val.value() };
        }
        else if (val instanceof DoubleValue) {
            var doubleValue = val.value();
            if (this.options.useProto3Json) {
                // Proto 3 let's us encode NaN and Infinity as string values as
                // expected by the backend. This is currently not checked by our unit
                // tests because they rely on protobuf.js.
                if (isNaN(doubleValue)) {
                    return { doubleValue: 'NaN' };
                }
                else if (doubleValue === Infinity) {
                    return { doubleValue: 'Infinity' };
                }
                else if (doubleValue === -Infinity) {
                    return { doubleValue: '-Infinity' };
                }
            }
            return { doubleValue: val.value() };
        }
        else if (val instanceof StringValue) {
            return { stringValue: val.value() };
        }
        else if (val instanceof ObjectValue) {
            return { mapValue: this.toMapValue(val) };
        }
        else if (val instanceof ArrayValue) {
            return { arrayValue: this.toArrayValue(val) };
        }
        else if (val instanceof TimestampValue) {
            return {
                timestampValue: this.toTimestamp(val.internalValue)
            };
        }
        else if (val instanceof GeoPointValue) {
            return {
                geoPointValue: {
                    latitude: val.value().latitude,
                    longitude: val.value().longitude
                }
            };
        }
        else if (val instanceof BlobValue) {
            return {
                bytesValue: this.toBytes(val.value())
            };
        }
        else if (val instanceof RefValue) {
            return {
                referenceValue: this.toResourceName(val.databaseId, val.key.path)
            };
        }
        else {
            return fail('Unknown FieldValue ' + JSON.stringify(val));
        }
    };
    JsonProtoSerializer.prototype.fromValue = function (obj) {
        var _this = this;
        if ('nullValue' in obj) {
            return NullValue.INSTANCE;
        }
        else if ('booleanValue' in obj) {
            return BooleanValue.of(obj.booleanValue);
        }
        else if ('integerValue' in obj) {
            return new IntegerValue(parseInt64(obj.integerValue));
        }
        else if ('doubleValue' in obj) {
            if (this.options.useProto3Json) {
                // Proto 3 uses the string values 'NaN' and 'Infinity'.
                if (obj.doubleValue === 'NaN') {
                    return DoubleValue.NAN;
                }
                else if (obj.doubleValue === 'Infinity') {
                    return DoubleValue.POSITIVE_INFINITY;
                }
                else if (obj.doubleValue === '-Infinity') {
                    return DoubleValue.NEGATIVE_INFINITY;
                }
            }
            return new DoubleValue(obj.doubleValue);
        }
        else if ('stringValue' in obj) {
            return new StringValue(obj.stringValue);
        }
        else if ('mapValue' in obj) {
            return this.fromFields(obj.mapValue.fields || {});
        }
        else if ('arrayValue' in obj) {
            // "values" is not present if the array is empty
            assertPresent(obj.arrayValue, 'arrayValue');
            var values = obj.arrayValue.values || [];
            return new ArrayValue(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('timestampValue' in obj) {
            assertPresent(obj.timestampValue, 'timestampValue');
            return new TimestampValue(this.fromTimestamp(obj.timestampValue));
        }
        else if ('geoPointValue' in obj) {
            assertPresent(obj.geoPointValue, 'geoPointValue');
            var latitude = obj.geoPointValue.latitude || 0;
            var longitude = obj.geoPointValue.longitude || 0;
            return new GeoPointValue(new GeoPoint(latitude, longitude));
        }
        else if ('bytesValue' in obj) {
            assertPresent(obj.bytesValue, 'bytesValue');
            var blob = this.fromBlob(obj.bytesValue);
            return new BlobValue(blob);
        }
        else if ('referenceValue' in obj) {
            assertPresent(obj.referenceValue, 'referenceValue');
            var resourceName = this.fromResourceName(obj.referenceValue);
            var dbId = new DatabaseId(resourceName.get(1), resourceName.get(3));
            var key = new DocumentKey(this.extractLocalPathFromResourceName(resourceName));
            return new RefValue(dbId, key);
        }
        else {
            return fail('Unknown Value proto ' + JSON.stringify(obj));
        }
    };
    /** Creates an api.Document from key and fields (but no create/update time) */
    JsonProtoSerializer.prototype.toMutationDocument = function (key, fields) {
        return {
            name: this.toName(key),
            fields: this.toFields(fields)
        };
    };
    JsonProtoSerializer.prototype.toDocument = function (document) {
        assert(!document.hasLocalMutations, "Can't serialize documents with mutations.");
        return {
            name: this.toName(document.key),
            fields: this.toFields(document.data),
            updateTime: this.toTimestamp(document.version.toTimestamp())
        };
    };
    JsonProtoSerializer.prototype.fromDocument = function (document, hasCommittedMutations) {
        return new Document(this.fromName(document.name), this.fromVersion(document.updateTime), this.fromFields(document.fields || {}), { hasCommittedMutations: !!hasCommittedMutations });
    };
    JsonProtoSerializer.prototype.toFields = function (fields) {
        var _this = this;
        var result = {};
        fields.forEach(function (key, value) {
            result[key] = _this.toValue(value);
        });
        return result;
    };
    JsonProtoSerializer.prototype.fromFields = function (object) {
        var _this = this;
        // Proto map<string, Value> gets mapped to Object, so cast it.
        var map = object;
        var result = ObjectValue.EMPTY;
        forEach(map, function (key, value) {
            result = result.set(new FieldPath([key]), _this.fromValue(value));
        });
        return result;
    };
    JsonProtoSerializer.prototype.toMapValue = function (map) {
        return {
            fields: this.toFields(map)
        };
    };
    JsonProtoSerializer.prototype.toArrayValue = function (array) {
        var _this = this;
        var result = [];
        array.forEach(function (value) {
            result.push(_this.toValue(value));
        });
        return { values: result };
    };
    JsonProtoSerializer.prototype.fromFound = function (doc) {
        assert(!!doc.found, 'Tried to deserialize a found document from a missing document.');
        assertPresent(doc.found.name, 'doc.found.name');
        assertPresent(doc.found.updateTime, 'doc.found.updateTime');
        var key = this.fromName(doc.found.name);
        var version = this.fromVersion(doc.found.updateTime);
        var fields = this.fromFields(doc.found.fields || {});
        return new Document(key, version, fields, {}, doc.found);
    };
    JsonProtoSerializer.prototype.fromMissing = function (result) {
        assert(!!result.missing, 'Tried to deserialize a missing document from a found document.');
        assert(!!result.readTime, 'Tried to deserialize a missing document without a read time.');
        var key = this.fromName(result.missing);
        var version = this.fromVersion(result.readTime);
        return new NoDocument(key, version);
    };
    JsonProtoSerializer.prototype.fromMaybeDocument = function (result) {
        if ('found' in result) {
            return this.fromFound(result);
        }
        else if ('missing' in result) {
            return this.fromMissing(result);
        }
        return fail('invalid batch get response: ' + JSON.stringify(result));
    };
    JsonProtoSerializer.prototype.toWatchTargetChangeState = function (state) {
        switch (state) {
            case WatchTargetChangeState.Added:
                return 'ADD';
            case WatchTargetChangeState.Current:
                return 'CURRENT';
            case WatchTargetChangeState.NoChange:
                return 'NO_CHANGE';
            case WatchTargetChangeState.Removed:
                return 'REMOVE';
            case WatchTargetChangeState.Reset:
                return 'RESET';
            default:
                return fail('Unknown WatchTargetChangeState: ' + state);
        }
    };
    JsonProtoSerializer.prototype.toTestWatchChange = function (watchChange) {
        if (watchChange instanceof ExistenceFilterChange) {
            return {
                filter: {
                    count: watchChange.existenceFilter.count,
                    targetId: watchChange.targetId
                }
            };
        }
        if (watchChange instanceof DocumentWatchChange) {
            if (watchChange.newDoc instanceof Document) {
                var doc = watchChange.newDoc;
                return {
                    documentChange: {
                        document: {
                            name: this.toName(doc.key),
                            fields: this.toFields(doc.data),
                            updateTime: this.toVersion(doc.version)
                        },
                        targetIds: watchChange.updatedTargetIds,
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc instanceof NoDocument) {
                var doc = watchChange.newDoc;
                return {
                    documentDelete: {
                        document: this.toName(doc.key),
                        readTime: this.toVersion(doc.version),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
            else if (watchChange.newDoc === null) {
                return {
                    documentRemove: {
                        document: this.toName(watchChange.key),
                        removedTargetIds: watchChange.removedTargetIds
                    }
                };
            }
        }
        if (watchChange instanceof WatchTargetChange) {
            var cause = undefined;
            if (watchChange.cause) {
                cause = {
                    code: mapRpcCodeFromCode(watchChange.cause.code),
                    message: watchChange.cause.message
                };
            }
            return {
                targetChange: {
                    targetChangeType: this.toWatchTargetChangeState(watchChange.state),
                    targetIds: watchChange.targetIds,
                    resumeToken: this.unsafeCastProtoByteString(watchChange.resumeToken),
                    cause: cause
                }
            };
        }
        return fail('Unrecognized watch change: ' + JSON.stringify(watchChange));
    };
    JsonProtoSerializer.prototype.fromWatchChange = function (change) {
        var watchChange;
        if ('targetChange' in change) {
            assertPresent(change.targetChange, 'targetChange');
            // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
            // if unset
            var state = this.fromWatchTargetChangeState(change.targetChange.targetChangeType || 'NO_CHANGE');
            var targetIds = change.targetChange.targetIds || [];
            var resumeToken = change.targetChange.resumeToken || this.emptyByteString();
            var causeProto = change.targetChange.cause;
            var cause = causeProto && this.fromRpcStatus(causeProto);
            watchChange = new WatchTargetChange(state, targetIds, resumeToken, cause || null);
        }
        else if ('documentChange' in change) {
            assertPresent(change.documentChange, 'documentChange');
            assertPresent(change.documentChange.document, 'documentChange.name');
            assertPresent(change.documentChange.document.name, 'documentChange.document.name');
            assertPresent(change.documentChange.document.updateTime, 'documentChange.document.updateTime');
            var entityChange = change.documentChange;
            var key = this.fromName(entityChange.document.name);
            var version = this.fromVersion(entityChange.document.updateTime);
            var fields = this.fromFields(entityChange.document.fields || {});
            // The document may soon be re-serialized back to protos in order to store it in local
            // persistence. Memoize the encoded form to avoid encoding it again.
            var doc = new Document(key, version, fields, {}, entityChange.document);
            var updatedTargetIds = entityChange.targetIds || [];
            var removedTargetIds = entityChange.removedTargetIds || [];
            watchChange = new DocumentWatchChange(updatedTargetIds, removedTargetIds, doc.key, doc);
        }
        else if ('documentDelete' in change) {
            assertPresent(change.documentDelete, 'documentDelete');
            assertPresent(change.documentDelete.document, 'documentDelete.document');
            var docDelete = change.documentDelete;
            var key = this.fromName(docDelete.document);
            var version = docDelete.readTime
                ? this.fromVersion(docDelete.readTime)
                : SnapshotVersion.forDeletedDoc();
            var doc = new NoDocument(key, version);
            var removedTargetIds = docDelete.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, doc.key, doc);
        }
        else if ('documentRemove' in change) {
            assertPresent(change.documentRemove, 'documentRemove');
            assertPresent(change.documentRemove.document, 'documentRemove');
            var docRemove = change.documentRemove;
            var key = this.fromName(docRemove.document);
            var removedTargetIds = docRemove.removedTargetIds || [];
            watchChange = new DocumentWatchChange([], removedTargetIds, key, null);
        }
        else if ('filter' in change) {
            // TODO(dimond): implement existence filter parsing with strategy.
            assertPresent(change.filter, 'filter');
            assertPresent(change.filter.targetId, 'filter.targetId');
            var filter = change.filter;
            var count = filter.count || 0;
            var existenceFilter = new ExistenceFilter(count);
            var targetId = filter.targetId;
            watchChange = new ExistenceFilterChange(targetId, existenceFilter);
        }
        else {
            return fail('Unknown change type ' + JSON.stringify(change));
        }
        return watchChange;
    };
    JsonProtoSerializer.prototype.fromWatchTargetChangeState = function (state) {
        if (state === 'NO_CHANGE') {
            return WatchTargetChangeState.NoChange;
        }
        else if (state === 'ADD') {
            return WatchTargetChangeState.Added;
        }
        else if (state === 'REMOVE') {
            return WatchTargetChangeState.Removed;
        }
        else if (state === 'CURRENT') {
            return WatchTargetChangeState.Current;
        }
        else if (state === 'RESET') {
            return WatchTargetChangeState.Reset;
        }
        else {
            return fail('Got unexpected TargetChange.state: ' + state);
        }
    };
    JsonProtoSerializer.prototype.versionFromListenResponse = function (change) {
        // We have only reached a consistent snapshot for the entire stream if there
        // is a read_time set and it applies to all targets (i.e. the list of
        // targets is empty). The backend is guaranteed to send such responses.
        if (!('targetChange' in change)) {
            return SnapshotVersion.MIN;
        }
        var targetChange = change.targetChange;
        if (targetChange.targetIds && targetChange.targetIds.length) {
            return SnapshotVersion.MIN;
        }
        if (!targetChange.readTime) {
            return SnapshotVersion.MIN;
        }
        return this.fromVersion(targetChange.readTime);
    };
    JsonProtoSerializer.prototype.toMutation = function (mutation) {
        var _this = this;
        var result;
        if (mutation instanceof SetMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.value)
            };
        }
        else if (mutation instanceof DeleteMutation) {
            result = { delete: this.toName(mutation.key) };
        }
        else if (mutation instanceof PatchMutation) {
            result = {
                update: this.toMutationDocument(mutation.key, mutation.data),
                updateMask: this.toDocumentMask(mutation.fieldMask)
            };
        }
        else if (mutation instanceof TransformMutation) {
            result = {
                transform: {
                    document: this.toName(mutation.key),
                    fieldTransforms: mutation.fieldTransforms.map(function (transform) {
                        return _this.toFieldTransform(transform);
                    })
                }
            };
        }
        else {
            return fail('Unknown mutation type ' + mutation.type);
        }
        if (!mutation.precondition.isNone) {
            result.currentDocument = this.toPrecondition(mutation.precondition);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromMutation = function (proto) {
        var _this = this;
        var precondition = proto.currentDocument
            ? this.fromPrecondition(proto.currentDocument)
            : Precondition.NONE;
        if (proto.update) {
            assertPresent(proto.update.name, 'name');
            var key = this.fromName(proto.update.name);
            var value = this.fromFields(proto.update.fields || {});
            if (proto.updateMask) {
                var fieldMask = this.fromDocumentMask(proto.updateMask);
                return new PatchMutation(key, value, fieldMask, precondition);
            }
            else {
                return new SetMutation(key, value, precondition);
            }
        }
        else if (proto.delete) {
            var key = this.fromName(proto.delete);
            return new DeleteMutation(key, precondition);
        }
        else if (proto.transform) {
            var key = this.fromName(proto.transform.document);
            var fieldTransforms = proto.transform.fieldTransforms.map(function (transform) {
                return _this.fromFieldTransform(transform);
            });
            assert(precondition.exists === true, 'Transforms only support precondition "exists == true"');
            return new TransformMutation(key, fieldTransforms);
        }
        else {
            return fail('unknown mutation proto: ' + JSON.stringify(proto));
        }
    };
    JsonProtoSerializer.prototype.toPrecondition = function (precondition) {
        assert(!precondition.isNone, "Can't serialize an empty precondition");
        if (precondition.updateTime !== undefined) {
            return {
                updateTime: this.toVersion(precondition.updateTime)
            };
        }
        else if (precondition.exists !== undefined) {
            return { exists: precondition.exists };
        }
        else {
            return fail('Unknown precondition');
        }
    };
    JsonProtoSerializer.prototype.fromPrecondition = function (precondition) {
        if (precondition.updateTime !== undefined) {
            return Precondition.updateTime(this.fromVersion(precondition.updateTime));
        }
        else if (precondition.exists !== undefined) {
            return Precondition.exists(precondition.exists);
        }
        else {
            return Precondition.NONE;
        }
    };
    JsonProtoSerializer.prototype.fromWriteResult = function (proto, commitTime) {
        var _this = this;
        // NOTE: Deletes don't have an updateTime.
        var version = proto.updateTime
            ? this.fromVersion(proto.updateTime)
            : this.fromVersion(commitTime);
        var transformResults = null;
        if (proto.transformResults && proto.transformResults.length > 0) {
            transformResults = proto.transformResults.map(function (result) {
                return _this.fromValue(result);
            });
        }
        return new MutationResult(version, transformResults);
    };
    JsonProtoSerializer.prototype.fromWriteResults = function (protos, commitTime) {
        var _this = this;
        if (protos && protos.length > 0) {
            assert(commitTime !== undefined, 'Received a write result without a commit time');
            return protos.map(function (proto) { return _this.fromWriteResult(proto, commitTime); });
        }
        else {
            return [];
        }
    };
    JsonProtoSerializer.prototype.toFieldTransform = function (fieldTransform) {
        var _this = this;
        var transform = fieldTransform.transform;
        if (transform instanceof ServerTimestampTransform) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                setToServerValue: 'REQUEST_TIME'
            };
        }
        else if (transform instanceof ArrayUnionTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                appendMissingElements: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof ArrayRemoveTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                removeAllFromArray: {
                    values: transform.elements.map(function (v) { return _this.toValue(v); })
                }
            };
        }
        else if (transform instanceof NumericIncrementTransformOperation) {
            return {
                fieldPath: fieldTransform.field.canonicalString(),
                increment: this.toValue(transform.operand)
            };
        }
        else {
            throw fail('Unknown transform: ' + fieldTransform.transform);
        }
    };
    JsonProtoSerializer.prototype.fromFieldTransform = function (proto) {
        var _this = this;
        var transform = null;
        if ('setToServerValue' in proto) {
            assert(proto.setToServerValue === 'REQUEST_TIME', 'Unknown server value transform proto: ' + JSON.stringify(proto));
            transform = ServerTimestampTransform.instance;
        }
        else if ('appendMissingElements' in proto) {
            var values = proto.appendMissingElements.values || [];
            transform = new ArrayUnionTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('removeAllFromArray' in proto) {
            var values = proto.removeAllFromArray.values || [];
            transform = new ArrayRemoveTransformOperation(values.map(function (v) { return _this.fromValue(v); }));
        }
        else if ('increment' in proto) {
            var operand = this.fromValue(proto.increment);
            assert(operand instanceof NumberValue, 'NUMERIC_ADD transform requires a NumberValue');
            transform = new NumericIncrementTransformOperation(operand);
        }
        else {
            fail('Unknown transform proto: ' + JSON.stringify(proto));
        }
        var fieldPath = FieldPath.fromServerFormat(proto.fieldPath);
        return new FieldTransform(fieldPath, transform);
    };
    JsonProtoSerializer.prototype.toDocumentsTarget = function (query) {
        return { documents: [this.toQueryPath(query.path)] };
    };
    JsonProtoSerializer.prototype.fromDocumentsTarget = function (documentsTarget) {
        var count = documentsTarget.documents.length;
        assert(count === 1, 'DocumentsTarget contained other than 1 document: ' + count);
        var name = documentsTarget.documents[0];
        return Query.atPath(this.fromQueryPath(name));
    };
    JsonProtoSerializer.prototype.toQueryTarget = function (query) {
        // Dissect the path into parent, collectionId, and optional key filter.
        var result = { structuredQuery: {} };
        var path = query.path;
        if (query.collectionGroup !== null) {
            assert(path.length % 2 === 0, 'Collection Group queries should be within a document path or root.');
            result.parent = this.toQueryPath(path);
            result.structuredQuery.from = [
                {
                    collectionId: query.collectionGroup,
                    allDescendants: true
                }
            ];
        }
        else {
            assert(path.length % 2 !== 0, 'Document queries with filters are not supported.');
            result.parent = this.toQueryPath(path.popLast());
            result.structuredQuery.from = [{ collectionId: path.lastSegment() }];
        }
        var where = this.toFilter(query.filters);
        if (where) {
            result.structuredQuery.where = where;
        }
        var orderBy = this.toOrder(query.orderBy);
        if (orderBy) {
            result.structuredQuery.orderBy = orderBy;
        }
        var limit = this.toInt32Value(query.limit);
        if (limit !== undefined) {
            result.structuredQuery.limit = limit;
        }
        if (query.startAt) {
            result.structuredQuery.startAt = this.toCursor(query.startAt);
        }
        if (query.endAt) {
            result.structuredQuery.endAt = this.toCursor(query.endAt);
        }
        return result;
    };
    JsonProtoSerializer.prototype.fromQueryTarget = function (target) {
        var path = this.fromQueryPath(target.parent);
        var query = target.structuredQuery;
        var fromCount = query.from ? query.from.length : 0;
        var collectionGroup = null;
        if (fromCount > 0) {
            assert(fromCount === 1, 'StructuredQuery.from with more than one collection is not supported.');
            var from = query.from[0];
            if (from.allDescendants) {
                collectionGroup = from.collectionId;
            }
            else {
                path = path.child(from.collectionId);
            }
        }
        var filterBy = [];
        if (query.where) {
            filterBy = this.fromFilter(query.where);
        }
        var orderBy = [];
        if (query.orderBy) {
            orderBy = this.fromOrder(query.orderBy);
        }
        var limit = null;
        if (query.limit) {
            limit = this.fromInt32Value(query.limit);
        }
        var startAt = null;
        if (query.startAt) {
            startAt = this.fromCursor(query.startAt);
        }
        var endAt = null;
        if (query.endAt) {
            endAt = this.fromCursor(query.endAt);
        }
        return new Query(path, collectionGroup, orderBy, filterBy, limit, startAt, endAt);
    };
    JsonProtoSerializer.prototype.toListenRequestLabels = function (queryData) {
        var value = this.toLabel(queryData.purpose);
        if (value == null) {
            return null;
        }
        else {
            return {
                'goog-listen-tags': value
            };
        }
    };
    JsonProtoSerializer.prototype.toLabel = function (purpose) {
        switch (purpose) {
            case QueryPurpose.Listen:
                return null;
            case QueryPurpose.ExistenceFilterMismatch:
                return 'existence-filter-mismatch';
            case QueryPurpose.LimboResolution:
                return 'limbo-document';
            default:
                return fail('Unrecognized query purpose: ' + purpose);
        }
    };
    JsonProtoSerializer.prototype.toTarget = function (queryData) {
        var result;
        var query = queryData.query;
        if (query.isDocumentQuery()) {
            result = { documents: this.toDocumentsTarget(query) };
        }
        else {
            result = { query: this.toQueryTarget(query) };
        }
        result.targetId = queryData.targetId;
        if (queryData.resumeToken.length > 0) {
            result.resumeToken = this.unsafeCastProtoByteString(queryData.resumeToken);
        }
        return result;
    };
    JsonProtoSerializer.prototype.toFilter = function (filters) {
        var _this = this;
        if (filters.length === 0)
            return;
        var protos = filters.map(function (filter) {
            if (filter instanceof FieldFilter) {
                return _this.toUnaryOrFieldFilter(filter);
            }
            else {
                return fail('Unrecognized filter: ' + JSON.stringify(filter));
            }
        });
        if (protos.length === 1) {
            return protos[0];
        }
        return { compositeFilter: { op: 'AND', filters: protos } };
    };
    JsonProtoSerializer.prototype.fromFilter = function (filter) {
        var _this = this;
        if (!filter) {
            return [];
        }
        else if (filter.unaryFilter !== undefined) {
            return [this.fromUnaryFilter(filter)];
        }
        else if (filter.fieldFilter !== undefined) {
            return [this.fromFieldFilter(filter)];
        }
        else if (filter.compositeFilter !== undefined) {
            return filter.compositeFilter
                .filters.map(function (f) { return _this.fromFilter(f); })
                .reduce(function (accum, current) { return accum.concat(current); });
        }
        else {
            return fail('Unknown filter: ' + JSON.stringify(filter));
        }
    };
    JsonProtoSerializer.prototype.toOrder = function (orderBys) {
        var _this = this;
        if (orderBys.length === 0)
            return;
        return orderBys.map(function (order) { return _this.toPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.fromOrder = function (orderBys) {
        var _this = this;
        return orderBys.map(function (order) { return _this.fromPropertyOrder(order); });
    };
    JsonProtoSerializer.prototype.toCursor = function (cursor) {
        var _this = this;
        return {
            before: cursor.before,
            values: cursor.position.map(function (component) { return _this.toValue(component); })
        };
    };
    JsonProtoSerializer.prototype.fromCursor = function (cursor) {
        var _this = this;
        var before = !!cursor.before;
        var position = cursor.values.map(function (component) { return _this.fromValue(component); });
        return new Bound(position, before);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toDirection = function (dir) {
        return DIRECTIONS[dir.name];
    };
    // visible for testing
    JsonProtoSerializer.prototype.fromDirection = function (dir) {
        switch (dir) {
            case 'ASCENDING':
                return Direction.ASCENDING;
            case 'DESCENDING':
                return Direction.DESCENDING;
            default:
                return undefined;
        }
    };
    // visible for testing
    JsonProtoSerializer.prototype.toOperatorName = function (op) {
        return OPERATORS[op.name];
    };
    JsonProtoSerializer.prototype.fromOperatorName = function (op) {
        switch (op) {
            case 'EQUAL':
                return Operator.EQUAL;
            case 'GREATER_THAN':
                return Operator.GREATER_THAN;
            case 'GREATER_THAN_OR_EQUAL':
                return Operator.GREATER_THAN_OR_EQUAL;
            case 'LESS_THAN':
                return Operator.LESS_THAN;
            case 'LESS_THAN_OR_EQUAL':
                return Operator.LESS_THAN_OR_EQUAL;
            case 'ARRAY_CONTAINS':
                return Operator.ARRAY_CONTAINS;
            case 'IN':
                return Operator.IN;
            case 'ARRAY_CONTAINS_ANY':
                return Operator.ARRAY_CONTAINS_ANY;
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified operator');
            default:
                return fail('Unknown operator');
        }
    };
    JsonProtoSerializer.prototype.toFieldPathReference = function (path) {
        return { fieldPath: path.canonicalString() };
    };
    JsonProtoSerializer.prototype.fromFieldPathReference = function (fieldReference) {
        return FieldPath.fromServerFormat(fieldReference.fieldPath);
    };
    // visible for testing
    JsonProtoSerializer.prototype.toPropertyOrder = function (orderBy) {
        return {
            field: this.toFieldPathReference(orderBy.field),
            direction: this.toDirection(orderBy.dir)
        };
    };
    JsonProtoSerializer.prototype.fromPropertyOrder = function (orderBy) {
        return new OrderBy(this.fromFieldPathReference(orderBy.field), this.fromDirection(orderBy.direction));
    };
    JsonProtoSerializer.prototype.fromFieldFilter = function (filter) {
        return FieldFilter.create(this.fromFieldPathReference(filter.fieldFilter.field), this.fromOperatorName(filter.fieldFilter.op), this.fromValue(filter.fieldFilter.value));
    };
    // visible for testing
    JsonProtoSerializer.prototype.toUnaryOrFieldFilter = function (filter) {
        if (filter.op === Operator.EQUAL) {
            if (filter.value.isEqual(DoubleValue.NAN)) {
                return {
                    unaryFilter: {
                        field: this.toFieldPathReference(filter.field),
                        op: 'IS_NAN'
                    }
                };
            }
            else if (filter.value.isEqual(NullValue.INSTANCE)) {
                return {
                    unaryFilter: {
                        field: this.toFieldPathReference(filter.field),
                        op: 'IS_NULL'
                    }
                };
            }
        }
        return {
            fieldFilter: {
                field: this.toFieldPathReference(filter.field),
                op: this.toOperatorName(filter.op),
                value: this.toValue(filter.value)
            }
        };
    };
    JsonProtoSerializer.prototype.fromUnaryFilter = function (filter) {
        switch (filter.unaryFilter.op) {
            case 'IS_NAN':
                var nanField = this.fromFieldPathReference(filter.unaryFilter.field);
                return FieldFilter.create(nanField, Operator.EQUAL, DoubleValue.NAN);
            case 'IS_NULL':
                var nullField = this.fromFieldPathReference(filter.unaryFilter.field);
                return FieldFilter.create(nullField, Operator.EQUAL, NullValue.INSTANCE);
            case 'OPERATOR_UNSPECIFIED':
                return fail('Unspecified filter');
            default:
                return fail('Unknown filter');
        }
    };
    JsonProtoSerializer.prototype.toDocumentMask = function (fieldMask) {
        var canonicalFields = [];
        fieldMask.fields.forEach(function (field) {
            return canonicalFields.push(field.canonicalString());
        });
        return {
            fieldPaths: canonicalFields
        };
    };
    JsonProtoSerializer.prototype.fromDocumentMask = function (proto) {
        var paths = proto.fieldPaths || [];
        var fields = paths.map(function (path) { return FieldPath.fromServerFormat(path); });
        return FieldMask.fromArray(fields);
    };
    return JsonProtoSerializer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */
var QueryListenersInfo = /** @class */ (function () {
    function QueryListenersInfo() {
        this.listeners = [];
    }
    return QueryListenersInfo;
}());
/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */
var EventManager = /** @class */ (function () {
    function EventManager(syncEngine) {
        this.syncEngine = syncEngine;
        this.queries = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.onlineState = OnlineState.Unknown;
        this.syncEngine.subscribe(this);
    }
    EventManager.prototype.listen = function (listener) {
        var query = listener.query;
        var firstListen = false;
        var queryInfo = this.queries.get(query);
        if (!queryInfo) {
            firstListen = true;
            queryInfo = new QueryListenersInfo();
            this.queries.set(query, queryInfo);
        }
        queryInfo.listeners.push(listener);
        listener.applyOnlineStateChange(this.onlineState);
        if (queryInfo.viewSnap)
            listener.onViewSnapshot(queryInfo.viewSnap);
        if (firstListen) {
            return this.syncEngine.listen(query).then(function (targetId) {
                queryInfo.targetId = targetId;
                return targetId;
            });
        }
        else {
            return Promise.resolve(queryInfo.targetId);
        }
    };
    EventManager.prototype.unlisten = function (listener) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, lastListen, queryInfo, i;
            return tslib_1.__generator(this, function (_a) {
                query = listener.query;
                lastListen = false;
                queryInfo = this.queries.get(query);
                if (queryInfo) {
                    i = queryInfo.listeners.indexOf(listener);
                    if (i >= 0) {
                        queryInfo.listeners.splice(i, 1);
                        lastListen = queryInfo.listeners.length === 0;
                    }
                }
                if (lastListen) {
                    this.queries.delete(query);
                    return [2 /*return*/, this.syncEngine.unlisten(query)];
                }
                return [2 /*return*/];
            });
        });
    };
    EventManager.prototype.onWatchChange = function (viewSnaps) {
        for (var _i = 0, viewSnaps_1 = viewSnaps; _i < viewSnaps_1.length; _i++) {
            var viewSnap = viewSnaps_1[_i];
            var query = viewSnap.query;
            var queryInfo = this.queries.get(query);
            if (queryInfo) {
                for (var _a = 0, _b = queryInfo.listeners; _a < _b.length; _a++) {
                    var listener = _b[_a];
                    listener.onViewSnapshot(viewSnap);
                }
                queryInfo.viewSnap = viewSnap;
            }
        }
    };
    EventManager.prototype.onWatchError = function (query, error) {
        var queryInfo = this.queries.get(query);
        if (queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.onError(error);
            }
        }
        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
        // after an error.
        this.queries.delete(query);
    };
    EventManager.prototype.onOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        this.queries.forEach(function (_, queryInfo) {
            for (var _i = 0, _a = queryInfo.listeners; _i < _a.length; _i++) {
                var listener = _a[_i];
                listener.applyOnlineStateChange(onlineState);
            }
        });
    };
    return EventManager;
}());
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */
var QueryListener = /** @class */ (function () {
    function QueryListener(query, queryObserver, options) {
        this.query = query;
        this.queryObserver = queryObserver;
        /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */
        this.raisedInitialEvent = false;
        this.onlineState = OnlineState.Unknown;
        this.options = options || {};
    }
    QueryListener.prototype.onViewSnapshot = function (snap) {
        assert(snap.docChanges.length > 0 || snap.syncStateChanged, 'We got a new snapshot with no changes?');
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            var docChanges = [];
            for (var _i = 0, _a = snap.docChanges; _i < _a.length; _i++) {
                var docChange = _a[_i];
                if (docChange.type !== ChangeType.Metadata) {
                    docChanges.push(docChange);
                }
            }
            snap = new ViewSnapshot(snap.query, snap.docs, snap.oldDocs, docChanges, snap.mutatedKeys, snap.fromCache, snap.syncStateChanged, 
            /* excludesMetadataChanges= */ true);
        }
        if (!this.raisedInitialEvent) {
            if (this.shouldRaiseInitialEvent(snap, this.onlineState)) {
                this.raiseInitialEvent(snap);
            }
        }
        else if (this.shouldRaiseEvent(snap)) {
            this.queryObserver.next(snap);
        }
        this.snap = snap;
    };
    QueryListener.prototype.onError = function (error) {
        this.queryObserver.error(error);
    };
    QueryListener.prototype.applyOnlineStateChange = function (onlineState) {
        this.onlineState = onlineState;
        if (this.snap &&
            !this.raisedInitialEvent &&
            this.shouldRaiseInitialEvent(this.snap, onlineState)) {
            this.raiseInitialEvent(this.snap);
        }
    };
    QueryListener.prototype.shouldRaiseInitialEvent = function (snap, onlineState) {
        assert(!this.raisedInitialEvent, 'Determining whether to raise first event but already had first event');
        // Always raise the first event when we're synced
        if (!snap.fromCache) {
            return true;
        }
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        var maybeOnline = onlineState !== OnlineState.Offline;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        if (this.options.waitForSyncWhenOnline && maybeOnline) {
            assert(snap.fromCache, 'Waiting for sync, but snapshot is not from cache');
            return false;
        }
        // Raise data from cache if we have any documents or we are offline
        return !snap.docs.isEmpty() || onlineState === OnlineState.Offline;
    };
    QueryListener.prototype.shouldRaiseEvent = function (snap) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (snap.docChanges.length > 0) {
            return true;
        }
        var hasPendingWritesChanged = this.snap && this.snap.hasPendingWrites !== snap.hasPendingWrites;
        if (snap.syncStateChanged || hasPendingWritesChanged) {
            return this.options.includeMetadataChanges === true;
        }
        // Generally we should have hit one of the cases above, but it's possible
        // to get here if there were only metadata docChanges and they got
        // stripped out.
        return false;
    };
    QueryListener.prototype.raiseInitialEvent = function (snap) {
        assert(!this.raisedInitialEvent, 'Trying to raise initial events for second time');
        snap = ViewSnapshot.fromInitialDocuments(snap.query, snap.docs, snap.mutatedKeys, snap.fromCache);
        this.raisedInitialEvent = true;
        this.queryObserver.next(snap);
    };
    return QueryListener;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */
var LocalViewChanges = /** @class */ (function () {
    function LocalViewChanges(targetId, addedKeys, removedKeys) {
        this.targetId = targetId;
        this.addedKeys = addedKeys;
        this.removedKeys = removedKeys;
    }
    LocalViewChanges.fromSnapshot = function (targetId, viewSnapshot) {
        var addedKeys = documentKeySet();
        var removedKeys = documentKeySet();
        for (var _i = 0, _a = viewSnapshot.docChanges; _i < _a.length; _i++) {
            var docChange = _a[_i];
            switch (docChange.type) {
                case ChangeType.Added:
                    addedKeys = addedKeys.add(docChange.doc.key);
                    break;
                case ChangeType.Removed:
                    removedKeys = removedKeys.add(docChange.doc.key);
                    break;
                default:
                // do nothing
            }
        }
        return new LocalViewChanges(targetId, addedKeys, removedKeys);
    };
    return LocalViewChanges;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AddedLimboDocument = /** @class */ (function () {
    function AddedLimboDocument(key) {
        this.key = key;
    }
    return AddedLimboDocument;
}());
var RemovedLimboDocument = /** @class */ (function () {
    function RemovedLimboDocument(key) {
        this.key = key;
    }
    return RemovedLimboDocument;
}());
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */
var View = /** @class */ (function () {
    function View(query, 
    /** Documents included in the remote target */
    _syncedDocuments) {
        this.query = query;
        this._syncedDocuments = _syncedDocuments;
        this.syncState = null;
        /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */
        this.current = false;
        /** Documents in the view but not in the remote target */
        this.limboDocuments = documentKeySet();
        /** Document Keys that have local changes */
        this.mutatedKeys = documentKeySet();
        this.documentSet = new DocumentSet(query.docComparator.bind(query));
    }
    Object.defineProperty(View.prototype, "syncedDocuments", {
        /**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */
        get: function () {
            return this._syncedDocuments;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */
    View.prototype.computeDocChanges = function (docChanges, previousChanges) {
        var _this = this;
        var changeSet = previousChanges
            ? previousChanges.changeSet
            : new DocumentChangeSet();
        var oldDocumentSet = previousChanges
            ? previousChanges.documentSet
            : this.documentSet;
        var newMutatedKeys = previousChanges
            ? previousChanges.mutatedKeys
            : this.mutatedKeys;
        var newDocumentSet = oldDocumentSet;
        var needsRefill = false;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        //
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        var lastDocInLimit = this.query.hasLimit() && oldDocumentSet.size === this.query.limit
            ? oldDocumentSet.last()
            : null;
        docChanges.inorderTraversal(function (key, newMaybeDoc) {
            var oldDoc = oldDocumentSet.get(key);
            var newDoc = newMaybeDoc instanceof Document ? newMaybeDoc : null;
            if (newDoc) {
                assert(key.isEqual(newDoc.key), 'Mismatching keys found in document changes: ' +
                    key +
                    ' != ' +
                    newDoc.key);
                newDoc = _this.query.matches(newDoc) ? newDoc : null;
            }
            var oldDocHadPendingMutations = oldDoc
                ? _this.mutatedKeys.has(oldDoc.key)
                : false;
            var newDocHasPendingMutations = newDoc
                ? newDoc.hasLocalMutations ||
                    // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    (_this.mutatedKeys.has(newDoc.key) && newDoc.hasCommittedMutations)
                : false;
            var changeApplied = false;
            // Calculate change
            if (oldDoc && newDoc) {
                var docsEqual = oldDoc.data.isEqual(newDoc.data);
                if (!docsEqual) {
                    if (!_this.shouldWaitForSyncedDocument(oldDoc, newDoc)) {
                        changeSet.track({
                            type: ChangeType.Modified,
                            doc: newDoc
                        });
                        changeApplied = true;
                        if (lastDocInLimit &&
                            _this.query.docComparator(newDoc, lastDocInLimit) > 0) {
                            // This doc moved from inside the limit to after the limit.
                            // That means there may be some doc in the local cache that's
                            // actually less than this one.
                            needsRefill = true;
                        }
                    }
                }
                else if (oldDocHadPendingMutations !== newDocHasPendingMutations) {
                    changeSet.track({ type: ChangeType.Metadata, doc: newDoc });
                    changeApplied = true;
                }
            }
            else if (!oldDoc && newDoc) {
                changeSet.track({ type: ChangeType.Added, doc: newDoc });
                changeApplied = true;
            }
            else if (oldDoc && !newDoc) {
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
                changeApplied = true;
                if (lastDocInLimit) {
                    // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    needsRefill = true;
                }
            }
            if (changeApplied) {
                if (newDoc) {
                    newDocumentSet = newDocumentSet.add(newDoc);
                    if (newDocHasPendingMutations) {
                        newMutatedKeys = newMutatedKeys.add(key);
                    }
                    else {
                        newMutatedKeys = newMutatedKeys.delete(key);
                    }
                }
                else {
                    newDocumentSet = newDocumentSet.delete(key);
                    newMutatedKeys = newMutatedKeys.delete(key);
                }
            }
        });
        if (this.query.hasLimit()) {
            while (newDocumentSet.size > this.query.limit) {
                var oldDoc = newDocumentSet.last();
                newDocumentSet = newDocumentSet.delete(oldDoc.key);
                newMutatedKeys = newMutatedKeys.delete(oldDoc.key);
                changeSet.track({ type: ChangeType.Removed, doc: oldDoc });
            }
        }
        assert(!needsRefill || !previousChanges, 'View was refilled using docs that themselves needed refilling.');
        return {
            documentSet: newDocumentSet,
            changeSet: changeSet,
            needsRefill: needsRefill,
            mutatedKeys: newMutatedKeys
        };
    };
    View.prototype.shouldWaitForSyncedDocument = function (oldDoc, newDoc) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return (oldDoc.hasLocalMutations &&
            newDoc.hasCommittedMutations &&
            !newDoc.hasLocalMutations);
    };
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */
    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    View.prototype.applyChanges = function (docChanges, updateLimboDocuments, targetChange) {
        var _this = this;
        assert(!docChanges.needsRefill, 'Cannot apply changes that need a refill');
        var oldDocs = this.documentSet;
        this.documentSet = docChanges.documentSet;
        this.mutatedKeys = docChanges.mutatedKeys;
        // Sort changes based on type and query comparator
        var changes = docChanges.changeSet.getChanges();
        changes.sort(function (c1, c2) {
            return (compareChangeType(c1.type, c2.type) ||
                _this.query.docComparator(c1.doc, c2.doc));
        });
        this.applyTargetChange(targetChange);
        var limboChanges = updateLimboDocuments
            ? this.updateLimboDocuments()
            : [];
        var synced = this.limboDocuments.size === 0 && this.current;
        var newSyncState = synced ? SyncState.Synced : SyncState.Local;
        var syncStateChanged = newSyncState !== this.syncState;
        this.syncState = newSyncState;
        if (changes.length === 0 && !syncStateChanged) {
            // no changes
            return { limboChanges: limboChanges };
        }
        else {
            var snap = new ViewSnapshot(this.query, docChanges.documentSet, oldDocs, changes, docChanges.mutatedKeys, newSyncState === SyncState.Local, syncStateChanged, 
            /* excludesMetadataChanges= */ false);
            return {
                snapshot: snap,
                limboChanges: limboChanges
            };
        }
    };
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */
    View.prototype.applyOnlineStateChange = function (onlineState) {
        if (this.current && onlineState === OnlineState.Offline) {
            // If we're offline, set `current` to false and then call applyChanges()
            // to refresh our syncState and generate a ViewChange as appropriate. We
            // are guaranteed to get a new TargetChange that sets `current` back to
            // true once the client is back online.
            this.current = false;
            return this.applyChanges({
                documentSet: this.documentSet,
                changeSet: new DocumentChangeSet(),
                mutatedKeys: this.mutatedKeys,
                needsRefill: false
            }, 
            /* updateLimboDocuments= */ false);
        }
        else {
            // No effect, just return a no-op ViewChange.
            return { limboChanges: [] };
        }
    };
    /**
     * Returns whether the doc for the given key should be in limbo.
     */
    View.prototype.shouldBeInLimbo = function (key) {
        // If the remote end says it's part of this query, it's not in limbo.
        if (this._syncedDocuments.has(key)) {
            return false;
        }
        // The local store doesn't think it's a result, so it shouldn't be in limbo.
        if (!this.documentSet.has(key)) {
            return false;
        }
        // If there are local changes to the doc, they might explain why the server
        // doesn't know that it's part of the query. So don't put it in limbo.
        // TODO(klimt): Ideally, we would only consider changes that might actually
        // affect this specific query.
        if (this.documentSet.get(key).hasLocalMutations) {
            return false;
        }
        // Everything else is in limbo.
        return true;
    };
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */
    View.prototype.applyTargetChange = function (targetChange) {
        var _this = this;
        if (targetChange) {
            targetChange.addedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.add(key)); });
            targetChange.modifiedDocuments.forEach(function (key) {
                return assert(_this._syncedDocuments.has(key), "Modified document " + key + " not found in view.");
            });
            targetChange.removedDocuments.forEach(function (key) { return (_this._syncedDocuments = _this._syncedDocuments.delete(key)); });
            this.current = targetChange.current;
        }
    };
    View.prototype.updateLimboDocuments = function () {
        var _this = this;
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) {
            return [];
        }
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        var oldLimboDocuments = this.limboDocuments;
        this.limboDocuments = documentKeySet();
        this.documentSet.forEach(function (doc) {
            if (_this.shouldBeInLimbo(doc.key)) {
                _this.limboDocuments = _this.limboDocuments.add(doc.key);
            }
        });
        // Diff the new limbo docs with the old limbo docs.
        var changes = [];
        oldLimboDocuments.forEach(function (key) {
            if (!_this.limboDocuments.has(key)) {
                changes.push(new RemovedLimboDocument(key));
            }
        });
        this.limboDocuments.forEach(function (key) {
            if (!oldLimboDocuments.has(key)) {
                changes.push(new AddedLimboDocument(key));
            }
        });
        return changes;
    };
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param localDocs - The documents that match the query according to the
     * LocalStore.
     * @param remoteKeys - The keys of the documents that match the query
     * according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.synchronizeWithPersistedState = function (localDocs, remoteKeys) {
        this._syncedDocuments = remoteKeys;
        this.limboDocuments = documentKeySet();
        var docChanges = this.computeDocChanges(localDocs);
        return this.applyChanges(docChanges, /*updateLimboDocuments=*/ true);
    };
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */
    // PORTING NOTE: Multi-tab only.
    View.prototype.computeInitialSnapshot = function () {
        return ViewSnapshot.fromInitialDocuments(this.query, this.documentSet, this.mutatedKeys, this.syncState === SyncState.Local);
    };
    return View;
}());
function compareChangeType(c1, c2) {
    var order = function (change) {
        switch (change) {
            case ChangeType.Added:
                return 1;
            case ChangeType.Modified:
                return 2;
            case ChangeType.Metadata:
                // A metadata change is converted to a modified change at the public
                // api layer.  Since we sort by document key and then change type,
                // metadata and modified changes must be sorted equivalently.
                return 2;
            case ChangeType.Removed:
                return 0;
            default:
                return fail('Unknown ChangeType: ' + change);
        }
    };
    return order(c1) - order(c2);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$8 = 'SyncEngine';
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */
var QueryView = /** @class */ (function () {
    function QueryView(
    /**
     * The query itself.
     */
    query, 
    /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */
    targetId, 
    /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */
    view) {
        this.query = query;
        this.targetId = targetId;
        this.view = view;
    }
    return QueryView;
}());
/** Tracks a limbo resolution. */
var LimboResolution = /** @class */ (function () {
    function LimboResolution(key) {
        this.key = key;
    }
    return LimboResolution;
}());
/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */
var SyncEngine = /** @class */ (function () {
    function SyncEngine(localStore, remoteStore, 
    // PORTING NOTE: Manages state synchronization in multi-tab environments.
    sharedClientState, currentUser) {
        this.localStore = localStore;
        this.remoteStore = remoteStore;
        this.sharedClientState = sharedClientState;
        this.currentUser = currentUser;
        this.syncEngineListener = null;
        this.queryViewsByQuery = new ObjectMap(function (q) {
            return q.canonicalId();
        });
        this.queryViewsByTarget = {};
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
        this.limboResolutionsByTarget = {};
        this.limboDocumentRefs = new ReferenceSet();
        /** Stores user completion handlers, indexed by User and BatchId. */
        this.mutationUserCallbacks = {};
        this.limboTargetIdGenerator = TargetIdGenerator.forSyncEngine();
        // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.isPrimary = undefined;
        this.onlineState = OnlineState.Unknown;
    }
    Object.defineProperty(SyncEngine.prototype, "isPrimaryClient", {
        // Only used for testing.
        get: function () {
            return this.isPrimary === true;
        },
        enumerable: true,
        configurable: true
    });
    /** Subscribes to SyncEngine notifications. Has to be called exactly once. */
    SyncEngine.prototype.subscribe = function (syncEngineListener) {
        assert(syncEngineListener !== null, 'SyncEngine listener cannot be null');
        assert(this.syncEngineListener === null, 'SyncEngine already has a subscriber.');
        this.syncEngineListener = syncEngineListener;
    };
    /**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */
    SyncEngine.prototype.listen = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var targetId, viewSnapshot, queryView, queryData, status_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('listen()');
                        queryView = this.queryViewsByQuery.get(query);
                        if (!queryView) return [3 /*break*/, 1];
                        // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                        // already exists when EventManager calls us for the first time. This
                        // happens when the primary tab is already listening to this query on
                        // behalf of another tab and the user of the primary also starts listening
                        // to the query. EventManager will not have an assigned target ID in this
                        // case and calls `listen` to obtain this ID.
                        targetId = queryView.targetId;
                        this.sharedClientState.addLocalQueryTarget(targetId);
                        viewSnapshot = queryView.view.computeInitialSnapshot();
                        return [3 /*break*/, 4];
                    case 1: return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 2:
                        queryData = _a.sent();
                        status_1 = this.sharedClientState.addLocalQueryTarget(queryData.targetId);
                        targetId = queryData.targetId;
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, status_1 === 'current')];
                    case 3:
                        viewSnapshot = _a.sent();
                        if (this.isPrimary) {
                            this.remoteStore.listen(queryData);
                        }
                        _a.label = 4;
                    case 4:
                        this.syncEngineListener.onWatchChange([viewSnapshot]);
                        return [2 /*return*/, targetId];
                }
            });
        });
    };
    /**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */
    SyncEngine.prototype.initializeViewAndComputeSnapshot = function (queryData, current) {
        var _this = this;
        var query = queryData.query;
        return this.localStore.executeQuery(query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryData.targetId)
                .then(function (remoteKeys) {
                var view = new View(query, remoteKeys);
                var viewDocChanges = view.computeDocChanges(docs);
                // tslint:disable-next-line:max-line-length Prettier formats this exceed 100 characters.
                var synthesizedTargetChange = TargetChange.createSynthesizedTargetChangeForCurrentChange(queryData.targetId, current && _this.onlineState !== OnlineState.Offline);
                var viewChange = view.applyChanges(viewDocChanges, 
                /* updateLimboDocuments= */ _this.isPrimary === true, synthesizedTargetChange);
                assert(viewChange.limboChanges.length === 0, 'View returned limbo docs before target ack from the server.');
                assert(!!viewChange.snapshot, 'applyChanges for new view should always return a snapshot');
                var data = new QueryView(query, queryData.targetId, view);
                _this.queryViewsByQuery.set(query, data);
                _this.queryViewsByTarget[queryData.targetId] = data;
                return viewChange.snapshot;
            });
        });
    };
    /**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeViewAndComputeSnapshot = function (queryView) {
        var _this = this;
        return this.localStore.executeQuery(queryView.query).then(function (docs) {
            return _this.localStore
                .remoteDocumentKeys(queryView.targetId)
                .then(function (remoteKeys) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var viewSnapshot;
                return tslib_1.__generator(this, function (_a) {
                    viewSnapshot = queryView.view.synchronizeWithPersistedState(docs, remoteKeys);
                    if (this.isPrimary) {
                        this.updateTrackedLimbos(queryView.targetId, viewSnapshot.limboChanges);
                    }
                    return [2 /*return*/, viewSnapshot];
                });
            }); });
        });
    };
    /** Stops listening to the query. */
    SyncEngine.prototype.unlisten = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryView, targetRemainsActive;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('unlisten()');
                        queryView = this.queryViewsByQuery.get(query);
                        assert(!!queryView, 'Trying to unlisten on query not found:' + query);
                        if (!this.isPrimary) return [3 /*break*/, 3];
                        // We need to remove the local query target first to allow us to verify
                        // whether any other client is still interested in this target.
                        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
                        targetRemainsActive = this.sharedClientState.isActiveQueryTarget(queryView.targetId);
                        if (!!targetRemainsActive) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(query, /*keepPersistedQueryData=*/ false)
                                .then(function () {
                                _this.sharedClientState.clearQueryState(queryView.targetId);
                                _this.remoteStore.unlisten(queryView.targetId);
                                _this.removeAndCleanupQuery(queryView);
                            })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */
    SyncEngine.prototype.write = function (batch, userCallback) {
        var _this = this;
        this.assertSubscribed('write()');
        return this.localStore
            .localWrite(batch)
            .then(function (result) {
            _this.sharedClientState.addPendingMutation(result.batchId);
            _this.addMutationCallback(result.batchId, userCallback);
            return _this.emitNewSnapsAndNotifyLocalStore(result.changes);
        })
            .then(function () {
            return _this.remoteStore.fillWritePipeline();
        });
    };
    // TODO(klimt): Wrap the given error in a standard Firestore error object.
    SyncEngine.prototype.wrapUpdateFunctionError = function (error) {
        return error;
    };
    /**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If some other client has changed any of the data
     * referenced, then the updateFunction will be called again. If the
     * updateFunction still fails after the given number of retries, then the
     * transaction will be rejection.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The promise returned is resolved when the transaction is fully committed.
     */
    SyncEngine.prototype.runTransaction = function (updateFunction, retries) {
        var _this = this;
        if (retries === void 0) { retries = 5; }
        assert(retries >= 0, 'Got negative number of retries for transaction.');
        var transaction = this.remoteStore.createTransaction();
        var wrappedUpdateFunction = function () {
            try {
                var userPromise = updateFunction(transaction);
                if (isNullOrUndefined(userPromise) ||
                    !userPromise.catch ||
                    !userPromise.then) {
                    return Promise.reject(Error('Transaction callback must return a Promise'));
                }
                return userPromise.catch(function (e) {
                    return Promise.reject(_this.wrapUpdateFunctionError(e));
                });
            }
            catch (e) {
                return Promise.reject(_this.wrapUpdateFunctionError(e));
            }
        };
        return wrappedUpdateFunction().then(function (result) {
            return transaction
                .commit()
                .then(function () {
                return result;
            })
                .catch(function (error) {
                if (retries === 0) {
                    return Promise.reject(error);
                }
                // TODO(klimt): Put in a retry delay?
                return _this.runTransaction(updateFunction, retries - 1);
            });
        });
    };
    SyncEngine.prototype.applyRemoteEvent = function (remoteEvent) {
        var _this = this;
        this.assertSubscribed('applyRemoteEvent()');
        return this.localStore
            .applyRemoteEvent(remoteEvent)
            .then(function (changes) {
            // Update `receivedDocument` as appropriate for any limbo targets.
            forEach(remoteEvent.targetChanges, function (targetId, targetChange) {
                var limboResolution = _this.limboResolutionsByTarget[Number(targetId)];
                if (limboResolution) {
                    // Since this is a limbo resolution lookup, it's for a single document
                    // and it could be added, modified, or removed, but not a combination.
                    assert(targetChange.addedDocuments.size +
                        targetChange.modifiedDocuments.size +
                        targetChange.removedDocuments.size <=
                        1, 'Limbo resolution for single document contains multiple changes.');
                    if (targetChange.addedDocuments.size > 0) {
                        limboResolution.receivedDocument = true;
                    }
                    else if (targetChange.modifiedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received change for limbo target document without add.');
                    }
                    else if (targetChange.removedDocuments.size > 0) {
                        assert(limboResolution.receivedDocument, 'Received remove for limbo target document without add.');
                        limboResolution.receivedDocument = false;
                    }
                }
            });
            return _this.emitNewSnapsAndNotifyLocalStore(changes, remoteEvent);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    /**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */
    SyncEngine.prototype.applyOnlineStateChange = function (onlineState, source) {
        // If we are the secondary client, we explicitly ignore the remote store's
        // online state (the local client may go offline, even though the primary
        // tab remains online) and only apply the primary tab's online state from
        // SharedClientState.
        if ((this.isPrimary && source === OnlineStateSource.RemoteStore) ||
            (!this.isPrimary && source === OnlineStateSource.SharedClientState)) {
            var newViewSnapshots_1 = [];
            this.queryViewsByQuery.forEach(function (query, queryView) {
                var viewChange = queryView.view.applyOnlineStateChange(onlineState);
                assert(viewChange.limboChanges.length === 0, 'OnlineState should not affect limbo documents.');
                if (viewChange.snapshot) {
                    newViewSnapshots_1.push(viewChange.snapshot);
                }
            });
            this.syncEngineListener.onOnlineStateChange(onlineState);
            this.syncEngineListener.onWatchChange(newViewSnapshots_1);
            this.onlineState = onlineState;
            if (this.isPrimary) {
                this.sharedClientState.setOnlineState(onlineState);
            }
        }
    };
    SyncEngine.prototype.rejectListen = function (targetId, err) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limboResolution, limboKey, documentUpdates, resolvedLimboDocuments, event_1, queryView_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('rejectListens()');
                        // PORTING NOTE: Multi-tab only.
                        this.sharedClientState.updateQueryState(targetId, 'rejected', err);
                        limboResolution = this.limboResolutionsByTarget[targetId];
                        limboKey = limboResolution && limboResolution.key;
                        if (!limboKey) return [3 /*break*/, 1];
                        // Since this query failed, we won't want to manually unlisten to it.
                        // So go ahead and remove it from bookkeeping.
                        this.limboTargetsByKey = this.limboTargetsByKey.remove(limboKey);
                        delete this.limboResolutionsByTarget[targetId];
                        documentUpdates = new SortedMap(DocumentKey.comparator);
                        documentUpdates = documentUpdates.insert(limboKey, new NoDocument(limboKey, SnapshotVersion.forDeletedDoc()));
                        resolvedLimboDocuments = documentKeySet().add(limboKey);
                        event_1 = new RemoteEvent(SnapshotVersion.MIN, 
                        /* targetChanges= */ {}, 
                        /* targetMismatches= */ new SortedSet(primitiveComparator), documentUpdates, resolvedLimboDocuments);
                        return [2 /*return*/, this.applyRemoteEvent(event_1)];
                    case 1:
                        queryView_1 = this.queryViewsByTarget[targetId];
                        assert(!!queryView_1, 'Unknown targetId: ' + targetId);
                        return [4 /*yield*/, this.localStore
                                .releaseQuery(queryView_1.query, /* keepPersistedQueryData */ false)
                                .then(function () { return _this.removeAndCleanupQuery(queryView_1); })
                                .catch(ignoreIfPrimaryLeaseLoss)];
                    case 2:
                        _a.sent();
                        this.syncEngineListener.onWatchError(queryView_1.query, err);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyBatchState = function (batchId, batchState, error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var documents;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSubscribed('applyBatchState()');
                        return [4 /*yield*/, this.localStore.lookupMutationDocuments(batchId)];
                    case 1:
                        documents = _a.sent();
                        if (documents === null) {
                            // A throttled tab may not have seen the mutation before it was completed
                            // and removed from the mutation queue, in which case we won't have cached
                            // the affected documents. In this case we can safely ignore the update
                            // since that means we didn't apply the mutation locally at all (if we
                            // had, we would have cached the affected documents), and so we will just
                            // see any resulting document changes via normal remote document updates
                            // as applicable.
                            debug(LOG_TAG$8, 'Cannot apply mutation batch with id: ' + batchId);
                            return [2 /*return*/];
                        }
                        if (!(batchState === 'pending')) return [3 /*break*/, 3];
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        return [4 /*yield*/, this.remoteStore.fillWritePipeline()];
                    case 2:
                        // If we are the primary client, we need to send this write to the
                        // backend. Secondary clients will ignore these writes since their remote
                        // connection is disabled.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        if (batchState === 'acknowledged' || batchState === 'rejected') {
                            // NOTE: Both these methods are no-ops for batches that originated from
                            // other clients.
                            this.processUserCallback(batchId, error ? error : null);
                            this.localStore.removeCachedMutationBatchMetadata(batchId);
                        }
                        else {
                            fail("Unknown batchState: " + batchState);
                        }
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(documents)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.applySuccessfulWrite = function (mutationBatchResult) {
        var _this = this;
        this.assertSubscribed('applySuccessfulWrite()');
        var batchId = mutationBatchResult.batch.batchId;
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        this.processUserCallback(batchId, /*error=*/ null);
        return this.localStore
            .acknowledgeBatch(mutationBatchResult)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'acknowledged');
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.rejectFailedWrite = function (batchId, error) {
        var _this = this;
        this.assertSubscribed('rejectFailedWrite()');
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        this.processUserCallback(batchId, error);
        return this.localStore
            .rejectBatch(batchId)
            .then(function (changes) {
            _this.sharedClientState.updateMutationState(batchId, 'rejected', error);
            return _this.emitNewSnapsAndNotifyLocalStore(changes);
        })
            .catch(ignoreIfPrimaryLeaseLoss);
    };
    SyncEngine.prototype.addMutationCallback = function (batchId, callback) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        if (!newCallbacks) {
            newCallbacks = new SortedMap(primitiveComparator);
        }
        newCallbacks = newCallbacks.insert(batchId, callback);
        this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
    };
    /**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */
    SyncEngine.prototype.processUserCallback = function (batchId, error) {
        var newCallbacks = this.mutationUserCallbacks[this.currentUser.toKey()];
        // NOTE: Mutations restored from persistence won't have callbacks, so it's
        // okay for there to be no callback for this ID.
        if (newCallbacks) {
            var callback = newCallbacks.get(batchId);
            if (callback) {
                assert(batchId === newCallbacks.minKey(), 'Mutation callbacks processed out-of-order?');
                if (error) {
                    callback.reject(error);
                }
                else {
                    callback.resolve();
                }
                newCallbacks = newCallbacks.remove(batchId);
            }
            this.mutationUserCallbacks[this.currentUser.toKey()] = newCallbacks;
        }
    };
    SyncEngine.prototype.removeAndCleanupQuery = function (queryView) {
        var _this = this;
        this.sharedClientState.removeLocalQueryTarget(queryView.targetId);
        this.queryViewsByQuery.delete(queryView.query);
        delete this.queryViewsByTarget[queryView.targetId];
        if (this.isPrimary) {
            var limboKeys = this.limboDocumentRefs.referencesForId(queryView.targetId);
            this.limboDocumentRefs.removeReferencesForId(queryView.targetId);
            limboKeys.forEach(function (limboKey) {
                var isReferenced = _this.limboDocumentRefs.containsKey(limboKey);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    _this.removeLimboTarget(limboKey);
                }
            });
        }
    };
    SyncEngine.prototype.removeLimboTarget = function (key) {
        // It's possible that the target already got removed because the query failed. In that case,
        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
        var limboTargetId = this.limboTargetsByKey.get(key);
        if (limboTargetId === null) {
            // This target already got removed, because the query failed.
            return;
        }
        this.remoteStore.unlisten(limboTargetId);
        this.limboTargetsByKey = this.limboTargetsByKey.remove(key);
        delete this.limboResolutionsByTarget[limboTargetId];
    };
    SyncEngine.prototype.updateTrackedLimbos = function (targetId, limboChanges) {
        for (var _i = 0, limboChanges_1 = limboChanges; _i < limboChanges_1.length; _i++) {
            var limboChange = limboChanges_1[_i];
            if (limboChange instanceof AddedLimboDocument) {
                this.limboDocumentRefs.addReference(limboChange.key, targetId);
                this.trackLimboChange(limboChange);
            }
            else if (limboChange instanceof RemovedLimboDocument) {
                debug(LOG_TAG$8, 'Document no longer in limbo: ' + limboChange.key);
                this.limboDocumentRefs.removeReference(limboChange.key, targetId);
                var isReferenced = this.limboDocumentRefs.containsKey(limboChange.key);
                if (!isReferenced) {
                    // We removed the last reference for this key
                    this.removeLimboTarget(limboChange.key);
                }
            }
            else {
                fail('Unknown limbo change: ' + JSON.stringify(limboChange));
            }
        }
    };
    SyncEngine.prototype.trackLimboChange = function (limboChange) {
        var key = limboChange.key;
        if (!this.limboTargetsByKey.get(key)) {
            debug(LOG_TAG$8, 'New document in limbo: ' + key);
            var limboTargetId = this.limboTargetIdGenerator.next();
            var query = Query.atPath(key.path);
            this.limboResolutionsByTarget[limboTargetId] = new LimboResolution(key);
            this.remoteStore.listen(new QueryData(query, limboTargetId, QueryPurpose.LimboResolution, ListenSequence.INVALID));
            this.limboTargetsByKey = this.limboTargetsByKey.insert(key, limboTargetId);
        }
    };
    // Visible for testing
    SyncEngine.prototype.currentLimboDocs = function () {
        return this.limboTargetsByKey;
    };
    SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore = function (changes, remoteEvent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newSnaps, docChangesInAllViews, queriesProcessed;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newSnaps = [];
                        docChangesInAllViews = [];
                        queriesProcessed = [];
                        this.queryViewsByQuery.forEach(function (_, queryView) {
                            queriesProcessed.push(Promise.resolve()
                                .then(function () {
                                var viewDocChanges = queryView.view.computeDocChanges(changes);
                                if (!viewDocChanges.needsRefill) {
                                    return viewDocChanges;
                                }
                                // The query has a limit and some docs were removed, so we need
                                // to re-run the query against the local store to make sure we
                                // didn't lose any good docs that had been past the limit.
                                return _this.localStore.executeQuery(queryView.query).then(function (docs) {
                                    return queryView.view.computeDocChanges(docs, viewDocChanges);
                                });
                            })
                                .then(function (viewDocChanges) {
                                var targetChange = remoteEvent && remoteEvent.targetChanges[queryView.targetId];
                                var viewChange = queryView.view.applyChanges(viewDocChanges, 
                                /* updateLimboDocuments= */ _this.isPrimary === true, targetChange);
                                _this.updateTrackedLimbos(queryView.targetId, viewChange.limboChanges);
                                if (viewChange.snapshot) {
                                    if (_this.isPrimary) {
                                        _this.sharedClientState.updateQueryState(queryView.targetId, viewChange.snapshot.fromCache ? 'not-current' : 'current');
                                    }
                                    newSnaps.push(viewChange.snapshot);
                                    var docChanges = LocalViewChanges.fromSnapshot(queryView.targetId, viewChange.snapshot);
                                    docChangesInAllViews.push(docChanges);
                                }
                            }));
                        });
                        return [4 /*yield*/, Promise.all(queriesProcessed)];
                    case 1:
                        _a.sent();
                        this.syncEngineListener.onWatchChange(newSnaps);
                        return [4 /*yield*/, this.localStore.notifyLocalViewChanges(docChangesInAllViews)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncEngine.prototype.assertSubscribed = function (fnName) {
        assert(this.syncEngineListener !== null, 'Trying to call ' + fnName + ' before calling subscribe().');
    };
    SyncEngine.prototype.handleCredentialChange = function (user) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userChanged, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userChanged = !this.currentUser.isEqual(user);
                        this.currentUser = user;
                        if (!userChanged) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.localStore.handleUserChange(user)];
                    case 1:
                        result = _a.sent();
                        // TODO(b/114226417): Consider calling this only in the primary tab.
                        this.sharedClientState.handleUserChange(user, result.removedBatchIds, result.addedBatchIds);
                        return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.remoteStore.handleCredentialChange()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyPrimaryState = function (isPrimary) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var activeTargets, activeQueries, _i, activeQueries_1, queryData, activeTargets_1, p_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(isPrimary === true && this.isPrimary !== true)) return [3 /*break*/, 3];
                        this.isPrimary = true;
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(true)];
                    case 1:
                        _a.sent();
                        activeTargets = this.sharedClientState.getAllActiveQueryTargets();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];
                    case 2:
                        activeQueries = _a.sent();
                        for (_i = 0, activeQueries_1 = activeQueries; _i < activeQueries_1.length; _i++) {
                            queryData = activeQueries_1[_i];
                            this.remoteStore.listen(queryData);
                        }
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(isPrimary === false && this.isPrimary !== false)) return [3 /*break*/, 7];
                        this.isPrimary = false;
                        activeTargets_1 = [];
                        p_1 = Promise.resolve();
                        forEachNumber(this.queryViewsByTarget, function (targetId, queryView) {
                            if (_this.sharedClientState.isLocalQueryTarget(targetId)) {
                                activeTargets_1.push(targetId);
                            }
                            else {
                                p_1 = p_1.then(function () { return _this.unlisten(queryView.query); });
                            }
                            _this.remoteStore.unlisten(queryView.targetId);
                        });
                        return [4 /*yield*/, p_1];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];
                    case 5:
                        _a.sent();
                        this.resetLimboDocuments();
                        return [4 /*yield*/, this.remoteStore.applyPrimaryState(false)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.resetLimboDocuments = function () {
        var _this = this;
        forEachNumber(this.limboResolutionsByTarget, function (targetId) {
            _this.remoteStore.unlisten(targetId);
        });
        this.limboDocumentRefs.removeAllReferences();
        this.limboResolutionsByTarget = [];
        this.limboTargetsByKey = new SortedMap(DocumentKey.comparator);
    };
    /**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     */
    // PORTING NOTE: Multi-tab only.
    SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots = function (targets) {
        var _this = this;
        var p = Promise.resolve();
        var activeQueries = [];
        var newViewSnapshots = [];
        var _loop_1 = function (targetId) {
            p = p.then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var queryData, queryView, viewChange, query;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            queryView = this.queryViewsByTarget[targetId];
                            if (!queryView) return [3 /*break*/, 4];
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                                /*keepPersistedQueryData=*/ true)];
                        case 1:
                            // For queries that have a local View, we need to update their state
                            // in LocalStore (as the resume token and the snapshot version
                            // might have changed) and reconcile their views with the persisted
                            // state (the list of syncedDocuments may have gotten out of sync).
                            _a.sent();
                            return [4 /*yield*/, this.localStore.allocateQuery(queryView.query)];
                        case 2:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.synchronizeViewAndComputeSnapshot(queryView)];
                        case 3:
                            viewChange = _a.sent();
                            if (viewChange.snapshot) {
                                newViewSnapshots.push(viewChange.snapshot);
                            }
                            return [3 /*break*/, 8];
                        case 4:
                            assert(this.isPrimary === true, 'A secondary tab should never have an active query without an active view.');
                            return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                        case 5:
                            query = _a.sent();
                            assert(!!query, "Query data for target " + targetId + " not found");
                            return [4 /*yield*/, this.localStore.allocateQuery(query)];
                        case 6:
                            queryData = _a.sent();
                            return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                                /*current=*/ false)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            activeQueries.push(queryData);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
            var targetId = targets_1[_i];
            _loop_1(targetId);
        }
        return p.then(function () {
            _this.syncEngineListener.onWatchChange(newViewSnapshots);
            return activeQueries;
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.getActiveClients = function () {
        return this.localStore.getActiveClients();
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyTargetState = function (targetId, state, error) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, queryView;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.isPrimary) {
                            // If we receive a target state notification via WebStorage, we are
                            // either already secondary or another tab has taken the primary lease.
                            debug(LOG_TAG$8, 'Ignoring unexpected query state notification.');
                            return [2 /*return*/];
                        }
                        if (!this.queryViewsByTarget[targetId]) return [3 /*break*/, 5];
                        _a = state;
                        switch (_a) {
                            case 'current': return [3 /*break*/, 1];
                            case 'not-current': return [3 /*break*/, 1];
                            case 'rejected': return [3 /*break*/, 2];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        {
                            return [2 /*return*/, this.localStore.getNewDocumentChanges().then(function (changes) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var synthesizedRemoteEvent;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                synthesizedRemoteEvent = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId, state === 'current');
                                                return [4 /*yield*/, this.emitNewSnapsAndNotifyLocalStore(changes, synthesizedRemoteEvent)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, function (err) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var activeTargets_2;
                                    return tslib_1.__generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!isDocumentChangeMissingError(err)) return [3 /*break*/, 2];
                                                activeTargets_2 = [];
                                                forEachNumber(this.queryViewsByTarget, function (target) {
                                                    return activeTargets_2.push(target);
                                                });
                                                return [4 /*yield*/, this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_2)];
                                            case 1:
                                                _a.sent();
                                                return [3 /*break*/, 3];
                                            case 2: throw err;
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })];
                        }
                        _b.label = 2;
                    case 2:
                        queryView = this.queryViewsByTarget[targetId];
                        this.removeAndCleanupQuery(queryView);
                        return [4 /*yield*/, this.localStore.releaseQuery(queryView.query, 
                            /*keepPersistedQueryData=*/ true)];
                    case 3:
                        _b.sent();
                        this.syncEngineListener.onWatchError(queryView.query, error);
                        return [3 /*break*/, 5];
                    case 4:
                        fail('Unexpected target state: ' + state);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only
    SyncEngine.prototype.applyActiveTargetsChange = function (added, removed) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _i, added_1, targetId, query, queryData, _loop_2, this_1, _a, removed_1, targetId;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.isPrimary) {
                            return [2 /*return*/];
                        }
                        _i = 0, added_1 = added;
                        _b.label = 1;
                    case 1:
                        if (!(_i < added_1.length)) return [3 /*break*/, 6];
                        targetId = added_1[_i];
                        assert(!this.queryViewsByTarget[targetId], 'Trying to add an already active target');
                        return [4 /*yield*/, this.localStore.getQueryForTarget(targetId)];
                    case 2:
                        query = _b.sent();
                        assert(!!query, "Query data for active target " + targetId + " not found");
                        return [4 /*yield*/, this.localStore.allocateQuery(query)];
                    case 3:
                        queryData = _b.sent();
                        return [4 /*yield*/, this.initializeViewAndComputeSnapshot(queryData, 
                            /*current=*/ false)];
                    case 4:
                        _b.sent();
                        this.remoteStore.listen(queryData);
                        _b.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        _loop_2 = function (targetId) {
                            var queryView;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        queryView = this_1.queryViewsByTarget[targetId];
                                        if (!queryView) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this_1.localStore
                                                .releaseQuery(queryView.query, /*keepPersistedQueryData=*/ false)
                                                .then(function () {
                                                _this.remoteStore.unlisten(targetId);
                                                _this.removeAndCleanupQuery(queryView);
                                            })
                                                .catch(ignoreIfPrimaryLeaseLoss)];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a = 0, removed_1 = removed;
                        _b.label = 7;
                    case 7:
                        if (!(_a < removed_1.length)) return [3 /*break*/, 10];
                        targetId = removed_1[_a];
                        return [5 /*yield**/, _loop_2(targetId)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        _a++;
                        return [3 /*break*/, 7];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.enableNetwork = function () {
        this.localStore.setNetworkEnabled(true);
        return this.remoteStore.enableNetwork();
    };
    // PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
    // the online state.
    SyncEngine.prototype.disableNetwork = function () {
        this.localStore.setNetworkEnabled(false);
        return this.remoteStore.disableNetwork();
    };
    SyncEngine.prototype.getRemoteKeysForTarget = function (targetId) {
        var limboResolution = this.limboResolutionsByTarget[targetId];
        if (limboResolution && limboResolution.receivedDocument) {
            return documentKeySet().add(limboResolution.key);
        }
        else {
            return this.queryViewsByTarget[targetId]
                ? this.queryViewsByTarget[targetId].view.syncedDocuments
                : documentKeySet();
        }
    };
    return SyncEngine;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */
var User = /** @class */ (function () {
    function User(uid) {
        this.uid = uid;
    }
    User.prototype.isAuthenticated = function () {
        return this.uid != null;
    };
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */
    User.prototype.toKey = function () {
        if (this.isAuthenticated()) {
            return 'uid:' + this.uid;
        }
        else {
            return 'anonymous-user';
        }
    };
    User.prototype.isEqual = function (otherUser) {
        return otherUser.uid === this.uid;
    };
    /** A user with a null UID. */
    User.UNAUTHENTICATED = new User(null);
    // TODO(mikelehen): Look into getting a proper uid-equivalent for
    // non-FirebaseAuth providers.
    User.GOOGLE_CREDENTIALS = new User('google-credentials-uid');
    User.FIRST_PARTY = new User('first-party-uid');
    return User;
}());

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$9 = 'SharedClientState';
// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var CLIENT_STATE_KEY_PREFIX = 'firestore_clients';
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
//
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var MUTATION_BATCH_KEY_PREFIX = 'firestore_mutations';
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var QUERY_TARGET_KEY_PREFIX = 'firestore_targets';
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
var ONLINE_STATE_KEY_PREFIX = 'firestore_online_state';
// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
// looks like 'firestore_sequence_number_<persistence_prefix>'.
var SEQUENCE_NUMBER_KEY_PREFIX = 'firestore_sequence_number';
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */
// Visible for testing
var MutationMetadata = /** @class */ (function () {
    function MutationMetadata(user, batchId, state, error) {
        this.user = user;
        this.batchId = batchId;
        this.state = state;
        this.error = error;
        assert((error !== undefined) === (state === 'rejected'), "MutationMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    MutationMetadata.fromWebStorageEntry = function (user, batchId, value) {
        var mutationBatch = JSON.parse(value);
        var validData = typeof mutationBatch === 'object' &&
            ['pending', 'acknowledged', 'rejected'].indexOf(mutationBatch.state) !==
                -1 &&
            (mutationBatch.error === undefined ||
                typeof mutationBatch.error === 'object');
        var firestoreError = undefined;
        if (validData && mutationBatch.error) {
            validData =
                typeof mutationBatch.error.message === 'string' &&
                    typeof mutationBatch.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(mutationBatch.error.code, mutationBatch.error.message);
            }
        }
        if (validData) {
            return new MutationMetadata(user, batchId, mutationBatch.state, firestoreError);
        }
        else {
            error(LOG_TAG$9, "Failed to parse mutation state for ID '" + batchId + "': " + value);
            return null;
        }
    };
    MutationMetadata.prototype.toWebStorageJSON = function () {
        var batchMetadata = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            batchMetadata.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(batchMetadata);
    };
    return MutationMetadata;
}());
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */
// Visible for testing
var QueryTargetMetadata = /** @class */ (function () {
    function QueryTargetMetadata(targetId, state, error) {
        this.targetId = targetId;
        this.state = state;
        this.error = error;
        assert((error !== undefined) === (state === 'rejected'), "QueryTargetMetadata must contain an error iff state is 'rejected'");
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    QueryTargetMetadata.fromWebStorageEntry = function (targetId, value) {
        var targetState = JSON.parse(value);
        var validData = typeof targetState === 'object' &&
            ['not-current', 'current', 'rejected'].indexOf(targetState.state) !==
                -1 &&
            (targetState.error === undefined ||
                typeof targetState.error === 'object');
        var firestoreError = undefined;
        if (validData && targetState.error) {
            validData =
                typeof targetState.error.message === 'string' &&
                    typeof targetState.error.code === 'string';
            if (validData) {
                firestoreError = new FirestoreError(targetState.error.code, targetState.error.message);
            }
        }
        if (validData) {
            return new QueryTargetMetadata(targetId, targetState.state, firestoreError);
        }
        else {
            error(LOG_TAG$9, "Failed to parse target state for ID '" + targetId + "': " + value);
            return null;
        }
    };
    QueryTargetMetadata.prototype.toWebStorageJSON = function () {
        var targetState = {
            state: this.state,
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        if (this.error) {
            targetState.error = {
                code: this.error.code,
                message: this.error.message
            };
        }
        return JSON.stringify(targetState);
    };
    return QueryTargetMetadata;
}());
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */
var RemoteClientState = /** @class */ (function () {
    function RemoteClientState(clientId, activeTargetIds) {
        this.clientId = clientId;
        this.activeTargetIds = activeTargetIds;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    RemoteClientState.fromWebStorageEntry = function (clientId, value) {
        var clientState = JSON.parse(value);
        var validData = typeof clientState === 'object' &&
            clientState.activeTargetIds instanceof Array;
        var activeTargetIdsSet = targetIdSet();
        for (var i = 0; validData && i < clientState.activeTargetIds.length; ++i) {
            validData = isSafeInteger(clientState.activeTargetIds[i]);
            activeTargetIdsSet = activeTargetIdsSet.add(clientState.activeTargetIds[i]);
        }
        if (validData) {
            return new RemoteClientState(clientId, activeTargetIdsSet);
        }
        else {
            error(LOG_TAG$9, "Failed to parse client data for instance '" + clientId + "': " + value);
            return null;
        }
    };
    return RemoteClientState;
}());
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */
var SharedOnlineState = /** @class */ (function () {
    function SharedOnlineState(clientId, onlineState) {
        this.clientId = clientId;
        this.onlineState = onlineState;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */
    SharedOnlineState.fromWebStorageEntry = function (value) {
        var onlineState = JSON.parse(value);
        var validData = typeof onlineState === 'object' &&
            onlineState.onlineState in OnlineState &&
            typeof onlineState.clientId === 'string';
        if (validData) {
            return new SharedOnlineState(onlineState.clientId, OnlineState[onlineState.onlineState]);
        }
        else {
            error(LOG_TAG$9, "Failed to parse online state: " + value);
            return null;
        }
    };
    return SharedOnlineState;
}());
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */
// Visible for testing.
var LocalClientState = /** @class */ (function () {
    function LocalClientState() {
        this.activeTargetIds = targetIdSet();
    }
    LocalClientState.prototype.addQueryTarget = function (targetId) {
        assert(!this.activeTargetIds.has(targetId), "Target with ID '" + targetId + "' already active.");
        this.activeTargetIds = this.activeTargetIds.add(targetId);
    };
    LocalClientState.prototype.removeQueryTarget = function (targetId) {
        this.activeTargetIds = this.activeTargetIds.delete(targetId);
    };
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */
    LocalClientState.prototype.toWebStorageJSON = function () {
        var data = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now() // Modify the existing value to trigger update.
        };
        return JSON.stringify(data);
    };
    return LocalClientState;
}());
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */
var WebStorageSharedClientState = /** @class */ (function () {
    function WebStorageSharedClientState(queue, platform, persistenceKey, localClientId, initialUser) {
        this.queue = queue;
        this.platform = platform;
        this.persistenceKey = persistenceKey;
        this.localClientId = localClientId;
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
        this.activeClients = {};
        this.storageListener = this.handleWebStorageEvent.bind(this);
        this.started = false;
        /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */
        this.earlyEvents = [];
        if (!WebStorageSharedClientState.isAvailable(this.platform)) {
            throw new FirestoreError(Code.UNIMPLEMENTED, 'LocalStorage is not available on this platform.');
        }
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var escapedPersistenceKey = persistenceKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        this.storage = this.platform.window.localStorage;
        this.currentUser = initialUser;
        this.localClientStorageKey = this.toWebStorageClientStateKey(this.localClientId);
        this.sequenceNumberKey = SEQUENCE_NUMBER_KEY_PREFIX + "_" + persistenceKey;
        this.activeClients[this.localClientId] = new LocalClientState();
        this.clientStateKeyRe = new RegExp("^" + CLIENT_STATE_KEY_PREFIX + "_" + escapedPersistenceKey + "_([^_]*)$");
        this.mutationBatchKeyRe = new RegExp("^" + MUTATION_BATCH_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)(?:_(.*))?$");
        this.queryTargetKeyRe = new RegExp("^" + QUERY_TARGET_KEY_PREFIX + "_" + escapedPersistenceKey + "_(\\d+)$");
        this.onlineStateKey = ONLINE_STATE_KEY_PREFIX + "_" + persistenceKey;
        // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.platform.window.addEventListener('storage', this.storageListener);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */
    WebStorageSharedClientState.isAvailable = function (platform) {
        return !!(platform.window && platform.window.localStorage != null);
    };
    WebStorageSharedClientState.prototype.start = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var existingClients, _i, existingClients_1, clientId, storageItem, clientState, onlineStateJSON, onlineState, _a, _b, event_1;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        assert(!this.started, 'WebStorageSharedClientState already started');
                        assert(this.syncEngine !== null, 'syncEngine property must be set before calling start()');
                        assert(this.onlineStateHandler !== null, 'onlineStateHandler property must be set before calling start()');
                        return [4 /*yield*/, this.syncEngine.getActiveClients()];
                    case 1:
                        existingClients = _c.sent();
                        for (_i = 0, existingClients_1 = existingClients; _i < existingClients_1.length; _i++) {
                            clientId = existingClients_1[_i];
                            if (clientId === this.localClientId) {
                                continue;
                            }
                            storageItem = this.getItem(this.toWebStorageClientStateKey(clientId));
                            if (storageItem) {
                                clientState = RemoteClientState.fromWebStorageEntry(clientId, storageItem);
                                if (clientState) {
                                    this.activeClients[clientState.clientId] = clientState;
                                }
                            }
                        }
                        this.persistClientState();
                        onlineStateJSON = this.storage.getItem(this.onlineStateKey);
                        if (onlineStateJSON) {
                            onlineState = this.fromWebStorageOnlineState(onlineStateJSON);
                            if (onlineState) {
                                this.handleOnlineStateEvent(onlineState);
                            }
                        }
                        for (_a = 0, _b = this.earlyEvents; _a < _b.length; _a++) {
                            event_1 = _b[_a];
                            this.handleWebStorageEvent(event_1);
                        }
                        this.earlyEvents = [];
                        // Register a window unload hook to remove the client metadata entry from
                        // WebStorage even if `shutdown()` was not called.
                        this.platform.window.addEventListener('unload', function () { return _this.shutdown(); });
                        this.started = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    WebStorageSharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) {
        this.setItem(this.sequenceNumberKey, JSON.stringify(sequenceNumber));
    };
    WebStorageSharedClientState.prototype.getAllActiveQueryTargets = function () {
        var activeTargets = targetIdSet();
        forEach(this.activeClients, function (key, value) {
            activeTargets = activeTargets.unionWith(value.activeTargetIds);
        });
        return activeTargets;
    };
    WebStorageSharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        // This is not using `obj.forEach` since `forEach` doesn't support early
        // return.
        for (var clientId in this.activeClients) {
            if (this.activeClients.hasOwnProperty(clientId)) {
                if (this.activeClients[clientId].activeTargetIds.has(targetId)) {
                    return true;
                }
            }
        }
        return false;
    };
    WebStorageSharedClientState.prototype.addPendingMutation = function (batchId) {
        this.persistMutationState(batchId, 'pending');
    };
    WebStorageSharedClientState.prototype.updateMutationState = function (batchId, state, error) {
        this.persistMutationState(batchId, state, error);
        // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.removeMutationState(batchId);
    };
    WebStorageSharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        var queryState = 'not-current';
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(targetId)) {
            var storageItem = this.storage.getItem(this.toWebStorageQueryTargetMetadataKey(targetId));
            if (storageItem) {
                var metadata = QueryTargetMetadata.fromWebStorageEntry(targetId, storageItem);
                if (metadata) {
                    queryState = metadata.state;
                }
            }
        }
        this.localClientState.addQueryTarget(targetId);
        this.persistClientState();
        return queryState;
    };
    WebStorageSharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localClientState.removeQueryTarget(targetId);
        this.persistClientState();
    };
    WebStorageSharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localClientState.activeTargetIds.has(targetId);
    };
    WebStorageSharedClientState.prototype.clearQueryState = function (targetId) {
        this.removeItem(this.toWebStorageQueryTargetMetadataKey(targetId));
    };
    WebStorageSharedClientState.prototype.updateQueryState = function (targetId, state, error) {
        this.persistQueryTargetState(targetId, state, error);
    };
    WebStorageSharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        var _this = this;
        removedBatchIds.forEach(function (batchId) {
            _this.removeMutationState(batchId);
        });
        this.currentUser = user;
        addedBatchIds.forEach(function (batchId) {
            _this.addPendingMutation(batchId);
        });
    };
    WebStorageSharedClientState.prototype.setOnlineState = function (onlineState) {
        this.persistOnlineState(onlineState);
    };
    WebStorageSharedClientState.prototype.shutdown = function () {
        if (this.started) {
            this.platform.window.removeEventListener('storage', this.storageListener);
            this.removeItem(this.localClientStorageKey);
            this.started = false;
        }
    };
    WebStorageSharedClientState.prototype.getItem = function (key) {
        var value = this.storage.getItem(key);
        debug(LOG_TAG$9, 'READ', key, value);
        return value;
    };
    WebStorageSharedClientState.prototype.setItem = function (key, value) {
        debug(LOG_TAG$9, 'SET', key, value);
        this.storage.setItem(key, value);
    };
    WebStorageSharedClientState.prototype.removeItem = function (key) {
        debug(LOG_TAG$9, 'REMOVE', key);
        this.storage.removeItem(key);
    };
    WebStorageSharedClientState.prototype.handleWebStorageEvent = function (event) {
        var _this = this;
        if (event.storageArea === this.storage) {
            debug(LOG_TAG$9, 'EVENT', event.key, event.newValue);
            if (event.key === this.localClientStorageKey) {
                error('Received WebStorage notification for local change. Another client might have ' +
                    'garbage-collected our state');
                return;
            }
            this.queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var clientState, clientId, mutationMetadata, queryTargetMetadata, onlineState, sequenceNumber;
                return tslib_1.__generator(this, function (_a) {
                    if (!this.started) {
                        this.earlyEvents.push(event);
                        return [2 /*return*/];
                    }
                    if (event.key === null) {
                        return [2 /*return*/];
                    }
                    if (this.clientStateKeyRe.test(event.key)) {
                        if (event.newValue != null) {
                            clientState = this.fromWebStorageClientState(event.key, event.newValue);
                            if (clientState) {
                                return [2 /*return*/, this.handleClientStateEvent(clientState.clientId, clientState)];
                            }
                        }
                        else {
                            clientId = this.fromWebStorageClientStateKey(event.key);
                            return [2 /*return*/, this.handleClientStateEvent(clientId, null)];
                        }
                    }
                    else if (this.mutationBatchKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            mutationMetadata = this.fromWebStorageMutationMetadata(event.key, event.newValue);
                            if (mutationMetadata) {
                                return [2 /*return*/, this.handleMutationBatchEvent(mutationMetadata)];
                            }
                        }
                    }
                    else if (this.queryTargetKeyRe.test(event.key)) {
                        if (event.newValue !== null) {
                            queryTargetMetadata = this.fromWebStorageQueryTargetMetadata(event.key, event.newValue);
                            if (queryTargetMetadata) {
                                return [2 /*return*/, this.handleQueryTargetEvent(queryTargetMetadata)];
                            }
                        }
                    }
                    else if (event.key === this.onlineStateKey) {
                        if (event.newValue !== null) {
                            onlineState = this.fromWebStorageOnlineState(event.newValue);
                            if (onlineState) {
                                return [2 /*return*/, this.handleOnlineStateEvent(onlineState)];
                            }
                        }
                    }
                    else if (event.key === this.sequenceNumberKey) {
                        assert(!!this.sequenceNumberHandler, 'Missing sequenceNumberHandler');
                        sequenceNumber = fromWebStorageSequenceNumber(event.newValue);
                        if (sequenceNumber !== ListenSequence.INVALID) {
                            this.sequenceNumberHandler(sequenceNumber);
                        }
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    };
    Object.defineProperty(WebStorageSharedClientState.prototype, "localClientState", {
        get: function () {
            return this.activeClients[this.localClientId];
        },
        enumerable: true,
        configurable: true
    });
    WebStorageSharedClientState.prototype.persistClientState = function () {
        this.setItem(this.localClientStorageKey, this.localClientState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.persistMutationState = function (batchId, state, error) {
        var mutationState = new MutationMetadata(this.currentUser, batchId, state, error);
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.setItem(mutationKey, mutationState.toWebStorageJSON());
    };
    WebStorageSharedClientState.prototype.removeMutationState = function (batchId) {
        var mutationKey = this.toWebStorageMutationBatchKey(batchId);
        this.removeItem(mutationKey);
    };
    WebStorageSharedClientState.prototype.persistOnlineState = function (onlineState) {
        var entry = {
            clientId: this.localClientId,
            onlineState: OnlineState[onlineState]
        };
        this.storage.setItem(this.onlineStateKey, JSON.stringify(entry));
    };
    WebStorageSharedClientState.prototype.persistQueryTargetState = function (targetId, state, error) {
        var targetKey = this.toWebStorageQueryTargetMetadataKey(targetId);
        var targetMetadata = new QueryTargetMetadata(targetId, state, error);
        this.setItem(targetKey, targetMetadata.toWebStorageJSON());
    };
    /** Assembles the key for a client state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageClientStateKey = function (clientId) {
        assert(clientId.indexOf('_') === -1, "Client key cannot contain '_', but was '" + clientId + "'");
        return CLIENT_STATE_KEY_PREFIX + "_" + this.persistenceKey + "_" + clientId;
    };
    /** Assembles the key for a query state in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageQueryTargetMetadataKey = function (targetId) {
        return QUERY_TARGET_KEY_PREFIX + "_" + this.persistenceKey + "_" + targetId;
    };
    /** Assembles the key for a mutation batch in WebStorage */
    WebStorageSharedClientState.prototype.toWebStorageMutationBatchKey = function (batchId) {
        var mutationKey = MUTATION_BATCH_KEY_PREFIX + "_" + this.persistenceKey + "_" + batchId;
        if (this.currentUser.isAuthenticated()) {
            mutationKey += "_" + this.currentUser.uid;
        }
        return mutationKey;
    };
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientStateKey = function (key) {
        var match = this.clientStateKeyRe.exec(key);
        return match ? match[1] : null;
    };
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageClientState = function (key, value) {
        var clientId = this.fromWebStorageClientStateKey(key);
        assert(clientId !== null, "Cannot parse client state key '" + key + "'");
        return RemoteClientState.fromWebStorageEntry(clientId, value);
    };
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata = function (key, value) {
        var match = this.mutationBatchKeyRe.exec(key);
        assert(match !== null, "Cannot parse mutation batch key '" + key + "'");
        var batchId = Number(match[1]);
        var userId = match[2] !== undefined ? match[2] : null;
        return MutationMetadata.fromWebStorageEntry(new User(userId), batchId, value);
    };
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata = function (key, value) {
        var match = this.queryTargetKeyRe.exec(key);
        assert(match !== null, "Cannot parse query target key '" + key + "'");
        var targetId = Number(match[1]);
        return QueryTargetMetadata.fromWebStorageEntry(targetId, value);
    };
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */
    WebStorageSharedClientState.prototype.fromWebStorageOnlineState = function (value) {
        return SharedOnlineState.fromWebStorageEntry(value);
    };
    WebStorageSharedClientState.prototype.handleMutationBatchEvent = function (mutationBatch) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (mutationBatch.user.uid !== this.currentUser.uid) {
                    debug(LOG_TAG$9, "Ignoring mutation for non-active user " + mutationBatch.user.uid);
                    return [2 /*return*/];
                }
                return [2 /*return*/, this.syncEngine.applyBatchState(mutationBatch.batchId, mutationBatch.state, mutationBatch.error)];
            });
        });
    };
    WebStorageSharedClientState.prototype.handleQueryTargetEvent = function (targetMetadata) {
        return this.syncEngine.applyTargetState(targetMetadata.targetId, targetMetadata.state, targetMetadata.error);
    };
    WebStorageSharedClientState.prototype.handleClientStateEvent = function (clientId, clientState) {
        var _this = this;
        var existingTargets = this.getAllActiveQueryTargets();
        if (clientState) {
            this.activeClients[clientId] = clientState;
        }
        else {
            delete this.activeClients[clientId];
        }
        var newTargets = this.getAllActiveQueryTargets();
        var addedTargets = [];
        var removedTargets = [];
        newTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!existingTargets.has(targetId)) {
                    addedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        existingTargets.forEach(function (targetId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                if (!newTargets.has(targetId)) {
                    removedTargets.push(targetId);
                }
                return [2 /*return*/];
            });
        }); });
        return this.syncEngine.applyActiveTargetsChange(addedTargets, removedTargets);
    };
    WebStorageSharedClientState.prototype.handleOnlineStateEvent = function (onlineState) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        if (this.activeClients[onlineState.clientId]) {
            this.onlineStateHandler(onlineState.onlineState);
        }
    };
    return WebStorageSharedClientState;
}());
function fromWebStorageSequenceNumber(seqString) {
    var sequenceNumber = ListenSequence.INVALID;
    if (seqString != null) {
        try {
            var parsed = JSON.parse(seqString);
            assert(typeof parsed === 'number', 'Found non-numeric sequence number');
            sequenceNumber = parsed;
        }
        catch (e) {
            error(LOG_TAG$9, 'Failed to read sequence number from WebStorage', e);
        }
    }
    return sequenceNumber;
}
/**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */
var MemorySharedClientState = /** @class */ (function () {
    function MemorySharedClientState() {
        this.localState = new LocalClientState();
        this.queryState = {};
        this.syncEngine = null;
        this.onlineStateHandler = null;
        this.sequenceNumberHandler = null;
    }
    MemorySharedClientState.prototype.addPendingMutation = function (batchId) {
        // No op.
    };
    MemorySharedClientState.prototype.updateMutationState = function (batchId, state, error) {
        // No op.
    };
    MemorySharedClientState.prototype.addLocalQueryTarget = function (targetId) {
        this.localState.addQueryTarget(targetId);
        return this.queryState[targetId] || 'not-current';
    };
    MemorySharedClientState.prototype.updateQueryState = function (targetId, state, error) {
        this.queryState[targetId] = state;
    };
    MemorySharedClientState.prototype.removeLocalQueryTarget = function (targetId) {
        this.localState.removeQueryTarget(targetId);
    };
    MemorySharedClientState.prototype.isLocalQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.clearQueryState = function (targetId) {
        delete this.queryState[targetId];
    };
    MemorySharedClientState.prototype.getAllActiveQueryTargets = function () {
        return this.localState.activeTargetIds;
    };
    MemorySharedClientState.prototype.isActiveQueryTarget = function (targetId) {
        return this.localState.activeTargetIds.has(targetId);
    };
    MemorySharedClientState.prototype.start = function () {
        this.localState = new LocalClientState();
        return Promise.resolve();
    };
    MemorySharedClientState.prototype.handleUserChange = function (user, removedBatchIds, addedBatchIds) {
        // No op.
    };
    MemorySharedClientState.prototype.setOnlineState = function (onlineState) {
        // No op.
    };
    MemorySharedClientState.prototype.shutdown = function () { };
    MemorySharedClientState.prototype.writeSequenceNumber = function (sequenceNumber) { };
    return MemorySharedClientState;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$a = 'FirestoreClient';
/** DOMException error code constants. */
var DOM_EXCEPTION_INVALID_STATE = 11;
var DOM_EXCEPTION_ABORTED = 20;
var DOM_EXCEPTION_QUOTA_EXCEEDED = 22;
var IndexedDbPersistenceSettings = /** @class */ (function () {
    function IndexedDbPersistenceSettings(cacheSizeBytes, synchronizeTabs) {
        this.cacheSizeBytes = cacheSizeBytes;
        this.synchronizeTabs = synchronizeTabs;
    }
    IndexedDbPersistenceSettings.prototype.lruParams = function () {
        return LruParams.withCacheSize(this.cacheSizeBytes);
    };
    return IndexedDbPersistenceSettings;
}());
var MemoryPersistenceSettings = /** @class */ (function () {
    function MemoryPersistenceSettings() {
    }
    return MemoryPersistenceSettings;
}());
/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */
var FirestoreClient = /** @class */ (function () {
    function FirestoreClient(platform, databaseInfo, credentials, 
    /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */
    asyncQueue) {
        this.platform = platform;
        this.databaseInfo = databaseInfo;
        this.credentials = credentials;
        this.asyncQueue = asyncQueue;
        this.clientId = AutoId.newId();
        this._clientShutdown = false;
    }
    /**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */
    FirestoreClient.prototype.start = function (persistenceSettings) {
        var _this = this;
        this.verifyNotShutdown();
        // We defer our initialization until we get the current user from
        // setChangeListener(). We block the async queue until we got the initial
        // user and the initialization is completed. This will prevent any scheduled
        // work from happening before initialization is completed.
        //
        // If initializationDone resolved then the FirestoreClient is in a usable
        // state.
        var initializationDone = new Deferred();
        // If usePersistence is true, certain classes of errors while starting are
        // recoverable but only by falling back to persistence disabled.
        //
        // If there's an error in the first case but not in recovery we cannot
        // reject the promise blocking the async queue because this will cause the
        // async queue to panic.
        var persistenceResult = new Deferred();
        var initialized = false;
        this.credentials.setChangeListener(function (user) {
            if (!initialized) {
                initialized = true;
                _this.initializePersistence(persistenceSettings, persistenceResult, user)
                    .then(function (maybeLruGc) { return _this.initializeRest(user, maybeLruGc); })
                    .then(initializationDone.resolve, initializationDone.reject);
            }
            else {
                _this.asyncQueue.enqueueAndForget(function () {
                    return _this.handleCredentialChange(user);
                });
            }
        });
        // Block the async queue until initialization is done
        this.asyncQueue.enqueueAndForget(function () {
            return initializationDone.promise;
        });
        // Return only the result of enabling persistence. Note that this does not
        // need to await the completion of initializationDone because the result of
        // this method should not reflect any other kind of failure to start.
        return persistenceResult.promise;
    };
    /** Enables the network connection and requeues all pending operations. */
    FirestoreClient.prototype.enableNetwork = function () {
        var _this = this;
        this.verifyNotShutdown();
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.enableNetwork();
        });
    };
    /**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param persistenceSettings Settings object to configure offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */
    FirestoreClient.prototype.initializePersistence = function (persistenceSettings, persistenceResult, user) {
        var _this = this;
        if (persistenceSettings instanceof IndexedDbPersistenceSettings) {
            return this.startIndexedDbPersistence(user, persistenceSettings)
                .then(function (maybeLruGc) {
                persistenceResult.resolve();
                return maybeLruGc;
            })
                .catch(function (error) {
                // Regardless of whether or not the retry succeeds, from an user
                // perspective, offline persistence has failed.
                persistenceResult.reject(error);
                // An unknown failure on the first stage shuts everything down.
                if (!_this.canFallback(error)) {
                    throw error;
                }
                console.warn('Error enabling offline persistence. Falling back to' +
                    ' persistence disabled: ' +
                    error);
                return _this.startMemoryPersistence();
            });
        }
        else {
            // When usePersistence == false, enabling offline persistence is defined
            // to unconditionally succeed. This allows start() to have the same
            // signature for both cases, despite the fact that the returned promise
            // is only used in the enablePersistence call.
            persistenceResult.resolve();
            return this.startMemoryPersistence();
        }
    };
    /**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */
    FirestoreClient.prototype.canFallback = function (error) {
        if (error instanceof FirestoreError) {
            return (error.code === Code.FAILED_PRECONDITION ||
                error.code === Code.UNIMPLEMENTED);
        }
        else if (typeof DOMException !== 'undefined' &&
            error instanceof DOMException) {
            // There are a few known circumstances where we can open IndexedDb but
            // trying to read/write will fail (e.g. quota exceeded). For
            // well-understood cases, we attempt to detect these and then gracefully
            // fall back to memory persistence.
            // NOTE: Rather than continue to add to this list, we could decide to
            // always fall back, with the risk that we might accidentally hide errors
            // representing actual SDK bugs.
            return (
            // When the browser is out of quota we could get either quota exceeded
            // or an aborted error depending on whether the error happened during
            // schema migration.
            error.code === DOM_EXCEPTION_QUOTA_EXCEEDED ||
                error.code === DOM_EXCEPTION_ABORTED ||
                // Firefox Private Browsing mode disables IndexedDb and returns
                // INVALID_STATE for any usage.
                error.code === DOM_EXCEPTION_INVALID_STATE);
        }
        return true;
    };
    /**
     * Checks that the client has not been shutdown. Ensures that other methods on
     * this class cannot be called after the client is shutdown.
     */
    FirestoreClient.prototype.verifyNotShutdown = function () {
        if (this._clientShutdown) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'The client has already been shutdown.');
        }
    };
    /**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */
    FirestoreClient.prototype.startIndexedDbPersistence = function (user, settings) {
        var _this = this;
        // TODO(http://b/33384523): For now we just disable garbage collection
        // when persistence is enabled.
        var storagePrefix = IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);
        // Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
        var serializer = new JsonProtoSerializer(this.databaseInfo.databaseId, {
            useProto3Json: true
        });
        return Promise.resolve().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var persistence, lruParams;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (settings.synchronizeTabs &&
                            !WebStorageSharedClientState.isAvailable(this.platform)) {
                            throw new FirestoreError(Code.UNIMPLEMENTED, 'IndexedDB persistence is only available on platforms that support LocalStorage.');
                        }
                        lruParams = settings.lruParams();
                        if (!settings.synchronizeTabs) return [3 /*break*/, 2];
                        this.sharedClientState = new WebStorageSharedClientState(this.asyncQueue, this.platform, storagePrefix, this.clientId, user);
                        return [4 /*yield*/, IndexedDbPersistence.createMultiClientIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams, { sequenceNumberSyncer: this.sharedClientState })];
                    case 1:
                        persistence = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        this.sharedClientState = new MemorySharedClientState();
                        return [4 /*yield*/, IndexedDbPersistence.createIndexedDbPersistence(storagePrefix, this.clientId, this.platform, this.asyncQueue, serializer, lruParams)];
                    case 3:
                        persistence = _a.sent();
                        _a.label = 4;
                    case 4:
                        this.persistence = persistence;
                        return [2 /*return*/, persistence.referenceDelegate.garbageCollector];
                }
            });
        }); });
    };
    /**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */
    FirestoreClient.prototype.startMemoryPersistence = function () {
        this.persistence = MemoryPersistence.createEagerPersistence(this.clientId);
        this.sharedClientState = new MemorySharedClientState();
        return Promise.resolve(null);
    };
    /**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */
    FirestoreClient.prototype.initializeRest = function (user, maybeLruGc) {
        var _this = this;
        debug(LOG_TAG$a, 'Initializing. user=', user.uid);
        return this.platform
            .loadConnection(this.databaseInfo)
            .then(function (connection) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var connectivityMonitor, serializer, datastore, remoteStoreOnlineStateChangedHandler, sharedClientStateOnlineStateChangedHandler;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.localStore = new LocalStore(this.persistence, user);
                        if (maybeLruGc) {
                            // We're running LRU Garbage collection. Set up the scheduler.
                            this.lruScheduler = new LruScheduler(maybeLruGc, this.asyncQueue, this.localStore);
                        }
                        connectivityMonitor = this.platform.newConnectivityMonitor();
                        serializer = this.platform.newSerializer(this.databaseInfo.databaseId);
                        datastore = new Datastore(this.asyncQueue, connection, this.credentials, serializer);
                        remoteStoreOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.RemoteStore);
                        };
                        sharedClientStateOnlineStateChangedHandler = function (onlineState) {
                            return _this.syncEngine.applyOnlineStateChange(onlineState, OnlineStateSource.SharedClientState);
                        };
                        this.remoteStore = new RemoteStore(this.localStore, datastore, this.asyncQueue, remoteStoreOnlineStateChangedHandler, connectivityMonitor);
                        this.syncEngine = new SyncEngine(this.localStore, this.remoteStore, this.sharedClientState, user);
                        this.sharedClientState.onlineStateHandler = sharedClientStateOnlineStateChangedHandler;
                        // Set up wiring between sync engine and other components
                        this.remoteStore.syncEngine = this.syncEngine;
                        this.sharedClientState.syncEngine = this.syncEngine;
                        this.eventMgr = new EventManager(this.syncEngine);
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        return [4 /*yield*/, this.sharedClientState.start()];
                    case 1:
                        // PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
                        _a.sent();
                        return [4 /*yield*/, this.remoteStore.start()];
                    case 2:
                        _a.sent();
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        return [4 /*yield*/, this.persistence.setPrimaryStateListener(function (isPrimary) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.syncEngine.applyPrimaryState(isPrimary)];
                                        case 1:
                                            _a.sent();
                                            if (this.lruScheduler) {
                                                if (isPrimary && !this.lruScheduler.started) {
                                                    this.lruScheduler.start();
                                                }
                                                else if (!isPrimary) {
                                                    this.lruScheduler.stop();
                                                }
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 3:
                        // NOTE: This will immediately call the listener, so we make sure to
                        // set it after localStore / remoteStore are started.
                        _a.sent();
                        // When a user calls clearPersistence() in one client, all other clientfs
                        // need to shut down to allow the delete to succeed.
                        return [4 /*yield*/, this.persistence.setDatabaseDeletedListener(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.shutdown()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 4:
                        // When a user calls clearPersistence() in one client, all other clientfs
                        // need to shut down to allow the delete to succeed.
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.handleCredentialChange = function (user) {
        this.asyncQueue.verifyOperationInProgress();
        debug(LOG_TAG$a, 'Credential Changed. Current user: ' + user.uid);
        return this.syncEngine.handleCredentialChange(user);
    };
    /** Disables the network connection. Pending operations will not complete. */
    FirestoreClient.prototype.disableNetwork = function () {
        var _this = this;
        this.verifyNotShutdown();
        return this.asyncQueue.enqueue(function () {
            return _this.syncEngine.disableNetwork();
        });
    };
    FirestoreClient.prototype.shutdown = function () {
        var _this = this;
        return this.asyncQueue.enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this._clientShutdown) return [3 /*break*/, 4];
                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
                        if (this.lruScheduler) {
                            this.lruScheduler.stop();
                        }
                        return [4 /*yield*/, this.remoteStore.shutdown()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sharedClientState.shutdown()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.persistence.shutdown()];
                    case 3:
                        _a.sent();
                        // `removeChangeListener` must be called after shutting down the
                        // RemoteStore as it will prevent the RemoteStore from retrieving
                        // auth tokens.
                        this.credentials.removeChangeListener();
                        this._clientShutdown = true;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    FirestoreClient.prototype.listen = function (query, observer, options) {
        var _this = this;
        this.verifyNotShutdown();
        var listener = new QueryListener(query, observer, options);
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.listen(listener);
        });
        return listener;
    };
    FirestoreClient.prototype.unlisten = function (listener) {
        var _this = this;
        this.verifyNotShutdown();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.eventMgr.unlisten(listener);
        });
    };
    FirestoreClient.prototype.getDocumentFromLocalCache = function (docKey) {
        var _this = this;
        this.verifyNotShutdown();
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.readDocument(docKey);
        })
            .then(function (maybeDoc) {
            if (maybeDoc instanceof Document) {
                return maybeDoc;
            }
            else if (maybeDoc instanceof NoDocument) {
                return null;
            }
            else {
                throw new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from cache. (However, this document may ' +
                    "exist on the server. Run again without setting 'source' in " +
                    'the GetOptions to attempt to retrieve the document from the ' +
                    'server.)');
            }
        });
    };
    FirestoreClient.prototype.getDocumentsFromLocalCache = function (query) {
        var _this = this;
        this.verifyNotShutdown();
        return this.asyncQueue
            .enqueue(function () {
            return _this.localStore.executeQuery(query);
        })
            .then(function (docs) {
            var remoteKeys = documentKeySet();
            var view = new View(query, remoteKeys);
            var viewDocChanges = view.computeDocChanges(docs);
            return view.applyChanges(viewDocChanges, 
            /* updateLimboDocuments= */ false).snapshot;
        });
    };
    FirestoreClient.prototype.write = function (mutations) {
        var _this = this;
        this.verifyNotShutdown();
        var deferred = new Deferred();
        this.asyncQueue.enqueueAndForget(function () {
            return _this.syncEngine.write(mutations, deferred);
        });
        return deferred.promise;
    };
    FirestoreClient.prototype.databaseId = function () {
        return this.databaseInfo.databaseId;
    };
    Object.defineProperty(FirestoreClient.prototype, "clientShutdown", {
        get: function () {
            return this._clientShutdown;
        },
        enumerable: true,
        configurable: true
    });
    FirestoreClient.prototype.transaction = function (updateFunction) {
        var _this = this;
        this.verifyNotShutdown();
        // We have to wait for the async queue to be sure syncEngine is initialized.
        return this.asyncQueue
            .enqueue(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/];
        }); }); })
            .then(function () { return _this.syncEngine.runTransaction(updateFunction); });
    };
    return FirestoreClient;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */
var AsyncObserver = /** @class */ (function () {
    function AsyncObserver(observer) {
        this.observer = observer;
        /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */
        this.muted = false;
    }
    AsyncObserver.prototype.next = function (value) {
        this.scheduleEvent(this.observer.next, value);
    };
    AsyncObserver.prototype.error = function (error) {
        this.scheduleEvent(this.observer.error, error);
    };
    AsyncObserver.prototype.mute = function () {
        this.muted = true;
    };
    AsyncObserver.prototype.scheduleEvent = function (eventHandler, event) {
        var _this = this;
        if (!this.muted) {
            setTimeout(function () {
                if (!_this.muted) {
                    eventHandler(event);
                }
            }, 0);
        }
    };
    return AsyncObserver;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */
var FieldPath$1 = /** @class */ (function () {
    /**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */
    function FieldPath$1() {
        var fieldNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fieldNames[_i] = arguments[_i];
        }
        validateNamedArrayAtLeastNumberOfElements('FieldPath', fieldNames, 'fieldNames', 1);
        for (var i = 0; i < fieldNames.length; ++i) {
            validateArgType('FieldPath', 'string', i, fieldNames[i]);
            if (fieldNames[i].length === 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). " +
                    'Field names must not be empty.');
            }
        }
        this._internalPath = new FieldPath(fieldNames);
    }
    FieldPath$1.documentId = function () {
        return FieldPath$1._DOCUMENT_ID;
    };
    FieldPath$1.prototype.isEqual = function (other) {
        if (!(other instanceof FieldPath$1)) {
            throw invalidClassError('isEqual', 'FieldPath', 1, other);
        }
        return this._internalPath.isEqual(other._internalPath);
    };
    /**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */
    FieldPath$1._DOCUMENT_ID = new FieldPath$1(FieldPath.keyField().canonicalString());
    return FieldPath$1;
}());
/**
 * Matches any characters in a field path string that are reserved.
 */
var RESERVED = new RegExp('[~\\*/\\[\\]]');
/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */
function fromDotSeparatedString(path) {
    var found = path.search(RESERVED);
    if (found >= 0) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not contain " +
            "'~', '*', '/', '[', or ']'");
    }
    try {
        return new (FieldPath$1.bind.apply(FieldPath$1, [void 0].concat(path.split('.'))))();
    }
    catch (e) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid field path (" + path + "). Paths must not be empty, " +
            "begin with '.', end with '.', or contain '..'");
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OAuthToken = /** @class */ (function () {
    function OAuthToken(value, user) {
        this.user = user;
        this.type = 'OAuth';
        this.authHeaders = { Authorization: "Bearer " + value };
    }
    return OAuthToken;
}());
/** A CredentialsProvider that always yields an empty token. */
var EmptyCredentialsProvider = /** @class */ (function () {
    function EmptyCredentialsProvider() {
        /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */
        this.changeListener = null;
    }
    EmptyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(null);
    };
    EmptyCredentialsProvider.prototype.invalidateToken = function () { };
    EmptyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire with initial user.
        changeListener(User.UNAUTHENTICATED);
    };
    EmptyCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.changeListener !== null, 'removeChangeListener() when no listener registered');
        this.changeListener = null;
    };
    return EmptyCredentialsProvider;
}());
var FirebaseCredentialsProvider = /** @class */ (function () {
    function FirebaseCredentialsProvider(app) {
        var _this = this;
        this.app = app;
        /**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */
        this.tokenListener = null;
        /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */
        this.tokenCounter = 0;
        /** The listener registered with setChangeListener(). */
        this.changeListener = null;
        this.forceRefresh = false;
        this.tokenListener = function () {
            _this.tokenCounter++;
            _this.currentUser = _this.getUser();
            if (_this.changeListener) {
                _this.changeListener(_this.currentUser);
            }
        };
        this.tokenCounter = 0;
        // Will fire at least once where we set this.currentUser
        this.app.INTERNAL.addAuthTokenListener(this.tokenListener);
    }
    FirebaseCredentialsProvider.prototype.getToken = function () {
        var _this = this;
        assert(this.tokenListener != null, 'getToken cannot be called after listener removed.');
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        var initialTokenCounter = this.tokenCounter;
        var forceRefresh = this.forceRefresh;
        this.forceRefresh = false;
        return this.app.INTERNAL.getToken(forceRefresh).then(function (tokenData) {
            // Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            if (_this.tokenCounter !== initialTokenCounter) {
                throw new FirestoreError(Code.ABORTED, 'getToken aborted due to token change.');
            }
            else {
                if (tokenData) {
                    assert(typeof tokenData.accessToken === 'string', 'Invalid tokenData returned from getToken():' + tokenData);
                    return new OAuthToken(tokenData.accessToken, _this.currentUser);
                }
                else {
                    return null;
                }
            }
        });
    };
    FirebaseCredentialsProvider.prototype.invalidateToken = function () {
        this.forceRefresh = true;
    };
    FirebaseCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        assert(!this.changeListener, 'Can only call setChangeListener() once.');
        this.changeListener = changeListener;
        // Fire the initial event, but only if we received the initial user
        if (this.currentUser) {
            changeListener(this.currentUser);
        }
    };
    FirebaseCredentialsProvider.prototype.removeChangeListener = function () {
        assert(this.tokenListener != null, 'removeChangeListener() called twice');
        assert(this.changeListener !== null, 'removeChangeListener() called when no listener registered');
        this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);
        this.tokenListener = null;
        this.changeListener = null;
    };
    FirebaseCredentialsProvider.prototype.getUser = function () {
        var currentUid = this.app.INTERNAL.getUid();
        assert(currentUid === null || typeof currentUid === 'string', 'Received invalid UID: ' + currentUid);
        return new User(currentUid);
    };
    return FirebaseCredentialsProvider;
}());
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */
var FirstPartyToken = /** @class */ (function () {
    function FirstPartyToken(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
        this.type = 'FirstParty';
        this.user = User.FIRST_PARTY;
    }
    Object.defineProperty(FirstPartyToken.prototype, "authHeaders", {
        get: function () {
            var headers = {
                'X-Goog-AuthUser': this.sessionIndex
            };
            var authHeader = this.gapi.auth.getAuthHeaderValueForFirstParty([]);
            if (authHeader) {
                headers['Authorization'] = authHeader;
            }
            return headers;
        },
        enumerable: true,
        configurable: true
    });
    return FirstPartyToken;
}());
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */
var FirstPartyCredentialsProvider = /** @class */ (function () {
    function FirstPartyCredentialsProvider(gapi, sessionIndex) {
        this.gapi = gapi;
        this.sessionIndex = sessionIndex;
    }
    FirstPartyCredentialsProvider.prototype.getToken = function () {
        return Promise.resolve(new FirstPartyToken(this.gapi, this.sessionIndex));
    };
    FirstPartyCredentialsProvider.prototype.setChangeListener = function (changeListener) {
        // Fire with initial uid.
        changeListener(User.FIRST_PARTY);
    };
    FirstPartyCredentialsProvider.prototype.removeChangeListener = function () { };
    FirstPartyCredentialsProvider.prototype.invalidateToken = function () { };
    return FirstPartyCredentialsProvider;
}());
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */
function makeCredentialsProvider(credentials) {
    if (!credentials) {
        return new EmptyCredentialsProvider();
    }
    switch (credentials.type) {
        case 'gapi':
            var client = credentials.client;
            // Make sure this really is a Gapi client.
            assert(!!(typeof client === 'object' &&
                client !== null &&
                client['auth'] &&
                client['auth']['getAuthHeaderValueForFirstParty']), 'unexpected gapi interface');
            return new FirstPartyCredentialsProvider(client, credentials.sessionIndex || '0');
        case 'provider':
            return credentials.client;
        default:
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'makeCredentialsProvider failed due to invalid credential type');
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isPartialObserver(obj) {
    return implementsAnyMethods(obj, ['next', 'error', 'complete']);
}
/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    var object = obj;
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in object && typeof object[method] === 'function') {
            return true;
        }
    }
    return false;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */
// tslint:disable-next-line:class-as-namespace  We use this as a base class.
var FieldValueImpl = /** @class */ (function () {
    function FieldValueImpl(_methodName) {
        this._methodName = _methodName;
    }
    FieldValueImpl.delete = function () {
        validateNoArgs('FieldValue.delete', arguments);
        return DeleteFieldValueImpl.instance;
    };
    FieldValueImpl.serverTimestamp = function () {
        validateNoArgs('FieldValue.serverTimestamp', arguments);
        return ServerTimestampFieldValueImpl.instance;
    };
    FieldValueImpl.arrayUnion = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayUnion', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayUnionFieldValueImpl(elements);
    };
    FieldValueImpl.arrayRemove = function () {
        var elements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            elements[_i] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('FieldValue.arrayRemove', arguments, 1);
        // NOTE: We don't actually parse the data until it's used in set() or
        // update() since we need access to the Firestore instance.
        return new ArrayRemoveFieldValueImpl(elements);
    };
    FieldValueImpl.increment = function (n) {
        validateArgType('FieldValue.increment', 'number', 1, n);
        validateExactNumberOfArgs('FieldValue.increment', arguments, 1);
        return new NumericIncrementFieldValueImpl(n);
    };
    FieldValueImpl.prototype.isEqual = function (other) {
        return this === other;
    };
    return FieldValueImpl;
}());
var DeleteFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(DeleteFieldValueImpl, _super);
    function DeleteFieldValueImpl() {
        return _super.call(this, 'FieldValue.delete') || this;
    }
    /** Singleton instance. */
    DeleteFieldValueImpl.instance = new DeleteFieldValueImpl();
    return DeleteFieldValueImpl;
}(FieldValueImpl));
var ServerTimestampFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ServerTimestampFieldValueImpl, _super);
    function ServerTimestampFieldValueImpl() {
        return _super.call(this, 'FieldValue.serverTimestamp') || this;
    }
    /** Singleton instance. */
    ServerTimestampFieldValueImpl.instance = new ServerTimestampFieldValueImpl();
    return ServerTimestampFieldValueImpl;
}(FieldValueImpl));
var ArrayUnionFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayUnionFieldValueImpl, _super);
    function ArrayUnionFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayUnion') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayUnionFieldValueImpl;
}(FieldValueImpl));
var ArrayRemoveFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(ArrayRemoveFieldValueImpl, _super);
    function ArrayRemoveFieldValueImpl(_elements) {
        var _this = _super.call(this, 'FieldValue.arrayRemove') || this;
        _this._elements = _elements;
        return _this;
    }
    return ArrayRemoveFieldValueImpl;
}(FieldValueImpl));
var NumericIncrementFieldValueImpl = /** @class */ (function (_super) {
    tslib_1.__extends(NumericIncrementFieldValueImpl, _super);
    function NumericIncrementFieldValueImpl(_operand) {
        var _this = _super.call(this, 'FieldValue.increment') || this;
        _this._operand = _operand;
        return _this;
    }
    return NumericIncrementFieldValueImpl;
}(FieldValueImpl));
// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
// tslint:disable-next-line:variable-name  We treat this as a class name.
var PublicFieldValue = makeConstructorPrivate(FieldValueImpl, 'Use FieldValue.<field>() instead.');

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var RESERVED_FIELD_REGEX = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */
var ParsedSetData = /** @class */ (function () {
    function ParsedSetData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedSetData.prototype.toMutations = function (key, precondition) {
        var mutations = [];
        if (this.fieldMask !== null) {
            mutations.push(new PatchMutation(key, this.data, this.fieldMask, precondition));
        }
        else {
            mutations.push(new SetMutation(key, this.data, precondition));
        }
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedSetData;
}());
/** The result of parsing "update" data (i.e. for an updateData call). */
var ParsedUpdateData = /** @class */ (function () {
    function ParsedUpdateData(data, fieldMask, fieldTransforms) {
        this.data = data;
        this.fieldMask = fieldMask;
        this.fieldTransforms = fieldTransforms;
    }
    ParsedUpdateData.prototype.toMutations = function (key, precondition) {
        var mutations = [
            new PatchMutation(key, this.data, this.fieldMask, precondition)
        ];
        if (this.fieldTransforms.length > 0) {
            mutations.push(new TransformMutation(key, this.fieldTransforms));
        }
        return mutations;
    };
    return ParsedUpdateData;
}());
/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */
var UserDataSource;
(function (UserDataSource) {
    UserDataSource[UserDataSource["Set"] = 0] = "Set";
    UserDataSource[UserDataSource["Update"] = 1] = "Update";
    UserDataSource[UserDataSource["MergeSet"] = 2] = "MergeSet";
    /**
     * Indicates the source is a where clause, cursor bound, arrayUnion()
     * element, etc. Of note, isWrite(source) will return false.
     */
    UserDataSource[UserDataSource["Argument"] = 3] = "Argument";
})(UserDataSource || (UserDataSource = {}));
function isWrite(dataSource) {
    switch (dataSource) {
        case UserDataSource.Set: // fall through
        case UserDataSource.MergeSet: // fall through
        case UserDataSource.Update:
            return true;
        case UserDataSource.Argument:
            return false;
        default:
            throw fail("Unexpected case for UserDataSource: " + dataSource);
    }
}
/** A "context" object passed around while parsing user data. */
var ParseContext = /** @class */ (function () {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */
    function ParseContext(dataSource, methodName, path, arrayElement, fieldTransforms, fieldMask) {
        this.dataSource = dataSource;
        this.methodName = methodName;
        this.path = path;
        this.arrayElement = arrayElement;
        // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        if (fieldTransforms === undefined) {
            this.validatePath();
        }
        this.arrayElement = arrayElement !== undefined ? arrayElement : false;
        this.fieldTransforms = fieldTransforms || [];
        this.fieldMask = fieldMask || [];
    }
    ParseContext.prototype.childContextForField = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePathSegment(field);
        return context;
    };
    ParseContext.prototype.childContextForFieldPath = function (field) {
        var childPath = this.path == null ? null : this.path.child(field);
        var context = new ParseContext(this.dataSource, this.methodName, childPath, 
        /*arrayElement=*/ false, this.fieldTransforms, this.fieldMask);
        context.validatePath();
        return context;
    };
    ParseContext.prototype.childContextForArray = function (index) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // null.
        return new ParseContext(this.dataSource, this.methodName, 
        /*path=*/ null, 
        /*arrayElement=*/ true, this.fieldTransforms, this.fieldMask);
    };
    ParseContext.prototype.createError = function (reason) {
        var fieldDescription = this.path === null || this.path.isEmpty()
            ? ''
            : " (found in field " + this.path.toString() + ")";
        return new FirestoreError(Code.INVALID_ARGUMENT, "Function " + this.methodName + "() called with invalid data. " +
            reason +
            fieldDescription);
    };
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */
    ParseContext.prototype.contains = function (fieldPath) {
        return (this.fieldMask.find(function (field) { return fieldPath.isPrefixOf(field); }) !== undefined ||
            this.fieldTransforms.find(function (transform) {
                return fieldPath.isPrefixOf(transform.field);
            }) !== undefined);
    };
    ParseContext.prototype.validatePath = function () {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path === null) {
            return;
        }
        for (var i = 0; i < this.path.length; i++) {
            this.validatePathSegment(this.path.get(i));
        }
    };
    ParseContext.prototype.validatePathSegment = function (segment) {
        if (isWrite(this.dataSource) && RESERVED_FIELD_REGEX.test(segment)) {
            throw this.createError('Document fields cannot begin and end with __');
        }
    };
    return ParseContext;
}());
/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */
var DocumentKeyReference = /** @class */ (function () {
    function DocumentKeyReference(databaseId, key) {
        this.databaseId = databaseId;
        this.key = key;
    }
    return DocumentKeyReference;
}());
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */
var UserDataConverter = /** @class */ (function () {
    function UserDataConverter(preConverter) {
        this.preConverter = preConverter;
    }
    /** Parse document data from a non-merge set() call. */
    UserDataConverter.prototype.parseSetData = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Set, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        return new ParsedSetData(updateData, 
        /* fieldMask= */ null, context.fieldTransforms);
    };
    /** Parse document data from a set() call with '{merge:true}'. */
    UserDataConverter.prototype.parseMergeData = function (methodName, input, fieldPaths) {
        var context = new ParseContext(UserDataSource.MergeSet, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var updateData = this.parseData(input, context);
        var fieldMask;
        var fieldTransforms;
        if (!fieldPaths) {
            fieldMask = FieldMask.fromArray(context.fieldMask);
            fieldTransforms = context.fieldTransforms;
        }
        else {
            var validatedFieldPaths = new SortedSet(FieldPath.comparator);
            for (var _i = 0, fieldPaths_1 = fieldPaths; _i < fieldPaths_1.length; _i++) {
                var stringOrFieldPath = fieldPaths_1[_i];
                var fieldPath = void 0;
                if (stringOrFieldPath instanceof FieldPath$1) {
                    fieldPath = stringOrFieldPath._internalPath;
                }
                else if (typeof stringOrFieldPath === 'string') {
                    fieldPath = fieldPathFromDotSeparatedString(methodName, stringOrFieldPath);
                }
                else {
                    throw fail('Expected stringOrFieldPath to be a string or a FieldPath');
                }
                if (!context.contains(fieldPath)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Field '" + fieldPath + "' is specified in your field mask but missing from your input data.");
                }
                validatedFieldPaths = validatedFieldPaths.add(fieldPath);
            }
            fieldMask = FieldMask.fromSet(validatedFieldPaths);
            fieldTransforms = context.fieldTransforms.filter(function (transform) {
                return fieldMask.covers(transform.field);
            });
        }
        return new ParsedSetData(updateData, fieldMask, fieldTransforms);
    };
    /** Parse update data from an update() call. */
    UserDataConverter.prototype.parseUpdateData = function (methodName, input) {
        var _this = this;
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        validatePlainObject('Data must be an object, but it was:', context, input);
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        forEach(input, function (key, value) {
            var path = fieldPathFromDotSeparatedString(methodName, key);
            var childContext = context.childContextForFieldPath(path);
            value = _this.runPreConverter(value, childContext);
            if (value instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = _this.parseData(value, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        });
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /** Parse update data from a list of field/value arguments. */
    UserDataConverter.prototype.parseUpdateVarargs = function (methodName, field, value, moreFieldsAndValues) {
        var context = new ParseContext(UserDataSource.Update, methodName, FieldPath.EMPTY_PATH);
        var keys = [fieldPathFromArgument(methodName, field)];
        var values = [value];
        if (moreFieldsAndValues.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() needs to be called with an even number " +
                'of arguments that alternate between field names and values.');
        }
        for (var i = 0; i < moreFieldsAndValues.length; i += 2) {
            keys.push(fieldPathFromArgument(methodName, moreFieldsAndValues[i]));
            values.push(moreFieldsAndValues[i + 1]);
        }
        var fieldMaskPaths = new SortedSet(FieldPath.comparator);
        var updateData = ObjectValue.EMPTY;
        for (var i = 0; i < keys.length; ++i) {
            var path = keys[i];
            var childContext = context.childContextForFieldPath(path);
            var value_1 = this.runPreConverter(values[i], childContext);
            if (value_1 instanceof DeleteFieldValueImpl) {
                // Add it to the field mask, but don't add anything to updateData.
                fieldMaskPaths = fieldMaskPaths.add(path);
            }
            else {
                var parsedValue = this.parseData(value_1, childContext);
                if (parsedValue != null) {
                    fieldMaskPaths = fieldMaskPaths.add(path);
                    updateData = updateData.set(path, parsedValue);
                }
            }
        }
        var mask = FieldMask.fromSet(fieldMaskPaths);
        return new ParsedUpdateData(updateData, mask, context.fieldTransforms);
    };
    /**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     */
    UserDataConverter.prototype.parseQueryValue = function (methodName, input) {
        var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
        var parsed = this.parseData(input, context);
        assert(parsed != null, 'Parsed data should not be null.');
        assert(context.fieldTransforms.length === 0, 'Field transforms should have been disallowed.');
        return parsed;
    };
    /** Sends data through this.preConverter, handling any thrown errors. */
    UserDataConverter.prototype.runPreConverter = function (input, context) {
        try {
            return this.preConverter(input);
        }
        catch (e) {
            var message = errorMessage(e);
            throw context.createError(message);
        }
    };
    /**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */
    UserDataConverter.prototype.parseData = function (input, context) {
        input = this.runPreConverter(input, context);
        if (looksLikeJsonObject(input)) {
            validatePlainObject('Unsupported field value:', context, input);
            return this.parseObject(input, context);
        }
        else if (input instanceof FieldValueImpl) {
            // FieldValues usually parse into transforms (except FieldValue.delete())
            // in which case we do not want to include this field in our parsed data
            // (as doing so will overwrite the field directly prior to the transform
            // trying to transform it). So we don't add this location to
            // context.fieldMask and we return null as our parsing result.
            this.parseSentinelFieldValue(input, context);
            return null;
        }
        else {
            // If context.path is null we are inside an array and we don't support
            // field mask paths more granular than the top-level array.
            if (context.path) {
                context.fieldMask.push(context.path);
            }
            if (input instanceof Array) {
                // TODO(b/34871131): Include the path containing the array in the error
                // message.
                if (context.arrayElement) {
                    throw context.createError('Nested arrays are not supported');
                }
                return this.parseArray(input, context);
            }
            else {
                return this.parseScalarValue(input, context);
            }
        }
    };
    UserDataConverter.prototype.parseObject = function (obj, context) {
        var _this = this;
        var result = new SortedMap(primitiveComparator);
        if (isEmpty(obj)) {
            // If we encounter an empty object, we explicitly add it to the update
            // mask to ensure that the server creates a map entry.
            if (context.path && context.path.length > 0) {
                context.fieldMask.push(context.path);
            }
        }
        else {
            forEach(obj, function (key, val) {
                var parsedValue = _this.parseData(val, context.childContextForField(key));
                if (parsedValue != null) {
                    result = result.insert(key, parsedValue);
                }
            });
        }
        return new ObjectValue(result);
    };
    UserDataConverter.prototype.parseArray = function (array, context) {
        var result = [];
        var entryIndex = 0;
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var entry = array_1[_i];
            var parsedEntry = this.parseData(entry, context.childContextForArray(entryIndex));
            if (parsedEntry == null) {
                // Just include nulls in the array for fields being replaced with a
                // sentinel.
                parsedEntry = NullValue.INSTANCE;
            }
            result.push(parsedEntry);
            entryIndex++;
        }
        return new ArrayValue(result);
    };
    /**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */
    UserDataConverter.prototype.parseSentinelFieldValue = function (value, context) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!isWrite(context.dataSource)) {
            throw context.createError(value._methodName + "() can only be used with update() and set()");
        }
        if (context.path === null) {
            throw context.createError(value._methodName + "() is not currently supported inside arrays");
        }
        if (value instanceof DeleteFieldValueImpl) {
            if (context.dataSource === UserDataSource.MergeSet) {
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                context.fieldMask.push(context.path);
            }
            else if (context.dataSource === UserDataSource.Update) {
                assert(context.path.length > 0, 'FieldValue.delete() at the top level should have already' +
                    ' been handled.');
                throw context.createError('FieldValue.delete() can only appear at the top level ' +
                    'of your update data');
            }
            else {
                // We shouldn't encounter delete sentinels for queries or non-merge set() calls.
                throw context.createError('FieldValue.delete() cannot be used with set() unless you pass ' +
                    '{merge:true}');
            }
        }
        else if (value instanceof ServerTimestampFieldValueImpl) {
            context.fieldTransforms.push(new FieldTransform(context.path, ServerTimestampTransform.instance));
        }
        else if (value instanceof ArrayUnionFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayUnion = new ArrayUnionTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayUnion));
        }
        else if (value instanceof ArrayRemoveFieldValueImpl) {
            var parsedElements = this.parseArrayTransformElements(value._methodName, value._elements);
            var arrayRemove = new ArrayRemoveTransformOperation(parsedElements);
            context.fieldTransforms.push(new FieldTransform(context.path, arrayRemove));
        }
        else if (value instanceof NumericIncrementFieldValueImpl) {
            var operand = this.parseQueryValue('FieldValue.increment', value._operand);
            var numericIncrement = new NumericIncrementTransformOperation(operand);
            context.fieldTransforms.push(new FieldTransform(context.path, numericIncrement));
        }
        else {
            fail('Unknown FieldValue type: ' + value);
        }
    };
    /**
     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
     *
     * @return The parsed value
     */
    UserDataConverter.prototype.parseScalarValue = function (value, context) {
        if (value === null) {
            return NullValue.INSTANCE;
        }
        else if (typeof value === 'number') {
            if (isSafeInteger(value)) {
                return new IntegerValue(value);
            }
            else {
                return new DoubleValue(value);
            }
        }
        else if (typeof value === 'boolean') {
            return BooleanValue.of(value);
        }
        else if (typeof value === 'string') {
            return new StringValue(value);
        }
        else if (value instanceof Date) {
            return new TimestampValue(Timestamp.fromDate(value));
        }
        else if (value instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            return new TimestampValue(new Timestamp(value.seconds, Math.floor(value.nanoseconds / 1000) * 1000));
        }
        else if (value instanceof GeoPoint) {
            return new GeoPointValue(value);
        }
        else if (value instanceof Blob) {
            return new BlobValue(value);
        }
        else if (value instanceof DocumentKeyReference) {
            return new RefValue(value.databaseId, value.key);
        }
        else {
            throw context.createError("Unsupported field value: " + valueDescription(value));
        }
    };
    UserDataConverter.prototype.parseArrayTransformElements = function (methodName, elements) {
        var _this = this;
        return elements.map(function (element, i) {
            // Although array transforms are used with writes, the actual elements
            // being unioned or removed are not considered writes since they cannot
            // contain any FieldValue sentinels, etc.
            var context = new ParseContext(UserDataSource.Argument, methodName, FieldPath.EMPTY_PATH);
            return _this.parseData(element, context.childContextForArray(i));
        });
    };
    return UserDataConverter;
}());
/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */
function looksLikeJsonObject(input) {
    return (typeof input === 'object' &&
        input !== null &&
        !(input instanceof Array) &&
        !(input instanceof Date) &&
        !(input instanceof Timestamp) &&
        !(input instanceof GeoPoint) &&
        !(input instanceof Blob) &&
        !(input instanceof DocumentKeyReference) &&
        !(input instanceof FieldValueImpl));
}
function validatePlainObject(message, context, input) {
    if (!looksLikeJsonObject(input) || !isPlainObject(input)) {
        var description = valueDescription(input);
        if (description === 'an object') {
            // Massage the error if it was an object.
            throw context.createError(message + ' a custom object');
        }
        else {
            throw context.createError(message + ' ' + description);
        }
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */
function fieldPathFromArgument(methodName, path) {
    if (path instanceof FieldPath$1) {
        return path._internalPath;
    }
    else if (typeof path === 'string') {
        return fieldPathFromDotSeparatedString(methodName, path);
    }
    else {
        var message = 'Field path arguments must be of type string or FieldPath.';
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */
function fieldPathFromDotSeparatedString(methodName, path) {
    try {
        return fromDotSeparatedString(path)._internalPath;
    }
    catch (e) {
        var message = errorMessage(e);
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Function " + methodName + "() called with invalid data. " + message);
    }
}
/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */
function errorMessage(error) {
    return error instanceof Error ? error.message : error.toString();
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
// settings() defaults:
var DEFAULT_HOST = 'firestore.googleapis.com';
var DEFAULT_SSL = true;
var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS = true;
var DEFAULT_FORCE_LONG_POLLING = false;
/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * `Firestore` instance.
 */
var CACHE_SIZE_UNLIMITED = LruParams.COLLECTION_DISABLED;
// enablePersistence() defaults:
var DEFAULT_SYNCHRONIZE_TABS = false;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */
var FirestoreSettings = /** @class */ (function () {
    function FirestoreSettings(settings) {
        if (settings.host === undefined) {
            if (settings.ssl !== undefined) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            }
            this.host = DEFAULT_HOST;
            this.ssl = DEFAULT_SSL;
        }
        else {
            validateNamedType('settings', 'non-empty string', 'host', settings.host);
            this.host = settings.host;
            validateNamedOptionalType('settings', 'boolean', 'ssl', settings.ssl);
            this.ssl = defaulted(settings.ssl, DEFAULT_SSL);
        }
        validateOptionNames('settings', settings, [
            'host',
            'ssl',
            'credentials',
            'timestampsInSnapshots',
            'cacheSizeBytes',
            'experimentalForceLongPolling'
        ]);
        validateNamedOptionalType('settings', 'object', 'credentials', settings.credentials);
        this.credentials = settings.credentials;
        validateNamedOptionalType('settings', 'boolean', 'timestampsInSnapshots', settings.timestampsInSnapshots);
        // Nobody should set timestampsInSnapshots anymore, but the error depends on
        // whether they set it to true or false...
        if (settings.timestampsInSnapshots === true) {
            error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");
        }
        else if (settings.timestampsInSnapshots === false) {
            error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");
        }
        this.timestampsInSnapshots = defaulted(settings.timestampsInSnapshots, DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);
        validateNamedOptionalType('settings', 'number', 'cacheSizeBytes', settings.cacheSizeBytes);
        if (settings.cacheSizeBytes === undefined) {
            this.cacheSizeBytes = LruParams.DEFAULT_CACHE_SIZE_BYTES;
        }
        else {
            if (settings.cacheSizeBytes !== CACHE_SIZE_UNLIMITED &&
                settings.cacheSizeBytes < LruParams.MINIMUM_CACHE_SIZE_BYTES) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + LruParams.MINIMUM_CACHE_SIZE_BYTES);
            }
            else {
                this.cacheSizeBytes = settings.cacheSizeBytes;
            }
        }
        validateNamedOptionalType('settings', 'boolean', 'experimentalForceLongPolling', settings.experimentalForceLongPolling);
        this.forceLongPolling =
            settings.experimentalForceLongPolling === undefined
                ? DEFAULT_FORCE_LONG_POLLING
                : settings.experimentalForceLongPolling;
    }
    FirestoreSettings.prototype.isEqual = function (other) {
        return (this.host === other.host &&
            this.ssl === other.ssl &&
            this.timestampsInSnapshots === other.timestampsInSnapshots &&
            this.credentials === other.credentials &&
            this.cacheSizeBytes === other.cacheSizeBytes &&
            this.forceLongPolling === other.forceLongPolling);
    };
    return FirestoreSettings;
}());
var FirestoreConfig = /** @class */ (function () {
    function FirestoreConfig() {
    }
    return FirestoreConfig;
}());
/**
 * The root reference to the database.
 */
var Firestore = /** @class */ (function () {
    function Firestore(databaseIdOrApp) {
        var _this = this;
        // Public for use in tests.
        // TODO(mikelehen): Use modularized initialization instead.
        this._queue = new AsyncQueue();
        this.INTERNAL = {
            delete: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // The client must be initalized to ensure that all subsequent API usage
                            // throws an exception.
                            this.ensureClientConfigured();
                            return [4 /*yield*/, this._firestoreClient.shutdown()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); }
        };
        var config = new FirestoreConfig();
        if (typeof databaseIdOrApp.options === 'object') {
            // This is very likely a Firebase app object
            // TODO(b/34177605): Can we somehow use instanceof?
            var app = databaseIdOrApp;
            config.firebaseApp = app;
            config.databaseId = Firestore.databaseIdFromApp(app);
            config.persistenceKey = config.firebaseApp.name;
            config.credentials = new FirebaseCredentialsProvider(app);
        }
        else {
            var external_1 = databaseIdOrApp;
            if (!external_1.projectId) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide projectId');
            }
            config.databaseId = new DatabaseId(external_1.projectId, external_1.database);
            // Use a default persistenceKey that lines up with FirebaseApp.
            config.persistenceKey = '[DEFAULT]';
            config.credentials = new EmptyCredentialsProvider();
        }
        config.settings = new FirestoreSettings({});
        this._config = config;
        this._databaseId = config.databaseId;
    }
    Firestore.prototype.settings = function (settingsLiteral) {
        validateExactNumberOfArgs('Firestore.settings', arguments, 1);
        validateArgType('Firestore.settings', 'object', 1, settingsLiteral);
        if (contains(settingsLiteral, 'persistence')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"persistence" is now specified with a separate call to ' +
                'firestore.enablePersistence().');
        }
        var newSettings = new FirestoreSettings(settingsLiteral);
        if (this._firestoreClient && !this._config.settings.isEqual(newSettings)) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and its settings can no longer ' +
                'be changed. You can only call settings() before calling any other ' +
                'methods on a Firestore object.');
        }
        this._config.settings = newSettings;
        if (newSettings.credentials !== undefined) {
            this._config.credentials = makeCredentialsProvider(newSettings.credentials);
        }
    };
    Firestore.prototype.enableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.enableNetwork();
    };
    Firestore.prototype.disableNetwork = function () {
        this.ensureClientConfigured();
        return this._firestoreClient.disableNetwork();
    };
    Firestore.prototype.enablePersistence = function (settings) {
        if (this._firestoreClient) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Firestore has already been started and persistence can no longer ' +
                'be enabled. You can only call enablePersistence() before calling ' +
                'any other methods on a Firestore object.');
        }
        var synchronizeTabs = false;
        if (settings) {
            if (settings.experimentalTabSynchronization !== undefined) {
                error("The 'experimentalTabSynchronization' setting has been renamed to " +
                    "'synchronizeTabs'. In a future release, the setting will be removed " +
                    'and it is recommended that you update your ' +
                    "firestore.enablePersistence() call to use 'synchronizeTabs'.");
            }
            synchronizeTabs = defaulted(settings.synchronizeTabs !== undefined
                ? settings.synchronizeTabs
                : settings.experimentalTabSynchronization, DEFAULT_SYNCHRONIZE_TABS);
        }
        return this.configureClient(new IndexedDbPersistenceSettings(this._config.settings.cacheSizeBytes, synchronizeTabs));
    };
    Firestore.prototype.clearPersistence = function () {
        var _this = this;
        var persistenceKey = IndexedDbPersistence.buildStoragePrefix(this.makeDatabaseInfo());
        var deferred = new Deferred();
        this._queue.enqueueAndForget(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (this._firestoreClient !== undefined &&
                            !this._firestoreClient.clientShutdown) {
                            throw new FirestoreError(Code.FAILED_PRECONDITION, 'Persistence cannot be cleared after this Firestore instance is initialized.');
                        }
                        return [4 /*yield*/, IndexedDbPersistence.clearPersistence(persistenceKey)];
                    case 1:
                        _a.sent();
                        deferred.resolve();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        deferred.reject(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        return deferred.promise;
    };
    Firestore.prototype.ensureClientConfigured = function () {
        if (!this._firestoreClient) {
            // Kick off starting the client but don't actually wait for it.
            // tslint:disable-next-line:no-floating-promises
            this.configureClient(new MemoryPersistenceSettings());
        }
        return this._firestoreClient;
    };
    Firestore.prototype.makeDatabaseInfo = function () {
        return new DatabaseInfo(this._config.databaseId, this._config.persistenceKey, this._config.settings.host, this._config.settings.ssl, this._config.settings.forceLongPolling);
    };
    Firestore.prototype.configureClient = function (persistenceSettings) {
        var _this = this;
        assert(!!this._config.settings.host, 'FirestoreSettings.host cannot be falsey');
        assert(!this._firestoreClient, 'configureClient() called multiple times');
        var databaseInfo = this.makeDatabaseInfo();
        var preConverter = function (value) {
            if (value instanceof DocumentReference) {
                var thisDb = _this._config.databaseId;
                var otherDb = value.firestore._config.databaseId;
                if (!otherDb.isEqual(thisDb)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document reference is for database ' +
                        (otherDb.projectId + "/" + otherDb.database + " but should be ") +
                        ("for database " + thisDb.projectId + "/" + thisDb.database));
                }
                return new DocumentKeyReference(_this._config.databaseId, value._key);
            }
            else {
                return value;
            }
        };
        this._dataConverter = new UserDataConverter(preConverter);
        this._firestoreClient = new FirestoreClient(PlatformSupport.getPlatform(), databaseInfo, this._config.credentials, this._queue);
        return this._firestoreClient.start(persistenceSettings);
    };
    Firestore.databaseIdFromApp = function (app) {
        var options = app.options;
        if (!contains(options, 'projectId')) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
        }
        var projectId = options['projectId'];
        if (!projectId || typeof projectId !== 'string') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'projectId must be a string in FirebaseApp.options');
        }
        return new DatabaseId(projectId);
    };
    Object.defineProperty(Firestore.prototype, "app", {
        get: function () {
            if (!this._config.firebaseApp) {
                throw new FirestoreError(Code.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is " +
                    'not available');
            }
            return this._config.firebaseApp;
        },
        enumerable: true,
        configurable: true
    });
    Firestore.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('Firestore.collection', arguments, 1);
        validateArgType('Firestore.collection', 'non-empty string', 1, pathString);
        this.ensureClientConfigured();
        return new CollectionReference(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.doc = function (pathString) {
        validateExactNumberOfArgs('Firestore.doc', arguments, 1);
        validateArgType('Firestore.doc', 'non-empty string', 1, pathString);
        this.ensureClientConfigured();
        return DocumentReference.forPath(ResourcePath.fromString(pathString), this);
    };
    Firestore.prototype.collectionGroup = function (collectionId) {
        validateExactNumberOfArgs('Firestore.collectionGroup', arguments, 1);
        validateArgType('Firestore.collectionGroup', 'non-empty string', 1, collectionId);
        if (collectionId.indexOf('/') >= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid collection ID '" + collectionId + "' passed to function " +
                "Firestore.collectionGroup(). Collection IDs must not contain '/'.");
        }
        this.ensureClientConfigured();
        return new Query$1(new Query(ResourcePath.EMPTY_PATH, collectionId), this);
    };
    Firestore.prototype.runTransaction = function (updateFunction) {
        var _this = this;
        validateExactNumberOfArgs('Firestore.runTransaction', arguments, 1);
        validateArgType('Firestore.runTransaction', 'function', 1, updateFunction);
        return this.ensureClientConfigured().transaction(function (transaction) {
            return updateFunction(new Transaction$1(_this, transaction));
        });
    };
    Firestore.prototype.batch = function () {
        this.ensureClientConfigured();
        return new WriteBatch(this);
    };
    Object.defineProperty(Firestore, "logLevel", {
        get: function () {
            switch (getLogLevel()) {
                case LogLevel.DEBUG:
                    return 'debug';
                case LogLevel.ERROR:
                    return 'error';
                case LogLevel.SILENT:
                    return 'silent';
                default:
                    return fail('Unknown log level: ' + getLogLevel());
            }
        },
        enumerable: true,
        configurable: true
    });
    Firestore.setLogLevel = function (level) {
        validateExactNumberOfArgs('Firestore.setLogLevel', arguments, 1);
        validateArgType('Firestore.setLogLevel', 'non-empty string', 1, level);
        switch (level) {
            case 'debug':
                setLogLevel(LogLevel.DEBUG);
                break;
            case 'error':
                setLogLevel(LogLevel.ERROR);
                break;
            case 'silent':
                setLogLevel(LogLevel.SILENT);
                break;
            default:
                throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid log level: ' + level);
        }
    };
    // Note: this is not a property because the minifier can't work correctly with
    // the way TypeScript compiler outputs properties.
    Firestore.prototype._areTimestampsInSnapshotsEnabled = function () {
        return this._config.settings.timestampsInSnapshots;
    };
    return Firestore;
}());
/**
 * A reference to a transaction.
 */
var Transaction$1 = /** @class */ (function () {
    function Transaction(_firestore, _transaction) {
        this._firestore = _firestore;
        this._transaction = _transaction;
    }
    Transaction.prototype.get = function (documentRef) {
        var _this = this;
        validateExactNumberOfArgs('Transaction.get', arguments, 1);
        var ref = validateReference('Transaction.get', documentRef, this._firestore);
        return this._transaction
            .lookup([ref._key])
            .then(function (docs) {
            if (!docs || docs.length !== 1) {
                return fail('Mismatch in docs returned from document lookup.');
            }
            var doc = docs[0];
            if (doc instanceof NoDocument) {
                return new DocumentSnapshot(_this._firestore, ref._key, null, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else if (doc instanceof Document) {
                return new DocumentSnapshot(_this._firestore, ref._key, doc, 
                /* fromCache= */ false, 
                /* hasPendingWrites= */ false);
            }
            else {
                throw fail("BatchGetDocumentsRequest returned unexpected document type: " + doc.constructor.name);
            }
        });
    };
    Transaction.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('Transaction.set', arguments, 2, 3);
        var ref = validateReference('Transaction.set', documentRef, this._firestore);
        options = validateSetOptions('Transaction.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('Transaction.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('Transaction.set', value);
        this._transaction.set(ref._key, parsed);
        return this;
    };
    Transaction.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('Transaction.update', arguments, 3);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('Transaction.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('Transaction.update', arguments, 2);
            ref = validateReference('Transaction.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('Transaction.update', fieldOrUpdateData);
        }
        this._transaction.update(ref._key, parsed);
        return this;
    };
    Transaction.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('Transaction.delete', arguments, 1);
        var ref = validateReference('Transaction.delete', documentRef, this._firestore);
        this._transaction.delete(ref._key);
        return this;
    };
    return Transaction;
}());
var WriteBatch = /** @class */ (function () {
    function WriteBatch(_firestore) {
        this._firestore = _firestore;
        this._mutations = [];
        this._committed = false;
    }
    WriteBatch.prototype.set = function (documentRef, value, options) {
        validateBetweenNumberOfArgs('WriteBatch.set', arguments, 2, 3);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.set', documentRef, this._firestore);
        options = validateSetOptions('WriteBatch.set', options);
        var parsed = options.merge || options.mergeFields
            ? this._firestore._dataConverter.parseMergeData('WriteBatch.set', value, options.mergeFields)
            : this._firestore._dataConverter.parseSetData('WriteBatch.set', value);
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.update = function (documentRef, fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 3] = arguments[_i];
        }
        this.verifyNotCommitted();
        var ref;
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('WriteBatch.update', arguments, 3);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('WriteBatch.update', arguments, 2);
            ref = validateReference('WriteBatch.update', documentRef, this._firestore);
            parsed = this._firestore._dataConverter.parseUpdateData('WriteBatch.update', fieldOrUpdateData);
        }
        this._mutations = this._mutations.concat(parsed.toMutations(ref._key, Precondition.exists(true)));
        return this;
    };
    WriteBatch.prototype.delete = function (documentRef) {
        validateExactNumberOfArgs('WriteBatch.delete', arguments, 1);
        this.verifyNotCommitted();
        var ref = validateReference('WriteBatch.delete', documentRef, this._firestore);
        this._mutations = this._mutations.concat(new DeleteMutation(ref._key, Precondition.NONE));
        return this;
    };
    WriteBatch.prototype.commit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.verifyNotCommitted();
                this._committed = true;
                if (this._mutations.length > 0) {
                    return [2 /*return*/, this._firestore.ensureClientConfigured().write(this._mutations)];
                }
                return [2 /*return*/];
            });
        });
    };
    WriteBatch.prototype.verifyNotCommitted = function () {
        if (this._committed) {
            throw new FirestoreError(Code.FAILED_PRECONDITION, 'A write batch can no longer be used after commit() ' +
                'has been called.');
        }
    };
    return WriteBatch;
}());
/**
 * A reference to a particular document in a collection in the database.
 */
var DocumentReference = /** @class */ (function () {
    function DocumentReference(_key, firestore) {
        this._key = _key;
        this.firestore = firestore;
        this._firestoreClient = this.firestore.ensureClientConfigured();
    }
    DocumentReference.forPath = function (path, firestore) {
        if (path.length % 2 !== 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid document reference. Document ' +
                'references must have an even number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return new DocumentReference(new DocumentKey(path), firestore);
    };
    Object.defineProperty(DocumentReference.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "parent", {
        get: function () {
            return new CollectionReference(this._key.path.popLast(), this.firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentReference.prototype, "path", {
        get: function () {
            return this._key.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    DocumentReference.prototype.collection = function (pathString) {
        validateExactNumberOfArgs('DocumentReference.collection', arguments, 1);
        validateArgType('DocumentReference.collection', 'non-empty string', 1, pathString);
        if (!pathString) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Must provide a non-empty collection name to collection()');
        }
        var path = ResourcePath.fromString(pathString);
        return new CollectionReference(this._key.path.child(path), this.firestore);
    };
    DocumentReference.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentReference)) {
            throw invalidClassError('isEqual', 'DocumentReference', 1, other);
        }
        return this.firestore === other.firestore && this._key.isEqual(other._key);
    };
    DocumentReference.prototype.set = function (value, options) {
        validateBetweenNumberOfArgs('DocumentReference.set', arguments, 1, 2);
        options = validateSetOptions('DocumentReference.set', options);
        var parsed = options.merge || options.mergeFields
            ? this.firestore._dataConverter.parseMergeData('DocumentReference.set', value, options.mergeFields)
            : this.firestore._dataConverter.parseSetData('DocumentReference.set', value);
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.NONE));
    };
    DocumentReference.prototype.update = function (fieldOrUpdateData, value) {
        var moreFieldsAndValues = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreFieldsAndValues[_i - 2] = arguments[_i];
        }
        var parsed;
        if (typeof fieldOrUpdateData === 'string' ||
            fieldOrUpdateData instanceof FieldPath$1) {
            validateAtLeastNumberOfArgs('DocumentReference.update', arguments, 2);
            parsed = this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update', fieldOrUpdateData, value, moreFieldsAndValues);
        }
        else {
            validateExactNumberOfArgs('DocumentReference.update', arguments, 1);
            parsed = this.firestore._dataConverter.parseUpdateData('DocumentReference.update', fieldOrUpdateData);
        }
        return this._firestoreClient.write(parsed.toMutations(this._key, Precondition.exists(true)));
    };
    DocumentReference.prototype.delete = function () {
        validateExactNumberOfArgs('DocumentReference.delete', arguments, 0);
        return this._firestoreClient.write([
            new DeleteMutation(this._key, Precondition.NONE)
        ]);
    };
    DocumentReference.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('DocumentReference.onSnapshot', arguments, 1, 4);
        var options = {
            includeMetadataChanges: false
        };
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('DocumentReference.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('DocumentReference.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        var internalOptions = {
            includeMetadataChanges: options.includeMetadataChanges
        };
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('DocumentReference.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('DocumentReference.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(internalOptions, observer);
    };
    DocumentReference.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (snapshot) {
                if (observer.next) {
                    assert(snapshot.docs.size <= 1, 'Too many documents returned on a document query');
                    var doc = snapshot.docs.get(_this._key);
                    observer.next(new DocumentSnapshot(_this.firestore, _this._key, doc, snapshot.fromCache, snapshot.hasPendingWrites));
                }
            },
            error: errHandler
        });
        var internalListener = this._firestoreClient.listen(Query.atPath(this._key.path), asyncObserver, options);
        return function () {
            asyncObserver.mute();
            _this._firestoreClient.unlisten(internalListener);
        };
    };
    DocumentReference.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('DocumentReference.get', arguments, 0, 1);
        validateGetOptions('DocumentReference.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentFromLocalCache(_this._key)
                    .then(function (doc) {
                    resolve(new DocumentSnapshot(_this.firestore, _this._key, doc, 
                    /*fromCache=*/ true, doc instanceof Document ? doc.hasLocalMutations : false));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    DocumentReference.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (snap) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (!snap.exists && snap.metadata.fromCache) {
                    // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document because the client is ' + 'offline.'));
                }
                else if (snap.exists &&
                    snap.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get document from server. (However, this ' +
                        'document does exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached document.)'));
                }
                else {
                    resolve(snap);
                }
            },
            error: reject
        });
    };
    return DocumentReference;
}());
var SnapshotMetadata = /** @class */ (function () {
    function SnapshotMetadata(hasPendingWrites, fromCache) {
        this.hasPendingWrites = hasPendingWrites;
        this.fromCache = fromCache;
    }
    SnapshotMetadata.prototype.isEqual = function (other) {
        return (this.hasPendingWrites === other.hasPendingWrites &&
            this.fromCache === other.fromCache);
    };
    return SnapshotMetadata;
}());
var DocumentSnapshot = /** @class */ (function () {
    function DocumentSnapshot(_firestore, _key, _document, _fromCache, _hasPendingWrites) {
        this._firestore = _firestore;
        this._key = _key;
        this._document = _document;
        this._fromCache = _fromCache;
        this._hasPendingWrites = _hasPendingWrites;
    }
    DocumentSnapshot.prototype.data = function (options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.data', arguments, 0, 1);
        options = validateSnapshotOptions('DocumentSnapshot.data', options);
        return !this._document
            ? undefined
            : this.convertObject(this._document.data, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
    };
    DocumentSnapshot.prototype.get = function (fieldPath, options) {
        validateBetweenNumberOfArgs('DocumentSnapshot.get', arguments, 1, 2);
        options = validateSnapshotOptions('DocumentSnapshot.get', options);
        if (this._document) {
            var value = this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get', fieldPath));
            if (value !== undefined) {
                return this.convertValue(value, FieldValueOptions.fromSnapshotOptions(options, this._firestore._areTimestampsInSnapshotsEnabled()));
            }
        }
        return undefined;
    };
    Object.defineProperty(DocumentSnapshot.prototype, "id", {
        get: function () {
            return this._key.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "ref", {
        get: function () {
            return new DocumentReference(this._key, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "exists", {
        get: function () {
            return this._document !== null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DocumentSnapshot.prototype, "metadata", {
        get: function () {
            return new SnapshotMetadata(this._hasPendingWrites, this._fromCache);
        },
        enumerable: true,
        configurable: true
    });
    DocumentSnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof DocumentSnapshot)) {
            throw invalidClassError('isEqual', 'DocumentSnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._fromCache === other._fromCache &&
            this._key.isEqual(other._key) &&
            (this._document === null
                ? other._document === null
                : this._document.isEqual(other._document)));
    };
    DocumentSnapshot.prototype.convertObject = function (data, options) {
        var _this = this;
        var result = {};
        data.forEach(function (key, value) {
            result[key] = _this.convertValue(value, options);
        });
        return result;
    };
    DocumentSnapshot.prototype.convertValue = function (value, options) {
        if (value instanceof ObjectValue) {
            return this.convertObject(value, options);
        }
        else if (value instanceof ArrayValue) {
            return this.convertArray(value, options);
        }
        else if (value instanceof RefValue) {
            var key = value.value(options);
            var database = this._firestore.ensureClientConfigured().databaseId();
            if (!value.databaseId.isEqual(database)) {
                // TODO(b/64130202): Somehow support foreign references.
                error("Document " + this._key.path + " contains a document " +
                    "reference within a different database (" +
                    (value.databaseId.projectId + "/" + value.databaseId.database + ") which is not ") +
                    "supported. It will be treated as a reference in the current " +
                    ("database (" + database.projectId + "/" + database.database + ") ") +
                    "instead.");
            }
            return new DocumentReference(key, this._firestore);
        }
        else {
            return value.value(options);
        }
    };
    DocumentSnapshot.prototype.convertArray = function (data, options) {
        var _this = this;
        return data.internalValue.map(function (value) {
            return _this.convertValue(value, options);
        });
    };
    return DocumentSnapshot;
}());
var QueryDocumentSnapshot = /** @class */ (function (_super) {
    tslib_1.__extends(QueryDocumentSnapshot, _super);
    function QueryDocumentSnapshot(firestore, key, document, fromCache, hasPendingWrites) {
        return _super.call(this, firestore, key, document, fromCache, hasPendingWrites) || this;
    }
    QueryDocumentSnapshot.prototype.data = function (options) {
        var data = _super.prototype.data.call(this, options);
        assert(typeof data === 'object', 'Document in a QueryDocumentSnapshot should exist');
        return data;
    };
    return QueryDocumentSnapshot;
}(DocumentSnapshot));
var Query$1 = /** @class */ (function () {
    function Query(_query, firestore) {
        this._query = _query;
        this.firestore = firestore;
    }
    Query.prototype.where = function (field, opStr, value) {
        validateExactNumberOfArgs('Query.where', arguments, 3);
        validateDefined('Query.where', 3, value);
        // TODO(in-queries): Add 'in' and 'array-contains-any' to validation.
        if (opStr !== 'in' &&
            opStr !== 'array-contains-any') {
            // Enumerated from the WhereFilterOp type in index.d.ts.
            var whereFilterOpEnums = ['<', '<=', '==', '>=', '>', 'array-contains'];
            validateStringEnum('Query.where', whereFilterOpEnums, 2, opStr);
        }
        var fieldValue;
        var fieldPath = fieldPathFromArgument('Query.where', field);
        var operator = Operator.fromString(opStr);
        if (fieldPath.isKeyField()) {
            if (operator === Operator.ARRAY_CONTAINS ||
                operator === Operator.ARRAY_CONTAINS_ANY ||
                operator === Operator.IN) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + operator.toString() + "' " +
                    'queries on FieldPath.documentId().');
            }
            if (typeof value === 'string') {
                if (value === '') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Function Query.where() requires its third parameter to be a ' +
                        'valid document ID if the first parameter is ' +
                        'FieldPath.documentId(), but it was an empty string.');
                }
                if (!this._query.isCollectionGroupQuery() &&
                    value.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid third parameter to Query.where(). When querying a collection by " +
                        "FieldPath.documentId(), the value provided must be a plain document ID, but " +
                        ("'" + value + "' contains a slash."));
                }
                var path = this._query.path.child(ResourcePath.fromString(value));
                if (!DocumentKey.isDocumentKey(path)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid third parameter to Query.where(). When querying a collection group by " +
                        "FieldPath.documentId(), the value provided must result in a valid document path, " +
                        ("but '" + path + "' is not because it has an odd number of segments (" + path.length + ")."));
                }
                fieldValue = new RefValue(this.firestore._databaseId, new DocumentKey(path));
            }
            else if (value instanceof DocumentReference) {
                var ref = value;
                fieldValue = new RefValue(this.firestore._databaseId, ref._key);
            }
            else {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.where() requires its third parameter to be a " +
                    "string or a DocumentReference if the first parameter is " +
                    "FieldPath.documentId(), but it was: " +
                    (valueDescription(value) + "."));
            }
        }
        else {
            if (operator === Operator.IN ||
                operator === Operator.ARRAY_CONTAINS_ANY) {
                if (!Array.isArray(value) || value.length === 0) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid Query. A non-empty array is required for ' +
                        ("'" + operator.toString() + "' filters."));
                }
                if (value.length > 10) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. '" + operator.toString() + "' filters support a " +
                        'maximum of 10 elements in the value array.');
                }
            }
            fieldValue = this.firestore._dataConverter.parseQueryValue('Query.where', value);
        }
        var filter = FieldFilter.create(fieldPath, operator, fieldValue);
        this.validateNewFilter(filter);
        return new Query(this._query.addFilter(filter), this.firestore);
    };
    Query.prototype.orderBy = function (field, directionStr) {
        validateBetweenNumberOfArgs('Query.orderBy', arguments, 1, 2);
        validateOptionalArgType('Query.orderBy', 'non-empty string', 2, directionStr);
        var direction;
        if (directionStr === undefined || directionStr === 'asc') {
            direction = Direction.ASCENDING;
        }
        else if (directionStr === 'desc') {
            direction = Direction.DESCENDING;
        }
        else {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + directionStr + "', " +
                "expected 'asc' or 'desc'.");
        }
        if (this._query.startAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.startAt() or ' +
                'Query.startAfter() before calling Query.orderBy().');
        }
        if (this._query.endAt !== null) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You must not call Query.endAt() or ' +
                'Query.endBefore() before calling Query.orderBy().');
        }
        var fieldPath = fieldPathFromArgument('Query.orderBy', field);
        var orderBy = new OrderBy(fieldPath, direction);
        this.validateNewOrderBy(orderBy);
        return new Query(this._query.addOrderBy(orderBy), this.firestore);
    };
    Query.prototype.limit = function (n) {
        validateExactNumberOfArgs('Query.limit', arguments, 1);
        validateArgType('Query.limit', 'number', 1, n);
        if (n <= 0) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid Query. Query limit (" + n + ") is invalid. Limit must be " +
                'positive.');
        }
        return new Query(this._query.withLimit(n), this.firestore);
    };
    Query.prototype.startAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAt', docOrField, fields, 
        /*before=*/ true);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.startAfter = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.startAfter', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.startAfter', docOrField, fields, 
        /*before=*/ false);
        return new Query(this._query.withStartAt(bound), this.firestore);
    };
    Query.prototype.endBefore = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endBefore', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endBefore', docOrField, fields, 
        /*before=*/ true);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.endAt = function (docOrField) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        validateAtLeastNumberOfArgs('Query.endAt', arguments, 1);
        var bound = this.boundFromDocOrFields('Query.endAt', docOrField, fields, 
        /*before=*/ false);
        return new Query(this._query.withEndAt(bound), this.firestore);
    };
    Query.prototype.isEqual = function (other) {
        if (!(other instanceof Query)) {
            throw invalidClassError('isEqual', 'Query', 1, other);
        }
        return (this.firestore === other.firestore && this._query.isEqual(other._query));
    };
    /** Helper function to create a bound from a document or fields */
    Query.prototype.boundFromDocOrFields = function (methodName, docOrField, fields, before) {
        validateDefined(methodName, 1, docOrField);
        if (docOrField instanceof DocumentSnapshot) {
            if (fields.length > 0) {
                throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "().");
            }
            var snap = docOrField;
            if (!snap.exists) {
                throw new FirestoreError(Code.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " +
                    (methodName + "()."));
            }
            return this.boundFromDocument(methodName, snap._document, before);
        }
        else {
            var allFields = [docOrField].concat(fields);
            return this.boundFromFields(methodName, allFields, before);
        }
    };
    /**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query or if any of the fields in the order by are an uncommitted
     * server timestamp.
     */
    Query.prototype.boundFromDocument = function (methodName, doc, before) {
        var components = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (var _i = 0, _a = this._query.orderBy; _i < _a.length; _i++) {
            var orderBy = _a[_i];
            if (orderBy.field.isKeyField()) {
                components.push(new RefValue(this.firestore._databaseId, doc.key));
            }
            else {
                var value = doc.field(orderBy.field);
                if (value instanceof ServerTimestampValue) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a ' +
                        'document for which the field "' +
                        orderBy.field +
                        '" is an uncommitted server timestamp. (Since the value of ' +
                        'this field is unknown, you cannot start/end a query with it.)');
                }
                else if (value !== undefined) {
                    components.push(value);
                }
                else {
                    var field = orderBy.field.canonicalString();
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a " +
                        ("document for which the field '" + field + "' (used as the ") +
                        "orderBy) does not exist.");
                }
            }
        }
        return new Bound(components, before);
    };
    /**
     * Converts a list of field values to a Bound for the given query.
     */
    Query.prototype.boundFromFields = function (methodName, values, before) {
        // Use explicit order by's because it has to match the query the user made
        var orderBy = this._query.explicitOrderBy;
        if (values.length > orderBy.length) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Too many arguments provided to " + methodName + "(). " +
                "The number of arguments must be less than or equal to the " +
                "number of Query.orderBy() clauses");
        }
        var components = [];
        for (var i = 0; i < values.length; i++) {
            var rawValue = values[i];
            var orderByComponent = orderBy[i];
            if (orderByComponent.field.isKeyField()) {
                if (typeof rawValue !== 'string') {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " +
                        (methodName + "(), but got a " + typeof rawValue));
                }
                if (!this._query.isCollectionGroupQuery() &&
                    rawValue.indexOf('/') !== -1) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), " +
                        ("the value passed to " + methodName + "() must be a plain document ID, but ") +
                        ("'" + rawValue + "' contains a slash."));
                }
                var path = this._query.path.child(ResourcePath.fromString(rawValue));
                if (!DocumentKey.isDocumentKey(path)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by " +
                        ("FieldPath.documentId(), the value passed to " + methodName + "() must result in a ") +
                        ("valid document path, but '" + path + "' is not because it contains an odd number ") +
                        "of segments.");
                }
                var key = new DocumentKey(path);
                components.push(new RefValue(this.firestore._databaseId, key));
            }
            else {
                var wrapped = this.firestore._dataConverter.parseQueryValue(methodName, rawValue);
                components.push(wrapped);
            }
        }
        return new Bound(components, before);
    };
    Query.prototype.onSnapshot = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        validateBetweenNumberOfArgs('Query.onSnapshot', arguments, 1, 4);
        var options = {};
        var observer;
        var currArg = 0;
        if (typeof args[currArg] === 'object' &&
            !isPartialObserver(args[currArg])) {
            options = args[currArg];
            validateOptionNames('Query.onSnapshot', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('Query.onSnapshot', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
            currArg++;
        }
        if (isPartialObserver(args[currArg])) {
            observer = args[currArg];
        }
        else {
            validateArgType('Query.onSnapshot', 'function', currArg, args[currArg]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 1, args[currArg + 1]);
            validateOptionalArgType('Query.onSnapshot', 'function', currArg + 2, args[currArg + 2]);
            observer = {
                next: args[currArg],
                error: args[currArg + 1],
                complete: args[currArg + 2]
            };
        }
        return this.onSnapshotInternal(options, observer);
    };
    Query.prototype.onSnapshotInternal = function (options, observer) {
        var _this = this;
        var errHandler = function (err) {
            console.error('Uncaught Error in onSnapshot:', err);
        };
        if (observer.error) {
            errHandler = observer.error.bind(observer);
        }
        var asyncObserver = new AsyncObserver({
            next: function (result) {
                if (observer.next) {
                    observer.next(new QuerySnapshot(_this.firestore, _this._query, result));
                }
            },
            error: errHandler
        });
        var firestoreClient = this.firestore.ensureClientConfigured();
        var internalListener = firestoreClient.listen(this._query, asyncObserver, options);
        return function () {
            asyncObserver.mute();
            firestoreClient.unlisten(internalListener);
        };
    };
    Query.prototype.get = function (options) {
        var _this = this;
        validateBetweenNumberOfArgs('Query.get', arguments, 0, 1);
        validateGetOptions('Query.get', options);
        return new Promise(function (resolve, reject) {
            if (options && options.source === 'cache') {
                _this.firestore
                    .ensureClientConfigured()
                    .getDocumentsFromLocalCache(_this._query)
                    .then(function (viewSnap) {
                    resolve(new QuerySnapshot(_this.firestore, _this._query, viewSnap));
                }, reject);
            }
            else {
                _this.getViaSnapshotListener(resolve, reject, options);
            }
        });
    };
    Query.prototype.getViaSnapshotListener = function (resolve, reject, options) {
        var unlisten = this.onSnapshotInternal({
            includeMetadataChanges: true,
            waitForSyncWhenOnline: true
        }, {
            next: function (result) {
                // Remove query first before passing event to user to avoid
                // user actions affecting the now stale query.
                unlisten();
                if (result.metadata.fromCache &&
                    options &&
                    options.source === 'server') {
                    reject(new FirestoreError(Code.UNAVAILABLE, 'Failed to get documents from server. (However, these ' +
                        'documents may exist in the local cache. Run again ' +
                        'without setting source to "server" to ' +
                        'retrieve the cached documents.)'));
                }
                else {
                    resolve(result);
                }
            },
            error: reject
        });
    };
    Query.prototype.validateNewFilter = function (filter) {
        if (filter instanceof FieldFilter) {
            var arrayOps = [Operator.ARRAY_CONTAINS, Operator.ARRAY_CONTAINS_ANY];
            var disjunctiveOps = [Operator.IN, Operator.ARRAY_CONTAINS_ANY];
            var isArrayOp = arrayOps.indexOf(filter.op) >= 0;
            var isDisjunctiveOp = disjunctiveOps.indexOf(filter.op) >= 0;
            if (filter.isInequality()) {
                var existingField = this._query.getInequalityFilterField();
                if (existingField !== null && !existingField.isEqual(filter.field)) {
                    throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. All where filters with an inequality' +
                        ' (<, <=, >, or >=) must be on the same field. But you have' +
                        (" inequality filters on '" + existingField.toString() + "'") +
                        (" and '" + filter.field.toString() + "'"));
                }
                var firstOrderByField = this._query.getFirstOrderByField();
                if (firstOrderByField !== null) {
                    this.validateOrderByAndInequalityMatch(filter.field, firstOrderByField);
                }
            }
            else if (isDisjunctiveOp || isArrayOp) {
                // You can have at most 1 disjunctive filter and 1 array filter. Check if
                // the new filter conflicts with an existing one.
                var conflictingOp = null;
                if (isDisjunctiveOp) {
                    conflictingOp = this._query.findFilterOperator(disjunctiveOps);
                }
                if (conflictingOp === null && isArrayOp) {
                    conflictingOp = this._query.findFilterOperator(arrayOps);
                }
                if (conflictingOp != null) {
                    // We special case when it's a duplicate op to give a slightly clearer error message.
                    if (conflictingOp === filter.op) {
                        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid query. You cannot use more than one ' +
                            ("'" + filter.op.toString() + "' filter."));
                    }
                    else {
                        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You cannot use '" + filter.op.toString() + "' filters " +
                            ("with '" + conflictingOp.toString() + "' filters."));
                    }
                }
            }
        }
    };
    Query.prototype.validateNewOrderBy = function (orderBy) {
        if (this._query.getFirstOrderByField() === null) {
            // This is the first order by. It must match any inequality.
            var inequalityField = this._query.getInequalityFilterField();
            if (inequalityField !== null) {
                this.validateOrderByAndInequalityMatch(inequalityField, orderBy.field);
            }
        }
    };
    Query.prototype.validateOrderByAndInequalityMatch = function (inequality, orderBy) {
        if (!orderBy.isEqual(inequality)) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality " +
                ("(<, <=, >, or >=) on field '" + inequality.toString() + "' ") +
                ("and so you must also use '" + inequality.toString() + "' ") +
                "as your first Query.orderBy(), but your first Query.orderBy() " +
                ("is on field '" + orderBy.toString() + "' instead."));
        }
    };
    return Query;
}());
var QuerySnapshot = /** @class */ (function () {
    function QuerySnapshot(_firestore, _originalQuery, _snapshot) {
        this._firestore = _firestore;
        this._originalQuery = _originalQuery;
        this._snapshot = _snapshot;
        this._cachedChanges = null;
        this._cachedChangesIncludeMetadataChanges = null;
        this.metadata = new SnapshotMetadata(_snapshot.hasPendingWrites, _snapshot.fromCache);
    }
    Object.defineProperty(QuerySnapshot.prototype, "docs", {
        get: function () {
            var result = [];
            this.forEach(function (doc) { return result.push(doc); });
            return result;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "empty", {
        get: function () {
            return this._snapshot.docs.isEmpty();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuerySnapshot.prototype, "size", {
        get: function () {
            return this._snapshot.docs.size;
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        validateBetweenNumberOfArgs('QuerySnapshot.forEach', arguments, 1, 2);
        validateArgType('QuerySnapshot.forEach', 'function', 1, callback);
        this._snapshot.docs.forEach(function (doc) {
            callback.call(thisArg, _this.convertToDocumentImpl(doc));
        });
    };
    Object.defineProperty(QuerySnapshot.prototype, "query", {
        get: function () {
            return new Query$1(this._originalQuery, this._firestore);
        },
        enumerable: true,
        configurable: true
    });
    QuerySnapshot.prototype.docChanges = function (options) {
        if (options) {
            validateOptionNames('QuerySnapshot.docChanges', options, [
                'includeMetadataChanges'
            ]);
            validateNamedOptionalType('QuerySnapshot.docChanges', 'boolean', 'includeMetadataChanges', options.includeMetadataChanges);
        }
        var includeMetadataChanges = !!(options && options.includeMetadataChanges);
        if (includeMetadataChanges && this._snapshot.excludesMetadataChanges) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'To include metadata changes with your document changes, you must ' +
                'also pass { includeMetadataChanges:true } to onSnapshot().');
        }
        if (!this._cachedChanges ||
            this._cachedChangesIncludeMetadataChanges !== includeMetadataChanges) {
            this._cachedChanges = changesFromSnapshot(this._firestore, includeMetadataChanges, this._snapshot);
            this._cachedChangesIncludeMetadataChanges = includeMetadataChanges;
        }
        return this._cachedChanges;
    };
    /** Check the equality. The call can be very expensive. */
    QuerySnapshot.prototype.isEqual = function (other) {
        if (!(other instanceof QuerySnapshot)) {
            throw invalidClassError('isEqual', 'QuerySnapshot', 1, other);
        }
        return (this._firestore === other._firestore &&
            this._originalQuery.isEqual(other._originalQuery) &&
            this._snapshot.isEqual(other._snapshot));
    };
    QuerySnapshot.prototype.convertToDocumentImpl = function (doc) {
        return new QueryDocumentSnapshot(this._firestore, doc.key, doc, this.metadata.fromCache, this._snapshot.mutatedKeys.has(doc.key));
    };
    return QuerySnapshot;
}());
// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
// into a method. Because this is a runtime breaking change and somewhat subtle
// (both Array and Function have a .length, etc.), we'll replace commonly-used
// properties (including Symbol.iterator) to throw a custom error message. In
// ~6 months we can delete the custom error as most folks will have hopefully
// migrated.
function throwDocChangesMethodError() {
    throw new FirestoreError(Code.INVALID_ARGUMENT, 'QuerySnapshot.docChanges has been changed from a property into a ' +
        'method, so usages like "querySnapshot.docChanges" should become ' +
        '"querySnapshot.docChanges()"');
}
var docChangesPropertiesToOverride = [
    'length',
    'forEach',
    'map'
].concat((typeof Symbol !== 'undefined' ? [Symbol.iterator] : []));
docChangesPropertiesToOverride.forEach(function (property) {
    /**
     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
     * is a Function. This could fail, in particular in the case of 'length' which
     * already exists on Function.prototype and on IE11 is improperly defined with
     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
     * still have a functional SDK.
     */
    try {
        Object.defineProperty(QuerySnapshot.prototype.docChanges, property, {
            get: function () { return throwDocChangesMethodError(); }
        });
    }
    catch (err) { } // Ignore this failure intentionally
});
var CollectionReference = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionReference, _super);
    function CollectionReference(path, firestore) {
        var _this = _super.call(this, Query.atPath(path), firestore) || this;
        if (path.length % 2 !== 1) {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Invalid collection reference. Collection ' +
                'references must have an odd number of segments, but ' +
                (path.canonicalString() + " has " + path.length));
        }
        return _this;
    }
    Object.defineProperty(CollectionReference.prototype, "id", {
        get: function () {
            return this._query.path.lastSegment();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "parent", {
        get: function () {
            var parentPath = this._query.path.popLast();
            if (parentPath.isEmpty()) {
                return null;
            }
            else {
                return new DocumentReference(new DocumentKey(parentPath), this.firestore);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CollectionReference.prototype, "path", {
        get: function () {
            return this._query.path.canonicalString();
        },
        enumerable: true,
        configurable: true
    });
    CollectionReference.prototype.doc = function (pathString) {
        validateBetweenNumberOfArgs('CollectionReference.doc', arguments, 0, 1);
        // We allow omission of 'pathString' but explicitly prohibit passing in both
        // 'undefined' and 'null'.
        if (arguments.length === 0) {
            pathString = AutoId.newId();
        }
        validateArgType('CollectionReference.doc', 'non-empty string', 1, pathString);
        if (pathString === '') {
            throw new FirestoreError(Code.INVALID_ARGUMENT, 'Document path must be a non-empty string');
        }
        var path = ResourcePath.fromString(pathString);
        return DocumentReference.forPath(this._query.path.child(path), this.firestore);
    };
    CollectionReference.prototype.add = function (value) {
        validateExactNumberOfArgs('CollectionReference.add', arguments, 1);
        validateArgType('CollectionReference.add', 'object', 1, value);
        var docRef = this.doc();
        return docRef.set(value).then(function () { return docRef; });
    };
    return CollectionReference;
}(Query$1));
function validateSetOptions(methodName, options) {
    if (options === undefined) {
        return {
            merge: false
        };
    }
    validateOptionNames(methodName, options, ['merge', 'mergeFields']);
    validateNamedOptionalType(methodName, 'boolean', 'merge', options.merge);
    validateOptionalArrayElements(methodName, 'mergeFields', 'a string or a FieldPath', options.mergeFields, function (element) {
        return typeof element === 'string' || element instanceof FieldPath$1;
    });
    if (options.mergeFields !== undefined && options.merge !== undefined) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, "Invalid options passed to function " + methodName + "(): You cannot specify both \"merge\" " +
            "and \"mergeFields\".");
    }
    return options;
}
function validateSnapshotOptions(methodName, options) {
    if (options === undefined) {
        return {};
    }
    validateOptionNames(methodName, options, ['serverTimestamps']);
    validateNamedOptionalPropertyEquals(methodName, 'options', 'serverTimestamps', options.serverTimestamps, ['estimate', 'previous', 'none']);
    return options;
}
function validateGetOptions(methodName, options) {
    validateOptionalArgType(methodName, 'object', 1, options);
    if (options) {
        validateOptionNames(methodName, options, ['source']);
        validateNamedOptionalPropertyEquals(methodName, 'options', 'source', options.source, ['default', 'server', 'cache']);
    }
}
function validateReference(methodName, documentRef, firestore) {
    if (!(documentRef instanceof DocumentReference)) {
        throw invalidClassError(methodName, 'DocumentReference', 1, documentRef);
    }
    else if (documentRef.firestore !== firestore) {
        throw new FirestoreError(Code.INVALID_ARGUMENT, 'Provided document reference is from a different Firestore instance.');
    }
    else {
        return documentRef;
    }
}
/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */
function changesFromSnapshot(firestore, includeMetadataChanges, snapshot) {
    if (snapshot.oldDocs.isEmpty()) {
        // Special case the first snapshot because index calculation is easy and
        // fast
        var lastDoc_1;
        var index_1 = 0;
        return snapshot.docChanges.map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            assert(change.type === ChangeType.Added, 'Invalid event type for first snapshot');
            assert(!lastDoc_1 || snapshot.query.docComparator(lastDoc_1, change.doc) < 0, 'Got added events in wrong order');
            lastDoc_1 = change.doc;
            return {
                type: 'added',
                doc: doc,
                oldIndex: -1,
                newIndex: index_1++
            };
        });
    }
    else {
        // A DocumentSet that is updated incrementally as changes are applied to use
        // to lookup the index of a document.
        var indexTracker_1 = snapshot.oldDocs;
        return snapshot.docChanges
            .filter(function (change) { return includeMetadataChanges || change.type !== ChangeType.Metadata; })
            .map(function (change) {
            var doc = new QueryDocumentSnapshot(firestore, change.doc.key, change.doc, snapshot.fromCache, snapshot.mutatedKeys.has(change.doc.key));
            var oldIndex = -1;
            var newIndex = -1;
            if (change.type !== ChangeType.Added) {
                oldIndex = indexTracker_1.indexOf(change.doc.key);
                assert(oldIndex >= 0, 'Index for document not found');
                indexTracker_1 = indexTracker_1.delete(change.doc.key);
            }
            if (change.type !== ChangeType.Removed) {
                indexTracker_1 = indexTracker_1.add(change.doc);
                newIndex = indexTracker_1.indexOf(change.doc.key);
            }
            return { type: resultChangeType(change.type), doc: doc, oldIndex: oldIndex, newIndex: newIndex };
        });
    }
}
function resultChangeType(type) {
    switch (type) {
        case ChangeType.Added:
            return 'added';
        case ChangeType.Modified:
        case ChangeType.Metadata:
            return 'modified';
        case ChangeType.Removed:
            return 'removed';
        default:
            return fail('Unknown change type: ' + type);
    }
}
// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
// tslint:disable:variable-name
var PublicFirestore = makeConstructorPrivate(Firestore, 'Use firebase.firestore() instead.');
var PublicTransaction = makeConstructorPrivate(Transaction$1, 'Use firebase.firestore().runTransaction() instead.');
var PublicWriteBatch = makeConstructorPrivate(WriteBatch, 'Use firebase.firestore().batch() instead.');
var PublicDocumentReference = makeConstructorPrivate(DocumentReference, 'Use firebase.firestore().doc() instead.');
var PublicDocumentSnapshot = makeConstructorPrivate(DocumentSnapshot);
var PublicQueryDocumentSnapshot = makeConstructorPrivate(QueryDocumentSnapshot);
var PublicQuery = makeConstructorPrivate(Query$1);
var PublicQuerySnapshot = makeConstructorPrivate(QuerySnapshot);
var PublicCollectionReference = makeConstructorPrivate(CollectionReference, 'Use firebase.firestore().collection() instead.');
// tslint:enable:variable-name

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firestoreNamespace = {
    Firestore: PublicFirestore,
    GeoPoint: GeoPoint,
    Timestamp: Timestamp,
    Blob: PublicBlob,
    Transaction: PublicTransaction,
    WriteBatch: PublicWriteBatch,
    DocumentReference: PublicDocumentReference,
    DocumentSnapshot: PublicDocumentSnapshot,
    Query: PublicQuery,
    QueryDocumentSnapshot: PublicQueryDocumentSnapshot,
    QuerySnapshot: PublicQuerySnapshot,
    CollectionReference: PublicCollectionReference,
    FieldPath: FieldPath$1,
    FieldValue: PublicFieldValue,
    setLogLevel: Firestore.setLogLevel,
    CACHE_SIZE_UNLIMITED: CACHE_SIZE_UNLIMITED
};
/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */
function configureForFirebase(firebase) {
    firebase.INTERNAL.registerService('firestore', function (app) { return new Firestore(app); }, shallowCopy(firestoreNamespace));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NoopConnectivityMonitor = /** @class */ (function () {
    function NoopConnectivityMonitor() {
    }
    NoopConnectivityMonitor.prototype.addCallback = function (callback) {
        // No-op.
    };
    NoopConnectivityMonitor.prototype.shutdown = function () {
        // No-op.
    };
    return NoopConnectivityMonitor;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$b = 'ConnectivityMonitor';
/**
 * Browser implementation of ConnectivityMonitor.
 */
var BrowserConnectivityMonitor = /** @class */ (function () {
    function BrowserConnectivityMonitor() {
        var _this = this;
        this.networkAvailableListener = function () { return _this.onNetworkAvailable(); };
        this.networkUnavailableListener = function () {
            return _this.onNetworkUnavailable();
        };
        this.callbacks = [];
        this.configureNetworkMonitoring();
    }
    BrowserConnectivityMonitor.prototype.addCallback = function (callback) {
        this.callbacks.push(callback);
    };
    BrowserConnectivityMonitor.prototype.shutdown = function () {
        window.removeEventListener('online', this.networkAvailableListener);
        window.removeEventListener('offline', this.networkUnavailableListener);
    };
    BrowserConnectivityMonitor.prototype.configureNetworkMonitoring = function () {
        window.addEventListener('online', this.networkAvailableListener);
        window.addEventListener('offline', this.networkUnavailableListener);
    };
    BrowserConnectivityMonitor.prototype.onNetworkAvailable = function () {
        debug(LOG_TAG$b, 'Network connectivity changed: AVAILABLE');
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(0 /* AVAILABLE */);
        }
    };
    BrowserConnectivityMonitor.prototype.onNetworkUnavailable = function () {
        debug(LOG_TAG$b, 'Network connectivity changed: UNAVAILABLE');
        for (var _i = 0, _a = this.callbacks; _i < _a.length; _i++) {
            var callback = _a[_i];
            callback(1 /* UNAVAILABLE */);
        }
    };
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */
    BrowserConnectivityMonitor.isAvailable = function () {
        return (typeof window !== 'undefined' &&
            window.addEventListener !== undefined &&
            window.removeEventListener !== undefined);
    };
    return BrowserConnectivityMonitor;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */
var StreamBridge = /** @class */ (function () {
    function StreamBridge(args) {
        this.sendFn = args.sendFn;
        this.closeFn = args.closeFn;
    }
    StreamBridge.prototype.onOpen = function (callback) {
        assert(!this.wrappedOnOpen, 'Called onOpen on stream twice!');
        this.wrappedOnOpen = callback;
    };
    StreamBridge.prototype.onClose = function (callback) {
        assert(!this.wrappedOnClose, 'Called onClose on stream twice!');
        this.wrappedOnClose = callback;
    };
    StreamBridge.prototype.onMessage = function (callback) {
        assert(!this.wrappedOnMessage, 'Called onMessage on stream twice!');
        this.wrappedOnMessage = callback;
    };
    StreamBridge.prototype.close = function () {
        this.closeFn();
    };
    StreamBridge.prototype.send = function (msg) {
        this.sendFn(msg);
    };
    StreamBridge.prototype.callOnOpen = function () {
        assert(this.wrappedOnOpen !== undefined, 'Cannot call onOpen because no callback was set');
        this.wrappedOnOpen();
    };
    StreamBridge.prototype.callOnClose = function (err) {
        assert(this.wrappedOnClose !== undefined, 'Cannot call onClose because no callback was set');
        this.wrappedOnClose(err);
    };
    StreamBridge.prototype.callOnMessage = function (msg) {
        assert(this.wrappedOnMessage !== undefined, 'Cannot call onMessage because no callback was set');
        this.wrappedOnMessage(msg);
    };
    return StreamBridge;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LOG_TAG$c = 'Connection';
var RPC_STREAM_SERVICE = 'google.firestore.v1.Firestore';
var RPC_URL_VERSION = 'v1';
/** Maps RPC names to the corresponding REST endpoint name. */
var RPC_NAME_REST_MAPPING = {
    BatchGetDocuments: 'batchGet',
    Commit: 'commit'
};
// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE = 'gl-js/ fire/' + SDK_VERSION;
var XHR_TIMEOUT_SECS = 15;
var WebChannelConnection = /** @class */ (function () {
    function WebChannelConnection(info) {
        this.databaseId = info.databaseId;
        var proto = info.ssl ? 'https' : 'http';
        this.baseUrl = proto + '://' + info.host;
        this.forceLongPolling = info.forceLongPolling;
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */
    WebChannelConnection.prototype.modifyHeadersForRequest = function (headers, token) {
        if (token) {
            for (var header in token.authHeaders) {
                if (token.authHeaders.hasOwnProperty(header)) {
                    headers[header] = token.authHeaders[header];
                }
            }
        }
        headers['X-Goog-Api-Client'] = X_GOOG_API_CLIENT_VALUE;
    };
    WebChannelConnection.prototype.invokeRPC = function (rpcName, request, token) {
        var _this = this;
        var url = this.makeUrl(rpcName);
        return new Promise(function (resolve, reject) {
            // tslint:disable-next-line:no-any XhrIo doesn't have TS typings.
            var xhr = new webchannelWrapper.XhrIo();
            xhr.listenOnce(webchannelWrapper.EventType.COMPLETE, function () {
                try {
                    switch (xhr.getLastErrorCode()) {
                        case webchannelWrapper.ErrorCode.NO_ERROR:
                            var json = xhr.getResponseJson();
                            debug(LOG_TAG$c, 'XHR received:', JSON.stringify(json));
                            resolve(json);
                            break;
                        case webchannelWrapper.ErrorCode.TIMEOUT:
                            debug(LOG_TAG$c, 'RPC "' + rpcName + '" timed out');
                            reject(new FirestoreError(Code.DEADLINE_EXCEEDED, 'Request time out'));
                            break;
                        case webchannelWrapper.ErrorCode.HTTP_ERROR:
                            var status_1 = xhr.getStatus();
                            debug(LOG_TAG$c, 'RPC "' + rpcName + '" failed with status:', status_1, 'response text:', xhr.getResponseText());
                            if (status_1 > 0) {
                                reject(new FirestoreError(mapCodeFromHttpStatus(status_1), 'Server responded with status ' + xhr.getStatusText()));
                            }
                            else {
                                // If we received an HTTP_ERROR but there's no status code,
                                // it's most probably a connection issue
                                debug(LOG_TAG$c, 'RPC "' + rpcName + '" failed');
                                reject(new FirestoreError(Code.UNAVAILABLE, 'Connection failed.'));
                            }
                            break;
                        default:
                            fail('RPC "' +
                                rpcName +
                                '" failed with unanticipated ' +
                                'webchannel error ' +
                                xhr.getLastErrorCode() +
                                ': ' +
                                xhr.getLastError() +
                                ', giving up.');
                    }
                }
                finally {
                    debug(LOG_TAG$c, 'RPC "' + rpcName + '" completed.');
                }
            });
            var requestString = JSON.stringify(request);
            debug(LOG_TAG$c, 'XHR sending: ', url + ' ' + requestString);
            // Content-Type: text/plain will avoid preflight requests which might
            // mess with CORS and redirects by proxies. If we add custom headers
            // we will need to change this code to potentially use the
            // $httpOverwrite parameter supported by ESF to avoid
            // triggering preflight requests.
            var headers = { 'Content-Type': 'text/plain' };
            _this.modifyHeadersForRequest(headers, token);
            xhr.send(url, 'POST', requestString, headers, XHR_TIMEOUT_SECS);
        });
    };
    WebChannelConnection.prototype.invokeStreamingRPC = function (rpcName, request, token) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.invokeRPC(rpcName, request, token);
    };
    WebChannelConnection.prototype.openStream = function (rpcName, token) {
        var urlParts = [
            this.baseUrl,
            '/',
            RPC_STREAM_SERVICE,
            '/',
            rpcName,
            '/channel'
        ];
        var webchannelTransport = webchannelWrapper.createWebChannelTransport();
        var request = {
            // Background channel test avoids the initial two test calls and decreases
            // initial cold start time.
            // TODO(dimond): wenboz@ mentioned this might affect use with proxies and
            // we should monitor closely for any reports.
            backgroundChannelTest: true,
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: 'gsessionid',
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database
            },
            sendRawJson: true,
            supportsCrossDomainXhr: true,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 10 * 60 * 1000
            },
            forceLongPolling: this.forceLongPolling
        };
        this.modifyHeadersForRequest(request.initMessageHeaders, token);
        // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        //
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
        // the headers should instead be encoded into a special "$httpHeaders" query
        // parameter, which is recognized by the webchannel backend. This is
        // formally defined here:
        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
        //
        // But for some unclear reason (see
        // https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
        // ReactNative and so we exclude it, which just means ReactNative may be
        // subject to the extra network roundtrip for CORS preflight.
        if (!util.isReactNative()) {
            request.httpHeadersOverwriteParam = '$httpHeaders';
        }
        var url = urlParts.join('');
        debug(LOG_TAG$c, 'Creating WebChannel: ' + url + ' ' + request);
        // tslint:disable-next-line:no-any Because listen isn't defined on it.
        var channel = webchannelTransport.createWebChannel(url, request);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        var opened = false;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        var closed = false;
        var streamBridge = new StreamBridge({
            sendFn: function (msg) {
                if (!closed) {
                    if (!opened) {
                        debug(LOG_TAG$c, 'Opening WebChannel transport.');
                        channel.open();
                        opened = true;
                    }
                    debug(LOG_TAG$c, 'WebChannel sending:', msg);
                    channel.send(msg);
                }
                else {
                    debug(LOG_TAG$c, 'Not sending because WebChannel is closed:', msg);
                }
            },
            closeFn: function () { return channel.close(); }
        });
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        var unguardedEventListen = function (type, fn) {
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            channel.listen(type, function (param) {
                try {
                    fn(param);
                }
                catch (e) {
                    setTimeout(function () {
                        throw e;
                    }, 0);
                }
            });
        };
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN, function () {
            if (!closed) {
                debug(LOG_TAG$c, 'WebChannel transport opened.');
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE, function () {
            if (!closed) {
                closed = true;
                debug(LOG_TAG$c, 'WebChannel transport closed');
                streamBridge.callOnClose();
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR, function (err) {
            if (!closed) {
                closed = true;
                debug(LOG_TAG$c, 'WebChannel transport errored:', err);
                streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE, 'The operation could not be completed'));
            }
        });
        unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE, function (msg) {
            if (!closed) {
                var msgData = msg.data[0];
                assert(!!msgData, 'Got a webchannel message without data.');
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // tslint:disable-next-line:no-any msgData.error is not typed.
                var msgDataAsAny = msgData;
                var error = msgDataAsAny.error || (msgDataAsAny[0] && msgDataAsAny[0].error);
                if (error) {
                    debug(LOG_TAG$c, 'WebChannel received error:', error);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    var status_2 = error.status;
                    var code = mapCodeFromRpcStatus(status_2);
                    var message = error.message;
                    if (code === undefined) {
                        code = Code.INTERNAL;
                        message =
                            'Unknown error status: ' +
                                status_2 +
                                ' with message ' +
                                error.message;
                    }
                    // Mark closed so no further events are propagated
                    closed = true;
                    streamBridge.callOnClose(new FirestoreError(code, message));
                    channel.close();
                }
                else {
                    debug(LOG_TAG$c, 'WebChannel received:', msgData);
                    streamBridge.callOnMessage(msgData);
                }
            }
        });
        setTimeout(function () {
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            streamBridge.callOnOpen();
        }, 0);
        return streamBridge;
    };
    // visible for testing
    WebChannelConnection.prototype.makeUrl = function (rpcName) {
        var urlRpcName = RPC_NAME_REST_MAPPING[rpcName];
        assert(urlRpcName !== undefined, 'Unknown REST mapping for: ' + rpcName);
        var url = [this.baseUrl, '/', RPC_URL_VERSION];
        url.push('/projects/');
        url.push(this.databaseId.projectId);
        url.push('/databases/');
        url.push(this.databaseId.database);
        url.push('/documents');
        url.push(':');
        url.push(urlRpcName);
        return url.join('');
    };
    return WebChannelConnection;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BrowserPlatform = /** @class */ (function () {
    function BrowserPlatform() {
        this.emptyByteString = '';
        this.base64Available = typeof atob !== 'undefined';
    }
    Object.defineProperty(BrowserPlatform.prototype, "document", {
        get: function () {
            return typeof document !== 'undefined' ? document : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatform.prototype, "window", {
        get: function () {
            return typeof window !== 'undefined' ? window : null;
        },
        enumerable: true,
        configurable: true
    });
    BrowserPlatform.prototype.loadConnection = function (databaseInfo) {
        return Promise.resolve(new WebChannelConnection(databaseInfo));
    };
    BrowserPlatform.prototype.newConnectivityMonitor = function () {
        if (BrowserConnectivityMonitor.isAvailable()) {
            return new BrowserConnectivityMonitor();
        }
        else {
            return new NoopConnectivityMonitor();
        }
    };
    BrowserPlatform.prototype.newSerializer = function (databaseId) {
        return new JsonProtoSerializer(databaseId, { useProto3Json: true });
    };
    BrowserPlatform.prototype.formatJSON = function (value) {
        return JSON.stringify(value);
    };
    BrowserPlatform.prototype.atob = function (encoded) {
        return atob(encoded);
    };
    BrowserPlatform.prototype.btoa = function (raw) {
        return btoa(raw);
    };
    return BrowserPlatform;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */
PlatformSupport.setPlatform(new BrowserPlatform());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerFirestore(instance) {
    configureForFirebase(instance);
}
registerFirestore(firebase);

exports.registerFirestore = registerFirestore;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return tmp_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return tmp_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebChannel", function() { return tmp_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrIo", function() { return tmp_5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWebChannelTransport", function() { return tmp_1; });
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var g,goog=goog||{},k=commonjsGlobal;function m(a){return "string"==typeof a}function aa(a){return "number"==typeof a}function n(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length;c++)if(b=b[a[c]],null==b)return null;return b}function ba(){}
function p(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return "array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return "object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return "array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return "function"}else return "null";
else if("function"==b&&"undefined"==typeof a.call)return "object";return b}function q(a){return "array"==p(a)}function ca(a){var b=p(a);return "array"==b||"object"==b&&"number"==typeof a.length}function r(a){var b=typeof a;return "object"==b&&null!=a||"function"==b}var t="closure_uid_"+(1E9*Math.random()>>>0),da=0;function ea(a,b,c){return a.call.apply(a.bind,arguments)}
function fa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function u(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?u=ea:u=fa;return u.apply(null,arguments)}
function v(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var w=Date.now||function(){return +new Date};function x(a,b){function c(){}c.prototype=b.prototype;a.N=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.yb=function(d,e,f){for(var h=Array(arguments.length-2),l=2;l<arguments.length;l++)h[l-2]=arguments[l];return b.prototype[e].apply(d,h)};}function y(){this.j=this.j;this.i=this.i;}var ha=0;y.prototype.j=!1;y.prototype.la=function(){if(!this.j&&(this.j=!0,this.G(),0!=ha)){var a=this[t]||(this[t]=++da);}};y.prototype.G=function(){if(this.i)for(;this.i.length;)this.i.shift()();};var ja=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if(m(a))return m(b)&&1==b.length?a.indexOf(b,0):-1;for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return -1},la=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c);}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a);};
function ma(a){a:{var b=na;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1;}return 0>b?null:m(a)?a.charAt(b):a[b]}function oa(a){return Array.prototype.concat.apply([],arguments)}function pa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return []}function qa(a){return /^[\s\xa0]*$/.test(a)}var ra=String.prototype.trim?function(a){return a.trim()}:function(a){return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]};function z(a,b){return -1!=a.indexOf(b)}function sa(a,b){return a<b?-1:a>b?1:0}var A;a:{var ta=k.navigator;if(ta){var ua=ta.userAgent;if(ua){A=ua;break a}}A="";}function va(a,b,c){for(var d in a)b.call(c,a[d],d,a);}function wa(a){var b={},c;for(c in a)b[c]=a[c];return b}var xa="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ya(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<xa.length;f++)c=xa[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c]);}}function za(a){za[" "](a);return a}za[" "]=ba;function Aa(a,b){var c=Ba;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)}var Ca=z(A,"Opera"),B=z(A,"Trident")||z(A,"MSIE"),Da=z(A,"Edge"),Ea=Da||B,Fa=z(A,"Gecko")&&!(z(A.toLowerCase(),"webkit")&&!z(A,"Edge"))&&!(z(A,"Trident")||z(A,"MSIE"))&&!z(A,"Edge"),Ga=z(A.toLowerCase(),"webkit")&&!z(A,"Edge");function Ha(){var a=k.document;return a?a.documentMode:void 0}var Ia;
a:{var Ja="",Ka=function(){var a=A;if(Fa)return /rv:([^\);]+)(\)|;)/.exec(a);if(Da)return /Edge\/([\d\.]+)/.exec(a);if(B)return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Ga)return /WebKit\/(\S+)/.exec(a);if(Ca)return /(?:Version)[ \/]?(\S+)/.exec(a)}();Ka&&(Ja=Ka?Ka[1]:"");if(B){var La=Ha();if(null!=La&&La>parseFloat(Ja)){Ia=String(La);break a}}Ia=Ja;}var Ba={};
function Ma(a){return Aa(a,function(){for(var b=0,c=ra(String(Ia)).split("."),d=ra(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var h=c[f]||"",l=d[f]||"";do{h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==h[0].length&&0==l[0].length)break;b=sa(0==h[1].length?0:parseInt(h[1],10),0==l[1].length?0:parseInt(l[1],10))||sa(0==h[2].length,0==l[2].length)||sa(h[2],l[2]);h=h[3];l=l[3];}while(0==b)}return 0<=b})}var Na;var Oa=k.document;
Na=Oa&&B?Ha()||("CSS1Compat"==Oa.compatMode?parseInt(Ia,10):5):void 0;var Pa=!B||9<=Number(Na),Qa=B&&!Ma("9"),Ra=function(){if(!k.addEventListener||!Object.defineProperty)return !1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0;}});try{k.addEventListener("test",ba,b),k.removeEventListener("test",ba,b);}catch(c){}return a}();function C(a,b){this.type=a;this.a=this.target=b;this.Ja=!0;}C.prototype.b=function(){this.Ja=!1;};function D(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.a=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.c=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.a=b;if(b=a.relatedTarget){if(Fa){a:{try{za(b.nodeName);var e=!0;break a}catch(f){}e=!1;}e||(b=null);}}else"mouseover"==
c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:Sa[a.pointerType]||"";this.c=a;a.defaultPrevented&&this.b();}}x(D,C);var Sa={2:"touch",3:"pen",4:"mouse"};D.prototype.b=function(){D.N.b.call(this);var a=this.c;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Qa)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1;}catch(b){}};var E="closure_listenable_"+(1E6*Math.random()|0),Ta=0;function Ua(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.da=e;this.key=++Ta;this.X=this.Z=!1;}function Va(a){a.X=!0;a.listener=null;a.proxy=null;a.src=null;a.da=null;}function Wa(a){this.src=a;this.a={};this.b=0;}Wa.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var h=Xa(a,b,d,e);-1<h?(b=a[h],c||(b.Z=!1)):(b=new Ua(b,this.src,f,!!d,e),b.Z=c,a.push(b));return b};function Ya(a,b){var c=b.type;if(c in a.a){var d=a.a[c],e=ja(d,b),f;(f=0<=e)&&Array.prototype.splice.call(d,e,1);f&&(Va(b),0==a.a[c].length&&(delete a.a[c],a.b--));}}
function Xa(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.X&&f.listener==b&&f.capture==!!c&&f.da==d)return e}return -1}var Za="closure_lm_"+(1E6*Math.random()|0),$a={};function bb(a,b,c,d,e){if(d&&d.once)return cb(a,b,c,d,e);if(q(b)){for(var f=0;f<b.length;f++)bb(a,b[f],c,d,e);return null}c=db(c);return a&&a[E]?a.Aa(b,c,r(d)?!!d.capture:!!d,e):eb(a,b,c,!1,d,e)}
function eb(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var h=r(e)?!!e.capture:!!e;if(h&&!Pa)return null;var l=fb(a);l||(a[Za]=l=new Wa(a));c=l.add(b,c,d,h,f);if(c.proxy)return c;d=gb();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Ra||(e=h),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(hb(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c}function gb(){var a=ib,b=Pa?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function cb(a,b,c,d,e){if(q(b)){for(var f=0;f<b.length;f++)cb(a,b[f],c,d,e);return null}c=db(c);return a&&a[E]?a.Ba(b,c,r(d)?!!d.capture:!!d,e):eb(a,b,c,!0,d,e)}
function jb(a,b,c,d,e){if(q(b))for(var f=0;f<b.length;f++)jb(a,b[f],c,d,e);else(d=r(d)?!!d.capture:!!d,c=db(c),a&&a[E])?(a=a.c,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Xa(f,c,d,e),-1<c&&(Va(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=fb(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Xa(b,c,d,e)),(c=-1<a?b[a]:null)&&kb(c));}
function kb(a){if(!aa(a)&&a&&!a.X){var b=a.src;if(b&&b[E])Ya(b.c,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(hb(c),d):b.addListener&&b.removeListener&&b.removeListener(d);(c=fb(b))?(Ya(c,a),0==c.b&&(c.src=null,b[Za]=null)):Va(a);}}}function hb(a){return a in $a?$a[a]:$a[a]="on"+a}function lb(a,b){var c=a.listener,d=a.da||a.src;a.Z&&kb(a);return c.call(d,b)}
function ib(a,b){return a.X?!0:Pa?lb(a,new D(b,this)):(b=new D(b||n("window.event"),this),lb(a,b))}function fb(a){a=a[Za];return a instanceof Wa?a:null}var mb="__closure_events_fn_"+(1E9*Math.random()>>>0);function db(a){if("function"==p(a))return a;a[mb]||(a[mb]=function(b){return a.handleEvent(b)});return a[mb]}function G(){y.call(this);this.c=new Wa(this);this.J=this;this.B=null;}x(G,y);G.prototype[E]=!0;g=G.prototype;g.addEventListener=function(a,b,c,d){bb(this,a,b,c,d);};g.removeEventListener=function(a,b,c,d){jb(this,a,b,c,d);};
g.dispatchEvent=function(a){var b,c=this.B;if(c)for(b=[];c;c=c.B)b.push(c);c=this.J;var d=a.type||a;if(m(a))a=new C(a,c);else if(a instanceof C)a.target=a.target||c;else{var e=a;a=new C(d,c);ya(a,e);}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var h=a.a=b[f];e=nb(h,d,!0,a)&&e;}h=a.a=c;e=nb(h,d,!0,a)&&e;e=nb(h,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)h=a.a=b[f],e=nb(h,d,!1,a)&&e;return e};
g.G=function(){G.N.G.call(this);if(this.c){var a=this.c,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)Va(d[e]);delete a.a[c];a.b--;}}this.B=null;};g.Aa=function(a,b,c,d){return this.c.add(String(a),b,!1,c,d)};g.Ba=function(a,b,c,d){return this.c.add(String(a),b,!0,c,d)};
function nb(a,b,c,d){b=a.c.a[String(b)];if(!b)return !0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var h=b[f];if(h&&!h.X&&h.capture==c){var l=h.listener,F=h.da||h.src;h.Z&&Ya(a.c,h);e=!1!==l.call(F,d)&&e;}}return e&&0!=d.Ja}var ob=k.JSON.stringify;function pb(a,b){this.c=a;this.f=b;this.b=0;this.a=null;}pb.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null;}else a=this.c();return a};function qb(){this.b=this.a=null;}var sb=new pb(function(){return new rb},function(a){a.reset();});qb.prototype.add=function(a,b){var c=sb.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c;};function tb(){var a=ub,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function rb(){this.next=this.b=this.a=null;}rb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null;};rb.prototype.reset=function(){this.next=this.b=this.a=null;};function vb(a){k.setTimeout(function(){throw a;},0);}function wb(a,b){xb||yb();zb||(xb(),zb=!0);ub.add(a,b);}var xb;function yb(){var a=k.Promise.resolve(void 0);xb=function(){a.then(Ab);};}var zb=!1,ub=new qb;function Ab(){for(var a;a=tb();){try{a.a.call(a.b);}catch(c){vb(c);}var b=sb;b.f(a);100>b.b&&(b.b++,a.next=b.a,b.a=a);}zb=!1;}function Cb(a,b){G.call(this);this.b=a||1;this.a=b||k;this.f=u(this.gb,this);this.g=w();}x(Cb,G);g=Cb.prototype;g.ba=!1;g.L=null;g.gb=function(){if(this.ba){var a=w()-this.g;0<a&&a<.8*this.b?this.L=this.a.setTimeout(this.f,this.b-a):(this.L&&(this.a.clearTimeout(this.L),this.L=null),this.dispatchEvent("tick"),this.ba&&(Db(this),this.start()));}};g.start=function(){this.ba=!0;this.L||(this.L=this.a.setTimeout(this.f,this.b),this.g=w());};function Db(a){a.ba=!1;a.L&&(a.a.clearTimeout(a.L),a.L=null);}
g.G=function(){Cb.N.G.call(this);Db(this);delete this.a;};function Eb(a,b,c){if("function"==p(a))c&&(a=u(a,c));else if(a&&"function"==typeof a.handleEvent)a=u(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function Fb(a,b,c){y.call(this);this.f=null!=c?u(a,c):a;this.c=b;this.b=u(this.ab,this);this.a=[];}x(Fb,y);g=Fb.prototype;g.ea=!1;g.U=null;g.Ua=function(a){this.a=arguments;this.U?this.ea=!0:Gb(this);};g.G=function(){Fb.N.G.call(this);this.U&&(k.clearTimeout(this.U),this.U=null,this.ea=!1,this.a=[]);};g.ab=function(){this.U=null;this.ea&&(this.ea=!1,Gb(this));};function Gb(a){a.U=Eb(a.b,a.c);a.f.apply(null,a.a);}function H(a){y.call(this);this.b=a;this.a={};}x(H,y);var Hb=[];function Ib(a,b,c,d){q(c)||(c&&(Hb[0]=c.toString()),c=Hb);for(var e=0;e<c.length;e++){var f=bb(b,c[e],d||a.handleEvent,!1,a.b||a);if(!f)break;a.a[f.key]=f;}}function Jb(a){va(a.a,function(b,c){this.a.hasOwnProperty(c)&&kb(b);},a);a.a={};}H.prototype.G=function(){H.N.G.call(this);Jb(this);};H.prototype.handleEvent=function(){throw Error("EventHandler.handleEvent not implemented");};function Kb(){}var I=new G;function Lb(a){C.call(this,"serverreachability",a);}x(Lb,C);function J(a){I.dispatchEvent(new Lb(I,a));}function Mb(a){C.call(this,"statevent",a);}x(Mb,C);function K(a){I.dispatchEvent(new Mb(I,a));}function Nb(a){C.call(this,"timingevent",a);}x(Nb,C);function Ob(a,b){if("function"!=p(a))throw Error("Fn must not be null and must be a function");return k.setTimeout(function(){a();},b)}var Pb={NO_ERROR:0,hb:1,ob:2,nb:3,kb:4,mb:5,pb:6,Ma:7,TIMEOUT:8,sb:9};var Qb={jb:"complete",wb:"success",Na:"error",Ma:"abort",ub:"ready",vb:"readystatechange",TIMEOUT:"timeout",qb:"incrementaldata",tb:"progress",lb:"downloadprogress",xb:"uploadprogress"};function Rb(){}Rb.prototype.a=null;function Sb(a){var b;(b=a.a)||(b=a.a={});return b}function Tb(){}var L={OPEN:"a",ib:"b",Na:"c",rb:"d"};function Ub(){C.call(this,"d");}x(Ub,C);function Vb(){C.call(this,"c");}x(Vb,C);var Wb;function Xb(){}x(Xb,Rb);Wb=new Xb;function M(a,b,c){this.g=a;this.W=b;this.V=c||1;this.I=new H(this);this.O=Yb;a=Ea?125:void 0;this.P=new Cb(a);this.h=null;this.b=!1;this.l=this.D=this.f=this.F=this.v=this.R=this.i=null;this.j=[];this.a=null;this.A=0;this.c=this.w=null;this.o=-1;this.m=!1;this.J=0;this.B=null;this.s=this.S=this.H=!1;}var Yb=45E3,Zb={},$b={};g=M.prototype;g.setTimeout=function(a){this.O=a;};function ac(a,b,c){a.F=1;a.f=bc(N(b));a.l=c;a.H=!0;cc(a,null);}function dc(a,b,c,d){a.F=1;a.f=bc(N(b));a.l=null;a.H=c;cc(a,d);}
function cc(a,b){a.v=w();ec(a);a.D=N(a.f);fc(a.D,"t",a.V);a.A=0;a.a=a.g.$(a.g.Y()?b:null);0<a.J&&(a.B=new Fb(u(a.Ka,a,a.a),a.J));Ib(a.I,a.a,"readystatechange",a.eb);b=a.h?wa(a.h):{};a.l?(a.w||(a.w="POST"),b["Content-Type"]="application/x-www-form-urlencoded",a.a.ca(a.D,a.w,a.l,b)):(a.w="GET",a.a.ca(a.D,a.w,null,b));J(1);}g.eb=function(a){a=a.target;var b=this.B;b&&3==O(a)?b.Ua():this.Ka(a);};
g.Ka=function(a){try{if(a==this.a)a:{var b=O(this.a),c=this.a.ya(),d=this.a.T();if(!(3>b||3==b&&!Ea&&!this.a.aa())){this.m||4!=b||7==c||(8==c||0>=d?J(3):J(2));gc(this);var e=this.a.T();this.o=e;var f=this.a.aa();if(this.b=200==e){if(this.S&&!this.s){b:{if(this.a){var h=hc(this.a,"X-HTTP-Initial-Response");if(h&&!qa(h)){var l=h;break b}}l=null;}if(l)this.s=!0,ic(this,l);else{this.b=!1;this.c=3;K(12);P(this);jc(this);break a}}this.H?(kc(this,b,f),Ea&&this.b&&3==b&&(Ib(this.I,this.P,"tick",this.cb),this.P.start())):
ic(this,f);4==b&&P(this);this.b&&!this.m&&(4==b?this.g.na(this):(this.b=!1,ec(this)));}else 400==e&&0<f.indexOf("Unknown SID")?(this.c=3,K(12)):(this.c=0,K(13)),P(this),jc(this);}}}catch(F){}finally{}};function kc(a,b,c){for(var d=!0;!a.m&&a.A<c.length;){var e=lc(a,c);if(e==$b){4==b&&(a.c=4,K(14),d=!1);break}else if(e==Zb){a.c=4;K(15);d=!1;break}else ic(a,e);}4==b&&0==c.length&&(a.c=1,K(16),d=!1);a.b=a.b&&d;d||(P(a),jc(a));}
g.cb=function(){if(this.a){var a=O(this.a),b=this.a.aa();this.A<b.length&&(gc(this),kc(this,a,b),this.b&&4!=a&&ec(this));}};function lc(a,b){var c=a.A,d=b.indexOf("\n",c);if(-1==d)return $b;c=Number(b.substring(c,d));if(isNaN(c))return Zb;d+=1;if(d+c>b.length)return $b;b=b.substr(d,c);a.A=d+c;return b}g.cancel=function(){this.m=!0;P(this);};function ec(a){a.R=w()+a.O;mc(a,a.O);}function mc(a,b){if(null!=a.i)throw Error("WatchDog timer not null");a.i=Ob(u(a.bb,a),b);}
function gc(a){a.i&&(k.clearTimeout(a.i),a.i=null);}g.bb=function(){this.i=null;var a=w();0<=a-this.R?(2!=this.F&&(J(3),K(17)),P(this),this.c=2,jc(this)):mc(this,this.R-a);};function jc(a){a.g.Da()||a.m||a.g.na(a);}function P(a){gc(a);var b=a.B;b&&"function"==typeof b.la&&b.la();a.B=null;Db(a.P);Jb(a.I);a.a&&(b=a.a,a.a=null,b.abort(),b.la());}function ic(a,b){try{a.g.Ga(a,b),J(4);}catch(c){}}function nc(a){if(a.C&&"function"==typeof a.C)return a.C();if(m(a))return a.split("");if(ca(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}
function oc(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ca(a)||m(a))la(a,b,void 0);else{if(a.K&&"function"==typeof a.K)var c=a.K();else if(a.C&&"function"==typeof a.C)c=void 0;else if(ca(a)||m(a)){c=[];for(var d=a.length,e=0;e<d;e++)c.push(e);}else for(e in c=[],d=0,a)c[d++]=e;d=nc(a);e=d.length;for(var f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a);}}function Q(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1]);}else if(a)if(a instanceof Q)for(c=a.K(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d]);}g=Q.prototype;g.C=function(){pc(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};g.K=function(){pc(this);return this.a.concat()};
function qc(a){a.b={};a.a.length=0;a.c=0;}function rc(a,b){R(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&pc(a));}function pc(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];R(a.b,d)&&(a.a[c++]=d);b++;}a.a.length=c;}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],R(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c;}}g.get=function(a,b){return R(this.b,a)?this.b[a]:b};g.set=function(a,b){R(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b;};
g.forEach=function(a,b){for(var c=this.K(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this);}};function R(a,b){return Object.prototype.hasOwnProperty.call(a,b)}var sc=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function tc(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1);}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"");}}}function S(a,b){this.b=this.j=this.f="";this.i=null;this.g=this.a="";this.h=!1;var c;a instanceof S?(this.h=void 0!==b?b:a.h,uc(this,a.f),this.j=a.j,vc(this,a.b),wc(this,a.i),this.a=a.a,xc(this,yc(a.c)),this.g=a.g):a&&(c=String(a).match(sc))?(this.h=!!b,uc(this,c[1]||"",!0),this.j=zc(c[2]||""),vc(this,c[3]||"",!0),wc(this,c[4]),this.a=zc(c[5]||"",!0),xc(this,c[6]||"",!0),this.g=zc(c[7]||"")):(this.h=!!b,this.c=new Ac(null,this.h));}
S.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Bc(b,Cc,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.j)&&a.push(Bc(b,Cc,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.a)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Bc(c,"/"==c.charAt(0)?Dc:Ec,!0));(c=this.c.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Bc(c,Fc));return a.join("")};
S.prototype.resolve=function(a){var b=N(this),c=!!a.f;c?uc(b,a.f):c=!!a.j;c?b.j=a.j:c=!!a.b;c?vc(b,a.b):c=null!=a.i;var d=a.a;if(c)wc(b,a.i);else if(c=!!a.a){if("/"!=d.charAt(0))if(this.b&&!this.a)d="/"+d;else{var e=b.a.lastIndexOf("/");-1!=e&&(d=b.a.substr(0,e+1)+d);}e=d;if(".."==e||"."==e)d="";else if(z(e,"./")||z(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],h=0;h<e.length;){var l=e[h++];"."==l?d&&h==e.length&&f.push(""):".."==l?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),d&&
h==e.length&&f.push("")):(f.push(l),d=!0);}d=f.join("/");}else d=e;}c?b.a=d:c=""!==a.c.toString();c?xc(b,yc(a.c)):c=!!a.g;c&&(b.g=a.g);return b};function N(a){return new S(a)}function uc(a,b,c){a.f=c?zc(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""));}function vc(a,b,c){a.b=c?zc(b,!0):b;}function wc(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b;}else a.i=null;}function xc(a,b,c){b instanceof Ac?(a.c=b,Gc(a.c,a.h)):(c||(b=Bc(b,Hc)),a.c=new Ac(b,a.h));}
function T(a,b,c){a.c.set(b,c);}function fc(a,b,c){q(c)||(c=[String(c)]);Ic(a.c,b,c);}function bc(a){T(a,"zx",Math.floor(2147483648*Math.random()).toString(36)+Math.abs(Math.floor(2147483648*Math.random())^w()).toString(36));return a}function Jc(a){return a instanceof S?N(a):new S(a,void 0)}function Kc(a,b,c,d){var e=new S(null,void 0);a&&uc(e,a);b&&vc(e,b);c&&wc(e,c);d&&(e.a=d);return e}function zc(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}
function Bc(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Lc),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Lc(a){a=a.charCodeAt(0);return "%"+(a>>4&15).toString(16)+(a&15).toString(16)}var Cc=/[#\/\?@]/g,Ec=/[#\?:]/g,Dc=/[#\?]/g,Hc=/[#\?@]/g,Fc=/#/g;function Ac(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b;}function U(a){a.a||(a.a=new Q,a.b=0,a.c&&tc(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c);}));}g=Ac.prototype;
g.add=function(a,b){U(this);this.c=null;a=V(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function Mc(a,b){U(a);b=V(a,b);R(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,rc(a.a,b));}function Nc(a,b){U(a);b=V(a,b);return R(a.a.b,b)}g.forEach=function(a,b){U(this);this.a.forEach(function(c,d){la(c,function(e){a.call(b,e,d,this);},this);},this);};
g.K=function(){U(this);for(var a=this.a.C(),b=this.a.K(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};g.C=function(a){U(this);var b=[];if(m(a))Nc(this,a)&&(b=oa(b,this.a.get(V(this,a))));else{a=this.a.C();for(var c=0;c<a.length;c++)b=oa(b,a[c]);}return b};g.set=function(a,b){U(this);this.c=null;a=V(this,a);Nc(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
g.get=function(a,b){if(!a)return b;a=this.C(a);return 0<a.length?String(a[0]):b};function Ic(a,b,c){Mc(a,b);0<c.length&&(a.c=null,a.a.set(V(a,b),pa(c)),a.b+=c.length);}g.toString=function(){if(this.c)return this.c;if(!this.a)return "";for(var a=[],b=this.a.K(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.C(d);for(var f=0;f<d.length;f++){var h=e;""!==d[f]&&(h+="="+encodeURIComponent(String(d[f])));a.push(h);}}return this.c=a.join("&")};
function yc(a){var b=new Ac;b.c=a.c;a.a&&(b.a=new Q(a.a),b.b=a.b);return b}function V(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Gc(a,b){b&&!a.f&&(U(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(Mc(this,d),Ic(this,e,c));},a));a.f=b;}function Qc(){}function Rc(){}x(Rc,Qc);function Sc(a){this.a=a;this.b=this.h=null;this.g=!1;this.i=null;this.c=-1;this.l=this.f=null;}g=Sc.prototype;g.M=null;function Uc(a){var b=a.a.F.a;if(null!=b)K(4),b?(K(10),Vc(a.a,a,!1)):(K(11),Vc(a.a,a,!0));else{a.b=new M(a,void 0,void 0);a.b.h=a.h;b=a.a;b=Wc(b,b.Y()?a.f:null,a.i);K(4);fc(b,"TYPE","xmlhttp");var c=a.a.j,d=a.a.I;c&&d&&T(b,c,d);dc(a.b,b,!1,a.f);}}g.$=function(a){return this.a.$(a)};g.abort=function(){this.b&&(this.b.cancel(),this.b=null);this.c=-1;};g.Da=function(){return !1};
g.Ga=function(a,b){this.c=a.o;if(0==this.M){if(!this.a.o&&(a=a.a)){var c=hc(a,"X-Client-Wire-Protocol");this.l=c?c:null;this.a.j&&(a=hc(a,"X-HTTP-Session-Id"))&&(this.a.I=a);}if(b){try{var d=this.a.ja.a.parse(b);}catch(e){b=this.a;b.m=this.c;W(b,2);return}this.f=d[0];}else b=this.a,b.m=this.c,W(b,2);}else if(1==this.M)if(this.g)K(6);else if("11111"==b){if(K(5),this.g=!0,!B||10<=Number(Na))this.c=200,this.b.cancel(),K(11),Vc(this.a,this,!0);}else K(7),this.g=!1;};
g.na=function(){this.c=this.b.o;if(this.b.b)0==this.M?(this.M=1,Uc(this)):1==this.M&&(this.g?(K(11),Vc(this.a,this,!0)):(K(10),Vc(this.a,this,!1)));else{0==this.M?K(8):1==this.M&&K(9);var a=this.a;a.m=this.c;W(a,2);}};g.Y=function(){return this.a.Y()};g.ma=function(){return this.a.ma()};function Xc(){this.a=this.b=null;}function Yc(){this.a=new Q;}function Zc(a){var b=typeof a;return "object"==b&&a||"function"==b?"o"+(a[t]||(a[t]=++da)):b.charAt(0)+a}Yc.prototype.add=function(a){this.a.set(Zc(a),a);};Yc.prototype.C=function(){return this.a.C()};function $c(a,b){this.b=a;this.a=b;}function ad(a){this.g=a||bd;k.PerformanceNavigationTiming?(a=k.performance.getEntriesByType("navigation"),a=0<a.length&&("hq"==a[0].nextHopProtocol||"h2"==a[0].nextHopProtocol)):a=!!(k.ka&&k.ka.Ea&&k.ka.Ea()&&k.ka.Ea().zb);this.f=a?this.g:1;this.a=null;1<this.f&&(this.a=new Yc);this.b=null;this.c=[];}var bd=10;function cd(a,b){!a.a&&(z(b,"spdy")||z(b,"quic")||z(b,"h2"))&&(a.f=a.g,a.a=new Yc,a.b&&(dd(a,a.b),a.b=null));}function ed(a){return a.b?!0:a.a?a.a.a.c>=a.f:!1}
function fd(a){return a.b?1:a.a?a.a.a.c:0}function gd(a,b){a.b?a=a.b==b:a.a?(b=Zc(b),a=R(a.a.a.b,b)):a=!1;return a}function dd(a,b){a.a?a.a.add(b):a.b=b;}function hd(a,b){if(a.b&&a.b==b)a.b=null;else{var c;if(c=a.a)c=Zc(b),c=R(a.a.a.b,c);c&&rc(a.a.a,Zc(b));}}ad.prototype.cancel=function(){this.c=id(this);this.b?(this.b.cancel(),this.b=null):this.a&&0!=this.a.a.c&&(la(this.a.C(),function(a){a.cancel();}),qc(this.a.a));};
function id(a){if(null!=a.b)return a.c.concat(a.b.j);if(null!=a.a&&0!=a.a.a.c){var b=a.c;la(a.a.C(),function(c){b=b.concat(c.j);});return b}return pa(a.c)}function jd(){}jd.prototype.stringify=function(a){return k.JSON.stringify(a,void 0)};jd.prototype.parse=function(a){return k.JSON.parse(a,void 0)};function kd(){this.a=new jd;}function ld(a,b,c){var d=c||"";try{oc(a,function(e,f){var h=e;r(e)&&(h=ob(e));b.push(d+f+"="+encodeURIComponent(h));});}catch(e){throw b.push(d+"type="+encodeURIComponent("_badmap")),e;}}function md(a,b){var c=new Kb;if(k.Image){var d=new Image;d.onload=v(nd,c,d,"TestLoadImage: loaded",!0,b);d.onerror=v(nd,c,d,"TestLoadImage: error",!1,b);d.onabort=v(nd,c,d,"TestLoadImage: abort",!1,b);d.ontimeout=v(nd,c,d,"TestLoadImage: timeout",!1,b);k.setTimeout(function(){if(d.ontimeout)d.ontimeout();},1E4);d.src=a;}else b(!1);}function nd(a,b,c,d,e){try{b.onload=null,b.onerror=null,b.onabort=null,b.ontimeout=null,e(d);}catch(f){}}var od=k.JSON.parse;function X(a){G.call(this);this.headers=new Q;this.H=a||null;this.b=!1;this.s=this.a=null;this.A="";this.h=0;this.f="";this.g=this.w=this.l=this.v=!1;this.o=0;this.m=null;this.I=pd;this.D=this.F=!1;}x(X,G);var pd="",qd=/^https?$/i,rd=["POST","PUT"];g=X.prototype;
g.ca=function(a,b,c,d){if(this.a)throw Error("[goog.net.XhrIo] Object is active with another request="+this.A+"; newUri="+a);b=b?b.toUpperCase():"GET";this.A=a;this.f="";this.h=0;this.v=!1;this.b=!0;this.a=new XMLHttpRequest;this.s=this.H?Sb(this.H):Sb(Wb);this.a.onreadystatechange=u(this.Fa,this);try{this.w=!0,this.a.open(b,String(a),!0),this.w=!1;}catch(f){sd(this,f);return}a=c||"";var e=new Q(this.headers);d&&oc(d,function(f,h){e.set(h,f);});d=ma(e.K());c=k.FormData&&a instanceof k.FormData;!(0<=
ja(rd,b))||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(f,h){this.a.setRequestHeader(h,f);},this);this.I&&(this.a.responseType=this.I);"withCredentials"in this.a&&this.a.withCredentials!==this.F&&(this.a.withCredentials=this.F);try{td(this),0<this.o&&((this.D=ud(this.a))?(this.a.timeout=this.o,this.a.ontimeout=u(this.Ca,this)):this.m=Eb(this.Ca,this.o,this)),this.l=!0,this.a.send(a),this.l=!1;}catch(f){sd(this,f);}};
function ud(a){return B&&Ma(9)&&aa(a.timeout)&&void 0!==a.ontimeout}function na(a){return "content-type"==a.toLowerCase()}g.Ca=function(){"undefined"!=typeof goog&&this.a&&(this.f="Timed out after "+this.o+"ms, aborting",this.h=8,this.dispatchEvent("timeout"),this.abort(8));};function sd(a,b){a.b=!1;a.a&&(a.g=!0,a.a.abort(),a.g=!1);a.f=b;a.h=5;vd(a);wd(a);}function vd(a){a.v||(a.v=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"));}
g.abort=function(a){this.a&&this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1,this.h=a||7,this.dispatchEvent("complete"),this.dispatchEvent("abort"),wd(this));};g.G=function(){this.a&&(this.b&&(this.b=!1,this.g=!0,this.a.abort(),this.g=!1),wd(this,!0));X.N.G.call(this);};g.Fa=function(){this.j||(this.w||this.l||this.g?xd(this):this.$a());};g.$a=function(){xd(this);};
function xd(a){if(a.b&&"undefined"!=typeof goog&&(!a.s[1]||4!=O(a)||2!=a.T()))if(a.l&&4==O(a))Eb(a.Fa,0,a);else if(a.dispatchEvent("readystatechange"),4==O(a)){a.b=!1;try{var b=a.T();a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1;}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.A).match(sc)[1]||null;if(!f&&k.self&&k.self.location){var h=k.self.location.protocol;f=h.substr(0,h.length-1);}e=!qd.test(f?f.toLowerCase():"");}d=e;}d?(a.dispatchEvent("complete"),
a.dispatchEvent("success")):(a.h=6,a.f=a.za()+" ["+a.T()+"]",vd(a));}finally{wd(a);}}}function wd(a,b){if(a.a){td(a);var c=a.a,d=a.s[0]?ba:null;a.a=null;a.s=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d;}catch(e){}}}function td(a){a.a&&a.D&&(a.a.ontimeout=null);a.m&&(k.clearTimeout(a.m),a.m=null);}function O(a){return a.a?a.a.readyState:0}g.T=function(){try{return 2<O(this)?this.a.status:-1}catch(a){return -1}};g.za=function(){try{return 2<O(this)?this.a.statusText:""}catch(a){return ""}};
g.aa=function(){try{return this.a?this.a.responseText:""}catch(a){return ""}};g.Va=function(a){if(this.a){var b=this.a.responseText;a&&0==b.indexOf(a)&&(b=b.substring(a.length));return od(b)}};function hc(a,b){return a.a?a.a.getResponseHeader(b):null}g.ya=function(){return this.h};g.Ya=function(){return m(this.f)?this.f:String(this.f)};function yd(a){var b="";va(a,function(c,d){b+=d;b+=":";b+=c;b+="\r\n";});return b}function zd(a,b,c){a:{for(d in c){var d=!1;break a}d=!0;}if(d)return a;c=yd(c);if(m(a)){b=encodeURIComponent(String(b));c=null!=c?"="+encodeURIComponent(String(c)):"";if(b+=c){c=a.indexOf("#");0>c&&(c=a.length);d=a.indexOf("?");if(0>d||d>c){d=c;var e="";}else e=a.substring(d+1,c);a=[a.substr(0,d),e,a.substr(c)];c=a[1];a[1]=b?c?c+"&"+b:b:c;a=a[0]+(a[1]?"?"+a[1]:"")+a[2];}return a}T(a,b,c);return a}function Ad(a){this.f=[];this.F=new Xc;this.ga=this.pa=this.B=this.ha=this.a=this.I=this.j=this.V=this.g=this.J=this.i=null;this.Ra=this.P=0;this.Pa=!!n("internalChannelParams.failFast",a);this.ia=this.w=this.s=this.l=this.h=this.c=null;this.oa=!0;this.m=this.ra=this.O=-1;this.S=this.v=this.A=0;this.Oa=n("internalChannelParams.baseRetryDelayMs",a)||5E3;this.Sa=n("internalChannelParams.retryDelaySeedMs",a)||1E4;this.Qa=n("internalChannelParams.forwardChannelMaxRetries",a)||2;this.qa=n("internalChannelParams.forwardChannelRequestTimeoutMs",
a)||2E4;this.La=a&&a.Ab||void 0;this.D=void 0;this.R=a&&a.supportsCrossDomainXhr||!1;this.H="";this.b=new ad(a&&a.concurrentRequestLimit);this.ja=new kd;this.o=a&&void 0!==a.backgroundChannelTest?a.backgroundChannelTest:!0;(this.W=a&&a.fastHandshake||!1)&&!this.o&&(this.o=!0);a&&a.forceLongPolling&&(this.oa=!1);this.fa=void 0;}g=Ad.prototype;g.wa=8;g.u=1;
function Bd(a){Cd(a);if(3==a.u){var b=a.P++,c=N(a.B);T(c,"SID",a.H);T(c,"RID",b);T(c,"TYPE","terminate");Dd(a,c);b=new M(a,b,void 0);b.F=2;b.f=bc(N(c));c=!1;k.navigator&&k.navigator.sendBeacon&&(c=k.navigator.sendBeacon(b.f.toString(),""));!c&&k.Image&&((new Image).src=b.f,c=!0);c||(b.a=b.g.$(null),b.a.ca(b.f));b.v=w();ec(b);}Ed(a);}
function Cd(a){a.w&&(a.w.abort(),a.w=null);a.a&&(a.a.cancel(),a.a=null);a.l&&(k.clearTimeout(a.l),a.l=null);Fd(a);a.b.cancel();a.h&&(aa(a.h)&&k.clearTimeout(a.h),a.h=null);}function Gd(a,b){a.f.push(new $c(a.Ra++,b));3==a.u&&Hd(a);}g.Da=function(){return 0==this.u};function Hd(a){ed(a.b)||a.h||(a.h=!0,wb(a.Ia,a),a.A=0);}
function Id(a,b){if(fd(a.b)>=a.b.f-(a.h?1:0))return !1;if(a.h)return a.f=b.j.concat(a.f),!0;if(1==a.u||2==a.u||a.A>=(a.Pa?0:a.Qa))return !1;a.h=Ob(u(a.Ia,a,b),Jd(a,a.A));a.A++;return !0}
g.Ia=function(a){if(this.h)if(this.h=null,1==this.u){if(!a){this.P=Math.floor(1E5*Math.random());a=this.P++;var b=new M(this,a,void 0),c=this.i;this.J&&(c?(c=wa(c),ya(c,this.J)):c=this.J);null===this.g&&(b.h=c);var d;if(this.W)a:{for(var e=d=0;e<this.f.length;e++){b:{var f=this.f[e];if("__data__"in f.a&&(f=f.a.__data__,m(f))){f=f.length;break b}f=void 0;}if(void 0===f)break;d+=f;if(4096<d){d=e;break a}if(4096===d||e===this.f.length-1){d=e+1;break a}}d=1E3;}else d=1E3;d=Kd(this,b,d);e=N(this.B);T(e,
"RID",a);T(e,"CVER",22);this.o&&this.j&&T(e,"X-HTTP-Session-Id",this.j);Dd(this,e);this.g&&c&&zd(e,this.g,c);dd(this.b,b);this.W?(T(e,"$req",d),T(e,"SID","null"),b.S=!0,ac(b,e,null)):ac(b,e,d);this.u=2;}}else 3==this.u&&(a?Ld(this,a):0==this.f.length||ed(this.b)||Ld(this));};
function Ld(a,b){var c;b?c=b.W:c=a.P++;var d=N(a.B);T(d,"SID",a.H);T(d,"RID",c);T(d,"AID",a.O);Dd(a,d);a.g&&a.i&&zd(d,a.g,a.i);c=new M(a,c,a.A+1);null===a.g&&(c.h=a.i);b&&(a.f=b.j.concat(a.f));b=Kd(a,c,1E3);c.setTimeout(Math.round(.5*a.qa)+Math.round(.5*a.qa*Math.random()));dd(a.b,c);ac(c,d,b);}function Dd(a,b){a.c&&oc({},function(c,d){T(b,d,c);});}
function Kd(a,b,c){c=Math.min(a.f.length,c);var d=a.c?u(a.c.Ta,a.c,a):null;a:for(var e=a.f,f=-1;;){var h=["count="+c];-1==f?0<c?(f=e[0].b,h.push("ofs="+f)):f=0:h.push("ofs="+f);for(var l=!0,F=0;F<c;F++){var Bb=e[F].b,Tc=e[F].a;Bb-=f;if(0>Bb)f=Math.max(0,e[F].b-100),l=!1;else try{ld(Tc,h,"req"+Bb+"_");}catch(Ud){d&&d(Tc);}}if(l){d=h.join("&");break a}}a=a.f.splice(0,c);b.j=a;return d}function Md(a){a.a||a.l||(a.S=1,wb(a.Ha,a),a.v=0);}
function Nd(a){if(a.a||a.l||3<=a.v)return !1;a.S++;a.l=Ob(u(a.Ha,a),Jd(a,a.v));a.v++;return !0}g.Ha=function(){this.l=null;this.a=new M(this,"rpc",this.S);null===this.g&&(this.a.h=this.i);this.a.J=0;var a=N(this.pa);T(a,"RID","rpc");T(a,"SID",this.H);T(a,"CI",this.ia?"0":"1");T(a,"AID",this.O);Dd(this,a);T(a,"TYPE","xmlhttp");this.g&&this.i&&zd(a,this.g,this.i);this.D&&this.a.setTimeout(this.D);dc(this.a,a,!0,this.ga);};
function Vc(a,b,c){var d=b.l;d&&cd(a.b,d);a.ia=a.oa&&c;a.m=b.c;a.B=Wc(a,null,a.ha);Hd(a);}
g.Ga=function(a,b){if(0!=this.u&&(this.a==a||gd(this.b,a)))if(this.m=a.o,!a.s&&gd(this.b,a)&&3==this.u){try{var c=this.ja.a.parse(b);}catch(f){c=null;}if(q(c)&&3==c.length){b=c;if(0==b[0])a:{if(!this.l){if(this.a)if(this.a.v+3E3<a.v)Fd(this),this.a.cancel(),this.a=null;else break a;Nd(this);K(18);}}else this.ra=b[1],0<this.ra-this.O&&37500>b[2]&&this.ia&&0==this.v&&!this.s&&(this.s=Ob(u(this.Za,this),6E3));if(1>=fd(this.b)&&this.fa){try{this.fa();}catch(f){}this.fa=void 0;}}else W(this,11);}else if((a.s||
this.a==a)&&Fd(this),!qa(b))for(b=c=this.ja.a.parse(b),c=0;c<b.length;c++){var d=b[c];this.O=d[0];d=d[1];if(2==this.u)if("c"==d[0]){this.H=d[1];this.ga=d[2];var e=d[3];null!=e&&(this.wa=e);d=d[5];null!=d&&aa(d)&&0<d&&(this.D=1.5*d);this.o&&(d=a.a)&&((e=hc(d,"X-Client-Wire-Protocol"))&&cd(this.b,e),this.j&&(d=hc(d,"X-HTTP-Session-Id")))&&(this.I=d,T(this.B,this.j,d));this.u=3;this.c&&this.c.va();d=a;this.pa=Wc(this,this.Y()?this.ga:null,this.ha);d.s?(hd(this.b,d),(e=this.D)&&d.setTimeout(e),d.i&&(gc(d),
ec(d)),this.a=d):Md(this);0<this.f.length&&Hd(this);}else"stop"!=d[0]&&"close"!=d[0]||W(this,7);else 3==this.u&&("stop"==d[0]||"close"==d[0]?"stop"==d[0]?W(this,7):Bd(this):"noop"!=d[0]&&this.c&&this.c.ua(d),this.v=0);}};g.Za=function(){null!=this.s&&(this.s=null,this.a.cancel(),this.a=null,Nd(this),K(19));};function Fd(a){null!=a.s&&(k.clearTimeout(a.s),a.s=null);}
g.na=function(a){var b=null;if(this.a==a){Fd(this);this.a=null;var c=2;}else if(gd(this.b,a))b=a.j,hd(this.b,a),c=1;else return;this.m=a.o;if(0!=this.u)if(a.b)1==c?(b=w()-a.v,I.dispatchEvent(new Nb(I,a.l?a.l.length:0,b,this.A)),Hd(this)):Md(this);else{var d=a.c;if(3==d||0==d&&0<this.m||!(1==c&&Id(this,a)||2==c&&Nd(this)))switch(b&&0<b.length&&(a=this.b,a.c=a.c.concat(b)),d){case 1:W(this,5);break;case 4:W(this,10);break;case 3:W(this,6);break;default:W(this,2);}}};
function Jd(a,b){var c=a.Oa+Math.floor(Math.random()*a.Sa);a.ma()||(c*=2);return c*b}function W(a,b){if(2==b){var c=null;a.c&&(c=null);var d=u(a.fb,a);c||(c=new S("//www.google.com/images/cleardot.gif"),k.location&&"http"==k.location.protocol||uc(c,"https"),bc(c));md(c.toString(),d);}else K(2);a.u=0;a.c&&a.c.ta(b);Ed(a);Cd(a);}g.fb=function(a){a?K(2):K(1);};function Ed(a){a.u=0;a.m=-1;if(a.c){if(0!=id(a.b).length||0!=a.f.length)a.b.c.length=0,pa(a.f),a.f.length=0;a.c.sa();}}
function Wc(a,b,c){var d=Jc(c);if(""!=d.b)b&&vc(d,b+"."+d.b),wc(d,d.i);else{var e=k.location,f;b?f=b+"."+e.hostname:f=e.hostname;d=Kc(e.protocol,f,+e.port,c);}a.V&&va(a.V,function(h,l){T(d,l,h);});b=a.j;c=a.I;b&&c&&T(d,b,c);T(d,"VER",a.wa);Dd(a,d);return d}g.$=function(a){if(a&&!this.R)throw Error("Can't create secondary domain capable XhrIo object.");a=new X(this.La);a.F=this.R;return a};g.ma=function(){return !!this.c&&!0};g.Y=function(){return this.R};function Od(){}g=Od.prototype;g.va=function(){};
g.ua=function(){};g.ta=function(){};g.sa=function(){};g.Ta=function(){};function Pd(a){for(var b=arguments[0],c=1;c<arguments.length;c++){var d=arguments[c];if(0==d.lastIndexOf("/",0))b=d;else{var e;(e=""==b)||(e=b.length-1,e=0<=e&&b.indexOf("/",e)==e);e?b+=d:b+="/"+d;}}return b}function Qd(){if(B&&!(10<=Number(Na)))throw Error("Environmental error: no available transport.");}Qd.prototype.a=function(a,b){return new Y(a,b)};
function Y(a,b){G.call(this);this.a=new Ad(b);this.g=a;this.m=b&&b.testUrl?b.testUrl:Pd(this.g,"test");this.b=b&&b.messageUrlParams||null;a=b&&b.messageHeaders||null;b&&b.clientProtocolHeaderRequired&&(a?a["X-Client-Protocol"]="webchannel":a={"X-Client-Protocol":"webchannel"});this.a.i=a;a=b&&b.initMessageHeaders||null;b&&b.messageContentType&&(a?a["X-WebChannel-Content-Type"]=b.messageContentType:a={"X-WebChannel-Content-Type":b.messageContentType});b&&b.xa&&(a?a["X-WebChannel-Client-Profile"]=b.xa:
a={"X-WebChannel-Client-Profile":b.xa});this.a.J=a;(a=b&&b.httpHeadersOverwriteParam)&&!qa(a)&&(this.a.g=a);this.l=b&&b.supportsCrossDomainXhr||!1;this.h=b&&b.sendRawJson||!1;(b=b&&b.httpSessionIdParam)&&!qa(b)&&(this.a.j=b,a=this.b,null!==a&&b in a&&(a=this.b,b in a&&delete a[b]));this.f=new Z(this);}x(Y,G);g=Y.prototype;g.addEventListener=function(a,b,c,d){Y.N.addEventListener.call(this,a,b,c,d);};g.removeEventListener=function(a,b,c,d){Y.N.removeEventListener.call(this,a,b,c,d);};
g.Wa=function(){this.a.c=this.f;this.l&&(this.a.R=!0);var a=this.a,b=this.m,c=this.g,d=this.b||void 0;K(0);a.ha=c;a.V=d||{};a.o&&(a.F.b=[],a.F.a=!1);a.w=new Sc(a);null===a.g&&(a.w.h=a.i);c=b;a.g&&a.i&&(c=zd(b,a.g,a.i));a=a.w;a.i=c;b=Wc(a.a,null,a.i);K(3);c=a.a.F.b;null!=c?(a.f=c[0],a.M=1,Uc(a)):(fc(b,"MODE","init"),!a.a.o&&a.a.j&&fc(b,"X-HTTP-Session-Id",a.a.j),a.b=new M(a,void 0,void 0),a.b.h=a.h,dc(a.b,b,!1,null),a.M=0);};g.close=function(){Bd(this.a);};
g.Xa=function(a){if(m(a)){var b={};b.__data__=a;Gd(this.a,b);}else this.h?(b={},b.__data__=ob(a),Gd(this.a,b)):Gd(this.a,a);};g.G=function(){this.a.c=null;delete this.f;Bd(this.a);delete this.a;Y.N.G.call(this);};function Rd(a){Ub.call(this);var b=a.__sm__;if(b){a:{for(var c in b){a=c;break a}a=void 0;}(this.c=a)?(a=this.c,this.data=null!==b&&a in b?b[a]:void 0):this.data=b;}else this.data=a;}x(Rd,Ub);function Sd(){Vb.call(this);this.status=1;}x(Sd,Vb);function Z(a){this.a=a;}x(Z,Od);Z.prototype.va=function(){this.a.dispatchEvent("a");};
Z.prototype.ua=function(a){this.a.dispatchEvent(new Rd(a));};Z.prototype.ta=function(a){this.a.dispatchEvent(new Sd(a));};Z.prototype.sa=function(){this.a.dispatchEvent("b");};var Td=v(function(a,b){function c(){}c.prototype=a.prototype;var d=new c;a.apply(d,Array.prototype.slice.call(arguments,1));return d},Qd);/*

 Copyright 2017 Google Inc.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
Qd.prototype.createWebChannel=Qd.prototype.a;Y.prototype.send=Y.prototype.Xa;Y.prototype.open=Y.prototype.Wa;Y.prototype.close=Y.prototype.close;Pb.NO_ERROR=0;Pb.TIMEOUT=8;Pb.HTTP_ERROR=6;Qb.COMPLETE="complete";Tb.EventType=L;L.OPEN="a";L.CLOSE="b";L.ERROR="c";L.MESSAGE="d";G.prototype.listen=G.prototype.Aa;X.prototype.listenOnce=X.prototype.Ba;X.prototype.getLastError=X.prototype.Ya;X.prototype.getLastErrorCode=X.prototype.ya;X.prototype.getStatus=X.prototype.T;X.prototype.getStatusText=X.prototype.za;
X.prototype.getResponseJson=X.prototype.Va;X.prototype.getResponseText=X.prototype.aa;X.prototype.send=X.prototype.ca;var tmp={createWebChannelTransport:Td,ErrorCode:Pb,EventType:Qb,WebChannel:Tb,XhrIo:X};
var tmp_1 = tmp.createWebChannelTransport;
var tmp_2 = tmp.ErrorCode;
var tmp_3 = tmp.EventType;
var tmp_4 = tmp.WebChannel;
var tmp_5 = tmp.XhrIo;

/* harmony default export */ __webpack_exports__["default"] = (tmp);

//# sourceMappingURL=index.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(51));
var tslib_1 = __webpack_require__(997);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */
var errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */
var HttpsErrorImpl = /** @class */ (function (_super) {
    tslib_1.__extends(HttpsErrorImpl, _super);
    function HttpsErrorImpl(code, message, details) {
        var _this = _super.call(this, message) || this;
        // This is a workaround for a bug in TypeScript when extending Error:
        // tslint:disable-next-line
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
        _this.code = code;
        _this.details = details;
        return _this;
    }
    return HttpsErrorImpl;
}(Error));
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */
function codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) {
        return 'ok';
    }
    switch (status) {
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
        default: // ignore
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */
function _errorForResponse(status, bodyJSON, serializer) {
    var code = codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    var description = code;
    var details = undefined;
    // Then look through the body for explicit details.
    try {
        var errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            var status_1 = errorJSON.status;
            if (typeof status_1 === 'string') {
                if (!errorCodeMap[status_1]) {
                    // They must've included an unknown error code in the body.
                    return new HttpsErrorImpl('internal', 'internal');
                }
                code = errorCodeMap[status_1];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status_1;
            }
            var message = errorJSON.message;
            if (typeof message === 'string') {
                description = message;
            }
            details = errorJSON.details;
            if (details !== undefined) {
                details = serializer.decode(details);
            }
        }
    }
    catch (e) {
        // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') {
        // Technically, there's an edge case where a developer could explicitly
        // return an error code of OK, and we will treat it as success, but that
        // seems reasonable.
        return null;
    }
    return new HttpsErrorImpl(code, description, details);
}

/**
 * Helper class to get metadata that should be included with a function call.
 */
var ContextProvider = /** @class */ (function () {
    function ContextProvider(app) {
        this.app = app;
    }
    ContextProvider.prototype.getAuthToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.app.INTERNAL.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token.accessToken];
                    case 2:
                        e_1 = _a.sent();
                        // If there's any error when trying to get the auth token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getInstanceIdToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var messaging, token, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // HACK: Until we have a separate instanceId package, this is a quick way
                        // to load in the messaging instance for this app.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        if (!this.app.messaging) {
                            return [2 /*return*/, undefined];
                        }
                        messaging = this.app.messaging();
                        return [4 /*yield*/, messaging.getToken()];
                    case 1:
                        token = _a.sent();
                        if (!token) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, token];
                    case 2:
                        e_2 = _a.sent();
                        // We don't warn on this, because it usually means messaging isn't set up.
                        // console.warn('Failed to retrieve instance id token.', e);
                        // If there's any error when trying to get the token, leave it off.
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ContextProvider.prototype.getContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var authToken, instanceIdToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthToken()];
                    case 1:
                        authToken = _a.sent();
                        return [4 /*yield*/, this.getInstanceIdToken()];
                    case 2:
                        instanceIdToken = _a.sent();
                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
                }
            });
        });
    };
    return ContextProvider;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function mapValues(o, f) {
    var result = {};
    for (var key in o) {
        if (o.hasOwnProperty(key)) {
            result[key] = f(o[key]);
        }
    }
    return result;
}
var Serializer = /** @class */ (function () {
    function Serializer() {
    }
    // Takes data and encodes it in a JSON-friendly way, such that types such as
    // Date are preserved.
    Serializer.prototype.encode = function (data) {
        var _this = this;
        if (data == null) {
            return null;
        }
        if (data instanceof Number) {
            data = data.valueOf();
        }
        if (typeof data === 'number' && isFinite(data)) {
            // Any number in JS is safe to put directly in JSON and parse as a double
            // without any loss of precision.
            return data;
        }
        if (data === true || data === false) {
            return data;
        }
        if (Object.prototype.toString.call(data) === '[object String]') {
            return data;
        }
        if (Array.isArray(data)) {
            return data.map(function (x) { return _this.encode(x); });
        }
        if (typeof data === 'function' || typeof data === 'object') {
            return mapValues(data, function (x) { return _this.encode(x); });
        }
        // If we got this far, the data is not encodable.
        throw new Error('Data cannot be encoded in JSON: ' + data);
    };
    // Takes data that's been encoded in a JSON-friendly form and returns a form
    // with richer datatypes, such as Dates, etc.
    Serializer.prototype.decode = function (json) {
        var _this = this;
        if (json == null) {
            return json;
        }
        if (json['@type']) {
            switch (json['@type']) {
                case LONG_TYPE:
                // Fall through and handle this the same as unsigned.
                case UNSIGNED_LONG_TYPE: {
                    // Technically, this could work return a valid number for malformed
                    // data if there was a number followed by garbage. But it's just not
                    // worth all the extra code to detect that case.
                    var value = Number(json['value']);
                    if (isNaN(value)) {
                        throw new Error('Data cannot be decoded from JSON: ' + json);
                    }
                    return value;
                }
                default: {
                    throw new Error('Data cannot be decoded from JSON: ' + json);
                }
            }
        }
        if (Array.isArray(json)) {
            return json.map(function (x) { return _this.decode(x); });
        }
        if (typeof json === 'function' || typeof json === 'object') {
            return mapValues(json, function (x) {
                return _this.decode(x);
            });
        }
        // Anything else is safe to return.
        return json;
    };
    return Serializer;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type HttpsErrorImpl.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */
function failAfter(millis) {
    return new Promise(function (_, reject) {
        setTimeout(function () {
            reject(new HttpsErrorImpl('deadline-exceeded', 'deadline-exceeded'));
        }, millis);
    });
}
/**
 * The main class for the Firebase Functions SDK.
 */
var Service = /** @class */ (function () {
    /**
     * Creates a new Functions service for the given app and (optional) region.
     * @param app_ The FirebaseApp to use.
     * @param region_ The region to call functions in.
     */
    function Service(app_, region_) {
        var _this = this;
        if (region_ === void 0) { region_ = 'us-central1'; }
        this.app_ = app_;
        this.region_ = region_;
        this.serializer = new Serializer();
        this.emulatorOrigin = null;
        this.INTERNAL = {
            delete: function () {
                return _this.deleteService();
            }
        };
        this.contextProvider = new ContextProvider(app_);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise(function (resolve) {
            _this.deleteService = function () {
                return resolve();
            };
        });
    }
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the URL for a callable with the given name.
     * @param name The name of the callable.
     */
    Service.prototype._url = function (name) {
        var projectId = this.app_.options.projectId;
        var region = this.region_;
        if (this.emulatorOrigin !== null) {
            var origin_1 = this.emulatorOrigin;
            return origin_1 + "/" + projectId + "/" + region + "/" + name;
        }
        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
    };
    /**
     * Changes this instance to point to a Cloud Functions emulator running
     * locally. See https://firebase.google.com/docs/functions/local-emulator
     *
     * @param origin The origin of the local emulator, such as
     * "http://localhost:5005".
     */
    Service.prototype.useFunctionsEmulator = function (origin) {
        this.emulatorOrigin = origin;
    };
    /**
     * Returns a reference to the callable https trigger with the given name.
     * @param name The name of the trigger.
     */
    Service.prototype.httpsCallable = function (name, options) {
        var _this = this;
        return function (data) {
            return _this.call(name, data, options || {});
        };
    };
    /**
     * Does an HTTP POST and returns the completed response.
     * @param url The url to post to.
     * @param body The JSON body of the post.
     * @param headers The HTTP headers to include in the request.
     * @return A Promise that will succeed when the request finishes.
     */
    Service.prototype.postJSON = function (url, body, headers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, e_1, json, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers.append('Content-Type', 'application/json');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: headers
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // This could be an unhandled error on the backend, or it could be a
                        // network error. There's no way to know, since an unhandled error on the
                        // backend will fail to set the proper CORS header, and thus will be
                        // treated as a network error by fetch.
                        return [2 /*return*/, {
                                status: 0,
                                json: null
                            }];
                    case 4:
                        json = null;
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, response.json()];
                    case 6:
                        json = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, {
                            status: response.status,
                            json: json
                        }];
                }
            });
        });
    };
    /**
     * Calls a callable function asynchronously and returns the result.
     * @param name The name of the callable trigger.
     * @param data The data to pass as params to the function.s
     */
    Service.prototype.call = function (name, data, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, body, headers, context, timeout, response, error, responseData, decodedData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this._url(name);
                        // Encode any special types, such as dates, in the input data.
                        data = this.serializer.encode(data);
                        body = { data: data };
                        headers = new Headers();
                        return [4 /*yield*/, this.contextProvider.getContext()];
                    case 1:
                        context = _a.sent();
                        if (context.authToken) {
                            headers.append('Authorization', 'Bearer ' + context.authToken);
                        }
                        if (context.instanceIdToken) {
                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
                        }
                        timeout = options.timeout || 70000;
                        return [4 /*yield*/, Promise.race([
                                this.postJSON(url, body, headers),
                                failAfter(timeout),
                                this.cancelAllRequests
                            ])];
                    case 2:
                        response = _a.sent();
                        // If service was deleted, interrupted response throws an error.
                        if (!response) {
                            throw new HttpsErrorImpl('cancelled', 'Firebase Functions instance was deleted.');
                        }
                        error = _errorForResponse(response.status, response.json, this.serializer);
                        if (error) {
                            throw error;
                        }
                        if (!response.json) {
                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
                        }
                        responseData = response.json.data;
                        // TODO(klimt): For right now, allow "result" instead of "data", for
                        // backwards compatibility.
                        if (typeof responseData === 'undefined') {
                            responseData = response.json.result;
                        }
                        if (typeof responseData === 'undefined') {
                            // Consider the response malformed.
                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
                        }
                        decodedData = this.serializer.decode(responseData);
                        return [2 /*return*/, { data: decodedData }];
                }
            });
        });
    };
    return Service;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Functions.
 */
var FUNCTIONS_TYPE = 'functions';
function factory(app, _unused, region) {
    return new Service(app, region);
}
function registerFunctions(instance) {
    var namespaceExports = {
        // no-inline
        Functions: Service
    };
    instance.INTERNAL.registerService(FUNCTIONS_TYPE, factory, namespaceExports, 
    // We don't need to wait on any AppHooks.
    undefined, 
    // Allow multiple functions instances per app.
    true);
}
registerFunctions(firebase);

exports.registerFunctions = registerFunctions;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSupported", function() { return isSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerMessaging", function() { return registerMessaging; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);





/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_MAP = (_a = {},
    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
    _a["should-be-overriden" /* SHOULD_BE_INHERITED */] = 'This method should be overriden by extended classes.',
    _a["bad-sender-id" /* BAD_SENDER_ID */] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().',
    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The required permissions were not granted and dismissed instead.',
    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The required permissions were not granted and blocked instead.',
    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.',
    _a["notifications-blocked" /* NOTIFICATIONS_BLOCKED */] = 'Notifications have been blocked.',
    _a["failed-serviceworker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}',
    _a["sw-registration-expected" /* SW_REGISTRATION_EXPECTED */] = 'A service worker registration was the expected input.',
    _a["get-subscription-failed" /* GET_SUBSCRIPTION_FAILED */] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.',
    _a["invalid-saved-token" /* INVALID_SAVED_TOKEN */] = 'Unable to access details of the saved token.',
    _a["sw-reg-redundant" /* SW_REG_REDUNDANT */] = 'The service worker being used for push was made redundant.',
    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occured while subscribing the user to FCM: {$errorInfo}',
    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
    _a["token-subscribe-no-push-set" /* TOKEN_SUBSCRIBE_NO_PUSH_SET */] = 'FCM returned an invalid response when getting an FCM token.',
    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occured while unsubscribing the ' +
        'user from FCM: {$errorInfo}',
    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occured while updating the user from FCM: {$errorInfo}',
    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
    _a["use-sw-before-get-token" /* USE_SW_BEFORE_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.',
    _a["invalid-delete-token" /* INVALID_DELETE_TOKEN */] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().',
    _a["delete-token-not-found" /* DELETE_TOKEN_NOT_FOUND */] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.',
    _a["delete-scope-not-found" /* DELETE_SCOPE_NOT_FOUND */] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.',
    _a["bg-handler-function-expected" /* BG_HANDLER_FUNCTION_EXPECTED */] = 'The input to setBackgroundMessageHandler() must be a function.',
    _a["no-window-client-to-msg" /* NO_WINDOW_CLIENT_TO_MSG */] = 'An attempt was made to message a non-existant window client.',
    _a["unable-to-resubscribe" /* UNABLE_TO_RESUBSCRIBE */] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$errorInfo}',
    _a["no-fcm-token-for-resubscribe" /* NO_FCM_TOKEN_FOR_RESUBSCRIBE */] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.',
    _a["failed-to-delete-token" /* FAILED_TO_DELETE_TOKEN */] = 'Unable to delete the currently saved token.',
    _a["no-sw-in-reg" /* NO_SW_IN_REG */] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.',
    _a["incorrect-gcm-sender-id" /* INCORRECT_GCM_SENDER_ID */] = "Please change your web app manifest's " +
        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.",
    _a["bad-scope" /* BAD_SCOPE */] = 'The service worker scope must be a string with at ' +
        'least one character.',
    _a["bad-vapid-key" /* BAD_VAPID_KEY */] = 'The public VAPID key is not a Uint8Array with 65 bytes.',
    _a["bad-subscription" /* BAD_SUBSCRIPTION */] = 'The subscription must be a valid PushSubscription.',
    _a["bad-token" /* BAD_TOKEN */] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.',
    _a["bad-push-set" /* BAD_PUSH_SET */] = 'The FCM push set used for storage / lookup was not ' +
        'not a valid push set string.',
    _a["failed-delete-vapid-key" /* FAILED_DELETE_VAPID_KEY */] = 'The VAPID key could not be deleted.',
    _a["invalid-public-vapid-key" /* INVALID_PUBLIC_VAPID_KEY */] = 'The public VAPID key must be a string.',
    _a["use-public-key-before-get-token" /* USE_PUBLIC_KEY_BEFORE_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
        'called before calling getToken() to ensure your VAPID key is used.',
    _a["public-vapid-key-decryption-failed" /* PUBLIC_KEY_DECRYPTION_FAILED */] = 'The public VAPID key did not equal 65 bytes when decrypted.',
    _a);
var errorFactory = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
]);
var ENDPOINT = 'https://fcm.googleapis.com';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MessageParameter;
(function (MessageParameter) {
    MessageParameter["TYPE_OF_MSG"] = "firebase-messaging-msg-type";
    MessageParameter["DATA"] = "firebase-messaging-msg-data";
})(MessageParameter || (MessageParameter = {}));
var MessageType;
(function (MessageType) {
    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isArrayBufferEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    if (a === b) {
        return true;
    }
    if (a.byteLength !== b.byteLength) {
        return false;
    }
    var viewA = new DataView(a);
    var viewB = new DataView(b);
    for (var i = 0; i < a.byteLength; i++) {
        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
            return false;
        }
    }
    return true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["e" /* __spread */])(uint8Version)));
}
function arrayBufferToBase64(arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IidModel = /** @class */ (function () {
    function IidModel() {
    }
    IidModel.prototype.getToken = function (senderId, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var p256dh, auth, fcmSubscribeBody, applicationPubKey, headers, subscribeOptions, responseData, response, err_1, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmSubscribeBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        subscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmSubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        throw errorFactory.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                            errorInfo: err_1
                        });
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
                        }
                        if (!responseData.pushSet) {
                            throw errorFactory.create("token-subscribe-no-push-set" /* TOKEN_SUBSCRIBE_NO_PUSH_SET */);
                        }
                        return [2 /*return*/, {
                                token: responseData.token,
                                pushSet: responseData.pushSet
                            }];
                }
            });
        });
    };
    /**
     * Update the underlying token details for fcmToken.
     */
    IidModel.prototype.updateToken = function (senderId, fcmToken, fcmPushSet, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var p256dh, auth, fcmUpdateBody, applicationPubKey, headers, updateOptions, responseData, response, err_2, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmUpdateBody = "push_set=" + fcmPushSet + "&" +
                            ("token=" + fcmToken + "&") +
                            ("authorized_entity=" + senderId + "&") +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmUpdateBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        updateOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUpdateBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', updateOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        throw errorFactory.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                            errorInfo: err_2
                        });
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    /**
     * Given a fcmToken, pushSet and messagingSenderId, delete an FCM token.
     */
    IidModel.prototype.deleteToken = function (senderId, fcmToken, fcmPushSet) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var fcmUnsubscribeBody, headers, unsubscribeOptions, response, responseData, message, err_3;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fcmUnsubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("token=" + fcmToken + "&") +
                            ("pushSet=" + fcmPushSet);
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        unsubscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUnsubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/unsubscribe', unsubscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                                errorInfo: message
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        throw errorFactory.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
                            errorInfo: err_3
                        });
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return IidModel;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function base64ToArrayBuffer(base64String) {
    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'undefined';
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function handleDb(db) {
    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // We found a database with the name 'undefined', but our expected object
        // store isn't defined.
        return;
    }
    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
    var iidModel = new IidModel();
    var openCursorRequest = objectStore.openCursor();
    openCursorRequest.onerror = function (event) {
        // NOOP - Nothing we can do.
        console.warn('Unable to cleanup old IDB.', event);
    };
    openCursorRequest.onsuccess = function () {
        var cursor = openCursorRequest.result;
        if (cursor) {
            // cursor.value contains the current record being iterated through
            // this is where you'd do something with the result
            var tokenDetails = cursor.value;
            // tslint:disable-next-line:no-floating-promises
            iidModel.deleteToken(tokenDetails.fcmSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet);
            cursor.continue();
        }
        else {
            db.close();
            indexedDB.deleteDatabase(OLD_DB_NAME);
        }
    };
}
function cleanV1() {
    var request = indexedDB.open(OLD_DB_NAME);
    request.onerror = function (_event) {
        // NOOP - Nothing we can do.
    };
    request.onsuccess = function (_event) {
        var db = request.result;
        handleDb(db);
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DbInterface = /** @class */ (function () {
    function DbInterface() {
        this.dbPromise = null;
    }
    /** Gets record(s) from the objectStore that match the given key. */
    DbInterface.prototype.get = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
    };
    /** Gets record(s) from the objectStore that match the given index. */
    DbInterface.prototype.getIndex = function (index, key) {
        function runRequest(objectStore) {
            var idbIndex = objectStore.index(index);
            return idbIndex.get(key);
        }
        return this.createTransaction(runRequest);
    };
    /** Assigns or overwrites the record for the given value. */
    // IndexedDB values are of type "any"
    DbInterface.prototype.put = function (value) {
        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
    };
    /** Deletes record(s) from the objectStore that match the given key. */
    DbInterface.prototype.delete = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
    };
    /**
     * Close the currently open database.
     */
    DbInterface.prototype.closeDatabase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var db;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dbPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dbPromise];
                    case 1:
                        db = _a.sent();
                        db.close();
                        this.dbPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates an IndexedDB Transaction and passes its objectStore to the
     * runRequest function, which runs the database request.
     *
     * @return Promise that resolves with the result of the runRequest function
     */
    DbInterface.prototype.createTransaction = function (runRequest, mode) {
        if (mode === void 0) { mode = 'readonly'; }
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var db, transaction, request, result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDb()];
                    case 1:
                        db = _a.sent();
                        transaction = db.transaction(this.objectStoreName, mode);
                        request = transaction.objectStore(this.objectStoreName);
                        return [4 /*yield*/, promisify(runRequest(request))];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                transaction.oncomplete = function () {
                                    resolve(result);
                                };
                                transaction.onerror = function () {
                                    reject(transaction.error);
                                };
                            })];
                }
            });
        });
    };
    /** Gets the cached db connection or opens a new one. */
    DbInterface.prototype.getDb = function () {
        var _this = this;
        if (!this.dbPromise) {
            this.dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                request.onsuccess = function () {
                    resolve(request.result);
                };
                request.onerror = function () {
                    _this.dbPromise = null;
                    reject(request.error);
                };
                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
            });
        }
        return this.dbPromise;
    };
    return DbInterface;
}());
/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
function promisify(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () {
            resolve(request.result);
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TokenDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __extends */])(TokenDetailsModel, _super);
    function TokenDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_token_details_db';
        _this.dbVersion = 3;
        _this.objectStoreName = 'fcm_token_object_Store';
        return _this;
    }
    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
        var db = request.result;
        // Lack of 'break' statements is intentional.
        switch (event.oldVersion) {
            case 0: {
                // New IDB instance
                var objectStore = db.createObjectStore(this.objectStoreName, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
            }
            case 1: {
                // Prior to version 2, we were using either 'fcm_token_details_db'
                // or 'undefined' as the database name due to bug in the SDK
                // So remove the old tokens and databases.
                cleanV1();
            }
            case 2: {
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_1 = objectStore.openCursor();
                cursorRequest_1.onsuccess = function () {
                    var cursor = cursorRequest_1.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, value);
                        if (!value.createTime) {
                            newValue.createTime = Date.now();
                        }
                        if (typeof value.vapidKey === 'string') {
                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
                        }
                        if (typeof value.auth === 'string') {
                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
                        }
                        if (typeof value.auth === 'string') {
                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
            }
            default: // ignore
        }
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                if (!fcmToken) {
                    throw errorFactory.create("bad-token" /* BAD_TOKEN */);
                }
                validateInputs({ fcmToken: fcmToken });
                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
            });
        });
    };
    /**
     * Given a service worker scope, this method will look up the details in
     * indexedDB.
     * @return The details associated with that token.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                if (!swScope) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                validateInputs({ swScope: swScope });
                return [2 /*return*/, this.get(swScope)];
            });
        });
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @param input A plain js object containing args to save.
     */
    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                if (!tokenDetails.swScope) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                if (!tokenDetails.vapidKey) {
                    throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
                }
                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
                    throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
                }
                if (!tokenDetails.fcmSenderId) {
                    throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
                }
                if (!tokenDetails.fcmToken) {
                    throw errorFactory.create("bad-token" /* BAD_TOKEN */);
                }
                if (!tokenDetails.fcmPushSet) {
                    throw errorFactory.create("bad-push-set" /* BAD_PUSH_SET */);
                }
                validateInputs(tokenDetails);
                return [2 /*return*/, this.put(tokenDetails)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     *
     * @return Resolves once the FCM token details have been deleted and returns
     * the deleted details.
     */
    TokenDetailsModel.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof token !== 'string' || token.length === 0) {
                            return [2 /*return*/, Promise.reject(errorFactory.create("invalid-delete-token" /* INVALID_DELETE_TOKEN */))];
                        }
                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
                    case 1:
                        details = _a.sent();
                        if (!details) {
                            throw errorFactory.create("delete-token-not-found" /* DELETE_TOKEN_NOT_FOUND */);
                        }
                        return [4 /*yield*/, this.delete(details.swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, details];
                }
            });
        });
    };
    return TokenDetailsModel;
}(DbInterface));
/**
 * This method takes an object and will check for known arguments and
 * validate the input.
 * @return Promise that resolves if input is valid, rejects otherwise.
 */
function validateInputs(input) {
    if (input.fcmToken) {
        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
            throw errorFactory.create("bad-token" /* BAD_TOKEN */);
        }
    }
    if (input.swScope) {
        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
            throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
        }
    }
    if (input.vapidKey) {
        if (!(input.vapidKey instanceof Uint8Array) ||
            input.vapidKey.length !== 65) {
            throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
        }
    }
    if (input.endpoint) {
        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.auth) {
        if (!(input.auth instanceof ArrayBuffer)) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.p256dh) {
        if (!(input.p256dh instanceof ArrayBuffer)) {
            throw errorFactory.create("bad-subscription" /* BAD_SUBSCRIPTION */);
        }
    }
    if (input.fcmSenderId) {
        if (typeof input.fcmSenderId !== 'string' ||
            input.fcmSenderId.length === 0) {
            throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
        }
    }
    if (input.fcmPushSet) {
        if (typeof input.fcmPushSet !== 'string' || input.fcmPushSet.length === 0) {
            throw errorFactory.create("bad-push-set" /* BAD_PUSH_SET */);
        }
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
var VapidDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __extends */])(VapidDetailsModel, _super);
    function VapidDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_vapid_details_db';
        _this.dbVersion = 1;
        _this.objectStoreName = 'fcm_vapid_object_Store';
        return _this;
    }
    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
        var db = request.result;
        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
    };
    /**
     * Given a service worker scope, this method will look up the vapid key
     * in indexedDB.
     */
    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof swScope !== 'string' || swScope.length === 0) {
                            throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                        }
                        return [4 /*yield*/, this.get(swScope)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.vapidKey : undefined];
                }
            });
        });
    };
    /**
     * Save a vapid key against a swScope for later date.
     */
    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                if (typeof swScope !== 'string' || swScope.length === 0) {
                    throw errorFactory.create("bad-scope" /* BAD_SCOPE */);
                }
                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
                    throw errorFactory.create("bad-vapid-key" /* BAD_VAPID_KEY */);
                }
                details = {
                    swScope: swScope,
                    vapidKey: vapidKey
                };
                return [2 /*return*/, this.put(details)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM VAPID key for a SW scope.
     * Resolves once the scope/vapid details have been deleted and returns the
     * deleted vapid key.
     */
    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var vapidKey;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
                    case 1:
                        vapidKey = _a.sent();
                        if (!vapidKey) {
                            throw errorFactory.create("delete-scope-not-found" /* DELETE_SCOPE_NOT_FOUND */);
                        }
                        return [4 /*yield*/, this.delete(swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, vapidKey];
                }
            });
        });
    };
    return VapidDetailsModel;
}(DbInterface));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SENDER_ID_OPTION_NAME = 'messagingSenderId';
// Database cache should be invalidated once a week.
var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
var BaseController = /** @class */ (function () {
    /**
     * An interface of the Messaging Service API
     */
    function BaseController(app) {
        var _this = this;
        if (!app.options[SENDER_ID_OPTION_NAME] ||
            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw errorFactory.create("bad-sender-id" /* BAD_SENDER_ID */);
        }
        this.messagingSenderId = app.options[SENDER_ID_OPTION_NAME];
        this.tokenDetailsModel = new TokenDetailsModel();
        this.vapidDetailsModel = new VapidDetailsModel();
        this.iidModel = new IidModel();
        this.app = app;
        this.INTERNAL = {
            delete: function () { return _this.delete(); }
        };
    }
    /**
     * @export
     */
    BaseController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentPermission = this.getNotificationPermission_();
                        if (currentPermission === 'denied') {
                            throw errorFactory.create("notifications-blocked" /* NOTIFICATIONS_BLOCKED */);
                        }
                        else if (currentPermission !== 'granted') {
                            // We must wait for permission to be granted
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        return [4 /*yield*/, this.getPublicVapidKey_()];
                    case 2:
                        publicVapidKey = _a.sent();
                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
                    case 3:
                        pushSubscription = _a.sent();
                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
                    case 4:
                        tokenDetails = _a.sent();
                        if (tokenDetails) {
                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    /**
     * manageExistingToken is triggered if there's an existing FCM token in the
     * database and it can take 3 different actions:
     * 1) Retrieve the existing FCM token from the database.
     * 2) If VAPID details have changed: Delete the existing token and create a
     * new one with the new VAPID key.
     * 3) If the database cache is invalidated: Send a request to FCM to update
     * the token, and to check if the token is still valid on FCM-side.
     */
    BaseController.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var isTokenValid, now;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
                        if (isTokenValid) {
                            now = Date.now();
                            if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
                                return [2 /*return*/, tokenDetails.fcmToken];
                            }
                            else {
                                return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                            }
                        }
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
                    case 1:
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        _a.sent();
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    BaseController.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var updatedToken, allDetails, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        return [4 /*yield*/, this.iidModel.updateToken(this.messagingSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet, pushSubscription, publicVapidKey)];
                    case 1:
                        updatedToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: updatedToken,
                            fcmPushSet: tokenDetails.fcmPushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, updatedToken];
                    case 4:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BaseController.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var tokenDetails, allDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.iidModel.getToken(this.messagingSenderId, pushSubscription, publicVapidKey)];
                    case 1:
                        tokenDetails = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: tokenDetails.token,
                            fcmPushSet: tokenDetails.pushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, tokenDetails.token];
                }
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after,
     * unsubscribes the token from FCM  and then unregisters the push
     * subscription if it exists. It returns a promise that indicates
     * whether or not the unsubscribe request was processed successfully.
     */
    BaseController.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var registration, pushSubscription;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Delete the token details from the database.
                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
                    case 1:
                        // Delete the token details from the database.
                        _a.sent();
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        registration = _a.sent();
                        if (!registration) return [3 /*break*/, 4];
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 3:
                        pushSubscription = _a.sent();
                        if (pushSubscription) {
                            return [2 /*return*/, pushSubscription.unsubscribe()];
                        }
                        _a.label = 4;
                    case 4: 
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * This method will delete the token from the client database, and make a
     * call to FCM to remove it from the server DB. Does not temper with the
     * push subscription.
     */
    BaseController.prototype.deleteTokenFromDB = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
                    case 1:
                        details = _a.sent();
                        return [4 /*yield*/, this.iidModel.deleteToken(details.fcmSenderId, details.fcmToken, details.fcmPushSet)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a PushSubscription for the current user.
     */
    BaseController.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
        return swRegistration.pushManager.getSubscription().then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: publicVapidKey
            });
        });
    };
    //
    // The following methods should only be available in the window.
    //
    /**
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    BaseController.prototype.requestPermission = function () {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.useServiceWorker = function (_registration) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.usePublicVapidKey = function (_b64PublicKey) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.onMessage = function (_nextOrObserver, _error, _completed) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    BaseController.prototype.onTokenRefresh = function (_nextOrObserver, _error, _completed) {
        throw errorFactory.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
    };
    //
    // The following methods are used by the service worker only.
    //
    BaseController.prototype.setBackgroundMessageHandler = function (_callback) {
        throw errorFactory.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    BaseController.prototype.delete = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.tokenDetailsModel.closeDatabase(),
                            this.vapidDetailsModel.closeDatabase()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current Notification Permission state.
     */
    BaseController.prototype.getNotificationPermission_ = function () {
        return Notification.permission;
    };
    BaseController.prototype.getTokenDetailsModel = function () {
        return this.tokenDetailsModel;
    };
    BaseController.prototype.getVapidDetailsModel = function () {
        return this.vapidDetailsModel;
    };
    // Visible for testing
    // TODO: make protected
    BaseController.prototype.getIidModel = function () {
        return this.iidModel;
    };
    return BaseController;
}());
/**
 * Checks if the tokenDetails match the details provided in the clients.
 */
function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
    if (!tokenDetails.vapidKey ||
        !isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
        return false;
    }
    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
    return isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FCM_MSG = 'FCM_MSG';
var SwController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __extends */])(SwController, _super);
    function SwController(app) {
        var _this = _super.call(this, app) || this;
        _this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            _this.onPush(e);
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            _this.onSubChange(e);
        });
        self.addEventListener('notificationclick', function (e) {
            _this.onNotificationClick(e);
        });
        return _this;
    }
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onPush = function (event) {
        event.waitUntil(this.onPush_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onSubChange = function (event) {
        event.waitUntil(this.onSubChange_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onNotificationClick = function (event) {
        event.waitUntil(this.onNotificationClick_(event));
    };
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     */
    SwController.prototype.onPush_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg, actions, maxActions;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.data) {
                            return [2 /*return*/];
                        }
                        try {
                            msgPayload = event.data.json();
                        }
                        catch (err) {
                            // Not JSON so not an FCM message
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.hasVisibleClients_()];
                    case 1:
                        hasVisibleClients = _a.sent();
                        if (hasVisibleClients) {
                            // App in foreground. Send to page.
                            return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
                        }
                        notificationDetails = this.getNotificationData_(msgPayload);
                        if (!notificationDetails) return [3 /*break*/, 3];
                        notificationTitle = notificationDetails.title || '';
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        reg = _a.sent();
                        actions = notificationDetails.actions;
                        maxActions = Notification.maxActions;
                        // tslint:enable no-any
                        if (actions && maxActions && actions.length > maxActions) {
                            console.warn("This browser only supports " + maxActions + " actions." +
                                "The remaining actions will not be displayed.");
                        }
                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
                    case 3:
                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange_ = function (_event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        registration = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw errorFactory.create("unable-to-resubscribe" /* UNABLE_TO_RESUBSCRIBE */, {
                            errorInfo: err_1
                        });
                    case 3:
                        _a.trys.push([3, 5, , 8]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        err_2 = _a.sent();
                        tokenDetailsModel = this.getTokenDetailsModel();
                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
                    case 6:
                        tokenDetails = _a.sent();
                        if (!tokenDetails) {
                            // This should rarely occure, but could if indexedDB
                            // is corrupted or wiped
                            throw err_2;
                        }
                        // Attempt to delete the token if we know it's bad
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 7:
                        // Attempt to delete the token if we know it's bad
                        _a.sent();
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var msgPayload, link, windowClient, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.notification ||
                            !event.notification.data ||
                            !event.notification.data[FCM_MSG]) {
                            // Not an FCM notification, do nothing.
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button.
                            // This will allow devs to act on action button clicks by using a custom
                            // onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        msgPayload = event.notification.data[FCM_MSG];
                        if (!msgPayload.notification) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        link = (msgPayload.fcmOptions && msgPayload.fcmOptions.link) ||
                            msgPayload.notification.click_action;
                        if (!link) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getWindowClient_(link)];
                    case 1:
                        windowClient = _a.sent();
                        if (!!windowClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        // Unable to find window client so need to open one.
                        windowClient = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, windowClient.focus()];
                    case 4:
                        windowClient = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!windowClient) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        // Delete notification and fcmOptions data from payload before sending to
                        // the page.
                        delete msgPayload.notification;
                        delete msgPayload.fcmOptions;
                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
                        // Attempt to send a message to the client to handle the data
                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
                }
            });
        });
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getNotificationData_ = function (msgPayload) {
        var _a;
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation.data = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, msgPayload.notification.data, (_a = {}, _a[FCM_MSG] = msgPayload, _a));
        return notificationInformation;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received
     * and a notification must be shown. The callback will be given the data from
     * the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        if (!callback || typeof callback !== 'function') {
            throw errorFactory.create("bg-handler-function-expected" /* BG_HANDLER_FUNCTION_EXPECTED */);
        }
        this.bgMessageHandler = callback;
    };
    /**
     * @param url The URL to look for when focusing a client.
     * @return Returns an existing window client or a newly opened WindowClient.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getWindowClient_ = function (url) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedURL = new URL(url, self.location.href).href;
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        suitableClient = null;
                        for (i = 0; i < clientList.length; i++) {
                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
                                .href;
                            if (parsedClientUrl === parsedURL) {
                                suitableClient = clientList[i];
                                break;
                            }
                        }
                        return [2 /*return*/, suitableClient];
                }
            });
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @param client The WindowClient to send the message to.
     * @param message The message to send to the client.
     * @returns Returns a promise that resolves after sending the message. This
     * does not guarantee that the message was successfully received.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.attemptToMessageClient_ = function (client, message) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                // NOTE: This returns a promise in case this API is abstracted later on to
                // do additional work
                if (!client) {
                    throw errorFactory.create("no-window-client-to-msg" /* NO_WINDOW_CLIENT_TO_MSG */);
                }
                client.postMessage(message);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns If there is currently a visible WindowClient, this method will
     * resolve to true, otherwise false.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.hasVisibleClients_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var clientList;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        return [2 /*return*/, clientList.some(function (client) {
                                return client.visibilityState === 'visible' &&
                                    // Ignore chrome-extension clients as that matches the background pages
                                    // of extensions, which are always considered visible.
                                    !client.url.startsWith('chrome-extension://');
                            })];
                }
            });
        });
    };
    /**
     * @param msgPayload The data from the push event that should be sent to all
     * available pages.
     * @returns Returns a promise that resolves once the message has been sent to
     * all WindowClients.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var clientList, internalMsg;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
                                return _this.attemptToMessageClient_(client, internalMsg);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @return he service worker registration to be used for the push service.
     */
    SwController.prototype.getSWRegistration_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                return [2 /*return*/, self.registration];
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    SwController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var swReg, vapidKeyFromDatabase;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        if (!swReg) {
                            throw errorFactory.create("sw-registration-expected" /* SW_REGISTRATION_EXPECTED */);
                        }
                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
                    case 2:
                        vapidKeyFromDatabase = _a.sent();
                        if (vapidKeyFromDatabase == null) {
                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
                        }
                        return [2 /*return*/, vapidKeyFromDatabase];
                }
            });
        });
    };
    return SwController;
}(BaseController));
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function createNewMsg(msgType, msgData) {
    var _a;
    return _a = {},
        _a[MessageParameter.TYPE_OF_MSG] = msgType,
        _a[MessageParameter.DATA] = msgData,
        _a;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __extends */])(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.registrationToUse = null;
        _this.publicVapidKeyToUse = null;
        _this.manifestCheckPromise = null;
        _this.messageObserver = null;
        // @ts-ignore: Unused variable error, this is not implemented yet.
        _this.tokenRefreshObserver = null;
        _this.onMessageInternal = Object(__WEBPACK_IMPORTED_MODULE_2__firebase_util__["createSubscribe"])(function (observer) {
            _this.messageObserver = observer;
        });
        _this.onTokenRefreshInternal = Object(__WEBPACK_IMPORTED_MODULE_2__firebase_util__["createSubscribe"])(function (observer) {
            _this.tokenRefreshObserver = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     *
     * @return Returns a promise that resolves to an FCM token or null if
     * permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.manifestCheckPromise) {
                            this.manifestCheckPromise = manifestCheck();
                        }
                        return [4 /*yield*/, this.manifestCheckPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.getToken.call(this)];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted
     *
     * @return Resolves if the permission was granted, otherwise rejects
     *
     * @deprecated Use Notification.requestPermission() instead.
     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            var permissionResult;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.getNotificationPermission_() === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw errorFactory.create("permission-blocked" /* PERMISSION_BLOCKED */);
                        }
                        else {
                            throw errorFactory.create("permission-default" /* PERMISSION_DEFAULT */);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     *
     * @param registration The service worker registration that should be used to
     * receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw errorFactory.create("sw-registration-expected" /* SW_REGISTRATION_EXPECTED */);
        }
        if (this.registrationToUse != null) {
            throw errorFactory.create("use-sw-before-get-token" /* USE_SW_BEFORE_GET_TOKEN */);
        }
        this.registrationToUse = registration;
    };
    /**
     * This method allows a developer to override the default vapid key
     * and instead use a custom VAPID public key.
     *
     * @param publicKey A URL safe base64 encoded string.
     */
    WindowController.prototype.usePublicVapidKey = function (publicKey) {
        if (typeof publicKey !== 'string') {
            throw errorFactory.create("invalid-public-vapid-key" /* INVALID_PUBLIC_VAPID_KEY */);
        }
        if (this.publicVapidKeyToUse != null) {
            throw errorFactory.create("use-public-key-before-get-token" /* USE_PUBLIC_KEY_BEFORE_GET_TOKEN */);
        }
        var parsedKey = base64ToArrayBuffer(publicKey);
        if (parsedKey.length !== 65) {
            throw errorFactory.create("public-vapid-key-decryption-failed" /* PUBLIC_KEY_DECRYPTION_FAILED */);
        }
        this.publicVapidKeyToUse = parsedKey;
    };
    /**
     * @export
     * @param nextOrObserver An observer object or a function triggered on
     * message.
     * @param error A function triggered on message error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onMessageInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onMessageInternal(nextOrObserver);
        }
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on token
     * refresh.
     * @param error A function triggered on token refresh error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onTokenRefreshInternal(nextOrObserver);
        }
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @param registration Registration to wait for service worker to become active
     * @return Wait for service worker registration to become active
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(errorFactory.create("no-sw-in-reg" /* NO_SW_IN_REG */));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(errorFactory.create("sw-reg-redundant" /* SW_REG_REDUNDANT */));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(errorFactory.create("sw-reg-redundant" /* SW_REG_REDUNDANT */));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will register the default service worker and return the registration
     * @return The service worker registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse) {
            return this.waitForRegistrationToActivate_(this.registrationToUse);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse is no longer undefined
        this.registrationToUse = null;
        return navigator.serviceWorker
            .register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        })
            .catch(function (err) {
            throw errorFactory.create("failed-serviceworker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service worker to not
                // install
                // tslint:disable-next-line:no-floating-promises
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the public VAPID key
     * provided by the developer.
     */
    WindowController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
                if (this.publicVapidKeyToUse) {
                    return [2 /*return*/, this.publicVapidKeyToUse];
                }
                return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[MessageParameter.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[MessageParameter.TYPE_OF_MSG]) {
                case MessageType.PUSH_MSG_RECEIVED:
                case MessageType.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[MessageParameter.DATA];
                    if (_this.messageObserver) {
                        _this.messageObserver.next(pushMessage);
                    }
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    return WindowController;
}(BaseController));
/**
 * The method checks that a manifest is defined and has the correct GCM
 * sender ID.
 * @return Returns a promise that resolves if the manifest matches
 * our required sender ID
 */
// Exported for testing
function manifestCheck() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var manifestTag, manifestContent, response, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    manifestTag = document.querySelector('link[rel="manifest"]');
                    if (!manifestTag) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(manifestTag.href)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    manifestContent = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    // If the download or parsing fails allow check.
                    // We only want to error if we KNOW that the gcm_sender_id is incorrect.
                    return [2 /*return*/];
                case 5:
                    if (!manifestContent || !manifestContent.gcm_sender_id) {
                        return [2 /*return*/];
                    }
                    if (manifestContent.gcm_sender_id !== '103953800507') {
                        throw errorFactory.create("incorrect-gcm-sender-id" /* INCORRECT_GCM_SENDER_ID */);
                    }
                    return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (!isSupported()) {
            throw errorFactory.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
        }
        if (self && 'ServiceWorkerGlobalScope' in self) {
            // Running in ServiceWorker context
            return new SwController(app);
        }
        else {
            // Assume we are in the window context.
            return new WindowController(app);
        }
    };
    var namespaceExports = {
        isSupported: isSupported
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return (navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStorage", function() { return registerStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(1000);



/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain name for firebase storage.
 */
var DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */
var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */
var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */
var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 100;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var MIN_SAFE_INTEGER = -9007199254740991;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseStorageError = /** @class */ (function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function () {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function () {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function () {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function () {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}());
var Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' +
        'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
        bucket +
        "' exceeded, please view quota on " +
        'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' +
        'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function noDefaultBucket() {
    return new FirebaseStorageError(Code.NO_DEFAULT_BUCKET, 'No default bucket ' +
        "found. Did you set the '" +
        CONFIG_STORAGE_BUCKET_KEY +
        "' property when initializing the app?");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    }
    else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
        fnName +
        '`: Expected ' +
        countPart +
        ' ' +
        plural +
        ', received ' +
        real +
        '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
        name +
        "' cannot be performed on a root reference, create a non-root " +
        "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' +
                StringFormat.RAW +
                ', ' +
                StringFormat.BASE64 +
                ', ' +
                StringFormat.BASE64URL +
                ', ' +
                StringFormat.DATA_URL +
                '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */ (function () {
    function StringData(data, contentType) {
        this.data = data;
        this.contentType = contentType || null;
    }
    return StringData;
}());
function dataFromString(format, stringData) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(stringData));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, stringData));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
        default:
        // do nothing
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(value) {
    var b = [];
    for (var i = 0; i < value.length; i++) {
        var c = value.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        }
        else {
            if (c <= 2047) {
                b.push(192 | (c >> 6), 128 | (c & 63));
            }
            else {
                if ((c & 64512) === 55296) {
                    // The start of a surrogate pair.
                    var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    }
                    else {
                        var hi = c;
                        var lo = value.charCodeAt(++i);
                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
                else {
                    if ((c & 64512) === 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    }
                    else {
                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(value) {
    var decoded;
    try {
        decoded = decodeURIComponent(value);
    }
    catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, value) {
    switch (format) {
        case StringFormat.BASE64: {
            var hasMinus = value.indexOf('-') !== -1;
            var hasUnder = value.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw invalidFormat(format, "Invalid character '" +
                    invalidChar +
                    "' found: is it base64url encoded?");
            }
            break;
        }
        case StringFormat.BASE64URL: {
            var hasPlus = value.indexOf('+') !== -1;
            var hasSlash = value.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            value = value.replace(/-/g, '+').replace(/_/g, '/');
            break;
        }
        default:
        // do nothing
    }
    var bytes;
    try {
        bytes = atob(value);
    }
    catch (e) {
        throw invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */ (function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64
                ? middle.substring(0, middle.length - ';base64'.length)
                : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}());
function dataURLBytes_(dataUrl) {
    var parts = new DataURLParts(dataUrl);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    }
    else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(dataUrl) {
    var parts = new DataURLParts(dataUrl);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return typeof p === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isInteger(p) {
    return isNumber(p) && Number.isInteger(p);
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */ (function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise(function (resolve) {
            _this.xhr_.addEventListener('abort', function () {
                _this.errorCode_ = ErrorCode.ABORT;
                resolve(_this);
            });
            _this.xhr_.addEventListener('error', function () {
                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve(_this);
            });
            _this.xhr_.addEventListener('load', function () {
                resolve(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, body, headers) {
        if (this.sent_) {
            throw internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (isDef(headers)) {
            for (var key in headers) {
                if (headers.hasOwnProperty(key)) {
                    this.xhr_.setRequestHeader(key, headers[key].toString());
                }
            }
        }
        if (isDef(body)) {
            this.xhr_.send(body);
        }
        else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        }
        catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */ (function () {
    function XhrIoPool() {
    }
    XhrIoPool.prototype.createXhrIo = function () {
        return new NetworkXhrIo();
    };
    return XhrIoPool;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    }
    else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    }
    else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < args.length; i++) {
            bb.append(args[i]);
        }
        return bb.getBlob();
    }
    else {
        if (isNativeBlobDefined()) {
            return new Blob(args);
        }
        else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    }
    else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    }
    else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
var FbsBlob = /** @class */ (function () {
    function FbsBlob(data, elideCopy) {
        var size = 0;
        var blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        }
        else if (data instanceof ArrayBuffer) {
            if (elideCopy) {
                this.data_ = new Uint8Array(data);
            }
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        }
        else if (data instanceof Uint8Array) {
            if (elideCopy) {
                this.data_ = data;
            }
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        }
        else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (isNativeBlobDefined()) {
            var blobby = args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                }
                else {
                    return val;
                }
            });
            return new FbsBlob(getBlob.apply(null, blobby));
        }
        else {
            var uint8Arrays = args.map(function (val) {
                if (isString(val)) {
                    return dataFromString(StringFormat.RAW, val).data;
                }
                else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Location = /** @class */ (function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function () {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "isRoot", {
        get: function () {
            return this.path.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        }
        catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        }
        else {
            throw invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var hostRegex = DEFAULT_HOST.replace(/[.]/g, '\\.');
        var httpRegex = new RegExp("^https?://" + hostRegex + "/" + version + "/b/" + bucketDomain + "/o" + path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [
            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
        ];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw invalidUrl(url);
        }
        return location;
    };
    return Location;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    }
    catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) {
        return obj;
    }
    else {
        return null;
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length === 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath
        .split('/')
        .filter(function (component) { return component.length > 0; })
        .join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    }
    else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    }
    else {
        return path.slice(index + 1);
    }
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeUrl(urlPart) {
    return "https://" + DEFAULT_HOST + "/v0" + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
            var nextPart = encode(key) + '=' + encode(params[key]);
            queryPart = queryPart + nextPart + '&';
        }
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
var Mapping = /** @class */ (function () {
    function Mapping(server, local, writable, xform) {
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || noXform_;
    }
    return Mapping;
}());
var mappings_ = null;
function xformPath(fullPath) {
    if (!isString(fullPath) || fullPath.length < 2) {
        return fullPath;
    }
    else {
        return lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(_metadata, size) {
        if (isDef(size)) {
            return Number(size);
        }
        else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function downloadUrlFromResourceString(metadata, resourceString) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    if (!isString(obj['downloadTokens'])) {
        // This can happen if objects are uploaded through GCS and retrieved
        // through list, so we don't want to throw an Error.
        return null;
    }
    var tokens = obj['downloadTokens'];
    if (tokens.length === 0) {
        return null;
    }
    var encode = encodeURIComponent;
    var tokensList = tokens.split(',');
    var urls = tokensList.map(function (token) {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        var base = makeUrl(urlPart);
        var queryString = makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    if (!isObject(p) || !p) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        if (p.hasOwnProperty(key)) {
            var val = p[key];
            if (key === 'customMetadata') {
                if (!isObject(val)) {
                    throw 'Expected object for \'customMetadata\' mapping.';
                }
            }
            else {
                if (isNonNullObject(val)) {
                    throw "Mapping for '" + key + "' cannot be an object.";
                }
            }
        }
    }
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_RESULTS_KEY = 'maxResults';
var MAX_MAX_RESULTS = 1000;
var PAGE_TOKEN_KEY = 'pageToken';
var PREFIXES_KEY = 'prefixes';
var ITEMS_KEY = 'items';
function fromBackendResponse(authWrapper, resource) {
    var listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    var bucket = authWrapper.bucket();
    if (bucket === null) {
        throw noDefaultBucket();
    }
    if (resource[PREFIXES_KEY]) {
        for (var _i = 0, _a = resource[PREFIXES_KEY]; _i < _a.length; _i++) {
            var path = _a[_i];
            var pathWithoutTrailingSlash = path.replace(/\/$/, '');
            var reference = authWrapper.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
            listResult.prefixes.push(reference);
        }
    }
    if (resource[ITEMS_KEY]) {
        for (var _b = 0, _c = resource[ITEMS_KEY]; _b < _c.length; _b++) {
            var item = _c[_b];
            var reference = authWrapper.makeStorageReference(new Location(bucket, item['name']));
            listResult.items.push(reference);
        }
    }
    return listResult;
}
function fromResponseString(authWrapper, resourceString) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromBackendResponse(authWrapper, resource);
}
function listOptionsValidator(p) {
    if (!isObject(p) || !p) {
        throw 'Expected ListOptions object.';
    }
    for (var key in p) {
        if (key === MAX_RESULTS_KEY) {
            if (!isInteger(p[MAX_RESULTS_KEY]) ||
                p[MAX_RESULTS_KEY] <= 0) {
                throw 'Expected maxResults to be a positive number.';
            }
            if (p[MAX_RESULTS_KEY] > 1000) {
                throw "Expected maxResults to be less than or equal to " + MAX_MAX_RESULTS + ".";
            }
        }
        else if (key === PAGE_TOKEN_KEY) {
            if (p[PAGE_TOKEN_KEY] && !isString(p[PAGE_TOKEN_KEY])) {
                throw 'Expected pageToken to be string.';
            }
        }
        else {
            throw 'Unknown option: ' + key;
        }
    }
}

var RequestInfo = /** @class */ (function () {
    function RequestInfo(url, method, 
    /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function listHandler(authWrapper) {
    function handler(xhr, text) {
        var listResult = fromResponseString(authWrapper, text);
        handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function downloadUrlHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return downloadUrlFromResourceString(metadata, text);
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = unauthenticated();
        }
        else {
            if (xhr.getStatus() === 402) {
                newErr = quotaExceeded(location.bucket);
            }
            else {
                if (xhr.getStatus() === 403) {
                    newErr = unauthorized(location.path);
                }
                else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function list(authWrapper, location, delimiter, pageToken, maxResults) {
    var urlParams = {};
    if (location.isRoot) {
        urlParams['prefix'] = '';
    }
    else {
        urlParams['prefix'] = location.path + '/';
    }
    if (delimiter && delimiter.length > 0) {
        urlParams['delimiter'] = delimiter;
    }
    if (pageToken) {
        urlParams['pageToken'] = pageToken;
    }
    if (maxResults) {
        urlParams['maxResults'] = maxResults;
    }
    var urlPart = location.bucketOnlyServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, listHandler(authWrapper), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
function getDownloadUrl(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'PATCH';
    var body = toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = makeUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(_xhr, _text) { }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return ((metadata && metadata['contentType']) ||
        (blob && blob.type()) ||
        'application/octet-stream');
}
function metadataForUpload_(location, blob, metadata) {
    var metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) {
        metadataClone['contentType'] = determineContentType_(null, blob);
    }
    return metadataClone;
}
function multipartUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str =
                str +
                    Math.random()
                        .toString()
                        .slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata_ = metadataForUpload_(location, blob, metadata);
    var metadataString = toResourceString(metadata_, mappings);
    var preBlobPart = '--' +
        boundary +
        '\r\n' +
        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
        metadataString +
        '\r\n--' +
        boundary +
        '\r\n' +
        'Content-Type: ' +
        metadata_['contentType'] +
        '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw cannotSliceBlob();
    }
    var urlParams = { name: metadata_['fullPath'] };
    var url = makeUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */ (function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}());
function checkResumeHeader_(xhr, allowed) {
    var status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    }
    catch (e) {
        handlerCheck(false);
    }
    var allowedStatus = allowed || ['active'];
    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadataForUpload = metadataForUpload_(location, blob, metadata);
    var urlParams = { name: metadataForUpload['fullPath'] };
    var url = makeUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = toResourceString(metadataForUpload, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        }
        catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        }
        catch (e) {
            handlerCheck(false);
        }
        if (!sizeString) {
            // null or empty string
            handlerCheck(false);
        }
        var size = Number(sizeString);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status_ = new ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    }
    else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) {
        throw serverFileWrongSize();
    }
    var bytesLeft = status_.total - status_.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status_.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status_.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status_.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        }
        else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Observer = /** @class */ (function () {
    function Observer(nextOrObserver, error, complete) {
        var asFunctions = isFunction(nextOrObserver) ||
            isDef(error) ||
            isDef(complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error || null;
            this.complete = complete || null;
        }
        else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}());

var UploadTaskSnapshot = /** @class */ (function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    return UploadTaskSnapshot;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        }
        catch (e) {
            if (e instanceof Error) {
                throw invalidArgument(i, name, e.message);
            }
            else {
                throw invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
var ArgSpec = /** @class */ (function () {
    function ArgSpec(validator, optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!optional;
    }
    return ArgSpec;
}());
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(validator, optional) {
    function stringValidator(p) {
        if (!isString(p)) {
            throw 'Expected string.';
        }
    }
    var chainedValidator;
    if (validator) {
        chainedValidator = and_(stringValidator, validator);
    }
    else {
        chainedValidator = stringValidator;
    }
    return new ArgSpec(chainedValidator, optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array ||
            p instanceof ArrayBuffer ||
            (isNativeBlobDefined() && p instanceof Blob);
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(optional) {
    return new ArgSpec(metadataValidator, optional);
}
function listOptionSpec(optional) {
    return new ArgSpec(listOptionsValidator, optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(validator, optional) {
    function isLooseObjectValidator(p) {
        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (validator !== undefined && validator !== null) {
            validator(p);
        }
    }
    return new ArgSpec(isLooseObjectValidator, optional);
}
function nullFunctionSpec(optional) {
    function validator(p) {
        var valid = p === null || isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, optional);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        // tslint:disable-next-line:no-floating-promises
        Promise.resolve().then(function () { return f.apply(void 0, argsToForward); });
    };
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
var UploadTask = /** @class */ (function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        var _this = this;
        if (metadata === void 0) { metadata = null; }
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(Code.CANCELED)) {
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.promise_ = new Promise(function (resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () { });
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded) { return _this.updateProgress_(sizeBefore + loaded); };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            }
            else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                }
                else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    }
                    else {
                        this.continueUpload_();
                    }
                }
            }
        }
        else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        // tslint:disable-next-line:no-floating-promises
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case InternalTaskState.CANCELING:
                    _this.transition_(InternalTaskState.CANCELED);
                    break;
                case InternalTaskState.PAUSING:
                    _this.transition_(InternalTaskState.PAUSED);
                    break;
                default:
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            }
            catch (e) {
                _this.error_ = e;
                _this.transition_(InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest
                .getPromise()
                .then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(InternalTaskState.SUCCESS);
                }
                else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            default: // Ignore
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case InternalTaskState.PAUSING:
                this.transition_(InternalTaskState.PAUSED);
                break;
            case InternalTaskState.CANCELING:
                this.transition_(InternalTaskState.CANCELED);
                break;
            case InternalTaskState.RUNNING:
                this.start_();
                break;
            default:
                // TODO(andysoto): assert(false);
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function () {
            var externalState = taskStateFromInternalTaskState(this.state_);
            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        function typeValidator() {
            if (type !== TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
            '`next`, `error`, `complete` properties.';
        var nextValidator = nullFunctionSpec(true).validator;
        var observerValidator = looseObjectSpec(null, true).validator;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            }
            catch (e) { }
            try {
                observerValidator(p);
                var anyDefined = isJustDef(p['next']) ||
                    isJustDef(p['error']) ||
                    isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            }
            catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            stringSpec(typeValidator),
            looseObjectSpec(nextOrObserverValidator, true),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, complete) {
                if (specs !== null) {
                    validate('on', specs, arguments);
                }
                var observer = new Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            looseObjectSpec(binderNextOrObserverValidator),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        var typeOnly = !(isJustDef(nextOrObserver) ||
            isJustDef(error) ||
            isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        }
        else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        var i = this.observers_.indexOf(observer);
        if (i !== -1) {
            this.observers_.splice(i, 1);
        }
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = this.observers_.slice();
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (taskStateFromInternalTaskState(this.state_)) {
                case TaskState.SUCCESS:
                    async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    var toCall = this.reject_;
                    async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next) {
                    async(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case TaskState.SUCCESS:
                if (observer.complete) {
                    async(observer.complete.bind(observer))();
                }
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error) {
                    async(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) {
                    async(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        validate('resume', [], arguments);
        var valid = this.state_ === InternalTaskState.PAUSED ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        validate('pause', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        validate('cancel', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
var Reference = /** @class */ (function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof Location) {
            this.location = location;
        }
        else {
            this.location = Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        validate('child', [stringSpec()], arguments);
        var newPath = child(this.location.path, childPath);
        var location = new Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function () {
            var newPath = parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function () {
            var location = new Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function () {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function () {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function () {
            return lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function () {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) { metadata = null; }
        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param value The string to upload.
     * @param format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (value, format, metadata) {
        if (format === void 0) { format = StringFormat.RAW; }
        validate('putString', [stringSpec(), stringSpec(formatValidator, true), metadataSpec(true)], arguments);
        this.throwIfRoot_('putString');
        var data = dataFromString(format, value);
        var metadataClone = Object.assign({}, metadata);
        if (!isDef(metadataClone['contentType']) &&
            isDef(data.contentType)) {
            metadataClone['contentType'] = data.contentType;
        }
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadataClone);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        var _this = this;
        validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = deleteObject(_this.authWrapper, _this.location);
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * List all items (files) and prefixes (folders) under this storage reference.
     *
     * This is a helper method for calling list() repeatedly until there are
     * no more results. The default pagination size is 1000.
     *
     * Note: The results may not be consistent if objects are changed while this
     * operation is running.
     *
     * Warning: listAll may potentially consume too many resources if there are
     * too many results.
     *
     * @return A Promise that resolves with all the items and prefixes under
     *      the current storage reference. `prefixes` contains references to
     *      sub-directories and `items` contains references to objects in this
     *      folder. `nextPageToken` is never returned.
     */
    Reference.prototype.listAll = function () {
        validate('listAll', [], arguments);
        var accumulator = {
            prefixes: [],
            items: []
        };
        return this.listAllHelper(accumulator).then(function () { return accumulator; });
    };
    Reference.prototype.listAllHelper = function (accumulator, pageToken) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
            var _a, _b, opt, nextPage;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __generator */])(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        opt = {
                            // maxResults is 1000 by default.
                            pageToken: pageToken
                        };
                        return [4 /*yield*/, this.list(opt)];
                    case 1:
                        nextPage = _c.sent();
                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
                        (_b = accumulator.items).push.apply(_b, nextPage.items);
                        if (!(nextPage.nextPageToken != null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.listAllHelper(accumulator, nextPage.nextPageToken)];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * List items (files) and prefixes (folders) under this storage reference.
     *
     * List API is only available for Firebase Rules Version 2.
     *
     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
     * delimited folder structure.
     * Refer to GCS's List API if you want to learn more.
     *
     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
     * support objects whose paths end with "/" or contain two consecutive
     * "/"s. Firebase Storage List API will filter these unsupported objects.
     * list() may fail if there are too many unsupported objects in the bucket.
     *
     * @param options See ListOptions for details.
     * @return A Promise that resolves with the items and prefixes.
     *      `prefixes` contains references to sub-folders and `items`
     *      contains references to objects in this folder. `nextPageToken`
     *      can be used to get the rest of the results.
     */
    Reference.prototype.list = function (options) {
        validate('list', [listOptionSpec(true)], arguments);
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var op = options || {};
            var requestInfo = list(self.authWrapper, self.location, 
            /*delimiter= */ '/', op.pageToken, op.maxResults);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        var _this = this;
        validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        var _this = this;
        validate('updateMetadata', [metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = updateMetadata(_this.authWrapper, _this.location, metadata, _this.mappings());
            return _this.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        var _this = this;
        validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getDownloadUrl(_this.authWrapper, _this.location, _this.mappings());
            return _this.authWrapper
                .makeRequest(requestInfo, authToken)
                .getPromise()
                .then(function (url) {
                if (url === null) {
                    throw noDownloadURL();
                }
                return url;
            });
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw invalidRootOperation(name);
        }
    };
    return Reference;
}());

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */ (function () {
    function FailRequest(error) {
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (_appDelete) {
        if (_appDelete === void 0) { _appDelete = false; }
    };
    return FailRequest;
}());

/**
 * @struct
 */
var RequestMap = /** @class */ (function () {
    function RequestMap() {
        this.map_ = new Map();
        this.id_ = MIN_SAFE_INTEGER;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     * @param r The request to register.
     */
    RequestMap.prototype.addRequest = function (r) {
        var _this = this;
        var id = this.id_;
        this.id_++;
        this.map_.set(id, r);
        r.getPromise().then(function () { return _this.map_.delete(id); }, function () { return _this.map_.delete(id); });
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        this.map_.forEach(function (val) {
            if (val) {
                val.cancel(true);
            }
        });
        this.map_.clear();
    };
    return RequestMap;
}());

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */ (function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = DEFAULT_MAX_OPERATION_RETRY_TIME;
        this.maxUploadRetryTime_ = DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this.requestMap_ = new RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[CONFIG_STORAGE_BUCKET_KEY] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null &&
            isDef(this.app_.INTERNAL) &&
            isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                }
                else {
                    return null;
                }
            }, function () { return null; });
        }
        else {
            return Promise.resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw appDeleted();
        }
        else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        }
        else {
            return new FailRequest(appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, arguments);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function handler(success) {
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.apply(null, arguments);
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.apply(null, arguments);
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        }
        else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        }
        else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */ (function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        var _this = this;
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        this.promise_ = new Promise(function (resolve, reject) {
            _this.resolve_ = resolve;
            _this.reject_ = reject;
            _this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled) {
            if (canceled) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            // tslint:disable-next-line:no-floating-promises
            xhr
                .send(self.url_, self.method_, self.body_, self.headers_)
                .then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = self.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve = self.resolve_;
            var reject = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (isJustDef(result)) {
                        resolve(result);
                    }
                    else {
                        resolve();
                    }
                }
                catch (e) {
                    reject(e);
                }
            }
            else {
                if (xhr !== null) {
                    var err = unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject(self.errorCallback_(xhr, err));
                    }
                    else {
                        reject(err);
                    }
                }
                else {
                    if (status.canceled) {
                        var err = self.appDelete_ ? appDeleted() : canceled();
                        reject(err);
                    }
                    else {
                        var err = retryLimitExceeded();
                        reject(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        }
        else {
            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}());
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
var RequestEndStatus = /** @class */ (function () {
    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!canceled;
    }
    return RequestEndStatus;
}());
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var version = typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = Object.assign({}, requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
var Service = /** @class */ (function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new Reference(authWrapper, loc);
        }
        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = Location.makeFromBucketSpec(url);
        }
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        validate('ref', [stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        }
        else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                Location.makeFromUrl(p);
            }
            catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        validate('refFromURL', [stringSpec(validator, false)], arguments);
        return new Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function () {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Service.prototype.setMaxOperationRetryTime = function (time) {
        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function () {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}());
/**
 * @struct
 */
var ServiceInternals = /** @class */ (function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return Promise.resolve();
    };
    return ServiceInternals;
}());

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage';
function factory(app, unused, url) {
    return new Service(app, new XhrIoPool(), url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: TaskState,
        TaskEvent: TaskEvent,
        StringFormat: StringFormat,
        Storage: Service,
        Reference: Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
    // Allow multiple storage instances per app.
    true);
}
registerStorage(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var firebase = _interopDefault(__webpack_require__(51));
var tslib_1 = __webpack_require__(1002);
var util = __webpack_require__(87);
__webpack_require__(1003);
var logger$1 = __webpack_require__(158);

var version = "0.2.10";

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SDK_VERSION = version;
/** The prefix for start User Timing marks used for creating Traces. */
var TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
/** The prefix for stop User Timing marks used for creating Traces. */
var TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
/** The prefix for User Timing measure used for creating Traces. */
var TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
/** The prefix for out of the box page load Trace name. */
var OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
var FIRST_PAINT_COUNTER_NAME = '_fp';
var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
var FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
var SERVICE = 'performance';
var SERVICE_NAME = 'Performance';

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["trace started" /* TRACE_STARTED_BEFORE */] = 'Trace {$traceName} was started before.',
    _a["trace stopped" /* TRACE_STOPPED_BEFORE */] = 'Trace {$traceName} is not running.',
    _a["no window" /* NO_WINDOW */] = 'Window is not available.',
    _a["no app id" /* NO_APP_ID */] = 'App id is not available.',
    _a["no project id" /* NO_PROJECT_ID */] = 'Project id is not available.',
    _a["no api key" /* NO_API_KEY */] = 'Api key is not available.',
    _a["invalid cc log" /* INVALID_CC_LOG */] = 'Attempted to queue invalid cc event',
    _a["FB not default" /* FB_NOT_DEFAULT */] = 'Performance can only start when Firebase app instance is the default one.',
    _a["RC response not ok" /* RC_NOT_OK */] = 'RC response is not ok',
    _a);
var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var apiInstance;
var windowInstance;
/**
 * This class holds a reference to various browser related objects injected by set methods.
 */
var Api = /** @class */ (function () {
    function Api(window) {
        if (!window) {
            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
        }
        this.performance = window.performance;
        this.PerformanceObserver = window.PerformanceObserver;
        this.windowLocation = window.location;
        this.navigator = window.navigator;
        this.document = window.document;
        if (this.navigator && this.navigator.cookieEnabled) {
            // If user blocks cookies on the browser, accessing localStorage will throw an exception.
            this.localStorage = window.localStorage;
        }
        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
            this.onFirstInputDelay = window.perfMetrics.onFirstInputDelay;
        }
    }
    Api.prototype.getUrl = function () {
        // Do not capture the string query part of url.
        return this.windowLocation.href.split('?')[0];
    };
    Api.prototype.mark = function (name) {
        if (!this.performance || !this.performance.mark) {
            return;
        }
        this.performance.mark(name);
    };
    Api.prototype.measure = function (measureName, mark1, mark2) {
        if (!this.performance || !this.performance.measure) {
            return;
        }
        this.performance.measure(measureName, mark1, mark2);
    };
    Api.prototype.getEntriesByType = function (type) {
        if (!this.performance || !this.performance.getEntriesByType) {
            return [];
        }
        return this.performance.getEntriesByType(type);
    };
    Api.prototype.getEntriesByName = function (name) {
        if (!this.performance || !this.performance.getEntriesByName) {
            return [];
        }
        return this.performance.getEntriesByName(name);
    };
    Api.prototype.getTimeOrigin = function () {
        // Polyfill the time origin with performance.timing.navigationStart.
        return (this.performance &&
            (this.performance.timeOrigin || this.performance.timing.navigationStart));
    };
    Api.prototype.requiredApisAvailable = function () {
        if (fetch && Promise && this.navigator && this.navigator.cookieEnabled) {
            return true;
        }
        return false;
    };
    Api.prototype.setupObserver = function (entryType, callback) {
        if (!this.PerformanceObserver) {
            return;
        }
        var observer = new this.PerformanceObserver(function (list) {
            for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
                var entry = _a[_i];
                // `entry` is a PerformanceEntry instance.
                callback(entry);
            }
        });
        // Start observing the entry types you care about.
        observer.observe({ entryTypes: [entryType] });
    };
    Api.getInstance = function () {
        if (apiInstance === undefined) {
            apiInstance = new Api(windowInstance);
        }
        return apiInstance;
    };
    return Api;
}());
function setupApi(window) {
    windowInstance = window;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var settingsServiceInstance;
var SettingsService = /** @class */ (function () {
    function SettingsService() {
        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
        this.instrumentationEnabled = true;
        // The variable which controls logging of custom traces.
        this.dataCollectionEnabled = true;
        // Configuration flags set through remote config.
        this.loggingEnabled = false;
        // Sampling rate between 0 and 1.
        this.tracesSamplingRate = 1;
        this.networkRequestsSamplingRate = 1;
        // Address of logging service.
        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
        this.logSource = 462;
        // Flags which control per session logging of traces and network requests.
        this.logTraceAfterSampling = false;
        this.logNetworkAfterSampling = false;
        // TTL of config retrieved from remote config in hours.
        this.configTimeToLive = 12;
    }
    SettingsService.prototype.getAppId = function () {
        var appId = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.appId;
        if (!appId) {
            throw ERROR_FACTORY.create("no app id" /* NO_APP_ID */);
        }
        return appId;
    };
    SettingsService.prototype.getProjectId = function () {
        var projectId = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.projectId;
        if (!projectId) {
            throw ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */);
        }
        return projectId;
    };
    SettingsService.prototype.getApiKey = function () {
        var apiKey = this.firebaseAppInstance &&
            this.firebaseAppInstance.options &&
            this.firebaseAppInstance.options.apiKey;
        if (!apiKey) {
            throw ERROR_FACTORY.create("no api key" /* NO_API_KEY */);
        }
        return apiKey;
    };
    SettingsService.getInstance = function () {
        if (settingsServiceInstance === undefined) {
            settingsServiceInstance = new SettingsService();
        }
        return settingsServiceInstance;
    };
    return SettingsService;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var iid;
function getIidPromise() {
    var iidPromise = SettingsService.getInstance()
        .firebaseAppInstance.installations()
        .getId();
    // tslint:disable-next-line:no-floating-promises
    iidPromise.then(function (iidVal) {
        iid = iidVal;
    });
    return iidPromise;
}
// This method should be used after the iid is retrieved by getIidPromise method.
function getIid() {
    return iid;
}
function getAuthTokenPromise() {
    var authTokenPromise = SettingsService.getInstance()
        .firebaseAppInstance.installations()
        .getToken();
    // tslint:disable-next-line:no-floating-promises
    authTokenPromise.then(function (authTokenVal) {
    });
    return authTokenPromise;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VisibilityState;
(function (VisibilityState) {
    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
    VisibilityState[VisibilityState["PRERENDER"] = 3] = "PRERENDER";
    VisibilityState[VisibilityState["UNLOADED"] = 4] = "UNLOADED";
})(VisibilityState || (VisibilityState = {}));
function getServiceWorkerStatus() {
    var navigator = Api.getInstance().navigator;
    if ('serviceWorker' in navigator) {
        if (navigator.serviceWorker.controller) {
            return 2 /* CONTROLLED */;
        }
        else {
            return 3 /* UNCONTROLLED */;
        }
    }
    else {
        return 1 /* UNSUPPORTED */;
    }
}
function getVisibilityState() {
    var document = Api.getInstance().document;
    var visibilityState = document.visibilityState;
    switch (visibilityState) {
        case 'visible':
            return VisibilityState.VISIBLE;
        case 'hidden':
            return VisibilityState.HIDDEN;
        case 'prerender':
            return VisibilityState.PRERENDER;
        default:
            return VisibilityState.UNKNOWN;
    }
}
function getEffectiveConnectionType() {
    var navigator = Api.getInstance().navigator;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var navigatorConnection = navigator.connection;
    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
    switch (effectiveType) {
        case 'slow-2g':
            return 1 /* CONNECTION_SLOW_2G */;
        case '2g':
            return 2 /* CONNECTION_2G */;
        case '3g':
            return 3 /* CONNECTION_3G */;
        case '4g':
            return 4 /* CONNECTION_4G */;
        default:
            return 0 /* UNKNOWN */;
    }
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var consoleLogger = new logger$1.Logger(SERVICE_NAME);
consoleLogger.logLevel = logger$1.LogLevel.INFO;

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var REMOTE_CONFIG_SDK_VERSION = '0.0.1';
// These values will be used if the remote config object is successfully
// retrieved, but the template does not have these fields.
var SECONDARY_CONFIGS = {
    loggingEnabled: true
};
var FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
function getConfig(iid) {
    var config = getStoredConfig();
    if (config) {
        processConfig(config);
        return Promise.resolve();
    }
    return getRemoteConfig(iid)
        .then(function (config) { return processConfig(config); })
        .then(function (config) { return storeConfig(config); }, 
    /** Do nothing for error, use defaults set in settings service. */ function () { });
}
function getStoredConfig() {
    var localStorage = Api.getInstance().localStorage;
    var expiryString = localStorage.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
    if (!expiryString || !configValid(expiryString)) {
        return;
    }
    var configStringified = localStorage.getItem(CONFIG_LOCAL_STORAGE_KEY);
    if (!configStringified) {
        return;
    }
    try {
        var configResponse = JSON.parse(configStringified);
        return configResponse;
    }
    catch (_a) {
        return;
    }
}
function storeConfig(config) {
    if (!config) {
        return;
    }
    var localStorage = Api.getInstance().localStorage;
    localStorage.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
    localStorage.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() +
        SettingsService.getInstance().configTimeToLive * 60 * 60 * 1000));
}
var COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
function getRemoteConfig(iid) {
    // Perf needs auth token only to retrieve remote config.
    return getAuthTokenPromise()
        .then(function (authToken) {
        var projectId = SettingsService.getInstance().getProjectId();
        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
        var request = new Request(configEndPoint, {
            method: 'POST',
            headers: {
                Authorization: FIS_AUTH_PREFIX + " " + authToken
            },
            /* eslint-disable camelcase */
            body: JSON.stringify({
                app_instance_id: iid,
                app_instance_id_token: authToken,
                app_id: SettingsService.getInstance().getAppId(),
                app_version: SDK_VERSION,
                sdk_version: REMOTE_CONFIG_SDK_VERSION
            })
            /* eslint-enable camelcase */
        });
        return fetch(request).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            // In case response is not ok. This will be caught by catch.
            throw ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */);
        });
    })
        .catch(function () {
        consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
        return undefined;
    });
}
/**
 * Processes config coming either from calling RC or from local storage.
 * This method only runs if call is successful or config in storage
 * is valie.
 */
function processConfig(config) {
    if (!config) {
        return config;
    }
    var settingsServiceInstance = SettingsService.getInstance();
    var entries = config.entries || {};
    if (entries.fpr_enabled !== undefined) {
        // TODO: Change the assignment of loggingEnabled once the received type is known.
        settingsServiceInstance.loggingEnabled =
            String(entries.fpr_enabled) === 'true';
    }
    else {
        // Config retrieved successfully, but there is no fpr_enabled in template.
        // Use secondary configs value.
        settingsServiceInstance.loggingEnabled = SECONDARY_CONFIGS.loggingEnabled;
    }
    if (entries.fpr_log_source) {
        settingsServiceInstance.logSource = Number(entries.fpr_log_source);
    }
    if (entries.fpr_log_endpoint_url) {
        settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
    }
    if (entries.fpr_vc_network_request_sampling_rate !== undefined) {
        settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
    }
    if (entries.fpr_vc_trace_sampling_rate !== undefined) {
        settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
    }
    // Set the per session trace and network logging flags.
    settingsServiceInstance.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
    settingsServiceInstance.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
    return config;
}
function configValid(expiry) {
    return Number(expiry) > Date.now();
}
function shouldLogAfterSampling(samplingRate) {
    return Math.random() <= samplingRate;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initializationStatus = 1 /* notInitialized */;
var initializationPromise;
function getInitializationPromise() {
    initializationStatus = 2 /* initializationPending */;
    initializationPromise = initializationPromise || initializePerf();
    return initializationPromise;
}
function isPerfInitialized() {
    return initializationStatus === 3 /* initialized */;
}
function initializePerf() {
    return getDocumentReadyComplete()
        .then(function () { return getIidPromise(); })
        .then(function (iid) { return getConfig(iid); })
        .then(function () { return changeInitializationStatus(); }, function () { return changeInitializationStatus(); });
}
/**
 * Returns a promise which resolves whenever the document readystate is complete or
 * immediately if it is called after page load complete.
 */
function getDocumentReadyComplete() {
    var document = Api.getInstance().document;
    return new Promise(function (resolve) {
        if (document && document.readyState !== 'complete') {
            var handler_1 = function () {
                if (document.readyState === 'complete') {
                    document.removeEventListener('readystatechange', handler_1);
                    resolve();
                }
            };
            document.addEventListener('readystatechange', handler_1);
        }
        else {
            resolve();
        }
    });
}
function changeInitializationStatus() {
    initializationStatus = 3 /* initialized */;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SEND_INTERVAL_MS = 10 * 1000;
var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1000;
// If end point does not work, the call will be tried for these many times.
var DEFAULT_REMAINING_TRIES = 3;
var remainingTries = DEFAULT_REMAINING_TRIES;
/* eslint-enable camelcase */
var queue = [];
function processQueue(timeOffset) {
    setTimeout(function () {
        // If there is no remainingTries left, stop retrying.
        if (remainingTries === 0) {
            return;
        }
        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
        if (!queue.length) {
            return processQueue(DEFAULT_SEND_INTERVAL_MS);
        }
        // Capture a snapshot of the queue and empty the "official queue".
        var staged = queue.slice();
        queue = [];
        /* eslint-disable camelcase */
        // We will pass the JSON serialized event to the backend.
        var log_event = staged.map(function (evt) { return ({
            source_extension_json: evt.message,
            event_time_ms: String(evt.eventTime)
        }); });
        var data = {
            request_time_ms: String(Date.now()),
            client_info: {
                client_type: 1,
                js_client_info: {}
            },
            log_source: SettingsService.getInstance().logSource,
            log_event: log_event
        };
        /* eslint-enable camelcase */
        fetch(SettingsService.getInstance().logEndPointUrl, {
            method: 'POST',
            body: JSON.stringify(data)
        })
            .then(function (res) {
            if (!res.ok) {
                consoleLogger.info('Call to Firebase backend failed.');
            }
            return res.json();
        })
            .then(function (res) {
            var wait = Number(res.next_request_wait_millis);
            // Find the next call wait time from the response.
            var requestOffset = isNaN(wait)
                ? DEFAULT_SEND_INTERVAL_MS
                : Math.max(DEFAULT_SEND_INTERVAL_MS, wait);
            remainingTries = DEFAULT_REMAINING_TRIES;
            // Schedule the next process.
            processQueue(requestOffset);
        })
            .catch(function () {
            /**
             * If the request fails for some reason, add the events that were attempted
             * back to the primary queue to retry later.
             */
            queue = staged.concat(queue);
            remainingTries--;
            consoleLogger.info("Tries left: " + remainingTries + ".");
            processQueue(DEFAULT_SEND_INTERVAL_MS);
        });
    }, timeOffset);
}
processQueue(INITIAL_SEND_TIME_DELAY_MS);
function addToQueue(evt) {
    if (!evt.eventTime || !evt.message) {
        throw ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */);
    }
    // Add the new event to the queue.
    queue = queue.concat([evt]);
}
/** Log handler for cc service to send the performance logs to the server. */
function ccHandler(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
serializer) {
    // The underscores for loggerInstance and level parameters are added to avoid the
    // noUnusedParameters related error.
    return function (_loggerInstance, _level) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var message = serializer.apply(void 0, args);
        addToQueue({
            message: message,
            eventTime: Date.now()
        });
    };
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-enble camelcase */
var logger;
// This method is not called before initialization.
function getLogger() {
    if (logger) {
        return logger;
    }
    var ccLogger = ccHandler(serializer);
    logger = new logger$1.Logger('@firebase/performance/cc');
    logger.logHandler = ccLogger;
    return logger;
}
function logTrace(trace) {
    var settingsService = SettingsService.getInstance();
    // Do not log if trace is auto generated and instrumentation is disabled.
    if (!settingsService.instrumentationEnabled && trace.isAuto) {
        return;
    }
    // Do not log if trace is custom and data collection is disabled.
    if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
        return;
    }
    // Do not log if required apis are not available.
    if (!Api.getInstance().requiredApisAvailable()) {
        return;
    }
    // Only log the page load auto traces if page is visible.
    if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
        return;
    }
    if (!settingsService.loggingEnabled ||
        !settingsService.logTraceAfterSampling) {
        return;
    }
    if (isPerfInitialized()) {
        sendTraceLog(trace);
    }
    else {
        // Custom traces can be used before the initialization but logging
        // should wait until after.
        getInitializationPromise().then(function () { return sendTraceLog(trace); }, function () { return sendTraceLog(trace); });
    }
}
function sendTraceLog(trace) {
    if (getIid()) {
        setTimeout(function () { return getLogger().log(trace, 1 /* Trace */); }, 0);
    }
}
function logNetworkRequest(networkRequest) {
    var settingsService = SettingsService.getInstance();
    // Do not log network requests if instrumentation is disabled.
    if (!settingsService.instrumentationEnabled) {
        return;
    }
    // Do not log the js sdk's call to cc service to avoid unnecessary cycle.
    if (networkRequest.url === settingsService.logEndPointUrl.split('?')[0]) {
        return;
    }
    if (!settingsService.loggingEnabled ||
        !settingsService.logNetworkAfterSampling) {
        return;
    }
    setTimeout(function () { return getLogger().log(networkRequest, 0 /* NetworkRequest */); }, 0);
}
function serializer(resource, resourceType) {
    if (resourceType === 0 /* NetworkRequest */) {
        return serializeNetworkRequest(resource);
    }
    return serializeTrace(resource);
}
function serializeNetworkRequest(networkRequest) {
    var networkRequestMetric = {
        url: networkRequest.url,
        http_method: networkRequest.httpMethod || 0,
        http_response_code: 200,
        response_payload_bytes: networkRequest.responsePayloadBytes,
        client_start_time_us: networkRequest.startTimeUs,
        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
    };
    var perfMetric = {
        application_info: getApplicationInfo(),
        network_request_metric: networkRequestMetric
    };
    return JSON.stringify(perfMetric);
}
function serializeTrace(trace) {
    var traceMetric = {
        name: trace.name,
        is_auto: trace.isAuto,
        client_start_time_us: trace.startTimeUs,
        duration_us: trace.durationUs
    };
    if (Object.keys(trace.counters).length !== 0) {
        traceMetric.counters = convertToKeyValueArray(trace.counters);
    }
    var customAttributes = trace.getAttributes();
    if (Object.keys(customAttributes).length !== 0) {
        traceMetric.custom_attributes = convertToKeyValueArray(customAttributes);
    }
    var perfMetric = {
        application_info: getApplicationInfo(),
        trace_metric: traceMetric
    };
    return JSON.stringify(perfMetric);
}
function getApplicationInfo() {
    return {
        google_app_id: SettingsService.getInstance().getAppId(),
        app_instance_id: getIid(),
        web_app_info: {
            sdk_version: SDK_VERSION,
            page_url: Api.getInstance().getUrl(),
            service_worker_status: getServiceWorkerStatus(),
            visibility_state: getVisibilityState(),
            effective_connection_type: getEffectiveConnectionType()
        },
        application_process_state: 0
    };
}
function convertToKeyValueArray(obj) {
    var keys = Object.keys(obj);
    return keys.map(function (key) { return ({ key: key, value: obj[key] }); });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Trace = /** @class */ (function () {
    /**
     * @param name The name of the trace.
     * @param isAuto If the trace is auto-instrumented.
     * @param traceMeasureName The name of the measure marker in user timing specification. This field
     * is only set when the trace is built for logging when the user directly uses the user timing
     * api (performance.mark and performance.measure).
     */
    function Trace(name, isAuto, traceMeasureName) {
        if (isAuto === void 0) { isAuto = false; }
        this.name = name;
        this.isAuto = isAuto;
        this.state = 1 /* UNINITIALIZED */;
        this.customAttributes = {};
        this.counters = {};
        this.api = Api.getInstance();
        this.randomId = Math.floor(Math.random() * 1000000);
        if (!this.isAuto) {
            this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
            this.traceMeasure =
                traceMeasureName ||
                    TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
            if (traceMeasureName) {
                // For the case of direct user timing traces, no start stop will happen. The measure object
                // is already available.
                this.calculateTraceMetrics();
            }
        }
    }
    /**
     * Starts a trace. The measurement of the duration starts at this point.
     */
    Trace.prototype.start = function () {
        if (this.state !== 1 /* UNINITIALIZED */) {
            throw ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */, {
                traceName: this.name
            });
        }
        this.api.mark(this.traceStartMark);
        this.state = 2 /* RUNNING */;
    };
    /**
     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
     * is logged.
     */
    Trace.prototype.stop = function () {
        if (this.state !== 2 /* RUNNING */) {
            throw ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */, {
                traceName: this.name
            });
        }
        this.state = 3 /* TERMINATED */;
        this.api.mark(this.traceStopMark);
        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
        this.calculateTraceMetrics();
        logTrace(this);
    };
    /**
     * Records a trace with predetermined values. If this method is used a trace is created and logged
     * directly. No need to use start and stop methods.
     * @param startTime Trace start time since epoch in millisec
     * @param duration The duraction of the trace in millisec
     * @param options An object which can optionally hold maps of custom metrics and custom attributes
     */
    Trace.prototype.record = function (startTime, duration, options) {
        this.durationUs = Math.floor(duration * 1000);
        this.startTimeUs = Math.floor(startTime * 1000);
        if (options && options.attributes) {
            this.customAttributes = tslib_1.__assign({}, options.attributes);
        }
        if (options && options.metrics) {
            for (var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++) {
                var metric = _a[_i];
                if (!isNaN(Number(options.metrics[metric]))) {
                    this.counters[metric] = Number(Math.floor(options.metrics[metric]));
                }
            }
        }
        logTrace(this);
    };
    /**
     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
     * custom metric if one with the given name does not exist.
     * @param counter Name of the custom metric
     * @param num Increment by value
     */
    Trace.prototype.incrementMetric = function (counter, num) {
        if (num === void 0) { num = 1; }
        if (this.counters[counter] === undefined) {
            this.counters[counter] = 0;
        }
        this.counters[counter] += num;
    };
    /**
     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
     * given name does not exist.
     * @param counter Name of the custom metric
     * @param num Set custom metric to this value
     */
    Trace.prototype.putMetric = function (counter, num) {
        this.counters[counter] = num;
    };
    /**
     * Returns the value of the custom metric by that name. If a custom metric with that name does
     * not exist will return zero.
     * @param counter
     */
    Trace.prototype.getMetric = function (counter) {
        return this.counters[counter] || 0;
    };
    /**
     * Sets a custom attribute of a trace to a certain value.
     * @param attr
     * @param value
     */
    Trace.prototype.putAttribute = function (attr, value) {
        this.customAttributes[attr] = value;
    };
    /**
     * Retrieves the value a custom attribute of a trace is set to.
     * @param attr
     */
    Trace.prototype.getAttribute = function (attr) {
        return this.customAttributes[attr];
    };
    Trace.prototype.removeAttribute = function (attr) {
        if (this.customAttributes[attr] === undefined) {
            return;
        }
        delete this.customAttributes[attr];
    };
    Trace.prototype.getAttributes = function () {
        return tslib_1.__assign({}, this.customAttributes);
    };
    Trace.prototype.setStartTime = function (startTime) {
        this.startTimeUs = startTime;
    };
    Trace.prototype.setDuration = function (duration) {
        this.durationUs = duration;
    };
    /**
     * Calculates and assigns the duration and start time of the trace using the measure performance
     * entry.
     */
    Trace.prototype.calculateTraceMetrics = function () {
        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
        if (perfMeasureEntry) {
            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
        }
    };
    /**
     * @param navigationTimings A single element array which contains the navigationTIming object of
     * the page load
     * @param paintTimings A array which contains paintTiming object of the page load
     * @param firstInputDelay First input delay in millisec
     */
    Trace.createOobTrace = function (navigationTimings, paintTimings, firstInputDelay) {
        var route = Api.getInstance().getUrl();
        if (!route) {
            return;
        }
        var trace = new Trace(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
        var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1000);
        trace.setStartTime(timeOriginUs);
        // navigationTimings includes only one element.
        if (navigationTimings && navigationTimings[0]) {
            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
            trace.incrementMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
            trace.incrementMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
            trace.incrementMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
        }
        var FIRST_PAINT = 'first-paint';
        var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
        if (paintTimings) {
            var firstPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_PAINT; });
            if (firstPaint && firstPaint.startTime) {
                trace.incrementMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
            }
            var firstContentfulPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_CONTENTFUL_PAINT; });
            if (firstContentfulPaint && firstContentfulPaint.startTime) {
                trace.incrementMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
            }
            if (firstInputDelay) {
                trace.incrementMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
            }
        }
        logTrace(trace);
    };
    Trace.createUserTimingTrace = function (measureName) {
        var trace = new Trace(measureName, false, measureName);
        logTrace(trace);
    };
    return Trace;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createNetworkRequestEntry(entry) {
    var performanceEntry = entry;
    if (!performanceEntry || performanceEntry.responseStart === undefined) {
        return;
    }
    var timeOrigin = Api.getInstance().getTimeOrigin();
    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
    var timeToResponseInitiatedUs = performanceEntry.responseStart
        ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000)
        : undefined;
    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
    // Remove the query params from logged network request url.
    var url = performanceEntry.name && performanceEntry.name.split('?')[0];
    var networkRequest = {
        url: url,
        responsePayloadBytes: performanceEntry.transferSize,
        startTimeUs: startTimeUs,
        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
        timeToResponseCompletedUs: timeToResponseCompletedUs
    };
    logNetworkRequest(networkRequest);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FID_WAIT_TIME_MS = 5000;
function setupOobResources() {
    // Do not initialize unless iid is available.
    if (!getIid()) {
        return;
    }
    // The load event might not have fired yet, and that means performance navigation timing
    // object has a duration of 0. The setup should run after all current tasks in js queue.
    setTimeout(function () { return setupOobTraces(); }, 0);
    setTimeout(function () { return setupNetworkRequests(); }, 0);
    setTimeout(function () { return setupUserTimingTraces(); }, 0);
}
function setupNetworkRequests() {
    var api = Api.getInstance();
    var resources = api.getEntriesByType('resource');
    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
        var resource = resources_1[_i];
        createNetworkRequestEntry(resource);
    }
    api.setupObserver('resource', createNetworkRequestEntry);
}
function setupOobTraces() {
    var api = Api.getInstance();
    var navigationTimings = api.getEntriesByType('navigation');
    var paintTimings = api.getEntriesByType('paint');
    // If First Input Desly polyfill is added to the page, report the fid value.
    // https://github.com/GoogleChromeLabs/first-input-delay
    if (api.onFirstInputDelay) {
        // If the fid call back is not called for certain time, continue without it.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var timeoutId_1 = setTimeout(function () {
            Trace.createOobTrace(navigationTimings, paintTimings);
            timeoutId_1 = undefined;
        }, FID_WAIT_TIME_MS);
        api.onFirstInputDelay(function (fid) {
            if (timeoutId_1) {
                clearTimeout(timeoutId_1);
                Trace.createOobTrace(navigationTimings, paintTimings, fid);
            }
        });
    }
    else {
        Trace.createOobTrace(navigationTimings, paintTimings);
    }
}
function setupUserTimingTraces() {
    var api = Api.getInstance();
    // Run through the measure performance entries collected up to this point.
    var measures = api.getEntriesByType('measure');
    for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
        var measure = measures_1[_i];
        createUserTimingTrace(measure);
    }
    // Setup an observer to capture the measures from this point on.
    api.setupObserver('measure', createUserTimingTrace);
}
function createUserTimingTrace(measure) {
    var measureName = measure.name;
    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
    if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) ===
        TRACE_MEASURE_PREFIX) {
        return;
    }
    Trace.createUserTimingTrace(measureName);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PerformanceController = /** @class */ (function () {
    function PerformanceController(app) {
        this.app = app;
        if (Api.getInstance().requiredApisAvailable()) {
            getInitializationPromise().then(setupOobResources, setupOobResources);
        }
        else {
            consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
        }
    }
    PerformanceController.prototype.trace = function (name) {
        return new Trace(name);
    };
    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
        get: function () {
            return SettingsService.getInstance().instrumentationEnabled;
        },
        set: function (val) {
            SettingsService.getInstance().instrumentationEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
        get: function () {
            return SettingsService.getInstance().dataCollectionEnabled;
        },
        set: function (val) {
            SettingsService.getInstance().dataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    return PerformanceController;
}());

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
function registerPerformance(instance) {
    var factoryMethod = function (app) {
        if (app.name !== DEFAULT_ENTRY_NAME) {
            throw ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */);
        }
        SettingsService.getInstance().firebaseAppInstance = app;
        return new PerformanceController(app);
    };
    // Register performance with firebase-app.
    var namespaceExports = {};
    instance.INTERNAL.registerService('performance', factoryMethod, namespaceExports);
}
setupApi(window);
registerPerformance(firebase);

exports.registerPerformance = registerPerformance;
//# sourceMappingURL=index.cjs.js.map


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerInstallations", function() { return registerInstallations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idb__);






var version = "0.1.7";

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 10000;
var PACKAGE_VERSION = "w:" + version;
var INTERNAL_AUTH_VERSION = 'FIS_v2';
var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
var SERVICE = 'installations';
var SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERROR_DESCRIPTION_MAP = (_a = {},
    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration values.',
    _a["create-installation-failed" /* CREATE_INSTALLATION_FAILED */] = 'Could not register Firebase Installation.',
    _a["generate-token-failed" /* GENERATE_TOKEN_FAILED */] = 'Could not generate Auth Token.',
    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
    _a);
var ERROR_FACTORY = new __WEBPACK_IMPORTED_MODULE_2__firebase_util__["ErrorFactory"](SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return (error instanceof __WEBPACK_IMPORTED_MODULE_2__firebase_util__["FirebaseError"] &&
        error.code.includes("request-failed" /* REQUEST_FAILED */));
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */);
    }
    var appName = app.name;
    var _a = app.options, projectId = _a.projectId, apiKey = _a.apiKey, appId = _a.appId;
    if (!appName || !projectId || !apiKey || !appId) {
        throw ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */);
    }
    return { appName: appName, projectId: projectId, apiKey: apiKey, appId: appId };
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_a) {
    var projectId = _a.projectId;
    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
function getErrorFromResponse(requestName, response) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var responseJson, errorData;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, response.json()];
                case 1:
                    responseJson = _a.sent();
                    errorData = responseJson.error;
                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        })];
            }
        });
    });
}
function getHeaders(_a) {
    var apiKey = _a.apiKey;
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, _a) {
    var refreshToken = _a.refreshToken;
    var headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
function retryIfServerError(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var result;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    if (result.status >= 500 && result.status < 600) {
                        // Internal Server Error. Retry request.
                        return [2 /*return*/, fn()];
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return INTERNAL_AUTH_VERSION + " " + refreshToken;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createInstallation(appConfig, _a) {
    var fid = _a.fid;
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = getInstallationsEndpoint(appConfig);
                    headers = getHeaders(appConfig);
                    body = {
                        fid: fid,
                        authVersion: INTERNAL_AUTH_VERSION,
                        appId: appConfig.appId,
                        sdkVersion: PACKAGE_VERSION
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _b.sent();
                    registeredInstallationEntry = {
                        fid: fid,
                        registrationStatus: 2 /* COMPLETED */,
                        refreshToken: responseValue.refreshToken,
                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
                    };
                    return [2 /*return*/, registeredInstallationEntry];
                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
                case 4: throw _b.sent();
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */
function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(buffer) {
    var array = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
    var b64 = btoa(String.fromCharCode.apply(String, Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["d" /* __spread */])(array)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Generates a new FID using random values from Web Crypto API. */
function generateFid() {
    // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
    // bytes. our implementation generates a 17 byte array instead.
    var fidByteArray = new Uint8Array(17);
    crypto.getRandomValues(fidByteArray);
    // Replace the first 4 random bits with the constant FID header of 0b0111.
    fidByteArray[0] = 112 + (fidByteArray[0] % 16);
    return encode(fidByteArray);
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    var b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = 'firebase-installations-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-installations-store';
var dbPromise = Object(__WEBPACK_IMPORTED_MODULE_3_idb__["openDb"])(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
    // We don't use 'break' in this switch statement, the fall-through
    // behavior is what we want, because if there are multiple versions between
    // the old version and the current version, we want ALL the migrations
    // that correspond to those versions to run, not only the last one.
    // eslint-disable-next-line default-case
    switch (upgradeDB.oldVersion) {
        case 0:
            upgradeDB.createObjectStore(OBJECT_STORE_NAME);
    }
});
/** Assigns or overwrites the record for the given key with the given value. */
function set(appConfig, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, dbPromise];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(value, key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/, value];
            }
        });
    });
}
/** Removes record(s) from the objectStore that match the given key. */
function remove(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var key, db, tx;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, dbPromise];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, tx.complete];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */
function update(appConfig, updateFn) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var key, db, tx, store, oldValue, newValue;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    key = getKey(appConfig);
                    return [4 /*yield*/, dbPromise];
                case 1:
                    db = _a.sent();
                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                    store = tx.objectStore(OBJECT_STORE_NAME);
                    return [4 /*yield*/, store.get(key)];
                case 2:
                    oldValue = _a.sent();
                    newValue = updateFn(oldValue);
                    if (newValue === oldValue) {
                        return [2 /*return*/, newValue];
                    }
                    if (!(newValue === undefined)) return [3 /*break*/, 4];
                    return [4 /*yield*/, store.delete(key)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, store.put(newValue, key)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [4 /*yield*/, tx.complete];
                case 7:
                    _a.sent();
                    return [2 /*return*/, newValue];
            }
        });
    });
}
function getKey(appConfig) {
    return appConfig.appName + "!" + appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */
function getInstallationEntry(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var registrationPromise, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
                            var installationEntry = updateOrCreateFid(oldEntry);
                            var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        })];
                case 1: return [2 /*return*/, (_a.installationEntry = _b.sent(),
                        _a.registrationPromise = registrationPromise,
                        _a)];
            }
        });
    });
}
function updateOrCreateFid(oldEntry) {
    var entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* NOT_STARTED */
    };
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* NOT_STARTED */
        };
    }
    return entry;
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the registration
 * and return an InProgressInstallationEntry.
 */
function triggerRegistrationIfNecessary(appConfig, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
            return {
                installationEntry: installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        var inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* IN_PROGRESS */,
            registrationTime: Date.now()
        };
        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
    }
    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
        return {
            installationEntry: installationEntry,
            registrationPromise: waitUntilFidRegistration(appConfig)
        };
    }
    else {
        return { installationEntry: installationEntry };
    }
}
/** This will be executed only once for each new Firebase Installation. */
function registerInstallation(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var registeredInstallationEntry, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 8]);
                    return [4 /*yield*/, createInstallation(appConfig, installationEntry)];
                case 1:
                    registeredInstallationEntry = _a.sent();
                    return [4 /*yield*/, set(appConfig, registeredInstallationEntry)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 3:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 5];
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 4:
                    // Server returned a "FID can not be used" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5: 
                // Registration failed. Set FID as not registered.
                return [4 /*yield*/, set(appConfig, {
                        fid: installationEntry.fid,
                        registrationStatus: 0 /* NOT_STARTED */
                    })];
                case 6:
                    // Registration failed. Set FID as not registered.
                    _a.sent();
                    _a.label = 7;
                case 7: throw e_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
/** Call if FID registration is pending. */
function waitUntilFidRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var entry;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // createInstallation request still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // createInstallation request still in progress.
                    _a.sent();
                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
                case 4:
                    entry = _a.sent();
                    return [3 /*break*/, 2];
                case 5:
                    if (entry.registrationStatus === 0 /* NOT_STARTED */) {
                        throw ERROR_FACTORY.create("create-installation-failed" /* CREATE_INSTALLATION_FAILED */);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */
function updateInstallationRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
        }
        if (hasInstallationRequestTimedOut(oldEntry)) {
            return {
                fid: oldEntry.fid,
                registrationStatus: 0 /* NOT_STARTED */
            };
        }
        return oldEntry;
    });
}
function hasInstallationRequestTimedOut(installationEntry) {
    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function generateAuthToken(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var endpoint, headers, body, request, response, responseValue, completedAuthToken;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    body = {
                        installation: {
                            sdkVersion: PACKAGE_VERSION
                        }
                    };
                    request = {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(body)
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    responseValue = _a.sent();
                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
                    return [2 /*return*/, completedAuthToken];
                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
                case 4: throw _a.sent();
            }
        });
    });
}
function getGenerateAuthTokenEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
function refreshAuthToken(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var tokenPromise, entry, authToken, _a;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
                        if (!isEntryRegistered(oldEntry)) {
                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
                        }
                        var oldAuthToken = oldEntry.authToken;
                        if (isAuthTokenValid(oldAuthToken)) {
                            // There is a valid token in the DB.
                            return oldEntry;
                        }
                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
                            // There already is a token request in progress.
                            tokenPromise = waitUntilAuthTokenRequest(appConfig);
                            return oldEntry;
                        }
                        else {
                            // No token or token expired.
                            if (!navigator.onLine) {
                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                            }
                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
                            tokenPromise = fetchAuthTokenFromServer(appConfig, inProgressEntry);
                            return inProgressEntry;
                        }
                    })];
                case 1:
                    entry = _b.sent();
                    if (!tokenPromise) return [3 /*break*/, 3];
                    return [4 /*yield*/, tokenPromise];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = entry.authToken;
                    _b.label = 4;
                case 4:
                    authToken = _a;
                    return [2 /*return*/, authToken.token];
            }
        });
    });
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 */
function waitUntilAuthTokenRequest(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var entry, authToken;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateAuthTokenRequest(appConfig)];
                case 1:
                    entry = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
                    // generateAuthToken still in progress.
                    return [4 /*yield*/, sleep(100)];
                case 3:
                    // generateAuthToken still in progress.
                    _a.sent();
                    return [4 /*yield*/, updateAuthTokenRequest(appConfig)];
                case 4:
                    entry = _a.sent();
                    return [3 /*break*/, 2];
                case 5:
                    authToken = entry.authToken;
                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
                        throw ERROR_FACTORY.create("generate-token-failed" /* GENERATE_TOKEN_FAILED */);
                    }
                    else {
                        return [2 /*return*/, authToken];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */
function updateAuthTokenRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
        }
        var oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, oldEntry, { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
        }
        return oldEntry;
    });
}
function fetchAuthTokenFromServer(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 8]);
                    return [4 /*yield*/, generateAuthToken(appConfig, installationEntry)];
                case 1:
                    authToken = _a.sent();
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, installationEntry, { authToken: authToken });
                    return [4 /*yield*/, set(appConfig, updatedInstallationEntry)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, authToken];
                case 3:
                    e_1 = _a.sent();
                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    return [4 /*yield*/, remove(appConfig)];
                case 4:
                    // Server returned a "FID not found" or a "Invalid authentication" error.
                    // Generate a new ID next time.
                    _a.sent();
                    return [3 /*break*/, 7];
                case 5:
                    updatedInstallationEntry = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, installationEntry, { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
                    return [4 /*yield*/, set(appConfig, updatedInstallationEntry)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: throw e_1;
                case 8: return [2 /*return*/];
            }
        });
    });
}
function isEntryRegistered(installationEntry) {
    return (installationEntry !== undefined &&
        installationEntry.registrationStatus === 2 /* COMPLETED */);
}
function isAuthTokenValid(authToken) {
    return (authToken.requestStatus === 2 /* COMPLETED */ &&
        !isAuthTokenExpired(authToken));
}
function isAuthTokenExpired(authToken) {
    var now = Date.now();
    return (now < authToken.creationTime ||
        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */,
        requestTime: Date.now()
    };
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["a" /* __assign */])({}, oldEntry, { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getId(app) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var appConfig, _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (registrationPromise) {
                        // Suppress registration errors as they are not a problem for getId.
                        registrationPromise.catch(function () { });
                    }
                    if (installationEntry.registrationStatus === 2 /* COMPLETED */) {
                        // If the installation is already registered, update the authentication
                        // token if needed. Suppress errors as they are not relevant to getId.
                        refreshAuthToken(appConfig).catch(function () { });
                    }
                    return [2 /*return*/, installationEntry.fid];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getToken(app) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var appConfig;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, completeInstallationRegistration(appConfig)];
                case 1:
                    _a.sent();
                    // At this point we either have a Registered Installation in the DB, or we've
                    // already thrown an error.
                    return [2 /*return*/, refreshAuthToken(appConfig)];
            }
        });
    });
}
function completeInstallationRegistration(appConfig) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var _a, installationEntry, registrationPromise;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
                case 1:
                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
                    if (!registrationPromise) return [3 /*break*/, 3];
                    // A createInstallation request is in progress. Wait until it finishes.
                    return [4 /*yield*/, registrationPromise];
                case 2:
                    // A createInstallation request is in progress. Wait until it finishes.
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (installationEntry.registrationStatus !== 2 /* COMPLETED */) {
                        // Installation ID can't be registered.
                        throw ERROR_FACTORY.create("create-installation-failed" /* CREATE_INSTALLATION_FAILED */);
                    }
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation(appConfig, installationEntry) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var endpoint, headers, request, response;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
                    headers = getHeadersWithAuth(appConfig, installationEntry);
                    request = {
                        method: 'DELETE',
                        headers: headers
                    };
                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
                case 1:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
                case 2: throw _a.sent();
                case 3: return [2 /*return*/];
            }
        });
    });
}
function getDeleteEndpoint(appConfig, _a) {
    var fid = _a.fid;
    return getInstallationsEndpoint(appConfig) + "/" + fid;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function deleteInstallation$1(app) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["b" /* __awaiter */])(this, void 0, void 0, function () {
        var appConfig, entry;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["c" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appConfig = extractAppConfig(app);
                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
                            if (oldEntry &&
                                oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
                                // Delete the unregistered entry without sending a deleteInstallation request.
                                return undefined;
                            }
                            return oldEntry;
                        })];
                case 1:
                    entry = _a.sent();
                    if (!entry) return [3 /*break*/, 6];
                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
                    // Can't delete while trying to register.
                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
                case 2:
                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
                    if (!!navigator.onLine) return [3 /*break*/, 3];
                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                case 3: return [4 /*yield*/, deleteInstallation(appConfig, entry)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, remove(appConfig)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerInstallations(instance) {
    var installationsName = 'installations';
    var factoryMethod = function (app) {
        // Throws if app isn't configured properly.
        extractAppConfig(app);
        return {
            app: app,
            getId: function () { return getId(app); },
            getToken: function () { return getToken(app); },
            delete: function () { return deleteInstallation$1(app); }
        };
    };
    instance.INTERNAL.registerService(installationsName, factoryMethod);
}
registerInstallations(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a);


//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.idb = {}));
}(this, function (exports) { 'use strict';

  function toArray(arr) {
    return Array.prototype.slice.call(arr);
  }

  function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
      request.onsuccess = function() {
        resolve(request.result);
      };

      request.onerror = function() {
        reject(request.error);
      };
    });
  }

  function promisifyRequestCall(obj, method, args) {
    var request;
    var p = new Promise(function(resolve, reject) {
      request = obj[method].apply(obj, args);
      promisifyRequest(request).then(resolve, reject);
    });

    p.request = request;
    return p;
  }

  function promisifyCursorRequestCall(obj, method, args) {
    var p = promisifyRequestCall(obj, method, args);
    return p.then(function(value) {
      if (!value) return;
      return new Cursor(value, p.request);
    });
  }

  function proxyProperties(ProxyClass, targetProp, properties) {
    properties.forEach(function(prop) {
      Object.defineProperty(ProxyClass.prototype, prop, {
        get: function() {
          return this[targetProp][prop];
        },
        set: function(val) {
          this[targetProp][prop] = val;
        }
      });
    });
  }

  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return this[targetProp][prop].apply(this[targetProp], arguments);
      };
    });
  }

  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
    properties.forEach(function(prop) {
      if (!(prop in Constructor.prototype)) return;
      ProxyClass.prototype[prop] = function() {
        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
      };
    });
  }

  function Index(index) {
    this._index = index;
  }

  proxyProperties(Index, '_index', [
    'name',
    'keyPath',
    'multiEntry',
    'unique'
  ]);

  proxyRequestMethods(Index, '_index', IDBIndex, [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
    'openCursor',
    'openKeyCursor'
  ]);

  function Cursor(cursor, request) {
    this._cursor = cursor;
    this._request = request;
  }

  proxyProperties(Cursor, '_cursor', [
    'direction',
    'key',
    'primaryKey',
    'value'
  ]);

  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
    'update',
    'delete'
  ]);

  // proxy 'next' methods
  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
    if (!(methodName in IDBCursor.prototype)) return;
    Cursor.prototype[methodName] = function() {
      var cursor = this;
      var args = arguments;
      return Promise.resolve().then(function() {
        cursor._cursor[methodName].apply(cursor._cursor, args);
        return promisifyRequest(cursor._request).then(function(value) {
          if (!value) return;
          return new Cursor(value, cursor._request);
        });
      });
    };
  });

  function ObjectStore(store) {
    this._store = store;
  }

  ObjectStore.prototype.createIndex = function() {
    return new Index(this._store.createIndex.apply(this._store, arguments));
  };

  ObjectStore.prototype.index = function() {
    return new Index(this._store.index.apply(this._store, arguments));
  };

  proxyProperties(ObjectStore, '_store', [
    'name',
    'keyPath',
    'indexNames',
    'autoIncrement'
  ]);

  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'put',
    'add',
    'delete',
    'clear',
    'get',
    'getAll',
    'getKey',
    'getAllKeys',
    'count'
  ]);

  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
    'openCursor',
    'openKeyCursor'
  ]);

  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
    'deleteIndex'
  ]);

  function Transaction(idbTransaction) {
    this._tx = idbTransaction;
    this.complete = new Promise(function(resolve, reject) {
      idbTransaction.oncomplete = function() {
        resolve();
      };
      idbTransaction.onerror = function() {
        reject(idbTransaction.error);
      };
      idbTransaction.onabort = function() {
        reject(idbTransaction.error);
      };
    });
  }

  Transaction.prototype.objectStore = function() {
    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
  };

  proxyProperties(Transaction, '_tx', [
    'objectStoreNames',
    'mode'
  ]);

  proxyMethods(Transaction, '_tx', IDBTransaction, [
    'abort'
  ]);

  function UpgradeDB(db, oldVersion, transaction) {
    this._db = db;
    this.oldVersion = oldVersion;
    this.transaction = new Transaction(transaction);
  }

  UpgradeDB.prototype.createObjectStore = function() {
    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
  };

  proxyProperties(UpgradeDB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
    'deleteObjectStore',
    'close'
  ]);

  function DB(db) {
    this._db = db;
  }

  DB.prototype.transaction = function() {
    return new Transaction(this._db.transaction.apply(this._db, arguments));
  };

  proxyProperties(DB, '_db', [
    'name',
    'version',
    'objectStoreNames'
  ]);

  proxyMethods(DB, '_db', IDBDatabase, [
    'close'
  ]);

  // Add cursor iterators
  // TODO: remove this once browsers do the right thing with promises
  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
    [ObjectStore, Index].forEach(function(Constructor) {
      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
      if (!(funcName in Constructor.prototype)) return;

      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
        var args = toArray(arguments);
        var callback = args[args.length - 1];
        var nativeObject = this._store || this._index;
        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
        request.onsuccess = function() {
          callback(request.result);
        };
      };
    });
  });

  // polyfill getAll
  [Index, ObjectStore].forEach(function(Constructor) {
    if (Constructor.prototype.getAll) return;
    Constructor.prototype.getAll = function(query, count) {
      var instance = this;
      var items = [];

      return new Promise(function(resolve) {
        instance.iterateCursor(query, function(cursor) {
          if (!cursor) {
            resolve(items);
            return;
          }
          items.push(cursor.value);

          if (count !== undefined && items.length == count) {
            resolve(items);
            return;
          }
          cursor.continue();
        });
      });
    };
  });

  function openDb(name, version, upgradeCallback) {
    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
    var request = p.request;

    if (request) {
      request.onupgradeneeded = function(event) {
        if (upgradeCallback) {
          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
        }
      };
    }

    return p.then(function(db) {
      return new DB(db);
    });
  }

  function deleteDb(name) {
    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
  }

  exports.openDb = openDb;
  exports.deleteDb = deleteDb;

  Object.defineProperty(exports, '__esModule', { value: true });

}));


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export env */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reduxFirebase; });
var env='development';var firebase={apiKey:"AIzaSyC3QG0gqsFvfCIsfCuhVa4sT5-ACE0OUjY",authDomain:"mycareer-ai.firebaseapp.com",databaseURL:"https://mycareer-ai.firebaseio.com",projectId:"mycareer-ai",storageBucket:"mycareer-ai.appspot.com",messagingSenderId:"274434834788"// Config for react-redux-firebase
// For more details, visit http://docs.react-redux-firebase.com/history/v2.0.0/docs/api/enhancer.html
};var reduxFirebase={userProfile:'users',// root that user profiles are written to
updateProfileOnLogin:false,// enable/disable updating of profile on login
enableLogging:false,// enable/disable Firebase Database Logging
attachAuthIsReady:true,// attaches auth is ready promise to store
presence:'presence'// autoPopulateProfile: true, // keep auto population of profile from v1
// profileParamsToPopulate: [
//   // create queries for profile population (remember to use populate)
//   { child: 'cars', root: 'cars' }
// ],
// useFirestoreForProfile: true, // Use Firestore to store profile
// profileParamsToPopulate: [{ child: 'cars', root: 'cars' }] // gather data for populating profile params
// profileDecorator: (userData) => ({ email: userData.email }) // customize format of user profile
};/* unused harmony default export */ var _unused_webpack_default_export = ({env:env,firebase:firebase,reduxFirebase:reduxFirebase});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.a5073b20.js